import * as THREE from 'three';

interface PlantInfo {
  type: PlantType;
  name: string;
  cost: number;
  emoji: string;
}

const PLANT_INFO: Record<PlantType, PlantInfo> = {
  'grape-launcher': { type: 'grape-launcher', name: 'Grape Launcher', cost: 100, emoji: '🍇' },
  'vine-wall': { type: 'vine-wall', name: 'Vine Wall', cost: 50, emoji: '🌿' },
  'pear-cannon': { type: 'pear-cannon', name: 'Pear Cannon', cost: 150, emoji: '🍐' },
  'frost-berri': { type: 'frost-berri', name: 'Frost Berri', cost: 125, emoji: '❄️' },
  'lily': { type: 'lily', name: 'Lily', cost: 50, emoji: '🌸' },
  'avocado-slammer': { type: 'avocado-slammer', name: 'Avocado Slammer', cost: 125, emoji: '🥑' },
  'pickle-picker': { type: 'pickle-picker', name: 'Pickle Picker', cost: 175, emoji: '🥒' },
  'grape-wall': { type: 'grape-wall', name: 'Grape Wall', cost: 0, emoji: '🍇🌿' },
  'grape-lily': { type: 'grape-lily', name: 'Grape Lily', cost: 150, emoji: '🍇🌸' },
  'pear-launcher': { type: 'pear-launcher', name: 'Pear Launcher', cost: 250, emoji: '🍐🍇' },
  'pear-wall': { type: 'pear-wall', name: 'Pear Wall', cost: 0, emoji: '🍐🌿' },
  'frost-slammer': { type: 'frost-slammer', name: 'Frost Slammer', cost: 0, emoji: '🥑❄️' },
  'frost-pear-wall': { type: 'frost-pear-wall', name: 'Frost Peall', cost: 0, emoji: '🍐❄️' },
  'tomato-spike': { type: 'tomato-spike', name: 'Tomato Spike', cost: 150, emoji: '🍅' },
  'strawberry-launcher': { type: 'strawberry-launcher', name: 'Strawberry Launcher', cost: 75, emoji: '🍓' },
  'pickle-spiker': { type: 'pickle-spiker', name: 'Pickle Spiker', cost: 0, emoji: '🥒🍅' },
  'grape-shot': { type: 'grape-shot', name: 'Grape Shot', cost: 200, emoji: '🍇🍇' },
  'grape-gun': { type: 'grape-gun', name: 'Grape Gun', cost: 0, emoji: '🍇🍇🍇' },
  'star-launcher': { type: 'star-launcher', name: 'Star Launcher', cost: 0, emoji: '⭐🍇' },
  'pear-spiker': { type: 'pear-spiker', name: 'Pear Spiker', cost: 0, emoji: '🍐🍅' },
  'seed-batch': { type: 'seed-batch', name: 'Seed Batch', cost: 300, emoji: '🫘' },
  'strawbomber': { type: 'strawbomber', name: 'Strawbomber', cost: 0, emoji: '🍓💣' },
  'frovine-slammer': { type: 'frovine-slammer', name: 'Frovine Slammer', cost: 0, emoji: '🌿❄️' },
  'pear-nuker': { type: 'pear-nuker', name: 'Pear Nuker', cost: 0, emoji: '🍐💥' },
  'frost-grape-gun': { type: 'frost-grape-gun', name: 'Frost Grape Gun', cost: 0, emoji: '❄️🍇🍇🍇' },
  'elder-frost-berri': { type: 'elder-frost-berri', name: 'Elder Frost Berri', cost: 3000, emoji: '❄️👴' },
  'straw-spiker': { type: 'straw-spiker', name: 'StrawSpiker', cost: 0, emoji: '🍓🍅' },
  'elder-tomato-spike': { type: 'elder-tomato-spike', name: 'Elder Tomato Spike', cost: 3000, emoji: '🍅👴' },
  'rose-reaper': { type: 'rose-reaper', name: 'Rose Reaper', cost: 200, emoji: '🌹' },
  'mushroom-bomber': { type: 'mushroom-bomber', name: 'Mushroom Bomber', cost: 175, emoji: '🍄' },
  'vined-wall': { type: 'vined-wall', name: 'Vined Wall', cost: 0, emoji: '🌿🌿' },
  'frostberry-launcher': { type: 'frostberry-launcher', name: 'Frostberry Launcher', cost: 0, emoji: '🍓❄️' },
  'reaper-peall': { type: 'reaper-peall', name: 'Reaper Peall', cost: 0, emoji: '🌹🧱' },
  'acorn-tree': { type: 'acorn-tree', name: 'Acorn Tree', cost: 150, emoji: '🌳' },
  'acorn-bomb': { type: 'acorn-bomb', name: 'Acorn Bomb', cost: 0, emoji: '🌰💣' },
  'banana-peel': { type: 'banana-peel', name: 'Banana Peel', cost: 200, emoji: '🍌' },
  'frost-peel': { type: 'frost-peel', name: 'Frost Peel', cost: 0, emoji: '🍌❄️' },
  'lilyer': { type: 'lilyer', name: 'Lilyer', cost: 0, emoji: '🌸🌸' },
  'lilyest': { type: 'lilyest', name: 'Lilyest', cost: 0, emoji: '🌸💎' },
  'frost-grape-launcher': { type: 'frost-grape-launcher', name: 'Frost Grape Launcher', cost: 0, emoji: '🍇❄️' },
  'strawberry-tree': { type: 'strawberry-tree', name: 'Strawberry Tree', cost: 0, emoji: '🍓🌳' },
  'frozen-mushroom-bomber': { type: 'frozen-mushroom-bomber', name: 'Frozen Mushroom Bomber', cost: 0, emoji: '🍄❄️' },
  'sunberry-launcher': { type: 'sunberry-launcher', name: 'Sunberry Launcher', cost: 0, emoji: '🍓☀️' },
  'lily-wall': { type: 'lily-wall', name: 'Lily Wall', cost: 0, emoji: '🌸🌿' },
  'black-hole-coconut': { type: 'black-hole-coconut', name: 'Black Hole Coconut', cost: 500, emoji: '🥥🕳️' },
  'lily-reaper': { type: 'lily-reaper', name: 'Lily Reaper', cost: 200, emoji: '🌸💀' },
  'frozen-overlord-mushroom': { type: 'frozen-overlord-mushroom', name: 'Frozen Overlord Mushroom', cost: 0, emoji: '🍄👑❄️' },
  'banana-launcher': { type: 'banana-launcher', name: 'Banana Launcher', cost: 0, emoji: '🍌🍇' },
  'lily-peel': { type: 'lily-peel', name: 'Lily Peel', cost: 0, emoji: '🌸🍌' },
  // New fusions
  'vine-slammer': { type: 'vine-slammer', name: 'Vine Slammer', cost: 0, emoji: '🥑🌿' },
  'grape-spiker': { type: 'grape-spiker', name: 'Grape Spiker', cost: 0, emoji: '🍇🍅' },
  'grape-gun-wall': { type: 'grape-gun-wall', name: 'Grape Gun Wall', cost: 0, emoji: '🍇🍇🌿' },
  'lily-gun': { type: 'lily-gun', name: 'Lily Gun', cost: 0, emoji: '🌸🍇🍇' },
  'pickle-spear': { type: 'pickle-spear', name: 'Pickle Spear', cost: 0, emoji: '🥒🍐' },
  'frost-spiker': { type: 'frost-spiker', name: 'Frost Spiker', cost: 0, emoji: '❄️🍓🍅' },
  'banana-leach': { type: 'banana-leach', name: 'Banana Leach', cost: 0, emoji: '🍌🌹' },
  'lily-cannon': { type: 'lily-cannon', name: 'Lily Cannon', cost: 0, emoji: '🌸🍐' },
  'frost-vine-wall': { type: 'frost-vine-wall', name: 'Frost Vine Wall', cost: 0, emoji: '❄️🌿' },
  'frozen-supernova-coconut': { type: 'frozen-supernova-coconut', name: 'Frozen Supernova Coconut', cost: 0, emoji: '❄️🥥💥' },
  'spike-wall': { type: 'spike-wall', name: 'Spike Wall', cost: 0, emoji: '🌿🍅' },
  'acorn-nest': { type: 'acorn-nest', name: 'Acorn Nest', cost: 0, emoji: '🌳🍌' },
  'frozen-lily': { type: 'frozen-lily', name: 'Frozen Lily', cost: 0, emoji: '❄️🌸' },
  'frozen-lilyer': { type: 'frozen-lilyer', name: 'Frozen Lilyer', cost: 0, emoji: '❄️🌸🌸' },
  'acorn-wall': { type: 'acorn-wall', name: 'Acorn Wall', cost: 0, emoji: '🌳🌿' },
  // 2nd form odd fusions
  'frost-overlord-grape-gun': { type: 'frost-overlord-grape-gun', name: 'Frost Overlord Grape Gun', cost: 0, emoji: '❄️👑🍇' },
  'thornbomber': { type: 'thornbomber', name: 'ThornBomber', cost: 0, emoji: '🍓🌹💣' },
  'titan-reaper-peall': { type: 'titan-reaper-peall', name: 'Titan Reaper Peall', cost: 0, emoji: '👑🌹🧱' },
  'frozen-nebula-mushroom': { type: 'frozen-nebula-mushroom', name: 'Frozen Nebula Mushroom', cost: 0, emoji: '🍄🌌❄️' },
  // New frost spike fusions
  'grape-frospike': { type: 'grape-frospike', name: 'Grape Frospike', cost: 0, emoji: '🍇❄️🍅' },
  'frospike': { type: 'frospike', name: 'Frospike', cost: 0, emoji: '❄️🍅' },
  // New crate plants
  'roots': { type: 'roots', name: 'Roots', cost: 100, emoji: '🌱' },
  'onion-flier': { type: 'onion-flier', name: 'Onion Flier', cost: 400, emoji: '🧅✈️' },
  'pineapple-crate': { type: 'pineapple-crate', name: 'Pineapple Crate', cost: 150, emoji: '🍍📦' },
  'kiwi-blocker': { type: 'kiwi-blocker', name: 'Kiwi Blocker', cost: 500, emoji: '🥝' },
  'eggplant-stunner': { type: 'eggplant-stunner', name: 'Eggplant Stunner', cost: 300, emoji: '🍆' },
  'iron-grape-launcher': { type: 'iron-grape-launcher', name: 'Iron Grape Launcher', cost: 300, emoji: '🍇🔩' },
  'banana-tree': { type: 'banana-tree', name: 'Banana Tree', cost: 2000, emoji: '🍌🌳' },
  // New fusions
  'onion-freezer': { type: 'onion-freezer', name: 'Onion Freezer', cost: 0, emoji: '🧅❄️' },
  'rooted-grape-launcher': { type: 'rooted-grape-launcher', name: 'Rooted Grape Launcher', cost: 0, emoji: '🌱🍇' },
  'vined-grape-wall': { type: 'vined-grape-wall', name: 'Vined Grape Wall', cost: 0, emoji: '🌿🍇🧱' },
  'grape-crate': { type: 'grape-crate', name: 'Grape Crate', cost: 0, emoji: '🍇📦' },
  'eggplant-cannon': { type: 'eggplant-cannon', name: 'Eggplant Cannon', cost: 0, emoji: '🍆🍐' },
  'kiwi-slammer': { type: 'kiwi-slammer', name: 'Kiwi Slammer', cost: 0, emoji: '🥝🥑' },
  'iron-grape-shot': { type: 'iron-grape-shot', name: 'Iron Grape Shot', cost: 0, emoji: '🍇🔩🔫' },
  'strawberry-pear-launcher': { type: 'strawberry-pear-launcher', name: 'Strawberry Pear Launcher', cost: 0, emoji: '🍓🍐' },
  'frozen-pickle-spear': { type: 'frozen-pickle-spear', name: 'Frozen Pickle Spear', cost: 0, emoji: '❄️🥒' },
  'mushroom-healer': { type: 'mushroom-healer', name: 'Mushroom Healer', cost: 0, emoji: '🍄🌹' },
  // Power plants
  'grape-pulser': { type: 'grape-pulser', name: 'Grape Pulser', cost: 0, emoji: '🍇⚡' },
  'overgrown-vine-wall': { type: 'overgrown-vine-wall', name: 'Overgrown Vine Wall', cost: 0, emoji: '🌿🌿🌿' },
  'great-god-lily': { type: 'great-god-lily', name: 'Great God Lily', cost: 0, emoji: '🌸👑' },
  // Dragon Battle reward plant
  'red-fire-flower': { type: 'red-fire-flower', name: 'Red Fire Flower', cost: 300, emoji: '🔥🌺' },
  'red-firecracker-flower': { type: 'red-firecracker-flower', name: 'Red Firecracker Flower', cost: 0, emoji: '🧨🌺' },
  'red-firespiker-flower': { type: 'red-firespiker-flower', name: 'Red Firespiker Flower', cost: 0, emoji: '🧨🍅' }
};

interface FusionRecipe {
  plant1: PlantType;
  plant2: PlantType;
  result: PlantType;
}

const FUSION_RECIPES: FusionRecipe[] = [
  { plant1: 'grape-launcher', plant2: 'vine-wall', result: 'grape-wall' },
  { plant1: 'grape-launcher', plant2: 'lily', result: 'grape-lily' },
  { plant1: 'grape-launcher', plant2: 'pear-cannon', result: 'pear-launcher' },
  { plant1: 'pear-cannon', plant2: 'vine-wall', result: 'pear-wall' },
  { plant1: 'avocado-slammer', plant2: 'frost-berri', result: 'frost-slammer' },
  { plant1: 'pear-wall', plant2: 'frost-berri', result: 'frost-pear-wall' },
  { plant1: 'pickle-picker', plant2: 'tomato-spike', result: 'pickle-spiker' },
  { plant1: 'grape-launcher', plant2: 'grape-launcher', result: 'grape-shot' },
  { plant1: 'grape-shot', plant2: 'grape-launcher', result: 'grape-gun' },
  { plant1: 'grape-lily', plant2: 'pear-launcher', result: 'star-launcher' },
  { plant1: 'pear-launcher', plant2: 'tomato-spike', result: 'pear-spiker' },
  { plant1: 'grape-gun', plant2: 'elder-frost-berri', result: 'frost-grape-gun' },
  { plant1: 'strawbomber', plant2: 'elder-tomato-spike', result: 'straw-spiker' },
  { plant1: 'vine-wall', plant2: 'vine-wall', result: 'vined-wall' },
  { plant1: 'strawberry-launcher', plant2: 'frost-berri', result: 'frostberry-launcher' },
  { plant1: 'frost-pear-wall', plant2: 'rose-reaper', result: 'reaper-peall' },
  { plant1: 'lily', plant2: 'lily', result: 'lilyer' },
  { plant1: 'lilyer', plant2: 'grape-lily', result: 'lilyest' },
  { plant1: 'banana-peel', plant2: 'frost-berri', result: 'frost-peel' },
  { plant1: 'grape-launcher', plant2: 'frost-berri', result: 'frost-grape-launcher' },
  { plant1: 'acorn-tree', plant2: 'strawberry-launcher', result: 'strawberry-tree' },
  { plant1: 'mushroom-bomber', plant2: 'frost-berri', result: 'frozen-mushroom-bomber' },
  { plant1: 'lily', plant2: 'strawberry-launcher', result: 'sunberry-launcher' },
  { plant1: 'lily', plant2: 'vine-wall', result: 'lily-wall' },
  { plant1: 'banana-peel', plant2: 'grape-launcher', result: 'banana-launcher' },
  { plant1: 'lily', plant2: 'rose-reaper', result: 'lily-reaper' },
  { plant1: 'frozen-mushroom-bomber', plant2: 'elder-frost-berri', result: 'frozen-overlord-mushroom' },
  { plant1: 'lily', plant2: 'banana-peel', result: 'lily-peel' },
  // New fusions (15 total)
  { plant1: 'avocado-slammer', plant2: 'vine-wall', result: 'vine-slammer' },
  { plant1: 'grape-launcher', plant2: 'tomato-spike', result: 'grape-spiker' },
  { plant1: 'grape-gun', plant2: 'vine-wall', result: 'grape-gun-wall' },
  { plant1: 'grape-shot', plant2: 'grape-wall', result: 'grape-gun-wall' },
  { plant1: 'grape-lily', plant2: 'grape-shot', result: 'lily-gun' },
  { plant1: 'pickle-spiker', plant2: 'pear-cannon', result: 'pickle-spear' },
  { plant1: 'frostberry-launcher', plant2: 'tomato-spike', result: 'frost-spiker' },
  { plant1: 'banana-peel', plant2: 'rose-reaper', result: 'banana-leach' },
  { plant1: 'lily', plant2: 'pear-cannon', result: 'lily-cannon' },
  { plant1: 'frost-berri', plant2: 'vine-wall', result: 'frost-vine-wall' },
  { plant1: 'frost-berri', plant2: 'black-hole-coconut', result: 'frozen-supernova-coconut' },
  { plant1: 'frost-grape-launcher', plant2: 'tomato-spike', result: 'grape-frospike' },
  { plant1: 'grape-spiker', plant2: 'frost-berri', result: 'grape-frospike' },
  { plant1: 'frost-berri', plant2: 'tomato-spike', result: 'frospike' },
  { plant1: 'vine-wall', plant2: 'tomato-spike', result: 'spike-wall' },
  { plant1: 'acorn-tree', plant2: 'banana-peel', result: 'acorn-nest' },
  { plant1: 'frost-berri', plant2: 'lily', result: 'frozen-lily' },
  { plant1: 'frozen-lily', plant2: 'lily', result: 'frozen-lilyer' },
  { plant1: 'acorn-tree', plant2: 'vine-wall', result: 'acorn-wall' },
  // 2nd form odd fusions
  { plant1: 'frost-grape-gun', plant2: 'elder-frost-berri', result: 'frost-overlord-grape-gun' },
  { plant1: 'straw-spiker', plant2: 'rose-reaper', result: 'thornbomber' },
  { plant1: 'reaper-peall', plant2: 'frovine-slammer', result: 'titan-reaper-peall' },
  { plant1: 'frozen-overlord-mushroom', plant2: 'black-hole-coconut', result: 'frozen-nebula-mushroom' },
  // New Gold Crate fusions
  { plant1: 'onion-flier', plant2: 'frost-berri', result: 'onion-freezer' },
  { plant1: 'roots', plant2: 'grape-launcher', result: 'rooted-grape-launcher' },
  { plant1: 'vined-wall', plant2: 'grape-launcher', result: 'vined-grape-wall' },
  { plant1: 'vine-wall', plant2: 'grape-wall', result: 'vined-grape-wall' },
  { plant1: 'pineapple-crate', plant2: 'grape-launcher', result: 'grape-crate' },
  { plant1: 'eggplant-stunner', plant2: 'pear-cannon', result: 'eggplant-cannon' },
  { plant1: 'kiwi-blocker', plant2: 'avocado-slammer', result: 'kiwi-slammer' },
  { plant1: 'iron-grape-launcher', plant2: 'iron-grape-launcher', result: 'iron-grape-shot' },
  { plant1: 'pear-cannon', plant2: 'strawberry-launcher', result: 'strawberry-pear-launcher' },
  { plant1: 'pickle-spiker', plant2: 'frost-berri', result: 'frozen-pickle-spear' },
  { plant1: 'mushroom-bomber', plant2: 'rose-reaper', result: 'mushroom-healer' },
  { plant1: 'red-fire-flower', plant2: 'red-fire-flower', result: 'red-firecracker-flower' },
  { plant1: 'red-firecracker-flower', plant2: 'tomato-spike', result: 'red-firespiker-flower' }
];

interface TitanFusionRecipe {
  left: PlantType;
  middle: PlantType;
  right: PlantType;
  result: PlantType;
}

const TITAN_FUSION_RECIPES: TitanFusionRecipe[] = [
  { left: 'pear-cannon', middle: 'strawberry-launcher', right: 'pear-cannon', result: 'strawbomber' },
  { left: 'frost-slammer', middle: 'vine-wall', right: 'frost-slammer', result: 'frovine-slammer' },
  { left: 'pear-launcher', middle: 'pear-spiker', right: 'pear-launcher', result: 'pear-nuker' }
];

// Plant unlock system - which plants are available from start vs unlocked by beating waves
const STARTING_PLANTS: PlantType[] = ['lily', 'vine-wall', 'grape-launcher', 'pear-cannon', 'strawberry-launcher'];

const WAVE_UNLOCKS: Record<number, PlantType[]> = {
  3: ['frost-berri'],
  5: ['avocado-slammer'],
  6: ['pickle-picker'],
  7: ['tomato-spike'],
  9: ['grape-shot'],
  10: ['seed-batch']
};

// Track unlocked plants globally
const unlockedPlants: Set<PlantType> = new Set(STARTING_PLANTS);

// Global cheat state (can be activated from menu screen)
let cheatActivated: boolean = false;
let cheatSun: number = 0;
let cheatCoins: number = 0;
let cheatMastery: number = 0;

// Function to activate cheat from menu (called by L key on start screen)
function activateGlobalCheat(): void {
  cheatActivated = true;
  cheatSun = 999999;
  cheatCoins = 999999;
  cheatMastery = 300;
  // Unlock ALL plants (base, fusion, titan, and elder)
  const allPlants: PlantType[] = [
    'grape-launcher', 'vine-wall', 'pear-cannon', 'frost-berri', 'lily', 'avocado-slammer',
    'pickle-picker', 'tomato-spike', 'strawberry-launcher', 'grape-shot', 'seed-batch',
    'grape-wall', 'grape-lily', 'pear-launcher', 'pear-wall', 'frost-slammer', 'frost-pear-wall',
    'pickle-spiker', 'grape-gun', 'star-launcher', 'pear-spiker', 'frost-grape-gun', 'straw-spiker', 'frost-peel',
    'strawbomber', 'frovine-slammer', 'pear-nuker',
    'elder-frost-berri', 'elder-tomato-spike',
    'rose-reaper', 'mushroom-bomber',
    'red-fire-flower'
  ];
  allPlants.forEach(plant => unlockedPlants.add(plant));
  // Unlock Dragon Battle reward
  localStorage.setItem('dragonBattleComplete', 'true');
  // Also add shop plants to owned list for cheat
  const ownedPlants = JSON.parse(localStorage.getItem('fusionTdOwnedPlants') || '[]');
  SHOP_PLANTS.forEach(plant => {
    if (!ownedPlants.includes(plant)) ownedPlants.push(plant);
  });
  localStorage.setItem('fusionTdOwnedPlants', JSON.stringify(ownedPlants));
  updatePlantCardLockStatus();

  // Auto-select all base plants for the player
  const basePlants: PlantType[] = [
    'grape-launcher', 'vine-wall', 'pear-cannon', 'frost-berri', 'lily', 'avocado-slammer',
    'pickle-picker', 'tomato-spike', 'strawberry-launcher', 'grape-shot', 'seed-batch'
  ];
  const selectedPlantsSet = (window as any).selectedPlants as Set<PlantType> | undefined;
  if (selectedPlantsSet) {
    basePlants.forEach(plant => selectedPlantsSet.add(plant));
    // Update UI to show selected plants
    document.querySelectorAll('.plant-card').forEach(card => {
      const plantType = card.getAttribute('data-plant') as PlantType;
      if (basePlants.includes(plantType)) {
        card.classList.add('selected');
      }
    });
    // Enable start button
    const startBtn = document.getElementById('start-game-btn') as HTMLButtonElement;
    if (startBtn) startBtn.disabled = false;
  }

  console.log('🎮 CHEAT ACTIVATED: ALL plants unlocked & selected!');
  console.log('❄️ Frost Berri Mastery: Will be MAXED (300/300) when game starts!');
  console.log('🍅 Tomato Spike Mastery: Will be MAXED (300/300) when game starts!');
  console.log('☀️ Sun: 999,999 | 💰 Coins: 999,999');
}

// Expose to window for menu screen access
(window as any).activateGlobalCheat = activateGlobalCheat;

// Shop plants that can be purchased (from Wood Crate, Iron Crate, and Gold Crate)
const SHOP_PLANTS: PlantType[] = [
  'rose-reaper', 'mushroom-bomber', 'acorn-tree', 'banana-peel', 'black-hole-coconut',
  'roots', 'onion-flier', 'pineapple-crate',
  'kiwi-blocker', 'eggplant-stunner', 'iron-grape-launcher', 'banana-tree'
];

// Function to check if a plant is unlocked
function isPlantUnlocked(plantType: PlantType): boolean {
  // Check Dragon Battle unlock
  if (plantType === 'red-fire-flower') {
    return localStorage.getItem('dragonBattleComplete') === 'true';
  }
  // Check if it's a shop plant - then check localStorage
  if (SHOP_PLANTS.includes(plantType)) {
    const owned = JSON.parse(localStorage.getItem('fusionTdOwnedPlants') || '[]');
    return owned.includes(plantType);
  }
  return unlockedPlants.has(plantType);
}

// Function to unlock a plant and update UI
function unlockPlant(plantType: PlantType): void {
  if (!unlockedPlants.has(plantType)) {
    unlockedPlants.add(plantType);
    updatePlantCardLockStatus();
    showUnlockNotification(plantType);
  }
}

// Function to update plant card lock status
function updatePlantCardLockStatus(): void {
  const plantCards = document.querySelectorAll('.plant-card');
  plantCards.forEach(card => {
    const plantType = card.getAttribute('data-plant') as PlantType;
    if (plantType) {
      const unlocked = isPlantUnlocked(plantType);
      if (unlocked) {
        card.classList.remove('locked');
        // Remove lock badge if exists
        const badge = card.querySelector('.lock-badge');
        if (badge) badge.remove();
      } else {
        card.classList.add('locked');
        // Add lock badge if not exists
        if (!card.querySelector('.lock-badge')) {
          const badge = document.createElement('div');
          badge.className = 'lock-badge';
          // Check if it's a shop plant
          if (SHOP_PLANTS.includes(plantType)) {
            badge.textContent = `🛒 Buy in Shop`;
          } else {
            // Find which wave unlocks this plant
            let unlockWave = 0;
            for (const [wave, plants] of Object.entries(WAVE_UNLOCKS)) {
              if ((plants as PlantType[]).includes(plantType)) {
                unlockWave = parseInt(wave);
                break;
              }
            }
            badge.textContent = `🔒 Wave ${unlockWave}`;
          }
          card.appendChild(badge);
        }
      }
    }
  });
}

// Function to show unlock notification
function showUnlockNotification(plantType: PlantType): void {
  const plantInfo = PLANT_INFO[plantType];
  const notification = document.createElement('div');
  notification.className = 'unlock-notification';
  notification.innerHTML = `
    <div style="font-size: 3rem; margin-bottom: 0.5rem;">${plantInfo.emoji}</div>
    <div>🎉 NEW PLANT UNLOCKED! 🎉</div>
    <div style="margin-top: 0.5rem; font-size: 1.2rem;">${plantInfo.name}</div>
  `;
  document.body.appendChild(notification);

  // Remove notification after 3 seconds
  setTimeout(() => {
    notification.style.animation = 'unlockPop 0.3s ease-in reverse';
    setTimeout(() => notification.remove(), 300);
  }, 3000);
}

class Game {
  private scene: THREE.Scene;
  private camera: THREE.PerspectiveCamera;
  private renderer: THREE.WebGLRenderer;
  private selectedPlants: PlantType[];
  private sun: number = 2000;
  private coins: number = 0;
  private currentPlantType: PlantType | null = null;
  private plantPreviewMesh: THREE.Group | null = null; // Preview of plant being placed
  private plantPreviewRotation: number = 0; // Rotation in radians (0, PI/2, PI, 3PI/2)
  private frostBerriMastery: number = 0; // Track zombies frozen by Frost Berri
  private frostBerriMasteryPoints: number = 0; // Track mastery points (5 per freeze, 20 per fusion)
  private tomatoSpikeMastery: number = 0; // Track zombies killed by Tomato Spike
  private tomatoSpikeMasteryPoints: number = 0; // Track mastery points (5 per kill, 20 per fusion)
  private frostGrapeGunUnlocked: boolean = false; // Must purchase from odd shop to unlock fusion
  private strawSpikerUnlocked: boolean = false; // Must purchase from odd shop to unlock fusion
  private reaperWallUnlocked: boolean = false; // Must purchase from odd shop to unlock fusion
  private frozenOverlordUnlocked: boolean = false; // Must purchase from odd shop to unlock fusion (150 coins)
  private frostOverlordGrapeGunUnlocked: boolean = false; // 2nd form odd fusion
  private thornbomberUnlocked: boolean = false; // 2nd form odd fusion
  private titanReaperPeallUnlocked: boolean = false; // 2nd form odd fusion
  private frozenNebulaMushroomUnlocked: boolean = false; // 2nd form odd fusion
  private lastClickTime: number = 0;
  private lastClickedPlant: Plant | null = null;
  private raycaster: THREE.Raycaster;
  private mouse: THREE.Vector2;
  private lawnPlane!: THREE.Mesh;
  private cube!: THREE.Mesh;
  private placedPlants: Plant[] = [];
  private plantSlots: Map<string, boolean> = new Map(); // Track occupied slots
  private slotMeshes: THREE.Mesh[] = [];
  private zombies: Zombie[] = [];
  private allies: Ally[] = []; // Animal allies from banana peel
  private projectiles: Projectile[] = [];
  private zombieProjectiles: any[] = [];
  private gameTime: number = 0;
  private nextZombieSpawn: number = 5;
  private waveStarted: boolean = false;
  private shovelMode: boolean = false;
  private gloveMode: boolean = false;
  private glovePlant: Plant | null = null; // Plant picked up with glove
  private gloveHighlightMeshes: THREE.Mesh[] = []; // Highlight meshes for glove mode
  private currentWave: number = 0;
  private zombiesInWave: number = 0;
  private zombiesSpawnedInWave: number = 0;
  private fireZombiesSpawnedThisWave: number = 0;
  private waveComplete: boolean = false;
  private cameraPosition = { x: 0, y: 22, z: 12 }; // Fixed eagle-eye view
  private keys: { [key: string]: boolean } = {};
  private scrollVelocityX: number = 0;
  private scrollVelocityZ: number = 0;
  private showHP: boolean = false;
  private showZombieHealth: boolean = false;
  private shiftHeld: boolean = false;
  private lastToggleTime: number = 0;
  private lastZombieToggleTime: number = 0;
  private selectedPearNuker: Plant | null = null;
  private gameOver: boolean = false;
  private slowMotion: boolean = false;
  private lastSlowMotionToggle: number = 0;
  private lastGloveToggle: number = 0;
  private waveSkipMode: boolean = false;
  private lastWaveSkipToggle: number = 0;
  private fallingSuns: { mesh: THREE.Group, targetY: number, value: number, collected: boolean }[] = [];
  private fallingSunTimer: number = 0;
  private hoverHighlight: THREE.Mesh | null = null;
  private lastWaveSkip: number = 0;

  // Pause menu and game speed
  private isPaused: boolean = false;
  private gameSpeed: number = 1;

  // Audio system
  private audioContext: AudioContext | null = null;
  private musicGainNode: GainNode | null = null;
  private musicPlaying: boolean = false;

  // Instant plant cooldowns (in seconds)
  private instantPlantCooldowns: Map<PlantType, number> = new Map();
  private readonly INSTANT_PLANT_COOLDOWN = 2; // 2 seconds cooldown

  // Power plant system
  private powerPlant: Plant | null = null;
  private powerPlantType: PowerPlantType | null = null;
  private powerPlantMoveCooldown: number = 0;
  private powerPlantAbility1Cooldown: number = 0;
  private powerPlantAbility2Cooldown: number = 0;

  // I, Zombie mode
  private isIZombieMode: boolean = false;
  private iZombieSun: number = 2000;
  private selectedZombieType: ZombieType | null = null;
  private iZombieSunTimer: number = 0;

  // Endless mode
  private isEndlessMode: boolean = false;
  private endlessWaveMultiplier: number = 1;

  // Conveyor Belt mode
  private isConveyorMode: boolean = false;
  private conveyorPlants: PlantType[] = [];
  private conveyorTimer: number = 0;

  // Last Stand mode
  private isLastStandMode: boolean = false;
  private lastStandSetupTime: number = 30; // 30 seconds to setup
  private lastStandStarted: boolean = false;

  // Vasebreaker mode
  private isVasebreakerMode: boolean = false;
  private vases: THREE.Mesh[] = [];
  private vasesRemaining: number = 0;

  // Shooter mode - click to shoot projectiles
  private isShooterMode: boolean = false;
  private shooterAmmo: number = 50;
  private shooterScore: number = 0;

  // Additional mode flags for tutorials
  private isSpeedrunMode: boolean = false;
  private isWhackMode: boolean = false;

  // Dragon Battle mode
  private isDragonBattleMode: boolean = false;
  private dragonBattleWave: number = 0;
  private dragonBattleRedDragonSpawned: boolean = false;
  private dragonBattleWave3Phase2: boolean = false;

  constructor(selectedPlants: PlantType[], isIZombieMode: boolean = false, isEndlessMode: boolean = false, powerPlant: PowerPlantType | null = null) {
    this.selectedPlants = selectedPlants;
    this.isIZombieMode = isIZombieMode;
    this.isEndlessMode = isEndlessMode;
    this.powerPlantType = powerPlant;
    // Initialize shared odd fusion unlock tracking for shop UI
    if (!(window as any).oddFusionUnlocks) {
      (window as any).oddFusionUnlocks = {};
    }
    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();

    // Load saved coins from localStorage
    const savedCoins = localStorage.getItem('fusionTdCoins');
    if (savedCoins) {
      this.coins = parseInt(savedCoins, 10) || 0;
    }

    // Apply cheat if activated from menu screen
    if (cheatActivated) {
      this.sun = cheatSun;
      this.coins = cheatCoins;
      // Max out ALL mastery for Frost Berri and Tomato Spike
      this.frostBerriMastery = 300;
      this.frostBerriMasteryPoints = 300;
      this.tomatoSpikeMastery = 300;
      this.tomatoSpikeMasteryPoints = 300;
      console.log('🎮 Cheat applied: Sun=' + this.sun + ', Coins=' + this.coins);
      console.log('❄️ Frost Berri Mastery: 300/300 MAXED!');
      console.log('🍅 Tomato Spike Mastery: 300/300 MAXED!');
    }

    // Speed Run mode - extra sun and skip tutorial
    if (localStorage.getItem('speedrunMode') === 'true') {
      this.sun = 5000;
      this.isSpeedrunMode = true;
      console.log('⏱️ Speed Run mode: Starting with 5000 sun!');
      localStorage.removeItem('speedrunMode'); // Clear flag
    }

    // Conveyor Belt mode - no sun needed, plants given automatically
    if (localStorage.getItem('conveyorMode') === 'true') {
      this.sun = 0; // No sun in conveyor mode
      this.isConveyorMode = true;
      console.log('🎒 Conveyor Belt mode: Plants will appear automatically!');
      localStorage.removeItem('conveyorMode'); // Clear flag
    }

    // Last Stand mode - lots of sun but no production
    if (localStorage.getItem('laststandMode') === 'true') {
      this.sun = 5000;
      this.isLastStandMode = true;
      console.log('🏰 Last Stand mode: Setup your defense, then survive!');
      localStorage.removeItem('laststandMode');
    }

    // Vasebreaker mode - strategic vase breaking TD
    if (localStorage.getItem('vasebreakerMode') === 'true') {
      this.sun = 200;
      this.isVasebreakerMode = true;
      console.log('🏺 Vasebreaker mode: Click vases to break them!');
      localStorage.removeItem('vasebreakerMode');
      // Spawn vases after scene is set up
      setTimeout(() => this.setupVasebreakerVases(), 500);
    }

    // Whack-a-Zombie mode - free shovel, smash zombies!
    if (localStorage.getItem('whackMode') === 'true') {
      this.sun = 1000;
      this.isWhackMode = true;
      console.log('🔨 Whack-a-Zombie mode: Free shovel - smash those zombies!');
      localStorage.removeItem('whackMode');
    }

    // Zombie Shooter TD mode - click to shoot, no planting!
    if (localStorage.getItem('shooterMode') === 'true') {
      this.sun = 0;
      this.isShooterMode = true;
      this.shooterAmmo = 50;
      console.log('🔫 Zombie Shooter mode: Click to shoot zombies!');
      localStorage.removeItem('shooterMode');
    }

    // Dragon Battle mode
    if (localStorage.getItem('dragonBattleMode') === 'true') {
      this.sun = 4000;
      this.isDragonBattleMode = true;
      console.log('🐉 Dragon Battle mode: Defeat the dragons!');
      localStorage.removeItem('dragonBattleMode');
    }

    // Setup scene
    this.scene = new THREE.Scene();

    // Create gradient sky background
    const skyCanvas = document.createElement('canvas');
    skyCanvas.width = 512;
    skyCanvas.height = 512;
    const skyCtx = skyCanvas.getContext('2d');
    if (skyCtx) {
      // Beautiful sunset/daytime gradient
      const gradient = skyCtx.createLinearGradient(0, 0, 0, 512);
      gradient.addColorStop(0, '#1a2a6c');     // Deep blue at top
      gradient.addColorStop(0.3, '#4a7bb7');   // Medium blue
      gradient.addColorStop(0.5, '#87ceeb');   // Sky blue
      gradient.addColorStop(0.7, '#b4d7e8');   // Light blue
      gradient.addColorStop(0.85, '#ffecd2');  // Warm horizon
      gradient.addColorStop(1, '#fcb69f');     // Peachy sunset
      skyCtx.fillStyle = gradient;
      skyCtx.fillRect(0, 0, 512, 512);

      // Add some clouds
      skyCtx.fillStyle = 'rgba(255, 255, 255, 0.3)';
      for (let i = 0; i < 8; i++) {
        const x = Math.random() * 512;
        const y = 50 + Math.random() * 200;
        const w = 60 + Math.random() * 100;
        const h = 20 + Math.random() * 30;
        skyCtx.beginPath();
        skyCtx.ellipse(x, y, w, h, 0, 0, Math.PI * 2);
        skyCtx.fill();
        // Second cloud puff
        skyCtx.beginPath();
        skyCtx.ellipse(x + w * 0.5, y - 5, w * 0.7, h * 0.8, 0, 0, Math.PI * 2);
        skyCtx.fill();
      }
    }
    const skyTexture = new THREE.CanvasTexture(skyCanvas);
    this.scene.background = skyTexture;

    // Setup camera
    this.camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    this.camera.position.set(0, 22, 12); // Fixed eagle-eye view
    this.camera.lookAt(0, 0, 0);

    // Setup renderer
    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(window.devicePixelRatio);

    const container = document.getElementById('canvas-container');
    if (container) {
      container.appendChild(this.renderer.domElement);
    }

    // Create lawn (grass field)
    this.createLawn();

    // Create planting slots
    this.createPlantingSlots();

    // Add a simple cube (placeholder for a tower)
    const geometry = new THREE.BoxGeometry(1, 2, 1);
    const material = new THREE.MeshPhongMaterial({ color: 0x8B4513 });
    this.cube = new THREE.Mesh(geometry, material);
    this.cube.position.set(-3, 1, -3);
    this.scene.add(this.cube);

    // Add lighting
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    this.scene.add(ambientLight);

    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
    directionalLight.position.set(10, 20, 10);
    directionalLight.castShadow = true;
    this.scene.add(directionalLight);

    // Setup UI
    this.setupUI();

    // Initialize mastery display
    this.updateMasteryDisplay();

    // Setup start wave button
    this.setupStartWaveButton();

    // Setup shovel button
    this.setupShovelButton();

    // Setup glove button
    this.setupGloveButton();

    // Setup camera controls
    this.setupCameraControls();

    // Setup pause menu
    this.setupPauseMenu();

    // Handle window resize
    window.addEventListener('resize', () => this.onWindowResize());

    // Handle mouse clicks for plant placement and pear cannon
    window.addEventListener('click', (event) => this.onMouseClick(event));

    // Handle mouse move for tile highlighting
    window.addEventListener('mousemove', (event) => this.onMouseMove(event));

    // Handle right-click for pear cannon
    window.addEventListener('contextmenu', (event) => {
      event.preventDefault();
      this.onRightClick(event);
    });

    // Handle odd fusion purchases (uses coins instead of sun)
    window.addEventListener('purchaseOddFusion', ((event: CustomEvent) => {
      const { plantType, coinCost, isUnlock } = event.detail;

      // Check if player has enough coins
      if (this.coins >= coinCost) {
        // Deduct coins
        this.coins -= coinCost;
        this.updateCoinDisplay();

        // Handle fusion unlock purchases (just unlock the recipe, player must fuse to create)
        if (isUnlock && plantType === 'frost-grape-gun') {
          this.frostGrapeGunUnlocked = true;
          (window as any).oddFusionUnlocks['frost-grape-gun'] = true;
          console.log(`✨ Unlocked ${plantType} fusion recipe for ${coinCost} coins!`);

          // Close the shop modal
          const oddShopModal = document.getElementById('odd-shop-modal');
          if (oddShopModal) {
            oddShopModal.classList.remove('active');
          }

          alert(`❄️🍇 FROST GRAPE GUN RECIPE UNLOCKED!\n\nYou can now fuse:\nGrape Gun + Elder Frost Berri = Frost Grape Gun\n\nCreate the fusion in-game to use it!`);
          return;
        }

        if (isUnlock && plantType === 'straw-spiker') {
          this.strawSpikerUnlocked = true;
          (window as any).oddFusionUnlocks['straw-spiker'] = true;
          console.log(`✨ Unlocked ${plantType} fusion recipe for ${coinCost} coins!`);

          // Close the shop modal
          const oddShopModal = document.getElementById('odd-shop-modal');
          if (oddShopModal) {
            oddShopModal.classList.remove('active');
          }

          alert(`🍓🍅 STRAWSPIKER RECIPE UNLOCKED!\n\nYou can now fuse:\nStrawbomber + Elder Tomato Spike = StrawSpiker\n\nCreate the fusion in-game to use it!`);
          return;
        }

        if (isUnlock && plantType === 'reaper-peall') {
          this.reaperWallUnlocked = true;
          (window as any).oddFusionUnlocks['reaper-peall'] = true;
          console.log(`✨ Unlocked ${plantType} fusion recipe for ${coinCost} coins!`);

          // Close the shop modal
          const oddShopModal = document.getElementById('odd-shop-modal');
          if (oddShopModal) {
            oddShopModal.classList.remove('active');
          }

          alert(`🌹🧱 REAPER WALL RECIPE UNLOCKED!\n\nYou can now fuse:\nFrost Peall + Rose Reaper = Reaper Peall\n\nCreate the fusion in-game to use it!`);
          return;
        }

        if (isUnlock && plantType === 'frozen-overlord-mushroom') {
          this.frozenOverlordUnlocked = true;
          (window as any).oddFusionUnlocks['frozen-overlord-mushroom'] = true;
          console.log(`✨ Unlocked ${plantType} fusion recipe for ${coinCost} coins!`);

          // Close the shop modal
          const oddShopModal = document.getElementById('odd-shop-modal');
          if (oddShopModal) {
            oddShopModal.classList.remove('active');
          }

          alert(`🍄👑❄️ FROZEN OVERLORD MUSHROOM RECIPE UNLOCKED!\n\nYou can now fuse:\nFrozen Mushroom Bomber + Elder Frost Berri = Frozen Overlord Mushroom\n\nDeals 200 damage in 3x3 area with freeze and slow!`);
          return;
        }

        // Handle 2nd form odd fusion unlocks
        if (isUnlock && plantType === 'frost-overlord-grape-gun') {
          this.frostOverlordGrapeGunUnlocked = true;
          (window as any).oddFusionUnlocks['frost-overlord-grape-gun'] = true;
          console.log(`✨ Unlocked ${plantType} fusion recipe for ${coinCost} coins!`);
          const oddShopModal = document.getElementById('odd-shop-modal');
          if (oddShopModal) oddShopModal.classList.remove('active');
          alert(`❄️👑🍇 FROST OVERLORD GRAPE GUN RECIPE UNLOCKED!\n\nYou can now fuse:\nFrost Grape Gun + Elder Frost Berri = Frost Overlord Grape Gun\n\nCreate the fusion in-game to use it!`);
          return;
        }

        if (isUnlock && plantType === 'thornbomber') {
          this.thornbomberUnlocked = true;
          (window as any).oddFusionUnlocks['thornbomber'] = true;
          console.log(`✨ Unlocked ${plantType} fusion recipe for ${coinCost} coins!`);
          const oddShopModal = document.getElementById('odd-shop-modal');
          if (oddShopModal) oddShopModal.classList.remove('active');
          alert(`🍓🌹💣 THORNBOMBER RECIPE UNLOCKED!\n\nYou can now fuse:\nStrawSpiker + Rose Reaper = ThornBomber\n\nCreate the fusion in-game to use it!`);
          return;
        }

        if (isUnlock && plantType === 'titan-reaper-peall') {
          this.titanReaperPeallUnlocked = true;
          (window as any).oddFusionUnlocks['titan-reaper-peall'] = true;
          console.log(`✨ Unlocked ${plantType} fusion recipe for ${coinCost} coins!`);
          const oddShopModal = document.getElementById('odd-shop-modal');
          if (oddShopModal) oddShopModal.classList.remove('active');
          alert(`👑🌹🧱 TITAN REAPER PEALL RECIPE UNLOCKED!\n\nYou can now fuse:\nReaper Peall + Frovine Slammer = Titan Reaper Peall\n\nCreate the fusion in-game to use it!`);
          return;
        }

        if (isUnlock && plantType === 'frozen-nebula-mushroom') {
          this.frozenNebulaMushroomUnlocked = true;
          (window as any).oddFusionUnlocks['frozen-nebula-mushroom'] = true;
          console.log(`✨ Unlocked ${plantType} fusion recipe for ${coinCost} coins!`);
          const oddShopModal = document.getElementById('odd-shop-modal');
          if (oddShopModal) oddShopModal.classList.remove('active');
          alert(`🍄🌌❄️ FROZEN NEBULA MUSHROOM RECIPE UNLOCKED!\n\nYou can now fuse:\nFrozen Overlord Mushroom + Black Hole Coconut = Frozen Nebula Mushroom\n\nCreate the fusion in-game to use it!`);
          return;
        }

        // Add plant to available plants if not already there
        if (!this.selectedPlants.includes(plantType)) {
          this.selectedPlants.push(plantType);

          // Add to plant bar UI
          const plantBar = document.getElementById('plant-bar');
          if (plantBar) {
            const info = PLANT_INFO[plantType];
            const slot = document.createElement('div');
            slot.className = 'plant-slot';
            slot.dataset.plant = plantType;
            slot.innerHTML = `
              <div class="name">${info.emoji} ${info.name}</div>
              <div class="cost">☀️ ${info.cost}</div>
            `;
            slot.addEventListener('click', () => this.selectPlant(plantType));
            plantBar.appendChild(slot);
          }
        }

        console.log(`✨ Purchased ${plantType} for ${coinCost} coins!`);

        // Close the shop modal
        const oddShopModal = document.getElementById('odd-shop-modal');
        if (oddShopModal) {
          oddShopModal.classList.remove('active');
        }

        // Show success message
        this.showPurchaseSuccess(plantType);
      } else {
        console.log(`❌ Not enough coins! Need ${coinCost}, have ${this.coins}`);
        alert(`Not enough coins! You need ${coinCost} coins but only have ${this.coins} coins.\n\nDefeat zombies to earn more coins!`);
      }
    }) as EventListener);

    // Start background music on first user interaction (required by browsers)
    const startMusicOnce = () => {
      if (!this.musicPlaying) {
        this.startBackgroundMusic();
      }
      document.removeEventListener('click', startMusicOnce);
      document.removeEventListener('keydown', startMusicOnce);
    };
    document.addEventListener('click', startMusicOnce);
    document.addEventListener('keydown', startMusicOnce);

    // Show tutorial at game start (only once when game loads) - but NOT in I Zombie or Endless mode
    if (!this.isIZombieMode && !this.isEndlessMode) {
      const tutorialOverlay = document.getElementById('tutorial-overlay');
      if (tutorialOverlay) {
        tutorialOverlay.classList.add('active');
      }
    }

    // Start animation loop
    this.animate();

    // Spawn power plant if selected
    if (this.powerPlantType) {
      this.spawnPowerPlant();
    }

    // Log controls
    console.log('🎮 CONTROLS:');
    console.log('- Scroll: Pan camera (Shift+Scroll for horizontal)');
    console.log('- Click plants: Select from top bar to place');
    console.log('- Click Shovel: Remove plants');
    console.log('- Click Pear Cannon: Manual fire');
    console.log('- Place plant on plant: Fusion!');
    console.log('- Press 1: Toggle plant HP display');
    console.log('- Press 2: Toggle zombie HP display');
    console.log('- Press 3: Toggle SLOW MOTION');
    console.log('- Press M: Toggle music');
  }

  private startBackgroundMusic(): void {
    if (this.musicPlaying) return;

    try {
      this.audioContext = new AudioContext();
      this.musicGainNode = this.audioContext.createGain();
      this.musicGainNode.gain.value = 0.3; // Volume
      this.musicGainNode.connect(this.audioContext.destination);

      this.musicPlaying = true;
      this.playMelody();
      console.log('🎵 Music started! Press M to toggle.');
    } catch (e) {
      console.log('Could not start audio:', e);
    }
  }

  private playMelody(): void {
    if (!this.audioContext || !this.musicGainNode || !this.musicPlaying) return;

    const ctx = this.audioContext;
    const masterGain = this.musicGainNode;

    // Epic tower defense melody - upbeat and catchy with multiple sections!
    // Notes in Hz (C4 = 261.63, D4 = 293.66, E4 = 329.63, etc.)
    const C4 = 261.63, D4 = 293.66, E4 = 329.63, F4 = 349.23, G4 = 392.00;
    const A4 = 440.00, B4 = 493.88, C5 = 523.25, D5 = 587.33, E5 = 659.25, F5 = 698.46, G5 = 783.99;
    const C3 = 130.81, D3 = 146.83, E3 = 164.81, F3 = 174.61, G3 = 196.00, A3 = 220.00;
    // B3 available at 246.94 Hz if needed

    // PART 1: Main Theme - heroic and uplifting
    const melody = [
      // Phrase 1 - Opening fanfare
      { note: E4, duration: 0.2 },
      { note: G4, duration: 0.2 },
      { note: C5, duration: 0.4 },
      { note: B4, duration: 0.2 },
      { note: A4, duration: 0.2 },
      { note: G4, duration: 0.4 },
      { note: E4, duration: 0.2 },
      { note: D4, duration: 0.2 },
      { note: C4, duration: 0.4 },
      { note: D4, duration: 0.2 },
      { note: E4, duration: 0.2 },
      { note: G4, duration: 0.4 },
      { note: A4, duration: 0.2 },
      { note: G4, duration: 0.2 },
      { note: E4, duration: 0.4 },
      { note: D4, duration: 0.4 },
      // Phrase 2 - Rising action
      { note: E4, duration: 0.2 },
      { note: G4, duration: 0.2 },
      { note: C5, duration: 0.4 },
      { note: D5, duration: 0.2 },
      { note: E5, duration: 0.2 },
      { note: D5, duration: 0.2 },
      { note: C5, duration: 0.2 },
      { note: B4, duration: 0.4 },
      { note: A4, duration: 0.2 },
      { note: G4, duration: 0.2 },
      { note: A4, duration: 0.2 },
      { note: B4, duration: 0.2 },
      { note: C5, duration: 0.6 },
      { note: 0, duration: 0.2 }, // Rest
      // PART 2: Battle section - more intense!
      { note: C5, duration: 0.15 },
      { note: B4, duration: 0.15 },
      { note: C5, duration: 0.15 },
      { note: E5, duration: 0.35 },
      { note: D5, duration: 0.15 },
      { note: C5, duration: 0.15 },
      { note: B4, duration: 0.15 },
      { note: A4, duration: 0.35 },
      { note: G4, duration: 0.2 },
      { note: A4, duration: 0.2 },
      { note: B4, duration: 0.2 },
      { note: C5, duration: 0.2 },
      { note: D5, duration: 0.4 },
      { note: E5, duration: 0.4 },
      // Phrase 4 - Triumphant conclusion
      { note: G5, duration: 0.3 },
      { note: F5, duration: 0.15 },
      { note: E5, duration: 0.15 },
      { note: D5, duration: 0.3 },
      { note: C5, duration: 0.3 },
      { note: B4, duration: 0.15 },
      { note: A4, duration: 0.15 },
      { note: G4, duration: 0.4 },
      { note: E4, duration: 0.2 },
      { note: F4, duration: 0.2 },
      { note: G4, duration: 0.4 },
      { note: C5, duration: 0.6 },
      { note: 0, duration: 0.2 }, // Rest
      // PART 3: Bridge - softer melodic section
      { note: A4, duration: 0.3 },
      { note: G4, duration: 0.3 },
      { note: E4, duration: 0.3 },
      { note: D4, duration: 0.3 },
      { note: C4, duration: 0.4 },
      { note: D4, duration: 0.2 },
      { note: E4, duration: 0.2 },
      { note: G4, duration: 0.4 },
      { note: A4, duration: 0.3 },
      { note: B4, duration: 0.3 },
      { note: C5, duration: 0.4 },
      { note: B4, duration: 0.2 },
      { note: A4, duration: 0.2 },
      { note: G4, duration: 0.6 },
      { note: 0, duration: 0.2 }, // Rest
      // PART 4: Final build-up and resolution
      { note: C4, duration: 0.2 },
      { note: E4, duration: 0.2 },
      { note: G4, duration: 0.2 },
      { note: C5, duration: 0.2 },
      { note: E5, duration: 0.4 },
      { note: D5, duration: 0.2 },
      { note: C5, duration: 0.2 },
      { note: B4, duration: 0.2 },
      { note: A4, duration: 0.2 },
      { note: G4, duration: 0.2 },
      { note: E4, duration: 0.2 },
      { note: C4, duration: 0.2 },
      { note: D4, duration: 0.2 },
      { note: E4, duration: 0.2 },
      { note: G4, duration: 0.2 },
      { note: C5, duration: 0.8 },
      { note: 0, duration: 0.4 }, // Rest
      // PART 5: Epic battle continuation - intense and driving
      { note: E5, duration: 0.2 },
      { note: D5, duration: 0.2 },
      { note: C5, duration: 0.2 },
      { note: B4, duration: 0.2 },
      { note: A4, duration: 0.3 },
      { note: G4, duration: 0.3 },
      { note: A4, duration: 0.2 },
      { note: B4, duration: 0.2 },
      { note: C5, duration: 0.4 },
      { note: D5, duration: 0.4 },
      { note: E5, duration: 0.2 },
      { note: F5, duration: 0.2 },
      { note: G5, duration: 0.6 },
      { note: 0, duration: 0.2 }, // Rest
      // Victory fanfare
      { note: C5, duration: 0.15 },
      { note: E5, duration: 0.15 },
      { note: G5, duration: 0.3 },
      { note: E5, duration: 0.15 },
      { note: G5, duration: 0.15 },
      { note: C5, duration: 0.3 },
      { note: D5, duration: 0.2 },
      { note: E5, duration: 0.2 },
      { note: F5, duration: 0.2 },
      { note: E5, duration: 0.2 },
      { note: D5, duration: 0.2 },
      { note: C5, duration: 0.4 },
      { note: B4, duration: 0.2 },
      { note: C5, duration: 0.6 },
      { note: 0, duration: 0.3 }, // Rest
      // PART 6: Calm before the storm - mysterious
      { note: A4, duration: 0.4 },
      { note: E4, duration: 0.4 },
      { note: F4, duration: 0.4 },
      { note: G4, duration: 0.4 },
      { note: A4, duration: 0.3 },
      { note: B4, duration: 0.3 },
      { note: C5, duration: 0.6 },
      { note: B4, duration: 0.3 },
      { note: A4, duration: 0.3 },
      { note: G4, duration: 0.4 },
      { note: 0, duration: 0.2 }, // Rest
      // Building tension
      { note: C4, duration: 0.15 },
      { note: D4, duration: 0.15 },
      { note: E4, duration: 0.15 },
      { note: F4, duration: 0.15 },
      { note: G4, duration: 0.15 },
      { note: A4, duration: 0.15 },
      { note: B4, duration: 0.15 },
      { note: C5, duration: 0.15 },
      { note: D5, duration: 0.3 },
      { note: E5, duration: 0.3 },
      { note: F5, duration: 0.3 },
      { note: G5, duration: 0.5 },
      { note: 0, duration: 0.2 }, // Rest
      // PART 7: Grand finale
      { note: G5, duration: 0.2 },
      { note: F5, duration: 0.2 },
      { note: E5, duration: 0.2 },
      { note: D5, duration: 0.2 },
      { note: C5, duration: 0.4 },
      { note: G4, duration: 0.2 },
      { note: E4, duration: 0.2 },
      { note: C4, duration: 0.4 },
      { note: D4, duration: 0.2 },
      { note: E4, duration: 0.2 },
      { note: G4, duration: 0.4 },
      { note: C5, duration: 0.6 },
      { note: E5, duration: 0.6 },
      { note: G5, duration: 0.8 },
      { note: 0, duration: 0.5 }, // Final rest before loop
    ];

    // Extended bass line with more variety
    const bass = [
      // Part 1 bass
      { note: C3, duration: 0.4 },
      { note: E3, duration: 0.4 },
      { note: G3, duration: 0.4 },
      { note: E3, duration: 0.4 },
      { note: A3, duration: 0.4 },
      { note: G3, duration: 0.4 },
      { note: F3, duration: 0.4 },
      { note: G3, duration: 0.4 },
      // Part 2 bass - more driving
      { note: C3, duration: 0.2 },
      { note: C3, duration: 0.2 },
      { note: G3, duration: 0.2 },
      { note: G3, duration: 0.2 },
      { note: A3, duration: 0.2 },
      { note: A3, duration: 0.2 },
      { note: E3, duration: 0.2 },
      { note: E3, duration: 0.2 },
      { note: F3, duration: 0.4 },
      { note: G3, duration: 0.4 },
      { note: C3, duration: 0.4 },
      { note: G3, duration: 0.4 },
      // Part 3 bass - gentler
      { note: A3, duration: 0.6 },
      { note: E3, duration: 0.6 },
      { note: F3, duration: 0.6 },
      { note: C3, duration: 0.6 },
      { note: D3, duration: 0.6 },
      { note: G3, duration: 0.6 },
      // Part 4 bass - building
      { note: C3, duration: 0.3 },
      { note: E3, duration: 0.3 },
      { note: G3, duration: 0.3 },
      { note: C3, duration: 0.3 },
      { note: F3, duration: 0.3 },
      { note: A3, duration: 0.3 },
      { note: G3, duration: 0.3 },
      { note: G3, duration: 0.3 },
      { note: C3, duration: 0.8 },
    ];

    // Harmony line (plays along with melody for richness)
    const harmony = [
      // Harmonizes with main theme
      { note: C4, duration: 0.4 },
      { note: E4, duration: 0.4 },
      { note: G4, duration: 0.4 },
      { note: E4, duration: 0.4 },
      { note: C4, duration: 0.4 },
      { note: B4 * 0.5, duration: 0.4 },
      { note: A4 * 0.5, duration: 0.4 },
      { note: G4 * 0.5, duration: 0.4 },
      { note: C4, duration: 0.8 },
      { note: E4, duration: 0.8 },
      { note: G4, duration: 0.8 },
      { note: A4, duration: 0.8 },
      { note: G4, duration: 0.8 },
      { note: E4, duration: 0.8 },
      { note: C4, duration: 1.6 },
    ];

    let melodyTime = ctx.currentTime + 0.1;
    let bassTime = ctx.currentTime + 0.1;

    // Play melody notes
    melody.forEach(({ note, duration }) => {
      if (note > 0) {
        this.playNote(ctx, masterGain, note, melodyTime, duration * 0.9, 'square', 0.15);
      }
      melodyTime += duration;
    });

    // Play bass line (loop it to match melody length)
    const melodyLength = melody.reduce((sum, n) => sum + n.duration, 0);
    let bassLoops = Math.ceil(melodyLength / bass.reduce((sum, n) => sum + n.duration, 0));

    for (let loop = 0; loop < bassLoops; loop++) {
      bass.forEach(({ note, duration }) => {
        if (bassTime < ctx.currentTime + melodyLength + 0.1) {
          this.playNote(ctx, masterGain, note, bassTime, duration * 0.7, 'triangle', 0.2);
        }
        bassTime += duration;
      });
    }

    // Play harmony line (loop to match melody length)
    let harmonyTime = ctx.currentTime + 0.1;
    const harmonyLength = harmony.reduce((sum, n) => sum + n.duration, 0);
    const harmonyLoops = Math.ceil(melodyLength / harmonyLength);

    for (let loop = 0; loop < harmonyLoops; loop++) {
      harmony.forEach(({ note, duration }) => {
        if (harmonyTime < ctx.currentTime + melodyLength + 0.1 && note > 0) {
          // Use sine wave for softer harmony, lower volume
          this.playNote(ctx, masterGain, note, harmonyTime, duration * 0.8, 'sine', 0.08);
        }
        harmonyTime += duration;
      });
    }

    // Enhanced percussion with multiple drum patterns
    let percTime = ctx.currentTime + 0.1;
    const beatCount = Math.floor(melodyLength / 0.2); // 8th notes for more detail

    for (let i = 0; i < beatCount; i++) {
      const beat = i % 8; // 8 beats per measure

      // Kick pattern - beats 1, 3, and sometimes 7
      if (beat === 0 || beat === 4 || (beat === 6 && i % 16 < 8)) {
        this.playDrum(ctx, masterGain, percTime, 'kick');
      }

      // Snare on beats 2 and 4 (beats 2 and 6 in 8th note counting)
      if (beat === 2 || beat === 6) {
        this.playDrum(ctx, masterGain, percTime, 'snare');
      }

      // Hihat pattern - 8th notes with accents
      if (beat % 2 === 0) {
        this.playDrum(ctx, masterGain, percTime, 'hihat');
      } else {
        // Lighter off-beat hihats
        this.playDrum(ctx, masterGain, percTime, 'ride');
      }

      // Tom fills every 8 measures (at beat 7)
      if (beat === 7 && i % 64 >= 56) {
        const fillBeat = (i % 8);
        if (fillBeat < 3) {
          this.playDrum(ctx, masterGain, percTime, 'tom-high');
        } else if (fillBeat < 6) {
          this.playDrum(ctx, masterGain, percTime, 'tom-low');
        }
      }

      // Crash on first beat of every 4th measure
      if (beat === 0 && i % 32 === 0 && i > 0) {
        this.playDrum(ctx, masterGain, percTime, 'crash');
      }

      percTime += 0.2;
    }

    // Extra percussion flourishes at section changes
    const sectionChanges = [3.2, 6.4, 9.6, 12.8]; // Approximate section change times
    sectionChanges.forEach(time => {
      if (time < melodyLength) {
        this.playDrum(ctx, masterGain, ctx.currentTime + time, 'crash');
        this.playDrum(ctx, masterGain, ctx.currentTime + time - 0.1, 'tom-high');
        this.playDrum(ctx, masterGain, ctx.currentTime + time - 0.2, 'tom-low');
      }
    });

    // Schedule next loop
    const loopDuration = melodyLength * 1000;
    setTimeout(() => {
      if (this.musicPlaying) {
        this.playMelody();
      }
    }, loopDuration);
  }

  private playNote(
    ctx: AudioContext,
    masterGain: GainNode,
    frequency: number,
    startTime: number,
    duration: number,
    waveType: OscillatorType,
    volume: number
  ): void {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = waveType;
    osc.frequency.setValueAtTime(frequency, startTime);

    gain.gain.setValueAtTime(0, startTime);
    gain.gain.linearRampToValueAtTime(volume, startTime + 0.02);
    gain.gain.setValueAtTime(volume, startTime + duration * 0.7);
    gain.gain.linearRampToValueAtTime(0, startTime + duration);

    osc.connect(gain);
    gain.connect(masterGain);

    osc.start(startTime);
    osc.stop(startTime + duration + 0.1);
  }

  private playDrum(ctx: AudioContext, masterGain: GainNode, time: number, type: 'kick' | 'snare' | 'hihat' | 'tom-high' | 'tom-low' | 'crash' | 'ride'): void {
    const gain = ctx.createGain();
    gain.connect(masterGain);

    if (type === 'kick') {
      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(150, time);
      osc.frequency.exponentialRampToValueAtTime(40, time + 0.1);
      gain.gain.setValueAtTime(0.3, time);
      gain.gain.exponentialRampToValueAtTime(0.01, time + 0.15);
      osc.connect(gain);
      osc.start(time);
      osc.stop(time + 0.15);
    } else if (type === 'snare') {
      // Noise burst for snare
      const bufferSize = ctx.sampleRate * 0.1;
      const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
      const data = buffer.getChannelData(0);
      for (let i = 0; i < bufferSize; i++) {
        data[i] = Math.random() * 2 - 1;
      }
      const noise = ctx.createBufferSource();
      noise.buffer = buffer;
      gain.gain.setValueAtTime(0.15, time);
      gain.gain.exponentialRampToValueAtTime(0.01, time + 0.1);
      noise.connect(gain);
      noise.start(time);
      noise.stop(time + 0.1);
    } else if (type === 'hihat') {
      // High noise burst for hihat
      const bufferSize = ctx.sampleRate * 0.05;
      const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
      const data = buffer.getChannelData(0);
      for (let i = 0; i < bufferSize; i++) {
        data[i] = Math.random() * 2 - 1;
      }
      const noise = ctx.createBufferSource();
      noise.buffer = buffer;

      // High-pass filter for hihat sound
      const filter = ctx.createBiquadFilter();
      filter.type = 'highpass';
      filter.frequency.value = 7000;

      gain.gain.setValueAtTime(0.08, time);
      gain.gain.exponentialRampToValueAtTime(0.01, time + 0.05);
      noise.connect(filter);
      filter.connect(gain);
      noise.start(time);
      noise.stop(time + 0.05);
    } else if (type === 'tom-high') {
      // High tom - pitched drum
      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(200, time);
      osc.frequency.exponentialRampToValueAtTime(120, time + 0.15);
      gain.gain.setValueAtTime(0.2, time);
      gain.gain.exponentialRampToValueAtTime(0.01, time + 0.2);
      osc.connect(gain);
      osc.start(time);
      osc.stop(time + 0.2);
    } else if (type === 'tom-low') {
      // Low tom - deeper pitched drum
      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(120, time);
      osc.frequency.exponentialRampToValueAtTime(60, time + 0.2);
      gain.gain.setValueAtTime(0.25, time);
      gain.gain.exponentialRampToValueAtTime(0.01, time + 0.25);
      osc.connect(gain);
      osc.start(time);
      osc.stop(time + 0.25);
    } else if (type === 'crash') {
      // Crash cymbal - long noise with high frequencies
      const bufferSize = ctx.sampleRate * 0.5;
      const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
      const data = buffer.getChannelData(0);
      for (let i = 0; i < bufferSize; i++) {
        data[i] = Math.random() * 2 - 1;
      }
      const noise = ctx.createBufferSource();
      noise.buffer = buffer;

      const filter = ctx.createBiquadFilter();
      filter.type = 'highpass';
      filter.frequency.value = 4000;

      gain.gain.setValueAtTime(0.15, time);
      gain.gain.exponentialRampToValueAtTime(0.01, time + 0.4);
      noise.connect(filter);
      filter.connect(gain);
      noise.start(time);
      noise.stop(time + 0.5);
    } else if (type === 'ride') {
      // Ride cymbal - metallic ping
      const bufferSize = ctx.sampleRate * 0.15;
      const buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
      const data = buffer.getChannelData(0);
      for (let i = 0; i < bufferSize; i++) {
        data[i] = Math.random() * 2 - 1;
      }
      const noise = ctx.createBufferSource();
      noise.buffer = buffer;

      const filter = ctx.createBiquadFilter();
      filter.type = 'bandpass';
      filter.frequency.value = 5000;
      filter.Q.value = 2;

      gain.gain.setValueAtTime(0.1, time);
      gain.gain.exponentialRampToValueAtTime(0.01, time + 0.12);
      noise.connect(filter);
      filter.connect(gain);
      noise.start(time);
      noise.stop(time + 0.15);
    }
  }

  private toggleMusic(): void {
    if (this.musicPlaying) {
      this.musicPlaying = false;
      if (this.musicGainNode) {
        this.musicGainNode.gain.value = 0;
      }
      console.log('🔇 Music paused');
    } else {
      this.musicPlaying = true;
      if (this.musicGainNode) {
        this.musicGainNode.gain.value = 0.3;
      }
      if (this.audioContext) {
        this.playMelody();
      } else {
        this.startBackgroundMusic();
      }
      console.log('🎵 Music resumed');
    }
  }

  private setupUI(): void {
    const gameUI = document.getElementById('game-ui');
    const plantBar = document.getElementById('plant-bar');
    const sunAmount = document.getElementById('sun-amount');

    if (gameUI) {
      gameUI.classList.add('active');
    }

    // I, Zombie mode setup
    if (this.isIZombieMode) {
      this.sun = 2000; // Start with 2000 sun
      if (sunAmount) {
        sunAmount.textContent = this.sun.toString();
      }
      this.setupIZombieMode();
      return; // Don't setup normal plant bar
    }

    // Shooter mode setup - click to shoot zombies!
    if (this.isShooterMode) {
      this.setupShooterMode();
      return; // Don't setup normal plant bar
    }

    // Whack-a-Zombie mode setup - only shovel, no plants!
    if (this.isWhackMode) {
      // Hide plant bar - only shovel is allowed!
      if (plantBar) {
        plantBar.style.display = 'none';
      }
      // Keep sun display visible but hide plant-related UI
      this.showModeSpecificTutorial();
    }

    // Endless mode setup - auto-start first wave
    if (this.isEndlessMode) {
      this.showModeTutorial('endless');
      this.sun = 1000; // Start with more sun in endless mode
      if (sunAmount) {
        sunAmount.textContent = this.sun.toString();
      }
      console.log('♾️ Endless mode active! Starting wave 1 automatically...');
      setTimeout(() => {
        this.startNextWave();
      }, 2000); // Delay to let tutorial show
    }

    if (sunAmount) {
      sunAmount.textContent = this.sun.toString();
    }

    // Update coin display with saved coins
    this.updateCoinDisplay();

    if (plantBar) {
      this.selectedPlants.forEach(plantType => {
        const info = PLANT_INFO[plantType];
        const slot = document.createElement('div');
        slot.className = 'plant-slot';
        slot.dataset.plant = plantType;
        slot.innerHTML = `
          <div class="name">${info.emoji} ${info.name}</div>
          <div class="cost">☀️ ${info.cost}</div>
        `;

        // For frost-berri and tomato-spike, use special click handling to support double-click toggle to Elder
        if (plantType === 'frost-berri') {
          let clickTimeout: number | null = null;
          slot.addEventListener('click', () => {
            if (clickTimeout) {
              // Double click detected - clear timeout and toggle
              clearTimeout(clickTimeout);
              clickTimeout = null;
              this.toggleFrostBerriElder(slot);
            } else {
              // Single click - wait to see if it's a double click
              clickTimeout = window.setTimeout(() => {
                clickTimeout = null;
                const currentPlant = slot.dataset.plant as PlantType;
                this.selectPlant(currentPlant);
              }, 250);
            }
          });
        } else if (plantType === 'tomato-spike') {
          let clickTimeout: number | null = null;
          slot.addEventListener('click', () => {
            if (clickTimeout) {
              // Double click detected - clear timeout and toggle
              clearTimeout(clickTimeout);
              clickTimeout = null;
              this.toggleTomatoSpikeElder(slot);
            } else {
              // Single click - wait to see if it's a double click
              clickTimeout = window.setTimeout(() => {
                clickTimeout = null;
                const currentPlant = slot.dataset.plant as PlantType;
                this.selectPlant(currentPlant);
              }, 250);
            }
          });
        } else {
          slot.addEventListener('click', () => this.selectPlant(plantType));
        }

        plantBar.appendChild(slot);
      });
    }

    // Show tutorials for modes that don't have dedicated setup methods
    this.showModeSpecificTutorial();
  }

  private showModeSpecificTutorial(): void {
    // Show tutorials based on active mode flags
    if (this.isVasebreakerMode) {
      this.showModeTutorial('vasebreaker');
    } else if (this.isConveyorMode) {
      this.showModeTutorial('conveyor');
    } else if (this.isSpeedrunMode) {
      this.showModeTutorial('speedrun');
    } else if (this.isLastStandMode) {
      this.showModeTutorial('laststand');
    } else if (this.isWhackMode) {
      this.showModeTutorial('whack');
      // Auto-activate shovel mode for Whack-a-Zombie!
      setTimeout(() => {
        this.shovelMode = true;
        const shovelBtn = document.getElementById('shovel-btn');
        if (shovelBtn) {
          shovelBtn.classList.add('active');
          shovelBtn.style.boxShadow = '0 0 20px #ffaa00, 0 0 40px #ff6600';
          shovelBtn.style.animation = 'pulse 1s infinite';
        }
        console.log('🔨 Shovel auto-activated for Whack-a-Zombie! Click zombies to smash them!');
      }, 100);
    } else if (this.isDragonBattleMode) {
      this.showModeTutorial('dragonbattle');
    }
    // Note: shooter, izombie, and endless modes show tutorials in their dedicated setup methods
  }

  private toggleFrostBerriElder(slot: HTMLElement): void {
    const currentPlant = slot.dataset.plant as PlantType;

    // Check if player has mastered frost-berri
    if (this.frostBerriMasteryPoints < 300) {
      console.log('❄️ You need mastery points to unlock Elder Frost Berri!');
      alert(`Frost Berri Mastery not complete!\n\nYou have ${this.frostBerriMasteryPoints}/300 mastery points.\n\nEarn more mastery points to unlock Elder Frost Berri!`);
      return;
    }

    if (currentPlant === 'frost-berri') {
      // Switch to elder-frost-berri
      const elderInfo = PLANT_INFO['elder-frost-berri'];
      slot.dataset.plant = 'elder-frost-berri';
      slot.innerHTML = `
        <div class="name">${elderInfo.emoji} ${elderInfo.name}</div>
        <div class="cost">☀️ ${elderInfo.cost}</div>
      `;
      slot.style.background = 'linear-gradient(135deg, #00ffff, #0080ff, #ffd700)';
      slot.style.boxShadow = '0 0 20px #00ffff, 0 0 40px #0080ff';
      alert('❄️👴 ELDER FROST BERRI ACTIVATED!\n\n20 second freeze on all zombies in range!');
      console.log('❄️👴 Switched to Elder Frost Berri!');
    } else if (currentPlant === 'elder-frost-berri') {
      // Switch back to frost-berri
      const normalInfo = PLANT_INFO['frost-berri'];
      slot.dataset.plant = 'frost-berri';
      slot.innerHTML = `
        <div class="name">${normalInfo.emoji} ${normalInfo.name}</div>
        <div class="cost">☀️ ${normalInfo.cost}</div>
      `;
      slot.style.background = '';
      slot.style.boxShadow = '';
      console.log('❄️ Switched back to Frost Berri!');
    }

    // Deselect current plant when switching
    this.currentPlantType = null;
    document.querySelectorAll('.plant-slot').forEach(s => s.classList.remove('selected'));
  }

  private toggleTomatoSpikeElder(slot: HTMLElement): void {
    const currentPlant = slot.dataset.plant as PlantType;

    // Check if player has mastered tomato-spike
    if (this.tomatoSpikeMasteryPoints < 300) {
      console.log('🍅 You need mastery points to unlock Elder Tomato Spike!');
      alert(`Tomato Spike Mastery not complete!\n\nYou have ${this.tomatoSpikeMasteryPoints}/300 mastery points.\n\nEarn more mastery points to unlock Elder Tomato Spike!`);
      return;
    }

    if (currentPlant === 'tomato-spike') {
      // Switch to elder-tomato-spike
      const elderInfo = PLANT_INFO['elder-tomato-spike'];
      slot.dataset.plant = 'elder-tomato-spike';
      slot.innerHTML = `
        <div class="name">${elderInfo.emoji} ${elderInfo.name}</div>
        <div class="cost">☀️ ${elderInfo.cost}</div>
      `;
      slot.style.background = 'linear-gradient(135deg, #ff4500, #ffd700, #ff0000)';
      slot.style.boxShadow = '0 0 20px #ff4500, 0 0 40px #ffd700';
      alert('🔥👴 ELDER TOMATO SPIKE ACTIVATED!\n\n300 damage explosion with 4-tile range!');
      console.log('🍅👴 Switched to Elder Tomato Spike!');
    } else if (currentPlant === 'elder-tomato-spike') {
      // Switch back to tomato-spike
      const normalInfo = PLANT_INFO['tomato-spike'];
      slot.dataset.plant = 'tomato-spike';
      slot.innerHTML = `
        <div class="name">${normalInfo.emoji} ${normalInfo.name}</div>
        <div class="cost">☀️ ${normalInfo.cost}</div>
      `;
      slot.style.background = '';
      slot.style.boxShadow = '';
      console.log('🍅 Switched back to Tomato Spike!');
    }

    // Deselect current plant when switching
    this.currentPlantType = null;
    document.querySelectorAll('.plant-slot').forEach(s => s.classList.remove('selected'));
  }

  private setupIZombieMode(): void {
    console.log('🧟 Setting up I, Zombie mode!');

    // Show tutorial
    this.showModeTutorial('izombie');

    // Create zombie bar instead of plant bar
    const plantBar = document.getElementById('plant-bar');
    if (plantBar) {
      plantBar.innerHTML = ''; // Clear existing plant bar

      // Zombie types available in I Zombie mode - just the basic 3
      const zombieTypes: { type: ZombieType, name: string, cost: number, emoji: string }[] = [
        { type: 'normal', name: 'Zombie', cost: 50, emoji: '🧟' },
        { type: 'fast', name: 'Fast Zombie', cost: 75, emoji: '🏃' },
        { type: 'tank', name: 'Tank Zombie', cost: 150, emoji: '🛡️' }
      ];

      zombieTypes.forEach(zombieInfo => {
        const slot = document.createElement('div');
        slot.className = 'plant-slot zombie-slot';
        slot.dataset.zombie = zombieInfo.type;
        slot.innerHTML = `
          <div class="name">${zombieInfo.emoji} ${zombieInfo.name}</div>
          <div class="cost">☀️ ${zombieInfo.cost}</div>
        `;
        // Purple zombie theme styling
        slot.style.background = 'linear-gradient(135deg, #5a4a6a, #3a2a4a)';
        slot.style.borderColor = '#9a6a9a';
        slot.style.color = '#ffffff';
        slot.style.minWidth = '70px';
        slot.style.padding = '0.4rem 0.5rem';

        slot.addEventListener('click', () => {
          // Check if we have enough sun
          if (this.sun < zombieInfo.cost) {
            console.log('Not enough sun to spawn ' + zombieInfo.name + '!');
            return;
          }

          // Select this zombie type
          this.selectedZombieType = zombieInfo.type;
          document.querySelectorAll('.plant-slot').forEach(s => s.classList.remove('selected'));
          slot.classList.add('selected');
          console.log('Selected zombie: ' + zombieInfo.name);
        });

        plantBar.appendChild(slot);
      });
    }

    // Hide the "Start Wave" button - in I Zombie mode, the game starts immediately
    const startWaveBtn = document.getElementById('start-wave-btn');
    if (startWaveBtn) {
      startWaveBtn.style.display = 'none';
    }

    // Pre-place enemy plants on the field
    this.placeIZombiePlants();

    // Update the title/hint
    const gloveHint = document.getElementById('glove-hint');
    if (gloveHint) {
      gloveHint.innerHTML = '🧟 I, ZOMBIE: Click right side to spawn zombies! Reach the left to win!';
      gloveHint.style.color = '#ff6666';
      gloveHint.style.fontSize = '1rem';
    }

    // Start the game immediately (wave already active in I Zombie)
    this.waveStarted = true;
  }

  private placeIZombiePlants(): void {
    // Place plants for I Zombie mode
    // Layout: Vine walls in FRONT (x=-2), Grape launchers in MIDDLE (x=-4), Lilies in BACK (x=-6)
    // Zombies come from the RIGHT, so higher X = closer to zombies = FRONT
    const plantSetup: { type: PlantType, x: number, z: number }[] = [
      // Row 1 (z = -8): Wall - Launcher - Lily
      { type: 'vine-wall', x: -2, z: -8 },
      { type: 'grape-launcher', x: -4, z: -8 },
      { type: 'lily', x: -6, z: -8 },
      // Row 2 (z = -6): Wall - Launcher - Lily
      { type: 'vine-wall', x: -2, z: -6 },
      { type: 'grape-launcher', x: -4, z: -6 },
      { type: 'lily', x: -6, z: -6 },
      // Row 3 (z = -4): Wall - Launcher - Lily
      { type: 'vine-wall', x: -2, z: -4 },
      { type: 'grape-launcher', x: -4, z: -4 },
      { type: 'lily', x: -6, z: -4 },
      // Row 4 (z = -2): Wall - Launcher - Lily
      { type: 'vine-wall', x: -2, z: -2 },
      { type: 'grape-launcher', x: -4, z: -2 },
      { type: 'lily', x: -6, z: -2 },
      // Row 5 (z = 0): Wall - Launcher - Lily
      { type: 'vine-wall', x: -2, z: 0 },
      { type: 'grape-launcher', x: -4, z: 0 },
      { type: 'lily', x: -6, z: 0 }
    ];

    plantSetup.forEach(setup => {
      const plantMesh = this.createPlantMesh(setup.type);
      plantMesh.position.set(setup.x, 0.5, setup.z);
      this.scene.add(plantMesh);

      const plant = new Plant(plantMesh, setup.type, new THREE.Vector3(setup.x, 0.5, setup.z));
      this.placedPlants.push(plant);

      // Mark slot as occupied
      const slotKey = `${setup.x},${setup.z}`;
      this.plantSlots.set(slotKey, true);
    });

    console.log(`Placed ${plantSetup.length} plants for I, Zombie mode`);
  }

  private showModeTutorial(mode: string): void {
    const tutorials: Record<string, { title: string; emoji: string; color: string; steps: string[] }> = {
      'shooter': {
        title: 'ZOMBIE SHOOTER',
        emoji: '🔫',
        color: '#4a8aff',
        steps: [
          '🎯 Click directly on zombies to shoot them!',
          '💥 Each shot deals 50 damage',
          '🔄 Bonus ammo awarded after each wave',
          '🏆 Survive 10 waves to win!'
        ]
      },
      'izombie': {
        title: 'I, ZOMBIE',
        emoji: '🧟',
        color: '#9a4a9a',
        steps: [
          '🧟 You ARE the zombies now!',
          '☀️ Spend sun to spawn zombies on the right',
          '🎯 Guide them to destroy all plants',
          '🏠 Reach the left side to WIN!'
        ]
      },
      'endless': {
        title: 'ENDLESS MODE',
        emoji: '♾️',
        color: '#5a5aaa',
        steps: [
          '♾️ Waves never stop coming!',
          '📈 Difficulty increases each wave',
          '☀️ Bonus sun awarded for surviving',
          '🏆 How far can you go?'
        ]
      },
      'vasebreaker': {
        title: 'VASEBREAKER',
        emoji: '🏺',
        color: '#aa8a4a',
        steps: [
          '🏺 Click vases to break them!',
          '🌱 Some contain helpful plants',
          '🧟 Others release zombies - watch out!',
          '☀️ Sun helps you place plants strategically'
        ]
      },
      'conveyor': {
        title: 'CONVEYOR BELT',
        emoji: '🎒',
        color: '#6a6a6a',
        steps: [
          '🎒 Plants appear automatically on the conveyor!',
          '🚫 No sun needed - plants are FREE!',
          '⚡ Click a plant, then click a tile to place',
          '🌊 Don\'t let zombies reach the left!'
        ]
      },
      'speedrun': {
        title: 'SPEED RUN',
        emoji: '⏱️',
        color: '#8a4aaa',
        steps: [
          '⏱️ Race against time!',
          '☀️ You start with 5000 sun',
          '🏃 Complete 5 waves as FAST as possible',
          '🏆 Beat your best time!'
        ]
      },
      'laststand': {
        title: 'LAST STAND',
        emoji: '🏰',
        color: '#8a4a4a',
        steps: [
          '🏰 Setup your ULTIMATE defense!',
          '☀️ You have 5000 sun to spend',
          '⏰ 30 seconds to prepare, then waves BEGIN!',
          '🚫 No sun production - plan wisely!'
        ]
      },
      'whack': {
        title: 'WHACK-A-ZOMBIE',
        emoji: '🔨',
        color: '#8a5a5a',
        steps: [
          '🔨 The shovel is your WEAPON!',
          '💀 Click zombies with shovel to SMASH them!',
          '🌱 You can still place plants too',
          '🏆 Survive using both strategies!'
        ]
      },
      'dragonbattle': {
        title: 'DRAGON BATTLE',
        emoji: '🐉',
        color: '#cc4444',
        steps: [
          '🐉 Dragons are invading! Defeat them all!',
          '🔥 Use Red Fire Flowers, Vine Walls, and Lilies!',
          '💥 3 waves of increasing difficulty!',
          '🏆 Defeat the Red Dragon to unlock a new plant!'
        ]
      }
    };

    const tutorial = tutorials[mode];
    if (!tutorial) return;

    // Create tutorial overlay
    const overlay = document.createElement('div');
    overlay.id = 'mode-tutorial-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.9);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10000;
      animation: tutorialFadeIn 0.5s ease-out;
    `;

    // Create tutorial content
    const content = document.createElement('div');
    content.style.cssText = `
      background: linear-gradient(180deg, rgba(30, 40, 30, 0.95) 0%, rgba(15, 25, 15, 0.98) 100%);
      border: 4px solid ${tutorial.color};
      border-radius: 20px;
      padding: 2.5rem;
      text-align: center;
      max-width: 500px;
      width: 90%;
      box-shadow: 0 0 50px ${tutorial.color}66, inset 0 0 30px rgba(0, 0, 0, 0.5);
      animation: tutorialSlideIn 0.6s ease-out;
      pointer-events: auto;
      position: relative;
      z-index: 10001;
    `;

    // Build tutorial HTML
    let stepsHTML = tutorial.steps.map((step, index) => `
      <div class="tutorial-step" style="
        opacity: 0;
        transform: translateX(-20px);
        animation: tutorialStepIn 0.4s ease-out ${0.3 + index * 0.15}s forwards;
        padding: 0.8rem 1rem;
        margin: 0.5rem 0;
        background: rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        border-left: 4px solid ${tutorial.color};
        text-align: left;
        font-size: 1.1rem;
        color: #ddeedd;
      ">${step}</div>
    `).join('');

    content.innerHTML = `
      <div style="font-size: 4rem; margin-bottom: 0.5rem; animation: tutorialBounce 0.6s ease-out;">${tutorial.emoji}</div>
      <h2 style="
        font-family: 'Cinzel Decorative', serif;
        font-size: 2.2rem;
        color: ${tutorial.color};
        text-shadow: 0 0 20px ${tutorial.color}88;
        margin-bottom: 1.5rem;
        letter-spacing: 3px;
      ">${tutorial.title}</h2>
      <div style="margin-bottom: 1.5rem;">
        ${stepsHTML}
      </div>
      <button id="tutorial-start-btn" style="
        font-family: 'Cinzel', serif;
        font-size: 1.3rem;
        padding: 1rem 2.5rem;
        background: linear-gradient(180deg, ${tutorial.color}, ${tutorial.color}88);
        color: white;
        border: 3px solid ${tutorial.color};
        border-radius: 15px;
        cursor: pointer;
        text-transform: uppercase;
        letter-spacing: 2px;
        box-shadow: 0 0 20px ${tutorial.color}66;
        transition: all 0.3s ease;
        position: relative;
        z-index: 10001;
        pointer-events: auto;
      ">Let's Go!</button>
    `;

    // Add CSS animations
    const style = document.createElement('style');
    style.textContent = `
      @keyframes tutorialFadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes tutorialSlideIn {
        from { transform: scale(0.8) translateY(-30px); opacity: 0; }
        to { transform: scale(1) translateY(0); opacity: 1; }
      }
      @keyframes tutorialStepIn {
        from { opacity: 0; transform: translateX(-20px); }
        to { opacity: 1; transform: translateX(0); }
      }
      @keyframes tutorialBounce {
        0% { transform: scale(0); }
        50% { transform: scale(1.2); }
        100% { transform: scale(1); }
      }
      @keyframes tutorialButtonIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }
      #tutorial-start-btn:hover {
        transform: scale(1.05);
        box-shadow: 0 0 30px ${tutorial.color}aa;
      }
    `;
    document.head.appendChild(style);

    overlay.appendChild(content);
    document.body.appendChild(overlay);

    // Handle start button click
    const startBtn = document.getElementById('tutorial-start-btn');
    if (startBtn) {
      startBtn.addEventListener('click', () => {
        overlay.style.animation = 'tutorialFadeIn 0.3s ease-out reverse';
        setTimeout(() => {
          overlay.remove();
          style.remove();

          // For conveyor mode, start wave when tutorial is dismissed
          if (mode === 'conveyor' && this.isConveyorMode && !this.waveStarted) {
            this.conveyorPlants = ['grape-launcher', 'vine-wall'];
            this.updateConveyorUI();
            this.startNextWave();
          }
        }, 300);
      });
    }
  }

  private setupShooterMode(): void {
    console.log('🔫 Setting up Zombie Shooter mode!');

    // Show tutorial
    this.showModeTutorial('shooter');

    // Hide plant bar, show shooter UI
    const plantBar = document.getElementById('plant-bar');
    if (plantBar) {
      plantBar.innerHTML = `
        <div style="display: flex; gap: 1rem; align-items: center; color: white; font-family: 'Cinzel', serif;">
          <div style="background: linear-gradient(135deg, #4a6a8a, #2a4a5a); padding: 0.5rem 1rem; border-radius: 8px; border: 2px solid #6a8aaa;">
            🔫 Ammo: <span id="shooter-ammo-display">${this.shooterAmmo}</span>
          </div>
          <div style="background: linear-gradient(135deg, #6a8a4a, #4a5a2a); padding: 0.5rem 1rem; border-radius: 8px; border: 2px solid #8aaa6a;">
            ⭐ Score: <span id="shooter-score-display">${this.shooterScore}</span>
          </div>
          <div style="background: linear-gradient(135deg, #8a4a4a, #5a2a2a); padding: 0.5rem 1rem; border-radius: 8px; border: 2px solid #aa6a6a;">
            Click zombies to shoot!
          </div>
        </div>
      `;
    }

    // Hide sun display
    const sunCounter = document.getElementById('sun-counter');
    if (sunCounter) {
      sunCounter.style.display = 'none';
    }

    // Hide shovel and glove
    const shovelBtn = document.getElementById('shovel-btn');
    const gloveBtn = document.getElementById('glove-btn');
    if (shovelBtn) shovelBtn.style.display = 'none';
    if (gloveBtn) gloveBtn.style.display = 'none';

    // Update hint
    const gloveHint = document.getElementById('glove-hint');
    if (gloveHint) {
      gloveHint.innerHTML = '🔫 ZOMBIE SHOOTER: Click on zombies to shoot them! Survive 10 waves!';
      gloveHint.style.color = '#66aaff';
      gloveHint.style.fontSize = '1rem';
    }

    // Start waves automatically
    this.waveStarted = true;
    this.currentWave = 1;
    this.startNextWave();

    // Update wave display
    const waveBtn = document.getElementById('wave-btn');
    if (waveBtn) {
      waveBtn.textContent = `Wave ${this.currentWave}`;
      waveBtn.style.pointerEvents = 'none';
    }
  }

  private handleShooterClick(event: MouseEvent): void {
    if (!this.isShooterMode || this.shooterAmmo <= 0) return;

    const rect = this.renderer.domElement.getBoundingClientRect();
    this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    this.raycaster.setFromCamera(this.mouse, this.camera);

    // Check if we clicked on a zombie
    const zombieMeshes = this.zombies.map(z => z.mesh);
    const intersects = this.raycaster.intersectObjects(zombieMeshes, true);

    // Use ammo
    this.shooterAmmo--;
    this.updateShooterUI();

    // Create shoot effect at click position
    const shootPos = new THREE.Vector3();
    this.raycaster.ray.at(10, shootPos);
    this.createShootEffect(shootPos);

    if (intersects.length > 0) {
      // Find which zombie was hit
      for (const zombie of this.zombies) {
        const isHit = zombie.mesh.children.some(child =>
          intersects.some(hit => hit.object === child)
        ) || intersects.some(hit => hit.object === zombie.mesh);

        if (isHit) {
          // Deal damage - one shot does 50 damage
          zombie.health -= 50;
          this.shooterScore += 10;
          this.updateShooterUI();

          // Hit effect
          this.createHitEffect(zombie.position.clone());

          console.log(`🎯 Hit zombie! Health: ${zombie.health}, Score: ${this.shooterScore}`);
          break;
        }
      }
    }

    // Check for game over (out of ammo with zombies remaining)
    if (this.shooterAmmo <= 0 && this.zombies.length > 0) {
      setTimeout(() => {
        if (this.zombies.length > 0) {
          this.showShooterGameOver();
        }
      }, 2000);
    }
  }

  private updateShooterUI(): void {
    const ammoDisplay = document.getElementById('shooter-ammo-display');
    const scoreDisplay = document.getElementById('shooter-score-display');
    if (ammoDisplay) ammoDisplay.textContent = this.shooterAmmo.toString();
    if (scoreDisplay) scoreDisplay.textContent = this.shooterScore.toString();
  }

  private createShootEffect(position: THREE.Vector3): void {
    // Muzzle flash effect
    const flashGeo = new THREE.SphereGeometry(0.3, 8, 8);
    const flashMat = new THREE.MeshBasicMaterial({ color: 0xffff00, transparent: true, opacity: 1 });
    const flash = new THREE.Mesh(flashGeo, flashMat);
    flash.position.copy(position);
    this.scene.add(flash);

    // Animate and remove
    let opacity = 1;
    const animate = () => {
      opacity -= 0.1;
      flashMat.opacity = opacity;
      flash.scale.multiplyScalar(1.1);
      if (opacity > 0) {
        requestAnimationFrame(animate);
      } else {
        this.scene.remove(flash);
      }
    };
    animate();
  }

  private createHitEffect(position: THREE.Vector3): void {
    // Red hit burst
    const burstGeo = new THREE.SphereGeometry(0.5, 8, 8);
    const burstMat = new THREE.MeshBasicMaterial({ color: 0xff0000, transparent: true, opacity: 0.8 });
    const burst = new THREE.Mesh(burstGeo, burstMat);
    burst.position.copy(position);
    burst.position.y += 1;
    this.scene.add(burst);

    // Animate and remove
    let opacity = 0.8;
    const animate = () => {
      opacity -= 0.08;
      burstMat.opacity = opacity;
      burst.scale.multiplyScalar(1.15);
      if (opacity > 0) {
        requestAnimationFrame(animate);
      } else {
        this.scene.remove(burst);
      }
    };
    animate();
  }

  private showShooterGameOver(): void {
    const gameOverDiv = document.createElement('div');
    gameOverDiv.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: linear-gradient(180deg, rgba(80, 40, 40, 0.95) 0%, rgba(40, 20, 20, 0.98) 100%);
      padding: 3rem;
      border-radius: 20px;
      border: 4px solid #aa6666;
      text-align: center;
      z-index: 10000;
      box-shadow: 0 0 50px rgba(200, 100, 100, 0.5);
    `;

    gameOverDiv.innerHTML = `
      <h1 style="font-family: 'Cinzel Decorative', serif; font-size: 3rem; color: #ff6666; margin-bottom: 1rem;">GAME OVER</h1>
      <p style="font-family: 'Cinzel', serif; font-size: 1.5rem; color: #ffaaaa; margin-bottom: 2rem;">Final Score: ${this.shooterScore}</p>
      <button id="shooter-restart" style="font-family: 'Cinzel', serif; font-size: 1.2rem; padding: 1rem 2rem; background: linear-gradient(180deg, #6a4a4a, #4a2a2a); color: white; border: 2px solid #aa6666; border-radius: 10px; cursor: pointer;">Try Again</button>
    `;

    document.body.appendChild(gameOverDiv);

    document.getElementById('shooter-restart')?.addEventListener('click', () => {
      localStorage.removeItem('shooterMode');
      window.location.reload();
    });
  }

  private showShooterVictory(): void {
    const victoryDiv = document.createElement('div');
    victoryDiv.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: linear-gradient(180deg, rgba(40, 80, 40, 0.95) 0%, rgba(20, 40, 20, 0.98) 100%);
      padding: 3rem;
      border-radius: 20px;
      border: 4px solid #66aa66;
      text-align: center;
      z-index: 10000;
      box-shadow: 0 0 50px rgba(100, 200, 100, 0.5);
    `;

    victoryDiv.innerHTML = `
      <h1 style="font-family: 'Cinzel Decorative', serif; font-size: 3rem; color: #66ff66; margin-bottom: 1rem;">🎯 VICTORY!</h1>
      <p style="font-family: 'Cinzel', serif; font-size: 1.5rem; color: #aaffaa; margin-bottom: 2rem;">Final Score: ${this.shooterScore}</p>
      <button id="shooter-menu" style="font-family: 'Cinzel', serif; font-size: 1.2rem; padding: 1rem 2rem; background: linear-gradient(180deg, #4a6a4a, #2a4a2a); color: white; border: 2px solid #66aa66; border-radius: 10px; cursor: pointer;">Back to Menu</button>
    `;

    document.body.appendChild(victoryDiv);

    document.getElementById('shooter-menu')?.addEventListener('click', () => {
      localStorage.removeItem('shooterMode');
      window.location.reload();
    });
  }

  // ============ DRAGON BATTLE MODE ============

  private startDragonBattleWave(): void {
    this.dragonBattleWave++;
    this.waveStarted = true;
    this.waveComplete = false;
    this.gameTime = 0;
    this.nextZombieSpawn = 2;
    this.zombiesSpawnedInWave = 0;
    this.dragonBattleRedDragonSpawned = false;
    this.dragonBattleWave3Phase2 = false;

    // Set zombie count per wave
    switch (this.dragonBattleWave) {
      case 1: this.zombiesInWave = 2; break;  // 2 blue
      case 2: this.zombiesInWave = 5; break;  // 4 blue + 1 green
      case 3: this.zombiesInWave = 10; break; // 7 blue + 3 green (red spawns after)
      default: this.zombiesInWave = 2; break;
    }

    const waveBtn = document.getElementById('wave-btn');
    if (waveBtn) waveBtn.textContent = `Dragon Wave ${this.dragonBattleWave}/3`;

    console.log(`🐉 Dragon Battle Wave ${this.dragonBattleWave} started! ${this.zombiesInWave} dragons incoming!`);
  }

  private spawnDragonBattleZombie(): void {
    const rows = 5;
    const randomRow = Math.floor(Math.random() * rows);
    const startZ = -8 + randomRow * 2;

    let zombieType: ZombieType;

    if (this.dragonBattleWave === 1) {
      zombieType = 'blue-dragon';
    } else if (this.dragonBattleWave === 2) {
      // 4 blue + 1 green, spawn green last
      if (this.zombiesSpawnedInWave >= 4) {
        zombieType = 'green-dragon';
      } else {
        zombieType = 'blue-dragon';
      }
    } else {
      // Wave 3: 7 blue + 3 green (red spawns separately after all die)
      if (this.zombiesSpawnedInWave >= 7) {
        zombieType = 'green-dragon';
      } else {
        zombieType = 'blue-dragon';
      }
    }

    const zombieMesh = this.createZombieMesh(zombieType);
    zombieMesh.position.set(10, 0.75, startZ);
    zombieMesh.rotation.y = -Math.PI / 2;
    this.scene.add(zombieMesh);

    const zombie = new Zombie(zombieMesh, zombieMesh.position, zombieType);
    this.zombies.push(zombie);
    this.zombiesSpawnedInWave++;
  }

  private spawnRedDragon(): void {
    const randomRow = Math.floor(Math.random() * 5);
    const startZ = -8 + randomRow * 2;

    const zombieMesh = this.createZombieMesh('red-dragon');
    zombieMesh.position.set(10, 0.75, startZ);
    zombieMesh.rotation.y = -Math.PI / 2;
    this.scene.add(zombieMesh);

    const zombie = new Zombie(zombieMesh, zombieMesh.position, 'red-dragon');
    this.zombies.push(zombie);

    // Show dramatic announcement
    const announce = document.createElement('div');
    announce.style.cssText = `
      position: fixed;
      top: 30%;
      left: 50%;
      transform: translateX(-50%);
      font-size: 3rem;
      font-weight: bold;
      color: #ff4444;
      font-family: 'Cinzel Decorative', serif;
      text-shadow: 0 0 30px rgba(255, 68, 68, 0.8), 0 0 60px rgba(255, 0, 0, 0.4);
      z-index: 10000;
      pointer-events: none;
    `;
    announce.textContent = '🐉 THE RED DRAGON APPEARS! 🐉';
    document.body.appendChild(announce);
    setTimeout(() => announce.remove(), 3000);
    console.log('🐉🔥 THE RED DRAGON HAS APPEARED!');
  }

  private completeDragonBattleWave(): void {
    this.waveComplete = true;
    this.waveStarted = false;

    console.log(`🐉 Dragon Battle Wave ${this.dragonBattleWave} complete!`);

    // Check for victory (wave 3 completed = red dragon defeated)
    if (this.dragonBattleWave >= 3) {
      this.showDragonBattleVictory();
      return;
    }

    // Auto-start next wave after delay
    setTimeout(() => {
      this.startDragonBattleWave();
    }, 3000);
  }

  private showDragonBattleVictory(): void {
    this.gameOver = true;

    // Unlock Red Fire Flower permanently
    localStorage.setItem('dragonBattleComplete', 'true');

    const victoryDiv = document.createElement('div');
    victoryDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(50, 0, 0, 0.95);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 10000;
      font-family: 'Cinzel Decorative', serif;
      color: white;
    `;

    victoryDiv.innerHTML = `
      <h1 style="font-size: 4rem; color: #ff4444; text-shadow: 0 0 30px rgba(255, 68, 68, 0.8); margin-bottom: 0.5rem;">🐉 DRAGON SLAYER! 🐉</h1>
      <p style="font-size: 1.5rem; color: #ffaa88; margin: 1rem 0; font-family: 'Cinzel', serif;">You defeated the Red Dragon!</p>
      <div style="font-size: 4rem; margin: 1rem 0;">🔥🌺</div>
      <p style="font-size: 1.5rem; color: #ff8866; margin: 0.5rem 0; font-family: 'Cinzel', serif;">NEW PLANT UNLOCKED: Red Fire Flower!</p>
      <p style="font-size: 1rem; color: #cccccc; margin: 0.5rem 0; font-family: 'Cinzel', serif;">Shoots firecrackers dealing 500 damage with burn effect!</p>
      <button id="dragon-victory-menu" style="padding: 1rem 2rem; font-size: 1.5rem; font-family: 'Cinzel', serif; background: linear-gradient(135deg, #ff4444, #cc2222); color: white; border: 2px solid #ff6666; border-radius: 10px; cursor: pointer; margin-top: 1.5rem; box-shadow: 0 0 20px rgba(255, 68, 68, 0.5);">Return to Menu</button>
    `;

    document.body.appendChild(victoryDiv);

    document.getElementById('dragon-victory-menu')?.addEventListener('click', () => {
      window.location.reload();
    });

    console.log('🐉 DRAGON BATTLE COMPLETE! Red Fire Flower unlocked!');
  }

  // ============ END DRAGON BATTLE MODE ============

  private handleIZombieClick(event: MouseEvent): void {
    if (!this.isIZombieMode || !this.selectedZombieType) return;

    const rect = this.renderer.domElement.getBoundingClientRect();
    this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    this.raycaster.setFromCamera(this.mouse, this.camera);

    // Cast ray to lawn plane to get spawn position
    const intersects = this.raycaster.intersectObject(this.lawnPlane);
    if (intersects.length > 0) {
      const point = intersects[0].point;

      // Only allow spawning on the right side (x > 4)
      if (point.x < 4) {
        console.log('Can only spawn zombies on the right side of the field!');
        return;
      }

      // Get zombie cost
      const zombieCosts: Record<ZombieType, number> = {
        'normal': 50, 'fast': 75, 'tank': 150,
        'tiny': 60, 'grape': 80, 'car': 300, 'grave': 100,
        'grape-gun': 200, 'healer': 150, 'super-car': 500, 'frost-grape-gun': 400,
        'fire': 100, 'fat': 125,
        'blue-dragon': 500, 'green-dragon': 750, 'red-dragon': 1500
      };
      const cost = zombieCosts[this.selectedZombieType];

      if (this.sun < cost) {
        console.log('Not enough sun!');
        return;
      }

      // Deduct sun
      this.sun -= cost;
      const sunAmount = document.getElementById('sun-amount');
      if (sunAmount) sunAmount.textContent = this.sun.toString();

      // Spawn the zombie - use same setup as normal zombie spawning
      const zombieMesh = this.createZombieMesh(this.selectedZombieType);
      // Snap to nearest row (rows are at -8, -6, -4, -2, 0)
      const nearestZ = Math.round(point.z / 2) * 2;
      // Clamp Z to valid lawn rows
      const clampedZ = Math.max(-8, Math.min(0, nearestZ));
      zombieMesh.position.set(point.x, 0.75, clampedZ); // y=0.75 like normal zombies
      zombieMesh.rotation.y = -Math.PI / 2; // Face left (toward -X direction) - same as normal spawn
      this.scene.add(zombieMesh);

      const zombie = new Zombie(zombieMesh, zombieMesh.position.clone(), this.selectedZombieType);

      // Copy arm references for animation - same as normal spawn
      if (zombieMesh.userData.leftArm) {
        zombie.leftArm = zombieMesh.userData.leftArm;
      }
      if (zombieMesh.userData.rightArm) {
        zombie.rightArm = zombieMesh.userData.rightArm;
      }

      this.zombies.push(zombie);

      console.log(`Spawned ${this.selectedZombieType} zombie at (${point.x.toFixed(1)}, ${clampedZ})`);

      // Create spawn effect
      const spawnEffect = new THREE.Mesh(
        new THREE.RingGeometry(0.5, 1.0, 16),
        new THREE.MeshBasicMaterial({ color: 0x8b4513, transparent: true, opacity: 0.7, side: THREE.DoubleSide })
      );
      spawnEffect.position.set(point.x, 0.1, clampedZ);
      spawnEffect.rotation.x = -Math.PI / 2;
      this.scene.add(spawnEffect);

      let effectScale = 0.5;
      let effectOpacity = 0.7;
      const effectInterval = setInterval(() => {
        effectScale += 0.2;
        effectOpacity -= 0.1;
        spawnEffect.scale.set(effectScale, effectScale, effectScale);
        (spawnEffect.material as THREE.MeshBasicMaterial).opacity = effectOpacity;
        if (effectOpacity <= 0) {
          this.scene.remove(spawnEffect);
          clearInterval(effectInterval);
        }
      }, 50);
    }
  }

  private setupStartWaveButton(): void {
    const startWaveBtn = document.getElementById('start-wave-btn');
    if (startWaveBtn) {
      startWaveBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent click from reaching the canvas
        console.log(`🔘 Start Wave button clicked! waveStarted=${this.waveStarted}, waveComplete=${this.waveComplete}`);
        if (!this.waveStarted && !this.waveComplete) {
          console.log('🚀 Starting first wave!');
          this.startNextWave();
        } else if (this.waveComplete) {
          console.log('🚀 Starting next wave after completion!');
          this.startNextWave();
        } else {
          console.log('⚠️ Wave already in progress, ignoring click');
        }
      });
    } else {
      console.error('❌ Start Wave button not found!');
    }
  }

  private setupPauseMenu(): void {
    // Note: pause-book-btn handler is in index.html
    const resumeBtn = document.getElementById('pause-resume-btn');
    const restartBtn = document.getElementById('pause-restart-btn');
    const speedButtons = document.querySelectorAll('.speed-btn');
    const currentSpeedValue = document.getElementById('current-speed-value');

    // Resume button click
    if (resumeBtn) {
      resumeBtn.addEventListener('click', () => {
        this.togglePause();
      });
    }

    // Restart button click - clears all progress
    if (restartBtn) {
      restartBtn.addEventListener('click', () => {
        if (confirm('Are you sure you want to restart? This will reset ALL progress including coins and owned plants!')) {
          // Clear all saved data
          localStorage.removeItem('fusionTdCoins');
          localStorage.removeItem('fusionTdOwnedPlants');
          // Reload to go back to menu
          window.location.reload();
        }
      });
    }

    // Save button
    const saveBtn = document.getElementById('pause-save-btn');
    if (saveBtn) {
      // Hide save for mini-game modes
      if (this.isShooterMode || this.isWhackMode || this.isVasebreakerMode || this.isIZombieMode || this.isConveyorMode) {
        (saveBtn as HTMLElement).style.display = 'none';
      }
      saveBtn.addEventListener('click', () => {
        saveGame();
        saveBtn.textContent = 'Saved!';
        setTimeout(() => {
          saveBtn.textContent = 'Save Game';
        }, 1500);
      });
    }

    // Speed buttons
    speedButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const speed = parseFloat(btn.getAttribute('data-speed') || '1');
        this.gameSpeed = speed;

        // Update active state
        speedButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // Update display
        if (currentSpeedValue) {
          currentSpeedValue.textContent = `${speed}x`;
        }
      });
    });
  }

  public serializeGameState(): Record<string, any> {
    const filterUserData = (userData: Record<string, any>): Record<string, any> => {
      const filtered: Record<string, any> = {};
      for (const [key, value] of Object.entries(userData)) {
        if (key === 'burnEffect' || key === 'originalEmissives') continue;
        if (value && typeof value === 'object' && (value.isObject3D || value.isMaterial)) continue;
        filtered[key] = value;
      }
      return filtered;
    };

    return {
      version: 1,
      timestamp: Date.now(),
      sun: this.sun,
      coins: this.coins,
      gameTime: this.gameTime,
      currentWave: this.currentWave,
      zombiesInWave: this.zombiesInWave,
      zombiesSpawnedInWave: this.zombiesSpawnedInWave,
      fireZombiesSpawnedThisWave: this.fireZombiesSpawnedThisWave,
      waveStarted: this.waveStarted,
      waveComplete: this.waveComplete,
      gameSpeed: this.gameSpeed,
      // Mode flags
      isEndlessMode: this.isEndlessMode,
      isIZombieMode: this.isIZombieMode,
      isConveyorMode: this.isConveyorMode,
      isLastStandMode: this.isLastStandMode,
      isDragonBattleMode: this.isDragonBattleMode,
      isSpeedrunMode: this.isSpeedrunMode,
      isWhackMode: this.isWhackMode,
      isShooterMode: this.isShooterMode,
      isVasebreakerMode: this.isVasebreakerMode,
      // Endless
      endlessWaveMultiplier: this.endlessWaveMultiplier,
      // Dragon Battle
      dragonBattleWave: this.dragonBattleWave,
      dragonBattleRedDragonSpawned: this.dragonBattleRedDragonSpawned,
      dragonBattleWave3Phase2: this.dragonBattleWave3Phase2,
      // I, Zombie
      iZombieSun: this.iZombieSun,
      // Last Stand
      lastStandSetupTime: this.lastStandSetupTime,
      lastStandStarted: this.lastStandStarted,
      // Shooter
      shooterAmmo: this.shooterAmmo,
      shooterScore: this.shooterScore,
      // Mastery
      frostBerriMastery: this.frostBerriMastery,
      frostBerriMasteryPoints: this.frostBerriMasteryPoints,
      tomatoSpikeMastery: this.tomatoSpikeMastery,
      tomatoSpikeMasteryPoints: this.tomatoSpikeMasteryPoints,
      // Odd shop unlocks
      frostGrapeGunUnlocked: this.frostGrapeGunUnlocked,
      strawSpikerUnlocked: this.strawSpikerUnlocked,
      reaperWallUnlocked: this.reaperWallUnlocked,
      frozenOverlordUnlocked: this.frozenOverlordUnlocked,
      frostOverlordGrapeGunUnlocked: this.frostOverlordGrapeGunUnlocked,
      thornbomberUnlocked: this.thornbomberUnlocked,
      titanReaperPeallUnlocked: this.titanReaperPeallUnlocked,
      frozenNebulaMushroomUnlocked: this.frozenNebulaMushroomUnlocked,
      // Plants deck
      selectedPlants: this.selectedPlants,
      powerPlantType: this.powerPlantType,
      // Entities
      plants: this.placedPlants.map(p => ({
        type: p.type,
        x: p.position.x,
        z: p.position.z,
        health: p.health,
        maxHealth: p.maxHealth,
        cooldown: p.cooldown,
        sunProductionTimer: p.sunProductionTimer,
        isTitan: p.isTitan,
        antiCrush: p.antiCrush,
        bunker: p.pineappleBunker ? {
          health: p.pineappleBunker.health,
          maxHealth: p.pineappleBunker.maxHealth
        } : null,
        userData: filterUserData(p.userData),
        burstCount: p.burstCount,
        burstDelay: p.burstDelay,
        burnStacks: p.burnStacks.map(b => ({
          damage: b.damage, duration: b.duration, tickTimer: b.tickTimer
        })),
      })),
      zombies: this.zombies.map(z => ({
        type: z.type,
        x: z.position.x,
        y: z.position.y,
        z: z.position.z,
        health: z.health,
        maxHealth: z.maxHealth,
        speed: z.speed,
        baseSpeed: z.baseSpeed,
        attackDamage: z.attackDamage,
        frozen: z.frozen,
        frozenTimer: z.frozenTimer,
        freezeImmunityTimer: z.freezeImmunityTimer,
        isFreezeImmune: z.isFreezeImmune,
        rooted: z.rooted,
        rootedTimer: z.rootedTimer,
        attackCooldown: z.attackCooldown,
        shootCooldown: z.shootCooldown,
        summonCooldown: z.summonCooldown,
        hasSummoned: z.hasSummoned,
        healCooldown: z.healCooldown,
        age: z.age,
        userData: {
          cursed: z.userData.cursed,
          curseSpawnZ: z.userData.curseSpawnZ,
          explodeTimer: z.userData.explodeTimer,
          burnStacks: z.userData.burnStacks?.map((b: { damage: number; duration: number; tickTimer: number }) => ({
            damage: b.damage, duration: b.duration, tickTimer: b.tickTimer
          })),
        },
      })),
      allies: this.allies.map(a => ({
        type: a.type,
        x: a.position.x,
        z: a.position.z,
        health: a.health,
        maxHealth: a.maxHealth,
        damage: a.damage,
        attackCooldown: a.attackCooldown,
        speed: a.speed,
        spawnZ: a.spawnZ,
      })),
    };
  }

  public loadGameState(data: Record<string, any>): void {
    // Restore scalar game state
    this.sun = data.sun;
    this.coins = data.coins;
    this.gameTime = data.gameTime;
    this.currentWave = data.currentWave;
    this.zombiesInWave = data.zombiesInWave;
    this.zombiesSpawnedInWave = data.zombiesSpawnedInWave;
    this.fireZombiesSpawnedThisWave = data.fireZombiesSpawnedThisWave || 0;
    this.waveStarted = data.waveStarted;
    this.waveComplete = data.waveComplete;
    this.gameSpeed = data.gameSpeed;

    // Mode flags
    this.isEndlessMode = data.isEndlessMode;
    this.isIZombieMode = data.isIZombieMode;
    this.isConveyorMode = data.isConveyorMode;
    this.isLastStandMode = data.isLastStandMode;
    this.isDragonBattleMode = data.isDragonBattleMode;
    this.isSpeedrunMode = data.isSpeedrunMode;
    this.isWhackMode = data.isWhackMode;
    this.isShooterMode = data.isShooterMode;
    this.isVasebreakerMode = data.isVasebreakerMode;

    // Mode-specific state
    this.endlessWaveMultiplier = data.endlessWaveMultiplier || 1;
    this.dragonBattleWave = data.dragonBattleWave || 0;
    this.dragonBattleRedDragonSpawned = data.dragonBattleRedDragonSpawned || false;
    this.dragonBattleWave3Phase2 = data.dragonBattleWave3Phase2 || false;
    this.iZombieSun = data.iZombieSun || 2000;
    this.lastStandSetupTime = data.lastStandSetupTime || 30;
    this.lastStandStarted = data.lastStandStarted || false;
    this.shooterAmmo = data.shooterAmmo || 50;
    this.shooterScore = data.shooterScore || 0;

    // Mastery & unlocks
    this.frostBerriMastery = data.frostBerriMastery || 0;
    this.frostBerriMasteryPoints = data.frostBerriMasteryPoints || 0;
    this.tomatoSpikeMastery = data.tomatoSpikeMastery || 0;
    this.tomatoSpikeMasteryPoints = data.tomatoSpikeMasteryPoints || 0;
    this.frostGrapeGunUnlocked = data.frostGrapeGunUnlocked || false;
    this.strawSpikerUnlocked = data.strawSpikerUnlocked || false;
    this.reaperWallUnlocked = data.reaperWallUnlocked || false;
    this.frozenOverlordUnlocked = data.frozenOverlordUnlocked || false;
    this.frostOverlordGrapeGunUnlocked = data.frostOverlordGrapeGunUnlocked || false;
    this.thornbomberUnlocked = data.thornbomberUnlocked || false;
    this.titanReaperPeallUnlocked = data.titanReaperPeallUnlocked || false;
    this.frozenNebulaMushroomUnlocked = data.frozenNebulaMushroomUnlocked || false;

    // Reconstruct plants
    for (const pData of data.plants) {
      const mesh = this.createPlantMesh(pData.type);
      mesh.position.set(pData.x, 0.5, pData.z);
      this.scene.add(mesh);

      const plant = new Plant(mesh, pData.type, new THREE.Vector3(pData.x, 0.5, pData.z));
      plant.health = pData.health;
      plant.maxHealth = pData.maxHealth;
      plant.cooldown = pData.cooldown;
      plant.sunProductionTimer = pData.sunProductionTimer;
      plant.isTitan = pData.isTitan;
      plant.antiCrush = pData.antiCrush || false;
      plant.burstCount = pData.burstCount || 0;
      plant.burstDelay = pData.burstDelay || 0;
      plant.burnStacks = pData.burnStacks || [];
      plant.userData = pData.userData || {};

      if (pData.bunker) {
        const bunkerMesh = this.createPlantMesh('pineapple-crate');
        bunkerMesh.position.set(pData.x, 0.2, pData.z);
        this.scene.add(bunkerMesh);
        plant.pineappleBunker = {
          health: pData.bunker.health,
          maxHealth: pData.bunker.maxHealth,
          mesh: bunkerMesh,
        };
      }

      this.placedPlants.push(plant);
      const slotKey = `${pData.x},${pData.z}`;
      this.plantSlots.set(slotKey, true);
      this.hideSlotIndicator(pData.x, pData.z);
    }

    // Reconstruct zombies
    for (const zData of data.zombies) {
      const mesh = this.createZombieMesh(zData.type);
      mesh.position.set(zData.x, zData.y || 0, zData.z);
      mesh.rotation.y = -Math.PI / 2;
      this.scene.add(mesh);

      const zombie = new Zombie(mesh, mesh.position.clone(), zData.type);
      zombie.position = mesh.position;
      zombie.health = zData.health;
      zombie.maxHealth = zData.maxHealth;
      zombie.speed = zData.speed;
      zombie.baseSpeed = zData.baseSpeed;
      zombie.attackDamage = zData.attackDamage;
      zombie.frozen = zData.frozen;
      zombie.frozenTimer = zData.frozenTimer;
      zombie.freezeImmunityTimer = zData.freezeImmunityTimer;
      zombie.isFreezeImmune = zData.isFreezeImmune;
      zombie.rooted = zData.rooted;
      zombie.rootedTimer = zData.rootedTimer;
      zombie.attackCooldown = zData.attackCooldown;
      zombie.shootCooldown = zData.shootCooldown;
      zombie.summonCooldown = zData.summonCooldown;
      zombie.hasSummoned = zData.hasSummoned;
      zombie.healCooldown = zData.healCooldown || 0;
      zombie.age = zData.age;
      zombie.userData = zData.userData || {};

      if (mesh.userData.leftArm) zombie.leftArm = mesh.userData.leftArm;
      if (mesh.userData.rightArm) zombie.rightArm = mesh.userData.rightArm;
      if (mesh.userData.leftLeg) zombie.leftLeg = mesh.userData.leftLeg;
      if (mesh.userData.rightLeg) zombie.rightLeg = mesh.userData.rightLeg;

      this.zombies.push(zombie);
    }

    // Reconstruct allies
    for (const aData of data.allies) {
      const mesh = this.createAllyMesh(aData.type);
      mesh.position.set(aData.x, 0.5, aData.z);
      this.scene.add(mesh);

      const ally = new Ally(mesh, aData.type, new THREE.Vector3(aData.x, 0.5, aData.z));
      ally.health = aData.health;
      ally.maxHealth = aData.maxHealth;
      ally.damage = aData.damage;
      ally.attackCooldown = aData.attackCooldown;
      ally.speed = aData.speed;
      ally.spawnZ = aData.spawnZ;

      this.allies.push(ally);
    }

    // Update UI
    const sunAmount = document.getElementById('sun-amount');
    if (sunAmount) sunAmount.textContent = this.sun.toString();
    this.updateCoinDisplay();

    // Rebuild plant bar with loaded selectedPlants
    this.setupPlantBar();

    // Update wave button display
    const startWaveBtn = document.getElementById('start-wave-btn');
    if (startWaveBtn) {
      if (this.waveStarted && !this.waveComplete) {
        const modeLabel = this.isEndlessMode ? 'Endless ' : '';
        startWaveBtn.textContent = `${modeLabel}Wave ${this.currentWave} Active!`;
        (startWaveBtn as HTMLButtonElement).disabled = true;
      } else {
        startWaveBtn.textContent = `Start Wave ${this.currentWave + 1}`;
        (startWaveBtn as HTMLButtonElement).disabled = false;
      }
    }

    // Update speed button active state
    document.querySelectorAll('.speed-btn').forEach(btn => {
      const speed = parseFloat(btn.getAttribute('data-speed') || '1');
      if (speed === this.gameSpeed) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
    const currentSpeedValue = document.getElementById('current-speed-value');
    if (currentSpeedValue) currentSpeedValue.textContent = `${this.gameSpeed}x`;

    console.log(`Game loaded: Wave ${this.currentWave}, ${this.placedPlants.length} plants, ${this.zombies.length} zombies, ${this.allies.length} allies`);
  }

  private togglePause(): void {
    this.isPaused = !this.isPaused;
    const pauseMenu = document.getElementById('pause-menu');

    if (pauseMenu) {
      if (this.isPaused) {
        pauseMenu.classList.add('active');
      } else {
        pauseMenu.classList.remove('active');
      }
    }
  }

  public startNextWave(): void {
    if (this.isDragonBattleMode) {
      this.startDragonBattleWave();
      return;
    }

    this.currentWave++;
    this.waveStarted = true;
    this.waveComplete = false;
    this.gameTime = 0;
    this.nextZombieSpawn = 2;
    this.zombiesSpawnedInWave = 0;
    this.fireZombiesSpawnedThisWave = 0;

    // Calculate zombies for this wave
    // Increased zombie counts for more action!
    let baseZombies: number;
    if (this.currentWave <= 3) {
      // Early waves: 8, 12, 16 zombies
      baseZombies = 4 + (this.currentWave * 4);
    } else if (this.currentWave <= 6) {
      // Medium waves: more zombies
      baseZombies = 10 + (this.currentWave * 4);
    } else {
      // Harder waves from wave 7+
      baseZombies = 15 + (this.currentWave * 5);
    }

    // In endless mode, apply difficulty multiplier
    if (this.isEndlessMode) {
      baseZombies = Math.floor(baseZombies * this.endlessWaveMultiplier);
      console.log(`♾️ Endless mode wave ${this.currentWave} (${this.endlessWaveMultiplier.toFixed(1)}x difficulty)`);
    }
    this.zombiesInWave = baseZombies;

    const startWaveBtn = document.getElementById('start-wave-btn');
    if (startWaveBtn) {
      const modeLabel = this.isEndlessMode ? '♾️ Endless ' : '';
      startWaveBtn.textContent = `${modeLabel}Wave ${this.currentWave} Active!`;
      startWaveBtn.classList.add('started');
      startWaveBtn.style.cursor = 'default';
    }

    console.log(`🌊 Wave ${this.currentWave} started! ${this.zombiesInWave} zombies incoming!`);

    // Initialize wave progress display
    this.updateWaveProgressDisplay();

    // Spawn special zombies for specific waves
    this.spawnWaveSpecialZombies();
  }

  private spawnWaveSpecialZombies(): void {
    const wave = this.currentWave;

    // Wave 3: 1 car zombie
    if (wave === 3) {
      setTimeout(() => this.spawnSpecificZombie('car'), 3000);
      console.log('🚗 Wave 3: Car zombie incoming!');
    }

    // Wave 5: 2 car zombies + 1 grape gun zombie
    if (wave === 5) {
      setTimeout(() => this.spawnSpecificZombie('car'), 2000);
      setTimeout(() => this.spawnSpecificZombie('car'), 4000);
      setTimeout(() => this.spawnSpecificZombie('grape-gun'), 5000);
      console.log('🚗🍇 Wave 5: 2 Car zombies + Grape Gun zombie!');
    }

    // Wave 7: 3 car zombies + 2 healer zombies
    if (wave === 7) {
      setTimeout(() => this.spawnSpecificZombie('car'), 2000);
      setTimeout(() => this.spawnSpecificZombie('car'), 3500);
      setTimeout(() => this.spawnSpecificZombie('car'), 5000);
      setTimeout(() => this.spawnSpecificZombie('healer'), 4000);
      setTimeout(() => this.spawnSpecificZombie('healer'), 6000);
      console.log('🚗💚 Wave 7: 3 Car zombies + 2 Healer zombies!');
    }

    // Wave 9: 5 healer zombies + 3 grape gun zombies
    if (wave === 9) {
      setTimeout(() => this.spawnSpecificZombie('healer'), 1500);
      setTimeout(() => this.spawnSpecificZombie('healer'), 3000);
      setTimeout(() => this.spawnSpecificZombie('healer'), 4500);
      setTimeout(() => this.spawnSpecificZombie('healer'), 6000);
      setTimeout(() => this.spawnSpecificZombie('healer'), 7500);
      setTimeout(() => this.spawnSpecificZombie('grape-gun'), 2500);
      setTimeout(() => this.spawnSpecificZombie('grape-gun'), 5000);
      setTimeout(() => this.spawnSpecificZombie('grape-gun'), 7000);
      console.log('💚🍇 Wave 9: 5 Healer zombies + 3 Grape Gun zombies!');
    }

    // Wave 10: 5 car zombies + 1 super car zombie + TITAN TUTORIAL!
    if (wave === 10) {
      // Show Titan fusion tutorial at wave 10
      if ((window as any).showTitanTutorial) {
        (window as any).showTitanTutorial();
      }
      setTimeout(() => this.spawnSpecificZombie('car'), 1000);
      setTimeout(() => this.spawnSpecificZombie('car'), 2500);
      setTimeout(() => this.spawnSpecificZombie('car'), 4000);
      setTimeout(() => this.spawnSpecificZombie('car'), 5500);
      setTimeout(() => this.spawnSpecificZombie('car'), 7000);
      setTimeout(() => this.spawnSpecificZombie('super-car'), 8000);
      console.log('🚗🚙 Wave 10: 5 Car zombies + SUPER CAR zombie!');
    }

    // Wave 11: 5 healer zombies + 2 grape gun zombies
    if (wave === 11) {
      setTimeout(() => this.spawnSpecificZombie('healer'), 1500);
      setTimeout(() => this.spawnSpecificZombie('healer'), 3000);
      setTimeout(() => this.spawnSpecificZombie('healer'), 4500);
      setTimeout(() => this.spawnSpecificZombie('healer'), 6000);
      setTimeout(() => this.spawnSpecificZombie('healer'), 7500);
      setTimeout(() => this.spawnSpecificZombie('grape-gun'), 4000);
      setTimeout(() => this.spawnSpecificZombie('grape-gun'), 6500);
      console.log('💚🍇 Wave 11: 5 Healer zombies + 2 Grape Gun zombies!');
    }

    // Wave 12: 1 super car zombie + 2 grape gun zombies
    if (wave === 12) {
      setTimeout(() => this.spawnSpecificZombie('super-car'), 3000);
      setTimeout(() => this.spawnSpecificZombie('grape-gun'), 4500);
      setTimeout(() => this.spawnSpecificZombie('grape-gun'), 6000);
      console.log('🚙🍇 Wave 12: SUPER CAR + 2 Grape Gun zombies!');
    }

    // Wave 13: 10 healer zombies at different times
    if (wave === 13) {
      for (let i = 0; i < 10; i++) {
        setTimeout(() => this.spawnSpecificZombie('healer'), 1000 + i * 1500);
      }
      console.log('💚💚💚 Wave 13: 10 Healer zombies incoming over time!');
    }

    // Wave 14: 2 super car zombies
    if (wave === 14) {
      setTimeout(() => this.spawnSpecificZombie('super-car'), 3000);
      setTimeout(() => this.spawnSpecificZombie('super-car'), 6000);
      console.log('🚙🚙 Wave 14: 2 SUPER CAR zombies!');
    }

    // Wave 15: FINAL WAVE - 1 frost grape gun + 2 healers next to it + 2 car zombies
    if (wave === 15) {
      // Spawn frost grape gun in middle row
      setTimeout(() => this.spawnSpecificZombie('frost-grape-gun', 0), 3000);
      // Spawn healers in adjacent rows
      setTimeout(() => this.spawnSpecificZombie('healer', -2), 3200);
      setTimeout(() => this.spawnSpecificZombie('healer', 2), 3200);
      // Spawn car zombies
      setTimeout(() => this.spawnSpecificZombie('car'), 5000);
      setTimeout(() => this.spawnSpecificZombie('car'), 7000);
      console.log('❄️🍇👑 FINAL WAVE 15: Frost Grape Gun + Healers + Cars! DEFEAT THEM TO WIN!');
    }
  }

  private spawnSpecificZombie(zombieType: ZombieType, rowOffset?: number): void {
    // Spawn at specific or random row
    let startZ: number;
    if (rowOffset !== undefined) {
      // Specific row offset from center (center is row 2, z = -4)
      startZ = -4 + rowOffset;
    } else {
      // Random row
      const rows = 5;
      const randomRow = Math.floor(Math.random() * rows);
      startZ = -8 + randomRow * 2;
    }

    const zombieMesh = this.createZombieMesh(zombieType);
    zombieMesh.position.set(10, 0.75, startZ);
    zombieMesh.rotation.y = -Math.PI / 2;
    this.scene.add(zombieMesh);

    const zombie = new Zombie(zombieMesh, zombieMesh.position, zombieType);

    if (zombieMesh.userData.leftArm) {
      zombie.leftArm = zombieMesh.userData.leftArm;
    }
    if (zombieMesh.userData.rightArm) {
      zombie.rightArm = zombieMesh.userData.rightArm;
    }

    this.zombies.push(zombie);
    console.log(`⚠️ Special ${zombieType} zombie spawned!`);
  }

  private setupVasebreakerVases(): void {
    // Create vases on the right side of the field
    const vasePositions: { x: number; z: number; content: 'plant' | 'zombie' | 'sun' }[] = [];

    // Generate vase positions (columns 4-8, all 5 rows)
    for (let col = 2; col <= 8; col += 2) {
      for (let row = 0; row < 5; row++) {
        const x = col;
        const z = -8 + row * 2;

        // Randomize content: 40% zombie, 35% plant, 25% sun
        const rand = Math.random();
        let content: 'plant' | 'zombie' | 'sun';
        if (rand < 0.40) {
          content = 'zombie';
        } else if (rand < 0.75) {
          content = 'plant';
        } else {
          content = 'sun';
        }

        vasePositions.push({ x, z, content });
      }
    }

    // Create vase meshes
    for (const pos of vasePositions) {
      const vase = this.createVaseMesh();
      vase.position.set(pos.x, 0.5, pos.z);
      vase.userData.content = pos.content;
      vase.userData.isVase = true;
      this.scene.add(vase);
      this.vases.push(vase);
    }

    this.vasesRemaining = this.vases.length;
    console.log(`🏺 Vasebreaker: ${this.vasesRemaining} vases placed! Click them to break!`);

    // Update wave display for vasebreaker
    const progressDisplay = document.getElementById('wave-progress');
    if (progressDisplay) {
      progressDisplay.innerHTML = `
        <div class="wave-info" style="color: #ffaa00;">🏺 VASEBREAKER MODE</div>
        <div class="zombie-count" style="color: #ffcc66;">Click vases to break them!</div>
        <div class="progress-bar-container">
          <div class="progress-bar-fill" style="width: 0%; background: linear-gradient(90deg, #ffaa00, #ff6600);"></div>
        </div>
        <div class="progress-percent">${this.vasesRemaining} vases remaining</div>
      `;
    }
  }

  private createVaseMesh(): THREE.Mesh {
    // Create a vase shape
    const vaseGroup = new THREE.Group();

    // Main body - rounded cylinder
    const bodyGeo = new THREE.CylinderGeometry(0.4, 0.5, 1.2, 16);
    const vaseMat = new THREE.MeshPhongMaterial({
      color: 0x8B4513,
      shininess: 60,
      specular: 0x553311
    });
    const body = new THREE.Mesh(bodyGeo, vaseMat);
    body.position.y = 0.6;
    vaseGroup.add(body);

    // Neck
    const neckGeo = new THREE.CylinderGeometry(0.25, 0.4, 0.3, 16);
    const neck = new THREE.Mesh(neckGeo, vaseMat);
    neck.position.y = 1.35;
    vaseGroup.add(neck);

    // Rim
    const rimGeo = new THREE.TorusGeometry(0.28, 0.05, 8, 16);
    const rim = new THREE.Mesh(rimGeo, vaseMat);
    rim.rotation.x = Math.PI / 2;
    rim.position.y = 1.5;
    vaseGroup.add(rim);

    // Question mark decoration
    const canvas = document.createElement('canvas');
    canvas.width = 64;
    canvas.height = 64;
    const ctx = canvas.getContext('2d')!;
    ctx.fillStyle = '#FFD700';
    ctx.font = 'bold 48px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('?', 32, 32);

    const texture = new THREE.CanvasTexture(canvas);
    const decalGeo = new THREE.PlaneGeometry(0.5, 0.5);
    const decalMat = new THREE.MeshBasicMaterial({ map: texture, transparent: true });
    const decal = new THREE.Mesh(decalGeo, decalMat);
    decal.position.set(0.41, 0.6, 0);
    decal.rotation.y = Math.PI / 2;
    vaseGroup.add(decal);

    // Return as single mesh for raycasting
    const combinedGeo = new THREE.CylinderGeometry(0.5, 0.5, 1.5, 16);
    const combinedMesh = new THREE.Mesh(combinedGeo, new THREE.MeshPhongMaterial({
      color: 0x8B4513,
      shininess: 60,
      transparent: true,
      opacity: 0
    }));
    combinedMesh.add(vaseGroup);

    return combinedMesh;
  }

  private breakVase(vase: THREE.Mesh): void {
    const content = vase.userData.content as 'plant' | 'zombie' | 'sun';
    const x = vase.position.x;
    const z = vase.position.z;

    // Remove vase
    this.scene.remove(vase);
    this.vases = this.vases.filter(v => v !== vase);
    this.vasesRemaining--;

    // Create breaking effect
    this.createVaseBreakEffect(x, z);

    // Spawn content
    if (content === 'zombie') {
      // Spawn a random zombie
      const types: ZombieType[] = ['normal', 'fast', 'tank', 'tiny'];
      const randomType = types[Math.floor(Math.random() * types.length)];
      const zombieMesh = this.createZombieMesh(randomType);
      zombieMesh.position.set(x, 0.75, z);
      zombieMesh.rotation.y = -Math.PI / 2;
      this.scene.add(zombieMesh);
      const zombie = new Zombie(zombieMesh, zombieMesh.position, randomType);
      if (zombieMesh.userData.leftArm) zombie.leftArm = zombieMesh.userData.leftArm;
      if (zombieMesh.userData.rightArm) zombie.rightArm = zombieMesh.userData.rightArm;
      this.zombies.push(zombie);
      console.log(`🏺💀 Vase contained a ${randomType} zombie!`);
    } else if (content === 'plant') {
      // Give player a random plant to place
      const plants: PlantType[] = ['grape-launcher', 'vine-wall', 'pear-cannon', 'frost-berri'];
      const randomPlant = plants[Math.floor(Math.random() * plants.length)];
      // Auto-place the plant at this location if slot is free
      const slotKey = `${Math.round(x / 2) * 2},${Math.round(z / 2) * 2}`;
      if (!this.plantSlots.get(slotKey)) {
        const plantMesh = this.createPlantMesh(randomPlant);
        const gridX = Math.round(x / 2) * 2;
        const gridZ = Math.round(z / 2) * 2;
        plantMesh.position.set(gridX, 0.5, gridZ);
        this.scene.add(plantMesh);
        const plant = new Plant(plantMesh, randomPlant, new THREE.Vector3(gridX, 0.5, gridZ));
        this.placedPlants.push(plant);
        this.plantSlots.set(slotKey, true);
        this.hideSlotIndicator(gridX, gridZ);
        console.log(`🏺🌱 Vase contained a ${randomPlant}! Placed automatically.`);
      } else {
        // Give sun instead if slot is occupied
        this.sun += 75;
        const sunAmount = document.getElementById('sun-amount');
        if (sunAmount) sunAmount.textContent = this.sun.toString();
        console.log(`🏺☀️ Slot occupied - got 75 sun instead!`);
      }
    } else {
      // Sun reward
      const sunReward = 50 + Math.floor(Math.random() * 100);
      this.sun += sunReward;
      const sunAmount = document.getElementById('sun-amount');
      if (sunAmount) sunAmount.textContent = this.sun.toString();
      console.log(`🏺☀️ Vase contained ${sunReward} sun!`);
    }

    // Update display
    this.updateVasebreakerDisplay();

    // Check for vasebreaker win
    if (this.vasesRemaining === 0 && this.zombies.length === 0) {
      this.showVasebreakerVictory();
    }
  }

  private createVaseBreakEffect(x: number, z: number): void {
    // Create particles for breaking effect
    const particleCount = 8;
    for (let i = 0; i < particleCount; i++) {
      const shardGeo = new THREE.BoxGeometry(0.15, 0.15, 0.05);
      const shardMat = new THREE.MeshPhongMaterial({ color: 0x8B4513 });
      const shard = new THREE.Mesh(shardGeo, shardMat);
      shard.position.set(x, 0.8, z);

      // Random velocity
      const vx = (Math.random() - 0.5) * 0.3;
      const vy = Math.random() * 0.2 + 0.1;
      const vz = (Math.random() - 0.5) * 0.3;

      this.scene.add(shard);

      // Animate shard
      let time = 0;
      const animateShard = () => {
        time += 0.016;
        shard.position.x += vx;
        shard.position.y += vy - time * 0.5;
        shard.position.z += vz;
        shard.rotation.x += 0.2;
        shard.rotation.z += 0.15;

        if (time < 0.5) {
          requestAnimationFrame(animateShard);
        } else {
          this.scene.remove(shard);
        }
      };
      animateShard();
    }
  }

  private updateVasebreakerDisplay(): void {
    const progressDisplay = document.getElementById('wave-progress');
    if (progressDisplay) {
      const totalVases = 20; // We start with ~20 vases
      const broken = totalVases - this.vasesRemaining;
      const percent = Math.floor((broken / totalVases) * 100);

      progressDisplay.innerHTML = `
        <div class="wave-info" style="color: #ffaa00;">🏺 VASEBREAKER MODE</div>
        <div class="zombie-count" style="color: #ffcc66;">${this.zombies.length} zombies | ${this.vasesRemaining} vases</div>
        <div class="progress-bar-container">
          <div class="progress-bar-fill" style="width: ${percent}%; background: linear-gradient(90deg, #ffaa00, #ff6600);"></div>
        </div>
        <div class="progress-percent">${percent}% cleared</div>
      `;
    }
  }

  private showVasebreakerVictory(): void {
    this.gameOver = true;

    const victoryDiv = document.createElement('div');
    victoryDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(50, 30, 0, 0.95);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 10000;
      color: white;
    `;

    victoryDiv.innerHTML = `
      <h1 style="font-size: 4rem; color: #ffaa00; text-shadow: 0 0 30px rgba(255, 170, 0, 0.8);">🏺 VASEBREAKER COMPLETE! 🏺</h1>
      <p style="font-size: 1.5rem; color: #ffcc66; margin: 1rem 0;">You broke all the vases and defeated all zombies!</p>
      <button onclick="location.reload()" style="padding: 1rem 2rem; font-size: 1.5rem; background: linear-gradient(135deg, #ffaa00, #ff6600); color: white; border: none; border-radius: 10px; cursor: pointer; margin-top: 1rem;">Return to Menu</button>
    `;

    document.body.appendChild(victoryDiv);
  }

  private skipToNextWave(): void {
    // Clear all current zombies
    for (const zombie of this.zombies) {
      this.scene.remove(zombie.mesh);
    }
    this.zombies = [];

    // Reset wave state
    this.waveStarted = false;
    this.waveComplete = true;
    this.zombiesSpawnedInWave = 0;
    this.fireZombiesSpawnedThisWave = 0;

    // Advance to next wave
    console.log(`⏭️ Skipping to wave ${this.currentWave + 1}...`);
    this.startNextWave();
  }

  private skipToPreviousWave(): void {
    if (this.currentWave <= 1) {
      console.log('⚠️ Already at wave 1, cannot go back further!');
      return;
    }

    // Clear all current zombies
    for (const zombie of this.zombies) {
      this.scene.remove(zombie.mesh);
    }
    this.zombies = [];

    // Go back 2 waves (because startNextWave will increment by 1)
    this.currentWave -= 2;
    if (this.currentWave < 0) this.currentWave = 0;

    // Reset wave state
    this.waveStarted = false;
    this.waveComplete = true;
    this.zombiesSpawnedInWave = 0;
    this.fireZombiesSpawnedThisWave = 0;

    console.log(`⏮️ Going back to wave ${this.currentWave + 1}...`);
    this.startNextWave();
  }

  private completeWave(): void {
    this.waveComplete = true;
    this.waveStarted = false;

    console.log(`✅ Wave ${this.currentWave} complete! All zombies defeated!`);

    // Show wave complete on progress display
    const progressDisplay = document.getElementById('wave-progress');
    if (progressDisplay) {
      progressDisplay.innerHTML = `
        <div class="wave-info" style="color: #00ff88;">Wave ${this.currentWave} Complete!</div>
        <div class="zombie-count" style="color: #00ffcc; animation: none;">All zombies defeated!</div>
        <div class="progress-bar-container">
          <div class="progress-bar-fill" style="width: 100%"></div>
        </div>
        <div class="progress-percent">100% complete</div>
      `;
    }

    // Endless mode special handling
    if (this.isEndlessMode) {
      // Save highscore
      const currentHighscore = parseInt(localStorage.getItem('endlessHighscore') || '0');
      if (this.currentWave > currentHighscore) {
        localStorage.setItem('endlessHighscore', this.currentWave.toString());
        console.log(`🏆 New endless highscore: Wave ${this.currentWave}!`);
      }

      // Give bonus sun for surviving (increases each wave)
      const bonusSun = 50 + (this.currentWave * 25);
      this.sun += bonusSun;
      const sunAmount = document.getElementById('sun-amount');
      if (sunAmount) sunAmount.textContent = this.sun.toString();
      console.log(`☀️ Bonus sun awarded: +${bonusSun} (total: ${this.sun})`);

      // Increase difficulty multiplier
      this.endlessWaveMultiplier = 1 + (this.currentWave * 0.1);

      // Auto-start next wave after short delay
      setTimeout(() => {
        this.startNextWave();
      }, 2000);
      return;
    }

    // Shooter mode handling
    if (this.isShooterMode) {
      // Give bonus ammo for completing wave
      const bonusAmmo = 15 + (this.currentWave * 5);
      this.shooterAmmo += bonusAmmo;
      this.updateShooterUI();
      console.log(`🔫 Wave ${this.currentWave} complete! +${bonusAmmo} ammo!`);

      // Check for shooter mode victory (10 waves)
      if (this.currentWave >= 10) {
        this.showShooterVictory();
        return;
      }

      // Auto-start next wave
      setTimeout(() => {
        this.startNextWave();
        const waveBtn = document.getElementById('wave-btn');
        if (waveBtn) waveBtn.textContent = `Wave ${this.currentWave}`;
      }, 2000);
      return;
    }

    // Check if any plants should be unlocked after this wave
    const plantsToUnlock = WAVE_UNLOCKS[this.currentWave];
    if (plantsToUnlock) {
      plantsToUnlock.forEach(plantType => {
        unlockPlant(plantType);
      });
    }

    // Check for victory (completed wave 15)
    if (this.currentWave >= 15) {
      this.showVictory();
      return;
    }

    // Return to plant selection for next wave
    this.showPlantSelectionForNextWave();
  }

  private updateWaveProgressDisplay(): void {
    const progressDisplay = document.getElementById('wave-progress');
    if (progressDisplay) {
      const zombiesRemaining = (this.zombiesInWave - this.zombiesSpawnedInWave) + this.zombies.length;
      const totalZombies = this.zombiesInWave;
      const zombiesKilled = totalZombies - zombiesRemaining;
      const percentComplete = Math.floor((zombiesKilled / totalZombies) * 100);

      progressDisplay.innerHTML = `
        <div class="wave-info">Wave ${this.currentWave}</div>
        <div class="zombie-count">${zombiesRemaining} zombies left</div>
        <div class="progress-bar-container">
          <div class="progress-bar-fill" style="width: ${percentComplete}%"></div>
        </div>
        <div class="progress-percent">${percentComplete}% complete</div>
      `;
    }
  }

  private showPlantSelectionForNextWave(): void {
    const plantSelection = document.getElementById('plant-selection');
    const gameUI = document.getElementById('game-ui');
    const startGameBtn = document.getElementById('start-game-btn') as HTMLButtonElement | null;

    if (plantSelection && gameUI && startGameBtn) {
      gameUI.classList.remove('active');
      plantSelection.classList.add('active');
      startGameBtn.textContent = `Continue to Wave ${this.currentWave + 1}`;
      startGameBtn.disabled = false;
      // Update plant card lock status to show newly unlocked plants
      updatePlantCardLockStatus();
    }
  }

  public updateSelectedPlants(plants: PlantType[]): void {
    this.selectedPlants = plants;
    this.setupPlantBar();
  }

  private setupPlantBar(): void {
    const plantBar = document.getElementById('plant-bar');
    if (!plantBar) return;

    // Conveyor mode has a different plant bar setup
    if (this.isConveyorMode) {
      this.setupConveyorBar();
      return;
    }

    // Clear existing plant slots
    plantBar.innerHTML = '';

    // Repopulate with new plant selection
    this.selectedPlants.forEach(plantType => {
      const info = PLANT_INFO[plantType];
      const slot = document.createElement('div');
      slot.className = 'plant-slot';
      slot.dataset.plant = plantType;
      slot.innerHTML = `
        <div class="name">${info.emoji} ${info.name}</div>
        <div class="cost">☀️ ${info.cost}</div>
      `;

      slot.addEventListener('click', () => this.selectPlant(plantType));
      plantBar.appendChild(slot);
    });

    // Update plant slot states (disabled/enabled)
    this.updatePlantSlots();
  }

  private setupConveyorBar(): void {
    const plantBar = document.getElementById('plant-bar');
    if (!plantBar) return;

    plantBar.innerHTML = '<div style="color: #aaa; padding: 5px;">🎒 Conveyor Belt - Read the tutorial, then click Let\'s Go!</div>';

    // Start with empty conveyor - plants only come during wave
    this.conveyorPlants = [];
    this.conveyorTimer = 0;
    // Wave will start when tutorial "Let's Go!" is clicked (see showModeTutorial)
  }

  private updateConveyorUI(): void {
    const plantBar = document.getElementById('plant-bar');
    if (!plantBar || !this.isConveyorMode) return;

    plantBar.innerHTML = '';

    // Show conveyor label
    const label = document.createElement('div');
    label.style.cssText = 'color: #88ff88; padding: 3px 8px; font-size: 0.8rem;';
    label.textContent = '🎒 Conveyor:';
    plantBar.appendChild(label);

    // Show plants on conveyor
    this.conveyorPlants.forEach((plantType, index) => {
      const info = PLANT_INFO[plantType];
      const slot = document.createElement('div');
      slot.className = 'plant-slot';
      slot.dataset.plant = plantType;
      slot.dataset.conveyorIndex = index.toString();
      slot.innerHTML = `
        <div class="name">${info.emoji}</div>
        <div class="cost" style="font-size: 0.7rem;">FREE</div>
      `;

      slot.addEventListener('click', () => {
        // Select this plant from conveyor
        this.currentPlantType = plantType;
        this.currentConveyorIndex = index;
        document.querySelectorAll('.plant-slot').forEach(s => s.classList.remove('selected'));
        slot.classList.add('selected');
      });

      plantBar.appendChild(slot);
    });
  }

  private currentConveyorIndex: number = -1;

  private setupShovelButton(): void {
    const shovelBtn = document.getElementById('shovel-btn');
    if (shovelBtn) {
      shovelBtn.addEventListener('click', () => {
        this.shovelMode = !this.shovelMode;

        if (this.shovelMode) {
          shovelBtn.classList.add('active');
          console.log('Shovel mode activated! Click plants to remove them.');

          // Deselect current plant type
          this.currentPlantType = null;
          document.querySelectorAll('.plant-slot').forEach(slot => {
            slot.classList.remove('selected');
          });

          // Deactivate glove mode if active
          this.gloveMode = false;
          this.glovePlant = null;
          const gloveBtn = document.getElementById('glove-btn');
          if (gloveBtn) gloveBtn.classList.remove('active');
          const gloveIndicator = document.getElementById('glove-indicator');
          if (gloveIndicator) gloveIndicator.classList.remove('active');
          this.clearGloveHighlights();
        } else {
          shovelBtn.classList.remove('active');
          console.log('Shovel mode deactivated.');
        }
      });
    }
  }

  private setupGloveButton(): void {
    const gloveBtn = document.getElementById('glove-btn');
    if (gloveBtn) {
      gloveBtn.addEventListener('click', () => {
        const wasHoldingPlant = this.glovePlant;
        this.gloveMode = !this.gloveMode;

        const gloveIndicator = document.getElementById('glove-indicator');

        if (this.gloveMode) {
          this.glovePlant = null;
          gloveBtn.classList.add('active');
          console.log('🧤 Glove mode activated! Click a plant to pick it up.');

          // Deselect current plant type
          this.currentPlantType = null;
          document.querySelectorAll('.plant-slot').forEach(slot => {
            slot.classList.remove('selected');
          });

          // Deactivate shovel mode if active
          this.shovelMode = false;
          const shovelBtn = document.getElementById('shovel-btn');
          if (shovelBtn) shovelBtn.classList.remove('active');

          // Show glove indicator
          if (gloveIndicator) {
            gloveIndicator.classList.add('active');
            gloveIndicator.textContent = '🧤 GLOVE MODE - Click plant to pick up';
          }

          // Update highlights
          this.updateGloveHighlights();
        } else {
          // Reset held plant visual if any - use wasHoldingPlant since we set glovePlant to null for mode ON
          if (wasHoldingPlant) {
            this.resetGlovePlantVisual(wasHoldingPlant);
          }
          this.glovePlant = null;
          gloveBtn.classList.remove('active');
          if (gloveIndicator) {
            gloveIndicator.classList.remove('active');
            gloveIndicator.classList.remove('holding');
          }
          this.clearGloveHighlights();
          console.log('🧤 Glove mode deactivated.');
        }
      });
    }
  }

  private setupCameraControls(): void {
    // Keyboard controls for camera movement
    window.addEventListener('keydown', (event) => {
      this.keys[event.key.toLowerCase()] = true;

      // Track Shift key for pineapple crate bunker HP display & fusion
      if (event.key === 'Shift') {
        this.shiftHeld = true;
      }

      // Cheat code: Press L to unlock all plants, infinite sun, coins, and MAX ALL MASTERY
      if (event.key.toLowerCase() === 'l') {
        this.sun = 999999;
        this.coins = 999999;
        // Max out ALL mastery for ALL plants
        this.frostBerriMastery = 300;
        this.frostBerriMasteryPoints = 300;
        this.tomatoSpikeMastery = 300;
        this.tomatoSpikeMasteryPoints = 300;
        // Unlock ALL plants (base, fusion, titan, elder, shop, and crate)
        const allPlants = Object.keys(PLANT_INFO) as PlantType[];
        allPlants.forEach(plant => unlockedPlants.add(plant));
        // Also add shop plants to owned list for cheat
        const ownedPlants = JSON.parse(localStorage.getItem('fusionTdOwnedPlants') || '[]');
        SHOP_PLANTS.forEach(plant => {
          if (!ownedPlants.includes(plant)) ownedPlants.push(plant);
        });
        localStorage.setItem('fusionTdOwnedPlants', JSON.stringify(ownedPlants));
        updatePlantCardLockStatus();
        // Update sun display
        const sunAmount = document.getElementById('sun-amount');
        if (sunAmount) sunAmount.textContent = this.sun.toString();
        this.updateCoinDisplay();
        this.updateMasteryDisplay();
        console.log('🎮 CHEAT ACTIVATED: ALL plants unlocked, infinite sun & coins, ALL MASTERY MAXED!');
      }

      // Esc key: Toggle pause menu
      if (event.key === 'Escape') {
        this.togglePause();
      }

      // M key: Toggle music
      if (event.key.toLowerCase() === 'm') {
        this.toggleMusic();
      }

      // Q key: Rotate plant preview, or power plant ability 1
      if (event.key.toLowerCase() === 'q') {
        if (this.currentPlantType) {
          this.rotatePlantPreview(-Math.PI / 2);
        } else if (this.powerPlant && this.powerPlant.health > 0) {
          this.usePowerPlantAbility1();
        }
      }

      // T key: Power plant ability 2
      if (event.key.toLowerCase() === 't') {
        if (this.powerPlant && this.powerPlant.health > 0) {
          this.usePowerPlantAbility2();
        }
      }

      // R key: Rotate plant preview clockwise (90 degrees)
      if (event.key.toLowerCase() === 'r' && this.currentPlantType) {
        this.rotatePlantPreview(Math.PI / 2);
      }

      // G key: Toggle glove mode for moving plants
      if (event.key.toLowerCase() === 'g') {
        const gloveBtn = document.getElementById('glove-btn');
        if (gloveBtn) {
          gloveBtn.click(); // Trigger the button click to toggle glove mode
        }
      }

      // X key: Toggle shovel mode for removing plants
      if (event.key.toLowerCase() === 'x') {
        const shovelBtn = document.getElementById('shovel-btn');
        if (shovelBtn) {
          shovelBtn.click(); // Trigger the button click to toggle shovel mode
        }
      }
    });

    window.addEventListener('keyup', (event) => {
      this.keys[event.key.toLowerCase()] = false;

      // Track Shift key release
      if (event.key === 'Shift') {
        this.shiftHeld = false;
      }
    });

    // Scroll to pan camera
    window.addEventListener('wheel', (event) => {
      const scrollSpeed = 3;
      if (event.shiftKey) {
        // Shift+scroll = horizontal pan
        this.scrollVelocityX += Math.sign(event.deltaY) * scrollSpeed;
      } else {
        // Normal scroll = vertical pan (forward/back)
        this.scrollVelocityZ += Math.sign(event.deltaY) * scrollSpeed;
      }
    }, { passive: true });
  }

  private selectPlant(plantType: PlantType): void {
    const info = PLANT_INFO[plantType];

    if (this.sun < info.cost) {
      console.log('Not enough sun!');
      return;
    }

    // Deactivate shovel mode when selecting a plant
    if (this.shovelMode) {
      this.shovelMode = false;
      const shovelBtn = document.getElementById('shovel-btn');
      if (shovelBtn) {
        shovelBtn.classList.remove('active');
      }
    }

    // Toggle selection
    if (this.currentPlantType === plantType) {
      this.currentPlantType = null;
    } else {
      this.currentPlantType = plantType;
    }

    // Update UI
    document.querySelectorAll('.plant-slot').forEach(slot => {
      if (slot.getAttribute('data-plant') === plantType && this.currentPlantType === plantType) {
        slot.classList.add('selected');
      } else {
        slot.classList.remove('selected');
      }
    });

    // Update selected plant indicator
    this.updateSelectedPlantIndicator();
  }

  private updateSelectedPlantIndicator(): void {
    const indicator = document.getElementById('selected-plant-indicator');
    if (!indicator) return;

    if (this.currentPlantType) {
      const plantInfo = PLANT_INFO[this.currentPlantType];
      const rotationDegrees = Math.round((this.plantPreviewRotation * 180) / Math.PI);
      indicator.textContent = `🌱 Placing: ${plantInfo.emoji} ${plantInfo.name} (${plantInfo.cost}☀️) | Q/R to rotate (${rotationDegrees}°)`;
      indicator.classList.add('active');

      // Create preview mesh if not exists or different plant type
      this.createPlantPreview(this.currentPlantType);
    } else {
      indicator.classList.remove('active');

      // Remove preview mesh
      this.removePlantPreview();
    }
  }

  private createPlantPreview(plantType: PlantType): void {
    // Remove existing preview if any
    this.removePlantPreview();

    // Reset rotation for new plant selection
    this.plantPreviewRotation = 0;

    // Create new preview mesh
    this.plantPreviewMesh = this.createPlantMesh(plantType);
    this.plantPreviewMesh.position.set(0, 1.5, 0); // Start above ground
    this.plantPreviewMesh.visible = false; // Hidden until mouse is over valid tile

    // Make the preview semi-transparent and glowing
    this.plantPreviewMesh.traverse((child) => {
      if (child instanceof THREE.Mesh && child.material) {
        const mat = child.material as THREE.MeshPhongMaterial;
        mat.transparent = true;
        mat.opacity = 0.7;
        if (mat.emissive) {
          mat.emissive.setHex(0x00ff00);
          mat.emissiveIntensity = 0.3;
        }
      }
    });

    this.scene.add(this.plantPreviewMesh);
  }

  private removePlantPreview(): void {
    if (this.plantPreviewMesh) {
      this.scene.remove(this.plantPreviewMesh);
      this.plantPreviewMesh = null;
    }
  }

  private updatePlantPreviewPosition(x: number, z: number): void {
    if (this.plantPreviewMesh) {
      this.plantPreviewMesh.position.set(x, 1.2, z); // Float above the tile
      this.plantPreviewMesh.visible = true;

      // Apply rotation
      this.plantPreviewMesh.rotation.y = this.plantPreviewRotation;

      // Bobbing animation
      const bobOffset = Math.sin(Date.now() * 0.005) * 0.15;
      this.plantPreviewMesh.position.y = 1.2 + bobOffset;
    }
  }

  private rotatePlantPreview(angle: number): void {
    this.plantPreviewRotation += angle;
    // Normalize to 0 - 2PI range
    while (this.plantPreviewRotation < 0) this.plantPreviewRotation += Math.PI * 2;
    while (this.plantPreviewRotation >= Math.PI * 2) this.plantPreviewRotation -= Math.PI * 2;

    // Apply rotation to preview mesh
    if (this.plantPreviewMesh) {
      this.plantPreviewMesh.rotation.y = this.plantPreviewRotation;
    }

    // Update indicator text with new rotation
    const indicator = document.getElementById('selected-plant-indicator');
    if (indicator && this.currentPlantType) {
      const plantInfo = PLANT_INFO[this.currentPlantType];
      const rotationDegrees = Math.round((this.plantPreviewRotation * 180) / Math.PI);
      indicator.textContent = `🌱 Placing: ${plantInfo.emoji} ${plantInfo.name} (${plantInfo.cost}☀️) | Q/R to rotate (${rotationDegrees}°)`;
    }

    console.log(`🔄 Plant rotation: ${Math.round((this.plantPreviewRotation * 180) / Math.PI)}°`);
  }

  private hidePlantPreview(): void {
    if (this.plantPreviewMesh) {
      this.plantPreviewMesh.visible = false;
    }
  }

  private onMouseMove(event: MouseEvent): void {
    // Only show highlight when placing plants or using glove
    if (!this.currentPlantType && !this.gloveMode) {
      this.hideHoverHighlight();
      this.hidePlantPreview();
      return;
    }

    // Calculate mouse position
    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    this.raycaster.setFromCamera(this.mouse, this.camera);

    // Check intersection with lawn
    const lawnIntersects = this.raycaster.intersectObject(this.lawnPlane, false);
    if (lawnIntersects.length > 0) {
      const point = lawnIntersects[0].point;

      // Snap to grid
      const gridX = Math.round(point.x / 2) * 2;
      const gridZ = Math.round(point.z / 2) * 2;

      // Check if within valid planting area
      if (gridX >= -8 && gridX <= 8 && gridZ >= -8 && gridZ <= 0) {
        this.showHoverHighlight(gridX, gridZ);
        // Show plant preview above the tile
        if (this.currentPlantType) {
          this.updatePlantPreviewPosition(gridX, gridZ);
        }
      } else {
        this.hideHoverHighlight();
        this.hidePlantPreview();
      }
    } else {
      this.hideHoverHighlight();
      this.hidePlantPreview();
    }
  }

  private showHoverHighlight(x: number, z: number): void {
    if (!this.hoverHighlight) {
      // Create highlight mesh
      const highlightGeo = new THREE.PlaneGeometry(1.9, 1.9);
      const highlightMat = new THREE.MeshBasicMaterial({
        color: this.gloveMode ? 0x00ffff : 0x00ff00,
        transparent: true,
        opacity: 0.4,
        side: THREE.DoubleSide
      });
      this.hoverHighlight = new THREE.Mesh(highlightGeo, highlightMat);
      this.hoverHighlight.rotation.x = -Math.PI / 2;
      this.scene.add(this.hoverHighlight);
    }

    // Update color based on mode
    const mat = this.hoverHighlight.material as THREE.MeshBasicMaterial;
    mat.color.setHex(this.gloveMode ? 0x00ffff : 0x00ff00);

    // Check if slot is occupied
    const slotKey = `${x},${z}`;
    const isOccupied = this.plantSlots.get(slotKey);
    mat.color.setHex(isOccupied ? 0xffaa00 : (this.gloveMode ? 0x00ffff : 0x00ff00));

    this.hoverHighlight.position.set(x, 0.1, z);
    this.hoverHighlight.visible = true;
  }

  private hideHoverHighlight(): void {
    if (this.hoverHighlight) {
      this.hoverHighlight.visible = false;
    }
  }

  private onMouseClick(event: MouseEvent): void {
    // Shooter mode: click to shoot zombies
    if (this.isShooterMode) {
      this.handleShooterClick(event);
      return;
    }

    // I, Zombie mode: spawn zombies instead of plants
    if (this.isIZombieMode) {
      this.handleIZombieClick(event);
      return;
    }

    // Check for sun collection first
    if (this.checkSunClick(event)) {
      return; // Sun was collected, don't process other clicks
    }

    // Calculate mouse position
    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    this.raycaster.setFromCamera(this.mouse, this.camera);

    // Check for vase clicks in Vasebreaker mode
    if (this.isVasebreakerMode && this.vases.length > 0) {
      const vaseIntersects = this.raycaster.intersectObjects(this.vases, true);
      if (vaseIntersects.length > 0) {
        // Find the parent vase mesh
        let clickedVase = vaseIntersects[0].object as THREE.Mesh;
        while (clickedVase.parent && !clickedVase.userData.isVase) {
          clickedVase = clickedVase.parent as THREE.Mesh;
        }
        if (clickedVase.userData.isVase) {
          this.breakVase(clickedVase);
          return;
        }
      }
    }

    // Whack-a-Zombie mode: click zombies with shovel to smash them!
    if (this.isWhackMode && this.shovelMode && this.zombies.length > 0) {
      const zombieMeshes = this.zombies.map(z => z.mesh);
      const zombieIntersects = this.raycaster.intersectObjects(zombieMeshes, true);
      if (zombieIntersects.length > 0) {
        // Find which zombie was hit
        for (const zombie of this.zombies) {
          const isHit = zombie.mesh.children.some(child =>
            zombieIntersects.some(hit => hit.object === child)
          ) || zombieIntersects.some(hit => hit.object === zombie.mesh);

          if (isHit) {
            // SMASH! Shovel deals massive damage (100 per hit)
            zombie.health -= 100;

            // Visual feedback - whack effect!
            // Big "POW" effect
            const powGeo = new THREE.SphereGeometry(0.8, 8, 8);
            const powMat = new THREE.MeshBasicMaterial({ color: 0xffff00, transparent: true, opacity: 0.9 });
            const pow = new THREE.Mesh(powGeo, powMat);
            pow.position.copy(zombie.position);
            pow.position.y += 1.5;
            this.scene.add(pow);

            // Create stars around impact
            for (let i = 0; i < 5; i++) {
              const starGeo = new THREE.OctahedronGeometry(0.2, 0);
              const starMat = new THREE.MeshBasicMaterial({ color: 0xffff00 });
              const star = new THREE.Mesh(starGeo, starMat);
              star.position.copy(zombie.position);
              star.position.y += 1.5;
              star.position.x += (Math.random() - 0.5) * 2;
              star.position.z += (Math.random() - 0.5) * 2;
              this.scene.add(star);

              // Animate star outward
              const angle = (i / 5) * Math.PI * 2;
              const speed = 0.15;
              let life = 1;
              const animateStar = () => {
                life -= 0.05;
                star.position.x += Math.cos(angle) * speed;
                star.position.z += Math.sin(angle) * speed;
                star.rotation.x += 0.2;
                star.rotation.y += 0.2;
                (star.material as THREE.MeshBasicMaterial).opacity = life;
                if (life > 0) {
                  requestAnimationFrame(animateStar);
                } else {
                  this.scene.remove(star);
                }
              };
              animateStar();
            }

            // Animate pow effect
            let opacity = 0.9;
            const animatePow = () => {
              opacity -= 0.08;
              powMat.opacity = opacity;
              pow.scale.multiplyScalar(1.15);
              if (opacity > 0) {
                requestAnimationFrame(animatePow);
              } else {
                this.scene.remove(pow);
              }
            };
            animatePow();

            // Knock the zombie back slightly
            zombie.position.x += 0.3;
            zombie.mesh.position.copy(zombie.position);

            console.log(`🔨 WHACK! Zombie took 100 damage! Health: ${zombie.health}`);
            return; // Handled the click
          }
        }
      }
    }

    // Check for plant clicks
    const plantMeshes = this.placedPlants.map(p => p.mesh);
    const plantIntersects = this.raycaster.intersectObjects(plantMeshes, true);

    if (plantIntersects.length > 0) {
      // Find which plant was clicked
      for (const plant of this.placedPlants) {
        if (plant.mesh.children.some(child => plantIntersects[0].object === child) || plantIntersects[0].object === plant.mesh) {
          // Double-click detection for Frost Berri mastery upgrade
          const currentTime = Date.now();
          if (this.lastClickedPlant === plant && currentTime - this.lastClickTime < 500) {
            // Double-click detected!
            if (plant.type === 'frost-berri' && this.frostBerriMasteryPoints >= 300) {
              // Upgrade to Elder Frost Berri - FREE with mastery (3000 sun is placement cost, not upgrade cost)

              // Change plant type to Elder Frost Berri
              plant.type = 'elder-frost-berri';

              // Replace mesh with Elder Frost Berri mesh
              this.scene.remove(plant.mesh);
              plant.mesh = this.createPlantMesh('elder-frost-berri');
              plant.mesh.position.copy(plant.position);
              // No rotation needed - default facing is +X towards zombie spawn
              this.scene.add(plant.mesh);

              console.log('🎉 Frost Berri upgraded to ELDER FROST BERRI! (20 second freeze, can be fused with Grape Gun!)');
              this.lastClickedPlant = null;
              return;
            } else if (plant.type === 'frost-berri') {
              console.log(`❌ Frost Berri not yet mastered! ${this.frostBerriMastery}/300 zombies frozen.`);
              alert(`Frost Berri Mastery not complete!\n\nYou have frozen ${this.frostBerriMastery}/300 zombies.\n\nFreeze ${300 - this.frostBerriMastery} more zombies to unlock Elder Frost Berri upgrade!`);
            }

            // Tomato Spike mastery upgrade
            if (plant.type === 'tomato-spike' && this.tomatoSpikeMasteryPoints >= 300) {
              // Upgrade to Elder Tomato Spike - FREE with mastery (3000 sun is placement cost, not upgrade cost)

              // Change plant type to Elder Tomato Spike
              plant.type = 'elder-tomato-spike';

              // Replace mesh with Elder Tomato Spike mesh
              this.scene.remove(plant.mesh);
              plant.mesh = this.createPlantMesh('elder-tomato-spike');
              plant.mesh.position.copy(plant.position);
              this.scene.add(plant.mesh);

              console.log('🎉 Tomato Spike upgraded to ELDER TOMATO SPIKE! (300 damage in 4-tile radius!)');
              this.lastClickedPlant = null;
              return;
            } else if (plant.type === 'tomato-spike') {
              console.log(`❌ Tomato Spike not yet mastered! ${this.tomatoSpikeMastery}/300 kills.`);
              alert(`Tomato Spike Mastery not complete!\n\nYou have killed ${this.tomatoSpikeMastery}/300 zombies with Tomato Spike.\n\nKill ${300 - this.tomatoSpikeMastery} more zombies to unlock Elder Tomato Spike upgrade!`);
            }
          }
          this.lastClickedPlant = plant;
          this.lastClickTime = currentTime;

          // Lily Reaper click ability: heal plant in front by 50 HP
          if (plant.type === 'lily-reaper') {
            // Find plant in front (same row, one position to the right towards zombies)
            const plantInFront = this.placedPlants.find(p => {
              const sameRow = Math.abs(p.position.z - plant.position.z) < 1;
              const inFront = p.position.x > plant.position.x && p.position.x < plant.position.x + 3;
              return sameRow && inFront && p !== plant;
            });

            if (plantInFront && plantInFront.health < plantInFront.maxHealth) {
              const healAmount = 50;
              const actualHeal = Math.min(healAmount, plantInFront.maxHealth - plantInFront.health);
              plantInFront.health = Math.min(plantInFront.maxHealth, plantInFront.health + healAmount);

              // Create healing wave effect from lily to target
              const healWaveGeo = new THREE.TorusGeometry(0.3, 0.08, 8, 16);
              const healWaveMat = new THREE.MeshBasicMaterial({
                color: 0x00ff66,
                transparent: true,
                opacity: 0.8
              });
              const healWave = new THREE.Mesh(healWaveGeo, healWaveMat);
              healWave.rotation.x = Math.PI / 2;
              healWave.position.copy(plant.position);
              healWave.position.y = 1;
              this.scene.add(healWave);

              // Animate healing wave to target
              const targetPos = plantInFront.position.clone();
              targetPos.y = 1;
              const startPos = healWave.position.clone();
              let waveProgress = 0;
              const waveInterval = setInterval(() => {
                waveProgress += 0.08;
                healWave.position.lerpVectors(startPos, targetPos, waveProgress);
                healWave.scale.set(1 + waveProgress * 0.5, 1 + waveProgress * 0.5, 1);
                if (healWaveMat instanceof THREE.MeshBasicMaterial) {
                  healWaveMat.opacity = 0.8 * (1 - waveProgress * 0.7);
                }
                if (waveProgress >= 1) {
                  this.scene.remove(healWave);
                  clearInterval(waveInterval);
                }
              }, 25);

              // Create heal burst at target
              const healBurstGeo = new THREE.SphereGeometry(0.6, 12, 12);
              const healBurstMat = new THREE.MeshBasicMaterial({
                color: 0x88ffaa,
                transparent: true,
                opacity: 0.7
              });
              const healBurst = new THREE.Mesh(healBurstGeo, healBurstMat);
              healBurst.position.copy(plantInFront.position);
              healBurst.position.y = 1;
              healBurst.scale.set(0.2, 0.2, 0.2);
              setTimeout(() => {
                this.scene.add(healBurst);
                let burstScale = 0.2;
                let burstOpacity = 0.7;
                const burstInterval = setInterval(() => {
                  burstScale += 0.15;
                  burstOpacity -= 0.08;
                  healBurst.scale.set(burstScale, burstScale, burstScale);
                  if (healBurstMat instanceof THREE.MeshBasicMaterial) {
                    healBurstMat.opacity = burstOpacity;
                  }
                  if (burstOpacity <= 0) {
                    this.scene.remove(healBurst);
                    clearInterval(burstInterval);
                  }
                }, 40);
              }, 300);

              // Floating heal number
              const healDiv = document.createElement('div');
              healDiv.textContent = `+${actualHeal} HP`;
              healDiv.style.cssText = `
                position: fixed;
                color: #00ff66;
                font-size: 24px;
                font-weight: bold;
                text-shadow: 0 0 10px #00ff88, 2px 2px 4px rgba(0,0,0,0.5);
                pointer-events: none;
                z-index: 10000;
              `;
              document.body.appendChild(healDiv);

              // Position the heal text at the healed plant
              const screenPos = new THREE.Vector3().copy(plantInFront.position);
              screenPos.y = 2;
              screenPos.project(this.camera);
              const container = document.getElementById('canvas-container');
              if (container) {
                const rect = container.getBoundingClientRect();
                healDiv.style.left = `${rect.left + (screenPos.x + 1) * rect.width / 2}px`;
                healDiv.style.top = `${rect.top + (-screenPos.y + 1) * rect.height / 2}px`;
              }

              // Animate heal text
              let healY = 0;
              let healOpacity = 1;
              const healTextInterval = setInterval(() => {
                healY += 2;
                healOpacity -= 0.03;
                healDiv.style.transform = `translateY(-${healY}px)`;
                healDiv.style.opacity = `${healOpacity}`;
                if (healOpacity <= 0) {
                  document.body.removeChild(healDiv);
                  clearInterval(healTextInterval);
                }
              }, 30);

              console.log(`🌸💀 Lily Reaper healed ${PLANT_INFO[plantInFront.type].name} for ${actualHeal} HP!`);
              return;
            } else if (plantInFront) {
              console.log(`🌸💀 ${PLANT_INFO[plantInFront.type].name} is already at full health!`);
            } else {
              console.log(`🌸💀 No plant in front to heal!`);
            }
            return;
          }

          // Lily Peel click ability: summon Sun Fish ally (costs 300 sun)
          if (plant.type === 'lily-peel') {
            const summonCost = 300;
            if (this.sun >= summonCost) {
              this.sun -= summonCost;
              const sunAmount = document.getElementById('sun-amount');
              if (sunAmount) {
                sunAmount.textContent = this.sun.toString();
              }
              this.updatePlantSlots();

              // Spawn Sun Fish ally in front of the lily-peel
              const allyType: AllyType = 'sun-fish';
              const spawnPos = plant.position.clone();
              spawnPos.x += 2; // Spawn 1 tile in front (toward zombies)
              spawnPos.y = 0.4;

              const allyMesh = this.createAllyMesh(allyType);
              allyMesh.position.copy(spawnPos);
              this.scene.add(allyMesh);
              const ally = new Ally(allyMesh, allyType, spawnPos.clone());
              this.allies.push(ally);

              // Summoning visual effect - golden burst
              const summonBurstGeo = new THREE.SphereGeometry(0.8, 12, 12);
              const summonBurstMat = new THREE.MeshBasicMaterial({
                color: 0xffff00,
                transparent: true,
                opacity: 0.7
              });
              const summonBurst = new THREE.Mesh(summonBurstGeo, summonBurstMat);
              summonBurst.position.copy(spawnPos);
              summonBurst.scale.set(0.2, 0.2, 0.2);
              this.scene.add(summonBurst);

              let burstScale = 0.2;
              let burstOpacity = 0.7;
              const burstInterval = setInterval(() => {
                burstScale += 0.15;
                burstOpacity -= 0.08;
                summonBurst.scale.set(burstScale, burstScale, burstScale);
                if (summonBurstMat instanceof THREE.MeshBasicMaterial) {
                  summonBurstMat.opacity = burstOpacity;
                }
                if (burstOpacity <= 0) {
                  this.scene.remove(summonBurst);
                  clearInterval(burstInterval);
                }
              }, 40);

              console.log(`🌸🍌 Lily Peel summoned a Sun Fish! (250 HP, 10 dmg/0.3s, 2 tile range)`);
              return;
            } else {
              console.log(`🌸🍌 Not enough sun to summon Sun Fish! Need ${summonCost} sun.`);
              alert(`Not enough sun to summon Sun Fish!\n\nYou need ${summonCost} sun. You have ${this.sun} sun.`);
              return;
            }
          }

          // Shovel mode: remove plant
          if (this.shovelMode) {
            this.removePlant(plant);
            return;
          }

          // Glove mode: pick up plant or fuse with held plant
          if (this.gloveMode) {
            if (this.glovePlant === null) {
              // Pick up this plant
              this.glovePlant = plant;
              const container = document.getElementById('canvas-container');
              if (container) container.style.cursor = 'grabbing';
              const gloveIndicator = document.getElementById('glove-indicator');
              if (gloveIndicator) {
                const plantInfo = PLANT_INFO[plant.type];
                gloveIndicator.textContent = `🧤 HOLDING: ${plantInfo.emoji} ${plantInfo.name}`;
                gloveIndicator.classList.add('holding');
              }
              // Make the picked plant visually stand out - lift it up and scale it
              plant.mesh.position.y += 0.5;
              plant.mesh.scale.set(1.2, 1.2, 1.2);
              // Store original emissive colors and make plant glow green
              plant.userData.originalEmissives = [];
              plant.mesh.traverse((child) => {
                if (child instanceof THREE.Mesh && child.material) {
                  const mat = child.material as THREE.MeshPhongMaterial;
                  if (mat.emissive) {
                    // Store original values
                    plant.userData.originalEmissives.push({
                      mesh: child,
                      color: mat.emissive.getHex(),
                      intensity: mat.emissiveIntensity
                    });
                    // Set green glow
                    mat.emissive.setHex(0x00ff88);
                    mat.emissiveIntensity = 0.5;
                  }
                }
              });
              console.log(`🧤 Picked up ${plant.type}! Click another plant to fuse or empty slot to move.`);
              // Update highlights to show placement options
              this.updateGloveHighlights();
              return; // Exit after picking up plant to prevent picking up multiple plants
            } else if (this.glovePlant !== plant) {
              // Try to fuse with this plant
              const recipe = FUSION_RECIPES.find(r =>
                (r.plant1 === this.glovePlant!.type && r.plant2 === plant.type) ||
                (r.plant1 === plant.type && r.plant2 === this.glovePlant!.type)
              );

              if (recipe) {
                // Check if frost-grape-gun fusion is locked
                if (recipe.result === 'frost-grape-gun' && !this.frostGrapeGunUnlocked) {
                  console.log('❌ Frost Grape Gun fusion is locked! Purchase from Odd Shop first.');
                  alert('🔒 Frost Grape Gun fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
                  this.glovePlant = null;
                  this.gloveMode = false;
                  const container = document.getElementById('canvas-container');
                  if (container) container.style.cursor = 'default';
                  const gloveIndicator = document.getElementById('glove-indicator');
                  if (gloveIndicator) gloveIndicator.classList.remove('active');
                  this.clearGloveHighlights();
                  return;
                }

                // Check if straw-spiker fusion is locked
                if (recipe.result === 'straw-spiker' && !this.strawSpikerUnlocked) {
                  console.log('❌ StrawSpiker fusion is locked! Purchase from Odd Shop first.');
                  alert('🔒 StrawSpiker fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
                  this.glovePlant = null;
                  this.gloveMode = false;
                  const container = document.getElementById('canvas-container');
                  if (container) container.style.cursor = 'default';
                  const gloveIndicator = document.getElementById('glove-indicator');
                  if (gloveIndicator) gloveIndicator.classList.remove('active');
                  this.clearGloveHighlights();
                  return;
                }

                // Check if frozen-overlord-mushroom fusion is locked
                if (recipe.result === 'frozen-overlord-mushroom' && !this.frozenOverlordUnlocked) {
                  console.log('❌ Frozen Overlord Mushroom fusion is locked! Purchase from Odd Shop first.');
                  alert('🔒 Frozen Overlord Mushroom fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop (150 coins) to use this fusion recipe.');
                  this.glovePlant = null;
                  this.gloveMode = false;
                  const container = document.getElementById('canvas-container');
                  if (container) container.style.cursor = 'default';
                  const gloveIndicator2 = document.getElementById('glove-indicator');
                  if (gloveIndicator2) gloveIndicator2.classList.remove('active');
                  this.clearGloveHighlights();
                  return;
                }

                // Check if reaper-wall fusion is locked
                if (recipe.result === 'reaper-peall' && !this.reaperWallUnlocked) {
                  console.log('❌ Reaper Peall fusion is locked! Purchase from Odd Shop first.');
                  alert('🔒 Reaper Peall fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
                  this.glovePlant = null;
                  this.gloveMode = false;
                  const container = document.getElementById('canvas-container');
                  if (container) container.style.cursor = 'default';
                  const gloveIndicator3 = document.getElementById('glove-indicator');
                  if (gloveIndicator3) gloveIndicator3.classList.remove('active');
                  this.clearGloveHighlights();
                  return;
                }

                // Check if 2nd form odd fusions are locked
                if (recipe.result === 'frost-overlord-grape-gun' && !this.frostOverlordGrapeGunUnlocked) {
                  console.log('❌ Frost Overlord Grape Gun fusion is locked! Purchase from Odd Shop first.');
                  alert('🔒 Frost Overlord Grape Gun fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
                  this.glovePlant = null;
                  this.gloveMode = false;
                  const container4 = document.getElementById('canvas-container');
                  if (container4) container4.style.cursor = 'default';
                  const gloveIndicator4 = document.getElementById('glove-indicator');
                  if (gloveIndicator4) gloveIndicator4.classList.remove('active');
                  this.clearGloveHighlights();
                  return;
                }
                if (recipe.result === 'thornbomber' && !this.thornbomberUnlocked) {
                  console.log('❌ ThornBomber fusion is locked! Purchase from Odd Shop first.');
                  alert('🔒 ThornBomber fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
                  this.glovePlant = null;
                  this.gloveMode = false;
                  const container5 = document.getElementById('canvas-container');
                  if (container5) container5.style.cursor = 'default';
                  const gloveIndicator5 = document.getElementById('glove-indicator');
                  if (gloveIndicator5) gloveIndicator5.classList.remove('active');
                  this.clearGloveHighlights();
                  return;
                }
                if (recipe.result === 'titan-reaper-peall' && !this.titanReaperPeallUnlocked) {
                  console.log('❌ Titan Reaper Peall fusion is locked! Purchase from Odd Shop first.');
                  alert('🔒 Titan Reaper Peall fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
                  this.glovePlant = null;
                  this.gloveMode = false;
                  const container6 = document.getElementById('canvas-container');
                  if (container6) container6.style.cursor = 'default';
                  const gloveIndicator6 = document.getElementById('glove-indicator');
                  if (gloveIndicator6) gloveIndicator6.classList.remove('active');
                  this.clearGloveHighlights();
                  return;
                }
                if (recipe.result === 'frozen-nebula-mushroom' && !this.frozenNebulaMushroomUnlocked) {
                  console.log('❌ Frozen Nebula Mushroom fusion is locked! Purchase from Odd Shop first.');
                  alert('🔒 Frozen Nebula Mushroom fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
                  this.glovePlant = null;
                  this.gloveMode = false;
                  const container7 = document.getElementById('canvas-container');
                  if (container7) container7.style.cursor = 'default';
                  const gloveIndicator7 = document.getElementById('glove-indicator');
                  if (gloveIndicator7) gloveIndicator7.classList.remove('active');
                  this.clearGloveHighlights();
                  return;
                }

                // Award mastery points if frost-berri is used
                if (this.glovePlant!.type === 'frost-berri' || plant.type === 'frost-berri') {
                  this.frostBerriMasteryPoints += 20;
                  this.updateMasteryDisplay();
                  console.log(`Frost Berri used in fusion! +20 mastery points. Total: ${this.frostBerriMasteryPoints}`);
                }

                // Award mastery points if tomato-spike is used
                if (this.glovePlant!.type === 'tomato-spike' || plant.type === 'tomato-spike') {
                  this.tomatoSpikeMasteryPoints += 20;
                  this.updateMasteryDisplay();
                  console.log(`Tomato Spike used in fusion! +20 mastery points. Total: ${this.tomatoSpikeMasteryPoints}`);
                }

                // Remove both plants
                const targetPos = plant.position.clone();
                const gridX = Math.round(targetPos.x / 2) * 2;
                const gridZ = Math.round(targetPos.z / 2) * 2;

                // Remove old slot
                const oldSlotKey = `${Math.round(this.glovePlant!.position.x / 2) * 2},${Math.round(this.glovePlant!.position.z / 2) * 2}`;
                this.plantSlots.set(oldSlotKey, false);
                this.showSlotIndicator(Math.round(this.glovePlant!.position.x / 2) * 2, Math.round(this.glovePlant!.position.z / 2) * 2);

                this.scene.remove(this.glovePlant!.mesh);
                this.scene.remove(plant.mesh);
                this.placedPlants = this.placedPlants.filter(p => p !== this.glovePlant && p !== plant);

                // Create fused plant
                const fusedMesh = this.createPlantMesh(recipe.result);
                fusedMesh.position.set(gridX, 0.5, gridZ);
                // All plants face right towards zombie spawn (+X direction)
                // No rotation needed - default facing is +X
                this.scene.add(fusedMesh);
                const fusedPlant = new Plant(fusedMesh, recipe.result, new THREE.Vector3(gridX, 0.5, gridZ));
                this.placedPlants.push(fusedPlant);

                console.log(`🧤 Fusion successful! Created ${PLANT_INFO[recipe.result].name}!`);

                // Reset glove mode after successful fusion
                this.glovePlant = null;
                this.gloveMode = false;
                const container = document.getElementById('canvas-container');
                if (container) container.style.cursor = 'default';
                const gloveIndicator = document.getElementById('glove-indicator');
                if (gloveIndicator) {
                  gloveIndicator.classList.remove('active');
                  gloveIndicator.classList.remove('holding');
                  gloveIndicator.textContent = '🧤 GLOVE MODE - Click plant to pick up';
                }
                const gloveBtn = document.getElementById('glove-btn');
                if (gloveBtn) gloveBtn.classList.remove('active');
                this.clearGloveHighlights();
              } else {
                // Fusion failed - KEEP plant held, just show message!
                console.log(`🧤 Cannot fuse ${this.glovePlant!.type} with ${plant.type}! Still holding plant.`);
                const gloveIndicator = document.getElementById('glove-indicator');
                if (gloveIndicator) {
                  const heldInfo = PLANT_INFO[this.glovePlant!.type];
                  gloveIndicator.textContent = `🧤 Can't fuse with ${PLANT_INFO[plant.type].name}! Still holding: ${heldInfo.emoji} ${heldInfo.name}`;
                }
                // Don't reset glove mode - keep the plant held!
              }
            }
            return;
          }

          // Pear cannon activation
          if (plant.type === 'pear-cannon' && plant.cooldown <= 0) {
            this.firePearCannon(plant);
            return;
          }

          // Star Launcher activation (costs 300 sun)
          if (plant.type === 'star-launcher' && plant.cooldown <= 0) {
            if (this.sun >= 300) {
              this.fireStarLauncher(plant);
              return;
            } else {
              console.log('Not enough sun for Star Launcher! (300 sun required)');
              return;
            }
          }

          // Eggplant Cannon activation (click to stun random zombie for 8s)
          if (plant.type === 'eggplant-cannon' && plant.cooldown <= 0) {
            if (this.zombies.length > 0) {
              const randomZombie = this.zombies[Math.floor(Math.random() * this.zombies.length)];
              if (!randomZombie.isFreezeImmune && randomZombie.freezeImmunityTimer <= 0 && !randomZombie.frozen) {
                randomZombie.frozen = true;
                randomZombie.frozenTimer = 8;
                randomZombie.speed = randomZombie.baseSpeed * 0.3;

                // Purple stun beam from plant to zombie
                const beamStart = plant.position.clone();
                beamStart.y = 1.0;
                const beamEnd = randomZombie.position.clone();
                beamEnd.y = 0.5;
                const beamDir = new THREE.Vector3().subVectors(beamEnd, beamStart);
                const beamLen = beamDir.length();
                const beamGeo = new THREE.CylinderGeometry(0.06, 0.06, beamLen, 8);
                const beamMat = new THREE.MeshBasicMaterial({ color: 0xaa00ff, transparent: true, opacity: 0.8 });
                const beam = new THREE.Mesh(beamGeo, beamMat);
                const midpoint = beamStart.clone().add(beamEnd).multiplyScalar(0.5);
                beam.position.copy(midpoint);
                beam.lookAt(beamEnd);
                beam.rotateX(Math.PI / 2);
                this.scene.add(beam);

                // Stun burst at zombie
                const burstGeo = new THREE.SphereGeometry(0.5, 16, 16);
                const burstMat = new THREE.MeshBasicMaterial({ color: 0xcc44ff, transparent: true, opacity: 0.7 });
                const burst = new THREE.Mesh(burstGeo, burstMat);
                burst.position.copy(beamEnd);
                this.scene.add(burst);

                // Fade beam and burst
                let beamOpacity = 0.8;
                const fadeInterval = setInterval(() => {
                  beamOpacity -= 0.1;
                  beamMat.opacity = beamOpacity;
                  burstMat.opacity = beamOpacity * 0.875;
                  burst.scale.multiplyScalar(1.1);
                  if (beamOpacity <= 0) {
                    this.scene.remove(beam);
                    this.scene.remove(burst);
                    clearInterval(fadeInterval);
                  }
                }, 50);

                console.log('Eggplant Cannon stunned a random zombie for 8 seconds!');
              }
              plant.cooldown = 9;
            }
            return;
          }

          // Pear Spiker activation (click-to-snipe)
          if (plant.type === 'pear-spiker' && plant.cooldown <= 0) {
            this.firePearSpiker(plant);
            return;
          }

          // Strawberry Pear Launcher activation (click for rapid fire mode)
          if (plant.type === 'strawberry-pear-launcher' && plant.cooldown <= 0 && !plant.userData?.rapidFireActive) {
            if (!plant.userData) plant.userData = {};
            plant.userData.rapidFireActive = true;
            plant.userData.rapidFireTimer = 5; // 5 seconds of rapid fire
            plant.cooldown = 0; // Reset cooldown to start firing immediately

            // Red energy burst activation effect
            const burstEffect = new THREE.Mesh(
              new THREE.SphereGeometry(0.8, 16, 16),
              new THREE.MeshBasicMaterial({ color: 0xff4466, transparent: true, opacity: 0.6 })
            );
            burstEffect.position.copy(plant.position);
            burstEffect.position.y = 1;
            this.scene.add(burstEffect);
            let burstOpacity = 0.6;
            const burstInterval = setInterval(() => {
              burstOpacity -= 0.1;
              (burstEffect.material as THREE.MeshBasicMaterial).opacity = burstOpacity;
              burstEffect.scale.multiplyScalar(1.2);
              if (burstOpacity <= 0) {
                this.scene.remove(burstEffect);
                clearInterval(burstInterval);
              }
            }, 50);
            return;
          }

          // Pear Nuker activation (click plant, then click target)
          if (plant.type === 'pear-nuker' && plant.cooldown <= 0) {
            console.log('Pear Nuker selected! Click anywhere to fire nuke!');
            this.selectedPearNuker = plant;
            return;
          }
        }
      }
    }

    // Check if Pear Nuker is selected and we're clicking to fire
    if (this.selectedPearNuker) {
      const intersects = this.raycaster.intersectObject(this.lawnPlane);
      if (intersects.length > 0) {
        const point = intersects[0].point;
        this.firePearNuke(this.selectedPearNuker, point);
        this.selectedPearNuker = null;
        return;
      }
    }

    // Glove mode: move plant to empty slot
    if (this.gloveMode && this.glovePlant) {
      const intersects = this.raycaster.intersectObject(this.lawnPlane);
      if (intersects.length > 0) {
        const point = intersects[0].point;
        const gridX = Math.round(point.x / 2) * 2;
        const gridZ = Math.round(point.z / 2) * 2;

        // Check if slot is within bounds (planting area: X from -8 to 8, Z from -8 to 0)
        // For titans, also check that the second slot (gridX + 2) is within bounds
        const isTitan = this.glovePlant.isTitan;
        const maxX = isTitan ? 6 : 8; // Titans need room for second slot

        if (gridX >= -8 && gridX <= maxX && gridZ >= -8 && gridZ <= 0) {
          const slotKey = `${gridX},${gridZ}`;
          const secondSlotKey = `${gridX + 2},${gridZ}`; // For titans

          // Check if slot(s) are empty
          const slotEmpty = !this.plantSlots.get(slotKey);
          const secondSlotEmpty = isTitan ? !this.plantSlots.get(secondSlotKey) : true;

          if (slotEmpty && secondSlotEmpty) {
            // Calculate old slot positions
            // For titans, the mesh position is between the two slots, so we need to calculate the actual slots
            const oldGridX = Math.round(this.glovePlant.position.x / 2) * 2;
            const oldGridZ = Math.round(this.glovePlant.position.z / 2) * 2;

            if (isTitan) {
              // Titan occupies two slots - the position is between them
              // Find the left slot and right slot from titan's centered position
              const titanPosX = this.glovePlant.position.x;
              const titanPosZ = this.glovePlant.position.z;
              // Titan is at position like (1, -4) which is between slots (0, -4) and (2, -4)
              const leftSlotX = Math.round(titanPosX - 1);
              const rightSlotX = Math.round(titanPosX + 1);
              const slotZ = Math.round(titanPosZ / 2) * 2;

              const oldLeftKey = `${leftSlotX},${slotZ}`;
              const oldRightKey = `${rightSlotX},${slotZ}`;

              // Free both old slots
              this.plantSlots.set(oldLeftKey, false);
              this.plantSlots.set(oldRightKey, false);
              this.showSlotIndicator(leftSlotX, slotZ);
              this.showSlotIndicator(rightSlotX, slotZ);
              console.log(`Freed titan slots: ${oldLeftKey} and ${oldRightKey}`);
            } else {
              // Regular plant - free single slot
              const oldSlotKey = `${oldGridX},${oldGridZ}`;
              this.plantSlots.set(oldSlotKey, false);
              this.showSlotIndicator(oldGridX, oldGridZ);
            }

            // Move plant to new position
            if (isTitan) {
              // Position titan between the two slots
              const titanX = gridX + 1; // Center between gridX and gridX+2
              this.glovePlant.position.set(titanX, 0.5, gridZ);
              this.glovePlant.mesh.position.set(titanX, 0.5, gridZ);

              // Mark both new slots as occupied
              this.plantSlots.set(slotKey, true);
              this.plantSlots.set(secondSlotKey, true);
              this.hideSlotIndicator(gridX, gridZ);
              this.hideSlotIndicator(gridX + 2, gridZ);
            } else {
              this.glovePlant.position.set(gridX, 0.5, gridZ);
              this.glovePlant.mesh.position.set(gridX, 0.5, gridZ);

              // Mark new slot as occupied
              this.plantSlots.set(slotKey, true);
              this.hideSlotIndicator(gridX, gridZ);
            }

            // Reset picked plant visual state
            this.resetGlovePlantVisual(this.glovePlant);

            console.log(`🧤 Moved ${this.glovePlant.type} to new position!`);
          } else {
            console.log('🧤 Slot already occupied!');
          }
        }

        // Reset glove mode
        if (this.glovePlant) {
          this.resetGlovePlantVisual(this.glovePlant);
        }
        this.glovePlant = null;
        this.gloveMode = false;
        const container = document.getElementById('canvas-container');
        if (container) container.style.cursor = 'default';
        const gloveIndicator = document.getElementById('glove-indicator');
        if (gloveIndicator) {
          gloveIndicator.classList.remove('active');
          gloveIndicator.classList.remove('holding');
        }
        const gloveBtn = document.getElementById('glove-btn');
        if (gloveBtn) gloveBtn.classList.remove('active');
        this.clearGloveHighlights();
      }
      return;
    }

    // Plant placement - blocked in certain modes
    if (this.isShooterMode) {
      // Shooter mode doesn't allow planting - only shooting
      return;
    }

    if (this.isWhackMode) {
      // Whack mode doesn't allow planting - only smashing zombies with shovel
      return;
    }

    if (!this.currentPlantType) return;

    const intersects = this.raycaster.intersectObject(this.lawnPlane);
    if (intersects.length > 0) {
      const point = intersects[0].point;

      // Place the plant (all plants are placeable for fusion purposes)
      this.placePlant(this.currentPlantType, point);
    }
  }

  private removePlant(plant: Plant): void {
    // Remove plant from scene
    this.scene.remove(plant.mesh);

    // Remove from placed plants array
    this.placedPlants = this.placedPlants.filter(p => p !== plant);

    // Free up the slot(s)
    if (plant.isTitan) {
      // Titan plants occupy two slots - position is between them
      // Titan is at position like (1, -4) which is between slots (0, -4) and (2, -4)
      const leftSlotX = Math.round(plant.position.x - 1);
      const rightSlotX = Math.round(plant.position.x + 1);
      const slotZ = Math.round(plant.position.z / 2) * 2;

      const leftKey = `${leftSlotX},${slotZ}`;
      const rightKey = `${rightSlotX},${slotZ}`;

      this.plantSlots.set(leftKey, false);
      this.plantSlots.set(rightKey, false);
      this.showSlotIndicator(leftSlotX, slotZ);
      this.showSlotIndicator(rightSlotX, slotZ);
      console.log(`Freed titan slots: ${leftKey} and ${rightKey}`);
    } else {
      // Regular plant - free single slot
      const slotKey = `${plant.position.x},${plant.position.z}`;
      this.plantSlots.set(slotKey, false);
      this.showSlotIndicator(plant.position.x, plant.position.z);
    }

    console.log(`Removed ${plant.type} with shovel!`);
  }

  private onRightClick(event: MouseEvent): void {
    // Alternative way to trigger pear cannon
    this.onMouseClick(event);
  }

  private firePearCannon(plant: Plant): void {
    const nearestZombie = this.findNearestZombie(plant.position);
    if (nearestZombie) {
      // Create pear projectile with glow
      const pearGroup = new THREE.Group();

      // Main pear body
      const pearGeo = new THREE.SphereGeometry(0.3, 16, 16);
      const pearMat = new THREE.MeshPhongMaterial({
        color: 0xd4af37,
        shininess: 100,
        emissive: 0xffaa00,
        emissiveIntensity: 0.3
      });
      const pear = new THREE.Mesh(pearGeo, pearMat);
      pearGroup.add(pear);

      // Glow effect
      const glowGeo = new THREE.SphereGeometry(0.4, 16, 16);
      const glowMat = new THREE.MeshBasicMaterial({
        color: 0xffff00,
        transparent: true,
        opacity: 0.4
      });
      const glow = new THREE.Mesh(glowGeo, glowMat);
      pearGroup.add(glow);

      // Trailing particles
      const trailGeo = new THREE.SphereGeometry(0.15, 8, 8);
      const trailMat = new THREE.MeshBasicMaterial({
        color: 0xffd700,
        transparent: true,
        opacity: 0.6
      });
      const trail = new THREE.Mesh(trailGeo, trailMat);
      trail.position.set(-0.2, 0, 0);
      pearGroup.add(trail);

      // Position at cannon barrel
      pearGroup.position.copy(plant.position);
      pearGroup.position.y = 1.5;
      this.scene.add(pearGroup);

      // Calculate direction to zombie (use actual current position)
      const direction = new THREE.Vector3()
        .subVectors(nearestZombie.position, pearGroup.position)
        .normalize();
      const velocity = direction.multiplyScalar(22); // Standard projectile speed

      // Create muzzle flash
      this.createMuzzleFlash(plant.position);

      const projectile = new Projectile(
        pearGroup as unknown as THREE.Mesh,
        pearGroup.position,
        velocity,
        450, // 450 damage (1.5x)
        false
      );
      this.projectiles.push(projectile);

      plant.cooldown = 10; // 10 second cooldown
      console.log('Pear cannon fired at zombie!');
    }
  }

  private fireStarLauncher(plant: Plant): void {
    // Costs 300 sun per use
    this.sun -= 300;
    const sunAmount = document.getElementById('sun-amount');
    if (sunAmount) {
      sunAmount.textContent = this.sun.toString();
    }
    this.updatePlantSlots();

    // Fire 10 stars in different directions
    for (let i = 0; i < 10; i++) {
      const angle = (Math.PI * 2 * i) / 10; // Distribute evenly in a circle

      // Create star projectile
      const starGroup = new THREE.Group();

      // Star shape (simplified as a glowing sphere with points)
      const starGeo = new THREE.SphereGeometry(0.25, 8, 8);
      const starMat = new THREE.MeshPhongMaterial({
        color: 0xffff00,
        emissive: 0xffff00,
        emissiveIntensity: 1.0,
        shininess: 100
      });
      const star = new THREE.Mesh(starGeo, starMat);
      starGroup.add(star);

      // Glow effect
      const glowGeo = new THREE.SphereGeometry(0.35, 8, 8);
      const glowMat = new THREE.MeshBasicMaterial({
        color: 0xffff00,
        transparent: true,
        opacity: 0.6
      });
      const glow = new THREE.Mesh(glowGeo, glowMat);
      starGroup.add(glow);

      // Position at plant
      starGroup.position.copy(plant.position);
      starGroup.position.y = 1.5;
      this.scene.add(starGroup);

      // Calculate velocity in the direction of this star
      const velocity = new THREE.Vector3(
        Math.cos(angle) * 12,
        0,
        Math.sin(angle) * 12
      );

      const projectile = new Projectile(
        starGroup as unknown as THREE.Mesh,
        starGroup.position,
        velocity,
        150, // 150 damage per star (1.5x)
        false
      );
      this.projectiles.push(projectile);
    }

    plant.cooldown = 12; // Long cooldown (12 seconds)
    console.log('Star Launcher fired 10 stars in all directions!');
  }

  private firePearSpiker(plant: Plant): void {
    const nearestZombie = this.findNearestZombie(plant.position);
    if (nearestZombie) {
      // Create spike projectile
      const spikeGroup = new THREE.Group();

      // Main spike (elongated cone)
      const spikeGeo = new THREE.ConeGeometry(0.2, 0.8, 8);
      const spikeMat = new THREE.MeshPhongMaterial({
        color: 0xff0000,
        emissive: 0xff0000,
        emissiveIntensity: 0.5,
        shininess: 100
      });
      const spike = new THREE.Mesh(spikeGeo, spikeMat);
      spike.rotation.z = -Math.PI / 2; // Point horizontally
      spikeGroup.add(spike);

      // Glow effect
      const glowGeo = new THREE.SphereGeometry(0.3, 8, 8);
      const glowMat = new THREE.MeshBasicMaterial({
        color: 0xff0000,
        transparent: true,
        opacity: 0.5
      });
      const glow = new THREE.Mesh(glowGeo, glowMat);
      spikeGroup.add(glow);

      // Position at plant
      spikeGroup.position.copy(plant.position);
      spikeGroup.position.y = 1.5;
      this.scene.add(spikeGroup);

      // Calculate direction to zombie
      const direction = new THREE.Vector3()
        .subVectors(nearestZombie.position, spikeGroup.position)
        .normalize();
      const velocity = direction.multiplyScalar(22); // Standard projectile speed

      // Rotate spike to face target
      const angle = Math.atan2(direction.z, direction.x);
      spikeGroup.rotation.y = angle;

      const projectile = new Projectile(
        spikeGroup as unknown as THREE.Mesh,
        spikeGroup.position,
        velocity,
        750, // 750 damage (1.5x)
        false
      );
      this.projectiles.push(projectile);

      plant.cooldown = 15; // Very long cooldown (15 seconds)
      console.log('Pear Spiker fired high-damage spike at nearest zombie!');
    }
  }

  private createMuzzleFlash(position: THREE.Vector3): void {
    // EPIC multi-layered muzzle flash with fire effects

    // Inner white-hot core
    const coreGeo = new THREE.SphereGeometry(0.3, 16, 16);
    const coreMat = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      opacity: 1.0
    });
    const core = new THREE.Mesh(coreGeo, coreMat);
    core.position.copy(position);
    core.position.y = 1.5;
    core.position.x += 0.3;
    this.scene.add(core);

    // Yellow flash layer
    const flashGeo = new THREE.SphereGeometry(0.6, 16, 16);
    const flashMat = new THREE.MeshBasicMaterial({
      color: 0xffff00,
      transparent: true,
      opacity: 0.9
    });
    const flash = new THREE.Mesh(flashGeo, flashMat);
    flash.position.copy(core.position);
    this.scene.add(flash);

    // Orange outer layer
    const outerGeo = new THREE.SphereGeometry(0.85, 16, 16);
    const outerMat = new THREE.MeshBasicMaterial({
      color: 0xff8800,
      transparent: true,
      opacity: 0.7
    });
    const outer = new THREE.Mesh(outerGeo, outerMat);
    outer.position.copy(core.position);
    this.scene.add(outer);

    // Fire streaks shooting outward
    const streaks: THREE.Mesh[] = [];
    for (let i = 0; i < 6; i++) {
      const streakGeo = new THREE.ConeGeometry(0.08, 0.5, 6);
      const streakMat = new THREE.MeshBasicMaterial({
        color: i % 2 === 0 ? 0xffff00 : 0xff6600,
        transparent: true,
        opacity: 0.9
      });
      const streak = new THREE.Mesh(streakGeo, streakMat);
      streak.position.copy(core.position);
      const angle = (i / 6) * Math.PI * 0.8 - Math.PI * 0.4;
      streak.rotation.z = -Math.PI / 2 + angle;
      streak.userData.speed = 0.15 + Math.random() * 0.1;
      streak.userData.angle = angle;
      this.scene.add(streak);
      streaks.push(streak);
    }

    // Spark particles
    const sparks: THREE.Mesh[] = [];
    for (let i = 0; i < 10; i++) {
      const sparkGeo = new THREE.SphereGeometry(0.04, 6, 6);
      const sparkMat = new THREE.MeshBasicMaterial({
        color: 0xffff88,
        transparent: true,
        opacity: 1.0
      });
      const spark = new THREE.Mesh(sparkGeo, sparkMat);
      spark.position.copy(core.position);
      spark.userData.velocity = new THREE.Vector3(
        2 + Math.random() * 4,
        (Math.random() - 0.5) * 3,
        (Math.random() - 0.5) * 3
      );
      this.scene.add(spark);
      sparks.push(spark);
    }

    // Animate flash
    let coreOpacity = 1.0;
    let flashOpacity = 0.9;
    let outerOpacity = 0.7;
    let frame = 0;

    const flashInterval = setInterval(() => {
      frame++;

      // Core shrinks fast
      coreOpacity -= 0.25;
      core.scale.multiplyScalar(0.8);
      if (coreMat instanceof THREE.MeshBasicMaterial) {
        coreMat.opacity = Math.max(0, coreOpacity);
      }

      // Flash fades
      flashOpacity -= 0.15;
      flash.scale.multiplyScalar(1.1);
      if (flashMat instanceof THREE.MeshBasicMaterial) {
        flashMat.opacity = Math.max(0, flashOpacity);
      }

      // Outer expands and fades
      outerOpacity -= 0.12;
      outer.scale.multiplyScalar(1.15);
      if (outerMat instanceof THREE.MeshBasicMaterial) {
        outerMat.opacity = Math.max(0, outerOpacity);
      }

      // Move streaks outward
      streaks.forEach(streak => {
        streak.position.x += streak.userData.speed;
        streak.position.y += Math.sin(streak.userData.angle) * streak.userData.speed * 0.5;
        const mat = streak.material as THREE.MeshBasicMaterial;
        mat.opacity -= 0.15;
        streak.scale.x *= 0.9;
      });

      // Move sparks
      sparks.forEach(spark => {
        spark.position.add(spark.userData.velocity.clone().multiplyScalar(0.05));
        spark.userData.velocity.y -= 0.15;
        const mat = spark.material as THREE.MeshBasicMaterial;
        mat.opacity -= 0.12;
      });

      if (frame >= 8) {
        this.scene.remove(core);
        this.scene.remove(flash);
        this.scene.remove(outer);
        streaks.forEach(s => this.scene.remove(s));
        sparks.forEach(s => this.scene.remove(s));
        clearInterval(flashInterval);
      }
    }, 40);
  }

  private triggerShootAnimation(position: THREE.Vector3, type: string): void {
    // Find the plant at this position
    const plant = this.placedPlants.find(p =>
      Math.abs(p.position.x - position.x) < 0.5 &&
      Math.abs(p.position.z - position.z) < 0.5
    );

    if (!plant) return;

    // Recoil animation - move plant back and then forward
    const originalY = plant.mesh.position.y;
    const originalRotation = plant.mesh.rotation.x;

    // Create muzzle flash particles based on type
    const flashColors: { [key: string]: number } = {
      'grape': 0xaa44ff,
      'frost': 0x88ddff,
      'strawberry': 0xff66aa,
      'sun': 0xffff00,
      'cannon': 0xff8800
    };
    const flashColor = flashColors[type] || 0xffffff;

    // Spawn muzzle flash particles
    for (let i = 0; i < 8; i++) {
      const particleGeo = new THREE.SphereGeometry(0.08 + Math.random() * 0.06, 8, 8);
      const particleMat = new THREE.MeshBasicMaterial({
        color: flashColor,
        transparent: true,
        opacity: 0.9
      });
      const particle = new THREE.Mesh(particleGeo, particleMat);
      particle.position.copy(position);
      particle.position.y = 1.2 + Math.random() * 0.3;
      particle.position.x += 0.3 + Math.random() * 0.3;
      particle.position.z += (Math.random() - 0.5) * 0.4;
      this.scene.add(particle);

      // Animate particle flying outward
      const vx = 2 + Math.random() * 3;
      const vy = (Math.random() - 0.5) * 2;
      const vz = (Math.random() - 0.5) * 2;
      let opacity = 0.9;
      let scale = 1;

      const particleInterval = setInterval(() => {
        particle.position.x += vx * 0.03;
        particle.position.y += vy * 0.03;
        particle.position.z += vz * 0.03;
        opacity -= 0.12;
        scale += 0.15;
        particle.scale.set(scale, scale, scale);
        if (particleMat instanceof THREE.MeshBasicMaterial) {
          particleMat.opacity = opacity;
        }
        if (opacity <= 0) {
          this.scene.remove(particle);
          clearInterval(particleInterval);
        }
      }, 30);
    }

    // Recoil animation
    let recoilPhase = 0;
    const recoilInterval = setInterval(() => {
      recoilPhase++;

      if (recoilPhase <= 3) {
        // Recoil back
        plant.mesh.position.x -= 0.08;
        plant.mesh.rotation.x = originalRotation - 0.1;
        plant.mesh.scale.set(1.1, 0.9, 1.1); // Squash
      } else if (recoilPhase <= 8) {
        // Return to position with bounce
        plant.mesh.position.x += 0.05;
        plant.mesh.rotation.x = originalRotation + 0.03 * (8 - recoilPhase);
        const t = (recoilPhase - 3) / 5;
        plant.mesh.scale.set(1 + 0.1 * (1 - t), 1 - 0.1 * (1 - t), 1 + 0.1 * (1 - t));
      } else {
        // Reset
        plant.mesh.rotation.x = originalRotation;
        plant.mesh.scale.set(1, 1, 1);
        clearInterval(recoilInterval);
      }
    }, 25);

    // Create smoke puff for cannon shots
    if (type === 'cannon' || type === 'grape') {
      for (let i = 0; i < 5; i++) {
        const smokeGeo = new THREE.SphereGeometry(0.15 + Math.random() * 0.1, 8, 8);
        const smokeMat = new THREE.MeshBasicMaterial({
          color: 0x888888,
          transparent: true,
          opacity: 0.5
        });
        const smoke = new THREE.Mesh(smokeGeo, smokeMat);
        smoke.position.copy(position);
        smoke.position.y = 1.3;
        smoke.position.x += 0.3;
        smoke.position.z += (Math.random() - 0.5) * 0.3;
        this.scene.add(smoke);

        let smokeOpacity = 0.5;
        let smokeScale = 1;
        const smokeInterval = setInterval(() => {
          smoke.position.y += 0.04;
          smoke.position.x += 0.02;
          smokeOpacity -= 0.05;
          smokeScale += 0.12;
          smoke.scale.set(smokeScale, smokeScale, smokeScale);
          if (smokeMat instanceof THREE.MeshBasicMaterial) {
            smokeMat.opacity = smokeOpacity;
          }
          if (smokeOpacity <= 0) {
            this.scene.remove(smoke);
            clearInterval(smokeInterval);
          }
        }, 40);
      }
    }
  }

  private findNearestZombie(position: THREE.Vector3): Zombie | null {
    let nearest: Zombie | null = null;
    let minDistance = Infinity;

    for (const zombie of this.zombies) {
      const distance = zombie.position.distanceTo(position);
      if (distance < minDistance) {
        minDistance = distance;
        nearest = zombie;
      }
    }

    return nearest;
  }

  private useFrostBerri(position: THREE.Vector3): void {
    const info = PLANT_INFO['frost-berri'];

    // Check cooldown
    const cooldown = this.instantPlantCooldowns.get('frost-berri') || 0;
    if (cooldown > 0) {
      console.log(`Frost Berri on cooldown! ${cooldown.toFixed(1)}s remaining`);
      return;
    }

    // Check if we have enough sun
    if (this.sun < info.cost) {
      console.log('Not enough sun!');
      return;
    }

    // Set cooldown
    this.instantPlantCooldowns.set('frost-berri', this.INSTANT_PLANT_COOLDOWN);

    // Deduct sun
    this.sun -= info.cost;
    const sunAmount = document.getElementById('sun-amount');
    if (sunAmount) {
      sunAmount.textContent = this.sun.toString();
    }
    this.updatePlantSlots();

    // Snap to grid
    const gridX = Math.round(position.x / 2) * 2;
    const gridZ = Math.round(position.z / 2) * 2;

    // Create frost explosion effect
    const frostGeo = new THREE.SphereGeometry(3, 16, 16);
    const frostMat = new THREE.MeshBasicMaterial({
      color: 0x87ceeb,
      transparent: true,
      opacity: 0.6
    });
    const frostMesh = new THREE.Mesh(frostGeo, frostMat);
    frostMesh.position.set(gridX, 1, gridZ);
    this.scene.add(frostMesh);

    // Deal damage and freeze in 3x3 area (6 units radius)
    const center = new THREE.Vector3(gridX, 0, gridZ);
    for (const zombie of this.zombies) {
      const distance = zombie.position.distanceTo(center);
      if (distance <= 6) {
        zombie.health -= 50;
        // Only freeze if not immune and not already frozen (prevents stacking)
        if (!zombie.isFreezeImmune && zombie.freezeImmunityTimer <= 0 && !zombie.frozen) {
          zombie.frozen = true;
          zombie.frozenTimer = 3; // Freeze for 3 seconds

          // Change all zombie parts to icy blue
          zombie.mesh.children.forEach(child => {
            if (child instanceof THREE.Mesh) {
              if (child.material instanceof THREE.MeshPhongMaterial) {
                child.material = new THREE.MeshPhongMaterial({
                  color: 0x87ceeb,
                  emissive: child.material.emissive,
                  emissiveIntensity: child.material.emissiveIntensity
                });
              }
            }
          });
        }
      }
    }

    // Remove explosion effect after animation
    setTimeout(() => {
      this.scene.remove(frostMesh);
    }, 500);

    // Deselect plant
    this.currentPlantType = null;
    document.querySelectorAll('.plant-slot').forEach(slot => {
      slot.classList.remove('selected');
    });
    this.updateSelectedPlantIndicator();

    console.log('Frost Berri used!');
  }

  private useTomatoSpike(position: THREE.Vector3): void {
    const info = PLANT_INFO['tomato-spike'];

    // Check cooldown
    const cooldown = this.instantPlantCooldowns.get('tomato-spike') || 0;
    if (cooldown > 0) {
      console.log(`Tomato Spike on cooldown! ${cooldown.toFixed(1)}s remaining`);
      return;
    }

    // Check if we have enough sun
    if (this.sun < info.cost) {
      console.log('Not enough sun!');
      return;
    }

    // Set cooldown
    this.instantPlantCooldowns.set('tomato-spike', this.INSTANT_PLANT_COOLDOWN);

    // Deduct sun
    this.sun -= info.cost;
    const sunAmount = document.getElementById('sun-amount');
    if (sunAmount) {
      sunAmount.textContent = this.sun.toString();
    }
    this.updatePlantSlots();

    // Snap to grid
    const gridX = Math.round(position.x / 2) * 2;
    const gridZ = Math.round(position.z / 2) * 2;

    // Create spike explosion effect
    const spikeGeo = new THREE.SphereGeometry(2.5, 16, 16);
    const spikeMat = new THREE.MeshBasicMaterial({
      color: 0xff0000,
      transparent: true,
      opacity: 0.7
    });
    const spikeMesh = new THREE.Mesh(spikeGeo, spikeMat);
    spikeMesh.position.set(gridX, 1, gridZ);
    this.scene.add(spikeMesh);

    // Create spike particles
    for (let i = 0; i < 20; i++) {
      const particleGeo = new THREE.ConeGeometry(0.1, 0.5, 8);
      const particleMat = new THREE.MeshBasicMaterial({ color: 0x333333 });
      const particle = new THREE.Mesh(particleGeo, particleMat);
      const angle = (i / 20) * Math.PI * 2;
      particle.position.set(
        gridX + Math.cos(angle) * 2,
        1 + Math.random(),
        gridZ + Math.sin(angle) * 2
      );
      particle.rotation.z = Math.PI / 2;
      particle.rotation.y = angle;
      this.scene.add(particle);

      // Remove particle after animation
      setTimeout(() => {
        this.scene.remove(particle);
      }, 600);
    }

    // Deal high damage in 2.5x2.5 area (5 units radius)
    const center = new THREE.Vector3(gridX, 0, gridZ);
    let hitCount = 0;
    for (const zombie of this.zombies) {
      const distance = zombie.position.distanceTo(center);
      if (distance <= 5) {
        zombie.health -= 80; // High damage!
        hitCount++;
      }
    }

    // Animate explosion effect
    let scale = 1;
    let opacity = 0.7;
    const explosionInterval = setInterval(() => {
      scale += 0.3;
      opacity -= 0.12;
      spikeMesh.scale.set(scale, scale, scale);
      if (spikeMat instanceof THREE.MeshBasicMaterial) {
        spikeMat.opacity = opacity;
      }
      if (opacity <= 0) {
        this.scene.remove(spikeMesh);
        clearInterval(explosionInterval);
      }
    }, 50);

    // Deselect plant
    this.currentPlantType = null;
    document.querySelectorAll('.plant-slot').forEach(slot => {
      slot.classList.remove('selected');
    });
    this.updateSelectedPlantIndicator();

    console.log(`Tomato Spike hit ${hitCount} zombies!`);
  }

  private placePlant(plantType: PlantType, position: THREE.Vector3): void {
    const info = PLANT_INFO[plantType];

    // Conveyor mode - no sun cost, remove from conveyor instead
    if (this.isConveyorMode) {
      if (this.currentConveyorIndex >= 0 && this.currentConveyorIndex < this.conveyorPlants.length) {
        // Remove plant from conveyor
        this.conveyorPlants.splice(this.currentConveyorIndex, 1);
        this.currentConveyorIndex = -1;
        this.updateConveyorUI();
      } else {
        console.log('Select a plant from the conveyor first!');
        return;
      }
    } else {
      // Normal mode - check if we have enough sun
      if (this.sun < info.cost) {
        console.log('Not enough sun!');
        return;
      }
    }

    // Snap to grid (2x2 slots)
    const gridX = Math.round(position.x / 2) * 2;
    const gridZ = Math.round(position.z / 2) * 2;

    // BLACK HOLE COCONUT - Special instant bomb, can be placed ANYWHERE on the lawn!
    if (plantType === 'black-hole-coconut') {
      // Check cooldown
      const cooldown = this.instantPlantCooldowns.get('black-hole-coconut') || 0;
      if (cooldown > 0) {
        console.log(`Black Hole Coconut on cooldown! ${cooldown.toFixed(1)}s remaining`);
        return;
      }

      // Just need to be on the lawn area (X: -10 to 12, Z: -10 to 2)
      if (gridX < -10 || gridX > 12 || gridZ < -10 || gridZ > 2) {
        console.log('Must place on the lawn!');
        return;
      }

      // Set cooldown
      this.instantPlantCooldowns.set('black-hole-coconut', this.INSTANT_PLANT_COOLDOWN);

      // Deduct sun (not in conveyor mode)
      if (!this.isConveyorMode) {
        this.sun -= info.cost;
        const sunAmount = document.getElementById('sun-amount');
        if (sunAmount) {
          sunAmount.textContent = this.sun.toString();
        }
        this.updatePlantSlots();
      }

      // Create the black hole mesh at click position (no slot needed!)
      const plantMesh = this.createPlantMesh('black-hole-coconut');
      plantMesh.position.set(gridX, 0.5, gridZ);
      this.scene.add(plantMesh);

      // Create plant object with timer (no slot occupation)
      const plant = new Plant(plantMesh, 'black-hole-coconut', new THREE.Vector3(gridX, 0.5, gridZ));
      plant.cooldown = 1; // Will trigger after 1 second
      this.placedPlants.push(plant);

      console.log('🕳️🥥 Black Hole Coconut deployed! Activating in 1 second...');

      // Deselect plant
      this.currentPlantType = null;
      document.querySelectorAll('.plant-slot').forEach(slot => {
        slot.classList.remove('selected');
      });
      this.updateSelectedPlantIndicator();

      return;
    }

    // Create slot key
    const slotKey = `${gridX},${gridZ}`;

    // Check if this is a valid slot
    if (!this.plantSlots.has(slotKey)) {
      console.log('Not a valid planting slot!');
      return;
    }

    // Check if slot is already occupied - if so, check for fusion!
    if (this.plantSlots.get(slotKey)) {
      // Find the plant at this location (also check for titans at adjacent tiles)
      const titanTypes: PlantType[] = ['strawbomber', 'frovine-slammer', 'pear-nuker'];
      let existingPlant = this.placedPlants.find(p =>
        p.position.x === gridX && p.position.z === gridZ
      );

      // If no plant found, check for titans at adjacent X positions (titans are 2 tiles wide)
      if (!existingPlant) {
        existingPlant = this.placedPlants.find(p =>
          titanTypes.includes(p.type) &&
          p.position.z === gridZ &&
          Math.abs(p.position.x - gridX) <= 1
        );
      }

      if (existingPlant) {
        // Check for Titan Fusion if placing seed-batch
        if (plantType === 'seed-batch') {
          // Check cooldown for seed-batch
          const cooldown = this.instantPlantCooldowns.get('seed-batch') || 0;
          if (cooldown > 0) {
            console.log(`Seed Batch on cooldown! ${cooldown.toFixed(1)}s remaining`);
            return;
          }

          console.log('Checking Titan Fusion with Seed Batch...');
          const titanResult = this.checkTitanFusion(gridX, gridZ, existingPlant);
          if (titanResult) {
            // Set cooldown
            this.instantPlantCooldowns.set('seed-batch', this.INSTANT_PLANT_COOLDOWN);

            // Deduct sun for seed batch (not in conveyor mode)
            if (!this.isConveyorMode) {
              this.sun -= info.cost;
              const sunAmount = document.getElementById('sun-amount');
              if (sunAmount) {
                sunAmount.textContent = this.sun.toString();
              }
            }

            this.currentPlantType = null;
            document.querySelectorAll('.plant-slot').forEach(slot => {
              slot.classList.remove('selected');
            });
            return;
          } else {
            console.log('No valid Titan Fusion pattern found!');
            return;
          }
        }

        // PINEAPPLE CRATE - Can be placed ON existing plants as a bunker!
        // When Shift is held, skip bunker placement and try fusion instead
        if (plantType === 'pineapple-crate' && !this.shiftHeld) {
          // Check if plant already has a pineapple bunker
          if (existingPlant.pineappleBunker) {
            console.log('This plant already has a Pineapple Crate bunker!');
            return;
          }

          // Don't allow placing on another pineapple-crate
          if (existingPlant.type === 'pineapple-crate') {
            console.log('Cannot stack Pineapple Crates!');
            return;
          }

          // Deduct sun (not in conveyor mode)
          if (!this.isConveyorMode) {
            this.sun -= info.cost;
            const sunAmount = document.getElementById('sun-amount');
            if (sunAmount) {
              sunAmount.textContent = this.sun.toString();
            }
            this.updatePlantSlots();
          }

          // Create the pineapple bunker mesh (now 1.5x bigger)
          const pineappleMesh = this.createPlantMesh('pineapple-crate');
          pineappleMesh.position.set(gridX, 0, gridZ);
          // Raise it slightly above the plant
          pineappleMesh.position.y = 0.2;
          this.scene.add(pineappleMesh);

          // Attach bunker to the existing plant
          existingPlant.pineappleBunker = {
            health: 800,
            maxHealth: 800,
            mesh: pineappleMesh
          };

          console.log(`🍍📦 Pineapple Crate placed on ${existingPlant.type}! Bunker HP: 800`);

          // Deselect plant
          this.currentPlantType = null;
          document.querySelectorAll('.plant-slot').forEach(slot => {
            slot.classList.remove('selected');
          });
          this.updateSelectedPlantIndicator();

          return;
        }

        // Check for fusion recipe
        // When Shift is held and plant has a bunker, fuse with the bunker (pineapple-crate) instead
        const fuseType = (this.shiftHeld && existingPlant.pineappleBunker) ? 'pineapple-crate' as PlantType : existingPlant.type;
        console.log(`Checking fusion: ${plantType} + ${fuseType}${this.shiftHeld && existingPlant.pineappleBunker ? ' (bunker fusion via Shift)' : ''}`);
        const recipe = FUSION_RECIPES.find(r =>
          (r.plant1 === plantType && r.plant2 === fuseType) ||
          (r.plant1 === fuseType && r.plant2 === plantType)
        );

        if (recipe) {
          console.log(`Found recipe: ${recipe.plant1} + ${recipe.plant2} = ${recipe.result}`);

          // Check if frost-grape-gun fusion is locked
          if (recipe.result === 'frost-grape-gun' && !this.frostGrapeGunUnlocked) {
            console.log('❌ Frost Grape Gun fusion is locked! Purchase from Odd Shop first.');
            alert('🔒 Frost Grape Gun fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
            return;
          }

          // Check if straw-spiker fusion is locked
          if (recipe.result === 'straw-spiker' && !this.strawSpikerUnlocked) {
            console.log('❌ StrawSpiker fusion is locked! Purchase from Odd Shop first.');
            alert('🔒 StrawSpiker fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
            return;
          }

          // Check if reaper-wall fusion is locked
          if (recipe.result === 'reaper-peall' && !this.reaperWallUnlocked) {
            console.log('❌ Reaper Peall fusion is locked! Purchase from Odd Shop first.');
            alert('🔒 Reaper Peall fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
            return;
          }

          // Check if 2nd form odd fusions are locked
          if (recipe.result === 'frost-overlord-grape-gun' && !this.frostOverlordGrapeGunUnlocked) {
            console.log('❌ Frost Overlord Grape Gun fusion is locked! Purchase from Odd Shop first.');
            alert('🔒 Frost Overlord Grape Gun fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
            return;
          }
          if (recipe.result === 'thornbomber' && !this.thornbomberUnlocked) {
            console.log('❌ ThornBomber fusion is locked! Purchase from Odd Shop first.');
            alert('🔒 ThornBomber fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
            return;
          }
          if (recipe.result === 'titan-reaper-peall' && !this.titanReaperPeallUnlocked) {
            console.log('❌ Titan Reaper Peall fusion is locked! Purchase from Odd Shop first.');
            alert('🔒 Titan Reaper Peall fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
            return;
          }
          if (recipe.result === 'frozen-nebula-mushroom' && !this.frozenNebulaMushroomUnlocked) {
            console.log('❌ Frozen Nebula Mushroom fusion is locked! Purchase from Odd Shop first.');
            alert('🔒 Frozen Nebula Mushroom fusion is LOCKED!\n\nPurchase the unlock from the Odd Fusions Shop to use this fusion recipe.');
            return;
          }

          // Deduct sun for the new plant (not in conveyor mode)
          if (!this.isConveyorMode) {
            this.sun -= info.cost;
            const sunAmount = document.getElementById('sun-amount');
            if (sunAmount) {
              sunAmount.textContent = this.sun.toString();
            }
          }

          // Award 20 mastery points if frost-berri is used in fusion
          if (plantType === 'frost-berri' || existingPlant.type === 'frost-berri') {
            this.frostBerriMasteryPoints += 20;
            this.updateMasteryDisplay();
            console.log(`Frost Berri used in fusion! +20 mastery points. Total: ${this.frostBerriMasteryPoints}`);
          }

          // Award 20 mastery points if tomato-spike is used in fusion
          if (plantType === 'tomato-spike' || existingPlant.type === 'tomato-spike') {
            this.tomatoSpikeMasteryPoints += 20;
            this.updateMasteryDisplay();
            console.log(`Tomato Spike used in fusion! +20 mastery points. Total: ${this.tomatoSpikeMasteryPoints}`);
          }

          // Perform fusion!
          const isBunkerFusion = !!(this.shiftHeld && existingPlant.pineappleBunker && fuseType === 'pineapple-crate');
          this.performFusionOnPlace(existingPlant, recipe.result, gridX, gridZ, isBunkerFusion);

          // Deselect plant and clear indicator
          this.currentPlantType = null;
          document.querySelectorAll('.plant-slot').forEach(slot => {
            slot.classList.remove('selected');
          });
          this.updateSelectedPlantIndicator(); // Clear the "Placing:" indicator

          return;
        } else {
          console.log(`Cannot fuse ${plantType} with ${existingPlant.type}!`);
          return;
        }
      } else {
        console.log('Slot already occupied!');
        return;
      }
    }

    // Handle delayed-use plants (frost-berri, elder-frost-berri, tomato-spike) - now last 1 second before triggering
    // Note: black-hole-coconut is handled separately above (doesn't need a slot)
    if (plantType === 'frost-berri' || plantType === 'elder-frost-berri' || plantType === 'tomato-spike' || plantType === 'elder-tomato-spike') {
      // Check for fusion with black-hole-coconut (which doesn't occupy a slot)
      const blackHoleAtPos = this.placedPlants.find(p =>
        p.type === 'black-hole-coconut' &&
        Math.abs(p.position.x - gridX) < 1 && Math.abs(p.position.z - gridZ) < 1
      );
      if (blackHoleAtPos && plantType === 'frost-berri') {
        // Fuse into frozen-supernova-coconut
        this.scene.remove(blackHoleAtPos.mesh);
        this.placedPlants = this.placedPlants.filter(p => p !== blackHoleAtPos);
        const fusedMesh = this.createPlantMesh('frozen-supernova-coconut');
        fusedMesh.position.set(gridX, 0.5, gridZ);
        this.scene.add(fusedMesh);
        const fusedPlant = new Plant(fusedMesh, 'frozen-supernova-coconut', new THREE.Vector3(gridX, 0.5, gridZ));
        this.placedPlants.push(fusedPlant);
        console.log('Fusion! Frost Berri + Black Hole Coconut = Frozen Supernova Coconut!');
        this.currentPlantType = null;
        document.querySelectorAll('.plant-slot').forEach(slot => slot.classList.remove('selected'));
        this.updateSelectedPlantIndicator();
        return;
      }

      // Check cooldown for instant plants
      const cooldown = this.instantPlantCooldowns.get(plantType) || 0;
      if (cooldown > 0) {
        console.log(`${PLANT_INFO[plantType].name} on cooldown! ${cooldown.toFixed(1)}s remaining`);
        return;
      }

      // Set cooldown
      this.instantPlantCooldowns.set(plantType, this.INSTANT_PLANT_COOLDOWN);

      // Deduct sun (not in conveyor mode)
      if (!this.isConveyorMode) {
        this.sun -= info.cost;
        const sunAmount = document.getElementById('sun-amount');
        if (sunAmount) {
          sunAmount.textContent = this.sun.toString();
        }
        this.updatePlantSlots();
      }

      // Create the plant mesh
      const plantMesh = this.createPlantMesh(plantType);
      plantMesh.position.set(gridX, 0.5, gridZ);
      // All plants face right towards zombie spawn (+X direction)
      // No rotation needed - default facing is +X
      this.scene.add(plantMesh);

      // Create plant object with timer
      const plant = new Plant(plantMesh, plantType, new THREE.Vector3(gridX, 0.5, gridZ));
      plant.cooldown = 1; // Will trigger after 1 second
      this.placedPlants.push(plant);

      // Mark slot as occupied temporarily
      const slotKey = `${gridX},${gridZ}`;
      this.plantSlots.set(slotKey, true);
      this.hideSlotIndicator(gridX, gridZ);

      console.log(`${plantType} planted! Will activate in 1 second...`);

      // Deselect plant
      this.currentPlantType = null;
      document.querySelectorAll('.plant-slot').forEach(slot => {
        slot.classList.remove('selected');
      });

      return;
    }

    // PINEAPPLE CRATE - Cannot be placed on empty slots, must be placed on existing plant!
    if (plantType === 'pineapple-crate') {
      console.log('🍍 Pineapple Crate must be placed ON an existing plant to protect it!');
      return;
    }

    // Mark slot as occupied
    this.plantSlots.set(slotKey, true);

    // Hide the slot indicator at this position
    this.hideSlotIndicator(gridX, gridZ);

    // Create plant mesh based on type
    const plantMesh = this.createPlantMesh(plantType);
    plantMesh.position.set(gridX, 0.5, gridZ);

    // Apply rotation from preview
    plantMesh.rotation.y = this.plantPreviewRotation;

    this.scene.add(plantMesh);

    const plant = new Plant(plantMesh, plantType, new THREE.Vector3(gridX, 0.5, gridZ));
    this.placedPlants.push(plant);

    // Deduct sun (not in conveyor mode)
    if (!this.isConveyorMode) {
      this.sun -= info.cost;
      const sunAmount = document.getElementById('sun-amount');
      if (sunAmount) {
        sunAmount.textContent = this.sun.toString();
      }
    }

    // Update UI to show which plants are affordable
    this.updatePlantSlots();

    // Deselect plant
    this.currentPlantType = null;
    document.querySelectorAll('.plant-slot').forEach(slot => {
      slot.classList.remove('selected');
    });
    this.updateSelectedPlantIndicator();

    console.log(`Placed ${info.name} at (${gridX}, ${gridZ})`);
  }

  private performFusionOnPlace(existingPlant: Plant, resultType: PlantType, gridX: number, gridZ: number, bunkerFusion = false): void {
    if (bunkerFusion) {
      // Bunker fusion: only replace the bunker, keep the base plant alive
      if (existingPlant.pineappleBunker) {
        this.scene.remove(existingPlant.pineappleBunker.mesh);
      }
      // Create the fused result as the new bunker
      const newBunkerMesh = this.createPlantMesh(resultType);
      newBunkerMesh.position.set(gridX, 0.2, gridZ);
      this.scene.add(newBunkerMesh);
      existingPlant.pineappleBunker = {
        health: 1250,
        maxHealth: 1250,
        mesh: newBunkerMesh
      };
      console.log(`Bunker fusion successful! Bunker upgraded to ${PLANT_INFO[resultType].name}! Base plant preserved.`);
      return;
    }

    // Remove pineapple bunker mesh if present
    if (existingPlant.pineappleBunker) {
      this.scene.remove(existingPlant.pineappleBunker.mesh);
      existingPlant.pineappleBunker = null;
    }

    // Remove the existing plant
    this.scene.remove(existingPlant.mesh);
    this.placedPlants = this.placedPlants.filter(p => p !== existingPlant);

    // Create fused plant at the same position
    const fusedMesh = this.createPlantMesh(resultType);
    fusedMesh.position.set(gridX, 0.5, gridZ);
    // All plants face right towards zombie spawn (+X direction)
    // No rotation needed - default facing is +X
    this.scene.add(fusedMesh);

    const fusedPlant = new Plant(fusedMesh, resultType, new THREE.Vector3(gridX, 0.5, gridZ));
    this.placedPlants.push(fusedPlant);

    // Slot stays occupied
    console.log(`Fusion successful! Created ${PLANT_INFO[resultType].name} by fusing!`);
  }

  private checkTitanFusion(gridX: number, gridZ: number, middlePlant: Plant): boolean {
    // Check for left and right plants (they should be in the same row, 2 units apart)
    const leftX = gridX - 2;
    const rightX = gridX + 2;

    // Use approximate position matching to handle floating point precision issues
    const leftPlant = this.placedPlants.find(p =>
      Math.abs(p.position.x - leftX) < 0.5 && Math.abs(p.position.z - gridZ) < 0.5
    );
    const rightPlant = this.placedPlants.find(p =>
      Math.abs(p.position.x - rightX) < 0.5 && Math.abs(p.position.z - gridZ) < 0.5
    );

    if (!leftPlant || !rightPlant) {
      console.log('Missing left or right plant for Titan Fusion');
      console.log(`Looking for plants at leftX=${leftX}, rightX=${rightX}, gridZ=${gridZ}`);
      console.log(`Found plants:`, this.placedPlants.map(p => `${p.type} at (${p.position.x}, ${p.position.z})`));
      return false;
    }

    // Check if the pattern matches a Titan recipe
    const recipe = TITAN_FUSION_RECIPES.find(r =>
      r.left === leftPlant.type &&
      r.middle === middlePlant.type &&
      r.right === rightPlant.type
    );

    if (recipe) {
      console.log(`Found Titan recipe: ${recipe.left} + ${recipe.middle} + ${recipe.right} = ${recipe.result}`);
      this.performTitanFusion(leftPlant, middlePlant, rightPlant, recipe.result);
      return true;
    }

    return false;
  }

  private performTitanFusion(leftPlant: Plant, middlePlant: Plant, rightPlant: Plant, resultType: PlantType): void {
    // Remove all three plants
    this.scene.remove(leftPlant.mesh);
    this.scene.remove(middlePlant.mesh);
    this.scene.remove(rightPlant.mesh);
    this.placedPlants = this.placedPlants.filter(p =>
      p !== leftPlant && p !== middlePlant && p !== rightPlant
    );

    // Clear the three slots
    const leftKey = `${leftPlant.position.x},${leftPlant.position.z}`;
    const middleKey = `${middlePlant.position.x},${middlePlant.position.z}`;
    const rightKey = `${rightPlant.position.x},${rightPlant.position.z}`;
    this.plantSlots.delete(leftKey);
    this.plantSlots.delete(middleKey);
    this.plantSlots.delete(rightKey);

    // Create Titan plant between middle and right positions (spans 2 slots)
    const titanMesh = this.createPlantMesh(resultType);
    const titanX = (middlePlant.position.x + rightPlant.position.x) / 2;
    titanMesh.position.set(titanX, 0.5, middlePlant.position.z);
    // All plants face right towards zombie spawn (+X direction)
    // No rotation needed - default facing is +X
    titanMesh.scale.set(1.0, 1.0, 1.0); // Titan - meshes are already properly sized
    this.scene.add(titanMesh);

    const titanPlant = new Plant(titanMesh, resultType, new THREE.Vector3(titanX, 0.5, middlePlant.position.z));
    titanPlant.isTitan = true;
    this.placedPlants.push(titanPlant);

    // Mark middle and right slots as occupied (Titan takes 2 slots)
    this.plantSlots.set(middleKey, true);
    this.plantSlots.set(rightKey, true);

    console.log(`Titan Fusion successful! Created ${PLANT_INFO[resultType].name}!`);
  }

  private createPlantingSlots(): void {
    // Create a grid of planting slots
    const slotSize = 2;
    const rows = 5; // 5 rows
    const cols = 9; // 9 columns

    const startX = -8; // Start position
    const startZ = -8;

    const slotGeometry = new THREE.PlaneGeometry(slotSize * 0.9, slotSize * 0.9);
    const slotMaterial = new THREE.MeshBasicMaterial({
      color: 0x90ee90,
      transparent: true,
      opacity: 0.3,
      side: THREE.DoubleSide
    });

    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        const x = startX + col * slotSize;
        const z = startZ + row * slotSize;

        // Create visual slot indicator
        const slotMesh = new THREE.Mesh(slotGeometry, slotMaterial);
        slotMesh.rotation.x = -Math.PI / 2;
        slotMesh.position.set(x, 0.05, z);
        slotMesh.userData.slotX = x;
        slotMesh.userData.slotZ = z;
        this.scene.add(slotMesh);
        this.slotMeshes.push(slotMesh);

        // Register slot as available
        const slotKey = `${x},${z}`;
        this.plantSlots.set(slotKey, false);
      }
    }
  }

  private hideSlotIndicator(x: number, z: number): void {
    const slot = this.slotMeshes.find(
      mesh => mesh.userData.slotX === x && mesh.userData.slotZ === z
    );
    if (slot) {
      slot.visible = false;
    }
  }

  private resetGlovePlantVisual(plant: Plant): void {
    // Reset plant position and scale to normal
    plant.mesh.position.y = plant.position.y;
    plant.mesh.scale.set(1, 1, 1);

    // Restore original emissive values if we stored them
    if (plant.userData.originalEmissives && plant.userData.originalEmissives.length > 0) {
      for (const data of plant.userData.originalEmissives) {
        if (data.mesh && data.mesh.material) {
          const mat = data.mesh.material as THREE.MeshPhongMaterial;
          if (mat.emissive) {
            mat.emissive.setHex(data.color);
            mat.emissiveIntensity = data.intensity;
          }
        }
      }
      // Clear the stored data
      plant.userData.originalEmissives = [];
    } else {
      // Fallback: reset emissive glow to default (for plants that weren't properly tracked)
      plant.mesh.traverse((child) => {
        if (child instanceof THREE.Mesh && child.material) {
          const mat = child.material as THREE.MeshPhongMaterial;
          if (mat.emissive && mat.emissive.getHex() === 0x00ff88) {
            // Only reset if it's the green pickup glow
            mat.emissive.setHex(0x000000);
            mat.emissiveIntensity = 0;
          }
        }
      });
    }
  }

  private clearGloveHighlights(): void {
    // Remove all existing glove highlight meshes
    for (const mesh of this.gloveHighlightMeshes) {
      this.scene.remove(mesh);
      mesh.geometry.dispose();
      if (mesh.material instanceof THREE.Material) {
        mesh.material.dispose();
      }
    }
    this.gloveHighlightMeshes = [];
  }

  private updateGloveHighlights(): void {
    // Clear existing highlights first
    this.clearGloveHighlights();

    if (!this.gloveMode) return;

    const slotSize = 2;
    const rows = 5;
    const cols = 9;
    const startX = -8;
    const startZ = -8;

    // Create reusable geometries
    const highlightGeo = new THREE.PlaneGeometry(slotSize * 0.92, slotSize * 0.92);
    const borderGeo = new THREE.RingGeometry(slotSize * 0.42, slotSize * 0.48, 4);

    if (this.glovePlant === null) {
      // No plant held - show ALL tiles with subtle grid + highlight plants brightly

      // First, show subtle grid for ALL tiles
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
          const x = startX + col * slotSize;
          const z = startZ + row * slotSize;
          const slotKey = `${x},${z}`;
          const isOccupied = this.plantSlots.get(slotKey);

          if (!isOccupied) {
            // Empty slot - subtle white/gray grid
            const gridMat = new THREE.MeshBasicMaterial({
              color: 0xffffff,
              transparent: true,
              opacity: 0.15,
              side: THREE.DoubleSide
            });
            const grid = new THREE.Mesh(highlightGeo.clone(), gridMat);
            grid.rotation.x = -Math.PI / 2;
            grid.position.set(x, 0.05, z);
            this.scene.add(grid);
            this.gloveHighlightMeshes.push(grid);

            // Add border outline
            const borderMat = new THREE.MeshBasicMaterial({
              color: 0xaaaaaa,
              transparent: true,
              opacity: 0.3,
              side: THREE.DoubleSide
            });
            const border = new THREE.Mesh(borderGeo.clone(), borderMat);
            border.rotation.x = -Math.PI / 2;
            border.rotation.z = Math.PI / 4; // Rotate to make square
            border.position.set(x, 0.06, z);
            this.scene.add(border);
            this.gloveHighlightMeshes.push(border);
          }
        }
      }

      // Then highlight plants more brightly (orange/yellow glow)
      for (const plant of this.placedPlants) {
        const highlightMat = new THREE.MeshBasicMaterial({
          color: 0xffaa00,
          transparent: true,
          opacity: 0.6,
          side: THREE.DoubleSide
        });
        const highlight = new THREE.Mesh(highlightGeo.clone(), highlightMat);
        highlight.rotation.x = -Math.PI / 2;
        highlight.position.set(plant.position.x, 0.08, plant.position.z);
        this.scene.add(highlight);
        this.gloveHighlightMeshes.push(highlight);

        // Add bright pulsing ring around pickable plants
        const ringGeo = new THREE.RingGeometry(0.8, 0.95, 32);
        const ringMat = new THREE.MeshBasicMaterial({
          color: 0xffff00,
          transparent: true,
          opacity: 0.8,
          side: THREE.DoubleSide
        });
        const ring = new THREE.Mesh(ringGeo, ringMat);
        ring.rotation.x = -Math.PI / 2;
        ring.position.set(plant.position.x, 0.12, plant.position.z);
        ring.userData.isPulsingRing = true;
        ring.userData.pulseTime = Math.random() * Math.PI * 2;
        this.scene.add(ring);
        this.gloveHighlightMeshes.push(ring);
      }
    } else {
      // Plant is held - highlight ALL tiles brightly showing where you can place

      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
          const x = startX + col * slotSize;
          const z = startZ + row * slotSize;
          const slotKey = `${x},${z}`;
          const isOccupied = this.plantSlots.get(slotKey);

          // Skip the slot where the held plant came from
          if (x === this.glovePlant.position.x && z === this.glovePlant.position.z) {
            continue;
          }

          if (!isOccupied) {
            // Empty slot - bright cyan/green (can place here!)
            const highlightMat = new THREE.MeshBasicMaterial({
              color: 0x00ff88,
              transparent: true,
              opacity: 0.5,
              side: THREE.DoubleSide
            });
            const highlight = new THREE.Mesh(highlightGeo.clone(), highlightMat);
            highlight.rotation.x = -Math.PI / 2;
            highlight.position.set(x, 0.08, z);
            this.scene.add(highlight);
            this.gloveHighlightMeshes.push(highlight);

            // Add bright border for empty slots
            const borderMat = new THREE.MeshBasicMaterial({
              color: 0x00ffaa,
              transparent: true,
              opacity: 0.7,
              side: THREE.DoubleSide
            });
            const border = new THREE.Mesh(borderGeo.clone(), borderMat);
            border.rotation.x = -Math.PI / 2;
            border.rotation.z = Math.PI / 4;
            border.position.set(x, 0.1, z);
            border.userData.isPulsingRing = true;
            border.userData.pulseTime = col * 0.3 + row * 0.2;
            this.scene.add(border);
            this.gloveHighlightMeshes.push(border);
          } else {
            // Occupied slot - check if fusion is possible
            const targetPlant = this.placedPlants.find(
              p => Math.abs(p.position.x - x) < 0.5 && Math.abs(p.position.z - z) < 0.5
            );
            if (targetPlant) {
              // Check if fusion is possible with this plant
              const canFuse = FUSION_RECIPES.some(
                r => (r.plant1 === this.glovePlant!.type && r.plant2 === targetPlant.type) ||
                     (r.plant1 === targetPlant.type && r.plant2 === this.glovePlant!.type)
              );

              if (canFuse) {
                // Fusion possible - bright purple/magenta
                const highlightMat = new THREE.MeshBasicMaterial({
                  color: 0xff44ff,
                  transparent: true,
                  opacity: 0.6,
                  side: THREE.DoubleSide
                });
                const highlight = new THREE.Mesh(highlightGeo.clone(), highlightMat);
                highlight.rotation.x = -Math.PI / 2;
                highlight.position.set(x, 0.08, z);
                this.scene.add(highlight);
                this.gloveHighlightMeshes.push(highlight);

                // Add fusion sparkle ring
                const ringGeo = new THREE.RingGeometry(0.8, 0.98, 32);
                const ringMat = new THREE.MeshBasicMaterial({
                  color: 0xff88ff,
                  transparent: true,
                  opacity: 0.9,
                  side: THREE.DoubleSide
                });
                const ring = new THREE.Mesh(ringGeo, ringMat);
                ring.rotation.x = -Math.PI / 2;
                ring.position.set(x, 0.14, z);
                ring.userData.isPulsingRing = true;
                ring.userData.pulseTime = Math.random() * Math.PI * 2;
                this.scene.add(ring);
                this.gloveHighlightMeshes.push(ring);
              } else {
                // Occupied but no fusion - show red/blocked
                const blockedMat = new THREE.MeshBasicMaterial({
                  color: 0xff4444,
                  transparent: true,
                  opacity: 0.3,
                  side: THREE.DoubleSide
                });
                const blocked = new THREE.Mesh(highlightGeo.clone(), blockedMat);
                blocked.rotation.x = -Math.PI / 2;
                blocked.position.set(x, 0.07, z);
                this.scene.add(blocked);
                this.gloveHighlightMeshes.push(blocked);
              }
            }
          }
        }
      }
    }
  }

  private createPlantMesh(plantType: PlantType): THREE.Group {
    const group = new THREE.Group();

    switch (plantType) {
      case 'grape-launcher': {
        // Ornate terracotta pot with decorative rim
        const potGeo = new THREE.CylinderGeometry(0.42, 0.32, 0.35, 16);
        const potMat = new THREE.MeshPhongMaterial({
          color: 0xa0522d,
          shininess: 40,
          specular: 0x444444
        });
        const pot = new THREE.Mesh(potGeo, potMat);
        pot.position.y = 0.175;
        group.add(pot);

        // Pot rim detail
        const rimGeo = new THREE.TorusGeometry(0.42, 0.05, 8, 16);
        const rimMat = new THREE.MeshPhongMaterial({ color: 0x8b4513, shininess: 60 });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.position.y = 0.35;
        rim.rotation.x = Math.PI / 2;
        group.add(rim);

        // Rich soil visible at top
        const soilGeo = new THREE.CylinderGeometry(0.38, 0.38, 0.08, 16);
        const soilMat = new THREE.MeshPhongMaterial({ color: 0x3d2817, shininess: 5 });
        const soil = new THREE.Mesh(soilGeo, soilMat);
        soil.position.y = 0.32;
        group.add(soil);

        // Thick organic stem with slight curve
        const stemGeo = new THREE.CylinderGeometry(0.14, 0.22, 1.1, 12);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x355e20,
          shininess: 25,
          specular: 0x222222
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.85;
        group.add(stem);

        // Stem texture rings
        for (let r = 0; r < 4; r++) {
          const ringGeo = new THREE.TorusGeometry(0.16 + r * 0.01, 0.02, 6, 12);
          const ringMat = new THREE.MeshPhongMaterial({ color: 0x2a4a18, shininess: 20 });
          const ring = new THREE.Mesh(ringGeo, ringMat);
          ring.position.y = 0.5 + r * 0.25;
          ring.rotation.x = Math.PI / 2;
          group.add(ring);
        }

        // Plump, juicy grape cluster with varied sizes
        const grapePositions = [
          { pos: [0, 1.45, 0], size: 0.24 },
          { pos: [-0.22, 1.28, 0.12], size: 0.22 },
          { pos: [0.22, 1.28, -0.12], size: 0.22 },
          { pos: [-0.12, 1.65, 0.08], size: 0.2 },
          { pos: [0.15, 1.62, -0.05], size: 0.21 },
          { pos: [0, 1.8, 0.03], size: 0.18 },
          { pos: [-0.08, 1.52, -0.12], size: 0.19 },
          { pos: [0.1, 1.48, 0.14], size: 0.2 },
          { pos: [0.18, 1.38, 0.08], size: 0.17 },
          { pos: [-0.18, 1.42, -0.06], size: 0.18 }
        ];

        grapePositions.forEach(({ pos, size }) => {
          const grapeGeo = new THREE.SphereGeometry(size, 20, 20);
          const grapeMat = new THREE.MeshPhongMaterial({
            color: 0x7b3f9e,
            shininess: 120,
            specular: 0xcc88ee,
            emissive: 0x3d1a4f,
            emissiveIntensity: 0.25
          });
          const grape = new THREE.Mesh(grapeGeo, grapeMat);
          grape.position.set(pos[0], pos[1], pos[2]);
          group.add(grape);

          // Highlight reflection on each grape
          const highlightGeo = new THREE.SphereGeometry(size * 0.3, 8, 8);
          const highlightMat = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.4
          });
          const highlight = new THREE.Mesh(highlightGeo, highlightMat);
          highlight.position.set(pos[0] - size * 0.3, pos[1] + size * 0.3, pos[2] + size * 0.3);
          group.add(highlight);
        });

        // Lush curved leaves with natural shape
        for (let i = 0; i < 6; i++) {
          const leafShape = new THREE.Shape();
          leafShape.moveTo(0, 0);
          leafShape.quadraticCurveTo(0.15, 0.1, 0.25, 0);
          leafShape.quadraticCurveTo(0.15, -0.1, 0, 0);
          const leafGeo = new THREE.ExtrudeGeometry(leafShape, { depth: 0.02, bevelEnabled: false });
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x4a7c28 : 0x3a6420,
            shininess: 60,
            side: THREE.DoubleSide,
            specular: 0x224411
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const angle = (i / 6) * Math.PI * 2;
          leaf.position.set(Math.cos(angle) * 0.35, 1.1, Math.sin(angle) * 0.35);
          leaf.rotation.y = angle + Math.PI;
          leaf.rotation.x = -0.4;
          leaf.scale.set(1.8, 1.8, 1);
          group.add(leaf);
        }

        // Magical purple aura glow
        const auraGeo = new THREE.SphereGeometry(0.7, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x9955cc,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 1.5;
        group.add(aura);

        // Floating sparkle particles
        for (let i = 0; i < 8; i++) {
          const sparkleGeo = new THREE.OctahedronGeometry(0.04, 0);
          const sparkleMat = new THREE.MeshBasicMaterial({
            color: 0xdd88ff,
            transparent: true,
            opacity: 0.7
          });
          const sparkle = new THREE.Mesh(sparkleGeo, sparkleMat);
          const angle = (i / 8) * Math.PI * 2;
          sparkle.position.set(
            Math.cos(angle) * 0.55,
            1.5 + Math.sin(angle * 3) * 0.25,
            Math.sin(angle) * 0.55
          );
          group.add(sparkle);
        }
        break;
      }

      case 'vine-wall': {
        // Mossy root base
        const vwBaseGeo = new THREE.CylinderGeometry(0.55, 0.65, 0.15, 14);
        const vwBaseMat = new THREE.MeshPhongMaterial({
          color: 0x1a4a12, shininess: 30, emissive: 0x0a2a08, emissiveIntensity: 0.2
        });
        const vwBase = new THREE.Mesh(vwBaseGeo, vwBaseMat);
        vwBase.position.y = 0.07;
        group.add(vwBase);

        // Main wall body
        const wallGeo = new THREE.BoxGeometry(0.75, 2.1, 1.3);
        const wallMat = new THREE.MeshPhongMaterial({
          color: 0x2d6b2d, shininess: 20, specular: 0x1a3a1a,
          emissive: 0x0a2a0a, emissiveIntensity: 0.15
        });
        const wall = new THREE.Mesh(wallGeo, wallMat);
        wall.position.y = 1.2;
        group.add(wall);

        // Layered bark texture on front face
        for (let layer = 0; layer < 3; layer++) {
          const barkGeo = new THREE.BoxGeometry(0.08, 2.1, 1.3 - layer * 0.2);
          const barkMat = new THREE.MeshPhongMaterial({
            color: layer === 0 ? 0x1a4a1a : layer === 1 ? 0x2a5a2a : 0x1f501f,
            shininess: 20
          });
          const bark = new THREE.Mesh(barkGeo, barkMat);
          bark.position.set(0.38 + layer * 0.06, 1.2, 0);
          group.add(bark);
        }

        // Intertwined vines with organic curves
        for (let i = 0; i < 5; i++) {
          const vineThickness = 0.08 + Math.random() * 0.06;
          const vineGeo = new THREE.CylinderGeometry(vineThickness, vineThickness + 0.03, 2.1, 10);
          const vineMat = new THREE.MeshPhongMaterial({
            color: i % 3 === 0 ? 0x1a6b1a : i % 3 === 1 ? 0x2d5a16 : 0x3d7b2d,
            shininess: 40, specular: 0x224422
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(0.5 + Math.sin(i) * 0.08, 1.2, -0.5 + i * 0.25);
          vine.rotation.z = Math.sin(i * 1.5) * 0.15;
          vine.rotation.x = Math.cos(i) * 0.05;
          group.add(vine);
        }

        // Menacing thorns pointing at zombies (+X)
        const thornGeo = new THREE.ConeGeometry(0.1, 0.55, 5);
        const thornMat = new THREE.MeshPhongMaterial({
          color: 0x5a4020, shininess: 70, specular: 0xaa8866
        });
        for (let row = 0; row < 4; row++) {
          for (let col = 0; col < 3; col++) {
            const thorn = new THREE.Mesh(thornGeo, thornMat.clone());
            thorn.position.set(0.65, 0.4 + row * 0.5, -0.4 + col * 0.4);
            thorn.rotation.z = -Math.PI / 2 + (Math.random() - 0.5) * 0.2;
            thorn.rotation.y = (Math.random() - 0.5) * 0.3;
            group.add(thorn);

            const tipGeo = new THREE.ConeGeometry(0.03, 0.12, 4);
            const tipMat = new THREE.MeshPhongMaterial({ color: 0x8a7050, shininess: 100 });
            const tip = new THREE.Mesh(tipGeo, tipMat);
            tip.position.copy(thorn.position);
            tip.position.x += 0.25;
            tip.rotation.copy(thorn.rotation);
            group.add(tip);
          }
        }

        // Lush leaves
        for (let i = 0; i < 8; i++) {
          const leafGeo = new THREE.SphereGeometry(0.18, 8, 6);
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 3 === 0 ? 0x4a8a2a : i % 3 === 1 ? 0x3a7a1a : 0x5a9a3a,
            shininess: 50, side: THREE.DoubleSide,
            emissive: 0x1a3a0a, emissiveIntensity: 0.1
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(1.5, 0.15, 1);
          leaf.position.set(0.5 + Math.random() * 0.15, 0.4 + Math.random() * 1.8, -0.5 + Math.random() * 1.0);
          leaf.rotation.y = Math.random() * Math.PI;
          leaf.rotation.z = -0.3 + Math.random() * 0.3;
          group.add(leaf);
        }

        // Wooden reinforcement beams
        const beamGeo = new THREE.BoxGeometry(0.9, 0.12, 0.12);
        const beamMat = new THREE.MeshPhongMaterial({
          color: 0x6b4423, shininess: 30, specular: 0x443322
        });
        [1.95, 1.15, 0.3].forEach((yPos, idx) => {
          const beam = new THREE.Mesh(beamGeo, beamMat);
          beam.position.set(0.2, yPos, 0);
          beam.rotation.z = (idx - 1) * 0.08;
          group.add(beam);
        });

        // Metal reinforcement bands
        for (let b = 0; b < 2; b++) {
          const bandGeo = new THREE.BoxGeometry(0.08, 0.06, 1.35);
          const bandMat = new THREE.MeshPhongMaterial({
            color: 0x555555, shininess: 80, specular: 0xaaaaaa
          });
          const band = new THREE.Mesh(bandGeo, bandMat);
          band.position.set(0.6, 0.7 + b * 1.0, 0);
          group.add(band);
        }

        // Subtle nature aura
        const vwAuraGeo = new THREE.SphereGeometry(1.2, 12, 12);
        const vwAuraMat = new THREE.MeshBasicMaterial({
          color: 0x44aa44, transparent: true, opacity: 0.08
        });
        const vwAura = new THREE.Mesh(vwAuraGeo, vwAuraMat);
        vwAura.position.y = 1.2;
        group.add(vwAura);

        break;
      }

      case 'pear-cannon': {
        // Sturdy wooden platform base
        const baseGeo = new THREE.CylinderGeometry(0.7, 0.8, 0.3, 20);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x6b4423,
          shininess: 30,
          specular: 0x443322
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.15;
        group.add(base);

        // Gold trim on base
        const baseRimGeo = new THREE.TorusGeometry(0.7, 0.05, 8, 24);
        const baseRimMat = new THREE.MeshPhongMaterial({
          color: 0xdaa520,
          shininess: 100,
          specular: 0xffdd88
        });
        const baseRim = new THREE.Mesh(baseRimGeo, baseRimMat);
        baseRim.position.y = 0.3;
        baseRim.rotation.x = Math.PI / 2;
        group.add(baseRim);

        // Big beautiful pear body - bright yellow-green
        const bodyGeo = new THREE.SphereGeometry(0.6, 24, 24);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0xc5e636,
          shininess: 100,
          specular: 0xffffaa,
          emissive: 0x3a4a10,
          emissiveIntensity: 0.2
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.scale.set(1, 1.5, 1);
        body.position.y = 1.0;
        group.add(body);

        // Pear top (narrower part)
        const topGeo = new THREE.SphereGeometry(0.35, 20, 20);
        const topMat = new THREE.MeshPhongMaterial({
          color: 0xb8d430,
          shininess: 90,
          specular: 0xffffaa
        });
        const top = new THREE.Mesh(topGeo, topMat);
        top.scale.set(1, 1.3, 1);
        top.position.y = 1.55;
        group.add(top);

        // Rosy blush on pear
        const blushGeo = new THREE.SphereGeometry(0.4, 16, 16);
        const blushMat = new THREE.MeshPhongMaterial({
          color: 0xff8866,
          transparent: true,
          opacity: 0.35,
          shininess: 60
        });
        const blush = new THREE.Mesh(blushGeo, blushMat);
        blush.position.set(0.3, 0.9, 0.25);
        group.add(blush);

        // Shiny bronze cannon barrel
        const barrelGeo = new THREE.CylinderGeometry(0.22, 0.18, 1.2, 20);
        const barrelMat = new THREE.MeshPhongMaterial({
          color: 0x8b5a2b,
          shininess: 120,
          specular: 0xddaa66
        });
        const barrel = new THREE.Mesh(barrelGeo, barrelMat);
        barrel.position.set(0.5, 1.4, 0);
        barrel.rotation.z = -Math.PI / 3;
        group.add(barrel);

        // Gold barrel bands
        for (let i = 0; i < 3; i++) {
          const bRingGeo = new THREE.TorusGeometry(0.2 - i * 0.01, 0.03, 8, 16);
          const bRingMat = new THREE.MeshPhongMaterial({
            color: 0xdaa520,
            shininess: 120,
            specular: 0xffee88
          });
          const bRing = new THREE.Mesh(bRingGeo, bRingMat);
          const offset = 0.25 + i * 0.3;
          bRing.position.set(0.3 + offset * 0.8, 1.2 + offset * 0.5, 0);
          bRing.rotation.z = -Math.PI / 3;
          group.add(bRing);
        }

        // Cannon muzzle with gold rim
        const muzzleGeo = new THREE.CylinderGeometry(0.18, 0.24, 0.2, 20);
        const muzzleMat = new THREE.MeshPhongMaterial({
          color: 0x5c3a1a,
          shininess: 80
        });
        const muzzle = new THREE.Mesh(muzzleGeo, muzzleMat);
        muzzle.position.set(0.9, 1.82, 0);
        muzzle.rotation.z = -Math.PI / 3;
        group.add(muzzle);

        // Glowing barrel interior (ready to fire!)
        const glowGeo = new THREE.CircleGeometry(0.14, 16);
        const glowMat = new THREE.MeshBasicMaterial({
          color: 0xffcc00,
          transparent: true,
          opacity: 0.8
        });
        const glow = new THREE.Mesh(glowGeo, glowMat);
        glow.position.set(0.98, 1.92, 0);
        glow.rotation.y = -Math.PI / 2;
        group.add(glow);

        // Brown stem on top
        const stemGeo = new THREE.CylinderGeometry(0.04, 0.06, 0.25, 10);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x5a3a15,
          shininess: 30
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 1.8;
        stem.rotation.z = 0.1;
        group.add(stem);

        // Cute leaves on top
        for (let l = 0; l < 2; l++) {
          const leafGeo = new THREE.SphereGeometry(0.14, 8, 6);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x4a9a2a,
            shininess: 60,
            side: THREE.DoubleSide
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(1.6, 0.2, 1);
          leaf.position.set(0.1 + l * 0.1, 1.9, l * 0.1 - 0.05);
          leaf.rotation.z = 0.5 - l * 0.3;
          leaf.rotation.y = l * 0.6;
          group.add(leaf);
        }

        // Add a cute face to the pear
        // Eyes
        const eyeGeo = new THREE.SphereGeometry(0.06, 12, 12);
        const eyeMat = new THREE.MeshPhongMaterial({ color: 0x222222, shininess: 100 });
        const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
        leftEye.position.set(0.55, 1.1, 0.15);
        group.add(leftEye);
        const rightEye = new THREE.Mesh(eyeGeo, eyeMat);
        rightEye.position.set(0.55, 1.1, -0.15);
        group.add(rightEye);

        // Eye highlights
        const highlightGeo = new THREE.SphereGeometry(0.025, 8, 8);
        const highlightMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
        const leftHighlight = new THREE.Mesh(highlightGeo, highlightMat);
        leftHighlight.position.set(0.6, 1.12, 0.13);
        group.add(leftHighlight);
        const rightHighlight = new THREE.Mesh(highlightGeo, highlightMat);
        rightHighlight.position.set(0.6, 1.12, -0.17);
        group.add(rightHighlight);

        // Cute smile
        const smileGeo = new THREE.TorusGeometry(0.08, 0.02, 8, 12, Math.PI);
        const smileMat = new THREE.MeshPhongMaterial({ color: 0x333333 });
        const smile = new THREE.Mesh(smileGeo, smileMat);
        smile.position.set(0.58, 0.95, 0);
        smile.rotation.set(Math.PI, Math.PI / 2, 0);
        group.add(smile);
        break;
      }

      case 'frost-berri': {
        // Ice pedestal base
        const pedestalGeo = new THREE.CylinderGeometry(0.5, 0.6, 0.3, 8);
        const pedestalMat = new THREE.MeshPhongMaterial({
          color: 0xb0e0e6,
          shininess: 100,
          transparent: true,
          opacity: 0.8,
          specular: 0xffffff
        });
        const pedestal = new THREE.Mesh(pedestalGeo, pedestalMat);
        pedestal.position.y = 0.15;
        group.add(pedestal);

        // Inner core - super bright
        const coreGeo = new THREE.SphereGeometry(0.4, 32, 32);
        const coreMat = new THREE.MeshPhongMaterial({
          color: 0xffffff,
          emissive: 0x87ceeb,
          emissiveIntensity: 1.0,
          shininess: 150,
          specular: 0xffffff
        });
        const core = new THREE.Mesh(coreGeo, coreMat);
        core.position.y = 0.8;
        group.add(core);

        // Main berry body - crystalline
        const berryGeo = new THREE.IcosahedronGeometry(0.6, 1);
        const berryMat = new THREE.MeshPhongMaterial({
          color: 0x87ceeb,
          shininess: 150,
          transparent: true,
          opacity: 0.7,
          emissive: 0x4169e1,
          emissiveIntensity: 0.5,
          specular: 0xffffff
        });
        const berry = new THREE.Mesh(berryGeo, berryMat);
        berry.position.y = 0.8;
        group.add(berry);

        // Multiple glow layers
        for (let i = 0; i < 3; i++) {
          const glowGeo = new THREE.SphereGeometry(0.75 + i * 0.15, 24, 24);
          const glowMat = new THREE.MeshBasicMaterial({
            color: i === 0 ? 0x00bfff : i === 1 ? 0x87ceeb : 0xafffff,
            transparent: true,
            opacity: 0.15 - i * 0.04
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.y = 0.8;
          group.add(glow);
        }

        // Large ice shards radiating out
        const shardGeo = new THREE.ConeGeometry(0.15, 1.0, 4);
        const shardMat = new THREE.MeshPhongMaterial({
          color: 0xe0ffff,
          transparent: true,
          opacity: 0.85,
          shininess: 150,
          emissive: 0xd0ffff,
          emissiveIntensity: 0.6,
          specular: 0xffffff
        });

        const shardPositions = [
          // Cardinal directions
          [0.7, 0.8, 0], [-0.7, 0.8, 0], [0, 0.8, 0.7], [0, 0.8, -0.7],
          // Diagonals
          [0.5, 0.8, 0.5], [-0.5, 0.8, 0.5], [0.5, 0.8, -0.5], [-0.5, 0.8, -0.5],
          // Top and angled
          [0, 1.4, 0], [0.4, 1.2, 0.4], [-0.4, 1.2, -0.4],
          // Bottom angled
          [0.5, 0.4, 0.3], [-0.5, 0.4, -0.3], [0.3, 0.5, -0.5], [-0.3, 0.5, 0.5]
        ];

        shardPositions.forEach(([x, y, z]) => {
          const shard = new THREE.Mesh(shardGeo, shardMat.clone());
          shard.position.set(x, y, z);

          // Point shard outward from center
          const angle = Math.atan2(z, x);
          const verticalAngle = Math.atan2(y - 0.8, Math.sqrt(x*x + z*z));
          shard.rotation.z = -angle - Math.PI / 2;
          shard.rotation.y = angle;
          shard.rotation.x = verticalAngle;

          group.add(shard);

          // Add glow to each shard tip
          const tipGlowGeo = new THREE.SphereGeometry(0.12, 12, 12);
          const tipGlowMat = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.8
          });
          const tipGlow = new THREE.Mesh(tipGlowGeo, tipGlowMat);
          tipGlow.position.copy(shard.position);
          group.add(tipGlow);
        });

        // Orbiting ice particles in multiple rings
        for (let ring = 0; ring < 3; ring++) {
          const particlesInRing = 12;
          const ringRadius = 1.0 + ring * 0.3;
          const ringHeight = 0.8 + (ring - 1) * 0.3;

          for (let i = 0; i < particlesInRing; i++) {
            const frostGeo = new THREE.SphereGeometry(0.06 + ring * 0.02, 12, 12);
            const frostMat = new THREE.MeshPhongMaterial({
              color: 0xffffff,
              transparent: true,
              opacity: 0.8,
              emissive: 0xe0ffff,
              emissiveIntensity: 0.8,
              shininess: 150
            });
            const frost = new THREE.Mesh(frostGeo, frostMat);
            const angle = (i / particlesInRing) * Math.PI * 2 + ring * Math.PI / 6;
            frost.position.set(
              Math.cos(angle) * ringRadius,
              ringHeight + Math.sin(i * 2) * 0.1,
              Math.sin(angle) * ringRadius
            );
            group.add(frost);

            // Particle glow
            const pGlowGeo = new THREE.SphereGeometry(0.1 + ring * 0.03, 12, 12);
            const pGlowMat = new THREE.MeshBasicMaterial({
              color: 0xafffff,
              transparent: true,
              opacity: 0.3
            });
            const pGlow = new THREE.Mesh(pGlowGeo, pGlowMat);
            pGlow.position.copy(frost.position);
            group.add(pGlow);
          }
        }

        // Floating snowflakes
        for (let i = 0; i < 20; i++) {
          const snowGeo = new THREE.PlaneGeometry(0.08, 0.08);
          const snowMat = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.7,
            side: THREE.DoubleSide
          });
          const snow = new THREE.Mesh(snowGeo, snowMat);
          const angle = Math.random() * Math.PI * 2;
          const radius = Math.random() * 1.2 + 0.5;
          snow.position.set(
            Math.cos(angle) * radius,
            0.3 + Math.random() * 1.0,
            Math.sin(angle) * radius
          );
          snow.rotation.z = Math.random() * Math.PI * 2;
          group.add(snow);
        }

        break;
      }

      case 'elder-frost-berri': {
        // LEGENDARY ELDER FROST BERRI - Ancient ice deity of destruction

        // Massive frozen golden pedestal
        const frostPedestalGeo = new THREE.CylinderGeometry(0.65, 0.8, 0.45, 12);
        const frostPedestalMat = new THREE.MeshPhongMaterial({
          color: 0x4169e1,
          shininess: 200,
          specular: 0xffffff,
          emissive: 0x0066cc,
          emissiveIntensity: 0.4,
          transparent: true,
          opacity: 0.9
        });
        const frostPedestal = new THREE.Mesh(frostPedestalGeo, frostPedestalMat);
        frostPedestal.position.y = 0.225;
        group.add(frostPedestal);

        // Golden trim rings on pedestal
        for (let ring = 0; ring < 3; ring++) {
          const trimGeo = new THREE.TorusGeometry(0.7 - ring * 0.05, 0.04, 8, 32);
          const trimMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            emissive: 0xffa500,
            emissiveIntensity: 0.7,
            shininess: 180
          });
          const trim = new THREE.Mesh(trimGeo, trimMat);
          trim.rotation.x = Math.PI / 2;
          trim.position.y = 0.1 + ring * 0.15;
          group.add(trim);
        }

        // Swirling ice vortex base
        for (let v = 0; v < 8; v++) {
          const vortexGeo = new THREE.TorusGeometry(0.3 + v * 0.08, 0.02, 6, 24);
          const vortexMat = new THREE.MeshBasicMaterial({
            color: 0x87ceeb,
            transparent: true,
            opacity: 0.4 - v * 0.04
          });
          const vortex = new THREE.Mesh(vortexGeo, vortexMat);
          vortex.rotation.x = Math.PI / 2;
          vortex.position.y = 0.5 + v * 0.05;
          vortex.rotation.z = v * 0.3;
          group.add(vortex);
        }

        // MASSIVE crystalline core - pure ancient ice power
        const frostCoreGeo = new THREE.IcosahedronGeometry(0.55, 3);
        const frostCoreMat = new THREE.MeshPhongMaterial({
          color: 0xffffff,
          emissive: 0x00ffff,
          emissiveIntensity: 1.5,
          shininess: 250,
          specular: 0xffffff,
          transparent: true,
          opacity: 0.95
        });
        const frostCore = new THREE.Mesh(frostCoreGeo, frostCoreMat);
        frostCore.position.y = 1.2;
        group.add(frostCore);

        // Outer crystalline shell
        const shellGeo = new THREE.IcosahedronGeometry(0.75, 1);
        const shellMat = new THREE.MeshPhongMaterial({
          color: 0x00bfff,
          shininess: 200,
          transparent: true,
          opacity: 0.5,
          emissive: 0x0080ff,
          emissiveIntensity: 0.6,
          specular: 0xffffff
        });
        const shell = new THREE.Mesh(shellGeo, shellMat);
        shell.position.y = 1.2;
        group.add(shell);

        // Multiple aurora-like glow layers
        const auroraColors = [0x00ffff, 0x00ff88, 0x0088ff, 0xffd700, 0x00ffcc];
        for (let i = 0; i < 5; i++) {
          const auroraGeo = new THREE.SphereGeometry(1.0 + i * 0.15, 24, 24);
          const auroraMat = new THREE.MeshBasicMaterial({
            color: auroraColors[i],
            transparent: true,
            opacity: 0.12 - i * 0.02
          });
          const aurora = new THREE.Mesh(auroraGeo, auroraMat);
          aurora.position.y = 1.2;
          group.add(aurora);
        }

        // EPIC ice crystal crown on top
        const crownGeo = new THREE.ConeGeometry(0.15, 0.8, 4);
        const crownMat = new THREE.MeshPhongMaterial({
          color: 0xe0ffff,
          transparent: true,
          opacity: 0.95,
          shininess: 250,
          emissive: 0x80ffff,
          emissiveIntensity: 1.0,
          specular: 0xffffff
        });

        // Central crown spike
        const centralCrown = new THREE.Mesh(crownGeo, crownMat);
        centralCrown.position.y = 2.3;
        group.add(centralCrown);

        // Crown ring of crystals
        for (let i = 0; i < 6; i++) {
          const crownSpike = new THREE.Mesh(crownGeo.clone(), crownMat.clone());
          const angle = (i / 6) * Math.PI * 2;
          crownSpike.position.set(
            Math.cos(angle) * 0.35,
            2.0,
            Math.sin(angle) * 0.35
          );
          crownSpike.rotation.z = -0.3;
          crownSpike.rotation.y = angle;
          group.add(crownSpike);
        }

        // MASSIVE radiating ice shards - the signature look
        const elderShardGeo = new THREE.ConeGeometry(0.18, 1.5, 4);
        const elderShardMat = new THREE.MeshPhongMaterial({
          color: 0xc0ffff,
          transparent: true,
          opacity: 0.92,
          shininess: 220,
          emissive: 0x40ffff,
          emissiveIntensity: 0.9,
          specular: 0xffffff
        });

        // Horizontal ring of mega shards
        for (let i = 0; i < 12; i++) {
          const shard = new THREE.Mesh(elderShardGeo.clone(), elderShardMat.clone());
          const angle = (i / 12) * Math.PI * 2;
          shard.position.set(
            Math.cos(angle) * 0.9,
            1.2,
            Math.sin(angle) * 0.9
          );
          shard.rotation.z = Math.PI / 2;
          shard.rotation.y = angle;
          group.add(shard);

          // Golden crystal tips
          const goldTipGeo = new THREE.OctahedronGeometry(0.1, 0);
          const goldTipMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            emissive: 0xffaa00,
            emissiveIntensity: 1.0,
            shininess: 200
          });
          const goldTip = new THREE.Mesh(goldTipGeo, goldTipMat);
          goldTip.position.set(
            Math.cos(angle) * 1.6,
            1.2,
            Math.sin(angle) * 1.6
          );
          group.add(goldTip);
        }

        // Diagonal shards going up
        for (let i = 0; i < 8; i++) {
          const diagShard = new THREE.Mesh(elderShardGeo.clone(), elderShardMat.clone());
          const angle = (i / 8) * Math.PI * 2 + Math.PI / 8;
          diagShard.position.set(
            Math.cos(angle) * 0.6,
            1.5,
            Math.sin(angle) * 0.6
          );
          diagShard.rotation.z = Math.PI / 3;
          diagShard.rotation.y = angle;
          group.add(diagShard);
        }

        // Diagonal shards going down
        for (let i = 0; i < 8; i++) {
          const diagShardDown = new THREE.Mesh(elderShardGeo.clone(), elderShardMat.clone());
          const angle = (i / 8) * Math.PI * 2;
          diagShardDown.position.set(
            Math.cos(angle) * 0.6,
            0.8,
            Math.sin(angle) * 0.6
          );
          diagShardDown.rotation.z = Math.PI * 0.65;
          diagShardDown.rotation.y = angle;
          group.add(diagShardDown);
        }

        // Orbiting ancient frost runes
        for (let i = 0; i < 10; i++) {
          const runeGeo = new THREE.OctahedronGeometry(0.1, 0);
          const runeMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            emissive: 0x00ffff,
            emissiveIntensity: 1.2,
            shininess: 180
          });
          const rune = new THREE.Mesh(runeGeo, runeMat);
          const angle = (i / 10) * Math.PI * 2;
          const heightVar = Math.sin(i * 1.5) * 0.4;
          rune.position.set(
            Math.cos(angle) * 1.3,
            1.2 + heightVar,
            Math.sin(angle) * 1.3
          );
          group.add(rune);
        }

        // Floating snowflake particles
        for (let s = 0; s < 16; s++) {
          const snowGeo = new THREE.OctahedronGeometry(0.05, 0);
          const snowMat = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.9
          });
          const snow = new THREE.Mesh(snowGeo, snowMat);
          const angle = Math.random() * Math.PI * 2;
          const radius = 0.8 + Math.random() * 0.8;
          const height = 0.5 + Math.random() * 1.5;
          snow.position.set(
            Math.cos(angle) * radius,
            height,
            Math.sin(angle) * radius
          );
          group.add(snow);
        }

        // Ice mist at base
        for (let m = 0; m < 8; m++) {
          const mistGeo = new THREE.SphereGeometry(0.2 + Math.random() * 0.15, 8, 8);
          const mistMat = new THREE.MeshBasicMaterial({
            color: 0xaaddff,
            transparent: true,
            opacity: 0.25
          });
          const mist = new THREE.Mesh(mistGeo, mistMat);
          const angle = (m / 8) * Math.PI * 2;
          mist.position.set(
            Math.cos(angle) * 0.7,
            0.2 + Math.random() * 0.2,
            Math.sin(angle) * 0.7
          );
          group.add(mist);
        }

        break;
      }

      case 'lily': {
        // ========================================
        // BEAUTIFUL WATER LILY - Elegant sun producer
        // ========================================

        // === WATER/POND BASE ===
        // Shimmering water surface
        const waterGeo = new THREE.CylinderGeometry(0.7, 0.65, 0.12, 24);
        const waterMat = new THREE.MeshPhongMaterial({
          color: 0x4488cc,
          shininess: 120,
          specular: 0x88ccff,
          transparent: true,
          opacity: 0.85
        });
        const water = new THREE.Mesh(waterGeo, waterMat);
        water.position.y = 0.06;
        group.add(water);

        // Water surface shimmer/reflection
        const shimmerGeo = new THREE.CylinderGeometry(0.68, 0.63, 0.02, 24);
        const shimmerMat = new THREE.MeshBasicMaterial({
          color: 0xaaddff,
          transparent: true,
          opacity: 0.4
        });
        const shimmer = new THREE.Mesh(shimmerGeo, shimmerMat);
        shimmer.position.y = 0.13;
        group.add(shimmer);

        // Decorative pond rim (stone/ceramic)
        const rimGeo = new THREE.TorusGeometry(0.88, 0.08, 8, 24);
        const rimMat = new THREE.MeshPhongMaterial({
          color: 0x8899aa,
          shininess: 60,
          specular: 0x445566
        });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.rotation.x = Math.PI / 2;
        rim.position.y = 0.15;
        group.add(rim);

        // === LILY PADS (floating on water) ===
        for (let i = 0; i < 3; i++) {
          const padAngle = (i / 3) * Math.PI * 2 + 0.3;
          const padDist = 0.5 + Math.random() * 0.2;

          // Main lily pad shape
          const padGeo = new THREE.CircleGeometry(0.28, 24);
          const padMat = new THREE.MeshPhongMaterial({
            color: 0x2d8a2d,
            shininess: 50,
            side: THREE.DoubleSide
          });
          const pad = new THREE.Mesh(padGeo, padMat);
          pad.rotation.x = -Math.PI / 2;
          pad.position.set(
            Math.cos(padAngle) * padDist,
            0.25,
            Math.sin(padAngle) * padDist
          );
          group.add(pad);

          // Pad vein detail (lighter green line)
          const veinGeo = new THREE.PlaneGeometry(0.26, 0.02);
          const veinMat = new THREE.MeshBasicMaterial({
            color: 0x44aa44,
            side: THREE.DoubleSide
          });
          const vein = new THREE.Mesh(veinGeo, veinMat);
          vein.rotation.x = -Math.PI / 2;
          vein.position.set(
            Math.cos(padAngle) * padDist,
            0.255,
            Math.sin(padAngle) * padDist
          );
          vein.rotation.z = padAngle;
          group.add(vein);
        }

        // === GRACEFUL STEM ===
        const stemGeo = new THREE.CylinderGeometry(0.06, 0.08, 0.7, 12);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x3d7a3d,
          shininess: 30
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.5;
        group.add(stem);

        // === ELEGANT LILY FLOWER ===
        // Outer petals (6 large, gracefully curved)
        const outerPetalShape = new THREE.Shape();
        outerPetalShape.moveTo(0, 0);
        outerPetalShape.quadraticCurveTo(0.15, 0.2, 0.12, 0.5);
        outerPetalShape.quadraticCurveTo(0.05, 0.6, 0, 0.65);
        outerPetalShape.quadraticCurveTo(-0.05, 0.6, -0.12, 0.5);
        outerPetalShape.quadraticCurveTo(-0.15, 0.2, 0, 0);

        const outerPetalGeo = new THREE.ExtrudeGeometry(outerPetalShape, {
          depth: 0.03,
          bevelEnabled: true,
          bevelThickness: 0.01,
          bevelSize: 0.01,
          bevelSegments: 2
        });

        for (let i = 0; i < 6; i++) {
          const petalMat = new THREE.MeshPhongMaterial({
            color: 0xffeef5,
            shininess: 80,
            specular: 0xffffff,
            emissive: 0xffddee,
            emissiveIntensity: 0.15,
            side: THREE.DoubleSide
          });
          const petal = new THREE.Mesh(outerPetalGeo, petalMat);
          const angle = (i / 6) * Math.PI * 2;
          petal.position.set(
            Math.cos(angle) * 0.15,
            0.85,
            Math.sin(angle) * 0.15
          );
          petal.rotation.y = -angle + Math.PI;
          petal.rotation.x = -0.4; // Tilt outward elegantly
          petal.scale.set(1.3, 1.3, 1);
          group.add(petal);
        }

        // Inner petals (6 smaller, more upright) - creates depth
        for (let i = 0; i < 6; i++) {
          const innerPetalMat = new THREE.MeshPhongMaterial({
            color: 0xfff5fa,
            shininess: 90,
            specular: 0xffffff,
            emissive: 0xffeeee,
            emissiveIntensity: 0.2,
            side: THREE.DoubleSide
          });
          const petal = new THREE.Mesh(outerPetalGeo, innerPetalMat);
          const angle = (i / 6) * Math.PI * 2 + Math.PI / 6; // Offset from outer petals
          petal.position.set(
            Math.cos(angle) * 0.08,
            0.9,
            Math.sin(angle) * 0.08
          );
          petal.rotation.y = -angle + Math.PI;
          petal.rotation.x = -0.2; // More upright
          petal.scale.set(0.9, 1.0, 0.8);
          group.add(petal);
        }

        // === GORGEOUS GOLDEN CENTER (Sun Producer!) ===
        // Main golden orb
        const centerGeo = new THREE.SphereGeometry(0.2, 20, 20);
        const centerMat = new THREE.MeshPhongMaterial({
          color: 0xffdd00,
          emissive: 0xffaa00,
          emissiveIntensity: 0.9,
          shininess: 150,
          specular: 0xffffaa
        });
        const center = new THREE.Mesh(centerGeo, centerMat);
        center.position.y = 1.0;
        group.add(center);

        // Stamen ring (tiny golden dots around center)
        for (let i = 0; i < 12; i++) {
          const stamenGeo = new THREE.SphereGeometry(0.03, 8, 8);
          const stamenMat = new THREE.MeshPhongMaterial({
            color: 0xffcc00,
            emissive: 0xff9900,
            emissiveIntensity: 0.7,
            shininess: 100
          });
          const stamen = new THREE.Mesh(stamenGeo, stamenMat);
          const angle = (i / 12) * Math.PI * 2;
          stamen.position.set(
            Math.cos(angle) * 0.25,
            0.98,
            Math.sin(angle) * 0.25
          );
          group.add(stamen);
        }

        // Inner glow (warm golden light)
        const innerGlowGeo = new THREE.SphereGeometry(0.28, 16, 16);
        const innerGlowMat = new THREE.MeshBasicMaterial({
          color: 0xffee66,
          transparent: true,
          opacity: 0.5
        });
        const innerGlow = new THREE.Mesh(innerGlowGeo, innerGlowMat);
        innerGlow.position.y = 1.0;
        group.add(innerGlow);

        // Outer glow (soft sun aura)
        const outerGlowGeo = new THREE.SphereGeometry(0.45, 16, 16);
        const outerGlowMat = new THREE.MeshBasicMaterial({
          color: 0xffff88,
          transparent: true,
          opacity: 0.25
        });
        const outerGlow = new THREE.Mesh(outerGlowGeo, outerGlowMat);
        outerGlow.position.y = 1.0;
        group.add(outerGlow);

        // Sparkle particles around flower
        for (let i = 0; i < 6; i++) {
          const sparkleGeo = new THREE.SphereGeometry(0.02, 6, 6);
          const sparkleMat = new THREE.MeshBasicMaterial({
            color: 0xffffaa,
            transparent: true,
            opacity: 0.8
          });
          const sparkle = new THREE.Mesh(sparkleGeo, sparkleMat);
          const angle = (i / 6) * Math.PI * 2;
          const height = 0.9 + Math.random() * 0.3;
          sparkle.position.set(
            Math.cos(angle) * (0.4 + Math.random() * 0.2),
            height,
            Math.sin(angle) * (0.4 + Math.random() * 0.2)
          );
          group.add(sparkle);
        }

        break;
      }

      case 'grape-wall': {
        // GRAPE WALL FUSION - Vine Fortress with Grape Cannon

        // Stone base platform
        {
        const gwBase = new THREE.Mesh(
          new THREE.BoxGeometry(1.0, 0.2, 1.0),
          new THREE.MeshPhongMaterial({ color: 0x3a3a3a, shininess: 40, specular: 0x555555 })
        );
        gwBase.position.y = 0.1;
        group.add(gwBase);
        }

        // Main living wall
        const wallGeo = new THREE.BoxGeometry(0.8, 2.3, 1.3);
        const wallMat = new THREE.MeshPhongMaterial({
          color: 0x2a6b2a, shininess: 35, specular: 0xffffff,
          emissive: 0x0a2a0a, emissiveIntensity: 0.15
        });
        const wall = new THREE.Mesh(wallGeo, wallMat);
        wall.position.y = 1.35;
        group.add(wall);

        // Glowing grape clusters (2 tiers x 4)
        {
        const grapeColors = [0x8b2d8b, 0x6b2d87, 0x9932cc];
        for (let tier = 0; tier < 2; tier++) {
          for (let g = 0; g < 4; g++) {
            const grapeGeo = new THREE.SphereGeometry(0.14 + Math.random() * 0.08, 12, 12);
            const grapeMat = new THREE.MeshPhongMaterial({
              color: grapeColors[(tier + g) % 3], shininess: 120, specular: 0xcc66cc,
              emissive: 0x4a1a6b, emissiveIntensity: 0.5
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            grape.position.set(0.5 + Math.random() * 0.12, 0.6 + tier * 0.8 + Math.random() * 0.3, -0.4 + g * 0.27);
            group.add(grape);
          }
        }
        }

        // Vine tendrils wrapping around (torus arcs)
        for (let i = 0; i < 3; i++) {
          const tendrilGeo = new THREE.TorusGeometry(0.5 + i * 0.08, 0.04, 8, 16, Math.PI);
          const tendrilMat = new THREE.MeshPhongMaterial({
            color: 0x1a8b1a, shininess: 45, emissive: 0x1a3a1a, emissiveIntensity: 0.2
          });
          const tendril = new THREE.Mesh(tendrilGeo, tendrilMat);
          tendril.position.set(-0.05, 0.6 + i * 0.55, 0);
          tendril.rotation.y = Math.PI / 2;
          group.add(tendril);
        }

        // Twisted vines
        for (let i = 0; i < 6; i++) {
          const vineGeo = new THREE.CylinderGeometry(0.06, 0.08, 2.3, 8);
          const vineMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x1a8b1a : 0x0d5c0d, shininess: 40,
            emissive: 0x1a3a1a, emissiveIntensity: 0.2
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(0.35 + (i % 3) * 0.1, 1.35, -0.5 + i * 0.2);
          vine.rotation.z = Math.sin(i * 0.8) * 0.15;
          group.add(vine);
        }

        // Thorns (3x3 grid)
        for (let row = 0; row < 3; row++) {
          for (let col = 0; col < 3; col++) {
            const thornGeo = new THREE.ConeGeometry(0.1, 0.5, 6);
            const thornMat = new THREE.MeshPhongMaterial({
              color: 0x4a3020, shininess: 80, specular: 0x888866
            });
            const thorn = new THREE.Mesh(thornGeo, thornMat);
            thorn.position.set(0.7, 0.5 + row * 0.7, -0.4 + col * 0.4);
            thorn.rotation.z = -Math.PI / 2;
            group.add(thorn);
          }
        }

        // Grape cannon on top
        {
        const cannonBase = new THREE.Mesh(
          new THREE.CylinderGeometry(0.3, 0.35, 0.35, 12),
          new THREE.MeshPhongMaterial({
            color: 0x3d1a4d, shininess: 60, emissive: 0x2d0a3d, emissiveIntensity: 0.3
          })
        );
        cannonBase.position.set(0.3, 2.3, 0);
        group.add(cannonBase);

        const cannonBarrel = new THREE.Mesh(
          new THREE.CylinderGeometry(0.15, 0.2, 0.6, 10),
          new THREE.MeshPhongMaterial({
            color: 0x6b2d87, shininess: 100, emissive: 0x4a1a6b, emissiveIntensity: 0.5
          })
        );
        cannonBarrel.position.set(0.6, 2.3, 0);
        cannonBarrel.rotation.z = Math.PI / 2;
        group.add(cannonBarrel);

        // Flanking grape clusters on cannon
        for (let side = -1; side <= 1; side += 2) {
          const flankGeo = new THREE.SphereGeometry(0.1, 8, 8);
          const flankMat = new THREE.MeshPhongMaterial({
            color: 0x9932cc, shininess: 120, emissive: 0x4a1a6b, emissiveIntensity: 0.5
          });
          const flank = new THREE.Mesh(flankGeo, flankMat);
          flank.position.set(0.45, 2.3, side * 0.25);
          group.add(flank);
        }
        }

        // Energy aura (tighter)
        {
        const aura = new THREE.Mesh(
          new THREE.SphereGeometry(1.2, 14, 14),
          new THREE.MeshBasicMaterial({ color: 0xaa55dd, transparent: true, opacity: 0.1 })
        );
        aura.position.y = 1.35;
        group.add(aura);

        // Pulsing core glow
        const coreGlow = new THREE.Mesh(
          new THREE.SphereGeometry(0.35, 12, 12),
          new THREE.MeshBasicMaterial({ color: 0xff66ff, transparent: true, opacity: 0.35 })
        );
        coreGlow.position.set(0.3, 1.4, 0);
        group.add(coreGlow);
        }

        break;
      }

      case 'grape-lily': {
        // FUSION: Grape Launcher + Lily = Grape Lily
        // Shoots sun grapes that give 5 sun when they hit zombies

        // Pot base
        const potGeo = new THREE.CylinderGeometry(0.4, 0.3, 0.3, 12);
        const potMat = new THREE.MeshPhongMaterial({ color: 0x8b4513, shininess: 30 });
        const pot = new THREE.Mesh(potGeo, potMat);
        pot.position.y = 0.15;
        group.add(pot);

        // Stem with purple-pink gradient effect
        const stemGeo = new THREE.CylinderGeometry(0.15, 0.2, 1.2, 12);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x8b4789,
          shininess: 30,
          emissive: 0x2d1035,
          emissiveIntensity: 0.1
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.8;
        group.add(stem);

        // Pink lily petals
        const petalGeo = new THREE.SphereGeometry(0.3, 12, 12);
        const petalMat = new THREE.MeshPhongMaterial({
          color: 0xffb6c1,
          shininess: 80,
          specular: 0xffffff,
          emissive: 0xff91a4,
          emissiveIntensity: 0.2
        });

        for (let i = 0; i < 8; i++) {
          const petal = new THREE.Mesh(petalGeo, petalMat.clone());
          petal.scale.set(0.5, 1.0, 0.35);
          const angle = (i / 8) * Math.PI * 2;
          petal.position.set(
            Math.cos(angle) * 0.35,
            1.4,
            Math.sin(angle) * 0.35
          );
          petal.rotation.y = angle;
          petal.rotation.x = Math.PI / 3.5;
          group.add(petal);
        }

        // Golden center with grapes
        const centerGeo = new THREE.SphereGeometry(0.25, 16, 16);
        const centerMat = new THREE.MeshPhongMaterial({
          color: 0xffd700,
          emissive: 0xffaa00,
          emissiveIntensity: 0.6,
          shininess: 120
        });
        const center = new THREE.Mesh(centerGeo, centerMat);
        center.position.y = 1.4;
        group.add(center);

        // Small grape clusters around the center
        const miniGrapeGeo = new THREE.SphereGeometry(0.15, 12, 12);
        const miniGrapeMat = new THREE.MeshPhongMaterial({
          color: 0x9370db,
          shininess: 100,
          specular: 0xaa55aa,
          emissive: 0x6b2d87,
          emissiveIntensity: 0.3
        });

        for (let i = 0; i < 6; i++) {
          const angle = (i / 6) * Math.PI * 2;
          const miniGrape = new THREE.Mesh(miniGrapeGeo, miniGrapeMat.clone());
          miniGrape.position.set(
            Math.cos(angle) * 0.35,
            1.5 + Math.sin(i) * 0.1,
            Math.sin(angle) * 0.35
          );
          group.add(miniGrape);
        }

        // Leaves with purple tint
        for (let i = 0; i < 5; i++) {
          const leafGeo = new THREE.BoxGeometry(0.45, 0.02, 0.35);
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x6b4d8b : 0x8b6ba8,
            shininess: 50,
            side: THREE.DoubleSide
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const angle = (i / 5) * Math.PI * 2;
          leaf.position.set(Math.cos(angle) * 0.35, 1.0, Math.sin(angle) * 0.35);
          leaf.rotation.y = angle;
          leaf.rotation.z = 0.3;
          group.add(leaf);
        }

        // Golden glow (sun energy)
        const glowGeo = new THREE.SphereGeometry(0.8, 16, 16);
        const glowMat = new THREE.MeshBasicMaterial({
          color: 0xffff00,
          transparent: true,
          opacity: 0.2
        });
        const glow = new THREE.Mesh(glowGeo, glowMat);
        glow.position.y = 1.4;
        group.add(glow);

        break;
      }

      case 'pear-launcher': {
        // FUSION: Grape Launcher + Pear Cannon = Pear Launcher
        // Auto-fires pears with long cooldown

        // Heavy base platform
        const baseGeo = new THREE.CylinderGeometry(0.5, 0.6, 0.35, 16);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x654321,
          shininess: 20
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.175;
        group.add(base);

        // Stem with grape vine texture
        const stemGeo = new THREE.CylinderGeometry(0.18, 0.22, 1.0, 12);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x3d6b1f,
          shininess: 30,
          emissive: 0x1a3010,
          emissiveIntensity: 0.1
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.7;
        group.add(stem);

        // Pear-shaped body (golden)
        const bodyGeo = new THREE.SphereGeometry(0.45, 20, 20);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0xd4af37,
          shininess: 100,
          specular: 0xffd700,
          emissive: 0x3d2b0f,
          emissiveIntensity: 0.2
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.scale.set(1, 1.3, 1);
        body.position.y = 1.2;
        group.add(body);

        // Purple grape accents on the body
        const accentGeo = new THREE.SphereGeometry(0.12, 12, 12);
        const accentMat = new THREE.MeshPhongMaterial({
          color: 0x6b2d87,
          shininess: 100,
          emissive: 0x2d1035,
          emissiveIntensity: 0.3
        });

        for (let i = 0; i < 8; i++) {
          const angle = (i / 8) * Math.PI * 2;
          const accent = new THREE.Mesh(accentGeo, accentMat.clone());
          accent.position.set(
            Math.cos(angle) * 0.4,
            1.2 + Math.sin(i * 2) * 0.15,
            Math.sin(angle) * 0.4
          );
          group.add(accent);
        }

        // Cannon barrel (shorter than pear cannon)
        const barrelGeo = new THREE.CylinderGeometry(0.22, 0.18, 0.8, 16);
        const barrelMat = new THREE.MeshPhongMaterial({
          color: 0x333333,
          shininess: 80,
          specular: 0xaaaaaa
        });
        const barrel = new THREE.Mesh(barrelGeo, barrelMat);
        barrel.position.set(0.35, 1.5, 0);
        barrel.rotation.z = -Math.PI / 4;
        group.add(barrel);

        // Leaves sprouting from stem
        for (let i = 0; i < 6; i++) {
          const leafGeo = new THREE.BoxGeometry(0.4, 0.02, 0.3);
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x3d6b1f : 0x2d5016,
            shininess: 50,
            side: THREE.DoubleSide
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const angle = (i / 6) * Math.PI * 2;
          leaf.position.set(Math.cos(angle) * 0.3, 0.9, Math.sin(angle) * 0.3);
          leaf.rotation.y = angle;
          leaf.rotation.z = 0.25;
          group.add(leaf);
        }

        // Purple-gold glow effect
        const glowGeo = new THREE.SphereGeometry(0.9, 16, 16);
        const glowMat = new THREE.MeshBasicMaterial({
          color: 0xdaa520,
          transparent: true,
          opacity: 0.15
        });
        const glow = new THREE.Mesh(glowGeo, glowMat);
        glow.position.y = 1.2;
        group.add(glow);

        break;
      }

      case 'avocado-slammer': {
        // EPIC Avocado that slams zombies within 2 tiles - THE HULK OF PLANTS

        // Heavy reinforced pot with metal bands
        const potGeo = new THREE.CylinderGeometry(0.5, 0.4, 0.4, 16);
        const potMat = new THREE.MeshPhongMaterial({
          color: 0x6b4423,
          shininess: 50,
          specular: 0x443322
        });
        const pot = new THREE.Mesh(potGeo, potMat);
        pot.position.y = 0.2;
        group.add(pot);

        // Metal reinforcement bands
        for (let i = 0; i < 2; i++) {
          const bandGeo = new THREE.TorusGeometry(0.48 - i * 0.05, 0.04, 8, 20);
          const bandMat = new THREE.MeshPhongMaterial({
            color: 0x666666,
            shininess: 120,
            specular: 0xaaaaaa
          });
          const band = new THREE.Mesh(bandGeo, bandMat);
          band.position.y = 0.15 + i * 0.12;
          band.rotation.x = Math.PI / 2;
          group.add(band);
        }

        // Cracked soil showing power
        const soilGeo = new THREE.CylinderGeometry(0.45, 0.45, 0.06, 16);
        const soilMat = new THREE.MeshPhongMaterial({ color: 0x3d2817 });
        const soil = new THREE.Mesh(soilGeo, soilMat);
        soil.position.y = 0.38;
        group.add(soil);

        // Thick powerful stem with veins
        const stemGeo = new THREE.CylinderGeometry(0.25, 0.35, 0.7, 16);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x4a6b23,
          shininess: 40,
          specular: 0x556633
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.7;
        group.add(stem);

        // Stem veins showing power
        for (let i = 0; i < 6; i++) {
          const veinGeo = new THREE.CylinderGeometry(0.03, 0.02, 0.65, 6);
          const veinMat = new THREE.MeshPhongMaterial({
            color: 0x2d4a12,
            shininess: 30
          });
          const vein = new THREE.Mesh(veinGeo, veinMat);
          const angle = (i / 6) * Math.PI * 2;
          vein.position.set(Math.cos(angle) * 0.28, 0.68, Math.sin(angle) * 0.28);
          group.add(vein);
        }

        // Main avocado body - MASSIVE AND POWERFUL
        const avocadoGeo = new THREE.SphereGeometry(0.7, 24, 24);
        const avocadoMat = new THREE.MeshPhongMaterial({
          color: 0x4a7812,
          shininess: 100,
          specular: 0x88bb44,
          emissive: 0x1a3806,
          emissiveIntensity: 0.3
        });
        const avocado = new THREE.Mesh(avocadoGeo, avocadoMat);
        avocado.scale.set(1.1, 1.4, 1.1);
        avocado.position.y = 1.5;
        group.add(avocado);

        // Darker green patches for texture
        for (let i = 0; i < 8; i++) {
          const patchGeo = new THREE.SphereGeometry(0.2, 8, 8);
          const patchMat = new THREE.MeshPhongMaterial({
            color: 0x2d5a0a,
            shininess: 60,
            transparent: true,
            opacity: 0.7
          });
          const patch = new THREE.Mesh(patchGeo, patchMat);
          const angle = (i / 8) * Math.PI * 2;
          patch.position.set(
            Math.cos(angle) * 0.5,
            1.2 + Math.sin(i) * 0.4,
            Math.sin(angle) * 0.5
          );
          patch.scale.set(1.5, 1, 0.5);
          group.add(patch);
        }

        // EPIC glowing power seed (brown center with energy)
        const seedGeo = new THREE.SphereGeometry(0.35, 20, 20);
        const seedMat = new THREE.MeshPhongMaterial({
          color: 0x6b4020,
          shininess: 80,
          specular: 0x996633,
          emissive: 0x442200,
          emissiveIntensity: 0.4
        });
        const seed = new THREE.Mesh(seedGeo, seedMat);
        seed.position.set(0.35, 1.5, 0);
        group.add(seed);

        // Seed inner glow
        const seedGlowGeo = new THREE.SphereGeometry(0.25, 12, 12);
        const seedGlowMat = new THREE.MeshBasicMaterial({
          color: 0xff8844,
          transparent: true,
          opacity: 0.5
        });
        const seedGlow = new THREE.Mesh(seedGlowGeo, seedGlowMat);
        seedGlow.position.copy(seed.position);
        group.add(seedGlow);

        // ANGRY EYES with glowing effect
        const eyeWhiteGeo = new THREE.SphereGeometry(0.12, 12, 12);
        const eyeWhiteMat = new THREE.MeshPhongMaterial({ color: 0xffffff, shininess: 100 });

        const leftEyeWhite = new THREE.Mesh(eyeWhiteGeo, eyeWhiteMat);
        leftEyeWhite.position.set(0.55, 1.75, 0.25);
        group.add(leftEyeWhite);

        const rightEyeWhite = new THREE.Mesh(eyeWhiteGeo, eyeWhiteMat);
        rightEyeWhite.position.set(0.55, 1.75, -0.25);
        group.add(rightEyeWhite);

        // Angry red pupils
        const pupilGeo = new THREE.SphereGeometry(0.06, 10, 10);
        const pupilMat = new THREE.MeshPhongMaterial({
          color: 0xff2200,
          emissive: 0xff0000,
          emissiveIntensity: 0.8
        });

        const leftPupil = new THREE.Mesh(pupilGeo, pupilMat);
        leftPupil.position.set(0.65, 1.75, 0.25);
        group.add(leftPupil);

        const rightPupil = new THREE.Mesh(pupilGeo, pupilMat);
        rightPupil.position.set(0.65, 1.75, -0.25);
        group.add(rightPupil);

        // Angry eyebrows
        const browGeo = new THREE.BoxGeometry(0.2, 0.04, 0.08);
        const browMat = new THREE.MeshPhongMaterial({ color: 0x2d4a12 });

        const leftBrow = new THREE.Mesh(browGeo, browMat);
        leftBrow.position.set(0.55, 1.9, 0.25);
        leftBrow.rotation.set(-0.4, Math.PI / 2, 0);
        group.add(leftBrow);

        const rightBrow = new THREE.Mesh(browGeo, browMat);
        rightBrow.position.set(0.55, 1.9, -0.25);
        rightBrow.rotation.set(0.4, Math.PI / 2, 0);
        group.add(rightBrow);

        // MASSIVE MUSCULAR ARMS
        // Left arm - upper
        const upperArmGeo = new THREE.CylinderGeometry(0.2, 0.18, 0.6, 12);
        const armMat = new THREE.MeshPhongMaterial({
          color: 0x5a8020,
          shininess: 60,
          specular: 0x77aa44
        });

        const leftUpperArm = new THREE.Mesh(upperArmGeo, armMat);
        leftUpperArm.position.set(-0.7, 1.4, 0);
        leftUpperArm.rotation.z = Math.PI / 3;
        group.add(leftUpperArm);

        // Left forearm with veins
        const forearmGeo = new THREE.CylinderGeometry(0.18, 0.15, 0.55, 12);
        const leftForearm = new THREE.Mesh(forearmGeo, armMat);
        leftForearm.position.set(-1.0, 1.0, 0);
        leftForearm.rotation.z = Math.PI / 6;
        group.add(leftForearm);

        // Bicep bulge
        const bicepGeo = new THREE.SphereGeometry(0.15, 10, 10);
        const leftBicep = new THREE.Mesh(bicepGeo, armMat);
        leftBicep.position.set(-0.65, 1.35, 0.1);
        leftBicep.scale.set(1.3, 1, 1);
        group.add(leftBicep);

        // Right arm - upper
        const rightUpperArm = new THREE.Mesh(upperArmGeo, armMat);
        rightUpperArm.position.set(0.7, 1.4, 0);
        rightUpperArm.rotation.z = -Math.PI / 3;
        group.add(rightUpperArm);

        // Right forearm
        const rightForearm = new THREE.Mesh(forearmGeo, armMat);
        rightForearm.position.set(1.0, 1.0, 0);
        rightForearm.rotation.z = -Math.PI / 6;
        group.add(rightForearm);

        // Right bicep
        const rightBicep = new THREE.Mesh(bicepGeo, armMat);
        rightBicep.position.set(0.65, 1.35, 0.1);
        rightBicep.scale.set(1.3, 1, 1);
        group.add(rightBicep);

        // EPIC SLAMMING FISTS with power glow
        const fistGeo = new THREE.SphereGeometry(0.25, 16, 16);
        const fistMat = new THREE.MeshPhongMaterial({
          color: 0x3d6018,
          shininess: 80,
          specular: 0x668833
        });

        const leftFist = new THREE.Mesh(fistGeo, fistMat);
        leftFist.position.set(-1.15, 0.55, 0);
        leftFist.scale.set(1.2, 1, 1.1);
        group.add(leftFist);

        const rightFist = new THREE.Mesh(fistGeo, fistMat);
        rightFist.position.set(1.15, 0.55, 0);
        rightFist.scale.set(1.2, 1, 1.1);
        group.add(rightFist);

        // Fist power glow
        const fistGlowGeo = new THREE.SphereGeometry(0.35, 12, 12);
        const fistGlowMat = new THREE.MeshBasicMaterial({
          color: 0x88ff44,
          transparent: true,
          opacity: 0.4
        });

        const leftFistGlow = new THREE.Mesh(fistGlowGeo, fistGlowMat);
        leftFistGlow.position.copy(leftFist.position);
        group.add(leftFistGlow);

        const rightFistGlow = new THREE.Mesh(fistGlowGeo, fistGlowMat);
        rightFistGlow.position.copy(rightFist.position);
        group.add(rightFistGlow);

        // Knuckle details
        for (let f = 0; f < 2; f++) {
          const fistPos = f === 0 ? leftFist.position : rightFist.position;
          for (let k = 0; k < 4; k++) {
            const knuckleGeo = new THREE.SphereGeometry(0.06, 8, 8);
            const knuckleMat = new THREE.MeshPhongMaterial({
              color: 0x4a7820,
              shininess: 60
            });
            const knuckle = new THREE.Mesh(knuckleGeo, knuckleMat);
            knuckle.position.set(
              fistPos.x + (f === 0 ? -0.1 : 0.1),
              fistPos.y + 0.15,
              fistPos.z + (k - 1.5) * 0.08
            );
            group.add(knuckle);
          }
        }

        // Power aura around the avocado
        const auraGeo = new THREE.SphereGeometry(1.0, 20, 20);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x88ff44,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 1.3;
        group.add(aura);

        // Ground impact cracks visual (static)
        for (let i = 0; i < 6; i++) {
          const crackGeo = new THREE.BoxGeometry(0.6, 0.02, 0.05);
          const crackMat = new THREE.MeshBasicMaterial({
            color: 0x88ff44,
            transparent: true,
            opacity: 0.6
          });
          const crack = new THREE.Mesh(crackGeo, crackMat);
          const angle = (i / 6) * Math.PI * 2;
          crack.position.set(Math.cos(angle) * 0.5, 0.02, Math.sin(angle) * 0.5);
          crack.rotation.y = angle;
          group.add(crack);
        }

        break;
      }

      case 'pickle-picker': {
        // Pickle that teleports zombies back

        // Pot base
        const potGeo = new THREE.CylinderGeometry(0.35, 0.25, 0.25, 12);
        const potMat = new THREE.MeshPhongMaterial({ color: 0x8b4513, shininess: 30 });
        const pot = new THREE.Mesh(potGeo, potMat);
        pot.position.y = 0.125;
        group.add(pot);

        // Vine stem (curly)
        const stemGeo = new THREE.CylinderGeometry(0.1, 0.12, 1.0, 12);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x2d5016,
          shininess: 20
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.7;
        stem.rotation.z = 0.2;
        group.add(stem);

        // Main pickle body (bumpy green)
        const pickleGeo = new THREE.CylinderGeometry(0.25, 0.3, 1.2, 12);
        const pickleMat = new THREE.MeshPhongMaterial({
          color: 0x3f7d20,
          shininess: 60,
          emissive: 0x1f3e10,
          emissiveIntensity: 0.2
        });
        const pickle = new THREE.Mesh(pickleGeo, pickleMat);
        pickle.position.y = 1.4;
        group.add(pickle);

        // Bumps on pickle
        for (let i = 0; i < 12; i++) {
          const bumpGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const bumpMat = new THREE.MeshPhongMaterial({
            color: 0x2d5a15,
            shininess: 40
          });
          const bump = new THREE.Mesh(bumpGeo, bumpMat);
          const angle = (i / 12) * Math.PI * 2;
          const height = 0.8 + (i % 4) * 0.3;
          bump.position.set(
            Math.cos(angle) * 0.28,
            height,
            Math.sin(angle) * 0.28
          );
          group.add(bump);
        }

        // Portal/teleport effect (purple swirl)
        for (let i = 0; i < 8; i++) {
          const portalGeo = new THREE.TorusGeometry(0.3 + i * 0.1, 0.03, 8, 16);
          const portalMat = new THREE.MeshBasicMaterial({
            color: 0x9370db,
            transparent: true,
            opacity: 0.4 - i * 0.04
          });
          const portal = new THREE.Mesh(portalGeo, portalMat);
          portal.position.y = 1.4 + i * 0.1;
          portal.rotation.x = Math.PI / 2 + i * 0.1;
          group.add(portal);
        }

        // Magical sparkles
        for (let i = 0; i < 15; i++) {
          const sparkleGeo = new THREE.SphereGeometry(0.05, 8, 8);
          const sparkleMat = new THREE.MeshBasicMaterial({
            color: 0xda70d6,
            transparent: true,
            opacity: 0.7
          });
          const sparkle = new THREE.Mesh(sparkleGeo, sparkleMat);
          const angle = Math.random() * Math.PI * 2;
          const radius = Math.random() * 0.8 + 0.3;
          sparkle.position.set(
            Math.cos(angle) * radius,
            0.5 + Math.random() * 1.5,
            Math.sin(angle) * radius
          );
          group.add(sparkle);
        }

        // Mystical eyes
        const eyeGeo = new THREE.SphereGeometry(0.08, 12, 12);
        const eyeMat = new THREE.MeshPhongMaterial({
          color: 0x9370db,
          emissive: 0x9370db,
          emissiveIntensity: 1.0
        });

        const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
        leftEye.position.set(0.26, 1.6, 0.12);
        group.add(leftEye);

        const rightEye = new THREE.Mesh(eyeGeo, eyeMat);
        rightEye.position.set(0.26, 1.6, -0.12);
        group.add(rightEye);

        // Purple glow aura
        const glowGeo = new THREE.SphereGeometry(0.8, 16, 16);
        const glowMat = new THREE.MeshBasicMaterial({
          color: 0x9370db,
          transparent: true,
          opacity: 0.2
        });
        const glow = new THREE.Mesh(glowGeo, glowMat);
        glow.position.y = 1.4;
        group.add(glow);

        break;
      }

      case 'pear-wall': {
        // PEAR FORTRESS - Fusion of pear-cannon and vine-wall

        // Base platform
        const baseGeo = new THREE.BoxGeometry(1.0, 0.2, 1.0);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x5a4020,
          shininess: 40
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.12;
        group.add(base);

        // Main wall structure - taller and imposing
        const wallGeo = new THREE.BoxGeometry(0.85, 2.2, 0.95);
        const wallMat = new THREE.MeshPhongMaterial({
          color: 0xc5e636,
          shininess: 80,
          specular: 0xffffaa,
          emissive: 0x4a5a10,
          emissiveIntensity: 0.1
        });
        const wall = new THREE.Mesh(wallGeo, wallMat);
        wall.position.y = 1.3;
        group.add(wall);

        // Gold trim bands
        for (let i = 0; i < 3; i++) {
          const bandGeo = new THREE.BoxGeometry(0.9, 0.1, 1.0);
          const bandMat = new THREE.MeshPhongMaterial({
            color: 0xdaa520,
            shininess: 120,
            specular: 0xffee88
          });
          const band = new THREE.Mesh(bandGeo, bandMat);
          band.position.y = 0.5 + i * 0.7;
          group.add(band);
        }

        // Giant pear face in center
        const faceGeo = new THREE.SphereGeometry(0.4, 20, 20);
        const faceMat = new THREE.MeshPhongMaterial({
          color: 0xb8d430,
          shininess: 90,
          emissive: 0x5a6a18,
          emissiveIntensity: 0.15
        });
        const face = new THREE.Mesh(faceGeo, faceMat);
        face.scale.set(1, 1.3, 0.5);
        face.position.set(0.45, 1.3, 0);
        group.add(face);

        // Angry eyes
        const eyeGeo = new THREE.SphereGeometry(0.08, 12, 12);
        const eyeMat = new THREE.MeshPhongMaterial({ color: 0x111111, shininess: 100 });
        const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
        leftEye.position.set(0.52, 1.4, -0.15);
        group.add(leftEye);
        const rightEye = new THREE.Mesh(eyeGeo, eyeMat);
        rightEye.position.set(0.52, 1.4, 0.15);
        group.add(rightEye);

        // Angry eyebrows
        const browGeo = new THREE.BoxGeometry(0.15, 0.04, 0.06);
        const browMat = new THREE.MeshPhongMaterial({ color: 0x3a2a10 });
        const leftBrow = new THREE.Mesh(browGeo, browMat);
        leftBrow.position.set(0.55, 1.52, -0.15);
        leftBrow.rotation.z = -0.4;
        group.add(leftBrow);
        const rightBrow = new THREE.Mesh(browGeo, browMat);
        rightBrow.position.set(0.55, 1.52, 0.15);
        rightBrow.rotation.z = 0.4;
        group.add(rightBrow);

        // Eye specular highlights
        {
          const highlightGeo = new THREE.SphereGeometry(0.03, 8, 8);
          const highlightMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const leftHighlight = new THREE.Mesh(highlightGeo, highlightMat);
          leftHighlight.position.set(0.56, 1.42, -0.17);
          group.add(leftHighlight);
          const rightHighlight = new THREE.Mesh(highlightGeo, highlightMat);
          rightHighlight.position.set(0.56, 1.42, 0.13);
          group.add(rightHighlight);
        }

        // Angry mouth
        {
          const mouthGeo = new THREE.BoxGeometry(0.04, 0.04, 0.18);
          const mouthMat = new THREE.MeshPhongMaterial({ color: 0x3a1a08, shininess: 30 });
          const mouth = new THREE.Mesh(mouthGeo, mouthMat);
          mouth.position.set(0.56, 1.22, 0);
          group.add(mouth);
        }

        // Crenellation battlements on top
        for (let i = 0; i < 7; i++) {
          const crenGeo = new THREE.BoxGeometry(0.12, 0.2, 0.1);
          const crenMat = new THREE.MeshPhongMaterial({
            color: 0xa8c832,
            shininess: 50,
            emissive: 0x4a5a10,
            emissiveIntensity: 0.08
          });
          const cren = new THREE.Mesh(crenGeo, crenMat);
          cren.position.set(0, 2.5, -0.4 + i * 0.13);
          group.add(cren);
        }

        // Side cannons (mini pear cannons)
        for (let side = -1; side <= 1; side += 2) {
          const cannonGeo = new THREE.CylinderGeometry(0.12, 0.1, 0.45, 12);
          const cannonMat = new THREE.MeshPhongMaterial({
            color: 0x8b5a2b,
            shininess: 80
          });
          const cannon = new THREE.Mesh(cannonGeo, cannonMat);
          cannon.position.set(0.5, 1.0, side * 0.35);
          cannon.rotation.z = -Math.PI / 2;
          group.add(cannon);

          // Cannon glow
          const glowGeo = new THREE.CircleGeometry(0.08, 12);
          const glowMat = new THREE.MeshBasicMaterial({
            color: 0xffcc00,
            transparent: true,
            opacity: 0.8
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.set(0.75, 1.0, side * 0.35);
          glow.rotation.y = Math.PI / 2;
          group.add(glow);
        }

        // Vines wrapping around
        for (let i = 0; i < 4; i++) {
          const vineGeo = new THREE.TorusGeometry(0.5 + i * 0.06, 0.05, 8, 20, Math.PI);
          const vineMat = new THREE.MeshPhongMaterial({
            color: 0x2d6016,
            shininess: 40
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(-0.08, 0.45 + i * 0.5, 0);
          vine.rotation.y = Math.PI / 2;
          group.add(vine);
        }

        // Pear fortress aura
        {
          const auraGeo = new THREE.SphereGeometry(1.4, 16, 16);
          const auraMat = new THREE.MeshBasicMaterial({
            color: 0xccee44,
            transparent: true,
            opacity: 0.08
          });
          const aura = new THREE.Mesh(auraGeo, auraMat);
          aura.position.y = 1.3;
          group.add(aura);
        }

        break;
      }

      case 'frost-slammer': {
        // EPIC FROST SLAMMER - Hulking Ice Berserker Golem

        // === FROZEN GROUND EFFECT ===
        const groundIceGeo = new THREE.CylinderGeometry(0.7, 0.8, 0.12, 16);
        const groundIceMat = new THREE.MeshPhongMaterial({
          color: 0x88ddff,
          shininess: 200,
          transparent: true,
          opacity: 0.6,
          emissive: 0x44aaff,
          emissiveIntensity: 0.3
        });
        const groundIce = new THREE.Mesh(groundIceGeo, groundIceMat);
        groundIce.position.y = 0.06;
        group.add(groundIce);

        // Ice spikes erupting from ground
        for (let i = 0; i < 8; i++) {
          const spikeHeight = 0.25 + Math.random() * 0.3;
          const spikeGeo = new THREE.ConeGeometry(0.07, spikeHeight, 4);
          const spikeMat = new THREE.MeshPhongMaterial({
            color: 0xccffff,
            shininess: 180,
            transparent: true,
            opacity: 0.85,
            emissive: 0x66ddff,
            emissiveIntensity: 0.4
          });
          const spike = new THREE.Mesh(spikeGeo, spikeMat);
          const angle = (i / 8) * Math.PI * 2 + Math.random() * 0.3;
          const radius = 0.55 + Math.random() * 0.2;
          spike.position.set(Math.cos(angle) * radius, spikeHeight / 2, Math.sin(angle) * radius);
          spike.rotation.x = (Math.random() - 0.5) * 0.3;
          spike.rotation.z = (Math.random() - 0.5) * 0.3;
          group.add(spike);
        }

        // === MASSIVE LEGS ===
        for (let side = -1; side <= 1; side += 2) {
          const legGeo = new THREE.CylinderGeometry(0.18, 0.22, 0.6, 8);
          const legMat = new THREE.MeshPhongMaterial({
            color: 0x2288aa,
            shininess: 100,
            emissive: 0x115566,
            emissiveIntensity: 0.3
          });
          const leg = new THREE.Mesh(legGeo, legMat);
          leg.position.set(side * 0.35, 0.45, 0);
          group.add(leg);

          // Frozen foot
          const footGeo = new THREE.BoxGeometry(0.3, 0.15, 0.4);
          const footMat = new THREE.MeshPhongMaterial({
            color: 0x55bbdd,
            shininess: 120,
            emissive: 0x2288aa,
            emissiveIntensity: 0.3
          });
          const foot = new THREE.Mesh(footGeo, footMat);
          foot.position.set(side * 0.35, 0.12, 0.05);
          group.add(foot);
        }

        // === HULKING TORSO ===
        const torsoGeo = new THREE.SphereGeometry(0.55, 16, 16);
        const torsoMat = new THREE.MeshPhongMaterial({
          color: 0x3399bb,
          shininess: 130,
          emissive: 0x226688,
          emissiveIntensity: 0.4
        });
        const torso = new THREE.Mesh(torsoGeo, torsoMat);
        torso.scale.set(1.2, 1.0, 0.9);
        torso.position.y = 1.1;
        group.add(torso);

        // Ice armor chest plate
        const chestGeo = new THREE.BoxGeometry(0.7, 0.5, 0.25);
        const chestMat = new THREE.MeshPhongMaterial({
          color: 0x77ddff,
          shininess: 180,
          transparent: true,
          opacity: 0.8,
          emissive: 0x44bbff,
          emissiveIntensity: 0.5
        });
        const chest = new THREE.Mesh(chestGeo, chestMat);
        chest.position.set(0, 1.15, 0.35);
        group.add(chest);

        // Glowing frost core in chest
        const coreGeo = new THREE.SphereGeometry(0.18, 12, 12);
        const coreMat = new THREE.MeshBasicMaterial({
          color: 0x00ffff,
          transparent: true,
          opacity: 0.9
        });
        const core = new THREE.Mesh(coreGeo, coreMat);
        core.position.set(0, 1.15, 0.45);
        group.add(core);

        // Core outer glow
        const coreGlowGeo = new THREE.SphereGeometry(0.25, 12, 12);
        const coreGlowMat = new THREE.MeshBasicMaterial({
          color: 0x66ffff,
          transparent: true,
          opacity: 0.4
        });
        const coreGlow = new THREE.Mesh(coreGlowGeo, coreGlowMat);
        coreGlow.position.set(0, 1.15, 0.45);
        group.add(coreGlow);

        // === MASSIVE ARMS ===
        for (let side = -1; side <= 1; side += 2) {
          // Shoulder
          const shoulderGeo = new THREE.SphereGeometry(0.22, 10, 10);
          const shoulderMat = new THREE.MeshPhongMaterial({
            color: 0x4499bb,
            shininess: 100,
            emissive: 0x226688,
            emissiveIntensity: 0.3
          });
          const shoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
          shoulder.position.set(side * 0.65, 1.3, 0);
          group.add(shoulder);

          // Upper arm (thick and muscular)
          const upperArmGeo = new THREE.CylinderGeometry(0.16, 0.2, 0.5, 8);
          const upperArmMat = new THREE.MeshPhongMaterial({
            color: 0x55aacc,
            shininess: 110,
            emissive: 0x337799,
            emissiveIntensity: 0.3
          });
          const upperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
          upperArm.position.set(side * 0.8, 1.05, 0);
          upperArm.rotation.z = side * 0.4;
          group.add(upperArm);

          // Forearm (even thicker - powerful)
          const forearmGeo = new THREE.CylinderGeometry(0.2, 0.16, 0.55, 8);
          const forearmMat = new THREE.MeshPhongMaterial({
            color: 0x66bbdd,
            shininess: 120,
            emissive: 0x4499bb,
            emissiveIntensity: 0.35
          });
          const forearm = new THREE.Mesh(forearmGeo, forearmMat);
          forearm.position.set(side * 0.95, 0.65, 0);
          forearm.rotation.z = side * 0.2;
          group.add(forearm);

          // === MASSIVE SPIKED FISTS ===
          const fistGeo = new THREE.DodecahedronGeometry(0.32, 0);
          const fistMat = new THREE.MeshPhongMaterial({
            color: 0x88ddff,
            shininess: 150,
            emissive: 0x55bbee,
            emissiveIntensity: 0.5
          });
          const fist = new THREE.Mesh(fistGeo, fistMat);
          fist.position.set(side * 1.1, 0.35, 0);
          group.add(fist);

          // Ice knuckle spikes
          for (let i = 0; i < 4; i++) {
            const knuckleGeo = new THREE.ConeGeometry(0.06, 0.35, 4);
            const knuckleMat = new THREE.MeshPhongMaterial({
              color: 0xccffff,
              shininess: 180,
              emissive: 0x88eeff,
              emissiveIntensity: 0.6
            });
            const knuckle = new THREE.Mesh(knuckleGeo, knuckleMat);
            const angle = (i / 4) * Math.PI - Math.PI / 2;
            knuckle.position.set(
              side * 1.1 + side * Math.cos(angle) * 0.25,
              0.35 + Math.sin(angle) * 0.2,
              Math.cos(angle + Math.PI / 2) * 0.2
            );
            knuckle.rotation.z = side * Math.PI / 2;
            knuckle.rotation.y = angle;
            group.add(knuckle);
          }
        }

        // === HEAD ===
        const headGeo = new THREE.SphereGeometry(0.28, 12, 12);
        const headMat = new THREE.MeshPhongMaterial({
          color: 0x55bbdd,
          shininess: 120,
          emissive: 0x3399bb,
          emissiveIntensity: 0.4
        });
        const head = new THREE.Mesh(headGeo, headMat);
        head.scale.set(1, 0.9, 0.85);
        head.position.y = 1.65;
        group.add(head);

        // Glowing eyes
        for (let side = -1; side <= 1; side += 2) {
          const eyeGeo = new THREE.SphereGeometry(0.06, 8, 8);
          const eyeMat = new THREE.MeshBasicMaterial({
            color: 0x00ffff
          });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.1, 1.68, 0.2);
          group.add(eye);
        }

        // Ice crown spikes
        for (let i = 0; i < 5; i++) {
          const crownGeo = new THREE.ConeGeometry(0.04, 0.25 + Math.random() * 0.15, 4);
          const crownMat = new THREE.MeshPhongMaterial({
            color: 0xaaffff,
            shininess: 200,
            transparent: true,
            opacity: 0.9,
            emissive: 0x66ddff,
            emissiveIntensity: 0.5
          });
          const crown = new THREE.Mesh(crownGeo, crownMat);
          const angle = (i / 5) * Math.PI - Math.PI / 2;
          crown.position.set(Math.sin(angle) * 0.2, 1.9, Math.cos(angle) * 0.1);
          crown.rotation.x = -0.2;
          group.add(crown);
        }

        // === FROST AURA EFFECTS ===
        // Orbiting ice shards
        for (let i = 0; i < 6; i++) {
          const shardGeo = new THREE.OctahedronGeometry(0.1, 0);
          const shardMat = new THREE.MeshPhongMaterial({
            color: 0x88eeff,
            shininess: 180,
            transparent: true,
            opacity: 0.8,
            emissive: 0x44ccff,
            emissiveIntensity: 0.6
          });
          const shard = new THREE.Mesh(shardGeo, shardMat);
          const angle = (i / 6) * Math.PI * 2;
          shard.position.set(Math.cos(angle) * 0.9, 1.0 + (i % 2) * 0.5, Math.sin(angle) * 0.9);
          group.add(shard);
        }

        // Snow particles
        for (let i = 0; i < 12; i++) {
          const snowGeo = new THREE.SphereGeometry(0.03, 6, 6);
          const snowMat = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.8
          });
          const snow = new THREE.Mesh(snowGeo, snowMat);
          const angle = (i / 12) * Math.PI * 2;
          const radius = 0.6 + Math.random() * 0.4;
          snow.position.set(
            Math.cos(angle) * radius,
            0.8 + Math.random() * 1.2,
            Math.sin(angle) * radius
          );
          group.add(snow);
        }

        break;
      }

      case 'frost-pear-wall': {
        // FROST PEAR WALL - Advanced Fusion Ice Warrior Fortress
        // Height: 2.4, faces +X towards zombies

        // Frozen glacier base
        const baseGeo = new THREE.CylinderGeometry(0.7, 0.85, 0.25, 6);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x3377aa,
          shininess: 200,
          specular: 0xaaddff,
          emissive: 0x224466,
          emissiveIntensity: 0.4
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.12;
        group.add(base);

        // Glowing ice rune circle
        const runeGeo = new THREE.RingGeometry(0.55, 0.7, 6);
        const runeMat = new THREE.MeshBasicMaterial({
          color: 0x66ddff,
          transparent: true,
          opacity: 0.5,
          side: THREE.DoubleSide
        });
        const rune = new THREE.Mesh(runeGeo, runeMat);
        rune.rotation.x = -Math.PI / 2;
        rune.position.y = 0.26;
        rune.userData.isFrostAura = true;
        group.add(rune);

        // Main fortress wall - taller crystalline ice
        const wallGeo = new THREE.BoxGeometry(0.7, 2.4, 1.0);
        const wallMat = new THREE.MeshPhongMaterial({
          color: 0x4488bb,
          shininess: 200,
          specular: 0xffffff,
          emissive: 0x224488,
          emissiveIntensity: 0.5
        });
        const wall = new THREE.Mesh(wallGeo, wallMat);
        wall.position.y = 1.45;
        group.add(wall);

        // Glowing ice shell
        const shellGeo = new THREE.BoxGeometry(0.75, 2.45, 1.05);
        const shellMat = new THREE.MeshPhongMaterial({
          color: 0x88ccff,
          shininess: 250,
          transparent: true,
          opacity: 0.35,
          emissive: 0x44aaff,
          emissiveIntensity: 0.4
        });
        const shell = new THREE.Mesh(shellGeo, shellMat);
        shell.position.y = 1.45;
        group.add(shell);

        // Frost crack lines across wall face
        for (let i = 0; i < 5; i++) {
          const crackGeo = new THREE.BoxGeometry(0.02, 0.3 + Math.random() * 0.3, 0.02);
          const crackMat = new THREE.MeshBasicMaterial({
            color: 0xbbeeff,
            transparent: true,
            opacity: 0.7
          });
          const crack = new THREE.Mesh(crackGeo, crackMat);
          crack.position.set(0.37, 0.6 + i * 0.4, -0.3 + Math.random() * 0.6);
          crack.rotation.z = (Math.random() - 0.5) * 0.8;
          group.add(crack);
        }

        // Frozen pear face - frosty green, facing +X
        const pearGeo = new THREE.SphereGeometry(0.32, 16, 16);
        pearGeo.scale(0.9, 1.2, 0.8);
        const pearMat = new THREE.MeshPhongMaterial({
          color: 0x77bb66,
          shininess: 100,
          emissive: 0x446633,
          emissiveIntensity: 0.4
        });
        const pear = new THREE.Mesh(pearGeo, pearMat);
        pear.position.set(0.4, 1.5, 0);
        group.add(pear);

        // WARRIOR EYES - fierce glowing ice eyes facing +X
        for (let eye = -1; eye <= 1; eye += 2) {
          // Eye socket (dark)
          const socketGeo = new THREE.SphereGeometry(0.08, 10, 10);
          const socketMat = new THREE.MeshPhongMaterial({
            color: 0x224466,
            shininess: 50
          });
          const socket = new THREE.Mesh(socketGeo, socketMat);
          socket.position.set(0.55, 1.6, eye * 0.12);
          group.add(socket);

          // Glowing ice eye
          const eyeGeo = new THREE.SphereGeometry(0.06, 10, 10);
          const eyeMat = new THREE.MeshBasicMaterial({
            color: 0x00ffff,
            transparent: true,
            opacity: 0.95
          });
          const eyeMesh = new THREE.Mesh(eyeGeo, eyeMat);
          eyeMesh.position.set(0.58, 1.6, eye * 0.12);
          eyeMesh.userData.isPearEye = true;
          group.add(eyeMesh);
        }

        // Angry ice eyebrows
        for (let brow = -1; brow <= 1; brow += 2) {
          const browGeo = new THREE.BoxGeometry(0.12, 0.03, 0.04);
          const browMat = new THREE.MeshPhongMaterial({
            color: 0x3388bb,
            emissive: 0x2266aa,
            emissiveIntensity: 0.5
          });
          const browMesh = new THREE.Mesh(browGeo, browMat);
          browMesh.position.set(0.55, 1.72, brow * 0.12);
          browMesh.rotation.z = brow * 0.4;
          group.add(browMesh);
        }

        // Stern mouth line
        {
          const mouthGeo = new THREE.BoxGeometry(0.08, 0.02, 0.12);
          const mouthMat = new THREE.MeshPhongMaterial({ color: 0x224455 });
          const mouth = new THREE.Mesh(mouthGeo, mouthMat);
          mouth.position.set(0.55, 1.35, 0);
          group.add(mouth);

          // Frozen breath effect
          const breathGeo = new THREE.SphereGeometry(0.12, 8, 8);
          const breathMat = new THREE.MeshBasicMaterial({
            color: 0xccf0ff,
            transparent: true,
            opacity: 0.2
          });
          const breath = new THREE.Mesh(breathGeo, breathMat);
          breath.position.set(0.72, 1.35, 0);
          breath.scale.set(1.5, 0.6, 1.2);
          group.add(breath);
        }

        // ICE CRYSTAL CROWN on top
        for (let i = 0; i < 7; i++) {
          const crownGeo = new THREE.ConeGeometry(0.08, 0.4 + (i === 3 ? 0.2 : 0), 4);
          const crownMat = new THREE.MeshPhongMaterial({
            color: 0x88ddff,
            shininess: 250,
            specular: 0xffffff,
            transparent: true,
            opacity: 0.9,
            emissive: 0x44aaff,
            emissiveIntensity: 0.5
          });
          const crown = new THREE.Mesh(crownGeo, crownMat);
          crown.position.set(0, 2.8, -0.45 + i * 0.15);
          group.add(crown);
        }

        // ICE SPIKES pointing forward (+X towards zombies!)
        for (let i = 0; i < 6; i++) {
          const spikeGeo = new THREE.ConeGeometry(0.06, 0.35, 4);
          const spikeMat = new THREE.MeshPhongMaterial({
            color: 0xaaddff,
            shininess: 250,
            transparent: true,
            opacity: 0.85,
            emissive: 0x66bbff,
            emissiveIntensity: 0.4
          });
          const spike = new THREE.Mesh(spikeGeo, spikeMat);
          spike.position.set(0.4, 0.6 + (i % 3) * 0.45, -0.35 + (i % 4) * 0.23);
          spike.rotation.z = -Math.PI / 2;
          group.add(spike);
        }

        // Hanging icicles on sides
        for (let side = -1; side <= 1; side += 2) {
          for (let i = 0; i < 4; i++) {
            const icicleGeo = new THREE.ConeGeometry(0.04, 0.3, 4);
            const icicleMat = new THREE.MeshPhongMaterial({
              color: 0xccffff,
              shininess: 250,
              transparent: true,
              opacity: 0.8,
              emissive: 0x66ddff,
              emissiveIntensity: 0.2
            });
            const icicle = new THREE.Mesh(icicleGeo, icicleMat);
            icicle.position.set(0, 0.5 + i * 0.5, side * 0.55);
            icicle.rotation.z = Math.PI;
            group.add(icicle);
          }
        }

        // Frost aura
        {
          const auraGeo = new THREE.SphereGeometry(1.3, 16, 16);
          const auraMat = new THREE.MeshBasicMaterial({
            color: 0x66ccff,
            transparent: true,
            opacity: 0.1
          });
          const aura = new THREE.Mesh(auraGeo, auraMat);
          aura.position.y = 1.4;
          aura.userData.isFrostAura = true;
          group.add(aura);
        }

        // Floating ice crystals
        for (let i = 0; i < 8; i++) {
          const crystalGeo = new THREE.OctahedronGeometry(0.05, 0);
          const crystalMat = new THREE.MeshBasicMaterial({
            color: 0xaaffff,
            transparent: true,
            opacity: 0.8
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const angle = (i / 8) * Math.PI * 2;
          crystal.position.set(
            Math.cos(angle) * 0.65,
            0.8 + (i % 4) * 0.4,
            Math.sin(angle) * 0.65
          );
          crystal.userData.isIceParticle = true;
          crystal.userData.particleIndex = i;
          group.add(crystal);
        }

        break;
      }

      case 'tomato-spike': {
        // EPIC TOMATO SPIKE - Explosive spike bomb with menacing design

        // Dark obsidian base with molten cracks
        const baseGeo = new THREE.CylinderGeometry(0.5, 0.6, 0.3, 8);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x1a0a0a,
          shininess: 120,
          specular: 0xff2200,
          emissive: 0x330000,
          emissiveIntensity: 0.4
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.15;
        group.add(base);

        // Molten lava cracks on base
        for (let i = 0; i < 6; i++) {
          const crackGeo = new THREE.BoxGeometry(0.08, 0.32, 0.02);
          const crackMat = new THREE.MeshBasicMaterial({
            color: 0xff4400,
            transparent: true,
            opacity: 0.9
          });
          const crack = new THREE.Mesh(crackGeo, crackMat);
          const angle = (i / 6) * Math.PI * 2;
          crack.position.set(Math.cos(angle) * 0.35, 0.15, Math.sin(angle) * 0.35);
          crack.rotation.y = angle;
          group.add(crack);
        }

        // Twisted thorny stem
        const stemGeo = new THREE.CylinderGeometry(0.1, 0.15, 0.7, 12);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x1a3010,
          shininess: 40,
          emissive: 0x0a1505,
          emissiveIntensity: 0.3
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.65;
        group.add(stem);

        // Thorns on stem
        for (let i = 0; i < 6; i++) {
          const thornGeo = new THREE.ConeGeometry(0.04, 0.15, 6);
          const thornMat = new THREE.MeshPhongMaterial({
            color: 0x2d4016,
            shininess: 60
          });
          const thorn = new THREE.Mesh(thornGeo, thornMat);
          const angle = (i / 3) * Math.PI;
          const height = 0.45 + (i % 3) * 0.2;
          thorn.position.set(Math.cos(angle) * 0.15, height, Math.sin(angle) * 0.15);
          thorn.rotation.z = Math.PI / 2;
          thorn.rotation.y = angle;
          group.add(thorn);
        }

        // Main tomato body - larger and more menacing with glowing core
        const tomatoGeo = new THREE.SphereGeometry(0.55, 24, 24);
        const tomatoMat = new THREE.MeshPhongMaterial({
          color: 0xff2222,
          shininess: 100,
          specular: 0xff6666,
          emissive: 0xaa0000,
          emissiveIntensity: 0.5
        });
        const tomato = new THREE.Mesh(tomatoGeo, tomatoMat);
        tomato.position.y = 1.3;
        group.add(tomato);

        // Inner glowing core visible through translucent outer layer
        const coreGeo = new THREE.SphereGeometry(0.35, 16, 16);
        const coreMat = new THREE.MeshBasicMaterial({
          color: 0xffff00,
          transparent: true,
          opacity: 0.6
        });
        const core = new THREE.Mesh(coreGeo, coreMat);
        core.position.y = 1.3;
        group.add(core);

        // Deadly chrome spikes - triple layer pattern
        const spikeMatChrome = new THREE.MeshPhongMaterial({
          color: 0x555555,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0x111111,
          emissiveIntensity: 0.2
        });

        // Large main spikes (8 around equator)
        for (let i = 0; i < 8; i++) {
          const spikeGeo = new THREE.ConeGeometry(0.1, 0.7, 8);
          const spike = new THREE.Mesh(spikeGeo, spikeMatChrome);
          const angle = (i / 8) * Math.PI * 2;
          spike.position.set(
            Math.cos(angle) * 0.65,
            1.3,
            Math.sin(angle) * 0.65
          );
          spike.rotation.z = Math.PI / 2;
          spike.rotation.y = angle;
          group.add(spike);
        }

        // Upper ring of spikes (6)
        for (let i = 0; i < 6; i++) {
          const spikeGeo = new THREE.ConeGeometry(0.08, 0.5, 6);
          const spike = new THREE.Mesh(spikeGeo, spikeMatChrome);
          const angle = (i / 6) * Math.PI * 2 + 0.3;
          spike.position.set(
            Math.cos(angle) * 0.45,
            1.65,
            Math.sin(angle) * 0.45
          );
          spike.rotation.z = Math.PI / 4;
          spike.rotation.y = angle;
          group.add(spike);
        }

        // Lower ring of spikes (6)
        for (let i = 0; i < 6; i++) {
          const spikeGeo = new THREE.ConeGeometry(0.08, 0.5, 6);
          const spike = new THREE.Mesh(spikeGeo, spikeMatChrome);
          const angle = (i / 6) * Math.PI * 2 + 0.5;
          spike.position.set(
            Math.cos(angle) * 0.45,
            0.95,
            Math.sin(angle) * 0.45
          );
          spike.rotation.z = -Math.PI / 4;
          spike.rotation.y = angle;
          group.add(spike);
        }

        // Top spike
        const topSpikeGeo = new THREE.ConeGeometry(0.12, 0.6, 8);
        const topSpike = new THREE.Mesh(topSpikeGeo, spikeMatChrome);
        topSpike.position.y = 2.0;
        group.add(topSpike);

        // Danger warning aura - pulsing red energy field
        const auraGeo = new THREE.SphereGeometry(0.85, 20, 20);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xff0000,
          transparent: true,
          opacity: 0.25
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 1.3;
        group.add(aura);

        // Orbiting energy particles
        for (let i = 0; i < 8; i++) {
          const particleGeo = new THREE.SphereGeometry(0.06, 8, 8);
          const particleMat = new THREE.MeshBasicMaterial({
            color: 0xffaa00,
            transparent: true,
            opacity: 0.8
          });
          const particle = new THREE.Mesh(particleGeo, particleMat);
          const angle = (i / 8) * Math.PI * 2;
          particle.position.set(Math.cos(angle) * 0.9, 1.3 + Math.sin(i) * 0.2, Math.sin(angle) * 0.9);
          group.add(particle);
        }

        break;
      }

      case 'elder-tomato-spike': {
        // ANCIENT ELDER TOMATO SPIKE - Devastating explosive spike damage

        // Golden ancient pedestal base
        const elderPedestalGeo = new THREE.CylinderGeometry(0.55, 0.65, 0.35, 8);
        const elderPedestalMat = new THREE.MeshPhongMaterial({
          color: 0xffd700,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0xff4500,
          emissiveIntensity: 0.3
        });
        const elderPedestal = new THREE.Mesh(elderPedestalGeo, elderPedestalMat);
        elderPedestal.position.y = 0.175;
        group.add(elderPedestal);

        // Ancient rune rings on base
        for (let ring = 0; ring < 2; ring++) {
          const runeRingGeo = new THREE.TorusGeometry(0.5 + ring * 0.15, 0.03, 8, 24);
          const runeRingMat = new THREE.MeshPhongMaterial({
            color: 0xff6600,
            emissive: 0xff3300,
            emissiveIntensity: 0.8,
            shininess: 100
          });
          const runeRing = new THREE.Mesh(runeRingGeo, runeRingMat);
          runeRing.rotation.x = Math.PI / 2;
          runeRing.position.y = 0.05 + ring * 0.1;
          group.add(runeRing);
        }

        // Thick ancient stem with thorns
        const elderStemGeo = new THREE.CylinderGeometry(0.18, 0.22, 0.7, 12);
        const elderStemMat = new THREE.MeshPhongMaterial({
          color: 0x1a3d0c,
          shininess: 40,
          emissive: 0x0a1f05,
          emissiveIntensity: 0.2
        });
        const elderStem = new THREE.Mesh(elderStemGeo, elderStemMat);
        elderStem.position.y = 0.7;
        group.add(elderStem);

        // Stem thorns
        for (let i = 0; i < 8; i++) {
          const thornGeo = new THREE.ConeGeometry(0.05, 0.2, 4);
          const thornMat = new THREE.MeshPhongMaterial({
            color: 0x2d1a0a,
            shininess: 80
          });
          const thorn = new THREE.Mesh(thornGeo, thornMat);
          const angle = (i / 8) * Math.PI * 2;
          const height = 0.5 + (i % 3) * 0.15;
          thorn.position.set(Math.cos(angle) * 0.2, height, Math.sin(angle) * 0.2);
          thorn.rotation.z = Math.PI / 2;
          thorn.rotation.y = angle;
          group.add(thorn);
        }

        // MASSIVE elder tomato body with golden veins
        const elderTomatoGeo = new THREE.SphereGeometry(0.65, 32, 32);
        const elderTomatoMat = new THREE.MeshPhongMaterial({
          color: 0xcc0000,
          shininess: 120,
          specular: 0xff4444,
          emissive: 0x880000,
          emissiveIntensity: 0.5
        });
        const elderTomato = new THREE.Mesh(elderTomatoGeo, elderTomatoMat);
        elderTomato.position.y = 1.4;
        group.add(elderTomato);

        // Golden vein patterns on tomato
        for (let v = 0; v < 6; v++) {
          const veinGeo = new THREE.TorusGeometry(0.5, 0.025, 6, 16, Math.PI);
          const veinMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            emissive: 0xffa500,
            emissiveIntensity: 0.6,
            shininess: 150
          });
          const vein = new THREE.Mesh(veinGeo, veinMat);
          vein.position.y = 1.4;
          vein.rotation.y = (v / 6) * Math.PI * 2;
          vein.rotation.x = Math.PI / 2;
          group.add(vein);
        }

        // Inner core glow
        const elderCoreGeo = new THREE.SphereGeometry(0.4, 20, 20);
        const elderCoreMat = new THREE.MeshBasicMaterial({
          color: 0xffff00,
          transparent: true,
          opacity: 0.6
        });
        const elderCore = new THREE.Mesh(elderCoreGeo, elderCoreMat);
        elderCore.position.y = 1.4;
        group.add(elderCore);

        // MASSIVE golden-tipped spikes - more and deadlier
        const elderSpikeGeo = new THREE.ConeGeometry(0.15, 0.9, 8);
        const elderSpikeMat = new THREE.MeshPhongMaterial({
          color: 0x1a1a1a,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0x330000,
          emissiveIntensity: 0.3
        });

        // Create many spikes in all directions
        for (let i = 0; i < 20; i++) {
          const spike = new THREE.Mesh(elderSpikeGeo, elderSpikeMat.clone());
          const angle = (i / 20) * Math.PI * 2;
          const elevation = ((i % 4) - 1.5) * 0.25;

          spike.position.set(
            Math.cos(angle) * 0.8,
            1.4 + elevation,
            Math.sin(angle) * 0.8
          );

          spike.rotation.z = Math.PI / 2;
          spike.rotation.y = angle;
          group.add(spike);

          // Golden spike tips
          const tipGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            emissive: 0xff8c00,
            emissiveIntensity: 0.9,
            shininess: 200
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(
            Math.cos(angle) * 1.2,
            1.4 + elevation,
            Math.sin(angle) * 1.2
          );
          group.add(tip);
        }

        // Crown of top spikes
        for (let i = 0; i < 5; i++) {
          const topSpike = new THREE.Mesh(elderSpikeGeo.clone(), elderSpikeMat.clone());
          const angle = (i / 5) * Math.PI * 2;
          topSpike.position.set(
            Math.cos(angle) * 0.3,
            2.0,
            Math.sin(angle) * 0.3
          );
          topSpike.rotation.x = -0.3;
          topSpike.rotation.y = angle;
          group.add(topSpike);
        }

        // Central mega spike on top
        const megaSpikeGeo = new THREE.ConeGeometry(0.2, 1.2, 8);
        const megaSpikeMat = new THREE.MeshPhongMaterial({
          color: 0x000000,
          shininess: 200,
          specular: 0xffffff,
          emissive: 0xffd700,
          emissiveIntensity: 0.4
        });
        const megaSpike = new THREE.Mesh(megaSpikeGeo, megaSpikeMat);
        megaSpike.position.y = 2.4;
        group.add(megaSpike);

        // Orbiting ancient rune symbols
        for (let i = 0; i < 6; i++) {
          const runeGeo = new THREE.OctahedronGeometry(0.12, 0);
          const runeMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            emissive: 0xff6600,
            emissiveIntensity: 1.0,
            shininess: 150
          });
          const rune = new THREE.Mesh(runeGeo, runeMat);
          const angle = (i / 6) * Math.PI * 2;
          rune.position.set(
            Math.cos(angle) * 1.0,
            1.4 + Math.sin(i * 2) * 0.3,
            Math.sin(angle) * 1.0
          );
          group.add(rune);
        }

        // Multiple intense glow layers
        for (let g = 0; g < 3; g++) {
          const glowGeo = new THREE.SphereGeometry(0.9 + g * 0.25, 20, 20);
          const glowMat = new THREE.MeshBasicMaterial({
            color: g === 0 ? 0xff0000 : (g === 1 ? 0xff6600 : 0xffd700),
            transparent: true,
            opacity: 0.15 - g * 0.04
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.y = 1.4;
          group.add(glow);
        }

        // Fire particle effects around base
        for (let f = 0; f < 12; f++) {
          const fireGeo = new THREE.ConeGeometry(0.06, 0.25, 6);
          const fireMat = new THREE.MeshBasicMaterial({
            color: f % 2 === 0 ? 0xff4500 : 0xffd700,
            transparent: true,
            opacity: 0.8
          });
          const fire = new THREE.Mesh(fireGeo, fireMat);
          const angle = (f / 12) * Math.PI * 2;
          fire.position.set(
            Math.cos(angle) * 0.6,
            0.3 + Math.random() * 0.2,
            Math.sin(angle) * 0.6
          );
          group.add(fire);
        }

        break;
      }

      case 'strawberry-launcher': {
        // ULTIMATE rapid-fire strawberry turret with incredible details

        // Heavy armored platform base
        const platformGeo = new THREE.CylinderGeometry(0.6, 0.7, 0.15, 20);
        const platformMat = new THREE.MeshPhongMaterial({
          color: 0x4a2a15,
          shininess: 70,
          specular: 0x886644,
          emissive: 0x1a0a05,
          emissiveIntensity: 0.1
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.075;
        group.add(platform);

        // Glowing red energy channels on platform
        for (let i = 0; i < 8; i++) {
          const channelGeo = new THREE.BoxGeometry(0.04, 0.04, 0.3);
          const channelMat = new THREE.MeshPhongMaterial({
            color: 0xff3366,
            emissive: 0xff3366,
            emissiveIntensity: 0.9,
            shininess: 100
          });
          const channel = new THREE.Mesh(channelGeo, channelMat);
          const angle = (i / 8) * Math.PI * 2;
          channel.position.set(
            Math.cos(angle) * 0.45,
            0.1,
            Math.sin(angle) * 0.45
          );
          channel.rotation.y = angle;
          group.add(channel);
        }

        // Heavy reinforced pot with metallic bands
        const potGeo = new THREE.CylinderGeometry(0.45, 0.5, 0.35, 20);
        const potMat = new THREE.MeshPhongMaterial({
          color: 0x5a3a1a,
          shininess: 60,
          specular: 0x8b6914,
          emissive: 0x2a1a0a,
          emissiveIntensity: 0.1
        });
        const pot = new THREE.Mesh(potGeo, potMat);
        pot.position.y = 0.325;
        group.add(pot);

        // Multiple metallic reinforcement rings
        for (let r = 0; r < 3; r++) {
          const ringGeo = new THREE.TorusGeometry(0.47 - r * 0.05, 0.04, 8, 20);
          const ringMat = new THREE.MeshPhongMaterial({
            color: r === 1 ? 0xffd700 : 0xcc6666,
            shininess: 150,
            specular: 0xffffff,
            emissive: r === 1 ? 0xaa8800 : 0x884444,
            emissiveIntensity: 0.4
          });
          const ring = new THREE.Mesh(ringGeo, ringMat);
          ring.position.y = 0.22 + r * 0.1;
          ring.rotation.x = Math.PI / 2;
          group.add(ring);
        }

        // Decorative strawberry emblems on pot
        for (let i = 0; i < 4; i++) {
          const emblemGeo = new THREE.SphereGeometry(0.08, 10, 10);
          const emblemMat = new THREE.MeshPhongMaterial({
            color: 0xff4466,
            emissive: 0xff2244,
            emissiveIntensity: 0.5,
            shininess: 100
          });
          const emblem = new THREE.Mesh(emblemGeo, emblemMat);
          const angle = (i / 4) * Math.PI * 2;
          emblem.position.set(
            Math.cos(angle) * 0.48,
            0.3,
            Math.sin(angle) * 0.48
          );
          emblem.scale.set(1, 1.2, 0.5);
          group.add(emblem);
        }

        // Main strawberry body - larger and ultra glossy
        const bodyGeo = new THREE.SphereGeometry(0.5, 24, 24);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0xff3366,
          shininess: 120,
          specular: 0xff88aa,
          emissive: 0xff1144,
          emissiveIntensity: 0.25
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.scale.set(1, 1.4, 1);
        body.position.y = 1.0;
        group.add(body);

        // Gradient color layer on strawberry (darker at bottom)
        const gradientGeo = new THREE.SphereGeometry(0.48, 20, 20, 0, Math.PI * 2, 0, Math.PI / 2);
        const gradientMat = new THREE.MeshPhongMaterial({
          color: 0xcc2244,
          shininess: 100,
          transparent: true,
          opacity: 0.6
        });
        const gradient = new THREE.Mesh(gradientGeo, gradientMat);
        gradient.scale.set(1, 1.4, 1);
        gradient.position.y = 1.0;
        gradient.rotation.x = Math.PI;
        group.add(gradient);

        // Highlight shine on strawberry
        const shineGeo = new THREE.SphereGeometry(0.2, 12, 12);
        const shineMat = new THREE.MeshBasicMaterial({
          color: 0xffffff,
          transparent: true,
          opacity: 0.3
        });
        const shine = new THREE.Mesh(shineGeo, shineMat);
        shine.position.set(-0.2, 1.2, 0.3);
        shine.scale.set(1, 0.6, 0.5);
        group.add(shine);

        // Detailed texture bumps on strawberry in pattern
        for (let ring = 0; ring < 6; ring++) {
          const numBumps = 8 + ring * 2;
          for (let i = 0; i < numBumps; i++) {
            const bumpGeo = new THREE.SphereGeometry(0.03, 6, 6);
            const bumpMat = new THREE.MeshPhongMaterial({
              color: 0xdd2255,
              shininess: 80,
              emissive: 0x881133,
              emissiveIntensity: 0.1
            });
            const bump = new THREE.Mesh(bumpGeo, bumpMat);
            const angle = (i / numBumps) * Math.PI * 2 + ring * 0.2;
            const heightFactor = (ring + 1) / 7;
            const height = 0.55 + heightFactor * 0.8;
            const radius = 0.44 * Math.sin(heightFactor * Math.PI);
            bump.position.set(
              Math.cos(angle) * radius,
              height,
              Math.sin(angle) * radius
            );
            group.add(bump);
          }
        }

        // Glowing yellow seeds in organized pattern
        for (let ring = 0; ring < 5; ring++) {
          const numSeeds = 6 + ring * 2;
          for (let i = 0; i < numSeeds; i++) {
            const seedGeo = new THREE.SphereGeometry(0.045, 10, 10);
            const seedMat = new THREE.MeshPhongMaterial({
              color: 0xffff00,
              emissive: 0xffff00,
              emissiveIntensity: 0.9,
              shininess: 120
            });
            const seed = new THREE.Mesh(seedGeo, seedMat);
            const angle = (i / numSeeds) * Math.PI * 2 + ring * 0.3;
            const heightFactor = (ring + 0.5) / 5;
            const height = 0.6 + heightFactor * 0.75;
            const radius = 0.46 * Math.sin(heightFactor * Math.PI);
            seed.position.set(
              Math.cos(angle) * radius,
              height,
              Math.sin(angle) * radius
            );
            group.add(seed);

            // Glow for each seed
            const glowGeo = new THREE.SphereGeometry(0.07, 8, 8);
            const glowMat = new THREE.MeshBasicMaterial({
              color: 0xffff00,
              transparent: true,
              opacity: 0.4
            });
            const glow = new THREE.Mesh(glowGeo, glowMat);
            glow.position.copy(seed.position);
            group.add(glow);
          }
        }

        // Epic green leafy crown at top - more detailed
        for (let layer = 0; layer < 2; layer++) {
          for (let i = 0; i < 8; i++) {
            const leafGeo = new THREE.BoxGeometry(0.35 - layer * 0.1, 0.05, 0.22 - layer * 0.05);
            const leafMat = new THREE.MeshPhongMaterial({
              color: layer === 0 ? 0x1a5010 : 0x2d7020,
              shininess: 50,
              specular: 0x3d9026,
              emissive: 0x0a2005,
              emissiveIntensity: 0.2,
              side: THREE.DoubleSide
            });
            const leaf = new THREE.Mesh(leafGeo, leafMat);
            const angle = (i / 8) * Math.PI * 2 + layer * 0.2;
            leaf.position.set(
              Math.cos(angle) * (0.2 - layer * 0.05),
              1.5 + layer * 0.08,
              Math.sin(angle) * (0.2 - layer * 0.05)
            );
            leaf.rotation.y = angle;
            leaf.rotation.z = -0.6 + layer * 0.2;
            group.add(leaf);
          }
        }

        // Central stem with detail
        const stemGeo = new THREE.CylinderGeometry(0.06, 0.1, 0.18, 12);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x1a5010,
          shininess: 50,
          emissive: 0x0a2005,
          emissiveIntensity: 0.2
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 1.45;
        group.add(stem);

        // Stem glow
        const stemGlowGeo = new THREE.SphereGeometry(0.12, 10, 10);
        const stemGlowMat = new THREE.MeshBasicMaterial({
          color: 0x44ff44,
          transparent: true,
          opacity: 0.3
        });
        const stemGlow = new THREE.Mesh(stemGlowGeo, stemGlowMat);
        stemGlow.position.y = 1.55;
        group.add(stemGlow);

        // Create turret group for rotatable barrels
        const turretGroup = new THREE.Group();
        turretGroup.position.set(0, 0.9, 0);
        group.add(turretGroup);
        // Store turret reference in userData for later access
        group.userData.turret = turretGroup;

        // Mechanical barrel mount (relative to turret group)
        const mountGeo = new THREE.CylinderGeometry(0.25, 0.22, 0.12, 16);
        const mountMat = new THREE.MeshPhongMaterial({
          color: 0x555566,
          shininess: 100,
          specular: 0x888899
        });
        const mount = new THREE.Mesh(mountGeo, mountMat);
        mount.position.set(0, 0.05, 0.35);
        mount.rotation.x = Math.PI / 4;
        turretGroup.add(mount);

        // Triple rapid-fire barrels with mechanical detail
        for (let i = 0; i < 3; i++) {
          const angle = (i / 3) * Math.PI * 2 - Math.PI / 2;

          // Barrel housing
          const housingGeo = new THREE.CylinderGeometry(0.1, 0.08, 0.15, 12);
          const housingMat = new THREE.MeshPhongMaterial({
            color: 0x666677,
            shininess: 100,
            specular: 0x888899
          });
          const housing = new THREE.Mesh(housingGeo, housingMat);
          housing.position.set(
            Math.cos(angle) * 0.35,
            0,
            0.42 + Math.sin(angle) * 0.1
          );
          housing.rotation.x = Math.PI / 3;
          turretGroup.add(housing);

          // Main barrel
          const barrelGeo = new THREE.CylinderGeometry(0.08, 0.065, 0.55, 16);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0xff2255,
            shininess: 100,
            specular: 0xff6688,
            emissive: 0xcc0033,
            emissiveIntensity: 0.35
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.position.set(
            Math.cos(angle) * 0.35,
            0.15,
            0.58 + Math.sin(angle) * 0.1
          );
          barrel.rotation.x = Math.PI / 3;
          turretGroup.add(barrel);

          // Barrel rings
          for (let r = 0; r < 2; r++) {
            const ringGeo = new THREE.TorusGeometry(0.085, 0.015, 6, 12);
            const ringMat = new THREE.MeshPhongMaterial({
              color: 0xff6688,
              shininess: 120,
              emissive: 0xcc4466,
              emissiveIntensity: 0.3
            });
            const ring = new THREE.Mesh(ringGeo, ringMat);
            ring.position.set(
              Math.cos(angle) * 0.35,
              0.05 + r * 0.18,
              0.5 + r * 0.12 + Math.sin(angle) * 0.1
            );
            ring.rotation.x = Math.PI / 3 + Math.PI / 2;
            turretGroup.add(ring);
          }

          // Glowing barrel tips
          const tipGeo = new THREE.SphereGeometry(0.09, 12, 12);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0xff6699,
            emissive: 0xff3366,
            emissiveIntensity: 0.85,
            shininess: 150
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(
            Math.cos(angle) * 0.35,
            0.38,
            0.78 + Math.sin(angle) * 0.1
          );
          turretGroup.add(tip);

          // Tip glow effect
          const tipGlowGeo = new THREE.SphereGeometry(0.14, 10, 10);
          const tipGlowMat = new THREE.MeshBasicMaterial({
            color: 0xff6699,
            transparent: true,
            opacity: 0.55
          });
          const tipGlow = new THREE.Mesh(tipGlowGeo, tipGlowMat);
          tipGlow.position.copy(tip.position);
          turretGroup.add(tipGlow);
        }

        // Energy cables from strawberry to barrels (part of turret)
        for (let i = 0; i < 3; i++) {
          const cableGeo = new THREE.CylinderGeometry(0.02, 0.02, 0.3, 8);
          const cableMat = new THREE.MeshPhongMaterial({
            color: 0xff88aa,
            emissive: 0xff4477,
            emissiveIntensity: 0.6,
            shininess: 80
          });
          const cable = new THREE.Mesh(cableGeo, cableMat);
          const angle = (i / 3) * Math.PI * 2 - Math.PI / 2;
          cable.position.set(
            Math.cos(angle) * 0.2,
            -0.05,
            0.25 + Math.sin(angle) * 0.05
          );
          cable.rotation.x = Math.PI / 3;
          cable.rotation.z = Math.cos(angle) * 0.3;
          turretGroup.add(cable);
        }

        // Energy core at center
        const coreGeo = new THREE.SphereGeometry(0.18, 16, 16);
        const coreMat = new THREE.MeshPhongMaterial({
          color: 0xff88aa,
          emissive: 0xff4477,
          emissiveIntensity: 1.0,
          shininess: 150,
          transparent: true,
          opacity: 0.9
        });
        const core = new THREE.Mesh(coreGeo, coreMat);
        core.position.y = 1.0;
        group.add(core);

        // Inner core
        const innerCoreGeo = new THREE.SphereGeometry(0.1, 12, 12);
        const innerCoreMat = new THREE.MeshBasicMaterial({
          color: 0xffffff,
          transparent: true,
          opacity: 0.8
        });
        const innerCore = new THREE.Mesh(innerCoreGeo, innerCoreMat);
        innerCore.position.y = 1.0;
        group.add(innerCore);

        // Core glow aura
        const auraGeo = new THREE.SphereGeometry(0.7, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xff6699,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 1.0;
        group.add(aura);

        // Outer decorative aura
        const outerAuraGeo = new THREE.SphereGeometry(0.95, 16, 16);
        const outerAuraMat = new THREE.MeshBasicMaterial({
          color: 0xff3366,
          transparent: true,
          opacity: 0.08
        });
        const outerAura = new THREE.Mesh(outerAuraGeo, outerAuraMat);
        outerAura.position.y = 0.9;
        group.add(outerAura);

        break;
      }

      case 'pickle-spiker': {
        // Fusion of pickle-picker and tomato-spike - epic knockback with glowing spikes

        // Heavy reinforced pot with metallic bands
        const potGeo = new THREE.CylinderGeometry(0.5, 0.45, 0.4, 20);
        const potMat = new THREE.MeshPhongMaterial({
          color: 0x4a2511,
          shininess: 60,
          specular: 0x888888,
          emissive: 0x1a0a05,
          emissiveIntensity: 0.1
        });
        const pot = new THREE.Mesh(potGeo, potMat);
        pot.position.y = 0.2;
        group.add(pot);

        // Multiple metal reinforcement rings
        for (let i = 0; i < 2; i++) {
          const ringGeo = new THREE.TorusGeometry(0.5, 0.07, 8, 20);
          const ringMat = new THREE.MeshPhongMaterial({
            color: 0xaaaaaa,
            shininess: 120,
            specular: 0xffffff,
            emissive: 0x444444,
            emissiveIntensity: 0.2
          });
          const ring = new THREE.Mesh(ringGeo, ringMat);
          ring.position.y = 0.15 + i * 0.2;
          ring.rotation.x = Math.PI / 2;
          group.add(ring);
        }

        // Main pickle body (glossy vibrant green)
        const pickleGeo = new THREE.CylinderGeometry(0.4, 0.42, 1.8, 20);
        const pickleMat = new THREE.MeshPhongMaterial({
          color: 0x52b828,
          shininess: 100,
          specular: 0x80ff40,
          emissive: 0x1f4010,
          emissiveIntensity: 0.25
        });
        const pickle = new THREE.Mesh(pickleGeo, pickleMat);
        pickle.position.y = 1.3;
        group.add(pickle);

        // Vertical ridges on pickle
        for (let i = 0; i < 8; i++) {
          const ridgeGeo = new THREE.CylinderGeometry(0.05, 0.05, 1.8, 8);
          const ridgeMat = new THREE.MeshPhongMaterial({
            color: 0x3d7d1f,
            shininess: 80
          });
          const ridge = new THREE.Mesh(ridgeGeo, ridgeMat);
          const angle = (i / 8) * Math.PI * 2;
          ridge.position.set(
            Math.cos(angle) * 0.42,
            1.3,
            Math.sin(angle) * 0.42
          );
          group.add(ridge);
        }

        // Pickle bumps with depth
        for (let i = 0; i < 24; i++) {
          const bumpGeo = new THREE.SphereGeometry(0.09, 10, 10);
          const bumpMat = new THREE.MeshPhongMaterial({
            color: 0x3d7d1f,
            shininess: 70,
            emissive: 0x1a3010,
            emissiveIntensity: 0.15
          });
          const bump = new THREE.Mesh(bumpGeo, bumpMat);
          const angle = (i / 8) * Math.PI * 2;
          const row = Math.floor(i / 8);
          bump.position.set(
            Math.cos(angle) * 0.42,
            0.6 + row * 0.45,
            Math.sin(angle) * 0.42
          );
          group.add(bump);
        }

        // EPIC GLOWING RED SPIKES with multiple sizes
        const createSpike = (baseRadius: number, height: number, emissiveStrength: number) => {
          const spikeGeo = new THREE.ConeGeometry(baseRadius, height, 10);
          const spikeMat = new THREE.MeshPhongMaterial({
            color: 0xff1a1a,
            shininess: 150,
            specular: 0xff8888,
            emissive: 0xff0000,
            emissiveIntensity: emissiveStrength
          });
          return new THREE.Mesh(spikeGeo, spikeMat);
        };

        // Four rows of varied spikes
        const spikeRows = [
          { count: 8, y: 0.7, radius: 0.5, size: 0.12, height: 0.55, glow: 0.4 },
          { count: 12, y: 1.1, radius: 0.52, size: 0.15, height: 0.7, glow: 0.5 },
          { count: 12, y: 1.5, radius: 0.5, size: 0.13, height: 0.6, glow: 0.45 },
          { count: 8, y: 1.9, radius: 0.48, size: 0.11, height: 0.5, glow: 0.4 }
        ];

        spikeRows.forEach(row => {
          for (let i = 0; i < row.count; i++) {
            const spike = createSpike(row.size, row.height, row.glow);
            const angle = (i / row.count) * Math.PI * 2;
            spike.position.set(
              Math.cos(angle) * row.radius,
              row.y,
              Math.sin(angle) * row.radius
            );
            spike.rotation.z = Math.PI / 2;
            spike.rotation.y = angle;
            group.add(spike);

            // Add glow to each spike
            const spikeGlowGeo = new THREE.SphereGeometry(row.size * 1.5, 8, 8);
            const spikeGlowMat = new THREE.MeshBasicMaterial({
              color: 0xff3333,
              transparent: true,
              opacity: 0.25
            });
            const spikeGlow = new THREE.Mesh(spikeGlowGeo, spikeGlowMat);
            spikeGlow.position.set(
              Math.cos(angle) * row.radius,
              row.y,
              Math.sin(angle) * row.radius
            );
            group.add(spikeGlow);
          }
        });

        // Mystical purple portal rings (from pickle picker)
        for (let i = 0; i < 6; i++) {
          const portalGeo = new THREE.TorusGeometry(0.3 + i * 0.1, 0.025, 10, 20);
          const portalMat = new THREE.MeshBasicMaterial({
            color: 0xa060ff,
            transparent: true,
            opacity: 0.4 - i * 0.05
          });
          const portal = new THREE.Mesh(portalGeo, portalMat);
          portal.position.y = 2.0 + i * 0.06;
          portal.rotation.x = Math.PI / 2 + i * 0.12;
          group.add(portal);
        }

        // Purple mystical sparkles
        for (let i = 0; i < 12; i++) {
          const sparkleGeo = new THREE.SphereGeometry(0.04, 8, 8);
          const sparkleMat = new THREE.MeshBasicMaterial({
            color: 0xda70d6,
            transparent: true,
            opacity: 0.7
          });
          const sparkle = new THREE.Mesh(sparkleGeo, sparkleMat);
          const angle = Math.random() * Math.PI * 2;
          const radius = Math.random() * 0.6 + 0.3;
          sparkle.position.set(
            Math.cos(angle) * radius,
            0.5 + Math.random() * 1.6,
            Math.sin(angle) * radius
          );
          group.add(sparkle);
        }

        // Dual-layer energy aura (red + purple)
        const redGlowGeo = new THREE.SphereGeometry(0.75, 20, 20);
        const redGlowMat = new THREE.MeshBasicMaterial({
          color: 0xff0000,
          transparent: true,
          opacity: 0.2
        });
        const redGlow = new THREE.Mesh(redGlowGeo, redGlowMat);
        redGlow.position.y = 1.3;
        group.add(redGlow);

        const purpleGlowGeo = new THREE.SphereGeometry(0.85, 20, 20);
        const purpleGlowMat = new THREE.MeshBasicMaterial({
          color: 0x9370db,
          transparent: true,
          opacity: 0.15
        });
        const purpleGlow = new THREE.Mesh(purpleGlowGeo, purpleGlowMat);
        purpleGlow.position.y = 1.3;
        group.add(purpleGlow);

        // Top spike crown
        for (let i = 0; i < 6; i++) {
          const crownSpike = createSpike(0.1, 0.45, 0.6);
          const angle = (i / 6) * Math.PI * 2;
          crownSpike.position.set(
            Math.cos(angle) * 0.25,
            2.2,
            Math.sin(angle) * 0.25
          );
          crownSpike.rotation.z = -Math.PI / 6;
          crownSpike.rotation.y = angle;
          group.add(crownSpike);
        }

        break;
      }

      case 'grape-shot': {
        // EPIC Fusion of grape-launcher + grape-launcher - dual rapid-fire grape shooter

        // Ornate connected base platform
        const platformGeo = new THREE.BoxGeometry(1.4, 0.12, 0.6);
        const platformMat = new THREE.MeshPhongMaterial({
          color: 0x4a2a6a,
          shininess: 80,
          specular: 0x9966cc,
          emissive: 0x2a1a4a,
          emissiveIntensity: 0.2
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.06;
        group.add(platform);

        // Glowing purple energy lines on platform
        for (let i = 0; i < 3; i++) {
          const lineGeo = new THREE.BoxGeometry(1.3, 0.02, 0.04);
          const lineMat = new THREE.MeshBasicMaterial({
            color: 0xaa66ff,
            transparent: true,
            opacity: 0.8
          });
          const line = new THREE.Mesh(lineGeo, lineMat);
          line.position.set(0, 0.13, -0.2 + i * 0.2);
          group.add(line);
        }

        // Double ornate pots with golden rims
        for (let i = 0; i < 2; i++) {
          const xOff = i === 0 ? -0.4 : 0.4;

          // Main pot
          const potGeo = new THREE.CylinderGeometry(0.28, 0.35, 0.3, 16);
          const potMat = new THREE.MeshPhongMaterial({
            color: 0x5a3a7a,
            shininess: 60,
            specular: 0x8855aa
          });
          const pot = new THREE.Mesh(potGeo, potMat);
          pot.position.set(xOff, 0.27, 0);
          group.add(pot);

          // Golden rim
          const rimGeo = new THREE.TorusGeometry(0.29, 0.04, 8, 20);
          const rimMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            shininess: 120,
            specular: 0xffff88,
            emissive: 0xaa8800,
            emissiveIntensity: 0.3
          });
          const rim = new THREE.Mesh(rimGeo, rimMat);
          rim.position.set(xOff, 0.42, 0);
          rim.rotation.x = Math.PI / 2;
          group.add(rim);

          // Glowing vine wrapping around pot
          for (let v = 0; v < 3; v++) {
            const vineAngle = (v / 3) * Math.PI * 2;
            const vineGeo = new THREE.TorusGeometry(0.32, 0.025, 6, 12, Math.PI / 2);
            const vineMat = new THREE.MeshPhongMaterial({
              color: 0x228822,
              emissive: 0x115511,
              emissiveIntensity: 0.4
            });
            const vine = new THREE.Mesh(vineGeo, vineMat);
            vine.position.set(xOff, 0.25 + v * 0.06, 0);
            vine.rotation.y = vineAngle;
            vine.rotation.x = Math.PI / 2;
            group.add(vine);
          }
        }

        // Two epic grape clusters with individual glowing grapes
        for (let side = 0; side < 2; side++) {
          const xOffset = side === 0 ? -0.4 : 0.4;

          // Main glowing grape cluster core
          const coreGeo = new THREE.SphereGeometry(0.22, 16, 16);
          const coreMat = new THREE.MeshPhongMaterial({
            color: 0x9933ff,
            shininess: 100,
            emissive: 0x6622aa,
            emissiveIntensity: 0.5
          });
          const core = new THREE.Mesh(coreGeo, coreMat);
          core.position.set(xOffset, 0.85, 0);
          group.add(core);

          // Outer glow
          const glowGeo = new THREE.SphereGeometry(0.3, 12, 12);
          const glowMat = new THREE.MeshBasicMaterial({
            color: 0xaa55ff,
            transparent: true,
            opacity: 0.25
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.set(xOffset, 0.85, 0);
          group.add(glow);

          // Ring of individual shiny grapes around cluster
          for (let j = 0; j < 6; j++) {
            const grapeGeo = new THREE.SphereGeometry(0.12, 12, 12);
            const grapeMat = new THREE.MeshPhongMaterial({
              color: 0x7722cc,
              shininess: 100,
              specular: 0xcc88ff,
              emissive: 0x4411aa,
              emissiveIntensity: 0.3
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            const angle = (j / 6) * Math.PI * 2;
            grape.position.set(
              xOffset + Math.cos(angle) * 0.28,
              0.7 + Math.sin(j * 0.5) * 0.1,
              Math.sin(angle) * 0.28
            );
            group.add(grape);

            // Tiny highlight on each grape
            const highlightGeo = new THREE.SphereGeometry(0.03, 8, 8);
            const highlightMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
            const highlight = new THREE.Mesh(highlightGeo, highlightMat);
            highlight.position.set(
              xOffset + Math.cos(angle) * 0.28 + 0.05,
              0.75 + Math.sin(j * 0.5) * 0.1,
              Math.sin(angle) * 0.28 - 0.05
            );
            group.add(highlight);
          }

          // Top grapes
          for (let j = 0; j < 3; j++) {
            const topGrapeGeo = new THREE.SphereGeometry(0.1, 12, 12);
            const topGrapeMat = new THREE.MeshPhongMaterial({
              color: 0x8833dd,
              shininess: 90,
              emissive: 0x5522aa,
              emissiveIntensity: 0.3
            });
            const topGrape = new THREE.Mesh(topGrapeGeo, topGrapeMat);
            const angle = (j / 3) * Math.PI * 2;
            topGrape.position.set(
              xOffset + Math.cos(angle) * 0.15,
              1.05,
              Math.sin(angle) * 0.15
            );
            group.add(topGrape);
          }

          // Decorative leaves
          const leafGeo = new THREE.ConeGeometry(0.12, 0.25, 8);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x227722,
            shininess: 40,
            emissive: 0x114411,
            emissiveIntensity: 0.2
          });
          for (let l = 0; l < 2; l++) {
            const leaf = new THREE.Mesh(leafGeo, leafMat);
            leaf.position.set(xOffset + (l === 0 ? -0.2 : 0.2), 1.15, 0);
            leaf.rotation.z = l === 0 ? 0.5 : -0.5;
            group.add(leaf);
          }

          // Shooting barrel with energy effect
          const barrelGeo = new THREE.CylinderGeometry(0.08, 0.1, 0.4, 12);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x6633aa,
            shininess: 100,
            specular: 0xaa77ff,
            emissive: 0x4422aa,
            emissiveIntensity: 0.4
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.position.set(0.35, 0.75, -xOffset);
          barrel.rotation.z = -Math.PI / 3.5;
          group.add(barrel);

          // Glowing barrel tip
          const tipGeo = new THREE.SphereGeometry(0.1, 12, 12);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0xcc88ff,
            emissive: 0xaa66ff,
            emissiveIntensity: 0.8
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(0.55, 0.95, -xOffset);
          group.add(tip);

          // Tip glow aura
          const tipAuraGeo = new THREE.SphereGeometry(0.15, 10, 10);
          const tipAuraMat = new THREE.MeshBasicMaterial({
            color: 0xcc88ff,
            transparent: true,
            opacity: 0.35
          });
          const tipAura = new THREE.Mesh(tipAuraGeo, tipAuraMat);
          tipAura.position.set(0.55, 0.95, -xOffset);
          group.add(tipAura);
        }

        // Central energy connection between the two clusters
        const connectionGeo = new THREE.CylinderGeometry(0.03, 0.03, 0.6, 8);
        const connectionMat = new THREE.MeshBasicMaterial({
          color: 0xaa55ff,
          transparent: true,
          opacity: 0.7
        });
        const connection = new THREE.Mesh(connectionGeo, connectionMat);
        connection.position.set(0, 0.85, 0);
        connection.rotation.z = Math.PI / 2;
        group.add(connection);

        // Energy orb in center
        const orbGeo = new THREE.SphereGeometry(0.12, 12, 12);
        const orbMat = new THREE.MeshPhongMaterial({
          color: 0xffffff,
          emissive: 0xaa66ff,
          emissiveIntensity: 1.0
        });
        const orb = new THREE.Mesh(orbGeo, orbMat);
        orb.position.set(0, 0.85, 0);
        group.add(orb);

        break;
      }

      case 'frost-grape-gun': {
        // EPIC ODD FUSION: Frost Grape Gun - Triple frozen grape gatling gun!

        // === MASSIVE FROZEN BASE PLATFORM ===
        const frostPlatformGeo = new THREE.CylinderGeometry(0.85, 1.0, 0.3, 8);
        const frostPlatformMat = new THREE.MeshPhongMaterial({
          color: 0x1e5f8a,
          shininess: 120,
          emissive: 0x0080aa,
          emissiveIntensity: 0.3
        });
        const frostPlatform = new THREE.Mesh(frostPlatformGeo, frostPlatformMat);
        frostPlatform.position.y = 0.15;
        group.add(frostPlatform);

        // Ice crystal ring around base
        for (let i = 0; i < 8; i++) {
          const crystalGeo = new THREE.ConeGeometry(0.1, 0.35, 4);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0xb0e0e6,
            shininess: 200,
            emissive: 0x40c0ff,
            emissiveIntensity: 0.6,
            transparent: true,
            opacity: 0.9
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const angle = (i / 8) * Math.PI * 2;
          crystal.position.set(
            Math.cos(angle) * 0.9,
            0.35,
            Math.sin(angle) * 0.9
          );
          crystal.rotation.z = (Math.random() - 0.5) * 0.4;
          group.add(crystal);
        }

        // === CENTRAL FROST CORE ===
        const frostCoreGeo = new THREE.IcosahedronGeometry(0.4, 2);
        const frostCoreMat = new THREE.MeshPhongMaterial({
          color: 0x00ffff,
          shininess: 200,
          emissive: 0x00ffff,
          emissiveIntensity: 0.7,
          transparent: true,
          opacity: 0.85
        });
        const frostCore = new THREE.Mesh(frostCoreGeo, frostCoreMat);
        frostCore.position.y = 0.8;
        group.add(frostCore);

        // Frost core glow layers
        for (let g = 0; g < 2; g++) {
          const glowGeo = new THREE.SphereGeometry(0.5 + g * 0.15, 16, 16);
          const glowMat = new THREE.MeshBasicMaterial({
            color: 0x40c0ff,
            transparent: true,
            opacity: 0.15 - g * 0.05
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.y = 0.8;
          group.add(glow);
        }

        // === TRIPLE FROZEN GRAPE CLUSTERS ===
        for (let side = 0; side < 3; side++) {
          const xOffset = (side - 1) * 0.55;

          // Main frozen grape cluster (larger)
          const clusterGeo = new THREE.SphereGeometry(0.35, 20, 20);
          const clusterMat = new THREE.MeshPhongMaterial({
            color: 0x6633cc,
            shininess: 140,
            emissive: 0x8844ff,
            emissiveIntensity: 0.5
          });
          const cluster = new THREE.Mesh(clusterGeo, clusterMat);
          cluster.position.set(xOffset, 1.3, 0);
          group.add(cluster);

          // Ice coating on grape
          const iceCoatGeo = new THREE.SphereGeometry(0.38, 16, 16);
          const iceCoatMat = new THREE.MeshPhongMaterial({
            color: 0x87ceeb,
            shininess: 200,
            transparent: true,
            opacity: 0.4,
            emissive: 0x40a0ff,
            emissiveIntensity: 0.3
          });
          const iceCoat = new THREE.Mesh(iceCoatGeo, iceCoatMat);
          iceCoat.position.copy(cluster.position);
          group.add(iceCoat);

          // Smaller frozen grapes orbiting
          for (let j = 0; j < 5; j++) {
            const smallGeo = new THREE.SphereGeometry(0.15, 12, 12);
            const smallMat = new THREE.MeshPhongMaterial({
              color: 0x8855dd,
              shininess: 120,
              emissive: 0x6633cc,
              emissiveIntensity: 0.4
            });
            const small = new THREE.Mesh(smallGeo, smallMat);
            const angle = (j / 5) * Math.PI * 2;
            small.position.set(
              xOffset + Math.cos(angle) * 0.32,
              1.3 + Math.sin(angle) * 0.28,
              Math.sin(angle) * 0.2
            );
            group.add(small);

            // Ice on small grapes
            const smallIceGeo = new THREE.SphereGeometry(0.17, 8, 8);
            const smallIceMat = new THREE.MeshPhongMaterial({
              color: 0xaaddff,
              shininess: 180,
              transparent: true,
              opacity: 0.35
            });
            const smallIce = new THREE.Mesh(smallIceGeo, smallIceMat);
            smallIce.position.copy(small.position);
            group.add(smallIce);
          }

          // === FROZEN GATLING BARRELS ===
          const barrelGeo = new THREE.CylinderGeometry(0.14, 0.16, 0.5, 12);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x4080aa,
            shininess: 150,
            emissive: 0x2060aa,
            emissiveIntensity: 0.4
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.rotation.x = Math.PI / 2;
          barrel.position.set(xOffset, 1.3, 0.45);
          group.add(barrel);

          // Barrel tip with frost glow
          const tipGeo = new THREE.CylinderGeometry(0.16, 0.12, 0.15, 12);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0x00ffff,
            emissive: 0x00ffff,
            emissiveIntensity: 1.0,
            shininess: 200
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.rotation.x = Math.PI / 2;
          tip.position.set(xOffset, 1.3, 0.75);
          group.add(tip);

          // Ice shards around barrel
          for (let s = 0; s < 4; s++) {
            const shardGeo = new THREE.ConeGeometry(0.06, 0.25, 4);
            const shardMat = new THREE.MeshPhongMaterial({
              color: 0xe0ffff,
              shininess: 200,
              emissive: 0x80ffff,
              emissiveIntensity: 0.5
            });
            const shard = new THREE.Mesh(shardGeo, shardMat);
            const shardAngle = (s / 4) * Math.PI * 2;
            shard.position.set(
              xOffset + Math.cos(shardAngle) * 0.22,
              1.3 + Math.sin(shardAngle) * 0.22,
              0.5
            );
            shard.rotation.x = Math.PI / 2;
            shard.rotation.z = shardAngle;
            group.add(shard);
          }
        }

        // === CONNECTING ICE BRIDGES ===
        for (let c = 0; c < 2; c++) {
          const bridgeGeo = new THREE.BoxGeometry(0.5, 0.1, 0.15);
          const bridgeMat = new THREE.MeshPhongMaterial({
            color: 0x87ceeb,
            shininess: 180,
            transparent: true,
            opacity: 0.75,
            emissive: 0x40a0ff,
            emissiveIntensity: 0.4
          });
          const bridge = new THREE.Mesh(bridgeGeo, bridgeMat);
          bridge.position.set((c - 0.5) * 0.55, 1.3, 0);
          group.add(bridge);
        }

        // Frost mist effect
        for (let m = 0; m < 6; m++) {
          const mistGeo = new THREE.SphereGeometry(0.15 + Math.random() * 0.1, 8, 8);
          const mistMat = new THREE.MeshBasicMaterial({
            color: 0xaaddff,
            transparent: true,
            opacity: 0.2
          });
          const mist = new THREE.Mesh(mistGeo, mistMat);
          mist.position.set(
            (Math.random() - 0.5) * 1.5,
            0.3 + Math.random() * 0.5,
            (Math.random() - 0.5) * 1
          );
          group.add(mist);
        }

        // Rotate to face right toward zombies (+X direction)
        group.rotation.y = -Math.PI / 2;

        break;
      }

      case 'straw-spiker': {
        // ████████████████████████████████████████████████████████████████████
        // ██  GODLIKE STRAWSPIKER - APOCALYPTIC FRUIT DRAGON WAR MACHINE  ██
        // ████████████████████████████████████████████████████████████████████

        // === FLOATING OBSIDIAN WARSHIP HULL ===
        const obsidianMat = new THREE.MeshPhongMaterial({
          color: 0x1a0a0a,
          shininess: 200,
          specular: 0xff2200,
          emissive: 0x440000,
          emissiveIntensity: 0.5
        });

        // Main hovering hull with curved shape
        const mainHullGeo = new THREE.BoxGeometry(2.5, 0.6, 7.0);
        const mainHull = new THREE.Mesh(mainHullGeo, obsidianMat);
        mainHull.position.set(0, 0.8, 1.0);
        group.add(mainHull);

        // Angled armor plating
        for (let side = -1; side <= 1; side += 2) {
          const armorGeo = new THREE.BoxGeometry(0.3, 0.8, 6.5);
          const armorMat = new THREE.MeshPhongMaterial({
            color: 0x8b0000,
            shininess: 150,
            emissive: 0x660000,
            emissiveIntensity: 0.6
          });
          const armor = new THREE.Mesh(armorGeo, armorMat);
          armor.position.set(side * 1.3, 0.9, 1.0);
          armor.rotation.z = side * 0.2;
          group.add(armor);
        }

        // HOVER ENGINES with flame jets
        for (let side = -1; side <= 1; side += 2) {
          for (let pos = 0; pos < 3; pos++) {
            // Engine housing
            const engineGeo = new THREE.CylinderGeometry(0.3, 0.4, 0.5, 12);
            const engineMat = new THREE.MeshPhongMaterial({
              color: 0x333333,
              shininess: 100,
              emissive: 0x111111,
              emissiveIntensity: 0.3
            });
            const engine = new THREE.Mesh(engineGeo, engineMat);
            engine.position.set(side * 1.0, 0.25, -1.5 + pos * 2.5);
            group.add(engine);

            // Flame jet
            const flameGeo = new THREE.ConeGeometry(0.25, 0.8, 8);
            const flameMat = new THREE.MeshBasicMaterial({
              color: pos % 2 === 0 ? 0x00ffff : 0xff4400,
              transparent: true,
              opacity: 0.9
            });
            const flame = new THREE.Mesh(flameGeo, flameMat);
            flame.position.set(side * 1.0, -0.2, -1.5 + pos * 2.5);
            flame.rotation.x = Math.PI;
            group.add(flame);

            // Flame glow
            const fGlowGeo = new THREE.SphereGeometry(0.35, 10, 10);
            const fGlowMat = new THREE.MeshBasicMaterial({
              color: pos % 2 === 0 ? 0x00aaff : 0xff6600,
              transparent: true,
              opacity: 0.5
            });
            const fGlow = new THREE.Mesh(fGlowGeo, fGlowMat);
            fGlow.position.set(side * 1.0, -0.1, -1.5 + pos * 2.5);
            group.add(fGlow);
          }
        }

        // LAVA VEINS running through the hull
        for (let v = 0; v < 12; v++) {
          const veinGeo = new THREE.BoxGeometry(2.0, 0.1, 0.1);
          const veinMat = new THREE.MeshBasicMaterial({
            color: v % 3 === 0 ? 0xff0000 : (v % 3 === 1 ? 0xff6600 : 0xffaa00)
          });
          const vein = new THREE.Mesh(veinGeo, veinMat);
          vein.position.set(0, 1.12, -2.0 + v * 0.55);
          group.add(vein);
        }

        // === DEMON WINGS ===
        for (let side = -1; side <= 1; side += 2) {
          // Main wing bone
          const wingBoneGeo = new THREE.BoxGeometry(0.15, 0.1, 2.5);
          const wingBoneMat = new THREE.MeshPhongMaterial({
            color: 0x2a0a0a,
            shininess: 100,
            emissive: 0x330000,
            emissiveIntensity: 0.4
          });
          const wingBone = new THREE.Mesh(wingBoneGeo, wingBoneMat);
          wingBone.position.set(side * 2.0, 1.5, 0);
          wingBone.rotation.y = side * 0.4;
          group.add(wingBone);

          // Wing membrane segments
          for (let seg = 0; seg < 4; seg++) {
            const memGeo = new THREE.PlaneGeometry(0.8, 1.5);
            const memMat = new THREE.MeshBasicMaterial({
              color: seg % 2 === 0 ? 0xff1a4a : 0x880022,
              transparent: true,
              opacity: 0.7,
              side: THREE.DoubleSide
            });
            const membrane = new THREE.Mesh(memGeo, memMat);
            membrane.position.set(side * (2.2 + seg * 0.4), 1.5 - seg * 0.15, -0.8 + seg * 0.5);
            membrane.rotation.y = side * (0.3 + seg * 0.15);
            membrane.rotation.x = -0.3;
            group.add(membrane);
          }

          // Wing claws
          for (let c = 0; c < 3; c++) {
            const clawGeo = new THREE.ConeGeometry(0.08, 0.4, 6);
            const clawMat = new THREE.MeshPhongMaterial({
              color: 0x1a1a1a,
              shininess: 200,
              specular: 0xffffff
            });
            const claw = new THREE.Mesh(clawGeo, clawMat);
            claw.position.set(side * (2.5 + c * 0.3), 1.3, -1.2 + c * 0.6);
            claw.rotation.z = side * 0.5;
            claw.rotation.x = 0.3;
            group.add(claw);
          }
        }

        // === BACK: DEMONIC STRAWBERRY LAUNCHER ===
        const demonBaseGeo = new THREE.CylinderGeometry(1.0, 1.2, 1.5, 8);
        const demonBaseMat = new THREE.MeshPhongMaterial({
          color: 0x660022,
          shininess: 120,
          emissive: 0x440011,
          emissiveIntensity: 0.7
        });
        const demonBase = new THREE.Mesh(demonBaseGeo, demonBaseMat);
        demonBase.position.set(0, 1.6, -1.2);
        group.add(demonBase);

        // COLOSSAL strawberry with demonic eyes
        const colossalStrawGeo = new THREE.SphereGeometry(0.9, 32, 32);
        const colossalStrawMat = new THREE.MeshPhongMaterial({
          color: 0xff0040,
          shininess: 180,
          emissive: 0xff0033,
          emissiveIntensity: 1.0
        });
        const colossalStraw = new THREE.Mesh(colossalStrawGeo, colossalStrawMat);
        colossalStraw.position.set(0, 2.8, -1.2);
        colossalStraw.scale.set(1, 1.5, 1);
        group.add(colossalStraw);

        // Demonic eyes on strawberry
        for (let eye = -1; eye <= 1; eye += 2) {
          const eyeGeo = new THREE.SphereGeometry(0.15, 12, 12);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0xffff00 });
          const eyeMesh = new THREE.Mesh(eyeGeo, eyeMat);
          eyeMesh.position.set(eye * 0.35, 2.9, -0.6);
          group.add(eyeMesh);

          const pupilGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const pupilMat = new THREE.MeshBasicMaterial({ color: 0xff0000 });
          const pupil = new THREE.Mesh(pupilGeo, pupilMat);
          pupil.position.set(eye * 0.35, 2.9, -0.48);
          group.add(pupil);
        }

        // Flaming seeds
        for (let i = 0; i < 30; i++) {
          const fSeedGeo = new THREE.SphereGeometry(0.1, 8, 8);
          const fSeedMat = new THREE.MeshBasicMaterial({
            color: i % 2 === 0 ? 0xffd700 : 0xff4400
          });
          const fSeed = new THREE.Mesh(fSeedGeo, fSeedMat);
          const angle = (i / 30) * Math.PI * 2;
          const vAngle = ((i % 8) / 8) * Math.PI;
          fSeed.position.set(
            Math.cos(angle) * 0.7 * Math.sin(vAngle),
            2.8 + Math.cos(vAngle) * 1.0,
            -1.2 + Math.sin(angle) * 0.7 * Math.sin(vAngle)
          );
          group.add(fSeed);
        }

        // Flame crown on strawberry
        for (let f = 0; f < 8; f++) {
          const crownFlameGeo = new THREE.ConeGeometry(0.15, 0.7, 6);
          const crownFlameMat = new THREE.MeshBasicMaterial({
            color: f % 2 === 0 ? 0xff4400 : 0xffff00,
            transparent: true,
            opacity: 0.9
          });
          const crownFlame = new THREE.Mesh(crownFlameGeo, crownFlameMat);
          const angle = (f / 8) * Math.PI * 2;
          crownFlame.position.set(
            Math.cos(angle) * 0.35,
            4.0,
            -1.2 + Math.sin(angle) * 0.35
          );
          group.add(crownFlame);
        }

        // === CENTER: APOCALYPTIC REACTOR CORE ===
        // Outer containment ring
        const containmentGeo = new THREE.TorusGeometry(1.2, 0.15, 16, 32);
        const containmentMat = new THREE.MeshPhongMaterial({
          color: 0xffd700,
          emissive: 0xff8800,
          emissiveIntensity: 1.0,
          shininess: 200
        });
        const containment = new THREE.Mesh(containmentGeo, containmentMat);
        containment.position.set(0, 1.5, 1.0);
        containment.rotation.x = Math.PI / 2;
        group.add(containment);

        // Multiple spinning rings at different angles
        for (let r = 0; r < 6; r++) {
          const spinRingGeo = new THREE.TorusGeometry(0.6 + r * 0.1, 0.04, 8, 24);
          const spinRingMat = new THREE.MeshPhongMaterial({
            color: r % 3 === 0 ? 0xff2d55 : (r % 3 === 1 ? 0xffd700 : 0x00ffff),
            emissive: r % 3 === 0 ? 0xff0044 : (r % 3 === 1 ? 0xffaa00 : 0x0088ff),
            emissiveIntensity: 1.5
          });
          const spinRing = new THREE.Mesh(spinRingGeo, spinRingMat);
          spinRing.position.set(0, 1.5 + (r - 2.5) * 0.15, 1.0);
          spinRing.rotation.x = Math.PI / 2 + r * 0.2;
          spinRing.rotation.z = r * 0.5;
          group.add(spinRing);
        }

        // Central PLASMA CORE
        const plasmaGeo = new THREE.IcosahedronGeometry(0.5, 2);
        const plasmaMat = new THREE.MeshPhongMaterial({
          color: 0xffffff,
          emissive: 0xff4466,
          emissiveIntensity: 3.0,
          shininess: 300
        });
        const plasma = new THREE.Mesh(plasmaGeo, plasmaMat);
        plasma.position.set(0, 1.5, 1.0);
        group.add(plasma);

        // Plasma glow layers
        for (let pg = 0; pg < 5; pg++) {
          const pGlowGeo = new THREE.SphereGeometry(0.6 + pg * 0.25, 20, 20);
          const pGlowMat = new THREE.MeshBasicMaterial({
            color: pg % 2 === 0 ? 0xff3366 : 0xffd700,
            transparent: true,
            opacity: 0.2 - pg * 0.03
          });
          const pGlow = new THREE.Mesh(pGlowGeo, pGlowMat);
          pGlow.position.set(0, 1.5, 1.0);
          group.add(pGlow);
        }

        // Lightning bolts from core
        for (let bolt = 0; bolt < 8; bolt++) {
          const boltGeo = new THREE.CylinderGeometry(0.03, 0.03, 1.5, 6);
          const boltMat = new THREE.MeshBasicMaterial({
            color: bolt % 2 === 0 ? 0x00ffff : 0xffff00
          });
          const lightning = new THREE.Mesh(boltGeo, boltMat);
          const angle = (bolt / 8) * Math.PI * 2;
          lightning.position.set(
            Math.cos(angle) * 0.8,
            1.5,
            1.0 + Math.sin(angle) * 0.8
          );
          lightning.rotation.z = Math.PI / 2;
          lightning.rotation.y = angle;
          group.add(lightning);
        }

        // === FRONT: MEGA TOMATO GATLING CANNON ===
        const gatlingBaseGeo = new THREE.CylinderGeometry(1.1, 1.3, 1.2, 16);
        const gatlingBaseMat = new THREE.MeshPhongMaterial({
          color: 0xcc1100,
          shininess: 120,
          emissive: 0x660000,
          emissiveIntensity: 0.6
        });
        const gatlingBase = new THREE.Mesh(gatlingBaseGeo, gatlingBaseMat);
        gatlingBase.position.set(0, 1.5, 3.2);
        group.add(gatlingBase);

        // FIVE barrel rotating system
        for (let b = 0; b < 5; b++) {
          const angle = (b / 5) * Math.PI * 2;
          const bX = Math.cos(angle) * 0.5;
          const bY = 1.5 + Math.sin(angle) * 0.5;

          // Main barrel
          const barrelGeo = new THREE.CylinderGeometry(0.15, 0.2, 1.8, 12);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x222222,
            shininess: 180,
            specular: 0x888888
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.rotation.x = Math.PI / 2;
          barrel.position.set(bX, bY, 4.2);
          group.add(barrel);

          // Barrel heat vents
          for (let hv = 0; hv < 4; hv++) {
            const heatGeo = new THREE.BoxGeometry(0.05, 0.35, 0.08);
            const heatMat = new THREE.MeshBasicMaterial({
              color: hv % 2 === 0 ? 0xff2200 : 0xff6600
            });
            const heat = new THREE.Mesh(heatGeo, heatMat);
            heat.position.set(bX, bY, 3.5 + hv * 0.35);
            group.add(heat);
          }

          // Muzzle flash
          const flashGeo = new THREE.ConeGeometry(0.25, 0.7, 8);
          const flashMat = new THREE.MeshBasicMaterial({
            color: b % 2 === 0 ? 0xffff00 : 0xff4400,
            transparent: true,
            opacity: 0.95
          });
          const flash = new THREE.Mesh(flashGeo, flashMat);
          flash.rotation.x = -Math.PI / 2;
          flash.position.set(bX, bY, 5.3);
          group.add(flash);
        }

        // MASSIVE spiked tomato warhead
        const warheadGeo = new THREE.SphereGeometry(0.8, 32, 32);
        const warheadMat = new THREE.MeshPhongMaterial({
          color: 0xff1111,
          shininess: 150,
          emissive: 0xdd0000,
          emissiveIntensity: 1.0
        });
        const warhead = new THREE.Mesh(warheadGeo, warheadMat);
        warhead.position.set(0, 2.5, 3.2);
        group.add(warhead);

        // 30 death spikes
        for (let s = 0; s < 30; s++) {
          const dSpikeGeo = new THREE.ConeGeometry(0.12, 0.8, 6);
          const dSpikeMat = new THREE.MeshPhongMaterial({
            color: 0x0a0a0a,
            shininess: 250,
            specular: 0xffffff,
            emissive: 0x440000,
            emissiveIntensity: 0.4
          });
          const dSpike = new THREE.Mesh(dSpikeGeo, dSpikeMat);
          const angle = (s / 30) * Math.PI * 2;
          const vAngle = ((s % 6) / 6) * Math.PI;
          const radius = 0.85;
          dSpike.position.set(
            Math.cos(angle) * radius * Math.sin(vAngle),
            2.5 + Math.cos(vAngle) * radius,
            3.2 + Math.sin(angle) * radius * Math.sin(vAngle)
          );
          dSpike.lookAt(
            dSpike.position.x * 2,
            dSpike.position.y * 2 - 2.5,
            dSpike.position.z * 2 - 3.2
          );
          group.add(dSpike);
        }

        // === CHAINS hanging from hull ===
        for (let ch = 0; ch < 6; ch++) {
          for (let link = 0; link < 5; link++) {
            const linkGeo = new THREE.TorusGeometry(0.08, 0.025, 6, 12);
            const linkMat = new THREE.MeshPhongMaterial({
              color: 0x444444,
              shininess: 100
            });
            const chainLink = new THREE.Mesh(linkGeo, linkMat);
            const xPos = -1.2 + ch * 0.5;
            chainLink.position.set(xPos, 0.1 - link * 0.15, -1 + ch * 0.8);
            chainLink.rotation.x = link % 2 === 0 ? 0 : Math.PI / 2;
            group.add(chainLink);
          }
        }

        // === SKULLS on the hull ===
        for (let sk = 0; sk < 4; sk++) {
          const skullGeo = new THREE.SphereGeometry(0.2, 12, 12);
          const skullMat = new THREE.MeshPhongMaterial({
            color: 0xddddaa,
            shininess: 50
          });
          const skull = new THREE.Mesh(skullGeo, skullMat);
          skull.position.set(-0.9 + sk * 0.6, 1.15, sk < 2 ? -2.0 : 4.0);
          skull.scale.set(1, 1.2, 0.9);
          group.add(skull);

          // Eye sockets
          for (let eye = -1; eye <= 1; eye += 2) {
            const socketGeo = new THREE.SphereGeometry(0.06, 8, 8);
            const socketMat = new THREE.MeshBasicMaterial({ color: 0xff0000 });
            const socket = new THREE.Mesh(socketGeo, socketMat);
            socket.position.set(-0.9 + sk * 0.6 + eye * 0.08, 1.2, (sk < 2 ? -2.0 : 4.0) - 0.15);
            group.add(socket);
          }
        }

        // === ORBITING FIRE SPIRITS ===
        for (let spirit = 0; spirit < 16; spirit++) {
          const spiritGeo = new THREE.SphereGeometry(0.15, 10, 10);
          const spiritMat = new THREE.MeshBasicMaterial({
            color: spirit % 4 === 0 ? 0xff0000 : (spirit % 4 === 1 ? 0xff8800 : (spirit % 4 === 2 ? 0xffff00 : 0x00ffff))
          });
          const spiritMesh = new THREE.Mesh(spiritGeo, spiritMat);
          const angle = (spirit / 16) * Math.PI * 2;
          spiritMesh.position.set(
            Math.cos(angle) * 2.2,
            1.5 + Math.sin(spirit * 1.5) * 0.8,
            1.0 + Math.sin(angle) * 2.2
          );
          group.add(spiritMesh);
        }

        // === ULTIMATE APOCALYPSE AURA ===
        for (let aura = 0; aura < 6; aura++) {
          const auraGeo = new THREE.SphereGeometry(2.5 + aura * 0.5, 24, 24);
          const auraMat = new THREE.MeshBasicMaterial({
            color: aura % 3 === 0 ? 0xff0044 : (aura % 3 === 1 ? 0xffd700 : 0x00ffff),
            transparent: true,
            opacity: 0.1 - aura * 0.012
          });
          const auraMesh = new THREE.Mesh(auraGeo, auraMat);
          auraMesh.position.set(0, 1.5, 1.0);
          auraMesh.scale.set(1, 0.8, 2.8);
          group.add(auraMesh);
        }

        // Scale down to fit within one tile
        group.scale.set(0.3, 0.3, 0.3);
        // Rotate to face right toward zombies
        group.rotation.y = -Math.PI / 2;

        break;
      }

      case 'grape-gun': {
        // EPIC Fusion of grape-shot + grape-launcher - triple grape gatling gun
        // Check for Blue Eye skin
        const activeSkins = localStorage.getItem('fusionTdActiveSkins');
        const skinData = activeSkins ? JSON.parse(activeSkins) : {};
        const isBlueEye = skinData['grape-gun'] === 'grape-gun-blue-eye';

        if (isBlueEye) {
          // ========== ABYSS SKIN - COMPLETELY DIFFERENT ELDRITCH VOID HORROR ==========

          // Floating void platform - black hole style
          const voidBaseGeo = new THREE.CylinderGeometry(0.7, 0.8, 0.1, 32);
          const voidBaseMat = new THREE.MeshPhongMaterial({
            color: 0x000000,
            shininess: 300,
            specular: 0x4400ff,
            emissive: 0x110022,
            emissiveIntensity: 0.5
          });
          const voidBase = new THREE.Mesh(voidBaseGeo, voidBaseMat);
          voidBase.position.y = 0.05;
          group.add(voidBase);

          // Swirling void rings
          for (let r = 0; r < 3; r++) {
            const voidRingGeo = new THREE.TorusGeometry(0.5 + r * 0.15, 0.02, 8, 32);
            const voidRingMat = new THREE.MeshBasicMaterial({
              color: r === 0 ? 0xff00ff : (r === 1 ? 0x00ffff : 0x8800ff),
              transparent: true,
              opacity: 0.8
            });
            const voidRing = new THREE.Mesh(voidRingGeo, voidRingMat);
            voidRing.position.y = 0.1 + r * 0.05;
            voidRing.rotation.x = Math.PI / 2;
            voidRing.rotation.z = r * 0.5;
            group.add(voidRing);
          }

          // Central giant evil eye
          const eyeSocketGeo = new THREE.SphereGeometry(0.4, 32, 32);
          const eyeSocketMat = new THREE.MeshPhongMaterial({
            color: 0x000000,
            shininess: 200,
            emissive: 0x220044,
            emissiveIntensity: 0.8
          });
          const eyeSocket = new THREE.Mesh(eyeSocketGeo, eyeSocketMat);
          eyeSocket.position.y = 0.8;
          group.add(eyeSocket);

          // Glowing eye iris
          const irisGeo = new THREE.SphereGeometry(0.25, 32, 32);
          const irisMat = new THREE.MeshBasicMaterial({
            color: 0x00ffff
          });
          const iris = new THREE.Mesh(irisGeo, irisMat);
          iris.position.set(0.15, 0.8, 0);
          iris.scale.set(0.5, 1, 1);
          group.add(iris);

          // Evil pupil - vertical slit
          const pupilGeo = new THREE.BoxGeometry(0.08, 0.35, 0.1);
          const pupilMat = new THREE.MeshBasicMaterial({ color: 0xff0066 });
          const pupil = new THREE.Mesh(pupilGeo, pupilMat);
          pupil.position.set(0.28, 0.8, 0);
          group.add(pupil);

          // Eye glow aura
          const eyeGlowGeo = new THREE.SphereGeometry(0.5, 16, 16);
          const eyeGlowMat = new THREE.MeshBasicMaterial({
            color: 0x8800ff,
            transparent: true,
            opacity: 0.3
          });
          const eyeGlow = new THREE.Mesh(eyeGlowGeo, eyeGlowMat);
          eyeGlow.position.y = 0.8;
          group.add(eyeGlow);

          // Three void tentacle barrels
          for (let i = 0; i < 3; i++) {
            const zOffset = (i - 1) * 0.4;

            // Tentacle base
            const tentBaseGeo = new THREE.CylinderGeometry(0.15, 0.2, 0.3, 8);
            const tentBaseMat = new THREE.MeshPhongMaterial({
              color: 0x1a0a2a,
              shininess: 100,
              emissive: 0x330066,
              emissiveIntensity: 0.5
            });
            const tentBase = new THREE.Mesh(tentBaseGeo, tentBaseMat);
            tentBase.position.set(0.3, 0.35, zOffset);
            group.add(tentBase);

            // Tentacle barrel
            const tentGeo = new THREE.CylinderGeometry(0.08, 0.12, 0.6, 8);
            const tentMat = new THREE.MeshPhongMaterial({
              color: 0x2a1a3a,
              shininess: 80,
              emissive: 0x440088,
              emissiveIntensity: 0.6
            });
            const tent = new THREE.Mesh(tentGeo, tentMat);
            tent.position.set(0.65, 0.5, zOffset);
            tent.rotation.z = -Math.PI / 2;
            group.add(tent);

            // Void orb at tip
            const orbGeo = new THREE.SphereGeometry(0.1, 16, 16);
            const orbMat = new THREE.MeshBasicMaterial({
              color: i === 1 ? 0xff00ff : 0x00ffff
            });
            const orb = new THREE.Mesh(orbGeo, orbMat);
            orb.position.set(0.95, 0.5, zOffset);
            group.add(orb);

            // Orb glow
            const orbGlowGeo = new THREE.SphereGeometry(0.15, 12, 12);
            const orbGlowMat = new THREE.MeshBasicMaterial({
              color: i === 1 ? 0xff00ff : 0x00ffff,
              transparent: true,
              opacity: 0.4
            });
            const orbGlow = new THREE.Mesh(orbGlowGeo, orbGlowMat);
            orbGlow.position.set(0.95, 0.5, zOffset);
            group.add(orbGlow);
          }

          // Floating void particles
          for (let p = 0; p < 20; p++) {
            const partGeo = new THREE.SphereGeometry(0.03, 8, 8);
            const partMat = new THREE.MeshBasicMaterial({
              color: p % 3 === 0 ? 0xff00ff : (p % 3 === 1 ? 0x00ffff : 0x8800ff),
              transparent: true,
              opacity: 0.8
            });
            const part = new THREE.Mesh(partGeo, partMat);
            part.position.set(
              (Math.random() - 0.5) * 1.2,
              0.2 + Math.random() * 1.0,
              (Math.random() - 0.5) * 1.0
            );
            group.add(part);
          }

          // Dark aura
          const darkAuraGeo = new THREE.SphereGeometry(0.9, 16, 16);
          const darkAuraMat = new THREE.MeshBasicMaterial({
            color: 0x220044,
            transparent: true,
            opacity: 0.2
          });
          const darkAura = new THREE.Mesh(darkAuraGeo, darkAuraMat);
          darkAura.position.y = 0.6;
          group.add(darkAura);

          break;
        }

        // ========== DEFAULT SKIN ==========
        // Color palette for default
        const skinColors = {
          energy: 0x9933ff,
          energyEmissive: 0x9933ff,
          grape: 0x8844aa,
          grapeEmissive: 0x6622aa,
          grapeSpec: 0xcc88ff,
          core: 0xaa66ff,
          hub: 0xcc88ff,
          hubEmissive: 0xaa66ff,
          tip: 0xcc66ff,
          tipEmissive: 0xaa44ff,
          emblem: 0x8844aa,
          emblemEmissive: 0x6622aa,
          clusterCore: 0x7b3d97,
          clusterCoreEmissive: 0x5a2f7c,
          platform: 0x4a3020,
          platformEmissive: 0x1a1008
        };

        // Heavy armored platform base with hexagonal pattern
        const platformGeo = new THREE.CylinderGeometry(0.75, 0.85, 0.18, 6);
        const platformMat = new THREE.MeshPhongMaterial({
          color: skinColors.platform,
          shininess: 70,
          specular: 0x886644,
          emissive: skinColors.platformEmissive,
          emissiveIntensity: 0.15
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.09;
        group.add(platform);

        // Glowing energy channels on platform
        for (let i = 0; i < 6; i++) {
          const channelGeo = new THREE.BoxGeometry(0.06, 0.05, 0.35);
          const channelMat = new THREE.MeshPhongMaterial({
            color: skinColors.energy,
            emissive: skinColors.energyEmissive,
            emissiveIntensity: 0.9,
            shininess: 100
          });
          const channel = new THREE.Mesh(channelGeo, channelMat);
          const angle = (i / 6) * Math.PI * 2;
          channel.position.set(
            Math.cos(angle) * 0.55,
            0.12,
            Math.sin(angle) * 0.55
          );
          channel.rotation.y = angle;
          group.add(channel);
        }

        // Inner platform ring with golden trim
        const innerRingGeo = new THREE.TorusGeometry(0.55, 0.06, 8, 20);
        const innerRingMat = new THREE.MeshPhongMaterial({
          color: 0xffd700,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0xaa8800,
          emissiveIntensity: 0.3
        });
        const innerRing = new THREE.Mesh(innerRingGeo, innerRingMat);
        innerRing.position.y = 0.15;
        innerRing.rotation.x = Math.PI / 2;
        group.add(innerRing);

        // Three ornate pots with golden rims and decorations
        for (let i = 0; i < 3; i++) {
          const xOffset = (i - 1) * 0.55;

          // Main pot body
          const potGeo = new THREE.CylinderGeometry(0.22, 0.18, 0.28, 16);
          const potMat = new THREE.MeshPhongMaterial({
            color: 0x6b3a1a,
            shininess: 60,
            specular: 0x886644,
            emissive: 0x2a1808,
            emissiveIntensity: 0.1
          });
          const pot = new THREE.Mesh(potGeo, potMat);
          pot.position.set(xOffset, 0.32, 0);
          group.add(pot);

          // Golden rim on pot
          const rimGeo = new THREE.TorusGeometry(0.22, 0.035, 8, 16);
          const rimMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            shininess: 150,
            specular: 0xffffff,
            emissive: 0xaa8800,
            emissiveIntensity: 0.4
          });
          const rim = new THREE.Mesh(rimGeo, rimMat);
          rim.position.set(xOffset, 0.46, 0);
          rim.rotation.x = Math.PI / 2;
          group.add(rim);

          // Decorative grape emblem on pot
          const emblemGeo = new THREE.SphereGeometry(0.06, 10, 10);
          const emblemMat = new THREE.MeshPhongMaterial({
            color: skinColors.emblem,
            emissive: skinColors.emblemEmissive,
            emissiveIntensity: 0.5,
            shininess: 100
          });
          for (let e = 0; e < 3; e++) {
            const emblem = new THREE.Mesh(emblemGeo, emblemMat);
            emblem.position.set(xOffset, 0.28 + e * 0.08, 0.2);
            emblem.scale.set(0.8 - e * 0.15, 0.8 - e * 0.15, 0.5);
            group.add(emblem);
          }

          // Decorative vines wrapping pot
          const vineGeo = new THREE.TorusGeometry(0.24, 0.02, 6, 16);
          const vineMat = new THREE.MeshPhongMaterial({
            color: 0x2d5a1e,
            shininess: 40
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(xOffset, 0.35, 0);
          vine.rotation.x = Math.PI / 2;
          vine.rotation.z = i * 0.5;
          group.add(vine);
        }

        // Three detailed grape clusters with individual glowing grapes
        for (let side = 0; side < 3; side++) {
          const xOffset = (side - 1) * 0.55;

          // Main cluster core with glow
          const clusterGeo = new THREE.SphereGeometry(0.22, 16, 16);
          const clusterMat = new THREE.MeshPhongMaterial({
            color: skinColors.clusterCore,
            shininess: 100,
            emissive: skinColors.clusterCoreEmissive,
            emissiveIntensity: 0.4
          });
          const cluster = new THREE.Mesh(clusterGeo, clusterMat);
          cluster.position.set(xOffset, 0.72, 0);
          group.add(cluster);

          // Individual detailed grapes around each cluster
          for (let j = 0; j < 8; j++) {
            const grapeGeo = new THREE.SphereGeometry(0.1, 12, 12);
            const grapeMat = new THREE.MeshPhongMaterial({
              color: skinColors.grape,
              shininess: 120,
              specular: skinColors.grapeSpec,
              emissive: skinColors.grapeEmissive,
              emissiveIntensity: 0.35
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            const angle = (j / 8) * Math.PI * 2;
            const heightOffset = (j % 2) * 0.1;
            grape.position.set(
              xOffset + Math.cos(angle) * 0.22,
              0.58 + heightOffset,
              Math.sin(angle) * 0.22
            );
            group.add(grape);

            // Highlight on each grape
            const highlightGeo = new THREE.SphereGeometry(0.03, 8, 8);
            const highlightMat = new THREE.MeshBasicMaterial({
              color: 0xffffff,
              transparent: true,
              opacity: 0.8
            });
            const highlight = new THREE.Mesh(highlightGeo, highlightMat);
            highlight.position.set(
              xOffset + Math.cos(angle) * 0.22 + 0.04,
              0.62 + heightOffset,
              Math.sin(angle) * 0.22 + 0.04
            );
            group.add(highlight);
          }

          // Glowing core inside each cluster
          const coreGeo = new THREE.SphereGeometry(0.12, 12, 12);
          const coreMat = new THREE.MeshBasicMaterial({
            color: skinColors.core,
            transparent: true,
            opacity: 0.6
          });
          const core = new THREE.Mesh(coreGeo, coreMat);
          core.position.set(xOffset, 0.72, 0);
          group.add(core);

          // Grape leaf on top of each cluster
          const leafGeo = new THREE.SphereGeometry(0.12, 8, 8);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x228822,
            shininess: 50,
            emissive: 0x114411,
            emissiveIntensity: 0.2
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(1.5, 0.3, 1);
          leaf.position.set(xOffset + 0.1, 0.92, 0.05);
          leaf.rotation.z = 0.3;
          group.add(leaf);
        }

        // Central energy hub connecting all clusters
        const hubGeo = new THREE.SphereGeometry(0.18, 16, 16);
        const hubMat = new THREE.MeshPhongMaterial({
          color: skinColors.hub,
          emissive: skinColors.hubEmissive,
          emissiveIntensity: 0.9,
          shininess: 150,
          transparent: true,
          opacity: 0.9
        });
        const hub = new THREE.Mesh(hubGeo, hubMat);
        hub.position.set(0, 0.85, 0);
        group.add(hub);

        // Hub glow effect
        const hubGlowGeo = new THREE.SphereGeometry(0.28, 12, 12);
        const hubGlowMat = new THREE.MeshBasicMaterial({
          color: skinColors.hubEmissive,
          transparent: true,
          opacity: 0.35
        });
        const hubGlow = new THREE.Mesh(hubGlowGeo, hubGlowMat);
        hubGlow.position.set(0, 0.85, 0);
        group.add(hubGlow);

        // Energy connections from hub to each cluster
        for (let i = 0; i < 3; i++) {
          const xOffset = (i - 1) * 0.55;
          const tubeGeo = new THREE.CylinderGeometry(0.03, 0.03, 0.35, 8);
          const tubeMat = new THREE.MeshPhongMaterial({
            color: skinColors.hub,
            emissive: skinColors.hubEmissive,
            emissiveIntensity: 0.7,
            shininess: 100
          });
          const tube = new THREE.Mesh(tubeGeo, tubeMat);
          tube.position.set(xOffset * 0.5, 0.78, 0);
          tube.rotation.z = Math.PI / 2;
          if (i !== 1) {
            tube.rotation.z += (i === 0 ? 0.2 : -0.2);
          }
          group.add(tube);
        }

        // Create turret group for rotatable barrels
        const turretGroup = new THREE.Group();
        turretGroup.position.set(0, 0.85, 0);
        group.add(turretGroup);
        // Store turret reference in userData for later access
        group.userData.turret = turretGroup;

        // Triple gatling barrels with glowing tips
        const barrelPositions = [
          { x: -0.18, z: 0.25 },
          { x: 0, z: 0.35 },
          { x: 0.18, z: 0.25 }
        ];

        for (let b = 0; b < 3; b++) {
          // Main barrel housing
          const housingGeo = new THREE.CylinderGeometry(0.12, 0.1, 0.2, 12);
          const housingMat = new THREE.MeshPhongMaterial({
            color: 0x444455,
            shininess: 120,
            specular: 0x888899
          });
          const housing = new THREE.Mesh(housingGeo, housingMat);
          housing.position.set(barrelPositions[b].x, 0.1, barrelPositions[b].z);
          housing.rotation.x = Math.PI / 4;
          turretGroup.add(housing);

          // Barrel tube
          const barrelGeo = new THREE.CylinderGeometry(0.07, 0.06, 0.45, 16);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x333344,
            shininess: 100,
            specular: 0x666677
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.position.set(
            barrelPositions[b].x,
            0.25 + b * 0.02,
            barrelPositions[b].z + 0.22
          );
          barrel.rotation.x = Math.PI / 4;
          turretGroup.add(barrel);

          // Barrel rings
          for (let r = 0; r < 2; r++) {
            const ringGeo = new THREE.TorusGeometry(0.075, 0.015, 6, 12);
            const ringMat = new THREE.MeshPhongMaterial({
              color: 0x666677,
              shininess: 100
            });
            const ring = new THREE.Mesh(ringGeo, ringMat);
            ring.position.set(
              barrelPositions[b].x,
              0.15 + r * 0.15 + b * 0.02,
              barrelPositions[b].z + 0.15 + r * 0.1
            );
            ring.rotation.x = Math.PI / 4 + Math.PI / 2;
            turretGroup.add(ring);
          }

          // Glowing muzzle tip
          const tipGeo = new THREE.SphereGeometry(0.08, 12, 12);
          const tipMat = new THREE.MeshPhongMaterial({
            color: skinColors.tip,
            emissive: skinColors.tipEmissive,
            emissiveIntensity: 0.9,
            shininess: 150
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(
            barrelPositions[b].x,
            0.43 + b * 0.02,
            barrelPositions[b].z + 0.42
          );
          turretGroup.add(tip);

          // Muzzle glow effect
          const tipGlowGeo = new THREE.SphereGeometry(0.12, 10, 10);
          const tipGlowMat = new THREE.MeshBasicMaterial({
            color: skinColors.tip,
            transparent: true,
            opacity: 0.5
          });
          const tipGlow = new THREE.Mesh(tipGlowGeo, tipGlowMat);
          tipGlow.position.copy(tip.position);
          turretGroup.add(tipGlow);
        }

        // Ammo belt visual connecting clusters to barrels (part of turret)
        for (let i = 0; i < 2; i++) {
          const beltGeo = new THREE.CylinderGeometry(0.025, 0.025, 0.4, 8);
          const beltMat = new THREE.MeshPhongMaterial({
            color: skinColors.grape,
            emissive: skinColors.grapeEmissive,
            emissiveIntensity: 0.4,
            shininess: 80
          });
          const belt = new THREE.Mesh(beltGeo, beltMat);
          const xPos = i === 0 ? -0.35 : 0.35;
          belt.position.set(xPos, -0.05, 0.15);
          belt.rotation.x = Math.PI / 3;
          belt.rotation.z = i === 0 ? 0.3 : -0.3;
          turretGroup.add(belt);
        }

        // Overall aura glow
        const auraGeo = new THREE.SphereGeometry(0.9, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: skinColors.energy,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.7;
        group.add(aura);

        break;
      }

      case 'star-launcher': {
        // Fusion of grape-lily + pear-launcher - EPIC COSMIC STAR CANNON

        // Ornate golden pedestal base with gems
        const pedestalGeo = new THREE.CylinderGeometry(0.55, 0.65, 0.4, 12);
        const pedestalMat = new THREE.MeshPhongMaterial({
          color: 0xffd700,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0xcc9900,
          emissiveIntensity: 0.3
        });
        const pedestal = new THREE.Mesh(pedestalGeo, pedestalMat);
        pedestal.position.y = 0.2;
        group.add(pedestal);

        // Decorative gem rings on pedestal
        for (let i = 0; i < 6; i++) {
          const gemGeo = new THREE.OctahedronGeometry(0.1, 0);
          const gemMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0xff00ff : 0x00ffff,
            shininess: 200,
            emissive: i % 2 === 0 ? 0xff00ff : 0x00ffff,
            emissiveIntensity: 0.6
          });
          const gem = new THREE.Mesh(gemGeo, gemMat);
          const angle = (i / 6) * Math.PI * 2;
          gem.position.set(Math.cos(angle) * 0.5, 0.2, Math.sin(angle) * 0.5);
          group.add(gem);
        }

        // Cosmic cannon body
        const cannonGeo = new THREE.CylinderGeometry(0.35, 0.45, 1.2, 16);
        const cannonMat = new THREE.MeshPhongMaterial({
          color: 0x4a0080,
          shininess: 120,
          specular: 0xffffff,
          emissive: 0x6600cc,
          emissiveIntensity: 0.4
        });
        const cannon = new THREE.Mesh(cannonGeo, cannonMat);
        cannon.position.y = 1.0;
        group.add(cannon);

        // Golden trim rings on cannon
        for (let i = 0; i < 3; i++) {
          const trimGeo = new THREE.TorusGeometry(0.4, 0.06, 8, 16);
          const trimMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            shininess: 150,
            emissive: 0xffaa00,
            emissiveIntensity: 0.3
          });
          const trim = new THREE.Mesh(trimGeo, trimMat);
          trim.position.y = 0.5 + i * 0.5;
          trim.rotation.x = Math.PI / 2;
          group.add(trim);
        }

        // Giant rotating star at top
        const starCore = new THREE.Group();
        // Main 5-pointed star made of cones
        for (let i = 0; i < 5; i++) {
          const pointGeo = new THREE.ConeGeometry(0.2, 0.7, 8);
          const pointMat = new THREE.MeshPhongMaterial({
            color: 0xffff00,
            shininess: 200,
            emissive: 0xffff00,
            emissiveIntensity: 0.9
          });
          const point = new THREE.Mesh(pointGeo, pointMat);
          const angle = (i / 5) * Math.PI * 2;
          point.position.set(Math.cos(angle) * 0.35, 0, Math.sin(angle) * 0.35);
          point.rotation.z = Math.PI / 2;
          point.rotation.y = angle;
          starCore.add(point);
        }
        // Inner star
        for (let i = 0; i < 5; i++) {
          const innerGeo = new THREE.ConeGeometry(0.12, 0.4, 6);
          const innerMat = new THREE.MeshPhongMaterial({
            color: 0xffffff,
            shininess: 200,
            emissive: 0xffffaa,
            emissiveIntensity: 1.0
          });
          const inner = new THREE.Mesh(innerGeo, innerMat);
          const angle = (i / 5) * Math.PI * 2 + Math.PI / 5;
          inner.position.set(Math.cos(angle) * 0.2, 0, Math.sin(angle) * 0.2);
          inner.rotation.z = Math.PI / 2;
          inner.rotation.y = angle;
          starCore.add(inner);
        }
        starCore.position.y = 1.8;
        group.add(starCore);

        // Bright center orb
        const orbGeo = new THREE.SphereGeometry(0.25, 16, 16);
        const orbMat = new THREE.MeshBasicMaterial({
          color: 0xffffff
        });
        const orb = new THREE.Mesh(orbGeo, orbMat);
        orb.position.y = 1.8;
        group.add(orb);

        // Multiple glow layers
        for (let i = 0; i < 3; i++) {
          const glowGeo = new THREE.SphereGeometry(0.5 + i * 0.2, 16, 16);
          const glowMat = new THREE.MeshBasicMaterial({
            color: i === 0 ? 0xffff00 : i === 1 ? 0xffaa00 : 0xff6600,
            transparent: true,
            opacity: 0.25 - i * 0.06
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.y = 1.8;
          group.add(glow);
        }

        // Floating sparkles around
        for (let i = 0; i < 8; i++) {
          const sparkleGeo = new THREE.OctahedronGeometry(0.06, 0);
          const sparkleMat = new THREE.MeshBasicMaterial({
            color: 0xffffff
          });
          const sparkle = new THREE.Mesh(sparkleGeo, sparkleMat);
          const angle = (i / 8) * Math.PI * 2;
          sparkle.position.set(
            Math.cos(angle) * 0.7,
            1.5 + (i % 3) * 0.3,
            Math.sin(angle) * 0.7
          );
          group.add(sparkle);
        }

        break;
      }

      case 'pear-spiker': {
        // EPIC PEAR SPIKER - Golden artillery cannon with devastating spike rounds

        // Armored siege platform base
        const platformGeo = new THREE.CylinderGeometry(0.6, 0.7, 0.35, 8);
        const platformMat = new THREE.MeshPhongMaterial({
          color: 0x2a2a2a,
          shininess: 100,
          specular: 0x666666,
          emissive: 0x111111,
          emissiveIntensity: 0.2
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.18;
        group.add(platform);

        // Golden trim around base
        const trimGeo = new THREE.TorusGeometry(0.65, 0.06, 8, 24);
        const trimMat = new THREE.MeshPhongMaterial({
          color: 0xffd700,
          shininess: 150,
          specular: 0xffff88,
          emissive: 0xcc9900,
          emissiveIntensity: 0.3
        });
        const trim = new THREE.Mesh(trimGeo, trimMat);
        trim.position.y = 0.35;
        trim.rotation.x = Math.PI / 2;
        group.add(trim);

        // Armored supports
        for (let i = 0; i < 4; i++) {
          const supportGeo = new THREE.BoxGeometry(0.15, 0.5, 0.1);
          const supportMat = new THREE.MeshPhongMaterial({
            color: 0x333333,
            shininess: 80,
            specular: 0x888888
          });
          const support = new THREE.Mesh(supportGeo, supportMat);
          const angle = (i / 4) * Math.PI * 2 + Math.PI / 4;
          support.position.set(Math.cos(angle) * 0.45, 0.55, Math.sin(angle) * 0.45);
          support.rotation.y = angle;
          group.add(support);
        }

        // Main golden pear body - larger and more impressive
        const pearGeo = new THREE.SphereGeometry(0.5, 24, 24);
        const pearMat = new THREE.MeshPhongMaterial({
          color: 0xffc800,
          shininess: 130,
          specular: 0xffffff,
          emissive: 0xcc8800,
          emissiveIntensity: 0.4
        });
        const pear = new THREE.Mesh(pearGeo, pearMat);
        pear.scale.set(1, 1.5, 1);
        pear.position.y = 1.1;
        group.add(pear);

        // Decorative golden rings around pear
        for (let i = 0; i < 3; i++) {
          const ringGeo = new THREE.TorusGeometry(0.4 - i * 0.05, 0.03, 8, 20);
          const ringMat = new THREE.MeshPhongMaterial({
            color: 0xffdd44,
            shininess: 140,
            emissive: 0xaa7700,
            emissiveIntensity: 0.3
          });
          const ring = new THREE.Mesh(ringGeo, ringMat);
          ring.position.y = 0.85 + i * 0.25;
          ring.rotation.x = Math.PI / 2;
          group.add(ring);
        }

        // Inner glowing core
        const coreGeo = new THREE.SphereGeometry(0.25, 16, 16);
        const coreMat = new THREE.MeshBasicMaterial({
          color: 0xffff88,
          transparent: true,
          opacity: 0.7
        });
        const core = new THREE.Mesh(coreGeo, coreMat);
        core.position.y = 1.1;
        group.add(core);

        // Heavy reinforced spike cannon housing
        const housingGeo = new THREE.CylinderGeometry(0.28, 0.22, 0.4, 12);
        const housingMat = new THREE.MeshPhongMaterial({
          color: 0x444444,
          shininess: 110,
          specular: 0xaaaaaa,
          emissive: 0x222222,
          emissiveIntensity: 0.2
        });
        const housing = new THREE.Mesh(housingGeo, housingMat);
        housing.position.set(0.4, 1.25, 0);
        housing.rotation.z = -Math.PI / 3;
        group.add(housing);

        // Main spike cannon barrel
        const barrelGeo = new THREE.CylinderGeometry(0.18, 0.14, 1.2, 16);
        const barrelMat = new THREE.MeshPhongMaterial({
          color: 0x2a2a2a,
          shininess: 120,
          specular: 0x888888,
          emissive: 0x111111,
          emissiveIntensity: 0.15
        });
        const barrel = new THREE.Mesh(barrelGeo, barrelMat);
        barrel.position.set(0.7, 1.55, 0);
        barrel.rotation.z = -Math.PI / 3;
        group.add(barrel);

        // Reinforcement rings on barrel
        for (let i = 0; i < 3; i++) {
          const bRingGeo = new THREE.TorusGeometry(0.2, 0.04, 8, 16);
          const bRingMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            shininess: 140,
            emissive: 0xaa8800,
            emissiveIntensity: 0.4
          });
          const bRing = new THREE.Mesh(bRingGeo, bRingMat);
          const offset = i * 0.35;
          bRing.position.set(0.55 + offset * 0.35, 1.35 + offset * 0.5, 0);
          bRing.rotation.z = -(Math.PI / 3 + Math.PI / 2);
          group.add(bRing);
        }

        // Deadly glowing spike tip
        const spikeGeo = new THREE.ConeGeometry(0.18, 0.7, 12);
        const spikeMat = new THREE.MeshPhongMaterial({
          color: 0xff2200,
          shininess: 150,
          specular: 0xff8866,
          emissive: 0xcc0000,
          emissiveIntensity: 0.7
        });
        const spike = new THREE.Mesh(spikeGeo, spikeMat);
        spike.position.set(1.05, 2.0, 0);
        spike.rotation.z = -Math.PI / 3;
        group.add(spike);

        // Spike glow effect
        const spikeGlowGeo = new THREE.SphereGeometry(0.25, 12, 12);
        const spikeGlowMat = new THREE.MeshBasicMaterial({
          color: 0xff4400,
          transparent: true,
          opacity: 0.5
        });
        const spikeGlow = new THREE.Mesh(spikeGlowGeo, spikeGlowMat);
        spikeGlow.position.set(1.05, 2.0, 0);
        group.add(spikeGlow);

        // Side armor plates
        for (let i = 0; i < 2; i++) {
          const plateGeo = new THREE.BoxGeometry(0.35, 0.6, 0.1);
          const plateMat = new THREE.MeshPhongMaterial({
            color: 0x3a3a3a,
            shininess: 90,
            specular: 0x666666
          });
          const plate = new THREE.Mesh(plateGeo, plateMat);
          plate.position.set(i === 0 ? -0.45 : 0.45, 1.0, 0.1);
          plate.rotation.y = i === 0 ? 0.3 : -0.3;
          group.add(plate);
        }

        // Decorative spikes on sides
        for (let side = 0; side < 2; side++) {
          for (let i = 0; i < 3; i++) {
            const dSpikeGeo = new THREE.ConeGeometry(0.06, 0.25, 8);
            const dSpikeMat = new THREE.MeshPhongMaterial({
              color: 0x555555,
              shininess: 100,
              specular: 0xaaaaaa
            });
            const dSpike = new THREE.Mesh(dSpikeGeo, dSpikeMat);
            const xPos = side === 0 ? -0.55 : 0.55;
            dSpike.position.set(xPos, 0.7 + i * 0.25, 0.1);
            dSpike.rotation.z = side === 0 ? Math.PI / 2 : -Math.PI / 2;
            group.add(dSpike);
          }
        }

        // Energy aura
        const auraGeo = new THREE.SphereGeometry(0.8, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xffcc00,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 1.2;
        group.add(aura);

        // Orbiting energy particles
        for (let i = 0; i < 6; i++) {
          const particleGeo = new THREE.SphereGeometry(0.06, 8, 8);
          const particleMat = new THREE.MeshBasicMaterial({
            color: 0xffdd44,
            transparent: true,
            opacity: 0.8
          });
          const particle = new THREE.Mesh(particleGeo, particleMat);
          const angle = (i / 6) * Math.PI * 2;
          particle.position.set(Math.cos(angle) * 0.65, 1.1 + Math.sin(i) * 0.2, Math.sin(angle) * 0.65);
          group.add(particle);
        }

        break;
      }

      case 'seed-batch': {
        // Magical seed pod - glowing with transformation power

        // Main pod body (bean/seed shaped)
        const podGeo = new THREE.CapsuleGeometry(0.3, 0.6, 4, 8);
        const podMat = new THREE.MeshPhongMaterial({
          color: 0x8b4513,
          shininess: 60
        });
        const pod = new THREE.Mesh(podGeo, podMat);
        pod.rotation.z = Math.PI / 6;
        pod.position.y = 0.5;
        group.add(pod);

        // Glowing magical aura
        const auraGeo = new THREE.SphereGeometry(0.5, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xffff00,
          transparent: true,
          opacity: 0.3
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.5;
        group.add(aura);

        // Seed details (little seeds visible through pod)
        for (let i = 0; i < 5; i++) {
          const seedGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const seedMat = new THREE.MeshPhongMaterial({
            color: 0xffd700,
            emissive: 0xffd700,
            emissiveIntensity: 0.5
          });
          const seed = new THREE.Mesh(seedGeo, seedMat);
          seed.position.set(
            (Math.random() - 0.5) * 0.3,
            0.3 + i * 0.15,
            (Math.random() - 0.5) * 0.2
          );
          group.add(seed);
        }

        break;
      }

      case 'strawbomber': {
        // TITAN: Strawberry bomb launcher artillery platform

        // Hexagonal armored base
        const baseGeo = new THREE.CylinderGeometry(0.9, 1, 0.6, 6);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x8b0000,
          shininess: 100,
          emissive: 0x330000,
          emissiveIntensity: 0.3
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.3;
        group.add(base);

        // Rotating turret platform
        const turretGeo = new THREE.CylinderGeometry(0.8, 0.7, 0.4, 16);
        const turretMat = new THREE.MeshPhongMaterial({
          color: 0xdc143c,
          shininess: 120,
          specular: 0xff8888
        });
        const turret = new THREE.Mesh(turretGeo, turretMat);
        turret.position.y = 0.7;
        group.add(turret);
        group.userData.turret = turret; // Store reference for rotation

        // Triple artillery barrels with details
        for (let i = 0; i < 3; i++) {
          // Main barrel
          const barrelGeo = new THREE.CylinderGeometry(0.18, 0.2, 1.5, 16);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x4a0000,
            shininess: 100
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.position.set((i - 1) * 0.45, 1.3, 0);
          barrel.rotation.x = -Math.PI / 6; // Angled up
          turret.add(barrel);

          // Barrel tip glow
          const tipGeo = new THREE.CylinderGeometry(0.2, 0.18, 0.15, 16);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0xff4500,
            emissive: 0xff4500,
            emissiveIntensity: 0.8
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set((i - 1) * 0.45, 2, -0.3);
          tip.rotation.x = -Math.PI / 6;
          turret.add(tip);

          // Ammunition feed tubes
          const tubeGeo = new THREE.CylinderGeometry(0.08, 0.08, 0.8, 8);
          const tubeMat = new THREE.MeshPhongMaterial({
            color: 0xa52a2a,
            shininess: 80
          });
          const tube = new THREE.Mesh(tubeGeo, tubeMat);
          tube.position.set((i - 1) * 0.45, 0.8, 0.3);
          tube.rotation.x = Math.PI / 4;
          turret.add(tube);
        }

        // Central bomb storage with strawberry texture
        const chamberGeo = new THREE.SphereGeometry(0.55, 20, 20);
        const chamberMat = new THREE.MeshPhongMaterial({
          color: 0xff0000,
          shininess: 120,
          emissive: 0xff1a1a,
          emissiveIntensity: 0.4
        });
        const chamber = new THREE.Mesh(chamberGeo, chamberMat);
        chamber.position.y = 0.7;
        turret.add(chamber);

        // Strawberry seeds details on chamber
        for (let i = 0; i < 12; i++) {
          const angle = (i / 12) * Math.PI * 2;
          const seedGeo = new THREE.SphereGeometry(0.06, 8, 8);
          const seedMat = new THREE.MeshPhongMaterial({
            color: 0xffff00,
            shininess: 100
          });
          const seed = new THREE.Mesh(seedGeo, seedMat);
          seed.position.set(
            Math.cos(angle) * 0.5,
            0.7 + Math.sin(i * 1.2) * 0.3,
            Math.sin(angle) * 0.5
          );
          turret.add(seed);
        }

        // Targeting array
        for (let i = 0; i < 3; i++) {
          const radarGeo = new THREE.BoxGeometry(0.1, 0.15, 0.05);
          const radarMat = new THREE.MeshPhongMaterial({
            color: 0x00ff00,
            emissive: 0x00ff00,
            emissiveIntensity: 0.6
          });
          const radar = new THREE.Mesh(radarGeo, radarMat);
          radar.position.set((i - 1) * 0.35, 1.1, 0.6);
          turret.add(radar);
        }

        // Armored shields on sides
        const shieldGeo = new THREE.BoxGeometry(0.3, 0.9, 0.1);
        const shieldMat = new THREE.MeshPhongMaterial({
          color: 0x8b0000,
          shininess: 90
        });
        for (let side = -1; side <= 1; side += 2) {
          const shield = new THREE.Mesh(shieldGeo, shieldMat);
          shield.position.set(side * 0.75, 0.9, 0);
          turret.add(shield);
        }

        // Scale to fit titan 2-tile space
        group.scale.set(0.85, 0.85, 0.85);

        break;
      }

      case 'frovine-slammer': {
        // EPIC TITAN: Colossal Frost-Vine Golem - The Ultimate Ice Berserker!

        // === FROZEN GROUND AURA ===
        const groundAuraGeo = new THREE.CylinderGeometry(1.3, 1.5, 0.1, 24);
        const groundAuraMat = new THREE.MeshBasicMaterial({
          color: 0x66ddff,
          transparent: true,
          opacity: 0.4
        });
        const groundAura = new THREE.Mesh(groundAuraGeo, groundAuraMat);
        groundAura.position.y = 0.05;
        group.add(groundAura);

        // Massive frozen stone base
        const baseGeo = new THREE.CylinderGeometry(1.0, 1.2, 0.5, 8);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x1a3a4a,
          shininess: 80,
          emissive: 0x0a1a2a,
          emissiveIntensity: 0.2
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.25;
        group.add(base);

        // Huge ice crystal formations around base
        for (let i = 0; i < 10; i++) {
          const crystalHeight = 0.5 + Math.random() * 0.6;
          const crystalGeo = new THREE.ConeGeometry(0.12 + Math.random() * 0.08, crystalHeight, 4);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0xaaffff,
            shininess: 220,
            transparent: true,
            opacity: 0.85,
            emissive: 0x66ddff,
            emissiveIntensity: 0.5
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const angle = (i / 10) * Math.PI * 2;
          const radius = 1.1 + Math.random() * 0.2;
          crystal.position.set(Math.cos(angle) * radius, crystalHeight / 2, Math.sin(angle) * radius);
          crystal.rotation.x = (Math.random() - 0.5) * 0.4;
          crystal.rotation.z = (Math.random() - 0.5) * 0.4;
          group.add(crystal);
        }

        // === MASSIVE LEGS ===
        for (let side = -1; side <= 1; side += 2) {
          // Thick vine leg
          const legGeo = new THREE.CylinderGeometry(0.25, 0.3, 0.8, 10);
          const legMat = new THREE.MeshPhongMaterial({
            color: 0x1e5a2e,
            shininess: 80,
            emissive: 0x0a3a1a,
            emissiveIntensity: 0.3
          });
          const leg = new THREE.Mesh(legGeo, legMat);
          leg.position.set(side * 0.45, 0.7, 0);
          group.add(leg);

          // Ice encasement on leg
          const legIceGeo = new THREE.CylinderGeometry(0.28, 0.33, 0.6, 8);
          const legIceMat = new THREE.MeshPhongMaterial({
            color: 0x88ddff,
            shininess: 180,
            transparent: true,
            opacity: 0.6,
            emissive: 0x44aadd,
            emissiveIntensity: 0.4
          });
          const legIce = new THREE.Mesh(legIceGeo, legIceMat);
          legIce.position.set(side * 0.45, 0.8, 0);
          group.add(legIce);

          // Frozen foot
          const footGeo = new THREE.BoxGeometry(0.4, 0.2, 0.5);
          const footMat = new THREE.MeshPhongMaterial({
            color: 0x2a6a3a,
            shininess: 60,
            emissive: 0x1a4a2a,
            emissiveIntensity: 0.2
          });
          const foot = new THREE.Mesh(footGeo, footMat);
          foot.position.set(side * 0.45, 0.2, 0.05);
          group.add(foot);
        }

        // === HULKING TORSO ===
        const torsoGeo = new THREE.CylinderGeometry(0.65, 0.8, 1.3, 12);
        const torsoMat = new THREE.MeshPhongMaterial({
          color: 0x2a6a3a,
          shininess: 100,
          emissive: 0x1a4a2a,
          emissiveIntensity: 0.3
        });
        const torso = new THREE.Mesh(torsoGeo, torsoMat);
        torso.position.y = 1.4;
        group.add(torso);

        // Thick frozen vines wrapping torso
        for (let i = 0; i < 6; i++) {
          const vineGeo = new THREE.TorusGeometry(0.7 + i * 0.03, 0.1, 8, 20);
          const vineMat = new THREE.MeshPhongMaterial({
            color: 0x3a8a4a,
            shininess: 90,
            emissive: 0x2a6a3a,
            emissiveIntensity: 0.3
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.y = 1.0 + i * 0.18;
          vine.rotation.x = Math.PI / 2;
          vine.rotation.z = i * 0.5;
          group.add(vine);

          // Ice on vines
          if (i % 2 === 0) {
            const vineIceGeo = new THREE.TorusGeometry(0.72 + i * 0.03, 0.06, 8, 20);
            const vineIceMat = new THREE.MeshPhongMaterial({
              color: 0xaaffff,
              shininess: 200,
              transparent: true,
              opacity: 0.5,
              emissive: 0x66ddff,
              emissiveIntensity: 0.4
            });
            const vineIce = new THREE.Mesh(vineIceGeo, vineIceMat);
            vineIce.position.y = 1.0 + i * 0.18;
            vineIce.rotation.x = Math.PI / 2;
            vineIce.rotation.z = i * 0.5;
            group.add(vineIce);
          }
        }

        // Ice chest plate with glowing core
        const chestGeo = new THREE.BoxGeometry(0.8, 0.6, 0.35);
        const chestMat = new THREE.MeshPhongMaterial({
          color: 0x77ddff,
          shininess: 200,
          transparent: true,
          opacity: 0.75,
          emissive: 0x44bbff,
          emissiveIntensity: 0.6
        });
        const chest = new THREE.Mesh(chestGeo, chestMat);
        chest.position.set(0, 1.55, 0.4);
        group.add(chest);

        // Glowing frost core
        const coreGeo = new THREE.SphereGeometry(0.22, 16, 16);
        const coreMat = new THREE.MeshBasicMaterial({
          color: 0x00ffff
        });
        const core = new THREE.Mesh(coreGeo, coreMat);
        core.position.set(0, 1.55, 0.55);
        group.add(core);

        // Core glow layers
        for (let g = 0; g < 2; g++) {
          const glowGeo = new THREE.SphereGeometry(0.28 + g * 0.1, 12, 12);
          const glowMat = new THREE.MeshBasicMaterial({
            color: 0x66ffff,
            transparent: true,
            opacity: 0.4 - g * 0.15
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.set(0, 1.55, 0.55);
          group.add(glow);
        }

        // === COLOSSAL ARMS & FISTS ===
        for (let side = -1; side <= 1; side += 2) {
          // Massive shoulder
          const shoulderGeo = new THREE.SphereGeometry(0.35, 12, 12);
          const shoulderMat = new THREE.MeshPhongMaterial({
            color: 0x3a8a4a,
            shininess: 90,
            emissive: 0x2a6a3a,
            emissiveIntensity: 0.3
          });
          const shoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
          shoulder.position.set(side * 0.85, 1.9, 0);
          group.add(shoulder);

          // Shoulder ice spike
          const shoulderSpikeGeo = new THREE.ConeGeometry(0.15, 0.6, 4);
          const shoulderSpikeMat = new THREE.MeshPhongMaterial({
            color: 0xaaffff,
            shininess: 200,
            transparent: true,
            opacity: 0.9,
            emissive: 0x66ddff,
            emissiveIntensity: 0.5
          });
          const shoulderSpike = new THREE.Mesh(shoulderSpikeGeo, shoulderSpikeMat);
          shoulderSpike.position.set(side * 1.0, 2.2, 0);
          shoulderSpike.rotation.z = side * 0.4;
          group.add(shoulderSpike);

          // Upper arm (thick vine)
          const upperArmGeo = new THREE.CylinderGeometry(0.22, 0.28, 0.7, 10);
          const upperArmMat = new THREE.MeshPhongMaterial({
            color: 0x2a6a3a,
            shininess: 80,
            emissive: 0x1a4a2a,
            emissiveIntensity: 0.3
          });
          const upperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
          upperArm.position.set(side * 1.1, 1.55, 0.1);
          upperArm.rotation.z = side * 0.5;
          group.add(upperArm);

          // Forearm (with ice armor)
          const forearmGeo = new THREE.CylinderGeometry(0.26, 0.22, 0.65, 10);
          const forearmMat = new THREE.MeshPhongMaterial({
            color: 0x55bbdd,
            shininess: 150,
            emissive: 0x3399bb,
            emissiveIntensity: 0.4
          });
          const forearm = new THREE.Mesh(forearmGeo, forearmMat);
          forearm.position.set(side * 1.25, 1.1, 0.25);
          forearm.rotation.z = side * 0.3;
          group.add(forearm);

          // === GIANT CRYSTAL FIST ===
          const fistGeo = new THREE.DodecahedronGeometry(0.45, 0);
          const fistMat = new THREE.MeshPhongMaterial({
            color: 0x88eeff,
            shininess: 220,
            emissive: 0x44ccff,
            emissiveIntensity: 0.7
          });
          const fist = new THREE.Mesh(fistGeo, fistMat);
          fist.position.set(side * 1.4, 0.55, 0.4);
          group.add(fist);

          // Inner fist glow
          const fistGlowGeo = new THREE.DodecahedronGeometry(0.35, 0);
          const fistGlowMat = new THREE.MeshBasicMaterial({
            color: 0x00ffff,
            transparent: true,
            opacity: 0.5
          });
          const fistGlow = new THREE.Mesh(fistGlowGeo, fistGlowMat);
          fistGlow.position.copy(fist.position);
          group.add(fistGlow);

          // Deadly ice knuckle spikes
          for (let k = 0; k < 5; k++) {
            const spikeGeo = new THREE.ConeGeometry(0.08, 0.5, 4);
            const spikeMat = new THREE.MeshPhongMaterial({
              color: 0xccffff,
              shininess: 250,
              emissive: 0x88eeff,
              emissiveIntensity: 0.8
            });
            const spike = new THREE.Mesh(spikeGeo, spikeMat);
            const angle = (k / 5) * Math.PI - Math.PI / 2;
            spike.position.set(
              side * 1.4 + side * Math.cos(angle) * 0.35,
              0.55 + Math.sin(angle) * 0.25,
              0.75
            );
            spike.rotation.x = Math.PI / 2.5;
            group.add(spike);
          }

          // Side spikes on fist
          for (let s = 0; s < 3; s++) {
            const sideSpikeGeo = new THREE.ConeGeometry(0.06, 0.35, 4);
            const sideSpikeMat = new THREE.MeshPhongMaterial({
              color: 0xaaffff,
              shininess: 200,
              emissive: 0x66ddff,
              emissiveIntensity: 0.6
            });
            const sideSpike = new THREE.Mesh(sideSpikeGeo, sideSpikeMat);
            sideSpike.position.set(
              side * 1.4 + side * 0.4,
              0.35 + s * 0.2,
              0.4
            );
            sideSpike.rotation.z = side * Math.PI / 2;
            group.add(sideSpike);
          }
        }

        // === CRYSTALLINE ICE HEAD ===
        const headGeo = new THREE.IcosahedronGeometry(0.4, 1);
        const headMat = new THREE.MeshPhongMaterial({
          color: 0x66eeff,
          shininess: 250,
          emissive: 0x44ccff,
          emissiveIntensity: 0.6,
          transparent: true,
          opacity: 0.9
        });
        const head = new THREE.Mesh(headGeo, headMat);
        head.position.y = 2.35;
        group.add(head);

        // Inner head glow
        const headGlowGeo = new THREE.SphereGeometry(0.25, 12, 12);
        const headGlowMat = new THREE.MeshBasicMaterial({
          color: 0x00ffff,
          transparent: true,
          opacity: 0.7
        });
        const headGlow = new THREE.Mesh(headGlowGeo, headGlowMat);
        headGlow.position.y = 2.35;
        group.add(headGlow);

        // Fierce glowing eyes
        for (let side = -1; side <= 1; side += 2) {
          const eyeGeo = new THREE.SphereGeometry(0.1, 12, 12);
          const eyeMat = new THREE.MeshBasicMaterial({
            color: 0x00ff88
          });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.15, 2.38, 0.28);
          group.add(eye);

          // Eye glow
          const eyeGlowGeo = new THREE.SphereGeometry(0.15, 8, 8);
          const eyeGlowMat = new THREE.MeshBasicMaterial({
            color: 0x44ffaa,
            transparent: true,
            opacity: 0.5
          });
          const eyeGlow = new THREE.Mesh(eyeGlowGeo, eyeGlowMat);
          eyeGlow.position.copy(eye.position);
          group.add(eyeGlow);
        }

        // Majestic ice crown
        for (let c = 0; c < 7; c++) {
          const crownHeight = 0.4 + Math.random() * 0.3;
          const crownGeo = new THREE.ConeGeometry(0.06, crownHeight, 4);
          const crownMat = new THREE.MeshPhongMaterial({
            color: 0xccffff,
            shininess: 250,
            transparent: true,
            opacity: 0.9,
            emissive: 0x88eeff,
            emissiveIntensity: 0.7
          });
          const crown = new THREE.Mesh(crownGeo, crownMat);
          const angle = (c / 7) * Math.PI * 2;
          crown.position.set(
            Math.cos(angle) * 0.32,
            2.7 + crownHeight / 2,
            Math.sin(angle) * 0.32
          );
          crown.rotation.x = -Math.sin(angle) * 0.2;
          crown.rotation.z = Math.cos(angle) * 0.2;
          group.add(crown);
        }

        // === FROST AURA EFFECTS ===
        // Orbiting ice shards
        for (let i = 0; i < 8; i++) {
          const shardGeo = new THREE.OctahedronGeometry(0.12, 0);
          const shardMat = new THREE.MeshPhongMaterial({
            color: 0x88eeff,
            shininess: 200,
            transparent: true,
            opacity: 0.8,
            emissive: 0x44ccff,
            emissiveIntensity: 0.6
          });
          const shard = new THREE.Mesh(shardGeo, shardMat);
          const angle = (i / 8) * Math.PI * 2;
          shard.position.set(
            Math.cos(angle) * 1.0,
            1.2 + (i % 2) * 0.6,
            Math.sin(angle) * 1.0
          );
          group.add(shard);
        }

        // Floating snow/ice particles
        for (let p = 0; p < 16; p++) {
          const particleGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const particleMat = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.8
          });
          const particle = new THREE.Mesh(particleGeo, particleMat);
          particle.position.set(
            (Math.random() - 0.5) * 2.5,
            0.5 + Math.random() * 2.5,
            (Math.random() - 0.5) * 2.5
          );
          group.add(particle);
        }

        // Large frost aura rings
        for (let r = 0; r < 2; r++) {
          const ringGeo = new THREE.TorusGeometry(1.2 + r * 0.3, 0.03, 8, 32);
          const ringMat = new THREE.MeshBasicMaterial({
            color: 0x66ddff,
            transparent: true,
            opacity: 0.3 - r * 0.1
          });
          const ring = new THREE.Mesh(ringGeo, ringMat);
          ring.position.y = 1.0 + r * 0.5;
          ring.rotation.x = Math.PI / 2;
          group.add(ring);
        }

        // Scale to fit titan 2-tile space (golem is very wide)
        group.scale.set(0.55, 0.55, 0.55);

        break;
      }

      case 'pear-nuker': {
        // TITAN: Massive pear nuke launcher - Ultra detailed nuclear artillery

        // Heavy reinforced base platform with hydraulics
        const baseGeo = new THREE.CylinderGeometry(0.9, 1.0, 0.5, 8);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x8b7d3b,
          shininess: 120,
          specular: 0xffee88
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.25;
        group.add(base);

        // Rotating turret base
        const turretBaseGeo = new THREE.CylinderGeometry(0.8, 0.75, 0.4, 16);
        const turretBaseMat = new THREE.MeshPhongMaterial({
          color: 0xffd700,
          shininess: 150,
          emissive: 0xffaa00,
          emissiveIntensity: 0.4,
          specular: 0xffff88
        });
        const turretBase = new THREE.Mesh(turretBaseGeo, turretBaseMat);
        turretBase.position.y = 0.6;
        group.add(turretBase);
        group.userData.turret = turretBase; // Store for rotation

        // Launch tube housing
        const housingGeo = new THREE.CylinderGeometry(0.5, 0.55, 1.0, 12);
        const housingMat = new THREE.MeshPhongMaterial({
          color: 0xb8860b,
          shininess: 110,
          specular: 0xddaa44
        });
        const housing = new THREE.Mesh(housingGeo, housingMat);
        housing.position.set(0, 1.2, 0);
        turretBase.add(housing);

        // MASSIVE nuclear pear warhead
        const pearGeo = new THREE.SphereGeometry(0.65, 24, 24);
        const pearMat = new THREE.MeshPhongMaterial({
          color: 0xd4af37,
          shininess: 130,
          emissive: 0xff6600,
          emissiveIntensity: 0.6,
          specular: 0xffdd88
        });
        const pear = new THREE.Mesh(pearGeo, pearMat);
        pear.position.set(0, 1.8, 0);
        pear.scale.set(1, 1.4, 1); // Pear shape
        turretBase.add(pear);

        // Nuclear hazard symbols on warhead
        for (let i = 0; i < 4; i++) {
          const angle = (i / 4) * Math.PI * 2;
          const symbolGeo = new THREE.TorusGeometry(0.15, 0.03, 8, 12);
          const symbolMat = new THREE.MeshPhongMaterial({
            color: 0xff0000,
            emissive: 0xff0000,
            emissiveIntensity: 0.9
          });
          const symbol = new THREE.Mesh(symbolGeo, symbolMat);
          symbol.position.set(
            Math.cos(angle) * 0.5,
            1.8,
            Math.sin(angle) * 0.5
          );
          symbol.rotation.y = angle;
          symbol.rotation.x = Math.PI / 2;
          turretBase.add(symbol);
        }

        // Advanced targeting array
        for (let i = 0; i < 3; i++) {
          const scopeGeo = new THREE.TorusGeometry(0.35 + i * 0.1, 0.04, 8, 20);
          const scopeMat = new THREE.MeshPhongMaterial({
            color: i === 1 ? 0xff0000 : 0xff6600,
            emissive: i === 1 ? 0xff0000 : 0xff3300,
            emissiveIntensity: 0.9
          });
          const scope = new THREE.Mesh(scopeGeo, scopeMat);
          scope.position.set(0, 2.4 + i * 0.1, 0);
          scope.rotation.x = Math.PI / 2;
          turretBase.add(scope);
        }

        // Laser sights
        for (let i = 0; i < 4; i++) {
          const laserGeo = new THREE.CylinderGeometry(0.02, 0.02, 0.4, 8);
          const laserMat = new THREE.MeshBasicMaterial({
            color: 0xff0000
          });
          const laser = new THREE.Mesh(laserGeo, laserMat);
          laser.position.set((i - 1.5) * 0.3, 1.4, -0.5);
          laser.rotation.x = Math.PI / 2;
          turretBase.add(laser);
        }

        // Cooling vents with steam effect
        for (let i = 0; i < 6; i++) {
          const ventGeo = new THREE.BoxGeometry(0.15, 0.3, 0.08);
          const ventMat = new THREE.MeshPhongMaterial({
            color: 0x333333,
            emissive: 0xff4400,
            emissiveIntensity: 0.3
          });
          const vent = new THREE.Mesh(ventGeo, ventMat);
          const angle = (i / 6) * Math.PI * 2;
          vent.position.set(
            Math.cos(angle) * 0.6,
            1.0,
            Math.sin(angle) * 0.6
          );
          vent.rotation.y = angle;
          turretBase.add(vent);
        }

        // Stabilizer arms
        for (let i = 0; i < 4; i++) {
          const angle = (i / 4) * Math.PI * 2;
          const armGeo = new THREE.BoxGeometry(0.12, 0.4, 0.6);
          const armMat = new THREE.MeshPhongMaterial({
            color: 0x8b7355,
            shininess: 100
          });
          const arm = new THREE.Mesh(armGeo, armMat);
          arm.position.set(
            Math.cos(angle) * 0.7,
            0.5,
            Math.sin(angle) * 0.7
          );
          arm.rotation.y = angle;
          group.add(arm);
        }

        // Nuclear glow aura - pulsing energy
        const glowGeo = new THREE.SphereGeometry(1.0, 20, 20);
        const glowMat = new THREE.MeshBasicMaterial({
          color: 0xffff00,
          transparent: true,
          opacity: 0.25
        });
        const glow = new THREE.Mesh(glowGeo, glowMat);
        glow.position.set(0, 1.8, 0);
        turretBase.add(glow);

        // Warning lights
        for (let i = 0; i < 8; i++) {
          const angle = (i / 8) * Math.PI * 2;
          const lightGeo = new THREE.SphereGeometry(0.08, 12, 12);
          const lightMat = new THREE.MeshBasicMaterial({
            color: i % 2 === 0 ? 0xff0000 : 0xffff00
          });
          const light = new THREE.Mesh(lightGeo, lightMat);
          light.position.set(
            Math.cos(angle) * 0.85,
            0.6,
            Math.sin(angle) * 0.85
          );
          group.add(light);
        }

        // Scale to fit titan 2-tile space
        group.scale.set(0.85, 0.85, 0.85);

        break;
      }

      case 'rose-reaper': {
        // ROSE REAPER - LEGENDARY dark gothic masterpiece

        // ===== ANCIENT CRACKED GRAVESTONE BASE =====
        const stoneGeo = new THREE.BoxGeometry(0.9, 0.5, 0.15);
        const stoneMat = new THREE.MeshPhongMaterial({
          color: 0x3a3a40,
          shininess: 40,
          specular: 0x555560,
          emissive: 0x0a0a12,
          emissiveIntensity: 0.3
        });
        const stone = new THREE.Mesh(stoneGeo, stoneMat);
        stone.position.set(-0.3, 0.25, 0);
        stone.rotation.y = Math.PI / 2;
        group.add(stone);

        // Gravestone top arch
        const archGeo = new THREE.CylinderGeometry(0.45, 0.45, 0.15, 16, 1, false, 0, Math.PI);
        const arch = new THREE.Mesh(archGeo, stoneMat);
        arch.rotation.x = Math.PI / 2;
        arch.rotation.y = Math.PI / 2;
        arch.rotation.z = Math.PI / 2;
        arch.position.set(-0.3, 0.5, 0);
        group.add(arch);

        // Cracks in stone (dark lines)
        for (let i = 0; i < 5; i++) {
          const crackGeo = new THREE.BoxGeometry(0.02, 0.15 + Math.random() * 0.2, 0.02);
          const crackMat = new THREE.MeshBasicMaterial({ color: 0x1a1a1a });
          const crack = new THREE.Mesh(crackGeo, crackMat);
          crack.position.set(-0.22, 0.2 + Math.random() * 0.2, 0.3 - i * 0.15);
          crack.rotation.z = (Math.random() - 0.5) * 0.5;
          group.add(crack);
        }

        // ===== HAUNTED SKULL =====
        const skullGeo = new THREE.SphereGeometry(0.32, 32, 32);
        const skullMat = new THREE.MeshPhongMaterial({
          color: 0xd8d0c0,
          shininess: 100,
          specular: 0xffffff,
          emissive: 0x2a1515,
          emissiveIntensity: 0.25
        });
        const skull = new THREE.Mesh(skullGeo, skullMat);
        skull.scale.set(0.85, 0.9, 1);
        skull.position.set(0, 0.45, 0);
        group.add(skull);

        // Skull jaw with menacing grin
        const jawGeo = new THREE.SphereGeometry(0.22, 20, 20);
        const jaw = new THREE.Mesh(jawGeo, skullMat);
        jaw.scale.set(0.65, 0.45, 0.85);
        jaw.position.set(0.08, 0.22, 0);
        group.add(jaw);

        // Deep eye sockets with infernal glow
        for (let side = -1; side <= 1; side += 2) {
          // Outer socket void
          const eyeSocketGeo = new THREE.SphereGeometry(0.09, 16, 16);
          const eyeSocketMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const eyeSocket = new THREE.Mesh(eyeSocketGeo, eyeSocketMat);
          eyeSocket.position.set(0.22, 0.5, -side * 0.12);
          group.add(eyeSocket);

          // Inner hellfire glow
          const eyeGlowGeo = new THREE.SphereGeometry(0.055, 16, 16);
          const eyeGlowMat = new THREE.MeshBasicMaterial({
            color: 0xff2200,
            transparent: true,
            opacity: 0.95
          });
          const eyeGlow = new THREE.Mesh(eyeGlowGeo, eyeGlowMat);
          eyeGlow.position.set(0.24, 0.5, -side * 0.12);
          eyeGlow.userData.isSkullEye = true;
          group.add(eyeGlow);

          // Eye flame trail
          const flameGeo = new THREE.ConeGeometry(0.04, 0.12, 8);
          const flameMat = new THREE.MeshBasicMaterial({
            color: 0xff4400,
            transparent: true,
            opacity: 0.7
          });
          const flame = new THREE.Mesh(flameGeo, flameMat);
          flame.position.set(0.22, 0.58, -side * 0.12);
          flame.userData.isEyeFlame = true;
          flame.userData.flameSide = side;
          group.add(flame);
        }

        // Nose cavity
        const noseGeo = new THREE.ConeGeometry(0.045, 0.07, 3);
        const noseMat = new THREE.MeshBasicMaterial({ color: 0x0a0505 });
        const nose = new THREE.Mesh(noseGeo, noseMat);
        nose.rotation.z = -Math.PI;
        nose.position.set(0.26, 0.38, 0);
        group.add(nose);

        // Menacing teeth rows
        for (let row = 0; row < 2; row++) {
          for (let i = 0; i < 7; i++) {
            const toothGeo = new THREE.ConeGeometry(0.02, 0.05 + (i % 2) * 0.02, 4);
            const toothMat = new THREE.MeshPhongMaterial({
              color: 0xf0e8d8,
              shininess: 120,
              specular: 0xffffff
            });
            const tooth = new THREE.Mesh(toothGeo, toothMat);
            tooth.position.set(0.24, 0.28 - row * 0.06, 0.09 - i * 0.03);
            tooth.rotation.z = row === 0 ? 0 : -Math.PI;
            group.add(tooth);
          }
        }

        // ===== BONE HANDS REACHING UP =====
        for (let side = -1; side <= 1; side += 2) {
          const handGroup = new THREE.Group();
          handGroup.position.set(side * 0.5, 0.1, 0.1);
          handGroup.rotation.z = side * 0.4;
          handGroup.rotation.x = -0.3;
          group.add(handGroup);

          // Arm bone
          const armGeo = new THREE.CylinderGeometry(0.03, 0.04, 0.35, 8);
          const boneMat = new THREE.MeshPhongMaterial({
            color: 0xd8d0c0,
            shininess: 80,
            specular: 0xffffff,
            emissive: 0x1a1210,
            emissiveIntensity: 0.2
          });
          const arm = new THREE.Mesh(armGeo, boneMat);
          arm.position.y = 0.15;
          handGroup.add(arm);

          // Palm
          const palmGeo = new THREE.SphereGeometry(0.06, 12, 12);
          const palm = new THREE.Mesh(palmGeo, boneMat);
          palm.scale.set(1, 0.6, 0.8);
          palm.position.y = 0.35;
          handGroup.add(palm);

          // Fingers (3 clawed)
          for (let f = 0; f < 3; f++) {
            const fingerGeo = new THREE.CylinderGeometry(0.012, 0.018, 0.12, 6);
            const finger = new THREE.Mesh(fingerGeo, boneMat);
            finger.position.set((f - 1) * 0.04, 0.42, 0.02);
            finger.rotation.x = -0.4;
            finger.rotation.z = (f - 1) * 0.2;
            handGroup.add(finger);

            // Claw tip
            const clawGeo = new THREE.ConeGeometry(0.015, 0.04, 6);
            const clawMat = new THREE.MeshPhongMaterial({
              color: 0x2a2020,
              shininess: 150,
              specular: 0x444444
            });
            const claw = new THREE.Mesh(clawGeo, clawMat);
            claw.position.set((f - 1) * 0.04, 0.5, 0.04);
            claw.rotation.x = -0.6;
            claw.rotation.z = (f - 1) * 0.2;
            handGroup.add(claw);
          }
        }

        // ===== SPECTRAL SHROUD =====
        const shroudGeo = new THREE.ConeGeometry(0.6, 0.8, 16, 1, true);
        const shroudMat = new THREE.MeshBasicMaterial({
          color: 0x1a0a15,
          transparent: true,
          opacity: 0.25,
          side: THREE.DoubleSide
        });
        const shroud = new THREE.Mesh(shroudGeo, shroudMat);
        shroud.position.y = 0.7;
        shroud.userData.isShroud = true;
        group.add(shroud);

        // ===== GLOWING RUNES ON GRAVESTONE =====
        const runeColors = [0xff0044, 0x8800ff, 0x00ff88];
        for (let i = 0; i < 3; i++) {
          const runeGeo = new THREE.TorusGeometry(0.06, 0.015, 6, 6);
          const runeMat = new THREE.MeshBasicMaterial({
            color: runeColors[i],
            transparent: true,
            opacity: 0.8
          });
          const rune = new THREE.Mesh(runeGeo, runeMat);
          rune.position.set(-0.25 + i * 0.25, 0.35, -0.21);
          rune.userData.isRune = true;
          rune.userData.runeIndex = i;
          group.add(rune);
        }

        // ===== TWISTED THORNY STEM =====
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x1a3315,
          shininess: 80,
          specular: 0x2a5525,
          emissive: 0x0a1a06,
          emissiveIntensity: 0.5
        });

        // Main stem with organic curve
        for (let s = 0; s < 8; s++) {
          const thickness = 0.065 - s * 0.005;
          const segGeo = new THREE.CylinderGeometry(thickness, thickness + 0.01, 0.15, 12);
          const seg = new THREE.Mesh(segGeo, stemMat);
          seg.position.y = 0.75 + s * 0.14;
          seg.position.x = Math.sin(s * 0.4) * 0.03;
          seg.rotation.y = s * 0.35;
          seg.rotation.z = Math.sin(s * 0.6) * 0.08;
          group.add(seg);
        }

        // Deadly thorns
        for (let i = 0; i < 24; i++) {
          const thornGeo = new THREE.ConeGeometry(0.02, 0.12 + (i % 3) * 0.03, 6);
          const thornMat = new THREE.MeshPhongMaterial({
            color: 0x2a4420,
            shininess: 140,
            specular: 0x5a8850,
            emissive: 0x1a2a15,
            emissiveIntensity: 0.6
          });
          const thorn = new THREE.Mesh(thornGeo, thornMat);
          const angle = (i / 6) * Math.PI;
          const height = 0.8 + (i / 24) * 1.0;
          thorn.position.set(Math.cos(angle) * 0.09, height, Math.sin(angle) * 0.09);
          thorn.rotation.z = Math.PI / 2.3;
          thorn.rotation.y = angle;
          group.add(thorn);
        }

        // ===== LEGENDARY DARK ROSE =====
        // Glowing core heart
        const coreGeo = new THREE.SphereGeometry(0.12, 32, 32);
        const coreMat = new THREE.MeshPhongMaterial({
          color: 0x1a0008,
          shininess: 250,
          specular: 0xaa0055,
          emissive: 0x440022,
          emissiveIntensity: 0.8
        });
        const core = new THREE.Mesh(coreGeo, coreMat);
        core.position.y = 1.85;
        group.add(core);

        // Inner petals - tight bud
        const innerPetalMat = new THREE.MeshPhongMaterial({
          color: 0x6b0020,
          shininess: 140,
          specular: 0xff3366,
          emissive: 0x3a0015,
          emissiveIntensity: 0.6
        });
        for (let i = 0; i < 5; i++) {
          const petalGeo = new THREE.SphereGeometry(0.1, 20, 20);
          const petal = new THREE.Mesh(petalGeo, innerPetalMat);
          const angle = (i / 5) * Math.PI * 2;
          petal.position.set(Math.cos(angle) * 0.06, 1.9, Math.sin(angle) * 0.06);
          petal.scale.set(1.3, 0.55, 0.25);
          petal.rotation.y = angle;
          petal.rotation.x = -0.15;
          petal.userData.isPetal = true;
          group.add(petal);
        }

        // Middle petals - opening spiral
        const midPetalMat = new THREE.MeshPhongMaterial({
          color: 0x8b0028,
          shininess: 120,
          specular: 0xff5577,
          emissive: 0x4a0018,
          emissiveIntensity: 0.55
        });
        for (let i = 0; i < 8; i++) {
          const petalGeo = new THREE.SphereGeometry(0.14, 20, 20);
          const petal = new THREE.Mesh(petalGeo, midPetalMat);
          const angle = (i / 8) * Math.PI * 2 + 0.2;
          petal.position.set(Math.cos(angle) * 0.16, 1.82, Math.sin(angle) * 0.16);
          petal.scale.set(1.4, 0.5, 0.28);
          petal.rotation.y = angle;
          petal.rotation.x = -0.35;
          petal.userData.isPetal = true;
          group.add(petal);
        }

        // Outer petals - full bloom
        const outerPetalMat = new THREE.MeshPhongMaterial({
          color: 0xaa0035,
          shininess: 100,
          specular: 0xff7799,
          emissive: 0x5a0025,
          emissiveIntensity: 0.5
        });
        for (let i = 0; i < 12; i++) {
          const petalGeo = new THREE.SphereGeometry(0.18, 20, 20);
          const petal = new THREE.Mesh(petalGeo, outerPetalMat);
          const angle = (i / 12) * Math.PI * 2 + 0.1;
          petal.position.set(Math.cos(angle) * 0.28, 1.72, Math.sin(angle) * 0.28);
          petal.scale.set(1.5, 0.45, 0.25);
          petal.rotation.y = angle;
          petal.rotation.x = -0.55;
          petal.userData.isPetal = true;
          group.add(petal);
        }

        // Outermost petals - dramatic spread
        const spreadPetalMat = new THREE.MeshPhongMaterial({
          color: 0xcc0045,
          shininess: 90,
          specular: 0xff99bb,
          emissive: 0x660030,
          emissiveIntensity: 0.45
        });
        for (let i = 0; i < 10; i++) {
          const petalGeo = new THREE.SphereGeometry(0.2, 20, 20);
          const petal = new THREE.Mesh(petalGeo, spreadPetalMat);
          const angle = (i / 10) * Math.PI * 2;
          petal.position.set(Math.cos(angle) * 0.42, 1.58, Math.sin(angle) * 0.42);
          petal.scale.set(1.5, 0.4, 0.22);
          petal.rotation.y = angle;
          petal.rotation.x = -0.75;
          petal.userData.isPetal = true;
          group.add(petal);
        }

        // ===== DEW DROPS ON ROSE =====
        for (let i = 0; i < 10; i++) {
          const dewGeo = new THREE.SphereGeometry(0.025, 12, 12);
          const dewMat = new THREE.MeshPhongMaterial({
            color: 0xffffff,
            shininess: 300,
            specular: 0xffffff,
            transparent: true,
            opacity: 0.8
          });
          const dew = new THREE.Mesh(dewGeo, dewMat);
          const angle = Math.random() * Math.PI * 2;
          const radius = 0.15 + Math.random() * 0.25;
          const height = 1.65 + Math.random() * 0.25;
          dew.position.set(Math.cos(angle) * radius, height, Math.sin(angle) * radius);
          dew.userData.isDewDrop = true;
          dew.userData.dewIndex = i;
          group.add(dew);
        }

        // ===== LEGENDARY SCYTHE =====
        const scytheGroup = new THREE.Group();
        scytheGroup.position.set(0.55, 1.0, 0);
        scytheGroup.rotation.z = -0.25;
        scytheGroup.userData.isScytheGroup = true;
        group.add(scytheGroup);

        // Bone handle with engravings
        const handleGeo = new THREE.CylinderGeometry(0.035, 0.045, 1.6, 12);
        const handleMat = new THREE.MeshPhongMaterial({
          color: 0xd8d0c0,
          shininess: 80,
          specular: 0xffffff,
          emissive: 0x1a1510,
          emissiveIntensity: 0.2
        });
        const handle = new THREE.Mesh(handleGeo, handleMat);
        handle.rotation.z = Math.PI / 2;
        scytheGroup.add(handle);

        // Handle grip wrapping
        for (let i = 0; i < 8; i++) {
          const wrapGeo = new THREE.TorusGeometry(0.045, 0.008, 6, 12);
          const wrapMat = new THREE.MeshPhongMaterial({
            color: 0x2a1a10,
            shininess: 40
          });
          const wrap = new THREE.Mesh(wrapGeo, wrapMat);
          wrap.position.x = -0.5 + i * 0.12;
          wrap.rotation.y = Math.PI / 2;
          scytheGroup.add(wrap);
        }

        // Skull pommel at handle end
        const pommelGeo = new THREE.SphereGeometry(0.06, 16, 16);
        const pommelMat = new THREE.MeshPhongMaterial({
          color: 0xd0c8b8,
          shininess: 100,
          emissive: 0x1a0808,
          emissiveIntensity: 0.3
        });
        const pommel = new THREE.Mesh(pommelGeo, pommelMat);
        pommel.scale.set(1, 0.85, 0.8);
        pommel.position.x = -0.75;
        scytheGroup.add(pommel);

        // Pommel eyes
        for (let side = -1; side <= 1; side += 2) {
          const pommelEyeGeo = new THREE.SphereGeometry(0.015, 8, 8);
          const pommelEyeMat = new THREE.MeshBasicMaterial({ color: 0xff0000 });
          const pommelEye = new THREE.Mesh(pommelEyeGeo, pommelEyeMat);
          pommelEye.position.set(-0.75, side * 0.02, 0.05);
          scytheGroup.add(pommelEye);
        }

        // Main blade - massive curved death
        const bladeGeo = new THREE.TorusGeometry(0.45, 0.025, 12, 32, Math.PI * 0.75);
        const bladeMat = new THREE.MeshPhongMaterial({
          color: 0x252530,
          shininess: 250,
          specular: 0xccccee,
          emissive: 0x151520,
          emissiveIntensity: 0.4
        });
        const blade = new THREE.Mesh(bladeGeo, bladeMat);
        blade.position.set(0.55, 0.2, 0);
        blade.rotation.y = Math.PI / 2;
        blade.rotation.x = Math.PI / 2;
        scytheGroup.add(blade);

        // Blade edge - razor sharp glow
        const edgeGeo = new THREE.TorusGeometry(0.47, 0.01, 8, 32, Math.PI * 0.75);
        const edgeMat = new THREE.MeshBasicMaterial({
          color: 0xaa00ff,
          transparent: true,
          opacity: 0.9
        });
        const edge = new THREE.Mesh(edgeGeo, edgeMat);
        edge.position.set(0.55, 0.2, 0);
        edge.rotation.y = Math.PI / 2;
        edge.rotation.x = Math.PI / 2;
        edge.userData.isScytheGlow = true;
        scytheGroup.add(edge);

        // Inner blade glow
        const innerGlowGeo = new THREE.TorusGeometry(0.43, 0.008, 6, 32, Math.PI * 0.75);
        const innerGlowMat = new THREE.MeshBasicMaterial({
          color: 0xff00aa,
          transparent: true,
          opacity: 0.6
        });
        const innerGlow = new THREE.Mesh(innerGlowGeo, innerGlowMat);
        innerGlow.position.set(0.55, 0.2, 0);
        innerGlow.rotation.y = Math.PI / 2;
        innerGlow.rotation.x = Math.PI / 2;
        innerGlow.userData.isScytheGlow = true;
        scytheGroup.add(innerGlow);

        // Runes on blade
        for (let i = 0; i < 5; i++) {
          const runeBladeGeo = new THREE.BoxGeometry(0.03, 0.015, 0.015);
          const runeBladeMat = new THREE.MeshBasicMaterial({
            color: 0xaa00ff,
            transparent: true,
            opacity: 0.8
          });
          const runeBlade = new THREE.Mesh(runeBladeGeo, runeBladeMat);
          const runeAngle = (i / 5) * Math.PI * 0.6 + 0.2;
          runeBlade.position.set(
            0.55 + Math.cos(runeAngle + Math.PI / 2) * 0.45,
            0.2 + Math.sin(runeAngle + Math.PI / 2) * 0.45 * 0.3,
            0
          );
          runeBlade.userData.isBladeRune = true;
          runeBlade.userData.runeIndex = i;
          scytheGroup.add(runeBlade);
        }

        // ===== SOUL CHAINS =====
        for (let c = 0; c < 3; c++) {
          const chainAngle = (c / 3) * Math.PI * 2;
          for (let link = 0; link < 6; link++) {
            const linkGeo = new THREE.TorusGeometry(0.025, 0.006, 6, 8);
            const linkMat = new THREE.MeshPhongMaterial({
              color: 0x444455,
              shininess: 150,
              specular: 0x8888aa,
              emissive: 0x220033,
              emissiveIntensity: 0.3
            });
            const chainLink = new THREE.Mesh(linkGeo, linkMat);
            const radius = 0.5 + link * 0.08;
            chainLink.position.set(
              Math.cos(chainAngle) * radius,
              0.5 + link * 0.1,
              Math.sin(chainAngle) * radius
            );
            chainLink.rotation.x = Math.PI / 2 + link * 0.2;
            chainLink.rotation.y = chainAngle;
            chainLink.userData.isChainLink = true;
            chainLink.userData.chainIndex = c;
            chainLink.userData.linkIndex = link;
            group.add(chainLink);
          }
        }

        // ===== AURAS AND EFFECTS =====
        // Healing aura - radiant green
        const healAuraGeo = new THREE.SphereGeometry(0.65, 32, 32);
        const healAuraMat = new THREE.MeshBasicMaterial({
          color: 0x00ff44,
          transparent: true,
          opacity: 0.08
        });
        const healAura = new THREE.Mesh(healAuraGeo, healAuraMat);
        healAura.position.y = 1.8;
        healAura.userData.isHealingAura = true;
        group.add(healAura);

        // Death aura - ominous purple
        const deathAuraGeo = new THREE.SphereGeometry(1.0, 32, 32);
        const deathAuraMat = new THREE.MeshBasicMaterial({
          color: 0x3a0028,
          transparent: true,
          opacity: 0.12
        });
        const deathAura = new THREE.Mesh(deathAuraGeo, deathAuraMat);
        deathAura.position.y = 1.5;
        deathAura.userData.isReaperAura = true;
        group.add(deathAura);

        // Ground fog effect
        const fogGeo = new THREE.CylinderGeometry(0.8, 1.0, 0.15, 24);
        const fogMat = new THREE.MeshBasicMaterial({
          color: 0x2a1a25,
          transparent: true,
          opacity: 0.25
        });
        const fog = new THREE.Mesh(fogGeo, fogMat);
        fog.position.y = 0.08;
        fog.userData.isFog = true;
        group.add(fog);

        // Soul wisps - life and death orbiting
        for (let i = 0; i < 12; i++) {
          const wispGeo = new THREE.SphereGeometry(0.04 + Math.random() * 0.025, 12, 12);
          const isLife = i < 6;
          const wispMat = new THREE.MeshBasicMaterial({
            color: isLife ? 0x00ff55 : 0xff0033,
            transparent: true,
            opacity: 0.9
          });
          const wisp = new THREE.Mesh(wispGeo, wispMat);
          const angle = (i / 12) * Math.PI * 2;
          wisp.position.set(Math.cos(angle) * 0.75, 1.5 + Math.sin(i * 0.8) * 0.4, Math.sin(angle) * 0.75);
          wisp.userData.isSoul = true;
          wisp.userData.soulIndex = i;

          // Wisp trail
          const trailGeo = new THREE.CylinderGeometry(0.015, 0.003, 0.15, 6);
          const trailMat = new THREE.MeshBasicMaterial({
            color: isLife ? 0x00aa33 : 0xaa0022,
            transparent: true,
            opacity: 0.5
          });
          const trail = new THREE.Mesh(trailGeo, trailMat);
          trail.position.y = -0.08;
          wisp.add(trail);

          group.add(wisp);
        }

        // Falling rose petals
        for (let i = 0; i < 12; i++) {
          const petalGeo = new THREE.SphereGeometry(0.025, 8, 8);
          const petalMat = new THREE.MeshBasicMaterial({
            color: 0xff1155,
            transparent: true,
            opacity: 0.75
          });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          petal.scale.set(1.8, 0.25, 1);
          const angle = Math.random() * Math.PI * 2;
          const radius = 0.2 + Math.random() * 0.6;
          petal.position.set(Math.cos(angle) * radius, 1.0 + Math.random() * 1.0, Math.sin(angle) * radius);
          petal.userData.isPollen = true;
          petal.userData.pollenIndex = i;
          group.add(petal);
        }

        // Dark energy swirls
        for (let i = 0; i < 8; i++) {
          const darkGeo = new THREE.SphereGeometry(0.035, 8, 8);
          const darkMat = new THREE.MeshBasicMaterial({
            color: 0x6600aa,
            transparent: true,
            opacity: 0.6
          });
          const dark = new THREE.Mesh(darkGeo, darkMat);
          const angle = (i / 6) * Math.PI * 2;
          dark.position.set(Math.cos(angle) * 0.5, 0.4, Math.sin(angle) * 0.5);
          dark.userData.isDarkEnergy = true;
          dark.userData.darkIndex = i;
          group.add(dark);
        }

        break;
      }

      case 'lily-reaper': {
        // LILY REAPER - Healing fusion of lily and rose reaper
        // Click to heal plant in front by 50 HP

        // === MYSTICAL LILY PAD BASE ===
        const lilyBaseGeo = new THREE.CylinderGeometry(0.7, 0.8, 0.12, 16);
        const lilyBaseMat = new THREE.MeshPhongMaterial({
          color: 0x2a6633,
          shininess: 80,
          emissive: 0x1a4422,
          emissiveIntensity: 0.3
        });
        const lilyBase = new THREE.Mesh(lilyBaseGeo, lilyBaseMat);
        lilyBase.position.y = 0.06;
        group.add(lilyBase);

        // Water ripples around base
        for (let i = 0; i < 3; i++) {
          const rippleGeo = new THREE.TorusGeometry(0.5 + i * 0.15, 0.02, 8, 32);
          const rippleMat = new THREE.MeshBasicMaterial({
            color: 0x66ddff,
            transparent: true,
            opacity: 0.4 - i * 0.1
          });
          const ripple = new THREE.Mesh(rippleGeo, rippleMat);
          ripple.rotation.x = Math.PI / 2;
          ripple.position.y = 0.02 - i * 0.01;
          ripple.userData.isRipple = true;
          ripple.userData.rippleIndex = i;
          group.add(ripple);
        }

        // === SPECTRAL LILY FLOWER ===
        // Central healing orb
        const healOrbGeo = new THREE.SphereGeometry(0.2, 16, 16);
        const healOrbMat = new THREE.MeshBasicMaterial({
          color: 0x00ff66,
          transparent: true,
          opacity: 0.8
        });
        const healOrb = new THREE.Mesh(healOrbGeo, healOrbMat);
        healOrb.position.y = 1.0;
        healOrb.userData.isHealOrb = true;
        group.add(healOrb);

        // Lily petals with ghostly glow
        const lilyPetalMat = new THREE.MeshPhongMaterial({
          color: 0xffeeff,
          shininess: 100,
          emissive: 0xaa88cc,
          emissiveIntensity: 0.4,
          transparent: true,
          opacity: 0.9
        });
        for (let i = 0; i < 6; i++) {
          const petalGeo = new THREE.SphereGeometry(0.25, 12, 12);
          const petal = new THREE.Mesh(petalGeo, lilyPetalMat);
          const angle = (i / 6) * Math.PI * 2;
          petal.position.set(Math.cos(angle) * 0.3, 0.95, Math.sin(angle) * 0.3);
          petal.scale.set(1.5, 0.3, 0.8);
          petal.rotation.y = angle;
          petal.rotation.x = -0.3;
          petal.userData.isLilyPetal = true;
          group.add(petal);
        }

        // === REAPER SKULL EMERGING FROM LILY ===
        const reaperSkullGeo = new THREE.SphereGeometry(0.22, 16, 16);
        const reaperSkullMat = new THREE.MeshPhongMaterial({
          color: 0xd8d0c0,
          shininess: 100,
          emissive: 0x225522,
          emissiveIntensity: 0.3
        });
        const reaperSkull = new THREE.Mesh(reaperSkullGeo, reaperSkullMat);
        reaperSkull.scale.set(1, 0.85, 0.8);
        reaperSkull.position.set(0, 1.3, 0);
        group.add(reaperSkull);

        // Skull eye sockets with healing green glow
        for (let side = -1; side <= 1; side += 2) {
          const socketGeo = new THREE.SphereGeometry(0.06, 8, 8);
          const socketMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const socket = new THREE.Mesh(socketGeo, socketMat);
          socket.position.set(0.15, 1.35, -side * 0.08);
          group.add(socket);

          const eyeGlowGeo = new THREE.SphereGeometry(0.04, 8, 8);
          const eyeGlowMat = new THREE.MeshBasicMaterial({
            color: 0x00ff44,
            transparent: true,
            opacity: 0.95
          });
          const eyeGlow = new THREE.Mesh(eyeGlowGeo, eyeGlowMat);
          eyeGlow.position.set(0.17, 1.35, -side * 0.08);
          eyeGlow.userData.isReaperEye = true;
          group.add(eyeGlow);
        }

        // === HEALING STEM WITH VINES ===
        const stemGeo = new THREE.CylinderGeometry(0.08, 0.12, 0.8, 8);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x336633,
          shininess: 60,
          emissive: 0x224422,
          emissiveIntensity: 0.25
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.55;
        group.add(stem);

        // Glowing vines wrapping stem
        for (let v = 0; v < 3; v++) {
          for (let i = 0; i < 8; i++) {
            const vineGeo = new THREE.SphereGeometry(0.025, 6, 6);
            const vineMat = new THREE.MeshBasicMaterial({
              color: 0x00ff88,
              transparent: true,
              opacity: 0.7
            });
            const vine = new THREE.Mesh(vineGeo, vineMat);
            const t = i / 8;
            const angle = t * Math.PI * 3 + v * (Math.PI * 2 / 3);
            vine.position.set(
              Math.cos(angle) * 0.12,
              0.2 + t * 0.7,
              Math.sin(angle) * 0.12
            );
            vine.userData.isHealVine = true;
            group.add(vine);
          }
        }

        // === FLOATING HEALING PARTICLES ===
        for (let i = 0; i < 10; i++) {
          const particleGeo = new THREE.SphereGeometry(0.03, 6, 6);
          const particleMat = new THREE.MeshBasicMaterial({
            color: i % 2 === 0 ? 0x00ff66 : 0x88ffaa,
            transparent: true,
            opacity: 0.8
          });
          const particle = new THREE.Mesh(particleGeo, particleMat);
          const angle = Math.random() * Math.PI * 2;
          const radius = 0.3 + Math.random() * 0.4;
          particle.position.set(
            Math.cos(angle) * radius,
            0.8 + Math.random() * 0.6,
            Math.sin(angle) * radius
          );
          particle.userData.isHealParticle = true;
          particle.userData.particleIndex = i;
          group.add(particle);
        }

        // === HEALING AURA ===
        const healingAuraGeo = new THREE.SphereGeometry(0.8, 16, 16);
        const healingAuraMat = new THREE.MeshBasicMaterial({
          color: 0x00ff55,
          transparent: true,
          opacity: 0.12
        });
        const healingAura = new THREE.Mesh(healingAuraGeo, healingAuraMat);
        healingAura.position.y = 1.0;
        healingAura.userData.isLilyHealAura = true;
        group.add(healingAura);

        // Death essence wisps
        for (let i = 0; i < 6; i++) {
          const wispGeo = new THREE.SphereGeometry(0.035, 6, 6);
          const wispMat = new THREE.MeshBasicMaterial({
            color: 0x9944aa,
            transparent: true,
            opacity: 0.6
          });
          const wisp = new THREE.Mesh(wispGeo, wispMat);
          const angle = (i / 6) * Math.PI * 2;
          wisp.position.set(Math.cos(angle) * 0.5, 0.6, Math.sin(angle) * 0.5);
          wisp.userData.isDeathWisp = true;
          wisp.userData.wispIndex = i;
          group.add(wisp);
        }

        break;
      }

      case 'lily-peel': {
        // LILY PEEL - Fusion of Lily + Banana Peel
        // Click to summon Sun Fish ally (costs 300 sun)

        // === LILY PAD BASE WITH BANANA YELLOW ACCENTS ===
        const padGeo = new THREE.CylinderGeometry(0.75, 0.85, 0.1, 16);
        const padMat = new THREE.MeshPhongMaterial({
          color: 0x2a7533,
          shininess: 60,
          emissive: 0x1a4422,
          emissiveIntensity: 0.2
        });
        const pad = new THREE.Mesh(padGeo, padMat);
        pad.position.y = 0.05;
        group.add(pad);

        // Banana peel stripes on pad
        for (let i = 0; i < 4; i++) {
          const stripeGeo = new THREE.BoxGeometry(0.6, 0.02, 0.08);
          const stripeMat = new THREE.MeshPhongMaterial({
            color: 0xffdd00,
            shininess: 80,
            emissive: 0xaa8800,
            emissiveIntensity: 0.3
          });
          const stripe = new THREE.Mesh(stripeGeo, stripeMat);
          const angle = (i / 4) * Math.PI * 2;
          stripe.position.set(0, 0.11, 0);
          stripe.rotation.y = angle;
          group.add(stripe);
        }

        // === LILY FLOWER WITH BANANA PETALS ===
        // Central sun orb
        const sunOrbGeo = new THREE.SphereGeometry(0.2, 16, 16);
        const sunOrbMat = new THREE.MeshBasicMaterial({
          color: 0xffff00,
          transparent: true,
          opacity: 0.9
        });
        const sunOrb = new THREE.Mesh(sunOrbGeo, sunOrbMat);
        sunOrb.position.y = 0.9;
        sunOrb.userData.isSunOrb = true;
        group.add(sunOrb);

        // Banana-yellow lily petals
        const petalMat = new THREE.MeshPhongMaterial({
          color: 0xffee55,
          shininess: 100,
          emissive: 0xffaa00,
          emissiveIntensity: 0.4
        });
        for (let i = 0; i < 6; i++) {
          const petalGeo = new THREE.SphereGeometry(0.22, 10, 10);
          const petal = new THREE.Mesh(petalGeo, petalMat);
          const angle = (i / 6) * Math.PI * 2;
          petal.position.set(Math.cos(angle) * 0.32, 0.85, Math.sin(angle) * 0.32);
          petal.scale.set(1.5, 0.35, 0.75);
          petal.rotation.y = angle;
          petal.rotation.x = -0.35;
          group.add(petal);
        }

        // === BANANA PEEL CURL ACCENTS ===
        for (let i = 0; i < 3; i++) {
          const curlGeo = new THREE.TorusGeometry(0.12, 0.04, 8, 16, Math.PI);
          const curlMat = new THREE.MeshPhongMaterial({
            color: 0xffdd00,
            shininess: 80,
            emissive: 0xaa7700,
            emissiveIntensity: 0.3
          });
          const curl = new THREE.Mesh(curlGeo, curlMat);
          const angle = (i / 3) * Math.PI * 2;
          curl.position.set(Math.cos(angle) * 0.5, 0.5, Math.sin(angle) * 0.5);
          curl.rotation.y = angle;
          curl.rotation.x = Math.PI / 4;
          group.add(curl);
        }

        // Stem
        const stemGeo = new THREE.CylinderGeometry(0.06, 0.08, 0.7, 8);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x2d8a3e,
          shininess: 40
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.45;
        group.add(stem);

        // === FISH SUMMONING INDICATOR ===
        const fishIconGeo = new THREE.SphereGeometry(0.1, 8, 8);
        fishIconGeo.scale(1.5, 0.8, 1);
        const fishIconMat = new THREE.MeshBasicMaterial({
          color: 0xffaa00,
          transparent: true,
          opacity: 0.6
        });
        const fishIcon = new THREE.Mesh(fishIconGeo, fishIconMat);
        fishIcon.position.set(0, 1.3, 0);
        fishIcon.userData.isFishIcon = true;
        group.add(fishIcon);

        // Sun glow aura
        const auraGeo = new THREE.SphereGeometry(0.6, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xffff66,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.8;
        group.add(aura);

        break;
      }

      case 'mushroom-bomber': {
        // MUSHROOM BOMBER - Epic toxic mushroom with bioluminescent effects

        // Rich forest floor base with moss
        const floorGeo = new THREE.CylinderGeometry(0.6, 0.7, 0.15, 16);
        const floorMat = new THREE.MeshPhongMaterial({
          color: 0x2d1f0f,
          shininess: 30,
          specular: 0x3a2815
        });
        const floor = new THREE.Mesh(floorGeo, floorMat);
        floor.position.y = 0.075;
        group.add(floor);

        // Moss patches on base
        for (let i = 0; i < 6; i++) {
          const mossGeo = new THREE.SphereGeometry(0.15, 12, 12);
          const mossMat = new THREE.MeshPhongMaterial({
            color: 0x2a5a2a,
            shininess: 20,
            emissive: 0x1a3a1a,
            emissiveIntensity: 0.2
          });
          const moss = new THREE.Mesh(mossGeo, mossMat);
          const angle = (i / 6) * Math.PI * 2;
          moss.position.set(Math.cos(angle) * 0.45, 0.1, Math.sin(angle) * 0.45);
          moss.scale.set(1, 0.4, 1);
          group.add(moss);
        }

        // Thick bulbous stem base
        const stemBaseGeo = new THREE.CylinderGeometry(0.25, 0.35, 0.3, 16);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0xf5e6d3,
          shininess: 60,
          specular: 0xffffee,
          emissive: 0x2a4a1a,
          emissiveIntensity: 0.15
        });
        const stemBase = new THREE.Mesh(stemBaseGeo, stemMat);
        stemBase.position.y = 0.3;
        group.add(stemBase);

        // Main stem with organic curves
        const stemMidGeo = new THREE.CylinderGeometry(0.18, 0.25, 0.5, 16);
        const stemMid = new THREE.Mesh(stemMidGeo, stemMat);
        stemMid.position.y = 0.7;
        group.add(stemMid);

        // Upper stem tapering
        const stemTopGeo = new THREE.CylinderGeometry(0.15, 0.18, 0.35, 16);
        const stemTop = new THREE.Mesh(stemTopGeo, stemMat);
        stemTop.position.y = 1.05;
        group.add(stemTop);

        // Stem ring/skirt (annulus)
        const ringGeo = new THREE.TorusGeometry(0.22, 0.03, 8, 16);
        const ringMat = new THREE.MeshPhongMaterial({
          color: 0xf0e0c0,
          shininess: 40,
          specular: 0xffffdd
        });
        const ring = new THREE.Mesh(ringGeo, ringMat);
        ring.rotation.x = Math.PI / 2;
        ring.position.y = 0.85;
        group.add(ring);

        // Main cap - dome shape with toxic purple-red gradient look
        const capGeo = new THREE.SphereGeometry(0.6, 32, 32, 0, Math.PI * 2, 0, Math.PI / 2);
        const capMat = new THREE.MeshPhongMaterial({
          color: 0x6a1b9a,
          shininess: 100,
          specular: 0xcc88ff,
          emissive: 0x4a0066,
          emissiveIntensity: 0.4
        });
        const cap = new THREE.Mesh(capGeo, capMat);
        cap.position.y = 1.25;
        group.add(cap);

        // Cap underside gills
        const gillsGeo = new THREE.CylinderGeometry(0.55, 0.15, 0.15, 24);
        const gillsMat = new THREE.MeshPhongMaterial({
          color: 0xe8d8c8,
          shininess: 30,
          emissive: 0x4a8a4a,
          emissiveIntensity: 0.2
        });
        const gills = new THREE.Mesh(gillsGeo, gillsMat);
        gills.position.y = 1.18;
        group.add(gills);

        // Bioluminescent spots on cap - various sizes
        const spotColors = [0x00ff88, 0x88ff00, 0xffff00, 0x00ffff];
        for (let ring = 0; ring < 3; ring++) {
          const spotsInRing = 5 + ring * 3;
          const radius = 0.2 + ring * 0.15;
          for (let i = 0; i < spotsInRing; i++) {
            const spotSize = 0.05 + Math.random() * 0.06;
            const spotGeo = new THREE.SphereGeometry(spotSize, 12, 12);
            const spotMat = new THREE.MeshPhongMaterial({
              color: spotColors[Math.floor(Math.random() * spotColors.length)],
              shininess: 150,
              emissive: spotColors[Math.floor(Math.random() * spotColors.length)],
              emissiveIntensity: 0.8
            });
            const spot = new THREE.Mesh(spotGeo, spotMat);
            const angle = (i / spotsInRing) * Math.PI * 2 + ring * 0.3;
            const yPos = 1.4 + ring * 0.08;
            spot.position.set(
              Math.cos(angle) * radius,
              yPos,
              Math.sin(angle) * radius
            );
            spot.userData.isGlowSpot = true;
            spot.userData.spotIndex = ring * 10 + i;
            group.add(spot);
          }
        }

        // Top center glowing spot
        const topSpotGeo = new THREE.SphereGeometry(0.12, 16, 16);
        const topSpotMat = new THREE.MeshPhongMaterial({
          color: 0x00ff66,
          shininess: 200,
          emissive: 0x00ff66,
          emissiveIntensity: 1.0
        });
        const topSpot = new THREE.Mesh(topSpotGeo, topSpotMat);
        topSpot.position.y = 1.8;
        topSpot.userData.isTopSpot = true;
        group.add(topSpot);

        // Toxic spore cloud aura
        const sporeAuraGeo = new THREE.SphereGeometry(0.9, 24, 24);
        const sporeAuraMat = new THREE.MeshBasicMaterial({
          color: 0x88ff44,
          transparent: true,
          opacity: 0.12
        });
        const sporeAura = new THREE.Mesh(sporeAuraGeo, sporeAuraMat);
        sporeAura.position.y = 1.3;
        sporeAura.userData.isSporeAura = true;
        group.add(sporeAura);

        // Floating toxic spore particles with trails
        for (let i = 0; i < 16; i++) {
          const sporeGeo = new THREE.SphereGeometry(0.04 + Math.random() * 0.03, 8, 8);
          const sporeMat = new THREE.MeshBasicMaterial({
            color: i % 2 === 0 ? 0xaaff44 : 0x66ff88,
            transparent: true,
            opacity: 0.75
          });
          const spore = new THREE.Mesh(sporeGeo, sporeMat);
          const angle = (i / 16) * Math.PI * 2;
          const radius = 0.5 + Math.random() * 0.4;
          spore.position.set(
            Math.cos(angle) * radius,
            1.2 + Math.random() * 0.6,
            Math.sin(angle) * radius
          );
          spore.userData.isSporeParticle = true;
          spore.userData.particleIndex = i;
          spore.userData.baseRadius = radius;
          group.add(spore);
        }

        // Smaller baby mushrooms around base
        for (let i = 0; i < 3; i++) {
          const babyGroup = new THREE.Group();
          const angle = (i / 3) * Math.PI * 2 + 0.5;
          babyGroup.position.set(Math.cos(angle) * 0.5, 0.1, Math.sin(angle) * 0.5);
          babyGroup.scale.set(0.35, 0.35, 0.35);

          const babyStemGeo = new THREE.CylinderGeometry(0.15, 0.2, 0.5, 12);
          const babyStem = new THREE.Mesh(babyStemGeo, stemMat);
          babyStem.position.y = 0.3;
          babyGroup.add(babyStem);

          const babyCapGeo = new THREE.SphereGeometry(0.35, 16, 16, 0, Math.PI * 2, 0, Math.PI / 2);
          const babyCapMat = new THREE.MeshPhongMaterial({
            color: 0x7b2d8e,
            shininess: 80,
            emissive: 0x4a1066,
            emissiveIntensity: 0.3
          });
          const babyCap = new THREE.Mesh(babyCapGeo, babyCapMat);
          babyCap.position.y = 0.6;
          babyGroup.add(babyCap);

          // Baby mushroom spots
          for (let j = 0; j < 3; j++) {
            const babySpotGeo = new THREE.SphereGeometry(0.06, 8, 8);
            const babySpotMat = new THREE.MeshPhongMaterial({
              color: 0x88ff66,
              emissive: 0x66ff44,
              emissiveIntensity: 0.6
            });
            const babySpot = new THREE.Mesh(babySpotGeo, babySpotMat);
            const spotAngle = (j / 3) * Math.PI * 2;
            babySpot.position.set(Math.cos(spotAngle) * 0.2, 0.75, Math.sin(spotAngle) * 0.2);
            babyGroup.add(babySpot);
          }

          group.add(babyGroup);
        }

        break;
      }

      case 'vined-wall': {
        // VINED WALL - Double Vine Wall Fortress
        // Height: 2.9 (default), faces +X towards zombies

        // Check for Frosty skin
        const activeSkinsVW = localStorage.getItem('fusionTdActiveSkins');
        const skinDataVW = activeSkinsVW ? JSON.parse(activeSkinsVW) : {};
        const isFrostyVW = skinDataVW['vined-wall'] === 'vined-wall-frosty';
        const scale = isFrostyVW ? 1.4 : 1.0;

        if (isFrostyVW) {
          // ===== FROSTY SKIN - MASSIVE FROZEN GOLEM FORTRESS =====
          // Completely different - an ice elemental golem

          // Frozen ground with ice cracks
          const iceGroundGeo = new THREE.CylinderGeometry(0.9 * scale, 1.0 * scale, 0.15 * scale, 16);
          const iceGroundMat = new THREE.MeshPhongMaterial({
            color: 0xaaddff,
            shininess: 300,
            specular: 0xffffff,
            emissive: 0x4488cc,
            emissiveIntensity: 0.5
          });
          const iceGround = new THREE.Mesh(iceGroundGeo, iceGroundMat);
          iceGround.position.y = 0.08 * scale;
          group.add(iceGround);

          // Ice crack lines on ground
          for (let c = 0; c < 8; c++) {
            const crackGeo = new THREE.BoxGeometry(0.8 * scale, 0.02, 0.03);
            const crackMat = new THREE.MeshBasicMaterial({ color: 0x00ffff });
            const crack = new THREE.Mesh(crackGeo, crackMat);
            crack.position.y = 0.16 * scale;
            crack.rotation.y = (c / 8) * Math.PI * 2;
            group.add(crack);
          }

          // Giant ice golem body - chunky
          const bodyGeo = new THREE.BoxGeometry(0.9 * scale, 2.0 * scale, 0.8 * scale);
          const bodyMat = new THREE.MeshPhongMaterial({
            color: 0x88ccff,
            shininess: 200,
            specular: 0xffffff,
            emissive: 0x2266aa,
            emissiveIntensity: 0.4,
            transparent: true,
            opacity: 0.9
          });
          const body = new THREE.Mesh(bodyGeo, bodyMat);
          body.position.y = 1.3 * scale;
          group.add(body);

          // Inner glowing core visible through ice
          const innerCoreGeo = new THREE.SphereGeometry(0.35 * scale, 16, 16);
          const innerCoreMat = new THREE.MeshBasicMaterial({
            color: 0x00ffff
          });
          const innerCore = new THREE.Mesh(innerCoreGeo, innerCoreMat);
          innerCore.position.y = 1.3 * scale;
          innerCore.userData.isVineHeart = true;
          group.add(innerCore);

          // Core glow
          const coreGlowGeo = new THREE.SphereGeometry(0.5 * scale, 12, 12);
          const coreGlowMat = new THREE.MeshBasicMaterial({
            color: 0x00ffff,
            transparent: true,
            opacity: 0.4
          });
          const coreGlow = new THREE.Mesh(coreGlowGeo, coreGlowMat);
          coreGlow.position.y = 1.3 * scale;
          coreGlow.userData.isHeartGlow = true;
          group.add(coreGlow);

          // Ice golem head
          const headGeo = new THREE.BoxGeometry(0.6 * scale, 0.5 * scale, 0.5 * scale);
          const headMat = new THREE.MeshPhongMaterial({
            color: 0xaaddff,
            shininess: 250,
            specular: 0xffffff,
            emissive: 0x4488cc,
            emissiveIntensity: 0.3
          });
          const head = new THREE.Mesh(headGeo, headMat);
          head.position.y = 2.6 * scale;
          group.add(head);

          // Glowing cyan eyes
          for (let eye = -1; eye <= 1; eye += 2) {
            const eyeGeo = new THREE.SphereGeometry(0.1 * scale, 12, 12);
            const eyeMat = new THREE.MeshBasicMaterial({ color: 0x00ffff });
            const eyeMesh = new THREE.Mesh(eyeGeo, eyeMat);
            eyeMesh.position.set(0.25 * scale, 2.65 * scale, eye * 0.15 * scale);
            group.add(eyeMesh);

            // Eye glow
            const eyeGlowGeo = new THREE.SphereGeometry(0.15 * scale, 8, 8);
            const eyeGlowMat = new THREE.MeshBasicMaterial({
              color: 0x00ffff,
              transparent: true,
              opacity: 0.5
            });
            const eyeGlowMesh = new THREE.Mesh(eyeGlowGeo, eyeGlowMat);
            eyeGlowMesh.position.set(0.25 * scale, 2.65 * scale, eye * 0.15 * scale);
            group.add(eyeGlowMesh);
          }

          // Ice crown spikes on head
          for (let sp = 0; sp < 5; sp++) {
            const crownGeo = new THREE.ConeGeometry(0.08 * scale, 0.4 * scale, 4);
            const crownMat = new THREE.MeshPhongMaterial({
              color: 0xeeffff,
              shininess: 350,
              specular: 0xffffff,
              emissive: 0x66ddff,
              emissiveIntensity: 0.6,
              transparent: true,
              opacity: 0.85
            });
            const crown = new THREE.Mesh(crownGeo, crownMat);
            crown.position.set(
              0,
              2.95 * scale,
              (sp - 2) * 0.12 * scale
            );
            group.add(crown);
          }

          // Shoulder ice crystals
          for (let sh = 0; sh < 4; sh++) {
            const shoulderGeo = new THREE.ConeGeometry(0.1 * scale, 0.5 * scale, 5);
            const shoulderMat = new THREE.MeshPhongMaterial({
              color: 0xddeeff,
              shininess: 300,
              specular: 0xffffff,
              emissive: 0x4488cc,
              emissiveIntensity: 0.4,
              transparent: true,
              opacity: 0.85
            });
            const shoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
            shoulder.position.set(
              0.3 * scale,
              2.2 * scale,
              (sh - 1.5) * 0.25 * scale
            );
            shoulder.rotation.z = -0.3;
            shoulder.rotation.x = (sh - 1.5) * 0.2;
            group.add(shoulder);
          }

          // Floating ice particles
          for (let p = 0; p < 25; p++) {
            const partGeo = new THREE.OctahedronGeometry(0.05 * scale, 0);
            const partMat = new THREE.MeshBasicMaterial({
              color: p % 3 === 0 ? 0xffffff : (p % 3 === 1 ? 0x88ffff : 0xaaddff),
              transparent: true,
              opacity: 0.8
            });
            const part = new THREE.Mesh(partGeo, partMat);
            part.position.set(
              (Math.random() - 0.5) * 1.8 * scale,
              (0.5 + Math.random() * 2.5) * scale,
              (Math.random() - 0.5) * 1.2 * scale
            );
            part.userData.isSpore = true;
            part.userData.sporeIndex = p;
            group.add(part);
          }

          // Frost aura
          const frostAuraGeo = new THREE.SphereGeometry(1.5 * scale, 16, 16);
          const frostAuraMat = new THREE.MeshBasicMaterial({
            color: 0x00ccff,
            transparent: true,
            opacity: 0.15
          });
          const frostAura = new THREE.Mesh(frostAuraGeo, frostAuraMat);
          frostAura.position.y = 1.5 * scale;
          frostAura.userData.isVineAura = true;
          group.add(frostAura);

          // Blizzard ring effect
          const blizzardGeo = new THREE.TorusGeometry(1.0 * scale, 0.05 * scale, 8, 32);
          const blizzardMat = new THREE.MeshBasicMaterial({
            color: 0x88ffff,
            transparent: true,
            opacity: 0.4
          });
          const blizzard = new THREE.Mesh(blizzardGeo, blizzardMat);
          blizzard.position.y = 0.5 * scale;
          blizzard.rotation.x = Math.PI / 2;
          group.add(blizzard);

          break;
        }

        // ===== DEFAULT SKIN =====
        // Ancient mossy stone foundation - larger
        const baseGeo = new THREE.CylinderGeometry(0.9 * scale, 1.0 * scale, 0.3 * scale, 16);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x3a5a2a,
          shininess: 45,
          emissive: 0x1a3a12,
          emissiveIntensity: 0.25
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.15 * scale;
        group.add(base);

        // Stone rim detail
        const rimGeo = new THREE.TorusGeometry(0.85 * scale, 0.08 * scale, 8, 20);
        const rimMat = new THREE.MeshPhongMaterial({
          color: 0x4a6a3a,
          shininess: 50
        });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.rotation.x = Math.PI / 2;
        rim.position.y = 0.3 * scale;
        group.add(rim);

        // Main vine wall structure - towering
        const wallGeo = new THREE.BoxGeometry(0.9 * scale, 2.9 * scale, 1.3 * scale);
        const wallMat = new THREE.MeshPhongMaterial({
          color: 0x2d5a1c,
          shininess: 55,
          emissive: 0x1a4a12,
          emissiveIntensity: 0.35
        });
        const wall = new THREE.Mesh(wallGeo, wallMat);
        wall.position.y = 1.6 * scale;
        group.add(wall);

        // Inner wall core (darker)
        const innerWallGeo = new THREE.BoxGeometry(0.6 * scale, 2.6 * scale, 1.2 * scale);
        const innerWallMat = new THREE.MeshPhongMaterial({
          color: 0x1a4a0c,
          shininess: 30
        });
        const innerWall = new THREE.Mesh(innerWallGeo, innerWallMat);
        innerWall.position.y = 1.5 * scale;
        group.add(innerWall);

        // Glowing vine heart - facing +X towards zombies (larger and brighter)
        const heartGeo = new THREE.SphereGeometry(0.28 * scale, 14, 14);
        const heartMat = new THREE.MeshPhongMaterial({
          color: 0x88ff44,
          shininess: 180,
          emissive: 0x55ff22,
          emissiveIntensity: 0.9
        });
        const heart = new THREE.Mesh(heartGeo, heartMat);
        heart.position.set(0.55 * scale, 1.5 * scale, 0);
        heart.userData.isVineHeart = true;
        group.add(heart);

        // Heart pulse glow
        const heartGlowGeo = new THREE.SphereGeometry(0.35 * scale, 12, 12);
        const heartGlowMat = new THREE.MeshBasicMaterial({
          color: 0x66ff33,
          transparent: true,
          opacity: 0.3
        });
        const heartGlow = new THREE.Mesh(heartGlowGeo, heartGlowMat);
        heartGlow.position.set(0.55 * scale, 1.5 * scale, 0);
        heartGlow.userData.isHeartGlow = true;
        group.add(heartGlow);

        // Thick spiraling vines wrapping around
        for (let i = 0; i < 12; i++) {
          const vineGeo = new THREE.CylinderGeometry(0.08 * scale, 0.11 * scale, (1.6 + Math.random() * 1.0) * scale, 10);
          const vineMat = new THREE.MeshPhongMaterial({
            color: i % 3 === 0 ? 0x3a7a22 : (i % 3 === 1 ? 0x4a8a32 : 0x2a6a1a),
            shininess: 75,
            emissive: 0x1a3a0a,
            emissiveIntensity: 0.25
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(
            (Math.random() - 0.3) * 0.8 * scale,
            (0.7 + Math.random() * 1.8) * scale,
            (Math.random() - 0.5) * 1.1 * scale
          );
          vine.rotation.x = (Math.random() - 0.5) * 1.0;
          vine.rotation.z = (Math.random() - 0.5) * 1.0;
          group.add(vine);
        }

        // Lush thick leaves
        for (let i = 0; i < 16; i++) {
          const leafGeo = new THREE.SphereGeometry((0.16 + Math.random() * 0.12) * scale, 10, 10);
          leafGeo.scale(1, 0.3, 1.6);
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 4 === 0 ? 0x5aaa3a : (i % 4 === 1 ? 0x4a9a2a : (i % 4 === 2 ? 0x6abb4a : 0x3a8a1a)),
            shininess: 65,
            emissive: 0x2a5a1a,
            emissiveIntensity: 0.2
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.position.set(
            (Math.random() - 0.3) * 1.0 * scale,
            (0.5 + Math.random() * 2.5) * scale,
            (Math.random() - 0.5) * 1.2 * scale
          );
          leaf.rotation.set(Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI);
          group.add(leaf);
        }

        // Deadly thorns pointing towards +X (at zombies!)
        for (let i = 0; i < 10; i++) {
          const thornGeo = new THREE.ConeGeometry(0.07 * scale, 0.45 * scale, 8);
          const thornMat = new THREE.MeshPhongMaterial({
            color: 0x3a5a18,
            shininess: 140,
            emissive: 0x1a3a08,
            emissiveIntensity: 0.35
          });
          const thorn = new THREE.Mesh(thornGeo, thornMat);
          thorn.position.set(
            0.55 * scale,
            (0.5 + (i % 6) * 0.5) * scale,
            (-0.5 + (i % 5) * 0.25) * scale
          );
          thorn.rotation.z = -Math.PI / 2;
          thorn.rotation.y = (Math.random() - 0.5) * 0.3;
          group.add(thorn);
        }

        // Glowing spores floating around
        for (let i = 0; i < 8; i++) {
          const sporeGeo = new THREE.SphereGeometry(0.05 * scale, 8, 8);
          const sporeMat = new THREE.MeshBasicMaterial({
            color: 0xaaffaa,
            transparent: true,
            opacity: 0.75
          });
          const spore = new THREE.Mesh(sporeGeo, sporeMat);
          spore.position.set(
            (Math.random() - 0.3) * 1.2 * scale,
            (1.0 + Math.random() * 2.0) * scale,
            (Math.random() - 0.5) * 1.0 * scale
          );
          spore.userData.isSpore = true;
          spore.userData.sporeIndex = i;
          group.add(spore);
        }

        // Braided double-vine motif wrapping the wall
        for (let i = 0; i < 6; i++) {
          const braidGeo = new THREE.TorusGeometry(0.55 * scale, 0.06 * scale, 8, 16, Math.PI);
          const braidMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x2a7a18 : 0x4a9a30,
            shininess: 50,
            emissive: 0x1a4a08,
            emissiveIntensity: 0.2
          });
          const braid = new THREE.Mesh(braidGeo, braidMat);
          braid.position.set(0, (0.4 + i * 0.42) * scale, 0);
          braid.rotation.y = Math.PI / 2 + (i % 2) * Math.PI;
          group.add(braid);
        }

        // Root system at base
        for (let i = 0; i < 5; i++) {
          const rootGeo = new THREE.CylinderGeometry(0.04 * scale, 0.08 * scale, 0.5 * scale, 6);
          const rootMat = new THREE.MeshPhongMaterial({
            color: 0x3a5020,
            shininess: 30
          });
          const root = new THREE.Mesh(rootGeo, rootMat);
          const angle = (i / 5) * Math.PI * 2;
          root.position.set(
            Math.cos(angle) * 0.6 * scale,
            0.15 * scale,
            Math.sin(angle) * 0.5 * scale
          );
          root.rotation.z = Math.cos(angle) * 0.6;
          root.rotation.x = Math.sin(angle) * 0.6;
          group.add(root);
        }

        // Canopy cap on top
        {
          const canopyGeo = new THREE.SphereGeometry(0.7 * scale, 12, 8, 0, Math.PI * 2, 0, Math.PI / 2);
          const canopyMat = new THREE.MeshPhongMaterial({
            color: 0x3a8a20,
            shininess: 40,
            emissive: 0x1a4a0a,
            emissiveIntensity: 0.2
          });
          const canopy = new THREE.Mesh(canopyGeo, canopyMat);
          canopy.position.y = 2.9 * scale;
          group.add(canopy);
        }

        // Nature aura
        const auraGeo = new THREE.SphereGeometry(1.6 * scale, 14, 14);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x44ff44,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 1.6 * scale;
        aura.userData.isVineAura = true;
        group.add(aura);

        break;
      }

      case 'frostberry-launcher': {
        // EPIC Frostberry Launcher - Triple frozen berry with ice cannons (like grape-gun)

        // Heavy frozen platform base
        const platformGeo = new THREE.CylinderGeometry(0.75, 0.85, 0.18, 6);
        const platformMat = new THREE.MeshPhongMaterial({
          color: 0x3a5570,
          shininess: 70,
          specular: 0x88aacc,
          emissive: 0x1a2530,
          emissiveIntensity: 0.15
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.09;
        group.add(platform);

        // Glowing ice energy channels on platform
        for (let i = 0; i < 6; i++) {
          const channelGeo = new THREE.BoxGeometry(0.06, 0.05, 0.35);
          const channelMat = new THREE.MeshPhongMaterial({
            color: 0x66eeff,
            emissive: 0x44ccff,
            emissiveIntensity: 0.9,
            shininess: 100
          });
          const channel = new THREE.Mesh(channelGeo, channelMat);
          const angle = (i / 6) * Math.PI * 2;
          channel.position.set(Math.cos(angle) * 0.55, 0.12, Math.sin(angle) * 0.55);
          channel.rotation.y = angle;
          group.add(channel);
        }

        // Silver ice ring trim
        const innerRingGeo = new THREE.TorusGeometry(0.55, 0.06, 8, 20);
        const innerRingMat = new THREE.MeshPhongMaterial({
          color: 0xccddee,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0x88aacc,
          emissiveIntensity: 0.3
        });
        const innerRing = new THREE.Mesh(innerRingGeo, innerRingMat);
        innerRing.position.y = 0.15;
        innerRing.rotation.x = Math.PI / 2;
        group.add(innerRing);

        // THREE ice pots with berries and cannons
        for (let i = 0; i < 3; i++) {
          const zOffset = (i - 1) * 0.55;

          // Ice pot body
          const potGeo = new THREE.CylinderGeometry(0.22, 0.18, 0.28, 16);
          const potMat = new THREE.MeshPhongMaterial({
            color: 0x4477aa,
            shininess: 60,
            specular: 0x88bbdd,
            emissive: 0x223355,
            emissiveIntensity: 0.1
          });
          const pot = new THREE.Mesh(potGeo, potMat);
          pot.position.set(0, 0.32, zOffset);
          group.add(pot);

          // Silver rim on pot
          const rimGeo = new THREE.TorusGeometry(0.22, 0.035, 8, 16);
          const rimMat = new THREE.MeshPhongMaterial({
            color: 0xccddee,
            shininess: 150,
            specular: 0xffffff,
            emissive: 0x88aacc,
            emissiveIntensity: 0.4
          });
          const rim = new THREE.Mesh(rimGeo, rimMat);
          rim.position.set(0, 0.46, zOffset);
          rim.rotation.x = Math.PI / 2;
          group.add(rim);

          // Ice crystal emblem on pot
          for (let e = 0; e < 3; e++) {
            const emblemGeo = new THREE.OctahedronGeometry(0.05, 0);
            const emblemMat = new THREE.MeshPhongMaterial({
              color: 0x66eeff,
              emissive: 0x44ccff,
              emissiveIntensity: 0.5,
              shininess: 100
            });
            const emblem = new THREE.Mesh(emblemGeo, emblemMat);
            emblem.position.set(0.2, 0.28 + e * 0.08, zOffset);
            emblem.scale.set(0.8 - e * 0.15, 0.8 - e * 0.15, 0.5);
            group.add(emblem);
          }

          // Frost vine wrapping pot
          const vineGeo = new THREE.TorusGeometry(0.24, 0.02, 6, 16);
          const vineMat = new THREE.MeshPhongMaterial({
            color: 0x66aacc,
            shininess: 40
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(0, 0.35, zOffset);
          vine.rotation.x = Math.PI / 2;
          vine.rotation.z = i * 0.5;
          group.add(vine);

          // FROZEN BERRY CLUSTER
          const clusterGeo = new THREE.SphereGeometry(0.22, 16, 16);
          const clusterMat = new THREE.MeshPhongMaterial({
            color: 0xff4466,
            shininess: 100,
            emissive: 0xaa2244,
            emissiveIntensity: 0.4
          });
          const cluster = new THREE.Mesh(clusterGeo, clusterMat);
          cluster.position.set(0, 0.72, zOffset);
          group.add(cluster);

          // Frost coating on berry
          const frostGeo = new THREE.SphereGeometry(0.24, 16, 16);
          const frostMat = new THREE.MeshPhongMaterial({
            color: 0xaaeeff,
            shininess: 200,
            transparent: true,
            opacity: 0.35
          });
          const frost = new THREE.Mesh(frostGeo, frostMat);
          frost.position.set(0, 0.72, zOffset);
          group.add(frost);

          // Individual icy seeds around berry
          for (let j = 0; j < 8; j++) {
            const seedGeo = new THREE.SphereGeometry(0.06, 12, 12);
            const seedMat = new THREE.MeshPhongMaterial({
              color: 0x66eeff,
              shininess: 120,
              specular: 0xaaffff,
              emissive: 0x44ccff,
              emissiveIntensity: 0.35
            });
            const seed = new THREE.Mesh(seedGeo, seedMat);
            const angle = (j / 8) * Math.PI * 2;
            const heightOffset = (j % 2) * 0.1;
            seed.position.set(
              Math.cos(angle) * 0.22,
              0.58 + heightOffset,
              zOffset + Math.sin(angle) * 0.22
            );
            group.add(seed);

            // Highlight on seed
            const highlightGeo = new THREE.SphereGeometry(0.02, 8, 8);
            const highlightMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.8 });
            const highlight = new THREE.Mesh(highlightGeo, highlightMat);
            highlight.position.set(
              Math.cos(angle) * 0.22 + 0.03,
              0.62 + heightOffset,
              zOffset + Math.sin(angle) * 0.22 + 0.03
            );
            group.add(highlight);
          }

          // Glowing core inside berry
          const coreGeo = new THREE.SphereGeometry(0.12, 12, 12);
          const coreMat = new THREE.MeshBasicMaterial({ color: 0xaaffff, transparent: true, opacity: 0.6 });
          const core = new THREE.Mesh(coreGeo, coreMat);
          core.position.set(0, 0.72, zOffset);
          group.add(core);

          // Ice leaf on top
          const leafGeo = new THREE.SphereGeometry(0.1, 8, 8);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x44ccaa,
            shininess: 50,
            emissive: 0x228866,
            emissiveIntensity: 0.2
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(1.5, 0.3, 1);
          leaf.position.set(0.08, 0.92, zOffset + 0.05);
          leaf.rotation.z = 0.3;
          group.add(leaf);

          // ICE CANNON for each berry
          const cannonGeo = new THREE.CylinderGeometry(0.08, 0.1, 0.4, 8);
          const cannonMat = new THREE.MeshPhongMaterial({
            color: 0x5599cc,
            shininess: 100,
            emissive: 0x336699,
            emissiveIntensity: 0.3
          });
          const cannon = new THREE.Mesh(cannonGeo, cannonMat);
          cannon.position.set(0.45, 0.65, zOffset);
          cannon.rotation.z = -Math.PI / 2;
          group.add(cannon);

          // Cannon tip glow
          const tipGeo = new THREE.SphereGeometry(0.08, 10, 10);
          const tipMat = new THREE.MeshBasicMaterial({ color: 0xaaffff });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(0.68, 0.65, zOffset);
          group.add(tip);

          // Tip glow aura
          const tipGlowGeo = new THREE.SphereGeometry(0.12, 8, 8);
          const tipGlowMat = new THREE.MeshBasicMaterial({ color: 0x66eeff, transparent: true, opacity: 0.4 });
          const tipGlow = new THREE.Mesh(tipGlowGeo, tipGlowMat);
          tipGlow.position.set(0.68, 0.65, zOffset);
          group.add(tipGlow);
        }

        // Central ice hub connecting berries
        const hubGeo = new THREE.SphereGeometry(0.16, 16, 16);
        const hubMat = new THREE.MeshPhongMaterial({
          color: 0x88eeff,
          emissive: 0x44ccff,
          emissiveIntensity: 0.9,
          shininess: 150,
          transparent: true,
          opacity: 0.9
        });
        const hub = new THREE.Mesh(hubGeo, hubMat);
        hub.position.set(0, 0.85, 0);
        group.add(hub);

        // Hub glow
        const hubGlowGeo = new THREE.SphereGeometry(0.25, 12, 12);
        const hubGlowMat = new THREE.MeshBasicMaterial({ color: 0x44ccff, transparent: true, opacity: 0.35 });
        const hubGlow = new THREE.Mesh(hubGlowGeo, hubGlowMat);
        hubGlow.position.set(0, 0.85, 0);
        group.add(hubGlow);

        // Ice tubes connecting hub to berries
        for (let i = 0; i < 3; i++) {
          const zOffset = (i - 1) * 0.55;
          const tubeGeo = new THREE.CylinderGeometry(0.025, 0.025, 0.35, 8);
          const tubeMat = new THREE.MeshPhongMaterial({
            color: 0x88eeff,
            emissive: 0x44ccff,
            emissiveIntensity: 0.7,
            shininess: 100
          });
          const tube = new THREE.Mesh(tubeGeo, tubeMat);
          tube.position.set(0, 0.78, zOffset * 0.5);
          tube.rotation.x = Math.PI / 2;
          if (i !== 1) tube.rotation.x += (i === 0 ? 0.15 : -0.15);
          group.add(tube);
        }

        break;
      }

      case 'reaper-peall': {
        // LEGENDARY REAPER PEALL - THE DEATH FORTRESS facing +X!
        // Epic gothic death castle with massive skull, scythe, and soul magic

        // Corrupted earth base with death runes
        const baseGeo = new THREE.CylinderGeometry(0.85, 1.0, 0.25, 12);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x0a0815,
          shininess: 40,
          emissive: 0x1a0030,
          emissiveIntensity: 0.5
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.125;
        group.add(base);

        // Triple death rune circles
        for (let r = 0; r < 3; r++) {
          const runeGeo = new THREE.RingGeometry(0.3 + r * 0.2, 0.35 + r * 0.2, 24);
          const runeMat = new THREE.MeshBasicMaterial({
            color: r === 1 ? 0xcc00ff : 0x8800aa,
            transparent: true,
            opacity: 0.7 - r * 0.15,
            side: THREE.DoubleSide
          });
          const rune = new THREE.Mesh(runeGeo, runeMat);
          rune.rotation.x = -Math.PI / 2;
          rune.position.y = 0.26;
          rune.userData.isBaseRune = true;
          rune.userData.runeIndex = r;
          group.add(rune);
        }

        // Death symbols in rune circles
        for (let i = 0; i < 6; i++) {
          const symbolGeo = new THREE.OctahedronGeometry(0.05, 0);
          const symbolMat = new THREE.MeshBasicMaterial({
            color: 0xaa00ff,
            transparent: true,
            opacity: 0.8
          });
          const symbol = new THREE.Mesh(symbolGeo, symbolMat);
          const angle = (i / 6) * Math.PI * 2;
          symbol.position.set(Math.cos(angle) * 0.65, 0.28, Math.sin(angle) * 0.65);
          symbol.userData.isBaseRune = true;
          symbol.userData.runeIndex = i;
          group.add(symbol);
        }

        // Gothic fortress main body - dark obsidian
        const fortressGeo = new THREE.BoxGeometry(0.8, 2.0, 1.1);
        const fortressMat = new THREE.MeshPhongMaterial({
          color: 0x15101f,
          shininess: 120,
          specular: 0x443366,
          emissive: 0x0a0512,
          emissiveIntensity: 0.4
        });
        const fortress = new THREE.Mesh(fortressGeo, fortressMat);
        fortress.position.y = 1.25;
        group.add(fortress);

        // Dark ice coating - frost effect
        const frostGeo = new THREE.BoxGeometry(0.85, 2.05, 1.15);
        const frostMat = new THREE.MeshPhongMaterial({
          color: 0x5577aa,
          shininess: 250,
          specular: 0xaaccff,
          transparent: true,
          opacity: 0.2,
          emissive: 0x335588,
          emissiveIntensity: 0.3
        });
        const frost = new THREE.Mesh(frostGeo, frostMat);
        frost.position.y = 1.25;
        group.add(frost);

        // Gothic tower spires on corners
        for (let corner = 0; corner < 4; corner++) {
          const cX = (corner < 2 ? 0.3 : -0.3);
          const cZ = (corner % 2 === 0 ? 0.45 : -0.45);

          const spireGeo = new THREE.ConeGeometry(0.12, 0.5, 6);
          const spireMat = new THREE.MeshPhongMaterial({
            color: 0x1a1025,
            shininess: 100,
            emissive: 0x110818,
            emissiveIntensity: 0.4
          });
          const spire = new THREE.Mesh(spireGeo, spireMat);
          spire.position.set(cX, 2.5, cZ);
          group.add(spire);

          // Purple crystal on spire tip
          const tipGeo = new THREE.OctahedronGeometry(0.06, 0);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0xaa44ff,
            emissive: 0x8822cc,
            emissiveIntensity: 0.8
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(cX, 2.8, cZ);
          tip.userData.isBaseRune = true;
          tip.userData.runeIndex = corner;
          group.add(tip);
        }

        // EPIC DEMON SKULL - facing +X towards zombies!
        const skullGeo = new THREE.SphereGeometry(0.45, 20, 20);
        skullGeo.scale(0.85, 1.15, 0.75);
        const skullMat = new THREE.MeshPhongMaterial({
          color: 0xd8d8c8,
          shininess: 80,
          specular: 0x665544,
          emissive: 0x442211,
          emissiveIntensity: 0.3
        });
        const skull = new THREE.Mesh(skullGeo, skullMat);
        skull.position.set(0.45, 1.6, 0);
        group.add(skull);

        // Skull crown horns
        for (let h = -1; h <= 1; h += 2) {
          const hornGeo = new THREE.ConeGeometry(0.06, 0.35, 6);
          const hornMat = new THREE.MeshPhongMaterial({
            color: 0x1a1015,
            shininess: 60,
            emissive: 0x220815,
            emissiveIntensity: 0.5
          });
          const horn = new THREE.Mesh(hornGeo, hornMat);
          horn.position.set(0.35, 1.95, h * 0.18);
          horn.rotation.z = h * 0.4;
          horn.rotation.x = -0.2;
          group.add(horn);
        }

        // Skull cheekbones
        for (let side = -1; side <= 1; side += 2) {
          const cheekGeo = new THREE.SphereGeometry(0.12, 10, 10);
          cheekGeo.scale(0.8, 0.6, 0.5);
          const cheek = new THREE.Mesh(cheekGeo, skullMat);
          cheek.position.set(0.52, 1.5, side * 0.22);
          group.add(cheek);
        }

        // Massive jaw
        const jawGeo = new THREE.SphereGeometry(0.28, 14, 14);
        jawGeo.scale(0.85, 0.45, 0.7);
        const jaw = new THREE.Mesh(jawGeo, skullMat);
        jaw.position.set(0.5, 1.25, 0);
        group.add(jaw);

        // BLAZING HELLFIRE EYES facing +X!
        for (let eye = -1; eye <= 1; eye += 2) {
          // Deep void socket
          const socketGeo = new THREE.SphereGeometry(0.12, 12, 12);
          const socketMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const socket = new THREE.Mesh(socketGeo, socketMat);
          socket.position.set(0.6, 1.65, eye * 0.14);
          group.add(socket);

          // Inner hellfire core
          const coreGeo = new THREE.SphereGeometry(0.08, 10, 10);
          const coreMat = new THREE.MeshBasicMaterial({
            color: 0xff0000,
            transparent: true,
            opacity: 1.0
          });
          const core = new THREE.Mesh(coreGeo, coreMat);
          core.position.set(0.65, 1.65, eye * 0.14);
          core.userData.isSkullEye = true;
          group.add(core);

          // Outer hellfire glow
          const glowGeo = new THREE.SphereGeometry(0.1, 10, 10);
          const glowMat = new THREE.MeshBasicMaterial({
            color: 0xff4400,
            transparent: true,
            opacity: 0.6
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.set(0.64, 1.65, eye * 0.14);
          glow.userData.isSkullEye = true;
          group.add(glow);

          // Flame trails rising from eyes
          for (let f = 0; f < 3; f++) {
            const flameGeo = new THREE.ConeGeometry(0.025 - f * 0.005, 0.12 + f * 0.04, 5);
            const flameMat = new THREE.MeshBasicMaterial({
              color: f === 0 ? 0xff2200 : (f === 1 ? 0xff6600 : 0xffaa00),
              transparent: true,
              opacity: 0.8 - f * 0.2
            });
            const flame = new THREE.Mesh(flameGeo, flameMat);
            flame.position.set(0.64, 1.78 + f * 0.08, eye * 0.14);
            flame.userData.isEyeFlame = true;
            group.add(flame);
          }
        }

        // Triangular nose void
        const noseGeo = new THREE.ConeGeometry(0.05, 0.1, 3);
        const noseMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
        const nose = new THREE.Mesh(noseGeo, noseMat);
        nose.position.set(0.65, 1.48, 0);
        nose.rotation.z = -Math.PI / 2;
        group.add(nose);

        // Sharp fanged teeth
        for (let t = -3; t <= 3; t++) {
          const isFang = Math.abs(t) === 2;
          const toothGeo = new THREE.ConeGeometry(isFang ? 0.03 : 0.025, isFang ? 0.1 : 0.06, 4);
          const toothMat = new THREE.MeshPhongMaterial({
            color: 0xeeeedd,
            shininess: 80
          });
          const tooth = new THREE.Mesh(toothGeo, toothMat);
          tooth.position.set(0.65, 1.28 - (isFang ? 0.02 : 0), t * 0.045);
          tooth.rotation.z = Math.PI;
          group.add(tooth);
        }

        // Blood roses on fortress sides
        for (let side = -1; side <= 1; side += 2) {
          for (let r = 0; r < 4; r++) {
            const roseGeo = new THREE.SphereGeometry(0.08, 12, 12);
            const roseMat = new THREE.MeshPhongMaterial({
              color: 0x660018,
              shininess: 120,
              emissive: 0x440010,
              emissiveIntensity: 0.7
            });
            const rose = new THREE.Mesh(roseGeo, roseMat);
            rose.position.set(0.15 - r * 0.1, 0.5 + r * 0.4, side * 0.6);
            group.add(rose);

            // Rose petals spiral
            for (let p = 0; p < 6; p++) {
              const petalGeo = new THREE.SphereGeometry(0.035, 6, 6);
              petalGeo.scale(1.4, 0.35, 1);
              const petalMat = new THREE.MeshPhongMaterial({
                color: 0x880020,
                shininess: 90,
                emissive: 0x440010,
                emissiveIntensity: 0.5
              });
              const petal = new THREE.Mesh(petalGeo, petalMat);
              const pAngle = (p / 6) * Math.PI * 2;
              petal.position.set(
                rose.position.x + Math.cos(pAngle) * 0.07,
                rose.position.y,
                rose.position.z + Math.sin(pAngle) * 0.07 * 0.3
              );
              petal.rotation.z = pAngle;
              group.add(petal);
            }
          }
        }

        // Ice crystal crown on top
        for (let i = 0; i < 7; i++) {
          const crystalGeo = new THREE.ConeGeometry(0.05, 0.35 + (i % 2) * 0.15, 4);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0x77aacc,
            shininess: 250,
            specular: 0xffffff,
            transparent: true,
            opacity: 0.85,
            emissive: 0x4488aa,
            emissiveIntensity: 0.6
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          crystal.position.set(-0.2, 2.35, -0.4 + i * 0.13);
          crystal.rotation.z = (i % 2 === 0 ? 0.1 : -0.1);
          group.add(crystal);
        }

        // Dark energy crystals pointing at zombies (+X)
        for (let i = 0; i < 4; i++) {
          const dkGeo = new THREE.ConeGeometry(0.04, 0.3, 4);
          const dkMat = new THREE.MeshPhongMaterial({
            color: 0x5522aa,
            shininess: 220,
            transparent: true,
            opacity: 0.9,
            emissive: 0x3311aa,
            emissiveIntensity: 0.7
          });
          const dk = new THREE.Mesh(dkGeo, dkMat);
          dk.position.set(0.4, 0.5 + i * 0.3, (i % 2 === 0 ? 0.35 : -0.35));
          dk.rotation.z = -Math.PI / 3;
          group.add(dk);
        }

        // Screaming souls orbiting the fortress
        for (let i = 0; i < 6; i++) {
          const soulGroup = new THREE.Group();

          // Soul body
          const soulGeo = new THREE.SphereGeometry(0.08, 10, 10);
          soulGeo.scale(0.8, 1.4, 0.8);
          const soulMat = new THREE.MeshBasicMaterial({
            color: 0x88eeff,
            transparent: true,
            opacity: 0.55
          });
          const soul = new THREE.Mesh(soulGeo, soulMat);
          soulGroup.add(soul);

          // Soul face (screaming O mouth)
          const mouthGeo = new THREE.TorusGeometry(0.02, 0.008, 6, 8);
          const mouthMat = new THREE.MeshBasicMaterial({
            color: 0x000000,
            transparent: true,
            opacity: 0.7
          });
          const mouth = new THREE.Mesh(mouthGeo, mouthMat);
          mouth.position.set(0.06, -0.02, 0);
          mouth.rotation.y = Math.PI / 2;
          soulGroup.add(mouth);

          // Soul eyes
          for (let e = -1; e <= 1; e += 2) {
            const eyeGeo = new THREE.SphereGeometry(0.015, 6, 6);
            const eyeMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
            const soulEye = new THREE.Mesh(eyeGeo, eyeMat);
            soulEye.position.set(0.065, 0.02, e * 0.025);
            soulGroup.add(soulEye);
          }

          const angle = (i / 6) * Math.PI * 2;
          soulGroup.position.set(
            Math.cos(angle) * 0.75,
            0.8 + (i % 3) * 0.45,
            Math.sin(angle) * 0.75
          );
          soulGroup.userData.isSoul = true;
          soulGroup.userData.soulIndex = i;
          group.add(soulGroup);
        }

        // Death aura - outer layer
        const auraOuterGeo = new THREE.SphereGeometry(1.1, 20, 20);
        const auraOuterMat = new THREE.MeshBasicMaterial({
          color: 0x220033,
          transparent: true,
          opacity: 0.12
        });
        const auraOuter = new THREE.Mesh(auraOuterGeo, auraOuterMat);
        auraOuter.position.y = 1.3;
        auraOuter.userData.isReaperAura = true;
        group.add(auraOuter);

        // Death aura - inner layer (more intense)
        const auraInnerGeo = new THREE.SphereGeometry(0.85, 18, 18);
        const auraInnerMat = new THREE.MeshBasicMaterial({
          color: 0x440066,
          transparent: true,
          opacity: 0.15
        });
        const auraInner = new THREE.Mesh(auraInnerGeo, auraInnerMat);
        auraInner.position.y = 1.3;
        auraInner.userData.isReaperAura = true;
        group.add(auraInner);

        // Death mist rising from base
        const mistGeo = new THREE.CylinderGeometry(0.8, 1.0, 0.35, 16);
        const mistMat = new THREE.MeshBasicMaterial({
          color: 0x330055,
          transparent: true,
          opacity: 0.25
        });
        const mist = new THREE.Mesh(mistGeo, mistMat);
        mist.position.y = 0.2;
        mist.userData.isDeathMist = true;
        group.add(mist);

        // MASSIVE REAPER SCYTHE on top facing +X!
        // Scythe pole
        const poleGeo = new THREE.CylinderGeometry(0.04, 0.045, 0.8, 8);
        const poleMat = new THREE.MeshPhongMaterial({
          color: 0x222233,
          shininess: 80,
          emissive: 0x111122,
          emissiveIntensity: 0.3
        });
        const pole = new THREE.Mesh(poleGeo, poleMat);
        pole.position.set(0.3, 2.4, 0);
        pole.rotation.z = Math.PI / 4;
        group.add(pole);

        // Curved scythe blade
        const bladeGeo = new THREE.BoxGeometry(0.7, 0.04, 0.18);
        const bladeMat = new THREE.MeshPhongMaterial({
          color: 0x556688,
          shininess: 250,
          specular: 0xffffff,
          emissive: 0x223344,
          emissiveIntensity: 0.4
        });
        const blade = new THREE.Mesh(bladeGeo, bladeMat);
        blade.position.set(0.65, 2.55, 0);
        blade.rotation.z = -0.25;
        group.add(blade);

        // Blade edge glow
        const edgeGeo = new THREE.BoxGeometry(0.72, 0.015, 0.19);
        const edgeMat = new THREE.MeshBasicMaterial({
          color: 0xaa00ff,
          transparent: true,
          opacity: 0.7
        });
        const edge = new THREE.Mesh(edgeGeo, edgeMat);
        edge.position.set(0.66, 2.52, 0);
        edge.rotation.z = -0.25;
        edge.userData.isBaseRune = true;
        edge.userData.runeIndex = 5;
        group.add(edge);

        // Blade tip - sharp point
        const tipGeo = new THREE.ConeGeometry(0.1, 0.25, 3);
        const tip = new THREE.Mesh(tipGeo, bladeMat);
        tip.position.set(1.0, 2.5, 0);
        tip.rotation.z = -Math.PI / 2 - 0.25;
        group.add(tip);

        // Soul energy dripping from blade
        for (let d = 0; d < 3; d++) {
          const dripGeo = new THREE.SphereGeometry(0.03, 6, 6);
          dripGeo.scale(1, 1.8, 1);
          const dripMat = new THREE.MeshBasicMaterial({
            color: 0x8844ff,
            transparent: true,
            opacity: 0.6
          });
          const drip = new THREE.Mesh(dripGeo, dripMat);
          drip.position.set(0.5 + d * 0.2, 2.4 - d * 0.1, 0);
          drip.userData.isSoul = true;
          drip.userData.soulIndex = 6 + d;
          group.add(drip);
        }

        break;
      }

      case 'acorn-tree': {
        // ACORN TREE - Shoots acorns that plant acorn bombs

        // Nature aura
        const atAura = new THREE.Mesh(
          new THREE.SphereGeometry(1.2, 16, 16),
          new THREE.MeshBasicMaterial({ color: 0x44aa22, transparent: true, opacity: 0.1 })
        );
        atAura.position.y = 1.5;
        atAura.userData.isTreeAura = true;
        group.add(atAura);

        // Rich soil mound
        const atSoil = new THREE.Mesh(
          new THREE.CylinderGeometry(0.7, 0.85, 0.3, 14),
          new THREE.MeshPhongMaterial({ color: 0x4a3a2a, shininess: 20, emissive: 0x1a1510, emissiveIntensity: 0.15 })
        );
        atSoil.position.y = 0.15;
        group.add(atSoil);

        // Exposed roots spreading outward
        const atRootMat = new THREE.MeshPhongMaterial({ color: 0x4a3020, shininess: 20 });
        const atDarkRootMat = new THREE.MeshPhongMaterial({ color: 0x3a2218, shininess: 15 });
        for (let i = 0; i < 7; i++) {
          const atRootGeo = new THREE.CylinderGeometry(0.04, 0.08, 0.5 + (i % 3) * 0.1, 6);
          const atRoot = new THREE.Mesh(atRootGeo, i % 2 === 0 ? atRootMat : atDarkRootMat);
          const atRAngle = (i / 7) * Math.PI * 2;
          atRoot.position.set(Math.cos(atRAngle) * 0.6, 0.12, Math.sin(atRAngle) * 0.6);
          atRoot.rotation.z = Math.cos(atRAngle) * 0.6;
          atRoot.rotation.x = Math.sin(atRAngle) * 0.6;
          group.add(atRoot);
        }

        // Main tree trunk (tapered, organic)
        const atTrunk = new THREE.Mesh(
          new THREE.CylinderGeometry(0.22, 0.4, 1.5, 12),
          new THREE.MeshPhongMaterial({ color: 0x5a4030, shininess: 30, emissive: 0x2a2015, emissiveIntensity: 0.15 })
        );
        atTrunk.position.y = 1.0;
        group.add(atTrunk);

        // Bark texture - vertical grooves
        for (let bg = 0; bg < 6; bg++) {
          const grooveGeo = new THREE.BoxGeometry(0.04, 1.3, 0.03);
          const grooveMat = new THREE.MeshPhongMaterial({ color: 0x3a2a1a, shininess: 15 });
          const groove = new THREE.Mesh(grooveGeo, grooveMat);
          const bgAngle = (bg / 6) * Math.PI * 2;
          groove.position.set(Math.cos(bgAngle) * 0.28, 1.0, Math.sin(bgAngle) * 0.28);
          groove.rotation.y = bgAngle;
          group.add(groove);
        }

        // Bark rings
        for (let i = 0; i < 4; i++) {
          const atBark = new THREE.Mesh(
            new THREE.TorusGeometry(0.3 - i * 0.015, 0.035, 8, 14),
            new THREE.MeshPhongMaterial({ color: 0x3a2a1a, shininess: 15 })
          );
          atBark.rotation.x = Math.PI / 2;
          atBark.position.y = 0.5 + i * 0.38;
          group.add(atBark);
        }

        // Branch stubs coming off trunk
        for (let br = 0; br < 3; br++) {
          const brGeo = new THREE.CylinderGeometry(0.05, 0.1, 0.35, 6);
          const brMesh = new THREE.Mesh(brGeo, new THREE.MeshPhongMaterial({ color: 0x4a3525, shininess: 25 }));
          const brAngle = (br / 3) * Math.PI * 2 + 0.5;
          brMesh.position.set(Math.cos(brAngle) * 0.25, 1.4 + br * 0.15, Math.sin(brAngle) * 0.25);
          brMesh.rotation.z = -Math.cos(brAngle) * 0.6;
          brMesh.rotation.x = Math.sin(brAngle) * 0.6;
          group.add(brMesh);
        }

        // Main canopy (lush, multi-layered)
        const atCanopyGeo = new THREE.SphereGeometry(0.95, 20, 18);
        atCanopyGeo.scale(1.3, 1.0, 1.3);
        const atCanopy = new THREE.Mesh(atCanopyGeo, new THREE.MeshPhongMaterial({
          color: 0x3a8a2a, shininess: 50, emissive: 0x1a4a12, emissiveIntensity: 0.3
        }));
        atCanopy.position.y = 2.05;
        group.add(atCanopy);

        // Secondary canopy layer (slightly different color for depth)
        const atCanopy2Geo = new THREE.SphereGeometry(0.8, 16, 14);
        atCanopy2Geo.scale(1.15, 0.85, 1.15);
        const atCanopy2 = new THREE.Mesh(atCanopy2Geo, new THREE.MeshPhongMaterial({
          color: 0x4a9a3a, shininess: 40, emissive: 0x1a5a15, emissiveIntensity: 0.2
        }));
        atCanopy2.position.y = 2.2;
        group.add(atCanopy2);

        // Leaf clusters around canopy (varied greens)
        const atLeafColors = [0x4a8a3a, 0x3a7a2a, 0x5a9a4a, 0x3a8530, 0x4a9040];
        for (let i = 0; i < 14; i++) {
          const atLeafGeo = new THREE.SphereGeometry(0.2 + (i % 3) * 0.05, 8, 8);
          atLeafGeo.scale(1.1, 0.5, 1.1);
          const atLeaf = new THREE.Mesh(atLeafGeo, new THREE.MeshPhongMaterial({
            color: atLeafColors[i % 5], shininess: 50
          }));
          const atLAngle = (i / 14) * Math.PI * 2;
          const atLY = i < 7 ? 1.6 + (i % 3) * 0.15 : 2.0 + (i % 4) * 0.12;
          atLeaf.position.set(Math.cos(atLAngle) * (0.45 + (i % 2) * 0.1), atLY, Math.sin(atLAngle) * (0.45 + (i % 2) * 0.1));
          group.add(atLeaf);
        }

        // Acorns hanging from canopy
        for (let i = 0; i < 6; i++) {
          const atAcAngle = (i / 6) * Math.PI * 2;
          const atAcY = 1.35 + (i % 2) * 0.2;

          // Tiny stem
          const acStem = new THREE.Mesh(
            new THREE.CylinderGeometry(0.01, 0.01, 0.08, 4),
            new THREE.MeshPhongMaterial({ color: 0x4a3520, shininess: 20 })
          );
          acStem.position.set(Math.cos(atAcAngle) * 0.38, atAcY + 0.1, Math.sin(atAcAngle) * 0.38);
          group.add(acStem);

          // Acorn cap (textured)
          const atCapGeo = new THREE.SphereGeometry(0.08, 10, 8);
          atCapGeo.scale(1.3, 0.5, 1.3);
          const atCap = new THREE.Mesh(atCapGeo, new THREE.MeshPhongMaterial({
            color: 0x6a5030, shininess: 50, specular: 0x444433
          }));
          atCap.position.set(Math.cos(atAcAngle) * 0.38, atAcY + 0.04, Math.sin(atAcAngle) * 0.38);
          group.add(atCap);

          // Acorn nut body
          const atNutGeo = new THREE.SphereGeometry(0.07, 10, 8);
          atNutGeo.scale(0.9, 1.3, 0.9);
          const atNut = new THREE.Mesh(atNutGeo, new THREE.MeshPhongMaterial({
            color: 0x8a6040, shininess: 80, emissive: 0x3a2010, emissiveIntensity: 0.2
          }));
          atNut.position.set(Math.cos(atAcAngle) * 0.38, atAcY - 0.08, Math.sin(atAcAngle) * 0.38);
          atNut.userData.isAcorn = true;
          group.add(atNut);
        }

        break;
      }

      case 'acorn-bomb': {
        // ACORN BOMB - Explodes when eaten!

        // Small dirt mound
        const dirtGeo = new THREE.CylinderGeometry(0.25, 0.35, 0.15, 8);
        const dirtMat = new THREE.MeshPhongMaterial({
          color: 0x5a4a3a,
          shininess: 20
        });
        const dirt = new THREE.Mesh(dirtGeo, dirtMat);
        dirt.position.y = 0.08;
        group.add(dirt);

        // Main acorn body - glowing dangerously
        const acornGeo = new THREE.SphereGeometry(0.25, 12, 12);
        acornGeo.scale(0.9, 1.3, 0.9);
        const acornMat = new THREE.MeshPhongMaterial({
          color: 0xaa7040,
          shininess: 100,
          emissive: 0xff4400,
          emissiveIntensity: 0.4
        });
        const acorn = new THREE.Mesh(acornGeo, acornMat);
        acorn.position.y = 0.4;
        group.add(acorn);

        // Acorn cap
        const capGeo = new THREE.SphereGeometry(0.22, 10, 10);
        capGeo.scale(1.2, 0.5, 1.2);
        const capMat = new THREE.MeshPhongMaterial({
          color: 0x6a5030,
          shininess: 50,
          emissive: 0x331100,
          emissiveIntensity: 0.3
        });
        const cap = new THREE.Mesh(capGeo, capMat);
        cap.position.y = 0.6;
        group.add(cap);

        // Danger glow aura
        const glowGeo = new THREE.SphereGeometry(0.35, 12, 12);
        const glowMat = new THREE.MeshBasicMaterial({
          color: 0xff6600,
          transparent: true,
          opacity: 0.3
        });
        const glow = new THREE.Mesh(glowGeo, glowMat);
        glow.position.y = 0.4;
        glow.userData.isBombGlow = true;
        group.add(glow);

        // Warning sparks
        for (let i = 0; i < 4; i++) {
          const sparkGeo = new THREE.SphereGeometry(0.03, 6, 6);
          const sparkMat = new THREE.MeshBasicMaterial({
            color: 0xffaa00,
            transparent: true,
            opacity: 0.8
          });
          const spark = new THREE.Mesh(sparkGeo, sparkMat);
          const angle = (i / 4) * Math.PI * 2;
          spark.position.set(
            Math.cos(angle) * 0.3,
            0.4,
            Math.sin(angle) * 0.3
          );
          spark.userData.isSpark = true;
          spark.userData.sparkIndex = i;
          group.add(spark);
        }

        break;
      }

      case 'banana-peel': {
        // BANANA PEEL - Summons animal allies!

        // Tropical flower pot
        const potGeo = new THREE.CylinderGeometry(0.4, 0.3, 0.4, 10);
        const potMat = new THREE.MeshPhongMaterial({
          color: 0x8a6a4a,
          shininess: 50
        });
        const pot = new THREE.Mesh(potGeo, potMat);
        pot.position.y = 0.2;
        group.add(pot);

        // Pot rim
        const rimGeo = new THREE.TorusGeometry(0.4, 0.05, 8, 16);
        const rimMat = new THREE.MeshPhongMaterial({
          color: 0x6a5040,
          shininess: 60
        });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.rotation.x = Math.PI / 2;
        rim.position.y = 0.4;
        group.add(rim);

        // Main banana bunch
        const bunchGroup = new THREE.Group();
        for (let i = 0; i < 5; i++) {
          const bananaGeo = new THREE.CylinderGeometry(0.08, 0.1, 0.6, 8);
          const bananaMat = new THREE.MeshPhongMaterial({
            color: 0xffdd00,
            shininess: 100,
            emissive: 0xaa8800,
            emissiveIntensity: 0.3
          });
          const banana = new THREE.Mesh(bananaGeo, bananaMat);
          const angle = (i / 5) * Math.PI - Math.PI / 2;
          banana.position.set(Math.cos(angle) * 0.15, 0, Math.sin(angle) * 0.08);
          banana.rotation.z = angle * 0.3;
          banana.rotation.x = -0.2;
          bunchGroup.add(banana);
        }
        bunchGroup.position.y = 0.9;
        group.add(bunchGroup);

        // Banana stem
        const stemGeo = new THREE.CylinderGeometry(0.08, 0.12, 0.3, 6);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x4a8a2a,
          shininess: 40
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.55;
        group.add(stem);

        // Large tropical leaves
        for (let i = 0; i < 4; i++) {
          const leafGeo = new THREE.SphereGeometry(0.3, 8, 8);
          leafGeo.scale(1, 0.15, 2.5);
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x3a8a2a : 0x4a9a3a,
            shininess: 50,
            emissive: 0x1a3a0a,
            emissiveIntensity: 0.2
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const angle = (i / 4) * Math.PI * 2;
          leaf.position.set(Math.cos(angle) * 0.25, 0.6, Math.sin(angle) * 0.25);
          leaf.rotation.y = angle;
          leaf.rotation.z = 0.5;
          group.add(leaf);
        }

        // Magical summon aura
        const auraGeo = new THREE.RingGeometry(0.5, 0.7, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xffaa00,
          transparent: true,
          opacity: 0.3,
          side: THREE.DoubleSide
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.rotation.x = -Math.PI / 2;
        aura.position.y = 0.05;
        aura.userData.isSummonAura = true;
        group.add(aura);

        // Sparkles around the plant
        for (let i = 0; i < 6; i++) {
          const sparkleGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const sparkleMat = new THREE.MeshBasicMaterial({
            color: 0xffdd44,
            transparent: true,
            opacity: 0.7
          });
          const sparkle = new THREE.Mesh(sparkleGeo, sparkleMat);
          const angle = (i / 6) * Math.PI * 2;
          sparkle.position.set(
            Math.cos(angle) * 0.6,
            0.5 + (i % 3) * 0.3,
            Math.sin(angle) * 0.6
          );
          sparkle.userData.isSparkle = true;
          sparkle.userData.sparkleIndex = i;
          group.add(sparkle);
        }

        break;
      }

      case 'banana-launcher': {
        // ========================================
        // BANANA LAUNCHER - NECROMANTIC DEATH CANNON!
        // Shoots cursed banana peels that mark zombies!
        // When marked zombie dies, spawns zombie allies!
        // ========================================

        // === DARK OBSIDIAN ALTAR BASE ===
        const altarGeo = new THREE.CylinderGeometry(0.65, 0.75, 0.35, 8);
        const altarMat = new THREE.MeshPhongMaterial({
          color: 0x1a0a1a,
          shininess: 150,
          emissive: 0x220033,
          emissiveIntensity: 0.5
        });
        const altar = new THREE.Mesh(altarGeo, altarMat);
        altar.position.y = 0.175;
        group.add(altar);

        // Glowing green rune engravings on altar
        for (let i = 0; i < 8; i++) {
          const runeGeo = new THREE.BoxGeometry(0.08, 0.25, 0.02);
          const runeMat = new THREE.MeshBasicMaterial({
            color: 0x00ff44,
            transparent: true,
            opacity: 0.9
          });
          const rune = new THREE.Mesh(runeGeo, runeMat);
          const angle = (i / 8) * Math.PI * 2;
          rune.position.set(Math.cos(angle) * 0.68, 0.18, Math.sin(angle) * 0.68);
          rune.rotation.y = angle;
          group.add(rune);
        }

        // === SUMMONING CIRCLE ON GROUND ===
        // Outer ring - purple
        const outerCircleGeo = new THREE.RingGeometry(0.85, 0.95, 32);
        const outerCircleMat = new THREE.MeshBasicMaterial({
          color: 0x9900ff,
          transparent: true,
          opacity: 0.7,
          side: THREE.DoubleSide
        });
        const outerCircle = new THREE.Mesh(outerCircleGeo, outerCircleMat);
        outerCircle.rotation.x = -Math.PI / 2;
        outerCircle.position.y = 0.02;
        group.add(outerCircle);

        // Inner ring - green
        const innerCircleGeo = new THREE.RingGeometry(0.7, 0.78, 32);
        const innerCircleMat = new THREE.MeshBasicMaterial({
          color: 0x00ff44,
          transparent: true,
          opacity: 0.8,
          side: THREE.DoubleSide
        });
        const innerCircle = new THREE.Mesh(innerCircleGeo, innerCircleMat);
        innerCircle.rotation.x = -Math.PI / 2;
        innerCircle.position.y = 0.025;
        group.add(innerCircle);

        // Pentagram star points
        for (let i = 0; i < 5; i++) {
          const starGeo = new THREE.ConeGeometry(0.08, 0.25, 3);
          const starMat = new THREE.MeshBasicMaterial({
            color: 0x00ff00,
            transparent: true,
            opacity: 0.8
          });
          const star = new THREE.Mesh(starGeo, starMat);
          const angle = (i / 5) * Math.PI * 2 - Math.PI / 2;
          star.position.set(Math.cos(angle) * 0.9, 0.03, Math.sin(angle) * 0.9);
          star.rotation.x = -Math.PI / 2;
          star.rotation.z = angle + Math.PI / 2;
          group.add(star);
        }

        // === CENTRAL SKULL CANNON ===
        // Giant skull base
        const skullBaseGeo = new THREE.SphereGeometry(0.35, 12, 10);
        const skullMat = new THREE.MeshPhongMaterial({
          color: 0xddddcc,
          shininess: 60,
          emissive: 0x222211,
          emissiveIntensity: 0.3
        });
        const skullBase = new THREE.Mesh(skullBaseGeo, skullMat);
        skullBase.position.y = 0.6;
        skullBase.scale.set(0.85, 0.9, 1);
        group.add(skullBase);

        // Skull jaw
        const jawGeo = new THREE.SphereGeometry(0.2, 10, 8);
        const jaw = new THREE.Mesh(jawGeo, skullMat);
        jaw.position.set(0.15, 0.4, 0);
        jaw.scale.set(0.7, 0.5, 0.9);
        group.add(jaw);

        // Eye sockets with BURNING green fire
        for (let side = -1; side <= 1; side += 2) {
          // Socket
          const socketGeo = new THREE.SphereGeometry(0.1, 8, 8);
          const socketMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const socket = new THREE.Mesh(socketGeo, socketMat);
          socket.position.set(0.25, 0.65, -side * 0.12);
          group.add(socket);

          // Burning soul fire
          const fireGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const fireMat = new THREE.MeshBasicMaterial({
            color: 0x00ff44,
            transparent: true,
            opacity: 0.95
          });
          const fire = new THREE.Mesh(fireGeo, fireMat);
          fire.position.set(0.28, 0.65, -side * 0.12);
          fire.userData.isSkullFire = true;
          group.add(fire);

          // Fire glow
          const glowGeo = new THREE.SphereGeometry(0.15, 8, 8);
          const glowMat = new THREE.MeshBasicMaterial({
            color: 0x00ff00,
            transparent: true,
            opacity: 0.3
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.set(0.28, 0.65, -side * 0.12);
          group.add(glow);
        }

        // Skull mouth cannon barrel
        const barrelGeo = new THREE.CylinderGeometry(0.12, 0.15, 0.5, 8);
        const barrelMat = new THREE.MeshPhongMaterial({
          color: 0x2a1a2a,
          shininess: 100,
          emissive: 0x110011,
          emissiveIntensity: 0.5
        });
        const barrel = new THREE.Mesh(barrelGeo, barrelMat);
        barrel.rotation.z = Math.PI / 2;
        barrel.position.set(0.35, 0.45, 0);
        group.add(barrel);

        // Barrel green energy ring
        const barrelRingGeo = new THREE.TorusGeometry(0.14, 0.03, 8, 16);
        const barrelRingMat = new THREE.MeshBasicMaterial({
          color: 0x00ff44,
          transparent: true,
          opacity: 0.9
        });
        const barrelRing = new THREE.Mesh(barrelRingGeo, barrelRingMat);
        barrelRing.rotation.y = Math.PI / 2;
        barrelRing.position.set(0.6, 0.45, 0);
        group.add(barrelRing);

        // === CURSED BANANA BUNCH ON TOP ===
        const bunchGroup = new THREE.Group();
        bunchGroup.position.y = 0.9;

        // 7 cursed bananas in a crown formation
        for (let i = 0; i < 7; i++) {
          const bananaGeo = new THREE.CapsuleGeometry(0.07, 0.4, 8, 12);
          const bananaMat = new THREE.MeshPhongMaterial({
            color: 0xccaa00, // Darker, more ominous yellow
            shininess: 80,
            emissive: 0x444400,
            emissiveIntensity: 0.4
          });
          const banana = new THREE.Mesh(bananaGeo, bananaMat);
          const angle = (i / 7) * Math.PI * 2;
          const tilt = 0.4;
          banana.position.set(
            Math.cos(angle) * 0.2,
            0.25,
            Math.sin(angle) * 0.2
          );
          banana.rotation.z = Math.cos(angle) * tilt;
          banana.rotation.x = Math.sin(angle) * tilt;
          bunchGroup.add(banana);

          // Purple curse vein on each banana
          const veinGeo = new THREE.CapsuleGeometry(0.02, 0.35, 4, 8);
          const veinMat = new THREE.MeshBasicMaterial({
            color: 0x9900ff,
            transparent: true,
            opacity: 0.8
          });
          const vein = new THREE.Mesh(veinGeo, veinMat);
          vein.position.copy(banana.position);
          vein.position.z += 0.05;
          vein.rotation.copy(banana.rotation);
          bunchGroup.add(vein);
        }

        // Central banana stem with skull
        const stemGeo = new THREE.CylinderGeometry(0.08, 0.1, 0.3, 6);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x3d2d1d,
          shininess: 50
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.5;
        bunchGroup.add(stem);

        // Mini skull on top
        const miniSkullGeo = new THREE.SphereGeometry(0.12, 8, 8);
        const miniSkull = new THREE.Mesh(miniSkullGeo, skullMat);
        miniSkull.position.y = 0.7;
        miniSkull.scale.set(1, 0.85, 0.8);
        bunchGroup.add(miniSkull);

        // Mini skull eyes
        for (let side = -1; side <= 1; side += 2) {
          const miniEyeGeo = new THREE.SphereGeometry(0.03, 6, 6);
          const miniEyeMat = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
          const miniEye = new THREE.Mesh(miniEyeGeo, miniEyeMat);
          miniEye.position.set(side * 0.04, 0.72, 0.08);
          bunchGroup.add(miniEye);
        }

        group.add(bunchGroup);

        // === FLOATING GHOST SPIRITS ===
        for (let i = 0; i < 4; i++) {
          const ghostGroup = new THREE.Group();
          const angle = (i / 4) * Math.PI * 2;

          // Ghost body
          const ghostGeo = new THREE.ConeGeometry(0.08, 0.2, 8);
          const ghostMat = new THREE.MeshBasicMaterial({
            color: 0x88ff88,
            transparent: true,
            opacity: 0.6
          });
          const ghost = new THREE.Mesh(ghostGeo, ghostMat);
          ghost.rotation.x = Math.PI;
          ghostGroup.add(ghost);

          // Ghost eyes
          for (let e = -1; e <= 1; e += 2) {
            const eyeGeo = new THREE.SphereGeometry(0.02, 6, 6);
            const eyeMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
            const eye = new THREE.Mesh(eyeGeo, eyeMat);
            eye.position.set(e * 0.025, 0.05, 0.05);
            ghostGroup.add(eye);
          }

          ghostGroup.position.set(Math.cos(angle) * 0.6, 1.0 + i * 0.15, Math.sin(angle) * 0.6);
          ghostGroup.userData.isGhost = true;
          ghostGroup.userData.ghostAngle = angle;
          group.add(ghostGroup);
        }

        // === SWIRLING SOUL PARTICLES ===
        for (let i = 0; i < 12; i++) {
          const particleGeo = new THREE.SphereGeometry(0.03, 6, 6);
          const particleMat = new THREE.MeshBasicMaterial({
            color: i % 2 === 0 ? 0x00ff44 : 0x9900ff,
            transparent: true,
            opacity: 0.7
          });
          const particle = new THREE.Mesh(particleGeo, particleMat);
          const angle = (i / 12) * Math.PI * 2;
          const height = 0.3 + (i % 3) * 0.4;
          particle.position.set(Math.cos(angle) * 0.5, height, Math.sin(angle) * 0.5);
          particle.userData.isSoulParticle = true;
          particle.userData.particleAngle = angle;
          particle.userData.particleHeight = height;
          group.add(particle);
        }

        // === DARK ENERGY AURA ===
        const auraGeo = new THREE.SphereGeometry(1.0, 20, 20);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x220044,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.7;
        group.add(aura);

        // Inner green glow
        const innerGlowGeo = new THREE.SphereGeometry(0.7, 16, 16);
        const innerGlowMat = new THREE.MeshBasicMaterial({
          color: 0x00ff22,
          transparent: true,
          opacity: 0.1
        });
        const innerGlow = new THREE.Mesh(innerGlowGeo, innerGlowMat);
        innerGlow.position.y = 0.7;
        group.add(innerGlow);

        // === BONE CHAINS WITH SKULLS ===
        for (let side = -1; side <= 1; side += 2) {
          // Chain links
          for (let j = 0; j < 4; j++) {
            const linkGeo = new THREE.TorusGeometry(0.04, 0.015, 6, 8);
            const linkMat = new THREE.MeshPhongMaterial({
              color: 0x888877,
              shininess: 100
            });
            const link = new THREE.Mesh(linkGeo, linkMat);
            link.position.set(side * 0.5, 0.5 - j * 0.1, 0);
            link.rotation.y = (j % 2) * Math.PI / 2;
            group.add(link);
          }

          // Hanging mini skull
          const hangSkullGeo = new THREE.SphereGeometry(0.06, 6, 6);
          const hangSkull = new THREE.Mesh(hangSkullGeo, skullMat);
          hangSkull.position.set(side * 0.5, 0.1, 0);
          hangSkull.scale.set(1, 0.9, 0.8);
          group.add(hangSkull);

          // Tiny glowing eyes
          for (let e = -1; e <= 1; e += 2) {
            const tinyEyeGeo = new THREE.SphereGeometry(0.015, 4, 4);
            const tinyEyeMat = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
            const tinyEye = new THREE.Mesh(tinyEyeGeo, tinyEyeMat);
            tinyEye.position.set(side * 0.5 + e * 0.02, 0.12, 0.04);
            group.add(tinyEye);
          }
        }

        break;
      }

      case 'frost-peel': {
        // FROST PEEL - EPIC ICE BEAST SUMMONER!

        // === FROZEN CRYSTAL BASE ===
        const baseGeo = new THREE.CylinderGeometry(0.7, 0.8, 0.3, 8);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x1a3a5c,
          shininess: 200,
          specular: 0x88ddff,
          emissive: 0x0a2040,
          emissiveIntensity: 0.3
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.15;
        group.add(base);

        // Glowing ice rim
        const rimGeo = new THREE.TorusGeometry(0.7, 0.08, 12, 32);
        const rimMat = new THREE.MeshBasicMaterial({
          color: 0x00ffff,
          transparent: true,
          opacity: 0.9
        });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.rotation.x = Math.PI / 2;
        rim.position.y = 0.3;
        group.add(rim);

        // === MAJESTIC FROZEN BANANA TREE ===
        // Ice trunk
        const trunkGeo = new THREE.CylinderGeometry(0.15, 0.25, 0.8, 8);
        const trunkMat = new THREE.MeshPhongMaterial({
          color: 0x4488aa,
          shininess: 150,
          emissive: 0x224466,
          emissiveIntensity: 0.4
        });
        const trunk = new THREE.Mesh(trunkGeo, trunkMat);
        trunk.position.y = 0.7;
        group.add(trunk);

        // Frozen banana bunch - crystalline
        for (let i = 0; i < 5; i++) {
          const bananaGeo = new THREE.CapsuleGeometry(0.08, 0.5, 8, 12);
          const bananaMat = new THREE.MeshPhongMaterial({
            color: 0x88ddff,
            shininess: 200,
            specular: 0xffffff,
            emissive: 0x44aadd,
            emissiveIntensity: 0.5,
            transparent: true,
            opacity: 0.9
          });
          const banana = new THREE.Mesh(bananaGeo, bananaMat);
          const angle = (i / 5) * Math.PI - Math.PI / 2;
          banana.position.set(Math.cos(angle) * 0.2, 1.3, Math.sin(angle) * 0.15);
          banana.rotation.z = angle * 0.4;
          banana.rotation.x = -0.3;
          group.add(banana);
        }

        // === GIANT FROST CRYSTAL CROWN ===
        const crystalGeo = new THREE.OctahedronGeometry(0.35, 0);
        const crystalMat = new THREE.MeshPhongMaterial({
          color: 0x00ffff,
          shininess: 300,
          specular: 0xffffff,
          emissive: 0x00ddff,
          emissiveIntensity: 1,
          transparent: true,
          opacity: 0.95
        });
        const crystal = new THREE.Mesh(crystalGeo, crystalMat);
        crystal.position.y = 1.8;
        crystal.userData.isFrostCrystal = true;
        group.add(crystal);

        // Crystal inner glow
        const innerGlowGeo = new THREE.SphereGeometry(0.2, 16, 16);
        const innerGlowMat = new THREE.MeshBasicMaterial({
          color: 0xffffff,
          transparent: true,
          opacity: 0.8
        });
        const innerGlow = new THREE.Mesh(innerGlowGeo, innerGlowMat);
        innerGlow.position.y = 1.8;
        group.add(innerGlow);

        // Crystal outer aura
        const outerAuraGeo = new THREE.SphereGeometry(0.5, 16, 16);
        const outerAuraMat = new THREE.MeshBasicMaterial({
          color: 0x00ffff,
          transparent: true,
          opacity: 0.2
        });
        const outerAura = new THREE.Mesh(outerAuraGeo, outerAuraMat);
        outerAura.position.y = 1.8;
        group.add(outerAura);

        // === ORBITING ICE SHARDS ===
        for (let i = 0; i < 6; i++) {
          const shardGeo = new THREE.ConeGeometry(0.05, 0.25, 4);
          const shardMat = new THREE.MeshPhongMaterial({
            color: 0xccffff,
            shininess: 200,
            emissive: 0x88ffff,
            emissiveIntensity: 0.6
          });
          const shard = new THREE.Mesh(shardGeo, shardMat);
          const angle = (i / 6) * Math.PI * 2;
          shard.position.set(Math.cos(angle) * 0.6, 1.5, Math.sin(angle) * 0.6);
          shard.rotation.z = Math.PI;
          shard.userData.isOrbitShard = true;
          shard.userData.shardIndex = i;
          group.add(shard);
        }

        // === FROZEN ANIMAL SPIRITS (ghost outlines) ===
        // Bull spirit
        const bullGeo = new THREE.SphereGeometry(0.2, 8, 8);
        bullGeo.scale(1.5, 1, 1);
        const spiritMat = new THREE.MeshBasicMaterial({
          color: 0x88ffff,
          transparent: true,
          opacity: 0.3
        });
        const bullSpirit = new THREE.Mesh(bullGeo, spiritMat);
        bullSpirit.position.set(0.5, 0.8, 0);
        bullSpirit.userData.isSpirit = true;
        group.add(bullSpirit);

        // Fox spirit
        const foxGeo = new THREE.ConeGeometry(0.12, 0.3, 6);
        const foxSpirit = new THREE.Mesh(foxGeo, spiritMat.clone());
        foxSpirit.position.set(-0.5, 0.8, 0);
        foxSpirit.rotation.z = Math.PI;
        foxSpirit.userData.isSpirit = true;
        group.add(foxSpirit);

        // === GROUND FROST EFFECT ===
        for (let r = 1; r <= 3; r++) {
          const frostRingGeo = new THREE.RingGeometry(r * 0.35, r * 0.35 + 0.05, 32);
          const frostRingMat = new THREE.MeshBasicMaterial({
            color: 0x00ffff,
            transparent: true,
            opacity: 0.5 - r * 0.12,
            side: THREE.DoubleSide
          });
          const frostRing = new THREE.Mesh(frostRingGeo, frostRingMat);
          frostRing.rotation.x = -Math.PI / 2;
          frostRing.position.y = 0.02;
          frostRing.userData.isSummonAura = true;
          group.add(frostRing);
        }

        // === FLOATING SNOWFLAKES ===
        for (let i = 0; i < 12; i++) {
          const flakeGeo = new THREE.OctahedronGeometry(0.04, 0);
          const flakeMat = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.9
          });
          const flake = new THREE.Mesh(flakeGeo, flakeMat);
          const angle = (i / 12) * Math.PI * 2;
          const radius = 0.4 + (i % 3) * 0.2;
          const height = 0.5 + (i % 4) * 0.4;
          flake.position.set(Math.cos(angle) * radius, height, Math.sin(angle) * radius);
          flake.userData.isSparkle = true;
          flake.userData.sparkleIndex = i;
          group.add(flake);
        }

        break;
      }

      case 'black-hole-coconut': {
        // BLACK HOLE COCONUT - ULTIMATE COSMIC DESTROYER!

        // === DARK MATTER COCONUT SHELL ===
        const shellGeo = new THREE.SphereGeometry(0.45, 32, 32, 0, Math.PI * 2, 0, Math.PI * 0.5);
        const shellMat = new THREE.MeshPhongMaterial({
          color: 0x1a1a2e,
          shininess: 200,
          specular: 0x4a00e0,
          emissive: 0x16003b,
          emissiveIntensity: 0.5
        });
        const shell = new THREE.Mesh(shellGeo, shellMat);
        shell.position.y = 1.0;
        shell.rotation.x = Math.PI;
        group.add(shell);

        // Glowing cracks in the shell
        for (let i = 0; i < 8; i++) {
          const crackGeo = new THREE.BoxGeometry(0.02, 0.25, 0.01);
          const crackMat = new THREE.MeshBasicMaterial({ color: 0x00ffff });
          const crack = new THREE.Mesh(crackGeo, crackMat);
          const angle = (i / 8) * Math.PI * 2;
          crack.position.set(Math.cos(angle) * 0.38, 0.85, Math.sin(angle) * 0.38);
          crack.rotation.y = angle;
          crack.rotation.z = 0.3;
          group.add(crack);
        }

        // Cyan energy rim
        const rimGeo = new THREE.TorusGeometry(0.35, 0.04, 16, 48);
        const rimMat = new THREE.MeshBasicMaterial({ color: 0x00ffff });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.rotation.x = Math.PI / 2;
        rim.position.y = 0.68;
        rim.userData.isEventHorizon = true;
        group.add(rim);

        // === THE VOID - ABSOLUTE DARKNESS ===
        const voidGeo = new THREE.SphereGeometry(0.32, 64, 64);
        const voidMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
        const voidCore = new THREE.Mesh(voidGeo, voidMat);
        voidCore.position.y = 0.85;
        group.add(voidCore);

        // === DUAL-COLOR ACCRETION DISK (Cyan + Orange like M87 black hole) ===
        // Hot cyan inner ring
        const cyanDiskGeo = new THREE.TorusGeometry(0.4, 0.06, 20, 80);
        const cyanDiskMat = new THREE.MeshBasicMaterial({
          color: 0x00ffff,
          transparent: true,
          opacity: 0.95
        });
        const cyanDisk = new THREE.Mesh(cyanDiskGeo, cyanDiskMat);
        cyanDisk.rotation.x = Math.PI / 2.5;
        cyanDisk.position.y = 0.85;
        cyanDisk.userData.isAccretionDisk = true;
        group.add(cyanDisk);

        // Hot orange/gold middle ring
        const goldDiskGeo = new THREE.TorusGeometry(0.55, 0.08, 20, 80);
        const goldDiskMat = new THREE.MeshBasicMaterial({
          color: 0xffaa00,
          transparent: true,
          opacity: 0.9
        });
        const goldDisk = new THREE.Mesh(goldDiskGeo, goldDiskMat);
        goldDisk.rotation.x = Math.PI / 2.5;
        goldDisk.position.y = 0.85;
        goldDisk.userData.isAccretionDisk = true;
        group.add(goldDisk);

        // Outer magenta/pink ring
        const pinkDiskGeo = new THREE.TorusGeometry(0.72, 0.1, 20, 80);
        const pinkDiskMat = new THREE.MeshBasicMaterial({
          color: 0xff0080,
          transparent: true,
          opacity: 0.75
        });
        const pinkDisk = new THREE.Mesh(pinkDiskGeo, pinkDiskMat);
        pinkDisk.rotation.x = Math.PI / 2.5;
        pinkDisk.position.y = 0.85;
        pinkDisk.userData.isAccretionDisk = true;
        group.add(pinkDisk);

        // Vertical gravitational lens ring
        const vertRingGeo = new THREE.TorusGeometry(0.5, 0.02, 16, 64);
        const vertRingMat = new THREE.MeshBasicMaterial({
          color: 0xffff00,
          transparent: true,
          opacity: 0.8
        });
        const vertRing = new THREE.Mesh(vertRingGeo, vertRingMat);
        vertRing.rotation.z = Math.PI / 2;
        vertRing.position.y = 0.85;
        vertRing.userData.isAccretionDisk = true;
        group.add(vertRing);

        // === ENERGY JETS (like real black holes!) ===
        // Top jet
        const topJetGeo = new THREE.ConeGeometry(0.15, 0.8, 16);
        const jetMat = new THREE.MeshBasicMaterial({
          color: 0x00ccff,
          transparent: true,
          opacity: 0.7
        });
        const topJet = new THREE.Mesh(topJetGeo, jetMat);
        topJet.position.y = 1.5;
        topJet.userData.isJet = true;
        group.add(topJet);

        // Bottom jet
        const botJetGeo = new THREE.ConeGeometry(0.15, 0.6, 16);
        const botJet = new THREE.Mesh(botJetGeo, jetMat.clone());
        botJet.position.y = 0.25;
        botJet.rotation.x = Math.PI;
        botJet.userData.isJet = true;
        group.add(botJet);

        // Jet glow spheres
        const topGlowGeo = new THREE.SphereGeometry(0.1, 16, 16);
        const glowMat = new THREE.MeshBasicMaterial({ color: 0x00ffff });
        const topGlow = new THREE.Mesh(topGlowGeo, glowMat);
        topGlow.position.y = 1.9;
        topGlow.userData.isJetGlow = true;
        group.add(topGlow);

        // === SWIRLING MATTER PARTICLES ===
        for (let i = 0; i < 16; i++) {
          const pGeo = new THREE.SphereGeometry(0.035, 8, 8);
          const colors = [0x00ffff, 0xffaa00, 0xff0080, 0xffff00, 0xffffff];
          const pMat = new THREE.MeshBasicMaterial({ color: colors[i % colors.length] });
          const particle = new THREE.Mesh(pGeo, pMat);
          const angle = (i / 16) * Math.PI * 2;
          const dist = 0.45 + (i % 4) * 0.12;
          particle.position.set(Math.cos(angle) * dist, 0.85, Math.sin(angle) * dist);
          particle.userData.isGravityParticle = true;
          particle.userData.particleIndex = i;
          group.add(particle);
        }

        // === ELECTRIC ARCS ===
        for (let i = 0; i < 4; i++) {
          const arcGeo = new THREE.TorusGeometry(0.6 + i * 0.1, 0.008, 8, 32, Math.PI * 0.3);
          const arcMat = new THREE.MeshBasicMaterial({
            color: i % 2 === 0 ? 0x00ffff : 0xff00ff,
            transparent: true,
            opacity: 0.8
          });
          const arc = new THREE.Mesh(arcGeo, arcMat);
          arc.rotation.x = Math.PI / 2;
          arc.rotation.z = (i / 4) * Math.PI * 2;
          arc.position.y = 0.85;
          arc.userData.isArc = true;
          arc.userData.arcIndex = i;
          group.add(arc);
        }

        // === GROUND SHOCKWAVE RINGS ===
        for (let r = 1; r <= 5; r++) {
          const ringGeo = new THREE.RingGeometry(r * 0.3, r * 0.3 + 0.03, 64);
          const ringColor = r <= 2 ? 0x00ffff : (r <= 4 ? 0xff0080 : 0x4400aa);
          const ringMat = new THREE.MeshBasicMaterial({
            color: ringColor,
            transparent: true,
            opacity: 0.6 - r * 0.1,
            side: THREE.DoubleSide
          });
          const ring = new THREE.Mesh(ringGeo, ringMat);
          ring.rotation.x = -Math.PI / 2;
          ring.position.y = 0.02;
          ring.userData.isGroundRing = true;
          ring.userData.ringIndex = r;
          group.add(ring);
        }

        // === FLOATING COSMIC DEBRIS ===
        for (let i = 0; i < 8; i++) {
          const debrisGeo = new THREE.OctahedronGeometry(0.05, 0);
          const debrisMat = new THREE.MeshBasicMaterial({
            color: i % 2 === 0 ? 0x00ffff : 0xffaa00
          });
          const debris = new THREE.Mesh(debrisGeo, debrisMat);
          const angle = (i / 8) * Math.PI * 2;
          debris.position.set(
            Math.cos(angle) * 1.1,
            0.4 + (i % 3) * 0.3,
            Math.sin(angle) * 1.1
          );
          debris.userData.isDebris = true;
          debris.userData.debrisIndex = i;
          group.add(debris);
        }

        break;
      }

      case 'lilyer': {
        // LILYER - MAGNIFICENT DOUBLE GOLDEN LOTUS - 100 sun every 7 seconds!
        // Two intertwined golden lotuses radiating with solar energy

        // Magical golden pond base
        const pondGeo = new THREE.CylinderGeometry(0.75, 0.7, 0.1, 32);
        const pondMat = new THREE.MeshPhongMaterial({
          color: 0x4488cc,
          shininess: 180,
          specular: 0xaaddff,
          transparent: true,
          opacity: 0.85
        });
        const pond = new THREE.Mesh(pondGeo, pondMat);
        pond.position.y = 0.05;
        group.add(pond);

        // Golden light reflecting on water
        const reflectGeo = new THREE.CylinderGeometry(0.73, 0.68, 0.02, 32);
        const reflectMat = new THREE.MeshBasicMaterial({
          color: 0xffcc44,
          transparent: true,
          opacity: 0.35
        });
        const reflect = new THREE.Mesh(reflectGeo, reflectMat);
        reflect.position.y = 0.13;
        reflect.userData.isShimmer = true;
        group.add(reflect);

        // Ornate golden rim with sun patterns
        const rimGeo = new THREE.TorusGeometry(0.88, 0.1, 12, 32);
        const rimMat = new THREE.MeshPhongMaterial({
          color: 0xffcc33,
          shininess: 180,
          specular: 0xffffff,
          emissive: 0xcc8800,
          emissiveIntensity: 0.5
        });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.rotation.x = Math.PI / 2;
        rim.position.y = 0.12;
        group.add(rim);

        // Sun emblems on rim
        for (let i = 0; i < 8; i++) {
          const emblemGeo = new THREE.OctahedronGeometry(0.06, 0);
          const emblemMat = new THREE.MeshPhongMaterial({
            color: 0xffee44,
            emissive: 0xffaa00,
            emissiveIntensity: 0.8
          });
          const emblem = new THREE.Mesh(emblemGeo, emblemMat);
          const angle = (i / 8) * Math.PI * 2;
          emblem.position.set(Math.cos(angle) * 0.88, 0.12, Math.sin(angle) * 0.88);
          emblem.userData.isLilyerCenter = true;
          group.add(emblem);
        }

        // Large lily pads - elegant with gold veins
        for (let i = 0; i < 2; i++) {
          // Main pad
          const padGeo = new THREE.CircleGeometry(0.4, 32);
          const padMat = new THREE.MeshPhongMaterial({
            color: 0x2a8a2a,
            shininess: 80,
            side: THREE.DoubleSide
          });
          const pad = new THREE.Mesh(padGeo, padMat);
          pad.rotation.x = -Math.PI / 2;
          pad.position.set(i === 0 ? -0.28 : 0.28, 0.16, i === 0 ? 0.18 : -0.18);
          group.add(pad);

          // Golden veins on pad
          for (let v = 0; v < 5; v++) {
            const veinGeo = new THREE.BoxGeometry(0.3, 0.01, 0.02);
            const veinMat = new THREE.MeshPhongMaterial({
              color: 0xccaa44,
              emissive: 0x886622,
              emissiveIntensity: 0.3
            });
            const vein = new THREE.Mesh(veinGeo, veinMat);
            const vAngle = (v / 5) * Math.PI * 0.8 - Math.PI * 0.4;
            vein.position.set(
              (i === 0 ? -0.28 : 0.28) + Math.cos(vAngle) * 0.12,
              0.165,
              (i === 0 ? 0.18 : -0.18) + Math.sin(vAngle) * 0.12
            );
            vein.rotation.y = vAngle + (i === 0 ? 0 : Math.PI);
            group.add(vein);
          }
        }

        // TWO MAGNIFICENT GOLDEN LOTUS FLOWERS
        for (let flower = 0; flower < 2; flower++) {
          const fX = flower === 0 ? -0.22 : 0.22;
          const fZ = flower === 0 ? 0.12 : -0.12;
          const fY = 0.35 + flower * 0.1;

          // Stem connecting to pad
          const stemGeo = new THREE.CylinderGeometry(0.04, 0.05, 0.25, 8);
          const stemMat = new THREE.MeshPhongMaterial({
            color: 0x3a8a3a,
            shininess: 60
          });
          const stem = new THREE.Mesh(stemGeo, stemMat);
          stem.position.set(fX, fY - 0.1, fZ);
          group.add(stem);

          // Outer petal layer - large golden petals
          for (let p = 0; p < 8; p++) {
            const petalGeo = new THREE.SphereGeometry(0.18, 12, 12);
            petalGeo.scale(1, 0.25, 0.5);
            const petalMat = new THREE.MeshPhongMaterial({
              color: 0xffcc44,
              shininess: 150,
              specular: 0xffffff,
              emissive: 0xcc8800,
              emissiveIntensity: 0.4
            });
            const petal = new THREE.Mesh(petalGeo, petalMat);
            const angle = (p / 8) * Math.PI * 2;
            petal.position.set(
              fX + Math.cos(angle) * 0.2,
              fY + 0.05,
              fZ + Math.sin(angle) * 0.2
            );
            petal.rotation.y = angle;
            petal.rotation.z = 0.6;
            group.add(petal);
          }

          // Middle petal layer - smaller, brighter gold
          for (let p = 0; p < 6; p++) {
            const petalGeo = new THREE.SphereGeometry(0.12, 10, 10);
            petalGeo.scale(1, 0.3, 0.5);
            const petalMat = new THREE.MeshPhongMaterial({
              color: 0xffdd66,
              shininess: 180,
              specular: 0xffffff,
              emissive: 0xddaa00,
              emissiveIntensity: 0.5
            });
            const petal = new THREE.Mesh(petalGeo, petalMat);
            const angle = (p / 6) * Math.PI * 2 + 0.25;
            petal.position.set(
              fX + Math.cos(angle) * 0.12,
              fY + 0.12,
              fZ + Math.sin(angle) * 0.12
            );
            petal.rotation.y = angle;
            petal.rotation.z = 0.4;
            group.add(petal);
          }

          // Inner petal layer - even brighter
          for (let p = 0; p < 5; p++) {
            const petalGeo = new THREE.SphereGeometry(0.08, 8, 8);
            petalGeo.scale(1, 0.35, 0.5);
            const petalMat = new THREE.MeshPhongMaterial({
              color: 0xffee88,
              shininess: 200,
              specular: 0xffffff,
              emissive: 0xffcc00,
              emissiveIntensity: 0.6
            });
            const petal = new THREE.Mesh(petalGeo, petalMat);
            const angle = (p / 5) * Math.PI * 2 + 0.5;
            petal.position.set(
              fX + Math.cos(angle) * 0.06,
              fY + 0.18,
              fZ + Math.sin(angle) * 0.06
            );
            petal.rotation.y = angle;
            petal.rotation.z = 0.25;
            group.add(petal);
          }

          // Glowing sun core - like a mini sun!
          const coreGeo = new THREE.SphereGeometry(0.1, 16, 16);
          const coreMat = new THREE.MeshPhongMaterial({
            color: 0xffee00,
            emissive: 0xffcc00,
            emissiveIntensity: 1.0
          });
          const core = new THREE.Mesh(coreGeo, coreMat);
          core.position.set(fX, fY + 0.2, fZ);
          core.userData.isLilyerCenter = true;
          group.add(core);

          // Sun rays emanating from core
          for (let r = 0; r < 6; r++) {
            const rayGeo = new THREE.ConeGeometry(0.02, 0.1, 4);
            const rayMat = new THREE.MeshBasicMaterial({
              color: 0xffee44,
              transparent: true,
              opacity: 0.8
            });
            const ray = new THREE.Mesh(rayGeo, rayMat);
            const angle = (r / 6) * Math.PI * 2;
            ray.position.set(
              fX + Math.cos(angle) * 0.12,
              fY + 0.2,
              fZ + Math.sin(angle) * 0.12
            );
            ray.rotation.z = -Math.PI / 2 + angle;
            ray.userData.isLilyerCenter = true;
            group.add(ray);
          }
        }

        // Golden magical particles floating up
        for (let i = 0; i < 8; i++) {
          const particleGeo = new THREE.SphereGeometry(0.03, 6, 6);
          const particleMat = new THREE.MeshBasicMaterial({
            color: 0xffdd44,
            transparent: true,
            opacity: 0.7
          });
          const particle = new THREE.Mesh(particleGeo, particleMat);
          particle.position.set(
            (Math.random() - 0.5) * 0.8,
            0.4 + Math.random() * 0.5,
            (Math.random() - 0.5) * 0.8
          );
          particle.userData.isLilyerCenter = true;
          group.add(particle);
        }

        // Golden sun aura glow
        const auraGeo = new THREE.SphereGeometry(0.75, 20, 20);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xffcc00,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.45;
        aura.userData.isLilyAura = true;
        group.add(aura);

        // Secondary warm glow
        const innerGlowGeo = new THREE.SphereGeometry(0.5, 16, 16);
        const innerGlowMat = new THREE.MeshBasicMaterial({
          color: 0xffee44,
          transparent: true,
          opacity: 0.15
        });
        const innerGlow = new THREE.Mesh(innerGlowGeo, innerGlowMat);
        innerGlow.position.y = 0.45;
        innerGlow.userData.isLilyAura = true;
        group.add(innerGlow);

        break;
      }

      case 'lilyest': {
        // LILYEST - Ultimate lily that produces BLUE sun (300 sun every 10 seconds)

        // Magical blue crystal water base
        const waterGeo = new THREE.CylinderGeometry(0.85, 0.8, 0.2, 24);
        const waterMat = new THREE.MeshPhongMaterial({
          color: 0x3366aa,
          shininess: 200,
          specular: 0x88ccff,
          transparent: true,
          opacity: 0.9,
          emissive: 0x224488,
          emissiveIntensity: 0.3
        });
        const water = new THREE.Mesh(waterGeo, waterMat);
        water.position.y = 0.1;
        group.add(water);

        // Blue magical shimmer
        const shimmerGeo = new THREE.CylinderGeometry(0.83, 0.78, 0.03, 24);
        const shimmerMat = new THREE.MeshBasicMaterial({
          color: 0x88ddff,
          transparent: true,
          opacity: 0.5
        });
        const shimmer = new THREE.Mesh(shimmerGeo, shimmerMat);
        shimmer.position.y = 0.21;
        shimmer.userData.isShimmer = true;
        group.add(shimmer);

        // Diamond-encrusted rim
        const rimGeo = new THREE.TorusGeometry(0.83, 0.1, 8, 24);
        const rimMat = new THREE.MeshPhongMaterial({
          color: 0x88aaff,
          shininess: 250,
          specular: 0xffffff,
          emissive: 0x4466cc,
          emissiveIntensity: 0.5
        });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.rotation.x = Math.PI / 2;
        rim.position.y = 0.2;
        group.add(rim);

        // Small diamonds around rim
        for (let i = 0; i < 8; i++) {
          const diamondGeo = new THREE.OctahedronGeometry(0.06, 0);
          const diamondMat = new THREE.MeshPhongMaterial({
            color: 0xaaddff,
            shininess: 250,
            emissive: 0x66aaff,
            emissiveIntensity: 0.6
          });
          const diamond = new THREE.Mesh(diamondGeo, diamondMat);
          const angle = (i / 8) * Math.PI * 2;
          diamond.position.set(Math.cos(angle) * 0.8, 0.25, Math.sin(angle) * 0.8);
          diamond.rotation.y = angle;
          group.add(diamond);
        }

        // Three elegant lily pads
        for (let i = 0; i < 3; i++) {
          const padGeo = new THREE.CircleGeometry(0.25, 24);
          const padMat = new THREE.MeshPhongMaterial({
            color: 0x229988,
            shininess: 80,
            side: THREE.DoubleSide
          });
          const pad = new THREE.Mesh(padGeo, padMat);
          pad.rotation.x = -Math.PI / 2;
          const angle = (i / 3) * Math.PI * 2;
          pad.position.set(Math.cos(angle) * 0.35, 0.23, Math.sin(angle) * 0.35);
          group.add(pad);
        }

        // Central MAJESTIC blue flower
        // Large glowing blue petals
        for (let i = 0; i < 8; i++) {
          const petalGeo = new THREE.SphereGeometry(0.2, 12, 12);
          petalGeo.scale(1, 0.25, 0.5);
          const petalMat = new THREE.MeshPhongMaterial({
            color: 0x4488ff,
            shininess: 150,
            emissive: 0x2266dd,
            emissiveIntensity: 0.5,
            transparent: true,
            opacity: 0.9
          });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          const angle = (i / 8) * Math.PI * 2;
          petal.position.set(
            Math.cos(angle) * 0.22,
            0.6,
            Math.sin(angle) * 0.22
          );
          petal.rotation.y = angle;
          petal.rotation.z = 0.6;
          group.add(petal);
        }

        // Glowing blue diamond center
        const centerGeo = new THREE.OctahedronGeometry(0.15, 0);
        const centerMat = new THREE.MeshPhongMaterial({
          color: 0x44ddff,
          shininess: 250,
          emissive: 0x22aaff,
          emissiveIntensity: 1.0
        });
        const center = new THREE.Mesh(centerGeo, centerMat);
        center.position.y = 0.7;
        center.userData.isLilyestCenter = true;
        group.add(center);

        // Magical blue sun aura
        const auraGeo = new THREE.SphereGeometry(0.7, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x44aaff,
          transparent: true,
          opacity: 0.18
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.6;
        aura.userData.isLilyAura = true;
        group.add(aura);

        // Floating blue sparkles
        for (let i = 0; i < 6; i++) {
          const sparkleGeo = new THREE.OctahedronGeometry(0.04, 0);
          const sparkleMat = new THREE.MeshBasicMaterial({
            color: 0x88ddff,
            transparent: true,
            opacity: 0.8
          });
          const sparkle = new THREE.Mesh(sparkleGeo, sparkleMat);
          const angle = (i / 6) * Math.PI * 2;
          sparkle.position.set(
            Math.cos(angle) * 0.5,
            0.4 + (i % 3) * 0.2,
            Math.sin(angle) * 0.5
          );
          sparkle.userData.isSparkle = true;
          sparkle.userData.sparkleIndex = i;
          group.add(sparkle);
        }

        break;
      }

      case 'frost-grape-launcher': {
        // FROST GRAPE LAUNCHER - Icy grape shooter with 50 damage and 30% slow

        // Frozen base
        const baseGeo = new THREE.CylinderGeometry(0.5, 0.6, 0.2, 14);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x6699cc,
          shininess: 120,
          emissive: 0x336699,
          emissiveIntensity: 0.3
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.1;
        group.add(base);

        // Ice crystal ring
        for (let i = 0; i < 6; i++) {
          const crystalGeo = new THREE.OctahedronGeometry(0.08, 0);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0xaaddff,
            shininess: 200,
            emissive: 0x66bbff,
            emissiveIntensity: 0.5,
            transparent: true,
            opacity: 0.85
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const angle = (i / 6) * Math.PI * 2;
          crystal.position.set(Math.cos(angle) * 0.5, 0.2, Math.sin(angle) * 0.5);
          group.add(crystal);
        }

        // Frosted grape body
        const grapeGeo = new THREE.SphereGeometry(0.35, 14, 14);
        const grapeMat = new THREE.MeshPhongMaterial({
          color: 0x6644aa,
          shininess: 100,
          emissive: 0x442288,
          emissiveIntensity: 0.3
        });
        const grape = new THREE.Mesh(grapeGeo, grapeMat);
        grape.position.y = 0.55;
        group.add(grape);

        // Frost coating on grape
        const frostGeo = new THREE.SphereGeometry(0.38, 14, 14);
        const frostMat = new THREE.MeshPhongMaterial({
          color: 0xaaddff,
          shininess: 180,
          transparent: true,
          opacity: 0.35,
          emissive: 0x66bbff,
          emissiveIntensity: 0.4
        });
        const frost = new THREE.Mesh(frostGeo, frostMat);
        frost.position.y = 0.55;
        group.add(frost);

        // Ice cannon barrel
        const barrelGeo = new THREE.CylinderGeometry(0.12, 0.15, 0.5, 10);
        const barrelMat = new THREE.MeshPhongMaterial({
          color: 0x88ccff,
          shininess: 150,
          emissive: 0x4488cc,
          emissiveIntensity: 0.4
        });
        const barrel = new THREE.Mesh(barrelGeo, barrelMat);
        barrel.position.set(0.35, 0.55, 0);
        barrel.rotation.z = -Math.PI / 2;
        group.add(barrel);

        // Frozen grape projectile in barrel
        const projGeo = new THREE.SphereGeometry(0.1, 8, 8);
        const projMat = new THREE.MeshPhongMaterial({
          color: 0x8866cc,
          shininess: 120,
          emissive: 0x5544aa,
          emissiveIntensity: 0.5
        });
        const proj = new THREE.Mesh(projGeo, projMat);
        proj.position.set(0.55, 0.55, 0);
        group.add(proj);

        // Icy aura
        const auraGeo = new THREE.SphereGeometry(0.7, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x88ddff,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.5;
        group.add(aura);

        break;
      }

      case 'strawberry-tree': {
        // STRAWBERRY TREE - Shoots sticky acorns that explode

        // Tree trunk base
        const trunkGeo = new THREE.CylinderGeometry(0.2, 0.35, 0.8, 10);
        const trunkMat = new THREE.MeshPhongMaterial({
          color: 0x8b4513,
          shininess: 40,
          emissive: 0x442208,
          emissiveIntensity: 0.2
        });
        const trunk = new THREE.Mesh(trunkGeo, trunkMat);
        trunk.position.y = 0.4;
        group.add(trunk);

        // Main canopy - strawberry colored
        const canopyGeo = new THREE.SphereGeometry(0.55, 14, 14);
        const canopyMat = new THREE.MeshPhongMaterial({
          color: 0xff4455,
          shininess: 80,
          emissive: 0xcc2233,
          emissiveIntensity: 0.3
        });
        const canopy = new THREE.Mesh(canopyGeo, canopyMat);
        canopy.position.y = 1.1;
        group.add(canopy);

        // Strawberry seeds on canopy
        for (let i = 0; i < 12; i++) {
          const seedGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const seedMat = new THREE.MeshPhongMaterial({
            color: 0xffee66,
            shininess: 100
          });
          const seed = new THREE.Mesh(seedGeo, seedMat);
          const theta = Math.random() * Math.PI * 2;
          const phi = Math.random() * Math.PI * 0.7 + 0.3;
          seed.position.set(
            Math.sin(phi) * Math.cos(theta) * 0.55,
            1.1 + Math.cos(phi) * 0.4,
            Math.sin(phi) * Math.sin(theta) * 0.55
          );
          group.add(seed);
        }

        // Acorn projectiles on branches
        for (let i = 0; i < 4; i++) {
          const acornGeo = new THREE.SphereGeometry(0.1, 8, 8);
          acornGeo.scale(1, 1.3, 1);
          const acornMat = new THREE.MeshPhongMaterial({
            color: 0xcc8844,
            shininess: 80,
            emissive: 0x885522,
            emissiveIntensity: 0.3
          });
          const acorn = new THREE.Mesh(acornGeo, acornMat);
          const angle = (i / 4) * Math.PI * 2;
          acorn.position.set(
            Math.cos(angle) * 0.45,
            1.0 + (i % 2) * 0.25,
            Math.sin(angle) * 0.45
          );
          group.add(acorn);

          // Acorn cap
          const capGeo = new THREE.CylinderGeometry(0.1, 0.08, 0.05, 8);
          const capMat = new THREE.MeshPhongMaterial({
            color: 0x664422,
            shininess: 60
          });
          const cap = new THREE.Mesh(capGeo, capMat);
          cap.position.set(
            Math.cos(angle) * 0.45,
            1.12 + (i % 2) * 0.25,
            Math.sin(angle) * 0.45
          );
          group.add(cap);
        }

        // Green leaves
        for (let i = 0; i < 6; i++) {
          const leafGeo = new THREE.SphereGeometry(0.15, 8, 8);
          leafGeo.scale(1, 0.3, 2);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x44aa44,
            shininess: 60,
            emissive: 0x226622,
            emissiveIntensity: 0.2
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const angle = (i / 6) * Math.PI * 2;
          leaf.position.set(
            Math.cos(angle) * 0.35,
            1.55,
            Math.sin(angle) * 0.35
          );
          leaf.rotation.y = angle;
          leaf.rotation.z = 0.4;
          group.add(leaf);
        }

        break;
      }

      case 'frozen-mushroom-bomber': {
        // FROZEN MUSHROOM BOMBER - 3x3 icy toxic fumes

        // Frozen soil base
        const baseGeo = new THREE.CylinderGeometry(0.5, 0.55, 0.15, 12);
        const baseMat = new THREE.MeshPhongMaterial({
          color: 0x5588aa,
          shininess: 100,
          emissive: 0x336688,
          emissiveIntensity: 0.3
        });
        const base = new THREE.Mesh(baseGeo, baseMat);
        base.position.y = 0.08;
        group.add(base);

        // Icy mushroom stem
        const stemGeo = new THREE.CylinderGeometry(0.15, 0.2, 0.5, 10);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0xaaddff,
          shininess: 120,
          emissive: 0x77aacc,
          emissiveIntensity: 0.35
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.4;
        group.add(stem);

        // Frosted mushroom cap
        const capGeo = new THREE.SphereGeometry(0.45, 14, 14);
        capGeo.scale(1.2, 0.6, 1.2);
        const capMat = new THREE.MeshPhongMaterial({
          color: 0x7744aa,
          shininess: 80,
          emissive: 0x442266,
          emissiveIntensity: 0.35
        });
        const cap = new THREE.Mesh(capGeo, capMat);
        cap.position.y = 0.8;
        group.add(cap);

        // Ice crystals on cap
        for (let i = 0; i < 8; i++) {
          const crystalGeo = new THREE.OctahedronGeometry(0.06, 0);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0xccffff,
            shininess: 200,
            emissive: 0x88ddff,
            emissiveIntensity: 0.6,
            transparent: true,
            opacity: 0.85
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const angle = (i / 8) * Math.PI * 2;
          crystal.position.set(
            Math.cos(angle) * 0.4,
            0.85 + Math.sin(i * 2) * 0.08,
            Math.sin(angle) * 0.4
          );
          group.add(crystal);
        }

        // Frost coating
        const frostGeo = new THREE.SphereGeometry(0.5, 14, 14);
        frostGeo.scale(1.2, 0.6, 1.2);
        const frostMat = new THREE.MeshPhongMaterial({
          color: 0xaaddff,
          shininess: 150,
          transparent: true,
          opacity: 0.3,
          emissive: 0x66bbff,
          emissiveIntensity: 0.4
        });
        const frost = new THREE.Mesh(frostGeo, frostMat);
        frost.position.y = 0.8;
        group.add(frost);

        // Toxic/icy spore vents
        for (let i = 0; i < 4; i++) {
          const ventGeo = new THREE.CylinderGeometry(0.05, 0.08, 0.1, 8);
          const ventMat = new THREE.MeshPhongMaterial({
            color: 0x66aacc,
            shininess: 100,
            emissive: 0x448899,
            emissiveIntensity: 0.5
          });
          const vent = new THREE.Mesh(ventGeo, ventMat);
          const angle = (i / 4) * Math.PI * 2 + Math.PI / 4;
          vent.position.set(
            Math.cos(angle) * 0.35,
            0.75,
            Math.sin(angle) * 0.35
          );
          group.add(vent);
        }

        // Icy aura
        const auraGeo = new THREE.SphereGeometry(0.7, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x88ccff,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.6;
        group.add(aura);

        break;
      }

      case 'frozen-overlord-mushroom': {
        // FROZEN OVERLORD MUSHROOM - Ultimate ice mushroom fusion
        // 3x3 area, 200 damage, 4s cooldown, 1s freeze, 50% slow for 5s

        // === FROZEN THRONE BASE ===
        const throneBaseGeo = new THREE.CylinderGeometry(0.8, 0.9, 0.2, 8);
        const throneBaseMat = new THREE.MeshPhongMaterial({
          color: 0x1a3a5c,
          shininess: 200,
          specular: 0xaaddff,
          emissive: 0x0a2040,
          emissiveIntensity: 0.5
        });
        const throneBase = new THREE.Mesh(throneBaseGeo, throneBaseMat);
        throneBase.position.y = 0.1;
        group.add(throneBase);

        // Ice crystal spikes around base
        for (let i = 0; i < 8; i++) {
          const spikeGeo = new THREE.ConeGeometry(0.08, 0.4, 6);
          const spikeMat = new THREE.MeshPhongMaterial({
            color: 0x88ddff,
            shininess: 250,
            transparent: true,
            opacity: 0.8,
            emissive: 0x66bbff,
            emissiveIntensity: 0.6
          });
          const spike = new THREE.Mesh(spikeGeo, spikeMat);
          const angle = (i / 8) * Math.PI * 2;
          spike.position.set(Math.cos(angle) * 0.7, 0.35, Math.sin(angle) * 0.7);
          spike.rotation.x = (Math.random() - 0.5) * 0.4;
          spike.rotation.z = (Math.random() - 0.5) * 0.4;
          group.add(spike);
        }

        // === MASSIVE FROZEN MUSHROOM STEM ===
        const overlordStemGeo = new THREE.CylinderGeometry(0.2, 0.3, 0.8, 12);
        const overlordStemMat = new THREE.MeshPhongMaterial({
          color: 0x99ccee,
          shininess: 180,
          emissive: 0x5588aa,
          emissiveIntensity: 0.5
        });
        const overlordStem = new THREE.Mesh(overlordStemGeo, overlordStemMat);
        overlordStem.position.y = 0.6;
        group.add(overlordStem);

        // Frost patterns on stem
        for (let i = 0; i < 6; i++) {
          const frostPatternGeo = new THREE.TorusGeometry(0.22, 0.02, 6, 16);
          const frostPatternMat = new THREE.MeshBasicMaterial({
            color: 0xaaeeff,
            transparent: true,
            opacity: 0.6
          });
          const frostPattern = new THREE.Mesh(frostPatternGeo, frostPatternMat);
          frostPattern.position.y = 0.3 + i * 0.12;
          frostPattern.rotation.x = Math.PI / 2;
          group.add(frostPattern);
        }

        // === OVERLORD CROWN CAP ===
        const crownCapGeo = new THREE.SphereGeometry(0.6, 16, 16);
        crownCapGeo.scale(1.3, 0.7, 1.3);
        const crownCapMat = new THREE.MeshPhongMaterial({
          color: 0x5522aa,
          shininess: 120,
          emissive: 0x3311aa,
          emissiveIntensity: 0.5
        });
        const crownCap = new THREE.Mesh(crownCapGeo, crownCapMat);
        crownCap.position.y = 1.2;
        group.add(crownCap);

        // Ice crown spires on top
        for (let i = 0; i < 5; i++) {
          const spireGeo = new THREE.ConeGeometry(0.06, 0.35, 6);
          const spireMat = new THREE.MeshPhongMaterial({
            color: 0xaaeeff,
            shininess: 300,
            transparent: true,
            opacity: 0.9,
            emissive: 0x88ddff,
            emissiveIntensity: 0.7
          });
          const spire = new THREE.Mesh(spireGeo, spireMat);
          const angle = (i / 5) * Math.PI * 2;
          spire.position.set(
            Math.cos(angle) * 0.35,
            1.5 + Math.abs(Math.sin(angle * 2)) * 0.15,
            Math.sin(angle) * 0.35
          );
          spire.userData.isCrownSpire = true;
          group.add(spire);
        }

        // Central crown jewel
        const jewelGeo = new THREE.OctahedronGeometry(0.15, 0);
        const jewelMat = new THREE.MeshPhongMaterial({
          color: 0x00ffff,
          shininess: 300,
          emissive: 0x00aaff,
          emissiveIntensity: 0.9,
          transparent: true,
          opacity: 0.95
        });
        const jewel = new THREE.Mesh(jewelGeo, jewelMat);
        jewel.position.y = 1.7;
        jewel.userData.isCrownJewel = true;
        group.add(jewel);

        // === ICE ELEMENTAL EYES ===
        for (let side = -1; side <= 1; side += 2) {
          const eyeSocketGeo = new THREE.SphereGeometry(0.1, 8, 8);
          const eyeSocketMat = new THREE.MeshBasicMaterial({ color: 0x001122 });
          const eyeSocket = new THREE.Mesh(eyeSocketGeo, eyeSocketMat);
          eyeSocket.position.set(side * 0.25, 1.15, 0.5);
          group.add(eyeSocket);

          const overlordEyeGeo = new THREE.SphereGeometry(0.07, 8, 8);
          const overlordEyeMat = new THREE.MeshBasicMaterial({
            color: 0x00ffff,
            transparent: true,
            opacity: 1.0
          });
          const overlordEye = new THREE.Mesh(overlordEyeGeo, overlordEyeMat);
          overlordEye.position.set(side * 0.25, 1.15, 0.53);
          overlordEye.userData.isOverlordEye = true;
          group.add(overlordEye);

          // Cold breath trails from eyes
          const breathGeo = new THREE.ConeGeometry(0.04, 0.15, 6);
          const breathMat = new THREE.MeshBasicMaterial({
            color: 0x88eeff,
            transparent: true,
            opacity: 0.5
          });
          const breath = new THREE.Mesh(breathGeo, breathMat);
          breath.position.set(side * 0.25, 1.1, 0.6);
          breath.rotation.x = Math.PI / 2;
          breath.userData.isBreath = true;
          group.add(breath);
        }

        // === FREEZING AURA RINGS ===
        for (let i = 0; i < 3; i++) {
          const auraRingGeo = new THREE.TorusGeometry(0.7 + i * 0.25, 0.03, 8, 32);
          const auraRingMat = new THREE.MeshBasicMaterial({
            color: 0x66eeff,
            transparent: true,
            opacity: 0.3 - i * 0.08
          });
          const auraRing = new THREE.Mesh(auraRingGeo, auraRingMat);
          auraRing.position.y = 0.8;
          auraRing.rotation.x = Math.PI / 2;
          auraRing.userData.isFreezeRing = true;
          auraRing.userData.ringIndex = i;
          group.add(auraRing);
        }

        // === ORBITING ICE CRYSTALS ===
        for (let i = 0; i < 6; i++) {
          const orbitCrystalGeo = new THREE.OctahedronGeometry(0.08, 0);
          const orbitCrystalMat = new THREE.MeshPhongMaterial({
            color: 0xccffff,
            shininess: 250,
            emissive: 0x88eeff,
            emissiveIntensity: 0.6,
            transparent: true,
            opacity: 0.85
          });
          const orbitCrystal = new THREE.Mesh(orbitCrystalGeo, orbitCrystalMat);
          const angle = (i / 6) * Math.PI * 2;
          orbitCrystal.position.set(
            Math.cos(angle) * 0.6,
            1.0 + Math.sin(i * 1.5) * 0.2,
            Math.sin(angle) * 0.6
          );
          orbitCrystal.userData.isOrbitCrystal = true;
          orbitCrystal.userData.crystalIndex = i;
          group.add(orbitCrystal);
        }

        // === FROST MIST ===
        const mistGeo = new THREE.SphereGeometry(1.0, 12, 12);
        const mistMat = new THREE.MeshBasicMaterial({
          color: 0x88ddff,
          transparent: true,
          opacity: 0.15
        });
        const mist = new THREE.Mesh(mistGeo, mistMat);
        mist.position.y = 0.8;
        mist.userData.isFrostMist = true;
        group.add(mist);

        // Ground frost spread
        const groundFrostGeo = new THREE.CylinderGeometry(1.2, 1.3, 0.05, 24);
        const groundFrostMat = new THREE.MeshPhongMaterial({
          color: 0xaaddff,
          shininess: 200,
          transparent: true,
          opacity: 0.4,
          emissive: 0x66bbff,
          emissiveIntensity: 0.3
        });
        const groundFrost = new THREE.Mesh(groundFrostGeo, groundFrostMat);
        groundFrost.position.y = 0.03;
        group.add(groundFrost);

        break;
      }

      case 'sunberry-launcher': {
        // SUNBERRY LAUNCHER - Shoots berries that give sun

        // Golden pot base
        const potGeo = new THREE.CylinderGeometry(0.4, 0.35, 0.35, 12);
        const potMat = new THREE.MeshPhongMaterial({
          color: 0xffcc44,
          shininess: 120,
          emissive: 0xcc9922,
          emissiveIntensity: 0.4
        });
        const pot = new THREE.Mesh(potGeo, potMat);
        pot.position.y = 0.18;
        group.add(pot);

        // Sun emblem on pot
        const emblemGeo = new THREE.CircleGeometry(0.15, 12);
        const emblemMat = new THREE.MeshBasicMaterial({
          color: 0xffee88,
          side: THREE.DoubleSide
        });
        const emblem = new THREE.Mesh(emblemGeo, emblemMat);
        emblem.position.set(0.4, 0.2, 0);
        emblem.rotation.y = Math.PI / 2;
        group.add(emblem);

        // Strawberry body with golden glow
        const berryGeo = new THREE.SphereGeometry(0.35, 14, 14);
        berryGeo.scale(1, 1.2, 1);
        const berryMat = new THREE.MeshPhongMaterial({
          color: 0xff5566,
          shininess: 100,
          emissive: 0xffaa44,
          emissiveIntensity: 0.35
        });
        const berry = new THREE.Mesh(berryGeo, berryMat);
        berry.position.y = 0.7;
        group.add(berry);

        // Golden seeds
        for (let i = 0; i < 10; i++) {
          const seedGeo = new THREE.SphereGeometry(0.035, 6, 6);
          const seedMat = new THREE.MeshPhongMaterial({
            color: 0xffdd44,
            shininess: 150,
            emissive: 0xffaa22,
            emissiveIntensity: 0.6
          });
          const seed = new THREE.Mesh(seedGeo, seedMat);
          const theta = Math.random() * Math.PI * 2;
          const phi = Math.random() * Math.PI * 0.6 + 0.3;
          seed.position.set(
            Math.sin(phi) * Math.cos(theta) * 0.35,
            0.7 + Math.cos(phi) * 0.3,
            Math.sin(phi) * Math.sin(theta) * 0.35
          );
          group.add(seed);
        }

        // Golden leaves
        for (let i = 0; i < 5; i++) {
          const leafGeo = new THREE.SphereGeometry(0.12, 8, 8);
          leafGeo.scale(1, 0.2, 2);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x66cc44,
            shininess: 60,
            emissive: 0xaacc22,
            emissiveIntensity: 0.25
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const angle = (i / 5) * Math.PI * 2;
          leaf.position.set(
            Math.cos(angle) * 0.2,
            1.0,
            Math.sin(angle) * 0.2
          );
          leaf.rotation.y = angle;
          leaf.rotation.z = 0.6;
          group.add(leaf);
        }

        // Sunlight aura
        const auraGeo = new THREE.SphereGeometry(0.6, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xffee66,
          transparent: true,
          opacity: 0.2
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.7;
        aura.userData.isSunAura = true;
        group.add(aura);

        // Sun rays
        for (let i = 0; i < 8; i++) {
          const rayGeo = new THREE.CylinderGeometry(0.02, 0.01, 0.3, 4);
          const rayMat = new THREE.MeshBasicMaterial({
            color: 0xffdd55,
            transparent: true,
            opacity: 0.6
          });
          const ray = new THREE.Mesh(rayGeo, rayMat);
          const angle = (i / 8) * Math.PI * 2;
          ray.position.set(
            Math.cos(angle) * 0.5,
            0.7,
            Math.sin(angle) * 0.5
          );
          ray.rotation.z = Math.PI / 2;
          ray.rotation.y = angle;
          group.add(ray);
        }

        break;
      }

      case 'lily-wall': {
        // LILY WALL - 250 HP wall that gives 25 sun when bitten

        // Mossy base
        const lwBaseGeo = new THREE.CylinderGeometry(0.55, 0.65, 0.15, 14);
        const lwBaseMat = new THREE.MeshPhongMaterial({
          color: 0x3a6a3a, shininess: 40, emissive: 0x1a3a1a, emissiveIntensity: 0.2
        });
        const lwBase = new THREE.Mesh(lwBaseGeo, lwBaseMat);
        lwBase.position.y = 0.07;
        group.add(lwBase);

        // Main wall
        const lwWallGeo = new THREE.BoxGeometry(0.7, 2.2, 1.0);
        const lwWallMat = new THREE.MeshPhongMaterial({
          color: 0x2a5a24, shininess: 55, emissive: 0x1a4a12, emissiveIntensity: 0.3
        });
        const lwWall = new THREE.Mesh(lwWallGeo, lwWallMat);
        lwWall.position.y = 1.25;
        group.add(lwWall);

        // Sun-gold accent bands
        for (let b = 0; b < 2; b++) {
          const bandGeo = new THREE.BoxGeometry(0.72, 0.06, 1.02);
          const bandMat = new THREE.MeshPhongMaterial({
            color: 0xddaa22, shininess: 100, specular: 0xffee88,
            emissive: 0xaa7711, emissiveIntensity: 0.2
          });
          const band = new THREE.Mesh(bandGeo, bandMat);
          band.position.y = 0.7 + b * 1.1;
          group.add(band);
        }

        // Main lily pond embedded in wall
        const lwPondGeo = new THREE.CylinderGeometry(0.4, 0.4, 0.1, 16);
        const lwPondMat = new THREE.MeshPhongMaterial({
          color: 0x4488cc, shininess: 150, transparent: true, opacity: 0.8,
          emissive: 0x224466, emissiveIntensity: 0.2
        });
        const lwPond = new THREE.Mesh(lwPondGeo, lwPondMat);
        lwPond.position.set(0.36, 1.3, 0);
        lwPond.rotation.z = Math.PI / 2;
        group.add(lwPond);

        // Lily pads around pond
        for (let lp = 0; lp < 3; lp++) {
          const padGeo = new THREE.CylinderGeometry(0.1, 0.1, 0.02, 10);
          const padMat = new THREE.MeshPhongMaterial({ color: 0x4a9a2a, shininess: 50 });
          const pad = new THREE.Mesh(padGeo, padMat);
          const ang = (lp / 3) * Math.PI * 2;
          pad.position.set(0.38, 1.3 + Math.sin(ang) * 0.3, Math.cos(ang) * 0.3);
          pad.rotation.z = Math.PI / 2;
          group.add(pad);
        }

        // Main lily flower petals
        for (let i = 0; i < 8; i++) {
          const petalGeo = new THREE.SphereGeometry(0.13, 8, 8);
          petalGeo.scale(1, 0.2, 2);
          const petalMat = new THREE.MeshPhongMaterial({
            color: 0xff99bb, shininess: 85, emissive: 0xff88aa, emissiveIntensity: 0.5
          });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          const angle = (i / 8) * Math.PI * 2;
          petal.position.set(0.42, 1.3 + Math.sin(angle) * 0.2, Math.cos(angle) * 0.2);
          petal.rotation.z = Math.PI / 2;
          petal.rotation.x = angle;
          group.add(petal);
        }

        // Golden center
        const lwCenterGeo = new THREE.SphereGeometry(0.1, 10, 10);
        const lwCenterMat = new THREE.MeshPhongMaterial({
          color: 0xffdd44, shininess: 120, emissive: 0xffaa22, emissiveIntensity: 0.6
        });
        const lwCenter = new THREE.Mesh(lwCenterGeo, lwCenterMat);
        lwCenter.position.set(0.47, 1.3, 0);
        lwCenter.userData.isLilyCenter = true;
        group.add(lwCenter);

        // Second smaller lily flower (upper area)
        for (let i = 0; i < 5; i++) {
          const petalGeo = new THREE.SphereGeometry(0.08, 6, 6);
          petalGeo.scale(1, 0.2, 1.8);
          const petalMat = new THREE.MeshPhongMaterial({
            color: 0xffbbdd, shininess: 70, emissive: 0xff99bb, emissiveIntensity: 0.35
          });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          const angle = (i / 5) * Math.PI * 2;
          petal.position.set(0.4, 1.9 + Math.sin(angle) * 0.1, -0.25 + Math.cos(angle) * 0.1);
          petal.rotation.z = Math.PI / 2;
          petal.rotation.x = angle;
          group.add(petal);
        }
        const lwCenter2Geo = new THREE.SphereGeometry(0.06, 8, 8);
        const lwCenter2Mat = new THREE.MeshPhongMaterial({
          color: 0xffdd44, shininess: 100, emissive: 0xffaa22, emissiveIntensity: 0.5
        });
        const lwCenter2 = new THREE.Mesh(lwCenter2Geo, lwCenter2Mat);
        lwCenter2.position.set(0.43, 1.9, -0.25);
        group.add(lwCenter2);

        // Vines wrapping around
        for (let i = 0; i < 10; i++) {
          const vineGeo = new THREE.CylinderGeometry(0.05, 0.06, 0.8 + Math.random() * 0.6, 6);
          const vineMat = new THREE.MeshPhongMaterial({ color: 0x3a7a22, shininess: 60 });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(
            (Math.random() - 0.5) * 0.5, 0.4 + Math.random() * 1.6, (Math.random() - 0.5) * 0.7
          );
          vine.rotation.x = (Math.random() - 0.5) * 0.8;
          vine.rotation.z = (Math.random() - 0.5) * 0.8;
          group.add(vine);
        }

        // Leaves
        for (let i = 0; i < 8; i++) {
          const leafGeo = new THREE.SphereGeometry(0.12, 8, 8);
          leafGeo.scale(1, 0.25, 1.5);
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x4a9a2a : 0x3a8a1a, shininess: 55, side: THREE.DoubleSide
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.position.set(
            (Math.random() - 0.5) * 0.6, 0.4 + Math.random() * 1.8, (Math.random() - 0.5) * 0.8
          );
          leaf.rotation.set(Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI);
          group.add(leaf);
        }

        // Water drip effects below pond
        for (let d = 0; d < 3; d++) {
          const dripGeo = new THREE.SphereGeometry(0.03, 6, 6);
          dripGeo.scale(0.5, 2, 0.5);
          const dripMat = new THREE.MeshPhongMaterial({
            color: 0x6699cc, shininess: 150, transparent: true, opacity: 0.6
          });
          const drip = new THREE.Mesh(dripGeo, dripMat);
          drip.position.set(0.38, 0.85 - d * 0.15, -0.15 + d * 0.15);
          group.add(drip);
        }

        // Sun glow aura around main flower
        const lwAuraGeo = new THREE.SphereGeometry(0.35, 10, 10);
        const lwAuraMat = new THREE.MeshBasicMaterial({
          color: 0xffee66, transparent: true, opacity: 0.2
        });
        const lwAura = new THREE.Mesh(lwAuraGeo, lwAuraMat);
        lwAura.position.set(0.45, 1.3, 0);
        group.add(lwAura);

        // Overall nature aura
        const lwAura2Geo = new THREE.SphereGeometry(1.0, 12, 12);
        const lwAura2Mat = new THREE.MeshBasicMaterial({
          color: 0xffcc44, transparent: true, opacity: 0.08
        });
        const lwAura2 = new THREE.Mesh(lwAura2Geo, lwAura2Mat);
        lwAura2.position.y = 1.25;
        group.add(lwAura2);

        break;
      }

      case 'vine-slammer': {
        // Fusion: Vine Wall + Avocado Slammer - MASSIVE living vine wall with powerful slam attack

        // MASSIVE thick organic vine wall base
        const wallGeo = new THREE.BoxGeometry(1.0, 2.0, 0.75);
        const wallMat = new THREE.MeshPhongMaterial({
          color: 0x3a7a34,
          shininess: 35,
          specular: 0x2a5a2a,
          emissive: 0x1a3a14,
          emissiveIntensity: 0.2
        });
        const wall = new THREE.Mesh(wallGeo, wallMat);
        wall.position.y = 1.0;
        group.add(wall);

        // Bark texture layers on wall
        for (let layer = 0; layer < 4; layer++) {
          const barkGeo = new THREE.BoxGeometry(0.1, 2.0, 0.7 - layer * 0.12);
          const barkMat = new THREE.MeshPhongMaterial({
            color: layer === 0 ? 0x2a6a2a : layer === 1 ? 0x3a7a3a : layer === 2 ? 0x2f6f2f : 0x357035,
            shininess: 20,
            emissive: 0x1a3a1a,
            emissiveIntensity: 0.1
          });
          const bark = new THREE.Mesh(barkGeo, barkMat);
          bark.position.set(0.52 + layer * 0.06, 1.0, 0);
          group.add(bark);
        }

        // Thick intertwined vines with organic weave
        for (let i = 0; i < 14; i++) {
          const vineThickness = 0.07 + Math.random() * 0.05;
          const vineGeo = new THREE.CylinderGeometry(vineThickness, vineThickness + 0.03, 0.8 + Math.random() * 0.4, 10);
          const vineMat = new THREE.MeshPhongMaterial({
            color: i % 3 === 0 ? 0x2a8b2a : i % 3 === 1 ? 0x3d7a26 : 0x4d9b3d,
            shininess: 45,
            specular: 0x336633,
            emissive: 0x1a4a1a,
            emissiveIntensity: 0.15
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.rotation.z = Math.PI / 2;
          vine.position.set(0.6 + Math.sin(i * 0.7) * 0.1, 0.2 + i * 0.14, (i % 3 - 1) * 0.2);
          vine.rotation.y = Math.sin(i) * 0.4;
          group.add(vine);
        }

        // HUGE powerful avocado fist (the slammer)
        const fistGeo = new THREE.SphereGeometry(0.6, 24, 24);
        fistGeo.scale(1.4, 1.2, 1.0);
        const fistMat = new THREE.MeshPhongMaterial({
          color: 0x5a9050,
          shininess: 110,
          specular: 0xaacc88,
          emissive: 0x2a5020,
          emissiveIntensity: 0.4
        });
        const fist = new THREE.Mesh(fistGeo, fistMat);
        fist.position.set(1.0, 1.3, 0);
        group.add(fist);

        // Avocado skin texture bumps
        for (let b = 0; b < 12; b++) {
          const bumpGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const bumpMat = new THREE.MeshPhongMaterial({
            color: 0x4a7a40,
            shininess: 50,
            emissive: 0x2a4a20,
            emissiveIntensity: 0.2
          });
          const bump = new THREE.Mesh(bumpGeo, bumpMat);
          const angle = (b / 12) * Math.PI * 2;
          bump.position.set(
            1.0 + Math.cos(angle) * 0.45,
            1.3 + Math.sin(b * 2) * 0.2,
            Math.sin(angle) * 0.4
          );
          group.add(bump);
        }

        // Glowing inner pit (power source)
        const pitGeo = new THREE.SphereGeometry(0.25, 16, 16);
        const pitMat = new THREE.MeshPhongMaterial({
          color: 0x9a7053,
          shininess: 100,
          emissive: 0x6a4030,
          emissiveIntensity: 0.6
        });
        const pit = new THREE.Mesh(pitGeo, pitMat);
        pit.position.set(1.0, 1.3, 0.38);
        group.add(pit);

        // Pit glow
        const pitGlowGeo = new THREE.SphereGeometry(0.35, 12, 12);
        const pitGlowMat = new THREE.MeshBasicMaterial({
          color: 0xffaa66,
          transparent: true,
          opacity: 0.25
        });
        const pitGlow = new THREE.Mesh(pitGlowGeo, pitGlowMat);
        pitGlow.position.set(1.0, 1.3, 0.38);
        group.add(pitGlow);

        // Muscular arm connecting fist to wall
        const armGeo = new THREE.CylinderGeometry(0.2, 0.28, 0.7, 14);
        const armMat = new THREE.MeshPhongMaterial({
          color: 0x4d8040,
          shininess: 60,
          specular: 0x557755,
          emissive: 0x2a4020,
          emissiveIntensity: 0.2
        });
        const arm = new THREE.Mesh(armGeo, armMat);
        arm.rotation.z = Math.PI / 2;
        arm.position.set(0.5, 1.3, 0);
        group.add(arm);

        // Arm muscle bulges
        for (let m = 0; m < 2; m++) {
          const muscleGeo = new THREE.SphereGeometry(0.15, 10, 10);
          muscleGeo.scale(1.6, 0.9, 0.9);
          const muscleMat = new THREE.MeshPhongMaterial({
            color: 0x5a9048,
            shininess: 50,
            emissive: 0x2a4020,
            emissiveIntensity: 0.15
          });
          const muscle = new THREE.Mesh(muscleGeo, muscleMat);
          muscle.position.set(0.55, 1.35, m === 0 ? 0.12 : -0.12);
          group.add(muscle);
        }

        // Lush leaves sprouting from wall
        for (let i = 0; i < 10; i++) {
          const leafGeo = new THREE.SphereGeometry(0.18, 10, 8);
          leafGeo.scale(2.0, 0.25, 1.4);
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x5aba4a : 0x4aaa3a,
            shininess: 65,
            specular: 0x448844,
            emissive: 0x2a5a2a,
            emissiveIntensity: 0.15,
            side: THREE.DoubleSide
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const angle = (i / 10) * Math.PI * 2;
          leaf.position.set(-0.35 + Math.cos(i) * 0.18, 0.35 + i * 0.18, Math.sin(angle) * 0.3);
          leaf.rotation.set(Math.cos(angle) * 0.6, angle, Math.sin(angle) * 0.4);
          group.add(leaf);
        }

        // Thorns for defense
        for (let i = 0; i < 8; i++) {
          const thornGeo = new THREE.ConeGeometry(0.08, 0.35, 6);
          const thornMat = new THREE.MeshPhongMaterial({
            color: 0x7a5030,
            shininess: 80,
            emissive: 0x3a2010,
            emissiveIntensity: 0.2
          });
          const thorn = new THREE.Mesh(thornGeo, thornMat);
          thorn.position.set(0.65, 0.3 + i * 0.22, ((i % 3) - 1) * 0.25);
          thorn.rotation.z = -Math.PI / 2;
          group.add(thorn);
        }

        // POWER aura around fist
        const auraGeo = new THREE.SphereGeometry(0.75, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x88ff88,
          transparent: true,
          opacity: 0.2
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.set(1.0, 1.3, 0);
        group.add(aura);

        // Extra impact particles
        for (let p = 0; p < 5; p++) {
          const particleGeo = new THREE.OctahedronGeometry(0.06, 0);
          const particleMat = new THREE.MeshBasicMaterial({
            color: 0xaaffaa,
            transparent: true,
            opacity: 0.6
          });
          const particle = new THREE.Mesh(particleGeo, particleMat);
          const angle = (p / 5) * Math.PI * 2;
          particle.position.set(
            1.0 + Math.cos(angle) * 0.6,
            1.3 + Math.sin(p) * 0.3,
            Math.sin(angle) * 0.5
          );
          group.add(particle);
        }

        break;
      }

      case 'grape-spiker': {
        // Fusion: Grape Launcher + Tomato Spike - MASSIVE Grape cluster with deadly spike

        // Large ornate terracotta pot with decorative rim
        const potGeo = new THREE.CylinderGeometry(0.5, 0.4, 0.45, 16);
        const potMat = new THREE.MeshPhongMaterial({
          color: 0xb06535,
          shininess: 55,
          specular: 0x555544,
          emissive: 0x3a2010,
          emissiveIntensity: 0.15
        });
        const pot = new THREE.Mesh(potGeo, potMat);
        pot.position.y = 0.225;
        group.add(pot);

        // Decorative pot bands
        for (let b = 0; b < 2; b++) {
          const bandGeo = new THREE.TorusGeometry(0.48 - b * 0.05, 0.025, 8, 20);
          const bandMat = new THREE.MeshPhongMaterial({
            color: 0xdaa520,
            shininess: 120,
            emissive: 0x886600,
            emissiveIntensity: 0.3
          });
          const band = new THREE.Mesh(bandGeo, bandMat);
          band.position.y = 0.15 + b * 0.15;
          band.rotation.x = Math.PI / 2;
          group.add(band);
        }

        // Pot rim detail
        const rimGeo = new THREE.TorusGeometry(0.5, 0.06, 10, 20);
        const rimMat = new THREE.MeshPhongMaterial({
          color: 0x9b5523,
          shininess: 70,
          emissive: 0x4a2010,
          emissiveIntensity: 0.2
        });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.position.y = 0.45;
        rim.rotation.x = Math.PI / 2;
        group.add(rim);

        // Rich soil
        const soilGeo = new THREE.CylinderGeometry(0.45, 0.45, 0.1, 16);
        const soilMat = new THREE.MeshPhongMaterial({ color: 0x4d3827, shininess: 8 });
        const soil = new THREE.Mesh(soilGeo, soilMat);
        soil.position.y = 0.42;
        group.add(soil);

        // Thick stem with texture
        const stemGeo = new THREE.CylinderGeometry(0.14, 0.2, 0.7, 12);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x457e30,
          shininess: 40,
          specular: 0x336633,
          emissive: 0x1a3a10,
          emissiveIntensity: 0.15
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.75;
        group.add(stem);

        // Stem rings
        for (let sr = 0; sr < 3; sr++) {
          const stemRingGeo = new THREE.TorusGeometry(0.17 - sr * 0.02, 0.02, 6, 12);
          const stemRingMat = new THREE.MeshPhongMaterial({ color: 0x3a6a28, shininess: 30 });
          const stemRing = new THREE.Mesh(stemRingGeo, stemRingMat);
          stemRing.position.y = 0.55 + sr * 0.2;
          stemRing.rotation.x = Math.PI / 2;
          group.add(stemRing);
        }

        // HUGE plump grape cluster
        const grapePositions = [
          { pos: [0, 1.1, 0], size: 0.28 },
          { pos: [-0.25, 0.9, 0.12], size: 0.25 },
          { pos: [0.25, 0.9, -0.12], size: 0.25 },
          { pos: [-0.15, 1.3, 0.1], size: 0.22 },
          { pos: [0.18, 1.25, -0.08], size: 0.23 },
          { pos: [0, 1.45, 0.06], size: 0.2 },
          { pos: [-0.18, 1.05, -0.12], size: 0.21 },
          { pos: [0.15, 1.0, 0.15], size: 0.22 },
          { pos: [0.08, 0.85, -0.18], size: 0.19 },
          { pos: [-0.08, 0.88, 0.2], size: 0.2 }
        ];

        grapePositions.forEach(({ pos, size }) => {
          const grapeGeo = new THREE.SphereGeometry(size, 20, 20);
          const grapeMat = new THREE.MeshPhongMaterial({
            color: 0x8b4fae,
            shininess: 140,
            specular: 0xdd99ff,
            emissive: 0x4d2a5f,
            emissiveIntensity: 0.35
          });
          const grape = new THREE.Mesh(grapeGeo, grapeMat);
          grape.position.set(pos[0], pos[1], pos[2]);
          group.add(grape);

          // Highlight reflection
          const highlightGeo = new THREE.SphereGeometry(size * 0.35, 8, 8);
          const highlightMat = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.5
          });
          const highlight = new THREE.Mesh(highlightGeo, highlightMat);
          highlight.position.set(pos[0] - size * 0.3, pos[1] + size * 0.3, pos[2] + size * 0.3);
          group.add(highlight);
        });

        // MASSIVE deadly crimson spike emerging from center
        const spikeGeo = new THREE.ConeGeometry(0.2, 1.1, 12);
        const spikeMat = new THREE.MeshPhongMaterial({
          color: 0xee4433,
          shininess: 170,
          specular: 0xff8866,
          emissive: 0x992211,
          emissiveIntensity: 0.45
        });
        const spike = new THREE.Mesh(spikeGeo, spikeMat);
        spike.position.y = 1.9;
        group.add(spike);

        // Spike inner core glow
        const spikeInnerGeo = new THREE.ConeGeometry(0.1, 0.9, 8);
        const spikeInnerMat = new THREE.MeshBasicMaterial({
          color: 0xff6644,
          transparent: true,
          opacity: 0.5
        });
        const spikeInner = new THREE.Mesh(spikeInnerGeo, spikeInnerMat);
        spikeInner.position.y = 1.85;
        group.add(spikeInner);

        // Spike tip glow
        const tipGeo = new THREE.ConeGeometry(0.06, 0.2, 8);
        const tipMat = new THREE.MeshBasicMaterial({
          color: 0xffaa88,
          transparent: true,
          opacity: 0.9
        });
        const tip = new THREE.Mesh(tipGeo, tipMat);
        tip.position.y = 2.4;
        group.add(tip);

        // Multiple spike rings for detail
        for (let r = 0; r < 4; r++) {
          const ringGeo = new THREE.TorusGeometry(0.16 - r * 0.035, 0.03, 8, 16);
          const ringMat = new THREE.MeshPhongMaterial({
            color: 0xcc3322,
            shininess: 100,
            emissive: 0x661100,
            emissiveIntensity: 0.3
          });
          const ring = new THREE.Mesh(ringGeo, ringMat);
          ring.position.y = 1.4 + r * 0.15;
          ring.rotation.x = Math.PI / 2;
          group.add(ring);
        }

        // Danger aura
        const auraGeo = new THREE.SphereGeometry(0.8, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xff4422,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 1.2;
        group.add(aura);

        // Danger particles
        for (let dp = 0; dp < 6; dp++) {
          const dPartGeo = new THREE.OctahedronGeometry(0.04, 0);
          const dPartMat = new THREE.MeshBasicMaterial({
            color: 0xff6644,
            transparent: true,
            opacity: 0.7
          });
          const dPart = new THREE.Mesh(dPartGeo, dPartMat);
          const angle = (dp / 6) * Math.PI * 2;
          dPart.position.set(
            Math.cos(angle) * 0.5,
            1.8 + Math.sin(dp * 2) * 0.3,
            Math.sin(angle) * 0.5
          );
          group.add(dPart);
        }

        // Lush leaves
        for (let i = 0; i < 6; i++) {
          const leafGeo = new THREE.SphereGeometry(0.14, 8, 8);
          leafGeo.scale(1.8, 0.25, 1.2);
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x5a9c38 : 0x4a8c28,
            shininess: 60,
            emissive: 0x2a4a18,
            emissiveIntensity: 0.15,
            side: THREE.DoubleSide
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const angle = (i / 6) * Math.PI * 2;
          leaf.position.set(Math.cos(angle) * 0.35, 0.75, Math.sin(angle) * 0.35);
          leaf.rotation.y = angle;
          leaf.rotation.z = -0.6;
          group.add(leaf);
        }

        break;
      }

      case 'grape-gun-wall': {
        // Fusion: Grape Gun + Vine Wall - Fortified defensive shooter

        // Ground base
        {
        const ggBase = new THREE.Mesh(
          new THREE.CylinderGeometry(0.55, 0.65, 0.15, 14),
          new THREE.MeshPhongMaterial({ color: 0x1a4a1a, shininess: 30, emissive: 0x0a2a0a, emissiveIntensity: 0.15 })
        );
        ggBase.position.y = 0.07;
        group.add(ggBase);
        }

        // Main fortified wall
        const wallGeo = new THREE.BoxGeometry(0.85, 2.3, 0.65);
        const wallMat = new THREE.MeshPhongMaterial({
          color: 0x2a6b2a,
          shininess: 25,
          specular: 0x1a4a1a,
          emissive: 0x0a2a0a,
          emissiveIntensity: 0.15
        });
        const wall = new THREE.Mesh(wallGeo, wallMat);
        wall.position.y = 1.3;
        group.add(wall);

        // Crenellation at top
        for (let c = 0; c < 3; c++) {
          const crenGeo = new THREE.BoxGeometry(0.2, 0.15, 0.15);
          const crenMat = new THREE.MeshPhongMaterial({ color: 0x2a5a2a, shininess: 30 });
          const cren = new THREE.Mesh(crenGeo, crenMat);
          cren.position.set(0, 2.52, -0.22 + c * 0.22);
          group.add(cren);
        }

        // Bark texture on back
        for (let layer = 0; layer < 3; layer++) {
          const barkGeo = new THREE.BoxGeometry(0.07, 2.3, 0.6 - layer * 0.1);
          const barkMat = new THREE.MeshPhongMaterial({
            color: layer === 0 ? 0x1a4a1a : layer === 1 ? 0x2a5a2a : 0x1f501f, shininess: 15
          });
          const bark = new THREE.Mesh(barkGeo, barkMat);
          bark.position.set(-0.44 + layer * 0.04, 1.3, 0);
          group.add(bark);
        }

        // Vines on surface
        for (let i = 0; i < 7; i++) {
          const vineGeo = new THREE.CylinderGeometry(0.04, 0.05, 2.3, 8);
          const vineMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x3d7a3d : 0x2d6a2d, shininess: 35
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(-0.35, 1.3, -0.25 + i * 0.08);
          vine.rotation.z = Math.sin(i) * 0.1;
          group.add(vine);
        }

        // Triple grape gun barrels - redistributed vertically
        for (let i = 0; i < 3; i++) {
          const yPos = 0.6 + i * 0.55;
          // Mount
          const mountGeo = new THREE.CylinderGeometry(0.15, 0.18, 0.15, 10);
          const mountMat = new THREE.MeshPhongMaterial({ color: 0x5a3090, shininess: 80 });
          const mount = new THREE.Mesh(mountGeo, mountMat);
          mount.rotation.z = Math.PI / 2;
          mount.position.set(0.35, yPos, (i - 1) * 0.14);
          group.add(mount);
          // Brace
          const braceGeo = new THREE.BoxGeometry(0.08, 0.06, 0.06);
          const braceMat = new THREE.MeshPhongMaterial({ color: 0x444444, shininess: 70 });
          const brace = new THREE.Mesh(braceGeo, braceMat);
          brace.position.set(0.3, yPos, (i - 1) * 0.14);
          group.add(brace);
          // Barrel - longer
          const barrelGeo = new THREE.CylinderGeometry(0.1, 0.14, 0.65, 12);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x7b3f9e, shininess: 120, specular: 0xaa66cc,
            emissive: 0x3d1f4f, emissiveIntensity: 0.25
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.rotation.z = Math.PI / 2;
          barrel.position.set(0.6, yPos, (i - 1) * 0.14);
          group.add(barrel);
          // Tip glow ring
          const tipGeo = new THREE.TorusGeometry(0.08, 0.025, 6, 12);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0x9955cc, shininess: 150, emissive: 0x6633aa, emissiveIntensity: 0.5
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.rotation.y = Math.PI / 2;
          tip.position.set(0.9, yPos, (i - 1) * 0.14);
          group.add(tip);
          // Loaded grape
          const grapeGeo = new THREE.SphereGeometry(0.07, 10, 10);
          const grapeMat = new THREE.MeshPhongMaterial({
            color: 0x8844bb, shininess: 130, emissive: 0x4422aa, emissiveIntensity: 0.6
          });
          const grape = new THREE.Mesh(grapeGeo, grapeMat);
          grape.position.set(0.88, yPos, (i - 1) * 0.14);
          group.add(grape);
        }

        // Ammo rack on side
        for (let a = 0; a < 3; a++) {
          const ammoGeo = new THREE.SphereGeometry(0.06, 8, 8);
          const ammoMat = new THREE.MeshPhongMaterial({
            color: 0x7733aa, shininess: 100, emissive: 0x3322aa, emissiveIntensity: 0.3
          });
          const ammo = new THREE.Mesh(ammoGeo, ammoMat);
          ammo.position.set(0.2, 0.5 + a * 0.5, 0.3);
          group.add(ammo);
        }

        // Targeting reticle
        {
        const retGeo = new THREE.RingGeometry(0.12, 0.15, 12);
        const retMat = new THREE.MeshBasicMaterial({
          color: 0xaa66ff, transparent: true, opacity: 0.4, side: THREE.DoubleSide
        });
        const ret = new THREE.Mesh(retGeo, retMat);
        ret.position.set(0.44, 1.4, 0);
        ret.rotation.y = Math.PI / 2;
        group.add(ret);
        }

        // Defensive thorns on back
        for (let i = 0; i < 5; i++) {
          const thornGeo = new THREE.ConeGeometry(0.06, 0.28, 5);
          const thornMat = new THREE.MeshPhongMaterial({ color: 0x5a4020, shininess: 65 });
          const thorn = new THREE.Mesh(thornGeo, thornMat);
          thorn.position.set(-0.5, 0.35 + i * 0.42, 0);
          thorn.rotation.z = Math.PI / 2;
          group.add(thorn);
        }

        // Leaves
        for (let i = 0; i < 7; i++) {
          const leafGeo = new THREE.SphereGeometry(0.12, 6, 6);
          leafGeo.scale(1.5, 0.15, 1);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x4a8a2a, shininess: 50, side: THREE.DoubleSide
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.position.set(-0.4, 0.3 + i * 0.28, Math.sin(i) * 0.22);
          leaf.rotation.set(Math.random() * 0.5, Math.random() * Math.PI, -0.4);
          group.add(leaf);
        }

        // Metal reinforcement bands
        for (let b = 0; b < 2; b++) {
          const bandGeo = new THREE.BoxGeometry(0.06, 0.05, 0.68);
          const bandMat = new THREE.MeshPhongMaterial({ color: 0x555555, shininess: 90, specular: 0xaaaaaa });
          const band = new THREE.Mesh(bandGeo, bandMat);
          band.position.set(-0.38, 0.7 + b * 1.2, 0);
          group.add(band);
        }

        // Purple aura
        {
        const auraGeo = new THREE.SphereGeometry(1.0, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x9955cc, transparent: true, opacity: 0.1
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 1.3;
        group.add(aura);
        }

        break;
      }

      case 'lily-gun': {
        // Fusion: Grape Lily + Grape Shot - Sun-producing gun

        // Elegant lily pad with ripple texture
        const padGeo = new THREE.CylinderGeometry(0.65, 0.75, 0.12, 20);
        const padMat = new THREE.MeshPhongMaterial({
          color: 0x2d8a4e,
          shininess: 70,
          specular: 0x44aa66
        });
        const pad = new THREE.Mesh(padGeo, padMat);
        pad.position.y = 0.06;
        group.add(pad);

        // Concentric ripple rings on pad
        for (let r = 0; r < 3; r++) {
          const rippleGeo = new THREE.TorusGeometry(0.25 + r * 0.15, 0.015, 6, 24);
          const rippleMat = new THREE.MeshPhongMaterial({
            color: 0x3a9a5e,
            shininess: 60
          });
          const ripple = new THREE.Mesh(rippleGeo, rippleMat);
          ripple.position.y = 0.13;
          ripple.rotation.x = Math.PI / 2;
          group.add(ripple);
        }

        // Central stem
        const stemGeo = new THREE.CylinderGeometry(0.08, 0.1, 0.4, 10);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x3a7a48,
          shininess: 40
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.35;
        group.add(stem);

        // Beautiful golden lily flower with petals
        for (let i = 0; i < 8; i++) {
          const petalGeo = new THREE.SphereGeometry(0.18, 10, 10);
          petalGeo.scale(1, 0.3, 0.6);
          const petalMat = new THREE.MeshPhongMaterial({
            color: 0xffdd44,
            shininess: 140,
            specular: 0xffffaa,
            emissive: 0xffaa22,
            emissiveIntensity: 0.35
          });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          const angle = (i / 8) * Math.PI * 2;
          petal.position.set(
            Math.cos(angle) * 0.2,
            0.65,
            Math.sin(angle) * 0.2
          );
          petal.rotation.y = angle;
          petal.rotation.z = 0.6;
          group.add(petal);
        }

        // Glowing golden center
        const centerGeo = new THREE.SphereGeometry(0.15, 14, 14);
        const centerMat = new THREE.MeshPhongMaterial({
          color: 0xffee66,
          shininess: 180,
          emissive: 0xffcc22,
          emissiveIntensity: 0.6
        });
        const center = new THREE.Mesh(centerGeo, centerMat);
        center.position.y = 0.7;
        group.add(center);

        // Triple grape gun barrels with golden accents
        for (let i = 0; i < 3; i++) {
          // Barrel housing
          const housingGeo = new THREE.CylinderGeometry(0.12, 0.14, 0.12, 10);
          const housingMat = new THREE.MeshPhongMaterial({
            color: 0xdda020,
            shininess: 100
          });
          const housing = new THREE.Mesh(housingGeo, housingMat);
          housing.rotation.z = Math.PI / 2;
          housing.position.set(0.35, 0.55 + (i - 1) * 0.18, (i - 1) * 0.12);
          group.add(housing);

          // Main barrel
          const barrelGeo = new THREE.CylinderGeometry(0.08, 0.1, 0.45, 12);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x7b3f9e,
            shininess: 130,
            specular: 0xaa77cc,
            emissive: 0x3d1f4f,
            emissiveIntensity: 0.25
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.rotation.z = Math.PI / 2;
          barrel.position.set(0.55, 0.55 + (i - 1) * 0.18, (i - 1) * 0.12);
          group.add(barrel);

          // Golden sun grape at barrel tip
          const sunGrapeGeo = new THREE.SphereGeometry(0.06, 10, 10);
          const sunGrapeMat = new THREE.MeshPhongMaterial({
            color: 0xffdd44,
            shininess: 150,
            emissive: 0xffaa00,
            emissiveIntensity: 0.6
          });
          const sunGrape = new THREE.Mesh(sunGrapeGeo, sunGrapeMat);
          sunGrape.position.set(0.75, 0.55 + (i - 1) * 0.18, (i - 1) * 0.12);
          group.add(sunGrape);
        }

        // Floating sparkles
        for (let i = 0; i < 6; i++) {
          const sparkleGeo = new THREE.OctahedronGeometry(0.04, 0);
          const sparkleMat = new THREE.MeshBasicMaterial({
            color: 0xffff88,
            transparent: true,
            opacity: 0.7
          });
          const sparkle = new THREE.Mesh(sparkleGeo, sparkleMat);
          const angle = (i / 6) * Math.PI * 2;
          sparkle.position.set(
            Math.cos(angle) * 0.45,
            0.5 + Math.sin(i * 2) * 0.2,
            Math.sin(angle) * 0.45
          );
          group.add(sparkle);
        }

        // Sun aura
        const auraGeo = new THREE.SphereGeometry(0.6, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xffdd44,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.65;
        group.add(aura);

        break;
      }

      case 'pickle-spear': {
        // Fusion: Pickle Spiker + Pear Cannon - Massive damage with knockback

        // Wooden cannon platform base
        const platformGeo = new THREE.CylinderGeometry(0.55, 0.65, 0.25, 16);
        const platformMat = new THREE.MeshPhongMaterial({
          color: 0x6b4423,
          shininess: 30,
          specular: 0x443322
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.125;
        group.add(platform);

        // Platform rim detail
        const rimGeo = new THREE.TorusGeometry(0.55, 0.04, 8, 20);
        const rimMat = new THREE.MeshPhongMaterial({
          color: 0xdaa520,
          shininess: 100
        });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.position.y = 0.25;
        rim.rotation.x = Math.PI / 2;
        group.add(rim);

        // Main pickle body (the launcher)
        const pickleGeo = new THREE.CapsuleGeometry(0.25, 0.5, 8, 14);
        const pickleMat = new THREE.MeshPhongMaterial({
          color: 0x556b2f,
          shininess: 90,
          specular: 0x88aa66,
          emissive: 0x2a3510,
          emissiveIntensity: 0.15
        });
        const pickle = new THREE.Mesh(pickleGeo, pickleMat);
        pickle.position.y = 0.6;
        group.add(pickle);

        // Pickle bumps/warts
        for (let i = 0; i < 10; i++) {
          const bumpGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const bumpMat = new THREE.MeshPhongMaterial({
            color: 0x4a5a25,
            shininess: 60
          });
          const bump = new THREE.Mesh(bumpGeo, bumpMat);
          const angle = (i / 5) * Math.PI;
          const yPos = 0.4 + (i % 5) * 0.1;
          bump.position.set(
            Math.cos(angle + i * 0.5) * 0.22,
            yPos,
            Math.sin(angle + i * 0.5) * 0.22
          );
          group.add(bump);
        }

        // Massive deadly spear
        const spearShaftGeo = new THREE.CylinderGeometry(0.06, 0.08, 1.1, 10);
        const spearShaftMat = new THREE.MeshPhongMaterial({
          color: 0x3d5a1e,
          shininess: 80,
          specular: 0x557744
        });
        const spearShaft = new THREE.Mesh(spearShaftGeo, spearShaftMat);
        spearShaft.rotation.z = -Math.PI / 4;
        spearShaft.position.set(0.4, 1.1, 0);
        group.add(spearShaft);

        // Deadly spear tip with metallic sheen
        const spearTipGeo = new THREE.ConeGeometry(0.12, 0.4, 8);
        const spearTipMat = new THREE.MeshPhongMaterial({
          color: 0x708090,
          shininess: 180,
          specular: 0xcccccc,
          emissive: 0x404040,
          emissiveIntensity: 0.2
        });
        const spearTip = new THREE.Mesh(spearTipGeo, spearTipMat);
        spearTip.rotation.z = -Math.PI / 4;
        spearTip.position.set(0.75, 1.45, 0);
        group.add(spearTip);

        // Spear blade edges
        for (let s = 0; s < 2; s++) {
          const edgeGeo = new THREE.BoxGeometry(0.02, 0.25, 0.08);
          const edgeMat = new THREE.MeshPhongMaterial({
            color: 0x888888,
            shininess: 200
          });
          const edge = new THREE.Mesh(edgeGeo, edgeMat);
          edge.rotation.z = -Math.PI / 4;
          edge.position.set(0.68, 1.38, (s - 0.5) * 0.1);
          group.add(edge);
        }

        // Brine drip effect
        for (let d = 0; d < 3; d++) {
          const dripGeo = new THREE.SphereGeometry(0.03, 6, 6);
          dripGeo.scale(1, 1.5, 1);
          const dripMat = new THREE.MeshPhongMaterial({
            color: 0x8fbc8f,
            shininess: 120,
            transparent: true,
            opacity: 0.7
          });
          const drip = new THREE.Mesh(dripGeo, dripMat);
          drip.position.set(
            Math.cos(d * 2) * 0.2,
            0.35 - d * 0.08,
            Math.sin(d * 2) * 0.2
          );
          group.add(drip);
        }

        // Power lines along spear
        const lineGeo = new THREE.CylinderGeometry(0.015, 0.015, 0.9, 6);
        const lineMat = new THREE.MeshPhongMaterial({
          color: 0x88aa44,
          shininess: 100,
          emissive: 0x446622,
          emissiveIntensity: 0.3
        });
        const line = new THREE.Mesh(lineGeo, lineMat);
        line.rotation.z = -Math.PI / 4;
        line.position.set(0.35, 1.05, 0.08);
        group.add(line);

        // Green power aura
        const auraGeo = new THREE.SphereGeometry(0.65, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x88ff44,
          transparent: true,
          opacity: 0.1
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.7;
        group.add(aura);

        break;
      }

      case 'frost-spiker': {
        // EPIC Frost Spiker - Triple ice spike crown (like grape-gun style)

        // Heavy purple crystal platform
        const platformGeo = new THREE.CylinderGeometry(0.75, 0.85, 0.18, 6);
        const platformMat = new THREE.MeshPhongMaterial({
          color: 0x4a3060,
          shininess: 70,
          specular: 0x8866aa,
          emissive: 0x251830,
          emissiveIntensity: 0.15
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.09;
        group.add(platform);

        // Glowing purple energy channels
        for (let i = 0; i < 6; i++) {
          const channelGeo = new THREE.BoxGeometry(0.06, 0.05, 0.35);
          const channelMat = new THREE.MeshPhongMaterial({
            color: 0xaa66ff,
            emissive: 0x8844dd,
            emissiveIntensity: 0.9,
            shininess: 100
          });
          const channel = new THREE.Mesh(channelGeo, channelMat);
          const angle = (i / 6) * Math.PI * 2;
          channel.position.set(Math.cos(angle) * 0.55, 0.12, Math.sin(angle) * 0.55);
          channel.rotation.y = angle;
          group.add(channel);
        }

        // Silver-purple ring trim
        const innerRingGeo = new THREE.TorusGeometry(0.55, 0.06, 8, 20);
        const innerRingMat = new THREE.MeshPhongMaterial({
          color: 0xccbbdd,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0x8866aa,
          emissiveIntensity: 0.3
        });
        const innerRing = new THREE.Mesh(innerRingGeo, innerRingMat);
        innerRing.position.y = 0.15;
        innerRing.rotation.x = Math.PI / 2;
        group.add(innerRing);

        // THREE ice pots with berries and spike crowns
        for (let i = 0; i < 3; i++) {
          const zOffset = (i - 1) * 0.55;

          // Purple ice pot
          const potGeo = new THREE.CylinderGeometry(0.22, 0.18, 0.28, 16);
          const potMat = new THREE.MeshPhongMaterial({
            color: 0x5544aa,
            shininess: 60,
            specular: 0x8877cc,
            emissive: 0x332266,
            emissiveIntensity: 0.1
          });
          const pot = new THREE.Mesh(potGeo, potMat);
          pot.position.set(0, 0.32, zOffset);
          group.add(pot);

          // Silver rim
          const rimGeo = new THREE.TorusGeometry(0.22, 0.035, 8, 16);
          const rimMat = new THREE.MeshPhongMaterial({
            color: 0xccbbdd,
            shininess: 150,
            specular: 0xffffff,
            emissive: 0x8866aa,
            emissiveIntensity: 0.4
          });
          const rim = new THREE.Mesh(rimGeo, rimMat);
          rim.position.set(0, 0.46, zOffset);
          rim.rotation.x = Math.PI / 2;
          group.add(rim);

          // Ice crystal emblems on pot
          for (let e = 0; e < 3; e++) {
            const emblemGeo = new THREE.OctahedronGeometry(0.05, 0);
            const emblemMat = new THREE.MeshPhongMaterial({
              color: 0xaa66ff,
              emissive: 0x8844dd,
              emissiveIntensity: 0.5,
              shininess: 100
            });
            const emblem = new THREE.Mesh(emblemGeo, emblemMat);
            emblem.position.set(0.2, 0.28 + e * 0.08, zOffset);
            emblem.scale.set(0.8 - e * 0.15, 0.8 - e * 0.15, 0.5);
            group.add(emblem);
          }

          // Ice vine wrapping pot
          const vineGeo = new THREE.TorusGeometry(0.24, 0.02, 6, 16);
          const vineMat = new THREE.MeshPhongMaterial({
            color: 0x77aacc,
            shininess: 40
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(0, 0.35, zOffset);
          vine.rotation.x = Math.PI / 2;
          vine.rotation.z = i * 0.5;
          group.add(vine);

          // FROZEN BERRY
          const clusterGeo = new THREE.SphereGeometry(0.2, 16, 16);
          const clusterMat = new THREE.MeshPhongMaterial({
            color: 0xff5577,
            shininess: 100,
            emissive: 0xaa3355,
            emissiveIntensity: 0.4
          });
          const cluster = new THREE.Mesh(clusterGeo, clusterMat);
          cluster.position.set(0, 0.68, zOffset);
          group.add(cluster);

          // Frost coating
          const frostGeo = new THREE.SphereGeometry(0.22, 16, 16);
          const frostMat = new THREE.MeshPhongMaterial({
            color: 0x99ddff,
            shininess: 200,
            transparent: true,
            opacity: 0.35
          });
          const frost = new THREE.Mesh(frostGeo, frostMat);
          frost.position.set(0, 0.68, zOffset);
          group.add(frost);

          // Icy seeds around berry
          for (let j = 0; j < 6; j++) {
            const seedGeo = new THREE.SphereGeometry(0.05, 12, 12);
            const seedMat = new THREE.MeshPhongMaterial({
              color: 0x66eeff,
              shininess: 120,
              specular: 0xaaffff,
              emissive: 0x44ccff,
              emissiveIntensity: 0.35
            });
            const seed = new THREE.Mesh(seedGeo, seedMat);
            const angle = (j / 6) * Math.PI * 2;
            seed.position.set(
              Math.cos(angle) * 0.18,
              0.58,
              zOffset + Math.sin(angle) * 0.18
            );
            group.add(seed);

            // Highlight
            const highlightGeo = new THREE.SphereGeometry(0.015, 8, 8);
            const highlightMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.8 });
            const highlight = new THREE.Mesh(highlightGeo, highlightMat);
            highlight.position.set(
              Math.cos(angle) * 0.18 + 0.02,
              0.61,
              zOffset + Math.sin(angle) * 0.18 + 0.02
            );
            group.add(highlight);
          }

          // Glowing core
          const coreGeo = new THREE.SphereGeometry(0.1, 12, 12);
          const coreMat = new THREE.MeshBasicMaterial({ color: 0xaaffff, transparent: true, opacity: 0.6 });
          const core = new THREE.Mesh(coreGeo, coreMat);
          core.position.set(0, 0.68, zOffset);
          group.add(core);

          // ICE SPIKE CROWN on each berry
          // Central spike
          const mainSpikeGeo = new THREE.ConeGeometry(0.1, 0.5, 6);
          const spikeMat = new THREE.MeshPhongMaterial({
            color: 0xaaeeff,
            shininess: 250,
            specular: 0xffffff,
            emissive: 0x66ddff,
            emissiveIntensity: 0.5
          });
          const mainSpike = new THREE.Mesh(mainSpikeGeo, spikeMat);
          mainSpike.position.set(0, 1.1, zOffset);
          group.add(mainSpike);

          // Spike glow
          const spikeGlowGeo = new THREE.ConeGeometry(0.06, 0.35, 6);
          const spikeGlowMat = new THREE.MeshBasicMaterial({ color: 0xaaffff, transparent: true, opacity: 0.5 });
          const spikeGlow = new THREE.Mesh(spikeGlowGeo, spikeGlowMat);
          spikeGlow.position.set(0, 1.05, zOffset);
          group.add(spikeGlow);

          // Ring of small spikes
          for (let s = 0; s < 4; s++) {
            const smallSpikeGeo = new THREE.ConeGeometry(0.05, 0.3, 5);
            const smallSpike = new THREE.Mesh(smallSpikeGeo, spikeMat);
            const angle = (s / 4) * Math.PI * 2;
            smallSpike.position.set(
              Math.cos(angle) * 0.15,
              0.95,
              zOffset + Math.sin(angle) * 0.15
            );
            smallSpike.rotation.z = -Math.cos(angle) * 0.25;
            smallSpike.rotation.x = Math.sin(angle) * 0.25;
            group.add(smallSpike);
          }

          // Leaf
          const leafGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x44ccaa,
            shininess: 50,
            emissive: 0x228866,
            emissiveIntensity: 0.2
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(1.5, 0.3, 1);
          leaf.position.set(0.12, 0.85, zOffset + 0.05);
          leaf.rotation.z = 0.3;
          group.add(leaf);
        }

        // Central energy hub
        const hubGeo = new THREE.SphereGeometry(0.14, 16, 16);
        const hubMat = new THREE.MeshPhongMaterial({
          color: 0xaa88ff,
          emissive: 0x8866dd,
          emissiveIntensity: 0.9,
          shininess: 150,
          transparent: true,
          opacity: 0.9
        });
        const hub = new THREE.Mesh(hubGeo, hubMat);
        hub.position.set(0, 0.82, 0);
        group.add(hub);

        // Hub glow
        const hubGlowGeo = new THREE.SphereGeometry(0.22, 12, 12);
        const hubGlowMat = new THREE.MeshBasicMaterial({ color: 0x8866dd, transparent: true, opacity: 0.35 });
        const hubGlow = new THREE.Mesh(hubGlowGeo, hubGlowMat);
        hubGlow.position.set(0, 0.82, 0);
        group.add(hubGlow);

        // Energy tubes connecting hub to berries
        for (let i = 0; i < 3; i++) {
          const zOffset = (i - 1) * 0.55;
          const tubeGeo = new THREE.CylinderGeometry(0.02, 0.02, 0.35, 8);
          const tubeMat = new THREE.MeshPhongMaterial({
            color: 0xaa88ff,
            emissive: 0x8866dd,
            emissiveIntensity: 0.7,
            shininess: 100
          });
          const tube = new THREE.Mesh(tubeGeo, tubeMat);
          tube.position.set(0, 0.75, zOffset * 0.5);
          tube.rotation.x = Math.PI / 2;
          if (i !== 1) tube.rotation.x += (i === 0 ? 0.15 : -0.15);
          group.add(tube);
        }

        break;
      }

      case 'banana-leach': {
        // Fusion: Banana Peel + Rose Reaper - Summons cursed zombie allies

        // Corrupted banana peel base - partially open
        const peelBaseGeo = new THREE.CapsuleGeometry(0.28, 0.55, 6, 10);
        const peelBaseMat = new THREE.MeshPhongMaterial({
          color: 0xccaa00,
          shininess: 90,
          specular: 0xffdd44,
          emissive: 0x442200,
          emissiveIntensity: 0.15
        });
        const peelBase = new THREE.Mesh(peelBaseGeo, peelBaseMat);
        peelBase.rotation.z = Math.PI / 6;
        peelBase.position.y = 0.45;
        group.add(peelBase);

        // Peel segments curling back
        for (let p = 0; p < 4; p++) {
          const segGeo = new THREE.SphereGeometry(0.2, 8, 8);
          segGeo.scale(0.4, 1, 0.8);
          const segMat = new THREE.MeshPhongMaterial({
            color: 0xddbb00,
            shininess: 80,
            side: THREE.DoubleSide
          });
          const seg = new THREE.Mesh(segGeo, segMat);
          const angle = (p / 4) * Math.PI * 2;
          seg.position.set(
            Math.cos(angle) * 0.25,
            0.35,
            Math.sin(angle) * 0.25
          );
          seg.rotation.set(0.8, angle, 0);
          group.add(seg);
        }

        // Dark spots (corruption marks)
        for (let d = 0; d < 6; d++) {
          const spotGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const spotMat = new THREE.MeshPhongMaterial({
            color: 0x3a2a0a,
            shininess: 30
          });
          const spot = new THREE.Mesh(spotGeo, spotMat);
          spot.position.set(
            (Math.random() - 0.5) * 0.4,
            0.3 + Math.random() * 0.3,
            (Math.random() - 0.5) * 0.4
          );
          group.add(spot);
        }

        // Dark reaper hood/cloak
        const hoodGeo = new THREE.ConeGeometry(0.35, 0.5, 10);
        const hoodMat = new THREE.MeshPhongMaterial({
          color: 0x1a0a1a,
          shininess: 15,
          emissive: 0x220022,
          emissiveIntensity: 0.3
        });
        const hood = new THREE.Mesh(hoodGeo, hoodMat);
        hood.position.y = 1.05;
        group.add(hood);

        // Hood opening with glowing eyes
        const faceGeo = new THREE.SphereGeometry(0.12, 8, 8);
        const faceMat = new THREE.MeshBasicMaterial({
          color: 0x000000
        });
        const face = new THREE.Mesh(faceGeo, faceMat);
        face.position.set(0, 0.9, 0.15);
        group.add(face);

        // Glowing green eyes
        for (let e = 0; e < 2; e++) {
          const eyeGeo = new THREE.SphereGeometry(0.035, 8, 8);
          const eyeMat = new THREE.MeshBasicMaterial({
            color: 0x00ff44,
            transparent: true,
            opacity: 0.9
          });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set((e - 0.5) * 0.08, 0.92, 0.22);
          group.add(eye);
        }

        // Spectral scythe
        const handleGeo = new THREE.CylinderGeometry(0.03, 0.035, 0.8, 8);
        const handleMat = new THREE.MeshPhongMaterial({
          color: 0x2a1a2a,
          shininess: 40
        });
        const handle = new THREE.Mesh(handleGeo, handleMat);
        handle.rotation.z = -Math.PI / 4;
        handle.position.set(0.35, 1.0, 0);
        group.add(handle);

        // Scythe blade
        const bladeGeo = new THREE.TorusGeometry(0.2, 0.02, 4, 12, Math.PI * 0.7);
        const bladeMat = new THREE.MeshPhongMaterial({
          color: 0x666688,
          shininess: 150,
          specular: 0xaaaacc
        });
        const blade = new THREE.Mesh(bladeGeo, bladeMat);
        blade.rotation.set(0, 0, -Math.PI / 2);
        blade.position.set(0.55, 1.35, 0);
        group.add(blade);

        // Necromantic aura
        const auraGeo = new THREE.SphereGeometry(0.65, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x22ff44,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.7;
        group.add(aura);

        // Dark energy particles
        for (let dp = 0; dp < 8; dp++) {
          const darkGeo = new THREE.OctahedronGeometry(0.04, 0);
          const darkMat = new THREE.MeshBasicMaterial({
            color: 0x44ff66,
            transparent: true,
            opacity: 0.6
          });
          const dark = new THREE.Mesh(darkGeo, darkMat);
          dark.position.set(
            (Math.random() - 0.5) * 0.9,
            0.3 + Math.random() * 0.9,
            (Math.random() - 0.5) * 0.9
          );
          group.add(dark);
        }

        break;
      }

      case 'lily-cannon': {
        // Fusion: Lily + Pear Cannon - Click to charge massive shots

        // Beautiful lily pad with veins
        const padGeo = new THREE.CylinderGeometry(0.6, 0.7, 0.12, 20);
        const padMat = new THREE.MeshPhongMaterial({
          color: 0x2d8a4e,
          shininess: 65,
          specular: 0x44aa66
        });
        const pad = new THREE.Mesh(padGeo, padMat);
        pad.position.y = 0.06;
        group.add(pad);

        // Pad vein patterns
        for (let v = 0; v < 8; v++) {
          const veinGeo = new THREE.BoxGeometry(0.02, 0.02, 0.5);
          const veinMat = new THREE.MeshPhongMaterial({
            color: 0x1a6a3e,
            shininess: 40
          });
          const vein = new THREE.Mesh(veinGeo, veinMat);
          const angle = (v / 8) * Math.PI * 2;
          vein.position.set(Math.cos(angle) * 0.25, 0.13, Math.sin(angle) * 0.25);
          vein.rotation.y = angle;
          group.add(vein);
        }

        // Water ripples
        for (let r = 0; r < 2; r++) {
          const rippleGeo = new THREE.TorusGeometry(0.4 + r * 0.2, 0.015, 6, 24);
          const rippleMat = new THREE.MeshPhongMaterial({
            color: 0x3a9a5e,
            shininess: 80,
            transparent: true,
            opacity: 0.6
          });
          const ripple = new THREE.Mesh(rippleGeo, rippleMat);
          ripple.position.y = 0.14;
          ripple.rotation.x = Math.PI / 2;
          group.add(ripple);
        }

        // Central stem
        const stemGeo = new THREE.CylinderGeometry(0.1, 0.12, 0.35, 10);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x3a7a48,
          shininess: 45
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.3;
        group.add(stem);

        // Lily flower petals around cannon
        for (let i = 0; i < 6; i++) {
          const petalGeo = new THREE.SphereGeometry(0.15, 10, 10);
          petalGeo.scale(1, 0.25, 0.5);
          const petalMat = new THREE.MeshPhongMaterial({
            color: 0xffaacc,
            shininess: 120,
            specular: 0xffffff,
            emissive: 0xff6699,
            emissiveIntensity: 0.15
          });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          const angle = (i / 6) * Math.PI * 2;
          petal.position.set(
            Math.cos(angle) * 0.15,
            0.5,
            Math.sin(angle) * 0.15
          );
          petal.rotation.y = angle;
          petal.rotation.z = 0.5;
          group.add(petal);
        }

        // Golden pear cannon barrel
        const cannonBaseGeo = new THREE.SphereGeometry(0.22, 14, 14);
        const cannonBaseMat = new THREE.MeshPhongMaterial({
          color: 0xc5e636,
          shininess: 110,
          specular: 0xffffaa,
          emissive: 0x4a6a10,
          emissiveIntensity: 0.15
        });
        const cannonBase = new THREE.Mesh(cannonBaseGeo, cannonBaseMat);
        cannonBase.position.set(0.15, 0.6, 0);
        group.add(cannonBase);

        // Cannon barrel
        const cannonGeo = new THREE.CylinderGeometry(0.18, 0.22, 0.7, 12);
        const cannonMat = new THREE.MeshPhongMaterial({
          color: 0xdaa520,
          shininess: 100,
          specular: 0xffdd88,
          emissive: 0x885500,
          emissiveIntensity: 0.15
        });
        const cannon = new THREE.Mesh(cannonGeo, cannonMat);
        cannon.rotation.z = -Math.PI / 4;
        cannon.position.set(0.45, 0.9, 0);
        group.add(cannon);

        // Cannon muzzle ring
        const muzzleGeo = new THREE.TorusGeometry(0.15, 0.04, 8, 16);
        const muzzleMat = new THREE.MeshPhongMaterial({
          color: 0xffd700,
          shininess: 150
        });
        const muzzle = new THREE.Mesh(muzzleGeo, muzzleMat);
        muzzle.rotation.x = Math.PI / 4;
        muzzle.position.set(0.7, 1.15, 0);
        group.add(muzzle);

        // Energy charge indicator
        const chargeGeo = new THREE.SphereGeometry(0.1, 10, 10);
        const chargeMat = new THREE.MeshBasicMaterial({
          color: 0xffff88,
          transparent: true,
          opacity: 0.7
        });
        const charge = new THREE.Mesh(chargeGeo, chargeMat);
        charge.position.set(0.75, 1.2, 0);
        group.add(charge);

        // Golden aura
        const auraGeo = new THREE.SphereGeometry(0.7, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xffdd44,
          transparent: true,
          opacity: 0.1
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.6;
        group.add(aura);

        break;
      }

      case 'frost-vine-wall': {
        // Fusion: Frost Berri + Vine Wall - Freezes attackers

        // Frozen ground base ring
        const fvwBaseGeo = new THREE.TorusGeometry(0.55, 0.08, 8, 16);
        const fvwBaseMat = new THREE.MeshPhongMaterial({
          color: 0x66bbdd, shininess: 180, specular: 0xaaddff,
          emissive: 0x3388aa, emissiveIntensity: 0.3
        });
        const fvwBase = new THREE.Mesh(fvwBaseGeo, fvwBaseMat);
        fvwBase.rotation.x = Math.PI / 2;
        fvwBase.position.y = 0.08;
        group.add(fvwBase);

        // Main frozen vine wall
        const fvwWallGeo = new THREE.BoxGeometry(0.8, 2.2, 0.6);
        const fvwWallMat = new THREE.MeshPhongMaterial({
          color: 0x2a6b4a, shininess: 40, specular: 0x1a4a3a,
          emissive: 0x0a2a1a, emissiveIntensity: 0.15
        });
        const fvwWall = new THREE.Mesh(fvwWallGeo, fvwWallMat);
        fvwWall.position.y = 1.25;
        group.add(fvwWall);

        // Frost coating overlay
        const fvwFrostGeo = new THREE.BoxGeometry(0.85, 2.25, 0.65);
        const fvwFrostMat = new THREE.MeshPhongMaterial({
          color: 0x88ddff, shininess: 180, transparent: true, opacity: 0.35,
          emissive: 0x4488cc, emissiveIntensity: 0.25
        });
        const fvwFrost = new THREE.Mesh(fvwFrostGeo, fvwFrostMat);
        fvwFrost.position.y = 1.25;
        group.add(fvwFrost);

        // Frost berri core embedded in wall center
        const fvwCoreGeo = new THREE.SphereGeometry(0.2, 12, 12);
        const fvwCoreMat = new THREE.MeshPhongMaterial({
          color: 0x66ccff, shininess: 200, specular: 0xffffff,
          emissive: 0x44aaff, emissiveIntensity: 0.6
        });
        const fvwCore = new THREE.Mesh(fvwCoreGeo, fvwCoreMat);
        fvwCore.position.set(0.42, 1.25, 0);
        group.add(fvwCore);

        // Frost bark texture
        for (let layer = 0; layer < 3; layer++) {
          const barkGeo = new THREE.BoxGeometry(0.06, 2.2, 0.55 - layer * 0.1);
          const barkMat = new THREE.MeshPhongMaterial({
            color: [0x1a5a4a, 0x2a6a5a, 0x1f5a4f][layer], shininess: 20
          });
          const bark = new THREE.Mesh(barkGeo, barkMat);
          bark.position.set(0.42 + layer * 0.04, 1.25, 0);
          group.add(bark);
        }

        // Frozen vines
        for (let i = 0; i < 6; i++) {
          const vineGeo = new THREE.CylinderGeometry(0.05, 0.06, 2.2, 8);
          const vineMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x3a8a6a : 0x2a7a5a, shininess: 45
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(0.5 + Math.sin(i) * 0.06, 1.25, -0.22 + i * 0.09);
          vine.rotation.z = Math.sin(i) * 0.1;
          group.add(vine);
        }

        // Ice crystals - 8 scattered across wall face
        for (let i = 0; i < 8; i++) {
          const crystalGeo = new THREE.OctahedronGeometry(0.1 + Math.random() * 0.08, 0);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0x88eeff, shininess: 250, transparent: true, opacity: 0.8,
            emissive: 0x44aaff, emissiveIntensity: 0.45
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          crystal.position.set(0.5, 0.3 + i * 0.26, (i % 3 - 1) * 0.18);
          crystal.rotation.set(Math.random(), Math.random(), Math.random());
          group.add(crystal);
        }

        // Frost vein lines on wall face
        for (let v = 0; v < 4; v++) {
          const veinGeo = new THREE.BoxGeometry(0.02, 0.4 + Math.random() * 0.5, 0.01);
          const veinMat = new THREE.MeshBasicMaterial({
            color: 0x88ddff, transparent: true, opacity: 0.6
          });
          const vein = new THREE.Mesh(veinGeo, veinMat);
          vein.position.set(0.42, 0.5 + v * 0.45, -0.15 + v * 0.1);
          vein.rotation.z = (Math.random() - 0.5) * 0.3;
          group.add(vein);
        }

        // Icicles hanging from top edge
        for (let ic = 0; ic < 6; ic++) {
          const icicleGeo = new THREE.ConeGeometry(0.04, 0.25 + Math.random() * 0.15, 6);
          const icicleMat = new THREE.MeshPhongMaterial({
            color: 0xccffff, shininess: 220, transparent: true, opacity: 0.85,
            emissive: 0x66aadd, emissiveIntensity: 0.2
          });
          const icicle = new THREE.Mesh(icicleGeo, icicleMat);
          icicle.position.set(0.55, 2.2, -0.25 + ic * 0.1);
          icicle.rotation.z = -Math.PI / 2;
          group.add(icicle);
        }

        // Frosted thorns
        for (let t = 0; t < 6; t++) {
          const thornGeo = new THREE.ConeGeometry(0.08, 0.35, 5);
          const thornMat = new THREE.MeshPhongMaterial({
            color: 0x5a6a80, shininess: 110, specular: 0x88aacc
          });
          const thorn = new THREE.Mesh(thornGeo, thornMat);
          thorn.position.set(0.65, 0.35 + t * 0.35, ((t % 3) - 1) * 0.18);
          thorn.rotation.z = -Math.PI / 2;
          group.add(thorn);
        }

        // Frost aura
        const fvwAuraGeo = new THREE.SphereGeometry(1.0, 14, 14);
        const fvwAuraMat = new THREE.MeshBasicMaterial({
          color: 0x88ddff, transparent: true, opacity: 0.12
        });
        const fvwAura = new THREE.Mesh(fvwAuraGeo, fvwAuraMat);
        fvwAura.position.y = 1.25;
        group.add(fvwAura);

        // Floating snowflake particles
        for (let p = 0; p < 10; p++) {
          const particleGeo = new THREE.OctahedronGeometry(0.03, 0);
          const particleMat = new THREE.MeshBasicMaterial({
            color: 0xffffff, transparent: true, opacity: 0.6
          });
          const particle = new THREE.Mesh(particleGeo, particleMat);
          particle.position.set(
            (Math.random() - 0.5) * 1.2, 0.3 + Math.random() * 2.0, (Math.random() - 0.5) * 0.8
          );
          group.add(particle);
        }

        break;
      }

      case 'frozen-supernova-coconut': {
        // Fusion: Frost Berri + Black Hole Coconut - Frozen singularity bomb!
        // Dark coconut core with icy surface
        const coconutGeo = new THREE.SphereGeometry(0.45, 20, 20);
        const coconutMat = new THREE.MeshPhongMaterial({
          color: 0x1a2030,
          shininess: 150,
          emissive: 0x0a1520,
          emissiveIntensity: 0.5
        });
        const coconut = new THREE.Mesh(coconutGeo, coconutMat);
        coconut.position.y = 0.6;
        group.add(coconut);

        // Swirling ice crystals around it
        for (let i = 0; i < 8; i++) {
          const crystalGeo = new THREE.OctahedronGeometry(0.12, 0);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0x88eeff,
            shininess: 250,
            transparent: true,
            opacity: 0.8,
            emissive: 0x44aaff,
            emissiveIntensity: 0.5
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const angle = (i / 8) * Math.PI * 2;
          crystal.position.set(Math.cos(angle) * 0.55, 0.6 + Math.sin(i) * 0.15, Math.sin(angle) * 0.55);
          crystal.rotation.set(Math.random(), Math.random(), Math.random());
          crystal.userData.isIceCrystal = true;
          crystal.userData.crystalIndex = i;
          group.add(crystal);
        }

        // Gravity pull effect - dark center ring
        const ringGeo = new THREE.TorusGeometry(0.35, 0.05, 8, 24);
        const ringMat = new THREE.MeshBasicMaterial({ color: 0x000022 });
        const ring = new THREE.Mesh(ringGeo, ringMat);
        ring.position.y = 0.6;
        ring.rotation.x = Math.PI / 2;
        group.add(ring);

        // Outer ice aura (pull range indicator)
        const auraGeo = new THREE.SphereGeometry(0.8, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x66ccff,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.6;
        aura.userData.isGravityAura = true;
        group.add(aura);

        // Snowflake particles
        for (let i = 0; i < 10; i++) {
          const snowGeo = new THREE.SphereGeometry(0.03, 6, 6);
          const snowMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const snow = new THREE.Mesh(snowGeo, snowMat);
          snow.position.set(
            (Math.random() - 0.5) * 1.2,
            0.3 + Math.random() * 0.8,
            (Math.random() - 0.5) * 1.2
          );
          snow.userData.isSnowflake = true;
          group.add(snow);
        }

        break;
      }

      case 'spike-wall': {
        // Fusion: Vine Wall + Tomato Spike - Damages attackers

        // Ground base
        const swBaseGeo = new THREE.CylinderGeometry(0.55, 0.65, 0.15, 14);
        const swBaseMat = new THREE.MeshPhongMaterial({
          color: 0x1a4a12, shininess: 30, emissive: 0x1a0a0a, emissiveIntensity: 0.1
        });
        const swBase = new THREE.Mesh(swBaseGeo, swBaseMat);
        swBase.position.y = 0.07;
        group.add(swBase);

        // Main vine wall
        const swWallGeo = new THREE.BoxGeometry(0.8, 2.2, 0.6);
        const swWallMat = new THREE.MeshPhongMaterial({
          color: 0x2a6b2a, shininess: 25, specular: 0x1a4a1a,
          emissive: 0x1a0a0a, emissiveIntensity: 0.1
        });
        const swWall = new THREE.Mesh(swWallGeo, swWallMat);
        swWall.position.y = 1.25;
        group.add(swWall);

        // Tomato-red accent band across center
        const swAccentGeo = new THREE.BoxGeometry(0.82, 0.08, 0.62);
        const swAccentMat = new THREE.MeshPhongMaterial({
          color: 0xcc3322, shininess: 60, emissive: 0x661100, emissiveIntensity: 0.2
        });
        const swAccent = new THREE.Mesh(swAccentGeo, swAccentMat);
        swAccent.position.y = 1.25;
        group.add(swAccent);

        // Bark texture layers
        for (let layer = 0; layer < 3; layer++) {
          const barkGeo = new THREE.BoxGeometry(0.06, 2.2, 0.55 - layer * 0.08);
          const barkMat = new THREE.MeshPhongMaterial({
            color: layer === 0 ? 0x1a4a1a : layer === 1 ? 0x2a5a2a : 0x1f501f, shininess: 15
          });
          const bark = new THREE.Mesh(barkGeo, barkMat);
          bark.position.set(-0.42 + layer * 0.04, 1.25, 0);
          group.add(bark);
        }

        // Woven vines
        for (let i = 0; i < 5; i++) {
          const vineGeo = new THREE.CylinderGeometry(0.045, 0.055, 2.2, 8);
          const vineMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x3d7a3d : 0x2d6a2d, shininess: 35
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(-0.35, 1.25, -0.22 + i * 0.11);
          vine.rotation.z = Math.sin(i) * 0.08;
          group.add(vine);
        }

        // Deadly crimson spikes - 3 rows x 5
        for (let row = 0; row < 3; row++) {
          for (let i = 0; i < 5; i++) {
            const spikeGeo = new THREE.ConeGeometry(0.1 - row * 0.02, 0.45 - row * 0.08, 8);
            const spikeMat = new THREE.MeshPhongMaterial({
              color: 0xcc4422, shininess: 120, specular: 0xff6644,
              emissive: 0x661100, emissiveIntensity: row === 0 ? 0.35 : 0.25
            });
            const spike = new THREE.Mesh(spikeGeo, spikeMat);
            spike.rotation.z = -Math.PI / 2;
            spike.position.set(0.5 + row * 0.12, 0.35 + i * 0.42, ((i % 2) - 0.5) * 0.18 + row * 0.04);
            group.add(spike);

            if (row === 0) {
              const tipGeo = new THREE.SphereGeometry(0.035, 6, 6);
              const tipMat = new THREE.MeshBasicMaterial({
                color: 0xff8866, transparent: true, opacity: 0.9
              });
              const tip = new THREE.Mesh(tipGeo, tipMat);
              tip.position.set(0.72, 0.35 + i * 0.42, ((i % 2) - 0.5) * 0.18);
              group.add(tip);
            }
          }
        }

        // Boss spike at center - 1.3x larger
        const bossGeo = new THREE.ConeGeometry(0.14, 0.6, 8);
        const bossMat = new THREE.MeshPhongMaterial({
          color: 0xdd3311, shininess: 150, specular: 0xff8844,
          emissive: 0x881100, emissiveIntensity: 0.4
        });
        const bossSpike = new THREE.Mesh(bossGeo, bossMat);
        bossSpike.rotation.z = -Math.PI / 2;
        bossSpike.position.set(0.55, 1.25, 0);
        group.add(bossSpike);

        // Spike base rings
        for (let r = 0; r < 5; r++) {
          const ringGeo = new THREE.TorusGeometry(0.08, 0.02, 6, 10);
          const ringMat = new THREE.MeshPhongMaterial({ color: 0x993311, shininess: 80 });
          const ring = new THREE.Mesh(ringGeo, ringMat);
          ring.rotation.y = Math.PI / 2;
          ring.position.set(0.42, 0.35 + r * 0.42, ((r % 2) - 0.5) * 0.18);
          group.add(ring);
        }

        // Leaves with reddish tint
        for (let i = 0; i < 7; i++) {
          const leafGeo = new THREE.SphereGeometry(0.12, 6, 6);
          leafGeo.scale(1.5, 0.15, 1);
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 3 === 0 ? 0x6a7a2a : i % 3 === 1 ? 0x4a8a2a : 0x3a7a1a,
            shininess: 50, side: THREE.DoubleSide
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.position.set(-0.38, 0.3 + i * 0.28, Math.sin(i * 1.5) * 0.22);
          leaf.rotation.set(Math.random() * 0.5, Math.random() * Math.PI, -0.4);
          group.add(leaf);
        }

        // Metal reinforcement bands
        for (let b = 0; b < 2; b++) {
          const bandGeo = new THREE.BoxGeometry(0.05, 0.05, 0.62);
          const bandMat = new THREE.MeshPhongMaterial({ color: 0x555555, shininess: 90, specular: 0xaaaaaa });
          const band = new THREE.Mesh(bandGeo, bandMat);
          band.position.set(-0.38, 0.7 + b * 1.1, 0);
          group.add(band);
        }

        // Danger aura
        const swAuraGeo = new THREE.SphereGeometry(1.0, 12, 12);
        const swAuraMat = new THREE.MeshBasicMaterial({
          color: 0xff4422, transparent: true, opacity: 0.1
        });
        const swAura = new THREE.Mesh(swAuraGeo, swAuraMat);
        swAura.position.y = 1.25;
        group.add(swAura);

        break;
      }

      case 'acorn-nest': {
        // Fusion: Acorn Tree + Banana Peel - Spawns squirrel allies

        // Woven twig nest base
        const nestBaseGeo = new THREE.SphereGeometry(0.5, 16, 16);
        nestBaseGeo.scale(1.6, 0.55, 1.6);
        const nestBaseMat = new THREE.MeshPhongMaterial({
          color: 0x6b4a2b,
          shininess: 25,
          specular: 0x443322
        });
        const nestBase = new THREE.Mesh(nestBaseGeo, nestBaseMat);
        nestBase.position.y = 0.3;
        group.add(nestBase);

        // Twig ring pattern
        for (let t = 0; t < 12; t++) {
          const twigGeo = new THREE.CylinderGeometry(0.025, 0.03, 0.5 + Math.random() * 0.2, 6);
          const twigMat = new THREE.MeshPhongMaterial({
            color: t % 3 === 0 ? 0x5a3a1a : t % 3 === 1 ? 0x6a4a2a : 0x4a2a0a,
            shininess: 20
          });
          const twig = new THREE.Mesh(twigGeo, twigMat);
          const angle = (t / 12) * Math.PI * 2;
          twig.position.set(
            Math.cos(angle) * 0.45,
            0.35,
            Math.sin(angle) * 0.45
          );
          twig.rotation.set(Math.random() * 0.3, angle, Math.PI / 2 + Math.random() * 0.2);
          group.add(twig);
        }

        // Outer nest rim
        const rimGeo = new THREE.TorusGeometry(0.55, 0.08, 8, 20);
        const rimMat = new THREE.MeshPhongMaterial({
          color: 0x5a3a1a,
          shininess: 20
        });
        const rim = new THREE.Mesh(rimGeo, rimMat);
        rim.position.y = 0.45;
        rim.rotation.x = Math.PI / 2;
        group.add(rim);

        // Soft interior padding (leaves/moss)
        const paddingGeo = new THREE.CylinderGeometry(0.4, 0.45, 0.1, 16);
        const paddingMat = new THREE.MeshPhongMaterial({
          color: 0x4a7a3a,
          shininess: 30
        });
        const padding = new THREE.Mesh(paddingGeo, paddingMat);
        padding.position.y = 0.35;
        group.add(padding);

        // Acorns in nest with caps
        for (let i = 0; i < 4; i++) {
          // Acorn body
          const acornGeo = new THREE.SphereGeometry(0.12, 12, 12);
          acornGeo.scale(1, 1.2, 1);
          const acornMat = new THREE.MeshPhongMaterial({
            color: 0x8b4513,
            shininess: 90,
            specular: 0xaa7744
          });
          const acorn = new THREE.Mesh(acornGeo, acornMat);
          const angle = (i / 4) * Math.PI * 2;
          acorn.position.set(
            Math.cos(angle) * 0.22,
            0.45,
            Math.sin(angle) * 0.22
          );
          group.add(acorn);

          // Acorn cap
          const capGeo = new THREE.SphereGeometry(0.11, 10, 10);
          capGeo.scale(1.1, 0.5, 1.1);
          const capMat = new THREE.MeshPhongMaterial({
            color: 0x5a3a1a,
            shininess: 40
          });
          const cap = new THREE.Mesh(capGeo, capMat);
          cap.position.set(
            Math.cos(angle) * 0.22,
            0.55,
            Math.sin(angle) * 0.22
          );
          group.add(cap);

          // Cap stem
          const stemGeo = new THREE.CylinderGeometry(0.015, 0.02, 0.08, 6);
          const stemMat = new THREE.MeshPhongMaterial({ color: 0x3a2a0a });
          const stem = new THREE.Mesh(stemGeo, stemMat);
          stem.position.set(
            Math.cos(angle) * 0.22,
            0.62,
            Math.sin(angle) * 0.22
          );
          group.add(stem);
        }

        // Central special golden acorn
        const goldenAcornGeo = new THREE.SphereGeometry(0.14, 14, 14);
        goldenAcornGeo.scale(1, 1.2, 1);
        const goldenAcornMat = new THREE.MeshPhongMaterial({
          color: 0xdaa520,
          shininess: 150,
          specular: 0xffdd88,
          emissive: 0x885500,
          emissiveIntensity: 0.2
        });
        const goldenAcorn = new THREE.Mesh(goldenAcornGeo, goldenAcornMat);
        goldenAcorn.position.y = 0.5;
        group.add(goldenAcorn);

        // Golden acorn cap
        const goldenCapGeo = new THREE.SphereGeometry(0.13, 10, 10);
        goldenCapGeo.scale(1.1, 0.5, 1.1);
        const goldenCapMat = new THREE.MeshPhongMaterial({
          color: 0xb8860b,
          shininess: 100
        });
        const goldenCap = new THREE.Mesh(goldenCapGeo, goldenCapMat);
        goldenCap.position.y = 0.62;
        group.add(goldenCap);

        // Small leaf decorations
        for (let l = 0; l < 4; l++) {
          const leafGeo = new THREE.SphereGeometry(0.08, 6, 6);
          leafGeo.scale(1.5, 0.2, 1);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x4a8a2a,
            shininess: 50,
            side: THREE.DoubleSide
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const angle = (l / 4) * Math.PI * 2 + 0.3;
          leaf.position.set(
            Math.cos(angle) * 0.55,
            0.4,
            Math.sin(angle) * 0.55
          );
          leaf.rotation.set(0.5, angle, 0);
          group.add(leaf);
        }

        // Warm golden aura
        const auraGeo = new THREE.SphereGeometry(0.6, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xdaa520,
          transparent: true,
          opacity: 0.1
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.45;
        group.add(aura);

        break;
      }

      case 'frozen-lily': {
        // Fusion: Frost Berri + Lily - Charges ice ball, gives sun per kill

        // Frozen lily pad
        const padGeo = new THREE.CylinderGeometry(0.55, 0.65, 0.1, 18);
        const padMat = new THREE.MeshPhongMaterial({
          color: 0x66bbdd,
          shininess: 120,
          transparent: true,
          opacity: 0.85,
          specular: 0xaaddff
        });
        const pad = new THREE.Mesh(padGeo, padMat);
        pad.position.y = 0.05;
        group.add(pad);

        // Ice layer on pad
        const iceLayerGeo = new THREE.CylinderGeometry(0.5, 0.6, 0.08, 18);
        const iceLayerMat = new THREE.MeshPhongMaterial({
          color: 0xaaeeff,
          shininess: 200,
          transparent: true,
          opacity: 0.5,
          emissive: 0x66ccff,
          emissiveIntensity: 0.2
        });
        const iceLayer = new THREE.Mesh(iceLayerGeo, iceLayerMat);
        iceLayer.position.y = 0.1;
        group.add(iceLayer);

        // Frost veins on pad
        for (let v = 0; v < 6; v++) {
          const veinGeo = new THREE.BoxGeometry(0.015, 0.02, 0.4);
          const veinMat = new THREE.MeshPhongMaterial({
            color: 0xffffff,
            shininess: 150,
            transparent: true,
            opacity: 0.6
          });
          const vein = new THREE.Mesh(veinGeo, veinMat);
          const angle = (v / 6) * Math.PI * 2;
          vein.position.set(Math.cos(angle) * 0.2, 0.11, Math.sin(angle) * 0.2);
          vein.rotation.y = angle;
          group.add(vein);
        }

        // Ice crystal stem
        const stemGeo = new THREE.CylinderGeometry(0.08, 0.1, 0.35, 8);
        const stemMat = new THREE.MeshPhongMaterial({
          color: 0x88ccee,
          shininess: 150,
          transparent: true,
          opacity: 0.8
        });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.28;
        group.add(stem);

        // Beautiful ice flower with petals
        for (let p = 0; p < 8; p++) {
          const petalGeo = new THREE.SphereGeometry(0.15, 10, 10);
          petalGeo.scale(1, 0.25, 0.5);
          const petalMat = new THREE.MeshPhongMaterial({
            color: 0xaaeeff,
            shininess: 200,
            transparent: true,
            opacity: 0.85,
            emissive: 0x66ccff,
            emissiveIntensity: 0.35
          });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          const angle = (p / 8) * Math.PI * 2;
          petal.position.set(
            Math.cos(angle) * 0.18,
            0.6,
            Math.sin(angle) * 0.18
          );
          petal.rotation.y = angle;
          petal.rotation.z = 0.6;
          group.add(petal);
        }

        // Glowing ice diamond center
        const centerGeo = new THREE.OctahedronGeometry(0.12, 0);
        const centerMat = new THREE.MeshPhongMaterial({
          color: 0xccffff,
          shininess: 250,
          emissive: 0x88ddff,
          emissiveIntensity: 0.6
        });
        const center = new THREE.Mesh(centerGeo, centerMat);
        center.position.y = 0.65;
        group.add(center);

        // Ice crystals around flower
        for (let c = 0; c < 5; c++) {
          const crystalGeo = new THREE.OctahedronGeometry(0.08, 0);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0x88eeff,
            shininess: 220,
            transparent: true,
            opacity: 0.7,
            emissive: 0x44aaff,
            emissiveIntensity: 0.3
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const angle = (c / 5) * Math.PI * 2;
          crystal.position.set(
            Math.cos(angle) * 0.35,
            0.4 + Math.sin(c * 2) * 0.15,
            Math.sin(angle) * 0.35
          );
          crystal.rotation.set(Math.random(), Math.random(), Math.random());
          group.add(crystal);
        }

        // Frost aura
        const auraGeo = new THREE.SphereGeometry(0.55, 14, 14);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x88ddff,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.5;
        group.add(aura);

        // Floating snowflakes
        for (let s = 0; s < 6; s++) {
          const snowGeo = new THREE.OctahedronGeometry(0.03, 0);
          const snowMat = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.6
          });
          const snow = new THREE.Mesh(snowGeo, snowMat);
          snow.position.set(
            (Math.random() - 0.5) * 0.8,
            0.3 + Math.random() * 0.6,
            (Math.random() - 0.5) * 0.8
          );
          group.add(snow);
        }

        break;
      }

      case 'frozen-lilyer': {
        // Enhanced Frozen Lily - Double flower, more sun per kill

        // Large frozen lily pad
        const padGeo = new THREE.CylinderGeometry(0.65, 0.75, 0.12, 20);
        const padMat = new THREE.MeshPhongMaterial({
          color: 0x55aacc,
          shininess: 130,
          transparent: true,
          opacity: 0.88,
          specular: 0x88ccff
        });
        const pad = new THREE.Mesh(padGeo, padMat);
        pad.position.y = 0.06;
        group.add(pad);

        // Thick ice layer
        const iceLayerGeo = new THREE.CylinderGeometry(0.6, 0.7, 0.1, 20);
        const iceLayerMat = new THREE.MeshPhongMaterial({
          color: 0x88ddff,
          shininess: 220,
          transparent: true,
          opacity: 0.55,
          emissive: 0x55bbff,
          emissiveIntensity: 0.25
        });
        const iceLayer = new THREE.Mesh(iceLayerGeo, iceLayerMat);
        iceLayer.position.y = 0.12;
        group.add(iceLayer);

        // Intricate frost patterns
        for (let v = 0; v < 8; v++) {
          const veinGeo = new THREE.BoxGeometry(0.018, 0.02, 0.5);
          const veinMat = new THREE.MeshPhongMaterial({
            color: 0xffffff,
            shininess: 180,
            transparent: true,
            opacity: 0.65
          });
          const vein = new THREE.Mesh(veinGeo, veinMat);
          const angle = (v / 8) * Math.PI * 2;
          vein.position.set(Math.cos(angle) * 0.25, 0.13, Math.sin(angle) * 0.25);
          vein.rotation.y = angle;
          group.add(vein);
        }

        // Double ice crystal stems
        for (let s = 0; s < 2; s++) {
          const stemGeo = new THREE.CylinderGeometry(0.07, 0.09, 0.4, 8);
          const stemMat = new THREE.MeshPhongMaterial({
            color: 0x77bbdd,
            shininess: 140,
            transparent: true,
            opacity: 0.8
          });
          const stem = new THREE.Mesh(stemGeo, stemMat);
          stem.position.set((s - 0.5) * 0.25, 0.32, 0);
          group.add(stem);
        }

        // Twin beautiful ice flowers
        for (let f = 0; f < 2; f++) {
          const flowerX = (f - 0.5) * 0.3;
          const flowerY = 0.6 + f * 0.15;

          // Petals for each flower
          for (let p = 0; p < 8; p++) {
            const petalGeo = new THREE.SphereGeometry(0.12, 10, 10);
            petalGeo.scale(1, 0.25, 0.5);
            const petalMat = new THREE.MeshPhongMaterial({
              color: f === 0 ? 0x99ddff : 0xbbeeFF,
              shininess: 210,
              transparent: true,
              opacity: 0.88,
              emissive: 0x55bbff,
              emissiveIntensity: 0.4
            });
            const petal = new THREE.Mesh(petalGeo, petalMat);
            const angle = (p / 8) * Math.PI * 2;
            petal.position.set(
              flowerX + Math.cos(angle) * 0.14,
              flowerY,
              Math.sin(angle) * 0.14
            );
            petal.rotation.y = angle;
            petal.rotation.z = 0.55;
            group.add(petal);
          }

          // Diamond center
          const centerGeo = new THREE.OctahedronGeometry(0.1, 0);
          const centerMat = new THREE.MeshPhongMaterial({
            color: 0xccffff,
            shininess: 250,
            emissive: 0x88ddff,
            emissiveIntensity: 0.7
          });
          const center = new THREE.Mesh(centerGeo, centerMat);
          center.position.set(flowerX, flowerY + 0.05, 0);
          group.add(center);
        }

        // Connecting ice bridge between flowers
        const bridgeGeo = new THREE.BoxGeometry(0.3, 0.04, 0.06);
        const bridgeMat = new THREE.MeshPhongMaterial({
          color: 0xaaeeff,
          shininess: 180,
          transparent: true,
          opacity: 0.7
        });
        const bridge = new THREE.Mesh(bridgeGeo, bridgeMat);
        bridge.position.set(0, 0.68, 0);
        bridge.rotation.z = 0.2;
        group.add(bridge);

        // Large ice crystals ring
        for (let c = 0; c < 7; c++) {
          const crystalGeo = new THREE.OctahedronGeometry(0.1, 0);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0x88eeff,
            shininess: 230,
            transparent: true,
            opacity: 0.75,
            emissive: 0x44aaff,
            emissiveIntensity: 0.35
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const angle = (c / 7) * Math.PI * 2;
          crystal.position.set(
            Math.cos(angle) * 0.45,
            0.35 + Math.sin(c * 2) * 0.12,
            Math.sin(angle) * 0.45
          );
          crystal.rotation.set(Math.random(), Math.random(), Math.random());
          group.add(crystal);
        }

        // Enhanced frost aura
        const auraGeo = new THREE.SphereGeometry(0.7, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x88ddff,
          transparent: true,
          opacity: 0.18
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.55;
        group.add(aura);

        // Abundant snowflakes
        for (let s = 0; s < 10; s++) {
          const snowGeo = new THREE.OctahedronGeometry(0.035, 0);
          const snowMat = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.65
          });
          const snow = new THREE.Mesh(snowGeo, snowMat);
          snow.position.set(
            (Math.random() - 0.5) * 1.0,
            0.25 + Math.random() * 0.7,
            (Math.random() - 0.5) * 1.0
          );
          group.add(snow);
        }

        break;
      }

      case 'acorn-wall': {
        // Fusion: Acorn Tree + Vine Wall - Auto-places acorn bombs

        // Ground base
        const awBaseGeo = new THREE.CylinderGeometry(0.55, 0.65, 0.15, 14);
        const awBaseMat = new THREE.MeshPhongMaterial({
          color: 0x3a2a15, shininess: 25, emissive: 0x2a1a08, emissiveIntensity: 0.1
        });
        const awBase = new THREE.Mesh(awBaseGeo, awBaseMat);
        awBase.position.y = 0.07;
        group.add(awBase);

        // Main oak bark wall
        const awWallGeo = new THREE.BoxGeometry(0.85, 2.3, 0.6);
        const awWallMat = new THREE.MeshPhongMaterial({
          color: 0x5a3a28, shininess: 25, specular: 0x3a2a20,
          emissive: 0x2a1a08, emissiveIntensity: 0.1
        });
        const awWall = new THREE.Mesh(awWallGeo, awWallMat);
        awWall.position.y = 1.3;
        group.add(awWall);

        // Bark texture layers
        for (let layer = 0; layer < 4; layer++) {
          const barkGeo = new THREE.BoxGeometry(0.06, 0.4 + Math.random() * 0.4, 0.55 - layer * 0.08);
          const barkMat = new THREE.MeshPhongMaterial({
            color: layer % 2 === 0 ? 0x4a3520 : 0x3a2510, shininess: 25
          });
          const bark = new THREE.Mesh(barkGeo, barkMat);
          bark.position.set(0.44 + layer * 0.03, 0.4 + layer * 0.45, (layer % 2 - 0.5) * 0.1);
          group.add(bark);
        }

        // Oak bark grain rings on face
        for (let r = 0; r < 2; r++) {
          const ringGeo = new THREE.TorusGeometry(0.18, 0.03, 6, 14);
          const ringMat = new THREE.MeshPhongMaterial({ color: 0x3a2510, shininess: 30 });
          const ring = new THREE.Mesh(ringGeo, ringMat);
          ring.position.set(0.44, 0.8 + r * 1.0, r === 0 ? -0.1 : 0.1);
          ring.rotation.y = Math.PI / 2;
          group.add(ring);
        }

        // Vine reinforcement
        for (let i = 0; i < 5; i++) {
          const vineGeo = new THREE.CylinderGeometry(0.05, 0.06, 2.3, 8);
          const vineMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x3a7a3a : 0x2a6a2a, shininess: 40
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(-0.35 + Math.sin(i) * 0.08, 1.3, -0.22 + i * 0.11);
          vine.rotation.z = Math.sin(i) * 0.1;
          group.add(vine);
        }

        // Tree crown on top
        const awCrownGeo = new THREE.SphereGeometry(0.38, 14, 14);
        const awCrownMat = new THREE.MeshPhongMaterial({
          color: 0x4a8a2a, shininess: 50, specular: 0x336622,
          emissive: 0x1a3a0a, emissiveIntensity: 0.15
        });
        const awCrown = new THREE.Mesh(awCrownGeo, awCrownMat);
        awCrown.position.y = 2.5;
        group.add(awCrown);

        // Branches connecting crown to wall
        for (let b = 0; b < 3; b++) {
          const branchGeo = new THREE.CylinderGeometry(0.04, 0.06, 0.6, 6);
          const branchMat = new THREE.MeshPhongMaterial({ color: 0x5a3a1a, shininess: 30 });
          const branch = new THREE.Mesh(branchGeo, branchMat);
          branch.position.set(Math.sin(b * 2.1) * 0.15, 2.2, Math.cos(b * 2.1) * 0.15);
          branch.rotation.x = (Math.random() - 0.5) * 0.5;
          branch.rotation.z = (Math.random() - 0.5) * 0.4;
          group.add(branch);
        }

        // Crown leaves
        for (let l = 0; l < 12; l++) {
          const leafGeo = new THREE.SphereGeometry(0.12, 6, 6);
          leafGeo.scale(1.5, 0.2, 1);
          const leafMat = new THREE.MeshPhongMaterial({
            color: l % 3 === 0 ? 0x5a9a3a : l % 3 === 1 ? 0x4a8a2a : 0x3a7a1a,
            shininess: 65, side: THREE.DoubleSide
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const theta = Math.acos(2 * (l / 12) - 1) * 0.7;
          const phi = (l / 12) * Math.PI * 4;
          leaf.position.set(
            Math.sin(theta) * Math.cos(phi) * 0.38, 2.5 + Math.cos(theta) * 0.28,
            Math.sin(theta) * Math.sin(phi) * 0.38
          );
          leaf.rotation.set(theta, phi, 0);
          group.add(leaf);
        }

        // Main acorn dispenser
        const awAcornGeo = new THREE.SphereGeometry(0.22, 14, 14);
        awAcornGeo.scale(1, 1.3, 1);
        const awAcornMat = new THREE.MeshPhongMaterial({
          color: 0x8b4513, shininess: 100, specular: 0xaa7744,
          emissive: 0x3a2008, emissiveIntensity: 0.15
        });
        const awAcorn = new THREE.Mesh(awAcornGeo, awAcornMat);
        awAcorn.position.set(0.15, 1.5, 0.2);
        group.add(awAcorn);

        // Acorn cap
        const awCapGeo = new THREE.SphereGeometry(0.2, 12, 12);
        awCapGeo.scale(1.15, 0.5, 1.15);
        const awCapMat = new THREE.MeshPhongMaterial({
          color: 0x5a3a1a, shininess: 80, specular: 0x886644
        });
        const awCap = new THREE.Mesh(awCapGeo, awCapMat);
        awCap.position.set(0.15, 1.65, 0.2);
        group.add(awCap);

        // Dispenser chute
        const chuteGeo = new THREE.CylinderGeometry(0.08, 0.1, 0.3, 8);
        const chuteMat = new THREE.MeshPhongMaterial({ color: 0x5a3a1a, shininess: 40 });
        const chute = new THREE.Mesh(chuteGeo, chuteMat);
        chute.position.set(0.3, 1.35, 0.2);
        chute.rotation.z = -0.6;
        group.add(chute);

        // Small acorn bombs ready to deploy
        for (let a = 0; a < 3; a++) {
          const acornGeo = new THREE.SphereGeometry(0.1, 10, 10);
          acornGeo.scale(1, 1.2, 1);
          const acornMat = new THREE.MeshPhongMaterial({
            color: 0x9b5523, shininess: 90, emissive: 0x4a2a08, emissiveIntensity: 0.2
          });
          const acorn = new THREE.Mesh(acornGeo, acornMat);
          const angle = (a / 3) * Math.PI * 2;
          acorn.position.set(Math.cos(angle) * 0.2, 1.2, Math.sin(angle) * 0.2);
          group.add(acorn);

          const capGeo = new THREE.SphereGeometry(0.09, 8, 8);
          capGeo.scale(1.1, 0.5, 1.1);
          const capMat = new THREE.MeshPhongMaterial({ color: 0x4a2a0a, shininess: 40 });
          const cap = new THREE.Mesh(capGeo, capMat);
          cap.position.set(Math.cos(angle) * 0.2, 1.28, Math.sin(angle) * 0.2);
          group.add(cap);
        }

        // Defensive thorns
        for (let t = 0; t < 5; t++) {
          const thornGeo = new THREE.ConeGeometry(0.07, 0.3, 5);
          const thornMat = new THREE.MeshPhongMaterial({ color: 0x5a4020, shininess: 65 });
          const thorn = new THREE.Mesh(thornGeo, thornMat);
          thorn.position.set(0.55, 0.35 + t * 0.4, ((t % 2) - 0.5) * 0.22);
          thorn.rotation.z = -Math.PI / 2;
          group.add(thorn);
        }

        // Nature aura
        const awAuraGeo = new THREE.SphereGeometry(1.0, 12, 12);
        const awAuraMat = new THREE.MeshBasicMaterial({
          color: 0x88aa44, transparent: true, opacity: 0.1
        });
        const awAura = new THREE.Mesh(awAuraGeo, awAuraMat);
        awAura.position.y = 1.3;
        group.add(awAura);

        break;
      }

      case 'frost-overlord-grape-gun': {
        // 2nd Form Odd Fusion - Ice blue themed grape-gun
        // Colors: Ice blue (0x66eeff, 0xaaeeff, 0x88ddff)

        // Hexagonal platform (same as grape-gun)
        const platformGeo = new THREE.CylinderGeometry(0.75, 0.85, 0.18, 6);
        const platformMat = new THREE.MeshPhongMaterial({
          color: 0x2a4a6a,
          shininess: 70,
          specular: 0x6699cc,
          emissive: 0x1a3050,
          emissiveIntensity: 0.15
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.09;
        group.add(platform);

        // 6 energy channels on platform
        for (let i = 0; i < 6; i++) {
          const channelGeo = new THREE.BoxGeometry(0.06, 0.05, 0.35);
          const channelMat = new THREE.MeshPhongMaterial({
            color: 0x66eeff,
            emissive: 0x44ccff,
            emissiveIntensity: 0.9,
            shininess: 100
          });
          const channel = new THREE.Mesh(channelGeo, channelMat);
          const angle = (i / 6) * Math.PI * 2;
          channel.position.set(
            Math.cos(angle) * 0.55,
            0.12,
            Math.sin(angle) * 0.55
          );
          channel.rotation.y = angle;
          group.add(channel);
        }

        // Ring trim (TorusGeometry 0.55, 0.06)
        const innerRingGeo = new THREE.TorusGeometry(0.55, 0.06, 8, 20);
        const innerRingMat = new THREE.MeshPhongMaterial({
          color: 0xaaeeff,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0x66ccff,
          emissiveIntensity: 0.3
        });
        const innerRing = new THREE.Mesh(innerRingGeo, innerRingMat);
        innerRing.position.y = 0.15;
        innerRing.rotation.x = Math.PI / 2;
        group.add(innerRing);

        // 3 pots along X-axis (xOffset = (i-1) * 0.55)
        for (let i = 0; i < 3; i++) {
          const xOffset = (i - 1) * 0.55;

          // Main pot body
          const potGeo = new THREE.CylinderGeometry(0.22, 0.18, 0.28, 16);
          const potMat = new THREE.MeshPhongMaterial({
            color: 0x3a5a7a,
            shininess: 60,
            specular: 0x6688aa,
            emissive: 0x1a3050,
            emissiveIntensity: 0.1
          });
          const pot = new THREE.Mesh(potGeo, potMat);
          pot.position.set(xOffset, 0.32, 0);
          group.add(pot);

          // Ice rim on pot
          const rimGeo = new THREE.TorusGeometry(0.22, 0.035, 8, 16);
          const rimMat = new THREE.MeshPhongMaterial({
            color: 0xaaeeff,
            shininess: 150,
            specular: 0xffffff,
            emissive: 0x66ccff,
            emissiveIntensity: 0.4
          });
          const rim = new THREE.Mesh(rimGeo, rimMat);
          rim.position.set(xOffset, 0.46, 0);
          rim.rotation.x = Math.PI / 2;
          group.add(rim);

          // Decorative emblem on pot
          const emblemGeo = new THREE.SphereGeometry(0.06, 10, 10);
          const emblemMat = new THREE.MeshPhongMaterial({
            color: 0x88ddff,
            emissive: 0x44aacc,
            emissiveIntensity: 0.5,
            shininess: 100
          });
          for (let e = 0; e < 3; e++) {
            const emblem = new THREE.Mesh(emblemGeo, emblemMat);
            emblem.position.set(xOffset, 0.28 + e * 0.08, 0.2);
            emblem.scale.set(0.8 - e * 0.15, 0.8 - e * 0.15, 0.5);
            group.add(emblem);
          }

          // Decorative vines wrapping pot
          const vineGeo = new THREE.TorusGeometry(0.24, 0.02, 6, 16);
          const vineMat = new THREE.MeshPhongMaterial({
            color: 0x4488aa,
            shininess: 40
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(xOffset, 0.35, 0);
          vine.rotation.x = Math.PI / 2;
          vine.rotation.z = i * 0.5;
          group.add(vine);
        }

        // 3 grape clusters with 8 LARGE grapes each (0.1 radius spheres)
        for (let side = 0; side < 3; side++) {
          const xOffset = (side - 1) * 0.55;

          // Main cluster core with glow
          const clusterGeo = new THREE.SphereGeometry(0.22, 16, 16);
          const clusterMat = new THREE.MeshPhongMaterial({
            color: 0x66ccff,
            shininess: 100,
            emissive: 0x44aacc,
            emissiveIntensity: 0.4
          });
          const cluster = new THREE.Mesh(clusterGeo, clusterMat);
          cluster.position.set(xOffset, 0.72, 0);
          group.add(cluster);

          // 8 individual grapes around each cluster (0.1 radius)
          for (let j = 0; j < 8; j++) {
            const grapeGeo = new THREE.SphereGeometry(0.1, 12, 12);
            const grapeMat = new THREE.MeshPhongMaterial({
              color: 0x88ddff,
              shininess: 120,
              specular: 0xaaeeff,
              emissive: 0x44aacc,
              emissiveIntensity: 0.35
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            const angle = (j / 8) * Math.PI * 2;
            const heightOffset = (j % 2) * 0.1;
            grape.position.set(
              xOffset + Math.cos(angle) * 0.22,
              0.58 + heightOffset,
              Math.sin(angle) * 0.22
            );
            group.add(grape);

            // Highlight on each grape
            const highlightGeo = new THREE.SphereGeometry(0.03, 8, 8);
            const highlightMat = new THREE.MeshBasicMaterial({
              color: 0xffffff,
              transparent: true,
              opacity: 0.8
            });
            const highlight = new THREE.Mesh(highlightGeo, highlightMat);
            highlight.position.set(
              xOffset + Math.cos(angle) * 0.22 + 0.04,
              0.62 + heightOffset,
              Math.sin(angle) * 0.22 + 0.04
            );
            group.add(highlight);
          }

          // Glowing core inside each cluster
          const coreGeo = new THREE.SphereGeometry(0.12, 12, 12);
          const coreMat = new THREE.MeshBasicMaterial({
            color: 0xaaeeff,
            transparent: true,
            opacity: 0.6
          });
          const core = new THREE.Mesh(coreGeo, coreMat);
          core.position.set(xOffset, 0.72, 0);
          group.add(core);

          // Leaf on top of each cluster
          const leafGeo = new THREE.SphereGeometry(0.12, 8, 8);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x4488aa,
            shininess: 50,
            emissive: 0x336688,
            emissiveIntensity: 0.2
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(1.5, 0.3, 1);
          leaf.position.set(xOffset + 0.1, 0.92, 0.05);
          leaf.rotation.z = 0.3;
          group.add(leaf);
        }

        // Central energy hub connecting all clusters
        const hubGeo = new THREE.SphereGeometry(0.18, 16, 16);
        const hubMat = new THREE.MeshPhongMaterial({
          color: 0x66eeff,
          emissive: 0x44ccff,
          emissiveIntensity: 0.9,
          shininess: 150,
          transparent: true,
          opacity: 0.9
        });
        const hub = new THREE.Mesh(hubGeo, hubMat);
        hub.position.set(0, 0.85, 0);
        group.add(hub);

        // Hub glow effect
        const hubGlowGeo = new THREE.SphereGeometry(0.28, 12, 12);
        const hubGlowMat = new THREE.MeshBasicMaterial({
          color: 0x88ddff,
          transparent: true,
          opacity: 0.35
        });
        const hubGlow = new THREE.Mesh(hubGlowGeo, hubGlowMat);
        hubGlow.position.set(0, 0.85, 0);
        group.add(hubGlow);

        // Energy connections from hub to each cluster
        for (let i = 0; i < 3; i++) {
          const xOffset = (i - 1) * 0.55;
          const tubeGeo = new THREE.CylinderGeometry(0.03, 0.03, 0.35, 8);
          const tubeMat = new THREE.MeshPhongMaterial({
            color: 0x66eeff,
            emissive: 0x44ccff,
            emissiveIntensity: 0.7,
            shininess: 100
          });
          const tube = new THREE.Mesh(tubeGeo, tubeMat);
          tube.position.set(xOffset * 0.5, 0.78, 0);
          tube.rotation.z = Math.PI / 2;
          if (i !== 1) {
            tube.rotation.z += (i === 0 ? 0.2 : -0.2);
          }
          group.add(tube);
        }

        // Create turret group for rotatable barrels
        const turretGroup = new THREE.Group();
        turretGroup.position.set(0, 0.85, 0);
        group.add(turretGroup);
        group.userData.turret = turretGroup;

        // Triple gatling barrels with glowing tips
        const barrelPositions = [
          { x: -0.18, z: 0.25 },
          { x: 0, z: 0.35 },
          { x: 0.18, z: 0.25 }
        ];

        for (let b = 0; b < 3; b++) {
          // Main barrel housing
          const housingGeo = new THREE.CylinderGeometry(0.12, 0.1, 0.2, 12);
          const housingMat = new THREE.MeshPhongMaterial({
            color: 0x444455,
            shininess: 120,
            specular: 0x888899
          });
          const housing = new THREE.Mesh(housingGeo, housingMat);
          housing.position.set(barrelPositions[b].x, 0.1, barrelPositions[b].z);
          housing.rotation.x = Math.PI / 4;
          turretGroup.add(housing);

          // Barrel tube
          const barrelGeo = new THREE.CylinderGeometry(0.07, 0.06, 0.45, 16);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x333344,
            shininess: 100,
            specular: 0x666677
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.position.set(
            barrelPositions[b].x,
            0.25 + b * 0.02,
            barrelPositions[b].z + 0.22
          );
          barrel.rotation.x = Math.PI / 4;
          turretGroup.add(barrel);

          // Barrel rings
          for (let r = 0; r < 2; r++) {
            const ringGeo = new THREE.TorusGeometry(0.075, 0.015, 6, 12);
            const ringMat = new THREE.MeshPhongMaterial({
              color: 0x666677,
              shininess: 100
            });
            const ring = new THREE.Mesh(ringGeo, ringMat);
            ring.position.set(
              barrelPositions[b].x,
              0.15 + r * 0.15 + b * 0.02,
              barrelPositions[b].z + 0.15 + r * 0.1
            );
            ring.rotation.x = Math.PI / 4 + Math.PI / 2;
            turretGroup.add(ring);
          }

          // Glowing muzzle tip (ice blue)
          const tipGeo = new THREE.SphereGeometry(0.08, 12, 12);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0x88ddff,
            emissive: 0x66ccff,
            emissiveIntensity: 0.9,
            shininess: 150
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(
            barrelPositions[b].x,
            0.43 + b * 0.02,
            barrelPositions[b].z + 0.42
          );
          turretGroup.add(tip);

          // Muzzle glow effect
          const tipGlowGeo = new THREE.SphereGeometry(0.12, 10, 10);
          const tipGlowMat = new THREE.MeshBasicMaterial({
            color: 0x88ddff,
            transparent: true,
            opacity: 0.5
          });
          const tipGlow = new THREE.Mesh(tipGlowGeo, tipGlowMat);
          tipGlow.position.copy(tip.position);
          turretGroup.add(tipGlow);
        }

        // Ammo belt visual connecting clusters to barrels
        for (let i = 0; i < 2; i++) {
          const beltGeo = new THREE.CylinderGeometry(0.025, 0.025, 0.4, 8);
          const beltMat = new THREE.MeshPhongMaterial({
            color: 0x88ddff,
            emissive: 0x44aacc,
            emissiveIntensity: 0.4,
            shininess: 80
          });
          const belt = new THREE.Mesh(beltGeo, beltMat);
          const xPos = i === 0 ? -0.35 : 0.35;
          belt.position.set(xPos, -0.05, 0.15);
          belt.rotation.x = Math.PI / 3;
          belt.rotation.z = i === 0 ? 0.3 : -0.3;
          turretGroup.add(belt);
        }

        // Overall aura glow
        const auraGeo = new THREE.SphereGeometry(0.9, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x66eeff,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.7;
        group.add(aura);

        // === FROST OVERLORD ENHANCEMENTS ===
        // Ice crown on hub
        const crownGeo = new THREE.ConeGeometry(0.15, 0.3, 6);
        const crownMat = new THREE.MeshPhongMaterial({
          color: 0xaaeeff, shininess: 250, specular: 0xffffff, emissive: 0x66ccff, emissiveIntensity: 0.6
        });
        const crown = new THREE.Mesh(crownGeo, crownMat);
        crown.position.set(0, 1.15, 0);
        group.add(crown);

        // Crown spikes
        for (let cs = 0; cs < 5; cs++) {
          const csGeo = new THREE.ConeGeometry(0.05, 0.18, 5);
          const csMat = new THREE.MeshPhongMaterial({ color: 0xccffff, shininess: 200, emissive: 0x88eeff, emissiveIntensity: 0.5 });
          const spike = new THREE.Mesh(csGeo, csMat);
          const csAngle = (cs / 5) * Math.PI * 2;
          spike.position.set(Math.cos(csAngle) * 0.18, 1.05, Math.sin(csAngle) * 0.18);
          spike.rotation.z = -Math.cos(csAngle) * 0.4;
          spike.rotation.x = Math.sin(csAngle) * 0.4;
          group.add(spike);
        }

        // Orbiting ice crystals
        for (let ic = 0; ic < 8; ic++) {
          const icGeo = new THREE.OctahedronGeometry(0.06, 0);
          const icMat = new THREE.MeshPhongMaterial({
            color: 0x88eeff, shininess: 280, transparent: true, opacity: 0.85, emissive: 0x44ccff, emissiveIntensity: 0.5
          });
          const crystal = new THREE.Mesh(icGeo, icMat);
          const icAngle = (ic / 8) * Math.PI * 2;
          crystal.position.set(Math.cos(icAngle) * 0.75, 0.5 + Math.sin(ic * 2) * 0.15, Math.sin(icAngle) * 0.75);
          crystal.rotation.set(Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI);
          group.add(crystal);
        }

        // Snowflake particles
        for (let sf = 0; sf < 12; sf++) {
          const sfGeo = new THREE.OctahedronGeometry(0.03, 0);
          const sfMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.7 });
          const snowflake = new THREE.Mesh(sfGeo, sfMat);
          snowflake.position.set((Math.random() - 0.5) * 1.4, 0.2 + Math.random() * 1.2, (Math.random() - 0.5) * 1.4);
          group.add(snowflake);
        }

        break;
      }

      case 'thornbomber': {
        // 2nd Form Odd Fusion - Red/pink themed grape-gun with gold trim
        // Colors: Red/pink (0xff4455, 0xddaa44, 0xaa2233)

        // Hexagonal platform (same as grape-gun)
        const platformGeo = new THREE.CylinderGeometry(0.75, 0.85, 0.18, 6);
        const platformMat = new THREE.MeshPhongMaterial({
          color: 0x4a2020,
          shininess: 70,
          specular: 0x885544,
          emissive: 0x2a1010,
          emissiveIntensity: 0.15
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.09;
        group.add(platform);

        // 6 energy channels on platform
        for (let i = 0; i < 6; i++) {
          const channelGeo = new THREE.BoxGeometry(0.06, 0.05, 0.35);
          const channelMat = new THREE.MeshPhongMaterial({
            color: 0xff4455,
            emissive: 0xaa2233,
            emissiveIntensity: 0.9,
            shininess: 100
          });
          const channel = new THREE.Mesh(channelGeo, channelMat);
          const angle = (i / 6) * Math.PI * 2;
          channel.position.set(
            Math.cos(angle) * 0.55,
            0.12,
            Math.sin(angle) * 0.55
          );
          channel.rotation.y = angle;
          group.add(channel);
        }

        // Ring trim (TorusGeometry 0.55, 0.06) - gold
        const innerRingGeo = new THREE.TorusGeometry(0.55, 0.06, 8, 20);
        const innerRingMat = new THREE.MeshPhongMaterial({
          color: 0xddaa44,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0xaa7722,
          emissiveIntensity: 0.3
        });
        const innerRing = new THREE.Mesh(innerRingGeo, innerRingMat);
        innerRing.position.y = 0.15;
        innerRing.rotation.x = Math.PI / 2;
        group.add(innerRing);

        // 3 pots along X-axis (xOffset = (i-1) * 0.55)
        for (let i = 0; i < 3; i++) {
          const xOffset = (i - 1) * 0.55;

          // Main pot body
          const potGeo = new THREE.CylinderGeometry(0.22, 0.18, 0.28, 16);
          const potMat = new THREE.MeshPhongMaterial({
            color: 0x6a3030,
            shininess: 60,
            specular: 0x885544,
            emissive: 0x3a1818,
            emissiveIntensity: 0.1
          });
          const pot = new THREE.Mesh(potGeo, potMat);
          pot.position.set(xOffset, 0.32, 0);
          group.add(pot);

          // Gold rim on pot
          const rimGeo = new THREE.TorusGeometry(0.22, 0.035, 8, 16);
          const rimMat = new THREE.MeshPhongMaterial({
            color: 0xddaa44,
            shininess: 150,
            specular: 0xffffff,
            emissive: 0xaa7722,
            emissiveIntensity: 0.4
          });
          const rim = new THREE.Mesh(rimGeo, rimMat);
          rim.position.set(xOffset, 0.46, 0);
          rim.rotation.x = Math.PI / 2;
          group.add(rim);

          // Decorative emblem on pot
          const emblemGeo = new THREE.SphereGeometry(0.06, 10, 10);
          const emblemMat = new THREE.MeshPhongMaterial({
            color: 0xff6677,
            emissive: 0xaa3344,
            emissiveIntensity: 0.5,
            shininess: 100
          });
          for (let e = 0; e < 3; e++) {
            const emblem = new THREE.Mesh(emblemGeo, emblemMat);
            emblem.position.set(xOffset, 0.28 + e * 0.08, 0.2);
            emblem.scale.set(0.8 - e * 0.15, 0.8 - e * 0.15, 0.5);
            group.add(emblem);
          }

          // Decorative vines wrapping pot
          const vineGeo = new THREE.TorusGeometry(0.24, 0.02, 6, 16);
          const vineMat = new THREE.MeshPhongMaterial({
            color: 0x2d5a1e,
            shininess: 40
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(xOffset, 0.35, 0);
          vine.rotation.x = Math.PI / 2;
          vine.rotation.z = i * 0.5;
          group.add(vine);
        }

        // 3 grape clusters with 8 LARGE grapes each (0.1 radius spheres)
        for (let side = 0; side < 3; side++) {
          const xOffset = (side - 1) * 0.55;

          // Main cluster core with glow
          const clusterGeo = new THREE.SphereGeometry(0.22, 16, 16);
          const clusterMat = new THREE.MeshPhongMaterial({
            color: 0xcc3344,
            shininess: 100,
            emissive: 0x882233,
            emissiveIntensity: 0.4
          });
          const cluster = new THREE.Mesh(clusterGeo, clusterMat);
          cluster.position.set(xOffset, 0.72, 0);
          group.add(cluster);

          // 8 individual grapes around each cluster (0.1 radius)
          for (let j = 0; j < 8; j++) {
            const grapeGeo = new THREE.SphereGeometry(0.1, 12, 12);
            const grapeMat = new THREE.MeshPhongMaterial({
              color: 0xff4455,
              shininess: 120,
              specular: 0xff8899,
              emissive: 0xaa2233,
              emissiveIntensity: 0.35
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            const angle = (j / 8) * Math.PI * 2;
            const heightOffset = (j % 2) * 0.1;
            grape.position.set(
              xOffset + Math.cos(angle) * 0.22,
              0.58 + heightOffset,
              Math.sin(angle) * 0.22
            );
            group.add(grape);

            // Highlight on each grape
            const highlightGeo = new THREE.SphereGeometry(0.03, 8, 8);
            const highlightMat = new THREE.MeshBasicMaterial({
              color: 0xffffff,
              transparent: true,
              opacity: 0.8
            });
            const highlight = new THREE.Mesh(highlightGeo, highlightMat);
            highlight.position.set(
              xOffset + Math.cos(angle) * 0.22 + 0.04,
              0.62 + heightOffset,
              Math.sin(angle) * 0.22 + 0.04
            );
            group.add(highlight);
          }

          // Glowing core inside each cluster
          const coreGeo = new THREE.SphereGeometry(0.12, 12, 12);
          const coreMat = new THREE.MeshBasicMaterial({
            color: 0xff8899,
            transparent: true,
            opacity: 0.6
          });
          const core = new THREE.Mesh(coreGeo, coreMat);
          core.position.set(xOffset, 0.72, 0);
          group.add(core);

          // Leaf on top of each cluster
          const leafGeo = new THREE.SphereGeometry(0.12, 8, 8);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x228822,
            shininess: 50,
            emissive: 0x114411,
            emissiveIntensity: 0.2
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(1.5, 0.3, 1);
          leaf.position.set(xOffset + 0.1, 0.92, 0.05);
          leaf.rotation.z = 0.3;
          group.add(leaf);
        }

        // Central energy hub connecting all clusters
        const hubGeo = new THREE.SphereGeometry(0.18, 16, 16);
        const hubMat = new THREE.MeshPhongMaterial({
          color: 0xff4455,
          emissive: 0xaa2233,
          emissiveIntensity: 0.9,
          shininess: 150,
          transparent: true,
          opacity: 0.9
        });
        const hub = new THREE.Mesh(hubGeo, hubMat);
        hub.position.set(0, 0.85, 0);
        group.add(hub);

        // Hub glow effect
        const hubGlowGeo = new THREE.SphereGeometry(0.28, 12, 12);
        const hubGlowMat = new THREE.MeshBasicMaterial({
          color: 0xff6677,
          transparent: true,
          opacity: 0.35
        });
        const hubGlow = new THREE.Mesh(hubGlowGeo, hubGlowMat);
        hubGlow.position.set(0, 0.85, 0);
        group.add(hubGlow);

        // Energy connections from hub to each cluster
        for (let i = 0; i < 3; i++) {
          const xOffset = (i - 1) * 0.55;
          const tubeGeo = new THREE.CylinderGeometry(0.03, 0.03, 0.35, 8);
          const tubeMat = new THREE.MeshPhongMaterial({
            color: 0xff4455,
            emissive: 0xaa2233,
            emissiveIntensity: 0.7,
            shininess: 100
          });
          const tube = new THREE.Mesh(tubeGeo, tubeMat);
          tube.position.set(xOffset * 0.5, 0.78, 0);
          tube.rotation.z = Math.PI / 2;
          if (i !== 1) {
            tube.rotation.z += (i === 0 ? 0.2 : -0.2);
          }
          group.add(tube);
        }

        // Create turret group for rotatable barrels
        const turretGroup = new THREE.Group();
        turretGroup.position.set(0, 0.85, 0);
        group.add(turretGroup);
        group.userData.turret = turretGroup;

        // Triple gatling barrels with glowing tips
        const barrelPositions = [
          { x: -0.18, z: 0.25 },
          { x: 0, z: 0.35 },
          { x: 0.18, z: 0.25 }
        ];

        for (let b = 0; b < 3; b++) {
          // Main barrel housing
          const housingGeo = new THREE.CylinderGeometry(0.12, 0.1, 0.2, 12);
          const housingMat = new THREE.MeshPhongMaterial({
            color: 0x444455,
            shininess: 120,
            specular: 0x888899
          });
          const housing = new THREE.Mesh(housingGeo, housingMat);
          housing.position.set(barrelPositions[b].x, 0.1, barrelPositions[b].z);
          housing.rotation.x = Math.PI / 4;
          turretGroup.add(housing);

          // Barrel tube
          const barrelGeo = new THREE.CylinderGeometry(0.07, 0.06, 0.45, 16);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x333344,
            shininess: 100,
            specular: 0x666677
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.position.set(
            barrelPositions[b].x,
            0.25 + b * 0.02,
            barrelPositions[b].z + 0.22
          );
          barrel.rotation.x = Math.PI / 4;
          turretGroup.add(barrel);

          // Barrel rings
          for (let r = 0; r < 2; r++) {
            const ringGeo = new THREE.TorusGeometry(0.075, 0.015, 6, 12);
            const ringMat = new THREE.MeshPhongMaterial({
              color: 0x666677,
              shininess: 100
            });
            const ring = new THREE.Mesh(ringGeo, ringMat);
            ring.position.set(
              barrelPositions[b].x,
              0.15 + r * 0.15 + b * 0.02,
              barrelPositions[b].z + 0.15 + r * 0.1
            );
            ring.rotation.x = Math.PI / 4 + Math.PI / 2;
            turretGroup.add(ring);
          }

          // Glowing muzzle tip (red/pink)
          const tipGeo = new THREE.SphereGeometry(0.08, 12, 12);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0xff6677,
            emissive: 0xcc4455,
            emissiveIntensity: 0.9,
            shininess: 150
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(
            barrelPositions[b].x,
            0.43 + b * 0.02,
            barrelPositions[b].z + 0.42
          );
          turretGroup.add(tip);

          // Muzzle glow effect
          const tipGlowGeo = new THREE.SphereGeometry(0.12, 10, 10);
          const tipGlowMat = new THREE.MeshBasicMaterial({
            color: 0xff6677,
            transparent: true,
            opacity: 0.5
          });
          const tipGlow = new THREE.Mesh(tipGlowGeo, tipGlowMat);
          tipGlow.position.copy(tip.position);
          turretGroup.add(tipGlow);
        }

        // Ammo belt visual connecting clusters to barrels
        for (let i = 0; i < 2; i++) {
          const beltGeo = new THREE.CylinderGeometry(0.025, 0.025, 0.4, 8);
          const beltMat = new THREE.MeshPhongMaterial({
            color: 0xff4455,
            emissive: 0xaa2233,
            emissiveIntensity: 0.4,
            shininess: 80
          });
          const belt = new THREE.Mesh(beltGeo, beltMat);
          const xPos = i === 0 ? -0.35 : 0.35;
          belt.position.set(xPos, -0.05, 0.15);
          belt.rotation.x = Math.PI / 3;
          belt.rotation.z = i === 0 ? 0.3 : -0.3;
          turretGroup.add(belt);
        }

        // Overall aura glow
        const auraGeo = new THREE.SphereGeometry(0.9, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xff4455,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.7;
        group.add(aura);

        // === THORNBOMBER ENHANCEMENTS ===
        // Deadly thorns radiating from each cluster
        for (let tc = 0; tc < 3; tc++) {
          const tcX = (tc - 1) * 0.55;
          for (let th = 0; th < 6; th++) {
            const thornGeo = new THREE.ConeGeometry(0.04, 0.25, 5);
            const thornMat = new THREE.MeshPhongMaterial({
              color: 0x4a2a1a, shininess: 80, specular: 0x6a4a3a, emissive: 0x2a1a0a, emissiveIntensity: 0.2
            });
            const thorn = new THREE.Mesh(thornGeo, thornMat);
            const thAngle = (th / 6) * Math.PI * 2;
            thorn.position.set(tcX + Math.cos(thAngle) * 0.32, 0.65, Math.sin(thAngle) * 0.32);
            thorn.rotation.z = Math.cos(thAngle) * (Math.PI / 2.5);
            thorn.rotation.x = Math.sin(thAngle) * (Math.PI / 2.5);
            group.add(thorn);

            // Glowing thorn tip
            const tipGeo = new THREE.ConeGeometry(0.015, 0.06, 4);
            const tipMat = new THREE.MeshBasicMaterial({ color: 0xff6644, transparent: true, opacity: 0.8 });
            const tip = new THREE.Mesh(tipGeo, tipMat);
            tip.position.set(tcX + Math.cos(thAngle) * 0.42, 0.68, Math.sin(thAngle) * 0.42);
            tip.rotation.copy(thorn.rotation);
            group.add(tip);
          }
        }

        // Rose petals around hub
        for (let rp = 0; rp < 8; rp++) {
          const petalGeo = new THREE.SphereGeometry(0.07, 8, 8);
          petalGeo.scale(1.5, 0.25, 1);
          const petalMat = new THREE.MeshPhongMaterial({
            color: rp % 2 === 0 ? 0xff4466 : 0xcc3355, shininess: 100, emissive: 0xaa2244, emissiveIntensity: 0.3, side: THREE.DoubleSide
          });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          const rpAngle = (rp / 8) * Math.PI * 2;
          petal.position.set(Math.cos(rpAngle) * 0.22, 0.88, Math.sin(rpAngle) * 0.22);
          petal.rotation.set(0.4, rpAngle, Math.PI / 4);
          group.add(petal);
        }

        // Bomb orbs at base
        for (let bo = 0; bo < 3; bo++) {
          const bombGeo = new THREE.SphereGeometry(0.08, 12, 12);
          const bombMat = new THREE.MeshPhongMaterial({
            color: 0x222222, shininess: 100, emissive: 0xff4400, emissiveIntensity: 0.5
          });
          const bomb = new THREE.Mesh(bombGeo, bombMat);
          const boAngle = (bo / 3) * Math.PI * 2 + 0.5;
          bomb.position.set(Math.cos(boAngle) * 0.6, 0.15, Math.sin(boAngle) * 0.6);
          group.add(bomb);

          // Fuse
          const fuseGeo = new THREE.CylinderGeometry(0.012, 0.015, 0.1, 6);
          const fuseMat = new THREE.MeshBasicMaterial({ color: 0xff8800 });
          const fuse = new THREE.Mesh(fuseGeo, fuseMat);
          fuse.position.set(Math.cos(boAngle) * 0.6, 0.25, Math.sin(boAngle) * 0.6);
          group.add(fuse);

          // Spark
          const sparkGeo = new THREE.SphereGeometry(0.025, 8, 8);
          const sparkMat = new THREE.MeshBasicMaterial({ color: 0xffff00 });
          const spark = new THREE.Mesh(sparkGeo, sparkMat);
          spark.position.set(Math.cos(boAngle) * 0.6, 0.32, Math.sin(boAngle) * 0.6);
          group.add(spark);
        }

        // Fire particles
        for (let fp = 0; fp < 10; fp++) {
          const fireGeo = new THREE.SphereGeometry(0.025, 6, 6);
          const fireMat = new THREE.MeshBasicMaterial({
            color: fp % 2 === 0 ? 0xff6622 : 0xffaa00, transparent: true, opacity: 0.7
          });
          const fire = new THREE.Mesh(fireGeo, fireMat);
          fire.position.set((Math.random() - 0.5) * 1.2, 0.2 + Math.random() * 0.6, (Math.random() - 0.5) * 1.2);
          group.add(fire);
        }

        break;
      }

      case 'titan-reaper-peall': {
        // 2nd Form Odd Fusion - Dark purple/silver themed grape-gun with cyan glow
        // Colors: Dark purple/silver (0x2a2a4e, 0x8888aa, 0x88ffff)

        // Hexagonal platform (same as grape-gun)
        const platformGeo = new THREE.CylinderGeometry(0.75, 0.85, 0.18, 6);
        const platformMat = new THREE.MeshPhongMaterial({
          color: 0x2a2a4e,
          shininess: 70,
          specular: 0x5a5a7e,
          emissive: 0x1a1a3e,
          emissiveIntensity: 0.15
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.09;
        group.add(platform);

        // 6 energy channels on platform
        for (let i = 0; i < 6; i++) {
          const channelGeo = new THREE.BoxGeometry(0.06, 0.05, 0.35);
          const channelMat = new THREE.MeshPhongMaterial({
            color: 0x88ffff,
            emissive: 0x44cccc,
            emissiveIntensity: 0.9,
            shininess: 100
          });
          const channel = new THREE.Mesh(channelGeo, channelMat);
          const angle = (i / 6) * Math.PI * 2;
          channel.position.set(
            Math.cos(angle) * 0.55,
            0.12,
            Math.sin(angle) * 0.55
          );
          channel.rotation.y = angle;
          group.add(channel);
        }

        // Ring trim (TorusGeometry 0.55, 0.06) - silver
        const innerRingGeo = new THREE.TorusGeometry(0.55, 0.06, 8, 20);
        const innerRingMat = new THREE.MeshPhongMaterial({
          color: 0x8888aa,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0x4444aa,
          emissiveIntensity: 0.3
        });
        const innerRing = new THREE.Mesh(innerRingGeo, innerRingMat);
        innerRing.position.y = 0.15;
        innerRing.rotation.x = Math.PI / 2;
        group.add(innerRing);

        // 3 pots along X-axis (xOffset = (i-1) * 0.55)
        for (let i = 0; i < 3; i++) {
          const xOffset = (i - 1) * 0.55;

          // Main pot body
          const potGeo = new THREE.CylinderGeometry(0.22, 0.18, 0.28, 16);
          const potMat = new THREE.MeshPhongMaterial({
            color: 0x3a3a5e,
            shininess: 60,
            specular: 0x5a5a7e,
            emissive: 0x1a1a3e,
            emissiveIntensity: 0.1
          });
          const pot = new THREE.Mesh(potGeo, potMat);
          pot.position.set(xOffset, 0.32, 0);
          group.add(pot);

          // Silver rim on pot
          const rimGeo = new THREE.TorusGeometry(0.22, 0.035, 8, 16);
          const rimMat = new THREE.MeshPhongMaterial({
            color: 0x8888aa,
            shininess: 150,
            specular: 0xffffff,
            emissive: 0x4444aa,
            emissiveIntensity: 0.4
          });
          const rim = new THREE.Mesh(rimGeo, rimMat);
          rim.position.set(xOffset, 0.46, 0);
          rim.rotation.x = Math.PI / 2;
          group.add(rim);

          // Decorative emblem on pot
          const emblemGeo = new THREE.SphereGeometry(0.06, 10, 10);
          const emblemMat = new THREE.MeshPhongMaterial({
            color: 0x88ffff,
            emissive: 0x44cccc,
            emissiveIntensity: 0.5,
            shininess: 100
          });
          for (let e = 0; e < 3; e++) {
            const emblem = new THREE.Mesh(emblemGeo, emblemMat);
            emblem.position.set(xOffset, 0.28 + e * 0.08, 0.2);
            emblem.scale.set(0.8 - e * 0.15, 0.8 - e * 0.15, 0.5);
            group.add(emblem);
          }

          // Decorative vines wrapping pot
          const vineGeo = new THREE.TorusGeometry(0.24, 0.02, 6, 16);
          const vineMat = new THREE.MeshPhongMaterial({
            color: 0x2a2a4e,
            shininess: 40
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(xOffset, 0.35, 0);
          vine.rotation.x = Math.PI / 2;
          vine.rotation.z = i * 0.5;
          group.add(vine);
        }

        // 3 grape clusters with 8 LARGE grapes each (0.1 radius spheres)
        for (let side = 0; side < 3; side++) {
          const xOffset = (side - 1) * 0.55;

          // Main cluster core with glow
          const clusterGeo = new THREE.SphereGeometry(0.22, 16, 16);
          const clusterMat = new THREE.MeshPhongMaterial({
            color: 0x5555aa,
            shininess: 100,
            emissive: 0x333388,
            emissiveIntensity: 0.4
          });
          const cluster = new THREE.Mesh(clusterGeo, clusterMat);
          cluster.position.set(xOffset, 0.72, 0);
          group.add(cluster);

          // 8 individual grapes around each cluster (0.1 radius)
          for (let j = 0; j < 8; j++) {
            const grapeGeo = new THREE.SphereGeometry(0.1, 12, 12);
            const grapeMat = new THREE.MeshPhongMaterial({
              color: 0x6666bb,
              shininess: 120,
              specular: 0x8888cc,
              emissive: 0x444488,
              emissiveIntensity: 0.35
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            const angle = (j / 8) * Math.PI * 2;
            const heightOffset = (j % 2) * 0.1;
            grape.position.set(
              xOffset + Math.cos(angle) * 0.22,
              0.58 + heightOffset,
              Math.sin(angle) * 0.22
            );
            group.add(grape);

            // Highlight on each grape
            const highlightGeo = new THREE.SphereGeometry(0.03, 8, 8);
            const highlightMat = new THREE.MeshBasicMaterial({
              color: 0xffffff,
              transparent: true,
              opacity: 0.8
            });
            const highlight = new THREE.Mesh(highlightGeo, highlightMat);
            highlight.position.set(
              xOffset + Math.cos(angle) * 0.22 + 0.04,
              0.62 + heightOffset,
              Math.sin(angle) * 0.22 + 0.04
            );
            group.add(highlight);
          }

          // Glowing core inside each cluster
          const coreGeo = new THREE.SphereGeometry(0.12, 12, 12);
          const coreMat = new THREE.MeshBasicMaterial({
            color: 0x88ffff,
            transparent: true,
            opacity: 0.6
          });
          const core = new THREE.Mesh(coreGeo, coreMat);
          core.position.set(xOffset, 0.72, 0);
          group.add(core);

          // Leaf on top of each cluster
          const leafGeo = new THREE.SphereGeometry(0.12, 8, 8);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x4444aa,
            shininess: 50,
            emissive: 0x222288,
            emissiveIntensity: 0.2
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(1.5, 0.3, 1);
          leaf.position.set(xOffset + 0.1, 0.92, 0.05);
          leaf.rotation.z = 0.3;
          group.add(leaf);
        }

        // Central energy hub connecting all clusters
        const hubGeo = new THREE.SphereGeometry(0.18, 16, 16);
        const hubMat = new THREE.MeshPhongMaterial({
          color: 0x88ffff,
          emissive: 0x44cccc,
          emissiveIntensity: 0.9,
          shininess: 150,
          transparent: true,
          opacity: 0.9
        });
        const hub = new THREE.Mesh(hubGeo, hubMat);
        hub.position.set(0, 0.85, 0);
        group.add(hub);

        // Hub glow effect
        const hubGlowGeo = new THREE.SphereGeometry(0.28, 12, 12);
        const hubGlowMat = new THREE.MeshBasicMaterial({
          color: 0x88ffff,
          transparent: true,
          opacity: 0.35
        });
        const hubGlow = new THREE.Mesh(hubGlowGeo, hubGlowMat);
        hubGlow.position.set(0, 0.85, 0);
        group.add(hubGlow);

        // Energy connections from hub to each cluster
        for (let i = 0; i < 3; i++) {
          const xOffset = (i - 1) * 0.55;
          const tubeGeo = new THREE.CylinderGeometry(0.03, 0.03, 0.35, 8);
          const tubeMat = new THREE.MeshPhongMaterial({
            color: 0x88ffff,
            emissive: 0x44cccc,
            emissiveIntensity: 0.7,
            shininess: 100
          });
          const tube = new THREE.Mesh(tubeGeo, tubeMat);
          tube.position.set(xOffset * 0.5, 0.78, 0);
          tube.rotation.z = Math.PI / 2;
          if (i !== 1) {
            tube.rotation.z += (i === 0 ? 0.2 : -0.2);
          }
          group.add(tube);
        }

        // Create turret group for rotatable barrels
        const turretGroup = new THREE.Group();
        turretGroup.position.set(0, 0.85, 0);
        group.add(turretGroup);
        group.userData.turret = turretGroup;

        // Triple gatling barrels with glowing tips
        const barrelPositions = [
          { x: -0.18, z: 0.25 },
          { x: 0, z: 0.35 },
          { x: 0.18, z: 0.25 }
        ];

        for (let b = 0; b < 3; b++) {
          // Main barrel housing
          const housingGeo = new THREE.CylinderGeometry(0.12, 0.1, 0.2, 12);
          const housingMat = new THREE.MeshPhongMaterial({
            color: 0x444455,
            shininess: 120,
            specular: 0x888899
          });
          const housing = new THREE.Mesh(housingGeo, housingMat);
          housing.position.set(barrelPositions[b].x, 0.1, barrelPositions[b].z);
          housing.rotation.x = Math.PI / 4;
          turretGroup.add(housing);

          // Barrel tube
          const barrelGeo = new THREE.CylinderGeometry(0.07, 0.06, 0.45, 16);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x333344,
            shininess: 100,
            specular: 0x666677
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.position.set(
            barrelPositions[b].x,
            0.25 + b * 0.02,
            barrelPositions[b].z + 0.22
          );
          barrel.rotation.x = Math.PI / 4;
          turretGroup.add(barrel);

          // Barrel rings
          for (let r = 0; r < 2; r++) {
            const ringGeo = new THREE.TorusGeometry(0.075, 0.015, 6, 12);
            const ringMat = new THREE.MeshPhongMaterial({
              color: 0x666677,
              shininess: 100
            });
            const ring = new THREE.Mesh(ringGeo, ringMat);
            ring.position.set(
              barrelPositions[b].x,
              0.15 + r * 0.15 + b * 0.02,
              barrelPositions[b].z + 0.15 + r * 0.1
            );
            ring.rotation.x = Math.PI / 4 + Math.PI / 2;
            turretGroup.add(ring);
          }

          // Glowing muzzle tip (cyan)
          const tipGeo = new THREE.SphereGeometry(0.08, 12, 12);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0x88ffff,
            emissive: 0x44cccc,
            emissiveIntensity: 0.9,
            shininess: 150
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(
            barrelPositions[b].x,
            0.43 + b * 0.02,
            barrelPositions[b].z + 0.42
          );
          turretGroup.add(tip);

          // Muzzle glow effect
          const tipGlowGeo = new THREE.SphereGeometry(0.12, 10, 10);
          const tipGlowMat = new THREE.MeshBasicMaterial({
            color: 0x88ffff,
            transparent: true,
            opacity: 0.5
          });
          const tipGlow = new THREE.Mesh(tipGlowGeo, tipGlowMat);
          tipGlow.position.copy(tip.position);
          turretGroup.add(tipGlow);
        }

        // Ammo belt visual connecting clusters to barrels
        for (let i = 0; i < 2; i++) {
          const beltGeo = new THREE.CylinderGeometry(0.025, 0.025, 0.4, 8);
          const beltMat = new THREE.MeshPhongMaterial({
            color: 0x6666bb,
            emissive: 0x444488,
            emissiveIntensity: 0.4,
            shininess: 80
          });
          const belt = new THREE.Mesh(beltGeo, beltMat);
          const xPos = i === 0 ? -0.35 : 0.35;
          belt.position.set(xPos, -0.05, 0.15);
          belt.rotation.x = Math.PI / 3;
          belt.rotation.z = i === 0 ? 0.3 : -0.3;
          turretGroup.add(belt);
        }

        // Overall aura glow
        const auraGeo = new THREE.SphereGeometry(0.9, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x88ffff,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.7;
        group.add(aura);

        // === TITAN REAPER ENHANCEMENTS ===
        // Floating skull on hub
        const skullGeo = new THREE.SphereGeometry(0.12, 14, 14);
        skullGeo.scale(1, 1.15, 0.85);
        const skullMat = new THREE.MeshPhongMaterial({
          color: 0xeeeeee, shininess: 120, specular: 0xffffff, emissive: 0x888888, emissiveIntensity: 0.2
        });
        const skull = new THREE.Mesh(skullGeo, skullMat);
        skull.position.set(0, 1.05, 0);
        group.add(skull);

        // Skull eyes
        for (let se = 0; se < 2; se++) {
          const eyeGeo = new THREE.SphereGeometry(0.03, 8, 8);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0x88ffff });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set((se - 0.5) * 0.07, 1.08, 0.08);
          group.add(eye);
        }

        // Scythe blades on sides
        for (let sb = 0; sb < 2; sb++) {
          const handleGeo = new THREE.CylinderGeometry(0.025, 0.03, 0.6, 8);
          const handleMat = new THREE.MeshPhongMaterial({ color: 0x2a1a2a, shininess: 50 });
          const handle = new THREE.Mesh(handleGeo, handleMat);
          handle.position.set((sb === 0 ? -0.65 : 0.65), 0.6, 0);
          handle.rotation.z = (sb === 0 ? -1 : 1) * 0.35;
          group.add(handle);

          const bladeGeo = new THREE.TorusGeometry(0.15, 0.015, 6, 12, Math.PI * 0.7);
          const bladeMat = new THREE.MeshPhongMaterial({
            color: 0x9999bb, shininess: 220, specular: 0xeeeeff, emissive: 0x5555aa, emissiveIntensity: 0.35
          });
          const blade = new THREE.Mesh(bladeGeo, bladeMat);
          blade.position.set((sb === 0 ? -0.78 : 0.78), 0.92, 0);
          blade.rotation.set(0, Math.PI / 2, (sb === 0 ? -1 : 1) * 1.1);
          group.add(blade);
        }

        // Soul wisps orbiting
        for (let sw = 0; sw < 10; sw++) {
          const wispGeo = new THREE.SphereGeometry(0.035, 8, 8);
          const wispMat = new THREE.MeshBasicMaterial({
            color: 0x88ffff, transparent: true, opacity: 0.7
          });
          const wisp = new THREE.Mesh(wispGeo, wispMat);
          const swAngle = (sw / 10) * Math.PI * 2;
          wisp.position.set(
            Math.cos(swAngle) * (0.5 + (sw % 3) * 0.15),
            0.4 + Math.sin(sw * 2) * 0.2,
            Math.sin(swAngle) * (0.5 + (sw % 3) * 0.15)
          );
          group.add(wisp);
        }

        // Dark chains
        for (let ch = 0; ch < 4; ch++) {
          const chAngle = (ch / 4) * Math.PI * 2 + 0.4;
          for (let link = 0; link < 3; link++) {
            const linkGeo = new THREE.TorusGeometry(0.03, 0.008, 6, 8);
            const linkMat = new THREE.MeshPhongMaterial({ color: 0x444466, shininess: 100 });
            const chainLink = new THREE.Mesh(linkGeo, linkMat);
            chainLink.position.set(Math.cos(chAngle) * 0.7, 0.12 + link * 0.05, Math.sin(chAngle) * 0.7);
            chainLink.rotation.x = Math.PI / 2 + (link % 2) * (Math.PI / 2);
            group.add(chainLink);
          }
        }

        break;
      }

      case 'frozen-nebula-mushroom': {
        // 2nd Form Odd Fusion - Deep purple/cosmic themed grape-gun
        // Colors: Deep purple/cosmic (0x6622aa, 0xaa55ff, 0xff44aa)

        // Hexagonal platform (same as grape-gun)
        const platformGeo = new THREE.CylinderGeometry(0.75, 0.85, 0.18, 6);
        const platformMat = new THREE.MeshPhongMaterial({
          color: 0x2a1a4a,
          shininess: 70,
          specular: 0x5544aa,
          emissive: 0x1a1030,
          emissiveIntensity: 0.15
        });
        const platform = new THREE.Mesh(platformGeo, platformMat);
        platform.position.y = 0.09;
        group.add(platform);

        // 6 energy channels on platform
        for (let i = 0; i < 6; i++) {
          const channelGeo = new THREE.BoxGeometry(0.06, 0.05, 0.35);
          const channelMat = new THREE.MeshPhongMaterial({
            color: 0xaa55ff,
            emissive: 0x7733cc,
            emissiveIntensity: 0.9,
            shininess: 100
          });
          const channel = new THREE.Mesh(channelGeo, channelMat);
          const angle = (i / 6) * Math.PI * 2;
          channel.position.set(
            Math.cos(angle) * 0.55,
            0.12,
            Math.sin(angle) * 0.55
          );
          channel.rotation.y = angle;
          group.add(channel);
        }

        // Ring trim (TorusGeometry 0.55, 0.06) - cosmic purple
        const innerRingGeo = new THREE.TorusGeometry(0.55, 0.06, 8, 20);
        const innerRingMat = new THREE.MeshPhongMaterial({
          color: 0xff44aa,
          shininess: 150,
          specular: 0xffffff,
          emissive: 0xcc2288,
          emissiveIntensity: 0.3
        });
        const innerRing = new THREE.Mesh(innerRingGeo, innerRingMat);
        innerRing.position.y = 0.15;
        innerRing.rotation.x = Math.PI / 2;
        group.add(innerRing);

        // 3 pots along X-axis (xOffset = (i-1) * 0.55)
        for (let i = 0; i < 3; i++) {
          const xOffset = (i - 1) * 0.55;

          // Main pot body
          const potGeo = new THREE.CylinderGeometry(0.22, 0.18, 0.28, 16);
          const potMat = new THREE.MeshPhongMaterial({
            color: 0x3a2860,
            shininess: 60,
            specular: 0x5544aa,
            emissive: 0x221444,
            emissiveIntensity: 0.1
          });
          const pot = new THREE.Mesh(potGeo, potMat);
          pot.position.set(xOffset, 0.32, 0);
          group.add(pot);

          // Cosmic rim on pot
          const rimGeo = new THREE.TorusGeometry(0.22, 0.035, 8, 16);
          const rimMat = new THREE.MeshPhongMaterial({
            color: 0xff44aa,
            shininess: 150,
            specular: 0xffffff,
            emissive: 0xcc2288,
            emissiveIntensity: 0.4
          });
          const rim = new THREE.Mesh(rimGeo, rimMat);
          rim.position.set(xOffset, 0.46, 0);
          rim.rotation.x = Math.PI / 2;
          group.add(rim);

          // Decorative emblem on pot
          const emblemGeo = new THREE.SphereGeometry(0.06, 10, 10);
          const emblemMat = new THREE.MeshPhongMaterial({
            color: 0xcc77ff,
            emissive: 0x8844cc,
            emissiveIntensity: 0.5,
            shininess: 100
          });
          for (let e = 0; e < 3; e++) {
            const emblem = new THREE.Mesh(emblemGeo, emblemMat);
            emblem.position.set(xOffset, 0.28 + e * 0.08, 0.2);
            emblem.scale.set(0.8 - e * 0.15, 0.8 - e * 0.15, 0.5);
            group.add(emblem);
          }

          // Decorative vines wrapping pot
          const vineGeo = new THREE.TorusGeometry(0.24, 0.02, 6, 16);
          const vineMat = new THREE.MeshPhongMaterial({
            color: 0x4422aa,
            shininess: 40
          });
          const vine = new THREE.Mesh(vineGeo, vineMat);
          vine.position.set(xOffset, 0.35, 0);
          vine.rotation.x = Math.PI / 2;
          vine.rotation.z = i * 0.5;
          group.add(vine);
        }

        // 3 grape clusters with 8 LARGE grapes each (0.1 radius spheres)
        for (let side = 0; side < 3; side++) {
          const xOffset = (side - 1) * 0.55;

          // Main cluster core with glow
          const clusterGeo = new THREE.SphereGeometry(0.22, 16, 16);
          const clusterMat = new THREE.MeshPhongMaterial({
            color: 0x7733cc,
            shininess: 100,
            emissive: 0x5522aa,
            emissiveIntensity: 0.4
          });
          const cluster = new THREE.Mesh(clusterGeo, clusterMat);
          cluster.position.set(xOffset, 0.72, 0);
          group.add(cluster);

          // 8 individual grapes around each cluster (0.1 radius)
          for (let j = 0; j < 8; j++) {
            const grapeGeo = new THREE.SphereGeometry(0.1, 12, 12);
            const grapeMat = new THREE.MeshPhongMaterial({
              color: 0xaa55ff,
              shininess: 120,
              specular: 0xcc88ff,
              emissive: 0x7733cc,
              emissiveIntensity: 0.35
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            const angle = (j / 8) * Math.PI * 2;
            const heightOffset = (j % 2) * 0.1;
            grape.position.set(
              xOffset + Math.cos(angle) * 0.22,
              0.58 + heightOffset,
              Math.sin(angle) * 0.22
            );
            group.add(grape);

            // Highlight on each grape
            const highlightGeo = new THREE.SphereGeometry(0.03, 8, 8);
            const highlightMat = new THREE.MeshBasicMaterial({
              color: 0xffffff,
              transparent: true,
              opacity: 0.8
            });
            const highlight = new THREE.Mesh(highlightGeo, highlightMat);
            highlight.position.set(
              xOffset + Math.cos(angle) * 0.22 + 0.04,
              0.62 + heightOffset,
              Math.sin(angle) * 0.22 + 0.04
            );
            group.add(highlight);
          }

          // Glowing core inside each cluster
          const coreGeo = new THREE.SphereGeometry(0.12, 12, 12);
          const coreMat = new THREE.MeshBasicMaterial({
            color: 0xff88cc,
            transparent: true,
            opacity: 0.6
          });
          const core = new THREE.Mesh(coreGeo, coreMat);
          core.position.set(xOffset, 0.72, 0);
          group.add(core);

          // Leaf on top of each cluster
          const leafGeo = new THREE.SphereGeometry(0.12, 8, 8);
          const leafMat = new THREE.MeshPhongMaterial({
            color: 0x6622aa,
            shininess: 50,
            emissive: 0x441188,
            emissiveIntensity: 0.2
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(1.5, 0.3, 1);
          leaf.position.set(xOffset + 0.1, 0.92, 0.05);
          leaf.rotation.z = 0.3;
          group.add(leaf);
        }

        // Central energy hub connecting all clusters
        const hubGeo = new THREE.SphereGeometry(0.18, 16, 16);
        const hubMat = new THREE.MeshPhongMaterial({
          color: 0xaa55ff,
          emissive: 0x7733cc,
          emissiveIntensity: 0.9,
          shininess: 150,
          transparent: true,
          opacity: 0.9
        });
        const hub = new THREE.Mesh(hubGeo, hubMat);
        hub.position.set(0, 0.85, 0);
        group.add(hub);

        // Hub glow effect
        const hubGlowGeo = new THREE.SphereGeometry(0.28, 12, 12);
        const hubGlowMat = new THREE.MeshBasicMaterial({
          color: 0xcc77ff,
          transparent: true,
          opacity: 0.35
        });
        const hubGlow = new THREE.Mesh(hubGlowGeo, hubGlowMat);
        hubGlow.position.set(0, 0.85, 0);
        group.add(hubGlow);

        // Energy connections from hub to each cluster
        for (let i = 0; i < 3; i++) {
          const xOffset = (i - 1) * 0.55;
          const tubeGeo = new THREE.CylinderGeometry(0.03, 0.03, 0.35, 8);
          const tubeMat = new THREE.MeshPhongMaterial({
            color: 0xaa55ff,
            emissive: 0x7733cc,
            emissiveIntensity: 0.7,
            shininess: 100
          });
          const tube = new THREE.Mesh(tubeGeo, tubeMat);
          tube.position.set(xOffset * 0.5, 0.78, 0);
          tube.rotation.z = Math.PI / 2;
          if (i !== 1) {
            tube.rotation.z += (i === 0 ? 0.2 : -0.2);
          }
          group.add(tube);
        }

        // Create turret group for rotatable barrels
        const turretGroup = new THREE.Group();
        turretGroup.position.set(0, 0.85, 0);
        group.add(turretGroup);
        group.userData.turret = turretGroup;

        // Triple gatling barrels with glowing tips
        const barrelPositions = [
          { x: -0.18, z: 0.25 },
          { x: 0, z: 0.35 },
          { x: 0.18, z: 0.25 }
        ];

        for (let b = 0; b < 3; b++) {
          // Main barrel housing
          const housingGeo = new THREE.CylinderGeometry(0.12, 0.1, 0.2, 12);
          const housingMat = new THREE.MeshPhongMaterial({
            color: 0x444455,
            shininess: 120,
            specular: 0x888899
          });
          const housing = new THREE.Mesh(housingGeo, housingMat);
          housing.position.set(barrelPositions[b].x, 0.1, barrelPositions[b].z);
          housing.rotation.x = Math.PI / 4;
          turretGroup.add(housing);

          // Barrel tube
          const barrelGeo = new THREE.CylinderGeometry(0.07, 0.06, 0.45, 16);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x333344,
            shininess: 100,
            specular: 0x666677
          });
          const barrel = new THREE.Mesh(barrelGeo, barrelMat);
          barrel.position.set(
            barrelPositions[b].x,
            0.25 + b * 0.02,
            barrelPositions[b].z + 0.22
          );
          barrel.rotation.x = Math.PI / 4;
          turretGroup.add(barrel);

          // Barrel rings
          for (let r = 0; r < 2; r++) {
            const ringGeo = new THREE.TorusGeometry(0.075, 0.015, 6, 12);
            const ringMat = new THREE.MeshPhongMaterial({
              color: 0x666677,
              shininess: 100
            });
            const ring = new THREE.Mesh(ringGeo, ringMat);
            ring.position.set(
              barrelPositions[b].x,
              0.15 + r * 0.15 + b * 0.02,
              barrelPositions[b].z + 0.15 + r * 0.1
            );
            ring.rotation.x = Math.PI / 4 + Math.PI / 2;
            turretGroup.add(ring);
          }

          // Glowing muzzle tip (cosmic purple/pink)
          const tipGeo = new THREE.SphereGeometry(0.08, 12, 12);
          const tipMat = new THREE.MeshPhongMaterial({
            color: 0xff66cc,
            emissive: 0xcc44aa,
            emissiveIntensity: 0.9,
            shininess: 150
          });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(
            barrelPositions[b].x,
            0.43 + b * 0.02,
            barrelPositions[b].z + 0.42
          );
          turretGroup.add(tip);

          // Muzzle glow effect
          const tipGlowGeo = new THREE.SphereGeometry(0.12, 10, 10);
          const tipGlowMat = new THREE.MeshBasicMaterial({
            color: 0xff66cc,
            transparent: true,
            opacity: 0.5
          });
          const tipGlow = new THREE.Mesh(tipGlowGeo, tipGlowMat);
          tipGlow.position.copy(tip.position);
          turretGroup.add(tipGlow);
        }

        // Ammo belt visual connecting clusters to barrels
        for (let i = 0; i < 2; i++) {
          const beltGeo = new THREE.CylinderGeometry(0.025, 0.025, 0.4, 8);
          const beltMat = new THREE.MeshPhongMaterial({
            color: 0xaa55ff,
            emissive: 0x7733cc,
            emissiveIntensity: 0.4,
            shininess: 80
          });
          const belt = new THREE.Mesh(beltGeo, beltMat);
          const xPos = i === 0 ? -0.35 : 0.35;
          belt.position.set(xPos, -0.05, 0.15);
          belt.rotation.x = Math.PI / 3;
          belt.rotation.z = i === 0 ? 0.3 : -0.3;
          turretGroup.add(belt);
        }

        // Overall aura glow
        const auraGeo = new THREE.SphereGeometry(0.9, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x6622aa,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.7;
        group.add(aura);

        // === FROZEN NEBULA MUSHROOM ENHANCEMENTS ===
        // Black hole on hub
        const blackHoleGeo = new THREE.SphereGeometry(0.1, 16, 16);
        const blackHoleMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
        const blackHole = new THREE.Mesh(blackHoleGeo, blackHoleMat);
        blackHole.position.set(0, 1.0, 0);
        group.add(blackHole);

        // Event horizon ring
        const horizonGeo = new THREE.TorusGeometry(0.14, 0.02, 8, 20);
        const horizonMat = new THREE.MeshBasicMaterial({ color: 0xaa55ff, transparent: true, opacity: 0.9 });
        const horizon = new THREE.Mesh(horizonGeo, horizonMat);
        horizon.position.set(0, 1.0, 0);
        horizon.rotation.x = Math.PI / 2;
        group.add(horizon);

        // Accretion disk
        const diskGeo = new THREE.RingGeometry(0.12, 0.28, 32);
        const diskMat = new THREE.MeshBasicMaterial({
          color: 0x8844ff, transparent: true, opacity: 0.4, side: THREE.DoubleSide
        });
        const disk = new THREE.Mesh(diskGeo, diskMat);
        disk.position.set(0, 1.0, 0);
        disk.rotation.x = Math.PI / 2;
        group.add(disk);

        // Nebula swirls on each cluster
        for (let nc = 0; nc < 3; nc++) {
          const ncX = (nc - 1) * 0.55;
          for (let ns = 0; ns < 2; ns++) {
            const swirlGeo = new THREE.TorusGeometry(0.15 + ns * 0.06, 0.015, 6, 16);
            const swirlMat = new THREE.MeshBasicMaterial({
              color: ns === 0 ? 0x8844ff : 0x4488ff, transparent: true, opacity: 0.5
            });
            const swirl = new THREE.Mesh(swirlGeo, swirlMat);
            swirl.position.set(ncX, 0.72 + ns * 0.02, 0);
            swirl.rotation.x = Math.PI / 2;
            swirl.rotation.z = ns * 0.6;
            group.add(swirl);
          }
        }

        // Orbiting cosmic crystals
        for (let oc = 0; oc < 10; oc++) {
          const crystalGeo = new THREE.OctahedronGeometry(0.05, 0);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: oc % 2 === 0 ? 0x88eeff : 0xee88ff,
            shininess: 220, transparent: true, opacity: 0.85, emissive: 0x6644aa, emissiveIntensity: 0.45
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const ocAngle = (oc / 10) * Math.PI * 2;
          crystal.position.set(
            Math.cos(ocAngle) * 0.72,
            0.5 + Math.sin(oc * 2.5) * 0.18,
            Math.sin(ocAngle) * 0.72
          );
          crystal.rotation.set(Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI);
          group.add(crystal);
        }

        // Star particles
        for (let sp = 0; sp < 20; sp++) {
          const starGeo = new THREE.SphereGeometry(0.02 + Math.random() * 0.015, 8, 8);
          const starMat = new THREE.MeshBasicMaterial({
            color: sp % 3 === 0 ? 0xffffff : sp % 3 === 1 ? 0xaaffff : 0xffaaff
          });
          const star = new THREE.Mesh(starGeo, starMat);
          star.position.set(
            (Math.random() - 0.5) * 1.4,
            0.3 + Math.random() * 0.9,
            (Math.random() - 0.5) * 1.4
          );
          group.add(star);
        }

        // Cosmic spore trails
        for (let st = 0; st < 8; st++) {
          const sporeGeo = new THREE.SphereGeometry(0.025, 8, 8);
          const sporeMat = new THREE.MeshBasicMaterial({
            color: st % 3 === 0 ? 0xaa44ff : st % 3 === 1 ? 0x44aaff : 0xff44aa,
            transparent: true, opacity: 0.75
          });
          const spore = new THREE.Mesh(sporeGeo, sporeMat);
          spore.position.set(
            (Math.random() - 0.5) * 1.0,
            0.9 + Math.random() * 0.4,
            (Math.random() - 0.5) * 1.0
          );
          group.add(spore);
        }

        break;
      }

      case 'grape-frospike': {
        // Fusion: Frost Grape Launcher + Tomato Spike OR Grape Spiker + Frost Berri
        // EPIC ICY GRAPE SPIKE LAUNCHER

        // Luxurious crystalline pot with gold trim
        const potGeo = new THREE.CylinderGeometry(0.4, 0.32, 0.35, 16);
        const potMat = new THREE.MeshPhongMaterial({
          color: 0x2a1a4a,
          shininess: 150,
          specular: 0x8866cc,
          emissive: 0x1a0a3a,
          emissiveIntensity: 0.3
        });
        const pot = new THREE.Mesh(potGeo, potMat);
        pot.position.y = 0.18;
        group.add(pot);

        // Gold trim ring on pot
        const trimGeo = new THREE.TorusGeometry(0.38, 0.03, 8, 24);
        const trimMat = new THREE.MeshPhongMaterial({
          color: 0xffd700,
          shininess: 200,
          specular: 0xffff88,
          emissive: 0xaa8800,
          emissiveIntensity: 0.3
        });
        const trim = new THREE.Mesh(trimGeo, trimMat);
        trim.rotation.x = Math.PI / 2;
        trim.position.y = 0.35;
        group.add(trim);

        // Frosted ice layer coating the pot
        const frostLayerGeo = new THREE.CylinderGeometry(0.42, 0.34, 0.38, 16);
        const frostLayerMat = new THREE.MeshPhongMaterial({
          color: 0x88ddff,
          shininess: 300,
          transparent: true,
          opacity: 0.35,
          emissive: 0x44aaff,
          emissiveIntensity: 0.4
        });
        const frostLayer = new THREE.Mesh(frostLayerGeo, frostLayerMat);
        frostLayer.position.y = 0.19;
        group.add(frostLayer);

        // Beautiful frozen grape cluster - layered and juicy looking
        const grapeColors = [0x7b3fa0, 0x9b4fc0, 0x6b2f90, 0x8b4fb0];
        for (let layer = 0; layer < 3; layer++) {
          const grapeCount = layer === 0 ? 6 : layer === 1 ? 5 : 3;
          for (let g = 0; g < grapeCount; g++) {
            const grapeGeo = new THREE.SphereGeometry(0.11 - layer * 0.015, 12, 12);
            const grapeMat = new THREE.MeshPhongMaterial({
              color: grapeColors[g % grapeColors.length],
              shininess: 180,
              specular: 0xddbbff,
              emissive: 0x3a1a5a,
              emissiveIntensity: 0.35
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            const angle = (g / grapeCount) * Math.PI * 2 + layer * 0.3;
            const radius = 0.18 - layer * 0.04;
            grape.position.set(
              Math.cos(angle) * radius,
              0.45 + layer * 0.12,
              Math.sin(angle) * radius
            );
            group.add(grape);

            // Frost shimmer on each grape
            const shimmerGeo = new THREE.SphereGeometry(0.12 - layer * 0.015, 12, 12);
            const shimmerMat = new THREE.MeshPhongMaterial({
              color: 0xaaeeff,
              shininess: 300,
              transparent: true,
              opacity: 0.25,
              emissive: 0x66ccff,
              emissiveIntensity: 0.5
            });
            const shimmer = new THREE.Mesh(shimmerGeo, shimmerMat);
            shimmer.position.copy(grape.position);
            group.add(shimmer);
          }
        }

        // Central grape stem
        const stemGeo = new THREE.CylinderGeometry(0.03, 0.05, 0.25, 8);
        const stemMat = new THREE.MeshPhongMaterial({ color: 0x2a5a2a, shininess: 30 });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.y = 0.8;
        group.add(stem);

        // EPIC ICE SPIKE CROWN - Main weapon
        const mainSpikeGeo = new THREE.ConeGeometry(0.14, 0.7, 8);
        const mainSpikeMat = new THREE.MeshPhongMaterial({
          color: 0x44ddff,
          shininess: 400,
          specular: 0xffffff,
          transparent: true,
          opacity: 0.92,
          emissive: 0x22aaff,
          emissiveIntensity: 0.6
        });
        const mainSpike = new THREE.Mesh(mainSpikeGeo, mainSpikeMat);
        mainSpike.position.y = 1.15;
        group.add(mainSpike);

        // Inner glow core for main spike
        const coreGeo = new THREE.ConeGeometry(0.06, 0.5, 6);
        const coreMat = new THREE.MeshBasicMaterial({
          color: 0xffffff,
          transparent: true,
          opacity: 0.6
        });
        const core = new THREE.Mesh(coreGeo, coreMat);
        core.position.y = 1.1;
        group.add(core);

        // Ring of smaller ice spikes around main
        for (let s = 0; s < 6; s++) {
          const spikeGeo = new THREE.ConeGeometry(0.06, 0.35, 6);
          const spikeMat = new THREE.MeshPhongMaterial({
            color: s % 2 === 0 ? 0x66eeff : 0x88ffff,
            shininess: 350,
            specular: 0xffffff,
            transparent: true,
            opacity: 0.88,
            emissive: 0x44ccff,
            emissiveIntensity: 0.5
          });
          const spike = new THREE.Mesh(spikeGeo, spikeMat);
          const angle = (s / 6) * Math.PI * 2;
          spike.position.set(Math.cos(angle) * 0.22, 0.85, Math.sin(angle) * 0.22);
          spike.rotation.x = -0.2;
          spike.rotation.z = -Math.sin(angle) * 0.25;
          group.add(spike);
        }

        // Floating ice crystals orbiting
        for (let c = 0; c < 4; c++) {
          const crystalGeo = new THREE.OctahedronGeometry(0.05, 0);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0xaaffff,
            shininess: 400,
            transparent: true,
            opacity: 0.85,
            emissive: 0x66ddff,
            emissiveIntensity: 0.6
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const angle = (c / 4) * Math.PI * 2;
          crystal.position.set(Math.cos(angle) * 0.4, 0.7 + Math.sin(c) * 0.1, Math.sin(angle) * 0.4);
          group.add(crystal);
        }

        // Magical frost aura
        const auraGeo = new THREE.SphereGeometry(0.55, 20, 20);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x66ccff,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.75;
        group.add(aura);

        // Sparkle particles
        for (let p = 0; p < 8; p++) {
          const sparkGeo = new THREE.SphereGeometry(0.015, 6, 6);
          const sparkMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const spark = new THREE.Mesh(sparkGeo, sparkMat);
          spark.position.set(
            (Math.random() - 0.5) * 0.6,
            0.4 + Math.random() * 0.8,
            (Math.random() - 0.5) * 0.6
          );
          group.add(spark);
        }

        break;
      }

      case 'frospike': {
        // Fusion: Frost Berri + Tomato Spike - Icy spike bomb

        // Dark crystalline base with frost-cracked surface
        const fsBaseGeo = new THREE.CylinderGeometry(0.45, 0.55, 0.25, 8);
        const fsBaseMat = new THREE.MeshPhongMaterial({
          color: 0x1a2244, shininess: 180, specular: 0x4466aa, emissive: 0x0a1133, emissiveIntensity: 0.3
        });
        const fsBase = new THREE.Mesh(fsBaseGeo, fsBaseMat);
        fsBase.position.y = 0.12;
        group.add(fsBase);

        // Frozen ground ring
        const fsRingGeo = new THREE.TorusGeometry(0.5, 0.05, 8, 24);
        const fsRingMat = new THREE.MeshPhongMaterial({
          color: 0x55ccff, shininess: 300, transparent: true, opacity: 0.6, emissive: 0x3399dd, emissiveIntensity: 0.4
        });
        const fsRing = new THREE.Mesh(fsRingGeo, fsRingMat);
        fsRing.rotation.x = Math.PI / 2;
        fsRing.position.y = 0.06;
        group.add(fsRing);

        // Frost cracks radiating from base
        for (let fc = 0; fc < 6; fc++) {
          const crackGeo = new THREE.BoxGeometry(0.02, 0.04, 0.35);
          const crackMat = new THREE.MeshBasicMaterial({ color: 0x66ddff, transparent: true, opacity: 0.85 });
          const crack = new THREE.Mesh(crackGeo, crackMat);
          const fcAngle = (fc / 6) * Math.PI * 2;
          crack.position.set(Math.cos(fcAngle) * 0.35, 0.06, Math.sin(fcAngle) * 0.35);
          crack.rotation.y = fcAngle;
          group.add(crack);
        }

        // Red berry core (from frost berri) encased in ice
        const fsBerryGeo = new THREE.SphereGeometry(0.22, 20, 20);
        const fsBerryMat = new THREE.MeshPhongMaterial({
          color: 0xdd3355, shininess: 120, specular: 0xff8899, emissive: 0x882233, emissiveIntensity: 0.4
        });
        const fsBerry = new THREE.Mesh(fsBerryGeo, fsBerryMat);
        fsBerry.position.y = 0.55;
        group.add(fsBerry);

        // Berry seeds
        for (let bs = 0; bs < 8; bs++) {
          const seedGeo = new THREE.SphereGeometry(0.03, 8, 8);
          const seedMat = new THREE.MeshPhongMaterial({ color: 0xffaaaa, shininess: 80 });
          const seed = new THREE.Mesh(seedGeo, seedMat);
          const bsAng = (bs / 8) * Math.PI * 2;
          const bsY = bs < 4 ? 0.5 : 0.6;
          seed.position.set(Math.cos(bsAng) * 0.19, bsY, Math.sin(bsAng) * 0.19);
          group.add(seed);
        }

        // Ice crystal shell encasing berry
        const fsShellGeo = new THREE.IcosahedronGeometry(0.3, 1);
        const fsShellMat = new THREE.MeshPhongMaterial({
          color: 0x88eeff, shininess: 400, transparent: true, opacity: 0.35,
          specular: 0xffffff, emissive: 0x44bbdd, emissiveIntensity: 0.3
        });
        const fsShell = new THREE.Mesh(fsShellGeo, fsShellMat);
        fsShell.position.y = 0.55;
        group.add(fsShell);

        // Inner white glow
        const fsGlowGeo = new THREE.SphereGeometry(0.14, 12, 12);
        const fsGlowMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.4 });
        const fsGlow = new THREE.Mesh(fsGlowGeo, fsGlowMat);
        fsGlow.position.y = 0.55;
        group.add(fsGlow);

        // MAIN central spike (tall, crystalline)
        const fsMainSpikeGeo = new THREE.ConeGeometry(0.14, 1.0, 6);
        const fsSpikeMat = new THREE.MeshPhongMaterial({
          color: 0x44ddff, shininess: 400, specular: 0xffffff,
          transparent: true, opacity: 0.92, emissive: 0x22aadd, emissiveIntensity: 0.6
        });
        const fsMainSpike = new THREE.Mesh(fsMainSpikeGeo, fsSpikeMat);
        fsMainSpike.position.y = 1.2;
        group.add(fsMainSpike);

        // Spike inner glow
        const fsSpikeCoreGeo = new THREE.ConeGeometry(0.05, 0.8, 6);
        const fsSpikeCoreMat = new THREE.MeshBasicMaterial({ color: 0xeeffff, transparent: true, opacity: 0.65 });
        const fsSpikeCore = new THREE.Mesh(fsSpikeCoreGeo, fsSpikeCoreMat);
        fsSpikeCore.position.y = 1.15;
        group.add(fsSpikeCore);

        // Crown of ice spikes radiating outward (tomato-spike style)
        for (let s = 0; s < 8; s++) {
          const sSpikeGeo = new THREE.ConeGeometry(0.06, 0.5 + (s % 3) * 0.08, 5);
          const sSpike = new THREE.Mesh(sSpikeGeo, fsSpikeMat);
          const sAngle = (s / 8) * Math.PI * 2;
          sSpike.position.set(Math.cos(sAngle) * 0.3, 0.6, Math.sin(sAngle) * 0.3);
          // Tilt outward
          sSpike.rotation.z = -Math.cos(sAngle) * 0.5;
          sSpike.rotation.x = Math.sin(sAngle) * 0.5;
          group.add(sSpike);
        }

        // Secondary ring of smaller downward-angled spikes
        for (let ds = 0; ds < 6; ds++) {
          const dSpikeGeo = new THREE.ConeGeometry(0.04, 0.35, 4);
          const dSpike = new THREE.Mesh(dSpikeGeo, new THREE.MeshPhongMaterial({
            color: 0x77eeff, shininess: 350, specular: 0xffffff, transparent: true, opacity: 0.85,
            emissive: 0x44bbdd, emissiveIntensity: 0.4
          }));
          const dsAngle = (ds / 6) * Math.PI * 2 + 0.3;
          dSpike.position.set(Math.cos(dsAngle) * 0.38, 0.4, Math.sin(dsAngle) * 0.38);
          dSpike.rotation.z = -Math.cos(dsAngle) * 0.8;
          dSpike.rotation.x = Math.sin(dsAngle) * 0.8;
          group.add(dSpike);
        }

        // Floating ice crystal shards
        for (let sh = 0; sh < 5; sh++) {
          const shardGeo = new THREE.OctahedronGeometry(0.055, 0);
          const shardMat = new THREE.MeshPhongMaterial({
            color: 0xbbffff, shininess: 400, transparent: true, opacity: 0.75,
            emissive: 0x66eeff, emissiveIntensity: 0.5
          });
          const shard = new THREE.Mesh(shardGeo, shardMat);
          const shAngle = (sh / 5) * Math.PI * 2;
          shard.position.set(Math.cos(shAngle) * 0.48, 0.45 + (sh % 3) * 0.15, Math.sin(shAngle) * 0.48);
          shard.rotation.set(sh * 0.8, sh * 1.2, sh * 0.5);
          group.add(shard);
        }

        // Cold aura
        const fsAuraGeo = new THREE.SphereGeometry(0.65, 20, 20);
        const fsAuraMat = new THREE.MeshBasicMaterial({ color: 0x3399ff, transparent: true, opacity: 0.12 });
        const fsAura = new THREE.Mesh(fsAuraGeo, fsAuraMat);
        fsAura.position.y = 0.65;
        group.add(fsAura);

        break;
      }

      case 'roots': {
        // ROOTS - Instant use trap that grabs and holds enemies for 5 seconds

        // Cracked earth mound
        const rtMoundGeo = new THREE.SphereGeometry(0.55, 16, 16);
        rtMoundGeo.scale(1.3, 0.35, 1.3);
        const rtMoundMat = new THREE.MeshPhongMaterial({
          color: 0x5c3d2e, shininess: 15, emissive: 0x2a1a10, emissiveIntensity: 0.15
        });
        const rtMound = new THREE.Mesh(rtMoundGeo, rtMoundMat);
        rtMound.position.y = 0.08;
        group.add(rtMound);

        // Dark soil ring
        const rtSoilRing = new THREE.Mesh(
          new THREE.TorusGeometry(0.5, 0.08, 8, 20),
          new THREE.MeshPhongMaterial({ color: 0x3a2818, shininess: 10 })
        );
        rtSoilRing.rotation.x = Math.PI / 2;
        rtSoilRing.position.y = 0.05;
        group.add(rtSoilRing);

        // Central root knot (gnarled woody ball)
        const rtKnotGeo = new THREE.IcosahedronGeometry(0.22, 1);
        const rtKnotMat = new THREE.MeshPhongMaterial({
          color: 0x6b4020, shininess: 30, emissive: 0x2a5522, emissiveIntensity: 0.3
        });
        const rtKnot = new THREE.Mesh(rtKnotGeo, rtKnotMat);
        rtKnot.position.y = 0.22;
        group.add(rtKnot);

        // Magical green glow inside knot
        const rtGlow = new THREE.Mesh(
          new THREE.SphereGeometry(0.14, 12, 12),
          new THREE.MeshBasicMaterial({ color: 0x66ff66, transparent: true, opacity: 0.7 })
        );
        rtGlow.position.y = 0.22;
        group.add(rtGlow);

        // 8 thick roots bursting upward from ground in a grabbing arc
        const rtRootMat = new THREE.MeshPhongMaterial({
          color: 0x7a4a28, shininess: 25, emissive: 0x2a1a0a, emissiveIntensity: 0.15
        });
        const rtDarkMat = new THREE.MeshPhongMaterial({
          color: 0x5a3518, shininess: 20, emissive: 0x1a0a02, emissiveIntensity: 0.1
        });
        for (let r = 0; r < 8; r++) {
          const rtAngle = (r / 8) * Math.PI * 2;
          const rtLen = 0.65 + (r % 3) * 0.1;

          // Main root - thick at base, tapers to grabbing tip
          const rtRootGeo = new THREE.CylinderGeometry(0.04, 0.1, rtLen, 8);
          const rtRoot = new THREE.Mesh(rtRootGeo, r % 2 === 0 ? rtRootMat : rtDarkMat);
          rtRoot.position.set(
            Math.cos(rtAngle) * 0.32,
            0.12 + rtLen * 0.32,
            Math.sin(rtAngle) * 0.32
          );
          rtRoot.rotation.z = -Math.cos(rtAngle) * 0.55;
          rtRoot.rotation.x = Math.sin(rtAngle) * 0.55;
          group.add(rtRoot);

          // Curling tip (grabbing inward)
          const rtTipGeo = new THREE.ConeGeometry(0.035, 0.22, 6);
          const rtTipMat = new THREE.MeshPhongMaterial({
            color: 0x5a3a18, shininess: 35, emissive: 0x1a4a1a, emissiveIntensity: 0.3
          });
          const rtTip = new THREE.Mesh(rtTipGeo, rtTipMat);
          rtTip.position.set(
            Math.cos(rtAngle) * 0.52,
            0.35 + rtLen * 0.38,
            Math.sin(rtAngle) * 0.52
          );
          rtTip.rotation.z = -Math.cos(rtAngle) * 1.3;
          rtTip.rotation.x = Math.sin(rtAngle) * 1.3;
          group.add(rtTip);

          // Small root bumps/knobs along each root
          if (r % 2 === 0) {
            const knobGeo = new THREE.SphereGeometry(0.04, 6, 6);
            const knob = new THREE.Mesh(knobGeo, rtRootMat);
            knob.position.set(
              Math.cos(rtAngle) * 0.38,
              0.2 + rtLen * 0.2,
              Math.sin(rtAngle) * 0.38
            );
            group.add(knob);
          }
        }

        // Thin secondary roots (between main roots)
        for (let sr = 0; sr < 6; sr++) {
          const srAngle = ((sr + 0.5) / 6) * Math.PI * 2;
          const srGeo = new THREE.CylinderGeometry(0.02, 0.05, 0.4, 5);
          const srRoot = new THREE.Mesh(srGeo, rtDarkMat);
          srRoot.position.set(Math.cos(srAngle) * 0.3, 0.2, Math.sin(srAngle) * 0.3);
          srRoot.rotation.z = -Math.cos(srAngle) * 0.7;
          srRoot.rotation.x = Math.sin(srAngle) * 0.7;
          group.add(srRoot);
        }

        // Ground cracks radiating outward
        for (let c = 0; c < 8; c++) {
          const cAngle = (c / 8) * Math.PI * 2;
          const crackGeo = new THREE.BoxGeometry(0.03, 0.04, 0.35 + (c % 3) * 0.08);
          const crackMat = new THREE.MeshPhongMaterial({
            color: 0x3a2a1a, emissive: 0x1a3a1a, emissiveIntensity: 0.25
          });
          const crack = new THREE.Mesh(crackGeo, crackMat);
          crack.position.set(Math.cos(cAngle) * 0.42, 0.02, Math.sin(cAngle) * 0.42);
          crack.rotation.y = cAngle;
          group.add(crack);
        }

        // Green magic particles (deterministic)
        for (let p = 0; p < 8; p++) {
          const pAngle = (p / 8) * Math.PI * 2;
          const pR = 0.2 + (p % 3) * 0.15;
          const particle = new THREE.Mesh(
            new THREE.SphereGeometry(0.025, 6, 6),
            new THREE.MeshBasicMaterial({ color: 0x88ff88, transparent: true, opacity: 0.65 })
          );
          particle.position.set(Math.cos(pAngle) * pR, 0.15 + (p % 4) * 0.12, Math.sin(pAngle) * pR);
          group.add(particle);
        }

        // Ground aura ring
        const rtAura = new THREE.Mesh(
          new THREE.RingGeometry(0.5, 0.7, 24),
          new THREE.MeshBasicMaterial({ color: 0x44ff44, transparent: true, opacity: 0.25, side: THREE.DoubleSide })
        );
        rtAura.rotation.x = -Math.PI / 2;
        rtAura.position.y = 0.04;
        group.add(rtAura);

        break;
      }

      case 'onion-flier': {
        // ONION FLIER - Cute round onion with propeller hat
        // Simple, clean design - round purple onion with green sprout

        // Main onion body (round and cute)
        const bodyGeo = new THREE.SphereGeometry(0.55, 24, 24);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0xe6c3dc, // Light pink/purple onion color
          shininess: 60
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 1.3;
        group.add(body);

        // Purple onion stripes/layers
        for (let stripe = 0; stripe < 4; stripe++) {
          const stripeGeo = new THREE.TorusGeometry(0.48 - stripe * 0.03, 0.025, 8, 24);
          const stripeMat = new THREE.MeshPhongMaterial({
            color: stripe % 2 === 0 ? 0xc9a0dc : 0x9370db,
            shininess: 50
          });
          const stripeMesh = new THREE.Mesh(stripeGeo, stripeMat);
          stripeMesh.position.y = 1.15 + stripe * 0.12;
          stripeMesh.rotation.x = Math.PI / 2;
          group.add(stripeMesh);
        }

        // Green onion sprouts on top
        for (let sprout = 0; sprout < 5; sprout++) {
          const sproutGeo = new THREE.CylinderGeometry(0.04, 0.06, 0.5, 8);
          const sproutMat = new THREE.MeshPhongMaterial({
            color: 0x32cd32,
            shininess: 40
          });
          const sproutMesh = new THREE.Mesh(sproutGeo, sproutMat);
          const angle = (sprout / 5) * Math.PI * 2;
          const radius = 0.12;
          sproutMesh.position.set(
            Math.cos(angle) * radius,
            2.0,
            Math.sin(angle) * radius
          );
          sproutMesh.rotation.z = Math.cos(angle) * 0.2;
          sproutMesh.rotation.x = -Math.sin(angle) * 0.2;
          group.add(sproutMesh);
        }

        // Propeller hub on top
        const hubGeo = new THREE.CylinderGeometry(0.08, 0.08, 0.06, 12);
        const hubMat = new THREE.MeshPhongMaterial({ color: 0x444444, shininess: 100 });
        const hub = new THREE.Mesh(hubGeo, hubMat);
        hub.position.y = 2.3;
        group.add(hub);

        // Propeller blades
        const propellerGroup = new THREE.Group();
        propellerGroup.position.y = 2.35;
        propellerGroup.userData.isPropeller = true;

        for (let b = 0; b < 4; b++) {
          const bladeGeo = new THREE.BoxGeometry(0.1, 0.02, 0.6);
          const bladeMat = new THREE.MeshPhongMaterial({ color: 0x666666, shininess: 80 });
          const blade = new THREE.Mesh(bladeGeo, bladeMat);
          blade.position.z = 0.3;
          const bladeWrapper = new THREE.Group();
          bladeWrapper.rotation.y = (b / 4) * Math.PI * 2;
          bladeWrapper.add(blade);
          propellerGroup.add(bladeWrapper);
        }
        group.add(propellerGroup);

        // Big cute eyes (facing positive X - toward enemies)
        for (let e = 0; e < 2; e++) {
          const eyeWhiteGeo = new THREE.SphereGeometry(0.14, 12, 12);
          const eyeWhiteMat = new THREE.MeshPhongMaterial({ color: 0xffffff, shininess: 100 });
          const eyeWhite = new THREE.Mesh(eyeWhiteGeo, eyeWhiteMat);
          eyeWhite.position.set(0.45, 1.4, e === 0 ? -0.15 : 0.15);
          group.add(eyeWhite);

          const pupilGeo = new THREE.SphereGeometry(0.07, 8, 8);
          const pupilMat = new THREE.MeshPhongMaterial({ color: 0x222222, shininess: 200 });
          const pupil = new THREE.Mesh(pupilGeo, pupilMat);
          pupil.position.set(0.56, 1.4, e === 0 ? -0.15 : 0.15);
          group.add(pupil);

          // Eye shine
          const shineGeo = new THREE.SphereGeometry(0.03, 6, 6);
          const shineMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const shine = new THREE.Mesh(shineGeo, shineMat);
          shine.position.set(0.58, 1.45, e === 0 ? -0.18 : 0.12);
          group.add(shine);
        }

        // Determined mouth
        const mouthGeo = new THREE.BoxGeometry(0.12, 0.04, 0.15);
        const mouthMat = new THREE.MeshPhongMaterial({ color: 0x8b4513 });
        const mouth = new THREE.Mesh(mouthGeo, mouthMat);
        mouth.position.set(0.52, 1.15, 0);
        group.add(mouth);

        // Small wings on sides
        for (let w = 0; w < 2; w++) {
          const wingGeo = new THREE.BoxGeometry(0.15, 0.35, 0.08);
          const wingMat = new THREE.MeshPhongMaterial({
            color: 0xadd8e6,
            shininess: 60,
            transparent: true,
            opacity: 0.8
          });
          const wing = new THREE.Mesh(wingGeo, wingMat);
          wing.position.set(0, 1.3, w === 0 ? -0.55 : 0.55);
          group.add(wing);
        }

        // Bomb carrier underneath
        const carrierGeo = new THREE.BoxGeometry(0.25, 0.1, 0.5);
        const carrierMat = new THREE.MeshPhongMaterial({ color: 0x333333, shininess: 60 });
        const carrier = new THREE.Mesh(carrierGeo, carrierMat);
        carrier.position.set(0, 0.75, 0);
        group.add(carrier);

        // 3 visible bombs
        for (let bomb = 0; bomb < 3; bomb++) {
          const bombGeo = new THREE.SphereGeometry(0.08, 10, 10);
          const bombMat = new THREE.MeshPhongMaterial({ color: 0x1a1a1a, shininess: 100 });
          const bombMesh = new THREE.Mesh(bombGeo, bombMat);
          bombMesh.position.set(0, 0.65, -0.15 + bomb * 0.15);
          group.add(bombMesh);
        }

        break;
      }

      case 'pineapple-crate': {
        // PINEAPPLE CRATE - Tropical wooden bunker (800 HP)
        // Thick solid walls with visible depth from the open top
        const crateW = 1.15;
        const crateH = 1.2;
        const crateD = 1.15;
        const wallT = 0.18;

        const woodMat = new THREE.MeshPhongMaterial({ color: 0xc8922a, shininess: 25, emissive: 0x3a2a10, emissiveIntensity: 0.15 });
        const darkWoodMat = new THREE.MeshPhongMaterial({ color: 0x9e7020, shininess: 20 });
        const beamMat = new THREE.MeshPhongMaterial({ color: 0x7a5518, shininess: 35 });
        const leafMat = new THREE.MeshPhongMaterial({ color: 0x2d8c2d, shininess: 50, emissive: 0x114411, emissiveIntensity: 0.2 });
        const metalMat = new THREE.MeshPhongMaterial({ color: 0x888888, shininess: 100, specular: 0xcccccc });

        // Floor visible from the open top
        const floorGeo = new THREE.BoxGeometry(crateW - wallT * 2 + 0.02, 0.08, crateD - wallT * 2 + 0.02);
        const floor = new THREE.Mesh(floorGeo, darkWoodMat);
        floor.position.set(0, 0.04, 0);
        group.add(floor);

        // 4 thick solid walls (real depth visible from above)
        const frontGeo = new THREE.BoxGeometry(crateW, crateH, wallT);
        const frontWall = new THREE.Mesh(frontGeo, woodMat);
        frontWall.position.set(0, crateH / 2, crateD / 2 - wallT / 2);
        group.add(frontWall);
        const backWall = new THREE.Mesh(frontGeo, woodMat);
        backWall.position.set(0, crateH / 2, -crateD / 2 + wallT / 2);
        group.add(backWall);
        const sideGeo = new THREE.BoxGeometry(wallT, crateH, crateD - wallT * 2);
        const leftWall = new THREE.Mesh(sideGeo, darkWoodMat);
        leftWall.position.set(-crateW / 2 + wallT / 2, crateH / 2, 0);
        group.add(leftWall);
        const rightWall = new THREE.Mesh(sideGeo, darkWoodMat);
        rightWall.position.set(crateW / 2 - wallT / 2, crateH / 2, 0);
        group.add(rightWall);

        // Plank groove lines on front/back
        const grooveMat = new THREE.MeshPhongMaterial({ color: 0x6b4c1a, shininess: 10 });
        for (let g = 0; g < 4; g++) {
          const gy = 0.22 + g * 0.28;
          for (const zSign of [-1, 1]) {
            const grooveGeo = new THREE.BoxGeometry(crateW + 0.01, 0.02, 0.02);
            const groove = new THREE.Mesh(grooveGeo, grooveMat);
            groove.position.set(0, gy, zSign * (crateD / 2));
            group.add(groove);
          }
        }

        // Corner posts (extend above walls)
        const corners: number[][] = [
          [crateW / 2, crateD / 2], [crateW / 2, -crateD / 2],
          [-crateW / 2, crateD / 2], [-crateW / 2, -crateD / 2]
        ];
        const postGeo = new THREE.BoxGeometry(0.14, crateH + 0.12, 0.14);
        for (const [cx, cz] of corners) {
          const post = new THREE.Mesh(postGeo, beamMat);
          post.position.set(cx, (crateH + 0.12) / 2, cz);
          group.add(post);
        }

        // Wide top rim beams (thick opening frame)
        const rimH = 0.12;
        const rimD = 0.22;
        const rimFBGeo = new THREE.BoxGeometry(crateW + 0.16, rimH, rimD);
        for (const zSign of [-1, 1]) {
          const beam = new THREE.Mesh(rimFBGeo, beamMat);
          beam.position.set(0, crateH + rimH / 2, zSign * (crateD / 2 - rimD / 2 + 0.08));
          group.add(beam);
        }
        const rimLRGeo = new THREE.BoxGeometry(rimD, rimH, crateD - rimD * 2 + 0.32);
        for (const xSign of [-1, 1]) {
          const beam = new THREE.Mesh(rimLRGeo, beamMat);
          beam.position.set(xSign * (crateW / 2 - rimD / 2 + 0.08), crateH + rimH / 2, 0);
          group.add(beam);
        }

        // Corner knobs on rim
        const knobGeo = new THREE.BoxGeometry(0.22, rimH + 0.08, 0.22);
        const knobMat = new THREE.MeshPhongMaterial({ color: 0x1e6b1e, shininess: 60, emissive: 0x0a330a, emissiveIntensity: 0.2 });
        for (const [cx, cz] of corners) {
          const knob = new THREE.Mesh(knobGeo, knobMat);
          knob.position.set(cx, crateH + (rimH + 0.08) / 2, cz);
          group.add(knob);
        }

        // Metal bands wrapping around middle
        for (const zSign of [-1, 1]) {
          const bandGeo = new THREE.BoxGeometry(crateW + 0.04, 0.06, 0.04);
          const band = new THREE.Mesh(bandGeo, metalMat);
          band.position.set(0, crateH * 0.5, zSign * crateD / 2);
          group.add(band);
        }
        for (const xSign of [-1, 1]) {
          const bandGeo = new THREE.BoxGeometry(0.04, 0.06, crateD + 0.04);
          const band = new THREE.Mesh(bandGeo, metalMat);
          band.position.set(xSign * crateW / 2, crateH * 0.5, 0);
          group.add(band);
        }

        // Metal corner brackets at bottom
        for (const [cx, cz] of corners) {
          const bvGeo = new THREE.BoxGeometry(0.04, 0.25, 0.04);
          const bv = new THREE.Mesh(bvGeo, metalMat);
          bv.position.set(cx, 0.125, cz);
          group.add(bv);
        }

        // Pineapple diamond pattern on front
        const diamondMat = new THREE.MeshPhongMaterial({ color: 0xe8a820, shininess: 60, emissive: 0x553300, emissiveIntensity: 0.15 });
        for (let row = 0; row < 3; row++) {
          for (let col = 0; col < 3; col++) {
            const dGeo = new THREE.BoxGeometry(0.1, 0.1, 0.04);
            const d = new THREE.Mesh(dGeo, diamondMat);
            d.position.set(-0.2 + col * 0.2, 0.3 + row * 0.3, crateD / 2 + 0.005);
            d.rotation.z = Math.PI / 4;
            group.add(d);
          }
        }

        // Pineapple leaf crown on top
        const leafGeo = new THREE.ConeGeometry(0.07, 0.5, 6);
        for (let l = 0; l < 8; l++) {
          const angle = (l / 8) * Math.PI * 2;
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.position.set(Math.cos(angle) * 0.3, crateH + rimH + 0.2, Math.sin(angle) * 0.3);
          leaf.rotation.x = Math.sin(angle) * 0.6;
          leaf.rotation.z = -Math.cos(angle) * 0.6;
          group.add(leaf);
        }

        break;
      }

      case 'iron-crate' as PlantType: {
        // IRON CRATE - Heavy armored steel bunker with thick walls
        const iW = 1.2, iH = 1.25, iD = 1.2, iWT = 0.2;
        const steelM = new THREE.MeshPhongMaterial({ color: 0x6a7078, shininess: 80, specular: 0xaaaaaa });
        const dkSteelM = new THREE.MeshPhongMaterial({ color: 0x505860, shininess: 60, specular: 0x888888 });
        const frameM = new THREE.MeshPhongMaterial({ color: 0x3a3e44, shininess: 90, specular: 0x666666 });
        const bandM = new THREE.MeshPhongMaterial({ color: 0x5a5a5a, shininess: 100, specular: 0xbbbbbb });
        const rivM = new THREE.MeshPhongMaterial({ color: 0x999999, shininess: 150, specular: 0xffffff });

        // Steel floor
        const iFlG = new THREE.BoxGeometry(iW - iWT * 2, 0.1, iD - iWT * 2);
        group.add(new THREE.Mesh(iFlG, dkSteelM));
        (group.children[group.children.length - 1] as THREE.Mesh).position.set(0, 0.05, 0);

        // 4 thick steel walls
        const iFG = new THREE.BoxGeometry(iW, iH, iWT);
        const iFr = new THREE.Mesh(iFG, steelM); iFr.position.set(0, iH / 2, iD / 2 - iWT / 2); group.add(iFr);
        const iBk = new THREE.Mesh(iFG, steelM); iBk.position.set(0, iH / 2, -iD / 2 + iWT / 2); group.add(iBk);
        const iSG = new THREE.BoxGeometry(iWT, iH, iD - iWT * 2);
        const iLt = new THREE.Mesh(iSG, dkSteelM); iLt.position.set(-iW / 2 + iWT / 2, iH / 2, 0); group.add(iLt);
        const iRt = new THREE.Mesh(iSG, dkSteelM); iRt.position.set(iW / 2 - iWT / 2, iH / 2, 0); group.add(iRt);

        // Corner pillars
        const iCo: number[][] = [[iW / 2, iD / 2], [iW / 2, -iD / 2], [-iW / 2, iD / 2], [-iW / 2, -iD / 2]];
        const iPG = new THREE.BoxGeometry(0.16, iH + 0.16, 0.16);
        for (const [cx, cz] of iCo) { const p = new THREE.Mesh(iPG, frameM); p.position.set(cx, (iH + 0.16) / 2, cz); group.add(p); }

        // Top rim
        const irH = 0.14, irD = 0.24;
        const irFB = new THREE.BoxGeometry(iW + 0.18, irH, irD);
        for (const zS of [-1, 1]) { const b = new THREE.Mesh(irFB, frameM); b.position.set(0, iH + irH / 2, zS * (iD / 2 - irD / 2 + 0.09)); group.add(b); }
        const irLR = new THREE.BoxGeometry(irD, irH, iD - irD * 2 + 0.36);
        for (const xS of [-1, 1]) { const b = new THREE.Mesh(irLR, frameM); b.position.set(xS * (iW / 2 - irD / 2 + 0.09), iH + irH / 2, 0); group.add(b); }

        // Corner caps
        const icG = new THREE.BoxGeometry(0.24, irH + 0.1, 0.24);
        const icM = new THREE.MeshPhongMaterial({ color: 0x2e3238, shininess: 120, specular: 0x888888 });
        for (const [cx, cz] of iCo) { const c = new THREE.Mesh(icG, icM); c.position.set(cx, iH + (irH + 0.1) / 2, cz); group.add(c); }

        // Bands
        for (const zS of [-1, 1]) { const g = new THREE.BoxGeometry(iW + 0.06, 0.08, 0.06); const b = new THREE.Mesh(g, bandM); b.position.set(0, iH * 0.35, zS * iD / 2); group.add(b); const b2 = new THREE.Mesh(g, bandM); b2.position.set(0, iH * 0.7, zS * iD / 2); group.add(b2); }

        // Rivets
        const rvG = new THREE.SphereGeometry(0.04, 8, 8);
        for (const [cx, cz] of iCo) { for (const ry of [0.15, iH * 0.35, iH * 0.7, iH - 0.05]) { const r = new THREE.Mesh(rvG, rivM); r.position.set(cx, ry, cz); group.add(r); } }

        // Hazard stripes
        const stM = new THREE.MeshPhongMaterial({ color: 0xddaa00, shininess: 40 });
        for (let s = 0; s < 5; s++) { const sg = new THREE.BoxGeometry(0.06, 0.22, 0.03); const st = new THREE.Mesh(sg, stM); st.position.set(-0.3 + s * 0.15, iH * 0.53, iD / 2); st.rotation.z = Math.PI / 6; group.add(st); }

        break;
      }

      case 'kiwi-blocker': {
        // KIWI BLOCKER - Heavy armored kiwi tank (500 sun, 2000 HP)
        const kbBaseMat = new THREE.MeshPhongMaterial({ color: 0x5c3d2e, shininess: 15, emissive: 0x1a1208, emissiveIntensity: 0.1 });
        const kbBase = new THREE.Mesh(new THREE.CylinderGeometry(0.6, 0.7, 0.18, 16), kbBaseMat);
        kbBase.position.y = 0.09; group.add(kbBase);

        // Main kiwi body - large oval with fuzzy brown skin
        const kbBodyGeo = new THREE.SphereGeometry(0.6, 24, 20);
        kbBodyGeo.scale(1, 1.3, 1);
        const kbBody = new THREE.Mesh(kbBodyGeo, new THREE.MeshPhongMaterial({
          color: 0x7a6040, shininess: 10, emissive: 0x2a1a0a, emissiveIntensity: 0.1
        }));
        kbBody.position.y = 0.85; group.add(kbBody);

        // Fuzzy skin texture layer
        const kbFuzzGeo = new THREE.SphereGeometry(0.62, 16, 14);
        kbFuzzGeo.scale(1, 1.3, 1);
        const kbFuzz = new THREE.Mesh(kbFuzzGeo, new THREE.MeshPhongMaterial({
          color: 0x8b7355, shininess: 3, transparent: true, opacity: 0.6
        }));
        kbFuzz.position.y = 0.85; group.add(kbFuzz);

        // Fuzzy bumps (deterministic golden-spiral placement)
        for (let i = 0; i < 40; i++) {
          const kbTheta = (i * 2.399) % (Math.PI * 2);
          const kbPhi = Math.acos(1 - 2 * ((i + 0.5) / 40));
          const kbBump = new THREE.Mesh(
            new THREE.SphereGeometry(0.035, 5, 5),
            new THREE.MeshPhongMaterial({ color: i % 3 === 0 ? 0x6a5538 : 0x7a6548, shininess: 3 })
          );
          kbBump.position.set(
            0.6 * Math.sin(kbPhi) * Math.cos(kbTheta),
            0.85 + 0.78 * Math.cos(kbPhi),
            0.6 * Math.sin(kbPhi) * Math.sin(kbTheta)
          );
          group.add(kbBump);
        }

        // Sliced kiwi top showing green flesh
        const kbSlice = new THREE.Mesh(
          new THREE.CylinderGeometry(0.4, 0.4, 0.06, 20),
          new THREE.MeshPhongMaterial({ color: 0x7ec850, shininess: 70, emissive: 0x2a6a10, emissiveIntensity: 0.25 })
        );
        kbSlice.position.y = 1.58; group.add(kbSlice);

        // White center core
        const kbCore = new THREE.Mesh(
          new THREE.CylinderGeometry(0.1, 0.1, 0.07, 12),
          new THREE.MeshPhongMaterial({ color: 0xf5f5e0, shininess: 50 })
        );
        kbCore.position.y = 1.6; group.add(kbCore);

        // Two-ring seed pattern (realistic kiwi cross-section)
        for (let kbRing = 0; kbRing < 2; kbRing++) {
          const kbSdCt = kbRing === 0 ? 8 : 14;
          const kbSdR = kbRing === 0 ? 0.16 : 0.3;
          for (let s = 0; s < kbSdCt; s++) {
            const sAng = (s / kbSdCt) * Math.PI * 2;
            const sdGeo = new THREE.SphereGeometry(0.018, 6, 6); sdGeo.scale(1, 1, 2.5);
            const sd = new THREE.Mesh(sdGeo, new THREE.MeshPhongMaterial({ color: 0x1a1a1a, shininess: 80 }));
            sd.position.set(Math.cos(sAng) * kbSdR, 1.61, Math.sin(sAng) * kbSdR); sd.rotation.y = sAng;
            group.add(sd);
          }
        }

        // Green radial lines from center
        for (let rl = 0; rl < 8; rl++) {
          const rlAng = (rl / 8) * Math.PI * 2;
          const rlLine = new THREE.Mesh(
            new THREE.BoxGeometry(0.015, 0.02, 0.25),
            new THREE.MeshPhongMaterial({ color: 0xa0e070, shininess: 30 })
          );
          rlLine.position.set(Math.cos(rlAng) * 0.18, 1.6, Math.sin(rlAng) * 0.18);
          rlLine.rotation.y = rlAng; group.add(rlLine);
        }

        // Wooden shield plates with bolts
        const kbShieldMat = new THREE.MeshPhongMaterial({
          color: 0x5a4a30, shininess: 40, specular: 0x333322, emissive: 0x1a1508, emissiveIntensity: 0.1
        });
        for (let a = 0; a < 6; a++) {
          const aAng = (a / 6) * Math.PI * 2;
          const plate = new THREE.Mesh(new THREE.BoxGeometry(0.32, 0.5, 0.07), kbShieldMat);
          plate.position.set(Math.cos(aAng) * 0.6, 0.85, Math.sin(aAng) * 0.6); plate.rotation.y = aAng;
          group.add(plate);
          const kbBolt = new THREE.Mesh(
            new THREE.CylinderGeometry(0.025, 0.025, 0.08, 6),
            new THREE.MeshPhongMaterial({ color: 0x888880, shininess: 120, specular: 0xcccccc })
          );
          kbBolt.position.set(Math.cos(aAng) * 0.64, 0.85, Math.sin(aAng) * 0.64);
          kbBolt.rotation.x = Math.PI / 2; kbBolt.rotation.z = aAng; group.add(kbBolt);
        }

        // Metal band around middle
        const kbBand = new THREE.Mesh(
          new THREE.TorusGeometry(0.62, 0.04, 8, 20),
          new THREE.MeshPhongMaterial({ color: 0x777768, shininess: 100, specular: 0xaaaaaa })
        );
        kbBand.position.y = 0.85; kbBand.rotation.x = Math.PI / 2; group.add(kbBand);

        // Protective green aura
        const kbAura = new THREE.Mesh(
          new THREE.SphereGeometry(0.9, 16, 16),
          new THREE.MeshBasicMaterial({ color: 0x66cc44, transparent: true, opacity: 0.08 })
        );
        kbAura.position.y = 0.85; group.add(kbAura);

        break;
      }

      case 'eggplant-stunner': {
        // EGGPLANT STUNNER - Stuns zombies with electric beam (300 sun)

        // Terracotta pot with rim
        const esPot = new THREE.Mesh(
          new THREE.CylinderGeometry(0.4, 0.3, 0.32, 16),
          new THREE.MeshPhongMaterial({ color: 0xa0522d, shininess: 40, specular: 0x444444 })
        );
        esPot.position.y = 0.16; group.add(esPot);
        const esRim = new THREE.Mesh(
          new THREE.TorusGeometry(0.4, 0.04, 8, 16),
          new THREE.MeshPhongMaterial({ color: 0x8b4513, shininess: 60 })
        );
        esRim.position.y = 0.32; esRim.rotation.x = Math.PI / 2; group.add(esRim);
        const esSoil = new THREE.Mesh(
          new THREE.CylinderGeometry(0.36, 0.36, 0.06, 16),
          new THREE.MeshPhongMaterial({ color: 0x3d2817, shininess: 5 })
        );
        esSoil.position.y = 0.3; group.add(esSoil);

        // Thick green stem
        const esStem = new THREE.Mesh(
          new THREE.CylinderGeometry(0.07, 0.12, 0.45, 10),
          new THREE.MeshPhongMaterial({ color: 0x3a6b2a, shininess: 25, specular: 0x224411 })
        );
        esStem.position.y = 0.5; group.add(esStem);

        // Main eggplant body - glossy deep purple teardrop shape
        const esBodyGeo = new THREE.SphereGeometry(0.38, 24, 20);
        esBodyGeo.scale(0.95, 1.5, 0.95);
        const esBody = new THREE.Mesh(esBodyGeo, new THREE.MeshPhongMaterial({
          color: 0x3a0070, shininess: 120, specular: 0xaa66dd,
          emissive: 0x1a0040, emissiveIntensity: 0.2
        }));
        esBody.position.y = 1.05; group.add(esBody);

        // Glossy highlight streaks (realistic eggplant shine)
        for (let hl = 0; hl < 2; hl++) {
          const hlGeo = new THREE.SphereGeometry(0.06, 8, 8);
          hlGeo.scale(1, 4, 1);
          const hlMesh = new THREE.Mesh(hlGeo, new THREE.MeshBasicMaterial({
            color: 0xffffff, transparent: true, opacity: 0.25
          }));
          hlMesh.position.set(hl === 0 ? 0.2 : -0.15, 1.05, hl === 0 ? 0.18 : -0.2);
          group.add(hlMesh);
        }

        // Purple skin detail rings
        for (let sr = 0; sr < 3; sr++) {
          const srRing = new THREE.Mesh(
            new THREE.TorusGeometry(0.32 - sr * 0.02, 0.015, 6, 16),
            new THREE.MeshPhongMaterial({ color: 0x5a20aa, shininess: 80, transparent: true, opacity: 0.5 })
          );
          srRing.position.y = 0.85 + sr * 0.2; srRing.rotation.x = Math.PI / 2;
          group.add(srRing);
        }

        // Green calyx (star-shaped leaves at top)
        const esCalyxMat = new THREE.MeshPhongMaterial({
          color: 0x2d7a2d, shininess: 50, emissive: 0x114411, emissiveIntensity: 0.15
        });
        for (let l = 0; l < 5; l++) {
          const lAng = (l / 5) * Math.PI * 2;
          // Each calyx leaf: flat cone pointing outward
          const esLeafGeo = new THREE.ConeGeometry(0.1, 0.28, 4);
          const esLeaf = new THREE.Mesh(esLeafGeo, esCalyxMat);
          esLeaf.position.set(Math.cos(lAng) * 0.14, 1.58, Math.sin(lAng) * 0.14);
          esLeaf.rotation.z = Math.cos(lAng) * 0.5;
          esLeaf.rotation.x = Math.sin(lAng) * 0.5;
          group.add(esLeaf);
        }
        // Calyx center cap
        const esCap = new THREE.Mesh(
          new THREE.CylinderGeometry(0.1, 0.12, 0.06, 8),
          new THREE.MeshPhongMaterial({ color: 0x246a24, shininess: 40 })
        );
        esCap.position.y = 1.58; group.add(esCap);

        // Electric energy eye (stun emitter on front of eggplant)
        const esEyeGlow = new THREE.Mesh(
          new THREE.SphereGeometry(0.1, 12, 12),
          new THREE.MeshBasicMaterial({ color: 0xffff66, transparent: true, opacity: 0.7 })
        );
        esEyeGlow.position.set(0.32, 1.05, 0); group.add(esEyeGlow);
        const esEyeCore = new THREE.Mesh(
          new THREE.SphereGeometry(0.06, 10, 10),
          new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.9 })
        );
        esEyeCore.position.set(0.34, 1.05, 0); group.add(esEyeCore);

        // Electric arcs around the eye
        for (let ea = 0; ea < 4; ea++) {
          const arcGeo = new THREE.TorusGeometry(0.14, 0.012, 4, 8, Math.PI * 0.6);
          const arcMat = new THREE.MeshBasicMaterial({ color: 0xffff44, transparent: true, opacity: 0.6 });
          const arc = new THREE.Mesh(arcGeo, arcMat);
          arc.position.set(0.32, 1.05, 0);
          arc.rotation.set(ea * 0.8, ea * 1.5, ea * 0.5);
          group.add(arc);
        }

        // Subtle purple aura
        const esAura = new THREE.Mesh(
          new THREE.SphereGeometry(0.6, 16, 16),
          new THREE.MeshBasicMaterial({ color: 0x8844cc, transparent: true, opacity: 0.08 })
        );
        esAura.position.y = 1.0; group.add(esAura);

        break;
      }

      case 'iron-grape-launcher': {
        // IRON GRAPE LAUNCHER - Cyborg grape launcher (grape launcher + metal cybernetics)

        // === TERRACOTTA POT (same as grape launcher) ===
        const igPotGeo = new THREE.CylinderGeometry(0.42, 0.32, 0.35, 16);
        const igPotMat = new THREE.MeshPhongMaterial({ color: 0xa0522d, shininess: 40, specular: 0x444444 });
        const igPot = new THREE.Mesh(igPotGeo, igPotMat);
        igPot.position.y = 0.175;
        group.add(igPot);

        // Pot rim - half terracotta, half metal (cyborg split)
        const igRimOrganic = new THREE.Mesh(
          new THREE.TorusGeometry(0.42, 0.05, 8, 16, Math.PI),
          new THREE.MeshPhongMaterial({ color: 0x8b4513, shininess: 60 })
        );
        igRimOrganic.position.y = 0.35;
        igRimOrganic.rotation.x = Math.PI / 2;
        group.add(igRimOrganic);

        const igRimMetal = new THREE.Mesh(
          new THREE.TorusGeometry(0.42, 0.05, 8, 16, Math.PI),
          new THREE.MeshPhongMaterial({ color: 0x707880, shininess: 180, specular: 0xdddddd })
        );
        igRimMetal.position.y = 0.35;
        igRimMetal.rotation.x = Math.PI / 2;
        igRimMetal.rotation.z = Math.PI;
        group.add(igRimMetal);

        // Metal bolts around pot
        const igBoltMat = new THREE.MeshPhongMaterial({ color: 0x999999, shininess: 200, specular: 0xffffff });
        for (let b = 0; b < 6; b++) {
          const bAng = (b / 6) * Math.PI * 2;
          const bolt = new THREE.Mesh(new THREE.CylinderGeometry(0.03, 0.03, 0.06, 6), igBoltMat);
          bolt.position.set(Math.cos(bAng) * 0.42, 0.25, Math.sin(bAng) * 0.42);
          group.add(bolt);
        }

        // Soil
        const igSoil = new THREE.Mesh(
          new THREE.CylinderGeometry(0.38, 0.38, 0.08, 16),
          new THREE.MeshPhongMaterial({ color: 0x3d2817, shininess: 5 })
        );
        igSoil.position.y = 0.32;
        group.add(igSoil);

        // === HYBRID STEM - organic left, metal right ===
        // Organic half stem
        const igStemOrganic = new THREE.Mesh(
          new THREE.CylinderGeometry(0.14, 0.22, 1.1, 12),
          new THREE.MeshPhongMaterial({ color: 0x355e20, shininess: 25, specular: 0x222222 })
        );
        igStemOrganic.position.y = 0.85;
        group.add(igStemOrganic);

        // Metal plating on stem (cyborg side)
        const igArmorMat = new THREE.MeshPhongMaterial({
          color: 0x606870, shininess: 150, specular: 0xcccccc,
          emissive: 0x1a1a2a, emissiveIntensity: 0.15
        });
        for (let p = 0; p < 3; p++) {
          const plate = new THREE.Mesh(
            new THREE.BoxGeometry(0.12, 0.28, 0.22),
            igArmorMat
          );
          plate.position.set(0.18, 0.5 + p * 0.3, 0);
          group.add(plate);
        }

        // Exposed wires/tubes on metal side
        const igWireMat = new THREE.MeshPhongMaterial({
          color: 0xcc3333, shininess: 80, emissive: 0x661111, emissiveIntensity: 0.3
        });
        for (let w = 0; w < 2; w++) {
          const wire = new THREE.Mesh(
            new THREE.CylinderGeometry(0.02, 0.02, 0.8, 6),
            igWireMat
          );
          wire.position.set(0.25, 0.75, -0.08 + w * 0.16);
          group.add(wire);
        }

        // Glowing energy tube (cyan)
        const igTube = new THREE.Mesh(
          new THREE.CylinderGeometry(0.025, 0.025, 0.7, 8),
          new THREE.MeshBasicMaterial({ color: 0x00ffff, transparent: true, opacity: 0.8 })
        );
        igTube.position.set(0.28, 0.8, 0.05);
        group.add(igTube);

        // Stem texture rings (organic side)
        for (let r = 0; r < 4; r++) {
          const ringGeo = new THREE.TorusGeometry(0.16 + r * 0.01, 0.02, 6, 12, Math.PI);
          const ring = new THREE.Mesh(ringGeo, new THREE.MeshPhongMaterial({ color: 0x2a4a18, shininess: 20 }));
          ring.position.y = 0.5 + r * 0.25;
          ring.rotation.x = Math.PI / 2;
          ring.rotation.z = Math.PI / 2;
          group.add(ring);
        }

        // Metal band rings (cyborg side)
        const igBandMat = new THREE.MeshPhongMaterial({ color: 0x4a4a55, shininess: 160, specular: 0xdddddd });
        for (let r = 0; r < 3; r++) {
          const ring = new THREE.Mesh(
            new THREE.TorusGeometry(0.2, 0.03, 8, 16, Math.PI),
            igBandMat
          );
          ring.position.y = 0.55 + r * 0.3;
          ring.rotation.x = Math.PI / 2;
          ring.rotation.z = -Math.PI / 2;
          group.add(ring);
        }

        // === GRAPE CLUSTER - half organic, half iron-plated ===
        const igGrapePositions = [
          { pos: [0, 1.45, 0], size: 0.24, metal: false },
          { pos: [-0.22, 1.28, 0.12], size: 0.22, metal: false },
          { pos: [0.22, 1.28, -0.12], size: 0.22, metal: true },
          { pos: [-0.12, 1.65, 0.08], size: 0.2, metal: false },
          { pos: [0.15, 1.62, -0.05], size: 0.21, metal: true },
          { pos: [0, 1.8, 0.03], size: 0.18, metal: true },
          { pos: [-0.08, 1.52, -0.12], size: 0.19, metal: false },
          { pos: [0.1, 1.48, 0.14], size: 0.2, metal: true },
          { pos: [0.18, 1.38, 0.08], size: 0.17, metal: true },
          { pos: [-0.18, 1.42, -0.06], size: 0.18, metal: false }
        ];

        igGrapePositions.forEach(({ pos, size, metal }) => {
          if (metal) {
            // Iron-plated grape - metallic silver/purple
            const grapeGeo = new THREE.SphereGeometry(size, 20, 20);
            const grapeMat = new THREE.MeshPhongMaterial({
              color: 0x6a5a8a, shininess: 200, specular: 0xcccccc,
              emissive: 0x2a1a3a, emissiveIntensity: 0.2
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            grape.position.set(pos[0], pos[1], pos[2]);
            group.add(grape);

            // Iron band around metal grapes
            const band = new THREE.Mesh(
              new THREE.TorusGeometry(size * 0.85, 0.02, 6, 12),
              igBoltMat
            );
            band.position.set(pos[0], pos[1], pos[2]);
            band.rotation.x = Math.random() * Math.PI;
            band.rotation.y = Math.random() * Math.PI;
            group.add(band);
          } else {
            // Organic grape - normal purple
            const grapeGeo = new THREE.SphereGeometry(size, 20, 20);
            const grapeMat = new THREE.MeshPhongMaterial({
              color: 0x7b3f9e, shininess: 120, specular: 0xcc88ee,
              emissive: 0x3d1a4f, emissiveIntensity: 0.25
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            grape.position.set(pos[0], pos[1], pos[2]);
            group.add(grape);

            // Highlight reflection
            const hl = new THREE.Mesh(
              new THREE.SphereGeometry(size * 0.3, 8, 8),
              new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.4 })
            );
            hl.position.set(pos[0] - size * 0.3, pos[1] + size * 0.3, pos[2] + size * 0.3);
            group.add(hl);
          }
        });

        // === CYBORG EYE (glowing red scanner) ===
        const igEye = new THREE.Mesh(
          new THREE.SphereGeometry(0.08, 12, 12),
          new THREE.MeshBasicMaterial({ color: 0xff0000 })
        );
        igEye.position.set(0.15, 1.5, 0.2);
        group.add(igEye);

        // Eye glow ring
        const igEyeGlow = new THREE.Mesh(
          new THREE.RingGeometry(0.06, 0.12, 16),
          new THREE.MeshBasicMaterial({ color: 0xff3333, transparent: true, opacity: 0.5, side: THREE.DoubleSide })
        );
        igEyeGlow.position.set(0.15, 1.5, 0.22);
        group.add(igEyeGlow);

        // === MECHANICAL SHOULDER CANNON ===
        // Pivot joint
        const igPivot = new THREE.Mesh(
          new THREE.SphereGeometry(0.1, 10, 10),
          igArmorMat
        );
        igPivot.position.set(0.3, 1.35, 0);
        group.add(igPivot);

        // Cannon barrel
        const igBarrel = new THREE.Mesh(
          new THREE.CylinderGeometry(0.08, 0.12, 0.6, 10),
          new THREE.MeshPhongMaterial({ color: 0x555560, shininess: 150, specular: 0xbbbbbb })
        );
        igBarrel.position.set(0.55, 1.35, 0);
        igBarrel.rotation.z = Math.PI / 2;
        group.add(igBarrel);

        // Cannon muzzle
        const igMuzzle = new THREE.Mesh(
          new THREE.CylinderGeometry(0.1, 0.08, 0.08, 10),
          new THREE.MeshPhongMaterial({ color: 0x3a3a40, shininess: 100 })
        );
        igMuzzle.position.set(0.85, 1.35, 0);
        igMuzzle.rotation.z = Math.PI / 2;
        group.add(igMuzzle);

        // Muzzle glow
        const igMuzzleGlow = new THREE.Mesh(
          new THREE.SphereGeometry(0.06, 8, 8),
          new THREE.MeshBasicMaterial({ color: 0x9955ff, transparent: true, opacity: 0.6 })
        );
        igMuzzleGlow.position.set(0.9, 1.35, 0);
        group.add(igMuzzleGlow);

        // === LEAVES (organic side only, fewer than normal) ===
        for (let i = 0; i < 3; i++) {
          const leafShape = new THREE.Shape();
          leafShape.moveTo(0, 0);
          leafShape.quadraticCurveTo(0.15, 0.1, 0.25, 0);
          leafShape.quadraticCurveTo(0.15, -0.1, 0, 0);
          const leafGeo = new THREE.ExtrudeGeometry(leafShape, { depth: 0.02, bevelEnabled: false });
          const leafMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x4a7c28 : 0x3a6420,
            shininess: 60, side: THREE.DoubleSide, specular: 0x224411
          });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          const angle = (i / 3) * Math.PI * 2 + Math.PI; // Only on organic side
          leaf.position.set(Math.cos(angle) * 0.35, 1.1, Math.sin(angle) * 0.35);
          leaf.rotation.y = angle + Math.PI;
          leaf.rotation.x = -0.4;
          leaf.scale.set(1.8, 1.8, 1);
          group.add(leaf);
        }

        // === METAL EXHAUST PIPES (cyborg side, where leaves would be) ===
        for (let i = 0; i < 2; i++) {
          const pipe = new THREE.Mesh(
            new THREE.CylinderGeometry(0.04, 0.05, 0.3, 8),
            igArmorMat
          );
          const pAng = (i / 2) * Math.PI * 0.6 - 0.15;
          pipe.position.set(Math.cos(pAng) * 0.35, 1.15, Math.sin(pAng) * 0.35);
          pipe.rotation.x = -0.5;
          pipe.rotation.z = pAng;
          group.add(pipe);
        }

        // === GLOWING ENERGY CORE ===
        const igCore = new THREE.Mesh(
          new THREE.SphereGeometry(0.1, 12, 12),
          new THREE.MeshBasicMaterial({ color: 0x00ffff, transparent: true, opacity: 0.7 })
        );
        igCore.position.set(0.12, 0.7, 0.15);
        group.add(igCore);

        // Core pulse ring
        const igCoreRing = new THREE.Mesh(
          new THREE.TorusGeometry(0.12, 0.02, 8, 16),
          new THREE.MeshBasicMaterial({ color: 0x00ccff, transparent: true, opacity: 0.5 })
        );
        igCoreRing.position.set(0.12, 0.7, 0.15);
        group.add(igCoreRing);

        break;
      }

      case 'iron-grape-shot': {
        // IRON GRAPE SHOT - Fusion of Iron Grape Launcher + Iron Grape Launcher
        // Armored dual-barrel iron grape gatling gun

        // === HEAVY IRON BASE PLATFORM ===
        const iggBaseGeo = new THREE.CylinderGeometry(0.7, 0.8, 0.15, 8);
        const iggBaseMat = new THREE.MeshPhongMaterial({
          color: 0x4a4a4a, shininess: 120, specular: 0x888888,
          emissive: 0x1a1a1a, emissiveIntensity: 0.15
        });
        const iggBase = new THREE.Mesh(iggBaseGeo, iggBaseMat);
        iggBase.position.y = 0.075;
        group.add(iggBase);

        // Base edge rivets
        const iggRivetMat = new THREE.MeshPhongMaterial({ color: 0x999999, shininess: 200, specular: 0xffffff });
        for (let r = 0; r < 8; r++) {
          const rAng = (r / 8) * Math.PI * 2;
          const rivet = new THREE.Mesh(new THREE.CylinderGeometry(0.03, 0.03, 0.06, 6), iggRivetMat);
          rivet.position.set(Math.cos(rAng) * 0.65, 0.15, Math.sin(rAng) * 0.65);
          group.add(rivet);
        }

        // Glowing purple energy channels on base
        for (let i = 0; i < 4; i++) {
          const channelGeo = new THREE.BoxGeometry(0.05, 0.04, 0.3);
          const channelMat = new THREE.MeshBasicMaterial({
            color: 0x6b2fa0, transparent: true, opacity: 0.8
          });
          const channel = new THREE.Mesh(channelGeo, channelMat);
          const cAng = (i / 4) * Math.PI * 2;
          channel.position.set(Math.cos(cAng) * 0.45, 0.16, Math.sin(cAng) * 0.45);
          channel.rotation.y = cAng;
          group.add(channel);
        }

        // === REINFORCED ARMORED BODY ===
        const iggBodyGeo = new THREE.CylinderGeometry(0.35, 0.5, 0.8, 10);
        const iggBodyMat = new THREE.MeshPhongMaterial({
          color: 0x4a4a4a, shininess: 140, specular: 0xaaaaaa,
          emissive: 0x1a1a2a, emissiveIntensity: 0.1
        });
        const iggBody = new THREE.Mesh(iggBodyGeo, iggBodyMat);
        iggBody.position.y = 0.55;
        group.add(iggBody);

        // Armor plates on body (front and back)
        const iggArmorMat = new THREE.MeshPhongMaterial({
          color: 0x2a2a2a, shininess: 160, specular: 0xcccccc,
          emissive: 0x111122, emissiveIntensity: 0.15
        });
        for (let p = 0; p < 4; p++) {
          const plate = new THREE.Mesh(
            new THREE.BoxGeometry(0.28, 0.3, 0.06),
            iggArmorMat
          );
          const pAng = (p / 4) * Math.PI * 2;
          plate.position.set(Math.cos(pAng) * 0.38, 0.55, Math.sin(pAng) * 0.38);
          plate.rotation.y = pAng;
          group.add(plate);

          // Rivets on each plate
          for (let rv = 0; rv < 2; rv++) {
            const plateRivet = new THREE.Mesh(
              new THREE.CylinderGeometry(0.02, 0.02, 0.07, 6),
              iggRivetMat
            );
            plateRivet.position.set(
              Math.cos(pAng) * 0.42,
              0.45 + rv * 0.2,
              Math.sin(pAng) * 0.42
            );
            plateRivet.rotation.x = Math.PI / 2;
            plateRivet.rotation.z = pAng;
            group.add(plateRivet);
          }
        }

        // Metal band rings around body
        const iggBandMat = new THREE.MeshPhongMaterial({ color: 0x3a3a3a, shininess: 180, specular: 0xdddddd });
        for (let b = 0; b < 3; b++) {
          const band = new THREE.Mesh(
            new THREE.TorusGeometry(0.38 - b * 0.03, 0.03, 8, 20),
            iggBandMat
          );
          band.position.y = 0.3 + b * 0.25;
          band.rotation.x = Math.PI / 2;
          group.add(band);
        }

        // === CYBORG MESH OVERLAY (like iron-grape-launcher) ===
        // Metal plating on one side
        for (let cp = 0; cp < 3; cp++) {
          const cybPlate = new THREE.Mesh(
            new THREE.BoxGeometry(0.1, 0.2, 0.18),
            new THREE.MeshPhongMaterial({
              color: 0x606870, shininess: 150, specular: 0xcccccc,
              emissive: 0x1a1a2a, emissiveIntensity: 0.15
            })
          );
          cybPlate.position.set(-0.32, 0.4 + cp * 0.22, 0);
          group.add(cybPlate);
        }

        // Exposed red wires on cyborg side
        const iggWireMat = new THREE.MeshPhongMaterial({
          color: 0xcc3333, shininess: 80, emissive: 0x661111, emissiveIntensity: 0.3
        });
        for (let w = 0; w < 2; w++) {
          const wire = new THREE.Mesh(
            new THREE.CylinderGeometry(0.015, 0.015, 0.6, 6),
            iggWireMat
          );
          wire.position.set(-0.38, 0.55, -0.06 + w * 0.12);
          group.add(wire);
        }

        // Glowing cyan energy tube
        const iggTube = new THREE.Mesh(
          new THREE.CylinderGeometry(0.02, 0.02, 0.5, 8),
          new THREE.MeshBasicMaterial({ color: 0x00ffff, transparent: true, opacity: 0.8 })
        );
        iggTube.position.set(-0.4, 0.6, 0.04);
        group.add(iggTube);

        // === CYBORG EYE (red scanner) ===
        const iggEye = new THREE.Mesh(
          new THREE.SphereGeometry(0.07, 12, 12),
          new THREE.MeshBasicMaterial({ color: 0xff0000 })
        );
        iggEye.position.set(-0.2, 0.85, 0.3);
        group.add(iggEye);

        const iggEyeGlow = new THREE.Mesh(
          new THREE.RingGeometry(0.05, 0.1, 16),
          new THREE.MeshBasicMaterial({ color: 0xff3333, transparent: true, opacity: 0.5, side: THREE.DoubleSide })
        );
        iggEyeGlow.position.set(-0.2, 0.85, 0.32);
        group.add(iggEyeGlow);

        // === DUAL BARRELS (side by side) ===
        for (let barrel = 0; barrel < 2; barrel++) {
          const zOff = barrel === 0 ? -0.18 : 0.18;

          // Barrel mount/housing
          const mountGeo = new THREE.CylinderGeometry(0.14, 0.16, 0.2, 10);
          const mountMat = new THREE.MeshPhongMaterial({
            color: 0x4a4a4a, shininess: 150, specular: 0xbbbbbb
          });
          const mount = new THREE.Mesh(mountGeo, mountMat);
          mount.position.set(0.3, 0.85, zOff);
          mount.rotation.z = Math.PI / 2;
          group.add(mount);

          // Main barrel tube (iron-colored)
          const barrelGeo = new THREE.CylinderGeometry(0.08, 0.11, 0.65, 10);
          const barrelMat = new THREE.MeshPhongMaterial({
            color: 0x555560, shininess: 160, specular: 0xbbbbbb,
            emissive: 0x111118, emissiveIntensity: 0.1
          });
          const barrelMesh = new THREE.Mesh(barrelGeo, barrelMat);
          barrelMesh.position.set(0.65, 0.85, zOff);
          barrelMesh.rotation.z = Math.PI / 2;
          group.add(barrelMesh);

          // Reinforcement rings on barrel
          for (let ring = 0; ring < 3; ring++) {
            const ringMesh = new THREE.Mesh(
              new THREE.TorusGeometry(0.1, 0.02, 8, 16),
              iggBandMat
            );
            ringMesh.position.set(0.45 + ring * 0.15, 0.85, zOff);
            ringMesh.rotation.y = Math.PI / 2;
            group.add(ringMesh);
          }

          // Darker bore hole at barrel tip
          const boreMat = new THREE.MeshPhongMaterial({
            color: 0x1a1a1a, shininess: 50
          });
          const bore = new THREE.Mesh(
            new THREE.CylinderGeometry(0.06, 0.06, 0.08, 10),
            boreMat
          );
          bore.position.set(0.98, 0.85, zOff);
          bore.rotation.z = Math.PI / 2;
          group.add(bore);

          // Muzzle glow (purple grape energy)
          const muzzleGlow = new THREE.Mesh(
            new THREE.SphereGeometry(0.05, 8, 8),
            new THREE.MeshBasicMaterial({ color: 0x9955ff, transparent: true, opacity: 0.6 })
          );
          muzzleGlow.position.set(1.02, 0.85, zOff);
          group.add(muzzleGlow);
        }

        // Connecting brace between barrels
        const braceGeo = new THREE.BoxGeometry(0.3, 0.06, 0.3);
        const braceMat = new THREE.MeshPhongMaterial({
          color: 0x3a3a3a, shininess: 140, specular: 0xaaaaaa
        });
        const brace = new THREE.Mesh(braceGeo, braceMat);
        brace.position.set(0.55, 0.85, 0);
        group.add(brace);

        // === IRON GRAPE AMMO (visible on top/sides) ===
        const iggAmmoPositions = [
          { pos: [0, 1.05, 0], size: 0.14, metal: true },
          { pos: [-0.12, 1.0, 0.12], size: 0.12, metal: true },
          { pos: [0.1, 1.02, -0.1], size: 0.13, metal: true },
          { pos: [0.15, 0.98, 0.08], size: 0.11, metal: false },
          { pos: [-0.08, 1.08, -0.08], size: 0.12, metal: false }
        ];

        iggAmmoPositions.forEach(({ pos, size, metal }) => {
          const grapeGeo = new THREE.SphereGeometry(size, 12, 12);
          if (metal) {
            // Iron-plated grape ammo
            const grapeMat = new THREE.MeshPhongMaterial({
              color: 0x6a5a8a, shininess: 200, specular: 0xcccccc,
              emissive: 0x2a1a3a, emissiveIntensity: 0.2
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            grape.position.set(pos[0], pos[1], pos[2]);
            group.add(grape);

            // Iron band around ammo
            const ammoBand = new THREE.Mesh(
              new THREE.TorusGeometry(size * 0.8, 0.015, 6, 10),
              iggRivetMat
            );
            ammoBand.position.set(pos[0], pos[1], pos[2]);
            ammoBand.rotation.x = Math.random() * Math.PI;
            group.add(ammoBand);
          } else {
            // Regular purple grape ammo
            const grapeMat = new THREE.MeshPhongMaterial({
              color: 0x6b2fa0, shininess: 120, specular: 0xcc88ee,
              emissive: 0x3d1a4f, emissiveIntensity: 0.25
            });
            const grape = new THREE.Mesh(grapeGeo, grapeMat);
            grape.position.set(pos[0], pos[1], pos[2]);
            group.add(grape);
          }
        });

        // === GLOWING ENERGY CORE ===
        const iggCore = new THREE.Mesh(
          new THREE.SphereGeometry(0.08, 12, 12),
          new THREE.MeshBasicMaterial({ color: 0x00ffff, transparent: true, opacity: 0.7 })
        );
        iggCore.position.set(0.1, 0.45, 0.2);
        group.add(iggCore);

        const iggCoreRing = new THREE.Mesh(
          new THREE.TorusGeometry(0.1, 0.015, 8, 16),
          new THREE.MeshBasicMaterial({ color: 0x00ccff, transparent: true, opacity: 0.5 })
        );
        iggCoreRing.position.set(0.1, 0.45, 0.2);
        group.add(iggCoreRing);

        break;
      }

      case 'banana-tree': {
        // BANANA TREE - Legendary Gold Crate summoner (2000 sun)

        // === ORNATE GOLDEN POT BASE ===
        const btPotGeo = new THREE.CylinderGeometry(0.5, 0.4, 0.35, 16);
        const btPotMat = new THREE.MeshPhongMaterial({
          color: 0xc8952e, shininess: 120, specular: 0xffdd88,
          emissive: 0x6a4a10, emissiveIntensity: 0.3
        });
        const btPot = new THREE.Mesh(btPotGeo, btPotMat);
        btPot.position.y = 0.175;
        group.add(btPot);

        // Gold pot rim
        const btRimGeo = new THREE.TorusGeometry(0.5, 0.06, 12, 24);
        const btRimMat = new THREE.MeshPhongMaterial({
          color: 0xffd700, shininess: 200, specular: 0xffffff,
          emissive: 0xaa8800, emissiveIntensity: 0.5
        });
        const btRim = new THREE.Mesh(btRimGeo, btRimMat);
        btRim.rotation.x = Math.PI / 2;
        btRim.position.y = 0.35;
        group.add(btRim);

        // Gold emblems on pot
        for (let e = 0; e < 4; e++) {
          const embAng = (e / 4) * Math.PI * 2;
          const emblem = new THREE.Mesh(
            new THREE.OctahedronGeometry(0.07, 0),
            new THREE.MeshPhongMaterial({ color: 0xffd700, emissive: 0xffaa00, emissiveIntensity: 0.8 })
          );
          emblem.position.set(Math.cos(embAng) * 0.45, 0.22, Math.sin(embAng) * 0.45);
          emblem.rotation.y = embAng;
          group.add(emblem);
        }

        // Rich soil
        const btSoilGeo = new THREE.CylinderGeometry(0.46, 0.46, 0.08, 16);
        const btSoilMat = new THREE.MeshPhongMaterial({ color: 0x3d2817, shininess: 5 });
        const btSoil = new THREE.Mesh(btSoilGeo, btSoilMat);
        btSoil.position.y = 0.37;
        group.add(btSoil);

        // === THICK TROPICAL TRUNK ===
        // Main trunk - tapered with slight curve
        const btTrunkGeo = new THREE.CylinderGeometry(0.15, 0.28, 1.4, 14);
        const btTrunkMat = new THREE.MeshPhongMaterial({
          color: 0x8b7355, shininess: 30,
          emissive: 0x4a3a20, emissiveIntensity: 0.2
        });
        const btTrunk = new THREE.Mesh(btTrunkGeo, btTrunkMat);
        btTrunk.position.y = 1.05;
        group.add(btTrunk);

        // Trunk bark rings
        const btBarkMat = new THREE.MeshPhongMaterial({ color: 0x6a5438, shininess: 15 });
        for (let r = 0; r < 8; r++) {
          const barkRing = new THREE.Mesh(
            new THREE.TorusGeometry(0.17 + (7 - r) * 0.014, 0.025, 8, 16),
            btBarkMat
          );
          barkRing.position.y = 0.45 + r * 0.16;
          barkRing.rotation.x = Math.PI / 2;
          group.add(barkRing);
        }

        // === LUSH CANOPY - Big drooping tropical leaves ===
        const btLeafMat = new THREE.MeshPhongMaterial({
          color: 0x2d8c2d, shininess: 50, specular: 0x44aa44,
          emissive: 0x114411, emissiveIntensity: 0.25,
          side: THREE.DoubleSide
        });
        const btDarkLeafMat = new THREE.MeshPhongMaterial({
          color: 0x1a6a1a, shininess: 40,
          emissive: 0x0a3a0a, emissiveIntensity: 0.2,
          side: THREE.DoubleSide
        });

        // Large drooping palm fronds
        for (let l = 0; l < 7; l++) {
          const ang = (l / 7) * Math.PI * 2;
          const leafGroup = new THREE.Group();

          // Leaf spine (midrib)
          const spine = new THREE.Mesh(
            new THREE.CylinderGeometry(0.02, 0.01, 0.9, 6),
            new THREE.MeshPhongMaterial({ color: 0x3a7a2a, shininess: 20 })
          );
          spine.rotation.z = -0.7;
          spine.position.set(0.3, 0, 0);
          leafGroup.add(spine);

          // Leaf blade segments (wider, more tropical)
          for (let s = 0; s < 4; s++) {
            const seg = new THREE.Mesh(
              new THREE.PlaneGeometry(0.25 - s * 0.04, 0.25),
              l % 2 === 0 ? btLeafMat : btDarkLeafMat
            );
            seg.position.set(0.12 + s * 0.2, -s * 0.06, 0);
            seg.rotation.z = -0.15 * s;
            leafGroup.add(seg);
          }

          leafGroup.position.set(0, 1.85, 0);
          leafGroup.rotation.y = ang;
          leafGroup.rotation.z = -0.3 - (l % 2) * 0.15;
          group.add(leafGroup);
        }

        // Crown tuft
        const btCrown = new THREE.Mesh(
          new THREE.SphereGeometry(0.22, 14, 14),
          new THREE.MeshPhongMaterial({
            color: 0x3aaa3a, shininess: 60,
            emissive: 0x1a6a1a, emissiveIntensity: 0.3
          })
        );
        btCrown.position.y = 1.85;
        group.add(btCrown);

        // === GOLDEN BANANA BUNCHES (hanging under canopy) ===
        const btBananaMat = new THREE.MeshPhongMaterial({
          color: 0xffe135, shininess: 100, specular: 0xffffaa,
          emissive: 0x886600, emissiveIntensity: 0.2
        });
        // Two clusters of bananas hanging at different heights
        for (let cluster = 0; cluster < 2; cluster++) {
          const clusterAng = cluster * Math.PI + 0.5;
          for (let b = 0; b < 4; b++) {
            const bAng = (b / 4) * Math.PI * 2 + cluster * 0.3;
            const banana = new THREE.Mesh(
              new THREE.CapsuleGeometry(0.05, 0.25, 8, 8),
              btBananaMat
            );
            banana.position.set(
              Math.cos(clusterAng) * 0.2 + Math.cos(bAng) * 0.08,
              1.5 - cluster * 0.2 - Math.abs(Math.sin(bAng)) * 0.08,
              Math.sin(clusterAng) * 0.2 + Math.sin(bAng) * 0.08
            );
            banana.rotation.z = Math.cos(bAng) * 0.5;
            banana.rotation.x = Math.sin(bAng) * 0.5;
            group.add(banana);
          }
          // Banana stem for each cluster
          const stemMat = new THREE.MeshPhongMaterial({ color: 0x5a8a2a, shininess: 20 });
          const stem = new THREE.Mesh(new THREE.CylinderGeometry(0.03, 0.02, 0.3, 6), stemMat);
          stem.position.set(Math.cos(clusterAng) * 0.18, 1.65 - cluster * 0.2, Math.sin(clusterAng) * 0.18);
          group.add(stem);
        }

        // === GOLDEN LEGENDARY AURA ===
        // Inner golden glow
        const btInnerAura = new THREE.Mesh(
          new THREE.SphereGeometry(0.55, 20, 20),
          new THREE.MeshBasicMaterial({ color: 0xffd700, transparent: true, opacity: 0.1 })
        );
        btInnerAura.position.y = 1.1;
        group.add(btInnerAura);

        // Outer golden aura
        const btOuterAura = new THREE.Mesh(
          new THREE.SphereGeometry(0.85, 20, 20),
          new THREE.MeshBasicMaterial({ color: 0xffaa00, transparent: true, opacity: 0.06 })
        );
        btOuterAura.position.y = 1.1;
        group.add(btOuterAura);

        // Floating golden sparkle particles
        for (let sp = 0; sp < 6; sp++) {
          const sparkle = new THREE.Mesh(
            new THREE.OctahedronGeometry(0.04, 0),
            new THREE.MeshBasicMaterial({ color: 0xffd700, transparent: true, opacity: 0.8 })
          );
          const spAng = (sp / 6) * Math.PI * 2;
          sparkle.position.set(
            Math.cos(spAng) * 0.5,
            0.6 + sp * 0.2,
            Math.sin(spAng) * 0.5
          );
          sparkle.userData.isSparkle = true;
          sparkle.userData.sparkleIndex = sp;
          group.add(sparkle);
        }

        // Ground golden ring
        const btGroundRing = new THREE.Mesh(
          new THREE.RingGeometry(0.5, 0.65, 24),
          new THREE.MeshBasicMaterial({ color: 0xffd700, transparent: true, opacity: 0.2, side: THREE.DoubleSide })
        );
        btGroundRing.rotation.x = -Math.PI / 2;
        btGroundRing.position.y = 0.02;
        group.add(btGroundRing);

        break;
      }

      case 'onion-freezer': {
        // ONION FREEZER - Frozen onion flier that drops ice bombs

        // Onion body - layered with visible onion skin rings
        const ofInnerMat = new THREE.MeshPhongMaterial({
          color: 0xc9a0dc, shininess: 80, specular: 0xeeccff, emissive: 0x553366, emissiveIntensity: 0.15
        });

        // Main onion bulb (slightly squished sphere)
        const ofBodyGeo = new THREE.SphereGeometry(0.5, 24, 20);
        const ofBody = new THREE.Mesh(ofBodyGeo, ofInnerMat);
        ofBody.position.y = 1.3;
        ofBody.scale.set(1, 0.9, 1);
        group.add(ofBody);

        // Onion skin layers (visible overlapping shells)
        for (let layer = 0; layer < 3; layer++) {
          const layerGeo = new THREE.SphereGeometry(0.52 + layer * 0.03, 20, 16, 0, Math.PI * 1.6);
          const layerMat = new THREE.MeshPhongMaterial({
            color: layer % 2 === 0 ? 0xd4a8e0 : 0xc89ad8, shininess: 70, specular: 0xeeddff,
            transparent: true, opacity: 0.7, side: THREE.DoubleSide
          });
          const layerMesh = new THREE.Mesh(layerGeo, layerMat);
          layerMesh.position.y = 1.3;
          layerMesh.scale.set(1, 0.9, 1);
          layerMesh.rotation.y = layer * 1.2;
          group.add(layerMesh);
        }

        // Frost crystallization spreading across onion
        const ofFrostMat = new THREE.MeshPhongMaterial({
          color: 0x99ddff, shininess: 250, specular: 0xffffff, transparent: true, opacity: 0.5,
          emissive: 0x55aadd, emissiveIntensity: 0.3
        });

        // Frost patches on body (ice crystals growing on surface)
        const frostPatchPositions = [
          [0.35, 1.4, 0.25], [-0.3, 1.2, 0.3], [0.1, 1.5, -0.4],
          [-0.35, 1.4, -0.2], [0.3, 1.15, -0.25], [-0.15, 1.45, 0.35]
        ];
        frostPatchPositions.forEach(([fx, fy, fz]) => {
          const patchGeo = new THREE.OctahedronGeometry(0.08, 0);
          const patch = new THREE.Mesh(patchGeo, ofFrostMat);
          patch.position.set(fx, fy, fz);
          patch.rotation.set(fx * 2, fy, fz);
          group.add(patch);
        });

        // Ice veins running across surface
        for (let iv = 0; iv < 4; iv++) {
          const ivGeo = new THREE.TorusGeometry(0.45, 0.015, 4, 16, Math.PI * 0.6);
          const ivMat = new THREE.MeshBasicMaterial({ color: 0x88ddff, transparent: true, opacity: 0.6 });
          const ivMesh = new THREE.Mesh(ivGeo, ivMat);
          ivMesh.position.y = 1.2 + iv * 0.08;
          ivMesh.rotation.x = Math.PI / 2;
          ivMesh.rotation.z = iv * 0.8;
          group.add(ivMesh);
        }

        // Onion sprouts on top (frosted green-blue)
        for (let sp = 0; sp < 5; sp++) {
          const spGeo = new THREE.CylinderGeometry(0.025, 0.05, 0.45, 8);
          const spMat = new THREE.MeshPhongMaterial({
            color: sp % 2 === 0 ? 0x66aa88 : 0x88ccaa, shininess: 40,
            emissive: 0x224433, emissiveIntensity: 0.15
          });
          const sprout = new THREE.Mesh(spGeo, spMat);
          const spAng = (sp / 5) * Math.PI * 2;
          sprout.position.set(Math.cos(spAng) * 0.08, 1.9, Math.sin(spAng) * 0.08);
          sprout.rotation.z = Math.cos(spAng) * 0.25;
          sprout.rotation.x = -Math.sin(spAng) * 0.25;
          group.add(sprout);
          // Tiny frost on sprout tips
          const frostTip = new THREE.Mesh(
            new THREE.SphereGeometry(0.03, 6, 6),
            new THREE.MeshPhongMaterial({ color: 0xaaeeff, shininess: 200, transparent: true, opacity: 0.7 })
          );
          frostTip.position.set(Math.cos(spAng) * 0.12, 2.15, Math.sin(spAng) * 0.12);
          group.add(frostTip);
        }

        // Propeller stem
        const ofStemGeo = new THREE.CylinderGeometry(0.03, 0.04, 0.2, 8);
        const ofStemMat = new THREE.MeshPhongMaterial({ color: 0x556655, shininess: 40 });
        const ofStemMesh = new THREE.Mesh(ofStemGeo, ofStemMat);
        ofStemMesh.position.y = 2.25;
        group.add(ofStemMesh);

        // Propeller hub (metallic)
        const ofHubGeo = new THREE.CylinderGeometry(0.07, 0.07, 0.05, 12);
        const ofHubMat = new THREE.MeshPhongMaterial({ color: 0x8899aa, shininess: 150, specular: 0xcccccc });
        const ofHub = new THREE.Mesh(ofHubGeo, ofHubMat);
        ofHub.position.y = 2.38;
        group.add(ofHub);

        // Propeller blades (wider, leaf-shaped, ice-tinted)
        for (let b = 0; b < 4; b++) {
          const bladeShape = new THREE.Shape();
          bladeShape.moveTo(0, 0);
          bladeShape.quadraticCurveTo(0.06, 0.15, 0, 0.35);
          bladeShape.quadraticCurveTo(-0.06, 0.15, 0, 0);
          const bladeGeo = new THREE.ExtrudeGeometry(bladeShape, { depth: 0.015, bevelEnabled: false });
          const bladeMat = new THREE.MeshPhongMaterial({
            color: 0xbbddff, shininess: 120, specular: 0xffffff, side: THREE.DoubleSide,
            transparent: true, opacity: 0.85
          });
          const blade = new THREE.Mesh(bladeGeo, bladeMat);
          blade.rotation.y = (b / 4) * Math.PI * 2;
          blade.rotation.x = -Math.PI / 2;
          blade.position.y = 2.4;
          blade.userData.isPropeller = true;
          group.add(blade);
        }

        // Bottom onion root tuft
        for (let rt = 0; rt < 6; rt++) {
          const rtGeo = new THREE.CylinderGeometry(0.01, 0.02, 0.15, 4);
          const rtMat = new THREE.MeshPhongMaterial({ color: 0xccbb99, shininess: 20 });
          const rtMesh = new THREE.Mesh(rtGeo, rtMat);
          const rtAng = (rt / 6) * Math.PI * 2;
          rtMesh.position.set(Math.cos(rtAng) * 0.08, 0.8, Math.sin(rtAng) * 0.08);
          rtMesh.rotation.z = Math.cos(rtAng) * 0.3;
          rtMesh.rotation.x = -Math.sin(rtAng) * 0.3;
          group.add(rtMesh);
        }

        // Cold aura glow
        const ofAura = new THREE.Mesh(
          new THREE.SphereGeometry(0.75, 16, 16),
          new THREE.MeshBasicMaterial({ color: 0x88ccff, transparent: true, opacity: 0.1 })
        );
        ofAura.position.y = 1.3;
        group.add(ofAura);

        break;
      }

      case 'rooted-grape-launcher': {
        // ROOTED GRAPE LAUNCHER - Grape launcher fully covered in tangled roots
        const rlRootMat = new THREE.MeshPhongMaterial({ color: 0x5a3a2a, shininess: 20, emissive: 0x1a1a0a, emissiveIntensity: 0.15 });
        const rlDarkRootMat = new THREE.MeshPhongMaterial({ color: 0x3d2818, shininess: 15, emissive: 0x110a02, emissiveIntensity: 0.1 });

        // Ground-level root spread (thick roots crawling outward)
        for (let r = 0; r < 8; r++) {
          const rootGeo = new THREE.CylinderGeometry(0.03, 0.12, 0.7 + (r % 3) * 0.15, 6);
          const root = new THREE.Mesh(rootGeo, r % 2 === 0 ? rlRootMat : rlDarkRootMat);
          const ang = (r / 8) * Math.PI * 2 + (r % 3) * 0.15;
          root.position.set(Math.cos(ang) * 0.45, 0.04, Math.sin(ang) * 0.45);
          root.rotation.z = Math.cos(ang) * 0.85;
          root.rotation.x = -Math.sin(ang) * 0.85;
          group.add(root);
        }

        // Pot (terracotta, same as grape launcher)
        const rlPotGeo = new THREE.CylinderGeometry(0.42, 0.32, 0.35, 16);
        const rlPotMat = new THREE.MeshPhongMaterial({ color: 0xa0522d, shininess: 40, specular: 0x444444 });
        const rlPot = new THREE.Mesh(rlPotGeo, rlPotMat);
        rlPot.position.y = 0.175;
        group.add(rlPot);

        // Roots covering the pot (thick wrapping roots)
        for (let pr = 0; pr < 5; pr++) {
          const potRootGeo = new THREE.TorusGeometry(0.38 + pr * 0.02, 0.04 + (pr % 2) * 0.01, 6, 14, Math.PI * 1.4);
          const potRoot = new THREE.Mesh(potRootGeo, pr % 2 === 0 ? rlRootMat : rlDarkRootMat);
          potRoot.position.y = 0.08 + pr * 0.06;
          potRoot.rotation.x = Math.PI / 2;
          potRoot.rotation.z = pr * 0.7;
          group.add(potRoot);
        }

        // Pot rim
        const rlRimGeo = new THREE.TorusGeometry(0.42, 0.05, 8, 16);
        const rlRimMat = new THREE.MeshPhongMaterial({ color: 0x8b4513, shininess: 60 });
        const rlRim = new THREE.Mesh(rlRimGeo, rlRimMat);
        rlRim.position.y = 0.35;
        rlRim.rotation.x = Math.PI / 2;
        group.add(rlRim);

        // Rich soil
        const rlSoilGeo = new THREE.CylinderGeometry(0.38, 0.38, 0.08, 16);
        const rlSoilMat = new THREE.MeshPhongMaterial({ color: 0x3d2817, shininess: 5 });
        const rlSoil = new THREE.Mesh(rlSoilGeo, rlSoilMat);
        rlSoil.position.y = 0.32;
        group.add(rlSoil);

        // Thick organic stem
        const rlStemGeo = new THREE.CylinderGeometry(0.14, 0.22, 1.1, 12);
        const rlStemMat = new THREE.MeshPhongMaterial({ color: 0x355e20, shininess: 25, specular: 0x222222 });
        const rlStem = new THREE.Mesh(rlStemGeo, rlStemMat);
        rlStem.position.y = 0.85;
        group.add(rlStem);

        // Dense roots wrapping entire stem
        for (let t = 0; t < 7; t++) {
          const wrapGeo = new THREE.TorusGeometry(0.18 + (t % 3) * 0.03, 0.035 + (t % 2) * 0.01, 6, 14, Math.PI * (1.2 + (t % 3) * 0.2));
          const wrap = new THREE.Mesh(wrapGeo, t % 3 === 0 ? rlDarkRootMat : rlRootMat);
          wrap.position.y = 0.35 + t * 0.15;
          wrap.rotation.y = t * 0.9;
          wrap.rotation.x = (t % 2 === 0 ? 0.1 : -0.1);
          group.add(wrap);
        }

        // Vertical root veins climbing stem
        for (let v = 0; v < 5; v++) {
          const veinGeo = new THREE.CylinderGeometry(0.025, 0.04, 0.9, 5);
          const vein = new THREE.Mesh(veinGeo, v % 2 === 0 ? rlRootMat : rlDarkRootMat);
          const rlAng = (v / 5) * Math.PI * 2;
          vein.position.set(Math.cos(rlAng) * 0.17, 0.8, Math.sin(rlAng) * 0.17);
          vein.rotation.z = Math.cos(rlAng) * 0.1;
          vein.rotation.x = -Math.sin(rlAng) * 0.1;
          group.add(vein);
        }

        // Full grape cluster with highlights (same as grape launcher)
        const rlGrapePositions = [
          { pos: [0, 1.45, 0], size: 0.24 }, { pos: [-0.22, 1.28, 0.12], size: 0.22 },
          { pos: [0.22, 1.28, -0.12], size: 0.22 }, { pos: [-0.12, 1.65, 0.08], size: 0.2 },
          { pos: [0.15, 1.62, -0.05], size: 0.21 }, { pos: [0, 1.8, 0.03], size: 0.18 },
          { pos: [-0.08, 1.52, -0.12], size: 0.19 }, { pos: [0.1, 1.48, 0.14], size: 0.2 },
          { pos: [0.18, 1.38, 0.08], size: 0.17 }, { pos: [-0.18, 1.42, -0.06], size: 0.18 }
        ];
        rlGrapePositions.forEach(({ pos, size }) => {
          const grapeGeo = new THREE.SphereGeometry(size, 20, 20);
          const grapeMat = new THREE.MeshPhongMaterial({
            color: 0x7b3f9e, shininess: 120, specular: 0xcc88ee, emissive: 0x3d1a4f, emissiveIntensity: 0.25
          });
          const grape = new THREE.Mesh(grapeGeo, grapeMat);
          grape.position.set(pos[0], pos[1], pos[2]);
          group.add(grape);
          const hlGeo = new THREE.SphereGeometry(size * 0.3, 8, 8);
          const hlMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.4 });
          const hl = new THREE.Mesh(hlGeo, hlMat);
          hl.position.set(pos[0] - size * 0.3, pos[1] + size * 0.3, pos[2] + size * 0.3);
          group.add(hl);
        });

        // Roots wrapping over the grape cluster
        for (let gr = 0; gr < 6; gr++) {
          const grRootGeo = new THREE.TorusGeometry(0.22 + gr * 0.02, 0.025, 6, 10, Math.PI * 0.8);
          const grRoot = new THREE.Mesh(grRootGeo, gr % 2 === 0 ? rlRootMat : rlDarkRootMat);
          grRoot.position.set((gr % 3 - 1) * 0.05, 1.35 + gr * 0.08, (gr % 2 - 0.5) * 0.06);
          grRoot.rotation.y = gr * 1.1;
          grRoot.rotation.x = (gr % 2 === 0 ? 0.3 : -0.3);
          group.add(grRoot);
        }

        // Small root tendrils dangling from grapes
        for (let d = 0; d < 4; d++) {
          const dangGeo = new THREE.CylinderGeometry(0.015, 0.03, 0.25, 5);
          const dang = new THREE.Mesh(dangGeo, rlRootMat);
          const rlDAng = (d / 4) * Math.PI * 2;
          dang.position.set(Math.cos(rlDAng) * 0.25, 1.2, Math.sin(rlDAng) * 0.25);
          dang.rotation.z = Math.cos(rlDAng) * 0.4;
          dang.rotation.x = -Math.sin(rlDAng) * 0.4;
          group.add(dang);
        }

        // Leaves (same as grape launcher)
        for (let i = 0; i < 6; i++) {
          const rlLeafShape = new THREE.Shape();
          rlLeafShape.moveTo(0, 0);
          rlLeafShape.quadraticCurveTo(0.15, 0.1, 0.25, 0);
          rlLeafShape.quadraticCurveTo(0.15, -0.1, 0, 0);
          const rlLeafGeo = new THREE.ExtrudeGeometry(rlLeafShape, { depth: 0.02, bevelEnabled: false });
          const rlLeafMat = new THREE.MeshPhongMaterial({
            color: i % 2 === 0 ? 0x4a7c28 : 0x3a6420, shininess: 60, side: THREE.DoubleSide, specular: 0x224411
          });
          const rlLeaf = new THREE.Mesh(rlLeafGeo, rlLeafMat);
          const rlLAngle = (i / 6) * Math.PI * 2;
          rlLeaf.position.set(Math.cos(rlLAngle) * 0.35, 1.1, Math.sin(rlLAngle) * 0.35);
          rlLeaf.rotation.y = rlLAngle + Math.PI;
          rlLeaf.rotation.x = -0.4;
          rlLeaf.scale.set(1.8, 1.8, 1);
          group.add(rlLeaf);
        }

        // Earthy green aura
        const rlAura = new THREE.Mesh(
          new THREE.SphereGeometry(0.7, 16, 16),
          new THREE.MeshBasicMaterial({ color: 0x558833, transparent: true, opacity: 0.12 })
        );
        rlAura.position.y = 1.2;
        group.add(rlAura);

        // Ground root ring
        const rlGroundRing = new THREE.Mesh(
          new THREE.RingGeometry(0.4, 0.7, 20),
          new THREE.MeshBasicMaterial({ color: 0x44aa22, transparent: true, opacity: 0.25, side: THREE.DoubleSide })
        );
        rlGroundRing.rotation.x = -Math.PI / 2;
        rlGroundRing.position.y = 0.02;
        group.add(rlGroundRing);

        break;
      }

      case 'vined-grape-wall': {
        // VINED GRAPE WALL - Thick living vine wall with integrated grape cannon
        const vgwVineMat = new THREE.MeshPhongMaterial({ color: 0x2a6a22, shininess: 25, specular: 0x1a3a1a });
        const vgwDarkVineMat = new THREE.MeshPhongMaterial({ color: 0x1a4a14, shininess: 20 });
        const vgwBarkMat = new THREE.MeshPhongMaterial({ color: 0x4a3520, shininess: 15, emissive: 0x1a1208, emissiveIntensity: 0.1 });

        // Gnarled root base spreading on ground
        for (let r = 0; r < 6; r++) {
          const rootGeo = new THREE.CylinderGeometry(0.04, 0.14, 0.6, 6);
          const root = new THREE.Mesh(rootGeo, vgwBarkMat);
          const ang = (r / 6) * Math.PI * 2;
          root.position.set(Math.cos(ang) * 0.55, 0.05, Math.sin(ang) * 0.55);
          root.rotation.z = Math.cos(ang) * 0.8;
          root.rotation.x = -Math.sin(ang) * 0.8;
          group.add(root);
        }

        // Mossy base platform
        const vgwBaseGeo = new THREE.CylinderGeometry(0.6, 0.7, 0.18, 14);
        const vgwBaseMat = new THREE.MeshPhongMaterial({ color: 0x1a4a12, shininess: 15, emissive: 0x0a2a08, emissiveIntensity: 0.15 });
        const vgwBase = new THREE.Mesh(vgwBaseGeo, vgwBaseMat);
        vgwBase.position.y = 0.09;
        group.add(vgwBase);

        // Main wall body - thick woody core
        const vgwWallGeo = new THREE.BoxGeometry(0.8, 2.2, 1.35);
        const vgwWallMat = new THREE.MeshPhongMaterial({ color: 0x3a5a28, shininess: 15, specular: 0x1a3a1a, emissive: 0x0a2a0a, emissiveIntensity: 0.1 });
        const vgwWall = new THREE.Mesh(vgwWallGeo, vgwWallMat);
        vgwWall.position.y = 1.2;
        group.add(vgwWall);

        // Bark texture strips on wall face
        for (let b = 0; b < 4; b++) {
          const barkGeo = new THREE.BoxGeometry(0.06, 1.8, 0.25);
          const bark = new THREE.Mesh(barkGeo, vgwBarkMat);
          bark.position.set(0.41, 1.2, -0.45 + b * 0.3);
          group.add(bark);
        }

        // Thick vines wrapping around wall (organic, irregular)
        for (let v = 0; v < 6; v++) {
          const vineGeo = new THREE.TorusGeometry(0.55 + (v % 3) * 0.03, 0.07 - (v % 2) * 0.02, 8, 18, Math.PI * 1.6);
          const vine = new THREE.Mesh(vineGeo, v % 2 === 0 ? vgwVineMat : vgwDarkVineMat);
          vine.position.y = 0.25 + v * 0.35;
          vine.rotation.y = v * 0.45 + (v % 2) * 0.3;
          group.add(vine);
        }

        // Vertical vine stalks on wall sides
        for (let vs = 0; vs < 4; vs++) {
          const stalkGeo = new THREE.CylinderGeometry(0.04, 0.06, 2.0, 6);
          const stalk = new THREE.Mesh(stalkGeo, vs % 2 === 0 ? vgwVineMat : vgwDarkVineMat);
          const zPos = -0.5 + vs * 0.33;
          stalk.position.set(0.42, 1.1, zPos);
          stalk.rotation.z = (vs % 2 === 0 ? 0.05 : -0.05);
          group.add(stalk);
        }

        // Grape cannon - organic barrel grown from wall
        const vgwBarrelGeo = new THREE.CylinderGeometry(0.14, 0.22, 0.9, 12);
        const vgwBarrelMat = new THREE.MeshPhongMaterial({ color: 0x2d5a1d, shininess: 35, emissive: 0x1a3a10, emissiveIntensity: 0.15 });
        const vgwBarrel = new THREE.Mesh(vgwBarrelGeo, vgwBarrelMat);
        vgwBarrel.position.set(0.65, 1.4, 0);
        vgwBarrel.rotation.z = -Math.PI / 2;
        group.add(vgwBarrel);

        // Vine rings wrapping the barrel
        for (let br = 0; br < 3; br++) {
          const bRingGeo = new THREE.TorusGeometry(0.16 + br * 0.02, 0.03, 6, 10);
          const bRing = new THREE.Mesh(bRingGeo, vgwVineMat);
          bRing.position.set(0.45 + br * 0.2, 1.4, 0);
          bRing.rotation.y = Math.PI / 2;
          group.add(bRing);
        }

        // Cannon muzzle - organic opening with leaf petals
        const vgwMuzzleGeo = new THREE.TorusGeometry(0.16, 0.05, 8, 14);
        const vgwMuzzleMat = new THREE.MeshPhongMaterial({ color: 0x2a5518, shininess: 30 });
        const vgwMuzzle = new THREE.Mesh(vgwMuzzleGeo, vgwMuzzleMat);
        vgwMuzzle.position.set(1.1, 1.4, 0);
        vgwMuzzle.rotation.y = Math.PI / 2;
        group.add(vgwMuzzle);

        // Grape cluster visible in barrel
        for (let g = 0; g < 5; g++) {
          const grapeGeo = new THREE.SphereGeometry(0.07, 12, 12);
          const grapeMat = new THREE.MeshPhongMaterial({ color: 0x7b3f9e, shininess: 120, emissive: 0x3d1a4f, emissiveIntensity: 0.3 });
          const grape = new THREE.Mesh(grapeGeo, grapeMat);
          const ang = (g / 5) * Math.PI * 2;
          grape.position.set(0.4, 1.4 + Math.sin(ang) * 0.08, Math.cos(ang) * 0.08);
          group.add(grape);
        }

        // Decorative grape cluster on top of wall
        const vgwTopGrapes = [
          [0, 2.35, 0, 0.12], [-0.1, 2.25, 0.08, 0.1], [0.1, 2.25, -0.06, 0.1],
          [0, 2.45, 0, 0.09], [-0.08, 2.4, -0.05, 0.08]
        ];
        vgwTopGrapes.forEach(([x, y, z, s]) => {
          const tg = new THREE.Mesh(new THREE.SphereGeometry(s, 12, 12),
            new THREE.MeshPhongMaterial({ color: 0x7b3f9e, shininess: 100, emissive: 0x3d1a4f, emissiveIntensity: 0.2 }));
          tg.position.set(x, y, z);
          group.add(tg);
        });

        // Leaves growing from wall (natural, varied sizes)
        for (let lf = 0; lf < 8; lf++) {
          const lfShape = new THREE.Shape();
          lfShape.moveTo(0, 0);
          lfShape.quadraticCurveTo(0.1, 0.06, 0.18, 0);
          lfShape.quadraticCurveTo(0.1, -0.06, 0, 0);
          const lfGeo = new THREE.ExtrudeGeometry(lfShape, { depth: 0.015, bevelEnabled: false });
          const lfMat = new THREE.MeshPhongMaterial({
            color: lf % 3 === 0 ? 0x4a8a28 : lf % 3 === 1 ? 0x3a7420 : 0x2a6418,
            shininess: 40, side: THREE.DoubleSide
          });
          const lfMesh = new THREE.Mesh(lfGeo, lfMat);
          const lfY = 0.5 + (lf / 8) * 1.6;
          const lfSide = lf % 2 === 0 ? 0.42 : -0.42;
          lfMesh.position.set(lfSide, lfY, (lf % 4 - 1.5) * 0.3);
          lfMesh.rotation.y = lf % 2 === 0 ? 0 : Math.PI;
          lfMesh.rotation.x = -0.3;
          lfMesh.scale.set(1.5, 1.5, 1);
          group.add(lfMesh);
        }

        // Moss patches on wall (flatter, more natural)
        const vgwMossPositions = [
          [0.42, 0.5, -0.3], [0.42, 1.0, 0.4], [-0.42, 0.7, 0.1],
          [-0.42, 1.5, -0.4], [0.42, 1.8, 0.2], [-0.42, 2.0, 0.3]
        ];
        vgwMossPositions.forEach(([x, y, z]) => {
          const mossGeo = new THREE.SphereGeometry(0.12, 8, 8);
          const mossMat = new THREE.MeshPhongMaterial({ color: 0x4a9a3a, shininess: 8 });
          const moss = new THREE.Mesh(mossGeo, mossMat);
          moss.position.set(x, y, z);
          moss.scale.set(0.8, 0.35, 1.2);
          group.add(moss);
        });

        // Subtle green aura
        const vgwAura = new THREE.Mesh(
          new THREE.SphereGeometry(0.9, 16, 16),
          new THREE.MeshBasicMaterial({ color: 0x44aa22, transparent: true, opacity: 0.08 })
        );
        vgwAura.position.y = 1.2;
        group.add(vgwAura);

        break;
      }

      case 'grape-crate': {
        // GRAPE CRATE - Purple pineapple crate with grape cannons
        const gcW = 1.15, gcH = 1.2, gcD = 1.15, gcWallT = 0.18;
        const gcWoodMat = new THREE.MeshPhongMaterial({ color: 0x6a3a8a, shininess: 30, emissive: 0x2a1a3a, emissiveIntensity: 0.15 });
        const gcDarkMat = new THREE.MeshPhongMaterial({ color: 0x4a2a6a, shininess: 25 });

        // Floor
        const gcFloorGeo = new THREE.BoxGeometry(gcW - gcWallT * 2, 0.08, gcD - gcWallT * 2);
        const gcFloor = new THREE.Mesh(gcFloorGeo, gcDarkMat);
        gcFloor.position.y = 0.04;
        group.add(gcFloor);

        // 4 walls
        const gcFrontGeo = new THREE.BoxGeometry(gcW, gcH, gcWallT);
        const gcFront = new THREE.Mesh(gcFrontGeo, gcWoodMat);
        gcFront.position.set(0, gcH / 2, gcD / 2 - gcWallT / 2);
        group.add(gcFront);
        const gcBack = new THREE.Mesh(gcFrontGeo, gcWoodMat);
        gcBack.position.set(0, gcH / 2, -gcD / 2 + gcWallT / 2);
        group.add(gcBack);
        const gcSideGeo = new THREE.BoxGeometry(gcWallT, gcH, gcD - gcWallT * 2);
        const gcLeft = new THREE.Mesh(gcSideGeo, gcDarkMat);
        gcLeft.position.set(-gcW / 2 + gcWallT / 2, gcH / 2, 0);
        group.add(gcLeft);
        const gcRight = new THREE.Mesh(gcSideGeo, gcDarkMat);
        gcRight.position.set(gcW / 2 - gcWallT / 2, gcH / 2, 0);
        group.add(gcRight);

        // Grape cannons on left and right sides
        for (const side of [-1, 1]) {
          const cannonGeo = new THREE.CylinderGeometry(0.1, 0.14, 0.5, 8);
          const cannonMat = new THREE.MeshPhongMaterial({ color: 0x555555, shininess: 100, specular: 0xaaaaaa });
          const cannon = new THREE.Mesh(cannonGeo, cannonMat);
          cannon.position.set(gcW / 2 * side + side * 0.3, gcH * 0.6, 0);
          cannon.rotation.z = side * Math.PI / 2;
          group.add(cannon);

          // Muzzle ring
          const muzzGeo = new THREE.TorusGeometry(0.12, 0.03, 8, 12);
          const muzzMat = new THREE.MeshPhongMaterial({ color: 0x7b3f9e, shininess: 80 });
          const muzz = new THREE.Mesh(muzzGeo, muzzMat);
          muzz.position.set(gcW / 2 * side + side * 0.55, gcH * 0.6, 0);
          muzz.rotation.y = Math.PI / 2;
          group.add(muzz);

          // Grape cluster at cannon
          for (let g = 0; g < 3; g++) {
            const gGeo = new THREE.SphereGeometry(0.06, 8, 8);
            const gMat = new THREE.MeshPhongMaterial({ color: 0x7b3f9e, shininess: 100, emissive: 0x3d1a4f, emissiveIntensity: 0.3 });
            const grape = new THREE.Mesh(gGeo, gMat);
            grape.position.set(gcW / 2 * side + side * 0.15, gcH * 0.6 + (g - 1) * 0.08, 0);
            group.add(grape);
          }
        }

        // Corner posts
        for (const cx of [-1, 1]) {
          for (const cz of [-1, 1]) {
            const postGeo = new THREE.CylinderGeometry(0.06, 0.06, gcH + 0.15, 6);
            const postMat = new THREE.MeshPhongMaterial({ color: 0x3a1a5a, shininess: 40 });
            const post = new THREE.Mesh(postGeo, postMat);
            post.position.set(cx * gcW / 2, gcH / 2 + 0.075, cz * gcD / 2);
            group.add(post);
          }
        }

        // Purple grape aura inside
        const gcAura = new THREE.Mesh(
          new THREE.SphereGeometry(0.4, 12, 12),
          new THREE.MeshBasicMaterial({ color: 0x9944cc, transparent: true, opacity: 0.15 })
        );
        gcAura.position.y = gcH * 0.5;
        group.add(gcAura);

        // Grape decoration on top
        for (let g = 0; g < 5; g++) {
          const topGrapeGeo = new THREE.SphereGeometry(0.08, 10, 10);
          const topGrapeMat = new THREE.MeshPhongMaterial({ color: 0x7b3f9e, shininess: 100, emissive: 0x4a2a6a, emissiveIntensity: 0.3 });
          const topGrape = new THREE.Mesh(topGrapeGeo, topGrapeMat);
          const ang = (g / 5) * Math.PI * 2;
          topGrape.position.set(Math.cos(ang) * 0.2, gcH + 0.1, Math.sin(ang) * 0.2);
          group.add(topGrape);
        }

        break;
      }

      case 'eggplant-cannon': {
        // EGGPLANT CANNON - Eggplant Stunner + Pear Cannon fusion
        // Click to stun a random zombie anywhere for 8 seconds, 9s cooldown

        // Heavy cannon base platform
        const ecBaseMat = new THREE.MeshPhongMaterial({ color: 0x5a4a3a, shininess: 40, specular: 0x444444 });
        const ecBase = new THREE.Mesh(new THREE.CylinderGeometry(0.55, 0.6, 0.2, 16), ecBaseMat);
        ecBase.position.y = 0.1;
        group.add(ecBase);

        // Base rim with purple accents
        const ecBaseRim = new THREE.Mesh(
          new THREE.TorusGeometry(0.55, 0.05, 8, 20),
          new THREE.MeshPhongMaterial({ color: 0x5a20aa, shininess: 100, specular: 0x8844cc })
        );
        ecBaseRim.position.y = 0.2;
        ecBaseRim.rotation.x = Math.PI / 2;
        group.add(ecBaseRim);

        // Cannon mount / turret body
        const ecTurret = new THREE.Mesh(
          new THREE.CylinderGeometry(0.3, 0.4, 0.5, 12),
          new THREE.MeshPhongMaterial({ color: 0x4a3a2a, shininess: 30 })
        );
        ecTurret.position.y = 0.45;
        group.add(ecTurret);

        // Eggplant body as the cannon barrel
        const ecBodyGeo = new THREE.SphereGeometry(0.32, 24, 20);
        ecBodyGeo.scale(0.8, 1.6, 0.8);
        const ecBody = new THREE.Mesh(ecBodyGeo, new THREE.MeshPhongMaterial({
          color: 0x3a0070, shininess: 120, specular: 0xaa66dd,
          emissive: 0x1a0040, emissiveIntensity: 0.25
        }));
        ecBody.position.set(0.3, 1.0, 0);
        ecBody.rotation.z = -Math.PI / 3; // Tilted like a cannon barrel
        group.add(ecBody);

        // Glossy highlight streaks on eggplant
        for (let hl = 0; hl < 2; hl++) {
          const hlGeo = new THREE.SphereGeometry(0.05, 8, 8);
          hlGeo.scale(1, 3.5, 1);
          const hlMesh = new THREE.Mesh(hlGeo, new THREE.MeshBasicMaterial({
            color: 0xffffff, transparent: true, opacity: 0.2
          }));
          hlMesh.position.set(0.3 + (hl === 0 ? 0.15 : -0.1), 1.0, hl === 0 ? 0.15 : -0.15);
          hlMesh.rotation.z = -Math.PI / 3;
          group.add(hlMesh);
        }

        // Calyx (green leaves at stem end of eggplant)
        const ecCalyxMat = new THREE.MeshPhongMaterial({
          color: 0x2d7a2d, shininess: 50, emissive: 0x114411, emissiveIntensity: 0.15,
          side: THREE.DoubleSide
        });
        for (let c = 0; c < 5; c++) {
          const cAng = (c / 5) * Math.PI * 2;
          const calyx = new THREE.Mesh(
            new THREE.PlaneGeometry(0.12, 0.2),
            ecCalyxMat
          );
          calyx.position.set(
            0.0 + Math.cos(cAng) * 0.08,
            0.65 + Math.sin(cAng) * 0.04,
            Math.sin(cAng) * 0.08
          );
          calyx.rotation.z = 0.3;
          calyx.rotation.y = cAng;
          group.add(calyx);
        }

        // Cannon muzzle ring at tip of eggplant
        const ecMuzzle = new THREE.Mesh(
          new THREE.TorusGeometry(0.18, 0.04, 8, 16),
          new THREE.MeshPhongMaterial({ color: 0x555555, shininess: 120, specular: 0xaaaaaa })
        );
        ecMuzzle.position.set(0.6, 1.35, 0);
        ecMuzzle.rotation.y = Math.PI / 2;
        ecMuzzle.rotation.x = Math.PI / 6;
        group.add(ecMuzzle);

        // Stun energy orb at muzzle
        const ecOrb = new THREE.Mesh(
          new THREE.SphereGeometry(0.1, 12, 12),
          new THREE.MeshBasicMaterial({ color: 0xaa00ff, transparent: true, opacity: 0.6 })
        );
        ecOrb.position.set(0.65, 1.4, 0);
        group.add(ecOrb);

        // Purple stun aura
        const ecAura = new THREE.Mesh(
          new THREE.SphereGeometry(0.6, 16, 16),
          new THREE.MeshBasicMaterial({ color: 0x7700cc, transparent: true, opacity: 0.08 })
        );
        ecAura.position.y = 0.9;
        group.add(ecAura);

        // Lightning bolt decorations on turret
        for (let lb = 0; lb < 3; lb++) {
          const lbAng = (lb / 3) * Math.PI * 2;
          const bolt = new THREE.Mesh(
            new THREE.ConeGeometry(0.04, 0.18, 4),
            new THREE.MeshBasicMaterial({ color: 0xffff00, transparent: true, opacity: 0.7 })
          );
          bolt.position.set(Math.cos(lbAng) * 0.35, 0.5, Math.sin(lbAng) * 0.35);
          bolt.rotation.z = Math.cos(lbAng) * 0.5;
          group.add(bolt);
        }

        break;
      }

      case 'kiwi-slammer': {
        // KIWI SLAMMER - Kiwi Blocker + Avocado Slammer fusion
        // 3000 HP, uses 200 HP to slam 300 damage every 5 seconds

        // Heavy ground base with cracks
        const ksBaseMat = new THREE.MeshPhongMaterial({ color: 0x5c3d2e, shininess: 15, emissive: 0x1a1208, emissiveIntensity: 0.1 });
        const ksBase = new THREE.Mesh(new THREE.CylinderGeometry(0.65, 0.75, 0.18, 16), ksBaseMat);
        ksBase.position.y = 0.09;
        group.add(ksBase);

        // Main kiwi body - large oval (same as kiwi-blocker)
        const ksBodyGeo = new THREE.SphereGeometry(0.55, 24, 20);
        ksBodyGeo.scale(1, 1.2, 1);
        const ksBody = new THREE.Mesh(ksBodyGeo, new THREE.MeshPhongMaterial({
          color: 0x7a6040, shininess: 10, emissive: 0x2a1a0a, emissiveIntensity: 0.1
        }));
        ksBody.position.y = 0.8;
        group.add(ksBody);

        // Fuzzy skin layer
        const ksFuzzGeo = new THREE.SphereGeometry(0.57, 16, 14);
        ksFuzzGeo.scale(1, 1.2, 1);
        const ksFuzz = new THREE.Mesh(ksFuzzGeo, new THREE.MeshPhongMaterial({
          color: 0x8b7355, shininess: 3, transparent: true, opacity: 0.5
        }));
        ksFuzz.position.y = 0.8;
        group.add(ksFuzz);

        // Fuzzy bumps
        for (let i = 0; i < 30; i++) {
          const theta = (i * 2.399) % (Math.PI * 2);
          const phi = Math.acos(1 - 2 * ((i + 0.5) / 30));
          const bump = new THREE.Mesh(
            new THREE.SphereGeometry(0.03, 5, 5),
            new THREE.MeshPhongMaterial({ color: i % 3 === 0 ? 0x6a5538 : 0x7a6548, shininess: 3 })
          );
          bump.position.set(
            0.55 * Math.sin(phi) * Math.cos(theta),
            0.8 + 0.66 * Math.cos(phi),
            0.55 * Math.sin(phi) * Math.sin(theta)
          );
          group.add(bump);
        }

        // Sliced kiwi top showing green flesh
        const ksSlice = new THREE.Mesh(
          new THREE.CylinderGeometry(0.38, 0.38, 0.06, 20),
          new THREE.MeshPhongMaterial({ color: 0x7ec850, shininess: 70, emissive: 0x2a6a10, emissiveIntensity: 0.25 })
        );
        ksSlice.position.y = 1.42;
        group.add(ksSlice);

        // White center core
        const ksCore = new THREE.Mesh(
          new THREE.CylinderGeometry(0.09, 0.09, 0.07, 12),
          new THREE.MeshPhongMaterial({ color: 0xf5f5e0, shininess: 50 })
        );
        ksCore.position.y = 1.44;
        group.add(ksCore);

        // Seed pattern
        for (let ring = 0; ring < 2; ring++) {
          const sdCount = ring === 0 ? 6 : 10;
          const sdRadius = ring === 0 ? 0.14 : 0.28;
          for (let s = 0; s < sdCount; s++) {
            const sAng = (s / sdCount) * Math.PI * 2;
            const sdGeo = new THREE.SphereGeometry(0.015, 6, 6);
            sdGeo.scale(1, 1, 2.5);
            const sd = new THREE.Mesh(sdGeo, new THREE.MeshPhongMaterial({ color: 0x1a1a1a, shininess: 80 }));
            sd.position.set(Math.cos(sAng) * sdRadius, 1.46, Math.sin(sAng) * sdRadius);
            sd.rotation.y = sAng;
            group.add(sd);
          }
        }

        // === AVOCADO SLAMMER FISTS ===
        // Big avocado-green fist (right)
        const ksFistMat = new THREE.MeshPhongMaterial({
          color: 0x4a8c28, shininess: 40, specular: 0x336622,
          emissive: 0x1a4a0a, emissiveIntensity: 0.2
        });
        const ksRFist = new THREE.Mesh(new THREE.SphereGeometry(0.25, 12, 12), ksFistMat);
        ksRFist.position.set(0.15, 0.6, -0.65);
        group.add(ksRFist);

        // Right arm
        const ksRArm = new THREE.Mesh(
          new THREE.CylinderGeometry(0.08, 0.1, 0.5, 8),
          ksFistMat
        );
        ksRArm.position.set(0.1, 0.7, -0.5);
        ksRArm.rotation.x = -Math.PI / 4;
        group.add(ksRArm);

        // Left fist
        const ksLFist = new THREE.Mesh(new THREE.SphereGeometry(0.25, 12, 12), ksFistMat);
        ksLFist.position.set(0.15, 0.6, 0.65);
        group.add(ksLFist);

        // Left arm
        const ksLArm = new THREE.Mesh(
          new THREE.CylinderGeometry(0.08, 0.1, 0.5, 8),
          ksFistMat
        );
        ksLArm.position.set(0.1, 0.7, 0.5);
        ksLArm.rotation.x = Math.PI / 4;
        group.add(ksLArm);

        // Knuckle details on fists
        for (const side of [-1, 1]) {
          for (let k = 0; k < 3; k++) {
            const knuckle = new THREE.Mesh(
              new THREE.SphereGeometry(0.06, 6, 6),
              new THREE.MeshPhongMaterial({ color: 0x3a7a1a, shininess: 30 })
            );
            knuckle.position.set(0.35, 0.55, -(side * 0.65 + (k - 1) * 0.08));
            group.add(knuckle);
          }
        }

        // Angry eyes (red glow)
        for (const side of [-0.15, 0.15]) {
          const eye = new THREE.Mesh(
            new THREE.SphereGeometry(0.06, 8, 8),
            new THREE.MeshBasicMaterial({ color: 0xff4400 })
          );
          eye.position.set(0.5, 1.05, -side);
          group.add(eye);

          // Eye glow
          const eyeGlow = new THREE.Mesh(
            new THREE.SphereGeometry(0.1, 8, 8),
            new THREE.MeshBasicMaterial({ color: 0xff2200, transparent: true, opacity: 0.3 })
          );
          eyeGlow.position.set(0.5, 1.05, -side);
          group.add(eyeGlow);
        }

        // Impact crack lines on ground
        const ksCrackMat = new THREE.MeshBasicMaterial({ color: 0xff6600, transparent: true, opacity: 0.3 });
        for (let cr = 0; cr < 6; cr++) {
          const crAng = (cr / 6) * Math.PI * 2;
          const crack = new THREE.Mesh(
            new THREE.BoxGeometry(0.04, 0.02, 0.5),
            ksCrackMat
          );
          crack.position.set(Math.cos(crAng) * 0.4, 0.02, Math.sin(crAng) * 0.4);
          crack.rotation.y = crAng;
          group.add(crack);
        }

        // Orange slam aura
        const ksAura = new THREE.Mesh(
          new THREE.SphereGeometry(0.7, 16, 16),
          new THREE.MeshBasicMaterial({ color: 0xff8800, transparent: true, opacity: 0.08 })
        );
        ksAura.position.y = 0.7;
        group.add(ksAura);

        break;
      }

      case 'grape-pulser': {
        // EPIC ELECTRIC GRAPE PULSER - Arcane tesla coil grape cannon
        // Base platform - hexagonal dark purple with electric trim
        const gpBaseGeo = new THREE.CylinderGeometry(0.5, 0.55, 0.15, 6);
        const gpBaseMat = new THREE.MeshPhongMaterial({ color: 0x2a0e4a, shininess: 80, specular: 0x6644aa });
        const gpBase = new THREE.Mesh(gpBaseGeo, gpBaseMat);
        gpBase.position.y = 0.075;
        group.add(gpBase);
        // Base electric ring
        const gpBaseRing = new THREE.Mesh(new THREE.TorusGeometry(0.5, 0.025, 8, 24), new THREE.MeshBasicMaterial({ color: 0x00ccff, transparent: true, opacity: 0.8 }));
        gpBaseRing.position.y = 0.15;
        gpBaseRing.rotation.x = Math.PI / 2;
        group.add(gpBaseRing);
        // Main body - layered bulb with neck
        const gpNeckGeo = new THREE.CylinderGeometry(0.18, 0.35, 0.3, 12);
        const gpNeckMat = new THREE.MeshPhongMaterial({ color: 0x3d1870, shininess: 60, specular: 0x5533aa });
        const gpNeck = new THREE.Mesh(gpNeckGeo, gpNeckMat);
        gpNeck.position.y = 0.3;
        group.add(gpNeck);
        // Main grape body - large pulsing orb
        const gpBodyGeo = new THREE.SphereGeometry(0.42, 20, 20);
        const gpBodyMat = new THREE.MeshPhongMaterial({ color: 0x7b3fc0, shininess: 150, specular: 0xcc88ff, emissive: 0x4a1080, emissiveIntensity: 0.4 });
        const gpBody = new THREE.Mesh(gpBodyGeo, gpBodyMat);
        gpBody.position.y = 0.7;
        gpBody.userData.isPowerCore = true;
        group.add(gpBody);
        // Inner electric plasma core
        const gpCoreGeo = new THREE.IcosahedronGeometry(0.22, 1);
        const gpCoreMat = new THREE.MeshBasicMaterial({ color: 0x00eeff, transparent: true, opacity: 0.6 });
        const gpCore = new THREE.Mesh(gpCoreGeo, gpCoreMat);
        gpCore.position.y = 0.7;
        gpCore.userData.isPowerCore = true;
        group.add(gpCore);
        // Inner bright spark
        const gpSparkGeo = new THREE.SphereGeometry(0.08, 8, 8);
        const gpSparkMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
        const gpSpark = new THREE.Mesh(gpSparkGeo, gpSparkMat);
        gpSpark.position.y = 0.7;
        group.add(gpSpark);
        // Tesla coil spikes radiating outward
        for (let i = 0; i < 6; i++) {
          const spikeGeo = new THREE.ConeGeometry(0.04, 0.35, 4);
          const spikeMat = new THREE.MeshPhongMaterial({ color: 0x9944dd, shininess: 100, emissive: 0x4400aa, emissiveIntensity: 0.3 });
          const spike = new THREE.Mesh(spikeGeo, spikeMat);
          const a = (i / 6) * Math.PI * 2;
          spike.position.set(Math.cos(a) * 0.38, 0.7, Math.sin(a) * 0.38);
          spike.rotation.z = a + Math.PI / 2;
          spike.rotation.y = a;
          group.add(spike);
          // Electric tip glow on each spike
          const tipGlow = new THREE.Mesh(new THREE.SphereGeometry(0.04, 6, 6), new THREE.MeshBasicMaterial({ color: 0x00ffff, transparent: true, opacity: 0.9 }));
          tipGlow.position.set(Math.cos(a) * 0.55, 0.7, Math.sin(a) * 0.55);
          tipGlow.userData.isPowerCore = true;
          group.add(tipGlow);
        }
        // Top grape crown cluster
        const gpTopGrape = new THREE.Mesh(new THREE.SphereGeometry(0.16, 10, 10), new THREE.MeshPhongMaterial({ color: 0x9b3fd0, shininess: 180, specular: 0xee88ff, emissive: 0x6622aa, emissiveIntensity: 0.3 }));
        gpTopGrape.position.y = 1.1;
        group.add(gpTopGrape);
        for (let i = 0; i < 5; i++) {
          const sg = new THREE.Mesh(new THREE.SphereGeometry(0.1, 8, 8), new THREE.MeshPhongMaterial({ color: 0x8b2dcc, shininess: 140, specular: 0xcc88ff }));
          const a = (i / 5) * Math.PI * 2;
          sg.position.set(Math.cos(a) * 0.18, 1.05, Math.sin(a) * 0.18);
          group.add(sg);
        }
        // Orbiting electric ring
        const gpOrbitRing = new THREE.Mesh(new THREE.TorusGeometry(0.55, 0.015, 8, 32), new THREE.MeshBasicMaterial({ color: 0x44ddff, transparent: true, opacity: 0.5 }));
        gpOrbitRing.position.y = 0.7;
        gpOrbitRing.userData.isPowerOrbit = true;
        group.add(gpOrbitRing);
        // Aura glow
        const gpAura = new THREE.Mesh(new THREE.SphereGeometry(0.65, 12, 12), new THREE.MeshBasicMaterial({ color: 0x6622ff, transparent: true, opacity: 0.08 }));
        gpAura.position.y = 0.7;
        group.add(gpAura);
        break;
      }

      case 'overgrown-vine-wall': {
        // EPIC OVERGROWN VINE WALL - Ancient living fortress
        const ovwMat = new THREE.MeshPhongMaterial({ color: 0x2d5a1e, shininess: 30, specular: 0x335522 });
        const ovwDarkMat = new THREE.MeshPhongMaterial({ color: 0x1a3a12, shininess: 20 });
        // Stone core with rounded edges
        const ovwCore = new THREE.Mesh(new THREE.BoxGeometry(1.4, 1.6, 1.2), new THREE.MeshPhongMaterial({ color: 0x4a4a3a, shininess: 20, specular: 0x333322 }));
        ovwCore.position.y = 0.85;
        group.add(ovwCore);
        // Mossy surface layer
        const ovwMoss = new THREE.Mesh(new THREE.BoxGeometry(1.5, 1.65, 1.3), ovwMat);
        ovwMoss.position.y = 0.87;
        group.add(ovwMoss);
        // Thick vine trunks wrapping around
        for (let i = 0; i < 4; i++) {
          const trunkGeo = new THREE.CylinderGeometry(0.12, 0.1, 1.8, 8);
          const trunk = new THREE.Mesh(trunkGeo, new THREE.MeshPhongMaterial({ color: 0x3d6a2e, shininess: 30 }));
          const zOff = (i < 2 ? 0.55 : -0.55);
          const xOff = (i % 2 === 0 ? 0.6 : -0.6);
          trunk.position.set(xOff, 0.9, zOff);
          trunk.rotation.z = (i % 2 === 0 ? 0.15 : -0.15);
          trunk.rotation.x = (i < 2 ? 0.1 : -0.1);
          group.add(trunk);
        }
        // Twisting vine strands across the face
        for (let i = 0; i < 8; i++) {
          const vineGeo = new THREE.CylinderGeometry(0.06, 0.04, 0.8 + Math.random() * 0.4, 6);
          const vine = new THREE.Mesh(vineGeo, new THREE.MeshPhongMaterial({ color: 0x4a8a3a, shininess: 30 }));
          vine.position.set((Math.random() - 0.5) * 1.2, 0.3 + Math.random() * 1.2, (Math.random() - 0.5) * 1.0);
          vine.rotation.z = (Math.random() - 0.5) * 0.8;
          vine.rotation.x = (Math.random() - 0.5) * 0.4;
          group.add(vine);
        }
        // Large leaves sprouting outward
        const leafMat = new THREE.MeshPhongMaterial({ color: 0x44bb22, shininess: 50, specular: 0x66dd44 });
        for (let i = 0; i < 8; i++) {
          const leafGeo = new THREE.SphereGeometry(0.18, 8, 6);
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(1, 0.3, 1.8);
          const a = (i / 8) * Math.PI * 2;
          const r = 0.65 + Math.random() * 0.2;
          leaf.position.set(Math.cos(a) * r, 0.5 + Math.random() * 1.0, Math.sin(a) * r);
          leaf.rotation.y = -a;
          leaf.rotation.z = (Math.random() - 0.5) * 0.5;
          group.add(leaf);
        }
        // Glowing flower buds
        for (let i = 0; i < 3; i++) {
          const budGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const budMat = new THREE.MeshPhongMaterial({ color: 0x88ff44, shininess: 100, emissive: 0x44aa22, emissiveIntensity: 0.5 });
          const bud = new THREE.Mesh(budGeo, budMat);
          bud.position.set((Math.random() - 0.5) * 1.0, 1.4 + Math.random() * 0.3, (Math.random() - 0.5) * 0.8);
          bud.userData.isPowerCore = true;
          group.add(bud);
        }
        // Top crown of thorns/branches
        for (let i = 0; i < 6; i++) {
          const thornGeo = new THREE.ConeGeometry(0.04, 0.3, 4);
          const thorn = new THREE.Mesh(thornGeo, ovwDarkMat);
          const a = (i / 6) * Math.PI * 2;
          thorn.position.set(Math.cos(a) * 0.5, 1.75, Math.sin(a) * 0.5);
          thorn.rotation.z = (Math.random() - 0.5) * 0.6;
          group.add(thorn);
        }
        // Nature aura - healing green glow
        const ovwAura = new THREE.Mesh(new THREE.SphereGeometry(1.2, 12, 12), new THREE.MeshBasicMaterial({ color: 0x44ff44, transparent: true, opacity: 0.08 }));
        ovwAura.position.y = 0.9;
        group.add(ovwAura);
        // Orbiting leaf ring
        const ovwOrbit = new THREE.Mesh(new THREE.TorusGeometry(0.9, 0.02, 8, 24), new THREE.MeshBasicMaterial({ color: 0x66ff44, transparent: true, opacity: 0.4 }));
        ovwOrbit.position.y = 0.9;
        ovwOrbit.userData.isPowerOrbit = true;
        group.add(ovwOrbit);
        break;
      }

      case 'great-god-lily': {
        // DIVINE GREAT GOD LILY - Celestial sun deity flower
        // Sacred pedestal base
        const gglPedestal = new THREE.Mesh(new THREE.CylinderGeometry(0.5, 0.55, 0.12, 12), new THREE.MeshPhongMaterial({ color: 0xdaa520, shininess: 150, specular: 0xffffff }));
        gglPedestal.position.y = 0.06;
        group.add(gglPedestal);
        const gglPedestalRim = new THREE.Mesh(new THREE.TorusGeometry(0.5, 0.02, 8, 24), new THREE.MeshBasicMaterial({ color: 0xffee66, transparent: true, opacity: 0.7 }));
        gglPedestalRim.position.y = 0.12;
        gglPedestalRim.rotation.x = Math.PI / 2;
        group.add(gglPedestalRim);
        // Ornate golden stem with spiral grooves
        const gglStem = new THREE.Mesh(new THREE.CylinderGeometry(0.07, 0.12, 0.55, 10), new THREE.MeshPhongMaterial({ color: 0xdaa520, shininess: 120, specular: 0xffdd88 }));
        gglStem.position.y = 0.4;
        group.add(gglStem);
        // Spiral vine around stem
        for (let i = 0; i < 12; i++) {
          const spiralGeo = new THREE.SphereGeometry(0.025, 6, 6);
          const spiralMat = new THREE.MeshPhongMaterial({ color: 0x44aa22, shininess: 60 });
          const spiral = new THREE.Mesh(spiralGeo, spiralMat);
          const t = i / 12;
          const a = t * Math.PI * 4;
          spiral.position.set(Math.cos(a) * 0.1, 0.15 + t * 0.5, Math.sin(a) * 0.1);
          group.add(spiral);
        }
        // Inner divine sun core - blazing
        const gglSunCore = new THREE.Mesh(new THREE.IcosahedronGeometry(0.2, 2), new THREE.MeshBasicMaterial({ color: 0xffffaa }));
        gglSunCore.position.y = 0.8;
        gglSunCore.userData.isPowerCore = true;
        group.add(gglSunCore);
        // Outer sun orb
        const gglSunOrb = new THREE.Mesh(new THREE.SphereGeometry(0.3, 16, 16), new THREE.MeshPhongMaterial({ color: 0xffd700, shininess: 200, specular: 0xffffff, emissive: 0xcc8800, emissiveIntensity: 0.5, transparent: true, opacity: 0.85 }));
        gglSunOrb.position.y = 0.8;
        group.add(gglSunOrb);
        // Two layers of petals - inner and outer
        // Inner petals (bright gold, pointed upward)
        for (let i = 0; i < 6; i++) {
          const petalGeo = new THREE.ConeGeometry(0.12, 0.35, 6);
          const petalMat = new THREE.MeshPhongMaterial({ color: 0xffcc00, shininess: 150, specular: 0xffffff, emissive: 0xaa7700, emissiveIntensity: 0.3 });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          const a = (i / 6) * Math.PI * 2;
          petal.position.set(Math.cos(a) * 0.22, 0.85, Math.sin(a) * 0.22);
          petal.rotation.z = Math.cos(a) * 0.5;
          petal.rotation.x = -Math.sin(a) * 0.5;
          group.add(petal);
        }
        // Outer petals (orange-gold, fanning outward)
        for (let i = 0; i < 8; i++) {
          const petalGeo = new THREE.SphereGeometry(0.18, 8, 6);
          const petalMat = new THREE.MeshPhongMaterial({ color: 0xff9900, shininess: 80, specular: 0xffdd88, emissive: 0x664400, emissiveIntensity: 0.2 });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          petal.scale.set(1, 0.25, 1.8);
          const a = (i / 8) * Math.PI * 2 + 0.2;
          petal.position.set(Math.cos(a) * 0.4, 0.7, Math.sin(a) * 0.4);
          petal.rotation.y = -a;
          group.add(petal);
        }
        // Divine halo - double ring
        const gglHalo1 = new THREE.Mesh(new THREE.TorusGeometry(0.5, 0.035, 8, 32), new THREE.MeshBasicMaterial({ color: 0xffdd00, transparent: true, opacity: 0.7 }));
        gglHalo1.position.y = 1.2;
        gglHalo1.rotation.x = Math.PI / 2;
        gglHalo1.userData.isPowerOrbit = true;
        group.add(gglHalo1);
        const gglHalo2 = new THREE.Mesh(new THREE.TorusGeometry(0.4, 0.02, 8, 32), new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.5 }));
        gglHalo2.position.y = 1.25;
        gglHalo2.rotation.x = Math.PI / 2;
        group.add(gglHalo2);
        // Crown jewels on halo
        for (let i = 0; i < 7; i++) {
          const jewel = new THREE.Mesh(new THREE.OctahedronGeometry(0.05, 0), new THREE.MeshPhongMaterial({ color: i % 2 === 0 ? 0xff4400 : 0x00ccff, shininess: 200, specular: 0xffffff, emissive: i % 2 === 0 ? 0xaa2200 : 0x0066aa, emissiveIntensity: 0.5 }));
          const a = (i / 7) * Math.PI * 2;
          jewel.position.set(Math.cos(a) * 0.5, 1.2, Math.sin(a) * 0.5);
          jewel.userData.isPowerCore = true;
          group.add(jewel);
        }
        // Sun ray beams emanating outward
        for (let i = 0; i < 8; i++) {
          const rayGeo = new THREE.CylinderGeometry(0.01, 0.025, 0.4, 4);
          const rayMat = new THREE.MeshBasicMaterial({ color: 0xffee44, transparent: true, opacity: 0.5 });
          const ray = new THREE.Mesh(rayGeo, rayMat);
          const a = (i / 8) * Math.PI * 2;
          ray.position.set(Math.cos(a) * 0.55, 0.8, Math.sin(a) * 0.55);
          ray.rotation.z = a + Math.PI / 2;
          ray.rotation.y = a;
          group.add(ray);
        }
        // Divine light aura
        const gglAura = new THREE.Mesh(new THREE.SphereGeometry(0.7, 12, 12), new THREE.MeshBasicMaterial({ color: 0xffee44, transparent: true, opacity: 0.1 }));
        gglAura.position.y = 0.85;
        group.add(gglAura);
        break;
      }

      case 'strawberry-pear-launcher': {
        // STRAWBERRY PEAR LAUNCHER - Fusion of Pear Cannon + Strawberry Launcher
        const splBase = new THREE.Mesh(
          new THREE.CylinderGeometry(0.7, 0.8, 0.2, 12),
          new THREE.MeshPhongMaterial({ color: 0x8b6914, shininess: 40, specular: 0x554422 })
        );
        splBase.position.y = 0.1;
        group.add(splBase);
        const splTrim = new THREE.Mesh(
          new THREE.TorusGeometry(0.72, 0.04, 8, 24),
          new THREE.MeshPhongMaterial({ color: 0xffd700, shininess: 200, specular: 0xffffff, emissive: 0x886600, emissiveIntensity: 0.3 })
        );
        splTrim.rotation.x = Math.PI / 2;
        splTrim.position.y = 0.2;
        group.add(splTrim);
        for (let ec = 0; ec < 6; ec++) {
          const channel = new THREE.Mesh(
            new THREE.BoxGeometry(0.05, 0.04, 0.5),
            new THREE.MeshPhongMaterial({ color: 0xff3344, emissive: 0xff1122, emissiveIntensity: 0.6, transparent: true, opacity: 0.8 })
          );
          const ecAngle = (ec / 6) * Math.PI * 2;
          channel.position.set(Math.cos(ecAngle) * 0.4, 0.22, Math.sin(ecAngle) * 0.4);
          channel.rotation.y = ecAngle;
          group.add(channel);
        }
        const splPearMat = new THREE.MeshPhongMaterial({ color: 0xc5e636, shininess: 120, specular: 0xffffaa, emissive: 0x3a4a10, emissiveIntensity: 0.2 });
        const splPear = new THREE.Mesh(new THREE.SphereGeometry(0.5, 16, 16), splPearMat);
        splPear.scale.set(1, 1.3, 1);
        splPear.position.y = 0.75;
        group.add(splPear);
        const splTop = new THREE.Mesh(new THREE.SphereGeometry(0.32, 12, 12), splPearMat);
        splTop.position.y = 1.15;
        group.add(splTop);
        const splBlushMat = new THREE.MeshPhongMaterial({ color: 0xff8888, transparent: true, opacity: 0.4, emissive: 0xff4444, emissiveIntensity: 0.2 });
        const splBlush1 = new THREE.Mesh(new THREE.SphereGeometry(0.15, 8, 8), splBlushMat);
        splBlush1.position.set(0.35, 0.65, 0.2);
        splBlush1.scale.set(1.2, 0.8, 0.5);
        group.add(splBlush1);
        const splBlush2 = new THREE.Mesh(new THREE.SphereGeometry(0.15, 8, 8), splBlushMat.clone());
        splBlush2.position.set(0.35, 0.65, -0.2);
        splBlush2.scale.set(1.2, 0.8, 0.5);
        group.add(splBlush2);
        for (let sd = 0; sd < 8; sd++) {
          const seed = new THREE.Mesh(
            new THREE.SphereGeometry(0.03, 6, 6),
            new THREE.MeshPhongMaterial({ color: 0xff2255, emissive: 0xcc0033, emissiveIntensity: 0.5 })
          );
          const sdPhi = Math.acos(-1 + (2 * sd) / 8);
          const sdTheta = Math.sqrt(8 * Math.PI) * sdPhi;
          seed.position.set(0.42 * Math.cos(sdTheta) * Math.sin(sdPhi), 0.75 + 0.5 * Math.cos(sdPhi), 0.42 * Math.sin(sdTheta) * Math.sin(sdPhi));
          group.add(seed);
        }
        const splTurretGroup = new THREE.Group();
        splTurretGroup.position.y = 1.35;
        splTurretGroup.add(new THREE.Mesh(
          new THREE.CylinderGeometry(0.15, 0.18, 0.15, 8),
          new THREE.MeshPhongMaterial({ color: 0xcc2244, shininess: 100, specular: 0xff8888, emissive: 0x881122, emissiveIntensity: 0.3 })
        ));
        for (let br = 0; br < 3; br++) {
          const barrel = new THREE.Mesh(
            new THREE.CylinderGeometry(0.06, 0.08, 0.6, 8),
            new THREE.MeshPhongMaterial({ color: 0xdd3355, shininess: 80, specular: 0xff8899, emissive: 0x991133, emissiveIntensity: 0.3 })
          );
          barrel.rotation.z = -Math.PI / 2;
          const brAngle = (br / 3) * Math.PI * 2;
          barrel.position.set(0.3, Math.sin(brAngle) * 0.1, Math.cos(brAngle) * 0.1);
          splTurretGroup.add(barrel);
          const muzzle = new THREE.Mesh(
            new THREE.SphereGeometry(0.07, 8, 8),
            new THREE.MeshBasicMaterial({ color: 0xff6688, transparent: true, opacity: 0.6 })
          );
          muzzle.position.set(0.6, Math.sin(brAngle) * 0.1, Math.cos(brAngle) * 0.1);
          splTurretGroup.add(muzzle);
        }
        group.add(splTurretGroup);
        group.userData.turret = splTurretGroup;
        const splStem = new THREE.Mesh(new THREE.CylinderGeometry(0.03, 0.04, 0.15, 6), new THREE.MeshPhongMaterial({ color: 0x5c3a1e }));
        splStem.position.y = 1.55;
        group.add(splStem);
        const splAura = new THREE.Mesh(new THREE.SphereGeometry(0.9, 12, 12), new THREE.MeshBasicMaterial({ color: 0xff6644, transparent: true, opacity: 0.08 }));
        splAura.position.y = 0.8;
        group.add(splAura);
        break;
      }

      case 'frozen-pickle-spear': {
        // FROZEN PICKLE SPEAR - Fusion of Pickle Spiker + Frost Berri
        const fpsBase = new THREE.Mesh(
          new THREE.CylinderGeometry(0.65, 0.75, 0.25, 8),
          new THREE.MeshPhongMaterial({ color: 0x88ccee, shininess: 200, specular: 0xffffff, emissive: 0x2266aa, emissiveIntensity: 0.3, transparent: true, opacity: 0.85 })
        );
        fpsBase.position.y = 0.12;
        group.add(fpsBase);
        const fpsInner = new THREE.Mesh(new THREE.SphereGeometry(0.3, 12, 12), new THREE.MeshBasicMaterial({ color: 0xaaeeff, transparent: true, opacity: 0.4 }));
        fpsInner.position.y = 0.12;
        group.add(fpsInner);
        for (let ri = 0; ri < 2; ri++) {
          const ring = new THREE.Mesh(
            new THREE.TorusGeometry(0.42 + ri * 0.08, 0.03, 8, 16),
            new THREE.MeshPhongMaterial({ color: 0x888899, shininess: 150, specular: 0xffffff, emissive: 0x334455, emissiveIntensity: 0.2 })
          );
          ring.rotation.x = Math.PI / 2;
          ring.position.y = 0.35 + ri * 0.35;
          group.add(ring);
        }
        const fpsPickle = new THREE.Mesh(
          new THREE.CylinderGeometry(0.35, 0.38, 0.8, 10),
          new THREE.MeshPhongMaterial({ color: 0x4caf50, shininess: 80, specular: 0x88ff88, emissive: 0x1a5c1a, emissiveIntensity: 0.2 })
        );
        fpsPickle.position.y = 0.65;
        group.add(fpsPickle);
        for (let bp = 0; bp < 6; bp++) {
          const bump = new THREE.Mesh(new THREE.SphereGeometry(0.06, 6, 6), new THREE.MeshPhongMaterial({ color: 0x388e3c, emissive: 0x1b5e1b, emissiveIntensity: 0.2 }));
          const bpAngle = (bp / 6) * Math.PI * 2;
          bump.position.set(Math.cos(bpAngle) * 0.36, 0.45 + (bp % 3) * 0.2, Math.sin(bpAngle) * 0.36);
          group.add(bump);
        }
        for (let cr = 0; cr < 5; cr++) {
          const crystal = new THREE.Mesh(
            new THREE.OctahedronGeometry(0.1, 0),
            new THREE.MeshPhongMaterial({ color: 0xaaeeff, shininess: 200, specular: 0xffffff, emissive: 0x4488cc, emissiveIntensity: 0.5, transparent: true, opacity: 0.85 })
          );
          const crAngle = (cr / 5) * Math.PI * 2;
          crystal.position.set(Math.cos(crAngle) * 0.42, 0.5 + (cr % 3) * 0.25, Math.sin(crAngle) * 0.42);
          crystal.rotation.set(Math.random(), Math.random(), Math.random());
          group.add(crystal);
        }
        const fpsShaft = new THREE.Mesh(
          new THREE.CylinderGeometry(0.05, 0.07, 0.8, 8),
          new THREE.MeshPhongMaterial({ color: 0x66bbdd, shininess: 150, specular: 0xffffff, emissive: 0x224466, emissiveIntensity: 0.3 })
        );
        fpsShaft.rotation.z = -Math.PI / 2;
        fpsShaft.position.set(0.65, 0.8, 0);
        group.add(fpsShaft);
        const fpsTip = new THREE.Mesh(
          new THREE.ConeGeometry(0.12, 0.35, 6),
          new THREE.MeshPhongMaterial({ color: 0xccf0ff, shininess: 250, specular: 0xffffff, emissive: 0x66aadd, emissiveIntensity: 0.6, transparent: true, opacity: 0.9 })
        );
        fpsTip.rotation.z = -Math.PI / 2;
        fpsTip.position.set(1.2, 0.8, 0);
        group.add(fpsTip);
        for (let vn = 0; vn < 3; vn++) {
          const vein = new THREE.Mesh(new THREE.CylinderGeometry(0.015, 0.015, 0.6, 6), new THREE.MeshPhongMaterial({ color: 0x52b828, emissive: 0x1f4010, emissiveIntensity: 0.3 }));
          vein.rotation.z = -Math.PI / 2;
          const vnAngle = (vn / 3) * Math.PI * 2;
          vein.position.set(0.65, 0.8 + Math.sin(vnAngle) * 0.06, Math.cos(vnAngle) * 0.06);
          group.add(vein);
        }
        const fpsMist = new THREE.Mesh(new THREE.SphereGeometry(0.8, 12, 12), new THREE.MeshBasicMaterial({ color: 0x88ddff, transparent: true, opacity: 0.08 }));
        fpsMist.position.y = 0.7;
        group.add(fpsMist);
        break;
      }

      case 'mushroom-healer': {
        // MUSHROOM HEALER - Fusion of Mushroom Bomber + Rose Reaper
        const mhBase = new THREE.Mesh(new THREE.CylinderGeometry(0.7, 0.8, 0.15, 12), new THREE.MeshPhongMaterial({ color: 0x3e2723, shininess: 20, specular: 0x332211 }));
        mhBase.position.y = 0.08;
        group.add(mhBase);
        for (let ms = 0; ms < 5; ms++) {
          const moss = new THREE.Mesh(new THREE.SphereGeometry(0.08, 6, 6), new THREE.MeshPhongMaterial({ color: 0x558b2f, emissive: 0x2e7d10, emissiveIntensity: 0.2 }));
          const msAngle = (ms / 5) * Math.PI * 2;
          moss.position.set(Math.cos(msAngle) * 0.55, 0.15, Math.sin(msAngle) * 0.55);
          moss.scale.set(1.5, 0.5, 1.5);
          group.add(moss);
        }
        const mhStem = new THREE.Mesh(new THREE.CylinderGeometry(0.18, 0.28, 0.7, 10), new THREE.MeshPhongMaterial({ color: 0xf5e6c8, shininess: 30, specular: 0xeeeecc, emissive: 0x332211, emissiveIntensity: 0.1 }));
        mhStem.position.y = 0.5;
        group.add(mhStem);
        for (let vi = 0; vi < 3; vi++) {
          const viAngle = (vi / 3) * Math.PI * 2;
          for (let vj = 0; vj < 4; vj++) {
            const vineSeg = new THREE.Mesh(new THREE.CylinderGeometry(0.02, 0.02, 0.2, 6), new THREE.MeshPhongMaterial({ color: 0x2e7d32, emissive: 0x1b5e20, emissiveIntensity: 0.2 }));
            const spiralAng = viAngle + vj * 0.5;
            vineSeg.position.set(Math.cos(spiralAng) * 0.22, 0.25 + vj * 0.15, Math.sin(spiralAng) * 0.22);
            vineSeg.rotation.z = Math.sin(spiralAng) * 0.3;
            group.add(vineSeg);
          }
          for (let vt = 0; vt < 2; vt++) {
            const thorn = new THREE.Mesh(new THREE.ConeGeometry(0.015, 0.06, 4), new THREE.MeshPhongMaterial({ color: 0x8b4513, emissive: 0x442200, emissiveIntensity: 0.3 }));
            const thAngle = viAngle + vt * 0.8;
            thorn.position.set(Math.cos(thAngle) * 0.26, 0.35 + vt * 0.2, Math.sin(thAngle) * 0.26);
            group.add(thorn);
          }
        }
        for (let rb = 0; rb < 3; rb++) {
          const rose = new THREE.Mesh(new THREE.SphereGeometry(0.06, 8, 8), new THREE.MeshPhongMaterial({ color: 0xff4477, emissive: 0xcc1144, emissiveIntensity: 0.4 }));
          const rbAngle = (rb / 3) * Math.PI * 2 + 0.3;
          rose.position.set(Math.cos(rbAngle) * 0.28, 0.35 + rb * 0.18, Math.sin(rbAngle) * 0.28);
          group.add(rose);
        }
        const mhCap = new THREE.Mesh(
          new THREE.SphereGeometry(0.55, 16, 16, 0, Math.PI * 2, 0, Math.PI / 2),
          new THREE.MeshPhongMaterial({ color: 0x7b1fa2, shininess: 60, specular: 0xcc88ff, emissive: 0x4a0072, emissiveIntensity: 0.25 })
        );
        mhCap.position.y = 0.9;
        group.add(mhCap);
        const mhGill = new THREE.Mesh(new THREE.CircleGeometry(0.55, 16), new THREE.MeshPhongMaterial({ color: 0xe8d5b7, side: THREE.DoubleSide }));
        mhGill.rotation.x = Math.PI / 2;
        mhGill.position.y = 0.9;
        group.add(mhGill);
        for (let sp = 0; sp < 7; sp++) {
          const spot = new THREE.Mesh(new THREE.SphereGeometry(0.06, 8, 8), new THREE.MeshPhongMaterial({ color: 0x44ff88, emissive: 0x22cc66, emissiveIntensity: 0.8, transparent: true, opacity: 0.9 }));
          const spPhi = 0.2 + Math.random() * 0.6;
          const spTheta = (sp / 7) * Math.PI * 2;
          spot.position.set(Math.cos(spTheta) * Math.sin(spPhi) * 0.52, 0.9 + Math.cos(spPhi) * 0.52, Math.sin(spTheta) * Math.sin(spPhi) * 0.52);
          spot.scale.set(1, 0.8, 1);
          group.add(spot);
        }
        const mhAura = new THREE.Mesh(new THREE.SphereGeometry(1.0, 12, 12), new THREE.MeshBasicMaterial({ color: 0x44ff88, transparent: true, opacity: 0.08 }));
        mhAura.position.y = 0.7;
        group.add(mhAura);
        for (let hsp = 0; hsp < 4; hsp++) {
          const spore = new THREE.Mesh(new THREE.SphereGeometry(0.04, 6, 6), new THREE.MeshBasicMaterial({ color: 0x66ffaa, transparent: true, opacity: 0.6 }));
          const hspAngle = (hsp / 4) * Math.PI * 2;
          spore.position.set(Math.cos(hspAngle) * 0.6, 1.1 + (hsp % 2) * 0.2, Math.sin(hspAngle) * 0.6);
          group.add(spore);
        }
        break;
      }

      case 'red-fire-flower': {
        // RED FIRE FLOWER - Dragon Battle reward plant
        // Terracotta pot
        const rffPotGeo = new THREE.CylinderGeometry(0.38, 0.30, 0.35, 16);
        const rffPotMat = new THREE.MeshPhongMaterial({ color: 0x8b3a2a, shininess: 40, specular: 0x444444 });
        const rffPot = new THREE.Mesh(rffPotGeo, rffPotMat);
        rffPot.position.y = 0.175;
        group.add(rffPot);
        // Pot rim
        const rffRimGeo = new THREE.TorusGeometry(0.38, 0.04, 8, 16);
        const rffRim = new THREE.Mesh(rffRimGeo, new THREE.MeshPhongMaterial({ color: 0xa04030, shininess: 60 }));
        rffRim.position.y = 0.35;
        rffRim.rotation.x = Math.PI / 2;
        group.add(rffRim);
        // Soil
        const rffSoilGeo = new THREE.CylinderGeometry(0.34, 0.34, 0.08, 16);
        const rffSoil = new THREE.Mesh(rffSoilGeo, new THREE.MeshPhongMaterial({ color: 0x3d2817, shininess: 5 }));
        rffSoil.position.y = 0.32;
        group.add(rffSoil);
        // Fiery red stem
        const rffStemGeo = new THREE.CylinderGeometry(0.08, 0.14, 0.9, 12);
        const rffStemMat = new THREE.MeshPhongMaterial({ color: 0x8b2500, shininess: 20, emissive: 0x441100, emissiveIntensity: 0.3 });
        const rffStem = new THREE.Mesh(rffStemGeo, rffStemMat);
        rffStem.position.y = 0.80;
        group.add(rffStem);
        // Leaves on stem
        for (let lf = 0; lf < 3; lf++) {
          const leafGeo = new THREE.SphereGeometry(0.12, 8, 8);
          const leafMat = new THREE.MeshPhongMaterial({ color: 0x2d5a1e, shininess: 30, emissive: 0x112200, emissiveIntensity: 0.1 });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(0.5, 0.3, 1.2);
          const lfAngle = (lf / 3) * Math.PI * 2;
          leaf.position.set(Math.cos(lfAngle) * 0.18, 0.5 + lf * 0.15, Math.sin(lfAngle) * 0.18);
          leaf.rotation.y = lfAngle;
          group.add(leaf);
        }
        // 8 Red fire petals
        for (let p = 0; p < 8; p++) {
          const petalGeo = new THREE.SphereGeometry(0.16, 8, 8);
          const petalMat = new THREE.MeshPhongMaterial({ color: 0xff2200, shininess: 80, specular: 0xff8866, emissive: 0xcc1100, emissiveIntensity: 0.5 });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          petal.scale.set(1, 0.4, 1.3);
          const pAngle = (p / 8) * Math.PI * 2;
          petal.position.set(Math.cos(pAngle) * 0.22, 1.35, Math.sin(pAngle) * 0.22);
          petal.rotation.y = -pAngle;
          group.add(petal);
        }
        // Inner orange petals
        for (let ip = 0; ip < 5; ip++) {
          const innerPetalGeo = new THREE.SphereGeometry(0.10, 8, 8);
          const innerPetalMat = new THREE.MeshPhongMaterial({ color: 0xff6600, shininess: 100, emissive: 0xff4400, emissiveIntensity: 0.6 });
          const innerPetal = new THREE.Mesh(innerPetalGeo, innerPetalMat);
          innerPetal.scale.set(1, 0.5, 1.2);
          const ipAngle = (ip / 5) * Math.PI * 2 + 0.4;
          innerPetal.position.set(Math.cos(ipAngle) * 0.12, 1.38, Math.sin(ipAngle) * 0.12);
          innerPetal.rotation.y = -ipAngle;
          group.add(innerPetal);
        }
        // Glowing fire center
        const rffCenterGeo = new THREE.SphereGeometry(0.14, 12, 12);
        const rffCenterMat = new THREE.MeshPhongMaterial({ color: 0xff8800, shininess: 200, specular: 0xffffff, emissive: 0xff6600, emissiveIntensity: 0.9 });
        const rffCenter = new THREE.Mesh(rffCenterGeo, rffCenterMat);
        rffCenter.position.y = 1.35;
        group.add(rffCenter);
        // Fire particles floating above
        for (let fp = 0; fp < 5; fp++) {
          const flameGeo = new THREE.ConeGeometry(0.05, 0.18, 6);
          const flameMat = new THREE.MeshBasicMaterial({ color: fp % 2 === 0 ? 0xff4400 : 0xffaa00, transparent: true, opacity: 0.7 });
          const flame = new THREE.Mesh(flameGeo, flameMat);
          flame.position.set((Math.random() - 0.5) * 0.3, 1.55 + Math.random() * 0.2, (Math.random() - 0.5) * 0.3);
          flame.userData.isFlameParticle = true;
          group.add(flame);
        }
        // Fire glow aura
        const rffAuraGeo = new THREE.SphereGeometry(0.5, 12, 12);
        const rffAuraMat = new THREE.MeshBasicMaterial({ color: 0xff4400, transparent: true, opacity: 0.12 });
        const rffAura = new THREE.Mesh(rffAuraGeo, rffAuraMat);
        rffAura.position.y = 1.35;
        group.add(rffAura);
        break;
      }

      case 'red-firecracker-flower': {
        // RED FIRECRACKER FLOWER - Fusion: Red Fire Flower + Red Fire Flower
        // Ornate black pot with gold trim
        const rcfPotGeo = new THREE.CylinderGeometry(0.42, 0.32, 0.4, 16);
        const rcfPotMat = new THREE.MeshPhongMaterial({ color: 0x1a1a1a, shininess: 80, specular: 0x666666 });
        const rcfPot = new THREE.Mesh(rcfPotGeo, rcfPotMat);
        rcfPot.position.y = 0.2;
        group.add(rcfPot);
        // Gold rim
        const rcfRimGeo = new THREE.TorusGeometry(0.42, 0.05, 8, 16);
        const rcfRim = new THREE.Mesh(rcfRimGeo, new THREE.MeshPhongMaterial({ color: 0xffd700, shininess: 200 }));
        rcfRim.position.y = 0.4;
        rcfRim.rotation.x = Math.PI / 2;
        group.add(rcfRim);
        // Ember soil
        const rcfSoilGeo = new THREE.CylinderGeometry(0.38, 0.38, 0.08, 16);
        const rcfSoil = new THREE.Mesh(rcfSoilGeo, new THREE.MeshPhongMaterial({ color: 0x4a1500, emissive: 0x220800, emissiveIntensity: 0.3 }));
        rcfSoil.position.y = 0.36;
        group.add(rcfSoil);
        // Thick fiery stem
        const rcfStemGeo = new THREE.CylinderGeometry(0.10, 0.16, 1.0, 12);
        const rcfStemMat = new THREE.MeshPhongMaterial({ color: 0x6b1500, shininess: 20, emissive: 0x551100, emissiveIntensity: 0.4 });
        const rcfStem = new THREE.Mesh(rcfStemGeo, rcfStemMat);
        rcfStem.position.y = 0.85;
        group.add(rcfStem);
        // Leaves with ember veins
        for (let lf = 0; lf < 4; lf++) {
          const leafGeo = new THREE.SphereGeometry(0.14, 8, 8);
          const leafMat = new THREE.MeshPhongMaterial({ color: 0x2d5a1e, shininess: 30, emissive: 0x331100, emissiveIntensity: 0.2 });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(0.5, 0.3, 1.3);
          const lfAngle = (lf / 4) * Math.PI * 2;
          leaf.position.set(Math.cos(lfAngle) * 0.2, 0.55 + lf * 0.12, Math.sin(lfAngle) * 0.2);
          leaf.rotation.y = lfAngle;
          group.add(leaf);
        }
        // 10 deep crimson petals (larger than base)
        for (let p = 0; p < 10; p++) {
          const petalGeo = new THREE.SphereGeometry(0.18, 8, 8);
          const petalMat = new THREE.MeshPhongMaterial({ color: 0xcc0000, shininess: 100, specular: 0xff6644, emissive: 0xaa0000, emissiveIntensity: 0.6 });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          petal.scale.set(1, 0.4, 1.4);
          const pAngle = (p / 10) * Math.PI * 2;
          petal.position.set(Math.cos(pAngle) * 0.28, 1.45, Math.sin(pAngle) * 0.28);
          petal.rotation.y = -pAngle;
          group.add(petal);
        }
        // Inner blazing orange petals
        for (let ip = 0; ip < 6; ip++) {
          const innerGeo = new THREE.SphereGeometry(0.11, 8, 8);
          const innerMat = new THREE.MeshPhongMaterial({ color: 0xff5500, shininess: 120, emissive: 0xff3300, emissiveIntensity: 0.7 });
          const innerPetal = new THREE.Mesh(innerGeo, innerMat);
          innerPetal.scale.set(1, 0.5, 1.2);
          const ipAngle = (ip / 6) * Math.PI * 2 + 0.3;
          innerPetal.position.set(Math.cos(ipAngle) * 0.15, 1.48, Math.sin(ipAngle) * 0.15);
          innerPetal.rotation.y = -ipAngle;
          group.add(innerPetal);
        }
        // White-hot center core
        const rcfCenterGeo = new THREE.SphereGeometry(0.16, 12, 12);
        const rcfCenterMat = new THREE.MeshPhongMaterial({ color: 0xffcc00, shininess: 200, specular: 0xffffff, emissive: 0xff8800, emissiveIntensity: 1.0 });
        const rcfCenter = new THREE.Mesh(rcfCenterGeo, rcfCenterMat);
        rcfCenter.position.y = 1.45;
        group.add(rcfCenter);
        // Two mini firecrackers sticking out of the flower
        for (let fc = 0; fc < 2; fc++) {
          const fcAngle = fc === 0 ? -0.4 : 0.4;
          const fcGroup = new THREE.Group();
          // Red firecracker body
          const fcBodyGeo = new THREE.CylinderGeometry(0.05, 0.05, 0.35, 8);
          const fcBodyMat = new THREE.MeshPhongMaterial({ color: 0xff0000, shininess: 100, emissive: 0xcc0000, emissiveIntensity: 0.4 });
          const fcBody = new THREE.Mesh(fcBodyGeo, fcBodyMat);
          fcBody.rotation.z = Math.PI / 2;
          fcGroup.add(fcBody);
          // Gold bands
          for (let b = 0; b < 2; b++) {
            const bandGeo = new THREE.CylinderGeometry(0.07, 0.07, 0.02, 8);
            const bandMat = new THREE.MeshPhongMaterial({ color: 0xffd700, shininess: 200 });
            const band = new THREE.Mesh(bandGeo, bandMat);
            band.rotation.z = Math.PI / 2;
            band.position.x = (b - 0.5) * 0.15;
            fcGroup.add(band);
          }
          // Sparking fuse tip
          const fcFuseGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const fcFuse = new THREE.Mesh(fcFuseGeo, new THREE.MeshBasicMaterial({ color: 0xffaa00, transparent: true, opacity: 0.9 }));
          fcFuse.position.x = 0.22;
          fcGroup.add(fcFuse);
          fcGroup.position.set(Math.sin(fcAngle) * 0.2, 1.55, Math.cos(fcAngle) * 0.2);
          fcGroup.rotation.z = 0.3 * (fc === 0 ? 1 : -1);
          group.add(fcGroup);
        }
        // Intense fire particles
        for (let fp = 0; fp < 8; fp++) {
          const flameGeo = new THREE.ConeGeometry(0.06, 0.22, 6);
          const flameMat = new THREE.MeshBasicMaterial({ color: fp % 3 === 0 ? 0xff2200 : fp % 3 === 1 ? 0xff6600 : 0xffaa00, transparent: true, opacity: 0.75 });
          const flame = new THREE.Mesh(flameGeo, flameMat);
          flame.position.set((Math.random() - 0.5) * 0.4, 1.65 + Math.random() * 0.25, (Math.random() - 0.5) * 0.4);
          flame.userData.isFlameParticle = true;
          group.add(flame);
        }
        // Large fire glow aura
        const rcfAuraGeo = new THREE.SphereGeometry(0.6, 12, 12);
        const rcfAuraMat = new THREE.MeshBasicMaterial({ color: 0xff3300, transparent: true, opacity: 0.15 });
        const rcfAura = new THREE.Mesh(rcfAuraGeo, rcfAuraMat);
        rcfAura.position.y = 1.45;
        group.add(rcfAura);
        break;
      }

      case 'red-firespiker-flower': {
        // RED FIRESPIKER FLOWER - Fusion: Red Firecracker Flower + Tomato Spike
        // Dark iron pot with spike motif
        const rsfPotGeo = new THREE.CylinderGeometry(0.44, 0.34, 0.42, 16);
        const rsfPotMat = new THREE.MeshPhongMaterial({ color: 0x2a1a1a, shininess: 60, specular: 0x555555 });
        const rsfPot = new THREE.Mesh(rsfPotGeo, rsfPotMat);
        rsfPot.position.y = 0.21;
        group.add(rsfPot);
        // Crimson gold rim
        const rsfRimGeo = new THREE.TorusGeometry(0.44, 0.05, 8, 16);
        const rsfRim = new THREE.Mesh(rsfRimGeo, new THREE.MeshPhongMaterial({ color: 0xcc3300, shininess: 150 }));
        rsfRim.position.y = 0.42;
        rsfRim.rotation.x = Math.PI / 2;
        group.add(rsfRim);
        // Spike studs around pot
        for (let sp = 0; sp < 6; sp++) {
          const spikeGeo = new THREE.ConeGeometry(0.04, 0.12, 6);
          const spikeMat = new THREE.MeshPhongMaterial({ color: 0x888888, shininess: 100 });
          const spike = new THREE.Mesh(spikeGeo, spikeMat);
          const spAngle = (sp / 6) * Math.PI * 2;
          spike.position.set(Math.cos(spAngle) * 0.44, 0.25, Math.sin(spAngle) * 0.44);
          spike.rotation.z = -spAngle + Math.PI / 2;
          spike.rotation.x = Math.PI / 2;
          group.add(spike);
        }
        // Ember soil with glowing cracks
        const rsfSoilGeo = new THREE.CylinderGeometry(0.40, 0.40, 0.08, 16);
        const rsfSoil = new THREE.Mesh(rsfSoilGeo, new THREE.MeshPhongMaterial({ color: 0x3a1200, emissive: 0x440800, emissiveIntensity: 0.4 }));
        rsfSoil.position.y = 0.38;
        group.add(rsfSoil);
        // Thorny stem with spikes
        const rsfStemGeo = new THREE.CylinderGeometry(0.11, 0.17, 1.1, 12);
        const rsfStemMat = new THREE.MeshPhongMaterial({ color: 0x5a1000, shininess: 20, emissive: 0x440800, emissiveIntensity: 0.5 });
        const rsfStem = new THREE.Mesh(rsfStemGeo, rsfStemMat);
        rsfStem.position.y = 0.90;
        group.add(rsfStem);
        // Thorns on stem
        for (let th = 0; th < 6; th++) {
          const thornGeo = new THREE.ConeGeometry(0.03, 0.15, 5);
          const thornMat = new THREE.MeshPhongMaterial({ color: 0xcc4400, shininess: 80, emissive: 0x661100, emissiveIntensity: 0.3 });
          const thorn = new THREE.Mesh(thornGeo, thornMat);
          const thAngle = (th / 6) * Math.PI * 2;
          const thY = 0.5 + th * 0.12;
          thorn.position.set(Math.cos(thAngle) * 0.16, thY, Math.sin(thAngle) * 0.16);
          thorn.rotation.z = Math.cos(thAngle) * 0.8;
          thorn.rotation.x = Math.sin(thAngle) * 0.8;
          group.add(thorn);
        }
        // Fiery leaves with red veins
        for (let lf = 0; lf < 4; lf++) {
          const leafGeo = new THREE.SphereGeometry(0.15, 8, 8);
          const leafMat = new THREE.MeshPhongMaterial({ color: 0x3a6620, shininess: 30, emissive: 0x441100, emissiveIntensity: 0.25 });
          const leaf = new THREE.Mesh(leafGeo, leafMat);
          leaf.scale.set(0.5, 0.3, 1.4);
          const lfAngle = (lf / 4) * Math.PI * 2 + 0.4;
          leaf.position.set(Math.cos(lfAngle) * 0.22, 0.6 + lf * 0.1, Math.sin(lfAngle) * 0.22);
          leaf.rotation.y = lfAngle;
          group.add(leaf);
        }
        // 12 deep red-black petals
        for (let p = 0; p < 12; p++) {
          const petalGeo = new THREE.SphereGeometry(0.19, 8, 8);
          const petalMat = new THREE.MeshPhongMaterial({ color: 0xaa0000, shininess: 110, specular: 0xff4422, emissive: 0x880000, emissiveIntensity: 0.65 });
          const petal = new THREE.Mesh(petalGeo, petalMat);
          petal.scale.set(1, 0.4, 1.5);
          const pAngle = (p / 12) * Math.PI * 2;
          petal.position.set(Math.cos(pAngle) * 0.32, 1.55, Math.sin(pAngle) * 0.32);
          petal.rotation.y = -pAngle;
          group.add(petal);
        }
        // Inner molten orange petals with spike tips
        for (let ip = 0; ip < 7; ip++) {
          const innerGeo = new THREE.SphereGeometry(0.12, 8, 8);
          const innerMat = new THREE.MeshPhongMaterial({ color: 0xff4400, shininess: 130, emissive: 0xff2200, emissiveIntensity: 0.8 });
          const innerPetal = new THREE.Mesh(innerGeo, innerMat);
          innerPetal.scale.set(0.8, 0.5, 1.3);
          const ipAngle = (ip / 7) * Math.PI * 2 + 0.2;
          innerPetal.position.set(Math.cos(ipAngle) * 0.17, 1.58, Math.sin(ipAngle) * 0.17);
          innerPetal.rotation.y = -ipAngle;
          group.add(innerPetal);
          // Spike tip on each inner petal
          const tipGeo = new THREE.ConeGeometry(0.03, 0.1, 5);
          const tipMat = new THREE.MeshPhongMaterial({ color: 0xff6600, emissive: 0xff4400, emissiveIntensity: 0.6 });
          const tip = new THREE.Mesh(tipGeo, tipMat);
          tip.position.set(Math.cos(ipAngle) * 0.25, 1.60, Math.sin(ipAngle) * 0.25);
          tip.rotation.z = Math.cos(ipAngle) * 0.5;
          tip.rotation.x = Math.sin(ipAngle) * 0.5;
          group.add(tip);
        }
        // White-hot spiked center core
        const rsfCenterGeo = new THREE.SphereGeometry(0.18, 12, 12);
        const rsfCenterMat = new THREE.MeshPhongMaterial({ color: 0xffdd00, shininess: 200, specular: 0xffffff, emissive: 0xff9900, emissiveIntensity: 1.0 });
        const rsfCenter = new THREE.Mesh(rsfCenterGeo, rsfCenterMat);
        rsfCenter.position.y = 1.55;
        group.add(rsfCenter);
        // Three firecrackers sticking out with spiked tips
        for (let fc = 0; fc < 3; fc++) {
          const fcAngle = (fc / 3) * Math.PI * 2 - Math.PI / 2;
          const fcGroup = new THREE.Group();
          // Red firecracker body
          const fcBodyGeo = new THREE.CylinderGeometry(0.055, 0.055, 0.38, 8);
          const fcBodyMat = new THREE.MeshPhongMaterial({ color: 0xdd0000, shininess: 100, emissive: 0xaa0000, emissiveIntensity: 0.5 });
          const fcBody = new THREE.Mesh(fcBodyGeo, fcBodyMat);
          fcBody.rotation.z = Math.PI / 2;
          fcGroup.add(fcBody);
          // Gold band
          const bandGeo = new THREE.CylinderGeometry(0.075, 0.075, 0.02, 8);
          const band = new THREE.Mesh(bandGeo, new THREE.MeshPhongMaterial({ color: 0xffd700, shininess: 200 }));
          band.rotation.z = Math.PI / 2;
          fcGroup.add(band);
          // Spike tip on firecracker
          const fcTipGeo = new THREE.ConeGeometry(0.04, 0.12, 6);
          const fcTip = new THREE.Mesh(fcTipGeo, new THREE.MeshPhongMaterial({ color: 0x999999, shininess: 120, emissive: 0x444444, emissiveIntensity: 0.2 }));
          fcTip.rotation.z = -Math.PI / 2;
          fcTip.position.x = 0.24;
          fcGroup.add(fcTip);
          // Sparking fuse
          const fcFuse = new THREE.Mesh(
            new THREE.SphereGeometry(0.04, 6, 6),
            new THREE.MeshBasicMaterial({ color: 0xffcc00, transparent: true, opacity: 0.9 })
          );
          fcFuse.position.x = -0.23;
          fcGroup.add(fcFuse);
          fcGroup.position.set(Math.cos(fcAngle) * 0.22, 1.65, Math.sin(fcAngle) * 0.22);
          fcGroup.rotation.z = 0.35 * Math.cos(fcAngle);
          fcGroup.rotation.x = 0.35 * Math.sin(fcAngle);
          group.add(fcGroup);
        }
        // Intense fire + ember particles
        for (let fp = 0; fp < 10; fp++) {
          const flameGeo = new THREE.ConeGeometry(0.065, 0.24, 6);
          const colors = [0xff1100, 0xff5500, 0xffaa00, 0xff3300];
          const flameMat = new THREE.MeshBasicMaterial({ color: colors[fp % 4], transparent: true, opacity: 0.8 });
          const flame = new THREE.Mesh(flameGeo, flameMat);
          flame.position.set((Math.random() - 0.5) * 0.45, 1.75 + Math.random() * 0.3, (Math.random() - 0.5) * 0.45);
          flame.userData.isFlameParticle = true;
          group.add(flame);
        }
        // Large intense fire aura
        const rsfAuraGeo = new THREE.SphereGeometry(0.7, 12, 12);
        const rsfAuraMat = new THREE.MeshBasicMaterial({ color: 0xff2200, transparent: true, opacity: 0.18 });
        const rsfAura = new THREE.Mesh(rsfAuraGeo, rsfAuraMat);
        rsfAura.position.y = 1.55;
        group.add(rsfAura);
        break;
      }

      default: {
        const geometry = new THREE.BoxGeometry(1, 1, 1);
        const material = new THREE.MeshPhongMaterial({ color: 0x00ff00 });
        const cube = new THREE.Mesh(geometry, material);
        group.add(cube);
      }
    }

    return group;
  }

  private createAllyMesh(allyType: AllyType): THREE.Group {
    const group = new THREE.Group();

    switch (allyType) {
      case 'raccoon': {
        // Enhanced cute but fierce raccoon ally with fluffy fur look

        // Body - bigger and fluffier
        const bodyGeo = new THREE.SphereGeometry(0.3, 16, 16);
        bodyGeo.scale(1.1, 0.9, 1.3);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0x6a6a6a,
          shininess: 30,
          emissive: 0x222222,
          emissiveIntensity: 0.1
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.35;
        group.add(body);

        // Fluffy chest tuft
        const chestGeo = new THREE.SphereGeometry(0.18, 10, 10);
        chestGeo.scale(1, 0.8, 0.6);
        const chestMat = new THREE.MeshPhongMaterial({
          color: 0x888888,
          shininess: 20
        });
        const chest = new THREE.Mesh(chestGeo, chestMat);
        chest.position.set(0, 0.3, 0.18);
        group.add(chest);

        // Head - rounder and more expressive
        const headGeo = new THREE.SphereGeometry(0.22, 14, 14);
        const headMat = new THREE.MeshPhongMaterial({
          color: 0x777777,
          shininess: 40,
          emissive: 0x222222,
          emissiveIntensity: 0.1
        });
        const head = new THREE.Mesh(headGeo, headMat);
        head.position.set(0, 0.52, 0.22);
        group.add(head);

        // Mask pattern (dark around eyes) - more detailed
        const maskGeo = new THREE.SphereGeometry(0.15, 10, 10);
        maskGeo.scale(1.4, 0.5, 0.5);
        const maskMat = new THREE.MeshPhongMaterial({
          color: 0x1a1a1a,
          shininess: 60
        });
        const mask = new THREE.Mesh(maskGeo, maskMat);
        mask.position.set(0, 0.55, 0.32);
        group.add(mask);

        // Snout
        const snoutGeo = new THREE.SphereGeometry(0.08, 8, 8);
        snoutGeo.scale(1, 0.7, 1.2);
        const snoutMat = new THREE.MeshPhongMaterial({ color: 0x999999 });
        const snout = new THREE.Mesh(snoutGeo, snoutMat);
        snout.position.set(0, 0.48, 0.38);
        group.add(snout);

        // Nose
        const noseGeo = new THREE.SphereGeometry(0.035, 6, 6);
        const noseMat = new THREE.MeshPhongMaterial({
          color: 0x111111,
          shininess: 100
        });
        const nose = new THREE.Mesh(noseGeo, noseMat);
        nose.position.set(0, 0.5, 0.44);
        group.add(nose);

        // Eyes - larger and more expressive
        for (let side = -1; side <= 1; side += 2) {
          const eyeGeo = new THREE.SphereGeometry(0.055, 8, 8);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.08, 0.55, 0.36);
          group.add(eye);

          const pupilGeo = new THREE.SphereGeometry(0.03, 8, 8);
          const pupilMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const pupil = new THREE.Mesh(pupilGeo, pupilMat);
          pupil.position.set(side * 0.08, 0.55, 0.4);
          group.add(pupil);

          // Eye shine
          const shineGeo = new THREE.SphereGeometry(0.012, 4, 4);
          const shineMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const shine = new THREE.Mesh(shineGeo, shineMat);
          shine.position.set(side * 0.06, 0.57, 0.41);
          group.add(shine);
        }

        // Ears - bigger and fluffier
        for (let side = -1; side <= 1; side += 2) {
          const earGeo = new THREE.ConeGeometry(0.08, 0.12, 8);
          const ear = new THREE.Mesh(earGeo, headMat);
          ear.position.set(side * 0.14, 0.68, 0.15);
          ear.rotation.z = side * 0.25;
          group.add(ear);

          // Inner ear
          const innerEarGeo = new THREE.ConeGeometry(0.04, 0.06, 6);
          const innerEarMat = new THREE.MeshPhongMaterial({ color: 0xffcccc });
          const innerEar = new THREE.Mesh(innerEarGeo, innerEarMat);
          innerEar.position.set(side * 0.14, 0.66, 0.17);
          innerEar.rotation.z = side * 0.25;
          group.add(innerEar);
        }

        // Striped fluffy tail - more rings
        for (let ring = 0; ring < 5; ring++) {
          const ringGeo = new THREE.CylinderGeometry(0.07 - ring * 0.005, 0.08 - ring * 0.005, 0.08, 10);
          const ringMat = new THREE.MeshPhongMaterial({
            color: ring % 2 === 0 ? 0x555555 : 0x222222,
            shininess: 30
          });
          const ringMesh = new THREE.Mesh(ringGeo, ringMat);
          ringMesh.position.set(0, 0.38, -0.25 - ring * 0.06);
          ringMesh.rotation.x = 0.6;
          group.add(ringMesh);
        }

        // Legs with paws
        for (let i = 0; i < 4; i++) {
          const legGeo = new THREE.CylinderGeometry(0.045, 0.05, 0.18, 8);
          const leg = new THREE.Mesh(legGeo, bodyMat);
          leg.position.set(
            (i % 2 === 0 ? -0.14 : 0.14),
            0.1,
            (i < 2 ? 0.12 : -0.1)
          );
          group.add(leg);

          // Paws
          const pawGeo = new THREE.SphereGeometry(0.05, 6, 6);
          pawGeo.scale(1, 0.5, 1.2);
          const pawMat = new THREE.MeshPhongMaterial({ color: 0x333333 });
          const paw = new THREE.Mesh(pawGeo, pawMat);
          paw.position.set(
            (i % 2 === 0 ? -0.14 : 0.14),
            0.02,
            (i < 2 ? 0.14 : -0.08)
          );
          group.add(paw);
        }

        break;
      }

      case 'monkey': {
        // Enhanced agile monkey ally with vibrant golden-brown fur

        // Body - sleeker, more athletic
        const bodyGeo = new THREE.SphereGeometry(0.26, 14, 14);
        bodyGeo.scale(0.85, 1.1, 1.15);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0xa0522d,
          shininess: 45,
          emissive: 0x442211,
          emissiveIntensity: 0.15
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.4;
        group.add(body);

        // Belly fur - lighter
        const bellyGeo = new THREE.SphereGeometry(0.15, 10, 10);
        bellyGeo.scale(1.2, 1, 0.6);
        const bellyMat = new THREE.MeshPhongMaterial({
          color: 0xf5deb3,
          shininess: 30
        });
        const belly = new THREE.Mesh(bellyGeo, bellyMat);
        belly.position.set(0, 0.38, 0.12);
        group.add(belly);

        // Head - more expressive
        const headGeo = new THREE.SphereGeometry(0.2, 12, 12);
        const head = new THREE.Mesh(headGeo, bodyMat);
        head.position.set(0, 0.62, 0.14);
        group.add(head);

        // Face (lighter color, heart-shaped)
        const faceGeo = new THREE.SphereGeometry(0.15, 10, 10);
        faceGeo.scale(1.1, 0.9, 0.55);
        const faceMat = new THREE.MeshPhongMaterial({
          color: 0xffe4c4,
          shininess: 50
        });
        const face = new THREE.Mesh(faceGeo, faceMat);
        face.position.set(0, 0.58, 0.26);
        group.add(face);

        // Muzzle
        const muzzleGeo = new THREE.SphereGeometry(0.08, 8, 8);
        muzzleGeo.scale(1, 0.6, 0.8);
        const muzzle = new THREE.Mesh(muzzleGeo, faceMat);
        muzzle.position.set(0, 0.52, 0.32);
        group.add(muzzle);

        // Nose
        const noseGeo = new THREE.SphereGeometry(0.03, 6, 6);
        const noseMat = new THREE.MeshPhongMaterial({
          color: 0x654321,
          shininess: 80
        });
        const nose = new THREE.Mesh(noseGeo, noseMat);
        nose.position.set(0, 0.54, 0.38);
        group.add(nose);

        // Mouth
        const mouthGeo = new THREE.TorusGeometry(0.025, 0.008, 6, 8, Math.PI);
        const mouthMat = new THREE.MeshPhongMaterial({ color: 0x8b4513 });
        const mouth = new THREE.Mesh(mouthGeo, mouthMat);
        mouth.position.set(0, 0.49, 0.35);
        mouth.rotation.x = Math.PI;
        group.add(mouth);

        // Eyes - larger and more lively
        for (let side = -1; side <= 1; side += 2) {
          const eyeWhiteGeo = new THREE.SphereGeometry(0.05, 8, 8);
          const eyeWhiteMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const eyeWhite = new THREE.Mesh(eyeWhiteGeo, eyeWhiteMat);
          eyeWhite.position.set(side * 0.07, 0.62, 0.3);
          group.add(eyeWhite);

          const eyeGeo = new THREE.SphereGeometry(0.035, 8, 8);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0x4a3728 });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.07, 0.62, 0.34);
          group.add(eye);

          const pupilGeo = new THREE.SphereGeometry(0.018, 6, 6);
          const pupilMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const pupil = new THREE.Mesh(pupilGeo, pupilMat);
          pupil.position.set(side * 0.07, 0.62, 0.37);
          group.add(pupil);

          // Eye shine
          const shineGeo = new THREE.SphereGeometry(0.01, 4, 4);
          const shineMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const shine = new THREE.Mesh(shineGeo, shineMat);
          shine.position.set(side * 0.055, 0.64, 0.375);
          group.add(shine);
        }

        // Ears - larger, rounder
        for (let side = -1; side <= 1; side += 2) {
          const earGeo = new THREE.SphereGeometry(0.07, 8, 8);
          const ear = new THREE.Mesh(earGeo, faceMat);
          ear.position.set(side * 0.18, 0.62, 0.05);
          group.add(ear);

          // Inner ear
          const innerEarGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const innerEarMat = new THREE.MeshPhongMaterial({ color: 0xffb6c1 });
          const innerEar = new THREE.Mesh(innerEarGeo, innerEarMat);
          innerEar.position.set(side * 0.17, 0.62, 0.08);
          group.add(innerEar);
        }

        // Curly tail
        const tailSegments = 6;
        for (let i = 0; i < tailSegments; i++) {
          const segGeo = new THREE.SphereGeometry(0.035 - i * 0.003, 6, 6);
          const seg = new THREE.Mesh(segGeo, bodyMat);
          const angle = (i / tailSegments) * Math.PI * 1.5;
          const radius = 0.12 + i * 0.03;
          seg.position.set(
            0,
            0.35 - i * 0.02,
            -0.2 - Math.cos(angle) * radius
          );
          group.add(seg);
        }

        // Arms - longer, more nimble
        for (let side = -1; side <= 1; side += 2) {
          // Upper arm
          const upperArmGeo = new THREE.CylinderGeometry(0.04, 0.035, 0.2, 8);
          const arm = new THREE.Mesh(upperArmGeo, bodyMat);
          arm.position.set(side * 0.2, 0.42, 0.08);
          arm.rotation.z = side * 0.6;
          group.add(arm);

          // Lower arm
          const lowerArmGeo = new THREE.CylinderGeometry(0.035, 0.03, 0.18, 6);
          const lowerArm = new THREE.Mesh(lowerArmGeo, bodyMat);
          lowerArm.position.set(side * 0.3, 0.28, 0.12);
          lowerArm.rotation.z = side * 0.3;
          group.add(lowerArm);

          // Hand
          const handGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const hand = new THREE.Mesh(handGeo, faceMat);
          hand.position.set(side * 0.35, 0.18, 0.14);
          group.add(hand);
        }

        // Legs - stronger
        for (let side = -1; side <= 1; side += 2) {
          const legGeo = new THREE.CylinderGeometry(0.05, 0.04, 0.22, 8);
          const leg = new THREE.Mesh(legGeo, bodyMat);
          leg.position.set(side * 0.12, 0.15, 0);
          group.add(leg);

          // Feet
          const footGeo = new THREE.SphereGeometry(0.05, 6, 6);
          footGeo.scale(1.2, 0.5, 1.4);
          const foot = new THREE.Mesh(footGeo, faceMat);
          foot.position.set(side * 0.12, 0.03, 0.04);
          group.add(foot);
        }

        break;
      }

      case 'gorilla': {
        // Enhanced massive gorilla ally - powerful silverback

        // Large muscular body
        const bodyGeo = new THREE.SphereGeometry(0.5, 16, 16);
        bodyGeo.scale(1.15, 1.1, 1.3);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0x2a2a2a,
          shininess: 35,
          emissive: 0x111111,
          emissiveIntensity: 0.1
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.6;
        group.add(body);

        // Silverback stripe
        const silverGeo = new THREE.SphereGeometry(0.35, 12, 12);
        silverGeo.scale(1.2, 0.7, 0.8);
        const silverMat = new THREE.MeshPhongMaterial({
          color: 0x888888,
          shininess: 50,
          emissive: 0x444444,
          emissiveIntensity: 0.1
        });
        const silver = new THREE.Mesh(silverGeo, silverMat);
        silver.position.set(0, 0.65, -0.15);
        group.add(silver);

        // Broad powerful chest
        const chestGeo = new THREE.SphereGeometry(0.35, 12, 12);
        chestGeo.scale(1.3, 0.9, 0.55);
        const chestMat = new THREE.MeshPhongMaterial({
          color: 0x3a3a3a,
          shininess: 40
        });
        const chest = new THREE.Mesh(chestGeo, chestMat);
        chest.position.set(0, 0.55, 0.28);
        group.add(chest);

        // Muscle definition on chest
        for (let side = -1; side <= 1; side += 2) {
          const pecGeo = new THREE.SphereGeometry(0.12, 8, 8);
          pecGeo.scale(1, 0.8, 0.5);
          const pec = new THREE.Mesh(pecGeo, chestMat);
          pec.position.set(side * 0.12, 0.58, 0.35);
          group.add(pec);
        }

        // Head - more detailed
        const headGeo = new THREE.SphereGeometry(0.28, 14, 14);
        headGeo.scale(1.05, 0.95, 1.05);
        const head = new THREE.Mesh(headGeo, bodyMat);
        head.position.set(0, 1.0, 0.18);
        group.add(head);

        // Sagittal crest (top of head ridge)
        const crestGeo = new THREE.SphereGeometry(0.12, 8, 8);
        crestGeo.scale(0.8, 0.6, 1.5);
        const crest = new THREE.Mesh(crestGeo, bodyMat);
        crest.position.set(0, 1.15, 0.1);
        group.add(crest);

        // Brow ridge
        const browGeo = new THREE.SphereGeometry(0.18, 8, 8);
        browGeo.scale(1.2, 0.4, 0.5);
        const brow = new THREE.Mesh(browGeo, bodyMat);
        brow.position.set(0, 1.05, 0.32);
        group.add(brow);

        // Face
        const faceGeo = new THREE.SphereGeometry(0.18, 10, 10);
        faceGeo.scale(1.1, 0.8, 0.55);
        const faceMat = new THREE.MeshPhongMaterial({
          color: 0x2d2d2d,
          shininess: 45
        });
        const face = new THREE.Mesh(faceGeo, faceMat);
        face.position.set(0, 0.94, 0.36);
        group.add(face);

        // Nose/muzzle
        const noseGeo = new THREE.SphereGeometry(0.1, 8, 8);
        noseGeo.scale(1, 0.6, 0.7);
        const nose = new THREE.Mesh(noseGeo, faceMat);
        nose.position.set(0, 0.88, 0.42);
        group.add(nose);

        // Nostrils
        for (let side = -1; side <= 1; side += 2) {
          const nostrilGeo = new THREE.SphereGeometry(0.025, 4, 4);
          const nostrilMat = new THREE.MeshPhongMaterial({ color: 0x111111 });
          const nostril = new THREE.Mesh(nostrilGeo, nostrilMat);
          nostril.position.set(side * 0.04, 0.87, 0.48);
          group.add(nostril);
        }

        // Eyes - intense and focused
        for (let side = -1; side <= 1; side += 2) {
          // Eye socket shadow
          const socketGeo = new THREE.SphereGeometry(0.055, 6, 6);
          const socketMat = new THREE.MeshPhongMaterial({ color: 0x151515 });
          const socket = new THREE.Mesh(socketGeo, socketMat);
          socket.position.set(side * 0.1, 1.0, 0.36);
          group.add(socket);

          const eyeGeo = new THREE.SphereGeometry(0.045, 8, 8);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0x8b4513 });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.1, 1.0, 0.38);
          group.add(eye);

          const pupilGeo = new THREE.SphereGeometry(0.025, 6, 6);
          const pupilMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const pupil = new THREE.Mesh(pupilGeo, pupilMat);
          pupil.position.set(side * 0.1, 1.0, 0.42);
          group.add(pupil);

          // Intense eye shine
          const shineGeo = new THREE.SphereGeometry(0.012, 4, 4);
          const shineMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const shine = new THREE.Mesh(shineGeo, shineMat);
          shine.position.set(side * 0.08, 1.02, 0.425);
          group.add(shine);
        }

        // Ears
        for (let side = -1; side <= 1; side += 2) {
          const earGeo = new THREE.SphereGeometry(0.06, 6, 6);
          earGeo.scale(0.6, 1, 0.5);
          const ear = new THREE.Mesh(earGeo, bodyMat);
          ear.position.set(side * 0.25, 1.0, 0.05);
          group.add(ear);
        }

        // MASSIVE muscular arms
        for (let side = -1; side <= 1; side += 2) {
          // Shoulder
          const shoulderGeo = new THREE.SphereGeometry(0.15, 8, 8);
          const shoulder = new THREE.Mesh(shoulderGeo, bodyMat);
          shoulder.position.set(side * 0.38, 0.7, 0.15);
          group.add(shoulder);

          // Upper arm
          const upperArmGeo = new THREE.CylinderGeometry(0.14, 0.12, 0.4, 10);
          const upperArm = new THREE.Mesh(upperArmGeo, bodyMat);
          upperArm.position.set(side * 0.45, 0.5, 0.12);
          upperArm.rotation.z = side * 0.5;
          group.add(upperArm);

          // Forearm - even bigger
          const forearmGeo = new THREE.CylinderGeometry(0.12, 0.1, 0.35, 10);
          const forearm = new THREE.Mesh(forearmGeo, bodyMat);
          forearm.position.set(side * 0.55, 0.28, 0.15);
          forearm.rotation.z = side * 0.3;
          group.add(forearm);

          // Massive fists
          const fistGeo = new THREE.SphereGeometry(0.14, 10, 10);
          fistGeo.scale(1, 0.8, 1.1);
          const fist = new THREE.Mesh(fistGeo, bodyMat);
          fist.position.set(side * 0.6, 0.12, 0.18);
          group.add(fist);

          // Knuckle details
          for (let k = 0; k < 4; k++) {
            const knuckleGeo = new THREE.SphereGeometry(0.025, 4, 4);
            const knuckle = new THREE.Mesh(knuckleGeo, bodyMat);
            knuckle.position.set(
              side * 0.6 + side * 0.02,
              0.14,
              0.26 + (k - 1.5) * 0.035
            );
            group.add(knuckle);
          }
        }

        // Short powerful legs
        for (let side = -1; side <= 1; side += 2) {
          const legGeo = new THREE.CylinderGeometry(0.12, 0.1, 0.28, 10);
          const leg = new THREE.Mesh(legGeo, bodyMat);
          leg.position.set(side * 0.22, 0.18, 0);
          group.add(leg);

          // Feet
          const footGeo = new THREE.SphereGeometry(0.1, 8, 8);
          footGeo.scale(1.3, 0.5, 1.5);
          const foot = new THREE.Mesh(footGeo, bodyMat);
          foot.position.set(side * 0.22, 0.04, 0.06);
          group.add(foot);
        }

        break;
      }

      case 'icy-bull': {
        // Enhanced powerful icy bull ally from Frost Peel - crystalline ice beast
        const scale = 1.3;

        // Massive icy body with crystal structure
        const bodyGeo = new THREE.SphereGeometry(0.45 * scale, 16, 16);
        bodyGeo.scale(1.35, 1.0, 1.2);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0x7bc8ff,
          shininess: 120,
          emissive: 0x3399dd,
          emissiveIntensity: 0.35,
          specular: 0xffffff
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.5 * scale;
        group.add(body);

        // Ice crystal spines on back
        for (let i = 0; i < 5; i++) {
          const spineGeo = new THREE.OctahedronGeometry(0.08 * scale, 0);
          spineGeo.scale(0.5, 2, 0.5);
          const spineMat = new THREE.MeshPhongMaterial({
            color: 0xccffff,
            shininess: 200,
            emissive: 0x66ddff,
            emissiveIntensity: 0.6,
            transparent: true,
            opacity: 0.85
          });
          const spine = new THREE.Mesh(spineGeo, spineMat);
          spine.position.set(0, 0.7 * scale, -0.1 * scale + i * 0.12 * scale - 0.2 * scale);
          spine.rotation.x = 0.3;
          group.add(spine);
        }

        // Powerful head
        const headGeo = new THREE.SphereGeometry(0.28 * scale, 12, 12);
        headGeo.scale(1.1, 0.95, 1.05);
        const headMat = new THREE.MeshPhongMaterial({
          color: 0x8adcff,
          shininess: 110,
          emissive: 0x4499cc,
          emissiveIntensity: 0.35,
          specular: 0xffffff
        });
        const head = new THREE.Mesh(headGeo, headMat);
        head.position.set(0, 0.6 * scale, 0.4 * scale);
        group.add(head);

        // Majestic ice horns - larger and more detailed
        for (let side = -1; side <= 1; side += 2) {
          // Main horn
          const hornGeo = new THREE.ConeGeometry(0.07 * scale, 0.35 * scale, 8);
          const hornMat = new THREE.MeshPhongMaterial({
            color: 0xdfffff,
            shininess: 200,
            emissive: 0x99eeff,
            emissiveIntensity: 0.6,
            transparent: true,
            opacity: 0.9,
            specular: 0xffffff
          });
          const horn = new THREE.Mesh(hornGeo, hornMat);
          horn.position.set(side * 0.22 * scale, 0.82 * scale, 0.28 * scale);
          horn.rotation.z = side * -0.7;
          horn.rotation.x = -0.25;
          group.add(horn);

          // Horn ice crystal accents
          const crystalGeo = new THREE.OctahedronGeometry(0.03 * scale, 0);
          const crystal = new THREE.Mesh(crystalGeo, hornMat);
          crystal.position.set(side * 0.15 * scale, 0.72 * scale, 0.3 * scale);
          group.add(crystal);
        }

        // Powerful snout
        const snoutGeo = new THREE.CylinderGeometry(0.12 * scale, 0.15 * scale, 0.18 * scale, 10);
        const snout = new THREE.Mesh(snoutGeo, headMat);
        snout.position.set(0, 0.52 * scale, 0.58 * scale);
        snout.rotation.x = Math.PI / 2;
        group.add(snout);

        // Nose ring (ice)
        const ringGeo = new THREE.TorusGeometry(0.05 * scale, 0.015 * scale, 6, 12);
        const ringMat = new THREE.MeshPhongMaterial({
          color: 0xccffff,
          shininess: 150,
          emissive: 0x88ddff,
          emissiveIntensity: 0.5
        });
        const ring = new THREE.Mesh(ringGeo, ringMat);
        ring.position.set(0, 0.46 * scale, 0.66 * scale);
        ring.rotation.x = Math.PI / 2;
        group.add(ring);

        // Glowing icy eyes
        for (let side = -1; side <= 1; side += 2) {
          // Eye glow
          const glowGeo = new THREE.SphereGeometry(0.055 * scale, 8, 8);
          const glowMat = new THREE.MeshBasicMaterial({
            color: 0x00ffff,
            transparent: true,
            opacity: 0.4
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.set(side * 0.12 * scale, 0.64 * scale, 0.5 * scale);
          group.add(glow);

          const eyeGeo = new THREE.SphereGeometry(0.045 * scale, 8, 8);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0x00ffff });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.12 * scale, 0.64 * scale, 0.52 * scale);
          group.add(eye);

          const pupilGeo = new THREE.SphereGeometry(0.02 * scale, 6, 6);
          const pupilMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const pupil = new THREE.Mesh(pupilGeo, pupilMat);
          pupil.position.set(side * 0.12 * scale, 0.64 * scale, 0.56 * scale);
          group.add(pupil);
        }

        // Powerful legs with ice hooves
        for (let i = 0; i < 4; i++) {
          const legGeo = new THREE.CylinderGeometry(0.08 * scale, 0.07 * scale, 0.35 * scale, 8);
          const leg = new THREE.Mesh(legGeo, bodyMat);
          leg.position.set(
            (i % 2 === 0 ? -0.22 : 0.22) * scale,
            0.18 * scale,
            (i < 2 ? 0.18 : -0.18) * scale
          );
          group.add(leg);

          // Ice hooves
          const hoofGeo = new THREE.CylinderGeometry(0.09 * scale, 0.1 * scale, 0.06 * scale, 8);
          const hoofMat = new THREE.MeshPhongMaterial({
            color: 0xaaeeff,
            shininess: 150,
            emissive: 0x66ccff,
            emissiveIntensity: 0.4
          });
          const hoof = new THREE.Mesh(hoofGeo, hoofMat);
          hoof.position.set(
            (i % 2 === 0 ? -0.22 : 0.22) * scale,
            0.02 * scale,
            (i < 2 ? 0.18 : -0.18) * scale
          );
          group.add(hoof);
        }

        // Frosted tail
        const tailGeo = new THREE.CylinderGeometry(0.04 * scale, 0.02 * scale, 0.3 * scale, 6);
        const tail = new THREE.Mesh(tailGeo, bodyMat);
        tail.position.set(0, 0.45 * scale, -0.4 * scale);
        tail.rotation.x = 0.6;
        group.add(tail);

        // Tail ice tuft
        const tuftGeo = new THREE.OctahedronGeometry(0.06 * scale, 0);
        const tuft = new THREE.Mesh(tuftGeo, ringMat);
        tuft.position.set(0, 0.35 * scale, -0.55 * scale);
        group.add(tuft);

        // Enhanced icy aura with particles
        const auraGeo = new THREE.SphereGeometry(0.7 * scale, 16, 16);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x88eeff,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.45 * scale;
        group.add(aura);

        // Floating ice crystals around the bull
        for (let i = 0; i < 6; i++) {
          const crystalGeo = new THREE.OctahedronGeometry(0.04 * scale, 0);
          const crystalMat = new THREE.MeshPhongMaterial({
            color: 0xccffff,
            shininess: 200,
            emissive: 0x88eeff,
            emissiveIntensity: 0.7,
            transparent: true,
            opacity: 0.7
          });
          const crystal = new THREE.Mesh(crystalGeo, crystalMat);
          const angle = (i / 6) * Math.PI * 2;
          crystal.position.set(
            Math.cos(angle) * 0.6 * scale,
            0.5 * scale + Math.sin(i * 2) * 0.15,
            Math.sin(angle) * 0.6 * scale
          );
          crystal.userData.isIceCrystal = true;
          crystal.userData.crystalIndex = i;
          group.add(crystal);
        }

        break;
      }

      case 'icy-fox': {
        // Enhanced swift icy fox ally - graceful arctic spirit

        // Sleek icy body
        const bodyGeo = new THREE.SphereGeometry(0.24, 12, 12);
        bodyGeo.scale(1.5, 0.85, 1.1);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0xb8e4ff,
          shininess: 90,
          emissive: 0x5599cc,
          emissiveIntensity: 0.3,
          specular: 0xffffff
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.28;
        group.add(body);

        // White belly fur
        const bellyGeo = new THREE.SphereGeometry(0.15, 10, 10);
        bellyGeo.scale(1.3, 0.6, 0.8);
        const bellyMat = new THREE.MeshPhongMaterial({
          color: 0xe8f8ff,
          shininess: 60,
          emissive: 0x88ccdd,
          emissiveIntensity: 0.2
        });
        const belly = new THREE.Mesh(bellyGeo, bellyMat);
        belly.position.set(0, 0.22, 0.08);
        group.add(belly);

        // Elegant head
        const headGeo = new THREE.SphereGeometry(0.15, 10, 10);
        headGeo.scale(1.25, 1.05, 1.35);
        const head = new THREE.Mesh(headGeo, bodyMat);
        head.position.set(0, 0.38, 0.24);
        group.add(head);

        // Cheek fluff
        for (let side = -1; side <= 1; side += 2) {
          const cheekGeo = new THREE.SphereGeometry(0.06, 6, 6);
          cheekGeo.scale(1, 0.7, 0.8);
          const cheek = new THREE.Mesh(cheekGeo, bellyMat);
          cheek.position.set(side * 0.1, 0.34, 0.3);
          group.add(cheek);
        }

        // Pointed snout
        const snoutGeo = new THREE.ConeGeometry(0.065, 0.18, 8);
        const snoutMat = new THREE.MeshPhongMaterial({
          color: 0xd8f0ff,
          shininess: 100,
          emissive: 0x77aacc,
          emissiveIntensity: 0.2
        });
        const snout = new THREE.Mesh(snoutGeo, snoutMat);
        snout.position.set(0, 0.34, 0.42);
        snout.rotation.x = -Math.PI / 2;
        group.add(snout);

        // Nose
        const noseGeo = new THREE.SphereGeometry(0.025, 6, 6);
        const noseMat = new THREE.MeshPhongMaterial({
          color: 0x224466,
          shininess: 120
        });
        const nose = new THREE.Mesh(noseGeo, noseMat);
        nose.position.set(0, 0.34, 0.5);
        group.add(nose);

        // Large pointed ears
        for (let side = -1; side <= 1; side += 2) {
          const earGeo = new THREE.ConeGeometry(0.06, 0.16, 6);
          const earMat = new THREE.MeshPhongMaterial({
            color: 0xa0d4ff,
            shininess: 80,
            emissive: 0x6699bb,
            emissiveIntensity: 0.25
          });
          const ear = new THREE.Mesh(earGeo, earMat);
          ear.position.set(side * 0.1, 0.52, 0.18);
          ear.rotation.z = side * 0.15;
          ear.rotation.x = 0.1;
          group.add(ear);

          // Inner ear
          const innerEarGeo = new THREE.ConeGeometry(0.03, 0.08, 4);
          const innerEarMat = new THREE.MeshPhongMaterial({
            color: 0xffd0e0,
            shininess: 40
          });
          const innerEar = new THREE.Mesh(innerEarGeo, innerEarMat);
          innerEar.position.set(side * 0.1, 0.5, 0.2);
          innerEar.rotation.z = side * 0.15;
          innerEar.rotation.x = 0.1;
          group.add(innerEar);
        }

        // Beautiful glowing eyes
        for (let side = -1; side <= 1; side += 2) {
          // Eye glow
          const glowGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const glowMat = new THREE.MeshBasicMaterial({
            color: 0x00ffff,
            transparent: true,
            opacity: 0.35
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.set(side * 0.06, 0.4, 0.34);
          group.add(glow);

          const eyeGeo = new THREE.SphereGeometry(0.03, 8, 8);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0x00eeff });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.06, 0.4, 0.35);
          group.add(eye);

          const pupilGeo = new THREE.SphereGeometry(0.012, 6, 6);
          const pupilMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const pupil = new THREE.Mesh(pupilGeo, pupilMat);
          pupil.position.set(side * 0.06, 0.4, 0.375);
          group.add(pupil);
        }

        // Magnificent fluffy tail with ice crystals
        const tailBaseGeo = new THREE.SphereGeometry(0.08, 8, 8);
        tailBaseGeo.scale(0.8, 0.7, 1.2);
        const tail1 = new THREE.Mesh(tailBaseGeo, bodyMat);
        tail1.position.set(0, 0.28, -0.22);
        tail1.rotation.x = 0.4;
        group.add(tail1);

        const tailMidGeo = new THREE.SphereGeometry(0.12, 10, 10);
        tailMidGeo.scale(0.7, 0.7, 1.4);
        const tailMat = new THREE.MeshPhongMaterial({
          color: 0xd8f4ff,
          shininess: 70,
          emissive: 0x88ccee,
          emissiveIntensity: 0.25
        });
        const tail2 = new THREE.Mesh(tailMidGeo, tailMat);
        tail2.position.set(0, 0.32, -0.35);
        tail2.rotation.x = 0.6;
        group.add(tail2);

        const tailTipGeo = new THREE.SphereGeometry(0.1, 8, 8);
        tailTipGeo.scale(0.6, 0.6, 1.3);
        const tailTipMat = new THREE.MeshPhongMaterial({
          color: 0xeeffff,
          shininess: 100,
          emissive: 0xaaddff,
          emissiveIntensity: 0.35
        });
        const tail3 = new THREE.Mesh(tailTipGeo, tailTipMat);
        tail3.position.set(0, 0.4, -0.48);
        tail3.rotation.x = 0.9;
        group.add(tail3);

        // Ice crystal on tail tip
        const tailCrystalGeo = new THREE.OctahedronGeometry(0.035, 0);
        const tailCrystalMat = new THREE.MeshPhongMaterial({
          color: 0xccffff,
          shininess: 200,
          emissive: 0x88eeff,
          emissiveIntensity: 0.6,
          transparent: true,
          opacity: 0.8
        });
        const tailCrystal = new THREE.Mesh(tailCrystalGeo, tailCrystalMat);
        tailCrystal.position.set(0, 0.48, -0.55);
        group.add(tailCrystal);

        // Slender legs with ice paws
        for (let i = 0; i < 4; i++) {
          const legGeo = new THREE.CylinderGeometry(0.03, 0.025, 0.15, 8);
          const leg = new THREE.Mesh(legGeo, bodyMat);
          leg.position.set(
            (i % 2 === 0 ? -0.1 : 0.1),
            0.1,
            (i < 2 ? 0.1 : -0.08)
          );
          group.add(leg);

          // Ice paws
          const pawGeo = new THREE.SphereGeometry(0.035, 6, 6);
          pawGeo.scale(1, 0.5, 1.2);
          const pawMat = new THREE.MeshPhongMaterial({
            color: 0xccffff,
            shininess: 100,
            emissive: 0x88ddff,
            emissiveIntensity: 0.3
          });
          const paw = new THREE.Mesh(pawGeo, pawMat);
          paw.position.set(
            (i % 2 === 0 ? -0.1 : 0.1),
            0.02,
            (i < 2 ? 0.12 : -0.06)
          );
          group.add(paw);
        }

        // Enhanced icy particles - snowflakes
        for (let i = 0; i < 8; i++) {
          const particleGeo = new THREE.OctahedronGeometry(0.018, 0);
          const particleMat = new THREE.MeshBasicMaterial({
            color: 0xccffff,
            transparent: true,
            opacity: 0.75
          });
          const particle = new THREE.Mesh(particleGeo, particleMat);
          const angle = (i / 8) * Math.PI * 2;
          particle.position.set(
            Math.cos(angle) * 0.3,
            0.35 + Math.sin(i * 1.5) * 0.12,
            Math.sin(angle) * 0.3
          );
          particle.userData.isSnowflake = true;
          particle.userData.snowflakeIndex = i;
          group.add(particle);
        }

        // Subtle frost aura
        const auraGeo = new THREE.SphereGeometry(0.4, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xaaeeff,
          transparent: true,
          opacity: 0.12
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.3;
        group.add(aura);

        break;
      }

      case 'zombie-raccoon': {
        // ========================================
        // ZOMBIE RACCOON - CURSED UNDEAD BEAST!
        // 10 HP, 90 damage, FAST attacker!
        // Risen from death by necromantic banana magic!
        // ========================================

        // === DECAYED BODY WITH GLOWING CRACKS ===
        const bodyGeo = new THREE.SphereGeometry(0.28, 14, 14);
        bodyGeo.scale(1.15, 0.9, 1.25);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0x3a4a3a,
          shininess: 40,
          emissive: 0x1a3a1a,
          emissiveIntensity: 0.5
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.32;
        group.add(body);

        // Glowing green cracks on body
        for (let i = 0; i < 5; i++) {
          const crackGeo = new THREE.BoxGeometry(0.02, 0.15, 0.01);
          const crackMat = new THREE.MeshBasicMaterial({
            color: 0x00ff44,
            transparent: true,
            opacity: 0.9
          });
          const crack = new THREE.Mesh(crackGeo, crackMat);
          const angle = (i / 5) * Math.PI - 0.5;
          crack.position.set(Math.cos(angle) * 0.2, 0.3, Math.sin(angle) * 0.2);
          crack.rotation.z = Math.random() * 0.5;
          group.add(crack);
        }

        // === ZOMBIE HEAD WITH SKULL FEATURES ===
        const headGeo = new THREE.SphereGeometry(0.2, 14, 14);
        const head = new THREE.Mesh(headGeo, bodyMat);
        head.position.set(0, 0.5, 0.22);
        group.add(head);

        // Exposed skull patch
        const skullPatchGeo = new THREE.SphereGeometry(0.1, 8, 8);
        const skullMat = new THREE.MeshPhongMaterial({
          color: 0xccccaa,
          shininess: 80,
          emissive: 0x222211,
          emissiveIntensity: 0.3
        });
        const skullPatch = new THREE.Mesh(skullPatchGeo, skullMat);
        skullPatch.position.set(0.05, 0.58, 0.2);
        skullPatch.scale.set(0.8, 0.6, 0.5);
        group.add(skullPatch);

        // Dark mask pattern
        const maskGeo = new THREE.SphereGeometry(0.14, 10, 10);
        maskGeo.scale(1.4, 0.5, 0.5);
        const maskMat = new THREE.MeshPhongMaterial({
          color: 0x0a0a0a,
          shininess: 100
        });
        const mask = new THREE.Mesh(maskGeo, maskMat);
        mask.position.set(0, 0.52, 0.32);
        group.add(mask);

        // BURNING GREEN SOUL EYES
        for (let side = -1; side <= 1; side += 2) {
          // Dark socket
          const socketGeo = new THREE.SphereGeometry(0.04, 8, 8);
          const socketMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const socket = new THREE.Mesh(socketGeo, socketMat);
          socket.position.set(side * 0.08, 0.52, 0.36);
          group.add(socket);

          // Burning soul fire
          const eyeGeo = new THREE.SphereGeometry(0.05, 8, 8);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0x00ff44 });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.08, 0.52, 0.38);
          group.add(eye);

          // Eye glow
          const glowGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const glowMat = new THREE.MeshBasicMaterial({
            color: 0x00ff00,
            transparent: true,
            opacity: 0.4
          });
          const glow = new THREE.Mesh(glowGeo, glowMat);
          glow.position.set(side * 0.08, 0.52, 0.38);
          group.add(glow);
        }

        // === EXPOSED RIBS WITH GLOW ===
        for (let i = 0; i < 4; i++) {
          const boneGeo = new THREE.CylinderGeometry(0.025, 0.02, 0.18, 6);
          const boneMat = new THREE.MeshPhongMaterial({
            color: 0xddddbb,
            shininess: 100
          });
          const bone = new THREE.Mesh(boneGeo, boneMat);
          bone.position.set(-0.12 + i * 0.08, 0.28, 0.18);
          bone.rotation.x = 0.4;
          group.add(bone);
        }

        // Green glow between ribs
        const ribGlowGeo = new THREE.BoxGeometry(0.3, 0.08, 0.05);
        const ribGlowMat = new THREE.MeshBasicMaterial({
          color: 0x00ff44,
          transparent: true,
          opacity: 0.5
        });
        const ribGlow = new THREE.Mesh(ribGlowGeo, ribGlowMat);
        ribGlow.position.set(0, 0.28, 0.15);
        group.add(ribGlow);

        // === ZOMBIE CLAWS ===
        for (let side = -1; side <= 1; side += 2) {
          // Leg
          const legGeo = new THREE.CylinderGeometry(0.05, 0.06, 0.2, 6);
          const leg = new THREE.Mesh(legGeo, bodyMat);
          leg.position.set(side * 0.15, 0.1, 0.1);
          group.add(leg);

          // Sharp claws
          for (let c = 0; c < 3; c++) {
            const clawGeo = new THREE.ConeGeometry(0.015, 0.08, 4);
            const clawMat = new THREE.MeshPhongMaterial({
              color: 0x111111,
              shininess: 100
            });
            const claw = new THREE.Mesh(clawGeo, clawMat);
            claw.position.set(side * 0.15 + (c - 1) * 0.03, 0.02, 0.15);
            claw.rotation.x = -0.3;
            group.add(claw);
          }
        }

        // === TATTERED ZOMBIE TAIL ===
        const tailGeo = new THREE.CylinderGeometry(0.045, 0.015, 0.4, 6);
        const tail = new THREE.Mesh(tailGeo, bodyMat);
        tail.position.set(0, 0.28, -0.28);
        tail.rotation.x = -0.6;
        group.add(tail);

        // Tail bone exposed
        const tailBoneGeo = new THREE.CylinderGeometry(0.02, 0.01, 0.15, 4);
        const tailBone = new THREE.Mesh(tailBoneGeo, skullMat);
        tailBone.position.set(0, 0.2, -0.4);
        tailBone.rotation.x = -0.6;
        group.add(tailBone);

        // === SOUL ENERGY AURA ===
        const innerAuraGeo = new THREE.SphereGeometry(0.35, 14, 14);
        const innerAuraMat = new THREE.MeshBasicMaterial({
          color: 0x00ff44,
          transparent: true,
          opacity: 0.15
        });
        const innerAura = new THREE.Mesh(innerAuraGeo, innerAuraMat);
        innerAura.position.y = 0.35;
        group.add(innerAura);

        // Outer dark aura
        const outerAuraGeo = new THREE.SphereGeometry(0.45, 14, 14);
        const outerAuraMat = new THREE.MeshBasicMaterial({
          color: 0x220044,
          transparent: true,
          opacity: 0.12
        });
        const outerAura = new THREE.Mesh(outerAuraGeo, outerAuraMat);
        outerAura.position.y = 0.35;
        group.add(outerAura);

        // === FLOATING SOUL WISPS ===
        for (let i = 0; i < 4; i++) {
          const wispGeo = new THREE.SphereGeometry(0.025, 6, 6);
          const wispMat = new THREE.MeshBasicMaterial({
            color: i % 2 === 0 ? 0x00ff44 : 0x9900ff,
            transparent: true,
            opacity: 0.7
          });
          const wisp = new THREE.Mesh(wispGeo, wispMat);
          const angle = (i / 4) * Math.PI * 2;
          wisp.position.set(Math.cos(angle) * 0.3, 0.4 + i * 0.05, Math.sin(angle) * 0.3);
          group.add(wisp);
        }

        break;
      }

      case 'zombie-gorilla': {
        // ========================================
        // ZOMBIE GORILLA - MASSIVE UNDEAD TITAN!
        // 100 HP, 200 damage - DEVASTATING POWER!
        // A monstrous beast risen by dark banana magic!
        // ========================================
        const scale = 1.4;

        // === MASSIVE DECAYED BODY WITH ARMOR PLATES ===
        const torsoGeo = new THREE.SphereGeometry(0.5 * scale, 16, 16);
        torsoGeo.scale(1.15, 1.05, 1.35);
        const torsoMat = new THREE.MeshPhongMaterial({
          color: 0x2a3a2a,
          shininess: 35,
          emissive: 0x1a3a1a,
          emissiveIntensity: 0.5
        });
        const torso = new THREE.Mesh(torsoGeo, torsoMat);
        torso.position.y = 0.6 * scale;
        group.add(torso);

        // Bone armor plates on back
        for (let i = 0; i < 5; i++) {
          const plateGeo = new THREE.BoxGeometry(0.15 * scale, 0.08 * scale, 0.05 * scale);
          const plateMat = new THREE.MeshPhongMaterial({
            color: 0xccccaa,
            shininess: 100
          });
          const plate = new THREE.Mesh(plateGeo, plateMat);
          plate.position.set(0, (0.4 + i * 0.12) * scale, -0.35 * scale);
          plate.rotation.x = 0.3;
          group.add(plate);
        }

        // Glowing green veins on torso
        for (let i = 0; i < 8; i++) {
          const veinGeo = new THREE.CylinderGeometry(0.015 * scale, 0.01 * scale, 0.3 * scale, 4);
          const veinMat = new THREE.MeshBasicMaterial({
            color: 0x00ff44,
            transparent: true,
            opacity: 0.8
          });
          const vein = new THREE.Mesh(veinGeo, veinMat);
          const angle = (i / 8) * Math.PI * 2;
          vein.position.set(
            Math.cos(angle) * 0.4 * scale,
            0.6 * scale,
            Math.sin(angle) * 0.45 * scale
          );
          vein.rotation.z = Math.random() * 0.5;
          group.add(vein);
        }

        // === TERRIFYING ZOMBIE HEAD ===
        const headGeo = new THREE.SphereGeometry(0.32 * scale, 14, 14);
        const head = new THREE.Mesh(headGeo, torsoMat);
        head.position.set(0, 1.0 * scale, 0.28 * scale);
        group.add(head);

        // HALF-EXPOSED SKULL
        const skullGeo = new THREE.SphereGeometry(0.22 * scale, 12, 12);
        const skullMat = new THREE.MeshPhongMaterial({
          color: 0xddddbb,
          shininess: 100,
          emissive: 0x222211,
          emissiveIntensity: 0.3
        });
        const skull = new THREE.Mesh(skullGeo, skullMat);
        skull.position.set(0.08 * scale, 1.1 * scale, 0.35 * scale);
        skull.scale.set(0.8, 0.9, 0.7);
        group.add(skull);

        // BLAZING GREEN SOUL EYES
        for (let side = -1; side <= 1; side += 2) {
          // Deep socket
          const socketGeo = new THREE.SphereGeometry(0.07 * scale, 8, 8);
          const socketMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const socket = new THREE.Mesh(socketGeo, socketMat);
          socket.position.set(side * 0.12 * scale, 1.02 * scale, 0.48 * scale);
          group.add(socket);

          // Blazing green fire
          const eyeGeo = new THREE.SphereGeometry(0.08 * scale, 10, 10);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0x00ff44 });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.12 * scale, 1.02 * scale, 0.5 * scale);
          group.add(eye);

          // Massive eye glow
          const eyeGlowGeo = new THREE.SphereGeometry(0.15 * scale, 10, 10);
          const eyeGlowMat = new THREE.MeshBasicMaterial({
            color: 0x00ff00,
            transparent: true,
            opacity: 0.35
          });
          const eyeGlow = new THREE.Mesh(eyeGlowGeo, eyeGlowMat);
          eyeGlow.position.set(side * 0.12 * scale, 1.02 * scale, 0.5 * scale);
          group.add(eyeGlow);
        }

        // Gorilla brow ridge
        const browGeo = new THREE.BoxGeometry(0.35 * scale, 0.08 * scale, 0.1 * scale);
        const brow = new THREE.Mesh(browGeo, torsoMat);
        brow.position.set(0, 1.12 * scale, 0.4 * scale);
        group.add(brow);

        // Open jaw with fangs
        const jawGeo = new THREE.SphereGeometry(0.15 * scale, 10, 10);
        const jaw = new THREE.Mesh(jawGeo, torsoMat);
        jaw.position.set(0, 0.85 * scale, 0.4 * scale);
        jaw.scale.set(1.2, 0.6, 1);
        group.add(jaw);

        // Massive fangs
        for (let side = -1; side <= 1; side += 2) {
          const fangGeo = new THREE.ConeGeometry(0.03 * scale, 0.12 * scale, 4);
          const fangMat = new THREE.MeshPhongMaterial({
            color: 0xffffee,
            shininess: 100
          });
          const fang = new THREE.Mesh(fangGeo, fangMat);
          fang.position.set(side * 0.08 * scale, 0.82 * scale, 0.48 * scale);
          fang.rotation.x = 0.2;
          group.add(fang);
        }

        // === DEVASTATING ARMS ===
        for (let side = -1; side <= 1; side += 2) {
          // Shoulder
          const shoulderGeo = new THREE.SphereGeometry(0.15 * scale, 10, 10);
          const shoulder = new THREE.Mesh(shoulderGeo, torsoMat);
          shoulder.position.set(side * 0.5 * scale, 0.8 * scale, 0.1 * scale);
          group.add(shoulder);

          // Upper arm
          const upperArmGeo = new THREE.CylinderGeometry(0.14 * scale, 0.16 * scale, 0.5 * scale, 10);
          const upperArm = new THREE.Mesh(upperArmGeo, torsoMat);
          upperArm.position.set(side * 0.55 * scale, 0.55 * scale, 0.12 * scale);
          upperArm.rotation.z = side * 0.5;
          group.add(upperArm);

          // Exposed arm bone
          const armBoneGeo = new THREE.CylinderGeometry(0.03 * scale, 0.025 * scale, 0.2 * scale, 6);
          const armBone = new THREE.Mesh(armBoneGeo, skullMat);
          armBone.position.set(side * 0.52 * scale, 0.5 * scale, 0.2 * scale);
          armBone.rotation.z = side * 0.5;
          group.add(armBone);

          // MASSIVE FIST
          const fistGeo = new THREE.SphereGeometry(0.22 * scale, 12, 12);
          const fist = new THREE.Mesh(fistGeo, torsoMat);
          fist.position.set(side * 0.75 * scale, 0.22 * scale, 0.18 * scale);
          group.add(fist);

          // Fist bone knuckles
          for (let k = 0; k < 4; k++) {
            const knuckleGeo = new THREE.SphereGeometry(0.035 * scale, 6, 6);
            const knuckle = new THREE.Mesh(knuckleGeo, skullMat);
            knuckle.position.set(
              side * 0.75 * scale + (k - 1.5) * 0.04 * scale,
              0.32 * scale,
              0.32 * scale
            );
            group.add(knuckle);
          }

          // Green energy around fist
          const fistGlowGeo = new THREE.SphereGeometry(0.28 * scale, 10, 10);
          const fistGlowMat = new THREE.MeshBasicMaterial({
            color: 0x00ff44,
            transparent: true,
            opacity: 0.2
          });
          const fistGlow = new THREE.Mesh(fistGlowGeo, fistGlowMat);
          fistGlow.position.set(side * 0.75 * scale, 0.22 * scale, 0.18 * scale);
          group.add(fistGlow);
        }

        // === POWERFUL LEGS ===
        for (let side = -1; side <= 1; side += 2) {
          const legGeo = new THREE.CylinderGeometry(0.12 * scale, 0.14 * scale, 0.4 * scale, 10);
          const leg = new THREE.Mesh(legGeo, torsoMat);
          leg.position.set(side * 0.22 * scale, 0.2 * scale, 0);
          group.add(leg);

          // Foot
          const footGeo = new THREE.SphereGeometry(0.1 * scale, 8, 8);
          footGeo.scale(1.3, 0.6, 1.5);
          const foot = new THREE.Mesh(footGeo, torsoMat);
          foot.position.set(side * 0.22 * scale, 0.05 * scale, 0.08 * scale);
          group.add(foot);
        }

        // === NECROMANTIC RUNES ON BODY ===
        for (let i = 0; i < 6; i++) {
          const runeGeo = new THREE.RingGeometry(0.04 * scale, 0.06 * scale, 6);
          const runeMat = new THREE.MeshBasicMaterial({
            color: 0x9900ff,
            transparent: true,
            opacity: 0.8,
            side: THREE.DoubleSide
          });
          const rune = new THREE.Mesh(runeGeo, runeMat);
          const angle = (i / 6) * Math.PI * 2;
          rune.position.set(
            Math.cos(angle) * 0.45 * scale,
            (0.5 + (i % 3) * 0.15) * scale,
            Math.sin(angle) * 0.5 * scale
          );
          rune.rotation.y = angle + Math.PI / 2;
          group.add(rune);
        }

        // === MASSIVE TOXIC AURA ===
        const innerAuraGeo = new THREE.SphereGeometry(0.9 * scale, 18, 18);
        const innerAuraMat = new THREE.MeshBasicMaterial({
          color: 0x00ff44,
          transparent: true,
          opacity: 0.15
        });
        const innerAura = new THREE.Mesh(innerAuraGeo, innerAuraMat);
        innerAura.position.y = 0.55 * scale;
        group.add(innerAura);

        // Dark outer aura
        const outerAuraGeo = new THREE.SphereGeometry(1.1 * scale, 18, 18);
        const outerAuraMat = new THREE.MeshBasicMaterial({
          color: 0x220044,
          transparent: true,
          opacity: 0.12
        });
        const outerAura = new THREE.Mesh(outerAuraGeo, outerAuraMat);
        outerAura.position.y = 0.55 * scale;
        group.add(outerAura);

        // === FLOATING SOUL PARTICLES ===
        for (let i = 0; i < 8; i++) {
          const soulGeo = new THREE.SphereGeometry(0.04 * scale, 6, 6);
          const soulMat = new THREE.MeshBasicMaterial({
            color: i % 2 === 0 ? 0x00ff44 : 0xaa00ff,
            transparent: true,
            opacity: 0.7
          });
          const soul = new THREE.Mesh(soulGeo, soulMat);
          const angle = (i / 8) * Math.PI * 2;
          soul.position.set(
            Math.cos(angle) * 0.7 * scale,
            (0.4 + (i % 3) * 0.25) * scale,
            Math.sin(angle) * 0.7 * scale
          );
          group.add(soul);
        }

        // === GROUND CRACK EFFECT ===
        for (let i = 0; i < 6; i++) {
          const crackGeo = new THREE.BoxGeometry(0.4 * scale, 0.02, 0.05);
          const crackMat = new THREE.MeshBasicMaterial({
            color: 0x00ff44,
            transparent: true,
            opacity: 0.6
          });
          const crack = new THREE.Mesh(crackGeo, crackMat);
          const angle = (i / 6) * Math.PI * 2;
          crack.position.set(Math.cos(angle) * 0.5 * scale, 0.01, Math.sin(angle) * 0.5 * scale);
          crack.rotation.y = angle;
          group.add(crack);
        }

        break;
      }

      case 'sun-fish': {
        // SUN FISH - Glowing golden fish ally summoned by Lily Peel
        // 250 HP, 10 damage every 0.3 seconds, 2 tile range

        // Fish body - golden and glowing
        const bodyGeo = new THREE.SphereGeometry(0.35, 16, 16);
        bodyGeo.scale(1.5, 0.8, 1);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0xffdd00,
          shininess: 100,
          emissive: 0xff8800,
          emissiveIntensity: 0.6
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.4;
        group.add(body);

        // Fish tail
        const tailGeo = new THREE.ConeGeometry(0.2, 0.4, 8);
        const tailMat = new THREE.MeshPhongMaterial({
          color: 0xffaa00,
          shininess: 80,
          emissive: 0xff6600,
          emissiveIntensity: 0.4
        });
        const tail = new THREE.Mesh(tailGeo, tailMat);
        tail.position.set(-0.5, 0.4, 0);
        tail.rotation.z = Math.PI / 2;
        group.add(tail);

        // Dorsal fin
        const dorsalGeo = new THREE.ConeGeometry(0.15, 0.25, 6);
        const dorsal = new THREE.Mesh(dorsalGeo, tailMat);
        dorsal.position.set(0, 0.7, 0);
        group.add(dorsal);

        // Side fins
        for (let side = -1; side <= 1; side += 2) {
          const finGeo = new THREE.ConeGeometry(0.1, 0.2, 6);
          const fin = new THREE.Mesh(finGeo, tailMat);
          fin.position.set(0.1, 0.35, side * 0.3);
          fin.rotation.x = side * Math.PI / 3;
          group.add(fin);
        }

        // Eyes
        for (let side = -1; side <= 1; side += 2) {
          const eyeGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0xffffff });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(0.35, 0.45, side * 0.15);
          group.add(eye);

          const pupilGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const pupilMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const pupil = new THREE.Mesh(pupilGeo, pupilMat);
          pupil.position.set(0.4, 0.45, side * 0.15);
          group.add(pupil);
        }

        // Sun glow aura
        const glowGeo = new THREE.SphereGeometry(0.5, 16, 16);
        const glowMat = new THREE.MeshBasicMaterial({
          color: 0xffff00,
          transparent: true,
          opacity: 0.25
        });
        const glow = new THREE.Mesh(glowGeo, glowMat);
        glow.position.y = 0.4;
        glow.scale.set(1.3, 1, 1.1);
        group.add(glow);

        // Sun ray particles
        for (let i = 0; i < 8; i++) {
          const rayGeo = new THREE.SphereGeometry(0.05, 6, 6);
          const rayMat = new THREE.MeshBasicMaterial({
            color: 0xffee44,
            transparent: true,
            opacity: 0.8
          });
          const ray = new THREE.Mesh(rayGeo, rayMat);
          const angle = (i / 8) * Math.PI * 2;
          ray.position.set(
            Math.cos(angle) * 0.6,
            0.4 + Math.sin(angle) * 0.2,
            Math.sin(angle) * 0.4
          );
          group.add(ray);
        }

        break;
      }

      case 'squirrel': {
        // SQUIRREL ALLY - Cute acorn-loving squirrel (Acorn Nest summon)
        // Body - fluffy brown
        const bodyGeo = new THREE.SphereGeometry(0.2, 12, 12);
        bodyGeo.scale(1, 1.2, 1.3);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0xb5651d,
          shininess: 40,
          emissive: 0x442200,
          emissiveIntensity: 0.1
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.25;
        group.add(body);

        // Head
        const headGeo = new THREE.SphereGeometry(0.15, 10, 10);
        const head = new THREE.Mesh(headGeo, bodyMat);
        head.position.set(0, 0.42, 0.15);
        group.add(head);

        // Cheeks (for acorn storage!)
        for (let side = -1; side <= 1; side += 2) {
          const cheekGeo = new THREE.SphereGeometry(0.06, 6, 6);
          const cheekMat = new THREE.MeshPhongMaterial({ color: 0xdaa520 });
          const cheek = new THREE.Mesh(cheekGeo, cheekMat);
          cheek.position.set(side * 0.1, 0.38, 0.22);
          group.add(cheek);
        }

        // Big bushy tail - signature squirrel feature
        const tailGeo = new THREE.SphereGeometry(0.18, 10, 10);
        tailGeo.scale(0.6, 1.8, 1);
        const tail = new THREE.Mesh(tailGeo, bodyMat);
        tail.position.set(0, 0.45, -0.25);
        tail.rotation.x = 0.5;
        group.add(tail);

        // Ears - pointed
        for (let side = -1; side <= 1; side += 2) {
          const earGeo = new THREE.ConeGeometry(0.04, 0.1, 6);
          const ear = new THREE.Mesh(earGeo, bodyMat);
          ear.position.set(side * 0.1, 0.55, 0.1);
          group.add(ear);
        }

        // Eyes
        for (let side = -1; side <= 1; side += 2) {
          const eyeGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.06, 0.45, 0.26);
          group.add(eye);
        }

        // Nose
        const noseGeo = new THREE.SphereGeometry(0.025, 6, 6);
        const noseMat = new THREE.MeshPhongMaterial({ color: 0x222222 });
        const nose = new THREE.Mesh(noseGeo, noseMat);
        nose.position.set(0, 0.4, 0.29);
        group.add(nose);

        // Little paws
        for (let i = 0; i < 4; i++) {
          const pawGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const paw = new THREE.Mesh(pawGeo, bodyMat);
          paw.position.set(
            (i % 2 === 0 ? -0.1 : 0.1),
            0.05,
            (i < 2 ? 0.1 : -0.08)
          );
          group.add(paw);
        }

        group.scale.set(0.9, 0.9, 0.9);
        break;
      }

      case 'buff-squirrel': {
        // BUFF SQUIRREL - Muscular golden squirrel (rare Acorn Nest summon)
        // Body - golden and muscular
        const bodyGeo = new THREE.SphereGeometry(0.28, 12, 12);
        bodyGeo.scale(1.2, 1.3, 1.4);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0xffd700,
          shininess: 80,
          emissive: 0xaa8800,
          emissiveIntensity: 0.3
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.35;
        group.add(body);

        // Muscular head
        const headGeo = new THREE.SphereGeometry(0.2, 10, 10);
        const head = new THREE.Mesh(headGeo, bodyMat);
        head.position.set(0, 0.58, 0.18);
        group.add(head);

        // HUGE bushy tail - glowing
        const tailGeo = new THREE.SphereGeometry(0.25, 10, 10);
        tailGeo.scale(0.7, 2.2, 1.2);
        const tailMat = new THREE.MeshPhongMaterial({
          color: 0xffaa00,
          shininess: 100,
          emissive: 0xff6600,
          emissiveIntensity: 0.4
        });
        const tail = new THREE.Mesh(tailGeo, tailMat);
        tail.position.set(0, 0.6, -0.3);
        tail.rotation.x = 0.6;
        group.add(tail);

        // Angry eyes
        for (let side = -1; side <= 1; side += 2) {
          const eyeGeo = new THREE.SphereGeometry(0.05, 6, 6);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0xff0000 });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.08, 0.62, 0.32);
          group.add(eye);
        }

        // Golden aura
        const auraGeo = new THREE.SphereGeometry(0.5, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0xffdd00,
          transparent: true,
          opacity: 0.2
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.4;
        group.add(aura);

        break;
      }

      case 'cursed-zombie': {
        // CURSED ZOMBIE ALLY - Undead minion (Banana Leach summon)
        // Rotting greenish body
        const bodyGeo = new THREE.CylinderGeometry(0.15, 0.12, 0.5, 8);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0x4a5a3a,
          shininess: 20,
          emissive: 0x112211,
          emissiveIntensity: 0.2
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.35;
        group.add(body);

        // Zombie head - rotting
        const headGeo = new THREE.SphereGeometry(0.12, 10, 10);
        const headMat = new THREE.MeshPhongMaterial({
          color: 0x5a6a4a,
          shininess: 15
        });
        const head = new THREE.Mesh(headGeo, headMat);
        head.position.set(0, 0.68, 0);
        group.add(head);

        // Glowing green eyes
        for (let side = -1; side <= 1; side += 2) {
          const eyeGeo = new THREE.SphereGeometry(0.025, 6, 6);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0x00ff44 });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.05, 0.7, 0.1);
          group.add(eye);
        }

        // Zombie arms reaching forward
        for (let side = -1; side <= 1; side += 2) {
          const armGeo = new THREE.CylinderGeometry(0.04, 0.03, 0.3, 6);
          const arm = new THREE.Mesh(armGeo, bodyMat);
          arm.position.set(side * 0.18, 0.45, 0.1);
          arm.rotation.x = -1.2;
          arm.rotation.z = side * 0.3;
          group.add(arm);
        }

        // Tattered legs
        for (let side = -1; side <= 1; side += 2) {
          const legGeo = new THREE.CylinderGeometry(0.05, 0.04, 0.25, 6);
          const leg = new THREE.Mesh(legGeo, bodyMat);
          leg.position.set(side * 0.08, 0.08, 0);
          group.add(leg);
        }

        // Necromantic aura
        const auraGeo = new THREE.SphereGeometry(0.3, 10, 10);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x22ff44,
          transparent: true,
          opacity: 0.15
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.4;
        group.add(aura);

        group.scale.set(0.85, 0.85, 0.85);
        break;
      }

      case 'cursed-brute': {
        // CURSED BRUTE - Large undead monster (rare Banana Leach summon)
        // Massive rotting body
        const bodyGeo = new THREE.CylinderGeometry(0.25, 0.2, 0.7, 10);
        const bodyMat = new THREE.MeshPhongMaterial({
          color: 0x3a4a2a,
          shininess: 15,
          emissive: 0x112200,
          emissiveIntensity: 0.3
        });
        const body = new THREE.Mesh(bodyGeo, bodyMat);
        body.position.y = 0.45;
        group.add(body);

        // Large deformed head
        const headGeo = new THREE.SphereGeometry(0.18, 10, 10);
        headGeo.scale(1.2, 1, 1);
        const headMat = new THREE.MeshPhongMaterial({
          color: 0x4a5a3a,
          shininess: 10
        });
        const head = new THREE.Mesh(headGeo, headMat);
        head.position.set(0, 0.88, 0.05);
        group.add(head);

        // Glowing red eyes (angry!)
        for (let side = -1; side <= 1; side += 2) {
          const eyeGeo = new THREE.SphereGeometry(0.04, 6, 6);
          const eyeMat = new THREE.MeshBasicMaterial({ color: 0xff2200 });
          const eye = new THREE.Mesh(eyeGeo, eyeMat);
          eye.position.set(side * 0.08, 0.9, 0.15);
          group.add(eye);
        }

        // Huge muscular arms
        for (let side = -1; side <= 1; side += 2) {
          const armGeo = new THREE.CylinderGeometry(0.08, 0.06, 0.45, 8);
          const arm = new THREE.Mesh(armGeo, bodyMat);
          arm.position.set(side * 0.3, 0.55, 0.15);
          arm.rotation.x = -1.0;
          arm.rotation.z = side * 0.4;
          group.add(arm);

          // Big fists
          const fistGeo = new THREE.SphereGeometry(0.08, 8, 8);
          const fist = new THREE.Mesh(fistGeo, headMat);
          fist.position.set(side * 0.35, 0.35, 0.35);
          group.add(fist);
        }

        // Thick legs
        for (let side = -1; side <= 1; side += 2) {
          const legGeo = new THREE.CylinderGeometry(0.08, 0.06, 0.35, 8);
          const leg = new THREE.Mesh(legGeo, bodyMat);
          leg.position.set(side * 0.12, 0.1, 0);
          group.add(leg);
        }

        // Dark necromantic aura
        const auraGeo = new THREE.SphereGeometry(0.5, 12, 12);
        const auraMat = new THREE.MeshBasicMaterial({
          color: 0x44ff22,
          transparent: true,
          opacity: 0.2
        });
        const aura = new THREE.Mesh(auraGeo, auraMat);
        aura.position.y = 0.5;
        group.add(aura);

        break;
      }

      case 'great-gorilla': {
        // Massive silverback gorilla - bigger than normal gorilla, golden accents
        const ggBodyGeo = new THREE.SphereGeometry(0.6, 16, 16);
        ggBodyGeo.scale(1.2, 1.1, 1.4);
        const ggBodyMat = new THREE.MeshPhongMaterial({
          color: 0x1a1a1a, shininess: 40, emissive: 0x111111, emissiveIntensity: 0.15
        });
        const ggBody = new THREE.Mesh(ggBodyGeo, ggBodyMat);
        ggBody.position.y = 0.5;
        group.add(ggBody);

        // Silver back stripe
        const ggBackGeo = new THREE.SphereGeometry(0.55, 12, 12);
        ggBackGeo.scale(1.0, 0.8, 0.6);
        const ggBackMat = new THREE.MeshPhongMaterial({
          color: 0x888888, shininess: 60, specular: 0xcccccc
        });
        const ggBack = new THREE.Mesh(ggBackGeo, ggBackMat);
        ggBack.position.set(0, 0.6, -0.15);
        group.add(ggBack);

        // Head
        const ggHeadGeo = new THREE.SphereGeometry(0.35, 16, 16);
        ggHeadGeo.scale(1.0, 0.95, 0.9);
        const ggHead = new THREE.Mesh(ggHeadGeo, ggBodyMat);
        ggHead.position.set(0, 1.0, 0.15);
        group.add(ggHead);

        // Eyes - fierce red
        for (let side = -1; side <= 1; side += 2) {
          const ggEyeGeo = new THREE.SphereGeometry(0.06, 8, 8);
          const ggEyeMat = new THREE.MeshBasicMaterial({ color: 0xff2200 });
          const ggEye = new THREE.Mesh(ggEyeGeo, ggEyeMat);
          ggEye.position.set(side * 0.12, 1.05, 0.35);
          group.add(ggEye);
        }

        // Massive arms
        for (let side = -1; side <= 1; side += 2) {
          const ggArmGeo = new THREE.CylinderGeometry(0.15, 0.18, 0.8, 8);
          const ggArm = new THREE.Mesh(ggArmGeo, ggBodyMat);
          ggArm.position.set(side * 0.55, 0.3, 0.1);
          ggArm.rotation.z = side * 0.3;
          group.add(ggArm);

          // Fists
          const ggFistGeo = new THREE.SphereGeometry(0.18, 10, 10);
          const ggFist = new THREE.Mesh(ggFistGeo, ggBodyMat);
          ggFist.position.set(side * 0.65, 0.05, 0.1);
          group.add(ggFist);
        }

        // Golden crown/marking
        const ggCrownGeo = new THREE.TorusGeometry(0.2, 0.04, 8, 12);
        const ggCrownMat = new THREE.MeshPhongMaterial({
          color: 0xffd700, shininess: 150, specular: 0xffff88, emissive: 0x664400, emissiveIntensity: 0.3
        });
        const ggCrown = new THREE.Mesh(ggCrownGeo, ggCrownMat);
        ggCrown.position.set(0, 1.2, 0.15);
        ggCrown.rotation.x = Math.PI / 2;
        group.add(ggCrown);

        // Power aura
        const ggAuraGeo = new THREE.SphereGeometry(0.8, 16, 16);
        const ggAuraMat = new THREE.MeshBasicMaterial({
          color: 0xff4400, transparent: true, opacity: 0.1
        });
        const ggAura = new THREE.Mesh(ggAuraGeo, ggAuraMat);
        ggAura.position.y = 0.5;
        group.add(ggAura);

        break;
      }

      case 'baby-yeti': {
        // Baby yeti - white/blue fur, small but tanky
        const byBodyGeo = new THREE.SphereGeometry(0.45, 16, 16);
        byBodyGeo.scale(1.0, 1.2, 1.0);
        const byBodyMat = new THREE.MeshPhongMaterial({
          color: 0xddeeff, shininess: 40, emissive: 0x445566, emissiveIntensity: 0.15
        });
        const byBody = new THREE.Mesh(byBodyGeo, byBodyMat);
        byBody.position.y = 0.5;
        group.add(byBody);

        // Fluffy belly
        const byBellyGeo = new THREE.SphereGeometry(0.35, 12, 12);
        const byBellyMat = new THREE.MeshPhongMaterial({
          color: 0xffffff, shininess: 30, emissive: 0x88aacc, emissiveIntensity: 0.1
        });
        const byBelly = new THREE.Mesh(byBellyGeo, byBellyMat);
        byBelly.position.set(0, 0.45, 0.15);
        group.add(byBelly);

        // Head
        const byHeadGeo = new THREE.SphereGeometry(0.3, 16, 16);
        const byHead = new THREE.Mesh(byHeadGeo, byBodyMat);
        byHead.position.set(0, 0.95, 0.05);
        group.add(byHead);

        // Cute eyes
        for (let side = -1; side <= 1; side += 2) {
          const byEyeGeo = new THREE.SphereGeometry(0.06, 8, 8);
          const byEyeMat = new THREE.MeshBasicMaterial({ color: 0x2244aa });
          const byEye = new THREE.Mesh(byEyeGeo, byEyeMat);
          byEye.position.set(side * 0.1, 1.0, 0.25);
          group.add(byEye);
          // Eye pupil
          const byPupilGeo = new THREE.SphereGeometry(0.03, 6, 6);
          const byPupilMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
          const byPupil = new THREE.Mesh(byPupilGeo, byPupilMat);
          byPupil.position.set(side * 0.1, 1.0, 0.28);
          group.add(byPupil);
        }

        // Small horns
        for (let side = -1; side <= 1; side += 2) {
          const byHornGeo = new THREE.ConeGeometry(0.06, 0.2, 6);
          const byHornMat = new THREE.MeshPhongMaterial({
            color: 0x99bbdd, shininess: 80
          });
          const byHorn = new THREE.Mesh(byHornGeo, byHornMat);
          byHorn.position.set(side * 0.15, 1.15, 0);
          byHorn.rotation.z = side * 0.3;
          group.add(byHorn);
        }

        // Arms
        for (let side = -1; side <= 1; side += 2) {
          const byArmGeo = new THREE.CylinderGeometry(0.1, 0.12, 0.4, 8);
          const byArm = new THREE.Mesh(byArmGeo, byBodyMat);
          byArm.position.set(side * 0.4, 0.35, 0);
          byArm.rotation.z = side * 0.4;
          group.add(byArm);
        }

        // Ice crystal aura
        const byAuraGeo = new THREE.SphereGeometry(0.6, 16, 16);
        const byAuraMat = new THREE.MeshBasicMaterial({
          color: 0x88ccff, transparent: true, opacity: 0.12
        });
        const byAura = new THREE.Mesh(byAuraGeo, byAuraMat);
        byAura.position.y = 0.5;
        group.add(byAura);

        // Small ice crystals floating around
        for (let i = 0; i < 4; i++) {
          const byCrystalGeo = new THREE.OctahedronGeometry(0.06, 0);
          const byCrystalMat = new THREE.MeshPhongMaterial({
            color: 0xccffff, shininess: 150, transparent: true, opacity: 0.7
          });
          const byCrystal = new THREE.Mesh(byCrystalGeo, byCrystalMat);
          const angle = (i / 4) * Math.PI * 2;
          byCrystal.position.set(Math.cos(angle) * 0.5, 0.8, Math.sin(angle) * 0.5);
          group.add(byCrystal);
        }

        break;
      }
    }

    return group;
  }

  private updatePlantSlots(): void {
    document.querySelectorAll('.plant-slot').forEach(slot => {
      const plantType = slot.getAttribute('data-plant') as PlantType;
      const info = PLANT_INFO[plantType];

      if (this.sun < info.cost) {
        slot.classList.add('disabled');
      } else {
        slot.classList.remove('disabled');
      }
    });
  }

  private updatePlantSlotCooldowns(): void {
    const instantPlants: PlantType[] = ['frost-berri', 'elder-frost-berri', 'tomato-spike', 'elder-tomato-spike', 'seed-batch'];

    document.querySelectorAll('.plant-slot').forEach(slot => {
      const plantType = slot.getAttribute('data-plant') as PlantType;

      if (instantPlants.includes(plantType)) {
        const cooldown = this.instantPlantCooldowns.get(plantType) || 0;
        let cooldownOverlay = slot.querySelector('.cooldown-overlay') as HTMLElement;

        if (cooldown > 0) {
          // Show cooldown overlay
          if (!cooldownOverlay) {
            cooldownOverlay = document.createElement('div');
            cooldownOverlay.className = 'cooldown-overlay';
            (slot as HTMLElement).style.position = 'relative';
            slot.appendChild(cooldownOverlay);
          }
          cooldownOverlay.textContent = cooldown.toFixed(1) + 's';
          cooldownOverlay.style.display = 'flex';
          slot.classList.add('on-cooldown');
        } else {
          // Hide cooldown overlay
          if (cooldownOverlay) {
            cooldownOverlay.style.display = 'none';
          }
          slot.classList.remove('on-cooldown');
        }
      }
    });
  }

  private updateCoinDisplay(): void {
    const coinAmount = document.getElementById('coin-amount');
    if (coinAmount) {
      coinAmount.textContent = this.coins.toString();
    }
    // Save coins to localStorage for the Plant Shop
    localStorage.setItem('fusionTdCoins', this.coins.toString());
  }

  private updateMasteryDisplay(): void {
    const masteryDisplay = document.getElementById('mastery-display');
    if (masteryDisplay) {
      const frostProgress = Math.min(this.frostBerriMasteryPoints, 300);
      const frostPercentage = (frostProgress / 300) * 100;
      const tomatoProgress = Math.min(this.tomatoSpikeMasteryPoints, 300);
      const tomatoPercentage = (tomatoProgress / 300) * 100;
      const frostMastered = this.frostBerriMasteryPoints >= 300;
      const tomatoMastered = this.tomatoSpikeMasteryPoints >= 300;
      masteryDisplay.innerHTML = `
        <div style="display: flex; gap: 0.5rem; flex-wrap: wrap;">
          <div style="min-width: 120px; background: linear-gradient(135deg, rgba(0, 200, 255, 0.15), rgba(0, 100, 200, 0.1)); padding: 0.3rem 0.5rem; border-radius: 8px; border: 1px solid ${frostMastered ? '#00ffff' : 'rgba(0, 255, 255, 0.4)'}; box-shadow: 0 0 ${frostMastered ? '15px' : '8px'} rgba(0, 255, 255, ${frostMastered ? '0.5' : '0.2'});">
            <div style="font-weight: bold; font-size: 0.6rem; color: #00ffff; text-shadow: 0 0 10px rgba(0, 255, 255, 0.8);">❄️ Frost ${frostMastered ? '👑' : ''}</div>
            <div style="background: rgba(0, 0, 0, 0.6); border-radius: 4px; padding: 2px; box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);">
              <div style="background: linear-gradient(90deg, #00ffff, #00aaff, #00ffff); height: 8px; border-radius: 3px; width: ${frostPercentage}%; box-shadow: 0 0 10px rgba(0, 255, 255, 0.8); ${frostMastered ? 'animation: masteryGlow 1s ease-in-out infinite;' : ''}"></div>
            </div>
            <div style="font-size: 0.5rem; margin-top: 0.15rem; font-weight: 600; color: ${frostMastered ? '#00ffff' : '#88ddff'}; text-shadow: 0 0 5px rgba(0, 255, 255, 0.5);">${frostProgress}/300</div>
          </div>
          <div style="min-width: 120px; background: linear-gradient(135deg, rgba(255, 50, 50, 0.15), rgba(200, 0, 0, 0.1)); padding: 0.3rem 0.5rem; border-radius: 8px; border: 1px solid ${tomatoMastered ? '#ff0066' : 'rgba(255, 0, 100, 0.4)'}; box-shadow: 0 0 ${tomatoMastered ? '15px' : '8px'} rgba(255, 0, 100, ${tomatoMastered ? '0.5' : '0.2'});">
            <div style="font-weight: bold; font-size: 0.6rem; color: #ff4466; text-shadow: 0 0 10px rgba(255, 50, 100, 0.8);">🍅 Tomato ${tomatoMastered ? '👑' : ''}</div>
            <div style="background: rgba(0, 0, 0, 0.6); border-radius: 4px; padding: 2px; box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);">
              <div style="background: linear-gradient(90deg, #ff0066, #ff4400, #ff0066); height: 8px; border-radius: 3px; width: ${tomatoPercentage}%; box-shadow: 0 0 10px rgba(255, 0, 100, 0.8); ${tomatoMastered ? 'animation: masteryGlow 1s ease-in-out infinite;' : ''}"></div>
            </div>
            <div style="font-size: 0.5rem; margin-top: 0.15rem; font-weight: 600; color: ${tomatoMastered ? '#ff4466' : '#ffaa88'}; text-shadow: 0 0 5px rgba(255, 100, 100, 0.5);">${tomatoProgress}/300</div>
          </div>
        </div>
        <style>
          @keyframes masteryGlow {
            0%, 100% { filter: brightness(1); }
            50% { filter: brightness(1.3); }
          }
        </style>
      `;
    }
  }

  private createLawn(): void {
    // Create endless grass plane (large enough to fill view)
    const grassSize = 200;
    const grassGeometry = new THREE.PlaneGeometry(grassSize, grassSize);
    const grassMaterial = new THREE.MeshPhongMaterial({
      color: 0x3d7a3d,
      side: THREE.DoubleSide
    });
    const grassPlane = new THREE.Mesh(grassGeometry, grassMaterial);
    grassPlane.rotation.x = -Math.PI / 2;
    grassPlane.position.y = -0.1;
    this.scene.add(grassPlane);

    // Create main lawn (planting area) - slightly lighter grass
    // Planting grid: X from -8 to 8, Z from -8 to 0
    const plantAreaWidth = 20; // -10 to 10 with padding
    const plantAreaDepth = 12; // -9 to 1 with padding
    const plantAreaZ = -4; // Center of the planting area
    const pathGeometry = new THREE.PlaneGeometry(plantAreaWidth, plantAreaDepth);
    const pathMaterial = new THREE.MeshPhongMaterial({
      color: 0x4a8f4a,
      side: THREE.DoubleSide
    });
    this.lawnPlane = new THREE.Mesh(pathGeometry, pathMaterial);
    this.lawnPlane.rotation.x = -Math.PI / 2;
    this.lawnPlane.position.set(0, 0, plantAreaZ);
    this.scene.add(this.lawnPlane);

    // Add grass blades for realistic look
    this.createGrassBlades(plantAreaWidth, plantAreaDepth, plantAreaZ);

    // Create fence around the planting area only
    this.createFence(plantAreaWidth, plantAreaDepth, plantAreaZ);

    // Create zombie spawn base on the right side
    this.createZombieSpawnBase();
  }

  private createGrassBlades(areaWidth: number, areaDepth: number, centerZ: number): void {
    // Create clusters of grass blades for realistic lawn look - richer colors
    const grassColors = [
      0x228b22,  // Forest green
      0x32cd32,  // Lime green
      0x3cb371,  // Medium sea green
      0x2e8b57,  // Sea green
      0x4a9f4a,  // Bright grass
      0x556b2f,  // Dark olive green
      0x6b8e23,  // Olive drab
      0x7cfc00   // Lawn green
    ];

    // Grass blade geometry - thin triangular shape
    const bladeGeometry = new THREE.ConeGeometry(0.03, 0.25, 4);

    // Create grass tufts across the planting area
    const spacing = 0.4;
    const halfWidth = areaWidth / 2 - 0.5;
    const halfDepth = areaDepth / 2 - 0.5;

    for (let x = -halfWidth; x <= halfWidth; x += spacing) {
      for (let z = -halfDepth; z <= halfDepth; z += spacing) {
        // Random chance to place grass tuft
        if (Math.random() > 0.3) {
          // Create a small cluster of 2-4 grass blades
          const numBlades = 2 + Math.floor(Math.random() * 3);

          for (let i = 0; i < numBlades; i++) {
            const colorIndex = Math.floor(Math.random() * grassColors.length);
            const grassMat = new THREE.MeshPhongMaterial({
              color: grassColors[colorIndex],
              side: THREE.DoubleSide
            });

            const blade = new THREE.Mesh(bladeGeometry, grassMat);

            // Slight random offset within the tuft
            const offsetX = (Math.random() - 0.5) * 0.15;
            const offsetZ = (Math.random() - 0.5) * 0.15;

            // Random height variation
            const heightScale = 0.6 + Math.random() * 0.8;
            blade.scale.y = heightScale;

            // Position the blade
            blade.position.set(
              x + offsetX,
              0.1 * heightScale,
              centerZ + z + offsetZ
            );

            // Slight random tilt for natural look
            blade.rotation.x = (Math.random() - 0.5) * 0.3;
            blade.rotation.z = (Math.random() - 0.5) * 0.3;

            this.scene.add(blade);
          }
        }
      }
    }

    // Add some scattered grass outside the play area too
    for (let i = 0; i < 500; i++) {
      const x = (Math.random() - 0.5) * 60;
      const z = (Math.random() - 0.5) * 40;

      // Skip if inside play area (already covered)
      if (Math.abs(x) < halfWidth + 1 && Math.abs(z - centerZ) < halfDepth + 1) continue;

      const colorIndex = Math.floor(Math.random() * grassColors.length);
      const grassMat = new THREE.MeshPhongMaterial({
        color: grassColors[colorIndex],
        side: THREE.DoubleSide
      });

      const blade = new THREE.Mesh(bladeGeometry, grassMat);
      const heightScale = 0.5 + Math.random() * 0.7;
      blade.scale.y = heightScale;
      blade.position.set(x, 0.1 * heightScale, z);
      blade.rotation.x = (Math.random() - 0.5) * 0.4;
      blade.rotation.z = (Math.random() - 0.5) * 0.4;

      this.scene.add(blade);
    }

    // Add small decorative flowers scattered around
    const flowerColors = [
      0xff6b6b,  // Red
      0xffd93d,  // Yellow
      0xff9ff3,  // Pink
      0x6bcb77,  // Green
      0x4d96ff,  // Blue
      0xffffff,  // White
      0xffb347   // Orange
    ];

    for (let i = 0; i < 150; i++) {
      const x = (Math.random() - 0.5) * (areaWidth - 2);
      const z = centerZ + (Math.random() - 0.5) * (areaDepth - 2);

      // Random flower type
      const flowerType = Math.floor(Math.random() * 3);
      const flowerColor = flowerColors[Math.floor(Math.random() * flowerColors.length)];

      if (flowerType === 0) {
        // Small daisy-like flower
        const petalGeo = new THREE.CircleGeometry(0.05, 6);
        const petalMat = new THREE.MeshPhongMaterial({
          color: flowerColor,
          side: THREE.DoubleSide,
          emissive: flowerColor,
          emissiveIntensity: 0.2
        });
        const flower = new THREE.Mesh(petalGeo, petalMat);
        flower.position.set(x, 0.15, z);
        flower.rotation.x = -Math.PI / 2 + (Math.random() - 0.5) * 0.3;
        this.scene.add(flower);

        // Yellow center
        const centerGeo = new THREE.CircleGeometry(0.02, 8);
        const centerMat = new THREE.MeshPhongMaterial({
          color: 0xffff00,
          side: THREE.DoubleSide,
          emissive: 0xffff00,
          emissiveIntensity: 0.3
        });
        const center = new THREE.Mesh(centerGeo, centerMat);
        center.position.set(x, 0.16, z);
        center.rotation.x = -Math.PI / 2;
        this.scene.add(center);
      } else if (flowerType === 1) {
        // Tiny tulip-like flower
        const tulipGeo = new THREE.ConeGeometry(0.03, 0.08, 5);
        const tulipMat = new THREE.MeshPhongMaterial({
          color: flowerColor,
          emissive: flowerColor,
          emissiveIntensity: 0.15
        });
        const tulip = new THREE.Mesh(tulipGeo, tulipMat);
        tulip.position.set(x, 0.2, z);
        tulip.rotation.x = Math.PI;
        this.scene.add(tulip);

        // Stem
        const stemGeo = new THREE.CylinderGeometry(0.008, 0.008, 0.15, 4);
        const stemMat = new THREE.MeshPhongMaterial({ color: 0x228b22 });
        const stem = new THREE.Mesh(stemGeo, stemMat);
        stem.position.set(x, 0.08, z);
        this.scene.add(stem);
      } else {
        // Tiny clover-like cluster
        for (let c = 0; c < 3; c++) {
          const cloverGeo = new THREE.SphereGeometry(0.025, 6, 6);
          const cloverMat = new THREE.MeshPhongMaterial({
            color: flowerColor,
            emissive: flowerColor,
            emissiveIntensity: 0.1
          });
          const clover = new THREE.Mesh(cloverGeo, cloverMat);
          const angle = (c / 3) * Math.PI * 2;
          clover.position.set(
            x + Math.cos(angle) * 0.03,
            0.12,
            z + Math.sin(angle) * 0.03
          );
          clover.scale.y = 0.5;
          this.scene.add(clover);
        }
      }
    }
  }

  private createZombieSpawnBase(): void {
    // HIGH-TECH ZOMBIE PORTAL FACILITY
    const baseX = 14;
    const baseZ = -4;
    const baseWidth = 6;
    const baseHeight = 5;
    const baseDepth = 14;

    // Dark metallic material
    const darkMetalMat = new THREE.MeshPhongMaterial({
      color: 0x1a1a2e,
      shininess: 60,
      specular: 0x333355
    });

    // Glowing green material
    const glowGreenMat = new THREE.MeshPhongMaterial({
      color: 0x00ff44,
      emissive: 0x00ff44,
      emissiveIntensity: 0.8,
      shininess: 100
    });

    // Purple accent material
    const purpleMat = new THREE.MeshPhongMaterial({
      color: 0x8833ff,
      emissive: 0x6622cc,
      emissiveIntensity: 0.5,
      shininess: 80
    });

    // Main building - sleek angular design
    const mainGeo = new THREE.BoxGeometry(baseWidth, baseHeight, baseDepth);
    const main = new THREE.Mesh(mainGeo, darkMetalMat);
    main.position.set(baseX, baseHeight / 2, baseZ);
    this.scene.add(main);

    // Angled top section
    const topGeo = new THREE.BoxGeometry(baseWidth + 1, 1.5, baseDepth + 1);
    const top = new THREE.Mesh(topGeo, darkMetalMat);
    top.position.set(baseX, baseHeight + 0.5, baseZ);
    this.scene.add(top);

    // Glowing antenna towers
    for (let i = 0; i < 3; i++) {
      const towerGeo = new THREE.CylinderGeometry(0.15, 0.2, 3, 8);
      const tower = new THREE.Mesh(towerGeo, darkMetalMat);
      tower.position.set(baseX + 2, baseHeight + 2.5, baseZ - 5 + i * 5);
      this.scene.add(tower);

      // Glowing top
      const topGlowGeo = new THREE.SphereGeometry(0.3, 12, 12);
      const topGlow = new THREE.Mesh(topGlowGeo, glowGreenMat);
      topGlow.position.set(baseX + 2, baseHeight + 4.2, baseZ - 5 + i * 5);
      this.scene.add(topGlow);
    }

    // Giant portal door frame
    const portalWidth = 4;
    const portalHeight = 4;
    const frameMat = new THREE.MeshPhongMaterial({
      color: 0x2a2a4a,
      shininess: 80,
      specular: 0x4444aa
    });

    // Portal frame - top
    const frameTopGeo = new THREE.BoxGeometry(0.4, 0.6, portalWidth + 1);
    const frameTop = new THREE.Mesh(frameTopGeo, frameMat);
    frameTop.position.set(baseX - baseWidth / 2 - 0.2, portalHeight + 0.3, baseZ);
    this.scene.add(frameTop);

    // Portal frame - sides
    const frameSideGeo = new THREE.BoxGeometry(0.4, portalHeight, 0.5);
    const frameLeft = new THREE.Mesh(frameSideGeo, frameMat);
    frameLeft.position.set(baseX - baseWidth / 2 - 0.2, portalHeight / 2, baseZ - portalWidth / 2 - 0.25);
    this.scene.add(frameLeft);
    const frameRight = new THREE.Mesh(frameSideGeo, frameMat);
    frameRight.position.set(baseX - baseWidth / 2 - 0.2, portalHeight / 2, baseZ + portalWidth / 2 + 0.25);
    this.scene.add(frameRight);

    // Glowing portal surface
    const portalGeo = new THREE.PlaneGeometry(portalWidth, portalHeight);
    const portalMat = new THREE.MeshBasicMaterial({
      color: 0x22ff66,
      transparent: true,
      opacity: 0.6,
      side: THREE.DoubleSide
    });
    const portal = new THREE.Mesh(portalGeo, portalMat);
    portal.position.set(baseX - baseWidth / 2 - 0.1, portalHeight / 2 + 0.2, baseZ);
    portal.rotation.y = Math.PI / 2;
    this.scene.add(portal);

    // Portal inner glow
    const innerGlowGeo = new THREE.PlaneGeometry(portalWidth - 0.5, portalHeight - 0.5);
    const innerGlowMat = new THREE.MeshBasicMaterial({
      color: 0xaaffaa,
      transparent: true,
      opacity: 0.4,
      side: THREE.DoubleSide
    });
    const innerGlow = new THREE.Mesh(innerGlowGeo, innerGlowMat);
    innerGlow.position.set(baseX - baseWidth / 2 - 0.15, portalHeight / 2 + 0.2, baseZ);
    innerGlow.rotation.y = Math.PI / 2;
    this.scene.add(innerGlow);

    // Glowing tech strips on building
    for (let i = 0; i < 5; i++) {
      const stripGeo = new THREE.BoxGeometry(0.1, 0.15, baseDepth - 2);
      const strip = new THREE.Mesh(stripGeo, glowGreenMat);
      strip.position.set(baseX - baseWidth / 2 + 0.1, 1 + i * 0.9, baseZ);
      this.scene.add(strip);
    }

    // Purple accent lights on sides
    for (let i = 0; i < 4; i++) {
      const accentGeo = new THREE.BoxGeometry(baseWidth + 0.2, 0.1, 0.3);
      const accent = new THREE.Mesh(accentGeo, purpleMat);
      accent.position.set(baseX, 0.8 + i * 1.2, baseZ - baseDepth / 2);
      this.scene.add(accent);
      const accent2 = new THREE.Mesh(accentGeo.clone(), purpleMat);
      accent2.position.set(baseX, 0.8 + i * 1.2, baseZ + baseDepth / 2);
      this.scene.add(accent2);
    }

    // Warning signs / tech panels
    for (let i = 0; i < 3; i++) {
      const panelGeo = new THREE.BoxGeometry(0.05, 0.8, 1.2);
      const panelMat = new THREE.MeshPhongMaterial({
        color: 0xff4444,
        emissive: 0xff2222,
        emissiveIntensity: 0.3
      });
      const panel = new THREE.Mesh(panelGeo, panelMat);
      panel.position.set(baseX - baseWidth / 2 - 0.05, 3.5, baseZ - 4 + i * 4);
      this.scene.add(panel);
    }

    // Ground platform
    const platformGeo = new THREE.BoxGeometry(baseWidth + 3, 0.3, baseDepth + 2);
    const platformMat = new THREE.MeshPhongMaterial({
      color: 0x222233,
      shininess: 40
    });
    const platform = new THREE.Mesh(platformGeo, platformMat);
    platform.position.set(baseX - 0.5, 0.15, baseZ);
    this.scene.add(platform);

    // Glowing floor strips
    for (let i = 0; i < 3; i++) {
      const floorStripGeo = new THREE.BoxGeometry(baseWidth + 2, 0.05, 0.3);
      const floorStrip = new THREE.Mesh(floorStripGeo, glowGreenMat);
      floorStrip.position.set(baseX - 0.5, 0.32, baseZ - 4 + i * 4);
      this.scene.add(floorStrip);
    }
  }

  private createFence(areaWidth: number, areaDepth: number, centerZ: number = 0): void {
    const fenceOffset = 0.5; // Distance from play area edge
    const postSpacing = 2; // Space between fence posts
    const postHeight = 1.2;
    const postRadius = 0.08;
    const railHeight = 0.06;
    const railDepth = 0.04;

    const woodMaterial = new THREE.MeshPhongMaterial({
      color: 0x8B4513,
      shininess: 10
    });
    const darkWoodMaterial = new THREE.MeshPhongMaterial({
      color: 0x654321,
      shininess: 10
    });

    // Create fence posts and rails for each side
    const halfWidth = areaWidth / 2 + fenceOffset;
    const halfDepth = areaDepth / 2 + fenceOffset;

    // Front fence (positive Z side)
    this.createFenceSide(-halfWidth, centerZ + halfDepth, halfWidth, centerZ + halfDepth, postSpacing, postHeight, postRadius, railHeight, railDepth, woodMaterial, darkWoodMaterial, true);

    // Back fence (negative Z side)
    this.createFenceSide(-halfWidth, centerZ - halfDepth, halfWidth, centerZ - halfDepth, postSpacing, postHeight, postRadius, railHeight, railDepth, woodMaterial, darkWoodMaterial, true);

    // Left fence (negative X)
    this.createFenceSide(-halfWidth, centerZ - halfDepth, -halfWidth, centerZ + halfDepth, postSpacing, postHeight, postRadius, railHeight, railDepth, woodMaterial, darkWoodMaterial, false);

    // Right fence (positive X)
    this.createFenceSide(halfWidth, centerZ - halfDepth, halfWidth, centerZ + halfDepth, postSpacing, postHeight, postRadius, railHeight, railDepth, woodMaterial, darkWoodMaterial, false);
  }

  private createFenceSide(
    x1: number, z1: number, x2: number, z2: number,
    postSpacing: number, postHeight: number, postRadius: number,
    railHeight: number, railDepth: number,
    woodMaterial: THREE.MeshPhongMaterial, darkWoodMaterial: THREE.MeshPhongMaterial,
    isHorizontal: boolean
  ): void {
    const length = isHorizontal ? Math.abs(x2 - x1) : Math.abs(z2 - z1);
    const numPosts = Math.floor(length / postSpacing) + 1;

    // Create fence posts
    const postGeometry = new THREE.CylinderGeometry(postRadius, postRadius * 1.1, postHeight, 8);
    const postTopGeometry = new THREE.ConeGeometry(postRadius * 1.3, 0.15, 8);

    for (let i = 0; i < numPosts; i++) {
      const t = numPosts > 1 ? i / (numPosts - 1) : 0.5;
      const x = isHorizontal ? x1 + (x2 - x1) * t : x1;
      const z = isHorizontal ? z1 : z1 + (z2 - z1) * t;

      // Main post
      const post = new THREE.Mesh(postGeometry, woodMaterial);
      post.position.set(x, postHeight / 2, z);
      this.scene.add(post);

      // Pointed top
      const postTop = new THREE.Mesh(postTopGeometry, darkWoodMaterial);
      postTop.position.set(x, postHeight + 0.075, z);
      this.scene.add(postTop);
    }

    // Create horizontal rails
    const railLength = length;
    const railGeometry = new THREE.BoxGeometry(
      isHorizontal ? railLength : railDepth,
      railHeight,
      isHorizontal ? railDepth : railLength
    );

    const midX = (x1 + x2) / 2;
    const midZ = (z1 + z2) / 2;

    // Top rail
    const topRail = new THREE.Mesh(railGeometry, darkWoodMaterial);
    topRail.position.set(midX, postHeight * 0.75, midZ);
    this.scene.add(topRail);

    // Bottom rail
    const bottomRail = new THREE.Mesh(railGeometry, darkWoodMaterial);
    bottomRail.position.set(midX, postHeight * 0.35, midZ);
    this.scene.add(bottomRail);
  }

  private onWindowResize(): void {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  }

  private showPurchaseSuccess(plantType: PlantType): void {
    const message = document.createElement('div');
    message.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
      color: white;
      padding: 2rem 3rem;
      border-radius: 15px;
      font-size: 1.5rem;
      font-weight: bold;
      z-index: 10001;
      box-shadow: 0 10px 40px rgba(16, 185, 129, 0.6);
      animation: popIn 0.3s ease-out;
    `;

    const info = PLANT_INFO[plantType];
    message.innerHTML = `
      <div style="text-align: center;">
        <div style="font-size: 3rem; margin-bottom: 0.5rem;">${info.emoji}</div>
        <div>✨ Purchased ${info.name}! ✨</div>
      </div>
    `;

    document.body.appendChild(message);

    setTimeout(() => {
      message.style.animation = 'fadeOut 0.3s ease-in';
      setTimeout(() => message.remove(), 300);
    }, 2000);
  }

  private showInsufficientSun(needed: number): void {
    const message = document.createElement('div');
    message.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
      color: white;
      padding: 2rem 3rem;
      border-radius: 15px;
      font-size: 1.5rem;
      font-weight: bold;
      z-index: 10001;
      box-shadow: 0 10px 40px rgba(239, 68, 68, 0.6);
      animation: shake 0.5s ease-in-out;
    `;

    message.innerHTML = `
      <div style="text-align: center;">
        <div style="font-size: 3rem; margin-bottom: 0.5rem;">❌</div>
        <div>Not Enough Sun!</div>
        <div style="font-size: 1.2rem; margin-top: 0.5rem; opacity: 0.9;">Need ${needed} sun</div>
      </div>
    `;

    document.body.appendChild(message);

    // Add shake animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes shake {
        0%, 100% { transform: translate(-50%, -50%) translateX(0); }
        25% { transform: translate(-50%, -50%) translateX(-10px); }
        75% { transform: translate(-50%, -50%) translateX(10px); }
      }
      @keyframes popIn {
        from { transform: translate(-50%, -50%) scale(0); }
        to { transform: translate(-50%, -50%) scale(1); }
      }
      @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
      }
    `;
    document.head.appendChild(style);

    setTimeout(() => {
      message.style.animation = 'fadeOut 0.3s ease-in';
      setTimeout(() => message.remove(), 300);
    }, 2000);
  }

  private showGameOver(): void {
    this.gameOver = true;

    // Delete saved game on game over
    deleteSavedGame();

    // Save endless highscore if in endless mode
    if (this.isEndlessMode) {
      const currentHighscore = parseInt(localStorage.getItem('endlessHighscore') || '0');
      if (this.currentWave > currentHighscore) {
        localStorage.setItem('endlessHighscore', this.currentWave.toString());
      }
    }

    // Create game over overlay
    const gameOverDiv = document.createElement('div');
    gameOverDiv.id = 'game-over';
    gameOverDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.9);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 10000;
      font-family: system-ui, -apple-system, sans-serif;
      color: white;
      animation: fadeIn 0.5s ease-in;
    `;

    const title = document.createElement('h1');
    title.textContent = this.isEndlessMode
      ? `Endless Run Over - Wave ${this.currentWave}!`
      : 'The zombies ate your brains!';
    title.style.cssText = `
      font-size: 3rem;
      margin-bottom: 2rem;
      color: ${this.isEndlessMode ? '#aa88ff' : '#ff4444'};
      text-shadow: 0 0 20px rgba(${this.isEndlessMode ? '170, 136, 255' : '255, 68, 68'}, 0.8);
      animation: pulse 1s infinite;
    `;

    const button = document.createElement('button');
    button.textContent = 'Return to Menu';
    button.style.cssText = `
      padding: 1rem 2rem;
      font-size: 1.5rem;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border: none;
      border-radius: 10px;
      cursor: pointer;
      transition: transform 0.2s, box-shadow 0.2s;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    `;

    button.addEventListener('mouseenter', () => {
      button.style.transform = 'scale(1.05)';
      button.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
    });

    button.addEventListener('mouseleave', () => {
      button.style.transform = 'scale(1)';
      button.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
    });

    button.addEventListener('click', () => {
      // Reload the page to go back to the menu
      window.location.reload();
    });

    gameOverDiv.appendChild(title);
    gameOverDiv.appendChild(button);
    document.body.appendChild(gameOverDiv);

    // Add CSS animations
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
      }
    `;
    document.head.appendChild(style);
  }

  private showVictory(): void {
    this.gameOver = true;

    // Create victory overlay
    const victoryDiv = document.createElement('div');
    victoryDiv.id = 'victory';
    victoryDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 50, 0, 0.95);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 10000;
      font-family: system-ui, -apple-system, sans-serif;
      color: white;
      animation: fadeIn 0.5s ease-in;
    `;

    const title = document.createElement('h1');
    title.textContent = 'YOU WON!';
    title.style.cssText = `
      font-size: 5rem;
      margin-bottom: 1rem;
      color: #44ff44;
      text-shadow: 0 0 40px rgba(68, 255, 68, 0.9), 0 0 80px rgba(68, 255, 68, 0.5);
      animation: pulse 1s infinite;
    `;

    const subtitle = document.createElement('p');
    subtitle.textContent = '🎉 You survived all 15 waves! 🎉';
    subtitle.style.cssText = `
      font-size: 1.5rem;
      margin-bottom: 2rem;
      color: #88ff88;
    `;

    const button = document.createElement('button');
    button.textContent = 'Return to Menu';
    button.style.cssText = `
      padding: 1rem 2rem;
      font-size: 1.5rem;
      background: linear-gradient(135deg, #44ff44 0%, #22aa22 100%);
      color: white;
      border: none;
      border-radius: 10px;
      cursor: pointer;
      transition: transform 0.2s, box-shadow 0.2s;
      box-shadow: 0 4px 15px rgba(68, 255, 68, 0.4);
    `;

    button.addEventListener('mouseenter', () => {
      button.style.transform = 'scale(1.05)';
      button.style.boxShadow = '0 6px 20px rgba(68, 255, 68, 0.6)';
    });

    button.addEventListener('mouseleave', () => {
      button.style.transform = 'scale(1)';
      button.style.boxShadow = '0 4px 15px rgba(68, 255, 68, 0.4)';
    });

    button.addEventListener('click', () => {
      // Reload the page to go back to the menu
      window.location.reload();
    });

    victoryDiv.appendChild(title);
    victoryDiv.appendChild(subtitle);
    victoryDiv.appendChild(button);
    document.body.appendChild(victoryDiv);

    console.log('🎉 VICTORY! You completed all 20 waves!');
  }

  private showIZombieVictory(): void {
    this.gameOver = true;

    // Create I Zombie victory overlay
    const victoryDiv = document.createElement('div');
    victoryDiv.id = 'izombie-victory';
    victoryDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(50, 0, 50, 0.95);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 10000;
      font-family: system-ui, -apple-system, sans-serif;
      color: white;
      animation: fadeIn 0.5s ease-in;
    `;

    const title = document.createElement('h1');
    title.textContent = '🧟 BRAINS! 🧟';
    title.style.cssText = `
      font-size: 4rem;
      margin-bottom: 1rem;
      color: #88ff88;
      text-shadow: 0 0 30px rgba(136, 255, 136, 0.8);
      animation: pulse 1s infinite;
    `;

    const subtitle = document.createElement('p');
    subtitle.textContent = 'Your zombies reached the house!';
    subtitle.style.cssText = `
      font-size: 1.5rem;
      margin-bottom: 2rem;
      color: #aaffaa;
    `;

    const button = document.createElement('button');
    button.textContent = 'Return to Menu';
    button.style.cssText = `
      padding: 1rem 2rem;
      font-size: 1.5rem;
      background: linear-gradient(135deg, #8844ff 0%, #6622aa 100%);
      color: white;
      border: none;
      border-radius: 10px;
      cursor: pointer;
      transition: transform 0.2s, box-shadow 0.2s;
      box-shadow: 0 4px 15px rgba(136, 68, 255, 0.4);
    `;

    button.addEventListener('mouseenter', () => {
      button.style.transform = 'scale(1.05)';
      button.style.boxShadow = '0 6px 20px rgba(136, 68, 255, 0.6)';
    });

    button.addEventListener('mouseleave', () => {
      button.style.transform = 'scale(1)';
      button.style.boxShadow = '0 4px 15px rgba(136, 68, 255, 0.4)';
    });

    button.addEventListener('click', () => {
      localStorage.removeItem('izombieMode');
      window.location.reload();
    });

    victoryDiv.appendChild(title);
    victoryDiv.appendChild(subtitle);
    victoryDiv.appendChild(button);
    document.body.appendChild(victoryDiv);

    console.log('🧟 I ZOMBIE VICTORY! Your zombies reached the house!');
  }

  private showIZombieLoss(): void {
    this.gameOver = true;

    // Create I Zombie loss overlay
    const lossDiv = document.createElement('div');
    lossDiv.id = 'izombie-loss';
    lossDiv.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(50, 20, 0, 0.95);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 10000;
      font-family: system-ui, -apple-system, sans-serif;
      color: white;
      animation: fadeIn 0.5s ease-in;
    `;

    const title = document.createElement('h1');
    title.textContent = '💀 DEFEAT! 💀';
    title.style.cssText = `
      font-size: 4rem;
      margin-bottom: 1rem;
      color: #ff4444;
      text-shadow: 0 0 30px rgba(255, 68, 68, 0.8);
      animation: pulse 1s infinite;
    `;

    const subtitle = document.createElement('p');
    subtitle.textContent = 'The plants defended their lawn!';
    subtitle.style.cssText = `
      font-size: 1.5rem;
      margin-bottom: 2rem;
      color: #ffaaaa;
    `;

    const button = document.createElement('button');
    button.textContent = 'Try Again';
    button.style.cssText = `
      padding: 1rem 2rem;
      font-size: 1.5rem;
      background: linear-gradient(135deg, #ff4444 0%, #aa2222 100%);
      color: white;
      border: none;
      border-radius: 10px;
      cursor: pointer;
      transition: transform 0.2s, box-shadow 0.2s;
      box-shadow: 0 4px 15px rgba(255, 68, 68, 0.4);
    `;

    button.addEventListener('mouseenter', () => {
      button.style.transform = 'scale(1.05)';
      button.style.boxShadow = '0 6px 20px rgba(255, 68, 68, 0.6)';
    });

    button.addEventListener('mouseleave', () => {
      button.style.transform = 'scale(1)';
      button.style.boxShadow = '0 4px 15px rgba(255, 68, 68, 0.4)';
    });

    button.addEventListener('click', () => {
      localStorage.removeItem('izombieMode');
      window.location.reload();
    });

    lossDiv.appendChild(title);
    lossDiv.appendChild(subtitle);
    lossDiv.appendChild(button);
    document.body.appendChild(lossDiv);

    console.log('🧟 I ZOMBIE DEFEAT! Plants defended their lawn!');
  }

  private animateFrameCount: number = 0;
  private animationFrameId: number = 0;
  private isDisposed: boolean = false;

  public dispose(): void {
    this.isDisposed = true;
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    // Remove power plant HUD
    const ppHud = document.getElementById('power-plant-hud');
    if (ppHud) ppHud.remove();
    // Remove renderer from DOM
    if (this.renderer && this.renderer.domElement && this.renderer.domElement.parentNode) {
      this.renderer.domElement.parentNode.removeChild(this.renderer.domElement);
    }
    // Dispose renderer
    if (this.renderer) {
      this.renderer.dispose();
    }
    // Clear arrays
    this.zombies = [];
    this.projectiles = [];
    this.placedPlants = [];
    this.allies = [];
    console.log('Game disposed');
  }

  private spawnPowerPlant(): void {
    if (!this.powerPlantType) return;
    const x = -8;
    const z = -4;
    const mesh = this.createPlantMesh(this.powerPlantType);
    mesh.position.set(x, 0.5, z);
    this.scene.add(mesh);
    const plant = new Plant(mesh, this.powerPlantType, new THREE.Vector3(x, 0.5, z));
    this.powerPlant = plant;
    this.plantSlots.set(`${x},${z}`, true);
    this.placedPlants.push(plant);
    this.createPowerPlantHUD();
  }

  private createPowerPlantHUD(): void {
    if (!this.powerPlantType) return;
    const existing = document.getElementById('power-plant-hud');
    if (existing) existing.remove();
    const config = POWER_PLANT_INFO[this.powerPlantType];
    const hud = document.createElement('div');
    hud.id = 'power-plant-hud';
    hud.style.cssText = `position:fixed;bottom:20px;left:20px;background:linear-gradient(180deg,rgba(30,40,30,0.92) 0%,rgba(15,25,15,0.96) 100%);border:2px solid #4caf50;border-radius:12px;padding:12px 16px;color:#f5deb3;font-family:'Cinzel',serif;font-size:0.85rem;z-index:100;min-width:210px;`;
    hud.innerHTML = `
      <div style="font-size:1.1rem;font-weight:bold;margin-bottom:8px;">${config.emoji} ${config.name}</div>
      <div style="margin-bottom:6px;">
        <div style="background:#333;border-radius:4px;height:8px;overflow:hidden;">
          <div id="pp-hp-fill" style="background:#4caf50;height:100%;width:100%;transition:width 0.3s;"></div>
        </div>
        <div id="pp-hp-text" style="font-size:0.7rem;color:#aaa;">${config.hp}/${config.hp}</div>
      </div>
      <div id="pp-move-cd" style="margin-bottom:4px;color:#aaa;"><span style="color:#fff;">[WASD]</span> Move: <span style="color:#4caf50;">Ready</span></div>
      <div id="pp-ability1-cd" style="margin-bottom:4px;color:#aaa;"><span style="color:#ffcc00;">[Q]</span> ${config.ability1.name}: <span style="color:#4caf50;">Ready</span></div>
      <div id="pp-ability2-cd" style="color:#aaa;"><span style="color:#ff6600;">[T]</span> ${config.ability2.name}: <span style="color:#4caf50;">Ready</span></div>
    `;
    document.body.appendChild(hud);
  }

  private updatePowerPlantHUD(): void {
    if (!this.powerPlant || !this.powerPlantType) return;
    const config = POWER_PLANT_INFO[this.powerPlantType];
    const hpFill = document.getElementById('pp-hp-fill');
    const hpText = document.getElementById('pp-hp-text');
    const moveCd = document.getElementById('pp-move-cd');
    const ab1Cd = document.getElementById('pp-ability1-cd');
    const ab2Cd = document.getElementById('pp-ability2-cd');
    if (hpFill) {
      const pct = Math.max(0, this.powerPlant.health / this.powerPlant.maxHealth * 100);
      hpFill.style.width = pct + '%';
      hpFill.style.background = pct > 50 ? '#4caf50' : pct > 25 ? '#ff9800' : '#f44336';
    }
    if (hpText) hpText.textContent = `${Math.max(0, Math.floor(this.powerPlant.health))}/${this.powerPlant.maxHealth}`;
    const readySpan = '<span style="color:#4caf50;">Ready</span>';
    const cdSpan = (t: number) => `<span style="color:#f44336;">${t.toFixed(1)}s</span>`;
    if (moveCd) moveCd.innerHTML = `<span style="color:#fff;">[WASD]</span> Move: ${this.powerPlantMoveCooldown > 0 ? cdSpan(this.powerPlantMoveCooldown) : readySpan}`;
    if (ab1Cd) ab1Cd.innerHTML = `<span style="color:#ffcc00;">[Q]</span> ${config.ability1.name}: ${this.powerPlantAbility1Cooldown > 0 ? cdSpan(this.powerPlantAbility1Cooldown) : readySpan}`;
    if (ab2Cd) ab2Cd.innerHTML = `<span style="color:#ff6600;">[T]</span> ${config.ability2.name}: ${this.powerPlantAbility2Cooldown > 0 ? cdSpan(this.powerPlantAbility2Cooldown) : readySpan}`;
    if (this.powerPlant.health <= 0) {
      const hud = document.getElementById('power-plant-hud');
      if (hud) { hud.style.opacity = '0.4'; hud.style.borderColor = '#666'; }
    }
  }

  private updatePowerPlant(deltaTime: number): void {
    if (!this.powerPlant || !this.powerPlantType || this.powerPlant.health <= 0) return;
    this.powerPlantMoveCooldown = Math.max(0, this.powerPlantMoveCooldown - deltaTime);
    this.powerPlantAbility1Cooldown = Math.max(0, this.powerPlantAbility1Cooldown - deltaTime);
    this.powerPlantAbility2Cooldown = Math.max(0, this.powerPlantAbility2Cooldown - deltaTime);

    // WASD tile-by-tile movement with 5s cooldown
    if (this.powerPlantMoveCooldown <= 0) {
      let dx = 0, dz = 0;
      if (this.keys['w']) dz = -2;
      else if (this.keys['s']) dz = 2;
      else if (this.keys['a']) dx = -2;
      else if (this.keys['d']) dx = 2;
      if (dx !== 0 || dz !== 0) {
        const newX = this.powerPlant.position.x + dx;
        const newZ = this.powerPlant.position.z + dz;
        if (newX >= -8 && newX <= 8 && newZ >= -8 && newZ <= 0) {
          const isOccupied = this.placedPlants.some(p =>
            p !== this.powerPlant &&
            Math.abs(p.position.x - newX) < 0.5 &&
            Math.abs(p.position.z - newZ) < 0.5
          );
          if (!isOccupied) {
            const oldKey = `${this.powerPlant.position.x},${this.powerPlant.position.z}`;
            this.plantSlots.delete(oldKey);
            this.powerPlant.position.set(newX, 0.5, newZ);
            this.powerPlant.mesh.position.set(newX, 0.5, newZ);
            this.plantSlots.set(`${newX},${newZ}`, true);
            this.powerPlantMoveCooldown = 0.3;
          }
        }
      }
    }

    // Power plant animations
    const time = Date.now() * 0.003;
    this.powerPlant.mesh.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        // Pulsing glow on core elements
        if (child.userData.isPowerCore) {
          const pulse = 0.85 + Math.sin(time * 2) * 0.15;
          child.scale.setScalar(pulse);
        }
        // Orbiting rings
        if (child.userData.isPowerOrbit) {
          child.rotation.z = time * 0.5;
          child.rotation.x = Math.PI / 2 + Math.sin(time * 0.7) * 0.15;
        }
      }
    });
    // Gentle hover bob
    this.powerPlant.mesh.position.y = 0.5 + Math.sin(time * 1.2) * 0.04;

    this.updatePowerPlantHUD();
  }

  private usePowerPlantAbility1(): void {
    if (!this.powerPlant || !this.powerPlantType || this.powerPlant.health <= 0) return;
    switch (this.powerPlantType) {
      case 'grape-pulser': {
        if (this.powerPlantAbility1Cooldown > 0) return;
        const nearest = this.findNearestZombieInRow(this.powerPlant.position);
        const target = nearest ? nearest.position.clone() : new THREE.Vector3(this.powerPlant.position.x + 20, 0.5, this.powerPlant.position.z);
        this.shootElectricGrape(this.powerPlant.position.clone(), target, 50, false);
        this.powerPlantAbility1Cooldown = 7;
        break;
      }
      case 'overgrown-vine-wall': {
        if (this.powerPlantAbility1Cooldown > 0) return;
        for (const plant of this.placedPlants) {
          if (plant === this.powerPlant) continue;
          const dist = plant.position.distanceTo(this.powerPlant.position);
          if (dist <= 6) {
            plant.health = Math.min(plant.health + 50, plant.maxHealth);
          }
        }
        this.createHealEffect(this.powerPlant.position, false);
        this.powerPlantAbility1Cooldown = 15;
        break;
      }
      case 'great-god-lily': {
        if (this.powerPlantAbility1Cooldown > 0) return;
        if (!this.waveStarted) return;
        this.sun += 200;
        const sunEl = document.getElementById('sun-amount');
        if (sunEl) sunEl.textContent = this.sun.toString();
        this.updatePlantSlots();
        this.createSunBurstEffect(this.powerPlant.position);
        this.powerPlantAbility1Cooldown = 15;
        break;
      }
    }
  }

  private usePowerPlantAbility2(): void {
    if (!this.powerPlant || !this.powerPlantType || this.powerPlant.health <= 0) return;
    switch (this.powerPlantType) {
      case 'grape-pulser': {
        if (this.powerPlantAbility2Cooldown > 0) return;
        const nearest2 = this.findNearestZombieInRow(this.powerPlant.position);
        const target2 = nearest2 ? nearest2.position.clone() : new THREE.Vector3(this.powerPlant.position.x + 20, 0.5, this.powerPlant.position.z);
        this.shootElectricGrape(this.powerPlant.position.clone(), target2, 500, true);
        this.powerPlantAbility2Cooldown = 40;
        break;
      }
      case 'overgrown-vine-wall': {
        if (this.powerPlantAbility2Cooldown > 0) return;
        for (const plant of this.placedPlants) {
          plant.health = Math.min(plant.health + 10, plant.maxHealth);
        }
        for (const zombie of this.zombies) {
          zombie.health -= 5;
        }
        this.createHealEffect(this.powerPlant.position, true);
        this.powerPlantAbility2Cooldown = 20;
        break;
      }
      case 'great-god-lily': {
        if (this.powerPlantAbility2Cooldown > 0) return;
        if (!this.waveStarted) return;
        this.sun += 500;
        const sunEl = document.getElementById('sun-amount');
        if (sunEl) sunEl.textContent = this.sun.toString();
        this.updatePlantSlots();
        this.createSunBurstEffect(this.powerPlant.position);
        this.powerPlantAbility2Cooldown = 30;
        break;
      }
    }
  }

  private shootElectricGrape(from: THREE.Vector3, to: THREE.Vector3, damage: number, isMega: boolean): void {
    const size = isMega ? 0.35 : 0.18;
    const grapeGeo = new THREE.SphereGeometry(size, 16, 16);
    const grapeMat = new THREE.MeshPhongMaterial({
      color: isMega ? 0xffcc00 : 0x00ccff,
      emissive: isMega ? 0xff8800 : 0x0066ff,
      emissiveIntensity: 0.6,
      shininess: 200
    });
    const grape = new THREE.Mesh(grapeGeo, grapeMat);
    grape.position.copy(from);
    grape.position.y = 1;
    this.scene.add(grape);
    const dir = new THREE.Vector3().subVectors(to, from).normalize();
    dir.y = 0;
    const projectile = new Projectile(grape, from.clone(), dir.multiplyScalar(15), damage, false);
    this.projectiles.push(projectile);
  }

  private createHealEffect(pos: THREE.Vector3, isGlobal: boolean): void {
    const color = isGlobal ? 0x88ff88 : 0x44ff44;
    const size = isGlobal ? 12 : 4;
    const ringGeo = new THREE.RingGeometry(0.5, size, 32);
    const ringMat = new THREE.MeshBasicMaterial({ color, transparent: true, opacity: 0.5, side: THREE.DoubleSide });
    const ring = new THREE.Mesh(ringGeo, ringMat);
    ring.position.copy(pos);
    ring.position.y = 0.5;
    ring.rotation.x = -Math.PI / 2;
    this.scene.add(ring);
    const startTime = Date.now();
    const animateRing = () => {
      const elapsed = (Date.now() - startTime) / 1000;
      if (elapsed > 0.8) { this.scene.remove(ring); ringGeo.dispose(); ringMat.dispose(); return; }
      ring.material.opacity = 0.5 * (1 - elapsed / 0.8);
      ring.scale.setScalar(1 + elapsed * 2);
      requestAnimationFrame(animateRing);
    };
    animateRing();
  }

  private createSunBurstEffect(pos: THREE.Vector3): void {
    for (let i = 0; i < 8; i++) {
      const sparkGeo = new THREE.SphereGeometry(0.15, 8, 8);
      const sparkMat = new THREE.MeshBasicMaterial({ color: 0xffdd00, transparent: true, opacity: 0.9 });
      const spark = new THREE.Mesh(sparkGeo, sparkMat);
      spark.position.copy(pos);
      spark.position.y = 1.5;
      this.scene.add(spark);
      const angle = (i / 8) * Math.PI * 2;
      const vx = Math.cos(angle) * 3;
      const vz = Math.sin(angle) * 3;
      const startTime = Date.now();
      const animateSpark = () => {
        const elapsed = (Date.now() - startTime) / 1000;
        if (elapsed > 0.6) { this.scene.remove(spark); sparkGeo.dispose(); sparkMat.dispose(); return; }
        spark.position.x += vx * 0.016;
        spark.position.z += vz * 0.016;
        spark.position.y += 0.02;
        spark.material.opacity = 0.9 * (1 - elapsed / 0.6);
        requestAnimationFrame(animateSpark);
      };
      animateSpark();
    }
  }

  private animate(): void {
    if (this.isDisposed) return;
    this.animationFrameId = requestAnimationFrame(() => this.animate());

    // Log once at the start to confirm game loop is running
    if (this.animateFrameCount === 0) {
      console.log('🎮 Game loop started!');
    }
    this.animateFrameCount++;

    let deltaTime = 0.016; // ~60 FPS

    // Apply slow motion if active
    if (this.slowMotion) {
      deltaTime *= 0.2; // Slow down to 20% speed
    }

    // Apply game speed multiplier
    deltaTime *= this.gameSpeed;

    // Stop updating if game is over
    if (this.gameOver) {
      this.renderer.render(this.scene, this.camera);
      return;
    }

    // Stop updating if paused (but still render)
    if (this.isPaused) {
      this.renderer.render(this.scene, this.camera);
      return;
    }

    // Update instant plant cooldowns
    for (const [plantType, cooldown] of this.instantPlantCooldowns) {
      if (cooldown > 0) {
        this.instantPlantCooldowns.set(plantType, Math.max(0, cooldown - deltaTime));
      }
    }
    // Update plant slot UI to show cooldowns
    this.updatePlantSlotCooldowns();

    // Toggle slow motion when "3" key is pressed
    if (this.keys['3'] && Date.now() - this.lastSlowMotionToggle > 300) {
      this.slowMotion = !this.slowMotion;
      this.lastSlowMotionToggle = Date.now();
      console.log(`🐌 Slow Motion: ${this.slowMotion ? 'ON' : 'OFF'}`);
    }

    // Toggle HP display when "1" key is pressed
    if (this.keys['1'] && Date.now() - this.lastToggleTime > 300) {
      this.showHP = !this.showHP;
      this.lastToggleTime = Date.now();
      console.log(`HP Display: ${this.showHP ? 'ON' : 'OFF'}`);
    }

    // Toggle zombie health display when "2" key is pressed
    if (this.keys['2'] && Date.now() - this.lastZombieToggleTime > 300) {
      this.showZombieHealth = !this.showZombieHealth;
      this.lastZombieToggleTime = Date.now();
      console.log(`Zombie Health Display: ${this.showZombieHealth ? 'ON' : 'OFF'}`);
    }

    // Last Stand mode - countdown timer then auto-start waves
    if (this.isLastStandMode && !this.lastStandStarted && !this.waveStarted) {
      this.lastStandSetupTime -= deltaTime;
      const waveBtn = document.getElementById('wave-btn');
      if (waveBtn) {
        waveBtn.textContent = `Auto-start in ${Math.ceil(this.lastStandSetupTime)}s`;
      }
      if (this.lastStandSetupTime <= 0) {
        this.lastStandStarted = true;
        this.startNextWave();
        console.log('🏰 Last Stand: Time is up! Defend yourself!');
      }
    }

    // Toggle glove mode when "E" key is pressed
    if (this.keys['e'] && Date.now() - this.lastGloveToggle > 300) {
      this.gloveMode = !this.gloveMode;
      this.glovePlant = null; // Reset picked plant
      this.lastGloveToggle = Date.now();

      // Update cursor and UI
      const container = document.getElementById('canvas-container');
      const gloveIndicator = document.getElementById('glove-indicator');
      const gloveBtn = document.getElementById('glove-btn');
      if (this.gloveMode) {
        if (container) container.style.cursor = 'grab';
        // Deselect other modes
        this.shovelMode = false;
        this.currentPlantType = null;
        document.querySelectorAll('.plant-slot').forEach(slot => slot.classList.remove('selected'));
        const shovelBtn = document.getElementById('shovel-btn');
        if (shovelBtn) shovelBtn.classList.remove('active');
        if (gloveBtn) gloveBtn.classList.add('active');
        if (gloveIndicator) {
          gloveIndicator.classList.add('active');
          gloveIndicator.textContent = '🧤 GLOVE MODE - Click plant to pick up';
        }
        console.log('🧤 Glove Mode: ON - Click a plant to pick it up!');
      } else {
        // Reset held plant visual if any
        if (this.glovePlant) {
          this.resetGlovePlantVisual(this.glovePlant);
        }
        if (container) container.style.cursor = 'default';
        if (gloveBtn) gloveBtn.classList.remove('active');
        if (gloveIndicator) {
          gloveIndicator.classList.remove('active');
          gloveIndicator.classList.remove('holding');
        }
        console.log('🧤 Glove Mode: OFF');
      }
      // Update glove highlights
      this.updateGloveHighlights();
    }

    // Toggle wave skip mode when "L" key is pressed
    if (this.keys['l'] && Date.now() - this.lastWaveSkipToggle > 300) {
      this.waveSkipMode = !this.waveSkipMode;
      this.lastWaveSkipToggle = Date.now();
      console.log(`⏭️ Wave Skip Mode: ${this.waveSkipMode ? 'ON - Use Arrow Up/Right to skip forward, Arrow Down/Left to go back' : 'OFF'}`);
    }

    // Handle wave skipping when in wave skip mode
    if (this.waveSkipMode && Date.now() - this.lastWaveSkip > 300) {
      // Skip forward (Arrow Up or Arrow Right)
      if (this.keys['arrowup'] || this.keys['arrowright']) {
        this.skipToNextWave();
        this.lastWaveSkip = Date.now();
      }
      // Skip backward (Arrow Down or Arrow Left) - only if wave > 1
      if ((this.keys['arrowdown'] || this.keys['arrowleft']) && this.currentWave > 1) {
        this.skipToPreviousWave();
        this.lastWaveSkip = Date.now();
      }
    }

    // Update camera position based on keyboard input (WASD keys)
    this.updateCamera(deltaTime);

    // Update power plant (movement, cooldowns, HUD)
    this.updatePowerPlant(deltaTime);

    // Animate glove highlight rings (pulsing effect)
    if (this.gloveMode) {
      const time = Date.now() * 0.005;
      for (const mesh of this.gloveHighlightMeshes) {
        if (mesh.userData.isPulsingRing) {
          const pulseTime = mesh.userData.pulseTime || 0;
          const scale = 1 + Math.sin(time + pulseTime) * 0.15;
          mesh.scale.set(scale, scale, 1);
          // Also pulse opacity
          if (mesh.material instanceof THREE.MeshBasicMaterial) {
            mesh.material.opacity = 0.5 + Math.sin(time + pulseTime) * 0.3;
          }
        }
      }
    }

    // Only increment time and spawn zombies if wave has started
    if (this.waveStarted) {
      this.gameTime += deltaTime;

      // Dragon Battle mode custom spawning
      if (this.isDragonBattleMode) {
        if (this.gameTime >= this.nextZombieSpawn && this.zombiesSpawnedInWave < this.zombiesInWave) {
          this.spawnDragonBattleZombie();
          this.nextZombieSpawn = this.gameTime + 3; // 3 seconds between dragons
        }

        // Wave 3 phase 2: spawn red dragon after all others die
        if (this.dragonBattleWave === 3 && !this.dragonBattleRedDragonSpawned &&
            this.zombiesSpawnedInWave >= this.zombiesInWave && this.zombies.length === 0 &&
            !this.dragonBattleWave3Phase2) {
          this.dragonBattleWave3Phase2 = true;
          setTimeout(() => {
            this.spawnRedDragon();
            this.dragonBattleRedDragonSpawned = true;
          }, 2000);
        }

        // Check wave completion
        if (this.dragonBattleWave === 3) {
          if (this.dragonBattleRedDragonSpawned && this.zombies.length === 0 && !this.waveComplete) {
            this.completeDragonBattleWave();
          }
        } else {
          if (this.zombiesSpawnedInWave >= this.zombiesInWave && this.zombies.length === 0 && !this.waveComplete) {
            this.completeDragonBattleWave();
          }
        }
      }

      // Spawn zombies in groups (only if we haven't spawned all zombies for this wave)
      if (this.gameTime >= this.nextZombieSpawn && this.zombiesSpawnedInWave < this.zombiesInWave) {
        // Spawn a group of 3-6 zombies at once
        const groupSize = Math.min(
          3 + Math.floor(Math.random() * 4), // 3-6 zombies per group
          this.zombiesInWave - this.zombiesSpawnedInWave // Don't exceed remaining zombies
        );
        for (let i = 0; i < groupSize; i++) {
          this.spawnZombie();
        }
        this.nextZombieSpawn = this.gameTime + 2; // Spawn groups every 2 seconds (faster!)
      }

      // Update wave progress display
      this.updateWaveProgressDisplay();

      // Check for wave completion (not in Dragon Battle - handled above)
      if (!this.isDragonBattleMode && this.zombiesSpawnedInWave >= this.zombiesInWave && this.zombies.length === 0 && !this.waveComplete) {
        this.completeWave();
      }
    }

    // Update zombies
    this.updateZombies(deltaTime);

    // Update plants
    this.updatePlants(deltaTime);

    // I Zombie mode specific updates
    if (this.isIZombieMode) {
      // Sun regeneration - give 25 sun every 5 seconds
      this.iZombieSunTimer += deltaTime;
      if (this.iZombieSunTimer >= 5) {
        this.sun += 25;
        const sunAmount = document.getElementById('sun-amount');
        if (sunAmount) sunAmount.textContent = this.sun.toString();
        this.iZombieSunTimer = 0;
      }

      // Check if all plants are destroyed = VICTORY!
      if (this.placedPlants.length === 0 && !this.gameOver) {
        console.log('🧟 All plants destroyed! YOU WIN!');
        this.showIZombieVictory();
      }

      // Check for I Zombie LOSS: no zombies alive and can't afford more
      if (this.zombies.length === 0 && this.placedPlants.length > 0 && this.sun < 50 && !this.gameOver) {
        console.log('🧟 No zombies and not enough sun! GAME OVER!');
        this.showIZombieLoss();
      }
    }

    // Conveyor Belt mode - spawn plants on the conveyor (only during active waves!)
    if (this.isConveyorMode && this.waveStarted) {
      this.conveyorTimer += deltaTime;
      // Add a plant to the conveyor every 4 seconds (max 10 plants)
      if (this.conveyorTimer >= 4 && this.conveyorPlants.length < 10) {
        const plantTypes: PlantType[] = ['grape-launcher', 'vine-wall', 'pear-cannon', 'frost-berri', 'lily', 'avocado-slammer'];
        const randomPlant = plantTypes[Math.floor(Math.random() * plantTypes.length)];
        this.conveyorPlants.push(randomPlant);
        this.conveyorTimer = 0;
        this.updateConveyorUI();
      }
    }

    // Update falling suns
    this.updateFallingSuns(deltaTime);

    // Display HP if enabled (hide when Shift held to show bunker HP instead)
    if (this.showHP && !this.shiftHeld) {
      this.displayPlantHP();
    } else {
      // Remove HP displays when disabled or Shift held
      for (const plant of this.placedPlants) {
        const hpDisplay = plant.mesh.children.find(child => child.userData.isHPDisplay);
        if (hpDisplay) {
          plant.mesh.remove(hpDisplay);
        }
      }
    }

    // Display zombie health if enabled
    if (this.showZombieHealth) {
      this.displayZombieHealth();
    } else {
      // Remove zombie HP displays when disabled
      for (const zombie of this.zombies) {
        const hpDisplay = zombie.mesh.children.find(child => child.userData.isZombieHPDisplay);
        if (hpDisplay) {
          zombie.mesh.remove(hpDisplay);
        }
      }
    }

    // Display pineapple bunker HP when Shift is held
    if (this.shiftHeld) {
      this.displayBunkerHP();
    } else {
      // Remove bunker HP displays when shift released
      for (const plant of this.placedPlants) {
        if (plant.pineappleBunker) {
          const hpDisplay = plant.pineappleBunker.mesh.children.find(child => child.userData.isBunkerHPDisplay);
          if (hpDisplay) {
            plant.pineappleBunker.mesh.remove(hpDisplay);
          }
        }
      }
    }

    // Update projectiles
    this.updateProjectiles(deltaTime);
    this.updateZombieProjectiles(deltaTime);

    // Update allies (from banana peel)
    this.updateAllies(deltaTime);

    // Gentle rotation for the tower
    this.cube.rotation.y += 0.005;

    this.renderer.render(this.scene, this.camera);
  }

  private updateCamera(deltaTime: number): void {
    // Camera panning via scroll wheel (shift+scroll for horizontal)
    this.camera.position.x += this.scrollVelocityX * deltaTime;
    this.camera.position.z += this.scrollVelocityZ * deltaTime;

    // Decay scroll velocity for smooth stop
    const friction = 0.9;
    this.scrollVelocityX *= friction;
    this.scrollVelocityZ *= friction;
    if (Math.abs(this.scrollVelocityX) < 0.01) this.scrollVelocityX = 0;
    if (Math.abs(this.scrollVelocityZ) < 0.01) this.scrollVelocityZ = 0;

    // Clamp camera position to reasonable bounds
    this.camera.position.x = Math.max(-15, Math.min(15, this.camera.position.x));
    this.camera.position.z = Math.max(-5, Math.min(20, this.camera.position.z));

    // Camera looks at a point in front of it
    this.camera.lookAt(this.camera.position.x, 0, this.camera.position.z - 12);
  }

  private spawnZombie(): void {
    if (this.isDragonBattleMode) return; // Dragon Battle has its own spawning
    // Spawn at random row on the right side
    const rows = 5;
    const randomRow = Math.floor(Math.random() * rows);
    const startZ = -8 + randomRow * 2;

    let zombieType: ZombieType;

    // Check for wave-specific Fire Zombie spawns (mini boss)
    // Wave 4: 1 fire zombie, Wave 7: 3 fire zombies, Wave 8-9: 1 each, Wave 15: 3 fire zombies
    const fireZombieWaves: { [wave: number]: number } = { 4: 1, 7: 3, 8: 1, 9: 1, 15: 3 };
    const fireZombiesForWave = fireZombieWaves[this.currentWave] || 0;

    // Track fire zombies spawned this wave
    if (!this.fireZombiesSpawnedThisWave) {
      this.fireZombiesSpawnedThisWave = 0;
    }

    // Spawn fire zombie if we haven't hit the limit for this wave
    if (fireZombiesForWave > 0 && this.fireZombiesSpawnedThisWave < fireZombiesForWave) {
      // Spawn fire zombie at specific intervals during the wave
      const spawnInterval = Math.floor(this.zombiesInWave / (fireZombiesForWave + 1));
      const shouldSpawnFire = this.zombiesSpawnedInWave > 0 &&
        this.zombiesSpawnedInWave % spawnInterval === 0;
      if (shouldSpawnFire) {
        zombieType = 'fire';
        this.fireZombiesSpawnedThisWave++;
      }
    }

    // Random zombie type with weighted probabilities (if not already assigned)
    if (!zombieType!) {
      const rand = Math.random();
      if (rand < 0.38) {
        zombieType = 'normal'; // 38% chance
      } else if (rand < 0.56) {
        zombieType = 'fast'; // 18% chance
      } else if (rand < 0.70) {
        zombieType = 'tiny'; // 14% chance
      } else if (rand < 0.81) {
        zombieType = 'grape'; // 11% chance
      } else if (rand < 0.89) {
        zombieType = 'grave'; // 8% chance
      } else if (rand < 0.95) {
        zombieType = 'tank'; // 6% chance
      } else if (rand < 0.98) {
        zombieType = 'fat'; // 3% chance - explodes in 3x3 area
      } else {
        zombieType = 'fire'; // 2% random chance on top of wave-specific
      }
    }

    const zombieMesh = this.createZombieMesh(zombieType);
    zombieMesh.position.set(10, 0.75, startZ);
    zombieMesh.rotation.y = -Math.PI / 2; // Face left (toward -X direction)
    this.scene.add(zombieMesh);

    const zombie = new Zombie(zombieMesh, zombieMesh.position, zombieType);

    // Copy arm references for animation
    if (zombieMesh.userData.leftArm) {
      zombie.leftArm = zombieMesh.userData.leftArm;
    }
    if (zombieMesh.userData.rightArm) {
      zombie.rightArm = zombieMesh.userData.rightArm;
    }

    this.zombies.push(zombie);
    this.zombiesSpawnedInWave++;

    console.log(`${zombieType} zombie spawned! (${this.zombiesSpawnedInWave}/${this.zombiesInWave})`);
  }

  private createGrapeZombieMesh(): THREE.Group {
    const zombieGroup = new THREE.Group();
    const scale = 1;

    // Purple grape-themed colors
    const skinColor = 0x9370db; // Purple skin
    const skinColorDark = 0x6a0dad;
    const clothesColor = 0x4b0082; // Indigo clothes
    const clothesColorAlt = 0x3a006f;
    const eyeColor = 0xff00ff; // Magenta eyes
    const hairColor = 0x2a0040;

    // Torso
    const torsoGeo = new THREE.CylinderGeometry(0.32 * scale, 0.28 * scale, 0.9 * scale, 12);
    const torsoMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 15 });
    const torso = new THREE.Mesh(torsoGeo, torsoMat);
    torso.position.y = 0.7 * scale;
    zombieGroup.add(torso);

    // Collar
    const collarGeo = new THREE.CylinderGeometry(0.34 * scale, 0.32 * scale, 0.15 * scale, 12);
    const collarMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 10 });
    const collar = new THREE.Mesh(collarGeo, collarMat);
    collar.position.y = 1.1 * scale;
    zombieGroup.add(collar);

    // Hips
    const hipsGeo = new THREE.CylinderGeometry(0.3 * scale, 0.26 * scale, 0.2 * scale, 12);
    const hipsMat = new THREE.MeshPhongMaterial({ color: 0x3d2040, shininess: 20 });
    const hips = new THREE.Mesh(hipsGeo, hipsMat);
    hips.position.y = 0.2 * scale;
    zombieGroup.add(hips);

    // Neck
    const neckGeo = new THREE.CylinderGeometry(0.12 * scale, 0.14 * scale, 0.2 * scale, 10);
    const neckMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const neck = new THREE.Mesh(neckGeo, neckMat);
    neck.position.y = 1.25 * scale;
    zombieGroup.add(neck);

    // Head
    const headGeo = new THREE.SphereGeometry(0.28 * scale, 16, 14);
    const headMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 25 });
    const head = new THREE.Mesh(headGeo, headMat);
    head.scale.set(1, 1.15, 1);
    head.position.y = 1.55 * scale;
    zombieGroup.add(head);

    // Hair
    const hairGeo = new THREE.SphereGeometry(0.29 * scale, 12, 8, 0, Math.PI * 2, 0, Math.PI * 0.5);
    const hairMat = new THREE.MeshPhongMaterial({ color: hairColor, shininess: 5 });
    const hair = new THREE.Mesh(hairGeo, hairMat);
    hair.position.y = 1.6 * scale;
    hair.scale.set(1, 0.7, 1);
    zombieGroup.add(hair);

    // Giant grape on head (launcher) - unique feature!
    const grapeGeo = new THREE.SphereGeometry(0.3, 16, 16);
    const grapeMat = new THREE.MeshPhongMaterial({
      color: 0x9370db,
      emissive: 0x6a0dad,
      emissiveIntensity: 0.5,
      shininess: 100
    });
    const grape = new THREE.Mesh(grapeGeo, grapeMat);
    grape.position.y = 1.95 * scale;
    zombieGroup.add(grape);

    // Grape launcher cannon
    const cannonGeo = new THREE.CylinderGeometry(0.1, 0.1, 0.4, 12);
    const cannonMat = new THREE.MeshPhongMaterial({ color: 0x4b0082 });
    const cannon = new THREE.Mesh(cannonGeo, cannonMat);
    cannon.position.set(0, 1.75 * scale, 0.35 * scale);
    cannon.rotation.x = Math.PI / 3;
    zombieGroup.add(cannon);

    // Ears
    const earGeo = new THREE.SphereGeometry(0.06 * scale, 8, 8);
    const earMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftEar = new THREE.Mesh(earGeo, earMat);
    leftEar.position.set(-0.28 * scale, 1.55 * scale, 0);
    leftEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(leftEar);
    const rightEar = new THREE.Mesh(earGeo, earMat);
    rightEar.position.set(0.28 * scale, 1.55 * scale, 0);
    rightEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(rightEar);

    // Glowing purple eyes
    const eyeGeo = new THREE.SphereGeometry(0.05 * scale, 12, 12);
    const eyeMat = new THREE.MeshPhongMaterial({
      color: eyeColor,
      emissive: eyeColor,
      emissiveIntensity: 0.9,
      shininess: 100
    });
    const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
    leftEye.position.set(-0.1 * scale, 1.58 * scale, 0.24 * scale);
    zombieGroup.add(leftEye);
    const rightEye = new THREE.Mesh(eyeGeo, eyeMat.clone());
    rightEye.position.set(0.1 * scale, 1.58 * scale, 0.24 * scale);
    zombieGroup.add(rightEye);

    // Mouth
    const mouthGeo = new THREE.BoxGeometry(0.16 * scale, 0.04 * scale, 0.04 * scale);
    const mouthMat = new THREE.MeshPhongMaterial({ color: 0x1a0a0a });
    const mouth = new THREE.Mesh(mouthGeo, mouthMat);
    mouth.position.set(0, 1.42 * scale, 0.24 * scale);
    zombieGroup.add(mouth);

    // Shoulders
    const shoulderGeo = new THREE.SphereGeometry(0.14 * scale, 10, 10);
    const shoulderMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 15 });
    const leftShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    leftShoulder.position.set(-0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(leftShoulder);
    const rightShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    rightShoulder.position.set(0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(rightShoulder);

    // Arm groups for animation - positioned at shoulder joint
    const leftArmGroup = new THREE.Group();
    leftArmGroup.position.set(-0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(leftArmGroup);

    const rightArmGroup = new THREE.Group();
    rightArmGroup.position.set(0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(rightArmGroup);

    // Upper arms - connected to shoulder, goes straight down
    const upperArmGeo = new THREE.CylinderGeometry(0.1 * scale, 0.085 * scale, 0.4 * scale, 10);
    const upperArmMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 12 });
    const leftUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    leftUpperArm.position.set(0, -0.2 * scale, 0);
    leftArmGroup.add(leftUpperArm);
    const rightUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    rightUpperArm.position.set(0, -0.2 * scale, 0);
    rightArmGroup.add(rightUpperArm);

    // Elbow joints - seamless connection between upper arm and forearm
    const elbowGeo = new THREE.SphereGeometry(0.085 * scale, 8, 8);
    const elbowMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const leftElbow = new THREE.Mesh(elbowGeo, elbowMat);
    leftElbow.position.set(0, -0.4 * scale, 0);
    leftArmGroup.add(leftElbow);
    const rightElbow = new THREE.Mesh(elbowGeo, elbowMat);
    rightElbow.position.set(0, -0.4 * scale, 0);
    rightArmGroup.add(rightElbow);

    // Forearms - connected at elbow, angled forward
    const forearmGeo = new THREE.CylinderGeometry(0.08 * scale, 0.065 * scale, 0.38 * scale, 10);
    const forearmMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const leftForearm = new THREE.Mesh(forearmGeo, forearmMat);
    leftForearm.position.set(0, -0.58 * scale, 0.12 * scale);
    leftForearm.rotation.x = 0.5;
    leftArmGroup.add(leftForearm);
    const rightForearm = new THREE.Mesh(forearmGeo, forearmMat);
    rightForearm.position.set(0, -0.58 * scale, 0.12 * scale);
    rightForearm.rotation.x = 0.5;
    rightArmGroup.add(rightForearm);

    // Wrist joints - seamless connection to hands
    const wristGeo = new THREE.SphereGeometry(0.06 * scale, 8, 8);
    const wristMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftWrist = new THREE.Mesh(wristGeo, wristMat);
    leftWrist.position.set(0, -0.72 * scale, 0.22 * scale);
    leftArmGroup.add(leftWrist);
    const rightWrist = new THREE.Mesh(wristGeo, wristMat);
    rightWrist.position.set(0, -0.72 * scale, 0.22 * scale);
    rightArmGroup.add(rightWrist);

    // Hands - connected at wrist
    const handGeo = new THREE.BoxGeometry(0.1 * scale, 0.14 * scale, 0.06 * scale);
    const handMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftHand = new THREE.Mesh(handGeo, handMat);
    leftHand.position.set(0, -0.82 * scale, 0.26 * scale);
    leftHand.rotation.x = 0.5;
    leftArmGroup.add(leftHand);
    const rightHand = new THREE.Mesh(handGeo, handMat);
    rightHand.position.set(0, -0.82 * scale, 0.26 * scale);
    rightHand.rotation.x = 0.5;
    rightArmGroup.add(rightHand);

    // Fingers - zombie claws
    for (let f = 0; f < 3; f++) {
      const fingerGeo = new THREE.CylinderGeometry(0.015 * scale, 0.01 * scale, 0.08 * scale, 6);
      const fingerMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 10 });
      const leftFinger = new THREE.Mesh(fingerGeo, fingerMat);
      leftFinger.position.set((f - 1) * 0.035 * scale, -0.9 * scale, 0.3 * scale);
      leftFinger.rotation.x = 0.8;
      leftArmGroup.add(leftFinger);
      const rightFinger = new THREE.Mesh(fingerGeo, fingerMat);
      rightFinger.position.set((f - 1) * 0.035 * scale, -0.9 * scale, 0.3 * scale);
      rightFinger.rotation.x = 0.8;
      rightArmGroup.add(rightFinger);
    }

    // Store arm references for animation
    zombieGroup.userData.leftArm = leftArmGroup;
    zombieGroup.userData.rightArm = rightArmGroup;

    // LEG GROUPS for proper animation - legs move together as a unit
    const leftLegGroup = new THREE.Group();
    leftLegGroup.position.set(-0.15 * scale, 0.1 * scale, 0); // Hip pivot point
    zombieGroup.add(leftLegGroup);

    const rightLegGroup = new THREE.Group();
    rightLegGroup.position.set(0.15 * scale, 0.1 * scale, 0); // Hip pivot point
    zombieGroup.add(rightLegGroup);

    // Thighs - attached to leg groups
    const thighGeo = new THREE.CylinderGeometry(0.12 * scale, 0.1 * scale, 0.45 * scale, 10);
    const thighMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 10 });
    const leftThigh = new THREE.Mesh(thighGeo, thighMat);
    leftThigh.position.set(0, -0.25 * scale, 0);
    leftLegGroup.add(leftThigh);
    const rightThigh = new THREE.Mesh(thighGeo, thighMat);
    rightThigh.position.set(0, -0.25 * scale, 0);
    rightLegGroup.add(rightThigh);

    // Shins - attached to leg groups
    const shinGeo = new THREE.CylinderGeometry(0.09 * scale, 0.07 * scale, 0.45 * scale, 10);
    const shinMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 10 });
    const leftShin = new THREE.Mesh(shinGeo, shinMat);
    leftShin.position.set(0, -0.65 * scale, 0);
    leftLegGroup.add(leftShin);
    const rightShin = new THREE.Mesh(shinGeo, shinMat);
    rightShin.position.set(0, -0.65 * scale, 0);
    rightLegGroup.add(rightShin);

    // Feet - attached to leg groups
    const footGeo = new THREE.BoxGeometry(0.12 * scale, 0.08 * scale, 0.2 * scale);
    const footMat = new THREE.MeshPhongMaterial({ color: 0x2a1a2a, shininess: 25 });
    const leftFoot = new THREE.Mesh(footGeo, footMat);
    leftFoot.position.set(0, -0.9 * scale, 0.04 * scale);
    leftLegGroup.add(leftFoot);
    const rightFoot = new THREE.Mesh(footGeo, footMat);
    rightFoot.position.set(0, -0.9 * scale, 0.04 * scale);
    rightLegGroup.add(rightFoot);

    // Store leg references for animation
    zombieGroup.userData.leftLeg = leftLegGroup;
    zombieGroup.userData.rightLeg = rightLegGroup;

    // Slouched posture
    torso.rotation.x = 0.12;
    head.rotation.x = 0.15;

    return zombieGroup;
  }

  private createCarZombieMesh(): THREE.Group {
    const zombieGroup = new THREE.Group();

    // Zombie driver colors
    const skinColor = 0x6b8e6b; // Greenish zombie skin
    const skinColorDark = 0x4a6a4a;
    const clothesColor = 0x8b0000; // Dark red to match car
    const eyeColor = 0xff3333;

    // === THE CAR - Menacing apocalypse vehicle ===
    // Main car body with battle damage look
    const carBodyGeo = new THREE.BoxGeometry(2.2, 1.0, 1.6);
    const carBodyMat = new THREE.MeshPhongMaterial({
      color: 0x1a1a1a, // Dark metal black
      shininess: 40,
      specular: 0x333333
    });
    const carBody = new THREE.Mesh(carBodyGeo, carBodyMat);
    carBody.position.y = 0.6;
    zombieGroup.add(carBody);

    // Blood-red racing stripes
    const stripeGeo = new THREE.BoxGeometry(2.3, 0.05, 0.2);
    const stripeMat = new THREE.MeshPhongMaterial({ color: 0x8b0000, emissive: 0x330000, emissiveIntensity: 0.3 });
    const stripe1 = new THREE.Mesh(stripeGeo, stripeMat);
    stripe1.position.set(0, 1.11, -0.3);
    zombieGroup.add(stripe1);
    const stripe2 = new THREE.Mesh(stripeGeo, stripeMat);
    stripe2.position.set(0, 1.11, 0.3);
    zombieGroup.add(stripe2);

    // Front bumper with cow catcher/plow
    const bumperGeo = new THREE.BoxGeometry(0.3, 0.8, 1.8);
    const bumperMat = new THREE.MeshPhongMaterial({ color: 0x333333, shininess: 60 });
    const bumper = new THREE.Mesh(bumperGeo, bumperMat);
    bumper.position.set(1.15, 0.4, 0);
    zombieGroup.add(bumper);

    // Angled plow blade
    const plowGeo = new THREE.BoxGeometry(0.1, 0.6, 2.0);
    const plowMat = new THREE.MeshPhongMaterial({ color: 0x666666, shininess: 80 });
    const plow = new THREE.Mesh(plowGeo, plowMat);
    plow.position.set(1.35, 0.3, 0);
    plow.rotation.y = 0.1;
    zombieGroup.add(plow);

    // Windshield - cracked tinted glass
    const windshieldGeo = new THREE.BoxGeometry(1.6, 0.7, 0.08);
    const windshieldMat = new THREE.MeshPhongMaterial({
      color: 0x222222,
      transparent: true,
      opacity: 0.7,
      shininess: 100
    });
    const windshield = new THREE.Mesh(windshieldGeo, windshieldMat);
    windshield.position.set(-0.2, 1.2, 0.75);
    windshield.rotation.x = -0.4;
    zombieGroup.add(windshield);

    // Roof with roll cage
    const roofGeo = new THREE.BoxGeometry(1.4, 0.3, 1.3);
    const roofMat = new THREE.MeshPhongMaterial({ color: 0x1a1a1a });
    const roof = new THREE.Mesh(roofGeo, roofMat);
    roof.position.set(-0.3, 1.5, 0);
    zombieGroup.add(roof);

    // Roll cage bars
    const cageBarGeo = new THREE.CylinderGeometry(0.04, 0.04, 0.8, 8);
    const cageBarMat = new THREE.MeshPhongMaterial({ color: 0x444444 });
    for (let i = 0; i < 3; i++) {
      const bar = new THREE.Mesh(cageBarGeo, cageBarMat);
      bar.position.set(-0.5 + i * 0.4, 1.35, 0.7);
      bar.rotation.x = -0.4;
      zombieGroup.add(bar);
    }

    // Big monster truck wheels
    const wheelGeo = new THREE.CylinderGeometry(0.45, 0.45, 0.35, 20);
    const wheelMat = new THREE.MeshPhongMaterial({ color: 0x0a0a0a, shininess: 30 });
    const hubGeo = new THREE.CylinderGeometry(0.2, 0.2, 0.36, 12);
    const hubMat = new THREE.MeshPhongMaterial({ color: 0x333333, shininess: 80 });

    const wheelPositions = [
      [-0.85, 0.1, -0.75],
      [-0.85, 0.1, 0.75],
      [0.7, 0.1, -0.75],
      [0.7, 0.1, 0.75]
    ];

    wheelPositions.forEach(pos => {
      const wheel = new THREE.Mesh(wheelGeo, wheelMat);
      wheel.position.set(pos[0], pos[1], pos[2]);
      wheel.rotation.x = Math.PI / 2; // Rotate so wheel spins correctly
      wheel.userData.isWheel = true; // Mark for animation
      zombieGroup.add(wheel);
      // Hub cap
      const hub = new THREE.Mesh(hubGeo, hubMat);
      hub.position.set(pos[0], pos[1], pos[2]);
      hub.rotation.z = Math.PI / 2;
      zombieGroup.add(hub);
    });

    // Deadly spikes on front - larger and more menacing
    for (let i = 0; i < 7; i++) {
      const spikeGeo = new THREE.ConeGeometry(0.12, 0.7, 6);
      const spikeMat = new THREE.MeshPhongMaterial({
        color: 0x666666,
        shininess: 100,
        specular: 0xaaaaaa
      });
      const spike = new THREE.Mesh(spikeGeo, spikeMat);
      spike.position.set(1.4, 0.2 + (i % 2) * 0.3, -0.8 + i * 0.27);
      spike.rotation.x = Math.PI / 2;
      zombieGroup.add(spike);
    }

    // Exhaust pipes with smoke effect
    const exhaustGeo = new THREE.CylinderGeometry(0.08, 0.1, 0.5, 8);
    const exhaustMat = new THREE.MeshPhongMaterial({ color: 0x222222 });
    const leftExhaust = new THREE.Mesh(exhaustGeo, exhaustMat);
    leftExhaust.position.set(-1.1, 0.8, -0.5);
    leftExhaust.rotation.z = -0.3;
    zombieGroup.add(leftExhaust);
    const rightExhaust = new THREE.Mesh(exhaustGeo, exhaustMat);
    rightExhaust.position.set(-1.1, 0.8, 0.5);
    rightExhaust.rotation.z = -0.3;
    zombieGroup.add(rightExhaust);

    // Glowing red headlights - evil eyes
    const headlightMat = new THREE.MeshPhongMaterial({
      color: 0xff0000,
      emissive: 0xff0000,
      emissiveIntensity: 1.2
    });
    const leftHeadlight = new THREE.Mesh(new THREE.SphereGeometry(0.12, 12, 12), headlightMat);
    leftHeadlight.position.set(1.1, 0.6, -0.5);
    zombieGroup.add(leftHeadlight);
    const rightHeadlight = new THREE.Mesh(new THREE.SphereGeometry(0.12, 12, 12), headlightMat.clone());
    rightHeadlight.position.set(1.1, 0.6, 0.5);
    zombieGroup.add(rightHeadlight);

    // Skull hood ornament
    const skullGeo = new THREE.SphereGeometry(0.15, 12, 10);
    const skullMat = new THREE.MeshPhongMaterial({ color: 0xccccaa, shininess: 20 });
    const skull = new THREE.Mesh(skullGeo, skullMat);
    skull.scale.set(1, 1.2, 0.8);
    skull.position.set(1.0, 1.15, 0);
    zombieGroup.add(skull);
    // Skull eye sockets
    const eyeSocketGeo = new THREE.SphereGeometry(0.04, 8, 8);
    const eyeSocketMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
    const leftSocket = new THREE.Mesh(eyeSocketGeo, eyeSocketMat);
    leftSocket.position.set(1.08, 1.18, -0.05);
    zombieGroup.add(leftSocket);
    const rightSocket = new THREE.Mesh(eyeSocketGeo, eyeSocketMat);
    rightSocket.position.set(1.08, 1.18, 0.05);
    zombieGroup.add(rightSocket);

    // === ZOMBIE DRIVER (visible through windshield) ===
    const driverScale = 0.7;

    // Driver torso
    const torsoGeo = new THREE.CylinderGeometry(0.25 * driverScale, 0.22 * driverScale, 0.6 * driverScale, 12);
    const torsoMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 15 });
    const torso = new THREE.Mesh(torsoGeo, torsoMat);
    torso.position.set(0, 1.0, 0);
    zombieGroup.add(torso);

    // Driver neck
    const neckGeo = new THREE.CylinderGeometry(0.08 * driverScale, 0.1 * driverScale, 0.15 * driverScale, 10);
    const neckMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const neck = new THREE.Mesh(neckGeo, neckMat);
    neck.position.set(0, 1.35, 0);
    zombieGroup.add(neck);

    // Driver head
    const headGeo = new THREE.SphereGeometry(0.2 * driverScale, 16, 14);
    const headMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 25 });
    const head = new THREE.Mesh(headGeo, headMat);
    head.scale.set(1, 1.15, 1);
    head.position.set(0, 1.55, 0.1);
    zombieGroup.add(head);

    // Driver hair
    const hairGeo = new THREE.SphereGeometry(0.21 * driverScale, 12, 8, 0, Math.PI * 2, 0, Math.PI * 0.5);
    const hairMat = new THREE.MeshPhongMaterial({ color: 0x2a2a2a, shininess: 5 });
    const hair = new THREE.Mesh(hairGeo, hairMat);
    hair.position.set(0, 1.6, 0.1);
    hair.scale.set(1, 0.7, 1);
    zombieGroup.add(hair);

    // Driver ears
    const earGeo = new THREE.SphereGeometry(0.04 * driverScale, 8, 8);
    const earMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftEar = new THREE.Mesh(earGeo, earMat);
    leftEar.position.set(-0.2 * driverScale, 1.55, 0.1);
    leftEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(leftEar);
    const rightEar = new THREE.Mesh(earGeo, earMat);
    rightEar.position.set(0.2 * driverScale, 1.55, 0.1);
    rightEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(rightEar);

    // Driver glowing eyes
    const eyeGeo = new THREE.SphereGeometry(0.04 * driverScale, 12, 12);
    const eyeMat = new THREE.MeshPhongMaterial({
      color: eyeColor,
      emissive: eyeColor,
      emissiveIntensity: 1.2,
      shininess: 100
    });
    const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
    leftEye.position.set(-0.08 * driverScale, 1.58, 0.25);
    zombieGroup.add(leftEye);
    const rightEye = new THREE.Mesh(eyeGeo, eyeMat.clone());
    rightEye.position.set(0.08 * driverScale, 1.58, 0.25);
    zombieGroup.add(rightEye);

    // Driver shoulders
    const shoulderGeo = new THREE.SphereGeometry(0.1 * driverScale, 10, 10);
    const shoulderMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 15 });
    const leftShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    leftShoulder.position.set(-0.3 * driverScale, 1.15, 0);
    zombieGroup.add(leftShoulder);
    const rightShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    rightShoulder.position.set(0.3 * driverScale, 1.15, 0);
    zombieGroup.add(rightShoulder);

    // Driver arm groups
    const leftArmGroup = new THREE.Group();
    leftArmGroup.position.set(-0.3 * driverScale, 1.15, 0);
    zombieGroup.add(leftArmGroup);

    const rightArmGroup = new THREE.Group();
    rightArmGroup.position.set(0.3 * driverScale, 1.15, 0);
    zombieGroup.add(rightArmGroup);

    // Driver upper arms
    const upperArmGeo = new THREE.CylinderGeometry(0.07 * driverScale, 0.06 * driverScale, 0.35 * driverScale, 10);
    const upperArmMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 12 });
    const leftUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    leftUpperArm.position.set(-0.05 * driverScale, -0.18 * driverScale, 0);
    leftUpperArm.rotation.z = 0.5;
    leftArmGroup.add(leftUpperArm);
    const rightUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    rightUpperArm.position.set(0.05 * driverScale, -0.18 * driverScale, 0);
    rightUpperArm.rotation.z = -0.5;
    rightArmGroup.add(rightUpperArm);

    // Driver forearms (reaching toward steering wheel)
    const forearmGeo = new THREE.CylinderGeometry(0.05 * driverScale, 0.04 * driverScale, 0.3 * driverScale, 10);
    const forearmMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const leftForearm = new THREE.Mesh(forearmGeo, forearmMat);
    leftForearm.position.set(-0.1 * driverScale, -0.4 * driverScale, 0.15 * driverScale);
    leftForearm.rotation.set(0.8, 0, 0.3);
    leftArmGroup.add(leftForearm);
    const rightForearm = new THREE.Mesh(forearmGeo, forearmMat);
    rightForearm.position.set(0.1 * driverScale, -0.4 * driverScale, 0.15 * driverScale);
    rightForearm.rotation.set(0.8, 0, -0.3);
    rightArmGroup.add(rightForearm);

    // Driver hands
    const handGeo = new THREE.BoxGeometry(0.07 * driverScale, 0.1 * driverScale, 0.05 * driverScale);
    const handMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftHand = new THREE.Mesh(handGeo, handMat);
    leftHand.position.set(-0.1 * driverScale, -0.55 * driverScale, 0.35 * driverScale);
    leftArmGroup.add(leftHand);
    const rightHand = new THREE.Mesh(handGeo, handMat);
    rightHand.position.set(0.1 * driverScale, -0.55 * driverScale, 0.35 * driverScale);
    rightArmGroup.add(rightHand);

    // Store arm references for animation
    zombieGroup.userData.leftArm = leftArmGroup;
    zombieGroup.userData.rightArm = rightArmGroup;

    return zombieGroup;
  }

  private createGraveZombieMesh(): THREE.Group {
    const zombieGroup = new THREE.Group();
    const scale = 1;

    // Dark necromancer colors
    const skinColor = 0x5a5a5a; // Gray dead skin
    const skinColorDark = 0x3a3a3a;
    const clothesColor = 0x2f2f2f; // Dark robes
    const clothesColorAlt = 0x1a1a1a;
    const eyeColor = 0x00ff00; // Necromancer green eyes

    // Torso (dark robes)
    const torsoGeo = new THREE.CylinderGeometry(0.32 * scale, 0.28 * scale, 0.9 * scale, 12);
    const torsoMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 5 });
    const torso = new THREE.Mesh(torsoGeo, torsoMat);
    torso.position.y = 0.7 * scale;
    zombieGroup.add(torso);

    // Robe bottom (flowing)
    const robeGeo = new THREE.CylinderGeometry(0.28 * scale, 0.45 * scale, 0.5 * scale, 12);
    const robeMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 5 });
    const robe = new THREE.Mesh(robeGeo, robeMat);
    robe.position.y = 0.15 * scale;
    zombieGroup.add(robe);

    // Collar
    const collarGeo = new THREE.CylinderGeometry(0.36 * scale, 0.34 * scale, 0.2 * scale, 12);
    const collarMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 5 });
    const collar = new THREE.Mesh(collarGeo, collarMat);
    collar.position.y = 1.15 * scale;
    zombieGroup.add(collar);

    // Neck
    const neckGeo = new THREE.CylinderGeometry(0.12 * scale, 0.14 * scale, 0.2 * scale, 10);
    const neckMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 10 });
    const neck = new THREE.Mesh(neckGeo, neckMat);
    neck.position.y = 1.25 * scale;
    zombieGroup.add(neck);

    // Head
    const headGeo = new THREE.SphereGeometry(0.28 * scale, 16, 14);
    const headMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 15 });
    const head = new THREE.Mesh(headGeo, headMat);
    head.scale.set(1, 1.15, 1);
    head.position.y = 1.55 * scale;
    zombieGroup.add(head);

    // Hood (necromancer cowl)
    const hoodGeo = new THREE.SphereGeometry(0.35 * scale, 12, 10, 0, Math.PI * 2, 0, Math.PI * 0.7);
    const hoodMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 5 });
    const hood = new THREE.Mesh(hoodGeo, hoodMat);
    hood.position.y = 1.6 * scale;
    hood.scale.set(1, 1, 1.2);
    zombieGroup.add(hood);

    // Hood point
    const hoodPointGeo = new THREE.ConeGeometry(0.15 * scale, 0.3 * scale, 8);
    const hoodPointMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 5 });
    const hoodPoint = new THREE.Mesh(hoodPointGeo, hoodPointMat);
    hoodPoint.position.y = 1.95 * scale;
    zombieGroup.add(hoodPoint);

    // Ears
    const earGeo = new THREE.SphereGeometry(0.06 * scale, 8, 8);
    const earMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 10 });
    const leftEar = new THREE.Mesh(earGeo, earMat);
    leftEar.position.set(-0.28 * scale, 1.55 * scale, 0);
    leftEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(leftEar);
    const rightEar = new THREE.Mesh(earGeo, earMat);
    rightEar.position.set(0.28 * scale, 1.55 * scale, 0);
    rightEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(rightEar);

    // Glowing green eyes (necromancer!)
    const eyeGeo = new THREE.SphereGeometry(0.05 * scale, 12, 12);
    const eyeMat = new THREE.MeshPhongMaterial({
      color: eyeColor,
      emissive: eyeColor,
      emissiveIntensity: 1.2,
      shininess: 100
    });
    const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
    leftEye.position.set(-0.1 * scale, 1.58 * scale, 0.24 * scale);
    zombieGroup.add(leftEye);
    const rightEye = new THREE.Mesh(eyeGeo, eyeMat.clone());
    rightEye.position.set(0.1 * scale, 1.58 * scale, 0.24 * scale);
    zombieGroup.add(rightEye);

    // Mouth
    const mouthGeo = new THREE.BoxGeometry(0.16 * scale, 0.04 * scale, 0.04 * scale);
    const mouthMat = new THREE.MeshPhongMaterial({ color: 0x0a0a0a });
    const mouth = new THREE.Mesh(mouthGeo, mouthMat);
    mouth.position.set(0, 1.42 * scale, 0.24 * scale);
    zombieGroup.add(mouth);

    // Shoulders
    const shoulderGeo = new THREE.SphereGeometry(0.14 * scale, 10, 10);
    const shoulderMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 5 });
    const leftShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    leftShoulder.position.set(-0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(leftShoulder);
    const rightShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    rightShoulder.position.set(0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(rightShoulder);

    // Arm groups for animation
    const leftArmGroup = new THREE.Group();
    leftArmGroup.position.set(-0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(leftArmGroup);

    const rightArmGroup = new THREE.Group();
    rightArmGroup.position.set(0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(rightArmGroup);

    // Upper arms (in robes)
    const upperArmGeo = new THREE.CylinderGeometry(0.1 * scale, 0.08 * scale, 0.45 * scale, 10);
    const upperArmMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 5 });
    const leftUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    leftUpperArm.position.set(-0.07 * scale, -0.25 * scale, 0);
    leftUpperArm.rotation.z = 0.4;
    leftArmGroup.add(leftUpperArm);
    const rightUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    rightUpperArm.position.set(0.07 * scale, -0.25 * scale, 0);
    rightUpperArm.rotation.z = -0.4;
    rightArmGroup.add(rightUpperArm);

    // Forearms
    const forearmGeo = new THREE.CylinderGeometry(0.07 * scale, 0.06 * scale, 0.4 * scale, 10);
    const forearmMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 10 });
    const leftForearm = new THREE.Mesh(forearmGeo, forearmMat);
    leftForearm.position.set(-0.17 * scale, -0.6 * scale, 0.15 * scale);
    leftForearm.rotation.set(0.6, 0, 0.3);
    leftArmGroup.add(leftForearm);
    const rightForearm = new THREE.Mesh(forearmGeo, forearmMat);
    rightForearm.position.set(0.17 * scale, -0.6 * scale, 0.15 * scale);
    rightForearm.rotation.set(0.6, 0, -0.3);
    rightArmGroup.add(rightForearm);

    // Hands (bony)
    const handGeo = new THREE.BoxGeometry(0.1 * scale, 0.14 * scale, 0.06 * scale);
    const handMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 10 });
    const leftHand = new THREE.Mesh(handGeo, handMat);
    leftHand.position.set(-0.17 * scale, -0.85 * scale, 0.35 * scale);
    leftHand.rotation.x = 0.3;
    leftArmGroup.add(leftHand);
    const rightHand = new THREE.Mesh(handGeo, handMat);
    rightHand.position.set(0.17 * scale, -0.85 * scale, 0.35 * scale);
    rightHand.rotation.x = 0.3;
    rightArmGroup.add(rightHand);

    // Store arm references for animation
    zombieGroup.userData.leftArm = leftArmGroup;
    zombieGroup.userData.rightArm = rightArmGroup;

    // Legs hidden under robe (but functional)
    const thighGeo = new THREE.CylinderGeometry(0.12 * scale, 0.1 * scale, 0.45 * scale, 10);
    const thighMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 5 });
    const leftThigh = new THREE.Mesh(thighGeo, thighMat);
    leftThigh.position.set(-0.15 * scale, -0.15 * scale, 0);
    zombieGroup.add(leftThigh);
    const rightThigh = new THREE.Mesh(thighGeo, thighMat);
    rightThigh.position.set(0.15 * scale, -0.15 * scale, 0);
    zombieGroup.add(rightThigh);

    const shinGeo = new THREE.CylinderGeometry(0.09 * scale, 0.07 * scale, 0.45 * scale, 10);
    const shinMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 5 });
    const leftShin = new THREE.Mesh(shinGeo, shinMat);
    leftShin.position.set(-0.15 * scale, -0.55 * scale, 0);
    zombieGroup.add(leftShin);
    const rightShin = new THREE.Mesh(shinGeo, shinMat);
    rightShin.position.set(0.15 * scale, -0.55 * scale, 0);
    zombieGroup.add(rightShin);

    const footGeo = new THREE.BoxGeometry(0.12 * scale, 0.08 * scale, 0.2 * scale);
    const footMat = new THREE.MeshPhongMaterial({ color: 0x1a1a1a, shininess: 15 });
    const leftFoot = new THREE.Mesh(footGeo, footMat);
    leftFoot.position.set(-0.15 * scale, -0.8 * scale, 0.04 * scale);
    zombieGroup.add(leftFoot);
    const rightFoot = new THREE.Mesh(footGeo, footMat);
    rightFoot.position.set(0.15 * scale, -0.8 * scale, 0.04 * scale);
    zombieGroup.add(rightFoot);

    // === UNIQUE FEATURES ===
    // Gravestone staff
    const staffGeo = new THREE.CylinderGeometry(0.06, 0.06, 1.6, 12);
    const staffMat = new THREE.MeshPhongMaterial({
      color: 0x4a4a4a,
      shininess: 30
    });
    const staff = new THREE.Mesh(staffGeo, staffMat);
    staff.position.set(0.5, 0.9, 0);
    zombieGroup.add(staff);

    // Mini gravestone on top of staff
    const graveGeo = new THREE.BoxGeometry(0.25, 0.35, 0.08);
    const graveMat = new THREE.MeshPhongMaterial({
      color: 0x666666,
      shininess: 20
    });
    const grave = new THREE.Mesh(graveGeo, graveMat);
    grave.position.set(0.5, 1.85, 0);
    zombieGroup.add(grave);

    // Gravestone arch
    const archGeo = new THREE.TorusGeometry(0.12, 0.04, 8, 12, Math.PI);
    const archMat = new THREE.MeshPhongMaterial({ color: 0x666666, shininess: 20 });
    const arch = new THREE.Mesh(archGeo, archMat);
    arch.position.set(0.5, 2.02, 0);
    arch.rotation.z = Math.PI;
    zombieGroup.add(arch);

    // Green glow aura (necromancy!)
    const auraGeo = new THREE.SphereGeometry(1.2, 16, 16);
    const auraMat = new THREE.MeshBasicMaterial({
      color: 0x00ff00,
      transparent: true,
      opacity: 0.15
    });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    aura.position.y = 1;
    zombieGroup.add(aura);

    // Slouched posture
    torso.rotation.x = 0.15;
    head.rotation.x = 0.2;

    return zombieGroup;
  }

  private createGrapeGunZombieMesh(): THREE.Group {
    const zombieGroup = new THREE.Group();
    const scale = 1.4; // Mini boss - bigger than normal!

    // Purple armored colors
    const skinColor = 0x8b6090; // Pale purple skin
    const skinColorDark = 0x6a4070;
    const clothesColor = 0x4b0082; // Indigo armor
    const clothesColorAlt = 0x3a006f;
    const eyeColor = 0xff0000; // Menacing red eyes

    // Torso (armored)
    const torsoGeo = new THREE.CylinderGeometry(0.35 * scale, 0.3 * scale, 0.95 * scale, 12);
    const torsoMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 50 });
    const torso = new THREE.Mesh(torsoGeo, torsoMat);
    torso.position.y = 0.7 * scale;
    zombieGroup.add(torso);

    // Armor plating on torso
    const armorGeo = new THREE.CylinderGeometry(0.38 * scale, 0.35 * scale, 0.5 * scale, 12);
    const armorMat = new THREE.MeshPhongMaterial({ color: 0x6a0dad, shininess: 80 });
    const armor = new THREE.Mesh(armorGeo, armorMat);
    armor.position.y = 0.8 * scale;
    zombieGroup.add(armor);

    // Collar
    const collarGeo = new THREE.CylinderGeometry(0.38 * scale, 0.36 * scale, 0.18 * scale, 12);
    const collarMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 40 });
    const collar = new THREE.Mesh(collarGeo, collarMat);
    collar.position.y = 1.15 * scale;
    zombieGroup.add(collar);

    // Hips
    const hipsGeo = new THREE.CylinderGeometry(0.32 * scale, 0.28 * scale, 0.22 * scale, 12);
    const hipsMat = new THREE.MeshPhongMaterial({ color: 0x3d2040, shininess: 40 });
    const hips = new THREE.Mesh(hipsGeo, hipsMat);
    hips.position.y = 0.2 * scale;
    zombieGroup.add(hips);

    // Neck
    const neckGeo = new THREE.CylinderGeometry(0.14 * scale, 0.16 * scale, 0.2 * scale, 10);
    const neckMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const neck = new THREE.Mesh(neckGeo, neckMat);
    neck.position.y = 1.28 * scale;
    zombieGroup.add(neck);

    // Head
    const headGeo = new THREE.SphereGeometry(0.3 * scale, 16, 14);
    const headMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 25 });
    const head = new THREE.Mesh(headGeo, headMat);
    head.scale.set(1, 1.15, 1);
    head.position.y = 1.58 * scale;
    zombieGroup.add(head);

    // Helmet
    const helmetGeo = new THREE.SphereGeometry(0.34 * scale, 14, 12, 0, Math.PI * 2, 0, Math.PI * 0.6);
    const helmetMat = new THREE.MeshPhongMaterial({ color: 0x6a0dad, shininess: 80 });
    const helmet = new THREE.Mesh(helmetGeo, helmetMat);
    helmet.position.y = 1.65 * scale;
    zombieGroup.add(helmet);

    // Helmet visor
    const visorGeo = new THREE.BoxGeometry(0.5 * scale, 0.12 * scale, 0.35 * scale);
    const visorMat = new THREE.MeshPhongMaterial({
      color: 0x9370db,
      shininess: 100,
      specular: 0xffffff
    });
    const visor = new THREE.Mesh(visorGeo, visorMat);
    visor.position.set(0, 1.7 * scale, 0.18 * scale);
    zombieGroup.add(visor);

    // Ears
    const earGeo = new THREE.SphereGeometry(0.07 * scale, 8, 8);
    const earMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftEar = new THREE.Mesh(earGeo, earMat);
    leftEar.position.set(-0.3 * scale, 1.55 * scale, 0);
    leftEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(leftEar);
    const rightEar = new THREE.Mesh(earGeo, earMat);
    rightEar.position.set(0.3 * scale, 1.55 * scale, 0);
    rightEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(rightEar);

    // Menacing red glowing eyes
    const eyeGeo = new THREE.SphereGeometry(0.06 * scale, 12, 12);
    const eyeMat = new THREE.MeshPhongMaterial({
      color: eyeColor,
      emissive: eyeColor,
      emissiveIntensity: 1.5,
      shininess: 100
    });
    const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
    leftEye.position.set(-0.12 * scale, 1.6 * scale, 0.26 * scale);
    zombieGroup.add(leftEye);
    const rightEye = new THREE.Mesh(eyeGeo, eyeMat.clone());
    rightEye.position.set(0.12 * scale, 1.6 * scale, 0.26 * scale);
    zombieGroup.add(rightEye);

    // Mouth
    const mouthGeo = new THREE.BoxGeometry(0.18 * scale, 0.05 * scale, 0.04 * scale);
    const mouthMat = new THREE.MeshPhongMaterial({ color: 0x1a0a0a });
    const mouth = new THREE.Mesh(mouthGeo, mouthMat);
    mouth.position.set(0, 1.42 * scale, 0.26 * scale);
    zombieGroup.add(mouth);

    // Shoulders (armored)
    const shoulderGeo = new THREE.SphereGeometry(0.18 * scale, 10, 10);
    const shoulderMat = new THREE.MeshPhongMaterial({ color: 0x6a0dad, shininess: 60 });
    const leftShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    leftShoulder.position.set(-0.42 * scale, 1.08 * scale, 0);
    zombieGroup.add(leftShoulder);
    const rightShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    rightShoulder.position.set(0.42 * scale, 1.08 * scale, 0);
    zombieGroup.add(rightShoulder);

    // Arm groups for animation
    const leftArmGroup = new THREE.Group();
    leftArmGroup.position.set(-0.42 * scale, 1.08 * scale, 0);
    zombieGroup.add(leftArmGroup);

    const rightArmGroup = new THREE.Group();
    rightArmGroup.position.set(0.42 * scale, 1.08 * scale, 0);
    zombieGroup.add(rightArmGroup);

    // Upper arms (armored)
    const upperArmGeo = new THREE.CylinderGeometry(0.12 * scale, 0.1 * scale, 0.5 * scale, 10);
    const upperArmMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 40 });
    const leftUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    leftUpperArm.position.set(-0.08 * scale, -0.28 * scale, 0);
    leftUpperArm.rotation.z = 0.4;
    leftArmGroup.add(leftUpperArm);
    const rightUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    rightUpperArm.position.set(0.08 * scale, -0.28 * scale, 0);
    rightUpperArm.rotation.z = -0.4;
    rightArmGroup.add(rightUpperArm);

    // Forearms
    const forearmGeo = new THREE.CylinderGeometry(0.09 * scale, 0.07 * scale, 0.45 * scale, 10);
    const forearmMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const leftForearm = new THREE.Mesh(forearmGeo, forearmMat);
    leftForearm.position.set(-0.18 * scale, -0.65 * scale, 0.18 * scale);
    leftForearm.rotation.set(0.6, 0, 0.3);
    leftArmGroup.add(leftForearm);
    const rightForearm = new THREE.Mesh(forearmGeo, forearmMat);
    rightForearm.position.set(0.18 * scale, -0.65 * scale, 0.18 * scale);
    rightForearm.rotation.set(0.6, 0, -0.3);
    rightArmGroup.add(rightForearm);

    // Hands
    const handGeo = new THREE.BoxGeometry(0.12 * scale, 0.16 * scale, 0.07 * scale);
    const handMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftHand = new THREE.Mesh(handGeo, handMat);
    leftHand.position.set(-0.18 * scale, -0.9 * scale, 0.4 * scale);
    leftHand.rotation.x = 0.3;
    leftArmGroup.add(leftHand);
    const rightHand = new THREE.Mesh(handGeo, handMat);
    rightHand.position.set(0.18 * scale, -0.9 * scale, 0.4 * scale);
    rightHand.rotation.x = 0.3;
    rightArmGroup.add(rightHand);

    // Store arm references for animation
    zombieGroup.userData.leftArm = leftArmGroup;
    zombieGroup.userData.rightArm = rightArmGroup;

    // Thighs (armored)
    const thighGeo = new THREE.CylinderGeometry(0.14 * scale, 0.12 * scale, 0.5 * scale, 10);
    const thighMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 40 });
    const leftThigh = new THREE.Mesh(thighGeo, thighMat);
    leftThigh.position.set(-0.17 * scale, -0.18 * scale, 0);
    zombieGroup.add(leftThigh);
    const rightThigh = new THREE.Mesh(thighGeo, thighMat);
    rightThigh.position.set(0.17 * scale, -0.18 * scale, 0);
    zombieGroup.add(rightThigh);

    // Shins
    const shinGeo = new THREE.CylinderGeometry(0.11 * scale, 0.09 * scale, 0.5 * scale, 10);
    const shinMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 40 });
    const leftShin = new THREE.Mesh(shinGeo, shinMat);
    leftShin.position.set(-0.17 * scale, -0.6 * scale, 0);
    zombieGroup.add(leftShin);
    const rightShin = new THREE.Mesh(shinGeo, shinMat);
    rightShin.position.set(0.17 * scale, -0.6 * scale, 0);
    zombieGroup.add(rightShin);

    // Feet (armored boots)
    const footGeo = new THREE.BoxGeometry(0.14 * scale, 0.1 * scale, 0.24 * scale);
    const footMat = new THREE.MeshPhongMaterial({ color: 0x2a1a2a, shininess: 50 });
    const leftFoot = new THREE.Mesh(footGeo, footMat);
    leftFoot.position.set(-0.17 * scale, -0.88 * scale, 0.05 * scale);
    zombieGroup.add(leftFoot);
    const rightFoot = new THREE.Mesh(footGeo, footMat);
    rightFoot.position.set(0.17 * scale, -0.88 * scale, 0.05 * scale);
    zombieGroup.add(rightFoot);

    // === UNIQUE FEATURE: TRIPLE BARREL GRAPE GUN ===
    // Gun body
    const gunBodyGeo = new THREE.BoxGeometry(0.35, 0.35, 1.0);
    const gunMat = new THREE.MeshPhongMaterial({
      color: 0x2f2f2f,
      shininess: 80
    });
    const gunBody = new THREE.Mesh(gunBodyGeo, gunMat);
    gunBody.position.set(0.6, 1.0 * scale, 0.7);
    zombieGroup.add(gunBody);

    // Three barrels for triple shot
    const barrelGeo = new THREE.CylinderGeometry(0.07, 0.07, 0.7, 12);
    const barrelMat = new THREE.MeshPhongMaterial({
      color: 0x1a1a1a,
      shininess: 100
    });

    const leftBarrel = new THREE.Mesh(barrelGeo, barrelMat);
    leftBarrel.position.set(0.48, 1.05 * scale, 1.2);
    leftBarrel.rotation.x = Math.PI / 2;
    zombieGroup.add(leftBarrel);

    const centerBarrel = new THREE.Mesh(barrelGeo, barrelMat.clone());
    centerBarrel.position.set(0.6, 1.05 * scale, 1.2);
    centerBarrel.rotation.x = Math.PI / 2;
    zombieGroup.add(centerBarrel);

    const rightBarrel = new THREE.Mesh(barrelGeo, barrelMat.clone());
    rightBarrel.position.set(0.72, 1.05 * scale, 1.2);
    rightBarrel.rotation.x = Math.PI / 2;
    zombieGroup.add(rightBarrel);

    // Grape ammo drum
    const drumGeo = new THREE.CylinderGeometry(0.3, 0.3, 0.25, 16);
    const drumMat = new THREE.MeshPhongMaterial({
      color: 0x8b00ff,
      emissive: 0x6a0dad,
      emissiveIntensity: 0.4,
      shininess: 60
    });
    const drum = new THREE.Mesh(drumGeo, drumMat);
    drum.position.set(0.6, 1.0 * scale, 0.25);
    drum.rotation.x = Math.PI / 2;
    zombieGroup.add(drum);

    // Purple aura (mini boss power!)
    const auraGeo = new THREE.SphereGeometry(1.5, 16, 16);
    const auraMat = new THREE.MeshBasicMaterial({
      color: 0x9370db,
      transparent: true,
      opacity: 0.2
    });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    aura.position.y = 1.2 * scale;
    zombieGroup.add(aura);

    // Slouched posture
    torso.rotation.x = 0.1;
    head.rotation.x = 0.12;

    return zombieGroup;
  }

  private createHealerZombieMesh(): THREE.Group {
    const zombieGroup = new THREE.Group();
    const scale = 1.2; // Mini boss - slightly bigger

    // Holy priest colors
    const skinColor = 0xc0c0c0; // Pale gray skin
    const skinColorDark = 0xa0a0a0;
    const clothesColor = 0xf0f0f0; // White robes
    const clothesColorAlt = 0xe0e0e0;
    const eyeColor = 0xffff00; // Holy golden eyes
    const hairColor = 0xd0d0d0;

    // Torso (white robes)
    const torsoGeo = new THREE.CylinderGeometry(0.34 * scale, 0.3 * scale, 0.95 * scale, 12);
    const torsoMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 40 });
    const torso = new THREE.Mesh(torsoGeo, torsoMat);
    torso.position.y = 0.7 * scale;
    zombieGroup.add(torso);

    // Gold trim belt
    const trimGeo = new THREE.CylinderGeometry(0.36 * scale, 0.34 * scale, 0.15 * scale, 12);
    const trimMat = new THREE.MeshPhongMaterial({
      color: 0xffd700,
      emissive: 0xffa500,
      emissiveIntensity: 0.3,
      shininess: 100
    });
    const trim = new THREE.Mesh(trimGeo, trimMat);
    trim.position.y = 0.35 * scale;
    zombieGroup.add(trim);

    // Robe bottom (flowing)
    const robeGeo = new THREE.CylinderGeometry(0.3 * scale, 0.42 * scale, 0.4 * scale, 12);
    const robeMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 30 });
    const robe = new THREE.Mesh(robeGeo, robeMat);
    robe.position.y = 0.1 * scale;
    zombieGroup.add(robe);

    // Collar (gold trimmed)
    const collarGeo = new THREE.CylinderGeometry(0.38 * scale, 0.36 * scale, 0.18 * scale, 12);
    const collarMat = new THREE.MeshPhongMaterial({
      color: 0xffd700,
      emissive: 0xffa500,
      emissiveIntensity: 0.2,
      shininess: 80
    });
    const collar = new THREE.Mesh(collarGeo, collarMat);
    collar.position.y = 1.15 * scale;
    zombieGroup.add(collar);

    // Neck
    const neckGeo = new THREE.CylinderGeometry(0.13 * scale, 0.15 * scale, 0.2 * scale, 10);
    const neckMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const neck = new THREE.Mesh(neckGeo, neckMat);
    neck.position.y = 1.28 * scale;
    zombieGroup.add(neck);

    // Head
    const headGeo = new THREE.SphereGeometry(0.29 * scale, 16, 14);
    const headMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 25 });
    const head = new THREE.Mesh(headGeo, headMat);
    head.scale.set(1, 1.15, 1);
    head.position.y = 1.58 * scale;
    zombieGroup.add(head);

    // Hair (silvery white)
    const hairGeo = new THREE.SphereGeometry(0.3 * scale, 12, 8, 0, Math.PI * 2, 0, Math.PI * 0.5);
    const hairMat = new THREE.MeshPhongMaterial({ color: hairColor, shininess: 20 });
    const hair = new THREE.Mesh(hairGeo, hairMat);
    hair.position.y = 1.62 * scale;
    hair.scale.set(1, 0.7, 1);
    zombieGroup.add(hair);

    // Holy halo
    const haloGeo = new THREE.TorusGeometry(0.4 * scale, 0.06 * scale, 16, 32);
    const haloMat = new THREE.MeshPhongMaterial({
      color: 0xffff00,
      emissive: 0xffff00,
      emissiveIntensity: 1,
      shininess: 100
    });
    const halo = new THREE.Mesh(haloGeo, haloMat);
    halo.position.y = 2.0 * scale;
    halo.rotation.x = Math.PI / 2;
    zombieGroup.add(halo);

    // Ears
    const earGeo = new THREE.SphereGeometry(0.06 * scale, 8, 8);
    const earMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftEar = new THREE.Mesh(earGeo, earMat);
    leftEar.position.set(-0.29 * scale, 1.55 * scale, 0);
    leftEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(leftEar);
    const rightEar = new THREE.Mesh(earGeo, earMat);
    rightEar.position.set(0.29 * scale, 1.55 * scale, 0);
    rightEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(rightEar);

    // Glowing yellow eyes (holy light)
    const eyeGeo = new THREE.SphereGeometry(0.055 * scale, 12, 12);
    const eyeMat = new THREE.MeshPhongMaterial({
      color: eyeColor,
      emissive: eyeColor,
      emissiveIntensity: 1.2,
      shininess: 100
    });
    const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
    leftEye.position.set(-0.11 * scale, 1.6 * scale, 0.25 * scale);
    zombieGroup.add(leftEye);
    const rightEye = new THREE.Mesh(eyeGeo, eyeMat.clone());
    rightEye.position.set(0.11 * scale, 1.6 * scale, 0.25 * scale);
    zombieGroup.add(rightEye);

    // Mouth
    const mouthGeo = new THREE.BoxGeometry(0.17 * scale, 0.04 * scale, 0.04 * scale);
    const mouthMat = new THREE.MeshPhongMaterial({ color: 0x1a1a1a });
    const mouth = new THREE.Mesh(mouthGeo, mouthMat);
    mouth.position.set(0, 1.43 * scale, 0.25 * scale);
    zombieGroup.add(mouth);

    // Shoulders
    const shoulderGeo = new THREE.SphereGeometry(0.15 * scale, 10, 10);
    const shoulderMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 30 });
    const leftShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    leftShoulder.position.set(-0.4 * scale, 1.08 * scale, 0);
    zombieGroup.add(leftShoulder);
    const rightShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    rightShoulder.position.set(0.4 * scale, 1.08 * scale, 0);
    zombieGroup.add(rightShoulder);

    // Arm groups for animation
    const leftArmGroup = new THREE.Group();
    leftArmGroup.position.set(-0.4 * scale, 1.08 * scale, 0);
    zombieGroup.add(leftArmGroup);

    const rightArmGroup = new THREE.Group();
    rightArmGroup.position.set(0.4 * scale, 1.08 * scale, 0);
    zombieGroup.add(rightArmGroup);

    // Upper arms (in white robes)
    const upperArmGeo = new THREE.CylinderGeometry(0.11 * scale, 0.09 * scale, 0.48 * scale, 10);
    const upperArmMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 25 });
    const leftUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    leftUpperArm.position.set(-0.07 * scale, -0.26 * scale, 0);
    leftUpperArm.rotation.z = 0.4;
    leftArmGroup.add(leftUpperArm);
    const rightUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    rightUpperArm.position.set(0.07 * scale, -0.26 * scale, 0);
    rightUpperArm.rotation.z = -0.4;
    rightArmGroup.add(rightUpperArm);

    // Forearms
    const forearmGeo = new THREE.CylinderGeometry(0.08 * scale, 0.065 * scale, 0.42 * scale, 10);
    const forearmMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const leftForearm = new THREE.Mesh(forearmGeo, forearmMat);
    leftForearm.position.set(-0.18 * scale, -0.62 * scale, 0.16 * scale);
    leftForearm.rotation.set(0.6, 0, 0.3);
    leftArmGroup.add(leftForearm);
    const rightForearm = new THREE.Mesh(forearmGeo, forearmMat);
    rightForearm.position.set(0.18 * scale, -0.62 * scale, 0.16 * scale);
    rightForearm.rotation.set(0.6, 0, -0.3);
    rightArmGroup.add(rightForearm);

    // Hands
    const handGeo = new THREE.BoxGeometry(0.11 * scale, 0.15 * scale, 0.06 * scale);
    const handMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftHand = new THREE.Mesh(handGeo, handMat);
    leftHand.position.set(-0.18 * scale, -0.88 * scale, 0.38 * scale);
    leftHand.rotation.x = 0.3;
    leftArmGroup.add(leftHand);
    const rightHand = new THREE.Mesh(handGeo, handMat);
    rightHand.position.set(0.18 * scale, -0.88 * scale, 0.38 * scale);
    rightHand.rotation.x = 0.3;
    rightArmGroup.add(rightHand);

    // Store arm references for animation
    zombieGroup.userData.leftArm = leftArmGroup;
    zombieGroup.userData.rightArm = rightArmGroup;

    // Thighs (hidden under robe)
    const thighGeo = new THREE.CylinderGeometry(0.13 * scale, 0.11 * scale, 0.48 * scale, 10);
    const thighMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 20 });
    const leftThigh = new THREE.Mesh(thighGeo, thighMat);
    leftThigh.position.set(-0.16 * scale, -0.16 * scale, 0);
    zombieGroup.add(leftThigh);
    const rightThigh = new THREE.Mesh(thighGeo, thighMat);
    rightThigh.position.set(0.16 * scale, -0.16 * scale, 0);
    zombieGroup.add(rightThigh);

    // Shins
    const shinGeo = new THREE.CylinderGeometry(0.1 * scale, 0.08 * scale, 0.48 * scale, 10);
    const shinMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 20 });
    const leftShin = new THREE.Mesh(shinGeo, shinMat);
    leftShin.position.set(-0.16 * scale, -0.58 * scale, 0);
    zombieGroup.add(leftShin);
    const rightShin = new THREE.Mesh(shinGeo, shinMat);
    rightShin.position.set(0.16 * scale, -0.58 * scale, 0);
    zombieGroup.add(rightShin);

    // Feet (white sandals)
    const footGeo = new THREE.BoxGeometry(0.13 * scale, 0.09 * scale, 0.22 * scale);
    const footMat = new THREE.MeshPhongMaterial({ color: 0xd0d0d0, shininess: 30 });
    const leftFoot = new THREE.Mesh(footGeo, footMat);
    leftFoot.position.set(-0.16 * scale, -0.85 * scale, 0.04 * scale);
    zombieGroup.add(leftFoot);
    const rightFoot = new THREE.Mesh(footGeo, footMat);
    rightFoot.position.set(0.16 * scale, -0.85 * scale, 0.04 * scale);
    zombieGroup.add(rightFoot);

    // === UNIQUE FEATURES ===
    // Cross symbol on chest
    const crossVGeo = new THREE.BoxGeometry(0.12 * scale, 0.4 * scale, 0.04 * scale);
    const crossMat = new THREE.MeshPhongMaterial({
      color: 0xffd700,
      emissive: 0xffa500,
      emissiveIntensity: 0.5
    });
    const crossV = new THREE.Mesh(crossVGeo, crossMat);
    crossV.position.set(0, 0.85 * scale, 0.32 * scale);
    zombieGroup.add(crossV);

    const crossHGeo = new THREE.BoxGeometry(0.32 * scale, 0.12 * scale, 0.04 * scale);
    const crossH = new THREE.Mesh(crossHGeo, crossMat.clone());
    crossH.position.set(0, 0.98 * scale, 0.32 * scale);
    zombieGroup.add(crossH);

    // Healing staff
    const staffGeo = new THREE.CylinderGeometry(0.08 * scale, 0.08 * scale, 1.9 * scale, 12);
    const staffMat = new THREE.MeshPhongMaterial({
      color: 0xffd700,
      shininess: 80
    });
    const staff = new THREE.Mesh(staffGeo, staffMat);
    staff.position.set(0.55, 0.95 * scale, 0);
    zombieGroup.add(staff);

    // Glowing healing orb on top of staff
    const orbGeo = new THREE.SphereGeometry(0.2, 16, 16);
    const orbMat = new THREE.MeshPhongMaterial({
      color: 0x00ff00,
      emissive: 0x00ff00,
      emissiveIntensity: 1.5,
      shininess: 100
    });
    const orb = new THREE.Mesh(orbGeo, orbMat);
    orb.position.set(0.55, 1.95 * scale, 0);
    zombieGroup.add(orb);

    // Smaller orbs orbiting the main orb
    for (let i = 0; i < 3; i++) {
      const smallOrbGeo = new THREE.SphereGeometry(0.06, 12, 12);
      const smallOrbMat = new THREE.MeshPhongMaterial({
        color: 0x00ff00,
        emissive: 0x00ff00,
        emissiveIntensity: 1,
        shininess: 100
      });
      const smallOrb = new THREE.Mesh(smallOrbGeo, smallOrbMat);
      const angle = (i / 3) * Math.PI * 2;
      smallOrb.position.set(
        0.55 + Math.cos(angle) * 0.3,
        1.95 * scale,
        Math.sin(angle) * 0.3
      );
      zombieGroup.add(smallOrb);
    }

    // Green healing aura (mini boss power!)
    const auraGeo = new THREE.SphereGeometry(1.5, 16, 16);
    const auraMat = new THREE.MeshBasicMaterial({
      color: 0x00ff00,
      transparent: true,
      opacity: 0.2
    });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    aura.position.y = 1.0 * scale;
    zombieGroup.add(aura);

    // Slouched posture
    torso.rotation.x = 0.1;
    head.rotation.x = 0.12;

    return zombieGroup;
  }

  private createSuperCarZombieMesh(): THREE.Group {
    // BOSS: Super Car Zombie - Massive armored death machine!
    const zombieGroup = new THREE.Group();

    // Zombie driver colors
    const skinColor = 0x4a5a4a; // Dark greenish zombie skin
    const clothesColor = 0x220022; // Dark purple to match car
    const eyeColor = 0xff00ff; // Magenta glowing eyes

    // === THE MEGA CAR ===
    // Massive armored car body (1.5x bigger)
    const carBodyGeo = new THREE.BoxGeometry(3, 1.8, 2.2);
    const carBodyMat = new THREE.MeshPhongMaterial({
      color: 0x220033,
      shininess: 100,
      specular: 0x8800ff
    });
    const carBody = new THREE.Mesh(carBodyGeo, carBodyMat);
    carBody.position.y = 0.9;
    zombieGroup.add(carBody);

    // Reinforced armor plating
    const armorGeo = new THREE.BoxGeometry(3.1, 0.2, 2.3);
    const armorMat = new THREE.MeshPhongMaterial({
      color: 0x333344,
      shininess: 150
    });
    const topArmor = new THREE.Mesh(armorGeo, armorMat);
    topArmor.position.y = 1.9;
    zombieGroup.add(topArmor);
    const bottomArmor = new THREE.Mesh(armorGeo, armorMat);
    bottomArmor.position.y = 0.05;
    zombieGroup.add(bottomArmor);

    // Side armor panels
    for (let side = -1; side <= 1; side += 2) {
      const sideArmorGeo = new THREE.BoxGeometry(2.8, 1.2, 0.15);
      const sideArmor = new THREE.Mesh(sideArmorGeo, armorMat);
      sideArmor.position.set(0, 0.9, side * 1.1);
      zombieGroup.add(sideArmor);
    }

    // Windshield (dark tinted)
    const windshieldGeo = new THREE.BoxGeometry(2.7, 1.2, 0.1);
    const windshieldMat = new THREE.MeshPhongMaterial({
      color: 0x110022,
      transparent: true,
      opacity: 0.7,
      shininess: 150
    });
    const windshield = new THREE.Mesh(windshieldGeo, windshieldMat);
    windshield.position.set(0, 1.5, 1.0);
    windshield.rotation.x = -0.2;
    zombieGroup.add(windshield);

    // Reinforced roof with turret mount
    const roofGeo = new THREE.BoxGeometry(2.6, 0.5, 1.8);
    const roofMat = new THREE.MeshPhongMaterial({ color: 0x110022 });
    const roof = new THREE.Mesh(roofGeo, roofMat);
    roof.position.y = 2.15;
    zombieGroup.add(roof);

    // Massive wheels (6 tires for this beast)
    const wheelGeo = new THREE.CylinderGeometry(0.55, 0.55, 0.4, 20);
    const wheelMat = new THREE.MeshPhongMaterial({ color: 0x111111, shininess: 50 });

    const wheels = [
      [-1.1, 0.1, -0.9],
      [-1.1, 0.1, 0.9],
      [0, 0.1, -0.9],
      [0, 0.1, 0.9],
      [1.1, 0.1, -0.9],
      [1.1, 0.1, 0.9]
    ];

    wheels.forEach(pos => {
      const wheel = new THREE.Mesh(wheelGeo, wheelMat);
      wheel.position.set(pos[0], pos[1], pos[2]);
      wheel.rotation.x = Math.PI / 2; // Rotate so wheel spins correctly
      wheel.userData.isWheel = true; // Mark for animation
      zombieGroup.add(wheel);

      // Chrome wheel caps
      const capGeo = new THREE.CylinderGeometry(0.2, 0.2, 0.45, 10);
      const capMat = new THREE.MeshPhongMaterial({ color: 0x888888, shininess: 200 });
      const cap = new THREE.Mesh(capGeo, capMat);
      cap.position.set(pos[0], pos[1], pos[2]);
      cap.rotation.z = Math.PI / 2;
      zombieGroup.add(cap);
    });

    // MASSIVE death spikes on front (double row)
    for (let row = 0; row < 2; row++) {
      for (let i = 0; i < 7; i++) {
        const spikeGeo = new THREE.ConeGeometry(0.2, 0.8 + row * 0.3, 8);
        const spikeMat = new THREE.MeshPhongMaterial({
          color: 0xcccccc,
          shininess: 150,
          emissive: 0x440044,
          emissiveIntensity: 0.3
        });
        const spike = new THREE.Mesh(spikeGeo, spikeMat);
        spike.position.set(-0.9 + i * 0.3, 0.4 + row * 0.6, 1.15);
        spike.rotation.x = Math.PI / 2;
        zombieGroup.add(spike);
      }
    }

    // Glowing purple headlights (evil!)
    const headlightMat = new THREE.MeshPhongMaterial({
      color: 0xff00ff,
      emissive: 0xff00ff,
      emissiveIntensity: 1.5
    });
    for (let x = -1; x <= 1; x += 2) {
      const headlight = new THREE.Mesh(new THREE.SphereGeometry(0.25, 14, 14), headlightMat);
      headlight.position.set(x * 0.9, 0.6, 1.12);
      zombieGroup.add(headlight);
    }

    // Purple energy aura
    const auraGeo = new THREE.SphereGeometry(2.5, 16, 16);
    const auraMat = new THREE.MeshBasicMaterial({
      color: 0x880088,
      transparent: true,
      opacity: 0.15
    });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    aura.position.y = 1.0;
    zombieGroup.add(aura);

    // Skull hood ornament
    const skullGeo = new THREE.SphereGeometry(0.25, 12, 12);
    skullGeo.scale(1, 1.2, 0.9);
    const skullMat = new THREE.MeshPhongMaterial({
      color: 0xddddcc,
      emissive: 0x440044,
      emissiveIntensity: 0.5
    });
    const skull = new THREE.Mesh(skullGeo, skullMat);
    skull.position.set(0, 1.95, 0.5);
    zombieGroup.add(skull);

    // Skull eyes
    for (let eye = -1; eye <= 1; eye += 2) {
      const eyeGeo = new THREE.SphereGeometry(0.06, 8, 8);
      const eyeMat = new THREE.MeshBasicMaterial({ color: 0xff00ff });
      const eyeMesh = new THREE.Mesh(eyeGeo, eyeMat);
      eyeMesh.position.set(eye * 0.1, 1.97, 0.65);
      zombieGroup.add(eyeMesh);
    }

    // === ZOMBIE DRIVER ===
    const driverScale = 0.8;

    // Driver torso
    const torsoGeo = new THREE.CylinderGeometry(0.3 * driverScale, 0.26 * driverScale, 0.7 * driverScale, 12);
    const torsoMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 15 });
    const torso = new THREE.Mesh(torsoGeo, torsoMat);
    torso.position.set(0, 1.4, 0);
    zombieGroup.add(torso);

    // Driver neck
    const neckGeo = new THREE.CylinderGeometry(0.1 * driverScale, 0.12 * driverScale, 0.18 * driverScale, 10);
    const neckMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const neck = new THREE.Mesh(neckGeo, neckMat);
    neck.position.set(0, 1.75, 0);
    zombieGroup.add(neck);

    // Driver head
    const headGeo = new THREE.SphereGeometry(0.28 * driverScale, 16, 14);
    const headMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 25 });
    const head = new THREE.Mesh(headGeo, headMat);
    head.scale.set(1, 1.1, 1);
    head.position.set(0, 2.0, 0);
    zombieGroup.add(head);

    // Driver evil eyes
    const driverEyeMat = new THREE.MeshPhongMaterial({
      color: eyeColor,
      emissive: eyeColor,
      emissiveIntensity: 1.2
    });
    for (let eye = -1; eye <= 1; eye += 2) {
      const driverEye = new THREE.Mesh(new THREE.SphereGeometry(0.05, 10, 10), driverEyeMat);
      driverEye.position.set(eye * 0.08, 2.02, 0.18);
      zombieGroup.add(driverEye);
    }

    // Exhaust flames
    for (let i = 0; i < 2; i++) {
      const flameGeo = new THREE.ConeGeometry(0.15, 0.4, 8);
      const flameMat = new THREE.MeshBasicMaterial({
        color: 0xff4400,
        transparent: true,
        opacity: 0.8
      });
      const flame = new THREE.Mesh(flameGeo, flameMat);
      flame.position.set(i === 0 ? -0.5 : 0.5, 0.5, -1.55);
      flame.rotation.x = -Math.PI / 2;
      zombieGroup.add(flame);
    }

    return zombieGroup;
  }

  private createFrostGrapeGunZombieMesh(): THREE.Group {
    // BOSS: Frost Grape Gun Zombie - Massive icy zombie with 5 frozen grape cannons!
    const zombieGroup = new THREE.Group();
    const scale = 1.8; // BOSS - even bigger than grape-gun!

    // Icy blue colors
    const skinColor = 0x88bbdd; // Pale blue-icy skin
    const skinColorDark = 0x6699bb;
    const clothesColor = 0x224477; // Dark ice blue armor
    const clothesColorAlt = 0x1a3355;
    const eyeColor = 0x00ffff; // Glowing cyan eyes
    const iceColor = 0x88ddff;
    const frostColor = 0x66ccff;

    // Torso (icy armor)
    const torsoGeo = new THREE.CylinderGeometry(0.38 * scale, 0.32 * scale, 1.0 * scale, 12);
    const torsoMat = new THREE.MeshPhongMaterial({
      color: clothesColor,
      shininess: 80,
      emissive: 0x112244,
      emissiveIntensity: 0.3
    });
    const torso = new THREE.Mesh(torsoGeo, torsoMat);
    torso.position.y = 0.7 * scale;
    zombieGroup.add(torso);

    // Ice armor plating
    const armorGeo = new THREE.CylinderGeometry(0.42 * scale, 0.38 * scale, 0.55 * scale, 12);
    const armorMat = new THREE.MeshPhongMaterial({
      color: iceColor,
      shininess: 150,
      emissive: frostColor,
      emissiveIntensity: 0.4,
      transparent: true,
      opacity: 0.85
    });
    const armor = new THREE.Mesh(armorGeo, armorMat);
    armor.position.y = 0.8 * scale;
    zombieGroup.add(armor);

    // Frost collar
    const collarGeo = new THREE.CylinderGeometry(0.42 * scale, 0.4 * scale, 0.2 * scale, 12);
    const collarMat = new THREE.MeshPhongMaterial({
      color: clothesColorAlt,
      shininess: 60,
      emissive: 0x223355,
      emissiveIntensity: 0.2
    });
    const collar = new THREE.Mesh(collarGeo, collarMat);
    collar.position.y = 1.18 * scale;
    zombieGroup.add(collar);

    // Hips
    const hipsGeo = new THREE.CylinderGeometry(0.35 * scale, 0.3 * scale, 0.25 * scale, 12);
    const hipsMat = new THREE.MeshPhongMaterial({ color: 0x2a3a4a, shininess: 50 });
    const hips = new THREE.Mesh(hipsGeo, hipsMat);
    hips.position.y = 0.18 * scale;
    zombieGroup.add(hips);

    // Neck
    const neckGeo = new THREE.CylinderGeometry(0.16 * scale, 0.18 * scale, 0.22 * scale, 10);
    const neckMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 30 });
    const neck = new THREE.Mesh(neckGeo, neckMat);
    neck.position.y = 1.32 * scale;
    zombieGroup.add(neck);

    // Head
    const headGeo = new THREE.SphereGeometry(0.34 * scale, 16, 14);
    const headMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 35 });
    const head = new THREE.Mesh(headGeo, headMat);
    head.scale.set(1, 1.15, 1);
    head.position.y = 1.65 * scale;
    zombieGroup.add(head);

    // Ice crown/helmet
    const crownGeo = new THREE.ConeGeometry(0.4 * scale, 0.5 * scale, 8);
    const crownMat = new THREE.MeshPhongMaterial({
      color: iceColor,
      shininess: 200,
      emissive: frostColor,
      emissiveIntensity: 0.6,
      transparent: true,
      opacity: 0.8
    });
    const crown = new THREE.Mesh(crownGeo, crownMat);
    crown.position.y = 2.0 * scale;
    zombieGroup.add(crown);

    // Ice crystals on crown
    for (let i = 0; i < 6; i++) {
      const crystalGeo = new THREE.OctahedronGeometry(0.12 * scale, 0);
      const crystalMat = new THREE.MeshPhongMaterial({
        color: 0xaaeeff,
        shininess: 200,
        emissive: 0x66ddff,
        emissiveIntensity: 0.7,
        transparent: true,
        opacity: 0.9
      });
      const crystal = new THREE.Mesh(crystalGeo, crystalMat);
      const angle = (i / 6) * Math.PI * 2;
      crystal.position.set(
        Math.cos(angle) * 0.3 * scale,
        1.85 * scale,
        Math.sin(angle) * 0.3 * scale
      );
      crystal.rotation.y = angle;
      zombieGroup.add(crystal);
    }

    // Ears
    const earGeo = new THREE.SphereGeometry(0.08 * scale, 8, 8);
    const earMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 20 });
    const leftEar = new THREE.Mesh(earGeo, earMat);
    leftEar.position.set(-0.34 * scale, 1.62 * scale, 0);
    leftEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(leftEar);
    const rightEar = new THREE.Mesh(earGeo, earMat);
    rightEar.position.set(0.34 * scale, 1.62 * scale, 0);
    rightEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(rightEar);

    // Glowing cyan eyes
    const eyeGeo = new THREE.SphereGeometry(0.08 * scale, 12, 12);
    const eyeMat = new THREE.MeshPhongMaterial({
      color: eyeColor,
      emissive: eyeColor,
      emissiveIntensity: 2.0,
      shininess: 150
    });
    const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
    leftEye.position.set(-0.14 * scale, 1.68 * scale, 0.28 * scale);
    zombieGroup.add(leftEye);
    const rightEye = new THREE.Mesh(eyeGeo, eyeMat.clone());
    rightEye.position.set(0.14 * scale, 1.68 * scale, 0.28 * scale);
    zombieGroup.add(rightEye);

    // Frozen mouth
    const mouthGeo = new THREE.BoxGeometry(0.2 * scale, 0.06 * scale, 0.05 * scale);
    const mouthMat = new THREE.MeshPhongMaterial({ color: 0x1a2030 });
    const mouth = new THREE.Mesh(mouthGeo, mouthMat);
    mouth.position.set(0, 1.48 * scale, 0.28 * scale);
    zombieGroup.add(mouth);

    // Shoulders (icy armor)
    const shoulderGeo = new THREE.SphereGeometry(0.22 * scale, 10, 10);
    const shoulderMat = new THREE.MeshPhongMaterial({
      color: iceColor,
      shininess: 100,
      emissive: frostColor,
      emissiveIntensity: 0.3
    });
    const leftShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    leftShoulder.position.set(-0.48 * scale, 1.12 * scale, 0);
    zombieGroup.add(leftShoulder);
    const rightShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    rightShoulder.position.set(0.48 * scale, 1.12 * scale, 0);
    zombieGroup.add(rightShoulder);

    // Arm groups
    const leftArmGroup = new THREE.Group();
    leftArmGroup.position.set(-0.48 * scale, 1.12 * scale, 0);
    zombieGroup.add(leftArmGroup);
    const rightArmGroup = new THREE.Group();
    rightArmGroup.position.set(0.48 * scale, 1.12 * scale, 0);
    zombieGroup.add(rightArmGroup);

    // Upper arms
    const upperArmGeo = new THREE.CylinderGeometry(0.14 * scale, 0.12 * scale, 0.55 * scale, 10);
    const upperArmMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 50 });
    const leftUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    leftUpperArm.position.set(-0.1 * scale, -0.3 * scale, 0);
    leftUpperArm.rotation.z = 0.4;
    leftArmGroup.add(leftUpperArm);
    const rightUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    rightUpperArm.position.set(0.1 * scale, -0.3 * scale, 0);
    rightUpperArm.rotation.z = -0.4;
    rightArmGroup.add(rightUpperArm);

    // Forearms
    const forearmGeo = new THREE.CylinderGeometry(0.11 * scale, 0.09 * scale, 0.5 * scale, 10);
    const forearmMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 25 });
    const leftForearm = new THREE.Mesh(forearmGeo, forearmMat);
    leftForearm.position.set(-0.2 * scale, -0.7 * scale, 0.2 * scale);
    leftForearm.rotation.set(0.6, 0, 0.3);
    leftArmGroup.add(leftForearm);
    const rightForearm = new THREE.Mesh(forearmGeo, forearmMat);
    rightForearm.position.set(0.2 * scale, -0.7 * scale, 0.2 * scale);
    rightForearm.rotation.set(0.6, 0, -0.3);
    rightArmGroup.add(rightForearm);

    // Hands
    const handGeo = new THREE.BoxGeometry(0.14 * scale, 0.18 * scale, 0.08 * scale);
    const handMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 20 });
    const leftHand = new THREE.Mesh(handGeo, handMat);
    leftHand.position.set(-0.2 * scale, -0.95 * scale, 0.45 * scale);
    leftHand.rotation.x = 0.3;
    leftArmGroup.add(leftHand);
    const rightHand = new THREE.Mesh(handGeo, handMat);
    rightHand.position.set(0.2 * scale, -0.95 * scale, 0.45 * scale);
    rightHand.rotation.x = 0.3;
    rightArmGroup.add(rightHand);

    // Store arm references
    zombieGroup.userData.leftArm = leftArmGroup;
    zombieGroup.userData.rightArm = rightArmGroup;

    // Legs
    const thighGeo = new THREE.CylinderGeometry(0.16 * scale, 0.14 * scale, 0.55 * scale, 10);
    const thighMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 50 });
    const leftThigh = new THREE.Mesh(thighGeo, thighMat);
    leftThigh.position.set(-0.2 * scale, -0.2 * scale, 0);
    zombieGroup.add(leftThigh);
    const rightThigh = new THREE.Mesh(thighGeo, thighMat);
    rightThigh.position.set(0.2 * scale, -0.2 * scale, 0);
    zombieGroup.add(rightThigh);

    const shinGeo = new THREE.CylinderGeometry(0.13 * scale, 0.11 * scale, 0.55 * scale, 10);
    const shinMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 50 });
    const leftShin = new THREE.Mesh(shinGeo, shinMat);
    leftShin.position.set(-0.2 * scale, -0.65 * scale, 0);
    zombieGroup.add(leftShin);
    const rightShin = new THREE.Mesh(shinGeo, shinMat);
    rightShin.position.set(0.2 * scale, -0.65 * scale, 0);
    zombieGroup.add(rightShin);

    // Icy boots
    const footGeo = new THREE.BoxGeometry(0.16 * scale, 0.12 * scale, 0.28 * scale);
    const footMat = new THREE.MeshPhongMaterial({
      color: iceColor,
      shininess: 100,
      emissive: frostColor,
      emissiveIntensity: 0.2
    });
    const leftFoot = new THREE.Mesh(footGeo, footMat);
    leftFoot.position.set(-0.2 * scale, -0.95 * scale, 0.06 * scale);
    zombieGroup.add(leftFoot);
    const rightFoot = new THREE.Mesh(footGeo, footMat);
    rightFoot.position.set(0.2 * scale, -0.95 * scale, 0.06 * scale);
    zombieGroup.add(rightFoot);

    // === UNIQUE FEATURE: QUINTUPLE FROST GRAPE GUN ===
    // Massive frozen gun body
    const gunBodyGeo = new THREE.BoxGeometry(0.5, 0.5, 1.4);
    const gunMat = new THREE.MeshPhongMaterial({
      color: 0x2244aa,
      shininess: 120,
      emissive: 0x112255,
      emissiveIntensity: 0.3
    });
    const gunBody = new THREE.Mesh(gunBodyGeo, gunMat);
    gunBody.position.set(0.8, 1.1 * scale, 0.8);
    zombieGroup.add(gunBody);

    // Ice coating on gun
    const iceCoatGeo = new THREE.BoxGeometry(0.56, 0.56, 1.5);
    const iceCoatMat = new THREE.MeshPhongMaterial({
      color: iceColor,
      shininess: 180,
      transparent: true,
      opacity: 0.4,
      emissive: frostColor,
      emissiveIntensity: 0.5
    });
    const iceCoat = new THREE.Mesh(iceCoatGeo, iceCoatMat);
    iceCoat.position.set(0.8, 1.1 * scale, 0.8);
    zombieGroup.add(iceCoat);

    // FIVE frozen barrels
    const barrelGeo = new THREE.CylinderGeometry(0.08, 0.08, 0.9, 12);
    const barrelMat = new THREE.MeshPhongMaterial({
      color: 0x1a3355,
      shininess: 120,
      emissive: 0x112244,
      emissiveIntensity: 0.2
    });

    const barrelPositions = [
      { x: 0.6, y: 1.2 * scale },   // Top left
      { x: 0.8, y: 1.25 * scale },  // Top center
      { x: 1.0, y: 1.2 * scale },   // Top right
      { x: 0.68, y: 0.95 * scale }, // Bottom left
      { x: 0.92, y: 0.95 * scale }  // Bottom right
    ];

    for (const pos of barrelPositions) {
      const barrel = new THREE.Mesh(barrelGeo, barrelMat.clone());
      barrel.position.set(pos.x, pos.y, 1.5);
      barrel.rotation.x = Math.PI / 2;
      zombieGroup.add(barrel);

      // Frost glow at barrel tips
      const glowGeo = new THREE.SphereGeometry(0.1, 10, 10);
      const glowMat = new THREE.MeshBasicMaterial({
        color: frostColor,
        transparent: true,
        opacity: 0.6
      });
      const glow = new THREE.Mesh(glowGeo, glowMat);
      glow.position.set(pos.x, pos.y, 1.95);
      zombieGroup.add(glow);
    }

    // Frozen grape ammo drum
    const drumGeo = new THREE.CylinderGeometry(0.4, 0.4, 0.35, 16);
    const drumMat = new THREE.MeshPhongMaterial({
      color: 0x4488cc,
      emissive: frostColor,
      emissiveIntensity: 0.5,
      shininess: 80,
      transparent: true,
      opacity: 0.85
    });
    const drum = new THREE.Mesh(drumGeo, drumMat);
    drum.position.set(0.8, 1.1 * scale, 0.15);
    drum.rotation.x = Math.PI / 2;
    zombieGroup.add(drum);

    // Frozen grapes visible in drum
    for (let i = 0; i < 5; i++) {
      const grapeGeo = new THREE.SphereGeometry(0.1, 8, 8);
      const grapeMat = new THREE.MeshPhongMaterial({
        color: 0x6688cc,
        emissive: 0x4466aa,
        emissiveIntensity: 0.4,
        shininess: 100
      });
      const grape = new THREE.Mesh(grapeGeo, grapeMat);
      const angle = (i / 5) * Math.PI * 2;
      grape.position.set(
        0.8 + Math.cos(angle) * 0.2,
        1.1 * scale,
        0.15 + Math.sin(angle) * 0.1
      );
      zombieGroup.add(grape);
    }

    // BOSS aura - icy mist
    const auraGeo = new THREE.SphereGeometry(2.2, 20, 20);
    const auraMat = new THREE.MeshBasicMaterial({
      color: frostColor,
      transparent: true,
      opacity: 0.15
    });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    aura.position.y = 1.2 * scale;
    aura.userData.isAura = true;
    zombieGroup.add(aura);

    // Floating ice particles around boss
    for (let i = 0; i < 10; i++) {
      const particleGeo = new THREE.OctahedronGeometry(0.08, 0);
      const particleMat = new THREE.MeshBasicMaterial({
        color: 0xccffff,
        transparent: true,
        opacity: 0.7
      });
      const particle = new THREE.Mesh(particleGeo, particleMat);
      const angle = (i / 10) * Math.PI * 2;
      particle.position.set(
        Math.cos(angle) * 1.5,
        1.0 * scale + (i % 3) * 0.4,
        Math.sin(angle) * 1.5
      );
      particle.userData.isIceParticle = true;
      particle.userData.particleIndex = i;
      zombieGroup.add(particle);
    }

    // Slouched threatening posture
    torso.rotation.x = 0.08;
    head.rotation.x = 0.1;

    return zombieGroup;
  }

  private createFireZombieMesh(): THREE.Group {
    const zombieGroup = new THREE.Group();
    const scale = 1.1; // Slightly larger for presence

    // Fire demon colors - charred black with glowing cracks
    const charredSkin = 0x1a0a05; // Charred black-brown
    const lavaCracks = 0xff4400; // Glowing orange lava
    const clothesColor = 0x0a0505; // Burnt clothes
    const eyeColor = 0xffff00; // Intense yellow fire eyes

    // Charred torso with lava cracks
    const torsoGeo = new THREE.CylinderGeometry(0.35 * scale, 0.30 * scale, 0.95 * scale, 12);
    const torsoMat = new THREE.MeshPhongMaterial({
      color: charredSkin,
      shininess: 5,
      emissive: 0x331100,
      emissiveIntensity: 0.4
    });
    const torso = new THREE.Mesh(torsoGeo, torsoMat);
    torso.position.y = 0.7 * scale;
    zombieGroup.add(torso);

    // Glowing lava crack lines on torso
    for (let i = 0; i < 5; i++) {
      const crackGeo = new THREE.BoxGeometry(0.02, 0.4 + Math.random() * 0.3, 0.02);
      const crackMat = new THREE.MeshBasicMaterial({ color: lavaCracks });
      const crack = new THREE.Mesh(crackGeo, crackMat);
      crack.position.set(
        (Math.random() - 0.5) * 0.3 * scale,
        0.5 + Math.random() * 0.4,
        0.3 * scale
      );
      crack.rotation.z = (Math.random() - 0.5) * 0.5;
      zombieGroup.add(crack);
    }

    // Neck with ember glow
    const neckGeo = new THREE.CylinderGeometry(0.12 * scale, 0.15 * scale, 0.22 * scale, 10);
    const neckMat = new THREE.MeshPhongMaterial({
      color: charredSkin,
      shininess: 10,
      emissive: 0x440000,
      emissiveIntensity: 0.3
    });
    const neck = new THREE.Mesh(neckGeo, neckMat);
    neck.position.y = 1.28 * scale;
    zombieGroup.add(neck);

    // Demonic head
    const headGeo = new THREE.SphereGeometry(0.3 * scale, 16, 14);
    const headMat = new THREE.MeshPhongMaterial({
      color: charredSkin,
      shininess: 15,
      emissive: 0x551100,
      emissiveIntensity: 0.3
    });
    const head = new THREE.Mesh(headGeo, headMat);
    head.scale.set(1, 1.2, 1);
    head.position.y = 1.6 * scale;
    zombieGroup.add(head);

    // Demonic horns
    const hornGeo = new THREE.ConeGeometry(0.06 * scale, 0.35 * scale, 8);
    const hornMat = new THREE.MeshPhongMaterial({
      color: 0x1a0a00,
      emissive: 0x330000,
      emissiveIntensity: 0.2
    });
    const leftHorn = new THREE.Mesh(hornGeo, hornMat);
    leftHorn.position.set(-0.18 * scale, 1.85 * scale, 0);
    leftHorn.rotation.z = 0.4;
    zombieGroup.add(leftHorn);
    const rightHorn = new THREE.Mesh(hornGeo, hornMat);
    rightHorn.position.set(0.18 * scale, 1.85 * scale, 0);
    rightHorn.rotation.z = -0.4;
    zombieGroup.add(rightHorn);

    // Massive flame crown - layered flames
    const flameColors = [0xff6600, 0xff4400, 0xffaa00, 0xff2200];
    for (let layer = 0; layer < 3; layer++) {
      for (let i = 0; i < 10; i++) {
        const height = 0.25 + layer * 0.15 + Math.random() * 0.15;
        const flameGeo = new THREE.ConeGeometry(0.06 - layer * 0.015, height, 6);
        const flameMat = new THREE.MeshPhongMaterial({
          color: flameColors[i % 4],
          emissive: flameColors[i % 4],
          emissiveIntensity: 0.8 - layer * 0.2,
          transparent: true,
          opacity: 0.95 - layer * 0.1
        });
        const flame = new THREE.Mesh(flameGeo, flameMat);
        const angle = (i / 10) * Math.PI * 2 + layer * 0.3;
        const radius = 0.18 - layer * 0.04;
        flame.position.set(
          Math.cos(angle) * radius * scale,
          (1.85 + layer * 0.1) * scale,
          Math.sin(angle) * radius * scale
        );
        flame.rotation.z = (Math.random() - 0.5) * 0.4;
        flame.rotation.x = (Math.random() - 0.5) * 0.2;
        zombieGroup.add(flame);
      }
    }

    // Intense glowing eyes - larger and more menacing
    const eyeGeo = new THREE.SphereGeometry(0.07 * scale, 12, 12);
    const eyeMat = new THREE.MeshPhongMaterial({
      color: eyeColor,
      emissive: 0xffff00,
      emissiveIntensity: 1.5,
      shininess: 100
    });
    const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
    leftEye.position.set(-0.11 * scale, 1.63 * scale, 0.26 * scale);
    zombieGroup.add(leftEye);
    const rightEye = new THREE.Mesh(eyeGeo, eyeMat.clone());
    rightEye.position.set(0.11 * scale, 1.63 * scale, 0.26 * scale);
    zombieGroup.add(rightEye);

    // Glowing mouth like furnace
    const mouthGeo = new THREE.BoxGeometry(0.15 * scale, 0.06 * scale, 0.05 * scale);
    const mouthMat = new THREE.MeshBasicMaterial({ color: 0xff3300 });
    const mouth = new THREE.Mesh(mouthGeo, mouthMat);
    mouth.position.set(0, 1.48 * scale, 0.27 * scale);
    zombieGroup.add(mouth);

    // Arm groups with shoulder pads
    const shoulderGeo = new THREE.SphereGeometry(0.14 * scale, 10, 10);
    const shoulderMat = new THREE.MeshPhongMaterial({ color: charredSkin, emissive: 0x220000, emissiveIntensity: 0.3 });

    const leftArmGroup = new THREE.Group();
    leftArmGroup.position.set(-0.4 * scale, 1.08 * scale, 0);
    zombieGroup.add(leftArmGroup);
    const leftShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    leftArmGroup.add(leftShoulder);

    const rightArmGroup = new THREE.Group();
    rightArmGroup.position.set(0.4 * scale, 1.08 * scale, 0);
    zombieGroup.add(rightArmGroup);
    const rightShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    rightArmGroup.add(rightShoulder);

    // Upper arms
    const upperArmGeo = new THREE.CylinderGeometry(0.1 * scale, 0.08 * scale, 0.48 * scale, 10);
    const upperArmMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 8, emissive: 0x110000, emissiveIntensity: 0.2 });
    const leftUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    leftUpperArm.position.set(-0.05 * scale, -0.28 * scale, 0);
    leftUpperArm.rotation.z = 0.3;
    leftArmGroup.add(leftUpperArm);
    const rightUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    rightUpperArm.position.set(0.05 * scale, -0.28 * scale, 0);
    rightUpperArm.rotation.z = -0.3;
    rightArmGroup.add(rightUpperArm);

    // Forearms with ember glow
    const forearmGeo = new THREE.CylinderGeometry(0.08 * scale, 0.06 * scale, 0.42 * scale, 10);
    const forearmMat = new THREE.MeshPhongMaterial({
      color: charredSkin,
      shininess: 15,
      emissive: 0x441100,
      emissiveIntensity: 0.4
    });
    const leftForearm = new THREE.Mesh(forearmGeo, forearmMat);
    leftForearm.position.set(-0.12 * scale, -0.62 * scale, 0.18 * scale);
    leftForearm.rotation.set(0.7, 0, 0.2);
    leftArmGroup.add(leftForearm);
    const rightForearm = new THREE.Mesh(forearmGeo, forearmMat);
    rightForearm.position.set(0.12 * scale, -0.62 * scale, 0.18 * scale);
    rightForearm.rotation.set(0.7, 0, -0.2);
    rightArmGroup.add(rightForearm);

    // Flaming hands
    const handGeo = new THREE.SphereGeometry(0.1 * scale, 10, 10);
    const handMat = new THREE.MeshPhongMaterial({
      color: 0xff4400,
      emissive: 0xff2200,
      emissiveIntensity: 0.8,
      shininess: 50
    });
    const leftHand = new THREE.Mesh(handGeo, handMat);
    leftHand.position.set(-0.15 * scale, -0.85 * scale, 0.32 * scale);
    leftArmGroup.add(leftHand);
    const rightHand = new THREE.Mesh(handGeo, handMat);
    rightHand.position.set(0.15 * scale, -0.85 * scale, 0.32 * scale);
    rightArmGroup.add(rightHand);

    // Flames coming from hands
    for (let hand = 0; hand < 2; hand++) {
      for (let f = 0; f < 4; f++) {
        const handFlameGeo = new THREE.ConeGeometry(0.04, 0.2, 5);
        const handFlameMat = new THREE.MeshBasicMaterial({
          color: f % 2 === 0 ? 0xff6600 : 0xffaa00,
          transparent: true,
          opacity: 0.8
        });
        const handFlame = new THREE.Mesh(handFlameGeo, handFlameMat);
        handFlame.position.set(
          (hand === 0 ? -0.15 : 0.15) * scale + (Math.random() - 0.5) * 0.08,
          -0.75 * scale,
          0.35 * scale + (Math.random() - 0.5) * 0.08
        );
        handFlame.rotation.x = -0.5;
        if (hand === 0) leftArmGroup.add(handFlame);
        else rightArmGroup.add(handFlame);
      }
    }

    // Store arm references
    zombieGroup.userData.leftArm = leftArmGroup;
    zombieGroup.userData.rightArm = rightArmGroup;

    // Legs
    const thighGeo = new THREE.CylinderGeometry(0.13 * scale, 0.1 * scale, 0.48 * scale, 10);
    const thighMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 8 });
    const leftThigh = new THREE.Mesh(thighGeo, thighMat);
    leftThigh.position.set(-0.15 * scale, -0.15 * scale, 0);
    zombieGroup.add(leftThigh);
    const rightThigh = new THREE.Mesh(thighGeo, thighMat);
    rightThigh.position.set(0.15 * scale, -0.15 * scale, 0);
    zombieGroup.add(rightThigh);

    // Feet
    const footGeo = new THREE.BoxGeometry(0.12 * scale, 0.08 * scale, 0.2 * scale);
    const footMat = new THREE.MeshPhongMaterial({ color: 0x2a2a2a, shininess: 25 });
    const leftFoot = new THREE.Mesh(footGeo, footMat);
    leftFoot.position.set(-0.15 * scale, -0.8 * scale, 0.04 * scale);
    zombieGroup.add(leftFoot);
    const rightFoot = new THREE.Mesh(footGeo, footMat);
    rightFoot.position.set(0.15 * scale, -0.8 * scale, 0.04 * scale);
    zombieGroup.add(rightFoot);

    // Fire aura
    const auraGeo = new THREE.SphereGeometry(0.8, 16, 16);
    const auraMat = new THREE.MeshBasicMaterial({
      color: 0xff4400,
      transparent: true,
      opacity: 0.15
    });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    aura.position.y = 0.8;
    zombieGroup.add(aura);

    // Floating fire particles
    for (let i = 0; i < 6; i++) {
      const particleGeo = new THREE.OctahedronGeometry(0.06, 0);
      const particleMat = new THREE.MeshBasicMaterial({
        color: i % 2 === 0 ? 0xff6600 : 0xffaa00,
        transparent: true,
        opacity: 0.7
      });
      const particle = new THREE.Mesh(particleGeo, particleMat);
      const angle = (i / 6) * Math.PI * 2;
      particle.position.set(
        Math.cos(angle) * 0.5,
        0.8 + Math.sin(i) * 0.3,
        Math.sin(angle) * 0.5
      );
      particle.userData.isFireParticle = true;
      particle.userData.particleIndex = i;
      zombieGroup.add(particle);
    }

    // Slouched posture
    torso.rotation.x = 0.12;
    head.rotation.x = 0.15;

    return zombieGroup;
  }

  private createFatZombieMesh(): THREE.Group {
    const zombieGroup = new THREE.Group();
    const scale = 1.4; // Big and intimidating

    // Bloated bomber zombie colors - sickly with explosive veins
    const bloatedSkin = 0x8a9a6a; // Sickly yellow-green
    const veinColor = 0xff4400; // Glowing explosive veins
    const skinDark = 0x6a7a4a;
    const clothesColor = 0x3a3a2a; // Tattered brown
    const eyeColor = 0xff0000; // Red warning eyes

    // Massive bloated torso - like a bomb ready to explode
    const torsoGeo = new THREE.SphereGeometry(0.7 * scale, 20, 20);
    const torsoMat = new THREE.MeshPhongMaterial({
      color: bloatedSkin,
      shininess: 30, // Stretched skin sheen
      emissive: 0x220000,
      emissiveIntensity: 0.15
    });
    const torso = new THREE.Mesh(torsoGeo, torsoMat);
    torso.scale.set(1.1, 0.85, 1.05);
    torso.position.y = 0.65 * scale;
    zombieGroup.add(torso);

    // Glowing veins on torso - showing internal explosive buildup
    for (let i = 0; i < 8; i++) {
      const veinGeo = new THREE.TubeGeometry(
        new THREE.CatmullRomCurve3([
          new THREE.Vector3((Math.random() - 0.5) * 0.4, 0.3 + Math.random() * 0.5, 0.55),
          new THREE.Vector3((Math.random() - 0.5) * 0.5, 0.5 + Math.random() * 0.3, 0.6),
          new THREE.Vector3((Math.random() - 0.5) * 0.4, 0.7 + Math.random() * 0.3, 0.5)
        ].map(v => v.multiplyScalar(scale))),
        8, 0.02 * scale, 6, false
      );
      const veinMat = new THREE.MeshBasicMaterial({
        color: veinColor,
        transparent: true,
        opacity: 0.7 + Math.random() * 0.3
      });
      const vein = new THREE.Mesh(veinGeo, veinMat);
      vein.rotation.y = (i / 8) * Math.PI * 2;
      zombieGroup.add(vein);
    }

    // Massive distended belly - the bomb chamber
    const bellyGeo = new THREE.SphereGeometry(0.6 * scale, 16, 16);
    const bellyMat = new THREE.MeshPhongMaterial({
      color: 0x7a8a5a,
      shininess: 40,
      emissive: 0x331100,
      emissiveIntensity: 0.2
    });
    const belly = new THREE.Mesh(bellyGeo, bellyMat);
    belly.scale.set(1.0, 0.9, 1.1);
    belly.position.set(0, 0.35 * scale, 0.25 * scale);
    zombieGroup.add(belly);

    // Belly glow - internal combustion ready
    const bellyGlowGeo = new THREE.SphereGeometry(0.45 * scale, 12, 12);
    const bellyGlowMat = new THREE.MeshBasicMaterial({
      color: 0xff4400,
      transparent: true,
      opacity: 0.25
    });
    const bellyGlow = new THREE.Mesh(bellyGlowGeo, bellyGlowMat);
    bellyGlow.position.set(0, 0.4 * scale, 0.2 * scale);
    zombieGroup.add(bellyGlow);

    // Short thick neck
    const neckGeo = new THREE.CylinderGeometry(0.22 * scale, 0.28 * scale, 0.12 * scale, 10);
    const neckMat = new THREE.MeshPhongMaterial({ color: bloatedSkin, shininess: 15 });
    const neck = new THREE.Mesh(neckGeo, neckMat);
    neck.position.y = 1.15 * scale;
    zombieGroup.add(neck);

    // Bloated head
    const headGeo = new THREE.SphereGeometry(0.35 * scale, 16, 14);
    const headMat = new THREE.MeshPhongMaterial({ color: bloatedSkin, shininess: 20 });
    const head = new THREE.Mesh(headGeo, headMat);
    head.scale.set(1.15, 1, 1.1);
    head.position.y = 1.45 * scale;
    zombieGroup.add(head);

    // Puffy cheeks - about to burst
    const cheekGeo = new THREE.SphereGeometry(0.14 * scale, 10, 10);
    const cheekMat = new THREE.MeshPhongMaterial({ color: skinDark, shininess: 20 });
    const leftCheek = new THREE.Mesh(cheekGeo, cheekMat);
    leftCheek.position.set(-0.22 * scale, 1.38 * scale, 0.18 * scale);
    zombieGroup.add(leftCheek);
    const rightCheek = new THREE.Mesh(cheekGeo, cheekMat);
    rightCheek.position.set(0.22 * scale, 1.38 * scale, 0.18 * scale);
    zombieGroup.add(rightCheek);

    // Intense glowing red eyes - warning of imminent explosion
    const eyeGeo = new THREE.SphereGeometry(0.08 * scale, 12, 12);
    const eyeMat = new THREE.MeshPhongMaterial({
      color: eyeColor,
      emissive: eyeColor,
      emissiveIntensity: 1.2,
      shininess: 100
    });
    const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
    leftEye.position.set(-0.14 * scale, 1.5 * scale, 0.3 * scale);
    zombieGroup.add(leftEye);
    const rightEye = new THREE.Mesh(eyeGeo, eyeMat.clone());
    rightEye.position.set(0.14 * scale, 1.5 * scale, 0.3 * scale);
    zombieGroup.add(rightEye);

    // Wide open mouth - screaming/about to explode
    const mouthGeo = new THREE.SphereGeometry(0.12 * scale, 12, 8, 0, Math.PI * 2, 0, Math.PI * 0.5);
    const mouthMat = new THREE.MeshPhongMaterial({ color: 0x1a0505, side: THREE.DoubleSide });
    const mouth = new THREE.Mesh(mouthGeo, mouthMat);
    mouth.position.set(0, 1.28 * scale, 0.32 * scale);
    mouth.rotation.x = Math.PI;
    zombieGroup.add(mouth);

    // Glowing mouth interior
    const mouthGlowGeo = new THREE.SphereGeometry(0.08 * scale, 8, 8);
    const mouthGlowMat = new THREE.MeshBasicMaterial({ color: 0xff4400 });
    const mouthGlow = new THREE.Mesh(mouthGlowGeo, mouthGlowMat);
    mouthGlow.position.set(0, 1.3 * scale, 0.28 * scale);
    zombieGroup.add(mouthGlow);

    // Short stubby arms sticking out
    const leftArmGroup = new THREE.Group();
    leftArmGroup.position.set(-0.65 * scale, 0.75 * scale, 0);
    zombieGroup.add(leftArmGroup);

    const rightArmGroup = new THREE.Group();
    rightArmGroup.position.set(0.65 * scale, 0.75 * scale, 0);
    zombieGroup.add(rightArmGroup);

    // Shoulder joints
    const shoulderGeo = new THREE.SphereGeometry(0.12 * scale, 10, 10);
    const shoulderMat = new THREE.MeshPhongMaterial({ color: bloatedSkin });
    const leftShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    leftArmGroup.add(leftShoulder);
    const rightShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    rightArmGroup.add(rightShoulder);

    // Fat stubby arms
    const armGeo = new THREE.CylinderGeometry(0.12 * scale, 0.1 * scale, 0.35 * scale, 10);
    const armMat = new THREE.MeshPhongMaterial({ color: bloatedSkin, shininess: 15 });
    const leftArm = new THREE.Mesh(armGeo, armMat);
    leftArm.position.set(-0.08 * scale, -0.2 * scale, 0.12 * scale);
    leftArm.rotation.set(0.4, 0, 0.5);
    leftArmGroup.add(leftArm);
    const rightArm = new THREE.Mesh(armGeo, armMat);
    rightArm.position.set(0.08 * scale, -0.2 * scale, 0.12 * scale);
    rightArm.rotation.set(0.4, 0, -0.5);
    rightArmGroup.add(rightArm);

    // Bloated hands
    const handGeo = new THREE.SphereGeometry(0.08 * scale, 10, 10);
    const handMat = new THREE.MeshPhongMaterial({ color: skinDark });
    const leftHand = new THREE.Mesh(handGeo, handMat);
    leftHand.position.set(-0.12 * scale, -0.42 * scale, 0.2 * scale);
    leftArmGroup.add(leftHand);
    const rightHand = new THREE.Mesh(handGeo, handMat);
    rightHand.position.set(0.12 * scale, -0.42 * scale, 0.2 * scale);
    rightArmGroup.add(rightHand);

    // Store arm references
    zombieGroup.userData.leftArm = leftArmGroup;
    zombieGroup.userData.rightArm = rightArmGroup;

    // Short thick legs
    const legGeo = new THREE.CylinderGeometry(0.16 * scale, 0.14 * scale, 0.38 * scale, 10);
    const legMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 8 });
    const leftLeg = new THREE.Mesh(legGeo, legMat);
    leftLeg.position.set(-0.22 * scale, -0.22 * scale, 0);
    zombieGroup.add(leftLeg);
    const rightLeg = new THREE.Mesh(legGeo, legMat);
    rightLeg.position.set(0.22 * scale, -0.22 * scale, 0);
    zombieGroup.add(rightLeg);

    // Big flat feet
    const footGeo = new THREE.BoxGeometry(0.18 * scale, 0.1 * scale, 0.28 * scale);
    const footMat = new THREE.MeshPhongMaterial({ color: 0x2a2a1a, shininess: 15 });
    const leftFoot = new THREE.Mesh(footGeo, footMat);
    leftFoot.position.set(-0.22 * scale, -0.48 * scale, 0.06 * scale);
    zombieGroup.add(leftFoot);
    const rightFoot = new THREE.Mesh(footGeo, footMat);
    rightFoot.position.set(0.22 * scale, -0.48 * scale, 0.06 * scale);
    zombieGroup.add(rightFoot);

    // Warning explosion aura - pulsing danger zone
    const warningGeo = new THREE.SphereGeometry(1.0 * scale, 20, 20);
    const warningMat = new THREE.MeshBasicMaterial({
      color: 0xff3300,
      transparent: true,
      opacity: 0.12
    });
    const warning = new THREE.Mesh(warningGeo, warningMat);
    warning.position.y = 0.5 * scale;
    warning.userData.isWarningAura = true;
    zombieGroup.add(warning);

    // Danger particles floating around
    for (let i = 0; i < 6; i++) {
      const particleGeo = new THREE.OctahedronGeometry(0.06 * scale, 0);
      const particleMat = new THREE.MeshBasicMaterial({
        color: i % 2 === 0 ? 0xff4400 : 0xffaa00,
        transparent: true,
        opacity: 0.8
      });
      const particle = new THREE.Mesh(particleGeo, particleMat);
      const angle = (i / 6) * Math.PI * 2;
      particle.position.set(
        Math.cos(angle) * 0.6 * scale,
        0.6 * scale + Math.sin(i * 1.5) * 0.3,
        Math.sin(angle) * 0.6 * scale
      );
      particle.userData.isDangerParticle = true;
      zombieGroup.add(particle);
    }

    // Menacing forward lean
    torso.rotation.x = 0.15;
    head.rotation.x = 0.12;

    return zombieGroup;
  }

  private createBlueDragonMesh(): THREE.Group {
    const group = new THREE.Group();
    const s = 1.5;
    const bodyColor = 0x2244aa;
    const wingColor = 0x4488ff;
    const bellyColor = 0x6699cc;
    const bodyMat = new THREE.MeshPhongMaterial({ color: bodyColor, shininess: 60, specular: 0x4466aa });
    const bellyMat = new THREE.MeshPhongMaterial({ color: bellyColor, shininess: 40 });

    // Chest (front body)
    const chestGeo = new THREE.CylinderGeometry(0.42 * s, 0.4 * s, 0.8 * s, 12);
    const chest = new THREE.Mesh(chestGeo, bodyMat);
    chest.rotation.z = Math.PI / 2;
    chest.position.set(0.2 * s, 0.85 * s, 0);
    group.add(chest);

    // Abdomen (rear body)
    const abdGeo = new THREE.CylinderGeometry(0.4 * s, 0.32 * s, 0.9 * s, 12);
    const abd = new THREE.Mesh(abdGeo, bodyMat);
    abd.rotation.z = Math.PI / 2;
    abd.position.set(-0.6 * s, 0.8 * s, 0);
    group.add(abd);

    // Belly (underside)
    const bellyGeo = new THREE.CylinderGeometry(0.35 * s, 0.28 * s, 1.4 * s, 12);
    const belly = new THREE.Mesh(bellyGeo, bellyMat);
    belly.rotation.z = Math.PI / 2;
    belly.position.set(-0.1 * s, 0.7 * s, 0);
    group.add(belly);

    // Neck
    const neckGeo = new THREE.CylinderGeometry(0.22 * s, 0.32 * s, 0.6 * s, 10);
    const neck = new THREE.Mesh(neckGeo, bodyMat);
    neck.rotation.z = Math.PI / 2 + 0.4;
    neck.position.set(0.75 * s, 1.05 * s, 0);
    group.add(neck);

    // Head
    const headGeo = new THREE.SphereGeometry(0.28 * s, 12, 12);
    const head = new THREE.Mesh(headGeo, bodyMat);
    head.scale.set(1.3, 1, 1);
    head.position.set(1.1 * s, 1.25 * s, 0);
    group.add(head);

    // Upper jaw/snout
    const snoutGeo = new THREE.ConeGeometry(0.14 * s, 0.45 * s, 8);
    const snout = new THREE.Mesh(snoutGeo, bodyMat);
    snout.rotation.z = -Math.PI / 2;
    snout.position.set(1.45 * s, 1.25 * s, 0);
    group.add(snout);

    // Lower jaw
    const jawGeo = new THREE.ConeGeometry(0.1 * s, 0.35 * s, 6);
    const jaw = new THREE.Mesh(jawGeo, bodyMat);
    jaw.rotation.z = -Math.PI / 2 + 0.15;
    jaw.position.set(1.35 * s, 1.15 * s, 0);
    group.add(jaw);

    // Nostrils
    const nostrilMat = new THREE.MeshBasicMaterial({ color: 0x111133 });
    for (const zSign of [-1, 1]) {
      const nostril = new THREE.Mesh(new THREE.SphereGeometry(0.03 * s, 6, 6), nostrilMat);
      nostril.position.set(1.62 * s, 1.28 * s, zSign * 0.06 * s);
      group.add(nostril);
    }

    // Eyes with pupils
    const eyeWhiteGeo = new THREE.SphereGeometry(0.07 * s, 8, 8);
    const eyeWhiteMat = new THREE.MeshBasicMaterial({ color: 0xffff44 });
    const pupilGeo = new THREE.SphereGeometry(0.035 * s, 6, 6);
    const pupilMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
    for (const zSign of [-1, 1]) {
      const eye = new THREE.Mesh(eyeWhiteGeo, eyeWhiteMat);
      eye.position.set(1.2 * s, 1.38 * s, zSign * 0.18 * s);
      group.add(eye);
      const pupil = new THREE.Mesh(pupilGeo, pupilMat);
      pupil.position.set(1.25 * s, 1.39 * s, zSign * 0.2 * s);
      group.add(pupil);
    }

    // Brow ridges
    const browMat = new THREE.MeshPhongMaterial({ color: 0x1a1a55, shininess: 80 });
    for (const zSign of [-1, 1]) {
      const brow = new THREE.Mesh(new THREE.BoxGeometry(0.15 * s, 0.04 * s, 0.08 * s), browMat);
      brow.position.set(1.18 * s, 1.44 * s, zSign * 0.15 * s);
      brow.rotation.z = 0.2 * zSign;
      group.add(brow);
    }

    // Horns (swept back)
    const hornMat = new THREE.MeshPhongMaterial({ color: 0x1a1a55, shininess: 120, specular: 0x6666aa });
    for (const zSign of [-1, 1]) {
      const horn = new THREE.Mesh(new THREE.ConeGeometry(0.06 * s, 0.35 * s, 6), hornMat);
      horn.position.set(1.0 * s, 1.5 * s, zSign * 0.15 * s);
      horn.rotation.z = 0.6;
      horn.rotation.x = zSign * 0.3;
      group.add(horn);
    }

    // Cheek/ear fins
    const finMat = new THREE.MeshPhongMaterial({ color: wingColor, shininess: 60, transparent: true, opacity: 0.7 });
    for (const zSign of [-1, 1]) {
      const finShape = new THREE.Shape();
      finShape.moveTo(0, 0);
      finShape.lineTo(0.2 * s, 0.12 * s);
      finShape.lineTo(0.15 * s, -0.1 * s);
      finShape.lineTo(0, 0);
      const fin = new THREE.Mesh(new THREE.ShapeGeometry(finShape), finMat);
      fin.position.set(1.0 * s, 1.3 * s, zSign * 0.22 * s);
      fin.rotation.y = zSign * Math.PI / 2;
      group.add(fin);
    }

    // Spine ridges along back
    const ridgeMat = new THREE.MeshPhongMaterial({ color: 0x3355bb, shininess: 80 });
    for (let i = 0; i < 8; i++) {
      const ridgeSize = 0.06 + Math.sin(i / 7 * Math.PI) * 0.06;
      const ridge = new THREE.Mesh(new THREE.ConeGeometry(ridgeSize * s, ridgeSize * 2.5 * s, 4), ridgeMat);
      ridge.position.set((0.7 - i * 0.22) * s, 1.1 * s, 0);
      group.add(ridge);
    }

    // Wings - shaped with bone structure
    const wingMat = new THREE.MeshPhongMaterial({ color: wingColor, side: THREE.DoubleSide, transparent: true, opacity: 0.6, emissive: 0x2244aa, emissiveIntensity: 0.2 });
    const wingBoneMat = new THREE.MeshPhongMaterial({ color: 0x1a3366, shininess: 60 });
    for (const zSign of [-1, 1]) {
      const wingGroup = new THREE.Group();
      // Wing membrane (scalloped, organic shape)
      const wingShape = new THREE.Shape();
      wingShape.moveTo(0, 0);
      wingShape.quadraticCurveTo(0.45 * s, 0.4 * s, 0.9 * s, 0.35 * s);
      wingShape.lineTo(0.88 * s, 0.05 * s);
      wingShape.lineTo(0.8 * s, -0.15 * s);
      wingShape.lineTo(0.7 * s, -0.4 * s);
      wingShape.lineTo(0.45 * s, -0.38 * s);
      wingShape.lineTo(0.2 * s, -0.3 * s);
      wingShape.quadraticCurveTo(0.08 * s, -0.15 * s, 0, 0);
      const wingMembrane = new THREE.Mesh(new THREE.ShapeGeometry(wingShape), wingMat);
      wingMembrane.rotation.y = zSign * Math.PI / 2;
      wingGroup.add(wingMembrane);
      // Wing bone
      const bone = new THREE.Mesh(new THREE.CylinderGeometry(0.02 * s, 0.015 * s, 0.9 * s, 6), wingBoneMat);
      bone.rotation.x = Math.PI / 2;
      bone.rotation.z = 0.3;
      bone.position.set(0, 0.1 * s, zSign * 0.4 * s);
      wingGroup.add(bone);
      // Finger bones
      for (let f = 0; f < 3; f++) {
        const fb = new THREE.Mesh(new THREE.CylinderGeometry(0.012 * s, 0.008 * s, 0.5 * s, 4), wingBoneMat);
        fb.position.set(0, 0.05 * s - f * 0.15 * s, zSign * 0.7 * s);
        fb.rotation.x = Math.PI / 2;
        fb.rotation.z = -0.2 + f * 0.25;
        wingGroup.add(fb);
      }
      wingGroup.position.set(0.1 * s, 1.15 * s, zSign * 0.25 * s);
      wingGroup.userData.isWing = true;
      group.add(wingGroup);
      if (zSign > 0) group.userData.leftWing = wingGroup;
      else group.userData.rightWing = wingGroup;
    }

    // Front legs with claws
    const legMat = new THREE.MeshPhongMaterial({ color: bodyColor, shininess: 40 });
    const clawMat = new THREE.MeshPhongMaterial({ color: 0x111133, shininess: 100 });
    for (const zSign of [-1, 1]) {
      // Upper leg
      const upper = new THREE.Mesh(new THREE.CylinderGeometry(0.09 * s, 0.07 * s, 0.35 * s, 8), legMat);
      upper.position.set(0.35 * s, 0.55 * s, zSign * 0.28 * s);
      upper.rotation.z = 0.15;
      group.add(upper);
      // Lower leg
      const lower = new THREE.Mesh(new THREE.CylinderGeometry(0.07 * s, 0.05 * s, 0.25 * s, 8), legMat);
      lower.position.set(0.38 * s, 0.3 * s, zSign * 0.28 * s);
      group.add(lower);
      // Foot with claws
      for (let c = -1; c <= 1; c++) {
        const claw = new THREE.Mesh(new THREE.ConeGeometry(0.02 * s, 0.1 * s, 4), clawMat);
        claw.rotation.z = -Math.PI / 2;
        claw.position.set(0.43 * s, 0.18 * s, (zSign * 0.28 + c * 0.04) * s);
        group.add(claw);
      }
    }

    // Hind legs with claws
    for (const zSign of [-1, 1]) {
      const upper = new THREE.Mesh(new THREE.CylinderGeometry(0.1 * s, 0.08 * s, 0.4 * s, 8), legMat);
      upper.position.set(-0.45 * s, 0.55 * s, zSign * 0.3 * s);
      upper.rotation.z = -0.1;
      group.add(upper);
      const lower = new THREE.Mesh(new THREE.CylinderGeometry(0.08 * s, 0.055 * s, 0.3 * s, 8), legMat);
      lower.position.set(-0.48 * s, 0.28 * s, zSign * 0.3 * s);
      group.add(lower);
      for (let c = -1; c <= 1; c++) {
        const claw = new THREE.Mesh(new THREE.ConeGeometry(0.02 * s, 0.1 * s, 4), clawMat);
        claw.rotation.z = -Math.PI / 2;
        claw.position.set(-0.42 * s, 0.15 * s, (zSign * 0.3 + c * 0.04) * s);
        group.add(claw);
      }
    }

    // Tail - multi-segment curving
    const tailSegments = 5;
    for (let i = 0; i < tailSegments; i++) {
      const t = i / tailSegments;
      const radius = (0.2 - t * 0.14) * s;
      const segLen = 0.35 * s;
      const seg = new THREE.Mesh(new THREE.CylinderGeometry(radius, radius * 0.75, segLen, 8), bodyMat);
      seg.rotation.z = Math.PI / 2 + t * 0.15;
      const xPos = (-1.05 - i * 0.32) * s;
      const yPos = (0.75 - i * 0.06) * s;
      seg.position.set(xPos, yPos, 0);
      group.add(seg);
    }
    // Tail fin/barb
    const barbGeo = new THREE.ConeGeometry(0.1 * s, 0.2 * s, 4);
    const barbMat = new THREE.MeshPhongMaterial({ color: 0x3355bb, shininess: 80 });
    const barb = new THREE.Mesh(barbGeo, barbMat);
    barb.rotation.z = Math.PI / 2;
    barb.position.set(-2.7 * s, 0.45 * s, 0);
    group.add(barb);

    // Rotate mesh so head faces +Z (aligns with standard zombie -PI/2 spawn rotation)
    const pivot = new THREE.Group();
    while (group.children.length > 0) pivot.add(group.children[0]);
    pivot.rotation.y = -Math.PI / 2;
    group.add(pivot);

    return group;
  }

  private createGreenDragonMesh(): THREE.Group {
    const group = new THREE.Group();
    const s = 1.7;
    const bodyColor = 0x228844;
    const wingColor = 0x44cc66;
    const bellyColor = 0x55aa77;
    const bodyMat = new THREE.MeshPhongMaterial({ color: bodyColor, shininess: 60, specular: 0x44aa66 });
    const bellyMat = new THREE.MeshPhongMaterial({ color: bellyColor, shininess: 40 });

    // Chest
    const chestGeo = new THREE.CylinderGeometry(0.44 * s, 0.42 * s, 0.85 * s, 12);
    const chest = new THREE.Mesh(chestGeo, bodyMat);
    chest.rotation.z = Math.PI / 2;
    chest.position.set(0.2 * s, 0.85 * s, 0);
    group.add(chest);

    // Abdomen
    const abdGeo = new THREE.CylinderGeometry(0.42 * s, 0.34 * s, 1.0 * s, 12);
    const abd = new THREE.Mesh(abdGeo, bodyMat);
    abd.rotation.z = Math.PI / 2;
    abd.position.set(-0.65 * s, 0.8 * s, 0);
    group.add(abd);

    // Belly
    const bellyGeo = new THREE.CylinderGeometry(0.37 * s, 0.3 * s, 1.5 * s, 12);
    const belly = new THREE.Mesh(bellyGeo, bellyMat);
    belly.rotation.z = Math.PI / 2;
    belly.position.set(-0.1 * s, 0.7 * s, 0);
    group.add(belly);

    // Neck
    const neckGeo = new THREE.CylinderGeometry(0.24 * s, 0.35 * s, 0.7 * s, 10);
    const neck = new THREE.Mesh(neckGeo, bodyMat);
    neck.rotation.z = Math.PI / 2 + 0.35;
    neck.position.set(0.8 * s, 1.08 * s, 0);
    group.add(neck);

    // Head
    const headGeo = new THREE.SphereGeometry(0.3 * s, 12, 12);
    const head = new THREE.Mesh(headGeo, bodyMat);
    head.scale.set(1.3, 1, 1);
    head.position.set(1.2 * s, 1.3 * s, 0);
    group.add(head);

    // Upper jaw
    const snoutGeo = new THREE.ConeGeometry(0.16 * s, 0.5 * s, 8);
    const snout = new THREE.Mesh(snoutGeo, bodyMat);
    snout.rotation.z = -Math.PI / 2;
    snout.position.set(1.55 * s, 1.3 * s, 0);
    group.add(snout);

    // Lower jaw
    const jawGeo = new THREE.ConeGeometry(0.11 * s, 0.38 * s, 6);
    const jaw = new THREE.Mesh(jawGeo, bodyMat);
    jaw.rotation.z = -Math.PI / 2 + 0.15;
    jaw.position.set(1.45 * s, 1.18 * s, 0);
    group.add(jaw);

    // Fireball glow in mouth
    const fireGlowGeo = new THREE.SphereGeometry(0.14 * s, 10, 10);
    const fireGlowMat = new THREE.MeshBasicMaterial({ color: 0xff6600, transparent: true, opacity: 0.6 });
    const fireGlow = new THREE.Mesh(fireGlowGeo, fireGlowMat);
    fireGlow.position.set(1.7 * s, 1.25 * s, 0);
    group.add(fireGlow);
    // Inner fire core
    const fireCore = new THREE.Mesh(new THREE.SphereGeometry(0.06 * s, 8, 8), new THREE.MeshBasicMaterial({ color: 0xffcc00 }));
    fireCore.position.set(1.7 * s, 1.25 * s, 0);
    group.add(fireCore);

    // Nostrils with smoke
    const nostrilMat = new THREE.MeshBasicMaterial({ color: 0x0a2211 });
    for (const zSign of [-1, 1]) {
      const nostril = new THREE.Mesh(new THREE.SphereGeometry(0.03 * s, 6, 6), nostrilMat);
      nostril.position.set(1.74 * s, 1.34 * s, zSign * 0.07 * s);
      group.add(nostril);
      // Smoke wisp
      const smoke = new THREE.Mesh(new THREE.SphereGeometry(0.04 * s, 6, 6), new THREE.MeshBasicMaterial({ color: 0x666666, transparent: true, opacity: 0.3 }));
      smoke.position.set(1.82 * s, 1.38 * s, zSign * 0.07 * s);
      group.add(smoke);
    }

    // Eyes with pupils
    const eyeWhiteMat = new THREE.MeshBasicMaterial({ color: 0xccff44 });
    const pupilMat = new THREE.MeshBasicMaterial({ color: 0x000000 });
    for (const zSign of [-1, 1]) {
      const eye = new THREE.Mesh(new THREE.SphereGeometry(0.075 * s, 8, 8), eyeWhiteMat);
      eye.position.set(1.3 * s, 1.44 * s, zSign * 0.19 * s);
      group.add(eye);
      const pupil = new THREE.Mesh(new THREE.SphereGeometry(0.038 * s, 6, 6), pupilMat);
      pupil.position.set(1.35 * s, 1.45 * s, zSign * 0.21 * s);
      group.add(pupil);
    }

    // Brow ridges
    const browMat = new THREE.MeshPhongMaterial({ color: 0x1a4422, shininess: 80 });
    for (const zSign of [-1, 1]) {
      const brow = new THREE.Mesh(new THREE.BoxGeometry(0.16 * s, 0.045 * s, 0.09 * s), browMat);
      brow.position.set(1.28 * s, 1.5 * s, zSign * 0.16 * s);
      group.add(brow);
    }

    // Horns (curved back, larger)
    const hornMat = new THREE.MeshPhongMaterial({ color: 0x1a3322, shininess: 120, specular: 0x66aa66 });
    for (const zSign of [-1, 1]) {
      const horn = new THREE.Mesh(new THREE.ConeGeometry(0.07 * s, 0.4 * s, 6), hornMat);
      horn.position.set(1.05 * s, 1.55 * s, zSign * 0.16 * s);
      horn.rotation.z = 0.5;
      horn.rotation.x = zSign * 0.25;
      group.add(horn);
      // Second smaller horn behind
      const horn2 = new THREE.Mesh(new THREE.ConeGeometry(0.04 * s, 0.25 * s, 6), hornMat);
      horn2.position.set(0.9 * s, 1.48 * s, zSign * 0.2 * s);
      horn2.rotation.z = 0.6;
      horn2.rotation.x = zSign * 0.3;
      group.add(horn2);
    }

    // Cheek/ear fins (larger, leaf-like for green dragon)
    const finMat = new THREE.MeshPhongMaterial({ color: wingColor, shininess: 60, transparent: true, opacity: 0.7 });
    for (const zSign of [-1, 1]) {
      const finShape = new THREE.Shape();
      finShape.moveTo(0, 0);
      finShape.quadraticCurveTo(0.12 * s, 0.15 * s, 0.25 * s, 0.1 * s);
      finShape.quadraticCurveTo(0.2 * s, -0.05 * s, 0.12 * s, -0.12 * s);
      finShape.lineTo(0, 0);
      const fin = new THREE.Mesh(new THREE.ShapeGeometry(finShape), finMat);
      fin.position.set(1.05 * s, 1.32 * s, zSign * 0.24 * s);
      fin.rotation.y = zSign * Math.PI / 2;
      group.add(fin);
    }

    // Spine ridges - jagged
    const ridgeMat = new THREE.MeshPhongMaterial({ color: 0x33aa55, shininess: 80 });
    for (let i = 0; i < 10; i++) {
      const ridgeSize = 0.07 + Math.sin(i / 9 * Math.PI) * 0.07;
      const ridge = new THREE.Mesh(new THREE.ConeGeometry(ridgeSize * s, ridgeSize * 2.8 * s, 4), ridgeMat);
      ridge.position.set((0.8 - i * 0.22) * s, 1.12 * s, 0);
      group.add(ridge);
    }

    // Wings - shaped with bone structure
    const wingMat = new THREE.MeshPhongMaterial({ color: wingColor, side: THREE.DoubleSide, transparent: true, opacity: 0.6, emissive: 0x226633, emissiveIntensity: 0.2 });
    const wingBoneMat = new THREE.MeshPhongMaterial({ color: 0x1a4422, shininess: 60 });
    for (const zSign of [-1, 1]) {
      const wingGroup = new THREE.Group();
      const wingShape = new THREE.Shape();
      wingShape.moveTo(0, 0);
      wingShape.quadraticCurveTo(0.5 * s, 0.45 * s, 1.0 * s, 0.4 * s);
      wingShape.lineTo(0.98 * s, 0.1 * s);
      wingShape.lineTo(0.9 * s, -0.15 * s);
      wingShape.lineTo(0.85 * s, -0.45 * s);
      wingShape.lineTo(0.55 * s, -0.42 * s);
      wingShape.lineTo(0.25 * s, -0.35 * s);
      wingShape.quadraticCurveTo(0.1 * s, -0.17 * s, 0, 0);
      const wingMembrane = new THREE.Mesh(new THREE.ShapeGeometry(wingShape), wingMat);
      wingMembrane.rotation.y = zSign * Math.PI / 2;
      wingGroup.add(wingMembrane);
      // Main bone
      const bone = new THREE.Mesh(new THREE.CylinderGeometry(0.025 * s, 0.018 * s, 1.0 * s, 6), wingBoneMat);
      bone.rotation.x = Math.PI / 2;
      bone.rotation.z = 0.3;
      bone.position.set(0, 0.1 * s, zSign * 0.45 * s);
      wingGroup.add(bone);
      for (let f = 0; f < 3; f++) {
        const fb = new THREE.Mesh(new THREE.CylinderGeometry(0.015 * s, 0.01 * s, 0.55 * s, 4), wingBoneMat);
        fb.position.set(0, 0.05 * s - f * 0.17 * s, zSign * 0.8 * s);
        fb.rotation.x = Math.PI / 2;
        fb.rotation.z = -0.2 + f * 0.25;
        wingGroup.add(fb);
      }
      wingGroup.position.set(0.1 * s, 1.15 * s, zSign * 0.28 * s);
      wingGroup.userData.isWing = true;
      group.add(wingGroup);
      if (zSign > 0) group.userData.leftWing = wingGroup;
      else group.userData.rightWing = wingGroup;
    }

    // Front legs with claws
    const legMat = new THREE.MeshPhongMaterial({ color: bodyColor, shininess: 40 });
    const clawMat = new THREE.MeshPhongMaterial({ color: 0x0a2211, shininess: 100 });
    for (const zSign of [-1, 1]) {
      const upper = new THREE.Mesh(new THREE.CylinderGeometry(0.1 * s, 0.08 * s, 0.4 * s, 8), legMat);
      upper.position.set(0.35 * s, 0.55 * s, zSign * 0.3 * s);
      upper.rotation.z = 0.15;
      group.add(upper);
      const lower = new THREE.Mesh(new THREE.CylinderGeometry(0.08 * s, 0.055 * s, 0.28 * s, 8), legMat);
      lower.position.set(0.38 * s, 0.28 * s, zSign * 0.3 * s);
      group.add(lower);
      for (let c = -1; c <= 1; c++) {
        const claw = new THREE.Mesh(new THREE.ConeGeometry(0.022 * s, 0.12 * s, 4), clawMat);
        claw.rotation.z = -Math.PI / 2;
        claw.position.set(0.44 * s, 0.16 * s, (zSign * 0.3 + c * 0.045) * s);
        group.add(claw);
      }
    }

    // Hind legs with claws
    for (const zSign of [-1, 1]) {
      const upper = new THREE.Mesh(new THREE.CylinderGeometry(0.11 * s, 0.09 * s, 0.45 * s, 8), legMat);
      upper.position.set(-0.5 * s, 0.55 * s, zSign * 0.32 * s);
      upper.rotation.z = -0.1;
      group.add(upper);
      const lower = new THREE.Mesh(new THREE.CylinderGeometry(0.09 * s, 0.06 * s, 0.32 * s, 8), legMat);
      lower.position.set(-0.53 * s, 0.26 * s, zSign * 0.32 * s);
      group.add(lower);
      for (let c = -1; c <= 1; c++) {
        const claw = new THREE.Mesh(new THREE.ConeGeometry(0.022 * s, 0.12 * s, 4), clawMat);
        claw.rotation.z = -Math.PI / 2;
        claw.position.set(-0.47 * s, 0.13 * s, (zSign * 0.32 + c * 0.045) * s);
        group.add(claw);
      }
    }

    // Tail - multi-segment with poison-tip
    const tailSegments = 6;
    for (let i = 0; i < tailSegments; i++) {
      const t = i / tailSegments;
      const radius = (0.22 - t * 0.15) * s;
      const segLen = 0.38 * s;
      const seg = new THREE.Mesh(new THREE.CylinderGeometry(radius, radius * 0.75, segLen, 8), bodyMat);
      seg.rotation.z = Math.PI / 2 + t * 0.12;
      seg.position.set((-1.15 - i * 0.34) * s, (0.75 - i * 0.05) * s, 0);
      group.add(seg);
    }
    // Poison barb tail tip
    const barbMat = new THREE.MeshPhongMaterial({ color: 0x44ee66, shininess: 100, emissive: 0x22aa44, emissiveIntensity: 0.3 });
    const barb = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.25 * s, 4), barbMat);
    barb.rotation.z = Math.PI / 2;
    barb.position.set(-3.25 * s, 0.45 * s, 0);
    group.add(barb);

    // Rotate mesh so head faces +Z (aligns with standard zombie -PI/2 spawn rotation)
    const pivot = new THREE.Group();
    while (group.children.length > 0) pivot.add(group.children[0]);
    pivot.rotation.y = -Math.PI / 2;
    group.add(pivot);

    return group;
  }

  private createRedDragonMesh(): THREE.Group {
    const group = new THREE.Group();
    const s = 2.0;
    const bodyColor = 0xcc2222;
    const wingColor = 0xff4444;
    const bellyColor = 0xaa4444;
    const bodyMat = new THREE.MeshPhongMaterial({ color: bodyColor, shininess: 80, specular: 0xff6666, emissive: 0x440000, emissiveIntensity: 0.2 });
    const bellyMat = new THREE.MeshPhongMaterial({ color: bellyColor, shininess: 40 });

    // Chest (massive front torso)
    const chestGeo = new THREE.CylinderGeometry(0.48 * s, 0.45 * s, 0.95 * s, 14);
    const chest = new THREE.Mesh(chestGeo, bodyMat);
    chest.rotation.z = Math.PI / 2;
    chest.position.set(0.2 * s, 0.9 * s, 0);
    group.add(chest);

    // Abdomen
    const abdGeo = new THREE.CylinderGeometry(0.45 * s, 0.36 * s, 1.1 * s, 14);
    const abd = new THREE.Mesh(abdGeo, bodyMat);
    abd.rotation.z = Math.PI / 2;
    abd.position.set(-0.7 * s, 0.85 * s, 0);
    group.add(abd);

    // Hip section
    const hipGeo = new THREE.CylinderGeometry(0.36 * s, 0.28 * s, 0.6 * s, 12);
    const hip = new THREE.Mesh(hipGeo, bodyMat);
    hip.rotation.z = Math.PI / 2;
    hip.position.set(-1.35 * s, 0.8 * s, 0);
    group.add(hip);

    // Belly (golden underside)
    const bellyGeo = new THREE.CylinderGeometry(0.4 * s, 0.32 * s, 1.8 * s, 12);
    const belly = new THREE.Mesh(bellyGeo, bellyMat);
    belly.rotation.z = Math.PI / 2;
    belly.position.set(-0.2 * s, 0.72 * s, 0);
    group.add(belly);

    // Neck (thick, muscular, angled up)
    const neckGeo = new THREE.CylinderGeometry(0.28 * s, 0.4 * s, 0.8 * s, 10);
    const neck = new THREE.Mesh(neckGeo, bodyMat);
    neck.rotation.z = Math.PI / 2 + 0.4;
    neck.position.set(0.85 * s, 1.15 * s, 0);
    group.add(neck);

    // Head (large, armored)
    const headGeo = new THREE.SphereGeometry(0.35 * s, 14, 14);
    const head = new THREE.Mesh(headGeo, bodyMat);
    head.scale.set(1.4, 1.1, 1.1);
    head.position.set(1.3 * s, 1.45 * s, 0);
    group.add(head);

    // Armored head plate
    const plateMat = new THREE.MeshPhongMaterial({ color: 0x991111, shininess: 100, specular: 0xff8888 });
    const plate = new THREE.Mesh(new THREE.BoxGeometry(0.35 * s, 0.06 * s, 0.35 * s), plateMat);
    plate.position.set(1.2 * s, 1.65 * s, 0);
    plate.rotation.z = 0.15;
    group.add(plate);

    // Upper jaw (longer, more menacing)
    const snoutGeo = new THREE.ConeGeometry(0.2 * s, 0.6 * s, 8);
    const snout = new THREE.Mesh(snoutGeo, bodyMat);
    snout.rotation.z = -Math.PI / 2;
    snout.position.set(1.72 * s, 1.42 * s, 0);
    group.add(snout);

    // Lower jaw (articulated)
    const jawGeo = new THREE.ConeGeometry(0.14 * s, 0.45 * s, 6);
    const jaw = new THREE.Mesh(jawGeo, bodyMat);
    jaw.rotation.z = -Math.PI / 2 + 0.2;
    jaw.position.set(1.6 * s, 1.28 * s, 0);
    group.add(jaw);

    // Teeth
    const toothMat = new THREE.MeshPhongMaterial({ color: 0xffffdd, shininess: 200 });
    for (let t = 0; t < 4; t++) {
      const tooth = new THREE.Mesh(new THREE.ConeGeometry(0.02 * s, 0.08 * s, 4), toothMat);
      const zOff = (-0.08 + t * 0.05) * s;
      tooth.position.set(1.65 * s + t * 0.04 * s, 1.32 * s, zOff);
      tooth.rotation.x = Math.PI;
      group.add(tooth);
      const tooth2 = tooth.clone();
      tooth2.position.z = -zOff;
      group.add(tooth2);
    }

    // Fireball cannon - massive with inner fire
    const fireGlowGeo = new THREE.SphereGeometry(0.2 * s, 12, 12);
    const fireGlowMat = new THREE.MeshBasicMaterial({ color: 0xff2200, transparent: true, opacity: 0.7 });
    const fireGlow = new THREE.Mesh(fireGlowGeo, fireGlowMat);
    fireGlow.position.set(1.95 * s, 1.38 * s, 0);
    group.add(fireGlow);
    const fireCoreGeo = new THREE.SphereGeometry(0.1 * s, 8, 8);
    const fireCoreMat = new THREE.MeshBasicMaterial({ color: 0xffcc00 });
    const fireCore = new THREE.Mesh(fireCoreGeo, fireCoreMat);
    fireCore.position.set(1.95 * s, 1.38 * s, 0);
    group.add(fireCore);

    // Nostrils with fire wisps
    for (const zSign of [-1, 1]) {
      const nostril = new THREE.Mesh(new THREE.SphereGeometry(0.035 * s, 6, 6), new THREE.MeshBasicMaterial({ color: 0x330000 }));
      nostril.position.set(1.95 * s, 1.48 * s, zSign * 0.08 * s);
      group.add(nostril);
      const wisp = new THREE.Mesh(new THREE.ConeGeometry(0.03 * s, 0.1 * s, 6), new THREE.MeshBasicMaterial({ color: 0xff6600, transparent: true, opacity: 0.5 }));
      wisp.position.set(2.02 * s, 1.52 * s, zSign * 0.08 * s);
      group.add(wisp);
    }

    // Eyes - glowing red with slit pupils
    for (const zSign of [-1, 1]) {
      // Eye socket (dark recess)
      const socket = new THREE.Mesh(new THREE.SphereGeometry(0.1 * s, 8, 8), new THREE.MeshPhongMaterial({ color: 0x330000 }));
      socket.position.set(1.42 * s, 1.58 * s, zSign * 0.22 * s);
      group.add(socket);
      // Glowing eye
      const eye = new THREE.Mesh(new THREE.SphereGeometry(0.08 * s, 8, 8), new THREE.MeshBasicMaterial({ color: 0xff0000 }));
      eye.position.set(1.45 * s, 1.58 * s, zSign * 0.23 * s);
      group.add(eye);
      // Slit pupil
      const slit = new THREE.Mesh(new THREE.BoxGeometry(0.02 * s, 0.12 * s, 0.03 * s), new THREE.MeshBasicMaterial({ color: 0x000000 }));
      slit.position.set(1.48 * s, 1.58 * s, zSign * 0.24 * s);
      group.add(slit);
    }

    // Crown horns - golden, majestic
    const crownMat = new THREE.MeshPhongMaterial({ color: 0xffaa00, shininess: 200, specular: 0xffffff, emissive: 0x885500, emissiveIntensity: 0.3 });
    // Main crown horns (large, curved back)
    for (const zSign of [-1, 1]) {
      const mainHorn = new THREE.Mesh(new THREE.ConeGeometry(0.08 * s, 0.5 * s, 6), crownMat);
      mainHorn.position.set(1.15 * s, 1.8 * s, zSign * 0.2 * s);
      mainHorn.rotation.z = 0.5;
      mainHorn.rotation.x = zSign * 0.2;
      group.add(mainHorn);
      // Secondary horn
      const secHorn = new THREE.Mesh(new THREE.ConeGeometry(0.055 * s, 0.35 * s, 6), crownMat);
      secHorn.position.set(1.0 * s, 1.72 * s, zSign * 0.25 * s);
      secHorn.rotation.z = 0.7;
      secHorn.rotation.x = zSign * 0.3;
      group.add(secHorn);
    }
    // Center crest horn
    const crestHorn = new THREE.Mesh(new THREE.ConeGeometry(0.06 * s, 0.4 * s, 6), crownMat);
    crestHorn.position.set(1.1 * s, 1.85 * s, 0);
    crestHorn.rotation.z = 0.3;
    group.add(crestHorn);

    // Cheek/ear fins (fiery, dramatic for red dragon)
    const finMat = new THREE.MeshPhongMaterial({ color: 0xff6622, shininess: 80, emissive: 0x661100, emissiveIntensity: 0.3, transparent: true, opacity: 0.75 });
    for (const zSign of [-1, 1]) {
      const finShape = new THREE.Shape();
      finShape.moveTo(0, 0);
      finShape.quadraticCurveTo(0.15 * s, 0.2 * s, 0.3 * s, 0.12 * s);
      finShape.quadraticCurveTo(0.25 * s, -0.05 * s, 0.15 * s, -0.15 * s);
      finShape.lineTo(0, 0);
      const fin = new THREE.Mesh(new THREE.ShapeGeometry(finShape), finMat);
      fin.position.set(1.1 * s, 1.45 * s, zSign * 0.28 * s);
      fin.rotation.y = zSign * Math.PI / 2;
      group.add(fin);
    }

    // Spine ridges - fire-tipped
    const ridgeMat = new THREE.MeshPhongMaterial({ color: 0xdd3333, shininess: 80 });
    const fireRidgeMat = new THREE.MeshBasicMaterial({ color: 0xff6600, transparent: true, opacity: 0.7 });
    for (let i = 0; i < 12; i++) {
      const ridgeSize = 0.08 + Math.sin(i / 11 * Math.PI) * 0.08;
      const ridge = new THREE.Mesh(new THREE.ConeGeometry(ridgeSize * s, ridgeSize * 3 * s, 4), ridgeMat);
      const rx = (0.85 - i * 0.22) * s;
      ridge.position.set(rx, 1.18 * s, 0);
      group.add(ridge);
      // Fire tip on every other ridge
      if (i % 2 === 0) {
        const fireTip = new THREE.Mesh(new THREE.ConeGeometry(ridgeSize * 0.6 * s, ridgeSize * 1.5 * s, 4), fireRidgeMat);
        fireTip.position.set(rx, 1.18 * s + ridgeSize * 2.5 * s, 0);
        fireTip.userData.isFlame = true;
        group.add(fireTip);
      }
    }

    // Wings - massive with bone structure and claw tips
    const wingMat = new THREE.MeshPhongMaterial({ color: wingColor, side: THREE.DoubleSide, transparent: true, opacity: 0.6, emissive: 0x661111, emissiveIntensity: 0.3 });
    const wingBoneMat = new THREE.MeshPhongMaterial({ color: 0x882222, shininess: 60 });
    for (const zSign of [-1, 1]) {
      const wingGroup = new THREE.Group();
      // Wing membrane (large, dramatic, scalloped)
      const wingShape = new THREE.Shape();
      wingShape.moveTo(0, 0);
      wingShape.quadraticCurveTo(0.65 * s, 0.6 * s, 1.3 * s, 0.55 * s);
      wingShape.lineTo(1.25 * s, 0.2 * s);
      wingShape.lineTo(1.1 * s, -0.1 * s);
      wingShape.lineTo(1.0 * s, -0.35 * s);
      wingShape.lineTo(0.9 * s, -0.55 * s);
      wingShape.lineTo(0.6 * s, -0.5 * s);
      wingShape.lineTo(0.3 * s, -0.4 * s);
      wingShape.quadraticCurveTo(0.12 * s, -0.2 * s, 0, 0);
      const wingMembrane = new THREE.Mesh(new THREE.ShapeGeometry(wingShape), wingMat);
      wingMembrane.rotation.y = zSign * Math.PI / 2;
      wingGroup.add(wingMembrane);
      // Main wing bone
      const mainBone = new THREE.Mesh(new THREE.CylinderGeometry(0.035 * s, 0.025 * s, 1.3 * s, 6), wingBoneMat);
      mainBone.rotation.x = Math.PI / 2;
      mainBone.rotation.z = 0.35;
      mainBone.position.set(0, 0.15 * s, zSign * 0.55 * s);
      wingGroup.add(mainBone);
      // Finger bones
      for (let f = 0; f < 4; f++) {
        const fb = new THREE.Mesh(new THREE.CylinderGeometry(0.018 * s, 0.012 * s, 0.65 * s, 4), wingBoneMat);
        fb.position.set(0, 0.1 * s - f * 0.18 * s, zSign * 0.95 * s);
        fb.rotation.x = Math.PI / 2;
        fb.rotation.z = -0.15 + f * 0.2;
        wingGroup.add(fb);
      }
      // Wing claw at tip
      const wingClaw = new THREE.Mesh(new THREE.ConeGeometry(0.03 * s, 0.15 * s, 4), new THREE.MeshPhongMaterial({ color: 0x440000, shininess: 100 }));
      wingClaw.position.set(0, 0.35 * s, zSign * 1.2 * s);
      wingClaw.rotation.x = zSign * -0.5;
      wingGroup.add(wingClaw);

      wingGroup.position.set(0.1 * s, 1.2 * s, zSign * 0.3 * s);
      wingGroup.userData.isWing = true;
      group.add(wingGroup);
      if (zSign > 0) group.userData.leftWing = wingGroup;
      else group.userData.rightWing = wingGroup;
    }

    // Fire aura around body
    const auraGeo = new THREE.SphereGeometry(1.2 * s, 12, 12);
    const auraMat = new THREE.MeshBasicMaterial({ color: 0xff4400, transparent: true, opacity: 0.08 });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    aura.position.set(-0.2 * s, 0.9 * s, 0);
    group.add(aura);

    // Front legs (muscular, with armor plates and claws)
    const legMat = new THREE.MeshPhongMaterial({ color: bodyColor, shininess: 40 });
    const clawMat = new THREE.MeshPhongMaterial({ color: 0x330000, shininess: 100 });
    for (const zSign of [-1, 1]) {
      // Shoulder
      const shoulder = new THREE.Mesh(new THREE.SphereGeometry(0.14 * s, 8, 8), bodyMat);
      shoulder.position.set(0.4 * s, 0.75 * s, zSign * 0.35 * s);
      group.add(shoulder);
      // Upper leg
      const upper = new THREE.Mesh(new THREE.CylinderGeometry(0.12 * s, 0.09 * s, 0.45 * s, 8), legMat);
      upper.position.set(0.42 * s, 0.5 * s, zSign * 0.35 * s);
      upper.rotation.z = 0.15;
      group.add(upper);
      // Lower leg
      const lower = new THREE.Mesh(new THREE.CylinderGeometry(0.09 * s, 0.06 * s, 0.32 * s, 8), legMat);
      lower.position.set(0.45 * s, 0.22 * s, zSign * 0.35 * s);
      group.add(lower);
      // Claws (3 per foot)
      for (let c = -1; c <= 1; c++) {
        const claw = new THREE.Mesh(new THREE.ConeGeometry(0.025 * s, 0.14 * s, 4), clawMat);
        claw.rotation.z = -Math.PI / 2;
        claw.position.set(0.52 * s, 0.1 * s, (zSign * 0.35 + c * 0.05) * s);
        group.add(claw);
      }
    }

    // Hind legs (powerful, larger)
    for (const zSign of [-1, 1]) {
      const shoulder = new THREE.Mesh(new THREE.SphereGeometry(0.16 * s, 8, 8), bodyMat);
      shoulder.position.set(-0.55 * s, 0.75 * s, zSign * 0.38 * s);
      group.add(shoulder);
      const upper = new THREE.Mesh(new THREE.CylinderGeometry(0.14 * s, 0.1 * s, 0.5 * s, 8), legMat);
      upper.position.set(-0.58 * s, 0.48 * s, zSign * 0.38 * s);
      upper.rotation.z = -0.1;
      group.add(upper);
      const lower = new THREE.Mesh(new THREE.CylinderGeometry(0.1 * s, 0.07 * s, 0.35 * s, 8), legMat);
      lower.position.set(-0.6 * s, 0.2 * s, zSign * 0.38 * s);
      group.add(lower);
      for (let c = -1; c <= 1; c++) {
        const claw = new THREE.Mesh(new THREE.ConeGeometry(0.025 * s, 0.14 * s, 4), clawMat);
        claw.rotation.z = -Math.PI / 2;
        claw.position.set(-0.53 * s, 0.08 * s, (zSign * 0.38 + c * 0.05) * s);
        group.add(claw);
      }
    }

    // Tail - multi-segment with fire barb
    const tailSegments = 7;
    for (let i = 0; i < tailSegments; i++) {
      const t = i / tailSegments;
      const radius = (0.25 - t * 0.17) * s;
      const segLen = 0.4 * s;
      const seg = new THREE.Mesh(new THREE.CylinderGeometry(radius, radius * 0.75, segLen, 8), bodyMat);
      seg.rotation.z = Math.PI / 2 + t * 0.1;
      seg.position.set((-1.65 - i * 0.36) * s, (0.78 - i * 0.04) * s, 0);
      group.add(seg);
      // Tail spines
      if (i % 2 === 0 && i < tailSegments - 1) {
        const spine = new THREE.Mesh(new THREE.ConeGeometry(0.04 * s, 0.15 * s, 4), ridgeMat);
        spine.position.set((-1.65 - i * 0.36) * s, (0.78 - i * 0.04 + radius + 0.05) * s, 0);
        group.add(spine);
      }
    }
    // Fire barb tail tip
    const barbMat = new THREE.MeshPhongMaterial({ color: 0xff4400, shininess: 100, emissive: 0xff2200, emissiveIntensity: 0.5 });
    const barb = new THREE.Mesh(new THREE.ConeGeometry(0.14 * s, 0.3 * s, 6), barbMat);
    barb.rotation.z = Math.PI / 2;
    barb.position.set(-4.2 * s, 0.5 * s, 0);
    group.add(barb);
    // Barb fire glow
    const barbGlow = new THREE.Mesh(new THREE.SphereGeometry(0.1 * s, 8, 8), new THREE.MeshBasicMaterial({ color: 0xff6600, transparent: true, opacity: 0.4 }));
    barbGlow.position.set(-4.25 * s, 0.5 * s, 0);
    group.add(barbGlow);

    // Rotate mesh so head faces +Z (aligns with standard zombie -PI/2 spawn rotation)
    const pivot = new THREE.Group();
    while (group.children.length > 0) pivot.add(group.children[0]);
    pivot.rotation.y = -Math.PI / 2;
    group.add(pivot);

    return group;
  }

  private createZombieMesh(type: ZombieType = 'normal'): THREE.Group {
    const zombieGroup = new THREE.Group();

    // Create custom meshes for special zombie types
    if (type === 'grape') {
      return this.createGrapeZombieMesh();
    } else if (type === 'car') {
      return this.createCarZombieMesh();
    } else if (type === 'grave') {
      return this.createGraveZombieMesh();
    } else if (type === 'grape-gun') {
      return this.createGrapeGunZombieMesh();
    } else if (type === 'healer') {
      return this.createHealerZombieMesh();
    } else if (type === 'super-car') {
      return this.createSuperCarZombieMesh();
    } else if (type === 'frost-grape-gun') {
      return this.createFrostGrapeGunZombieMesh();
    } else if (type === 'fire') {
      return this.createFireZombieMesh();
    } else if (type === 'fat') {
      return this.createFatZombieMesh();
    } else if (type === 'blue-dragon') {
      return this.createBlueDragonMesh();
    } else if (type === 'green-dragon') {
      return this.createGreenDragonMesh();
    } else if (type === 'red-dragon') {
      return this.createRedDragonMesh();
    }

    let scale = 1;
    let skinColor = 0x8fbc8f; // Pale greenish skin
    let skinColorDark = 0x6b8e6b;
    let clothesColor = 0x4a4a4a;
    let clothesColorAlt = 0x3d3d3d;
    let eyeColor = 0xff3333;
    let hairColor = 0x2a2a2a;

    // Adjust appearance based on type
    switch (type) {
      case 'fast':
        scale = 0.9;
        skinColor = 0xc9a0a0; // Pale pinkish
        skinColorDark = 0xa08080;
        clothesColor = 0x8b0000;
        clothesColorAlt = 0x660000;
        eyeColor = 0xffff00;
        hairColor = 0x4a2020;
        break;
      case 'tank':
        scale = 1.5;
        skinColor = 0x808080; // Grayish
        skinColorDark = 0x606060;
        clothesColor = 0x2f4f4f;
        clothesColorAlt = 0x1f3f3f;
        eyeColor = 0xff8c00;
        hairColor = 0x1a1a1a;
        break;
      case 'tiny':
        scale = 0.6;
        skinColor = 0xd8bfd8; // Pale purple
        skinColorDark = 0xb898b8;
        clothesColor = 0x663399;
        clothesColorAlt = 0x4a2670;
        eyeColor = 0x00ff00;
        hairColor = 0x4a3060;
        break;
    }

    // Torso
    const torsoGeo = new THREE.CylinderGeometry(0.32 * scale, 0.28 * scale, 0.9 * scale, 12);
    const torsoMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 15 });
    const torso = new THREE.Mesh(torsoGeo, torsoMat);
    torso.position.y = 0.7 * scale;
    zombieGroup.add(torso);

    // Collar
    const collarGeo = new THREE.CylinderGeometry(0.34 * scale, 0.32 * scale, 0.15 * scale, 12);
    const collarMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 10 });
    const collar = new THREE.Mesh(collarGeo, collarMat);
    collar.position.y = 1.1 * scale;
    zombieGroup.add(collar);

    // Hips
    const hipsGeo = new THREE.CylinderGeometry(0.3 * scale, 0.26 * scale, 0.2 * scale, 12);
    const hipsMat = new THREE.MeshPhongMaterial({ color: 0x3d3020, shininess: 20 });
    const hips = new THREE.Mesh(hipsGeo, hipsMat);
    hips.position.y = 0.2 * scale;
    zombieGroup.add(hips);

    // Neck
    const neckGeo = new THREE.CylinderGeometry(0.12 * scale, 0.14 * scale, 0.2 * scale, 10);
    const neckMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const neck = new THREE.Mesh(neckGeo, neckMat);
    neck.position.y = 1.25 * scale;
    zombieGroup.add(neck);

    // Head
    const headGeo = new THREE.SphereGeometry(0.28 * scale, 16, 14);
    const headMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 25 });
    const head = new THREE.Mesh(headGeo, headMat);
    head.scale.set(1, 1.15, 1);
    head.position.y = 1.55 * scale;
    zombieGroup.add(head);

    // Hair
    const hairGeo = new THREE.SphereGeometry(0.29 * scale, 12, 8, 0, Math.PI * 2, 0, Math.PI * 0.5);
    const hairMat = new THREE.MeshPhongMaterial({ color: hairColor, shininess: 5 });
    const hair = new THREE.Mesh(hairGeo, hairMat);
    hair.position.y = 1.6 * scale;
    hair.scale.set(1, 0.7, 1);
    zombieGroup.add(hair);

    // Ears
    const earGeo = new THREE.SphereGeometry(0.06 * scale, 8, 8);
    const earMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftEar = new THREE.Mesh(earGeo, earMat);
    leftEar.position.set(-0.28 * scale, 1.55 * scale, 0);
    leftEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(leftEar);
    const rightEar = new THREE.Mesh(earGeo, earMat);
    rightEar.position.set(0.28 * scale, 1.55 * scale, 0);
    rightEar.scale.set(0.6, 1, 0.8);
    zombieGroup.add(rightEar);

    // Glowing eyes
    const eyeGeo = new THREE.SphereGeometry(0.05 * scale, 12, 12);
    const eyeMat = new THREE.MeshPhongMaterial({
      color: eyeColor,
      emissive: eyeColor,
      emissiveIntensity: 0.9,
      shininess: 100
    });
    const leftEye = new THREE.Mesh(eyeGeo, eyeMat);
    leftEye.position.set(-0.1 * scale, 1.58 * scale, 0.24 * scale);
    zombieGroup.add(leftEye);
    const rightEye = new THREE.Mesh(eyeGeo, eyeMat.clone());
    rightEye.position.set(0.1 * scale, 1.58 * scale, 0.24 * scale);
    zombieGroup.add(rightEye);

    // Mouth
    const mouthGeo = new THREE.BoxGeometry(0.16 * scale, 0.04 * scale, 0.04 * scale);
    const mouthMat = new THREE.MeshPhongMaterial({ color: 0x1a0a0a });
    const mouth = new THREE.Mesh(mouthGeo, mouthMat);
    mouth.position.set(0, 1.42 * scale, 0.24 * scale);
    zombieGroup.add(mouth);

    // Shoulders
    const shoulderGeo = new THREE.SphereGeometry(0.14 * scale, 10, 10);
    const shoulderMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 15 });
    const leftShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    leftShoulder.position.set(-0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(leftShoulder);
    const rightShoulder = new THREE.Mesh(shoulderGeo, shoulderMat);
    rightShoulder.position.set(0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(rightShoulder);

    // Arm groups for animation - positioned at shoulder joint
    const leftArmGroup = new THREE.Group();
    leftArmGroup.position.set(-0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(leftArmGroup);

    const rightArmGroup = new THREE.Group();
    rightArmGroup.position.set(0.38 * scale, 1.05 * scale, 0);
    zombieGroup.add(rightArmGroup);

    // Upper arms - connected to shoulder, goes straight down
    const upperArmGeo = new THREE.CylinderGeometry(0.1 * scale, 0.085 * scale, 0.4 * scale, 10);
    const upperArmMat = new THREE.MeshPhongMaterial({ color: clothesColor, shininess: 12 });
    const leftUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    leftUpperArm.position.set(0, -0.2 * scale, 0);
    leftArmGroup.add(leftUpperArm);
    const rightUpperArm = new THREE.Mesh(upperArmGeo, upperArmMat);
    rightUpperArm.position.set(0, -0.2 * scale, 0);
    rightArmGroup.add(rightUpperArm);

    // Elbow joints - seamless connection between upper arm and forearm
    const elbowGeo = new THREE.SphereGeometry(0.085 * scale, 8, 8);
    const elbowMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const leftElbow = new THREE.Mesh(elbowGeo, elbowMat);
    leftElbow.position.set(0, -0.4 * scale, 0);
    leftArmGroup.add(leftElbow);
    const rightElbow = new THREE.Mesh(elbowGeo, elbowMat);
    rightElbow.position.set(0, -0.4 * scale, 0);
    rightArmGroup.add(rightElbow);

    // Forearms - connected at elbow, angled forward
    const forearmGeo = new THREE.CylinderGeometry(0.08 * scale, 0.065 * scale, 0.38 * scale, 10);
    const forearmMat = new THREE.MeshPhongMaterial({ color: skinColor, shininess: 20 });
    const leftForearm = new THREE.Mesh(forearmGeo, forearmMat);
    leftForearm.position.set(0, -0.58 * scale, 0.12 * scale);
    leftForearm.rotation.x = 0.5;
    leftArmGroup.add(leftForearm);
    const rightForearm = new THREE.Mesh(forearmGeo, forearmMat);
    rightForearm.position.set(0, -0.58 * scale, 0.12 * scale);
    rightForearm.rotation.x = 0.5;
    rightArmGroup.add(rightForearm);

    // Wrist joints - seamless connection to hands
    const wristGeo = new THREE.SphereGeometry(0.06 * scale, 8, 8);
    const wristMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftWrist = new THREE.Mesh(wristGeo, wristMat);
    leftWrist.position.set(0, -0.72 * scale, 0.22 * scale);
    leftArmGroup.add(leftWrist);
    const rightWrist = new THREE.Mesh(wristGeo, wristMat);
    rightWrist.position.set(0, -0.72 * scale, 0.22 * scale);
    rightArmGroup.add(rightWrist);

    // Hands - connected at wrist
    const handGeo = new THREE.BoxGeometry(0.1 * scale, 0.14 * scale, 0.06 * scale);
    const handMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 15 });
    const leftHand = new THREE.Mesh(handGeo, handMat);
    leftHand.position.set(0, -0.82 * scale, 0.26 * scale);
    leftHand.rotation.x = 0.5;
    leftArmGroup.add(leftHand);
    const rightHand = new THREE.Mesh(handGeo, handMat);
    rightHand.position.set(0, -0.82 * scale, 0.26 * scale);
    rightHand.rotation.x = 0.5;
    rightArmGroup.add(rightHand);

    // Fingers - zombie claws
    for (let f = 0; f < 3; f++) {
      const fingerGeo = new THREE.CylinderGeometry(0.015 * scale, 0.01 * scale, 0.08 * scale, 6);
      const fingerMat = new THREE.MeshPhongMaterial({ color: skinColorDark, shininess: 10 });
      const leftFinger = new THREE.Mesh(fingerGeo, fingerMat);
      leftFinger.position.set((f - 1) * 0.035 * scale, -0.9 * scale, 0.3 * scale);
      leftFinger.rotation.x = 0.8;
      leftArmGroup.add(leftFinger);
      const rightFinger = new THREE.Mesh(fingerGeo, fingerMat);
      rightFinger.position.set((f - 1) * 0.035 * scale, -0.9 * scale, 0.3 * scale);
      rightFinger.rotation.x = 0.8;
      rightArmGroup.add(rightFinger);
    }

    // Store arm references for animation
    zombieGroup.userData.leftArm = leftArmGroup;
    zombieGroup.userData.rightArm = rightArmGroup;

    // Thighs
    const thighGeo = new THREE.CylinderGeometry(0.12 * scale, 0.1 * scale, 0.45 * scale, 10);
    const thighMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 10 });
    const leftThigh = new THREE.Mesh(thighGeo, thighMat);
    leftThigh.position.set(-0.15 * scale, -0.15 * scale, 0);
    zombieGroup.add(leftThigh);
    const rightThigh = new THREE.Mesh(thighGeo, thighMat);
    rightThigh.position.set(0.15 * scale, -0.15 * scale, 0);
    zombieGroup.add(rightThigh);

    // Shins
    const shinGeo = new THREE.CylinderGeometry(0.09 * scale, 0.07 * scale, 0.45 * scale, 10);
    const shinMat = new THREE.MeshPhongMaterial({ color: clothesColorAlt, shininess: 10 });
    const leftShin = new THREE.Mesh(shinGeo, shinMat);
    leftShin.position.set(-0.15 * scale, -0.55 * scale, 0);
    zombieGroup.add(leftShin);
    const rightShin = new THREE.Mesh(shinGeo, shinMat);
    rightShin.position.set(0.15 * scale, -0.55 * scale, 0);
    zombieGroup.add(rightShin);

    // Feet
    const footGeo = new THREE.BoxGeometry(0.12 * scale, 0.08 * scale, 0.2 * scale);
    const footMat = new THREE.MeshPhongMaterial({ color: 0x2a2a2a, shininess: 25 });
    const leftFoot = new THREE.Mesh(footGeo, footMat);
    leftFoot.position.set(-0.15 * scale, -0.8 * scale, 0.04 * scale);
    zombieGroup.add(leftFoot);
    const rightFoot = new THREE.Mesh(footGeo, footMat);
    rightFoot.position.set(0.15 * scale, -0.8 * scale, 0.04 * scale);
    zombieGroup.add(rightFoot);

    // Type-specific features
    if (type === 'tank') {
      const armorGeo = new THREE.CylinderGeometry(0.38 * scale, 0.34 * scale, 0.7 * scale, 12);
      const armorMat = new THREE.MeshPhongMaterial({ color: 0x3a3a3a, shininess: 60 });
      const armor = new THREE.Mesh(armorGeo, armorMat);
      armor.position.y = 0.75 * scale;
      zombieGroup.add(armor);

      const helmetGeo = new THREE.SphereGeometry(0.32 * scale, 14, 12);
      const helmetMat = new THREE.MeshPhongMaterial({ color: 0x2a2a2a, shininess: 80 });
      const helmet = new THREE.Mesh(helmetGeo, helmetMat);
      helmet.position.y = 1.65 * scale;
      helmet.scale.set(1, 0.8, 1);
      zombieGroup.add(helmet);
    }

    if (type === 'fast') {
      for (let i = 0; i < 3; i++) {
        const trailGeo = new THREE.PlaneGeometry(0.05 * scale, 1.2 * scale);
        const trailMat = new THREE.MeshBasicMaterial({
          color: 0xff4500,
          transparent: true,
          opacity: 0.3 - i * 0.1,
          side: THREE.DoubleSide
        });
        const trail = new THREE.Mesh(trailGeo, trailMat);
        trail.position.set(0, 0.6 * scale, -0.25 * scale - i * 0.15 * scale);
        zombieGroup.add(trail);
      }
    }

    // Slouched posture
    torso.rotation.x = 0.12;
    head.rotation.x = 0.15;

    return zombieGroup;
  }

  private updateZombies(deltaTime: number): void {
    for (let i = this.zombies.length - 1; i >= 0; i--) {
      const zombie = this.zombies[i];

      // IMPORTANT: Check death FIRST - before frozen check so frozen zombies can die
      if (zombie.health <= 0) {
        // Check if zombie was cursed by banana launcher - spawn zombie ally!
        if (zombie.userData && zombie.userData.cursed) {
          const roll = Math.random();
          const allyType: AllyType = roll < 0.7 ? 'zombie-raccoon' : 'zombie-gorilla';

          // Create zombie ally at zombie's death position
          const allyMesh = this.createAllyMesh(allyType);
          const spawnPos = zombie.position.clone();
          allyMesh.position.copy(spawnPos);
          allyMesh.rotation.y = Math.PI / 2; // Face towards zombies
          this.scene.add(allyMesh);

          const ally = new Ally(allyMesh, allyType, spawnPos.clone());
          ally.spawnZ = zombie.userData.curseSpawnZ || spawnPos.z;
          this.allies.push(ally);

          // Green explosion effect
          const explosionGeo = new THREE.SphereGeometry(0.8, 16, 16);
          const explosionMat = new THREE.MeshBasicMaterial({
            color: 0x00ff00,
            transparent: true,
            opacity: 0.8
          });
          const explosion = new THREE.Mesh(explosionGeo, explosionMat);
          explosion.position.copy(spawnPos);
          this.scene.add(explosion);

          let explosionOpacity = 0.8;
          const explosionInterval = setInterval(() => {
            explosionOpacity -= 0.1;
            explosion.scale.multiplyScalar(1.15);
            explosionMat.opacity = explosionOpacity;
            if (explosionOpacity <= 0) {
              this.scene.remove(explosion);
              clearInterval(explosionInterval);
            }
          }, 40);

          console.log(`🍌💀 Cursed zombie died! Spawned ${allyType}!`);
        }

        this.scene.remove(zombie.mesh);
        this.zombies.splice(i, 1);
        this.coins += 1; // Award 1 coin for killing a zombie
        this.updateCoinDisplay();
        console.log('Zombie defeated! +1 coin');

        // Check for vasebreaker victory
        if (this.isVasebreakerMode) {
          this.updateVasebreakerDisplay();
          if (this.vasesRemaining === 0 && this.zombies.length === 0) {
            this.showVasebreakerVictory();
          }
        }
        continue; // Skip to next zombie since this one is dead
      }

      // Update freeze immunity timer
      if (zombie.freezeImmunityTimer > 0) {
        zombie.freezeImmunityTimer -= deltaTime;
      }

      // Process burn stacks on zombie (from Red Fire Flower firecrackers)
      if (zombie.userData.burnStacks && zombie.userData.burnStacks.length > 0) {
        for (let bs = zombie.userData.burnStacks.length - 1; bs >= 0; bs--) {
          const burn = zombie.userData.burnStacks[bs];
          burn.tickTimer += deltaTime;
          burn.duration -= deltaTime;
          if (burn.tickTimer >= 2) {
            zombie.health -= burn.damage;
            burn.tickTimer = 0;
          }
          if (burn.duration <= 0) {
            zombie.userData.burnStacks.splice(bs, 1);
          }
        }
        // Visual burn effect
        if (!zombie.userData.burnEffect) {
          const fireGeo = new THREE.ConeGeometry(0.15, 0.4, 6);
          const fireMat = new THREE.MeshBasicMaterial({ color: 0xff4400, transparent: true, opacity: 0.7 });
          const fireParticle = new THREE.Mesh(fireGeo, fireMat);
          fireParticle.position.set(0, 2.0, 0);
          zombie.mesh.add(fireParticle);
          zombie.userData.burnEffect = fireParticle;
        } else {
          const fire = zombie.userData.burnEffect as THREE.Mesh;
          fire.rotation.y += deltaTime * 5;
          fire.scale.y = 1 + Math.sin(Date.now() * 0.01) * 0.3;
        }
      } else if (zombie.userData.burnEffect) {
        zombie.mesh.remove(zombie.userData.burnEffect);
        zombie.userData.burnEffect = null;
      }

      // Handle frozen status
      if (zombie.frozen) {
        zombie.frozenTimer -= deltaTime;
        if (zombie.frozenTimer <= 0) {
          zombie.frozen = false;
          // Set 2 second freeze immunity after unfreezing
          zombie.freezeImmunityTimer = 2;
          // Reset speed to base speed (in case of any stacking issues)
          zombie.speed = zombie.baseSpeed;
          // Restore original colors
          zombie.mesh.children.forEach(child => {
            if (child instanceof THREE.Mesh) {
              if (child.material instanceof THREE.MeshPhongMaterial) {
                // Reset to original zombie colors based on zombie type
                this.restoreZombieColors(zombie, child);
              }
            }
          });
        } else {
          continue; // Don't move if frozen
        }
      }

      // Handle rooted status (held by roots plant)
      if (zombie.rooted) {
        zombie.rootedTimer -= deltaTime;
        if (zombie.rootedTimer <= 0) {
          zombie.rooted = false;
          // Restore original colors
          zombie.mesh.children.forEach(child => {
            if (child instanceof THREE.Mesh) {
              if (child.material instanceof THREE.MeshPhongMaterial) {
                this.restoreZombieColors(zombie, child);
              }
            }
          });
          // Remove root tendrils
          const toRemove: THREE.Object3D[] = [];
          this.scene.children.forEach(child => {
            if (child.userData && child.userData.isRootTendril && child.userData.zombieId === zombie.mesh.uuid) {
              toRemove.push(child);
            }
          });
          toRemove.forEach(obj => this.scene.remove(obj));
        } else {
          continue; // Don't move if rooted
        }
      }

      // Update attack cooldown
      zombie.attackCooldown = Math.max(0, zombie.attackCooldown - deltaTime);

      // Special zombie behaviors
      if (zombie.type === 'grape') {
        // Grape zombie shoots grapes at plants
        zombie.shootCooldown = Math.max(0, zombie.shootCooldown - deltaTime);
        if (zombie.shootCooldown <= 0 && this.placedPlants.length > 0) {
          // Find nearest plant to shoot
          let nearestPlant = this.placedPlants[0];
          let minDistance = zombie.position.distanceTo(nearestPlant.position);
          for (const plant of this.placedPlants) {
            const distance = zombie.position.distanceTo(plant.position);
            if (distance < minDistance) {
              minDistance = distance;
              nearestPlant = plant;
            }
          }
          // Shoot at nearest plant
          this.shootGrapeFromZombie(zombie.position, nearestPlant.position);
          zombie.shootCooldown = 3; // Shoot every 3 seconds
        }
      } else if (zombie.type === 'grave') {
        // Grave zombie summons other zombies only in the first 2 seconds of being alive
        zombie.age += deltaTime;

        if (!zombie.hasSummoned && zombie.age <= 2) {
          // Summon 2-3 random zombies immediately
          const summonCount = 2 + Math.floor(Math.random() * 2); // 2-3 zombies
          const summonTypes: ZombieType[] = ['normal', 'fast', 'tank', 'tiny', 'grape'];

          for (let s = 0; s < summonCount; s++) {
            const randomType = summonTypes[Math.floor(Math.random() * summonTypes.length)];
            const summonedMesh = this.createZombieMesh(randomType);
            const offsetZ = (s - 1) * 1.5; // Spread them out
            // Clamp z position to stay within lawn boundaries (-8 to 0)
            const clampedZ = Math.max(-8, Math.min(0, zombie.position.z + offsetZ));
            summonedMesh.position.set(zombie.position.x + 1, 0.75, clampedZ);
            summonedMesh.rotation.y = -Math.PI / 2;
            this.scene.add(summonedMesh);

            const summonedZombie = new Zombie(summonedMesh, summonedMesh.position, randomType);
            this.zombies.push(summonedZombie);
          }

          console.log(`Grave zombie summoned ${summonCount} zombies!`);
          zombie.hasSummoned = true; // Never summon again
        }
      } else if (zombie.type === 'grape-gun') {
        // Grape Gun zombie shoots 3 grapes at plants in front of it
        zombie.shootCooldown = Math.max(0, zombie.shootCooldown - deltaTime);
        if (zombie.shootCooldown <= 0 && this.placedPlants.length > 0) {
          // Find plants in the same row (in front of zombie)
          const plantsInRow = this.placedPlants.filter(plant => {
            const zDiff = Math.abs(plant.position.z - zombie.position.z);
            return zDiff < 1 && plant.position.x < zombie.position.x; // In same row and in front
          });

          if (plantsInRow.length > 0) {
            // Find nearest plant in the row
            let nearestPlant = plantsInRow[0];
            let minDistance = zombie.position.distanceTo(nearestPlant.position);
            for (const plant of plantsInRow) {
              const distance = zombie.position.distanceTo(plant.position);
              if (distance < minDistance) {
                minDistance = distance;
                nearestPlant = plant;
              }
            }

            // Shoot 3 grapes at the nearest plant in row
            for (let i = 0; i < 3; i++) {
              setTimeout(() => {
                this.shootGrapeFromZombie(zombie.position, nearestPlant.position);
              }, i * 100); // Slight delay between shots for effect
            }

            console.log('Grape Gun zombie fired triple shot!');
            zombie.shootCooldown = 2; // Shoot every 2 seconds
          }
        }
      } else if (zombie.type === 'frost-grape-gun') {
        // BOSS: Frost Grape Gun zombie shoots 5 frozen grapes that slow plants!
        zombie.shootCooldown = Math.max(0, zombie.shootCooldown - deltaTime);
        if (zombie.shootCooldown <= 0 && this.placedPlants.length > 0) {
          // Find plants in the same row (in front of zombie)
          const plantsInRow = this.placedPlants.filter(plant => {
            const zDiff = Math.abs(plant.position.z - zombie.position.z);
            return zDiff < 1.5 && plant.position.x < zombie.position.x; // Wider detection range
          });

          if (plantsInRow.length > 0) {
            // Find nearest plant in the row
            let nearestPlant = plantsInRow[0];
            let minDistance = zombie.position.distanceTo(nearestPlant.position);
            for (const plant of plantsInRow) {
              const distance = zombie.position.distanceTo(plant.position);
              if (distance < minDistance) {
                minDistance = distance;
                nearestPlant = plant;
              }
            }

            // Shoot 5 frozen grapes at the nearest plant
            for (let i = 0; i < 5; i++) {
              setTimeout(() => {
                this.shootFrostGrapeFromZombie(zombie.position, nearestPlant.position);
              }, i * 80); // Faster burst
            }

            console.log('BOSS: Frost Grape Gun zombie fired quintuple frost barrage!');
            zombie.shootCooldown = 2.5; // Shoot every 2.5 seconds
          }
        }

        // Animate ice particles around the boss
        zombie.mesh.traverse((child) => {
          if (child instanceof THREE.Mesh && child.userData.isIceParticle) {
            const idx = child.userData.particleIndex || 0;
            const time = Date.now() * 0.001;
            const angle = time + (idx / 10) * Math.PI * 2;
            child.position.x = Math.cos(angle) * 1.5;
            child.position.z = Math.sin(angle) * 1.5;
            child.rotation.x += 0.05;
            child.rotation.y += 0.03;
          }
          if (child instanceof THREE.Mesh && child.userData.isAura) {
            const time = Date.now() * 0.002;
            const mat = child.material as THREE.MeshBasicMaterial;
            mat.opacity = 0.1 + Math.sin(time) * 0.05;
          }
        });
      } else if (zombie.type === 'healer') {
        // Healer zombie heals nearby zombies 10 HP every second with green aura
        zombie.healCooldown = Math.max(0, zombie.healCooldown - deltaTime);

        // Update the healing aura visual (green circle around healer)
        let healAura = zombie.mesh.children.find(c => c.userData.isHealAura) as THREE.Mesh;
        if (!healAura) {
          // Create the healing aura if it doesn't exist
          const healRange = 8;
          const auraGeo = new THREE.RingGeometry(0, healRange, 32);
          const auraMat = new THREE.MeshBasicMaterial({
            color: 0x00ff00,
            transparent: true,
            opacity: 0.15,
            side: THREE.DoubleSide
          });
          healAura = new THREE.Mesh(auraGeo, auraMat);
          healAura.rotation.x = -Math.PI / 2;
          healAura.position.y = 0.05;
          healAura.userData.isHealAura = true;
          zombie.mesh.add(healAura);
        }

        // Pulse the aura opacity
        const auraMat = healAura.material as THREE.MeshBasicMaterial;
        auraMat.opacity = 0.1 + Math.sin(Date.now() * 0.003) * 0.1;

        if (zombie.healCooldown <= 0) {
          // Find zombies within healing range (8 units)
          const healRange = 8;
          let healsPerformed = 0;

          for (const otherZombie of this.zombies) {
            if (otherZombie !== zombie) {
              const distance = zombie.position.distanceTo(otherZombie.position);
              if (distance <= healRange) {
                // Heal for 10 HP every second, but don't exceed max health
                const healAmount = 10;
                const oldHealth = otherZombie.health;
                otherZombie.health = Math.min(otherZombie.health + healAmount, otherZombie.maxHealth);
                const actualHeal = otherZombie.health - oldHealth;

                if (actualHeal > 0) {
                  healsPerformed++;

                  // Visual healing effect (smaller, more frequent)
                  const healEffectGeo = new THREE.SphereGeometry(0.25, 8, 8);
                  const healEffectMat = new THREE.MeshBasicMaterial({
                    color: 0x00ff00,
                    transparent: true,
                    opacity: 0.6
                  });
                  const healEffect = new THREE.Mesh(healEffectGeo, healEffectMat);
                  healEffect.position.copy(otherZombie.position);
                  healEffect.position.y = 1;
                  this.scene.add(healEffect);

                  // Animate healing effect (faster animation)
                  let scale = 0.3;
                  let opacity = 0.6;
                  const healInterval = setInterval(() => {
                    scale += 0.15;
                    opacity -= 0.12;
                    healEffect.scale.set(scale, scale, scale);
                    if (healEffectMat instanceof THREE.MeshBasicMaterial) {
                      healEffectMat.opacity = opacity;
                    }
                    if (opacity <= 0) {
                      this.scene.remove(healEffect);
                      clearInterval(healInterval);
                    }
                  }, 40);
                }
              }
            }
          }

          if (healsPerformed > 0) {
            console.log(`Healer zombie healed ${healsPerformed} zombie(s) for 10 HP!`);
          }

          zombie.healCooldown = 1; // Heal every 1 second
        }
      } else if (zombie.type === 'fat') {
        // Fat zombie explosion countdown
        if (zombie.userData.explodeTimer !== undefined) {
          zombie.userData.explodeTimer -= deltaTime;

          // Visual warning - pulse the zombie bigger
          const pulseScale = 1 + Math.sin(Date.now() * 0.01) * 0.1;
          zombie.mesh.scale.set(pulseScale, pulseScale, pulseScale);

          if (zombie.userData.explodeTimer <= 0) {
            // EXPLODE! Deal 200 damage in 3x3 area
            console.log(`💥 Fat zombie EXPLODED!`);

            // Create explosion visual
            const explosionGeo = new THREE.SphereGeometry(3, 16, 16);
            const explosionMat = new THREE.MeshBasicMaterial({
              color: 0xff4400,
              transparent: true,
              opacity: 0.8
            });
            const explosion = new THREE.Mesh(explosionGeo, explosionMat);
            explosion.position.copy(zombie.position);
            explosion.position.y = 1;
            this.scene.add(explosion);

            // Animate explosion
            let scale = 0.1;
            let opacity = 0.8;
            const explodeInterval = setInterval(() => {
              scale += 0.3;
              opacity -= 0.1;
              explosion.scale.set(scale, scale, scale);
              explosionMat.opacity = opacity;
              if (opacity <= 0) {
                this.scene.remove(explosion);
                clearInterval(explodeInterval);
              }
            }, 50);

            // Damage all plants in 3x3 area (3 units radius)
            for (const plant of this.placedPlants) {
              const distance = zombie.position.distanceTo(plant.position);
              if (distance < 3) {
                plant.health -= 200;
                console.log(`💥 Explosion hit ${plant.type}! Health: ${plant.health}`);
              }
            }

            // Kill the fat zombie after explosion
            zombie.health = 0;
          }
        }
      } else if (zombie.type === 'fire') {
        // Fire zombie visual effects - animate flames
        zombie.mesh.traverse((child) => {
          if (child instanceof THREE.Mesh && child.userData.isFlame) {
            const time = Date.now() * 0.005;
            const idx = child.userData.flameIndex || 0;
            child.scale.y = 1 + Math.sin(time + idx) * 0.3;
            child.position.y += Math.sin(time * 2 + idx) * 0.01;
          }
        });
      } else if (zombie.type === 'green-dragon' || zombie.type === 'red-dragon') {
        // Dragon fireball shooting
        zombie.shootCooldown = Math.max(0, zombie.shootCooldown - deltaTime);
        if (zombie.shootCooldown <= 0 && this.placedPlants.length > 0) {
          let nearestPlant: Plant | null = null;
          let minDist = Infinity;
          for (const plant of this.placedPlants) {
            if (plant.health <= 0) continue;
            const dist = zombie.position.distanceTo(plant.position);
            if (dist < minDist) {
              minDist = dist;
              nearestPlant = plant;
            }
          }
          if (nearestPlant) {
            const fireballDamage = zombie.type === 'red-dragon' ? 750 : 300;
            this.shootDragonFireball(zombie.position, nearestPlant.position, fireballDamage);
            zombie.shootCooldown = zombie.type === 'red-dragon' ? 4 : 5;
          }
        }
      }

      // Dragon wing animation + hover bob
      if (zombie.type === 'blue-dragon' || zombie.type === 'green-dragon' || zombie.type === 'red-dragon') {
        const time = Date.now() * 0.003;
        const leftWing = zombie.mesh.userData.leftWing as THREE.Mesh | undefined;
        const rightWing = zombie.mesh.userData.rightWing as THREE.Mesh | undefined;
        if (leftWing) leftWing.rotation.x = -0.4 + Math.sin(time) * 0.3;
        if (rightWing) rightWing.rotation.x = 0.4 - Math.sin(time) * 0.3;

        // Hover bob - dragons float slightly up and down
        const bobSpeed = zombie.type === 'red-dragon' ? 0.7 : 1.0;
        const bobAmount = zombie.type === 'red-dragon' ? 0.15 : 0.1;
        zombie.mesh.position.y = 0.75 + Math.sin(time * bobSpeed) * bobAmount;

        // Gentle body sway
        zombie.mesh.rotation.z = Math.sin(time * 0.8) * 0.03;

        // Red dragon flame spine animation
        if (zombie.type === 'red-dragon') {
          zombie.mesh.traverse((child) => {
            if (child instanceof THREE.Mesh && child.userData.isFlame) {
              child.scale.y = 1 + Math.sin(time * 2 + child.position.x) * 0.4;
              child.position.y += Math.sin(time * 3) * 0.005;
            }
          });
        }
      }

      // Check for nearby allies to eat first (allies block zombies just like plants)
      zombie.isEating = false;
      zombie.targetPlant = null;

      // Check allies first - zombies will stop to eat allies before plants
      for (const ally of this.allies) {
        const distance = zombie.position.distanceTo(ally.position);
        const sameLane = Math.abs(zombie.position.z - ally.spawnZ) < 1;
        // Zombie must be behind ally (zombie.x > ally.x since zombies move left)
        if (sameLane && distance < 1.2 && zombie.position.x > ally.position.x - 0.5) {
          // Car/Dragon zombie crushes allies
          if (zombie.type === 'car' || zombie.type === 'super-car' || zombie.type === 'blue-dragon' || zombie.type === 'green-dragon' || zombie.type === 'red-dragon') {
            ally.health = 0;
            console.log(`${zombie.type} zombie CRUSHED ${ally.type} ally!`);
            continue;
          } else if (zombie.type === 'grape-gun' || zombie.type === 'frost-grape-gun') {
            // Grape-gun zombies don't eat, only shoot
            continue;
          } else {
            // Normal zombie stops to eat the ally
            zombie.isEating = true;
            zombie.targetPlant = null; // Not eating a plant
            ally.isBeingEaten = true;

            // Attack the ally
            if (zombie.attackCooldown <= 0) {
              ally.health -= zombie.attackDamage;
              zombie.attackCooldown = 1; // Attack every 1 second
              console.log(`${zombie.type} zombie eating ${ally.type} ally! Health: ${ally.health}`);
            }
            break;
          }
        }
      }

      // Only check plants if not eating an ally
      if (!zombie.isEating) {
        for (const plant of this.placedPlants) {
          const distance = zombie.position.distanceTo(plant.position);
          if (distance < 1.2) {
            // Car/Dragon zombie crushing mechanic
            if (zombie.type === 'car' || zombie.type === 'super-car' || zombie.type === 'blue-dragon' || zombie.type === 'green-dragon' || zombie.type === 'red-dragon') {
              if (!plant.antiCrush) {
                // Instantly crush the plant!
                plant.health = 0;
                console.log(`${zombie.type} CRUSHED ${plant.type}!`);
                // Don't stop - keeps moving through non-anti-crush plants
                continue;
              } else {
                // Can't crush this plant - bounce back!
                const currentTime = Date.now();
                if (currentTime - zombie.lastBounceTime > 500) { // Bounce cooldown of 0.5 seconds
                  // Super Car deals 300, regular car 150, dragons 800
                  const crushDamage = (zombie.type === 'blue-dragon' || zombie.type === 'green-dragon' || zombie.type === 'red-dragon') ? 800 : (zombie.type === 'super-car' ? 300 : 150);
                  plant.health -= crushDamage;
                  console.log(`${zombie.type} zombie BOUNCED off anti-crush ${plant.type}! Dealt ${crushDamage} damage. Health: ${plant.health}`);

                  // Move the car zombie back one tile (2 units to the right)
                  zombie.position.x += 2;
                  zombie.mesh.position.x += 2;

                  // Update last bounce time
                  zombie.lastBounceTime = currentTime;
                }
                // Don't eat, keep moving (will move forward again)
                continue;
              }
            } else if (zombie.type === 'grape-gun' || zombie.type === 'frost-grape-gun') {
              // Grape-gun zombies don't eat, only shoot - keep moving
              continue;
            } else if (zombie.type === 'fat') {
              // Fat zombie stops and prepares to explode
              if (!zombie.userData.explodeTimer) {
                zombie.userData.explodeTimer = 2; // 2 second countdown
                zombie.isEating = true; // Stops movement
                console.log(`💣 Fat zombie preparing to explode!`);
              }
              break;
            } else {
              // Normal zombie behavior
              zombie.isEating = true;
              zombie.targetPlant = plant;

              // Attack the plant
              if (zombie.attackCooldown <= 0) {
                // Check for pineapple bunker protection first!
                if (plant.pineappleBunker && plant.pineappleBunker.health > 0) {
                  // Damage the pineapple bunker instead of the plant
                  plant.pineappleBunker.health -= zombie.attackDamage;
                  console.log(`🍍 Zombie eating pineapple bunker! Bunker HP: ${plant.pineappleBunker.health}/${plant.pineappleBunker.maxHealth}`);

                  // Visual shake on the pineapple mesh
                  if (plant.pineappleBunker.mesh) {
                    plant.pineappleBunker.mesh.rotation.z = (Math.random() - 0.5) * 0.2;
                    setTimeout(() => {
                      if (plant.pineappleBunker && plant.pineappleBunker.mesh) {
                        plant.pineappleBunker.mesh.rotation.z = 0;
                      }
                    }, 100);
                  }

                  // Check if pineapple bunker is destroyed
                  if (plant.pineappleBunker.health <= 0) {
                    console.log(`🍍💥 Pineapple bunker destroyed!`);
                    // Remove the pineapple mesh from scene
                    if (plant.pineappleBunker.mesh) {
                      this.scene.remove(plant.pineappleBunker.mesh);
                    }
                    plant.pineappleBunker = null;
                  }
                } else {
                  // No bunker, damage plant directly
                  // Check if a nearby kiwi-blocker can tank this damage
                  // Only one kiwi blocker can protect a plant, and kiwi blockers don't protect each other
                  let kiwiBlocker: Plant | null = null;
                  if (plant.type !== 'kiwi-blocker') {
                    // Find the single closest kiwi-blocker in 3x3 range
                    let closestDist = Infinity;
                    for (const p of this.placedPlants) {
                      if (p.type === 'kiwi-blocker' && p.health > 0) {
                        const dx = Math.abs(p.position.x - plant.position.x);
                        const dz = Math.abs(p.position.z - plant.position.z);
                        if (dx <= 2 && dz <= 2) {
                          const dist = dx + dz;
                          if (dist < closestDist) {
                            closestDist = dist;
                            kiwiBlocker = p;
                          }
                        }
                      }
                    }
                  }

                  if (kiwiBlocker) {
                    // Kiwi blocker absorbs the damage instead - split between kiwi and plant
                    // Kiwi takes 80% of damage, plant still takes 20%
                    const kiwiDmg = Math.floor(zombie.attackDamage * 0.8);
                    const plantDmg = zombie.attackDamage - kiwiDmg;
                    kiwiBlocker.health -= kiwiDmg;
                    plant.health -= plantDmg;
                    console.log(`🥝 Kiwi Blocker tanked ${kiwiDmg} damage for ${plant.type}! Kiwi HP: ${kiwiBlocker.health}`);
                  } else {
                    plant.health -= zombie.attackDamage;
                  }

                  // Fire zombie applies burn effect on bite
                  if (zombie.type === 'fire') {
                    plant.burnStacks.push({
                      damage: 5, // 5 damage per tick
                      duration: 5, // 5 seconds total
                      tickTimer: 0 // Ticks every 2 seconds
                    });
                    console.log(`🔥 Fire zombie set ${plant.type} on fire! Burn stacks: ${plant.burnStacks.length}`);
                  } else {
                    console.log(`${zombie.type} zombie eating ${plant.type}! Health: ${plant.health}`);
                  }
                }

                zombie.attackCooldown = 1; // Attack every 1 second
                // Visual feedback handled in eating animation below
              }

              break;
            }
          }
        }
      }

      // Only move if not eating
      if (!zombie.isEating) {
        // CAR ZOMBIES - Special vehicle animation (no walking!)
        if (zombie.type === 'car' || zombie.type === 'super-car') {
          zombie.walkCycle += deltaTime * 3;
          const driveCycle = zombie.walkCycle;

          // Wheels spinning animation - find wheel meshes and rotate them
          zombie.mesh.children.forEach(child => {
            if (child.userData && child.userData.isWheel) {
              child.rotation.z -= deltaTime * 15; // Spin wheels fast
            }
          });

          // Car bouncing/suspension animation
          const bounceAmount = zombie.type === 'super-car' ? 0.08 : 0.05;
          zombie.mesh.position.y = 0.5 + Math.sin(driveCycle * 8) * bounceAmount;

          // Slight tilt based on "road bumps"
          zombie.mesh.rotation.z = Math.sin(driveCycle * 6) * 0.03;
          zombie.mesh.rotation.x = Math.sin(driveCycle * 4) * 0.02;

          // Car faces forward (toward plants)
          zombie.mesh.rotation.y = -Math.PI / 2;

          // Engine rumble effect - subtle vibration
          const rumble = Math.sin(driveCycle * 20) * 0.01;
          zombie.mesh.position.z = zombie.position.z + rumble;

          // Move car - no speed variation, cars move smoothly
          zombie.position.x -= zombie.speed * deltaTime;
          zombie.mesh.position.x = zombie.position.x;

          // Safety clamp
          zombie.position.z = Math.max(-8, Math.min(0, zombie.position.z));
          zombie.mesh.position.z = zombie.position.z + rumble;
        } else {
          // SMOOTH ZOMBIE WALK ANIMATION
          zombie.walkCycle += deltaTime * 2.0; // Smooth walk speed

          // Walk cycle varies by zombie type
          const walkSpeed = zombie.type === 'fast' ? 4.0 : (zombie.type === 'tank' ? 2.0 : 3.0);
          const cycle = zombie.walkCycle * walkSpeed;

          // Smooth easing function for natural movement
          const smoothSin = (t: number) => Math.sin(t) * 0.5 + 0.5;
          const smoothCos = (t: number) => Math.cos(t) * 0.5 + 0.5;

          // ARMS - smooth swinging motion synced with legs
          if (zombie.leftArm && zombie.rightArm) {
            // Arms swing opposite to legs for natural walk
            const leftArmSwing = Math.sin(cycle) * 0.4;
            const rightArmSwing = Math.sin(cycle + Math.PI) * 0.4;

            // Smooth arm rotation - forward/back swing
            zombie.leftArm.rotation.x = -0.8 + leftArmSwing;
            zombie.rightArm.rotation.x = -0.8 + rightArmSwing;

            // Slight outward angle
            zombie.leftArm.rotation.z = 0.15;
            zombie.rightArm.rotation.z = -0.15;
          }

          // LEGS - smooth walking gait
          if (zombie.leftLeg && zombie.rightLeg) {
            // Legs swing opposite to each other
            const leftLegSwing = Math.sin(cycle) * 0.5;
            const rightLegSwing = Math.sin(cycle + Math.PI) * 0.5;

            zombie.leftLeg.rotation.x = leftLegSwing;
            zombie.rightLeg.rotation.x = rightLegSwing;
          }

          // BODY MOVEMENT - gentle bob and sway
          const bobAmount = zombie.type === 'tank' ? 0.03 : 0.05;
          const swayAmount = zombie.type === 'tiny' ? 0.04 : 0.03;

          // Smooth up/down bob synced with steps (double frequency)
          const bobPhase = Math.abs(Math.sin(cycle * 2));
          zombie.mesh.position.y = 0.75 + bobPhase * bobAmount;

          // Gentle side-to-side sway
          zombie.mesh.rotation.z = Math.sin(cycle) * swayAmount;

          // Slight forward lean
          zombie.mesh.rotation.x = 0.1;

          // Face direction of movement
          zombie.mesh.rotation.y = -Math.PI / 2;

          // Smooth movement
          zombie.position.x -= zombie.speed * deltaTime;
          zombie.mesh.position.x = zombie.position.x;

          // Safety clamp - keep zombies within lawn boundaries
          zombie.position.z = Math.max(-8, Math.min(0, zombie.position.z));
          zombie.mesh.position.z = zombie.position.z;
        }
      } else {
        // SMOOTH EATING ANIMATION
        const eatTime = Date.now() * 0.004; // Slower for smoother motion
        const eatCycle = Math.sin(eatTime * 3);
        const eatCycle2 = Math.sin(eatTime * 3 + Math.PI * 0.5);

        // Arms reach forward and pull back smoothly
        if (zombie.leftArm && zombie.rightArm) {
          // Coordinated arm movement - reaching and pulling
          zombie.leftArm.rotation.x = -1.0 + eatCycle * 0.25;
          zombie.rightArm.rotation.x = -1.0 + eatCycle2 * 0.25;

          // Arms stay relatively steady while eating
          zombie.leftArm.rotation.z = 0.2;
          zombie.rightArm.rotation.z = -0.2;
        }

        // Smooth head bob while eating
        zombie.mesh.rotation.x = 0.2 + Math.abs(eatCycle) * 0.1;

        // Face the plant
        zombie.mesh.rotation.y = -Math.PI / 2;

        // Gentle body movement
        zombie.mesh.position.y = 0.75 + Math.abs(eatCycle) * 0.04;

        // Minimal sway
        zombie.mesh.rotation.z = eatCycle * 0.03;
      }

      // Check if zombie reached the houses
      if (zombie.position.x < -10) {
        if (!this.gameOver) {
          if (this.isIZombieMode) {
            // In I Zombie mode, reaching the left is VICTORY!
            console.log('🧟 Zombie reached the house! YOU WIN!');
            this.showIZombieVictory();
          } else {
            console.log('Zombie reached the house! Game Over!');
            this.showGameOver();
          }
        }
        // Don't remove the zombie - let it stay there
      }
      // Death check is now handled at the start of the loop
    }
  }

  // Restore zombie colors based on type after unfreezing
  private restoreZombieColors(zombie: Zombie, child: THREE.Mesh): void {
    if (!(child.material instanceof THREE.MeshPhongMaterial)) return;

    // Get original colors based on zombie type
    let skinColor = 0x8fbc8f;
    let clothesColor = 0x4a4a4a;

    switch (zombie.type) {
      case 'fast':
        skinColor = 0xc9a0a0;
        clothesColor = 0x8b0000;
        break;
      case 'tank':
        skinColor = 0x808080;
        clothesColor = 0x2f4f4f;
        break;
      case 'tiny':
        skinColor = 0xd8bfd8;
        clothesColor = 0x663399;
        break;
      case 'fire':
        skinColor = 0xff6b35;
        clothesColor = 0x8b0000;
        break;
      case 'fat':
        skinColor = 0xa0a060;
        clothesColor = 0x4a4a2a;
        break;
      case 'grave':
        skinColor = 0x5a5a5a;
        clothesColor = 0x2f2f2f;
        break;
      case 'healer':
        skinColor = 0x90ee90;
        clothesColor = 0x228b22;
        break;
      default:
        skinColor = 0x8fbc8f;
        clothesColor = 0x4a4a4a;
    }

    // Check the current ice blue color and restore appropriate original color
    const currentColor = child.material.color.getHex();
    if (currentColor === 0x87ceeb || currentColor === 0x00bfff || currentColor === 0xadd8e6) {
      // This was frozen - restore based on material's position/properties
      // Default to skin color, clothes color will be handled by other checks
      child.material.color.setHex(skinColor);
    }
  }

  private updatePlants(deltaTime: number): void {
    for (let i = this.placedPlants.length - 1; i >= 0; i--) {
      const plant = this.placedPlants[i];
      plant.cooldown = Math.max(0, plant.cooldown - deltaTime);
      plant.animationTime += deltaTime;

      // Animate plants
      this.animatePlant(plant);

      // Process burn stacks from fire zombie
      if (plant.burnStacks.length > 0) {
        for (let j = plant.burnStacks.length - 1; j >= 0; j--) {
          const burn = plant.burnStacks[j];
          burn.tickTimer += deltaTime;
          burn.duration -= deltaTime;

          // Deal burn damage every 2 seconds
          if (burn.tickTimer >= 2) {
            plant.health -= burn.damage;
            burn.tickTimer = 0;
            console.log(`🔥 Burn damage: ${plant.type} takes ${burn.damage} damage! Health: ${plant.health}`);
          }

          // Remove expired burn stacks
          if (burn.duration <= 0) {
            plant.burnStacks.splice(j, 1);
          }
        }

        // Visual burn effect - add fire particles if not already present
        if (!plant.userData.burnEffect) {
          const fireGeo = new THREE.ConeGeometry(0.15, 0.4, 6);
          const fireMat = new THREE.MeshBasicMaterial({
            color: 0xff4400,
            transparent: true,
            opacity: 0.7
          });
          const fireParticle = new THREE.Mesh(fireGeo, fireMat);
          fireParticle.position.set(0, 1.5, 0);
          plant.mesh.add(fireParticle);
          plant.userData.burnEffect = fireParticle;
        } else {
          // Animate fire
          const fire = plant.userData.burnEffect as THREE.Mesh;
          fire.rotation.y += deltaTime * 5;
          fire.scale.y = 1 + Math.sin(Date.now() * 0.01) * 0.3;
        }
      } else if (plant.userData.burnEffect) {
        // Remove burn effect when no more burn stacks
        plant.mesh.remove(plant.userData.burnEffect);
        plant.userData.burnEffect = null;
      }

      // Check if plant is dead
      if (plant.health <= 0) {
        // Check if it's an acorn-bomb - explode on death!
        if (plant.type === 'acorn-bomb') {
          // Deal 50 damage to all zombies in 1.5 tile range
          const explosionRange = 3; // 1.5 tiles = 3 units
          this.zombies.forEach(zombie => {
            const dist = zombie.position.distanceTo(plant.position);
            if (dist <= explosionRange) {
              zombie.health -= 50;
              console.log('Acorn Bomb explosion hit zombie for 50 damage!');
            }
          });

          // Create explosion effect
          const explGeo = new THREE.SphereGeometry(1.5, 16, 16);
          const explMat = new THREE.MeshBasicMaterial({
            color: 0xff6600,
            transparent: true,
            opacity: 0.8
          });
          const explosion = new THREE.Mesh(explGeo, explMat);
          explosion.position.copy(plant.position);
          explosion.position.y = 0.5;
          explosion.scale.set(0.3, 0.3, 0.3);
          this.scene.add(explosion);

          // Animate explosion
          let explScale = 0.3;
          let explOpacity = 0.8;
          const explInterval = setInterval(() => {
            explScale += 0.25;
            explOpacity -= 0.12;
            explosion.scale.set(explScale, explScale, explScale);
            if (explMat instanceof THREE.MeshBasicMaterial) {
              explMat.opacity = explOpacity;
            }
            if (explOpacity <= 0) {
              this.scene.remove(explosion);
              clearInterval(explInterval);
            }
          }, 40);

          console.log('BOOM! Acorn Bomb exploded!');
        }

        this.scene.remove(plant.mesh);
        this.placedPlants.splice(i, 1);

        // Free up the slot(s)
        if (plant.isTitan) {
          // Titan plants occupy two slots - position is between them
          // Titan is at position like (1, -4) which is between slots (0, -4) and (2, -4)
          const leftSlotX = Math.round(plant.position.x - 1);
          const rightSlotX = Math.round(plant.position.x + 1);
          const slotZ = Math.round(plant.position.z / 2) * 2;

          const leftKey = `${leftSlotX},${slotZ}`;
          const rightKey = `${rightSlotX},${slotZ}`;

          this.plantSlots.set(leftKey, false);
          this.plantSlots.set(rightKey, false);
          this.showSlotIndicator(leftSlotX, slotZ);
          this.showSlotIndicator(rightSlotX, slotZ);
        } else {
          // Regular plant - free single slot
          const slotKey = `${plant.position.x},${plant.position.z}`;
          this.plantSlots.set(slotKey, false);
          this.showSlotIndicator(plant.position.x, plant.position.z);
        }

        // If the dead plant is the power plant, clear the reference
        if (plant === this.powerPlant) {
          this.powerPlant = null;
        }

        console.log(`${plant.type} was eaten!`);
        continue;
      }

      switch (plant.type) {
        case 'grape-launcher':
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            // Find nearest zombie in the same row
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              console.log(`🍇 Grape launcher at z=${plant.position.z.toFixed(1)} firing at zombie at z=${nearestZombie.position.z.toFixed(1)}, x=${nearestZombie.position.x.toFixed(1)}`);
              this.shootGrape(plant.position, nearestZombie.position);
              plant.cooldown = 2; // 2 second cooldown
            }
          }
          break;

        case 'grape-wall':
          // Fusion plant: shoots weaker grapes but has wall health
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootGrape(plant.position, nearestZombie.position, 23); // Weaker grapes (23 damage, 1.5x)
              plant.cooldown = 2.5; // Slightly longer cooldown
            }
          }
          break;

        case 'lily':
          // Only produce sun when wave has started
          if (this.waveStarted) {
            plant.sunProductionTimer += deltaTime;
            if (plant.sunProductionTimer >= 10) {
              // Spawn visual sun from lily position
              this.spawnFallingSun(plant.position.x, plant.position.z, true);
              plant.sunProductionTimer = 0;

              // Animate lily (bounce up)
              const originalY = plant.mesh.position.y;
              plant.mesh.position.y = originalY + 0.3;
              setTimeout(() => {
                if (plant.mesh) plant.mesh.position.y = originalY;
              }, 200);

              console.log('Lily produced sun!');
            }
          }
          break;

        case 'lilyer':
          // Lilyer - produces BIG sun (100 sun) every 7 seconds
          if (this.waveStarted) {
            plant.sunProductionTimer += deltaTime;
            if (plant.sunProductionTimer >= 7) {
              // Spawn BIG sun worth 100
              this.spawnBigSun(plant.position.x, plant.position.z);
              plant.sunProductionTimer = 0;

              // Animate lilyer (bounce up with glow)
              const originalY = plant.mesh.position.y;
              plant.mesh.position.y = originalY + 0.4;
              setTimeout(() => {
                if (plant.mesh) plant.mesh.position.y = originalY;
              }, 200);

              console.log('Lilyer produced BIG sun (100)!');
            }
          }
          break;

        case 'lilyest':
          // Lilyest - produces BLUE sun (300 sun) every 10 seconds
          if (this.waveStarted) {
            plant.sunProductionTimer += deltaTime;
            if (plant.sunProductionTimer >= 10) {
              // Spawn BLUE sun worth 300
              this.spawnBlueSun(plant.position.x, plant.position.z);
              plant.sunProductionTimer = 0;

              // Animate lilyest (bounce up with magical effect)
              const originalY = plant.mesh.position.y;
              plant.mesh.position.y = originalY + 0.5;
              setTimeout(() => {
                if (plant.mesh) plant.mesh.position.y = originalY;
              }, 200);

              console.log('Lilyest produced BLUE sun (300)!');
            }
          }
          break;

        case 'grape-lily':
          // Fusion plant: shoots sun grapes that give 5 sun when they hit zombies
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootSunGrape(plant.position, nearestZombie.position);
              plant.cooldown = 2; // Same as grape launcher
            }
          }
          break;

        case 'pear-launcher':
          // Fusion plant: auto-fires pears with long cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootPearProjectile(plant, nearestZombie);
              plant.cooldown = 10; // Long cooldown like pear cannon
            }
          }
          break;

        case 'avocado-slammer':
          // Slams all zombies within 2 tiles (4 units = 2 tiles)
          if (plant.cooldown <= 0) {
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 4; // 2 tiles = 4 units
            });

            if (zombiesInRange.length > 0) {
              this.performSlam(plant, zombiesInRange);
              plant.cooldown = 4; // Medium cooldown (4 seconds)
            }
          }
          break;

        case 'elder-frost-berri':
          // Delayed-use plant: after 1 second, freezes zombies for 20 seconds and disappears
          if (plant.cooldown <= 0) {
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 6; // 3 tiles = 6 units
            });

            if (zombiesInRange.length > 0) {
              this.performFrostFreeze(plant, zombiesInRange, true); // true = elder version (20 second freeze)
              console.log(`ELDER Frost Berri activated! Froze ${zombiesInRange.length} zombies for 20 SECONDS!`);
            } else {
              console.log('Elder Frost Berri activated but no zombies in range.');
            }

            // Mark plant for removal
            plant.health = 0;
          }
          break;

        case 'frost-berri':
          // Delayed-use plant: after 1 second, freezes zombies and disappears
          if (plant.cooldown <= 0) {
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 6; // 3 tiles = 6 units
            });

            if (zombiesInRange.length > 0) {
              this.performFrostFreeze(plant, zombiesInRange);
              console.log(`Frost Berri activated! Froze ${zombiesInRange.length} zombies!`);
            } else {
              console.log('Frost Berri activated but no zombies in range.');
            }

            // Mark plant for removal
            plant.health = 0;
          }
          break;

        case 'roots':
          // TRAP - Waits on ground, stuns zombie that touches it for 5 seconds, then disappears
          {
            // Check if any zombie is touching the roots
            const touchingZombie = this.zombies.find(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 1.5 && !z.rooted; // Close enough to trigger, and not already rooted
            });

            if (touchingZombie) {
              // Root this zombie
              touchingZombie.rooted = true;
              touchingZombie.rootedTimer = 5; // Stun for 5 seconds

              // Visual effect - add brown/green tint to zombie
              touchingZombie.mesh.children.forEach(child => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
                  child.material = new THREE.MeshPhongMaterial({
                    color: 0x5c4033, // Brown root color
                    emissive: 0x228b22,
                    emissiveIntensity: 0.3
                  });
                }
              });

              // Create root tendrils around zombie
              for (let r = 0; r < 6; r++) {
                const rootGeo = new THREE.CylinderGeometry(0.05, 0.1, 0.8, 6);
                const rootMat = new THREE.MeshPhongMaterial({
                  color: 0x8b4513,
                  emissive: 0x2e8b57,
                  emissiveIntensity: 0.4
                });
                const root = new THREE.Mesh(rootGeo, rootMat);
                const angle = (r / 6) * Math.PI * 2;
                root.position.set(
                  touchingZombie.position.x + Math.cos(angle) * 0.4,
                  0.4,
                  touchingZombie.position.z + Math.sin(angle) * 0.4
                );
                root.rotation.z = -Math.cos(angle) * 0.5;
                root.rotation.x = Math.sin(angle) * 0.5;
                root.userData.isRootTendril = true;
                root.userData.zombieId = touchingZombie.mesh.uuid;
                this.scene.add(root);
              }

              // Create activation burst effect
              const burstGeo = new THREE.RingGeometry(0.1, 1.5, 24);
              const burstMat = new THREE.MeshBasicMaterial({
                color: 0x228b22,
                transparent: true,
                opacity: 0.7,
                side: THREE.DoubleSide
              });
              const burst = new THREE.Mesh(burstGeo, burstMat);
              burst.rotation.x = -Math.PI / 2;
              burst.position.set(plant.position.x, 0.1, plant.position.z);
              this.scene.add(burst);

              // Remove effect after animation
              setTimeout(() => {
                this.scene.remove(burst);
              }, 500);

              console.log(`Roots triggered! Stunned zombie for 5 seconds!`);

              // Mark plant for removal after triggering
              plant.health = 0;
            }
          }
          break;

        case 'onion-flier':
          // Flying onion bomber - flies over zombies to drop 3 bombs!
          // 3 second cooldown, 50 damage per bomb with splash
          if (!plant.userData) plant.userData = {};
          if (plant.userData.flyState === undefined) {
            plant.userData.flyState = 'idle'; // idle, flying, bombing, returning
            plant.userData.flyTargetX = 0;
            plant.userData.flyTargetZ = 0;
            plant.userData.homeX = plant.position.x;
            plant.userData.homeZ = plant.position.z;
            plant.userData.bombsDropped = 0;
          }

          // Animate propeller always
          plant.mesh.children.forEach(child => {
            if (child.userData && child.userData.isPropeller) {
              child.rotation.y += plant.userData.flyState === 'flying' ? 0.8 : 0.4;
            }
          });

          // Gentle hovering motion
          plant.mesh.position.y = Math.sin(Date.now() * 0.004) * 0.12;

          // Always face toward enemies (positive X)
          if (plant.userData.flyState === 'idle') {
            plant.mesh.rotation.y = 0; // Face +X where zombies spawn
          }

          if (plant.userData.flyState === 'idle' && this.waveStarted && plant.cooldown <= 0) {
            // Find best zombie group to bomb
            let bestTarget: { x: number; z: number; count: number } | null = null;
            let maxZombies = 0;

            for (let x = -4; x <= 14; x += 2) {
              for (let z = -8; z <= 0; z += 2) {
                const zombiesHere = this.zombies.filter(zombie => {
                  const dx = zombie.position.x - x;
                  const dz = zombie.position.z - z;
                  return Math.sqrt(dx * dx + dz * dz) <= 2.0;
                }).length;

                if (zombiesHere > maxZombies) {
                  maxZombies = zombiesHere;
                  bestTarget = { x, z, count: zombiesHere };
                }
              }
            }

            if (bestTarget && bestTarget.count > 0) {
              plant.userData.flyState = 'flying';
              plant.userData.flyTargetX = bestTarget.x;
              plant.userData.flyTargetZ = bestTarget.z;
              plant.userData.bombsDropped = 0;
            }
          } else if (plant.userData.flyState === 'flying') {
            // Fly toward target
            const dx = plant.userData.flyTargetX - plant.mesh.position.x;
            const dz = plant.userData.flyTargetZ - plant.mesh.position.z;
            const dist = Math.sqrt(dx * dx + dz * dz);

            // Face direction of travel
            plant.mesh.rotation.y = Math.atan2(-dz, dx);

            if (dist > 0.5) {
              const speed = 0.2;
              plant.mesh.position.x += (dx / dist) * speed;
              plant.mesh.position.z += (dz / dist) * speed;
            } else {
              // Arrived! Start bombing!
              plant.userData.flyState = 'bombing';
              plant.userData.bombTimer = 0;
            }
          } else if (plant.userData.flyState === 'bombing') {
            // Drop 3 bombs with slight delay between each
            plant.userData.bombTimer = (plant.userData.bombTimer || 0) + deltaTime;

            if (plant.userData.bombTimer >= 0.15 && plant.userData.bombsDropped < 3) {
              plant.userData.bombTimer = 0;
              plant.userData.bombsDropped++;

              // Bomb offset positions (spread pattern)
              const offsets = [
                { x: 0, z: 0 },
                { x: -0.8, z: -0.5 },
                { x: 0.8, z: 0.5 }
              ];
              const offset = offsets[plant.userData.bombsDropped - 1];
              const bombX = plant.userData.flyTargetX + offset.x;
              const bombZ = plant.userData.flyTargetZ + offset.z;

              // Create falling bomb
              const bombGeo = new THREE.SphereGeometry(0.1, 10, 10);
              const bombMat = new THREE.MeshPhongMaterial({ color: 0x1a1a1a, shininess: 100 });
              const bomb = new THREE.Mesh(bombGeo, bombMat);
              bomb.position.set(plant.mesh.position.x, 1.8, plant.mesh.position.z);
              this.scene.add(bomb);

              // Animate bomb falling
              let bombFall = 0;
              const finalBombX = bombX;
              const finalBombZ = bombZ;
              const startX = plant.mesh.position.x;
              const startZ = plant.mesh.position.z;

              const bombInterval = setInterval(() => {
                bombFall += 0.1;
                if (bombFall >= 1) {
                  clearInterval(bombInterval);
                  this.scene.remove(bomb);

                  // Explosion with splash!
                  const explosionGeo = new THREE.SphereGeometry(1.5, 12, 12);
                  const explosionMat = new THREE.MeshBasicMaterial({
                    color: 0xff6600,
                    transparent: true,
                    opacity: 0.7
                  });
                  const explosion = new THREE.Mesh(explosionGeo, explosionMat);
                  explosion.position.set(finalBombX, 0.3, finalBombZ);
                  this.scene.add(explosion);

                  // 50 damage splash to zombies in radius
                  const splashRadius = 1.5;
                  for (const zombie of this.zombies) {
                    const zx = zombie.position.x - finalBombX;
                    const zz = zombie.position.z - finalBombZ;
                    const zDist = Math.sqrt(zx * zx + zz * zz);
                    if (zDist <= splashRadius) {
                      zombie.health -= 50;
                    }
                  }

                  setTimeout(() => this.scene.remove(explosion), 200);
                } else {
                  // Arc toward target
                  bomb.position.x = startX + (finalBombX - startX) * bombFall;
                  bomb.position.z = startZ + (finalBombZ - startZ) * bombFall;
                  bomb.position.y = 1.8 - bombFall * 1.5;
                  bomb.rotation.x += 0.15;
                }
              }, 25);
            }

            // After dropping all 3 bombs, return home
            if (plant.userData.bombsDropped >= 3 && plant.userData.bombTimer >= 0.2) {
              plant.userData.flyState = 'returning';
              plant.cooldown = 3; // 3 second cooldown
            }
          } else if (plant.userData.flyState === 'returning') {
            // Fly back home
            const dx = plant.userData.homeX - plant.mesh.position.x;
            const dz = plant.userData.homeZ - plant.mesh.position.z;
            const dist = Math.sqrt(dx * dx + dz * dz);

            // Face direction of travel
            plant.mesh.rotation.y = Math.atan2(-dz, dx);

            if (dist > 0.3) {
              const speed = 0.18;
              plant.mesh.position.x += (dx / dist) * speed;
              plant.mesh.position.z += (dz / dist) * speed;
            } else {
              plant.mesh.position.x = plant.userData.homeX;
              plant.mesh.position.z = plant.userData.homeZ;
              plant.mesh.rotation.y = 0; // Face +X toward enemies
              plant.userData.flyState = 'idle';
            }
          }
          break;

        case 'pickle-picker':
          // Every 8 seconds, teleport a zombie to the beginning
          if (this.waveStarted) {
            plant.sunProductionTimer += deltaTime; // Reuse timer for teleport
            if (plant.sunProductionTimer >= 8) {
              if (this.zombies.length > 0) {
                this.teleportZombie();
                plant.sunProductionTimer = 0;
              }
            }
          }
          break;

        case 'pear-wall':
          // Fusion plant: defensive wall that explodes when attacked
          // Check if being attacked (health decreased recently)
          if (plant.health < plant.maxHealth && plant.cooldown <= 0) {
            // Find zombies near the wall
            const nearbyZombies = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance < 2; // Explosion radius
            });

            if (nearbyZombies.length > 0) {
              this.performPearExplosion(plant, nearbyZombies);
              plant.cooldown = 6; // 6 second cooldown as requested
            }
          }
          break;

        case 'frost-slammer':
          // Fusion plant: slams zombies and slows them by 50% for 5 seconds
          if (plant.cooldown <= 0) {
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 4; // 2 tiles = 4 units
            });

            if (zombiesInRange.length > 0) {
              this.performFrostSlam(plant, zombiesInRange);
              plant.cooldown = 4; // Same cooldown as avocado slammer
            }
          }
          break;

        case 'frost-pear-wall':
          // Fusion plant: explosive frozen wall with freeze chance
          // Check if being attacked (health decreased recently)
          if (plant.health < plant.maxHealth && plant.cooldown <= 0) {
            // Find zombies near the wall
            const nearbyZombies = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance < 2; // Explosion radius
            });

            if (nearbyZombies.length > 0) {
              this.performFrostPearExplosion(plant, nearbyZombies);
              plant.cooldown = 6; // 6 second cooldown as requested
            }
          }
          break;

        case 'strawberry-launcher':
          // Fast shooting plant with low damage
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              // Rotate turret to face the zombie
              const turret = plant.mesh.userData.turret as THREE.Group;
              if (turret) {
                const direction = new THREE.Vector3().subVectors(nearestZombie.position, plant.position);
                const targetAngle = Math.atan2(direction.x, direction.z);
                turret.rotation.y = targetAngle;
              }

              this.shootStrawberry(plant.position, nearestZombie.position);
              plant.cooldown = 0.8; // Very fast cooldown (0.8 seconds)
            }
          }
          break;

        case 'pickle-spiker':
          // Fusion plant: knocks back zombies with higher damage and medium cooldown
          if (plant.cooldown <= 0) {
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 5; // 2.5 tiles = 5 units (increased range)
            });

            if (zombiesInRange.length > 0) {
              this.performPickleKnockback(plant, zombiesInRange);
              plant.cooldown = 12; // 12 second cooldown
            }
          }
          break;

        case 'grape-shot':
          // Fusion plant: shoots 2 grapes in burst with medium cooldown
          // Handle ongoing burst
          if (plant.burstCount > 0) {
            plant.burstDelay -= deltaTime;
            if (plant.burstDelay <= 0 && plant.burstTarget) {
              // Fire next grape in burst
              const offsetY = plant.burstCount === 2 ? 0 : 0.3;
              const shotPos = plant.position.clone();
              shotPos.y += offsetY;
              this.shootGrape(shotPos, plant.burstTarget);
              plant.burstCount--;
              plant.burstDelay = 0.15; // 0.15 seconds between burst shots

              // Burst finished, set main cooldown
              if (plant.burstCount <= 0) {
                plant.cooldown = 2.5;
                plant.burstTarget = null;
              }
            }
          } else if (plant.cooldown <= 0 && this.zombies.length > 0) {
            // Start new burst
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              plant.burstCount = 2;
              plant.burstDelay = 0;
              plant.burstTarget = nearestZombie.position.clone();
            }
          }
          break;

        case 'frost-grape-gun':
          // Exclusive shop plant: shoots 3 frozen grapes with freeze effect
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              // Shoot 3 frozen grapes with offsets
              this.shootFrozenGrape(plant.position, nearestZombie.position);
              const offsetPos1 = plant.position.clone();
              offsetPos1.y += 0.3;
              this.shootFrozenGrape(offsetPos1, nearestZombie.position);
              const offsetPos2 = plant.position.clone();
              offsetPos2.y -= 0.3;
              this.shootFrozenGrape(offsetPos2, nearestZombie.position);
              plant.cooldown = 3; // Medium cooldown (3 seconds)
            }
          }
          break;

        case 'straw-spiker':
          // Odd fusion: shoots tomato spike + strawberry bomb, stuns zombies, places tomato spike
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.fireStrawSpiker(plant, nearestZombie);
              plant.cooldown = 5; // 5 second cooldown
            }
          }
          break;

        case 'rose-reaper':
          // Shop plant: attacks zombies in 3 tile range and heals plant in front
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            // Find zombies in 3 tile range (6 units)
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 6; // 3 tiles = 6 units
            });

            if (zombiesInRange.length > 0) {
              // Attack all zombies in range
              zombiesInRange.forEach(zombie => {
                zombie.health -= 25; // 25 damage

                // Create thorn projectile effect
                const thornGeo = new THREE.ConeGeometry(0.08, 0.3, 6);
                const thornMat = new THREE.MeshPhongMaterial({
                  color: 0x2a5a2a,
                  emissive: 0x1a3a1a,
                  emissiveIntensity: 0.5
                });
                const thorn = new THREE.Mesh(thornGeo, thornMat);
                thorn.position.copy(plant.position);
                thorn.position.y = 1.5;
                this.scene.add(thorn);

                // Animate thorn to zombie
                const targetPos = zombie.position.clone();
                targetPos.y = 1;
                const startPos = thorn.position.clone();
                let progress = 0;
                const thornInterval = setInterval(() => {
                  progress += 0.15;
                  thorn.position.lerpVectors(startPos, targetPos, progress);
                  thorn.lookAt(targetPos);
                  if (progress >= 1) {
                    this.scene.remove(thorn);
                    clearInterval(thornInterval);
                  }
                }, 16);
              });

              // Heal plant in front (same row, to the right/zombie side)
              const plantInFront = this.placedPlants.find(p => {
                const sameRow = Math.abs(p.position.z - plant.position.z) < 1;
                const inFront = p.position.x > plant.position.x && p.position.x < plant.position.x + 4;
                return sameRow && inFront && p !== plant;
              });

              if (plantInFront && plantInFront.health < plantInFront.maxHealth) {
                plantInFront.health = Math.min(plantInFront.maxHealth, plantInFront.health + 25);

                // Create heal effect
                const healGeo = new THREE.SphereGeometry(0.5, 12, 12);
                const healMat = new THREE.MeshBasicMaterial({
                  color: 0x00ff44,
                  transparent: true,
                  opacity: 0.6
                });
                const heal = new THREE.Mesh(healGeo, healMat);
                heal.position.copy(plantInFront.position);
                heal.position.y = 1;
                this.scene.add(heal);

                // Animate heal effect
                let healScale = 0.5;
                let healOpacity = 0.6;
                const healInterval = setInterval(() => {
                  healScale += 0.15;
                  healOpacity -= 0.1;
                  heal.scale.set(healScale, healScale, healScale);
                  if (healMat instanceof THREE.MeshBasicMaterial) {
                    healMat.opacity = healOpacity;
                  }
                  if (healOpacity <= 0) {
                    this.scene.remove(heal);
                    clearInterval(healInterval);
                  }
                }, 50);

                console.log(`Rose Reaper healed ${PLANT_INFO[plantInFront.type].name} for 25 HP!`);
              }

              console.log(`Rose Reaper attacked ${zombiesInRange.length} zombies for 25 damage each!`);
              plant.cooldown = 5; // 5 second cooldown
            }
          }
          break;

        case 'mushroom-bomber':
          // Shop plant: releases toxic spores that damage all zombies in 2.5 tile range
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            // Find zombies in 2.5 tile range (5 units)
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 5; // 2.5 tiles = 5 units
            });

            if (zombiesInRange.length > 0) {
              // Create spore burst effect
              const sporeCount = 12;
              for (let i = 0; i < sporeCount; i++) {
                const sporeGeo = new THREE.SphereGeometry(0.1, 8, 8);
                const sporeMat = new THREE.MeshBasicMaterial({
                  color: 0xadff2f,
                  transparent: true,
                  opacity: 0.8
                });
                const spore = new THREE.Mesh(sporeGeo, sporeMat);
                spore.position.copy(plant.position);
                spore.position.y = 1.0;
                this.scene.add(spore);

                // Animate spore outward
                const angle = (i / sporeCount) * Math.PI * 2;
                const targetX = plant.position.x + Math.cos(angle) * 3;
                const targetZ = plant.position.z + Math.sin(angle) * 3;
                const startPos = spore.position.clone();
                let progress = 0;
                const sporeInterval = setInterval(() => {
                  progress += 0.05;
                  spore.position.x = startPos.x + (targetX - startPos.x) * progress;
                  spore.position.z = startPos.z + (targetZ - startPos.z) * progress;
                  spore.position.y = 1.0 + Math.sin(progress * Math.PI) * 0.5;
                  if (sporeMat instanceof THREE.MeshBasicMaterial) {
                    sporeMat.opacity = 0.8 * (1 - progress);
                  }
                  if (progress >= 1) {
                    this.scene.remove(spore);
                    clearInterval(sporeInterval);
                  }
                }, 30);
              }

              // Create toxic cloud effect
              const cloudGeo = new THREE.SphereGeometry(2, 16, 16);
              const cloudMat = new THREE.MeshBasicMaterial({
                color: 0x7cfc00,
                transparent: true,
                opacity: 0.3
              });
              const cloud = new THREE.Mesh(cloudGeo, cloudMat);
              cloud.position.copy(plant.position);
              cloud.position.y = 1;
              cloud.scale.set(0.3, 0.3, 0.3);
              this.scene.add(cloud);

              // Animate cloud expansion
              let cloudScale = 0.3;
              let cloudOpacity = 0.3;
              const cloudInterval = setInterval(() => {
                cloudScale += 0.08;
                cloudOpacity -= 0.02;
                cloud.scale.set(cloudScale, cloudScale * 0.5, cloudScale);
                if (cloudMat instanceof THREE.MeshBasicMaterial) {
                  cloudMat.opacity = cloudOpacity;
                }
                if (cloudOpacity <= 0) {
                  this.scene.remove(cloud);
                  clearInterval(cloudInterval);
                }
              }, 40);

              // Damage all zombies in range
              zombiesInRange.forEach(zombie => {
                zombie.health -= 20; // 20 damage per hit
              });

              console.log(`Mushroom Bomber released spores on ${zombiesInRange.length} zombies for 20 damage each!`);
              plant.cooldown = 3; // 3 second cooldown
            }
          }
          break;

        case 'vined-wall':
          // Defensive wall - no attack, just soaks damage (500 HP)
          break;

        case 'frostberry-launcher':
          // Fusion plant: shoots frostberries every 1 second, 50% slow, 20 damage
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              // Create frostberry projectile
              const frostberryGeo = new THREE.SphereGeometry(0.15, 8, 8);
              const frostberryMat = new THREE.MeshPhongMaterial({
                color: 0xff88aa,
                shininess: 150,
                emissive: 0x88ddff,
                emissiveIntensity: 0.5
              });
              const frostberry = new THREE.Mesh(frostberryGeo, frostberryMat);
              frostberry.position.copy(plant.position);
              frostberry.position.y = 0.8;
              this.scene.add(frostberry);

              // Ice trail effect
              const trailGeo = new THREE.SphereGeometry(0.08, 6, 6);
              const trailMat = new THREE.MeshBasicMaterial({
                color: 0xaaddff,
                transparent: true,
                opacity: 0.6
              });
              const trail = new THREE.Mesh(trailGeo, trailMat);
              trail.position.copy(frostberry.position);
              this.scene.add(trail);

              const direction = new THREE.Vector3().subVectors(nearestZombie.position, plant.position).normalize();
              direction.y = 0;
              const velocity = direction.multiplyScalar(25); // FAST!
              const projectile = new Projectile(frostberry, plant.position.clone(), velocity, 30, false); // 30 damage (1.5x)
              projectile.userData = { type: 'frostberry', slowAmount: 0.5, slowDuration: 2 };
              this.projectiles.push(projectile);

              // Animate trail and remove
              let trailOpacity = 0.6;
              const trailInterval = setInterval(() => {
                trailOpacity -= 0.1;
                if (trailMat instanceof THREE.MeshBasicMaterial) {
                  trailMat.opacity = trailOpacity;
                }
                if (trailOpacity <= 0) {
                  this.scene.remove(trail);
                  clearInterval(trailInterval);
                }
              }, 50);

              plant.cooldown = 1; // 1 second cooldown - fast fire rate!
            }
          }
          break;

        case 'reaper-peall':
          // Odd fusion: when bitten, shoots skull dealing 300 damage + 50% slow + 50% freeze chance
          // This is a reactive attack - triggered when zombie bites it
          // We track this with a special counter
          if (plant.userData.lastHealth === undefined) {
            plant.userData.lastHealth = plant.health;
          }

          // Check if plant took damage (was bitten)
          if (plant.health < plant.userData.lastHealth && plant.cooldown <= 0) {
            // Find the zombie that's eating this plant
            const attackingZombie = this.zombies.find(z => z.targetPlant === plant && z.isEating);
            if (attackingZombie) {
              // Fire skull projectile!
              this.fireReaperSkull(plant, attackingZombie);
              plant.cooldown = 8; // 8 second cooldown
            }
          }
          plant.userData.lastHealth = plant.health;
          break;

        case 'acorn-tree':
          // Shop plant: shoots acorns that spawn acorn bombs when they hit zombies
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              // Create acorn projectile
              const acornGeo = new THREE.SphereGeometry(0.12, 8, 8);
              acornGeo.scale(0.8, 1.2, 0.8);
              const acornMat = new THREE.MeshPhongMaterial({
                color: 0x8a6040,
                shininess: 80,
                emissive: 0x3a2010,
                emissiveIntensity: 0.3
              });
              const acorn = new THREE.Mesh(acornGeo, acornMat);
              acorn.position.copy(plant.position);
              acorn.position.y = 1.5;
              this.scene.add(acorn);

              const direction = new THREE.Vector3().subVectors(nearestZombie.position, plant.position).normalize();
              direction.y = 0;
              const velocity = direction.multiplyScalar(20); // FAST projectile speed!
              const projectile = new Projectile(acorn, plant.position.clone(), velocity, 23, false); // 23 damage (1.5x)
              projectile.userData = { type: 'acorn', spawnsBomb: true };
              this.projectiles.push(projectile);

              plant.cooldown = 4; // 4 second cooldown
            }
          }
          break;

        case 'acorn-bomb':
          // Acorn bomb - explodes when killed, dealing 50 damage in area
          // Check if it's about to die (health check happens elsewhere)
          // The explosion logic is handled in plant death
          break;

        case 'banana-peel':
          // Shop plant: summons animal allies every 10 seconds
          if (plant.cooldown <= 0) {
            // Determine ally type: 40% raccoon, 40% monkey, 20% gorilla
            const roll = Math.random();
            let allyType: AllyType;
            if (roll < 0.4) {
              allyType = 'raccoon';
            } else if (roll < 0.8) {
              allyType = 'monkey';
            } else {
              allyType = 'gorilla';
            }

            // Create ally mesh
            const allyMesh = this.createAllyMesh(allyType);
            const spawnPos = plant.position.clone();
            spawnPos.x += 1; // Spawn in front of the plant
            allyMesh.position.copy(spawnPos);
            allyMesh.rotation.y = Math.PI / 2; // Face towards zombies (+X direction)
            this.scene.add(allyMesh);

            // Create ally object
            const ally = new Ally(allyMesh, allyType, spawnPos.clone());
            this.allies.push(ally);

            // Create summon effect
            const summonGeo = new THREE.RingGeometry(0.3, 0.8, 16);
            const summonMat = new THREE.MeshBasicMaterial({
              color: 0xffaa00,
              transparent: true,
              opacity: 0.8,
              side: THREE.DoubleSide
            });
            const summon = new THREE.Mesh(summonGeo, summonMat);
            summon.rotation.x = -Math.PI / 2;
            summon.position.copy(spawnPos);
            summon.position.y = 0.1;
            this.scene.add(summon);

            // Animate summon effect
            let summonScale = 0.5;
            let summonOpacity = 0.8;
            const summonInterval = setInterval(() => {
              summonScale += 0.15;
              summonOpacity -= 0.1;
              summon.scale.set(summonScale, summonScale, 1);
              if (summonMat instanceof THREE.MeshBasicMaterial) {
                summonMat.opacity = summonOpacity;
              }
              if (summonOpacity <= 0) {
                this.scene.remove(summon);
                clearInterval(summonInterval);
              }
            }, 50);

            console.log(`Banana Peel summoned a ${allyType}!`);
            plant.cooldown = 20; // 20 second cooldown
          }
          break;

        case 'frost-peel':
          // Fusion of Banana Peel + Frost Berri: summons icy animals
          if (plant.cooldown <= 0) {
            // Determine ally type: 20% icy-bull (powerful), 80% icy-fox (swift)
            const roll = Math.random();
            let allyType: AllyType;
            if (roll < 0.2) {
              allyType = 'icy-bull';
            } else {
              allyType = 'icy-fox';
            }

            // Create ally mesh
            const allyMesh = this.createAllyMesh(allyType);
            const spawnPos = plant.position.clone();
            spawnPos.x += 1; // Spawn in front of the plant
            allyMesh.position.copy(spawnPos);
            allyMesh.rotation.y = Math.PI / 2; // Face towards zombies (+X direction)
            this.scene.add(allyMesh);

            // Create ally object
            const ally = new Ally(allyMesh, allyType, spawnPos.clone());
            this.allies.push(ally);

            // Create icy summon effect
            const summonGeo = new THREE.RingGeometry(0.3, 0.8, 16);
            const summonMat = new THREE.MeshBasicMaterial({
              color: 0x00ddff,
              transparent: true,
              opacity: 0.9,
              side: THREE.DoubleSide
            });
            const summon = new THREE.Mesh(summonGeo, summonMat);
            summon.rotation.x = -Math.PI / 2;
            summon.position.copy(spawnPos);
            summon.position.y = 0.1;
            this.scene.add(summon);

            // Ice burst particles
            for (let i = 0; i < 8; i++) {
              const iceGeo = new THREE.OctahedronGeometry(0.08, 0);
              const iceMat = new THREE.MeshBasicMaterial({
                color: 0xccffff,
                transparent: true,
                opacity: 0.8
              });
              const ice = new THREE.Mesh(iceGeo, iceMat);
              ice.position.copy(spawnPos);
              ice.position.y = 0.3;
              this.scene.add(ice);

              const angle = (i / 8) * Math.PI * 2;
              const targetX = spawnPos.x + Math.cos(angle) * 1.5;
              const targetZ = spawnPos.z + Math.sin(angle) * 1.5;
              const startPos = ice.position.clone();
              let progress = 0;
              const iceInterval = setInterval(() => {
                progress += 0.08;
                ice.position.x = startPos.x + (targetX - startPos.x) * progress;
                ice.position.z = startPos.z + (targetZ - startPos.z) * progress;
                ice.position.y = 0.3 + Math.sin(progress * Math.PI) * 0.8;
                ice.rotation.x += 0.2;
                ice.rotation.y += 0.15;
                if (iceMat instanceof THREE.MeshBasicMaterial) {
                  iceMat.opacity = 0.8 * (1 - progress);
                }
                if (progress >= 1) {
                  this.scene.remove(ice);
                  clearInterval(iceInterval);
                }
              }, 30);
            }

            // Animate summon ring
            let summonScale = 0.5;
            let summonOpacity = 0.9;
            const summonInterval = setInterval(() => {
              summonScale += 0.18;
              summonOpacity -= 0.12;
              summon.scale.set(summonScale, summonScale, 1);
              if (summonMat instanceof THREE.MeshBasicMaterial) {
                summonMat.opacity = summonOpacity;
              }
              if (summonOpacity <= 0) {
                this.scene.remove(summon);
                clearInterval(summonInterval);
              }
            }, 50);

            console.log(`Frost Peel summoned a ${allyType}!`);
            plant.cooldown = 15; // 15 second cooldown
          }
          break;

        case 'frost-grape-launcher':
          // Fusion: shoots frozen grapes with 50 damage and 30% slow
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              // Create frozen grape projectile
              const frostGrapeGeo = new THREE.SphereGeometry(0.15, 10, 10);
              const frostGrapeMat = new THREE.MeshPhongMaterial({
                color: 0x7766cc,
                shininess: 120,
                emissive: 0x4455aa,
                emissiveIntensity: 0.4
              });
              const frostGrape = new THREE.Mesh(frostGrapeGeo, frostGrapeMat);

              // Ice coating
              const iceCoatGeo = new THREE.SphereGeometry(0.18, 8, 8);
              const iceCoatMat = new THREE.MeshPhongMaterial({
                color: 0xaaddff,
                transparent: true,
                opacity: 0.4,
                shininess: 180
              });
              const iceCoat = new THREE.Mesh(iceCoatGeo, iceCoatMat);
              frostGrape.add(iceCoat);

              frostGrape.position.copy(plant.position);
              frostGrape.position.y = 0.8;
              this.scene.add(frostGrape);

              const direction = new THREE.Vector3().subVectors(nearestZombie.position, plant.position).normalize();
              direction.y = 0;
              const velocity = direction.multiplyScalar(22); // FAST!
              const projectile = new Projectile(frostGrape, plant.position.clone(), velocity, 75, false, false, true); // 75 damage (1.5x), frozen
              this.projectiles.push(projectile);

              plant.cooldown = 2; // 2 second cooldown
            }
          }
          break;

        case 'banana-launcher':
          // Fusion plant: shoots cursed banana peels that mark zombies
          // When marked zombie dies, spawns zombie allies!
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              // Create EPIC cursed banana peel projectile
              const peelGroup = new THREE.Group();

              // === DARK BANANA PEEL CORE ===
              // Main peel - darker, cursed yellow
              const peelGeo = new THREE.TorusGeometry(0.15, 0.05, 10, 16, Math.PI * 1.2);
              const peelMat = new THREE.MeshPhongMaterial({
                color: 0xaa8800,
                shininess: 100,
                emissive: 0x443300,
                emissiveIntensity: 0.5
              });
              const peel = new THREE.Mesh(peelGeo, peelMat);
              peel.rotation.x = Math.PI / 2;
              peelGroup.add(peel);

              // Second peel strip
              const peel2Geo = new THREE.TorusGeometry(0.12, 0.04, 8, 12, Math.PI);
              const peel2 = new THREE.Mesh(peel2Geo, peelMat);
              peel2.rotation.x = Math.PI / 2;
              peel2.rotation.z = Math.PI / 3;
              peel2.position.y = 0.03;
              peelGroup.add(peel2);

              // Third peel strip
              const peel3 = new THREE.Mesh(peel2Geo, peelMat);
              peel3.rotation.x = Math.PI / 2;
              peel3.rotation.z = -Math.PI / 3;
              peel3.position.y = -0.03;
              peelGroup.add(peel3);

              // === CENTRAL SKULL ===
              const skullGeo = new THREE.SphereGeometry(0.1, 10, 10);
              const skullMat = new THREE.MeshPhongMaterial({
                color: 0xccccbb,
                shininess: 80,
                emissive: 0x222211,
                emissiveIntensity: 0.3
              });
              const skull = new THREE.Mesh(skullGeo, skullMat);
              skull.scale.set(1, 0.85, 0.7);
              peelGroup.add(skull);

              // Skull burning eyes
              for (let side = -1; side <= 1; side += 2) {
                const eyeGeo = new THREE.SphereGeometry(0.025, 6, 6);
                const eyeMat = new THREE.MeshBasicMaterial({ color: 0x00ff44 });
                const eye = new THREE.Mesh(eyeGeo, eyeMat);
                eye.position.set(side * 0.035, 0.02, 0.06);
                peelGroup.add(eye);
              }

              // === SWIRLING ENERGY RINGS ===
              // Purple outer ring
              const ring1Geo = new THREE.TorusGeometry(0.22, 0.02, 8, 24);
              const ring1Mat = new THREE.MeshBasicMaterial({
                color: 0x9900ff,
                transparent: true,
                opacity: 0.7
              });
              const ring1 = new THREE.Mesh(ring1Geo, ring1Mat);
              ring1.rotation.x = Math.PI / 4;
              peelGroup.add(ring1);

              // Green inner ring
              const ring2Geo = new THREE.TorusGeometry(0.18, 0.015, 8, 20);
              const ring2Mat = new THREE.MeshBasicMaterial({
                color: 0x00ff44,
                transparent: true,
                opacity: 0.8
              });
              const ring2 = new THREE.Mesh(ring2Geo, ring2Mat);
              ring2.rotation.x = -Math.PI / 4;
              ring2.rotation.y = Math.PI / 2;
              peelGroup.add(ring2);

              // === GHOSTLY AURA ===
              const auraGeo = new THREE.SphereGeometry(0.28, 12, 12);
              const auraMat = new THREE.MeshBasicMaterial({
                color: 0x00ff22,
                transparent: true,
                opacity: 0.25
              });
              const aura = new THREE.Mesh(auraGeo, auraMat);
              peelGroup.add(aura);

              // Outer dark aura
              const darkAuraGeo = new THREE.SphereGeometry(0.35, 12, 12);
              const darkAuraMat = new THREE.MeshBasicMaterial({
                color: 0x330044,
                transparent: true,
                opacity: 0.2
              });
              const darkAura = new THREE.Mesh(darkAuraGeo, darkAuraMat);
              peelGroup.add(darkAura);

              // === TRAILING SOUL WISPS ===
              for (let i = 0; i < 6; i++) {
                const wispGeo = new THREE.SphereGeometry(0.03, 6, 6);
                const wispMat = new THREE.MeshBasicMaterial({
                  color: i % 2 === 0 ? 0x00ff44 : 0xaa00ff,
                  transparent: true,
                  opacity: 0.6
                });
                const wisp = new THREE.Mesh(wispGeo, wispMat);
                const angle = (i / 6) * Math.PI * 2;
                wisp.position.set(
                  Math.cos(angle) * 0.25,
                  Math.sin(angle) * 0.1,
                  Math.sin(angle) * 0.25
                );
                peelGroup.add(wisp);
              }

              peelGroup.position.copy(plant.position);
              peelGroup.position.y = 0.8;
              this.scene.add(peelGroup);

              const direction = new THREE.Vector3().subVectors(nearestZombie.position, plant.position).normalize();
              direction.y = 0;
              const velocity = direction.multiplyScalar(18);
              const projectile = new Projectile(peelGroup as unknown as THREE.Mesh, plant.position.clone(), velocity, 0, false); // 0 damage!
              projectile.userData = { type: 'cursed-banana', spawnsZombieAlly: true };
              this.projectiles.push(projectile);

              plant.cooldown = 3; // 3 second cooldown
            }
          }
          break;

        case 'strawberry-tree':
          // Fusion: 5 damage shots, 30% chance to shoot bomb (20 damage), sticks 3s, explodes for 230 damage
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              // 30% chance to shoot a sticky bomb
              const isBomb = Math.random() < 0.3;

              if (isBomb) {
                // Create sticky bomb projectile
                const bombGeo = new THREE.SphereGeometry(0.12, 10, 10);
                const bombMat = new THREE.MeshPhongMaterial({
                  color: 0xff4422,
                  shininess: 100,
                  emissive: 0xcc2200,
                  emissiveIntensity: 0.5
                });
                const bomb = new THREE.Mesh(bombGeo, bombMat);

                // Glowing fuse
                const fuseGeo = new THREE.CylinderGeometry(0.02, 0.02, 0.1, 6);
                const fuseMat = new THREE.MeshBasicMaterial({
                  color: 0xffaa00,
                  transparent: true,
                  opacity: 0.9
                });
                const fuse = new THREE.Mesh(fuseGeo, fuseMat);
                fuse.position.y = 0.1;
                bomb.add(fuse);

                // Strawberry pattern
                for (let i = 0; i < 6; i++) {
                  const seedGeo = new THREE.SphereGeometry(0.015, 4, 4);
                  const seedMat = new THREE.MeshBasicMaterial({ color: 0xffee44 });
                  const seed = new THREE.Mesh(seedGeo, seedMat);
                  const angle = (i / 6) * Math.PI * 2;
                  seed.position.set(Math.cos(angle) * 0.08, Math.sin(angle) * 0.08, 0.06);
                  bomb.add(seed);
                }

                bomb.position.copy(plant.position);
                bomb.position.y = 1.2;
                this.scene.add(bomb);

                const direction = new THREE.Vector3().subVectors(nearestZombie.position, plant.position).normalize();
                direction.y = 0;
                const velocity = direction.multiplyScalar(18);
                const projectile = new Projectile(bomb, plant.position.clone(), velocity, 20, false);
                projectile.userData = { type: 'sticky-bomb', stickTime: 3, explosionDamage: 230 };
                this.projectiles.push(projectile);
              } else {
                // Create regular seed projectile (5 damage)
                const seedGeo = new THREE.SphereGeometry(0.08, 8, 8);
                const seedMat = new THREE.MeshPhongMaterial({
                  color: 0xff5566,
                  shininess: 80,
                  emissive: 0xcc3344,
                  emissiveIntensity: 0.3
                });
                const seed = new THREE.Mesh(seedGeo, seedMat);

                seed.position.copy(plant.position);
                seed.position.y = 1.2;
                this.scene.add(seed);

                const direction = new THREE.Vector3().subVectors(nearestZombie.position, plant.position).normalize();
                direction.y = 0;
                const velocity = direction.multiplyScalar(22);
                const projectile = new Projectile(seed, plant.position.clone(), velocity, 5, false);
                this.projectiles.push(projectile);
              }

              plant.cooldown = 0.8; // 0.8 second cooldown (fast!)
            }
          }
          break;

        case 'frozen-mushroom-bomber':
          // Fusion: 3x3 icy toxic fumes, 20 damage, 30% slow, +30% freeze chance, 3.5s cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            // Find zombies in 3x3 area (6 units = 3 tiles)
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 6;
            });

            if (zombiesInRange.length > 0) {
              // Create icy spore burst effect
              const sporeCount = 16;
              for (let i = 0; i < sporeCount; i++) {
                const sporeGeo = new THREE.SphereGeometry(0.08, 6, 6);
                const sporeMat = new THREE.MeshBasicMaterial({
                  color: 0x88ddff,
                  transparent: true,
                  opacity: 0.8
                });
                const spore = new THREE.Mesh(sporeGeo, sporeMat);
                spore.position.copy(plant.position);
                spore.position.y = 1.0;
                this.scene.add(spore);

                const angle = (i / sporeCount) * Math.PI * 2;
                const targetX = plant.position.x + Math.cos(angle) * 4;
                const targetZ = plant.position.z + Math.sin(angle) * 4;
                const startPos = spore.position.clone();
                let progress = 0;
                const sporeInterval = setInterval(() => {
                  progress += 0.04;
                  spore.position.x = startPos.x + (targetX - startPos.x) * progress;
                  spore.position.z = startPos.z + (targetZ - startPos.z) * progress;
                  spore.position.y = 1.0 + Math.sin(progress * Math.PI) * 0.6;
                  if (sporeMat instanceof THREE.MeshBasicMaterial) {
                    sporeMat.opacity = 0.8 * (1 - progress);
                  }
                  if (progress >= 1) {
                    this.scene.remove(spore);
                    clearInterval(sporeInterval);
                  }
                }, 25);
              }

              // Create icy toxic cloud
              const cloudGeo = new THREE.SphereGeometry(3, 16, 16);
              const cloudMat = new THREE.MeshBasicMaterial({
                color: 0x66ccff,
                transparent: true,
                opacity: 0.35
              });
              const cloud = new THREE.Mesh(cloudGeo, cloudMat);
              cloud.position.copy(plant.position);
              cloud.position.y = 1;
              cloud.scale.set(0.3, 0.3, 0.3);
              this.scene.add(cloud);

              let cloudScale = 0.3;
              let cloudOpacity = 0.35;
              const cloudInterval = setInterval(() => {
                cloudScale += 0.06;
                cloudOpacity -= 0.02;
                cloud.scale.set(cloudScale, cloudScale * 0.5, cloudScale);
                if (cloudMat instanceof THREE.MeshBasicMaterial) {
                  cloudMat.opacity = cloudOpacity;
                }
                if (cloudOpacity <= 0) {
                  this.scene.remove(cloud);
                  clearInterval(cloudInterval);
                }
              }, 35);

              // Damage zombies and apply slow/freeze
              zombiesInRange.forEach(zombie => {
                zombie.health -= 20; // 20 damage

                // 30% chance to freeze (if not immune)
                if (Math.random() < 0.3 && !zombie.isFreezeImmune && zombie.freezeImmunityTimer <= 0 && !zombie.frozen) {
                  zombie.frozen = true;
                  zombie.frozenTimer = 3;
                  zombie.mesh.children.forEach(child => {
                    if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
                      child.material.color.setHex(0x88ddff);
                    }
                  });
                } else if (!zombie.frozen) {
                  // Apply 30% slow using baseSpeed to prevent stacking
                  zombie.speed = zombie.baseSpeed * 0.7;
                  zombie.mesh.children.forEach(child => {
                    if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
                      child.material.color.setHex(0xaabbcc);
                    }
                  });
                  setTimeout(() => {
                    zombie.speed = zombie.baseSpeed; // Reset to base speed
                  }, 4000);
                }
              });

              console.log(`Frozen Mushroom Bomber hit ${zombiesInRange.length} zombies!`);
              plant.cooldown = 3.5; // 3.5 second cooldown
            }
          }
          break;

        case 'frozen-overlord-mushroom':
          // Ultimate fusion: 3x3 area, 200 damage, 4s cooldown, 1s freeze, 50% slow for 5s
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            // Find zombies in 3x3 area (6 units = 3 tiles)
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 6;
            });

            if (zombiesInRange.length > 0) {
              // Create devastating ice storm effect
              const iceStormCount = 24;
              for (let i = 0; i < iceStormCount; i++) {
                const crystalGeo = new THREE.OctahedronGeometry(0.12, 0);
                const crystalMat = new THREE.MeshPhongMaterial({
                  color: 0x88eeff,
                  shininess: 300,
                  emissive: 0x44aaff,
                  emissiveIntensity: 0.8,
                  transparent: true,
                  opacity: 0.9
                });
                const crystal = new THREE.Mesh(crystalGeo, crystalMat);
                crystal.position.copy(plant.position);
                crystal.position.y = 1.5;
                this.scene.add(crystal);

                const angle = (i / iceStormCount) * Math.PI * 2;
                const targetX = plant.position.x + Math.cos(angle) * 5;
                const targetZ = plant.position.z + Math.sin(angle) * 5;
                const startPos = crystal.position.clone();
                let progress = 0;
                const crystalInterval = setInterval(() => {
                  progress += 0.03;
                  crystal.position.x = startPos.x + (targetX - startPos.x) * progress;
                  crystal.position.z = startPos.z + (targetZ - startPos.z) * progress;
                  crystal.position.y = 1.5 + Math.sin(progress * Math.PI) * 1.5;
                  crystal.rotation.x += 0.2;
                  crystal.rotation.y += 0.3;
                  if (crystalMat instanceof THREE.MeshPhongMaterial) {
                    crystalMat.opacity = 0.9 * (1 - progress * 0.7);
                  }
                  if (progress >= 1) {
                    this.scene.remove(crystal);
                    clearInterval(crystalInterval);
                  }
                }, 20);
              }

              // Create massive ice nova
              const novaGeo = new THREE.TorusGeometry(0.5, 0.2, 12, 48);
              const novaMat = new THREE.MeshBasicMaterial({
                color: 0x00ffff,
                transparent: true,
                opacity: 0.8
              });
              const nova = new THREE.Mesh(novaGeo, novaMat);
              nova.rotation.x = Math.PI / 2;
              nova.position.copy(plant.position);
              nova.position.y = 0.5;
              this.scene.add(nova);

              let novaScale = 0.5;
              let novaOpacity = 0.8;
              const novaInterval = setInterval(() => {
                novaScale += 0.25;
                novaOpacity -= 0.04;
                nova.scale.set(novaScale, novaScale, 1);
                if (novaMat instanceof THREE.MeshBasicMaterial) {
                  novaMat.opacity = novaOpacity;
                }
                if (novaOpacity <= 0) {
                  this.scene.remove(nova);
                  clearInterval(novaInterval);
                }
              }, 25);

              // Create ice pillar at center
              const pillarGeo = new THREE.CylinderGeometry(0.3, 0.6, 3, 8);
              const pillarMat = new THREE.MeshPhongMaterial({
                color: 0xaaeeff,
                shininess: 250,
                transparent: true,
                opacity: 0.6,
                emissive: 0x44bbff,
                emissiveIntensity: 0.7
              });
              const pillar = new THREE.Mesh(pillarGeo, pillarMat);
              pillar.position.copy(plant.position);
              pillar.position.y = 1.5;
              pillar.scale.set(0.1, 0.1, 0.1);
              this.scene.add(pillar);

              let pillarScaleV = 0.1;
              let pillarOpacity = 0.6;
              const pillarInterval = setInterval(() => {
                pillarScaleV += 0.1;
                if (pillarScaleV > 1) {
                  pillarOpacity -= 0.05;
                }
                pillar.scale.set(pillarScaleV, Math.min(pillarScaleV, 1.2), pillarScaleV);
                if (pillarMat instanceof THREE.MeshPhongMaterial) {
                  pillarMat.opacity = pillarOpacity;
                }
                if (pillarOpacity <= 0) {
                  this.scene.remove(pillar);
                  clearInterval(pillarInterval);
                }
              }, 30);

              // Damage all zombies in range - 200 damage!
              zombiesInRange.forEach(zombie => {
                zombie.health -= 200; // Massive 200 damage!

                // Freeze for 1 second (if not immune and not already frozen)
                if (!zombie.isFreezeImmune && zombie.freezeImmunityTimer <= 0 && !zombie.frozen) {
                  zombie.frozen = true;
                  zombie.frozenTimer = 1;

                  // Visual freeze effect
                  zombie.mesh.children.forEach(child => {
                    if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
                      child.material.color.setHex(0x66ddff);
                      child.material.emissive.setHex(0x2288cc);
                      child.material.emissiveIntensity = 0.6;
                    }
                  });

                  // After freeze, apply 50% slow for 5 seconds using baseSpeed
                  setTimeout(() => {
                    zombie.speed = zombie.baseSpeed * 0.5; // 50% slow from base
                    zombie.mesh.children.forEach(child => {
                      if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
                        child.material.color.setHex(0x99bbdd);
                      }
                    });
                    setTimeout(() => {
                      zombie.speed = zombie.baseSpeed; // Reset to base speed
                    }, 5000);
                  }, 1000);
                }

                // Create ice shard impact on each zombie
                const shardGeo = new THREE.OctahedronGeometry(0.2, 0);
                const shardMat = new THREE.MeshBasicMaterial({
                  color: 0x00ffff,
                  transparent: true,
                  opacity: 0.9
                });
                const shard = new THREE.Mesh(shardGeo, shardMat);
                shard.position.copy(zombie.position);
                shard.position.y = 1;
                this.scene.add(shard);

                let shardScale = 0.5;
                let shardOpacity = 0.9;
                const shardInterval = setInterval(() => {
                  shardScale += 0.2;
                  shardOpacity -= 0.1;
                  shard.scale.set(shardScale, shardScale, shardScale);
                  shard.rotation.y += 0.3;
                  if (shardMat instanceof THREE.MeshBasicMaterial) {
                    shardMat.opacity = shardOpacity;
                  }
                  if (shardOpacity <= 0) {
                    this.scene.remove(shard);
                    clearInterval(shardInterval);
                  }
                }, 30);
              });

              console.log(`❄️👑 Frozen Overlord Mushroom devastated ${zombiesInRange.length} zombies for 200 damage each!`);
              plant.cooldown = 4; // 4 second cooldown
            }
          }
          break;

        case 'sunberry-launcher':
          // Fusion: shoots every 0.8s, 5 damage, gives 5 sun on hit
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              // Create sunberry projectile
              const sunberryGeo = new THREE.SphereGeometry(0.12, 10, 10);
              const sunberryMat = new THREE.MeshPhongMaterial({
                color: 0xff6677,
                shininess: 100,
                emissive: 0xffaa44,
                emissiveIntensity: 0.5
              });
              const sunberry = new THREE.Mesh(sunberryGeo, sunberryMat);

              // Sun glow
              const sunGlowGeo = new THREE.SphereGeometry(0.16, 8, 8);
              const sunGlowMat = new THREE.MeshBasicMaterial({
                color: 0xffee66,
                transparent: true,
                opacity: 0.4
              });
              const sunGlow = new THREE.Mesh(sunGlowGeo, sunGlowMat);
              sunberry.add(sunGlow);

              sunberry.position.copy(plant.position);
              sunberry.position.y = 0.9;
              this.scene.add(sunberry);

              const direction = new THREE.Vector3().subVectors(nearestZombie.position, plant.position).normalize();
              direction.y = 0;
              const velocity = direction.multiplyScalar(22); // FAST!
              const projectile = new Projectile(sunberry, plant.position.clone(), velocity, 5, false, true); // isSunGrape = true for sun on hit
              this.projectiles.push(projectile);

              plant.cooldown = 0.8; // 0.8 second cooldown (fast!)
            }
          }
          break;

        case 'lily-wall':
          // Fusion: 250 HP wall that gives 25 sun when bitten
          // Track if being bitten (health decreased)
          if (!plant.userData.lastHealth) {
            plant.userData.lastHealth = plant.health;
          }

          if (plant.health < plant.userData.lastHealth && plant.cooldown <= 0) {
            // Being bitten! Give 25 sun
            this.sun += 25;
            const sunAmountElem = document.getElementById('sun-amount');
            if (sunAmountElem) sunAmountElem.textContent = this.sun.toString();

            // Create sun burst effect
            const sunBurstGeo = new THREE.SphereGeometry(0.3, 10, 10);
            const sunBurstMat = new THREE.MeshBasicMaterial({
              color: 0xffee44,
              transparent: true,
              opacity: 0.8
            });
            const sunBurst = new THREE.Mesh(sunBurstGeo, sunBurstMat);
            sunBurst.position.copy(plant.position);
            sunBurst.position.y = 1.2;
            this.scene.add(sunBurst);

            let burstScale = 0.5;
            let burstOpacity = 0.8;
            const burstInterval = setInterval(() => {
              burstScale += 0.2;
              burstOpacity -= 0.12;
              sunBurst.scale.set(burstScale, burstScale, burstScale);
              if (sunBurstMat instanceof THREE.MeshBasicMaterial) {
                sunBurstMat.opacity = burstOpacity;
              }
              if (burstOpacity <= 0) {
                this.scene.remove(sunBurst);
                clearInterval(burstInterval);
              }
            }, 40);

            console.log('Lily Wall generated 25 sun from being bitten!');
            plant.cooldown = 1; // 1 second between sun productions
          }

          plant.userData.lastHealth = plant.health;
          break;

        case 'black-hole-coconut':
          // INSTANT USE: After 1 second, creates a gravitational singularity that pulls and damages all zombies in 5x5 area
          if (plant.cooldown <= 0) {
            const pullRange = 5.0; // 5x5 tiles = 10 units diameter
            let zombiesHit = 0;

            // Create massive gravitational explosion effect
            const singularityGeo = new THREE.SphereGeometry(0.5, 24, 24);
            const singularityMat = new THREE.MeshBasicMaterial({
              color: 0x000000,
              transparent: true,
              opacity: 1
            });
            const singularity = new THREE.Mesh(singularityGeo, singularityMat);
            singularity.position.copy(plant.position);
            singularity.position.y = 1;
            this.scene.add(singularity);

            // Create expanding purple ring effect
            const ringGeo = new THREE.TorusGeometry(0.5, 0.2, 8, 32);
            const ringMat = new THREE.MeshBasicMaterial({
              color: 0xff00ff,
              transparent: true,
              opacity: 1
            });
            const ring = new THREE.Mesh(ringGeo, ringMat);
            ring.rotation.x = Math.PI / 2;
            ring.position.copy(plant.position);
            ring.position.y = 0.5;
            this.scene.add(ring);

            // Pull ALL zombies in range toward center and deal damage
            for (const zombie of this.zombies) {
              const dx = zombie.position.x - plant.position.x;
              const dz = zombie.position.z - plant.position.z;
              const distance = Math.sqrt(dx * dx + dz * dz);

              if (distance <= pullRange) {
                // Pull zombie toward center instantly
                const pullStrength = 0.8; // How much to pull (0-1, closer to plant)
                zombie.position.x = plant.position.x + dx * (1 - pullStrength);
                zombie.position.z = plant.position.z + dz * (1 - pullStrength);
                zombie.mesh.position.copy(zombie.position);

                // Deal 100 damage to each zombie
                zombie.health -= 100;
                zombiesHit++;

                // Visual: create purple damage flash on zombie
                zombie.mesh.traverse((child) => {
                  if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
                    child.material.emissive.setHex(0xff00ff);
                    child.material.emissiveIntensity = 0.8;
                    // Reset after a moment
                    setTimeout(() => {
                      if (child.material instanceof THREE.MeshPhongMaterial) {
                        child.material.emissive.setHex(0x000000);
                        child.material.emissiveIntensity = 0.2;
                      }
                    }, 500);
                  }
                });
              }
            }

            console.log(`🕳️🥥 Black Hole Coconut activated! Pulled and damaged ${zombiesHit} zombies for 100 damage each!`);

            // Animate the singularity collapse
            let animStep = 0;
            const animInterval = setInterval(() => {
              animStep++;

              // Expand the ring
              ring.scale.set(1 + animStep * 0.5, 1 + animStep * 0.5, 1);
              ringMat.opacity = 1 - (animStep * 0.15);

              // Pulse the singularity then collapse
              if (animStep < 5) {
                singularity.scale.set(1 + animStep * 0.3, 1 + animStep * 0.3, 1 + animStep * 0.3);
              } else {
                singularity.scale.set(Math.max(0, (10 - animStep) * 0.3), Math.max(0, (10 - animStep) * 0.3), Math.max(0, (10 - animStep) * 0.3));
              }

              if (animStep >= 10) {
                this.scene.remove(singularity);
                this.scene.remove(ring);
                clearInterval(animInterval);
              }
            }, 50);

            // No slot to free - Black Hole Coconut doesn't occupy a slot!
            // Mark plant for removal
            plant.health = 0;
          } else {
            // ULTIMATE BLACK HOLE ANIMATION!
            const t = plant.animationTime;
            plant.mesh.traverse((child) => {
              if (child instanceof THREE.Mesh) {
                // Spin accretion disks at different speeds
                if (child.userData.isAccretionDisk) {
                  child.rotation.z += 5 * deltaTime;
                }
                // Pulse the cyan rim
                if (child.userData.isEventHorizon) {
                  const pulse = 1 + Math.sin(t * 12) * 0.25;
                  child.scale.set(pulse, pulse, 1);
                }
                // Pulse and flicker jets
                if (child.userData.isJet) {
                  const jetPulse = 1 + Math.sin(t * 15) * 0.3;
                  child.scale.set(jetPulse, 1 + Math.sin(t * 8) * 0.2, jetPulse);
                }
                // Jet glow pulses
                if (child.userData.isJetGlow) {
                  const glowPulse = 1 + Math.sin(t * 20) * 0.5;
                  child.scale.set(glowPulse, glowPulse, glowPulse);
                }
                // Spiral particles into the void
                if (child.userData.isGravityParticle) {
                  const idx = child.userData.particleIndex || 0;
                  const speed = 4 + (idx % 4);
                  const angle = t * speed + (idx / 16) * Math.PI * 2;
                  const dist = 0.45 + (idx % 4) * 0.12 + Math.sin(t * 3 + idx) * 0.08;
                  child.position.x = Math.cos(angle) * dist;
                  child.position.z = Math.sin(angle) * dist;
                }
                // Rotate electric arcs
                if (child.userData.isArc) {
                  const idx = child.userData.arcIndex || 0;
                  child.rotation.z = t * 3 + (idx / 4) * Math.PI * 2;
                }
                // Pulse ground rings outward
                if (child.userData.isGroundRing) {
                  const idx = child.userData.ringIndex || 1;
                  const pulse = 1 + Math.sin(t * 4 - idx * 0.5) * 0.15;
                  child.scale.set(pulse, pulse, 1);
                }
                // Float and spin debris
                if (child.userData.isDebris) {
                  const idx = child.userData.debrisIndex || 0;
                  const angle = t * 1.5 + (idx / 8) * Math.PI * 2;
                  child.position.x = Math.cos(angle) * 1.1;
                  child.position.z = Math.sin(angle) * 1.1;
                  child.position.y = 0.5 + Math.sin(t * 2 + idx) * 0.3;
                  child.rotation.x += 3 * deltaTime;
                  child.rotation.y += 2 * deltaTime;
                }
              }
            });
            // Rotate the whole thing
            plant.mesh.rotation.y += 0.3 * deltaTime;
          }
          break;

        case 'grape-gun':
          // Fusion plant: shoots 3 grapes in burst with medium cooldown
          // Handle ongoing burst
          if (plant.burstCount > 0) {
            plant.burstDelay -= deltaTime;
            if (plant.burstDelay <= 0 && plant.burstTarget) {
              // Rotate turret to face the target - ONLY rotate Y axis
              const turret = plant.mesh.userData.turret as THREE.Group;
              if (turret) {
                const direction = new THREE.Vector3().subVectors(plant.burstTarget, plant.position);
                // Only use X and Z for horizontal aiming, ignore Y
                const targetAngle = Math.atan2(direction.x, direction.z);
                turret.rotation.set(0, targetAngle, 0); // Reset X and Z rotations
              }

              // Fire next grape in burst with different offsets
              const offsetY = plant.burstCount === 3 ? 0 : (plant.burstCount === 2 ? 0.3 : -0.3);
              const shotPos = plant.position.clone();
              shotPos.y += offsetY;
              this.shootGrape(shotPos, plant.burstTarget);
              plant.burstCount--;
              plant.burstDelay = 0.12; // 0.12 seconds between burst shots

              // Burst finished, set main cooldown
              if (plant.burstCount <= 0) {
                plant.cooldown = 3;
                plant.burstTarget = null;
                // Reset turret to default position (facing +X towards zombies)
                if (turret) {
                  turret.rotation.set(0, Math.PI / 2, 0);
                }
              }
            }
          } else if (plant.cooldown <= 0 && this.zombies.length > 0) {
            // Start new burst
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              // Rotate turret to face the zombie - ONLY rotate Y axis
              const turret = plant.mesh.userData.turret as THREE.Group;
              if (turret) {
                const direction = new THREE.Vector3().subVectors(nearestZombie.position, plant.position);
                // Only use X and Z for horizontal aiming, ignore Y
                const targetAngle = Math.atan2(direction.x, direction.z);
                turret.rotation.set(0, targetAngle, 0); // Reset X and Z rotations
              }

              plant.burstCount = 3;
              plant.burstDelay = 0;
              plant.burstTarget = nearestZombie.position.clone();
            }
          } else {
            // When idle, keep turret facing default direction (+X towards zombies)
            const turret = plant.mesh.userData.turret as THREE.Group;
            if (turret && !plant.burstTarget) {
              turret.rotation.set(0, Math.PI / 2, 0);
            }
          }
          break;

        case 'star-launcher':
          // Fusion plant: click-to-fire 10 stars for 300 sun
          // This is handled in the click event, not here
          break;

        case 'pear-spiker':
          // Fusion plant: click-to-fire high damage spike at nearest zombie
          // This is handled in the click event, not here
          break;

        case 'strawbomber':
          // TITAN: Throws 3 bombs from sky every 5 seconds
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            this.throwStrawbombs(plant);
            plant.cooldown = 5;
          }
          break;

        case 'frovine-slammer':
          // TITAN: Slams zombies 2 tiles in front, slows by 50% for 5 seconds
          if (plant.cooldown <= 0) {
            const zombiesInRange = this.zombies.filter(z => {
              const distance = Math.abs(z.position.x - plant.position.x);
              const isInRow = Math.abs(z.position.z - plant.position.z) < 1.5;
              return distance <= 4 && z.position.x > plant.position.x && isInRow; // 2 tiles = 4 units, zombies come from RIGHT (positive X)
            });

            if (zombiesInRange.length > 0) {
              this.performFrostSlam(plant, zombiesInRange);
              plant.cooldown = 2;
            }
          }
          break;

        case 'pear-nuker':
          // TITAN: Click-to-fire nuke - handled in click event
          break;

        case 'tomato-spike':
          // Delayed-use plant: after 1 second, explodes and disappears
          if (plant.cooldown <= 0) {
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 5; // 2.5 tiles = 5 units
            });

            // Create explosion effect
            const explosionGeo = new THREE.SphereGeometry(5, 16, 16);
            const explosionMat = new THREE.MeshBasicMaterial({
              color: 0xff4444,
              transparent: true,
              opacity: 0.7
            });
            const explosion = new THREE.Mesh(explosionGeo, explosionMat);
            explosion.position.copy(plant.position);
            explosion.position.y = 1;
            this.scene.add(explosion);

            // Deal damage and track kills for mastery
            let killCount = 0;
            zombiesInRange.forEach(zombie => {
              const wasAlive = zombie.health > 0;
              zombie.health -= 450; // High damage (450)
              // Track kills for mastery
              if (wasAlive && zombie.health <= 0) {
                killCount++;
              }
            });

            // Award mastery points for kills (5 points per kill)
            if (killCount > 0) {
              this.tomatoSpikeMastery += killCount;
              this.tomatoSpikeMasteryPoints += killCount * 5;
              this.updateMasteryDisplay();
              console.log(`Tomato Spike Mastery: ${this.tomatoSpikeMastery}/300 zombies killed | Points: ${this.tomatoSpikeMasteryPoints}`);

              if (this.tomatoSpikeMasteryPoints >= 300) {
                console.log('🎉 Tomato Spike MASTERED! Double-click any Tomato Spike to upgrade to Elder Tomato Spike!');
              }
            }

            // Animate explosion
            let scale = 0.5;
            let opacity = 0.7;
            const explosionInterval = setInterval(() => {
              scale += 0.3;
              opacity -= 0.1;
              explosion.scale.set(scale, scale, scale);
              if (explosionMat instanceof THREE.MeshBasicMaterial) {
                explosionMat.opacity = opacity;
              }
              if (opacity <= 0) {
                this.scene.remove(explosion);
                clearInterval(explosionInterval);
              }
            }, 50);

            console.log(`Tomato Spike activated! Hit ${zombiesInRange.length} zombies with 150 damage! Killed: ${killCount}`);

            // Mark plant for removal
            plant.health = 0;
          }
          break;

        case 'elder-tomato-spike':
          // ELDER VERSION: Massive explosion, 300 damage, larger range, epic visual
          if (plant.cooldown <= 0) {
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 8; // 4 tiles = 8 units (bigger range!)
            });

            // Create EPIC golden explosion effect
            const explosionGeo = new THREE.SphereGeometry(8, 20, 20);
            const explosionMat = new THREE.MeshBasicMaterial({
              color: 0xffd700,
              transparent: true,
              opacity: 0.8
            });
            const explosion = new THREE.Mesh(explosionGeo, explosionMat);
            explosion.position.copy(plant.position);
            explosion.position.y = 1;
            this.scene.add(explosion);

            // Create fire ring
            const fireRingGeo = new THREE.TorusGeometry(4, 1, 16, 32);
            const fireRingMat = new THREE.MeshBasicMaterial({
              color: 0xff4500,
              transparent: true,
              opacity: 0.9
            });
            const fireRing = new THREE.Mesh(fireRingGeo, fireRingMat);
            fireRing.position.copy(plant.position);
            fireRing.position.y = 0.5;
            fireRing.rotation.x = Math.PI / 2;
            this.scene.add(fireRing);

            // Deal DEVASTATING damage
            zombiesInRange.forEach(zombie => {
              zombie.health -= 3000; // Massive 3K damage!
            });

            // Animate epic explosion
            let scale = 0.3;
            let opacity = 0.8;
            let ringScale = 0.5;
            const explosionInterval = setInterval(() => {
              scale += 0.4;
              ringScale += 0.6;
              opacity -= 0.08;
              explosion.scale.set(scale, scale, scale);
              fireRing.scale.set(ringScale, ringScale, 1);
              if (explosionMat instanceof THREE.MeshBasicMaterial) {
                explosionMat.opacity = opacity;
              }
              if (fireRingMat instanceof THREE.MeshBasicMaterial) {
                fireRingMat.opacity = opacity;
              }
              if (opacity <= 0) {
                this.scene.remove(explosion);
                this.scene.remove(fireRing);
                clearInterval(explosionInterval);
              }
            }, 50);

            console.log(`🔥 ELDER Tomato Spike DEVASTATED ${zombiesInRange.length} zombies with 300 damage!`);

            // Mark plant for removal
            plant.health = 0;
          }
          break;

        case 'vine-slammer':
          // Fusion: Vine Wall + Avocado Slammer - 35 damage, 2 tile range (4 units), 2s cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const zombiesInRange = this.zombies.filter(z =>
              z.position.distanceTo(plant.position) <= 4 && z.position.x > plant.position.x);
            if (zombiesInRange.length > 0) {
              this.performVineSlam(plant, zombiesInRange);
              plant.cooldown = 2;
            }
          }
          break;

        case 'grape-spiker':
          // Fusion: Grape Launcher + Tomato Spike - 75 damage spike, 3s cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootGrapeSpike(plant.position, nearestZombie.position);
              plant.cooldown = 3;
            }
          }
          break;

        case 'grape-gun-wall':
          // Fusion: Grape Gun + Vine Wall - 3 grapes at 10 damage each, 600 HP wall
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              for (let i = 0; i < 3; i++) {
                setTimeout(() => {
                  this.shootGrape(plant.position, nearestZombie.position, 15); // 15 damage (1.5x)
                }, i * 100);
              }
              plant.cooldown = 3;
            }
          }
          break;

        case 'lily-gun':
          // Fusion: Grape Lily + Grape Shot - Shoots 3 sun grapes (gives sun on hit)
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              for (let i = 0; i < 3; i++) {
                setTimeout(() => {
                  this.shootSunGrape(plant.position, nearestZombie.position);
                }, i * 100);
              }
              plant.cooldown = 2.5;
            }
          }
          break;

        case 'pickle-spear':
          // Fusion: Pickle Spiker + Pear Cannon - 200 damage, 2 tile knockback, 15s cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.throwPickleSpear(plant.position, nearestZombie);
              plant.cooldown = 15;
            }
          }
          break;

        case 'frost-spiker':
          // Fusion: Frostberry Launcher + Tomato Spike - 2 damage, 30% slow, 0.1s cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootFrostSpike(plant.position, nearestZombie);
              plant.cooldown = 0.1;
            }
          }
          break;

        case 'grape-frospike':
          // Fusion: Frost Grape Launcher + Tomato Spike - 100 damage, 50% slow, 4.5s cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootGrapeFrospike(plant.position, nearestZombie);
              plant.cooldown = 4.5;
            }
          }
          break;

        case 'frospike':
          // Fusion: Frost Berri + Tomato Spike - 450 damage, 3s freeze, instant-use
          if (plant.cooldown <= 0) {
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 5; // 2.5 tiles range
            });

            // Create ice explosion effect
            const iceExplosionGeo = new THREE.SphereGeometry(5, 16, 16);
            const iceExplosionMat = new THREE.MeshBasicMaterial({
              color: 0x66ddff,
              transparent: true,
              opacity: 0.7
            });
            const iceExplosion = new THREE.Mesh(iceExplosionGeo, iceExplosionMat);
            iceExplosion.position.copy(plant.position);
            iceExplosion.position.y = 1;
            this.scene.add(iceExplosion);

            // Deal 450 damage and freeze for 3 seconds
            zombiesInRange.forEach(zombie => {
              zombie.health -= 450;
              zombie.frozen = true;
              zombie.frozenTimer = 3;
            });

            // Animate ice explosion
            let scale = 0.5;
            let opacity = 0.7;
            const explosionInterval = setInterval(() => {
              scale += 0.3;
              opacity -= 0.1;
              iceExplosion.scale.set(scale, scale, scale);
              if (iceExplosionMat instanceof THREE.MeshBasicMaterial) {
                iceExplosionMat.opacity = opacity;
              }
              if (opacity <= 0) {
                this.scene.remove(iceExplosion);
                clearInterval(explosionInterval);
              }
            }, 50);

            console.log(`Frospike activated! Hit ${zombiesInRange.length} zombies with 450 damage and 3s freeze!`);
            plant.health = 0; // Instant use - destroys self
          }
          break;

        case 'banana-leach':
          // Fusion: Banana Peel + Rose Reaper - Summons leach allies
          if (plant.cooldown <= 0) {
            this.spawnLeachAlly(plant.position);
            plant.cooldown = 10;
          }
          break;

        case 'lily-cannon':
          // Fusion: Lily + Pear Cannon - Click to charge, handled in click event
          break;

        case 'frost-vine-wall':
          // Fusion: Frost Berri + Vine Wall - 30% freeze when bitten
          if (!plant.userData.lastHealth) {
            plant.userData.lastHealth = plant.health;
          }
          if (plant.health < plant.userData.lastHealth) {
            // Being bitten - 30% chance to freeze attacker
            if (Math.random() < 0.3) {
              const nearestZombie = this.zombies.find(z => z.targetPlant === plant);
              if (nearestZombie) {
                nearestZombie.frozen = true;
                nearestZombie.frozenTimer = 2;
              }
            }
          }
          plant.userData.lastHealth = plant.health;
          break;

        case 'frozen-supernova-coconut':
          // Instant use - 5x5 area, pulls zombies in, 150 damage, 2s freeze after 1s delay
          if (plant.cooldown <= 0) {
            if (!plant.userData.explodeDelay) {
              plant.userData.explodeDelay = 1;
              plant.userData.pulling = true;
            }

            // Pull zombies in during the delay
            if (plant.userData.pulling) {
              const pullRange = 10;
              this.zombies.forEach(z => {
                const dist = z.position.distanceTo(plant.position);
                if (dist <= pullRange && dist > 0.5) {
                  const pullDir = new THREE.Vector3().subVectors(plant.position, z.position).normalize();
                  const pullStrength = 0.15;
                  z.position.add(pullDir.multiplyScalar(pullStrength));
                  z.mesh.position.copy(z.position);
                }
              });
            }

            plant.userData.explodeDelay -= deltaTime;
            if (plant.userData.explodeDelay <= 0) {
              const range = 10; // 5x5 tiles
              this.zombies.forEach(z => {
                if (z.position.distanceTo(plant.position) <= range) {
                  z.health -= 150;
                  z.frozen = true;
                  z.frozenTimer = 2;
                }
              });
              this.createIceExplosion(plant.position);
              plant.health = 0; // Instant use
            }
          }
          break;

        case 'spike-wall':
          // Fusion: Vine Wall + Tomato Spike - 25 damage when bitten
          if (!plant.userData.lastHealth) {
            plant.userData.lastHealth = plant.health;
          }
          if (plant.health < plant.userData.lastHealth && plant.cooldown <= 0) {
            const nearestZombie = this.zombies.find(z => z.targetPlant === plant);
            if (nearestZombie) {
              nearestZombie.health -= 25;
              plant.cooldown = 0.5;
            }
          }
          plant.userData.lastHealth = plant.health;
          break;

        case 'acorn-nest':
          // Fusion: Acorn Tree + Banana Peel - Summons squirrels every 5s
          if (plant.cooldown <= 0) {
            this.spawnSquirrelAlly(plant.position, Math.random() < 0.05);
            plant.cooldown = 5;
          }
          break;

        case 'frozen-lily':
          // Fusion: Frost Berri + Lily - Charges ice ball over 10s
          plant.userData.chargeTime = (plant.userData.chargeTime || 0) + deltaTime;
          if (plant.userData.chargeTime >= 10 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootFrozenIceBall(plant.position, nearestZombie.position, 100, 25);
              plant.userData.chargeTime = 0;
            }
          }
          break;

        case 'frozen-lilyer':
          // Enhanced frozen lily - 100 damage, 50 sun per kill
          plant.userData.chargeTime = (plant.userData.chargeTime || 0) + deltaTime;
          if (plant.userData.chargeTime >= 10 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootFrozenIceBall(plant.position, nearestZombie.position, 100, 50);
              plant.userData.chargeTime = 0;
            }
          }
          break;

        case 'acorn-wall':
          // Fusion: Acorn Tree + Vine Wall - Auto-places acorn bomb when zombie nearby
          if (plant.cooldown <= 0) {
            const nearbyZombie = this.zombies.find(z =>
              z.position.distanceTo(plant.position) <= 4 && z.position.x > plant.position.x);
            if (nearbyZombie) {
              this.placeAcornBomb(plant.position);
              plant.cooldown = 8;
            }
          }
          break;

        case 'frost-overlord-grape-gun':
          // 2nd form: 3x100 damage grapes, 1s freeze, 4.5s cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              for (let i = 0; i < 3; i++) {
                setTimeout(() => {
                  this.shootFrostGrape(plant.position, nearestZombie.position, 100, 1);
                }, i * 100);
              }
              plant.cooldown = 4.5;
            }
          }
          break;

        case 'thornbomber':
          // 2nd form: 2 tile ram 450 damage + knockback, 3 bombs at 25 damage
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const zombiesInRange = this.zombies.filter(z =>
              z.position.distanceTo(plant.position) <= 4 && z.position.x > plant.position.x);
            if (zombiesInRange.length > 0) {
              zombiesInRange.forEach(z => {
                z.health -= 450;
                z.position.x += 4; // Knockback
                z.mesh.position.x += 4;
              });
              // Drop 3 bombs
              for (let i = 0; i < 3; i++) {
                this.dropThornBomb(plant.position, i);
              }
              plant.cooldown = 6;
            }
          }
          break;

        case 'titan-reaper-peall':
          // 2nd form: 2 tiles, 100 damage 2-tile range, 1s freeze, 2.5s cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const zombiesInRange = this.zombies.filter(z =>
              z.position.distanceTo(plant.position) <= 4);
            if (zombiesInRange.length > 0) {
              zombiesInRange.forEach(z => {
                z.health -= 100;
                z.frozen = true;
                z.frozenTimer = 1;
              });
              plant.cooldown = 2.5;
            }
          }
          break;

        case 'frozen-nebula-mushroom':
          // 2nd form: 50% disappear, 5x5 spore, pulls enemies, 250 damage, 50% slow
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const range = 10; // 5x5 tiles
            const zombiesInRange = this.zombies.filter(z => z.position.distanceTo(plant.position) <= range);
            if (zombiesInRange.length > 0) {
              zombiesInRange.forEach(z => {
                // Pull towards plant
                const pullDir = new THREE.Vector3().subVectors(plant.position, z.position).normalize();
                z.position.add(pullDir.multiplyScalar(2));
                z.mesh.position.copy(z.position);
                z.health -= 250;
                // 50% slow
                z.speed *= 0.5;
                setTimeout(() => { z.speed *= 2; }, 5000);
              });
              // 50% chance to disappear (teleport randomly)
              if (Math.random() < 0.5) {
                const newX = Math.random() * 8 - 4;
                const newZ = Math.random() * 8 - 4;
                plant.position.set(newX, plant.position.y, newZ);
                plant.mesh.position.copy(plant.position);
              }
              plant.cooldown = 4;
            }
          }
          break;

        case 'iron-grape-launcher':
          // GOLD CRATE: Shoots iron grapes dealing 100 damage every 5 seconds
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootIronGrape(plant.position, nearestZombie.position);
              plant.cooldown = 5;
            }
          }
          break;

        case 'iron-grape-shot':
          // Fusion: Iron Grape Launcher + Grape Shot - fires 2 iron grapes in burst, 100 dmg each, 1 tile knockback
          if (plant.burstCount > 0) {
            plant.burstDelay -= deltaTime;
            if (plant.burstDelay <= 0 && plant.burstTarget) {
              const shotPos = plant.position.clone();
              shotPos.y += plant.burstCount === 2 ? 0.15 : -0.15;
              this.shootIronGrape(shotPos, plant.burstTarget);
              plant.burstCount--;
              plant.burstDelay = 0.12;

              if (plant.burstCount <= 0) {
                plant.cooldown = 3;
                plant.burstTarget = null;
              }
            }
          } else if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              plant.burstCount = 2;
              plant.burstDelay = 0;
              plant.burstTarget = nearestZombie.position.clone();
            }
          }
          break;

        case 'eggplant-stunner':
          // GOLD CRATE: Shoots stun beam freezing zombies for 5 seconds, 7s cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootStunBeam(plant, nearestZombie);
              plant.cooldown = 7;
            }
          }
          break;

        case 'kiwi-blocker':
          // GOLD CRATE: Passive tank - damage redirect handled in zombie eating logic
          // Just animate a subtle pulse to show it's active
          break;

        case 'kiwi-slammer':
          // Fusion: Kiwi Blocker + Avocado Slammer - uses 200 HP to slam 300 damage, 5s cooldown
          if (plant.cooldown <= 0 && plant.health > 200) {
            const zombiesInRange = this.zombies.filter(z => {
              const distance = z.position.distanceTo(plant.position);
              return distance <= 4; // 2 tiles = 4 units
            });

            if (zombiesInRange.length > 0) {
              // Spend 200 HP
              plant.health -= 200;

              // Deal 300 damage to all zombies in range
              zombiesInRange.forEach(zombie => {
                zombie.health -= 300;
              });

              // Create green/orange slam shockwave
              const slamGeo = new THREE.CylinderGeometry(4, 0.5, 0.5, 32);
              const slamMat = new THREE.MeshBasicMaterial({
                color: 0x88cc22,
                transparent: true,
                opacity: 0.8
              });
              const slam = new THREE.Mesh(slamGeo, slamMat);
              slam.position.copy(plant.position);
              slam.position.y = 0.25;
              this.scene.add(slam);

              // Inner orange ring
              const innerGeo = new THREE.CylinderGeometry(2, 0.3, 0.6, 24);
              const innerMat = new THREE.MeshBasicMaterial({
                color: 0xff8800,
                transparent: true,
                opacity: 0.9
              });
              const inner = new THREE.Mesh(innerGeo, innerMat);
              inner.position.copy(plant.position);
              inner.position.y = 0.3;
              this.scene.add(inner);

              // Animate slam effect
              let slamScale = 1;
              let slamOpacity = 0.8;
              const slamInterval = setInterval(() => {
                slamScale += 0.2;
                slamOpacity -= 0.12;
                slam.scale.set(slamScale, 1, slamScale);
                inner.scale.set(slamScale * 0.8, 1, slamScale * 0.8);
                slamMat.opacity = slamOpacity;
                innerMat.opacity = slamOpacity * 1.1;
                if (slamOpacity <= 0) {
                  this.scene.remove(slam);
                  this.scene.remove(inner);
                  clearInterval(slamInterval);
                }
              }, 50);

              // Bounce animation on the plant
              const origY = plant.mesh.position.y;
              plant.mesh.position.y = origY + 0.5;
              setTimeout(() => {
                if (plant.mesh) plant.mesh.position.y = origY;
              }, 150);

              plant.cooldown = 5;
              console.log(`Kiwi Slammer hit ${zombiesInRange.length} zombies for 300 damage! (200 HP spent, ${plant.health} HP remaining)`);
            }
          }
          break;

        case 'banana-tree':
          // GOLD CRATE: Summons allies every 30 seconds
          if (plant.cooldown <= 0) {
            const roll = Math.random();
            let allyType: AllyType;
            if (roll < 0.6) {
              allyType = 'gorilla'; // 60% - same as banana peel gorilla
            } else if (roll < 0.9) {
              allyType = 'great-gorilla'; // 30% - 1000 HP, 200 dmg/4s
            } else {
              allyType = 'baby-yeti'; // 10% - 1500 HP, 50 dmg/1s
            }

            const allyMesh = this.createAllyMesh(allyType);
            const spawnPos = plant.position.clone();
            spawnPos.x += 1;
            allyMesh.position.copy(spawnPos);
            allyMesh.rotation.y = Math.PI / 2;
            this.scene.add(allyMesh);

            const ally = new Ally(allyMesh, allyType, spawnPos.clone());
            this.allies.push(ally);

            // Golden summon effect
            const summonGeo = new THREE.RingGeometry(0.3, 0.8, 16);
            const summonMat = new THREE.MeshBasicMaterial({
              color: 0xffd700,
              transparent: true,
              opacity: 0.9,
              side: THREE.DoubleSide
            });
            const summon = new THREE.Mesh(summonGeo, summonMat);
            summon.rotation.x = -Math.PI / 2;
            summon.position.copy(spawnPos);
            summon.position.y = 0.1;
            this.scene.add(summon);

            let summonScale = 0.5;
            let summonOpacity = 0.9;
            const summonInterval = setInterval(() => {
              summonScale += 0.15;
              summonOpacity -= 0.1;
              summon.scale.set(summonScale, summonScale, 1);
              if (summonMat instanceof THREE.MeshBasicMaterial) {
                summonMat.opacity = summonOpacity;
              }
              if (summonOpacity <= 0) {
                this.scene.remove(summon);
                clearInterval(summonInterval);
              }
            }, 50);

            console.log(`Banana Tree summoned a ${allyType}!`);
            plant.cooldown = 30;
          }
          break;

        case 'onion-freezer':
          // Fusion: Onion Flier + Frost Berri - Flies over zombies dropping ice bombs (250 damage + 30% slow)
          if (!plant.userData) plant.userData = {};
          if (plant.userData.flyState === undefined) {
            plant.userData.flyState = 'idle';
            plant.userData.flyTargetX = 0;
            plant.userData.flyTargetZ = 0;
            plant.userData.homeX = plant.position.x;
            plant.userData.homeZ = plant.position.z;
            plant.userData.bombsDropped = 0;
          }

          // Animate propeller always
          plant.mesh.children.forEach(child => {
            if (child.userData && child.userData.isPropeller) {
              child.rotation.y += plant.userData.flyState === 'flying' ? 0.8 : 0.4;
            }
          });

          // Gentle hovering
          plant.mesh.position.y = Math.sin(Date.now() * 0.004) * 0.12;

          if (plant.userData.flyState === 'idle') {
            plant.mesh.rotation.y = 0;
          }

          if (plant.userData.flyState === 'idle' && this.waveStarted && plant.cooldown <= 0) {
            // Find best zombie group to bomb
            let bestTarget: { x: number; z: number; count: number } | null = null;
            let maxZombies = 0;

            for (let x = -4; x <= 14; x += 2) {
              for (let z = -8; z <= 0; z += 2) {
                const zombiesHere = this.zombies.filter(zombie => {
                  const dx = zombie.position.x - x;
                  const dz = zombie.position.z - z;
                  return Math.sqrt(dx * dx + dz * dz) <= 2.0;
                }).length;

                if (zombiesHere > maxZombies) {
                  maxZombies = zombiesHere;
                  bestTarget = { x, z, count: zombiesHere };
                }
              }
            }

            if (bestTarget && bestTarget.count > 0) {
              plant.userData.flyState = 'flying';
              plant.userData.flyTargetX = bestTarget.x;
              plant.userData.flyTargetZ = bestTarget.z;
              plant.userData.bombsDropped = 0;
            }
          } else if (plant.userData.flyState === 'flying') {
            const dx = plant.userData.flyTargetX - plant.mesh.position.x;
            const dz = plant.userData.flyTargetZ - plant.mesh.position.z;
            const dist = Math.sqrt(dx * dx + dz * dz);
            plant.mesh.rotation.y = Math.atan2(-dz, dx);

            if (dist > 0.5) {
              const speed = 0.2;
              plant.mesh.position.x += (dx / dist) * speed;
              plant.mesh.position.z += (dz / dist) * speed;
            } else {
              plant.userData.flyState = 'bombing';
              plant.userData.bombTimer = 0;
            }
          } else if (plant.userData.flyState === 'bombing') {
            plant.userData.bombTimer = (plant.userData.bombTimer || 0) + deltaTime;

            if (plant.userData.bombTimer >= 0.2 && plant.userData.bombsDropped < 1) {
              plant.userData.bombTimer = 0;
              plant.userData.bombsDropped++;

              // Create ice bomb
              const bombGeo = new THREE.SphereGeometry(0.15, 10, 10);
              const bombMat = new THREE.MeshPhongMaterial({ color: 0x88ccff, shininess: 150, emissive: 0x4488cc, emissiveIntensity: 0.4 });
              const bomb = new THREE.Mesh(bombGeo, bombMat);
              bomb.position.set(plant.mesh.position.x, 1.8, plant.mesh.position.z);
              this.scene.add(bomb);

              const finalBombX = plant.userData.flyTargetX;
              const finalBombZ = plant.userData.flyTargetZ;
              const startX = plant.mesh.position.x;
              const startZ = plant.mesh.position.z;

              let bombFall = 0;
              const bombInterval = setInterval(() => {
                bombFall += 0.1;
                if (bombFall >= 1) {
                  clearInterval(bombInterval);
                  this.scene.remove(bomb);

                  // ICE EXPLOSION - 250 damage + 30% slow
                  const explosionGeo = new THREE.SphereGeometry(2.0, 12, 12);
                  const explosionMat = new THREE.MeshBasicMaterial({
                    color: 0x88ddff, transparent: true, opacity: 0.7
                  });
                  const explosion = new THREE.Mesh(explosionGeo, explosionMat);
                  explosion.position.set(finalBombX, 0.3, finalBombZ);
                  this.scene.add(explosion);

                  // Ice shards
                  for (let i = 0; i < 8; i++) {
                    const shardGeo = new THREE.ConeGeometry(0.08, 0.3, 4);
                    const shardMat = new THREE.MeshPhongMaterial({ color: 0xccffff, transparent: true, opacity: 0.8 });
                    const shard = new THREE.Mesh(shardGeo, shardMat);
                    const angle = (i / 8) * Math.PI * 2;
                    shard.position.set(finalBombX + Math.cos(angle) * 1.5, 0.5, finalBombZ + Math.sin(angle) * 1.5);
                    this.scene.add(shard);
                    setTimeout(() => this.scene.remove(shard), 400);
                  }

                  const splashRadius = 2.0;
                  for (const zombie of this.zombies) {
                    const zx = zombie.position.x - finalBombX;
                    const zz = zombie.position.z - finalBombZ;
                    const zDist = Math.sqrt(zx * zx + zz * zz);
                    if (zDist <= splashRadius) {
                      zombie.health -= 250;
                      // 30% slow for 3 seconds
                      const origSpeed = zombie.speed;
                      zombie.speed *= 0.7;
                      setTimeout(() => { zombie.speed = origSpeed; }, 3000);
                    }
                  }

                  setTimeout(() => this.scene.remove(explosion), 300);
                } else {
                  bomb.position.x = startX + (finalBombX - startX) * bombFall;
                  bomb.position.z = startZ + (finalBombZ - startZ) * bombFall;
                  bomb.position.y = 1.8 - bombFall * 1.5;
                  bomb.rotation.x += 0.15;
                }
              }, 25);
            }

            if (plant.userData.bombsDropped >= 1 && plant.userData.bombTimer >= 0.3) {
              plant.userData.flyState = 'returning';
              plant.cooldown = 11; // 11 second cooldown
            }
          } else if (plant.userData.flyState === 'returning') {
            const dx = plant.userData.homeX - plant.mesh.position.x;
            const dz = plant.userData.homeZ - plant.mesh.position.z;
            const dist = Math.sqrt(dx * dx + dz * dz);
            plant.mesh.rotation.y = Math.atan2(-dz, dx);

            if (dist > 0.3) {
              const speed = 0.18;
              plant.mesh.position.x += (dx / dist) * speed;
              plant.mesh.position.z += (dz / dist) * speed;
            } else {
              plant.mesh.position.x = plant.userData.homeX;
              plant.mesh.position.z = plant.userData.homeZ;
              plant.mesh.rotation.y = 0;
              plant.userData.flyState = 'idle';
            }
          }
          break;

        case 'rooted-grape-launcher':
          // Fusion: Roots + Grape Launcher - Shoots grapes + stuns zombie on eat
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootGrape(plant.position, nearestZombie.position, 30);
              plant.cooldown = 3;
            }
          }
          // Check if being eaten - disappear and stun the zombie
          {
            const eatingZombie = this.zombies.find(z =>
              z.isEating && z.targetPlant &&
              z.targetPlant.position.distanceTo(plant.position) < 0.5
            );
            if (eatingZombie) {
              // Stun the zombie for 5 seconds
              eatingZombie.rooted = true;
              eatingZombie.rootedTimer = 5;
              eatingZombie.isEating = false;
              eatingZombie.targetPlant = null;

              // Root visual on zombie
              eatingZombie.mesh.children.forEach(child => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
                  child.material = new THREE.MeshPhongMaterial({
                    color: 0x5c4033,
                    emissive: 0x228b22,
                    emissiveIntensity: 0.3
                  });
                }
              });

              // Root tendrils
              for (let r = 0; r < 4; r++) {
                const rootGeo = new THREE.CylinderGeometry(0.04, 0.08, 0.6, 6);
                const rootMat = new THREE.MeshPhongMaterial({ color: 0x3a5a2a });
                const root = new THREE.Mesh(rootGeo, rootMat);
                const angle = (r / 4) * Math.PI * 2;
                root.position.set(
                  eatingZombie.position.x + Math.cos(angle) * 0.3,
                  0.3,
                  eatingZombie.position.z + Math.sin(angle) * 0.3
                );
                root.rotation.z = Math.cos(angle) * 0.5;
                this.scene.add(root);
                setTimeout(() => this.scene.remove(root), 5000);
              }

              console.log('Rooted Grape Launcher stunned zombie and vanished!');
              plant.health = 0; // Disappear
            }
          }
          break;

        case 'vined-grape-wall':
          // Fusion: Vined Wall + Grape Launcher - 1800 HP wall that shoots grapes
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootGrape(plant.position, nearestZombie.position, 50);
              plant.cooldown = 3;
            }
          }
          break;

        case 'grape-crate':
          // Fusion: Pineapple Crate + Grape Launcher - 1250 HP, buffs grape plants by 7.5%
          // Passive buff handled in projectile damage calculation
          // Just display a subtle grape energy pulse visual
          break;

        case 'strawberry-pear-launcher':
          // Fusion: Pear Cannon + Strawberry Launcher - burst of 2 @ 30 dmg, 2s cooldown
          // Click activates rapid-fire mode: 0.5s cooldown for 5 seconds, then 10s recharge
          if (!plant.userData) plant.userData = {};
          if (plant.userData.rapidFireActive) {
            // Rapid fire mode: shoots every 0.5s for 5 seconds
            if (plant.cooldown <= 0 && this.zombies.length > 0) {
              const nearestZombie = this.findNearestZombieInRow(plant.position);
              if (nearestZombie) {
                this.shootStrawberryPear(plant.position, nearestZombie.position);
                plant.cooldown = 0.5;
              }
            }
            plant.userData.rapidFireTimer -= deltaTime;
            if (plant.userData.rapidFireTimer <= 0) {
              plant.userData.rapidFireActive = false;
              plant.cooldown = 10; // 10s cooldown before clicking again
            }
          } else if (plant.burstCount > 0) {
            // Handle ongoing burst
            plant.burstDelay -= deltaTime;
            if (plant.burstDelay <= 0 && plant.burstTarget) {
              const shotPos = plant.position.clone();
              shotPos.y += plant.burstCount === 2 ? 0 : 0.3;
              this.shootStrawberryPear(shotPos, plant.burstTarget);
              plant.burstCount--;
              plant.burstDelay = 0.15;
              if (plant.burstCount <= 0) {
                plant.cooldown = 2;
                plant.burstTarget = null;
              }
            }
          } else if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              plant.burstCount = 2;
              plant.burstDelay = 0;
              plant.burstTarget = nearestZombie.position.clone();
            }
          }
          break;

        case 'frozen-pickle-spear':
          // Fusion: Pickle Spiker + Frost Berri - 500 dmg, 2 tile knockback, 50% slow, 15s cd
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.throwFrozenPickleSpear(plant.position, nearestZombie.position);
              plant.cooldown = 15;
            }
          }
          break;

        case 'mushroom-healer':
          // Fusion: Mushroom Bomber + Rose Reaper - heals all plants in 3x3 range for 50 HP, 5s cooldown
          if (plant.cooldown <= 0) {
            const damagedPlantsInRange = this.placedPlants.filter(p => {
              if (p === plant || p.health <= 0) return false;
              const distance = p.position.distanceTo(plant.position);
              return distance <= 6 && p.health < p.maxHealth;
            });

            if (damagedPlantsInRange.length > 0) {
              damagedPlantsInRange.forEach(targetPlant => {
                const healAmount = 50;
                targetPlant.health = Math.min(targetPlant.maxHealth, targetPlant.health + healAmount);

                // Green healing spore effect flying to target
                const spore = new THREE.Mesh(
                  new THREE.SphereGeometry(0.15, 8, 8),
                  new THREE.MeshBasicMaterial({ color: 0x44ff88, transparent: true, opacity: 0.7 })
                );
                spore.position.copy(plant.position);
                spore.position.y = 1.5;
                this.scene.add(spore);

                const startPos = spore.position.clone();
                const targetPos = targetPlant.position.clone();
                targetPos.y = 1.0;
                let sporeProgress = 0;
                const sporeInterval = setInterval(() => {
                  sporeProgress += 0.08;
                  spore.position.lerpVectors(startPos, targetPos, Math.min(sporeProgress, 1));
                  spore.position.y += Math.sin(sporeProgress * Math.PI) * 0.3;
                  (spore.material as THREE.MeshBasicMaterial).opacity = 0.7 * (1 - sporeProgress * 0.5);
                  if (sporeProgress >= 1) {
                    this.scene.remove(spore);
                    clearInterval(sporeInterval);

                    // Heal burst at target
                    const healBurst = new THREE.Mesh(
                      new THREE.SphereGeometry(0.5, 12, 12),
                      new THREE.MeshBasicMaterial({ color: 0x00ff44, transparent: true, opacity: 0.6 })
                    );
                    healBurst.position.copy(targetPos);
                    this.scene.add(healBurst);
                    let healOpacity = 0.6;
                    const healInterval = setInterval(() => {
                      healOpacity -= 0.1;
                      (healBurst.material as THREE.MeshBasicMaterial).opacity = healOpacity;
                      healBurst.scale.multiplyScalar(1.15);
                      if (healOpacity <= 0) {
                        this.scene.remove(healBurst);
                        clearInterval(healInterval);
                      }
                    }, 50);
                  }
                }, 30);
              });

              // Green healing cloud around mushroom healer
              const cloud = new THREE.Mesh(
                new THREE.SphereGeometry(2, 16, 16),
                new THREE.MeshBasicMaterial({ color: 0x44ff88, transparent: true, opacity: 0.2 })
              );
              cloud.position.copy(plant.position);
              cloud.position.y = 1;
              cloud.scale.set(0.3, 0.3, 0.3);
              this.scene.add(cloud);
              let cloudScale = 0.3;
              const cloudInterval = setInterval(() => {
                cloudScale += 0.15;
                cloud.scale.set(cloudScale, cloudScale * 0.6, cloudScale);
                (cloud.material as THREE.MeshBasicMaterial).opacity *= 0.88;
                if ((cloud.material as THREE.MeshBasicMaterial).opacity < 0.02) {
                  this.scene.remove(cloud);
                  clearInterval(cloudInterval);
                }
              }, 50);

              plant.cooldown = 5;
            }
          }
          break;
        case 'red-fire-flower':
          // Dragon Battle reward: Shoots red firecrackers dealing 500 damage, 10s cooldown
          if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootFirecracker(plant.position, nearestZombie.position);
              plant.cooldown = 10;
            }
          }
          break;
        case 'red-firecracker-flower':
          // Fusion: Shoots TWO firecrackers at 500 dmg each, 10s cooldown
          if (plant.burstCount > 0) {
            plant.burstDelay -= deltaTime;
            if (plant.burstDelay <= 0) {
              const burstTarget = this.findNearestZombieInRow(plant.position);
              if (burstTarget) {
                this.shootFirecracker(plant.position, burstTarget.position);
              }
              plant.burstCount--;
              plant.burstDelay = 0.2;
              if (plant.burstCount <= 0) {
                plant.cooldown = 10;
              }
            }
          } else if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootFirecracker(plant.position, nearestZombie.position);
              plant.burstCount = 1; // 1 more after the first = 2 total
              plant.burstDelay = 0.2;
            }
          }
          break;
        case 'red-firespiker-flower':
          // Fusion: Shoots THREE firecrackers at 500 dmg each + 10 dmg/s burn, 15s cooldown
          if (plant.burstCount > 0) {
            plant.burstDelay -= deltaTime;
            if (plant.burstDelay <= 0) {
              const burstTarget = this.findNearestZombieInRow(plant.position);
              if (burstTarget) {
                this.shootFirespiker(plant.position, burstTarget.position);
              }
              plant.burstCount--;
              plant.burstDelay = 0.25;
              if (plant.burstCount <= 0) {
                plant.cooldown = 15;
              }
            }
          } else if (plant.cooldown <= 0 && this.zombies.length > 0) {
            const nearestZombie = this.findNearestZombieInRow(plant.position);
            if (nearestZombie) {
              this.shootFirespiker(plant.position, nearestZombie.position);
              plant.burstCount = 2; // 2 more after the first = 3 total
              plant.burstDelay = 0.25;
            }
          }
          break;
      }
    }
  }

  private shootFirespiker(from: THREE.Vector3, to: THREE.Vector3): void {
    const crackerGroup = new THREE.Group();

    // Main firecracker body - darker red with spike motif
    const bodyGeo = new THREE.CylinderGeometry(0.09, 0.09, 0.45, 8);
    const bodyMat = new THREE.MeshPhongMaterial({
      color: 0xcc0000, shininess: 100, emissive: 0xaa0000, emissiveIntensity: 0.6
    });
    const body = new THREE.Mesh(bodyGeo, bodyMat);
    body.rotation.z = Math.PI / 2;
    crackerGroup.add(body);

    // Gold bands
    for (let i = 0; i < 3; i++) {
      const bandGeo = new THREE.CylinderGeometry(0.11, 0.11, 0.03, 8);
      const bandMat = new THREE.MeshPhongMaterial({ color: 0xffd700, shininess: 200 });
      const band = new THREE.Mesh(bandGeo, bandMat);
      band.rotation.z = Math.PI / 2;
      band.position.x = (i - 1) * 0.14;
      crackerGroup.add(band);
    }

    // Spiked metal tip
    const tipGeo = new THREE.ConeGeometry(0.06, 0.15, 6);
    const tipMat = new THREE.MeshPhongMaterial({ color: 0x888888, shininess: 120 });
    const tip = new THREE.Mesh(tipGeo, tipMat);
    tip.rotation.z = -Math.PI / 2;
    tip.position.x = 0.30;
    crackerGroup.add(tip);

    // Intense sparking fuse
    const fuseGeo = new THREE.SphereGeometry(0.07, 8, 8);
    const fuseMat = new THREE.MeshBasicMaterial({ color: 0xffcc00, transparent: true, opacity: 0.95 });
    const fuse = new THREE.Mesh(fuseGeo, fuseMat);
    fuse.position.x = -0.28;
    crackerGroup.add(fuse);

    // Double flame trail
    for (let f = 0; f < 2; f++) {
      const flameGeo = new THREE.ConeGeometry(0.07, 0.2, 6);
      const flameMat = new THREE.MeshBasicMaterial({ color: f === 0 ? 0xff4400 : 0xff8800, transparent: true, opacity: 0.7 });
      const flame = new THREE.Mesh(flameGeo, flameMat);
      flame.rotation.z = -Math.PI / 2;
      flame.position.set(-0.38 - f * 0.1, (f - 0.5) * 0.06, 0);
      crackerGroup.add(flame);
    }

    crackerGroup.position.copy(from);
    crackerGroup.position.y = 1.3;
    this.scene.add(crackerGroup);

    this.triggerShootAnimation(from, 'fire');

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(22);

    const projectile = new Projectile(crackerGroup as unknown as THREE.Mesh, crackerGroup.position, velocity, 500, false);
    projectile.userData = { type: 'firecracker', isBurn: true, burnDamage: 20, burnDuration: 8 };
    this.projectiles.push(projectile);
  }

  private shootFirecracker(from: THREE.Vector3, to: THREE.Vector3): void {
    const crackerGroup = new THREE.Group();

    // Main firecracker body - red cylinder
    const bodyGeo = new THREE.CylinderGeometry(0.08, 0.08, 0.4, 8);
    const bodyMat = new THREE.MeshPhongMaterial({
      color: 0xff0000, shininess: 100, emissive: 0xcc0000, emissiveIntensity: 0.5
    });
    const body = new THREE.Mesh(bodyGeo, bodyMat);
    body.rotation.z = Math.PI / 2;
    crackerGroup.add(body);

    // Gold bands on firecracker
    for (let i = 0; i < 3; i++) {
      const bandGeo = new THREE.CylinderGeometry(0.10, 0.10, 0.03, 8);
      const bandMat = new THREE.MeshPhongMaterial({ color: 0xffd700, shininess: 200 });
      const band = new THREE.Mesh(bandGeo, bandMat);
      band.rotation.z = Math.PI / 2;
      band.position.x = (i - 1) * 0.12;
      crackerGroup.add(band);
    }

    // Sparking fuse tip
    const fuseGeo = new THREE.SphereGeometry(0.06, 8, 8);
    const fuseMat = new THREE.MeshBasicMaterial({ color: 0xffaa00, transparent: true, opacity: 0.9 });
    const fuse = new THREE.Mesh(fuseGeo, fuseMat);
    fuse.position.x = -0.25;
    crackerGroup.add(fuse);

    // Flame trail
    const flameGeo = new THREE.ConeGeometry(0.08, 0.25, 6);
    const flameMat = new THREE.MeshBasicMaterial({ color: 0xff6600, transparent: true, opacity: 0.6 });
    const flame = new THREE.Mesh(flameGeo, flameMat);
    flame.rotation.z = -Math.PI / 2;
    flame.position.x = -0.35;
    crackerGroup.add(flame);

    crackerGroup.position.copy(from);
    crackerGroup.position.y = 1.2;
    this.scene.add(crackerGroup);

    this.triggerShootAnimation(from, 'fire');

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(20);

    const projectile = new Projectile(crackerGroup as unknown as THREE.Mesh, crackerGroup.position, velocity, 500, false);
    projectile.userData = { type: 'firecracker', isBurn: true };
    this.projectiles.push(projectile);
  }

  private shootDragonFireball(from: THREE.Vector3, to: THREE.Vector3, damage: number = 300): void {
    const fireballGroup = new THREE.Group();

    // Main fireball body
    const ballGeo = new THREE.SphereGeometry(0.3, 16, 16);
    const ballMat = new THREE.MeshPhongMaterial({
      color: 0xff4400, shininess: 150, emissive: 0xff2200, emissiveIntensity: 0.8
    });
    const ball = new THREE.Mesh(ballGeo, ballMat);
    fireballGroup.add(ball);

    // Inner core
    const coreGeo = new THREE.SphereGeometry(0.15, 12, 12);
    const coreMat = new THREE.MeshBasicMaterial({ color: 0xffff00, transparent: true, opacity: 0.9 });
    const core = new THREE.Mesh(coreGeo, coreMat);
    fireballGroup.add(core);

    // Outer flame glow
    const glowGeo = new THREE.SphereGeometry(0.45, 12, 12);
    const glowMat = new THREE.MeshBasicMaterial({ color: 0xff6600, transparent: true, opacity: 0.3 });
    const glow = new THREE.Mesh(glowGeo, glowMat);
    fireballGroup.add(glow);

    // Fire trail particles
    for (let i = 0; i < 6; i++) {
      const trailGeo = new THREE.ConeGeometry(0.06, 0.2, 6);
      const trailMat = new THREE.MeshBasicMaterial({ color: 0xff8800, transparent: true, opacity: 0.7 });
      const trail = new THREE.Mesh(trailGeo, trailMat);
      const angle = (i / 6) * Math.PI * 2;
      trail.position.set(Math.cos(angle) * 0.3, Math.sin(angle) * 0.3, 0);
      fireballGroup.add(trail);
    }

    fireballGroup.position.copy(from);
    fireballGroup.position.y = 1.2;
    this.scene.add(fireballGroup);

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(15);

    // Store as zombie projectile (damages plants, not zombies)
    if (!this.zombieProjectiles) this.zombieProjectiles = [];
    this.zombieProjectiles.push({
      mesh: fireballGroup as unknown as THREE.Mesh,
      position: fireballGroup.position,
      velocity: velocity,
      damage: damage,
      isFromZombie: true,
      isBurn: true
    });
  }

  private shootIronGrape(from: THREE.Vector3, to: THREE.Vector3): void {
    // Apply Grape Pulser power plant passive: +10% damage (applied to projectile below)
    const ironGrapeDmg = (this.powerPlant && this.powerPlantType === 'grape-pulser' && this.powerPlant.health > 0) ? 110 : 100;
    const grapeGroup = new THREE.Group();

    // Iron grape core - metallic dark purple
    const grapeGeo = new THREE.SphereGeometry(0.22, 16, 16);
    const grapeMat = new THREE.MeshPhongMaterial({
      color: 0x5a3a7a,
      shininess: 180,
      specular: 0xaaaaaa,
      emissive: 0x2a1a3a,
      emissiveIntensity: 0.3
    });
    const grape = new THREE.Mesh(grapeGeo, grapeMat);
    grapeGroup.add(grape);

    // Iron plating around the grape
    const ironGeo = new THREE.TorusGeometry(0.2, 0.04, 8, 12);
    const ironMat = new THREE.MeshPhongMaterial({
      color: 0x888888,
      shininess: 200,
      specular: 0xffffff,
      emissive: 0x333333,
      emissiveIntensity: 0.2
    });
    const ring1 = new THREE.Mesh(ironGeo, ironMat);
    grapeGroup.add(ring1);
    const ring2 = new THREE.Mesh(ironGeo, ironMat);
    ring2.rotation.y = Math.PI / 2;
    grapeGroup.add(ring2);

    // Impact glow
    const glowGeo = new THREE.SphereGeometry(0.3, 12, 12);
    const glowMat = new THREE.MeshBasicMaterial({
      color: 0x9955cc,
      transparent: true,
      opacity: 0.3
    });
    const glow = new THREE.Mesh(glowGeo, glowMat);
    grapeGroup.add(glow);

    grapeGroup.position.copy(from);
    grapeGroup.position.y = 1.0;
    this.scene.add(grapeGroup);

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(18);
    const projectile = new Projectile(grapeGroup as unknown as THREE.Mesh, from.clone(), velocity, ironGrapeDmg, false);
    projectile.userData = { knockback: 2 }; // 1 tile knockback
    this.projectiles.push(projectile);
  }

  private shootStrawberryPear(from: THREE.Vector3, to: THREE.Vector3): void {
    const projGroup = new THREE.Group();

    // Pear-shaped body (gold-green, smaller than regular pear)
    const body = new THREE.Mesh(
      new THREE.SphereGeometry(0.1, 12, 12),
      new THREE.MeshPhongMaterial({ color: 0xc5e636, shininess: 100, specular: 0xffffaa, emissive: 0x3a4a10, emissiveIntensity: 0.3 })
    );
    body.scale.set(0.9, 1.2, 0.9);
    projGroup.add(body);

    // Strawberry seed dots (red)
    for (let i = 0; i < 5; i++) {
      const seed = new THREE.Mesh(
        new THREE.SphereGeometry(0.015, 6, 6),
        new THREE.MeshPhongMaterial({ color: 0xff2255, emissive: 0x880022, emissiveIntensity: 0.5 })
      );
      const phi = Math.acos(-1 + (2 * i) / 5);
      const theta = Math.sqrt(5 * Math.PI) * phi;
      seed.position.set(0.08 * Math.cos(theta) * Math.sin(phi), 0.1 * Math.cos(phi), 0.08 * Math.sin(theta) * Math.sin(phi));
      projGroup.add(seed);
    }

    // Pink energy trail glow
    const glow = new THREE.Mesh(
      new THREE.SphereGeometry(0.15, 8, 8),
      new THREE.MeshBasicMaterial({ color: 0xff88aa, transparent: true, opacity: 0.3 })
    );
    projGroup.add(glow);

    projGroup.position.copy(from);
    projGroup.position.y = 1.2;
    this.scene.add(projGroup);

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(22);
    const projectile = new Projectile(projGroup as unknown as THREE.Mesh, projGroup.position.clone(), velocity, 30, false);
    this.projectiles.push(projectile);
  }

  private throwFrozenPickleSpear(from: THREE.Vector3, to: THREE.Vector3): void {
    const spearGroup = new THREE.Group();

    // Icy pickle spear shaft
    const shaft = new THREE.Mesh(
      new THREE.CylinderGeometry(0.06, 0.18, 1.4, 8),
      new THREE.MeshPhongMaterial({ color: 0x88ddff, shininess: 200, specular: 0xffffff, emissive: 0x2266aa, emissiveIntensity: 0.4 })
    );
    shaft.rotation.z = -Math.PI / 2;
    spearGroup.add(shaft);

    // Ice crystal tip
    const tip = new THREE.Mesh(
      new THREE.OctahedronGeometry(0.12, 0),
      new THREE.MeshPhongMaterial({ color: 0xaaeeff, shininess: 200, specular: 0xffffff, emissive: 0x4488ff, emissiveIntensity: 0.6, transparent: true, opacity: 0.9 })
    );
    tip.position.x = 0.7;
    spearGroup.add(tip);

    // Green pickle veins on shaft
    for (let i = 0; i < 3; i++) {
      const vein = new THREE.Mesh(
        new THREE.CylinderGeometry(0.02, 0.02, 0.8, 6),
        new THREE.MeshPhongMaterial({ color: 0x52b828, emissive: 0x1f4010, emissiveIntensity: 0.3 })
      );
      vein.rotation.z = -Math.PI / 2;
      const vnAngle = (i / 3) * Math.PI * 2;
      vein.position.set(0, Math.sin(vnAngle) * 0.08, Math.cos(vnAngle) * 0.08);
      spearGroup.add(vein);
    }

    // Frost trail glow
    const frostGlow = new THREE.Mesh(
      new THREE.SphereGeometry(0.25, 8, 8),
      new THREE.MeshBasicMaterial({ color: 0x88ddff, transparent: true, opacity: 0.3 })
    );
    spearGroup.add(frostGlow);

    spearGroup.position.copy(from);
    spearGroup.position.y = 1.0;
    this.scene.add(spearGroup);

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(25);
    const projectile = new Projectile(spearGroup as unknown as THREE.Mesh, spearGroup.position.clone(), velocity, 500, false);
    projectile.userData = { knockback: 4, slowChance: 1.0, slowAmount: 0.5, slowDuration: 5000 }; // 2 tile knockback + 50% slow for 5s
    this.projectiles.push(projectile);
  }

  private shootStunBeam(plant: Plant, target: Zombie): void {
    // Create visual beam from plant to zombie
    const beamStart = plant.position.clone();
    beamStart.y = 1.0;
    const beamEnd = target.position.clone();
    beamEnd.y = 0.5;

    const direction = new THREE.Vector3().subVectors(beamEnd, beamStart);
    const length = direction.length();

    // Beam cylinder
    const beamGeo = new THREE.CylinderGeometry(0.08, 0.08, length, 8);
    const beamMat = new THREE.MeshBasicMaterial({
      color: 0xaa00ff,
      transparent: true,
      opacity: 0.8
    });
    const beam = new THREE.Mesh(beamGeo, beamMat);

    // Position beam between plant and zombie
    const midpoint = beamStart.clone().add(beamEnd).multiplyScalar(0.5);
    beam.position.copy(midpoint);

    // Rotate beam to point from plant to zombie
    beam.lookAt(beamEnd);
    beam.rotateX(Math.PI / 2);

    this.scene.add(beam);

    // Inner glow beam
    const innerGeo = new THREE.CylinderGeometry(0.04, 0.04, length, 8);
    const innerMat = new THREE.MeshBasicMaterial({
      color: 0xdd66ff,
      transparent: true,
      opacity: 0.9
    });
    const innerBeam = new THREE.Mesh(innerGeo, innerMat);
    innerBeam.position.copy(midpoint);
    innerBeam.lookAt(beamEnd);
    innerBeam.rotateX(Math.PI / 2);
    this.scene.add(innerBeam);

    // Stun all zombies in the beam's row
    const rowZ = plant.position.z;
    const stunTargets = this.zombies.filter(z => {
      const sameRow = Math.abs(z.position.z - rowZ) < 1.5;
      const inFront = z.position.x > plant.position.x;
      const inRange = z.position.x <= target.position.x + 2;
      return sameRow && inFront && inRange;
    });

    stunTargets.forEach(z => {
      if (!z.isFreezeImmune && z.freezeImmunityTimer <= 0) {
        z.frozen = true;
        z.frozenTimer = 5; // 5 second stun

        // Purple stun visual on zombie
        z.mesh.children.forEach(child => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            child.material = new THREE.MeshPhongMaterial({
              color: 0x7700aa,
              emissive: 0x4400aa,
              emissiveIntensity: 0.5
            });
          }
        });
      }
    });

    // Impact ring at target
    const impactGeo = new THREE.RingGeometry(0.2, 0.6, 16);
    const impactMat = new THREE.MeshBasicMaterial({
      color: 0xcc44ff,
      transparent: true,
      opacity: 0.8,
      side: THREE.DoubleSide
    });
    const impact = new THREE.Mesh(impactGeo, impactMat);
    impact.position.copy(target.position);
    impact.position.y = 0.5;
    impact.rotation.x = -Math.PI / 2;
    this.scene.add(impact);

    // Animate beam fade
    let beamOpacity = 0.8;
    const beamInterval = setInterval(() => {
      beamOpacity -= 0.1;
      beamMat.opacity = beamOpacity;
      innerMat.opacity = beamOpacity + 0.1;
      impactMat.opacity = beamOpacity;
      const scale = 1 + (0.8 - beamOpacity) * 2;
      impact.scale.set(scale, scale, 1);
      if (beamOpacity <= 0) {
        this.scene.remove(beam);
        this.scene.remove(innerBeam);
        this.scene.remove(impact);
        clearInterval(beamInterval);
      }
    }, 50);

    console.log(`Eggplant Stunner stunned ${stunTargets.length} zombies for 5 seconds!`);
  }

  private performSlam(plant: Plant, zombies: Zombie[]): void {
    // Create slam effect
    const slamGeo = new THREE.CylinderGeometry(4, 0.5, 0.5, 32);
    const slamMat = new THREE.MeshBasicMaterial({
      color: 0xffa500,
      transparent: true,
      opacity: 0.8
    });
    const slam = new THREE.Mesh(slamGeo, slamMat);
    slam.position.copy(plant.position);
    slam.position.y = 0.25;
    this.scene.add(slam);

    // Deal damage to all zombies in range
    zombies.forEach(zombie => {
      zombie.health -= 50; // Medium damage
    });

    // Animate slam effect
    let scale = 1;
    let opacity = 0.8;
    const slamInterval = setInterval(() => {
      scale += 0.2;
      opacity -= 0.15;
      slam.scale.set(scale, 1, scale);
      if (slamMat instanceof THREE.MeshBasicMaterial) {
        slamMat.opacity = opacity;
      }
      if (opacity <= 0) {
        this.scene.remove(slam);
        clearInterval(slamInterval);
      }
    }, 50);

    console.log(`Avocado Slammer hit ${zombies.length} zombies!`);
  }

  private performVineSlam(plant: Plant, zombies: Zombie[]): void {
    const slamGeo = new THREE.CylinderGeometry(2, 0.3, 0.4, 24);
    const slamMat = new THREE.MeshBasicMaterial({ color: 0x228b22, transparent: true, opacity: 0.8 });
    const slam = new THREE.Mesh(slamGeo, slamMat);
    slam.position.copy(plant.position);
    slam.position.y = 0.2;
    this.scene.add(slam);
    zombies.forEach(z => { z.health -= 35; });
    let scale = 1;
    const interval = setInterval(() => {
      scale += 0.15; slamMat.opacity -= 0.12;
      slam.scale.set(scale, 1, scale);
      if (slamMat.opacity <= 0) { this.scene.remove(slam); clearInterval(interval); }
    }, 50);
    console.log(`Vine Slammer hit ${zombies.length} zombies!`);
  }

  private shootGrapeSpike(from: THREE.Vector3, to: THREE.Vector3): void {
    const spikeGeo = new THREE.ConeGeometry(0.15, 0.5, 8);
    const spikeMat = new THREE.MeshPhongMaterial({ color: 0x8b4513, shininess: 100, emissive: 0x6b2513, emissiveIntensity: 0.3 });
    const spike = new THREE.Mesh(spikeGeo, spikeMat);
    spike.position.copy(from); spike.position.y = 1;
    this.scene.add(spike);
    const dir = new THREE.Vector3().subVectors(to, from).normalize();
    dir.y = 0;
    spike.rotation.z = -Math.PI / 2;
    const projectile = new Projectile(spike, from.clone(), dir.multiplyScalar(20), 113, false); // Grape Spike: 113 damage (1.5x)
    this.projectiles.push(projectile);
  }

  private throwPickleSpear(from: THREE.Vector3, zombie: Zombie): void {
    const spearGeo = new THREE.CylinderGeometry(0.08, 0.15, 1.2, 8);
    const spearMat = new THREE.MeshPhongMaterial({ color: 0x556b2f, shininess: 80 });
    const spear = new THREE.Mesh(spearGeo, spearMat);
    spear.position.copy(from); spear.position.y = 1;
    spear.rotation.z = -Math.PI / 2;
    this.scene.add(spear);
    const dir = new THREE.Vector3().subVectors(zombie.position, from).normalize();
    dir.y = 0;
    const projectile = new Projectile(spear, from.clone(), dir.multiplyScalar(25), 300, false); // 300 damage (1.5x)
    projectile.userData = { knockback: 4 };
    this.projectiles.push(projectile);
  }

  private shootFrostSpike(from: THREE.Vector3, zombie: Zombie): void {
    const spikeGeo = new THREE.OctahedronGeometry(0.08, 0);
    const spikeMat = new THREE.MeshPhongMaterial({ color: 0x88ddff, shininess: 200 });
    const spike = new THREE.Mesh(spikeGeo, spikeMat);
    spike.position.copy(from); spike.position.y = 1;
    this.scene.add(spike);
    const dir = new THREE.Vector3().subVectors(zombie.position, from).normalize();
    dir.y = 0;
    const projectile = new Projectile(spike, from.clone(), dir.multiplyScalar(30), 3, false); // 3 damage (1.5x)
    projectile.userData = { slowChance: 0.3, slowAmount: 0.7 };
    this.projectiles.push(projectile);
  }

  private shootGrapeFrospike(from: THREE.Vector3, zombie: Zombie): void {
    // Large ice spike projectile - 100 damage, 50% slow
    const spikeGeo = new THREE.ConeGeometry(0.15, 0.6, 8);
    const spikeMat = new THREE.MeshPhongMaterial({
      color: 0x66ddff,
      shininess: 300,
      transparent: true,
      opacity: 0.9,
      emissive: 0x44aaff,
      emissiveIntensity: 0.4
    });
    const spike = new THREE.Mesh(spikeGeo, spikeMat);
    spike.position.copy(from);
    spike.position.y = 1;
    spike.rotation.z = -Math.PI / 2; // Point forward
    this.scene.add(spike);

    const dir = new THREE.Vector3().subVectors(zombie.position, from).normalize();
    dir.y = 0;
    const projectile = new Projectile(spike, from.clone(), dir.multiplyScalar(20), 150, false); // 100 * 1.5 = 150 damage
    projectile.userData = { slowChance: 1.0, slowAmount: 0.5, slowDuration: 3 }; // 50% slow always applied
    this.projectiles.push(projectile);
  }

  private spawnLeachAlly(pos: THREE.Vector3): void {
    const isRare = Math.random() < 0.2;
    const allyType: AllyType = isRare ? 'cursed-brute' : 'cursed-zombie';
    const allyMesh = this.createAllyMesh(allyType);
    const spawnPos = new THREE.Vector3(pos.x + 2, 0.5, pos.z);
    allyMesh.position.copy(spawnPos);
    allyMesh.rotation.y = Math.PI / 2;
    this.scene.add(allyMesh);
    const ally = new Ally(allyMesh, allyType, spawnPos.clone());
    ally.spawnZ = pos.z;
    this.allies.push(ally);
    console.log(`Spawned ${isRare ? 'BRUTE' : 'normal'} cursed zombie ally!`);
  }

  private createIceExplosion(pos: THREE.Vector3): void {
    const iceGeo = new THREE.SphereGeometry(5, 16, 16);
    const iceMat = new THREE.MeshBasicMaterial({ color: 0x88eeff, transparent: true, opacity: 0.6 });
    const ice = new THREE.Mesh(iceGeo, iceMat);
    ice.position.copy(pos); ice.position.y = 1;
    ice.scale.set(0.1, 0.1, 0.1);
    this.scene.add(ice);
    let s = 0.1;
    const interval = setInterval(() => {
      s += 0.15; iceMat.opacity -= 0.08;
      ice.scale.set(s, s, s);
      if (iceMat.opacity <= 0) { this.scene.remove(ice); clearInterval(interval); }
    }, 50);
  }

  private spawnSquirrelAlly(pos: THREE.Vector3, isBuff: boolean): void {
    const allyType: AllyType = isBuff ? 'buff-squirrel' : 'squirrel';
    const allyMesh = this.createAllyMesh(allyType);
    const spawnPos = new THREE.Vector3(pos.x + 2, 0.5, pos.z);
    allyMesh.position.copy(spawnPos);
    allyMesh.rotation.y = Math.PI / 2;
    this.scene.add(allyMesh);
    const ally = new Ally(allyMesh, allyType, spawnPos.clone());
    ally.spawnZ = pos.z;
    this.allies.push(ally);
    console.log(`Spawned ${isBuff ? 'BUFF' : 'normal'} squirrel ally!`);
  }

  private shootFrozenIceBall(from: THREE.Vector3, to: THREE.Vector3, damage: number, sunPerKill: number): void {
    const ballGeo = new THREE.SphereGeometry(0.25, 12, 12);
    const ballMat = new THREE.MeshPhongMaterial({ color: 0x88eeff, shininess: 200 });
    const ball = new THREE.Mesh(ballGeo, ballMat);
    ball.position.copy(from); ball.position.y = 1.2;
    this.scene.add(ball);
    const dir = new THREE.Vector3().subVectors(to, from).normalize();
    dir.y = 0;
    const projectile = new Projectile(ball, from.clone(), dir.multiplyScalar(15), damage, false);
    projectile.userData = { sunPerKill, freezeDuration: 1 };
    this.projectiles.push(projectile);
  }

  private placeAcornBomb(pos: THREE.Vector3): void {
    const bombGeo = new THREE.SphereGeometry(0.2, 10, 10);
    const bombMat = new THREE.MeshPhongMaterial({ color: 0x8b4513 });
    const bomb = new THREE.Mesh(bombGeo, bombMat);
    bomb.position.set(pos.x + 2, 0.3, pos.z);
    this.scene.add(bomb);
    console.log('Acorn Wall placed bomb!');
  }

  private shootFrostGrape(from: THREE.Vector3, to: THREE.Vector3, damage: number, freezeDuration: number): void {
    const grapeGeo = new THREE.SphereGeometry(0.15, 10, 10);
    const grapeMat = new THREE.MeshPhongMaterial({ color: 0x88ddff, shininess: 150 });
    const grape = new THREE.Mesh(grapeGeo, grapeMat);
    grape.position.copy(from); grape.position.y = 1;
    this.scene.add(grape);
    const dir = new THREE.Vector3().subVectors(to, from).normalize();
    dir.y = 0;
    const projectile = new Projectile(grape, from.clone(), dir.multiplyScalar(20), damage, false);
    projectile.userData = { freezeDuration };
    this.projectiles.push(projectile);
  }

  private dropThornBomb(pos: THREE.Vector3, index: number): void {
    const bombGeo = new THREE.SphereGeometry(0.15, 8, 8);
    const bombMat = new THREE.MeshPhongMaterial({ color: 0xff4422 });
    const bomb = new THREE.Mesh(bombGeo, bombMat);
    bomb.position.set(pos.x + index * 2 - 2, 5, pos.z);
    this.scene.add(bomb);
    // Animate falling
    let y = 5;
    const interval = setInterval(() => {
      y -= 0.3; bomb.position.y = y;
      if (y <= 0.5) {
        this.scene.remove(bomb);
        // Explode
        this.zombies.forEach(z => {
          if (z.position.distanceTo(bomb.position) <= 2) z.health -= 25;
        });
        clearInterval(interval);
      }
    }, 30);
  }

  private performPearExplosion(plant: Plant, zombies: Zombie[]): void {
    // Create explosion effect
    const explosionGeo = new THREE.SphereGeometry(2, 16, 16);
    const explosionMat = new THREE.MeshBasicMaterial({
      color: 0xffa500,
      transparent: true,
      opacity: 0.7
    });
    const explosion = new THREE.Mesh(explosionGeo, explosionMat);
    explosion.position.copy(plant.position);
    explosion.position.y = 1;
    this.scene.add(explosion);

    // Deal damage to all zombies in range
    zombies.forEach(zombie => {
      zombie.health -= 300; // High damage from explosion
    });

    // Animate explosion effect
    let scale = 0.5;
    let opacity = 0.7;
    const explosionInterval = setInterval(() => {
      scale += 0.3;
      opacity -= 0.1;
      explosion.scale.set(scale, scale, scale);
      if (explosionMat instanceof THREE.MeshBasicMaterial) {
        explosionMat.opacity = opacity;
      }
      if (opacity <= 0) {
        this.scene.remove(explosion);
        clearInterval(explosionInterval);
      }
    }, 50);

    console.log(`Pear Wall exploded and hit ${zombies.length} zombies!`);
  }

  private performFrostSlam(plant: Plant, zombies: Zombie[]): void {
    // Create icy slam effect
    const slamGeo = new THREE.CylinderGeometry(4, 0.5, 0.5, 32);
    const slamMat = new THREE.MeshBasicMaterial({
      color: 0x87ceeb,
      transparent: true,
      opacity: 0.8
    });
    const slam = new THREE.Mesh(slamGeo, slamMat);
    slam.position.copy(plant.position);
    slam.position.y = 0.25;
    this.scene.add(slam);

    // Deal damage to all zombies in range and apply slow effect
    // Frovine Slammer (TITAN) does 100 damage, regular Frost Slammer does 50
    const damage = plant.type === 'frovine-slammer' ? 100 : 50;
    zombies.forEach(zombie => {
      zombie.health -= damage;

      // Only slow, don't freeze
      // Don't set frozen = true, just reduce speed

      // Change zombie color to icy blue to show slow effect
      zombie.mesh.children.forEach(child => {
        if (child instanceof THREE.Mesh) {
          if (child.material instanceof THREE.MeshPhongMaterial) {
            child.material.color.setHex(0x87ceeb);
          }
        }
      });

      // Reduce speed by 50% for 5 seconds
      const originalSpeed = zombie.speed;
      zombie.speed = originalSpeed * 0.5;

      // After 5 seconds, restore speed and color
      setTimeout(() => {
        zombie.speed = originalSpeed;
        // Restore original colors
        zombie.mesh.children.forEach(child => {
          if (child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshPhongMaterial) {
              // Reset to original zombie colors based on type
              let originalColor = 0x7cb342; // Default zombie green
              if (zombie.type === 'fast') originalColor = 0xff4500;
              else if (zombie.type === 'tank') originalColor = 0x696969;
              else if (zombie.type === 'tiny') originalColor = 0xba55d3;
              else if (zombie.type === 'grape') originalColor = 0x8b00ff;
              else if (zombie.type === 'car') originalColor = 0xdc143c;
              else if (zombie.type === 'grave') originalColor = 0x2f2f2f;

              child.material.color.setHex(originalColor);
            }
          }
        });
      }, 5000);
    });

    // Animate slam effect
    let scale = 1;
    let opacity = 0.8;
    const slamInterval = setInterval(() => {
      scale += 0.2;
      opacity -= 0.15;
      slam.scale.set(scale, 1, scale);
      if (slamMat instanceof THREE.MeshBasicMaterial) {
        slamMat.opacity = opacity;
      }
      if (opacity <= 0) {
        this.scene.remove(slam);
        clearInterval(slamInterval);
      }
    }, 50);

    const plantName = plant.type === 'frovine-slammer' ? 'Frovine Slammer' : 'Frost Slammer';
    console.log(`${plantName} hit ${zombies.length} zombies for ${damage} damage with icy slam!`);
  }

  private throwStrawbombs(plant: Plant): void {
    // Throw 3 bombs that fall from the sky
    for (let i = 0; i < 3; i++) {
      setTimeout(() => {
        // Random zombie to target
        if (this.zombies.length === 0) return;
        const targetZombie = this.zombies[Math.floor(Math.random() * this.zombies.length)];
        const targetPos = targetZombie.position.clone();

        // Create bomb high in the sky
        const bombGeo = new THREE.SphereGeometry(0.25, 12, 12);
        const bombMat = new THREE.MeshPhongMaterial({
          color: 0xff0000,
          emissive: 0xff0000,
          emissiveIntensity: 0.6
        });
        const bomb = new THREE.Mesh(bombGeo, bombMat);
        bomb.position.set(targetPos.x, 10, targetPos.z); // Start high up
        this.scene.add(bomb);

        // Animate bomb falling
        const fallSpeed = 0.15;
        const fallInterval = setInterval(() => {
          bomb.position.y -= fallSpeed;

          // Check if bomb hit ground
          if (bomb.position.y <= 0.5) {
            this.scene.remove(bomb);
            clearInterval(fallInterval);

            // Create explosion at impact
            const explosionGeo = new THREE.SphereGeometry(2, 16, 16);
            const explosionMat = new THREE.MeshBasicMaterial({
              color: 0xff4500,
              transparent: true,
              opacity: 0.8
            });
            const explosion = new THREE.Mesh(explosionGeo, explosionMat);
            explosion.position.set(targetPos.x, 0.5, targetPos.z);
            this.scene.add(explosion);

            // Deal damage to zombies in 2 tile radius (4 units)
            this.zombies.forEach(zombie => {
              const distance = zombie.position.distanceTo(targetPos);
              if (distance <= 4) {
                zombie.health -= 25; // 25 damage per bomb
              }
            });

            // Animate explosion
            let scale = 0.5;
            let opacity = 0.8;
            const explInterval = setInterval(() => {
              scale += 0.3;
              opacity -= 0.15;
              explosion.scale.set(scale, scale, scale);
              if (explosionMat instanceof THREE.MeshBasicMaterial) {
                explosionMat.opacity = opacity;
              }
              if (opacity <= 0) {
                this.scene.remove(explosion);
                clearInterval(explInterval);
              }
            }, 50);
          }
        }, 16); // ~60 FPS
      }, i * 300); // Stagger bombs by 300ms
    }

    console.log('Strawbomber launched 3 bombs!');
  }

  private fireStrawSpiker(plant: Plant, targetZombie: Zombie): void {
    const targetPos = targetZombie.position.clone();

    // 1. Shoot a tomato spike projectile (horizontal)
    const spikeGeo = new THREE.SphereGeometry(0.2, 12, 12);
    const spikeMat = new THREE.MeshPhongMaterial({
      color: 0xff4444,
      emissive: 0xff2222,
      emissiveIntensity: 0.5
    });
    const spikeProjectile = new THREE.Mesh(spikeGeo, spikeMat);
    spikeProjectile.position.copy(plant.position);
    spikeProjectile.position.y = 0.7;
    this.scene.add(spikeProjectile);

    // Add spikes to projectile
    for (let i = 0; i < 4; i++) {
      const miniSpikeGeo = new THREE.ConeGeometry(0.05, 0.15, 6);
      const miniSpikeMat = new THREE.MeshPhongMaterial({ color: 0x8b0000 });
      const miniSpike = new THREE.Mesh(miniSpikeGeo, miniSpikeMat);
      const angle = (i / 4) * Math.PI * 2;
      miniSpike.position.set(Math.cos(angle) * 0.2, 0, Math.sin(angle) * 0.2);
      miniSpike.rotation.z = Math.cos(angle) * Math.PI / 2;
      miniSpike.rotation.x = -Math.sin(angle) * Math.PI / 2;
      spikeProjectile.add(miniSpike);
    }

    // Animate tomato spike projectile
    const direction = new THREE.Vector3().subVectors(targetPos, plant.position).normalize();
    const spikeSpeed = 0.3;
    const spikeInterval = setInterval(() => {
      spikeProjectile.position.add(direction.clone().multiplyScalar(spikeSpeed));
      spikeProjectile.rotation.x += 0.2;
      spikeProjectile.rotation.y += 0.1;

      // Check collision with zombies
      let hitZombie = false;
      for (const zombie of this.zombies) {
        if (spikeProjectile.position.distanceTo(zombie.position) < 1) {
          hitZombie = true;

          // Stun all zombies in 3 tile radius for 2 seconds
          const stunRadius = 6; // 3 tiles = 6 units
          this.zombies.forEach(z => {
            if (z.position.distanceTo(spikeProjectile.position) <= stunRadius) {
              z.frozen = true;
              z.frozenTimer = 2; // 2 second stun
              // Change zombie color to show stun
              z.mesh.traverse((child) => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
                  child.material.emissive = new THREE.Color(0xffff00);
                  child.material.emissiveIntensity = 0.5;
                }
              });
            }
          });

          // Create stun explosion effect
          const stunGeo = new THREE.SphereGeometry(stunRadius, 16, 16);
          const stunMat = new THREE.MeshBasicMaterial({
            color: 0xffff00,
            transparent: true,
            opacity: 0.4
          });
          const stunExplosion = new THREE.Mesh(stunGeo, stunMat);
          stunExplosion.position.copy(spikeProjectile.position);
          stunExplosion.position.y = 0.5;
          this.scene.add(stunExplosion);

          // Animate stun effect
          let stunOpacity = 0.4;
          const stunInterval = setInterval(() => {
            stunOpacity -= 0.08;
            if (stunMat instanceof THREE.MeshBasicMaterial) {
              stunMat.opacity = stunOpacity;
            }
            if (stunOpacity <= 0) {
              this.scene.remove(stunExplosion);
              clearInterval(stunInterval);
            }
          }, 50);

          // Try to place a tomato spike in a 3x3 area
          const impactX = Math.round(spikeProjectile.position.x / 2) * 2;
          const impactZ = Math.round(spikeProjectile.position.z / 2) * 2;
          let placed = false;

          // Check 3x3 grid for empty slot
          for (let dx = -2; dx <= 2 && !placed; dx += 2) {
            for (let dz = -2; dz <= 2 && !placed; dz += 2) {
              const checkX = impactX + dx;
              const checkZ = impactZ + dz;
              const slotKey = `${checkX},${checkZ}`;

              // Check bounds and if slot is empty
              if (checkX >= -8 && checkX <= 8 && checkZ >= -4 && checkZ <= 4) {
                if (!this.plantSlots.get(slotKey)) {
                  // Place tomato spike!
                  const tomatoMesh = this.createPlantMesh('tomato-spike');
                  tomatoMesh.position.set(checkX, 0.5, checkZ);
                  // No rotation needed - default facing is +X towards zombie spawn
                  this.scene.add(tomatoMesh);

                  const tomatoPlant = new Plant(tomatoMesh, 'tomato-spike', new THREE.Vector3(checkX, 0.5, checkZ));
                  this.placedPlants.push(tomatoPlant);
                  this.plantSlots.set(slotKey, true);
                  this.hideSlotIndicator(checkX, checkZ);

                  console.log(`StrawSpiker placed Tomato Spike at (${checkX}, ${checkZ})!`);
                  placed = true;
                }
              }
            }
          }

          break;
        }
      }

      // Remove spike if hit or out of bounds
      if (hitZombie || spikeProjectile.position.x > 12) {
        this.scene.remove(spikeProjectile);
        clearInterval(spikeInterval);
      }
    }, 16);

    // 2. Drop a strawberry bomb from the sky (like strawbomber but just 1)
    setTimeout(() => {
      if (this.zombies.length === 0) return;
      const bombTarget = this.zombies[Math.floor(Math.random() * this.zombies.length)].position.clone();

      const bombGeo = new THREE.SphereGeometry(0.3, 12, 12);
      const bombMat = new THREE.MeshPhongMaterial({
        color: 0xff2d55,
        emissive: 0xff0033,
        emissiveIntensity: 0.6
      });
      const bomb = new THREE.Mesh(bombGeo, bombMat);
      bomb.position.set(bombTarget.x, 10, bombTarget.z);
      this.scene.add(bomb);

      // Add seeds to bomb
      for (let i = 0; i < 5; i++) {
        const seedGeo = new THREE.SphereGeometry(0.05, 6, 6);
        const seedMat = new THREE.MeshPhongMaterial({ color: 0xffd700 });
        const seed = new THREE.Mesh(seedGeo, seedMat);
        const angle = (i / 5) * Math.PI * 2;
        seed.position.set(Math.cos(angle) * 0.25, Math.sin(angle) * 0.15, 0);
        bomb.add(seed);
      }

      const fallSpeed = 0.2;
      const bombInterval = setInterval(() => {
        bomb.position.y -= fallSpeed;
        bomb.rotation.z += 0.1;

        if (bomb.position.y <= 0.5) {
          this.scene.remove(bomb);
          clearInterval(bombInterval);

          // Explosion
          const explosionGeo = new THREE.SphereGeometry(2, 16, 16);
          const explosionMat = new THREE.MeshBasicMaterial({
            color: 0xff2d55,
            transparent: true,
            opacity: 0.7
          });
          const explosion = new THREE.Mesh(explosionGeo, explosionMat);
          explosion.position.set(bombTarget.x, 0.5, bombTarget.z);
          this.scene.add(explosion);

          // Damage zombies
          this.zombies.forEach(zombie => {
            if (zombie.position.distanceTo(bombTarget) <= 4) {
              zombie.health -= 50; // 50 damage
            }
          });

          // Animate explosion
          let scale = 0.5;
          let opacity = 0.7;
          const explInterval = setInterval(() => {
            scale += 0.25;
            opacity -= 0.12;
            explosion.scale.set(scale, scale, scale);
            if (explosionMat instanceof THREE.MeshBasicMaterial) {
              explosionMat.opacity = opacity;
            }
            if (opacity <= 0) {
              this.scene.remove(explosion);
              clearInterval(explInterval);
            }
          }, 50);
        }
      }, 16);
    }, 200); // Slight delay before bomb

    console.log('StrawSpiker fired tomato spike + strawberry bomb!');
  }

  private fireReaperSkull(plant: Plant, targetZombie: Zombie): void {
    // Create skull projectile
    const skullGroup = new THREE.Group();

    // Skull shape
    const skullGeo = new THREE.SphereGeometry(0.2, 10, 10);
    skullGeo.scale(1, 1.2, 0.9);
    const skullMat = new THREE.MeshPhongMaterial({
      color: 0xddddcc,
      shininess: 80,
      emissive: 0x441111,
      emissiveIntensity: 0.5
    });
    const skull = new THREE.Mesh(skullGeo, skullMat);
    skullGroup.add(skull);

    // Glowing eyes
    for (let eye = -1; eye <= 1; eye += 2) {
      const eyeGeo = new THREE.SphereGeometry(0.05, 6, 6);
      const eyeMat = new THREE.MeshBasicMaterial({ color: 0xff0000 });
      const eyeMesh = new THREE.Mesh(eyeGeo, eyeMat);
      eyeMesh.position.set(eye * 0.08, 0.05, 0.15);
      skullGroup.add(eyeMesh);
    }

    // Dark aura trail
    const auraGeo = new THREE.SphereGeometry(0.3, 8, 8);
    const auraMat = new THREE.MeshBasicMaterial({
      color: 0x440044,
      transparent: true,
      opacity: 0.4
    });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    skullGroup.add(aura);

    skullGroup.position.copy(plant.position);
    skullGroup.position.y = 1.5;
    skullGroup.position.z += 0.4; // Start from front of wall
    this.scene.add(skullGroup);

    // Calculate direction
    const direction = new THREE.Vector3().subVectors(targetZombie.position, skullGroup.position).normalize();
    const velocity = direction.clone().multiplyScalar(0.4);

    // Face the direction of travel
    skullGroup.lookAt(targetZombie.position);

    const skullInterval = setInterval(() => {
      // Check if target zombie is still alive and in the game
      if (targetZombie.health <= 0 || !this.zombies.includes(targetZombie)) {
        this.scene.remove(skullGroup);
        clearInterval(skullInterval);
        return;
      }

      skullGroup.position.add(velocity);

      // Rotate skull for effect
      skullGroup.rotation.z += 0.1;

      // Check collision with zombie
      const dist = skullGroup.position.distanceTo(targetZombie.position);
      if (dist < 1) {
        // SPLASH DAMAGE - hit ALL zombies in radius!
        const splashRadius = 2.5;
        const splashDamage = 150; // Half damage to nearby zombies
        const mainDamage = 300;

        // Deal damage to all zombies in splash radius
        for (const zombie of this.zombies) {
          const zombieDist = zombie.position.distanceTo(skullGroup.position);
          if (zombieDist < splashRadius) {
            if (zombie === targetZombie) {
              // Main target takes full damage
              zombie.health -= mainDamage;
            } else {
              // Nearby zombies take splash damage
              zombie.health -= splashDamage;
            }

            // 50% slow to ALL zombies hit using baseSpeed to prevent stacking
            zombie.speed = zombie.baseSpeed * 0.5;

            // 50% chance to freeze EACH zombie (if not immune and not already frozen)
            if (Math.random() < 0.5 && !zombie.isFreezeImmune && zombie.freezeImmunityTimer <= 0 && !zombie.frozen) {
              zombie.frozen = true;
              zombie.frozenTimer = 3; // 3 second freeze
            }

            // Restore speed after 3 seconds (if not frozen)
            setTimeout(() => {
              if (!zombie.frozen) {
                zombie.speed = zombie.baseSpeed; // Reset to base speed
              }
            }, 3000);
          }
        }

        console.log('Reaper Peall skull SPLASHED for 300 main + 150 splash damage!');

        // Create dark explosion effect - BIGGER for splash
        const explosionGeo = new THREE.SphereGeometry(splashRadius, 16, 16);
        const explosionMat = new THREE.MeshBasicMaterial({
          color: 0x660033,
          transparent: true,
          opacity: 0.7
        });
        const explosion = new THREE.Mesh(explosionGeo, explosionMat);
        explosion.position.copy(skullGroup.position);
        this.scene.add(explosion);

        // Inner skull burst effect
        const burstGeo = new THREE.SphereGeometry(0.8, 12, 12);
        const burstMat = new THREE.MeshBasicMaterial({
          color: 0xff2200,
          transparent: true,
          opacity: 0.9
        });
        const burst = new THREE.Mesh(burstGeo, burstMat);
        burst.position.copy(skullGroup.position);
        this.scene.add(burst);

        // Animate explosion
        let scale = 0.3;
        let opacity = 0.7;
        const explInterval = setInterval(() => {
          scale += 0.15;
          opacity -= 0.08;
          explosion.scale.set(scale, scale, scale);
          burst.scale.set(scale * 1.5, scale * 1.5, scale * 1.5);
          if (explosionMat instanceof THREE.MeshBasicMaterial) {
            explosionMat.opacity = opacity;
          }
          if (burstMat instanceof THREE.MeshBasicMaterial) {
            burstMat.opacity = opacity * 1.2;
          }
          if (opacity <= 0) {
            this.scene.remove(explosion);
            this.scene.remove(burst);
            clearInterval(explInterval);
          }
        }, 50);

        this.scene.remove(skullGroup);
        clearInterval(skullInterval);
      }

      // Remove if out of bounds
      if (skullGroup.position.x > 15 || skullGroup.position.x < -15) {
        this.scene.remove(skullGroup);
        clearInterval(skullInterval);
      }
    }, 16);
  }

  private firePearNuke(plant: Plant, target: THREE.Vector3): void {
    console.log('Pear Nuker firing at:', target);

    // Create giant pear projectile
    const pearGeo = new THREE.SphereGeometry(0.4, 16, 16);
    const pearMat = new THREE.MeshPhongMaterial({
      color: 0xccff00,
      emissive: 0xffff00,
      emissiveIntensity: 1
    });
    const pear = new THREE.Mesh(pearGeo, pearMat);
    pear.position.copy(plant.position);
    pear.position.y = 1;
    this.scene.add(pear);

    // Calculate direction and velocity
    const direction = new THREE.Vector3().subVectors(target, plant.position).normalize();
    const velocity = direction.multiplyScalar(0.5);

    // Animate pear projectile
    const flyInterval = setInterval(() => {
      pear.position.add(velocity);

      // Check if reached target (within 1 unit)
      const distance = pear.position.distanceTo(target);
      if (distance < 1) {
        this.scene.remove(pear);
        clearInterval(flyInterval);

        // Create MASSIVE nuclear explosion
        const nukeGeo = new THREE.SphereGeometry(6, 32, 32);
        const nukeMat = new THREE.MeshBasicMaterial({
          color: 0xffff00,
          transparent: true,
          opacity: 1
        });
        const nuke = new THREE.Mesh(nukeGeo, nukeMat);
        nuke.position.copy(target);
        nuke.position.y = 0.5;
        this.scene.add(nuke);

        // Deal 3500 damage to ALL zombies in range
        this.zombies.forEach(zombie => {
          const dist = zombie.position.distanceTo(target);
          if (dist <= 12) { // Large explosion radius (6 tiles)
            zombie.health -= 3500;
          }
        });

        // Animate nuclear explosion
        let scale = 1;
        let opacity = 1;
        let color = 0xffff00; // Start yellow
        const nukeInterval = setInterval(() => {
          scale += 0.8;
          opacity -= 0.08;

          // Color transition: yellow -> orange -> red
          if (scale < 3) {
            color = 0xffff00; // Yellow
          } else if (scale < 6) {
            color = 0xff9900; // Orange
          } else {
            color = 0xff0000; // Red
          }

          nuke.scale.set(scale, scale, scale);
          if (nukeMat instanceof THREE.MeshBasicMaterial) {
            nukeMat.opacity = opacity;
            nukeMat.color.setHex(color);
          }

          if (opacity <= 0) {
            this.scene.remove(nuke);
            clearInterval(nukeInterval);
          }
        }, 50);

        console.log('NUCLEAR EXPLOSION! 3500 damage dealt!');
      }
    }, 16);

    // Set 20 second cooldown
    plant.cooldown = 20;
  }

  private performFrostFreeze(plant: Plant, zombies: Zombie[], isElder: boolean = false): void {
    // Create frost wave effect
    const frostGeo = new THREE.SphereGeometry(6, 16, 16);
    const frostMat = new THREE.MeshBasicMaterial({
      color: isElder ? 0x00bfff : 0x87ceeb,
      transparent: true,
      opacity: isElder ? 0.8 : 0.6
    });
    const frost = new THREE.Mesh(frostGeo, frostMat);
    frost.position.copy(plant.position);
    frost.position.y = 1;
    this.scene.add(frost);

    // Determine freeze duration
    const freezeDuration = isElder ? 20 : 4; // Elder: 20 seconds, Regular: 4 seconds

    // Track how many zombies actually got frozen
    let frozenCount = 0;

    // Freeze all zombies in range (if not immune)
    zombies.forEach(zombie => {
      // Skip if freeze immune (bosses, fire zombie) or has freeze immunity timer
      if (zombie.isFreezeImmune || zombie.freezeImmunityTimer > 0) {
        return;
      }
      // Don't stack freezes - only freeze if not already frozen
      // (prevents permanent freeze from continuous re-freezing)
      if (!zombie.frozen) {
        zombie.frozen = true;
        zombie.frozenTimer = freezeDuration;
        frozenCount++;

        // Change zombie color to icy blue
        zombie.mesh.children.forEach(child => {
          if (child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.color.setHex(isElder ? 0x00bfff : 0x87ceeb);
            }
          }
        });
      }
    });

    // Track mastery for regular Frost Berri only (only count actually frozen zombies)
    if (!isElder && plant.type === 'frost-berri' && frozenCount > 0) {
      this.frostBerriMastery += frozenCount;
      // Award 5 mastery points per zombie frozen
      this.frostBerriMasteryPoints += frozenCount * 5;
      this.updateMasteryDisplay();
      console.log(`Frost Berri Mastery: ${this.frostBerriMastery}/300 zombies frozen | Points: ${this.frostBerriMasteryPoints}`);

      // Check if mastery complete
      if (this.frostBerriMasteryPoints >= 300) {
        console.log('🎉 Frost Berri MASTERED! Double-click any Frost Berri to upgrade to Elder Frost Berri!');
      }
    }

    // Animate frost effect
    let scale = 0.5;
    let opacity = 0.6;
    const frostInterval = setInterval(() => {
      scale += 0.2;
      opacity -= 0.1;
      frost.scale.set(scale, scale, scale);
      if (frostMat instanceof THREE.MeshBasicMaterial) {
        frostMat.opacity = opacity;
      }
      if (opacity <= 0) {
        this.scene.remove(frost);
        clearInterval(frostInterval);
      }
    }, 50);

    console.log(`Frost Berri froze ${zombies.length} zombies!`);
  }

  private performFrostPearExplosion(plant: Plant, zombies: Zombie[]): void {
    // Create frozen explosion effect
    const explosionGeo = new THREE.SphereGeometry(2, 16, 16);
    const explosionMat = new THREE.MeshBasicMaterial({
      color: 0x87ceeb,
      transparent: true,
      opacity: 0.7
    });
    const explosion = new THREE.Mesh(explosionGeo, explosionMat);
    explosion.position.copy(plant.position);
    explosion.position.y = 1;
    this.scene.add(explosion);

    // Deal damage to all zombies in range
    zombies.forEach(zombie => {
      zombie.health -= 300; // High damage from explosion!

      // 20% chance to freeze zombies (if not immune and not already frozen)
      if (Math.random() < 0.2 && !zombie.isFreezeImmune && zombie.freezeImmunityTimer <= 0 && !zombie.frozen) {
        zombie.frozen = true;
        zombie.frozenTimer = 3; // Freeze for 3 seconds

        // Change zombie color to icy blue
        zombie.mesh.children.forEach(child => {
          if (child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.color.setHex(0x87ceeb);
            }
          }
        });

        console.log(`Zombie frozen by Frost Pear Wall!`);
      }
    });

    // Animate explosion effect with frost particles
    let scale = 0.5;
    let opacity = 0.7;
    const explosionInterval = setInterval(() => {
      scale += 0.3;
      opacity -= 0.1;
      explosion.scale.set(scale, scale, scale);
      if (explosionMat instanceof THREE.MeshBasicMaterial) {
        explosionMat.opacity = opacity;
      }
      if (opacity <= 0) {
        this.scene.remove(explosion);
        clearInterval(explosionInterval);
      }
    }, 50);

    console.log(`Frost Pear Wall exploded and hit ${zombies.length} zombies!`);
  }

  private performPickleKnockback(plant: Plant, zombies: Zombie[]): void {
    // Create epic knockback wave effect
    const waveGeo = new THREE.CylinderGeometry(5, 1.5, 0.5, 32);
    const waveMat = new THREE.MeshBasicMaterial({
      color: 0xff2244,
      transparent: true,
      opacity: 0.8
    });
    const wave = new THREE.Mesh(waveGeo, waveMat);
    wave.position.copy(plant.position);
    wave.position.y = 0.5;
    this.scene.add(wave);

    // Deal medium damage and knock back zombies
    zombies.forEach(zombie => {
      zombie.health -= 60; // Increased damage

      // Calculate knockback direction (away from plant)
      const dx = zombie.position.x - plant.position.x;
      const dz = zombie.position.z - plant.position.z;
      const distance = Math.sqrt(dx * dx + dz * dz);

      if (distance > 0) {
        // Normalize and apply knockback (1 tile = 2 units)
        const knockbackForce = 2.0; // 1 tile knockback
        zombie.position.x += (dx / distance) * knockbackForce;
        zombie.position.z += (dz / distance) * knockbackForce;

        // Clamp to lawn boundaries (z: -8 to 0, x: -10 to 12)
        zombie.position.z = Math.max(-8, Math.min(0, zombie.position.z));
        zombie.position.x = Math.max(-10, Math.min(12, zombie.position.x));

        zombie.mesh.position.x = zombie.position.x;
        zombie.mesh.position.z = zombie.position.z;
      }

      // Add a longer stun (slow movement for 2 seconds)
      const originalSpeed = zombie.speed;
      zombie.speed = originalSpeed * 0.2;
      setTimeout(() => {
        zombie.speed = originalSpeed;
      }, 2000);
    });

    // Animate wave effect
    let scale = 1;
    let opacity = 0.7;
    const waveInterval = setInterval(() => {
      scale += 0.3;
      opacity -= 0.15;
      wave.scale.set(scale, 1, scale);
      if (waveMat instanceof THREE.MeshBasicMaterial) {
        waveMat.opacity = opacity;
      }
      if (opacity <= 0) {
        this.scene.remove(wave);
        clearInterval(waveInterval);
      }
    }, 50);

    console.log(`Pickle Spiker knocked back ${zombies.length} zombies!`);
  }

  private teleportZombie(): void {
    // Pick a random zombie
    const randomIndex = Math.floor(Math.random() * this.zombies.length);
    const zombie = this.zombies[randomIndex];

    // Create teleport effect at current position
    this.createTeleportEffect(zombie.position);

    // Teleport zombie back to starting position
    const startZ = zombie.position.z;
    zombie.position.x = 10; // Back to the right side
    zombie.mesh.position.x = 10;

    // Create teleport effect at new position
    this.createTeleportEffect(zombie.position);

    console.log('Pickle Picker teleported a zombie back to the beginning!');
  }

  private createTeleportEffect(position: THREE.Vector3): void {
    // Create purple portal effect
    const portalGeo = new THREE.TorusGeometry(0.8, 0.2, 16, 32);
    const portalMat = new THREE.MeshBasicMaterial({
      color: 0x9370db,
      transparent: true,
      opacity: 0.9
    });
    const portal = new THREE.Mesh(portalGeo, portalMat);
    portal.position.copy(position);
    portal.position.y = 1;
    portal.rotation.x = Math.PI / 2;
    this.scene.add(portal);

    // Add sparkles
    for (let i = 0; i < 20; i++) {
      const sparkleGeo = new THREE.SphereGeometry(0.1, 8, 8);
      const sparkleMat = new THREE.MeshBasicMaterial({
        color: 0xda70d6,
        transparent: true,
        opacity: 0.8
      });
      const sparkle = new THREE.Mesh(sparkleGeo, sparkleMat);
      sparkle.position.copy(position);
      sparkle.position.x += (Math.random() - 0.5) * 2;
      sparkle.position.y += Math.random() * 2;
      sparkle.position.z += (Math.random() - 0.5) * 2;
      this.scene.add(sparkle);

      // Remove sparkle after animation
      setTimeout(() => {
        this.scene.remove(sparkle);
      }, 500);
    }

    // Animate portal
    let opacity = 0.9;
    let scale = 1;
    const portalInterval = setInterval(() => {
      opacity -= 0.15;
      scale += 0.15;
      portal.scale.set(scale, scale, scale);
      if (portalMat instanceof THREE.MeshBasicMaterial) {
        portalMat.opacity = opacity;
      }
      if (opacity <= 0) {
        this.scene.remove(portal);
        clearInterval(portalInterval);
      }
    }, 50);
  }

  private animatePlant(plant: Plant): void {
    switch (plant.type) {
      case 'grape-launcher':
        // Gentle sway
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 2) * 0.05;
        // Grape cluster bobs
        plant.mesh.children.forEach((child, index) => {
          if (index > 0 && index < 7) { // Grape spheres
            child.position.y += Math.sin(plant.animationTime * 3 + index) * 0.002;
          }
        });
        break;

      case 'vine-wall':
        // Very slight sway forward and back
        plant.mesh.rotation.x = Math.sin(plant.animationTime * 1.5) * 0.02;
        // Thorns vibrate slightly
        plant.mesh.children.forEach((child, index) => {
          if (index > 4) { // Thorn meshes
            child.rotation.x = Math.sin(plant.animationTime * 2 + index) * 0.1;
          }
        });
        break;

      case 'pear-cannon':
        // Rotate barrel to face nearest zombie
        const nearestZombie = this.findNearestZombie(plant.position);
        if (nearestZombie && plant.mesh.children[2]) {
          const barrel = plant.mesh.children[2];
          const direction = new THREE.Vector3()
            .subVectors(nearestZombie.position, plant.position);

          // Calculate angles for 3D aiming
          const horizontalDist = Math.sqrt(direction.x * direction.x + direction.z * direction.z);
          const angleY = Math.atan2(direction.z, direction.x);
          const angleX = Math.atan2(direction.y, horizontalDist);

          barrel.rotation.y = angleY;
          barrel.rotation.z = -angleX; // Tilt up/down
        }
        // Bob slightly
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2) * 0.02;
        break;

      case 'lily':
        // Petals gently open and close
        plant.mesh.children.forEach((child, index) => {
          if (index > 2 && index < 9) { // Petals
            const baseScale = 1;
            const pulse = Math.sin(plant.animationTime * 1.5 + index * 0.5) * 0.1;
            child.scale.set(baseScale + pulse, baseScale + pulse, baseScale + pulse);
          }
        });
        // Center glows
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const center = plant.mesh.children[plant.mesh.children.length - 1];
          center.rotation.y += 0.02;
        }
        break;

      case 'lilyer':
        // Double lily golden glow animation
        plant.mesh.children.forEach(child => {
          // Shimmer effect
          if (child.userData.isShimmer && child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.3 + Math.sin(plant.animationTime * 3) * 0.15;
            }
          }
          // Centers pulse brightly
          if (child.userData.isLilyerCenter && child instanceof THREE.Mesh) {
            const pulse = 1 + Math.sin(plant.animationTime * 4) * 0.2;
            child.scale.set(pulse, pulse, pulse);
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.6 + Math.sin(plant.animationTime * 5) * 0.3;
            }
          }
          // Aura pulses
          if (child.userData.isLilyAura && child instanceof THREE.Mesh) {
            const scale = 1 + Math.sin(plant.animationTime * 2) * 0.1;
            child.scale.set(scale, scale, scale);
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.12 + Math.sin(plant.animationTime * 3) * 0.06;
            }
          }
        });
        // Gentle bob
        plant.mesh.position.y = 0.5 + Math.sin(plant.animationTime * 1.5) * 0.03;
        break;

      case 'lilyest':
        // Magical blue lily animation
        plant.mesh.children.forEach(child => {
          // Shimmer effect
          if (child.userData.isShimmer && child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.4 + Math.sin(plant.animationTime * 3) * 0.2;
            }
          }
          // Center diamond rotates and pulses
          if (child.userData.isLilyestCenter && child instanceof THREE.Mesh) {
            child.rotation.y += 0.03;
            child.rotation.x = Math.sin(plant.animationTime * 2) * 0.2;
            const pulse = 1 + Math.sin(plant.animationTime * 4) * 0.25;
            child.scale.set(pulse, pulse, pulse);
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.8 + Math.sin(plant.animationTime * 5) * 0.4;
            }
          }
          // Aura pulses magically
          if (child.userData.isLilyAura && child instanceof THREE.Mesh) {
            const scale = 1 + Math.sin(plant.animationTime * 2) * 0.12;
            child.scale.set(scale, scale, scale);
            child.rotation.y += 0.005;
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.15 + Math.sin(plant.animationTime * 3) * 0.08;
            }
          }
          // Sparkles float
          if (child.userData.isSparkle) {
            const i = child.userData.sparkleIndex;
            child.position.y = 0.4 + (i % 3) * 0.2 + Math.sin(plant.animationTime * 2 + i) * 0.1;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.6 + Math.sin(plant.animationTime * 4 + i) * 0.3;
            }
          }
        });
        // Gentle magical bob
        plant.mesh.position.y = 0.5 + Math.sin(plant.animationTime * 1.8) * 0.04;
        break;

      case 'frost-berri':
        // This is instant use, but if we had a placed version:
        // Spinning crystals animation
        break;

      case 'grape-wall':
        // Slight sway like vine wall
        plant.mesh.rotation.x = Math.sin(plant.animationTime * 1.5) * 0.02;
        // Grapes pulse with energy
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.SphereGeometry) {
            const scale = 1 + Math.sin(plant.animationTime * 2 + index) * 0.05;
            child.scale.set(scale, scale, scale);
          }
        });
        // Purple glow pulses
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const glow = plant.mesh.children[plant.mesh.children.length - 1];
          glow.rotation.y += 0.01;
        }
        break;

      case 'grape-lily':
        // Gentle sway like lily
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 1.8) * 0.04;
        // Petals pulse gently
        plant.mesh.children.forEach((child, index) => {
          if (index > 2 && index < 11) { // Petals
            const baseScale = 0.5;
            const pulse = Math.sin(plant.animationTime * 1.5 + index * 0.3) * 0.08;
            child.scale.set(baseScale + pulse, 1.0 + pulse * 0.5, 0.35 + pulse * 0.1);
          }
        });
        // Golden center rotates
        if (plant.mesh.children.length > 11) {
          plant.mesh.children[10].rotation.y += 0.03; // Center
        }
        // Glow pulses
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const glow = plant.mesh.children[plant.mesh.children.length - 1];
          const scale = 1 + Math.sin(plant.animationTime * 2) * 0.1;
          glow.scale.set(scale, scale, scale);
        }
        break;

      case 'pear-launcher':
        // Bob up and down
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2) * 0.03;
        // Barrel tracks nearest zombie
        const nearestZombieForPearLauncher = this.findNearestZombie(plant.position);
        if (nearestZombieForPearLauncher && plant.mesh.children.length > 10) {
          const barrel = plant.mesh.children[10]; // Barrel is the 11th child
          const direction = new THREE.Vector3()
            .subVectors(nearestZombieForPearLauncher.position, plant.position);

          const horizontalDist = Math.sqrt(direction.x * direction.x + direction.z * direction.z);
          const angleY = Math.atan2(direction.z, direction.x);
          const angleX = Math.atan2(direction.y, horizontalDist);

          barrel.rotation.y = angleY;
          barrel.rotation.z = -angleX;
        }
        // Grape accents pulse
        plant.mesh.children.forEach((child, index) => {
          if (index > 3 && index < 12 && child instanceof THREE.Mesh) {
            const scale = 1 + Math.sin(plant.animationTime * 3 + index) * 0.06;
            child.scale.set(scale, scale, scale);
          }
        });
        // Glow rotates
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const glow = plant.mesh.children[plant.mesh.children.length - 1];
          glow.rotation.y += 0.015;
        }
        break;

      case 'avocado-slammer':
        // Always face the zombie spawn point (+X direction)
        plant.mesh.rotation.y = 0;

        // Bob aggressively
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 4) * 0.05;
        // Arms swing (ready to slam)
        plant.mesh.children.forEach((child, index) => {
          // Arms are children 5 and 6
          if (index === 5 || index === 6) { // Left and right arms
            child.rotation.z = (index === 5 ? Math.PI / 4 : -Math.PI / 4) + Math.sin(plant.animationTime * 3) * 0.3;
          }
          // Fists are children 7 and 8
          if (index === 7 || index === 8) {
            const yOffset = Math.abs(Math.sin(plant.animationTime * 3)) * 0.2;
            child.position.y = (index === 7 ? 0.7 : 0.7) - yOffset;
          }
        });
        // Slam rings pulse
        plant.mesh.children.forEach((child, index) => {
          if (index >= 3 && index < 6) { // Rings
            const scale = 1 + Math.sin(plant.animationTime * 2 + index) * 0.1;
            child.scale.set(scale, 1, scale);
          }
        });
        // Eyes glow pulse
        if (plant.mesh.children.length > 10) {
          const leftEye = plant.mesh.children[9];
          const rightEye = plant.mesh.children[10];
          const intensity = 0.8 + Math.sin(plant.animationTime * 5) * 0.2;
          if (leftEye instanceof THREE.Mesh && leftEye.material instanceof THREE.MeshPhongMaterial) {
            leftEye.material.emissiveIntensity = intensity;
          }
          if (rightEye instanceof THREE.Mesh && rightEye.material instanceof THREE.MeshPhongMaterial) {
            rightEye.material.emissiveIntensity = intensity;
          }
        }
        // Aura pulses
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const aura = plant.mesh.children[plant.mesh.children.length - 1];
          const scale = 1 + Math.sin(plant.animationTime * 2.5) * 0.15;
          aura.scale.set(scale, scale, scale);
        }
        break;

      case 'pickle-picker':
        // Float mysteriously
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.5) * 0.08;
        // Rotate slowly
        plant.mesh.rotation.y += 0.01;
        // Portal rings rotate
        plant.mesh.children.forEach((child, index) => {
          if (index >= 6 && index < 14) { // Portal rings
            child.rotation.x = Math.PI / 2 + (index - 6) * 0.1 + plant.animationTime * 0.5;
            child.rotation.z += 0.02;
          }
        });
        // Sparkles twinkle
        plant.mesh.children.forEach((child, index) => {
          if (index >= 14 && index < 29) { // Sparkles
            const scale = 1 + Math.sin(plant.animationTime * 4 + index) * 0.3;
            child.scale.set(scale, scale, scale);
          }
        });
        // Eyes glow pulse
        if (plant.mesh.children.length > 30) {
          const leftEye = plant.mesh.children[29];
          const rightEye = plant.mesh.children[30];
          const intensity = 1.0 + Math.sin(plant.animationTime * 3) * 0.2;
          if (leftEye instanceof THREE.Mesh && leftEye.material instanceof THREE.MeshPhongMaterial) {
            leftEye.material.emissiveIntensity = intensity;
          }
          if (rightEye instanceof THREE.Mesh && rightEye.material instanceof THREE.MeshPhongMaterial) {
            rightEye.material.emissiveIntensity = intensity;
          }
        }
        // Glow pulses
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const glow = plant.mesh.children[plant.mesh.children.length - 1];
          const scale = 1 + Math.sin(plant.animationTime * 2) * 0.12;
          glow.scale.set(scale, scale, scale);
          glow.rotation.y += 0.02;
        }
        break;

      case 'pear-wall':
        // Gentle wall sway
        plant.mesh.rotation.x = Math.sin(plant.animationTime * 1.5) * 0.02;
        // Explosive pears pulse with energy
        plant.mesh.children.forEach((child, index) => {
          if (index >= 4 && index < 7) { // The embedded pears
            const pulseScale = 1 + Math.sin(plant.animationTime * 3 + index) * 0.1;
            child.scale.set(pulseScale, pulseScale * 1.3, pulseScale);
            // Glow intensity varies
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 4 + index) * 0.2;
            }
          }
        });
        // Thorns vibrate slightly
        plant.mesh.children.forEach((child, index) => {
          if (index >= 7) { // Thorns
            child.rotation.x = Math.sin(plant.animationTime * 2 + index) * 0.08;
          }
        });
        break;

      case 'frost-slammer':
        // Always face the zombie spawn point (+X direction)
        plant.mesh.rotation.y = 0;

        // Bob aggressively
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 4) * 0.05;
        // Arms swing (ready to slam)
        plant.mesh.children.forEach((child, index) => {
          // Icy arms are children 5 and 6
          if (index === 5 || index === 6) {
            child.rotation.z = (index === 5 ? Math.PI / 4 : -Math.PI / 4) + Math.sin(plant.animationTime * 3) * 0.3;
          }
          // Ice fists are children 7 and 8
          if (index === 7 || index === 8) {
            const yOffset = Math.abs(Math.sin(plant.animationTime * 3)) * 0.2;
            child.position.y = 0.7 - yOffset;
          }
        });
        // Frost particles orbit
        plant.mesh.children.forEach((child, index) => {
          if (index >= 9) { // Frost particles
            const angle = plant.animationTime + index;
            const radius = 0.7;
            child.position.x = Math.cos(angle) * radius;
            child.position.z = Math.sin(angle) * radius;
            child.position.y = 1.4 + Math.sin(plant.animationTime * 2 + index) * 0.3;
          }
        });
        break;

      case 'frost-pear-wall':
        // Gentle icy wall sway
        plant.mesh.rotation.x = Math.sin(plant.animationTime * 1.5) * 0.02;
        // Wall shimmers with frost
        plant.mesh.children.forEach((child, index) => {
          // Frost aura pulsing and rotating
          if (child.userData.isFrostAura) {
            const scale = 1 + Math.sin(plant.animationTime * 2) * 0.15;
            child.scale.set(scale, scale, scale);
            child.rotation.y += 0.01;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.1 + Math.sin(plant.animationTime * 3) * 0.08;
            }
          }
          if (index === 1) { // Main wall (now at index 1 after aura)
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
              child.material.opacity = 0.85 + Math.sin(plant.animationTime * 2) * 0.1;
              child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 2.5) * 0.15;
            }
          }
        });
        // Frozen explosive pears pulse with icy energy
        plant.mesh.children.forEach((child, index) => {
          if (index >= 4 && index < 7) { // The embedded frozen pears
            const pulseScale = 1 + Math.sin(plant.animationTime * 3 + index) * 0.12;
            child.scale.set(pulseScale, pulseScale * 1.3, pulseScale);
            // Icy glow intensity varies
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 4 + index) * 0.25;
            }
          }
        });
        // Ice crystal thorns shimmer
        plant.mesh.children.forEach((child, index) => {
          if (index >= 7 && index < 15) { // Thorns
            child.rotation.x = Math.sin(plant.animationTime * 2 + index) * 0.08;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
              child.material.opacity = 0.85 + Math.sin(plant.animationTime * 3 + index) * 0.1;
            }
          }
        });
        // Frost particles orbit
        plant.mesh.children.forEach((child, index) => {
          if (index >= 15) { // Frost particles
            const angle = plant.animationTime * 2 + index;
            const radius = 0.6;
            child.position.x = 0.5 + Math.cos(angle) * radius;
            child.position.z = Math.sin(angle) * radius;
            child.position.y = 0.8 + (index - 15) * 0.3 + Math.sin(plant.animationTime * 3 + index) * 0.1;
          }
        });
        break;

      case 'strawberry-launcher':
        // Energetic bounce
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 4) * 0.06;
        // Rotate slightly to track targets
        plant.mesh.rotation.y = Math.sin(plant.animationTime * 2.5) * 0.12;

        // Glowing seeds pulse
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            if ((child.material.color.getHex() & 0xffff00) === 0xffff00) { // Yellow seeds
              child.material.emissiveIntensity = 0.8 + Math.sin(plant.animationTime * 6 + index) * 0.2;
            }
          }
        });

        // Triple barrels pulse and rotate when ready
        plant.mesh.children.forEach((child, index) => {
          // Barrels are around indices 50-75 (triple barrels + tips)
          if (index >= 50 && index < 60) {
            const pulse = 1 + Math.sin(plant.animationTime * 5 + index) * 0.1;
            child.scale.set(pulse, pulse, pulse);
            if (plant.cooldown <= 0.3) { // Pulse faster when nearly ready
              child.rotation.z = Math.sin(plant.animationTime * 15 + index) * 0.1;
            }
          }
        });

        // Energy core pulses
        if (plant.mesh.children.length > 65) {
          const core = plant.mesh.children[plant.mesh.children.length - 2]; // Core
          const coreScale = 1 + Math.sin(plant.animationTime * 5) * 0.15;
          core.scale.set(coreScale, coreScale, coreScale);
          if (core instanceof THREE.Mesh && core.material instanceof THREE.MeshPhongMaterial) {
            core.material.emissiveIntensity = 0.9 + Math.sin(plant.animationTime * 6) * 0.1;
          }
        }

        // Aura pulses
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const aura = plant.mesh.children[plant.mesh.children.length - 1];
          const auraScale = 1 + Math.sin(plant.animationTime * 3) * 0.2;
          aura.scale.set(auraScale, auraScale, auraScale);
          aura.rotation.y += 0.02;
        }

        break;

      case 'pickle-spiker':
        // Float mysteriously like pickle-picker
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.5) * 0.08;
        // Rotate slowly
        plant.mesh.rotation.y += 0.015;
        // Spikes pulse with red energy
        plant.mesh.children.forEach((child, index) => {
          // Spikes are the red glowing meshes
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            if ((child.material.color.getHex() & 0xff0000) === 0xff0000) { // Red spikes
              const pulseScale = 1 + Math.sin(plant.animationTime * 4 + index * 0.2) * 0.15;
              child.scale.set(pulseScale, pulseScale, pulseScale);
              // Glow intensity varies
              child.material.emissiveIntensity = 0.8 + Math.sin(plant.animationTime * 5 + index) * 0.2;
            }
          }
        });
        // Portal rings rotate
        plant.mesh.children.forEach((child, index) => {
          if (index >= 60 && index < 66) { // Portal rings (adjusted index for pickle spiker)
            child.rotation.x += 0.03;
            child.rotation.z += 0.02;
          }
        });
        // Sparkles twinkle
        plant.mesh.children.forEach((child, index) => {
          if (index >= 66 && index < 78) { // Sparkles
            const scale = 1 + Math.sin(plant.animationTime * 4 + index) * 0.4;
            child.scale.set(scale, scale, scale);
          }
        });
        // Dual aura pulses
        if (plant.mesh.children.length > 80) {
          const redAura = plant.mesh.children[plant.mesh.children.length - 2];
          const purpleAura = plant.mesh.children[plant.mesh.children.length - 1];
          const scale = 1 + Math.sin(plant.animationTime * 2.5) * 0.2;
          redAura.scale.set(scale, scale, scale);
          purpleAura.scale.set(scale * 1.1, scale * 1.1, scale * 1.1);
          redAura.rotation.y += 0.02;
          purpleAura.rotation.y -= 0.015;
        }
        break;

      case 'grape-shot':
        // Keep upright - RESET all rotations to prevent sideways tilt
        plant.mesh.rotation.x = 0;
        plant.mesh.rotation.z = 0;
        // Grape cluster bobs more energetically (only scale, no rotation)
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.SphereGeometry) {
            const scale = 1 + Math.sin(plant.animationTime * 3.5 + index) * 0.08;
            child.scale.set(scale, scale, scale);
          }
        });
        // Dual barrel pulses (only scale, no rotation to prevent tilt)
        plant.mesh.children.forEach((child, index) => {
          if (index === 7 || index === 8) { // Dual barrels
            const pulse = 1 + Math.sin(plant.animationTime * 3 + index) * 0.1;
            child.scale.set(pulse, pulse, pulse);
            // Reset any accumulated rotation
            child.rotation.x = 0;
            child.rotation.z = 0;
          }
        });
        break;

      case 'frost-grape-gun':
        // Icy sway with shimmer
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 2.5) * 0.07;
        // Frozen grapes pulse with icy glow
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.SphereGeometry) {
            const scale = 1 + Math.sin(plant.animationTime * 5 + index) * 0.12;
            child.scale.set(scale, scale, scale);
            // Ice glow pulses
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 6 + index) * 0.3;
            }
          }
        });
        // Triple frozen barrels shimmer
        plant.mesh.children.forEach((child, index) => {
          if (index >= 9 && index < 12) { // Triple barrels
            const pulse = 1 + Math.sin(plant.animationTime * 5 + index) * 0.15;
            child.scale.set(pulse, pulse, pulse);
            child.rotation.z = Math.sin(plant.animationTime * 3 + index) * 0.08;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 7 + index) * 0.4;
            }
          }
        });
        break;

      case 'grape-gun':
        // Keep upright - only very subtle sway that returns to 0
        plant.mesh.rotation.x = 0;
        plant.mesh.rotation.z = 0; // No tilt - keep perfectly upright
        // Grapes pulse with more intensity (scale only, no rotation)
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.SphereGeometry) {
            const scale = 1 + Math.sin(plant.animationTime * 4 + index) * 0.1;
            child.scale.set(scale, scale, scale);
            // Glow pulses
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 5 + index) * 0.2;
            }
          }
        });
        // Triple barrels pulse (scale only, no rotation to prevent sideways tilt)
        plant.mesh.children.forEach((child, index) => {
          if (index >= 9 && index < 12) { // Triple barrels
            const pulse = 1 + Math.sin(plant.animationTime * 4 + index) * 0.12;
            child.scale.set(pulse, pulse, pulse);
            // Reset any accumulated rotation to prevent sideways tilt
            child.rotation.x = 0;
            child.rotation.z = 0;
          }
        });
        break;

      case 'star-launcher':
        // Gentle sway from lily heritage
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 1.8) * 0.05;
        // Petals pulse gently
        plant.mesh.children.forEach((child, index) => {
          if (index > 2 && index < 11) { // Petals from grape-lily
            const baseScale = 0.5;
            const pulse = Math.sin(plant.animationTime * 1.5 + index * 0.3) * 0.1;
            child.scale.set(baseScale + pulse, 1.0 + pulse * 0.5, 0.35 + pulse * 0.1);
          }
        });
        // Star accents twinkle
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            if ((child.material.color.getHex() & 0xffff00) === 0xffff00) { // Yellow stars
              const twinkle = 1 + Math.sin(plant.animationTime * 6 + index) * 0.3;
              child.scale.set(twinkle * 0.8, twinkle * 0.8, twinkle * 0.8);
              child.material.emissiveIntensity = 0.8 + Math.sin(plant.animationTime * 7 + index) * 0.2;
            }
          }
        });
        // Barrel rotates
        if (plant.mesh.children.length > 15) {
          const barrel = plant.mesh.children[15];
          barrel.rotation.y += 0.02;
        }
        // Glow pulses intensely
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const glow = plant.mesh.children[plant.mesh.children.length - 1];
          const scale = 1 + Math.sin(plant.animationTime * 2.5) * 0.15;
          glow.scale.set(scale, scale, scale);
          glow.rotation.y += 0.03;
        }
        break;

      case 'pear-spiker':
        // Bob up and down aggressively
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 3) * 0.05;
        // Face the spawn point (right side, +X direction)
        plant.mesh.rotation.y = 0;
        // Pear glows pulse
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            if ((child.material.color.getHex() & 0xffd700) === 0xffd700) { // Golden pears
              child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 4 + index) * 0.2;
            }
          }
        });
        // Spike launcher pulses red when ready
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            if ((child.material.color.getHex() & 0xff0000) === 0xff0000) { // Red spike elements
              const pulse = 1 + Math.sin(plant.animationTime * 5 + index) * 0.15;
              child.scale.set(pulse, pulse, pulse);
              if (plant.cooldown <= 1) { // Pulse faster when nearly ready
                child.material.emissiveIntensity = 0.7 + Math.sin(plant.animationTime * 10) * 0.3;
              }
            }
          }
        });
        // Glow rotates
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const glow = plant.mesh.children[plant.mesh.children.length - 1];
          glow.rotation.y += 0.025;
          const scale = 1 + Math.sin(plant.animationTime * 3) * 0.12;
          glow.scale.set(scale, scale, scale);
        }
        break;

      case 'strawbomber':
        // TITAN: Bob menacingly
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2.5) * 0.08;
        // Rotate launcher slowly
        plant.mesh.rotation.y = Math.sin(plant.animationTime * 0.5) * 0.3;
        // Bomb barrels pulse when ready
        plant.mesh.children.forEach((child, index) => {
          if (index >= 8 && index < 11) { // Bomb barrels
            const pulse = 1 + Math.sin(plant.animationTime * 4 + index) * 0.1;
            child.scale.set(pulse, pulse, pulse);
            if (plant.cooldown <= 1 && child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 10) * 0.3;
            }
          }
        });
        // Strawberry accents glow
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            if ((child.material.color.getHex() & 0xff0000) === 0xff0000) {
              child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 3 + index) * 0.2;
            }
          }
        });
        break;

      case 'frovine-slammer':
        // TITAN: Intimidating punching animation
        // Always face the zombie spawn point (+X direction)
        plant.mesh.rotation.y = 0;

        // Heavy stomping animation
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 3) * 0.06;

        // Animate massive fists - alternating punch motion
        // Structure: body (0), 8 vines (1-8), left fist (9), left spikes (10-14), left arm (15), left armor (16),
        //            right fist (17), right spikes (18-22), right arm (23), right armor (24), then more parts

        // Left fist (index 9)
        if (plant.mesh.children[9]) {
          const leftFist = plant.mesh.children[9];
          const punchAmount = Math.sin(plant.animationTime * 2.5);
          leftFist.position.set(-0.9, 1.0, -0.4 + punchAmount * 0.8);
          leftFist.rotation.x = punchAmount * 0.5;
        }

        // Right fist (index 17)
        if (plant.mesh.children[17]) {
          const rightFist = plant.mesh.children[17];
          const punchAmount = Math.sin(plant.animationTime * 2.5 + Math.PI);
          rightFist.position.set(0.9, 1.0, -0.4 + punchAmount * 0.8);
          rightFist.rotation.x = punchAmount * 0.5;
        }

        // Body sways with punches
        plant.mesh.children.forEach((child, index) => {
          if (index === 0) { // Main body
            child.rotation.z = Math.sin(plant.animationTime * 2.5) * 0.1;
          }
        });

        // Vines writhe and pulse
        plant.mesh.children.forEach((child, index) => {
          if (index >= 1 && index <= 8) { // Vine wraps
            const pulse = 1 + Math.sin(plant.animationTime * 4 + index) * 0.08;
            child.scale.set(pulse, pulse, pulse);
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 3 + index) * 0.15;
            }
          }
        });

        // Ice crystal head rotates menacingly
        plant.mesh.children.forEach((child, index) => {
          if (index >= 17 && index <= 20) { // Head area
            child.rotation.y += 0.02;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 4) * 0.2;
            }
          }
        });

        // Frost aura pulses
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const aura = plant.mesh.children[plant.mesh.children.length - 1];
          const scale = 1 + Math.sin(plant.animationTime * 2) * 0.15;
          aura.scale.set(scale, scale, scale);
          if (aura instanceof THREE.Mesh && aura.material instanceof THREE.MeshBasicMaterial) {
            aura.material.opacity = 0.15 + Math.sin(plant.animationTime * 3) * 0.05;
          }
        }

        // Ice spikes shimmer
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            if ((child.material.color.getHex() & 0x4682b4) === 0x4682b4) { // Ice blue elements
              child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 5 + index) * 0.2;
            }
          }
        });
        break;

      case 'pear-nuker':
        // TITAN: Massive intimidating presence
        // Bob heavily
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2) * 0.1;
        // Rotate slowly
        plant.mesh.rotation.y += 0.005;
        // Pear accents pulse with nuclear energy
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            if ((child.material.color.getHex() & 0xccff00) === 0xccff00) { // Glowing pears
              const pulse = 1 + Math.sin(plant.animationTime * 4 + index) * 0.12;
              child.scale.set(pulse, pulse, pulse);
              child.material.emissiveIntensity = 0.7 + Math.sin(plant.animationTime * 5 + index) * 0.3;
            }
          }
        });
        // Nuclear glow intensifies when ready
        if (plant.mesh.children[plant.mesh.children.length - 1]) {
          const glow = plant.mesh.children[plant.mesh.children.length - 1];
          glow.rotation.y += 0.03;
          const scale = 1 + Math.sin(plant.animationTime * 3) * 0.2;
          glow.scale.set(scale, scale, scale);
        }
        break;

      case 'rose-reaper':
        // LEGENDARY dark rose - ominous presence
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.2) * 0.025;

        // Skull eyes flicker with hellfire
        plant.mesh.children.forEach(child => {
          if (child.userData.isSkullEye && child instanceof THREE.Mesh) {
            const flicker = 0.75 + Math.sin(plant.animationTime * 10) * 0.15 + Math.random() * 0.1;
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = flicker;
            }
            const pulse = 1 + Math.sin(plant.animationTime * 5) * 0.25;
            child.scale.set(pulse, pulse, pulse);
          }
          // Eye flames dance
          if (child.userData.isEyeFlame && child instanceof THREE.Mesh) {
            const side = child.userData.flameSide;
            child.scale.y = 1 + Math.sin(plant.animationTime * 8 + side) * 0.3;
            child.scale.x = 1 + Math.sin(plant.animationTime * 6) * 0.2;
            child.position.y = 0.58 + Math.sin(plant.animationTime * 7) * 0.02;
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.5 + Math.sin(plant.animationTime * 9) * 0.2;
            }
          }
        });

        // Runes on gravestone pulse
        plant.mesh.children.forEach(child => {
          if (child.userData.isRune && child instanceof THREE.Mesh) {
            const i = child.userData.runeIndex;
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.6 + Math.sin(plant.animationTime * 3 + i * 2) * 0.3;
            }
            child.rotation.z = plant.animationTime * 0.5 + i;
          }
        });

        // Shroud billows
        const shroud = plant.mesh.children.find(c => c.userData.isShroud);
        if (shroud) {
          shroud.rotation.y += 0.008;
          const scale = 1 + Math.sin(plant.animationTime * 1.5) * 0.08;
          shroud.scale.set(scale, 1 + Math.sin(plant.animationTime * 2) * 0.05, scale);
          if (shroud instanceof THREE.Mesh && shroud.material instanceof THREE.MeshBasicMaterial) {
            shroud.material.opacity = 0.2 + Math.sin(plant.animationTime * 2) * 0.08;
          }
        }

        // Petals breathing
        plant.mesh.children.forEach((child, index) => {
          if (child.userData.isPetal && child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 2.5 + index * 0.15) * 0.12;
          }
        });

        // Dew drops shimmer
        plant.mesh.children.forEach(child => {
          if (child.userData.isDewDrop && child instanceof THREE.Mesh) {
            const i = child.userData.dewIndex;
            const shimmer = 1 + Math.sin(plant.animationTime * 6 + i * 1.5) * 0.2;
            child.scale.set(shimmer, shimmer, shimmer);
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.opacity = 0.6 + Math.sin(plant.animationTime * 4 + i) * 0.25;
            }
          }
        });

        // Scythe group animation
        plant.mesh.children.forEach(child => {
          if (child.userData.isScytheGroup) {
            // Gentle sway
            child.rotation.z = -0.25 + Math.sin(plant.animationTime * 1.2) * 0.06;
            child.rotation.x = Math.sin(plant.animationTime * 0.8) * 0.03;

            // Blade glow effects
            child.children.forEach(part => {
              if (part.userData.isScytheGlow && part instanceof THREE.Mesh && part.material instanceof THREE.MeshBasicMaterial) {
                part.material.opacity = 0.7 + Math.sin(plant.animationTime * 4) * 0.25;
              }
              if (part.userData.isBladeRune && part instanceof THREE.Mesh && part.material instanceof THREE.MeshBasicMaterial) {
                const ri = part.userData.runeIndex;
                part.material.opacity = 0.6 + Math.sin(plant.animationTime * 5 + ri * 1.2) * 0.35;
              }
            });
          }
        });

        // Soul chains sway
        plant.mesh.children.forEach(child => {
          if (child.userData.isChainLink && child instanceof THREE.Mesh) {
            const ci = child.userData.chainIndex;
            const li = child.userData.linkIndex;
            child.rotation.x = Math.PI / 2 + li * 0.2 + Math.sin(plant.animationTime * 2 + ci + li * 0.3) * 0.15;
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.2 + Math.sin(plant.animationTime * 3 + ci + li) * 0.15;
            }
          }
        });

        // Healing aura
        const roseHealAura = plant.mesh.children.find(c => c.userData.isHealingAura);
        if (roseHealAura) {
          roseHealAura.rotation.y += 0.015;
          const scale = 1 + Math.sin(plant.animationTime * 2) * 0.1;
          roseHealAura.scale.set(scale, scale, scale);
        }

        // Death aura
        const roseDeathAura = plant.mesh.children.find(c => c.userData.isReaperAura);
        if (roseDeathAura) {
          roseDeathAura.rotation.y -= 0.01;
          const scale = 1 + Math.sin(plant.animationTime * 1.5) * 0.12;
          roseDeathAura.scale.set(scale, scale * 0.8, scale);
        }

        // Ground fog swirls
        const fog = plant.mesh.children.find(c => c.userData.isFog);
        if (fog) {
          fog.rotation.y += 0.012;
          const scale = 1 + Math.sin(plant.animationTime * 1.5) * 0.15;
          fog.scale.set(scale, 1, scale);
          if (fog instanceof THREE.Mesh && fog.material instanceof THREE.MeshBasicMaterial) {
            fog.material.opacity = 0.2 + Math.sin(plant.animationTime * 2) * 0.08;
          }
        }

        // Soul wisps orbit with trails
        plant.mesh.children.forEach(child => {
          if (child.userData.isSoul) {
            const i = child.userData.soulIndex;
            const speed = 1.2 + (i % 3) * 0.2;
            const angle = plant.animationTime * speed + (i / 12) * Math.PI * 2;
            const vertOffset = Math.sin(plant.animationTime * 2.5 + i * 0.5) * 0.4;
            const radius = 0.7 + Math.sin(plant.animationTime * 1.5 + i) * 0.12;
            child.position.x = Math.cos(angle) * radius;
            child.position.z = Math.sin(angle) * radius;
            child.position.y = 1.5 + vertOffset;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.7 + Math.sin(plant.animationTime * 4 + i) * 0.2;
            }
          }
        });

        // Falling petals spiral down
        plant.mesh.children.forEach(child => {
          if (child.userData.isPollen) {
            const i = child.userData.pollenIndex;
            const spiralAngle = plant.animationTime * 0.8 + i * 0.5;
            const radius = 0.25 + Math.sin(plant.animationTime * 0.5 + i) * 0.25;
            child.position.x = Math.cos(spiralAngle) * radius;
            child.position.z = Math.sin(spiralAngle) * radius;
            const fallY = 2.0 - ((plant.animationTime * 0.25 + i * 0.15) % 1.2) * 1.0;
            child.position.y = fallY;
            child.rotation.y = plant.animationTime * 3;
            child.rotation.x = Math.sin(plant.animationTime * 4 + i) * 0.8;
            child.rotation.z = Math.cos(plant.animationTime * 3 + i) * 0.4;
          }
        });

        // Dark energy swirls around skull
        plant.mesh.children.forEach(child => {
          if (child.userData.isDarkEnergy) {
            const i = child.userData.darkIndex;
            const angle = plant.animationTime * 2.5 + (i / 8) * Math.PI * 2;
            const radius = 0.4 + Math.sin(plant.animationTime * 2 + i) * 0.12;
            child.position.x = Math.cos(angle) * radius;
            child.position.z = Math.sin(angle) * radius;
            child.position.y = 0.4 + Math.sin(plant.animationTime * 3.5 + i * 0.7) * 0.2;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.45 + Math.sin(plant.animationTime * 5 + i) * 0.25;
            }
          }
        });
        break;

      case 'lily-reaper':
        // Mystical healing lily reaper - gentle floating and glowing
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.5) * 0.04;
        plant.mesh.rotation.y = Math.sin(plant.animationTime * 0.5) * 0.03;

        // Healing orb pulsing
        plant.mesh.children.forEach(child => {
          if (child.userData.isHealOrb && child instanceof THREE.Mesh) {
            const pulse = 1 + Math.sin(plant.animationTime * 3) * 0.2;
            child.scale.set(pulse, pulse, pulse);
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.6 + Math.sin(plant.animationTime * 4) * 0.2;
            }
          }
        });

        // Reaper eyes glow
        plant.mesh.children.forEach(child => {
          if (child.userData.isReaperEye && child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.7 + Math.sin(plant.animationTime * 6) * 0.25;
            }
            const pulse = 1 + Math.sin(plant.animationTime * 4) * 0.15;
            child.scale.set(pulse, pulse, pulse);
          }
        });

        // Water ripples expand
        plant.mesh.children.forEach(child => {
          if (child.userData.isRipple) {
            const i = child.userData.rippleIndex;
            const scale = 1 + ((plant.animationTime * 0.3 + i * 0.3) % 1) * 0.5;
            child.scale.set(scale, scale, 1);
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.4 * (1 - ((plant.animationTime * 0.3 + i * 0.3) % 1));
            }
          }
        });

        // Healing vines shimmer
        plant.mesh.children.forEach((child, index) => {
          if (child.userData.isHealVine && child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
            child.material.opacity = 0.5 + Math.sin(plant.animationTime * 5 + index * 0.5) * 0.3;
          }
        });

        // Healing particles float
        plant.mesh.children.forEach(child => {
          if (child.userData.isHealParticle) {
            const i = child.userData.particleIndex;
            const angle = plant.animationTime * 1.5 + (i / 10) * Math.PI * 2;
            const radius = 0.35 + Math.sin(plant.animationTime * 2 + i) * 0.1;
            child.position.x = Math.cos(angle) * radius;
            child.position.z = Math.sin(angle) * radius;
            child.position.y = 0.8 + Math.sin(plant.animationTime * 2.5 + i * 0.5) * 0.3;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.6 + Math.sin(plant.animationTime * 4 + i) * 0.3;
            }
          }
        });

        // Death wisps orbit
        plant.mesh.children.forEach(child => {
          if (child.userData.isDeathWisp) {
            const i = child.userData.wispIndex;
            const angle = plant.animationTime * 2 + (i / 6) * Math.PI * 2;
            const radius = 0.5 + Math.sin(plant.animationTime * 1.5 + i) * 0.08;
            child.position.x = Math.cos(angle) * radius;
            child.position.z = Math.sin(angle) * radius;
            child.position.y = 0.6 + Math.sin(plant.animationTime * 3 + i) * 0.15;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.4 + Math.sin(plant.animationTime * 4 + i) * 0.2;
            }
          }
        });

        // Healing aura pulses
        plant.mesh.children.forEach(child => {
          if (child.userData.isLilyHealAura && child instanceof THREE.Mesh) {
            const scale = 1 + Math.sin(plant.animationTime * 2) * 0.15;
            child.scale.set(scale, scale, scale);
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.1 + Math.sin(plant.animationTime * 3) * 0.05;
            }
          }
        });
        break;

      case 'mushroom-bomber':
        // Epic toxic mushroom - organic breathing motion
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2) * 0.05;
        plant.mesh.rotation.y = Math.sin(plant.animationTime * 0.8) * 0.06;

        // Cap breathing/pulsing
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            const hex = child.material.color.getHex();
            // Purple cap
            if (hex === 0x6a1b9a) {
              const pulse = 1 + Math.sin(plant.animationTime * 2) * 0.04;
              child.scale.set(pulse * 0.6, pulse * 0.6 * 0.5, pulse * 0.6);
              child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 2.5) * 0.15;
            }
          }
        });

        // Bioluminescent spots glow animation
        plant.mesh.children.forEach(child => {
          if (child.userData.isGlowSpot && child instanceof THREE.Mesh) {
            const i = child.userData.spotIndex;
            const pulse = 1 + Math.sin(plant.animationTime * 4 + i * 0.5) * 0.25;
            child.scale.set(pulse, pulse, pulse);
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.6 + Math.sin(plant.animationTime * 5 + i * 0.3) * 0.35;
            }
          }
        });

        // Top spot intense glow
        const topSpot = plant.mesh.children.find(c => c.userData.isTopSpot);
        if (topSpot && topSpot instanceof THREE.Mesh) {
          const pulse = 1 + Math.sin(plant.animationTime * 3) * 0.2;
          topSpot.scale.set(pulse, pulse, pulse);
          if (topSpot.material instanceof THREE.MeshPhongMaterial) {
            topSpot.material.emissiveIntensity = 0.8 + Math.sin(plant.animationTime * 4) * 0.2;
          }
        }

        // Toxic spore cloud pulse
        const toxicAura = plant.mesh.children.find(c => c.userData.isSporeAura);
        if (toxicAura) {
          const scale = 1 + Math.sin(plant.animationTime * 1.5) * 0.15;
          toxicAura.scale.set(scale, scale * 0.8, scale);
          toxicAura.rotation.y += 0.008;
          if (toxicAura instanceof THREE.Mesh && toxicAura.material instanceof THREE.MeshBasicMaterial) {
            toxicAura.material.opacity = 0.1 + Math.sin(plant.animationTime * 2) * 0.04;
          }
        }

        // Floating spore particles - chaotic orbit
        plant.mesh.children.forEach(child => {
          if (child.userData.isSporeParticle) {
            const i = child.userData.particleIndex;
            const baseRadius = child.userData.baseRadius || 0.6;
            const angle = plant.animationTime * (1.2 + i * 0.1) + (i / 16) * Math.PI * 2;
            const radiusOscillation = baseRadius + Math.sin(plant.animationTime * 2 + i) * 0.15;
            child.position.x = Math.cos(angle) * radiusOscillation;
            child.position.z = Math.sin(angle) * radiusOscillation;
            child.position.y = 1.3 + Math.sin(plant.animationTime * 3 + i * 0.8) * 0.35;
            // Fade in and out
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.5 + Math.sin(plant.animationTime * 2.5 + i) * 0.3;
            }
          }
        });
        break;

      case 'vined-wall':
        // Epic nature wall animation
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 1.5) * 0.04;
        plant.mesh.position.y = 0.5 + Math.sin(plant.animationTime * 2) * 0.025;

        // Vine heart pulses with life energy
        plant.mesh.children.forEach(child => {
          if (child.userData.isVineHeart && child instanceof THREE.Mesh) {
            const pulse = 1 + Math.sin(plant.animationTime * 3) * 0.2;
            child.scale.set(pulse, pulse, pulse);
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 4) * 0.3;
            }
          }
          // Floating spores
          if (child.userData.isSpore) {
            const i = child.userData.sporeIndex;
            child.position.y += Math.sin(plant.animationTime * 2 + i) * 0.003;
            child.position.x += Math.cos(plant.animationTime * 1.5 + i * 2) * 0.002;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.5 + Math.sin(plant.animationTime * 3 + i) * 0.3;
            }
          }
          // Nature aura breathing
          if (child.userData.isVineAura) {
            const scale = 1 + Math.sin(plant.animationTime * 1.5) * 0.12;
            child.scale.set(scale, scale, scale);
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.08 + Math.sin(plant.animationTime * 2) * 0.05;
            }
          }
        });
        break;

      case 'frostberry-launcher':
        // Epic frost launcher animation
        plant.mesh.children.forEach(child => {
          // Frost mist swirling
          if (child.userData.isFrostMist) {
            const scale = 1 + Math.sin(plant.animationTime * 2) * 0.18;
            child.scale.set(scale, scale, scale);
            child.rotation.y += 0.01;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.12 + Math.sin(plant.animationTime * 3) * 0.08;
            }
          }
          // Frost core glowing
          if (child.userData.isFrostCore && child instanceof THREE.Mesh) {
            const pulse = 1 + Math.sin(plant.animationTime * 4) * 0.25;
            child.scale.set(pulse, pulse, pulse);
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.6 + Math.sin(plant.animationTime * 5) * 0.3;
            }
          }
          // Ice crystals shimmer
          if (child.userData.isCrystal && child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 3) * 0.2;
            }
          }
          // Snowflakes floating
          if (child.userData.isSnowflake) {
            const i = child.userData.snowIndex;
            child.position.y += Math.sin(plant.animationTime * 1.5 + i) * 0.004;
            child.position.x += Math.cos(plant.animationTime * 2 + i * 1.5) * 0.003;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.6 + Math.sin(plant.animationTime * 2 + i) * 0.3;
            }
          }
        });
        // Ice shimmer wobble
        plant.mesh.rotation.y = Math.sin(plant.animationTime * 4) * 0.025;
        break;

      case 'reaper-peall':
        // Epic reaper wall animation
        plant.mesh.children.forEach(child => {
          // Skull eyes burning hellfire
          if (child.userData.isSkullEye && child instanceof THREE.Mesh) {
            const flicker = 0.7 + Math.sin(plant.animationTime * 10) * 0.2 + Math.random() * 0.1;
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = flicker;
            }
            const pulse = 1 + Math.sin(plant.animationTime * 6) * 0.2;
            child.scale.set(pulse, pulse, pulse);
          }
          // Eye flames dancing
          if (child.userData.isEyeFlame && child instanceof THREE.Mesh) {
            child.scale.y = 1 + Math.sin(plant.animationTime * 8) * 0.4;
            child.scale.x = 1 + Math.sin(plant.animationTime * 6) * 0.2;
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.5 + Math.sin(plant.animationTime * 7) * 0.3;
            }
          }
          // Dark aura pulsing
          if (child.userData.isReaperAura) {
            const scale = 1 + Math.sin(plant.animationTime * 2) * 0.12;
            child.scale.set(scale, scale, scale);
            child.rotation.y += 0.005;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.15 + Math.sin(plant.animationTime * 3) * 0.08;
            }
          }
          // Ghostly souls swirling
          if (child.userData.isSoul) {
            const i = child.userData.soulIndex;
            const angle = plant.animationTime * 0.8 + (i / 4) * Math.PI * 2;
            child.position.x = Math.cos(angle) * 0.8;
            child.position.z = Math.sin(angle) * 0.5;
            child.position.y = 1.2 + Math.sin(plant.animationTime * 2 + i) * 0.3;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.3 + Math.sin(plant.animationTime * 3 + i) * 0.2;
            }
          }
          // Base runes glowing
          if (child.userData.isBaseRune && child instanceof THREE.Mesh) {
            const i = child.userData.runeIndex;
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.5 + Math.sin(plant.animationTime * 2.5 + i * 0.8) * 0.4;
            }
          }
          // Death mist swirling
          if (child.userData.isDeathMist) {
            child.rotation.y += 0.008;
            const scale = 1 + Math.sin(plant.animationTime * 1.5) * 0.1;
            child.scale.set(scale, 1, scale);
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.2 + Math.sin(plant.animationTime * 2) * 0.1;
            }
          }
        });
        break;

      case 'acorn-tree':
        // Tree sway animation
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 1.2) * 0.035;
        plant.mesh.children.forEach(child => {
          // Nature aura pulsing
          if (child.userData.isTreeAura) {
            const scale = 1 + Math.sin(plant.animationTime * 2) * 0.1;
            child.scale.set(scale, scale, scale);
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.1 + Math.sin(plant.animationTime * 2.5) * 0.05;
            }
          }
          // Acorns bobbing and glowing
          if (child.userData.isAcorn && child instanceof THREE.Mesh) {
            child.position.y += Math.sin(plant.animationTime * 3) * 0.003;
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.2 + Math.sin(plant.animationTime * 4) * 0.15;
            }
          }
        });
        // Canopy gentle sway (index varies based on added elements)
        const canopyIdx = 12; // After aura, soil, roots, trunk, bark rings
        if (plant.mesh.children[canopyIdx]) {
          plant.mesh.children[canopyIdx].rotation.y = Math.sin(plant.animationTime * 0.8) * 0.02;
        }
        break;

      case 'acorn-bomb':
        // Pulsing danger glow
        plant.mesh.children.forEach(child => {
          if (child.userData.isBombGlow) {
            const pulse = 1 + Math.sin(plant.animationTime * 4) * 0.3;
            child.scale.set(pulse, pulse, pulse);
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.2 + Math.sin(plant.animationTime * 5) * 0.15;
            }
          }
          // Sparks orbiting
          if (child.userData.isSpark) {
            const i = child.userData.sparkIndex;
            const angle = plant.animationTime * 3 + (i / 4) * Math.PI * 2;
            child.position.x = Math.cos(angle) * 0.3;
            child.position.z = Math.sin(angle) * 0.3;
            child.position.y = 0.4 + Math.sin(plant.animationTime * 4 + i) * 0.1;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.5 + Math.sin(plant.animationTime * 6 + i) * 0.4;
            }
          }
        });
        break;

      case 'banana-peel':
        // Magical summoning animation
        plant.mesh.children.forEach(child => {
          // Summon aura rotating
          if (child.userData.isSummonAura) {
            child.rotation.z += 0.02;
            const pulse = 1 + Math.sin(plant.animationTime * 2) * 0.15;
            child.scale.set(pulse, pulse, 1);
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.2 + Math.sin(plant.animationTime * 3) * 0.15;
            }
          }
          // Sparkles floating
          if (child.userData.isSparkle) {
            const i = child.userData.sparkleIndex;
            child.position.y = 0.5 + (i % 3) * 0.3 + Math.sin(plant.animationTime * 2 + i) * 0.15;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.4 + Math.sin(plant.animationTime * 4 + i * 1.5) * 0.4;
            }
          }
        });
        // Gentle sway
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 1.5) * 0.02;
        break;

      case 'frost-peel':
        // Icy summoning animation
        plant.mesh.children.forEach(child => {
          // Icy summon aura rotating
          if (child.userData.isSummonAura) {
            child.rotation.z += 0.025;
            const pulse = 1 + Math.sin(plant.animationTime * 2.5) * 0.18;
            child.scale.set(pulse, pulse, 1);
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.25 + Math.sin(plant.animationTime * 3.5) * 0.2;
            }
          }
          // Frost crystal spinning and glowing
          if (child.userData.isFrostCrystal) {
            child.rotation.y += 0.03;
            child.rotation.x = Math.sin(plant.animationTime * 2) * 0.15;
            const pulse = 1 + Math.sin(plant.animationTime * 4) * 0.15;
            child.scale.set(pulse, pulse, pulse);
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 5) * 0.3;
            }
          }
          // Icy sparkles floating
          if (child.userData.isSparkle) {
            const i = child.userData.sparkleIndex;
            child.position.y = 0.4 + (i % 3) * 0.25 + Math.sin(plant.animationTime * 2.5 + i) * 0.12;
            child.rotation.x += 0.05;
            child.rotation.y += 0.03;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.5 + Math.sin(plant.animationTime * 5 + i * 2) * 0.4;
            }
          }
        });
        // Gentle icy sway
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 1.8) * 0.025;
        break;

      case 'frozen-overlord-mushroom':
        // Ultimate ice overlord - intimidating presence with icy power
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.2) * 0.04;
        plant.mesh.rotation.y += 0.003; // Slow regal rotation

        // Crown jewel pulsing intensely
        plant.mesh.children.forEach(child => {
          if (child.userData.isCrownJewel && child instanceof THREE.Mesh) {
            const pulse = 1 + Math.sin(plant.animationTime * 4) * 0.25;
            child.scale.set(pulse, pulse, pulse);
            child.rotation.y += 0.05;
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.7 + Math.sin(plant.animationTime * 5) * 0.3;
            }
          }
        });

        // Crown spires shimmer
        plant.mesh.children.forEach(child => {
          if (child.userData.isCrownSpire && child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 4 + Math.random()) * 0.3;
          }
        });

        // Overlord eyes glow menacingly
        plant.mesh.children.forEach(child => {
          if (child.userData.isOverlordEye && child instanceof THREE.Mesh) {
            const pulse = 1 + Math.sin(plant.animationTime * 6) * 0.2;
            child.scale.set(pulse, pulse, pulse);
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.8 + Math.sin(plant.animationTime * 8) * 0.2;
            }
          }
          // Cold breath trails
          if (child.userData.isBreath && child instanceof THREE.Mesh) {
            child.scale.y = 1 + Math.sin(plant.animationTime * 5) * 0.4;
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.3 + Math.sin(plant.animationTime * 6) * 0.2;
            }
          }
        });

        // Freeze aura rings expand
        plant.mesh.children.forEach(child => {
          if (child.userData.isFreezeRing) {
            const i = child.userData.ringIndex;
            const expandScale = 1 + ((plant.animationTime * 0.5 + i * 0.3) % 1) * 0.4;
            child.scale.set(expandScale, expandScale, 1);
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.3 * (1 - ((plant.animationTime * 0.5 + i * 0.3) % 1));
            }
          }
        });

        // Orbiting ice crystals
        plant.mesh.children.forEach(child => {
          if (child.userData.isOrbitCrystal) {
            const i = child.userData.crystalIndex;
            const angle = plant.animationTime * 1.5 + (i / 6) * Math.PI * 2;
            const radius = 0.6 + Math.sin(plant.animationTime * 2 + i) * 0.1;
            child.position.x = Math.cos(angle) * radius;
            child.position.z = Math.sin(angle) * radius;
            child.position.y = 1.0 + Math.sin(plant.animationTime * 2.5 + i * 0.5) * 0.25;
            child.rotation.x += 0.04;
            child.rotation.y += 0.06;
            if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 4 + i) * 0.3;
            }
          }
        });

        // Frost mist breathing
        plant.mesh.children.forEach(child => {
          if (child.userData.isFrostMist && child instanceof THREE.Mesh) {
            const scale = 1 + Math.sin(plant.animationTime * 1.5) * 0.12;
            child.scale.set(scale, scale * 0.8, scale);
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.12 + Math.sin(plant.animationTime * 2) * 0.06;
            }
          }
        });
        break;

      case 'frost-spiker':
        // Icy pulsing animation with crystal shimmer
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2.5) * 0.03;
        // Ice crystals rotate and pulse
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            // Crystal ring spins and pulses
            if (child.geometry instanceof THREE.OctahedronGeometry) {
              const pulse = 1 + Math.sin(plant.animationTime * 4 + index) * 0.15;
              child.scale.set(pulse, pulse, pulse);
              child.rotation.y += 0.03;
              child.rotation.x = Math.sin(plant.animationTime * 3 + index) * 0.2;
              if (child.material instanceof THREE.MeshPhongMaterial) {
                child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 5 + index) * 0.3;
              }
            }
            // Icicles shimmer
            if (child.geometry instanceof THREE.ConeGeometry) {
              const shimmer = 1 + Math.sin(plant.animationTime * 6 + index) * 0.1;
              child.scale.set(shimmer, shimmer, shimmer);
            }
            // Berry pulses
            if (child.geometry instanceof THREE.SphereGeometry && child.position.y > 0.4 && child.position.y < 0.8) {
              const breathe = 1 + Math.sin(plant.animationTime * 2) * 0.05;
              child.scale.set(breathe, breathe, breathe);
            }
          }
        });
        // Frost aura pulses and rotates
        const frostAura = plant.mesh.children.find(c => c instanceof THREE.Mesh &&
          (c as THREE.Mesh).geometry instanceof THREE.SphereGeometry && c.position.y > 0.7);
        if (frostAura) {
          const scale = 1 + Math.sin(plant.animationTime * 2) * 0.12;
          frostAura.scale.set(scale, scale, scale);
          frostAura.rotation.y += 0.01;
        }
        break;

      case 'banana-leach':
        // Dark necromantic animation with ghostly effects
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.5) * 0.025;
        // Glowing eyes flicker menacingly
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
            // Eyes flicker
            if (child.geometry instanceof THREE.SphereGeometry && child.position.y > 0.85 && child.position.y < 1.0) {
              const flicker = 0.7 + Math.sin(plant.animationTime * 8 + index) * 0.2 + Math.random() * 0.1;
              child.material.opacity = flicker;
              const pulse = 1 + Math.sin(plant.animationTime * 6) * 0.2;
              child.scale.set(pulse, pulse, pulse);
            }
          }
        });
        // Scythe sways ominously
        plant.mesh.children.forEach(child => {
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.TorusGeometry) {
            child.rotation.z = -Math.PI / 2 + Math.sin(plant.animationTime * 1.2) * 0.1;
          }
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.CylinderGeometry && child.position.x > 0.2) {
            child.rotation.z = -Math.PI / 4 + Math.sin(plant.animationTime * 1.2) * 0.08;
          }
        });
        // Necromantic aura pulses
        const necroAura = plant.mesh.children.find(c => c instanceof THREE.Mesh &&
          (c as THREE.Mesh).geometry instanceof THREE.SphereGeometry && c.position.y > 0.6 && c.position.y < 0.8);
        if (necroAura && necroAura instanceof THREE.Mesh && necroAura.material instanceof THREE.MeshBasicMaterial) {
          const scale = 1 + Math.sin(plant.animationTime * 2) * 0.15;
          necroAura.scale.set(scale, scale, scale);
          necroAura.rotation.y += 0.015;
          necroAura.material.opacity = 0.12 + Math.sin(plant.animationTime * 3) * 0.08;
        }
        // Hood sways slightly
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 1.0) * 0.03;
        break;

      case 'acorn-wall':
        // Sturdy wall animation with tree growth effects
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 0.8) * 0.015; // Very subtle sway
        // Leaves rustle
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.SphereGeometry) {
            // Crown leaves rustle
            if (child.position.y > 1.3) {
              const rustle = 1 + Math.sin(plant.animationTime * 3 + index * 0.5) * 0.08;
              child.scale.set(child.scale.x * rustle / (1 + Math.sin((plant.animationTime - 0.016) * 3 + index * 0.5) * 0.08),
                              child.scale.y,
                              child.scale.z);
              child.rotation.z = Math.sin(plant.animationTime * 2 + index) * 0.1;
            }
            // Acorns glow when ready to drop
            if (child.position.y > 0.85 && child.position.y < 1.2) {
              const glow = 1 + Math.sin(plant.animationTime * 4 + index) * 0.1;
              child.scale.set(glow, glow * 1.2, glow);
              if (child.material instanceof THREE.MeshPhongMaterial) {
                child.material.emissiveIntensity = 0.2 + Math.sin(plant.animationTime * 5 + index) * 0.15;
              }
            }
          }
        });
        // Vines pulse with life
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.CylinderGeometry) {
            if (child.position.x < -0.2) { // Vines are on the left side
              const pulse = 1 + Math.sin(plant.animationTime * 2 + index * 0.3) * 0.05;
              child.scale.set(pulse, 1, pulse);
            }
          }
        });
        break;

      case 'tomato-spike':
      case 'elder-tomato-spike':
        // Spiky plants pulse aggressively
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 3) * 0.04;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            // Spikes vibrate menacingly
            if (child.geometry instanceof THREE.ConeGeometry) {
              const vibrate = 1 + Math.sin(plant.animationTime * 6 + index) * 0.12;
              child.scale.set(vibrate, vibrate, vibrate);
              child.rotation.x = Math.sin(plant.animationTime * 4 + index) * 0.1;
            }
            // Tomato body pulses
            if (child.geometry instanceof THREE.SphereGeometry) {
              const pulse = 1 + Math.sin(plant.animationTime * 2) * 0.06;
              child.scale.set(pulse, pulse, pulse);
              if (child.material instanceof THREE.MeshPhongMaterial) {
                child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 3) * 0.15;
              }
            }
          }
        });
        break;

      case 'straw-spiker':
        // Strawberry spiker bounces and spikes pulse
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 4) * 0.05;
        plant.mesh.rotation.y = Math.sin(plant.animationTime * 2) * 0.08;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            // Red strawberry parts glow
            if ((child.material.color.getHex() & 0xff0000) > 0x800000) {
              child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 5 + index) * 0.2;
            }
          }
        });
        break;

      case 'spike-wall':
        // Defensive wall with pulsing spikes
        plant.mesh.rotation.x = Math.sin(plant.animationTime * 1.5) * 0.02;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.ConeGeometry) {
            const pulse = 1 + Math.sin(plant.animationTime * 4 + index * 0.5) * 0.15;
            child.scale.set(pulse, pulse, pulse);
          }
        });
        break;

      case 'seed-batch':
        // Seeds float and spin mystically
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2) * 0.06;
        plant.mesh.rotation.y += 0.015;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            const float = Math.sin(plant.animationTime * 3 + index) * 0.05;
            child.position.y += float * 0.02;
            child.rotation.x = Math.sin(plant.animationTime * 2 + index) * 0.2;
          }
        });
        break;

      case 'elder-frost-berri':
        // Elder frost berry - powerful icy presence
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2) * 0.03;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 4 + index) * 0.25;
          }
        });
        plant.mesh.rotation.y += 0.008;
        break;

      case 'frost-grape-launcher':
        // Icy version of grape launcher
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 2) * 0.04;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            if (child.geometry instanceof THREE.SphereGeometry) {
              const pulse = 1 + Math.sin(plant.animationTime * 3 + index) * 0.08;
              child.scale.set(pulse, pulse, pulse);
            }
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 4) * 0.2;
            }
          }
        });
        break;

      case 'frozen-mushroom-bomber':
        // Frozen version of mushroom bomber
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.8) * 0.04;
        plant.mesh.rotation.y = Math.sin(plant.animationTime * 0.6) * 0.05;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 3 + index) * 0.2;
          }
        });
        break;

      case 'frost-vine-wall':
        // Icy vine wall - shimmers with frost
        plant.mesh.rotation.x = Math.sin(plant.animationTime * 1.5) * 0.02;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 3 + index) * 0.15;
            child.material.opacity = 0.85 + Math.sin(plant.animationTime * 2) * 0.1;
          }
        });
        break;

      case 'frozen-lily':
      case 'frozen-lilyer':
        // Frozen lily variants - icy shimmer
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.5) * 0.03;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            const scale = 1 + Math.sin(plant.animationTime * 2 + index * 0.5) * 0.08;
            child.scale.set(scale, scale, scale);
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 3) * 0.2;
            }
          }
        });
        break;

      case 'strawberry-tree':
        // Tree sway with berry bouncing
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 1.0) * 0.03;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            // Berries bob
            if (child.geometry instanceof THREE.SphereGeometry && child.position.y > 1) {
              child.position.y += Math.sin(plant.animationTime * 2.5 + index) * 0.003;
            }
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.2 + Math.sin(plant.animationTime * 3 + index) * 0.1;
            }
          }
        });
        break;

      case 'acorn-nest':
        // Nest rustles with acorns rolling
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 0.8) * 0.02;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.SphereGeometry) {
            child.rotation.x = Math.sin(plant.animationTime * 2 + index) * 0.15;
            child.rotation.z = Math.cos(plant.animationTime * 1.5 + index) * 0.1;
          }
        });
        break;

      case 'sunberry-launcher':
        // Bright sun-powered launcher
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 3) * 0.05;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            // Yellow/golden parts glow intensely
            child.material.emissiveIntensity = 0.6 + Math.sin(plant.animationTime * 5 + index) * 0.3;
          }
        });
        // Sun glow pulses
        const sunGlow = plant.mesh.children[plant.mesh.children.length - 1];
        if (sunGlow) {
          const scale = 1 + Math.sin(plant.animationTime * 4) * 0.2;
          sunGlow.scale.set(scale, scale, scale);
        }
        break;

      case 'lily-wall':
        // Lily wall - petals pulse, defensive stance
        plant.mesh.rotation.x = Math.sin(plant.animationTime * 1.5) * 0.02;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            const pulse = 1 + Math.sin(plant.animationTime * 2 + index * 0.3) * 0.06;
            child.scale.set(pulse, pulse, pulse);
          }
        });
        break;

      case 'lily-peel':
        // Lily peel - summoning animation
        plant.mesh.rotation.y += 0.01;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
            child.material.opacity = 0.5 + Math.sin(plant.animationTime * 3 + index) * 0.3;
          }
        });
        break;

      case 'lily-gun':
      case 'lily-cannon':
        // Lily-based shooters - gentle sway with petal pulse
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 1.8) * 0.04;
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2) * 0.03;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 3 + index) * 0.15;
            }
          }
        });
        break;

      case 'vine-slammer':
        // Vine slammer - aggressive vine movements
        plant.mesh.rotation.y = 0;
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 4) * 0.05;
        plant.mesh.children.forEach((child, index) => {
          // Vines writhe
          if (index < 8) {
            child.rotation.z = Math.sin(plant.animationTime * 3 + index) * 0.2;
          }
        });
        break;

      case 'grape-spiker':
        // Grape spiker - grapes pulse, spikes vibrate
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 3) * 0.04;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            if (child.geometry instanceof THREE.SphereGeometry) {
              const pulse = 1 + Math.sin(plant.animationTime * 3 + index) * 0.1;
              child.scale.set(pulse, pulse, pulse);
            }
            if (child.geometry instanceof THREE.ConeGeometry) {
              child.rotation.x = Math.sin(plant.animationTime * 5 + index) * 0.15;
            }
          }
        });
        break;

      case 'grape-gun-wall':
        // Grape gun wall - defensive with grape pulses
        plant.mesh.rotation.x = Math.sin(plant.animationTime * 1.5) * 0.02;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.SphereGeometry) {
            const pulse = 1 + Math.sin(plant.animationTime * 3 + index) * 0.08;
            child.scale.set(pulse, pulse, pulse);
          }
        });
        break;

      case 'frost-overlord-grape-gun':
        // Ultimate frost grape gun - icy power radiates
        plant.mesh.rotation.z = Math.sin(plant.animationTime * 2) * 0.05;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            const pulse = 1 + Math.sin(plant.animationTime * 4 + index) * 0.12;
            child.scale.set(pulse, pulse, pulse);
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 5) * 0.3;
            }
          }
        });
        break;

      case 'black-hole-coconut':
        // Black hole - ominous spinning and pulling effect
        plant.mesh.rotation.y += 0.03;
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.5) * 0.02;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial) {
            child.material.opacity = 0.6 + Math.sin(plant.animationTime * 3 + index) * 0.3;
          }
          // Event horizon ring spins
          if (child instanceof THREE.Mesh && child.geometry instanceof THREE.TorusGeometry) {
            child.rotation.x += 0.02;
            child.rotation.z = Math.sin(plant.animationTime * 2) * 0.3;
          }
        });
        break;

      case 'frozen-supernova-coconut':
        // Frozen supernova - icy cosmic power
        plant.mesh.rotation.y += 0.02;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.6 + Math.sin(plant.animationTime * 4 + index) * 0.3;
            }
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.5 + Math.sin(plant.animationTime * 3) * 0.25;
            }
          }
        });
        break;

      case 'banana-launcher':
        // Banana launcher - tropical bouncing
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 3.5) * 0.06;
        plant.mesh.rotation.y = Math.sin(plant.animationTime * 2) * 0.1;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 4 + index) * 0.15;
          }
        });
        break;

      case 'pickle-spear':
        // Pickle spear - floating and spinning
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.5) * 0.07;
        plant.mesh.rotation.y += 0.012;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 3 + index) * 0.2;
          }
        });
        break;

      case 'thornbomber':
        // Thornbomber - thorns pulse dangerously
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2.5) * 0.05;
        plant.mesh.rotation.y = Math.sin(plant.animationTime * 1) * 0.08;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            if (child.geometry instanceof THREE.ConeGeometry) {
              const pulse = 1 + Math.sin(plant.animationTime * 5 + index) * 0.15;
              child.scale.set(pulse, pulse, pulse);
            }
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 4) * 0.2;
            }
          }
        });
        break;

      case 'titan-reaper-peall':
        // Titan reaper wall - ultimate dark presence
        plant.mesh.children.forEach((child, index) => {
          if (child.userData.isSkullEye && child instanceof THREE.Mesh) {
            const flicker = 0.8 + Math.sin(plant.animationTime * 12) * 0.15 + Math.random() * 0.05;
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = flicker;
            }
          }
          if (child.userData.isSoul) {
            const i = child.userData.soulIndex || index;
            const angle = plant.animationTime * 0.6 + (i / 6) * Math.PI * 2;
            child.position.x = Math.cos(angle) * 1.0;
            child.position.z = Math.sin(angle) * 0.6;
            child.position.y = 1.5 + Math.sin(plant.animationTime * 2 + i) * 0.4;
          }
        });
        break;

      case 'frozen-nebula-mushroom':
        // Frozen nebula mushroom - cosmic ice swirls
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.5) * 0.05;
        plant.mesh.rotation.y += 0.005;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 3 + index) * 0.25;
            }
            if (child.material instanceof THREE.MeshBasicMaterial) {
              child.material.opacity = 0.4 + Math.sin(plant.animationTime * 2 + index) * 0.2;
            }
          }
        });
        break;

      case 'grape-frospike':
        // Grape frospike - icy grape pulsing with frost crystals
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2) * 0.03;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            // Ice crystals rotate and shimmer
            if (child.geometry instanceof THREE.OctahedronGeometry || child.geometry instanceof THREE.ConeGeometry) {
              const pulse = 1 + Math.sin(plant.animationTime * 4 + index) * 0.15;
              child.scale.set(pulse, pulse, pulse);
              child.rotation.y += 0.02;
              if (child.material instanceof THREE.MeshPhongMaterial) {
                child.material.emissiveIntensity = 0.4 + Math.sin(plant.animationTime * 5 + index) * 0.3;
              }
            }
            // Grapes breathe
            if (child.geometry instanceof THREE.SphereGeometry && child.position.y > 0.4 && child.position.y < 0.7) {
              const breathe = 1 + Math.sin(plant.animationTime * 2.5 + index) * 0.08;
              child.scale.set(breathe, breathe, breathe);
            }
          }
        });
        break;

      case 'frospike':
        // Frospike - deadly ice spike with cold aura
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 2.5) * 0.04;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            // Ice spikes pulse menacingly
            if (child.geometry instanceof THREE.ConeGeometry) {
              const pulse = 1 + Math.sin(plant.animationTime * 3 + index) * 0.12;
              child.scale.set(pulse, pulse * 1.1, pulse);
              if (child.material instanceof THREE.MeshPhongMaterial) {
                child.material.emissiveIntensity = 0.5 + Math.sin(plant.animationTime * 4 + index) * 0.35;
              }
            }
            // Frost particles float
            if (child.geometry instanceof THREE.SphereGeometry && child.position.y > 0.3) {
              child.position.y += Math.sin(plant.animationTime * 3 + index) * 0.002;
              if (child.material instanceof THREE.MeshBasicMaterial) {
                child.material.opacity = 0.5 + Math.sin(plant.animationTime * 2 + index) * 0.2;
              }
            }
          }
        });
        // Cold aura pulses
        const coldAura = plant.mesh.children.find(c => c instanceof THREE.Mesh &&
          (c as THREE.Mesh).geometry instanceof THREE.SphereGeometry && c.position.y > 0.6);
        if (coldAura) {
          const scale = 1 + Math.sin(plant.animationTime * 2) * 0.15;
          coldAura.scale.set(scale, scale, scale);
          coldAura.rotation.y += 0.01;
        }
        break;

      case 'strawberry-pear-launcher':
        // Pear body bob, turret spins fast during rapid-fire
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 3) * 0.05;
        if (plant.mesh.userData.turret) {
          if (plant.userData?.rapidFireActive) {
            (plant.mesh.userData.turret as THREE.Group).rotation.y += 0.08;
          }
        }
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
            child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 4 + index) * 0.15;
          }
        });
        break;

      case 'frozen-pickle-spear':
        // Floating bob, ice crystals pulse and rotate
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.5) * 0.06;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            if (child.geometry instanceof THREE.OctahedronGeometry) {
              const pulse = 1 + Math.sin(plant.animationTime * 4 + index) * 0.15;
              child.scale.set(pulse, pulse, pulse);
              child.rotation.y += 0.02;
            }
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 3 + index) * 0.2;
            }
          }
        });
        break;

      case 'mushroom-healer':
        // Gentle breathing, green glow pulses
        plant.mesh.position.y = plant.position.y + Math.sin(plant.animationTime * 1.8) * 0.04;
        plant.mesh.children.forEach((child, index) => {
          if (child instanceof THREE.Mesh) {
            if (child.material instanceof THREE.MeshBasicMaterial && child.material.color.getHex() === 0x44ff88) {
              child.material.opacity = 0.08 + Math.sin(plant.animationTime * 2) * 0.04;
              const scale = 1 + Math.sin(plant.animationTime * 1.5) * 0.1;
              child.scale.set(scale, scale, scale);
            }
            if (child.material instanceof THREE.MeshBasicMaterial && child.material.color.getHex() === 0x66ffaa) {
              // Floating spore particles orbit
              const sporeAngle = plant.animationTime * 1.2 + index * 1.5;
              child.position.x = Math.cos(sporeAngle) * 0.6;
              child.position.z = Math.sin(sporeAngle) * 0.6;
              child.position.y = 1.1 + Math.sin(plant.animationTime * 2 + index) * 0.15;
            }
            if (child.material instanceof THREE.MeshPhongMaterial) {
              child.material.emissiveIntensity = 0.3 + Math.sin(plant.animationTime * 3 + index) * 0.2;
            }
          }
        });
        break;
    }
  }

  private showSlotIndicator(x: number, z: number): void {
    const slot = this.slotMeshes.find(
      mesh => mesh.userData.slotX === x && mesh.userData.slotZ === z
    );
    if (slot) {
      slot.visible = true;
    }
  }

  private displayPlantHP(): void {
    // Display HP text above each plant
    for (const plant of this.placedPlants) {
      // Remove old HP display if it exists
      const oldHPDisplay = plant.mesh.children.find(child => child.userData.isHPDisplay);
      if (oldHPDisplay) {
        plant.mesh.remove(oldHPDisplay);
      }

      // Calculate plant height from bounding box
      const box = new THREE.Box3().setFromObject(plant.mesh);
      const plantHeight = box.max.y - box.min.y;
      // Position HP bar above the plant with some padding
      const hpBarY = Math.max(plantHeight + 0.5, 2.0);

      // Create canvas for HP text - WIDER canvas for longer bar
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      if (!context) continue;

      canvas.width = 512;  // Wider canvas
      canvas.height = 80;  // Taller for better text

      // Draw HP background
      context.fillStyle = 'rgba(0, 0, 0, 0.8)';
      context.fillRect(0, 0, canvas.width, canvas.height);

      // HP bar background - LONGER bar
      context.fillStyle = 'rgba(60, 60, 60, 0.9)';
      context.fillRect(15, 12, 482, 28);

      // HP bar border
      context.strokeStyle = 'rgba(255, 255, 255, 0.5)';
      context.lineWidth = 2;
      context.strokeRect(15, 12, 482, 28);

      // HP bar (colored based on health percentage)
      const healthPercent = plant.health / plant.maxHealth;
      const barWidth = 482 * healthPercent;

      // Gradient fill for HP bar
      const gradient = context.createLinearGradient(15, 0, 15 + barWidth, 0);
      if (healthPercent > 0.6) {
        gradient.addColorStop(0, 'rgba(0, 200, 0, 1)');
        gradient.addColorStop(1, 'rgba(100, 255, 100, 1)');
      } else if (healthPercent > 0.3) {
        gradient.addColorStop(0, 'rgba(200, 150, 0, 1)');
        gradient.addColorStop(1, 'rgba(255, 220, 0, 1)');
      } else {
        gradient.addColorStop(0, 'rgba(180, 0, 0, 1)');
        gradient.addColorStop(1, 'rgba(255, 50, 50, 1)');
      }
      context.fillStyle = gradient;
      context.fillRect(17, 14, Math.max(0, barWidth - 4), 24);

      // HP text - larger and centered
      context.font = 'bold 28px Arial';
      context.fillStyle = 'white';
      context.textAlign = 'center';
      context.shadowColor = 'black';
      context.shadowBlur = 4;
      context.fillText(`${Math.ceil(plant.health)} / ${plant.maxHealth}`, 256, 62);

      // Create texture and sprite
      const texture = new THREE.CanvasTexture(canvas);
      const spriteMaterial = new THREE.SpriteMaterial({ map: texture });
      const sprite = new THREE.Sprite(spriteMaterial);
      sprite.scale.set(3, 0.6, 1);  // Wider sprite scale
      sprite.position.set(0, hpBarY, 0); // Dynamic height based on plant
      sprite.userData.isHPDisplay = true;

      plant.mesh.add(sprite);
    }
  }

  private displayBunkerHP(): void {
    for (const plant of this.placedPlants) {
      if (!plant.pineappleBunker) continue;

      const bunker = plant.pineappleBunker;
      // Remove old bunker HP display
      const oldDisplay = bunker.mesh.children.find(child => child.userData.isBunkerHPDisplay);
      if (oldDisplay) {
        bunker.mesh.remove(oldDisplay);
      }

      const box = new THREE.Box3().setFromObject(bunker.mesh);
      const bunkerHeight = box.max.y - box.min.y;
      const hpBarY = Math.max(bunkerHeight + 0.5, 2.5);

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      if (!context) continue;

      canvas.width = 512;
      canvas.height = 80;

      // Orange-tinted background for bunker HP
      context.fillStyle = 'rgba(40, 20, 0, 0.85)';
      context.fillRect(0, 0, canvas.width, canvas.height);

      context.fillStyle = 'rgba(60, 40, 20, 0.9)';
      context.fillRect(15, 12, 482, 28);

      context.strokeStyle = 'rgba(255, 180, 50, 0.7)';
      context.lineWidth = 2;
      context.strokeRect(15, 12, 482, 28);

      const healthPercent = bunker.health / bunker.maxHealth;
      const barWidth = 482 * healthPercent;

      const gradient = context.createLinearGradient(15, 0, 15 + barWidth, 0);
      gradient.addColorStop(0, 'rgba(200, 130, 0, 1)');
      gradient.addColorStop(1, 'rgba(255, 200, 50, 1)');
      context.fillStyle = gradient;
      context.fillRect(17, 14, Math.max(0, barWidth - 4), 24);

      context.font = 'bold 28px Arial';
      context.fillStyle = 'white';
      context.textAlign = 'center';
      context.shadowColor = 'black';
      context.shadowBlur = 4;
      context.fillText(`Bunker: ${Math.ceil(bunker.health)} / ${bunker.maxHealth}`, 256, 62);

      const texture = new THREE.CanvasTexture(canvas);
      const spriteMaterial = new THREE.SpriteMaterial({ map: texture });
      const sprite = new THREE.Sprite(spriteMaterial);
      sprite.scale.set(3, 0.6, 1);
      sprite.position.set(0, hpBarY, 0);
      sprite.userData.isBunkerHPDisplay = true;

      bunker.mesh.add(sprite);
    }
  }

  private displayZombieHealth(): void {
    // Display HP text above each zombie
    for (const zombie of this.zombies) {
      // Remove old HP display if it exists
      const oldHPDisplay = zombie.mesh.children.find(child => child.userData.isZombieHPDisplay);
      if (oldHPDisplay) {
        zombie.mesh.remove(oldHPDisplay);
      }

      // Create canvas for HP text
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      if (!context) continue;

      canvas.width = 256;
      canvas.height = 64;

      // Draw HP text
      context.fillStyle = 'rgba(0, 0, 0, 0.7)';
      context.fillRect(0, 0, canvas.width, canvas.height);

      // HP bar background
      context.fillStyle = 'rgba(100, 100, 100, 0.8)';
      context.fillRect(10, 10, 236, 20);

      // HP bar (colored based on health percentage)
      const healthPercent = zombie.health / zombie.maxHealth;
      const barWidth = 236 * healthPercent;

      if (healthPercent > 0.6) {
        context.fillStyle = 'rgba(255, 100, 100, 0.9)'; // Red for zombies
      } else if (healthPercent > 0.3) {
        context.fillStyle = 'rgba(255, 150, 0, 0.9)'; // Orange
      } else {
        context.fillStyle = 'rgba(200, 0, 0, 0.9)'; // Dark red
      }
      context.fillRect(10, 10, barWidth, 20);

      // HP text
      context.font = 'bold 24px Arial';
      context.fillStyle = 'white';
      context.textAlign = 'center';
      context.fillText(`${Math.ceil(zombie.health)} / ${zombie.maxHealth}`, 128, 50);

      // Create texture and sprite
      const texture = new THREE.CanvasTexture(canvas);
      const spriteMaterial = new THREE.SpriteMaterial({ map: texture });
      const sprite = new THREE.Sprite(spriteMaterial);
      sprite.scale.set(2, 0.5, 1);
      sprite.position.set(0, 3.5, 0); // Above zombie head
      sprite.userData.isZombieHPDisplay = true;

      zombie.mesh.add(sprite);
    }
  }

  private findNearestZombieInRow(position: THREE.Vector3): Zombie | null {
    let nearest: Zombie | null = null;
    let minDistance = Infinity;

    for (const zombie of this.zombies) {
      // Check if in same row (within 1 unit)
      if (Math.abs(zombie.position.z - position.z) < 1.5) {
        // Check if zombie is ahead (to the right)
        if (zombie.position.x > position.x) {
          const distance = zombie.position.distanceTo(position);
          if (distance < minDistance) {
            minDistance = distance;
            nearest = zombie;
          }
        }
      }
    }

    return nearest;
  }

  private shootGrape(from: THREE.Vector3, to: THREE.Vector3, damage: number = 45): void { // 45 damage (1.5x)
    // Apply Grape Pulser power plant passive: +10% damage
    if (this.powerPlant && this.powerPlantType === 'grape-pulser' && this.powerPlant.health > 0) {
      damage = Math.round(damage * 1.1);
    }
    const grapeGroup = new THREE.Group();

    // Main grape body - juicy and glossy
    const grapeGeo = new THREE.SphereGeometry(0.18, 16, 16);
    const grapeMat = new THREE.MeshPhongMaterial({
      color: 0x8b2daa,
      shininess: 150,
      specular: 0xcc88ff,
      emissive: 0x3d1055,
      emissiveIntensity: 0.4
    });
    const grape = new THREE.Mesh(grapeGeo, grapeMat);
    grapeGroup.add(grape);

    // Inner glow core
    const coreGeo = new THREE.SphereGeometry(0.1, 12, 12);
    const coreMat = new THREE.MeshBasicMaterial({
      color: 0xdd88ff,
      transparent: true,
      opacity: 0.8
    });
    const core = new THREE.Mesh(coreGeo, coreMat);
    grapeGroup.add(core);

    // Outer energy glow
    const glowGeo = new THREE.SphereGeometry(0.28, 12, 12);
    const glowMat = new THREE.MeshBasicMaterial({
      color: 0x9944cc,
      transparent: true,
      opacity: 0.35
    });
    const glow = new THREE.Mesh(glowGeo, glowMat);
    grapeGroup.add(glow);

    // Energy ring spinning around
    const ringGeo = new THREE.TorusGeometry(0.22, 0.025, 8, 16);
    const ringMat = new THREE.MeshBasicMaterial({
      color: 0xcc66ff,
      transparent: true,
      opacity: 0.7
    });
    const ring = new THREE.Mesh(ringGeo, ringMat);
    ring.rotation.x = Math.PI / 2;
    grapeGroup.add(ring);

    // Sparkle particles around grape
    for (let i = 0; i < 6; i++) {
      const sparkGeo = new THREE.OctahedronGeometry(0.03, 0);
      const sparkMat = new THREE.MeshBasicMaterial({
        color: 0xffaaff,
        transparent: true,
        opacity: 0.9
      });
      const spark = new THREE.Mesh(sparkGeo, sparkMat);
      const angle = (i / 6) * Math.PI * 2;
      spark.position.set(Math.cos(angle) * 0.25, Math.sin(angle) * 0.25, 0);
      grapeGroup.add(spark);
    }

    grapeGroup.position.copy(from);
    grapeGroup.position.y = 1.2;
    this.scene.add(grapeGroup);

    // Trigger shooting animation on the plant
    this.triggerShootAnimation(from, 'grape');

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(22);

    const projectile = new Projectile(grapeGroup as unknown as THREE.Mesh, grapeGroup.position, velocity, damage, true);
    this.projectiles.push(projectile);
  }

  private shootFrozenGrape(from: THREE.Vector3, to: THREE.Vector3, damage: number = 50): void {
    const frozenGroup = new THREE.Group();

    // Main frozen grape - crystalline ice
    const grapeGeo = new THREE.IcosahedronGeometry(0.18, 1);
    const grapeMat = new THREE.MeshPhongMaterial({
      color: 0x88ddff,
      shininess: 200,
      specular: 0xffffff,
      emissive: 0x00aaff,
      emissiveIntensity: 0.6,
      transparent: true,
      opacity: 0.9
    });
    const grape = new THREE.Mesh(grapeGeo, grapeMat);
    frozenGroup.add(grape);

    // Bright inner core
    const coreGeo = new THREE.SphereGeometry(0.1, 12, 12);
    const coreMat = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      opacity: 0.95
    });
    const core = new THREE.Mesh(coreGeo, coreMat);
    frozenGroup.add(core);

    // Ice shards radiating out
    for (let i = 0; i < 8; i++) {
      const shardGeo = new THREE.ConeGeometry(0.025, 0.15, 4);
      const shardMat = new THREE.MeshPhongMaterial({
        color: 0xccffff,
        shininess: 150,
        transparent: true,
        opacity: 0.85,
        emissive: 0x44ddff,
        emissiveIntensity: 0.4
      });
      const shard = new THREE.Mesh(shardGeo, shardMat);
      const angle = (i / 8) * Math.PI * 2;
      shard.position.set(Math.cos(angle) * 0.18, Math.sin(angle) * 0.18, 0);
      shard.rotation.z = angle - Math.PI / 2;
      frozenGroup.add(shard);
    }

    // Frost aura
    const auraGeo = new THREE.SphereGeometry(0.32, 16, 16);
    const auraMat = new THREE.MeshBasicMaterial({
      color: 0x66ddff,
      transparent: true,
      opacity: 0.25
    });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    frozenGroup.add(aura);

    // Swirling snowflakes
    for (let i = 0; i < 6; i++) {
      const flakeGeo = new THREE.PlaneGeometry(0.04, 0.04);
      const flakeMat = new THREE.MeshBasicMaterial({
        color: 0xffffff,
        transparent: true,
        opacity: 0.9,
        side: THREE.DoubleSide
      });
      const flake = new THREE.Mesh(flakeGeo, flakeMat);
      const angle = (i / 6) * Math.PI * 2;
      flake.position.set(Math.cos(angle) * 0.28, Math.sin(angle) * 0.28, 0);
      frozenGroup.add(flake);
    }

    frozenGroup.position.copy(from);
    frozenGroup.position.y = 1.2;
    this.scene.add(frozenGroup);

    // Trigger shooting animation
    this.triggerShootAnimation(from, 'frost');

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(22);

    const projectile = new Projectile(frozenGroup as unknown as THREE.Mesh, frozenGroup.position, velocity, damage, true, false, true);
    this.projectiles.push(projectile);
  }

  private shootStrawberry(from: THREE.Vector3, to: THREE.Vector3): void {
    const strawberryGroup = new THREE.Group();

    // Main strawberry body - vibrant red teardrop shape
    const berryGeo = new THREE.SphereGeometry(0.12, 16, 16);
    const berryMat = new THREE.MeshPhongMaterial({
      color: 0xff2255,
      shininess: 120,
      specular: 0xff88aa,
      emissive: 0x880022,
      emissiveIntensity: 0.3
    });
    const berry = new THREE.Mesh(berryGeo, berryMat);
    berry.scale.set(0.9, 1.2, 0.9); // Strawberry shape
    strawberryGroup.add(berry);

    // Yellow seeds embedded in surface
    for (let i = 0; i < 8; i++) {
      const seedGeo = new THREE.SphereGeometry(0.018, 6, 6);
      const seedMat = new THREE.MeshPhongMaterial({
        color: 0xffee00,
        shininess: 100,
        emissive: 0xffaa00,
        emissiveIntensity: 0.5
      });
      const seed = new THREE.Mesh(seedGeo, seedMat);
      const phi = Math.acos(-1 + (2 * i) / 8);
      const theta = Math.sqrt(8 * Math.PI) * phi;
      seed.position.set(
        0.1 * Math.cos(theta) * Math.sin(phi),
        0.12 * Math.cos(phi),
        0.1 * Math.sin(theta) * Math.sin(phi)
      );
      strawberryGroup.add(seed);
    }

    // Tiny leaf cap
    const leafGeo = new THREE.ConeGeometry(0.06, 0.04, 6);
    const leafMat = new THREE.MeshPhongMaterial({
      color: 0x22aa22,
      shininess: 40
    });
    const leaf = new THREE.Mesh(leafGeo, leafMat);
    leaf.position.y = 0.12;
    leaf.rotation.x = Math.PI;
    strawberryGroup.add(leaf);

    // Pink energy glow
    const glowGeo = new THREE.SphereGeometry(0.18, 12, 12);
    const glowMat = new THREE.MeshBasicMaterial({
      color: 0xff66aa,
      transparent: true,
      opacity: 0.35
    });
    const glow = new THREE.Mesh(glowGeo, glowMat);
    strawberryGroup.add(glow);

    // Speed trail sparkles
    for (let i = 0; i < 4; i++) {
      const sparkGeo = new THREE.OctahedronGeometry(0.025, 0);
      const sparkMat = new THREE.MeshBasicMaterial({
        color: 0xffaacc,
        transparent: true,
        opacity: 0.8
      });
      const spark = new THREE.Mesh(sparkGeo, sparkMat);
      spark.position.set(-0.1 - i * 0.08, (Math.random() - 0.5) * 0.1, (Math.random() - 0.5) * 0.1);
      strawberryGroup.add(spark);
    }

    strawberryGroup.position.copy(from);
    strawberryGroup.position.y = 1.2;
    this.scene.add(strawberryGroup);

    // Trigger shooting animation
    this.triggerShootAnimation(from, 'strawberry');

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(22); // Standard projectile speed

    const projectile = new Projectile(strawberryGroup as unknown as THREE.Mesh, strawberryGroup.position, velocity, 15, true); // 15 damage (1.5x)
    this.projectiles.push(projectile);
  }

  private shootSunGrape(from: THREE.Vector3, to: THREE.Vector3): void {
    const sunGrapeGroup = new THREE.Group();

    // Main grape body - radiant golden sun
    const grapeGeo = new THREE.SphereGeometry(0.2, 20, 20);
    const grapeMat = new THREE.MeshPhongMaterial({
      color: 0xffdd00,
      shininess: 180,
      specular: 0xffffff,
      emissive: 0xffaa00,
      emissiveIntensity: 0.7
    });
    const grape = new THREE.Mesh(grapeGeo, grapeMat);
    sunGrapeGroup.add(grape);

    // Brilliant inner core
    const coreGeo = new THREE.SphereGeometry(0.12, 16, 16);
    const coreMat = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      opacity: 0.95
    });
    const core = new THREE.Mesh(coreGeo, coreMat);
    sunGrapeGroup.add(core);

    // Sun rays/corona
    for (let i = 0; i < 12; i++) {
      const rayGeo = new THREE.ConeGeometry(0.03, 0.2, 4);
      const rayMat = new THREE.MeshBasicMaterial({
        color: 0xffff66,
        transparent: true,
        opacity: 0.8
      });
      const ray = new THREE.Mesh(rayGeo, rayMat);
      const angle = (i / 12) * Math.PI * 2;
      ray.position.set(Math.cos(angle) * 0.22, Math.sin(angle) * 0.22, 0);
      ray.rotation.z = angle - Math.PI / 2;
      sunGrapeGroup.add(ray);
    }

    // Golden glow layers
    for (let i = 0; i < 3; i++) {
      const glowGeo = new THREE.SphereGeometry(0.28 + i * 0.08, 16, 16);
      const glowMat = new THREE.MeshBasicMaterial({
        color: i === 0 ? 0xffff00 : i === 1 ? 0xffdd00 : 0xffaa00,
        transparent: true,
        opacity: 0.25 - i * 0.06
      });
      const glow = new THREE.Mesh(glowGeo, glowMat);
      sunGrapeGroup.add(glow);
    }

    // Orbiting sun particles
    for (let i = 0; i < 6; i++) {
      const particleGeo = new THREE.SphereGeometry(0.035, 8, 8);
      const particleMat = new THREE.MeshBasicMaterial({
        color: 0xffff88,
        transparent: true,
        opacity: 0.9
      });
      const particle = new THREE.Mesh(particleGeo, particleMat);
      const angle = (i / 6) * Math.PI * 2;
      particle.position.set(Math.cos(angle) * 0.35, Math.sin(angle) * 0.35, 0);
      sunGrapeGroup.add(particle);
    }

    sunGrapeGroup.position.copy(from);
    sunGrapeGroup.position.y = 1.4;
    this.scene.add(sunGrapeGroup);

    // Trigger shooting animation
    this.triggerShootAnimation(from, 'sun');

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(22);

    const projectile = new Projectile(
      sunGrapeGroup as unknown as THREE.Mesh,
      sunGrapeGroup.position,
      velocity,
      25,
      true,
      true
    );
    this.projectiles.push(projectile);
  }

  private shootGrapeFromZombie(from: THREE.Vector3, to: THREE.Vector3): void {
    const evilGrapeGroup = new THREE.Group();

    // Main evil grape body - corrupted dark purple
    const grapeGeo = new THREE.SphereGeometry(0.18, 16, 16);
    const grapeMat = new THREE.MeshPhongMaterial({
      color: 0x660066,
      shininess: 120,
      specular: 0xff00ff,
      emissive: 0x440044,
      emissiveIntensity: 0.6
    });
    const grape = new THREE.Mesh(grapeGeo, grapeMat);
    evilGrapeGroup.add(grape);

    // Dark corrupted core
    const coreGeo = new THREE.SphereGeometry(0.1, 12, 12);
    const coreMat = new THREE.MeshBasicMaterial({
      color: 0x220022,
      transparent: true,
      opacity: 0.9
    });
    const core = new THREE.Mesh(coreGeo, coreMat);
    evilGrapeGroup.add(core);

    // Evil energy tendrils
    for (let i = 0; i < 6; i++) {
      const tendrilGeo = new THREE.CylinderGeometry(0.015, 0.005, 0.2, 6);
      const tendrilMat = new THREE.MeshBasicMaterial({
        color: 0xcc00cc,
        transparent: true,
        opacity: 0.7
      });
      const tendril = new THREE.Mesh(tendrilGeo, tendrilMat);
      const angle = (i / 6) * Math.PI * 2;
      tendril.position.set(Math.cos(angle) * 0.18, Math.sin(angle) * 0.18, 0);
      tendril.rotation.z = angle - Math.PI / 2;
      evilGrapeGroup.add(tendril);
    }

    // Sinister purple glow
    const glowGeo = new THREE.SphereGeometry(0.28, 12, 12);
    const glowMat = new THREE.MeshBasicMaterial({
      color: 0xff00ff,
      transparent: true,
      opacity: 0.35
    });
    const glow = new THREE.Mesh(glowGeo, glowMat);
    evilGrapeGroup.add(glow);

    // Outer dark aura
    const auraGeo = new THREE.SphereGeometry(0.35, 12, 12);
    const auraMat = new THREE.MeshBasicMaterial({
      color: 0x440044,
      transparent: true,
      opacity: 0.2
    });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    evilGrapeGroup.add(aura);

    // Evil sparkles
    for (let i = 0; i < 4; i++) {
      const sparkGeo = new THREE.OctahedronGeometry(0.025, 0);
      const sparkMat = new THREE.MeshBasicMaterial({
        color: 0xff66ff,
        transparent: true,
        opacity: 0.8
      });
      const spark = new THREE.Mesh(sparkGeo, sparkMat);
      const angle = (i / 4) * Math.PI * 2;
      spark.position.set(Math.cos(angle) * 0.3, Math.sin(angle) * 0.3, 0);
      evilGrapeGroup.add(spark);
    }

    evilGrapeGroup.position.copy(from);
    evilGrapeGroup.position.y = 1.2;
    this.scene.add(evilGrapeGroup);

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(18); // Slightly slower than plant projectiles

    // Create a special zombie projectile that damages plants
    const zombieProjectile = {
      mesh: evilGrapeGroup as unknown as THREE.Mesh,
      position: evilGrapeGroup.position,
      velocity: velocity,
      damage: 15,
      isFromZombie: true
    };

    // Add to a zombie projectiles array
    if (!this.zombieProjectiles) {
      this.zombieProjectiles = [];
    }
    this.zombieProjectiles.push(zombieProjectile);
  }

  private shootFrostGrapeFromZombie(from: THREE.Vector3, to: THREE.Vector3): void {
    // BOSS attack: Frozen grape projectile that damages AND slows plants
    const frostGrapeGroup = new THREE.Group();

    // Main frozen grape body - icy blue
    const grapeGeo = new THREE.SphereGeometry(0.22, 16, 16);
    const grapeMat = new THREE.MeshPhongMaterial({
      color: 0x4488cc,
      shininess: 180,
      specular: 0xaaddff,
      emissive: 0x2266aa,
      emissiveIntensity: 0.7
    });
    const grape = new THREE.Mesh(grapeGeo, grapeMat);
    frostGrapeGroup.add(grape);

    // Frozen ice core
    const coreGeo = new THREE.SphereGeometry(0.12, 12, 12);
    const coreMat = new THREE.MeshBasicMaterial({
      color: 0x88ddff,
      transparent: true,
      opacity: 0.9
    });
    const core = new THREE.Mesh(coreGeo, coreMat);
    frostGrapeGroup.add(core);

    // Ice crystal spikes
    for (let i = 0; i < 8; i++) {
      const spikeGeo = new THREE.ConeGeometry(0.03, 0.15, 4);
      const spikeMat = new THREE.MeshPhongMaterial({
        color: 0xaaeeff,
        shininess: 200,
        emissive: 0x66ccff,
        emissiveIntensity: 0.5,
        transparent: true,
        opacity: 0.85
      });
      const spike = new THREE.Mesh(spikeGeo, spikeMat);
      const angle = (i / 8) * Math.PI * 2;
      spike.position.set(
        Math.cos(angle) * 0.2,
        Math.sin(angle) * 0.2,
        (i % 2) * 0.05 - 0.025
      );
      spike.rotation.z = angle - Math.PI / 2;
      frostGrapeGroup.add(spike);
    }

    // Frost glow
    const glowGeo = new THREE.SphereGeometry(0.32, 12, 12);
    const glowMat = new THREE.MeshBasicMaterial({
      color: 0x66ccff,
      transparent: true,
      opacity: 0.4
    });
    const glow = new THREE.Mesh(glowGeo, glowMat);
    frostGrapeGroup.add(glow);

    // Outer icy mist aura
    const auraGeo = new THREE.SphereGeometry(0.4, 12, 12);
    const auraMat = new THREE.MeshBasicMaterial({
      color: 0x88ddff,
      transparent: true,
      opacity: 0.2
    });
    const aura = new THREE.Mesh(auraGeo, auraMat);
    frostGrapeGroup.add(aura);

    // Ice sparkles
    for (let i = 0; i < 6; i++) {
      const sparkGeo = new THREE.OctahedronGeometry(0.03, 0);
      const sparkMat = new THREE.MeshBasicMaterial({
        color: 0xccffff,
        transparent: true,
        opacity: 0.9
      });
      const spark = new THREE.Mesh(sparkGeo, sparkMat);
      const angle = (i / 6) * Math.PI * 2;
      spark.position.set(Math.cos(angle) * 0.35, Math.sin(angle) * 0.35, 0);
      frostGrapeGroup.add(spark);
    }

    frostGrapeGroup.position.copy(from);
    frostGrapeGroup.position.y = 1.4;
    this.scene.add(frostGrapeGroup);

    const direction = new THREE.Vector3().subVectors(to, from).normalize();
    direction.y = 0;
    const velocity = direction.multiplyScalar(20); // Faster than regular zombie grapes

    // Create a frost zombie projectile that damages AND slows plants
    const frostProjectile = {
      mesh: frostGrapeGroup as unknown as THREE.Mesh,
      position: frostGrapeGroup.position,
      velocity: velocity,
      damage: 25, // Higher damage than regular zombie grape
      isFromZombie: true,
      isFrost: true, // Special flag for frost effect
      slowAmount: 0.5, // 50% slow
      slowDuration: 3 // 3 seconds
    };

    if (!this.zombieProjectiles) {
      this.zombieProjectiles = [];
    }
    this.zombieProjectiles.push(frostProjectile);
  }

  private shootPearProjectile(plant: Plant, zombie: Zombie): void {
    const pearGroup = new THREE.Group();

    // Main pear body - explosive cannonball with pear shape
    const pearGeo = new THREE.SphereGeometry(0.35, 20, 20);
    const pearMat = new THREE.MeshPhongMaterial({
      color: 0xeebb00,
      shininess: 150,
      specular: 0xffffaa,
      emissive: 0xcc8800,
      emissiveIntensity: 0.5
    });
    const pear = new THREE.Mesh(pearGeo, pearMat);
    pear.scale.set(0.85, 1.15, 0.85); // Pear shape
    pearGroup.add(pear);

    // Red explosive tip/blush
    const tipGeo = new THREE.SphereGeometry(0.2, 16, 16);
    const tipMat = new THREE.MeshPhongMaterial({
      color: 0xff4422,
      shininess: 100,
      emissive: 0xff2200,
      emissiveIntensity: 0.4,
      transparent: true,
      opacity: 0.8
    });
    const tip = new THREE.Mesh(tipGeo, tipMat);
    tip.position.x = 0.2;
    pearGroup.add(tip);

    // Bright explosive core
    const coreGeo = new THREE.SphereGeometry(0.18, 12, 12);
    const coreMat = new THREE.MeshBasicMaterial({
      color: 0xffff88,
      transparent: true,
      opacity: 0.9
    });
    const core = new THREE.Mesh(coreGeo, coreMat);
    pearGroup.add(core);

    // Fire trail particles
    for (let i = 0; i < 8; i++) {
      const fireGeo = new THREE.SphereGeometry(0.06 - i * 0.006, 8, 8);
      const fireMat = new THREE.MeshBasicMaterial({
        color: i < 3 ? 0xffff00 : i < 6 ? 0xff8800 : 0xff2200,
        transparent: true,
        opacity: 0.8 - i * 0.08
      });
      const fire = new THREE.Mesh(fireGeo, fireMat);
      fire.position.set(-0.15 - i * 0.12, (Math.random() - 0.5) * 0.15, (Math.random() - 0.5) * 0.15);
      pearGroup.add(fire);
    }

    // Explosive glow layers
    for (let i = 0; i < 3; i++) {
      const glowGeo = new THREE.SphereGeometry(0.45 + i * 0.1, 16, 16);
      const glowMat = new THREE.MeshBasicMaterial({
        color: i === 0 ? 0xffff00 : i === 1 ? 0xffaa00 : 0xff6600,
        transparent: true,
        opacity: 0.3 - i * 0.08
      });
      const glow = new THREE.Mesh(glowGeo, glowMat);
      pearGroup.add(glow);
    }

    // Smoke wisps
    for (let i = 0; i < 4; i++) {
      const smokeGeo = new THREE.SphereGeometry(0.08, 8, 8);
      const smokeMat = new THREE.MeshBasicMaterial({
        color: 0x666666,
        transparent: true,
        opacity: 0.4
      });
      const smoke = new THREE.Mesh(smokeGeo, smokeMat);
      smoke.position.set(-0.3 - i * 0.15, Math.random() * 0.2, (Math.random() - 0.5) * 0.2);
      pearGroup.add(smoke);
    }

    // Position at plant
    pearGroup.position.copy(plant.position);
    pearGroup.position.y = 1.5;
    this.scene.add(pearGroup);

    // Calculate direction to zombie
    const direction = new THREE.Vector3()
      .subVectors(zombie.position, pearGroup.position)
      .normalize();
    const velocity = direction.multiplyScalar(22); // Standard projectile speed

    // Create enhanced muzzle flash and trigger recoil animation
    this.createMuzzleFlash(plant.position);
    this.triggerShootAnimation(plant.position, 'cannon');

    const projectile = new Projectile(
      pearGroup as unknown as THREE.Mesh,
      pearGroup.position,
      velocity,
      300,
      false
    );
    this.projectiles.push(projectile);

    console.log('Pear Launcher auto-fired at zombie!');
  }

  private updateProjectiles(deltaTime: number): void {
    for (let i = this.projectiles.length - 1; i >= 0; i--) {
      const projectile = this.projectiles[i];

      // Move projectile
      projectile.position.add(projectile.velocity.clone().multiplyScalar(deltaTime));
      projectile.mesh.position.copy(projectile.position);

      // Dynamic rotation for all projectiles - spin them dramatically
      projectile.mesh.rotation.x += 0.25;
      projectile.mesh.rotation.y += 0.2;
      projectile.mesh.rotation.z += 0.15;

      // Pulsing scale effect for energy projectiles
      if (projectile.mesh.children && projectile.mesh.children.length > 0) {
        const pulse = 1 + Math.sin(Date.now() * 0.015) * 0.1;
        projectile.mesh.scale.set(pulse, pulse, pulse);
      }

      // Spawn trail particles occasionally
      if (Math.random() < 0.4) {
        const trailGeo = new THREE.SphereGeometry(0.06, 6, 6);
        let trailColor = 0xaa44ff; // Default purple for grapes

        if (projectile.isFrozen) {
          trailColor = 0x88ddff; // Ice blue
        } else if (projectile.isSunGrape) {
          trailColor = 0xffff00; // Golden yellow
        } else if (projectile.damage > 100) {
          trailColor = 0xff8800; // Orange for heavy damage
        }

        const trailMat = new THREE.MeshBasicMaterial({
          color: trailColor,
          transparent: true,
          opacity: 0.7
        });
        const trail = new THREE.Mesh(trailGeo, trailMat);
        trail.position.copy(projectile.position);
        trail.position.x -= 0.1;
        trail.position.y += (Math.random() - 0.5) * 0.15;
        trail.position.z += (Math.random() - 0.5) * 0.15;
        this.scene.add(trail);

        // Fade out trail particle
        let trailOpacity = 0.7;
        const trailInterval = setInterval(() => {
          trailOpacity -= 0.15;
          trail.scale.multiplyScalar(0.85);
          if (trailMat instanceof THREE.MeshBasicMaterial) {
            trailMat.opacity = trailOpacity;
          }
          if (trailOpacity <= 0) {
            this.scene.remove(trail);
            clearInterval(trailInterval);
          }
        }, 40);
      }

      // Check collision with zombies
      let hit = false;
      for (const zombie of this.zombies) {
        const distance = projectile.position.distanceTo(zombie.position);
        if (distance < 1.0) {
          console.log(`💥 Projectile HIT zombie! Distance: ${distance.toFixed(2)}, Damage: ${projectile.damage}, Zombie health before: ${zombie.health}`);
          // Grape crate damage boost: 7.5% per grape crate on field
          let finalDamage = projectile.damage;
          const grapeCrateCount = this.placedPlants.filter(p => p.type === 'grape-crate' && p.health > 0).length;
          if (grapeCrateCount > 0) {
            finalDamage = Math.floor(finalDamage * (1 + 0.075 * grapeCrateCount));
          }

          if (projectile.isAreaDamage) {
            // Area damage
            this.dealAreaDamage(projectile.position, 2, finalDamage);
          } else {
            zombie.health -= finalDamage;
            // Create impact effect
            this.createImpactEffect(projectile.position);
          }
          console.log(`💥 Zombie health after: ${zombie.health}`);

          // Check if it's a sun grape - give sun on hit
          if (projectile.isSunGrape) {
            this.sun += 5;
            const sunAmount = document.getElementById('sun-amount');
            if (sunAmount) {
              sunAmount.textContent = this.sun.toString();
            }
            this.updatePlantSlots();
            console.log('Sun grape hit! +5 sun');
          }

          // Check if it's a frozen grape - apply freeze effect (if not immune)
          if (projectile.isFrozen && !zombie.isFreezeImmune && zombie.freezeImmunityTimer <= 0 && !zombie.frozen) {
            zombie.frozen = true;
            zombie.frozenTimer = 3; // Freeze for 3 seconds
            zombie.speed = zombie.baseSpeed * 0.5; // Slow by 50% from base
            console.log('Frozen grape hit! Zombie slowed!');
          }

          // Check if it's a frostberry - apply slow effect using baseSpeed
          if (projectile.userData && projectile.userData.type === 'frostberry') {
            zombie.speed = zombie.baseSpeed * (1 - projectile.userData.slowAmount);
            setTimeout(() => {
              zombie.speed = zombie.baseSpeed; // Reset to base speed
            }, projectile.userData.slowDuration * 1000);
            console.log('Frostberry hit! Zombie slowed by 50%!');
          }

          // Handle slowChance effect (for frost-spiker and similar plants) using baseSpeed
          if (projectile.userData && projectile.userData.slowChance) {
            if (Math.random() < projectile.userData.slowChance) {
              const slowAmount = projectile.userData.slowAmount || 0.3;
              const slowDuration = projectile.userData.slowDuration || 3000;
              zombie.speed = zombie.baseSpeed * (1 - slowAmount);
              setTimeout(() => {
                zombie.speed = zombie.baseSpeed; // Reset to base speed
              }, slowDuration);
              console.log(`❄️ Slow effect applied! ${slowAmount * 100}% slow for ${slowDuration}ms`);
            }
          }

          // Handle knockback effect (for pickle-spear and similar plants)
          if (projectile.userData && projectile.userData.knockback) {
            const knockbackDist = projectile.userData.knockback;
            zombie.position.x += knockbackDist;
            zombie.mesh.position.x += knockbackDist;
            console.log(`💨 Knockback! Zombie pushed back ${knockbackDist} units`);
          }

          // Handle burn effect from firecracker (Red Fire Flower)
          if (projectile.userData && projectile.userData.isBurn) {
            if (!zombie.userData.burnStacks) {
              zombie.userData.burnStacks = [];
            }
            zombie.userData.burnStacks.push({
              damage: projectile.userData.burnDamage || 5,
              duration: projectile.userData.burnDuration || 5,
              tickTimer: 0
            });
          }

          // Dragon knockback-on-hit behavior
          if (zombie.type === 'blue-dragon' || zombie.type === 'green-dragon' || zombie.type === 'red-dragon') {
            // Knockback: push dragon back 1 tile (2 units)
            zombie.position.x += 2;
            zombie.mesh.position.x += 2;

            // Row shift for blue and red dragons
            if (zombie.type === 'blue-dragon' || zombie.type === 'red-dragon') {
              const rows = [-8, -6, -4, -2, 0];
              const currentRowIndex = rows.findIndex(z => Math.abs(z - zombie.position.z) < 1);
              if (currentRowIndex >= 0) {
                const direction = Math.random() < 0.5 ? -1 : 1;
                const newIndex = Math.max(0, Math.min(rows.length - 1, currentRowIndex + direction));
                zombie.position.z = rows[newIndex];
                zombie.mesh.position.z = rows[newIndex];
              }
            }
          }

          // Handle freezeDuration effect (for frost plants) - check immunity
          if (projectile.userData && projectile.userData.freezeDuration &&
              !zombie.isFreezeImmune && zombie.freezeImmunityTimer <= 0 && !zombie.frozen) {
            zombie.frozen = true;
            zombie.frozenTimer = projectile.userData.freezeDuration;
            zombie.speed = zombie.baseSpeed * 0.3; // Heavy slow while frozen from base

            // Visual freeze effect - add ice particles
            const iceGeo = new THREE.OctahedronGeometry(0.15, 0);
            const iceMat = new THREE.MeshPhongMaterial({
              color: 0x88ddff,
              transparent: true,
              opacity: 0.7,
              emissive: 0x4488ff,
              emissiveIntensity: 0.3
            });
            for (let f = 0; f < 3; f++) {
              const ice = new THREE.Mesh(iceGeo, iceMat);
              ice.position.set(
                zombie.position.x + (Math.random() - 0.5) * 0.5,
                0.5 + Math.random() * 0.8,
                zombie.position.z + (Math.random() - 0.5) * 0.5
              );
              this.scene.add(ice);
              setTimeout(() => this.scene.remove(ice), projectile.userData.freezeDuration * 1000);
            }
            console.log(`🧊 Freeze effect! Frozen for ${projectile.userData.freezeDuration}s`);
          }

          // Handle sunPerKill effect (for lily-gun, frozen-lily, frozen-lilyer)
          if (projectile.userData && projectile.userData.sunPerKill && zombie.health <= 0) {
            this.sun += projectile.userData.sunPerKill;
            const sunAmount = document.getElementById('sun-amount');
            if (sunAmount) {
              sunAmount.textContent = this.sun.toString();
            }
            this.updatePlantSlots();

            // Create sun visual effect
            const sunEffectGeo = new THREE.SphereGeometry(0.3, 12, 12);
            const sunEffectMat = new THREE.MeshBasicMaterial({
              color: 0xffff00,
              transparent: true,
              opacity: 0.9
            });
            const sunEffect = new THREE.Mesh(sunEffectGeo, sunEffectMat);
            sunEffect.position.copy(zombie.position);
            sunEffect.position.y = 1;
            this.scene.add(sunEffect);

            // Animate sun flying up
            let sunY = 1;
            const sunInterval = setInterval(() => {
              sunY += 0.15;
              sunEffect.position.y = sunY;
              sunEffect.scale.multiplyScalar(0.95);
              if (sunEffectMat instanceof THREE.MeshBasicMaterial) {
                sunEffectMat.opacity -= 0.08;
              }
              if (sunY > 3) {
                this.scene.remove(sunEffect);
                clearInterval(sunInterval);
              }
            }, 50);

            console.log(`☀️ Sun on kill! +${projectile.userData.sunPerKill} sun`);
          }

          // Check if it's an acorn - spawn acorn bomb on nearest tile
          if (projectile.userData && projectile.userData.type === 'acorn' && projectile.userData.spawnsBomb) {
            // Find nearest empty tile to zombie position
            const nearestX = Math.round(zombie.position.x / 2) * 2;
            const nearestZ = zombie.position.z;
            const slotKey = `${nearestX},${nearestZ}`;

            // Check if slot is empty
            if (!this.plantSlots.get(slotKey)) {
              // Create acorn bomb at this location
              const bombMesh = this.createPlantMesh('acorn-bomb');
              bombMesh.position.set(nearestX, 0.5, nearestZ);
              this.scene.add(bombMesh);

              const bombPlant = new Plant(bombMesh, 'acorn-bomb', new THREE.Vector3(nearestX, 0.5, nearestZ));
              this.placedPlants.push(bombPlant);
              this.plantSlots.set(slotKey, true);

              console.log(`Acorn planted an Acorn Bomb at (${nearestX}, ${nearestZ})!`);
            }
          }

          // Check if it's a cursed banana - mark zombie to spawn ally on death!
          if (projectile.userData && projectile.userData.type === 'cursed-banana' && projectile.userData.spawnsZombieAlly) {
            // Mark the zombie with curse
            zombie.userData = zombie.userData || {};
            zombie.userData.cursed = true;
            zombie.userData.curseSpawnZ = zombie.position.z;

            // Visual: add green glow to zombie
            zombie.mesh.traverse((child) => {
              if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshPhongMaterial) {
                child.material.emissive.setHex(0x00ff00);
                child.material.emissiveIntensity = 0.5;
              }
            });

            console.log(`🍌💀 Cursed banana marked zombie! Will spawn ally on death!`);
          }

          // Check if it's a sticky bomb - attach to zombie and explode after 3 seconds
          if (projectile.userData && projectile.userData.type === 'sticky-bomb') {
            const stickTime = projectile.userData.stickTime || 3;
            const explosionDamage = projectile.userData.explosionDamage || 230;
            const targetZombie = zombie;

            // Create visual indicator stuck to zombie
            const bombIndicatorGeo = new THREE.SphereGeometry(0.15, 8, 8);
            const bombIndicatorMat = new THREE.MeshBasicMaterial({
              color: 0xff4422,
              transparent: true,
              opacity: 0.9
            });
            const bombIndicator = new THREE.Mesh(bombIndicatorGeo, bombIndicatorMat);
            bombIndicator.position.set(0, 1, 0);
            targetZombie.mesh.add(bombIndicator);

            // Pulsing fuse
            let fuseTime = 0;
            const fuseInterval = setInterval(() => {
              fuseTime += 0.1;
              const pulse = 1 + Math.sin(fuseTime * 10) * 0.3;
              bombIndicator.scale.set(pulse, pulse, pulse);
              // Get brighter as explosion nears
              const intensity = 0.7 + (fuseTime / stickTime) * 0.3;
              if (bombIndicatorMat instanceof THREE.MeshBasicMaterial) {
                bombIndicatorMat.color.setHex(0xff0000 + Math.floor(intensity * 100) * 0x000100);
              }
            }, 50);

            // Schedule explosion
            setTimeout(() => {
              clearInterval(fuseInterval);
              targetZombie.mesh.remove(bombIndicator);

              // Create massive explosion effect
              const explosionGeo = new THREE.SphereGeometry(1.5, 16, 16);
              const explosionMat = new THREE.MeshBasicMaterial({
                color: 0xff6622,
                transparent: true,
                opacity: 0.9
              });
              const explosion = new THREE.Mesh(explosionGeo, explosionMat);
              explosion.position.copy(targetZombie.position);
              explosion.position.y = 1;
              explosion.scale.set(0.2, 0.2, 0.2);
              this.scene.add(explosion);

              // Explosion ring
              const ringGeo = new THREE.TorusGeometry(0.5, 0.15, 8, 32);
              const ringMat = new THREE.MeshBasicMaterial({
                color: 0xffaa00,
                transparent: true,
                opacity: 0.8
              });
              const ring = new THREE.Mesh(ringGeo, ringMat);
              ring.rotation.x = Math.PI / 2;
              ring.position.copy(targetZombie.position);
              ring.position.y = 0.5;
              this.scene.add(ring);

              // Animate explosion
              let expScale = 0.2;
              let expOpacity = 0.9;
              let ringScale = 0.5;
              const expInterval = setInterval(() => {
                expScale += 0.2;
                expOpacity -= 0.08;
                ringScale += 0.4;
                explosion.scale.set(expScale, expScale, expScale);
                ring.scale.set(ringScale, ringScale, 1);
                if (explosionMat instanceof THREE.MeshBasicMaterial) {
                  explosionMat.opacity = expOpacity;
                }
                if (ringMat instanceof THREE.MeshBasicMaterial) {
                  ringMat.opacity = expOpacity * 0.8;
                }
                if (expOpacity <= 0) {
                  this.scene.remove(explosion);
                  this.scene.remove(ring);
                  clearInterval(expInterval);
                }
              }, 30);

              // Deal massive area damage!
              const zombiesInRange = this.zombies.filter(z => {
                return z.position.distanceTo(targetZombie.position) <= 3;
              });

              zombiesInRange.forEach(z => {
                z.health -= explosionDamage;
              });

              console.log(`💣💥 Sticky bomb EXPLODED! Hit ${zombiesInRange.length} zombies for ${explosionDamage} damage each!`);
            }, stickTime * 1000);

            console.log(`🍓💣 Sticky bomb attached to zombie! Exploding in ${stickTime} seconds!`);
          }

          hit = true;
          break;
        }
      }

      // Remove if hit or out of bounds
      if (hit || projectile.position.x > 12 || projectile.position.x < -12) {
        this.scene.remove(projectile.mesh);
        this.projectiles.splice(i, 1);
      }
    }
  }

  private updateZombieProjectiles(deltaTime: number): void {
    for (let i = this.zombieProjectiles.length - 1; i >= 0; i--) {
      const projectile = this.zombieProjectiles[i];

      // Move projectile
      projectile.position.add(projectile.velocity.clone().multiplyScalar(deltaTime));
      projectile.mesh.position.copy(projectile.position);

      // Rotate for visual effect
      projectile.mesh.rotation.x += 0.2;
      projectile.mesh.rotation.y += 0.15;

      // Check collision with plants
      let hit = false;
      for (const plant of this.placedPlants) {
        const distance = projectile.position.distanceTo(plant.position);
        if (distance < 1.0) {
          // Damage the plant
          plant.health -= projectile.damage;
          console.log(`Zombie grape hit ${plant.type}! Damage: ${projectile.damage}`);

          // Apply burn effect from dragon fireballs
          if (projectile.isBurn) {
            plant.burnStacks.push({
              damage: 5,
              duration: 5,
              tickTimer: 0
            });
          }

          // Create impact effect
          this.createImpactEffect(projectile.position);

          hit = true;
          break;
        }
      }

      // Remove if hit or out of bounds
      if (hit || projectile.position.x > 12 || projectile.position.x < -12) {
        this.scene.remove(projectile.mesh);
        this.zombieProjectiles.splice(i, 1);
      }
    }
  }

  private updateAllies(deltaTime: number): void {
    for (let i = this.allies.length - 1; i >= 0; i--) {
      const ally = this.allies[i];

      // Update animation time
      ally.animationTime += deltaTime;

      // Simple walking animation
      ally.mesh.position.y = 0.05 + Math.abs(Math.sin(ally.animationTime * 8)) * 0.08;
      ally.mesh.rotation.z = Math.sin(ally.animationTime * 4) * 0.05;

      // Check if ally is dead
      if (ally.health <= 0) {
        // Release any zombie that was eating this ally
        for (const zombie of this.zombies) {
          if (zombie.targetPlant === null && zombie.isEating) {
            // Check if zombie was eating this ally based on position
            const dist = zombie.position.distanceTo(ally.position);
            if (dist < 1.5) {
              zombie.isEating = false;
            }
          }
        }
        this.scene.remove(ally.mesh);
        this.allies.splice(i, 1);
        console.log(`${ally.type} was defeated!`);
        continue;
      }

      // Check if a zombie is eating this ally (zombie stopped to attack)
      ally.isBeingEaten = false;
      for (const zombie of this.zombies) {
        if (!zombie.frozen) {
          const dist = zombie.position.distanceTo(ally.position);
          // Check if zombie is in same lane and close enough
          const sameLane = Math.abs(zombie.position.z - ally.spawnZ) < 1;
          if (sameLane && dist < 1.0 && zombie.position.x > ally.position.x) {
            // Zombie should eat the ally (ally is blocking zombie's path)
            ally.isBeingEaten = true;
            zombie.isEating = true;
            zombie.targetPlant = null; // Not eating a plant

            // Zombie damages ally
            ally.health -= zombie.attackDamage * deltaTime;
          }
        }
      }

      // Face right (towards zombies - +X direction)
      ally.mesh.rotation.y = Math.PI / 2; // Face towards zombies (+X direction)

      // Always decrement attack cooldown (even while being eaten)
      ally.attackCooldown = Math.max(0, ally.attackCooldown - deltaTime);

      // Find nearest zombie in same lane to attack
      let nearestInLane: Zombie | null = null;
      let nearestDist = Infinity;
      for (const zombie of this.zombies) {
        const sameLane = Math.abs(zombie.position.z - ally.spawnZ) < 1;
        if (sameLane && zombie.health > 0) {
          const dist = Math.abs(zombie.position.x - ally.position.x);
          if (dist < nearestDist) {
            nearestDist = dist;
            nearestInLane = zombie;
          }
        }
      }

      // Sun-fish has 2 tile range (4 units), other allies 1.5 tiles (3 units)
      const attackRange = ally.type === 'sun-fish' ? 4 : 1.5;

      // Attack if close enough and cooldown is ready (can attack while being eaten!)
      if (nearestInLane && nearestDist < attackRange && ally.attackCooldown <= 0) {
        nearestInLane.health -= ally.damage;

        // Create attack effect - golden for sun-fish
        const attackGeo = new THREE.SphereGeometry(0.2, 8, 8);
        const attackColor = ally.type === 'sun-fish' ? 0xffff00 :
                           (ally.type === 'gorilla' || ally.type === 'great-gorilla' ? 0xff4400 :
                           (ally.type === 'baby-yeti' ? 0x88ddff :
                           (ally.type === 'monkey' ? 0xffaa00 : 0x888888)));
        const attackMat = new THREE.MeshBasicMaterial({
          color: attackColor,
          transparent: true,
          opacity: 0.8
        });
        const attackEffect = new THREE.Mesh(attackGeo, attackMat);
        attackEffect.position.copy(nearestInLane.position);
        attackEffect.position.y = 0.5;
        this.scene.add(attackEffect);

        // Animate attack effect
        let attackScale = 0.5;
        let attackOpacity = 0.8;
        const attackInterval = setInterval(() => {
          attackScale += 0.2;
          attackOpacity -= 0.15;
          attackEffect.scale.set(attackScale, attackScale, attackScale);
          if (attackMat instanceof THREE.MeshBasicMaterial) {
            attackMat.opacity = attackOpacity;
          }
          if (attackOpacity <= 0) {
            this.scene.remove(attackEffect);
            clearInterval(attackInterval);
          }
        }, 30);

        console.log(`${ally.type} attacked for ${ally.damage} damage!`);
        // Sun-fish attacks every 0.3 seconds, others every 1.5 seconds
        ally.attackCooldown = ally.type === 'sun-fish' ? 0.3 :
                              ally.type === 'great-gorilla' ? 4.0 :
                              ally.type === 'baby-yeti' ? 1.0 : 1.5;
      }

      // Sun-fish stops when it has a target in range, other allies only stop when being eaten
      const allyHasTarget = nearestInLane && nearestDist < attackRange;

      // If not being eaten and not in attack range, move forward (towards zombies, which is +X direction)
      if (!ally.isBeingEaten && !allyHasTarget) {
        // Always walk forward in the lane (towards +X where zombies spawn)
        ally.position.x += ally.speed * deltaTime;

        // Keep in spawn lane
        ally.position.z = ally.spawnZ;

        ally.mesh.position.x = ally.position.x;
        ally.mesh.position.z = ally.position.z;
      }

      // Keep ally in bounds (remove if walks off right side)
      if (ally.position.x > 12) {
        this.scene.remove(ally.mesh);
        this.allies.splice(i, 1);
        console.log(`${ally.type} walked off the field!`);
        continue;
      }
      ally.mesh.position.x = ally.position.x;
      ally.mesh.position.z = ally.position.z;
    }
  }

  private createImpactEffect(position: THREE.Vector3): void {
    // EPIC explosion effect on impact with multiple layers

    // Inner flash core - bright white
    const coreGeo = new THREE.SphereGeometry(0.4, 16, 16);
    const coreMat = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      opacity: 1.0
    });
    const core = new THREE.Mesh(coreGeo, coreMat);
    core.position.copy(position);
    this.scene.add(core);

    // Main impact ring - orange/yellow
    const impactGeo = new THREE.SphereGeometry(0.6, 20, 20);
    const impactMat = new THREE.MeshBasicMaterial({
      color: 0xffaa00,
      transparent: true,
      opacity: 0.9
    });
    const impact = new THREE.Mesh(impactGeo, impactMat);
    impact.position.copy(position);
    this.scene.add(impact);

    // Outer explosion ring - red/orange
    const outerGeo = new THREE.SphereGeometry(0.8, 20, 20);
    const outerMat = new THREE.MeshBasicMaterial({
      color: 0xff4400,
      transparent: true,
      opacity: 0.7
    });
    const outer = new THREE.Mesh(outerGeo, outerMat);
    outer.position.copy(position);
    this.scene.add(outer);

    // Shockwave ring
    const ringGeo = new THREE.TorusGeometry(0.5, 0.1, 8, 24);
    const ringMat = new THREE.MeshBasicMaterial({
      color: 0xffff00,
      transparent: true,
      opacity: 0.8
    });
    const ring = new THREE.Mesh(ringGeo, ringMat);
    ring.position.copy(position);
    ring.rotation.x = Math.PI / 2;
    this.scene.add(ring);

    // Debris particles flying outward
    const debris: THREE.Mesh[] = [];
    for (let i = 0; i < 12; i++) {
      const debrisGeo = new THREE.OctahedronGeometry(0.08 + Math.random() * 0.06, 0);
      const debrisMat = new THREE.MeshBasicMaterial({
        color: Math.random() > 0.5 ? 0xff6600 : 0xffaa00,
        transparent: true,
        opacity: 1.0
      });
      const d = new THREE.Mesh(debrisGeo, debrisMat);
      d.position.copy(position);
      d.userData.velocity = new THREE.Vector3(
        (Math.random() - 0.5) * 8,
        Math.random() * 6 + 2,
        (Math.random() - 0.5) * 8
      );
      this.scene.add(d);
      debris.push(d);
    }

    // Spark particles
    const sparks: THREE.Mesh[] = [];
    for (let i = 0; i < 8; i++) {
      const sparkGeo = new THREE.SphereGeometry(0.04, 6, 6);
      const sparkMat = new THREE.MeshBasicMaterial({
        color: 0xffff88,
        transparent: true,
        opacity: 1.0
      });
      const spark = new THREE.Mesh(sparkGeo, sparkMat);
      spark.position.copy(position);
      spark.userData.velocity = new THREE.Vector3(
        (Math.random() - 0.5) * 12,
        Math.random() * 4,
        (Math.random() - 0.5) * 12
      );
      this.scene.add(spark);
      sparks.push(spark);
    }

    // Animate everything
    let coreOpacity = 1.0;
    let impactScale = 0.6;
    let outerScale = 0.8;
    let ringScale = 0.5;
    let impactOpacity = 0.9;
    let outerOpacity = 0.7;
    let ringOpacity = 0.8;
    let frame = 0;

    const impactInterval = setInterval(() => {
      frame++;

      // Core shrinks and fades fast
      coreOpacity -= 0.2;
      core.scale.set(1 - frame * 0.15, 1 - frame * 0.15, 1 - frame * 0.15);
      if (coreMat instanceof THREE.MeshBasicMaterial) {
        coreMat.opacity = Math.max(0, coreOpacity);
      }

      // Main impact expands
      impactScale += 0.4;
      impactOpacity -= 0.12;
      impact.scale.set(impactScale, impactScale, impactScale);
      if (impactMat instanceof THREE.MeshBasicMaterial) {
        impactMat.opacity = Math.max(0, impactOpacity);
      }

      // Outer ring expands faster
      outerScale += 0.5;
      outerOpacity -= 0.1;
      outer.scale.set(outerScale, outerScale, outerScale);
      if (outerMat instanceof THREE.MeshBasicMaterial) {
        outerMat.opacity = Math.max(0, outerOpacity);
      }

      // Shockwave ring expands outward
      ringScale += 0.6;
      ringOpacity -= 0.12;
      ring.scale.set(ringScale, ringScale * 0.3, ringScale);
      if (ringMat instanceof THREE.MeshBasicMaterial) {
        ringMat.opacity = Math.max(0, ringOpacity);
      }

      // Update debris
      debris.forEach((d, i) => {
        if (d.userData.velocity) {
          d.position.add(d.userData.velocity.clone().multiplyScalar(0.04));
          d.userData.velocity.y -= 0.3; // Gravity
          d.rotation.x += 0.3;
          d.rotation.y += 0.2;
          const mat = d.material as THREE.MeshBasicMaterial;
          mat.opacity -= 0.08;
          if (mat.opacity <= 0) {
            this.scene.remove(d);
          }
        }
      });

      // Update sparks
      sparks.forEach(spark => {
        if (spark.userData.velocity) {
          spark.position.add(spark.userData.velocity.clone().multiplyScalar(0.03));
          const mat = spark.material as THREE.MeshBasicMaterial;
          mat.opacity -= 0.1;
          if (mat.opacity <= 0) {
            this.scene.remove(spark);
          }
        }
      });

      if (frame >= 10) {
        this.scene.remove(core);
        this.scene.remove(impact);
        this.scene.remove(outer);
        this.scene.remove(ring);
        debris.forEach(d => this.scene.remove(d));
        sparks.forEach(s => this.scene.remove(s));
        clearInterval(impactInterval);
      }
    }, 35);
  }

  private dealAreaDamage(center: THREE.Vector3, radius: number, damage: number): void {
    for (const zombie of this.zombies) {
      const distance = zombie.position.distanceTo(center);
      if (distance <= radius) {
        zombie.health -= damage;
      }
    }
  }

  // ============================================
  // FALLING SUN SYSTEM
  // ============================================
  private createSunMesh(): THREE.Group {
    const sunGroup = new THREE.Group();

    // Main sun sphere
    const sunGeo = new THREE.SphereGeometry(0.35, 16, 16);
    const sunMat = new THREE.MeshPhongMaterial({
      color: 0xffdd00,
      emissive: 0xffaa00,
      emissiveIntensity: 0.6,
      shininess: 100
    });
    const sun = new THREE.Mesh(sunGeo, sunMat);
    sunGroup.add(sun);

    // Sun rays
    for (let i = 0; i < 8; i++) {
      const rayGeo = new THREE.ConeGeometry(0.08, 0.25, 4);
      const rayMat = new THREE.MeshPhongMaterial({
        color: 0xffee44,
        emissive: 0xffcc00,
        emissiveIntensity: 0.5
      });
      const ray = new THREE.Mesh(rayGeo, rayMat);
      const angle = (i / 8) * Math.PI * 2;
      ray.position.set(Math.cos(angle) * 0.4, 0, Math.sin(angle) * 0.4);
      ray.rotation.z = -Math.PI / 2 + angle;
      ray.rotation.order = 'ZYX';
      ray.lookAt(0, 0, 0);
      ray.rotateX(Math.PI / 2);
      sunGroup.add(ray);
    }

    // Glow effect
    const glowGeo = new THREE.SphereGeometry(0.5, 16, 16);
    const glowMat = new THREE.MeshBasicMaterial({
      color: 0xffff66,
      transparent: true,
      opacity: 0.3
    });
    const glow = new THREE.Mesh(glowGeo, glowMat);
    sunGroup.add(glow);

    return sunGroup;
  }

  private spawnFallingSun(x?: number, z?: number, fromLily: boolean = false): void {
    const sunMesh = this.createSunMesh();

    // Random position within play area if not specified
    const sunX = x !== undefined ? x : -8 + Math.random() * 16;
    const sunZ = z !== undefined ? z : -8 + Math.random() * 8;

    // Start from above and fall to ground level
    const startY = fromLily ? 1.5 : 12;
    const targetY = 0.5;

    sunMesh.position.set(sunX, startY, sunZ);
    sunMesh.userData.clickable = true;
    this.scene.add(sunMesh);

    this.fallingSuns.push({
      mesh: sunMesh,
      targetY: targetY,
      value: 25,
      collected: false
    });
  }

  private spawnBigSun(x: number, z: number): void {
    // BIG SUN - worth 100 sun, larger and golden
    const sunGroup = new THREE.Group();

    // Large golden sun core
    const coreGeo = new THREE.SphereGeometry(0.5, 20, 20);
    const coreMat = new THREE.MeshPhongMaterial({
      color: 0xffcc00,
      emissive: 0xffaa00,
      emissiveIntensity: 0.9,
      shininess: 100
    });
    const core = new THREE.Mesh(coreGeo, coreMat);
    sunGroup.add(core);

    // Larger glowing outer layer
    const glowGeo = new THREE.SphereGeometry(0.6, 16, 16);
    const glowMat = new THREE.MeshBasicMaterial({
      color: 0xffdd44,
      transparent: true,
      opacity: 0.4
    });
    const glow = new THREE.Mesh(glowGeo, glowMat);
    sunGroup.add(glow);

    // Sun rays
    for (let i = 0; i < 10; i++) {
      const rayGeo = new THREE.ConeGeometry(0.1, 0.35, 6);
      const rayMat = new THREE.MeshPhongMaterial({
        color: 0xffdd00,
        emissive: 0xffaa00,
        emissiveIntensity: 0.7
      });
      const ray = new THREE.Mesh(rayGeo, rayMat);
      const angle = (i / 10) * Math.PI * 2;
      ray.position.set(Math.cos(angle) * 0.55, Math.sin(angle) * 0.55, 0);
      ray.rotation.z = angle - Math.PI / 2;
      sunGroup.add(ray);
    }

    sunGroup.position.set(x, 1.5, z);
    sunGroup.userData.clickable = true;
    this.scene.add(sunGroup);

    this.fallingSuns.push({
      mesh: sunGroup,
      targetY: 0.6,
      value: 100, // Big sun worth 100!
      collected: false
    });
  }

  private spawnBlueSun(x: number, z: number): void {
    // BLUE SUN - worth 300 sun, magical blue diamond
    const sunGroup = new THREE.Group();

    // Blue diamond core
    const coreGeo = new THREE.OctahedronGeometry(0.45, 1);
    const coreMat = new THREE.MeshPhongMaterial({
      color: 0x44aaff,
      emissive: 0x2288ff,
      emissiveIntensity: 1.0,
      shininess: 200,
      specular: 0xffffff
    });
    const core = new THREE.Mesh(coreGeo, coreMat);
    sunGroup.add(core);

    // Magical glow
    const glowGeo = new THREE.SphereGeometry(0.6, 16, 16);
    const glowMat = new THREE.MeshBasicMaterial({
      color: 0x66ccff,
      transparent: true,
      opacity: 0.35
    });
    const glow = new THREE.Mesh(glowGeo, glowMat);
    sunGroup.add(glow);

    // Sparkle particles orbiting
    for (let i = 0; i < 8; i++) {
      const sparkleGeo = new THREE.OctahedronGeometry(0.08, 0);
      const sparkleMat = new THREE.MeshBasicMaterial({
        color: 0xaaddff,
        transparent: true,
        opacity: 0.8
      });
      const sparkle = new THREE.Mesh(sparkleGeo, sparkleMat);
      const angle = (i / 8) * Math.PI * 2;
      sparkle.position.set(Math.cos(angle) * 0.5, Math.sin(angle) * 0.3, Math.sin(angle) * 0.5);
      sunGroup.add(sparkle);
    }

    // Inner glow ring
    const ringGeo = new THREE.TorusGeometry(0.35, 0.05, 8, 24);
    const ringMat = new THREE.MeshBasicMaterial({
      color: 0x88ddff,
      transparent: true,
      opacity: 0.6
    });
    const ring = new THREE.Mesh(ringGeo, ringMat);
    ring.rotation.x = Math.PI / 2;
    sunGroup.add(ring);

    sunGroup.position.set(x, 1.8, z);
    sunGroup.userData.clickable = true;
    this.scene.add(sunGroup);

    this.fallingSuns.push({
      mesh: sunGroup,
      targetY: 0.7,
      value: 300, // Blue sun worth 300!
      collected: false
    });
  }

  private updateFallingSuns(deltaTime: number): void {
    // Spawn falling sun every 10 seconds when wave is active
    if (this.waveStarted) {
      this.fallingSunTimer += deltaTime;
      if (this.fallingSunTimer >= 10) {
        this.spawnFallingSun();
        this.fallingSunTimer = 0;
      }
    }

    // Update existing suns
    for (let i = this.fallingSuns.length - 1; i >= 0; i--) {
      const sun = this.fallingSuns[i];

      if (sun.collected) {
        // Animate collection (shrink and rise)
        sun.mesh.scale.multiplyScalar(0.9);
        sun.mesh.position.y += deltaTime * 3;
        if (sun.mesh.scale.x < 0.1) {
          this.scene.remove(sun.mesh);
          this.fallingSuns.splice(i, 1);
        }
      } else {
        // Fall down
        if (sun.mesh.position.y > sun.targetY) {
          sun.mesh.position.y -= deltaTime * 3;
          if (sun.mesh.position.y < sun.targetY) {
            sun.mesh.position.y = sun.targetY;
          }
        }

        // Gentle bobbing and rotation when landed
        if (sun.mesh.position.y <= sun.targetY + 0.1) {
          sun.mesh.position.y = sun.targetY + Math.sin(Date.now() * 0.003) * 0.1;
          sun.mesh.rotation.y += deltaTime * 2;
        }

        // Auto-disappear after 15 seconds on ground
        if (!sun.mesh.userData.spawnTime) {
          sun.mesh.userData.spawnTime = Date.now();
        }
        if (Date.now() - sun.mesh.userData.spawnTime > 15000) {
          this.scene.remove(sun.mesh);
          this.fallingSuns.splice(i, 1);
        }
      }
    }
  }

  private collectSun(sun: { mesh: THREE.Group, targetY: number, value: number, collected: boolean }): void {
    if (sun.collected) return;

    sun.collected = true;
    this.sun += sun.value;
    const sunAmount = document.getElementById('sun-amount');
    if (sunAmount) {
      sunAmount.textContent = this.sun.toString();
    }
    this.updatePlantSlots();
  }

  private checkSunClick(event: MouseEvent): boolean {
    const rect = this.renderer.domElement.getBoundingClientRect();
    const mouse = new THREE.Vector2(
      ((event.clientX - rect.left) / rect.width) * 2 - 1,
      -((event.clientY - rect.top) / rect.height) * 2 + 1
    );

    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, this.camera);

    for (const sun of this.fallingSuns) {
      if (sun.collected) continue;

      const intersects = raycaster.intersectObject(sun.mesh, true);
      if (intersects.length > 0) {
        this.collectSun(sun);
        return true;
      }
    }
    return false;
  }
}

// Plant types
export type PlantType = 'grape-launcher' | 'vine-wall' | 'pear-cannon' | 'frost-berri' | 'lily' | 'avocado-slammer' | 'pickle-picker' | 'grape-wall' | 'grape-lily' | 'pear-launcher' | 'pear-wall' | 'frost-slammer' | 'frost-pear-wall' | 'tomato-spike' | 'strawberry-launcher' | 'pickle-spiker' | 'grape-shot' | 'grape-gun' | 'star-launcher' | 'pear-spiker' | 'seed-batch' | 'strawbomber' | 'frovine-slammer' | 'pear-nuker' | 'frost-grape-gun' | 'elder-frost-berri' | 'straw-spiker' | 'elder-tomato-spike' | 'rose-reaper' | 'mushroom-bomber' | 'vined-wall' | 'frostberry-launcher' | 'reaper-peall' | 'acorn-tree' | 'acorn-bomb' | 'banana-peel' | 'lilyer' | 'lilyest' | 'frost-peel' | 'frost-grape-launcher' | 'strawberry-tree' | 'frozen-mushroom-bomber' | 'sunberry-launcher' | 'lily-wall' | 'black-hole-coconut' | 'banana-launcher' | 'lily-reaper' | 'frozen-overlord-mushroom' | 'lily-peel' | 'vine-slammer' | 'grape-spiker' | 'grape-gun-wall' | 'lily-gun' | 'pickle-spear' | 'frost-spiker' | 'banana-leach' | 'lily-cannon' | 'frost-vine-wall' | 'frozen-supernova-coconut' | 'spike-wall' | 'acorn-nest' | 'frozen-lily' | 'frozen-lilyer' | 'acorn-wall' | 'frost-overlord-grape-gun' | 'thornbomber' | 'titan-reaper-peall' | 'frozen-nebula-mushroom' | 'grape-frospike' | 'frospike' | 'roots' | 'onion-flier' | 'pineapple-crate' | 'kiwi-blocker' | 'eggplant-stunner' | 'iron-grape-launcher' | 'banana-tree' | 'onion-freezer' | 'rooted-grape-launcher' | 'vined-grape-wall' | 'grape-crate' | 'eggplant-cannon' | 'kiwi-slammer' | 'iron-grape-shot' | 'strawberry-pear-launcher' | 'frozen-pickle-spear' | 'mushroom-healer' | 'grape-pulser' | 'overgrown-vine-wall' | 'great-god-lily' | 'red-fire-flower' | 'red-firecracker-flower' | 'red-firespiker-flower';

export type PowerPlantType = 'grape-pulser' | 'overgrown-vine-wall' | 'great-god-lily';

interface PowerPlantAbility {
  name: string;
  key: string;
  cooldown: number;
  description: string;
}

interface PowerPlantConfig {
  type: PowerPlantType;
  name: string;
  emoji: string;
  hp: number;
  passive: string;
  ability1: PowerPlantAbility;
  ability2: PowerPlantAbility;
}

const POWER_PLANT_INFO: Record<PowerPlantType, PowerPlantConfig> = {
  'grape-pulser': {
    type: 'grape-pulser', name: 'Grape Pulser', emoji: '🍇⚡', hp: 200,
    passive: '+10% damage to all grape-type plants',
    ability1: { name: 'Electric Grape', key: 'Q', cooldown: 7, description: '50 damage electric grape' },
    ability2: { name: 'Mega Electric Grape', key: 'T', cooldown: 40, description: '500 damage mega electric grape' },
  },
  'overgrown-vine-wall': {
    type: 'overgrown-vine-wall', name: 'Overgrown Vine Wall', emoji: '🌿🌿🌿', hp: 2000,
    passive: 'None',
    ability1: { name: 'Area Heal', key: 'Q', cooldown: 15, description: 'Heal plants in 3x3 area by 50 HP' },
    ability2: { name: 'Global Heal', key: 'T', cooldown: 20, description: 'Heal all plants 10 HP, 5 dmg to all zombies' },
  },
  'great-god-lily': {
    type: 'great-god-lily', name: 'Great God Lily', emoji: '🌸👑', hp: 200,
    passive: 'None',
    ability1: { name: 'Sun Burst', key: 'Q', cooldown: 15, description: 'Give 200 sun' },
    ability2: { name: 'Sun Storm', key: 'T', cooldown: 30, description: 'Give 500 sun' },
  },
};

export interface PlantData {
  type: PlantType;
  name: string;
  cost: number;
  description: string;
}

class Plant {
  mesh: THREE.Group;
  type: PlantType;
  position: THREE.Vector3;
  cooldown: number = 0;
  sunProductionTimer: number = 0;
  isTitan: boolean = false;
  health: number = 100;
  maxHealth: number = 100;
  animationTime: number = 0;
  antiCrush: boolean = false;
  turretParts: THREE.Group[] = []; // For storing rotatable turret/barrel parts
  // Burst fire properties
  burstCount: number = 0; // How many shots left in current burst
  burstDelay: number = 0; // Time until next shot in burst
  burstTarget: THREE.Vector3 | null = null; // Target position for burst
  // Custom data storage for special plant behaviors
  userData: Record<string, any> = {};
  // Fire zombie burning effect: each stack deals 5 damage every 2s for 5s
  burnStacks: { damage: number; duration: number; tickTimer: number }[] = [];
  // Pineapple Crate bunker system - protects plants underneath
  pineappleBunker: { health: number; maxHealth: number; mesh: THREE.Group } | null = null;

  constructor(mesh: THREE.Group, type: PlantType, position: THREE.Vector3) {
    this.mesh = mesh;
    this.type = type;
    this.position = position;

    // Set health based on plant type
    if (type === 'vine-wall') {
      this.health = 200;
      this.maxHealth = 200;
    } else if (type === 'grape-wall') {
      // Fusion plant has combined health
      this.health = 250;
      this.maxHealth = 250;
    } else if (type === 'pear-wall') {
      // Fusion plant: explosive defensive wall
      this.health = 275;
      this.maxHealth = 275;
    } else if (type === 'frost-slammer') {
      // Fusion plant: offensive slam plant
      this.health = 150;
      this.maxHealth = 150;
    } else if (type === 'frost-berri') {
      // Frost plant that freezes zombies
      this.health = 120;
      this.maxHealth = 120;
    } else if (type === 'elder-frost-berri') {
      // Elder Frost Berri - upgraded version with longer freeze
      this.health = 150;
      this.maxHealth = 150;
    } else if (type === 'frost-pear-wall') {
      // Fusion plant: frozen explosive wall with 3x HP
      this.health = 600;
      this.maxHealth = 600;
    } else if (type === 'strawberry-launcher') {
      // Fast shooting plant with low damage
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'strawbomber') {
      // TITAN: Strawberry bomb launcher
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'frovine-slammer') {
      // TITAN: Icy vine slammer
      this.health = 400;
      this.maxHealth = 400;
    } else if (type === 'pear-nuker') {
      // TITAN: Pear nuke launcher
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'vined-wall') {
      // Double vine wall fusion - extra tanky
      this.health = 450;
      this.maxHealth = 450;
    } else if (type === 'frostberry-launcher') {
      // Fusion: Fast frost shooter
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'reaper-peall') {
      // ODD FUSION: Defensive wall that counter-attacks with skulls
      this.health = 700;
      this.maxHealth = 700;
    } else if (type === 'acorn-tree') {
      // SHOP PLANT: Shoots acorns that plant acorn bombs
      this.health = 120;
      this.maxHealth = 120;
    } else if (type === 'acorn-bomb') {
      // Explodes when destroyed
      this.health = 50;
      this.maxHealth = 50;
    } else if (type === 'banana-peel') {
      // SHOP PLANT: Summons animal allies
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'frost-peel') {
      // FUSION: Banana Peel + Frost Berri - Summons icy allies
      this.health = 150;
      this.maxHealth = 150;
    } else if (type === 'frost-grape-launcher') {
      // FUSION: Grape Launcher + Frost Berri - Frozen grape shooter
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'strawberry-tree') {
      // FUSION: Acorn Tree + Strawberry Launcher - Sticky acorn shooter
      this.health = 130;
      this.maxHealth = 130;
    } else if (type === 'frozen-mushroom-bomber') {
      // FUSION: Mushroom Bomber + Frost Berri - Icy toxic clouds
      this.health = 120;
      this.maxHealth = 120;
    } else if (type === 'sunberry-launcher') {
      // FUSION: Lily + Strawberry Launcher - Sun-giving shooter
      this.health = 90;
      this.maxHealth = 90;
    } else if (type === 'lily-wall') {
      // FUSION: Lily + Vine Wall - Sun-producing wall
      this.health = 250;
      this.maxHealth = 250;
    } else if (type === 'black-hole-coconut') {
      // SHOP PLANT: Cosmic coconut with gravity pull
      this.health = 200;
      this.maxHealth = 200;
    } else if (type === 'lily-reaper') {
      // FUSION: Lily + Rose Reaper - Click to heal plant in front
      this.health = 150;
      this.maxHealth = 150;
    } else if (type === 'frozen-overlord-mushroom') {
      // ODD FUSION: Frozen Mushroom Bomber + Elder Frost Berri - Ultimate ice devastation
      this.health = 180;
      this.maxHealth = 180;
    } else if (type === 'vine-slammer') {
      // FUSION: Avocado Slammer + Vine Wall - Melee wall with 2 tile range
      this.health = 350;
      this.maxHealth = 350;
    } else if (type === 'grape-spiker') {
      // FUSION: Grape Launcher + Tomato Spike - Spike shooter
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'grape-gun-wall') {
      // FUSION: Grape Gun + Vine Wall - Wall that shoots 3 grapes
      this.health = 450;
      this.maxHealth = 450;
    } else if (type === 'lily-gun') {
      // FUSION: Grape Lily + Grape Shot - Shoots sun grapes, click ability
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'pickle-spear') {
      // FUSION: Pickle Spiker + Pear Cannon - Massive knockback spear
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'frost-spiker') {
      // FUSION: Frostberry Launcher + Tomato Spike - Ultra rapid frost shooter
      this.health = 75;
      this.maxHealth = 75;
    } else if (type === 'banana-leach') {
      // FUSION: Banana Peel + Rose Reaper - Summons leach allies
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'lily-cannon') {
      // FUSION: Lily + Pear Cannon - Chargeable sun cannon
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'frost-vine-wall') {
      // FUSION: Frost Berri + Vine Wall - Freezing wall
      this.health = 350;
      this.maxHealth = 350;
    } else if (type === 'frozen-supernova-coconut') {
      // FUSION: Frost Berri + Black Hole Coconut - Instant use explosive
      this.health = 1;
      this.maxHealth = 1;
    } else if (type === 'spike-wall') {
      // FUSION: Vine Wall + Tomato Spike - Damaging wall
      this.health = 400;
      this.maxHealth = 400;
    } else if (type === 'acorn-nest') {
      // FUSION: Acorn Tree + Banana Peel - Squirrel summoner
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'frozen-lily') {
      // FUSION: Frost Berri + Lily - Ice ball shooter
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'frozen-lilyer') {
      // FUSION: Frozen Lily + Lily - Enhanced ice shooter
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'acorn-wall') {
      // FUSION: Acorn Tree + Vine Wall - Auto bomb placer
      this.health = 300;
      this.maxHealth = 300;
    } else if (type === 'frost-overlord-grape-gun') {
      // 2ND FORM: Frost Grape Gun 2nd - Freezing grape gun
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'thornbomber') {
      // 2ND FORM: StrawSpiker 2nd - Ram + bombs
      this.health = 150;
      this.maxHealth = 150;
      this.isTitan = true; // 2 tiles
    } else if (type === 'titan-reaper-peall') {
      // 2ND FORM: Reaper Peall 2nd - Massive freezing wall
      this.health = 1000;
      this.maxHealth = 1000;
      this.isTitan = true; // 2 tiles
    } else if (type === 'frozen-nebula-mushroom') {
      // 2ND FORM: Frozen Overlord Mushroom 2nd - Pull + damage
      this.health = 200;
      this.maxHealth = 200;
    } else if (type === 'pineapple-crate') {
      // SHOP PLANT: Protective bunker crate - 800 HP (400 * 2)
      this.health = 400;
      this.maxHealth = 400;
    } else if (type === 'onion-flier') {
      // SHOP PLANT: Flying bomber
      this.health = 150;
      this.maxHealth = 150;
    } else if (type === 'roots') {
      // SHOP PLANT: Underground trap
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'kiwi-blocker') {
      // GOLD CRATE: Heavy defensive blocker - tanks damage for nearby plants (1000 base * 2x global = 2000)
      this.health = 1000;
      this.maxHealth = 1000;
    } else if (type === 'eggplant-stunner') {
      // GOLD CRATE: Stun beam plant
      this.health = 150;
      this.maxHealth = 150;
    } else if (type === 'iron-grape-launcher') {
      // GOLD CRATE: Armored grape launcher (400 * 2x = 800 HP)
      this.health = 400;
      this.maxHealth = 400;
    } else if (type === 'banana-tree') {
      // GOLD CRATE: Legendary summoner
      this.health = 200;
      this.maxHealth = 200;
    } else if (type === 'onion-freezer') {
      // Fusion: Onion Flier + Frost Berri - Ice bomber
      this.health = 150;
      this.maxHealth = 150;
    } else if (type === 'rooted-grape-launcher') {
      // Fusion: Roots + Grape Launcher - Shoots + stuns on eat
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'vined-grape-wall') {
      // Fusion: Vined Wall + Grape Launcher - Tanky shooter
      this.health = 1800;
      this.maxHealth = 1800;
    } else if (type === 'grape-crate') {
      // Fusion: Pineapple Crate + Grape Launcher - Grape buffer (625 * 2x global = 1250)
      this.health = 625;
      this.maxHealth = 625;
    } else if (type === 'eggplant-cannon') {
      // Fusion: Eggplant Stunner + Pear Cannon - Click to stun random zombie (100 * 2x = 200 HP)
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'kiwi-slammer') {
      // Fusion: Kiwi Blocker + Avocado Slammer - HP-cost slammer (1500 * 2x = 3000 HP)
      this.health = 1500;
      this.maxHealth = 1500;
    } else if (type === 'iron-grape-shot') {
      // Fusion: Iron Grape Launcher + Iron Grape Launcher - Dual iron grape shot (450 * 2x = 900 HP)
      this.health = 450;
      this.maxHealth = 450;
    } else if (type === 'strawberry-pear-launcher') {
      // Fusion: Pear Cannon + Strawberry Launcher - Burst shooter with click rapid-fire (100 * 2x = 200 HP)
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'frozen-pickle-spear') {
      // Fusion: Pickle Spiker + Frost Berri - Frozen spear launcher (100 * 2x = 200 HP)
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'mushroom-healer') {
      // Fusion: Mushroom Bomber + Rose Reaper - Area healer (150 * 2x = 300 HP)
      this.health = 150;
      this.maxHealth = 150;
    } else if (type === 'grape-pulser') {
      // Power plant: Electric grape attacker (100 * 2x = 200 HP)
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'overgrown-vine-wall') {
      // Power plant: Healing wall (1000 * 2x = 2000 HP)
      this.health = 1000;
      this.maxHealth = 1000;
    } else if (type === 'great-god-lily') {
      // Power plant: Sun generator (100 * 2x = 200 HP)
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'red-fire-flower') {
      // Dragon Battle reward: Red firecracker shooter (100 * 2x = 200 HP)
      this.health = 100;
      this.maxHealth = 100;
    } else if (type === 'red-firecracker-flower') {
      // Fusion: Red Fire Flower + Red Fire Flower - double firecracker shooter (150 * 2x = 300 HP)
      this.health = 150;
      this.maxHealth = 150;
    } else if (type === 'red-firespiker-flower') {
      // Fusion: Red Firecracker Flower + Tomato Spike - triple firecracker with heavy burn (175 * 2x = 350 HP)
      this.health = 175;
      this.maxHealth = 175;
    }

    // Apply 2X HP multiplier to all plants for better survivability
    this.health *= 2;
    this.maxHealth *= 2;

    // Apply additional 2X HP multiplier to WALL plants specifically
    const wallTypes: PlantType[] = [
      'vine-wall', 'grape-wall', 'pear-wall', 'frost-pear-wall', 'vined-wall',
      'lily-wall', 'grape-gun-wall', 'frost-vine-wall', 'spike-wall', 'acorn-wall',
      'reaper-peall', 'titan-reaper-peall', 'vined-grape-wall'
    ];
    if (wallTypes.includes(type)) {
      this.health *= 2;
      this.maxHealth *= 2;
    }

    // Set anti-crush for wall plants and heavy plants
    if (type === 'vine-wall' || type === 'grape-wall' || type === 'pear-wall' ||
        type === 'frost-pear-wall' || type === 'avocado-slammer' || type === 'frost-slammer' ||
        type === 'frovine-slammer' || type === 'vined-wall' || type === 'reaper-peall' ||
        type === 'lily-wall' || type === 'vine-slammer' || type === 'grape-gun-wall' ||
        type === 'frost-vine-wall' || type === 'spike-wall' || type === 'acorn-wall' ||
        type === 'titan-reaper-peall' || type === 'kiwi-blocker' ||
        type === 'vined-grape-wall' || type === 'grape-crate') {
      this.antiCrush = true;
    }
  }
}

type ZombieType = 'normal' | 'fast' | 'tank' | 'tiny' | 'grape' | 'car' | 'grave' | 'grape-gun' | 'healer' | 'super-car' | 'frost-grape-gun' | 'fire' | 'fat' | 'blue-dragon' | 'green-dragon' | 'red-dragon';

class Zombie {
  mesh: THREE.Group;
  position: THREE.Vector3;
  health: number = 100;
  maxHealth: number = 100;
  speed: number = 1;
  baseSpeed: number = 1; // Original speed - for preventing speed debuff stacking
  frozen: boolean = false;
  frozenTimer: number = 0;
  freezeImmunityTimer: number = 0; // 2 second immunity after unfreezing
  rooted: boolean = false; // Held by roots
  rootedTimer: number = 0;
  isFreezeImmune: boolean = false; // Permanent freeze immunity (bosses, fire zombie)
  isEating: boolean = false;
  targetPlant: Plant | null = null;
  attackCooldown: number = 0;
  walkCycle: number = 0;
  leftArm: THREE.Group | THREE.Mesh | null = null;
  rightArm: THREE.Group | THREE.Mesh | null = null;
  leftLeg: THREE.Mesh | null = null;
  rightLeg: THREE.Mesh | null = null;
  type: ZombieType;
  attackDamage: number = 120;
  shootCooldown: number = 0; // For grape zombie
  summonCooldown: number = 0; // For grave zombie
  hasSummoned: boolean = false; // For grave zombie - only summon once in first 2 seconds
  age: number = 0; // Track how long zombie has been alive
  lastBounceTime: number = 0; // For car zombie bounce cooldown
  healCooldown: number = 0; // For healer zombie
  userData: { cursed?: boolean; curseSpawnZ?: number; explodeTimer?: number; burnStacks?: { damage: number; duration: number; tickTimer: number }[]; burnEffect?: THREE.Mesh | null } = {}; // For curse effects and fat zombie explosion

  constructor(mesh: THREE.Group, position: THREE.Vector3, type: ZombieType = 'normal') {
    this.mesh = mesh;
    this.position = position;
    this.type = type;

    // Set stats based on type - zombie HP at 1.5x
    switch (type) {
      case 'fast':
        this.health = 135;
        this.maxHealth = 135;
        this.speed = 2.7; // Fast zombie
        this.attackDamage = 120;
        break;
      case 'tank':
        this.health = 675;
        this.maxHealth = 675;
        this.speed = 0.75; // Slow tank
        this.attackDamage = 120;
        break;
      case 'tiny':
        this.health = 90;
        this.maxHealth = 90;
        this.speed = 2.1; // Quick little zombie
        this.attackDamage = 120;
        break;
      case 'grape':
        this.health = 180;
        this.maxHealth = 180;
        this.speed = 1.2;
        this.attackDamage = 0;
        this.shootCooldown = 0;
        break;
      case 'car':
        this.health = 6750;
        this.maxHealth = 6750;
        this.speed = 0.6;
        this.attackDamage = 9999;
        break;
      case 'grave':
        this.health = 300;
        this.maxHealth = 300;
        this.speed = 0.9;
        this.attackDamage = 120;
        this.summonCooldown = 0;
        break;
      case 'grape-gun':
        this.health = 2250;
        this.maxHealth = 2250;
        this.speed = 0.75;
        this.attackDamage = 0;
        this.shootCooldown = 0;
        break;
      case 'healer':
        this.health = 1800;
        this.maxHealth = 1800;
        this.speed = 0.75;
        this.attackDamage = 120;
        this.healCooldown = 0;
        break;
      case 'super-car':
        this.health = 11250;
        this.maxHealth = 11250;
        this.speed = 1.2;
        this.attackDamage = 9999;
        break;
      case 'frost-grape-gun':
        this.health = 4500;
        this.maxHealth = 4500;
        this.speed = 0.6;
        this.attackDamage = 0;
        this.shootCooldown = 0;
        break;
      case 'fire':
        this.health = 225;
        this.maxHealth = 225;
        this.speed = 1.35;
        this.attackDamage = 120;
        break;
      case 'fat':
        this.health = 300;
        this.maxHealth = 300;
        this.speed = 0.9;
        this.attackDamage = 120;
        break;
      case 'blue-dragon':
        this.health = 5000;
        this.maxHealth = 5000;
        this.speed = 1.2;
        this.attackDamage = 800;
        this.isFreezeImmune = true;
        break;
      case 'green-dragon':
        this.health = 7500;
        this.maxHealth = 7500;
        this.speed = 1.2;
        this.attackDamage = 800;
        this.shootCooldown = 0;
        this.isFreezeImmune = true;
        break;
      case 'red-dragon':
        this.health = 15000;
        this.maxHealth = 15000;
        this.speed = 2.4;
        this.attackDamage = 800;
        this.shootCooldown = 0;
        this.isFreezeImmune = true;
        break;
      default:
        this.health = 225;
        this.maxHealth = 225;
        this.speed = 1.2; // Normal zombie
        this.attackDamage = 120;
    }

    // Store base speed for preventing speed debuff stacking
    this.baseSpeed = this.speed;

    // Set freeze immunity for bosses and fire zombie
    if (type === 'fire' || type === 'super-car' || type === 'frost-grape-gun' || type === 'car') {
      this.isFreezeImmune = true;
    }

    // Store references to limbs for animation
    // First check userData where arm/leg groups are stored in createZombieMesh
    if (mesh.userData.leftArm) {
      this.leftArm = mesh.userData.leftArm;
    }
    if (mesh.userData.rightArm) {
      this.rightArm = mesh.userData.rightArm;
    }
    if (mesh.userData.leftLeg) {
      this.leftLeg = mesh.userData.leftLeg;
    }
    if (mesh.userData.rightLeg) {
      this.rightLeg = mesh.userData.rightLeg;
    }

    // Find legs and any mesh-based arms from children (fallback)
    mesh.children.forEach(child => {
      if (child instanceof THREE.Mesh) {
        // Only set arms if not already found in userData
        if (!this.leftArm && child.position.x < -0.4 && child.position.y > 0.5) {
          this.leftArm = child;
        } else if (!this.rightArm && child.position.x > 0.4 && child.position.y > 0.5) {
          this.rightArm = child;
        } else if (!this.leftLeg && child.position.x < 0 && child.position.y < 0) {
          this.leftLeg = child;
        } else if (!this.rightLeg && child.position.x > 0 && child.position.y < 0) {
          this.rightLeg = child;
        }
      } else if (child instanceof THREE.Group) {
        // Also check for arm/leg groups directly in children
        if (!this.leftArm && child.position.x < -0.2 && child.position.y > 0.5) {
          this.leftArm = child;
        } else if (!this.rightArm && child.position.x > 0.2 && child.position.y > 0.5) {
          this.rightArm = child;
        } else if (!this.leftLeg && child.position.x < 0 && child.position.y <= 0.5) {
          this.leftLeg = child;
        } else if (!this.rightLeg && child.position.x > 0 && child.position.y <= 0.5) {
          this.rightLeg = child;
        }
      }
    });
  }
}

class Projectile {
  mesh: THREE.Mesh;
  position: THREE.Vector3;
  velocity: THREE.Vector3;
  damage: number;
  isAreaDamage: boolean;
  isSunGrape: boolean;
  isFrozen: boolean;
  userData: Record<string, any> = {}; // Custom data for special projectile effects

  constructor(mesh: THREE.Mesh, position: THREE.Vector3, velocity: THREE.Vector3, damage: number, isAreaDamage: boolean, isSunGrape: boolean = false, isFrozen: boolean = false) {
    this.mesh = mesh;
    this.position = position;
    this.velocity = velocity;
    this.damage = damage;
    this.isAreaDamage = isAreaDamage;
    this.isSunGrape = isSunGrape;
    this.isFrozen = isFrozen;
  }
}

// Ally types for banana peel summons
type AllyType = 'raccoon' | 'monkey' | 'gorilla' | 'icy-bull' | 'icy-fox' | 'zombie-raccoon' | 'zombie-gorilla' | 'sun-fish' | 'squirrel' | 'buff-squirrel' | 'cursed-zombie' | 'cursed-brute' | 'great-gorilla' | 'baby-yeti';

class Ally {
  mesh: THREE.Group;
  position: THREE.Vector3;
  health: number;
  maxHealth: number;
  damage: number;
  attackCooldown: number = 0;
  type: AllyType;
  targetZombie: Zombie | null = null;
  speed: number;
  animationTime: number = 0;
  spawnZ: number; // Store spawn lane
  isBeingEaten: boolean = false; // Zombie eating this ally

  constructor(mesh: THREE.Group, type: AllyType, position: THREE.Vector3) {
    this.mesh = mesh;
    this.type = type;
    this.position = position;
    this.spawnZ = position.z; // Remember spawn lane

    // Set stats based on ally type
    switch (type) {
      case 'raccoon':
        this.health = 100;
        this.maxHealth = 100;
        this.damage = 30; // 1.5x (was 20)
        this.speed = 2.5;
        break;
      case 'monkey':
        this.health = 70;
        this.maxHealth = 70;
        this.damage = 75; // 1.5x (was 50)
        this.speed = 3.0;
        break;
      case 'gorilla':
        this.health = 400;
        this.maxHealth = 400;
        this.damage = 75; // 1.5x (was 50)
        this.speed = 1.5;
        break;
      case 'icy-bull':
        this.health = 300;
        this.maxHealth = 300;
        this.damage = 150; // 1.5x (was 100)
        this.speed = 2.0;
        break;
      case 'icy-fox':
        this.health = 100;
        this.maxHealth = 100;
        this.damage = 45; // 1.5x (was 30)
        this.speed = 3.5;
        break;
      case 'zombie-raccoon':
        this.health = 10;
        this.maxHealth = 10;
        this.damage = 135; // 1.5x (was 90)
        this.speed = 3.0;
        this.attackCooldown = 0;
        break;
      case 'zombie-gorilla':
        this.health = 100;
        this.maxHealth = 100;
        this.damage = 300; // 1.5x (was 200)
        this.speed = 2.0;
        this.attackCooldown = 0;
        break;
      case 'sun-fish':
        this.health = 250;
        this.maxHealth = 250;
        this.damage = 15; // 1.5x (was 10)
        this.speed = 2.0; // Moves like other allies, stops when attacking
        this.attackCooldown = 0;
        break;
      case 'squirrel':
        // Basic squirrel ally from acorn-nest - quick and nimble
        this.health = 80;
        this.maxHealth = 80;
        this.damage = 23; // 1.5x (was 15)
        this.speed = 3.0;
        this.attackCooldown = 0;
        break;
      case 'buff-squirrel':
        // Golden buff squirrel - tanky and powerful
        this.health = 350;
        this.maxHealth = 350;
        this.damage = 68; // 1.5x (was 45)
        this.speed = 2.0;
        this.attackCooldown = 0;
        break;
      case 'cursed-zombie':
        // Undead minion from banana-leach - fast and deadly but fragile
        this.health = 15;
        this.maxHealth = 15;
        this.damage = 120; // 1.5x (was 80)
        this.speed = 2.8;
        this.attackCooldown = 0;
        break;
      case 'cursed-brute':
        // Large undead brute - heavy hitter with more health
        this.health = 120;
        this.maxHealth = 120;
        this.damage = 270; // 1.5x (was 180)
        this.speed = 1.8;
        this.attackCooldown = 0;
        break;
      case 'great-gorilla':
        // Banana Tree ally - powerful gorilla (1000 HP, 200 dmg every 4s)
        this.health = 1000;
        this.maxHealth = 1000;
        this.damage = 200;
        this.speed = 1.5;
        this.attackCooldown = 0;
        break;
      case 'baby-yeti':
        // Banana Tree ally - tanky fast attacker (1500 HP, 50 dmg every 1s)
        this.health = 1500;
        this.maxHealth = 1500;
        this.damage = 50;
        this.speed = 1.0;
        this.attackCooldown = 0;
        break;
    }
  }
}

// Setup menu interaction
const playButton = document.getElementById('play-button');
const menu = document.getElementById('menu');
const plantSelection = document.getElementById('plant-selection');
const startGameBtn = document.getElementById('start-game-btn') as HTMLButtonElement | null;
const plantCards = document.querySelectorAll('.plant-card');

const selectedPlants: Set<PlantType> = new Set();
// Read from window.selectedPowerPlant set by index.html script
function getSelectedPowerPlant(): PowerPlantType | null {
  return (window as any).selectedPowerPlant || null;
}
let currentGame: Game | null = null;

// Helper function to cleanup current game before starting new one
function cleanupCurrentGame(): void {
  if (currentGame) {
    currentGame.dispose();
    currentGame = null;
  }
}

// === Save/Load System ===
function hasSavedGame(): boolean {
  return localStorage.getItem('fusionTdGameSave') !== null;
}

function deleteSavedGame(): void {
  localStorage.removeItem('fusionTdGameSave');
}

function saveGame(): void {
  if (!currentGame) return;
  try {
    const data = currentGame.serializeGameState();
    // Don't save mini-game modes
    if (data.isShooterMode || data.isWhackMode || data.isVasebreakerMode || data.isIZombieMode || data.isConveyorMode || data.isDragonBattleMode) return;
    const json = JSON.stringify(data);
    localStorage.setItem('fusionTdGameSave', json);
    console.log(`Game saved (${(json.length / 1024).toFixed(1)} KB)`);
  } catch (e) {
    console.error('Failed to save game:', e);
  }
}

// Auto-save when tab is closed or hidden
window.addEventListener('beforeunload', () => {
  saveGame();
});
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    saveGame();
  }
});

function loadGame(): void {
  const json = localStorage.getItem('fusionTdGameSave');
  if (!json) return;

  try {
    const data = JSON.parse(json);
    if (!data.version) {
      console.error('Invalid save data');
      return;
    }

    // Cleanup any existing game
    cleanupCurrentGame();

    // Hide menu, show game UI
    const menu = document.getElementById('menu');
    const plantSelection = document.getElementById('plant-selection');
    if (menu) menu.classList.add('hidden');
    if (plantSelection) plantSelection.classList.remove('active');

    // Suppress tutorial on load
    localStorage.setItem('skipTutorial', 'true');

    // Create new Game with saved plants/mode
    currentGame = new Game(
      data.selectedPlants,
      data.isIZombieMode || false,
      data.isEndlessMode || false,
      data.powerPlantType || null
    );

    // Restore all state from save
    currentGame.loadGameState(data);

    // Delete save after successful load
    deleteSavedGame();

    console.log('Game loaded successfully!');
  } catch (e) {
    console.error('Failed to load game:', e);
  }
}

// Expose selectedPlants to window for cheat access
(window as any).selectedPlants = selectedPlants;

// Show shop plants that are owned
function updateOwnedShopPlants(): void {
  const owned = JSON.parse(localStorage.getItem('fusionTdOwnedPlants') || '[]');
  document.querySelectorAll('.plant-card.shop-plant').forEach(card => {
    const plantType = card.getAttribute('data-plant');
    if (plantType && owned.includes(plantType)) {
      (card as HTMLElement).style.display = '';
    } else {
      (card as HTMLElement).style.display = 'none';
    }
  });
}

if (playButton && menu && plantSelection) {
  playButton.addEventListener('click', () => {
    menu.classList.add('hidden');
    plantSelection.classList.add('active');
    // Initialize lock status when entering plant selection
    updatePlantCardLockStatus();
    // Show owned shop plants
    updateOwnedShopPlants();
  });
}

// Continue button - load saved game
const continueButton = document.getElementById('continue-button');
if (continueButton) {
  if (hasSavedGame()) {
    try {
      const saveJson = localStorage.getItem('fusionTdGameSave');
      if (saveJson) {
        const saveData = JSON.parse(saveJson);
        const modeLabel = saveData.isEndlessMode ? 'Endless ' : saveData.isDragonBattleMode ? 'Dragon ' : '';
        const timeAgo = Date.now() - saveData.timestamp;
        const minutes = Math.floor(timeAgo / 60000);
        const hours = Math.floor(minutes / 60);
        const timeStr = hours > 0 ? `${hours}h ago` : minutes > 0 ? `${minutes}m ago` : 'just now';
        continueButton.innerHTML = `Continue<span class="save-info">${modeLabel}Wave ${saveData.currentWave} - ${timeStr}</span>`;
        continueButton.style.display = '';
      }
    } catch {
      continueButton.style.display = 'none';
    }
  }
  continueButton.addEventListener('click', () => {
    loadGame();
  });
}

// Handle plant card selection
plantCards.forEach(card => {
  card.addEventListener('click', () => {
    const plantType = card.getAttribute('data-plant') as PlantType;

    // Check if the plant is locked
    if (!isPlantUnlocked(plantType)) {
      // Show a message that the plant is locked
      console.log(`🔒 ${PLANT_INFO[plantType].name} is locked! Beat the required wave to unlock.`);
      return;
    }

    const MAX_PLANTS = 8;

    if (selectedPlants.has(plantType)) {
      selectedPlants.delete(plantType);
      card.classList.remove('selected');
    } else {
      // Check if we've reached the maximum
      if (selectedPlants.size >= MAX_PLANTS) {
        console.log(`⚠️ Maximum ${MAX_PLANTS} plants allowed!`);
        // Flash the card red to indicate limit reached
        const htmlCard = card as HTMLElement;
        htmlCard.style.animation = 'none';
        void htmlCard.offsetHeight; // Trigger reflow
        htmlCard.style.animation = 'limitShake 0.5s ease-out';
        return;
      }
      selectedPlants.add(plantType);
      card.classList.add('selected');
    }

    // Update plant counter display
    const counterEl = document.getElementById('plant-counter');
    if (counterEl) {
      counterEl.textContent = `${selectedPlants.size}/${MAX_PLANTS}`;
      if (selectedPlants.size >= MAX_PLANTS) {
        counterEl.style.color = '#ff6b6b';
      } else {
        counterEl.style.color = '#90ee90';
      }
    }

    // Enable start button if at least one plant is selected
    if (startGameBtn) {
      startGameBtn.disabled = selectedPlants.size === 0;
    }
  });
});

// Initialize plant card lock status on page load
updatePlantCardLockStatus();

// Start game with selected plants
if (startGameBtn && plantSelection) {
  startGameBtn.disabled = true;

  startGameBtn.addEventListener('click', () => {
    if (selectedPlants.size > 0) {
      plantSelection.classList.remove('active');

      if (currentGame === null) {
        // First time - create new game
        currentGame = new Game(Array.from(selectedPlants), false, false, getSelectedPowerPlant());
      } else {
        // Returning from completed wave - update plants and start next wave
        currentGame.updateSelectedPlants(Array.from(selectedPlants));
        const gameUI = document.getElementById('game-ui');
        if (gameUI) {
          gameUI.classList.add('active');
        }
        // Start the next wave immediately
        currentGame.startNextWave();
      }
    }
  });
}

// ============================================
// MENU MUSIC SYSTEM (Calm ambient background)
// ============================================
let audioContext: AudioContext | null = null;
let menuMusicGain: GainNode | null = null;
let menuMusicOscillators: OscillatorNode[] = [];
let menuMusicPlaying = false;

function createMenuMusic(): void {
  if (audioContext) return;

  audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
  menuMusicGain = audioContext.createGain();
  menuMusicGain.gain.value = 0.4;
  menuMusicGain.connect(audioContext.destination);

  // Fun bouncy melody using arpeggios - like a happy video game!
  const melodyOsc = audioContext.createOscillator();
  const melodyGain = audioContext.createGain();
  melodyOsc.type = 'square'; // Retro game sound
  melodyOsc.frequency.value = 523.25; // C5
  melodyGain.gain.value = 0.15;
  melodyOsc.connect(melodyGain);
  melodyGain.connect(menuMusicGain);
  menuMusicOscillators.push(melodyOsc);

  // Happy melody pattern (C major pentatonic - impossible to sound sad!)
  const melodyNotes = [523.25, 587.33, 659.25, 783.99, 659.25, 587.33, 523.25, 392.00]; // C5, D5, E5, G5, E5, D5, C5, G4
  let melodyIndex = 0;
  const melodySpeed = 200; // Fast and bouncy!

  const playMelody = () => {
    if (!audioContext || !menuMusicPlaying) return;
    melodyOsc.frequency.setValueAtTime(melodyNotes[melodyIndex], audioContext.currentTime);
    melodyGain.gain.setValueAtTime(0.2, audioContext.currentTime);
    melodyGain.gain.exponentialRampToValueAtTime(0.08, audioContext.currentTime + 0.15);
    melodyIndex = (melodyIndex + 1) % melodyNotes.length;
    setTimeout(playMelody, melodySpeed);
  };
  setTimeout(playMelody, 100);

  // Punchy bass line
  const bassOsc = audioContext.createOscillator();
  const bassGain = audioContext.createGain();
  bassOsc.type = 'square';
  bassOsc.frequency.value = 130.81; // C3
  bassGain.gain.value = 0.12;
  bassOsc.connect(bassGain);
  bassGain.connect(menuMusicGain);
  menuMusicOscillators.push(bassOsc);

  // Bass rhythm pattern
  const bassNotes = [130.81, 130.81, 196.00, 164.81]; // C3, C3, G3, E3
  let bassIndex = 0;
  const bassSpeed = 400;

  const playBass = () => {
    if (!audioContext || !menuMusicPlaying) return;
    bassOsc.frequency.setValueAtTime(bassNotes[bassIndex], audioContext.currentTime);
    bassGain.gain.setValueAtTime(0.15, audioContext.currentTime);
    bassGain.gain.exponentialRampToValueAtTime(0.06, audioContext.currentTime + 0.2);
    bassIndex = (bassIndex + 1) % bassNotes.length;
    setTimeout(playBass, bassSpeed);
  };
  setTimeout(playBass, 100);

  // Add a soft pad for fullness
  const padOsc = audioContext.createOscillator();
  const padGain = audioContext.createGain();
  padOsc.type = 'sine';
  padOsc.frequency.value = 261.63; // C4
  padGain.gain.value = 0.1;
  padOsc.connect(padGain);
  padGain.connect(menuMusicGain);
  menuMusicOscillators.push(padOsc);
}

function startMenuMusic(): void {
  if (menuMusicPlaying) return;

  try {
    createMenuMusic();

    if (audioContext && audioContext.state === 'suspended') {
      audioContext.resume();
    }

    menuMusicOscillators.forEach(osc => {
      try {
        osc.start();
      } catch (e) {
        // Already started
      }
    });

    // Fade in
    if (menuMusicGain) {
      menuMusicGain.gain.setValueAtTime(0, audioContext!.currentTime);
      menuMusicGain.gain.linearRampToValueAtTime(0.15, audioContext!.currentTime + 1);
    }

    menuMusicPlaying = true;
  } catch (e) {
    console.log('Could not start menu music:', e);
  }
}

function stopMenuMusic(): void {
  if (!menuMusicPlaying || !menuMusicGain || !audioContext) return;

  // Fade out
  menuMusicGain.gain.linearRampToValueAtTime(0, audioContext.currentTime + 0.5);

  setTimeout(() => {
    menuMusicOscillators.forEach(osc => {
      try {
        osc.stop();
      } catch (e) {
        // Already stopped
      }
    });
    menuMusicOscillators = [];
    menuMusicPlaying = false;
    audioContext = null;
    menuMusicGain = null;
  }, 600);
}

// Start music on first user interaction
document.addEventListener('click', () => {
  const menuEl = document.getElementById('menu');
  const plantSelectionEl = document.getElementById('plant-selection');
  const minigamesScreen = document.getElementById('minigames-screen');

  const menuVisible = menuEl && !menuEl.classList.contains('hidden');
  const selectionVisible = plantSelectionEl && plantSelectionEl.classList.contains('active');
  const minigamesVisible = minigamesScreen && minigamesScreen.classList.contains('active');

  if ((menuVisible || selectionVisible || minigamesVisible) && !menuMusicPlaying) {
    startMenuMusic();
  }
}, { once: true });

// ============================================
// BACK BUTTON (Plant Selection -> Menu)
// ============================================
const backBtn = document.getElementById('back-btn');
if (backBtn && menu && plantSelection) {
  backBtn.addEventListener('click', () => {
    plantSelection.classList.remove('active');
    menu.classList.remove('hidden');
    // Clear plant selections
    selectedPlants.clear();
    document.querySelectorAll('.plant-card.selected').forEach(card => {
      card.classList.remove('selected');
    });
    // Reset plant counter
    const counterEl = document.getElementById('plant-counter');
    if (counterEl) {
      counterEl.textContent = '0/8';
      counterEl.style.color = '#90ee90';
    }
    if (startGameBtn) {
      startGameBtn.disabled = true;
    }
  });
}

// ============================================
// MINI GAMES SYSTEM
// ============================================
const minigamesButton = document.getElementById('minigames-button');
const minigamesScreen = document.getElementById('minigames-screen');
const minigamesBackBtn = document.getElementById('minigames-back-btn');

// Open mini-games screen
if (minigamesButton && menu && minigamesScreen) {
  minigamesButton.addEventListener('click', () => {
    menu.classList.add('hidden');
    minigamesScreen.classList.add('active');
    if (!menuMusicPlaying) startMenuMusic();
  });
}

// Back to menu from mini-games
if (minigamesBackBtn && menu && minigamesScreen) {
  minigamesBackBtn.addEventListener('click', () => {
    minigamesScreen.classList.remove('active');
    menu.classList.remove('hidden');
  });
}

// ---- PLANT MEMORY GAME ----
const plantMemoryCard = document.getElementById('plant-memory-card');
const plantMemoryModal = document.getElementById('plant-memory-modal');
const pmemoryStartBtn = document.getElementById('pmemory-start-btn');
const pmemoryCloseBtn = document.getElementById('pmemory-close-btn');
const pmemoryGrid = document.getElementById('pmemory-grid');
const pmemoryScoreDisplay = document.getElementById('pmemory-score');
const pmemoryRoundDisplay = document.getElementById('pmemory-round');
const pmemoryStatus = document.getElementById('pmemory-status');

const pmemoryPlantEmojis = ['🍇', '🌿', '🍐', '🫐', '🌸', '🥑'];
let pmemoryPattern: number[] = [];
let pmemoryUserPattern: number[] = [];
let pmemoryRound = 1;
let pmemoryScore = 0;
let pmemoryShowingPattern = false;

if (plantMemoryCard && plantMemoryModal) {
  plantMemoryCard.addEventListener('click', () => {
    plantMemoryModal.classList.add('active');
  });
}

if (pmemoryCloseBtn && plantMemoryModal) {
  pmemoryCloseBtn.addEventListener('click', () => {
    plantMemoryModal.classList.remove('active');
  });
}

// Mini-game tutorial function
function showMiniGameTutorial(game: string, callback: () => void): void {
  const tutorials: Record<string, { title: string; emoji: string; color: string; steps: string[] }> = {
    'memory': {
      title: 'PLANT MEMORY',
      emoji: '🧠',
      color: '#4a8a4a',
      steps: [
        '👀 Watch the plants light up in order',
        '🖱️ Click them back in the SAME order',
        '📈 Pattern gets longer each round',
        '🏆 How many rounds can you remember?'
      ]
    },
    'quickplant': {
      title: 'QUICK PLANT',
      emoji: '⚡',
      color: '#8a8a4a',
      steps: [
        '🧟 Zombie appears on a tile!',
        '🌱 Click the correct plant to stop it',
        '❌ Wrong plant = lose a life!',
        '🏆 Survive as long as possible!'
      ]
    },
    'beghouled': {
      title: 'BEGHOULED',
      emoji: '💎',
      color: '#6a4a8a',
      steps: [
        '🔀 Swap adjacent plants to match 3+',
        '💥 Matches disappear and score points',
        '📉 You have 30 moves total',
        '🏆 Get the highest score!'
      ]
    },
    'stars': {
      title: 'SEEING STARS',
      emoji: '⭐',
      color: '#8a8a4a',
      steps: [
        '⭐ Find the star-shaped pattern (9 spots)',
        '🌸 Plant lilies on the glowing spots',
        '⏰ You have 45 seconds!',
        '🏆 Complete the pattern to win!'
      ]
    }
  };

  const tutorial = tutorials[game];
  if (!tutorial) {
    callback();
    return;
  }

  const overlay = document.createElement('div');
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10001;
    animation: mgTutFadeIn 0.4s ease-out;
  `;

  const content = document.createElement('div');
  content.style.cssText = `
    background: linear-gradient(180deg, rgba(30, 40, 30, 0.95) 0%, rgba(15, 25, 15, 0.98) 100%);
    border: 3px solid ${tutorial.color};
    border-radius: 15px;
    padding: 2rem;
    text-align: center;
    max-width: 400px;
    width: 85%;
    box-shadow: 0 0 40px ${tutorial.color}66;
    animation: mgTutSlideIn 0.5s ease-out;
  `;

  let stepsHTML = tutorial.steps.map((step, i) => `
    <div style="
      opacity: 0;
      animation: mgTutStepIn 0.3s ease-out ${0.2 + i * 0.1}s forwards;
      padding: 0.6rem;
      margin: 0.4rem 0;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 8px;
      border-left: 3px solid ${tutorial.color};
      text-align: left;
      font-size: 1rem;
      color: #ddeedd;
    ">${step}</div>
  `).join('');

  content.innerHTML = `
    <style>
      @keyframes mgTutFadeIn { from { opacity: 0; } to { opacity: 1; } }
      @keyframes mgTutSlideIn { from { transform: scale(0.9) translateY(-20px); opacity: 0; } to { transform: scale(1) translateY(0); opacity: 1; } }
      @keyframes mgTutStepIn { from { opacity: 0; transform: translateX(-15px); } to { opacity: 1; transform: translateX(0); } }
      @keyframes mgTutBtnIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
    </style>
    <div style="font-size: 3rem; margin-bottom: 0.5rem;">${tutorial.emoji}</div>
    <h3 style="font-family: 'Cinzel', serif; font-size: 1.6rem; color: ${tutorial.color}; margin-bottom: 1rem; letter-spacing: 2px;">${tutorial.title}</h3>
    <div style="margin-bottom: 1rem;">${stepsHTML}</div>
    <button id="mg-tutorial-start" style="
      font-family: 'Cinzel', serif;
      font-size: 1.1rem;
      padding: 0.8rem 2rem;
      background: linear-gradient(180deg, ${tutorial.color}, ${tutorial.color}88);
      color: white;
      border: 2px solid ${tutorial.color};
      border-radius: 10px;
      cursor: pointer;
      opacity: 0;
      animation: mgTutBtnIn 0.3s ease-out 0.6s forwards;
    ">Start!</button>
  `;

  overlay.appendChild(content);
  document.body.appendChild(overlay);

  document.getElementById('mg-tutorial-start')?.addEventListener('click', () => {
    overlay.style.opacity = '0';
    overlay.style.transition = 'opacity 0.3s';
    setTimeout(() => {
      overlay.remove();
      callback();
    }, 300);
  });
}

function initPlantMemory(): void {
  if (!pmemoryGrid) return;

  // Show tutorial first
  showMiniGameTutorial('memory', () => {
    startPlantMemoryGame();
  });
}

function startPlantMemoryGame(): void {
  if (!pmemoryGrid) return;
  pmemoryGrid.innerHTML = '';
  pmemoryPattern = [];
  pmemoryUserPattern = [];
  pmemoryRound = 1;
  pmemoryScore = 0;
  if (pmemoryScoreDisplay) pmemoryScoreDisplay.textContent = '0';
  if (pmemoryRoundDisplay) pmemoryRoundDisplay.textContent = '1';
  if (pmemoryStatus) pmemoryStatus.textContent = 'Watch the pattern...';

  // Create 4x4 grid
  for (let i = 0; i < 16; i++) {
    const cell = document.createElement('div');
    cell.style.cssText = 'width: 60px; height: 60px; background: #2a3a2a; border: 2px solid #4a5a4a; border-radius: 8px; display: flex; justify-content: center; align-items: center; font-size: 2rem; cursor: pointer;';
    cell.dataset.index = i.toString();
    cell.addEventListener('click', () => handlePlantMemoryClick(i));
    pmemoryGrid.appendChild(cell);
  }

  // Start showing pattern
  setTimeout(() => showPlantPattern(), 500);
}

function showPlantPattern(): void {
  pmemoryShowingPattern = true;
  // Add new position to pattern
  pmemoryPattern.push(Math.floor(Math.random() * 16));

  if (pmemoryStatus) pmemoryStatus.textContent = 'Memorize the pattern!';

  // Show each plant in sequence
  let i = 0;
  const showNext = () => {
    if (i < pmemoryPattern.length) {
      const cells = pmemoryGrid?.querySelectorAll('div');
      if (cells) {
        cells[pmemoryPattern[i]].textContent = pmemoryPlantEmojis[Math.floor(Math.random() * pmemoryPlantEmojis.length)];
        cells[pmemoryPattern[i]].style.background = '#4a6a4a';
        setTimeout(() => {
          cells[pmemoryPattern[i]].textContent = '';
          cells[pmemoryPattern[i]].style.background = '#2a3a2a';
          i++;
          setTimeout(showNext, 300);
        }, 600);
      }
    } else {
      pmemoryShowingPattern = false;
      pmemoryUserPattern = [];
      if (pmemoryStatus) pmemoryStatus.textContent = 'Your turn! Click the cells in order!';
    }
  };
  showNext();
}

function handlePlantMemoryClick(index: number): void {
  if (pmemoryShowingPattern) return;

  const cells = pmemoryGrid?.querySelectorAll('div');
  if (!cells) return;

  pmemoryUserPattern.push(index);
  cells[index].textContent = '✓';
  cells[index].style.background = '#4a6a4a';

  setTimeout(() => {
    cells[index].textContent = '';
    cells[index].style.background = '#2a3a2a';
  }, 200);

  // Check if correct
  const currentIndex = pmemoryUserPattern.length - 1;
  if (pmemoryPattern[currentIndex] !== index) {
    if (pmemoryStatus) pmemoryStatus.textContent = `Wrong! Game Over! Final Score: ${pmemoryScore}`;
    return;
  }

  // Check if pattern complete
  if (pmemoryUserPattern.length === pmemoryPattern.length) {
    pmemoryScore += pmemoryRound * 10;
    pmemoryRound++;
    if (pmemoryScoreDisplay) pmemoryScoreDisplay.textContent = pmemoryScore.toString();
    if (pmemoryRoundDisplay) pmemoryRoundDisplay.textContent = pmemoryRound.toString();
    if (pmemoryStatus) pmemoryStatus.textContent = 'Correct! Next round...';
    setTimeout(() => showPlantPattern(), 1000);
  }
}

if (pmemoryStartBtn) {
  pmemoryStartBtn.addEventListener('click', initPlantMemory);
}

// ---- QUICK PLANT GAME ----
const quickPlantCard = document.getElementById('quick-plant-card');
const quickPlantModal = document.getElementById('quick-plant-modal');
const quickplantStartBtn = document.getElementById('quickplant-start-btn');
const quickplantCloseBtn = document.getElementById('quickplant-close-btn');
const quickplantGrid = document.getElementById('quickplant-grid');
const quickplantScoreDisplay = document.getElementById('quickplant-score');
const quickplantLivesDisplay = document.getElementById('quickplant-lives');
const quickplantTimerDisplay = document.getElementById('quickplant-timer');
const quickplantZombie = document.getElementById('quickplant-zombie');

let quickplantScore = 0;
let quickplantLives = 3;
let quickplantActive = false;
let quickplantTargetCell = -1;
let quickplantInterval: ReturnType<typeof setInterval> | null = null;

if (quickPlantCard && quickPlantModal) {
  quickPlantCard.addEventListener('click', () => {
    quickPlantModal.classList.add('active');
  });
}

if (quickplantCloseBtn && quickPlantModal) {
  quickplantCloseBtn.addEventListener('click', () => {
    quickPlantModal.classList.remove('active');
    quickplantActive = false;
    if (quickplantInterval) clearInterval(quickplantInterval);
  });
}

function initQuickPlant(): void {
  if (!quickplantGrid) return;

  // Show tutorial first
  showMiniGameTutorial('quickplant', () => {
    startQuickPlantGame();
  });
}

function startQuickPlantGame(): void {
  if (!quickplantGrid) return;
  quickplantGrid.innerHTML = '';
  quickplantScore = 0;
  quickplantLives = 3;
  quickplantActive = true;
  if (quickplantScoreDisplay) quickplantScoreDisplay.textContent = '0';
  if (quickplantLivesDisplay) quickplantLivesDisplay.textContent = '3';

  // Create 5x3 grid
  for (let i = 0; i < 15; i++) {
    const cell = document.createElement('div');
    cell.style.cssText = 'width: 50px; height: 50px; background: #2a3a2a; border: 2px solid #4a5a4a; border-radius: 8px; display: flex; justify-content: center; align-items: center; font-size: 1.5rem; cursor: pointer;';
    cell.dataset.index = i.toString();
    cell.addEventListener('click', () => handleQuickPlantClick(i));
    quickplantGrid.appendChild(cell);
  }

  startQuickPlantRound();
}

function startQuickPlantRound(): void {
  if (!quickplantActive) return;

  const cells = quickplantGrid?.querySelectorAll('div');
  if (!cells) return;

  // Clear all cells
  cells.forEach(c => {
    c.textContent = '';
    c.style.background = '#2a3a2a';
    c.style.borderColor = '#4a5a4a';
  });

  // Pick random target
  quickplantTargetCell = Math.floor(Math.random() * 15);
  cells[quickplantTargetCell].style.background = '#4a5a2a';
  cells[quickplantTargetCell].style.borderColor = '#8a8a4a';

  let timeLeft = 3;
  if (quickplantTimerDisplay) quickplantTimerDisplay.textContent = timeLeft.toString();

  if (quickplantInterval) clearInterval(quickplantInterval);
  quickplantInterval = setInterval(() => {
    timeLeft--;
    if (quickplantTimerDisplay) quickplantTimerDisplay.textContent = timeLeft.toString();

    if (timeLeft <= 0 && quickplantActive) {
      if (quickplantInterval) clearInterval(quickplantInterval);
      quickplantLives--;
      if (quickplantLivesDisplay) quickplantLivesDisplay.textContent = quickplantLives.toString();
      cells[quickplantTargetCell].textContent = '🧟';
      cells[quickplantTargetCell].style.background = '#5a2a2a';

      if (quickplantLives <= 0) {
        quickplantActive = false;
        if (quickplantZombie) quickplantZombie.innerHTML = `Game Over! Final Score: ${quickplantScore}`;
      } else {
        setTimeout(() => startQuickPlantRound(), 1000);
      }
    }
  }, 1000);
}

function handleQuickPlantClick(index: number): void {
  if (!quickplantActive) return;

  const cells = quickplantGrid?.querySelectorAll('div');
  if (!cells) return;

  if (index === quickplantTargetCell) {
    quickplantScore += 10;
    if (quickplantScoreDisplay) quickplantScoreDisplay.textContent = quickplantScore.toString();
    cells[index].textContent = '🌱';
    cells[index].style.background = '#2a5a2a';
    if (quickplantInterval) clearInterval(quickplantInterval);
    setTimeout(() => startQuickPlantRound(), 500);
  }
}

if (quickplantStartBtn) {
  quickplantStartBtn.addEventListener('click', initQuickPlant);
}

// ---- I, ZOMBIE MINI-GAME ----
const izombieCard = document.getElementById('izombie-card');
const izombieGameModal = document.getElementById('izombie-game-modal');
const izombieStartBtn = document.getElementById('izombie-start-btn');
const izombieCloseBtn = document.getElementById('izombie-close-btn');

if (izombieCard && izombieGameModal) {
  izombieCard.addEventListener('click', () => {
    izombieGameModal.classList.add('active');
  });
}

if (izombieCloseBtn && izombieGameModal) {
  izombieCloseBtn.addEventListener('click', () => {
    izombieGameModal.classList.remove('active');
  });
}

if (izombieStartBtn) {
  izombieStartBtn.addEventListener('click', () => {
    console.log('🧟 I, Zombie mode starting...');

    // Set I Zombie mode flag FIRST
    localStorage.setItem('izombieMode', 'true');

    // Hide EVERYTHING before starting
    const elementsToHide = [
      'izombie-game-modal',
      'minigames-screen',
      'plant-selection',
      'menu',
      'book-modal',
      'shop-modal',
      'tutorial-overlay',
      'click-game-modal',
      'memory-game-modal',
      'reaction-game-modal'
    ];

    elementsToHide.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.classList.remove('active');
        if (id === 'menu') el.classList.add('hidden');
      }
    });

    // Cleanup any existing game first
    cleanupCurrentGame();

    // Create I Zombie game instance
    console.log('🧟 Creating I, Zombie game...');
    const iZombiePlants: PlantType[] = ['grape-launcher', 'vine-wall', 'lily'];
    currentGame = new Game(iZombiePlants, true); // Pass true for I Zombie mode

    // AFTER game is created, ensure plant-selection stays hidden
    const plantSelection = document.getElementById('plant-selection');
    if (plantSelection) {
      plantSelection.classList.remove('active');
      plantSelection.style.display = 'none'; // Force hide with inline style
    }

    // Make sure game-ui is visible
    const gameUI = document.getElementById('game-ui');
    if (gameUI) {
      gameUI.classList.add('active');
    }

    stopMenuMusic();
    console.log('🧟 I, Zombie mode started!');
  });
}

// Stop menu music when game starts
if (startGameBtn) {
  startGameBtn.addEventListener('click', () => {
    stopMenuMusic();
  });
}

// ---- WHACK-A-ZOMBIE TD MODE ----
const whackCard = document.getElementById('whack-zombie-card');
const whackGameModal = document.getElementById('whack-game-modal');
const whackStartBtn = document.getElementById('whack-start-btn');
const whackCloseBtn = document.getElementById('whack-close-btn');

if (whackCard && whackGameModal) {
  whackCard.addEventListener('click', () => {
    whackGameModal.classList.add('active');
  });
}

if (whackCloseBtn && whackGameModal) {
  whackCloseBtn.addEventListener('click', () => {
    whackGameModal.classList.remove('active');
  });
}

if (whackStartBtn) {
  whackStartBtn.addEventListener('click', () => {
    console.log('🔨 Whack-a-Zombie mode starting...');

    // Set whack mode flag
    localStorage.setItem('whackMode', 'true');

    // Hide all screens
    const elementsToHide = [
      'whack-game-modal',
      'minigames-screen',
      'plant-selection',
      'menu',
      'tutorial-overlay'
    ];

    elementsToHide.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.classList.remove('active');
        if (id === 'menu') el.classList.add('hidden');
      }
    });

    // Start TD game with whack mode - use default plants
    cleanupCurrentGame();
    const whackPlants: PlantType[] = ['grape-launcher', 'vine-wall', 'pear-cannon', 'frost-berri', 'lily', 'avocado-slammer'];
    currentGame = new Game(whackPlants, false, false);

    // Make sure game-ui is visible
    const gameUI = document.getElementById('game-ui');
    if (gameUI) {
      gameUI.classList.add('active');
    }

    stopMenuMusic();
    console.log('🔨 Whack-a-Zombie mode started!');
  });
}

// ---- ENDLESS MODE MINI-GAME ----
const endlessCard = document.getElementById('endless-card');
const endlessGameModal = document.getElementById('endless-game-modal');
const endlessStartBtn = document.getElementById('endless-start-btn');
const endlessCloseBtn = document.getElementById('endless-close-btn');
const endlessHighscoreDisplay = document.getElementById('endless-highscore');

// Load highscore from localStorage
let endlessHighscore = parseInt(localStorage.getItem('endlessHighscore') || '0');
if (endlessHighscoreDisplay) endlessHighscoreDisplay.textContent = endlessHighscore.toString();

if (endlessCard && endlessGameModal) {
  endlessCard.addEventListener('click', () => {
    endlessGameModal.classList.add('active');
    // Update highscore display
    if (endlessHighscoreDisplay) endlessHighscoreDisplay.textContent = endlessHighscore.toString();
  });
}

if (endlessCloseBtn && endlessGameModal) {
  endlessCloseBtn.addEventListener('click', () => {
    endlessGameModal.classList.remove('active');
  });
}

if (endlessStartBtn) {
  endlessStartBtn.addEventListener('click', () => {
    console.log('♾️ Endless mode starting...');

    // Set endless mode flag
    localStorage.setItem('endlessMode', 'true');

    // Hide all screens
    const elementsToHide = [
      'endless-game-modal',
      'minigames-screen',
      'plant-selection',
      'menu',
      'book-modal',
      'shop-modal',
      'tutorial-overlay'
    ];

    elementsToHide.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.classList.remove('active');
        if (id === 'menu') el.classList.add('hidden');
      }
    });

    // Create endless game instance (will be handled by Game class checking localStorage)
    cleanupCurrentGame();
    console.log('♾️ Creating Endless game...');
    const endlessPlants: PlantType[] = ['grape-launcher', 'vine-wall', 'lily', 'pear-cannon', 'frost-berri', 'avocado-slammer'];
    currentGame = new Game(endlessPlants, false, true); // Pass true for endless mode

    // Make sure game-ui is visible
    const gameUI = document.getElementById('game-ui');
    if (gameUI) {
      gameUI.classList.add('active');
    }

    stopMenuMusic();
    console.log('♾️ Endless mode started!');
  });
}

// ---- ZOMBIE SHOOTER TD MODE ----
const zombieShooterCard = document.getElementById('zombie-shooter-card');
const zombieShooterModal = document.getElementById('zombie-shooter-modal');
const shooterStartBtn = document.getElementById('shooter-start-btn');
const shooterCloseBtn = document.getElementById('shooter-close-btn');

if (zombieShooterCard && zombieShooterModal) {
  zombieShooterCard.addEventListener('click', () => {
    zombieShooterModal.classList.add('active');
  });
}

if (shooterCloseBtn && zombieShooterModal) {
  shooterCloseBtn.addEventListener('click', () => {
    zombieShooterModal.classList.remove('active');
  });
}

if (shooterStartBtn) {
  shooterStartBtn.addEventListener('click', () => {
    console.log('🔫 Zombie Shooter TD mode starting...');

    // Set shooter mode flag
    localStorage.setItem('shooterMode', 'true');

    // Hide all screens
    const elementsToHide = [
      'zombie-shooter-modal',
      'minigames-screen',
      'plant-selection',
      'menu',
      'tutorial-overlay'
    ];

    elementsToHide.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.classList.remove('active');
        if (id === 'menu') el.classList.add('hidden');
      }
    });

    // Create shooter game - no plants needed, just shooting!
    cleanupCurrentGame();
    const shooterPlants: PlantType[] = ['grape-launcher']; // Just for show
    currentGame = new Game(shooterPlants, false, false);

    const gameUI = document.getElementById('game-ui');
    if (gameUI) gameUI.classList.add('active');

    stopMenuMusic();
    console.log('🔫 Zombie Shooter started! Click on zombies to shoot them!');
  });
}

// ---- VASEBREAKER TD MODE ----
const vaseCard = document.getElementById('vasebreaker-card');
const vaseGameModal = document.getElementById('vasebreaker-game-modal');
const vaseStartBtn = document.getElementById('vase-start-btn');
const vaseCloseBtn = document.getElementById('vase-close-btn');

if (vaseCard && vaseGameModal) {
  vaseCard.addEventListener('click', () => {
    vaseGameModal.classList.add('active');
  });
}

if (vaseCloseBtn && vaseGameModal) {
  vaseCloseBtn.addEventListener('click', () => {
    vaseGameModal.classList.remove('active');
  });
}

if (vaseStartBtn) {
  vaseStartBtn.addEventListener('click', () => {
    console.log('🏺 Vasebreaker TD mode starting...');

    // Set vasebreaker mode flag
    localStorage.setItem('vasebreakerMode', 'true');

    // Hide all screens
    const elementsToHide = [
      'vasebreaker-game-modal',
      'minigames-screen',
      'plant-selection',
      'menu',
      'tutorial-overlay'
    ];

    elementsToHide.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.classList.remove('active');
        if (id === 'menu') el.classList.add('hidden');
      }
    });

    // Create vasebreaker game - limited plants, vases spawn on field
    cleanupCurrentGame();
    const vasePlants: PlantType[] = ['grape-launcher', 'vine-wall', 'pear-cannon', 'frost-berri', 'lily'];
    currentGame = new Game(vasePlants, false, false);

    const gameUI = document.getElementById('game-ui');
    if (gameUI) gameUI.classList.add('active');

    stopMenuMusic();
    console.log('🏺 Vasebreaker started! Break vases to find plants and defeat zombies!');
  });
}

// ---- CONVEYOR BELT MINI-GAME ----
const conveyorCard = document.getElementById('conveyor-card');
const conveyorGameModal = document.getElementById('conveyor-game-modal');
const conveyorStartBtn = document.getElementById('conveyor-start-btn');
const conveyorCloseBtn = document.getElementById('conveyor-close-btn');

if (conveyorCard && conveyorGameModal) {
  conveyorCard.addEventListener('click', () => {
    conveyorGameModal.classList.add('active');
  });
}

if (conveyorCloseBtn && conveyorGameModal) {
  conveyorCloseBtn.addEventListener('click', () => {
    conveyorGameModal.classList.remove('active');
  });
}

if (conveyorStartBtn) {
  conveyorStartBtn.addEventListener('click', () => {
    console.log('🎒 Conveyor Belt mode starting...');

    // Set conveyor mode flag
    localStorage.setItem('conveyorMode', 'true');

    // Hide all screens
    const elementsToHide = [
      'conveyor-game-modal',
      'minigames-screen',
      'plant-selection',
      'menu',
      'tutorial-overlay'
    ];

    elementsToHide.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.classList.remove('active');
        if (id === 'menu') el.classList.add('hidden');
      }
    });

    // Create conveyor game - random plants will be given
    cleanupCurrentGame();
    const conveyorPlants: PlantType[] = ['grape-launcher', 'vine-wall', 'pear-cannon', 'frost-berri', 'lily', 'avocado-slammer'];
    currentGame = new Game(conveyorPlants, false, false);

    // Make sure game-ui is visible
    const gameUI = document.getElementById('game-ui');
    if (gameUI) {
      gameUI.classList.add('active');
    }

    stopMenuMusic();
    console.log('🎒 Conveyor Belt mode started!');
  });
}

// ---- SPEED RUN MINI-GAME ----
const speedrunCard = document.getElementById('speedrun-card');
const speedrunModal = document.getElementById('speedrun-game-modal');
const speedrunStartBtn = document.getElementById('speedrun-start-btn');
const speedrunCloseBtn = document.getElementById('speedrun-close-btn');
const speedrunTimerDisplay = document.getElementById('speedrun-timer');
const speedrunBestDisplay = document.getElementById('speedrun-best');

let speedrunBest = localStorage.getItem('speedrunBest') || '--:--:--';
if (speedrunBestDisplay) speedrunBestDisplay.textContent = speedrunBest;

if (speedrunCard && speedrunModal) {
  speedrunCard.addEventListener('click', () => {
    speedrunModal.classList.add('active');
    if (speedrunBestDisplay) speedrunBestDisplay.textContent = speedrunBest;
  });
}

if (speedrunCloseBtn && speedrunModal) {
  speedrunCloseBtn.addEventListener('click', () => {
    speedrunModal.classList.remove('active');
  });
}

if (speedrunStartBtn) {
  speedrunStartBtn.addEventListener('click', () => {
    console.log('⏱️ Speed Run starting...');

    // Set speed run mode flag - Game class will check this
    localStorage.setItem('speedrunMode', 'true');
    localStorage.setItem('speedrunStart', Date.now().toString());

    // Hide all screens
    const elementsToHide = [
      'speedrun-game-modal',
      'minigames-screen',
      'plant-selection',
      'menu',
      'tutorial-overlay'
    ];

    elementsToHide.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.classList.remove('active');
        if (id === 'menu') el.classList.add('hidden');
      }
    });

    // Create speed run game with all plants (Game class handles sun based on speedrunMode)
    cleanupCurrentGame();
    const allPlants: PlantType[] = ['grape-launcher', 'vine-wall', 'pear-cannon', 'frost-berri', 'lily', 'avocado-slammer', 'pickle-picker', 'tomato-spike', 'strawberry-launcher'];
    currentGame = new Game(allPlants, false, false);

    // Make sure game-ui is visible
    const gameUI = document.getElementById('game-ui');
    if (gameUI) {
      gameUI.classList.add('active');
    }

    stopMenuMusic();
    console.log('⏱️ Speed Run started! Complete 5 waves as fast as possible!');
  });
}

// ---- BEGHOULED MINI-GAME ----
const beghouledCard = document.getElementById('beghouled-card');
const beghouledModal = document.getElementById('beghouled-game-modal');
const beghouledStartBtn = document.getElementById('beghouled-start-btn');
const beghouledCloseBtn = document.getElementById('beghouled-close-btn');
const beghouledGrid = document.getElementById('beghouled-grid');
const beghouledScoreDisplay = document.getElementById('beghouled-score');
const beghouledMovesDisplay = document.getElementById('beghouled-moves');
const beghouledStatusEl = document.getElementById('beghouled-status');

const beghouledPlants = ['🍇', '🌿', '🍐', '🫐', '🌸', '🥑'];
let beghouledBoard: string[][] = [];
let beghouledSelected: { row: number, col: number } | null = null;
let beghouledScore = 0;
let beghouledMoves = 30;
let beghouledActive = false;

if (beghouledCard && beghouledModal) {
  beghouledCard.addEventListener('click', () => {
    beghouledModal.classList.add('active');
  });
}

if (beghouledCloseBtn && beghouledModal) {
  beghouledCloseBtn.addEventListener('click', () => {
    beghouledModal.classList.remove('active');
    beghouledActive = false;
  });
}

function initBeghouled(): void {
  // Show tutorial first
  showMiniGameTutorial('beghouled', () => {
    startBeghouledGame();
  });
}

function startBeghouledGame(): void {
  beghouledScore = 0;
  beghouledMoves = 30;
  beghouledSelected = null;
  beghouledActive = true;
  beghouledBoard = [];

  if (beghouledScoreDisplay) beghouledScoreDisplay.textContent = '0';
  if (beghouledMovesDisplay) beghouledMovesDisplay.textContent = '30';
  if (beghouledStatusEl) beghouledStatusEl.textContent = '';

  // Create board
  for (let row = 0; row < 6; row++) {
    beghouledBoard[row] = [];
    for (let col = 0; col < 6; col++) {
      beghouledBoard[row][col] = beghouledPlants[Math.floor(Math.random() * beghouledPlants.length)];
    }
  }

  // Remove initial matches
  let hasMatches = true;
  while (hasMatches) {
    hasMatches = false;
    for (let row = 0; row < 6; row++) {
      for (let col = 0; col < 6; col++) {
        // Check horizontal match
        if (col < 4 && beghouledBoard[row][col] === beghouledBoard[row][col + 1] && beghouledBoard[row][col] === beghouledBoard[row][col + 2]) {
          beghouledBoard[row][col] = beghouledPlants[Math.floor(Math.random() * beghouledPlants.length)];
          hasMatches = true;
        }
        // Check vertical match
        if (row < 4 && beghouledBoard[row][col] === beghouledBoard[row + 1][col] && beghouledBoard[row][col] === beghouledBoard[row + 2][col]) {
          beghouledBoard[row][col] = beghouledPlants[Math.floor(Math.random() * beghouledPlants.length)];
          hasMatches = true;
        }
      }
    }
  }

  renderBeghouled();
}

function renderBeghouled(): void {
  if (!beghouledGrid) return;
  beghouledGrid.innerHTML = '';

  for (let row = 0; row < 6; row++) {
    for (let col = 0; col < 6; col++) {
      const cell = document.createElement('div');
      cell.className = 'beghouled-cell';
      cell.textContent = beghouledBoard[row][col];
      cell.dataset.row = row.toString();
      cell.dataset.col = col.toString();

      if (beghouledSelected && beghouledSelected.row === row && beghouledSelected.col === col) {
        cell.classList.add('selected');
      }

      cell.addEventListener('click', () => handleBeghouledClick(row, col));
      beghouledGrid.appendChild(cell);
    }
  }
}

function handleBeghouledClick(row: number, col: number): void {
  if (!beghouledActive || beghouledMoves <= 0) return;

  if (!beghouledSelected) {
    beghouledSelected = { row, col };
    renderBeghouled();
    return;
  }

  // Check if adjacent
  const dr = Math.abs(beghouledSelected.row - row);
  const dc = Math.abs(beghouledSelected.col - col);

  if ((dr === 1 && dc === 0) || (dr === 0 && dc === 1)) {
    // Swap
    const temp = beghouledBoard[beghouledSelected.row][beghouledSelected.col];
    beghouledBoard[beghouledSelected.row][beghouledSelected.col] = beghouledBoard[row][col];
    beghouledBoard[row][col] = temp;

    // Check for matches
    const matches = findBeghouledMatches();
    if (matches.length > 0) {
      beghouledMoves--;
      if (beghouledMovesDisplay) beghouledMovesDisplay.textContent = beghouledMoves.toString();

      // Remove matches and add score
      matches.forEach(pos => {
        beghouledBoard[pos.row][pos.col] = '';
        beghouledScore += 10;
      });
      if (beghouledScoreDisplay) beghouledScoreDisplay.textContent = beghouledScore.toString();

      // Drop and fill
      setTimeout(() => {
        dropBeghouled();
        fillBeghouled();
        renderBeghouled();

        // Check for cascades
        setTimeout(() => checkBeghouledCascade(), 300);
      }, 200);
    } else {
      // Swap back
      beghouledBoard[row][col] = beghouledBoard[beghouledSelected.row][beghouledSelected.col];
      beghouledBoard[beghouledSelected.row][beghouledSelected.col] = temp;
    }

    beghouledSelected = null;
  } else {
    beghouledSelected = { row, col };
  }

  renderBeghouled();

  if (beghouledMoves <= 0) {
    beghouledActive = false;
    if (beghouledStatusEl) beghouledStatusEl.textContent = `Game Over! Final Score: ${beghouledScore}`;
  }
}

function findBeghouledMatches(): { row: number, col: number }[] {
  const matches: { row: number, col: number }[] = [];

  // Check horizontal
  for (let row = 0; row < 6; row++) {
    for (let col = 0; col < 4; col++) {
      if (beghouledBoard[row][col] &&
          beghouledBoard[row][col] === beghouledBoard[row][col + 1] &&
          beghouledBoard[row][col] === beghouledBoard[row][col + 2]) {
        matches.push({ row, col }, { row, col: col + 1 }, { row, col: col + 2 });
      }
    }
  }

  // Check vertical
  for (let row = 0; row < 4; row++) {
    for (let col = 0; col < 6; col++) {
      if (beghouledBoard[row][col] &&
          beghouledBoard[row][col] === beghouledBoard[row + 1][col] &&
          beghouledBoard[row][col] === beghouledBoard[row + 2][col]) {
        matches.push({ row, col }, { row: row + 1, col }, { row: row + 2, col });
      }
    }
  }

  return matches;
}

function dropBeghouled(): void {
  for (let col = 0; col < 6; col++) {
    let writeRow = 5;
    for (let row = 5; row >= 0; row--) {
      if (beghouledBoard[row][col]) {
        beghouledBoard[writeRow][col] = beghouledBoard[row][col];
        if (writeRow !== row) beghouledBoard[row][col] = '';
        writeRow--;
      }
    }
  }
}

function fillBeghouled(): void {
  for (let row = 0; row < 6; row++) {
    for (let col = 0; col < 6; col++) {
      if (!beghouledBoard[row][col]) {
        beghouledBoard[row][col] = beghouledPlants[Math.floor(Math.random() * beghouledPlants.length)];
      }
    }
  }
}

function checkBeghouledCascade(): void {
  const matches = findBeghouledMatches();
  if (matches.length > 0) {
    matches.forEach(pos => {
      beghouledBoard[pos.row][pos.col] = '';
      beghouledScore += 15; // Bonus for cascade
    });
    if (beghouledScoreDisplay) beghouledScoreDisplay.textContent = beghouledScore.toString();

    setTimeout(() => {
      dropBeghouled();
      fillBeghouled();
      renderBeghouled();
      setTimeout(() => checkBeghouledCascade(), 300);
    }, 200);
  }
}

if (beghouledStartBtn) {
  beghouledStartBtn.addEventListener('click', initBeghouled);
}

// ---- SEEING STARS MINI-GAME ----
const starsCard = document.getElementById('stars-card');
const starsModal = document.getElementById('stars-game-modal');
const starsStartBtn = document.getElementById('stars-start-btn');
const starsCloseBtn = document.getElementById('stars-close-btn');
const starsGrid = document.getElementById('stars-grid');
const starsTimerDisplay = document.getElementById('stars-timer');
const starsCountDisplay = document.getElementById('stars-count');
const starsStatusEl = document.getElementById('stars-status');

// Star pattern positions (5x5 grid, 5-pointed star shape)
const STAR_PATTERN = [
  { row: 0, col: 2 },                           // Top point
  { row: 1, col: 0 }, { row: 1, col: 4 },       // Upper arms
  { row: 2, col: 1 }, { row: 2, col: 3 },       // Inner sides
  { row: 3, col: 0 }, { row: 3, col: 4 },       // Lower arms
  { row: 4, col: 1 }, { row: 4, col: 3 },       // Bottom points
];

let starsPlanted: Set<string> = new Set();
let starsTimer = 30;
let starsActive = false;
let starsInterval: ReturnType<typeof setInterval> | null = null;

if (starsCard && starsModal) {
  starsCard.addEventListener('click', () => {
    starsModal.classList.add('active');
  });
}

if (starsCloseBtn && starsModal) {
  starsCloseBtn.addEventListener('click', () => {
    starsModal.classList.remove('active');
    starsActive = false;
    if (starsInterval) clearInterval(starsInterval);
  });
}

function initStars(): void {
  // Show tutorial first
  showMiniGameTutorial('stars', () => {
    startStarsGame();
  });
}

function startStarsGame(): void {
  starsPlanted = new Set();
  starsTimer = 45;
  starsActive = true;

  if (starsTimerDisplay) starsTimerDisplay.textContent = '45';
  if (starsCountDisplay) starsCountDisplay.textContent = '0';
  if (starsStatusEl) starsStatusEl.textContent = 'Plant Lilies on the glowing spots!';

  renderStarsGrid();

  if (starsInterval) clearInterval(starsInterval);
  starsInterval = setInterval(() => {
    starsTimer--;
    if (starsTimerDisplay) starsTimerDisplay.textContent = starsTimer.toString();

    if (starsTimer <= 0) {
      starsActive = false;
      if (starsInterval) clearInterval(starsInterval);
      if (starsStatusEl) starsStatusEl.textContent = `Time's up! You planted ${starsPlanted.size}/9 stars!`;
    }
  }, 1000);
}

function renderStarsGrid(): void {
  if (!starsGrid) return;
  starsGrid.innerHTML = '';

  for (let row = 0; row < 5; row++) {
    for (let col = 0; col < 5; col++) {
      const cell = document.createElement('div');
      cell.className = 'stars-cell';

      const key = `${row},${col}`;
      const isStarSpot = STAR_PATTERN.some(p => p.row === row && p.col === col);

      if (starsPlanted.has(key)) {
        cell.classList.add('planted');
        cell.textContent = '🌸';
      } else if (isStarSpot) {
        cell.classList.add('star-spot');
        cell.textContent = '⭐';
      }

      cell.addEventListener('click', () => handleStarsClick(row, col));
      starsGrid.appendChild(cell);
    }
  }
}

function handleStarsClick(row: number, col: number): void {
  if (!starsActive) return;

  const key = `${row},${col}`;
  const isStarSpot = STAR_PATTERN.some(p => p.row === row && p.col === col);

  if (isStarSpot && !starsPlanted.has(key)) {
    starsPlanted.add(key);
    if (starsCountDisplay) starsCountDisplay.textContent = starsPlanted.size.toString();
    renderStarsGrid();

    if (starsPlanted.size >= 9) {
      starsActive = false;
      if (starsInterval) clearInterval(starsInterval);
      if (starsStatusEl) starsStatusEl.textContent = `You did it! All stars planted with ${starsTimer}s left!`;
    }
  }
}

if (starsStartBtn) {
  starsStartBtn.addEventListener('click', initStars);
}

// ---- LAST STAND MINI-GAME ----
const laststandCard = document.getElementById('laststand-card');
const laststandModal = document.getElementById('laststand-game-modal');
const laststandStartBtn = document.getElementById('laststand-start-btn');
const laststandCloseBtn = document.getElementById('laststand-close-btn');

if (laststandCard && laststandModal) {
  laststandCard.addEventListener('click', () => {
    laststandModal.classList.add('active');
  });
}

if (laststandCloseBtn && laststandModal) {
  laststandCloseBtn.addEventListener('click', () => {
    laststandModal.classList.remove('active');
  });
}

if (laststandStartBtn) {
  laststandStartBtn.addEventListener('click', () => {
    console.log('🏰 Last Stand starting...');

    // Set last stand mode flag
    localStorage.setItem('laststandMode', 'true');

    // Hide all screens
    const elementsToHide = [
      'laststand-game-modal',
      'minigames-screen',
      'plant-selection',
      'menu',
      'tutorial-overlay'
    ];

    elementsToHide.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.classList.remove('active');
        if (id === 'menu') el.classList.add('hidden');
      }
    });

    // Create last stand game - no lily (no sun production!)
    cleanupCurrentGame();
    const laststandPlants: PlantType[] = ['grape-launcher', 'vine-wall', 'pear-cannon', 'frost-berri', 'avocado-slammer', 'pickle-picker', 'tomato-spike', 'strawberry-launcher'];
    currentGame = new Game(laststandPlants, false, false);

    const gameUI = document.getElementById('game-ui');
    if (gameUI) gameUI.classList.add('active');

    stopMenuMusic();
    console.log('🏰 Last Stand started! Setup your defense, then survive!');
  });
}

// ---- DRAGON BATTLE MINI-GAME ----
const dragonCard = document.getElementById('dragon-battle-card');
const dragonGameModal = document.getElementById('dragon-battle-modal');
const dragonStartBtn = document.getElementById('dragon-start-btn');
const dragonCloseBtn = document.getElementById('dragon-close-btn');

if (dragonCard && dragonGameModal) {
  dragonCard.addEventListener('click', () => {
    dragonGameModal.classList.add('active');
  });
}

if (dragonCloseBtn && dragonGameModal) {
  dragonCloseBtn.addEventListener('click', () => {
    dragonGameModal.classList.remove('active');
  });
}

if (dragonStartBtn) {
  dragonStartBtn.addEventListener('click', () => {
    console.log('🐉 Dragon Battle mode starting...');

    // Set dragon battle mode flag
    localStorage.setItem('dragonBattleMode', 'true');

    // Hide all screens
    const elementsToHide = [
      'dragon-battle-modal',
      'minigames-screen',
      'plant-selection',
      'menu',
      'tutorial-overlay'
    ];

    elementsToHide.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.classList.remove('active');
        if (id === 'menu') el.classList.add('hidden');
      }
    });

    // Create Dragon Battle game with specific plants only
    cleanupCurrentGame();
    const dragonPlants: PlantType[] = ['red-fire-flower', 'vine-wall', 'lily'];
    currentGame = new Game(dragonPlants, false, false);

    const gameUI = document.getElementById('game-ui');
    if (gameUI) gameUI.classList.add('active');

    stopMenuMusic();
    console.log('🐉 Dragon Battle mode started!');
  });
}

// ============================================
// TUTORIAL SYSTEM
// ============================================
const tutorialOverlay = document.getElementById('tutorial-overlay');
const tutorialSkip = document.getElementById('tutorial-skip');
const tutorialNext = document.getElementById('tutorial-next');
const tutorialBack = document.getElementById('tutorial-back');
const tutorialSteps = document.querySelectorAll('.tutorial-step');
const tutorialDots = document.querySelectorAll('.tutorial-dot');
const tutorialProgress = document.querySelector('.tutorial-progress-fill') as HTMLElement | null;
const tutorialStepCounter = document.getElementById('tutorial-current');
const tutorialStepTotal = document.getElementById('tutorial-total');
const tutorialDontShow = document.getElementById('tutorial-dont-show') as HTMLInputElement | null;

let currentTutorialStep = 0;
let maxVisitedStep = 0;

function showTutorial(): void {
  // Check if user chose to skip tutorial
  if (localStorage.getItem('skipTutorial') === 'true') {
    return;
  }

  if (tutorialOverlay) {
    tutorialOverlay.classList.add('active');
    currentTutorialStep = 0;
    maxVisitedStep = 0;

    // Set total steps count
    if (tutorialStepTotal) {
      tutorialStepTotal.textContent = String(tutorialSteps.length);
    }

    updateTutorialStep();
  }
}

function hideTutorial(): void {
  if (tutorialOverlay) {
    // Save preference if checkbox is checked
    if (tutorialDontShow?.checked) {
      localStorage.setItem('skipTutorial', 'true');
    }

    // Fade out animation
    tutorialOverlay.style.animation = 'tutorialOverlayIn 0.3s ease-out reverse';
    setTimeout(() => {
      tutorialOverlay.classList.remove('active');
      tutorialOverlay.style.animation = '';
    }, 300);
  }
}

function goToTutorialStep(newStep: number): void {
  if (newStep < 0 || newStep >= tutorialSteps.length) return;

  const oldStep = currentTutorialStep;
  currentTutorialStep = newStep;

  // Track max visited for completed dots
  if (currentTutorialStep > maxVisitedStep) {
    maxVisitedStep = currentTutorialStep;
  }

  // Animate out current step
  const currentStepEl = tutorialSteps[oldStep];
  if (currentStepEl && oldStep !== newStep) {
    currentStepEl.classList.add('exiting');
    setTimeout(() => {
      currentStepEl.classList.remove('exiting');
      currentStepEl.classList.remove('active');
      updateTutorialStep();
    }, 200);
  } else {
    updateTutorialStep();
  }
}

function updateTutorialStep(): void {
  tutorialSteps.forEach((step, index) => {
    if (index === currentTutorialStep) {
      step.classList.add('active');
    } else if (!step.classList.contains('exiting')) {
      step.classList.remove('active');
    }
  });

  tutorialDots.forEach((dot, index) => {
    dot.classList.toggle('active', index === currentTutorialStep);
    dot.classList.toggle('completed', index < currentTutorialStep);
  });

  // Update progress bar
  if (tutorialProgress) {
    const progress = ((currentTutorialStep + 1) / tutorialSteps.length) * 100;
    tutorialProgress.style.width = `${progress}%`;
  }

  // Update step counter
  if (tutorialStepCounter) {
    tutorialStepCounter.textContent = String(currentTutorialStep + 1);
  }

  // Update back button visibility
  if (tutorialBack) {
    tutorialBack.style.display = currentTutorialStep > 0 ? 'inline-block' : 'none';
  }

  // Update button text on last step
  if (tutorialNext) {
    if (currentTutorialStep === tutorialSteps.length - 1) {
      tutorialNext.textContent = '🎮 Start Playing!';
      tutorialNext.style.background = 'linear-gradient(180deg, #4a8f4a 0%, #2a5f2a 100%)';
      tutorialNext.style.borderColor = '#6fbf6f';
    } else {
      tutorialNext.textContent = 'Next →';
      tutorialNext.style.background = '';
      tutorialNext.style.borderColor = '';
    }
  }
}

// Skip button handler
if (tutorialSkip) {
  tutorialSkip.addEventListener('click', hideTutorial);
}

// Next button handler
if (tutorialNext) {
  tutorialNext.addEventListener('click', () => {
    if (currentTutorialStep < tutorialSteps.length - 1) {
      goToTutorialStep(currentTutorialStep + 1);
    } else {
      hideTutorial();
    }
  });
}

// Back button handler
if (tutorialBack) {
  tutorialBack.addEventListener('click', () => {
    if (currentTutorialStep > 0) {
      goToTutorialStep(currentTutorialStep - 1);
    }
  });
}

// Clickable dots - jump to any step
tutorialDots.forEach((dot, index) => {
  dot.addEventListener('click', () => {
    goToTutorialStep(index);
  });
});

// Keyboard navigation for tutorial
document.addEventListener('keydown', (e) => {
  if (!tutorialOverlay?.classList.contains('active')) return;

  if (e.key === 'ArrowRight' || e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    if (currentTutorialStep < tutorialSteps.length - 1) {
      goToTutorialStep(currentTutorialStep + 1);
    } else {
      hideTutorial();
    }
  } else if (e.key === 'ArrowLeft') {
    e.preventDefault();
    if (currentTutorialStep > 0) {
      goToTutorialStep(currentTutorialStep - 1);
    }
  } else if (e.key === 'Escape') {
    e.preventDefault();
    hideTutorial();
  }
});

// Tutorial is now shown when wave 1 starts (handled in Game.startNextWave)

// ============================================
// TITAN TUTORIAL SYSTEM (Wave 10)
// ============================================
const titanTutorialOverlay = document.getElementById('titan-tutorial-overlay');
const titanTutorialClose = document.getElementById('titan-tutorial-close');
let titanTutorialShown = false;

function showTitanTutorial(): void {
  // Only show once per session and if not already shown
  if (titanTutorialShown || localStorage.getItem('titanTutorialShown') === 'true') {
    return;
  }

  if (titanTutorialOverlay) {
    titanTutorialOverlay.classList.add('active');
    titanTutorialShown = true;
    localStorage.setItem('titanTutorialShown', 'true');
  }
}

function hideTitanTutorial(): void {
  if (titanTutorialOverlay) {
    titanTutorialOverlay.style.animation = 'tutorialOverlayIn 0.3s ease-out reverse';
    setTimeout(() => {
      titanTutorialOverlay.classList.remove('active');
      titanTutorialOverlay.style.animation = '';
    }, 300);
  }
}

if (titanTutorialClose) {
  titanTutorialClose.addEventListener('click', hideTitanTutorial);
}

// Close Titan tutorial with Escape or Enter
document.addEventListener('keydown', (e) => {
  if (!titanTutorialOverlay?.classList.contains('active')) return;

  if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    hideTitanTutorial();
  }
});

// Export for use in Game class
(window as any).showTitanTutorial = showTitanTutorial;
